var GlobalNavButton = {
   name: "GlobalNavButton",
   vendor: "UiFabric",
   unicode: 59136,
   value: "",
   charCode: "E700",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 640L2048 640L0 640L0 512L2048 512L2048 640ZM2048 1664L2048 1664L0 1664L0 1536L2048 1536L2048 1664ZM2048 1151L2048 1151L0 1151L0 1024L2048 1024L2048 1151Z"
         }
      }
   ]
}

var ChevronDown = {
   name: "ChevronDown",
   vendor: "UiFabric",
   unicode: 59149,
   value: "",
   charCode: "E70D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1382L1939 467L2029 557L1024 1562L19 557L109 467L1024 1382Z"
         }
      }
   ]
}

var Add = {
   name: "Add",
   vendor: "UiFabric",
   unicode: 59152,
   value: "",
   charCode: "E710",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1088 960L2048 960L2048 1088L1088 1088L1088 2048L960 2048L960 1088L0 1088L0 960L960 960L960 0L1088 0L1088 960Z"
         }
      }
   ]
}

var Cancel = {
   name: "Cancel",
   vendor: "UiFabric",
   unicode: 59153,
   value: "",
   charCode: "E711",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1805 333L1115 1024L1805 1715L1715 1805L1024 1115L333 1805L243 1715L933 1024L243 333L333 243L1024 933L1715 243L1805 333Z"
         }
      }
   ]
}

var Settings = {
   name: "Settings",
   vendor: "UiFabric",
   unicode: 59155,
   value: "",
   charCode: "E713",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2042 827L1783 988Q1783 997 1783.50 1006Q1784 1015 1784 1024L1784 1024Q1784 1033 1783.50 1042Q1783 1051 1783 1060L1783 1060L2042 1221L1883 1604L1586 1536Q1562 1562 1536 1586L1536 1586L1604 1883L1221 2042L1060 1783Q1051 1783 1042 1783.50Q1033 1784 1024 1784L1024 1784Q1015 1784 1006 1783.50Q997 1783 988 1783L988 1783L827 2042L444 1883L512 1586Q486 1562 462 1536L462 1536L165 1604L6 1221L265 1060Q265 1051 264.50 1042Q264 1033 264 1024L264 1024Q264 1015 264.50 1006Q265 997 265 988L265 988L6 827L165 444L462 512Q486 486 512 462L512 462L444 165L827 6L988 265Q997 265 1006 264.50Q1015 264 1024 264L1024 264Q1033 264 1042 264.50Q1051 265 1060 265L1060 265L1221 6L1604 165L1536 462Q1562 486 1586 512L1586 512L1883 444L2042 827ZM1902 1266L1666 1118Q1668 1094 1670 1070.50Q1672 1047 1672 1023L1672 1023Q1672 1000 1670 976Q1668 952 1666 929L1666 929L1902 782L1816 574L1545 637Q1514 599 1481.50 567Q1449 535 1411 503L1411 503L1474 232L1266 146L1118 382Q1095 380 1071 378Q1047 376 1024 376L1024 376Q1000 376 976.50 378Q953 380 929 382L929 382L782 146L574 232L637 503Q599 534 567 566.50Q535 599 503 637L503 637L232 574L146 782L382 930Q380 954 378 977.50Q376 1001 376 1025L376 1025Q376 1048 378 1072Q380 1096 382 1119L382 1119L146 1266L232 1474L503 1411Q534 1449 566.50 1481Q599 1513 637 1545L637 1545L574 1816L782 1902L930 1666Q953 1668 977 1670Q1001 1672 1024 1672L1024 1672Q1048 1672 1071.50 1670Q1095 1668 1119 1666L1119 1666L1266 1902L1474 1816L1411 1545Q1449 1514 1481 1481.50Q1513 1449 1545 1411L1545 1411L1816 1474L1902 1266ZM1024 648L1024 648Q1102 648 1170.50 677.50Q1239 707 1290 758Q1341 809 1370.50 877.50Q1400 946 1400 1024L1400 1024Q1400 1102 1370.50 1170.50Q1341 1239 1290 1290Q1239 1341 1170.50 1370.50Q1102 1400 1024 1400L1024 1400Q946 1400 877.50 1370.50Q809 1341 758 1290Q707 1239 677.50 1170.50Q648 1102 648 1024L648 1024Q648 946 677.50 877.50Q707 809 758 758Q809 707 877.50 677.50Q946 648 1024 648ZM1024 1288L1024 1288Q1079 1288 1127 1267.50Q1175 1247 1211 1211Q1247 1175 1267.50 1127Q1288 1079 1288 1024L1288 1024Q1288 969 1267.50 921Q1247 873 1211 837Q1175 801 1127 780.50Q1079 760 1024 760L1024 760Q969 760 921 780.50Q873 801 837 837Q801 873 780.50 921Q760 969 760 1024L760 1024Q760 1079 780.50 1127Q801 1175 837 1211Q873 1247 921 1267.50Q969 1288 1024 1288Z"
         }
      }
   ]
}

var Mail = {
   name: "Mail",
   vendor: "UiFabric",
   unicode: 59157,
   value: "",
   charCode: "E715",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1664L0 1664L0 384ZM1905 512L143 512L1024 953L1905 512ZM128 1536L1920 1536L1920 648L1024 1095L128 648L128 1536Z"
         }
      }
   ]
}

var Pin = {
   name: "Pin",
   vendor: "UiFabric",
   unicode: 59160,
   value: "",
   charCode: "E718",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 512L2048 512L2048 1408L1984 1408Q1906 1408 1841 1374.50Q1776 1341 1729 1280L1729 1280L1235 1280Q1207 1339 1165 1386.50Q1123 1434 1070.50 1467Q1018 1500 957.50 1518Q897 1536 832 1536L832 1536L768 1536L768 1024L128 1024L0 960L128 896L768 896L768 384L832 384Q897 384 957.50 402Q1018 420 1070.50 453Q1123 486 1165 533.50Q1207 581 1235 640L1235 640L1729 640Q1776 579 1841 545.50Q1906 512 1984 512L1984 512ZM1920 1269L1920 651Q1896 659 1879 671Q1862 683 1848.50 697.50Q1835 712 1823.50 730Q1812 748 1800 768L1800 768L1147 768L1132 725Q1104 646 1041 591Q978 536 896 519L896 519L896 1401Q978 1384 1041 1329Q1104 1274 1132 1195L1132 1195L1147 1152L1800 1152Q1812 1172 1823.50 1190Q1835 1208 1848.50 1222.50Q1862 1237 1879 1249Q1896 1261 1920 1269L1920 1269Z"
         }
      }
   ]
}

var Filter = {
   name: "Filter",
   vendor: "UiFabric",
   unicode: 59164,
   value: "",
   charCode: "E71C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 347L1280 1115L1280 1920L768 1920L768 1115L0 347L0 128ZM1920 293L1920 256L128 256L128 293L896 1061L896 1792L1152 1792L1152 1061L1920 293Z"
         }
      }
   ]
}

var Share = {
   name: "Share",
   vendor: "UiFabric",
   unicode: 59181,
   value: "",
   charCode: "E72D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1664L1408 1536L1536 1408L1536 1792L0 1792L0 512L128 512L128 1664L1408 1664ZM1280 1408L1280 1024Q1152 1024 1029.50 1049.50Q907 1075 793 1124.50Q679 1174 575.50 1245.50Q472 1317 384 1408L384 1408L384 1280Q384 1156 416 1041.50Q448 927 506.50 827.50Q565 728 646.50 646.50Q728 565 827.50 506.50Q927 448 1041.50 416Q1156 384 1280 384L1280 384L1280 0L1984 704L1280 1408ZM1408 512L1381 512Q1325 512 1276 513Q1227 514 1179 519.50Q1131 525 1083 537.50Q1035 550 981 572L981 572Q894 608 819.50 664Q745 720 686.50 791.50Q628 863 587.50 946.50Q547 1030 528 1122L528 1122Q696 1010 887 953Q1078 896 1280 896L1280 896L1408 896L1408 1099L1803 704L1408 309L1408 512Z"
         }
      }
   ]
}

var Remove = {
   name: "Remove",
   vendor: "UiFabric",
   unicode: 59192,
   value: "",
   charCode: "E738",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 960L2048 1088L0 1088L0 960L2048 960Z"
         }
      }
   ]
}

var SwitchUser = {
   name: "SwitchUser",
   vendor: "UiFabric",
   unicode: 59208,
   value: "",
   charCode: "E748",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1339 1152L1339 1152L1152 1152Q1069 1089 970.50 1056.50Q872 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q440 911 395.50 863.50Q351 816 320 760Q289 704 272.50 641Q256 578 256 512L256 512Q256 406 296.50 313Q337 220 406.50 150.50Q476 81 569 40.50Q662 0 768 0L768 0Q874 0 967 40.50Q1060 81 1129.50 150.50Q1199 220 1239.50 313Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140.50 863.50Q1096 911 1040 946L1040 946Q1126 978 1202 1030.50Q1278 1083 1339 1152ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1152 1408L1152 1280L1706 1280L1621 1195L1707 1109L1943 1344L1707 1579L1621 1493L1706 1408L1152 1408ZM1365 1493L1451 1579L1366 1664L1920 1664L1920 1792L1366 1792L1451 1877L1365 1963L1129 1728L1365 1493Z"
         }
      }
   ]
}

var Print = {
   name: "Print",
   vendor: "UiFabric",
   unicode: 59209,
   value: "",
   charCode: "E749",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 768L1920 768Q1946 768 1969.50 778Q1993 788 2010.50 805.50Q2028 823 2038 846.50Q2048 870 2048 896L2048 896L2048 1792L1536 1792L1536 2048L512 2048L512 1792L0 1792L0 896Q0 870 10 846.50Q20 823 37.50 805.50Q55 788 78.50 778Q102 768 128 768L128 768L512 768L512 0L1536 0L1536 768ZM640 128L640 768L1408 768L1408 128L640 128ZM1408 1920L1408 1408L640 1408L640 1920L1408 1920ZM1920 1664L1920 896L128 896L128 1664L512 1664L512 1280L1536 1280L1536 1664L1920 1664ZM320 1024L320 1024Q346 1024 365 1043Q384 1062 384 1088L384 1088Q384 1114 365 1133Q346 1152 320 1152L320 1152Q294 1152 275 1133Q256 1114 256 1088L256 1088Q256 1062 275 1043Q294 1024 320 1024Z"
         }
      }
   ]
}

var ReturnKey = {
   name: "ReturnKey",
   vendor: "UiFabric",
   unicode: 59217,
   value: "",
   charCode: "E751",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 384L1792 1152L475 1152L941 1619L851 1709L230 1088L851 467L941 557L475 1024L1664 1024L1664 384L1792 384Z"
         }
      }
   ]
}

var PageLeft = {
   name: "PageLeft",
   vendor: "UiFabric",
   unicode: 59232,
   value: "",
   charCode: "E760",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1029 128L1029 128Q1152 128 1265.50 160Q1379 192 1478 250Q1577 308 1658.50 389.50Q1740 471 1798 570Q1856 669 1888 782.50Q1920 896 1920 1019L1920 1019Q1920 1142 1888 1255.50Q1856 1369 1798 1468Q1740 1567 1658.50 1648.50Q1577 1730 1478 1788Q1379 1846 1265.50 1878Q1152 1910 1029 1910L1029 1910Q906 1910 792.50 1878Q679 1846 580 1788Q481 1730 399.50 1648.50Q318 1567 260 1468Q202 1369 170 1255.50Q138 1142 138 1019L138 1019Q138 896 170 782.50Q202 669 260 570Q318 471 399.50 389.50Q481 308 580 250Q679 192 792.50 160Q906 128 1029 128ZM1029 1782L1029 1782Q1134 1782 1231.50 1754.50Q1329 1727 1414 1677.50Q1499 1628 1568.50 1558.50Q1638 1489 1687.50 1404Q1737 1319 1764.50 1221.50Q1792 1124 1792 1019L1792 1019Q1792 914 1764.50 816.50Q1737 719 1687.50 634.50Q1638 550 1568 480Q1498 410 1413.50 360.50Q1329 311 1231.50 283.50Q1134 256 1029 256L1029 256Q924 256 826.50 283.50Q729 311 644 360.50Q559 410 489.50 479.50Q420 549 370.50 634Q321 719 293.50 816.50Q266 914 266 1019L266 1019Q266 1124 293.50 1221.50Q321 1319 370.50 1404Q420 1489 489.50 1558.50Q559 1628 644 1677.50Q729 1727 826.50 1754.50Q924 1782 1029 1782ZM1139 563L1229 653L859 1024L1229 1395L1139 1485L677 1024L1139 563Z"
         }
      }
   ]
}

var PageRight = {
   name: "PageRight",
   vendor: "UiFabric",
   unicode: 59233,
   value: "",
   charCode: "E761",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1029 256L1029 256Q924 256 826.50 283.50Q729 311 644 360.50Q559 410 489.50 479.50Q420 549 370.50 634Q321 719 293.50 816.50Q266 914 266 1019L266 1019Q266 1124 293.50 1221.50Q321 1319 370.50 1404Q420 1489 489.50 1558.50Q559 1628 644 1677.50Q729 1727 826.50 1754.50Q924 1782 1029 1782L1029 1782Q1134 1782 1231.50 1754.50Q1329 1727 1414 1677.50Q1499 1628 1568.50 1558.50Q1638 1489 1687.50 1404Q1737 1319 1764.50 1221.50Q1792 1124 1792 1019L1792 1019Q1792 914 1764.50 816.50Q1737 719 1687.50 634.50Q1638 550 1568 480Q1498 410 1413.50 360.50Q1329 311 1231.50 283.50Q1134 256 1029 256ZM1029 128L1029 128Q1152 128 1265.50 160Q1379 192 1478 250Q1577 308 1658.50 389.50Q1740 471 1798 570Q1856 669 1888 782.50Q1920 896 1920 1019L1920 1019Q1920 1142 1888 1255.50Q1856 1369 1798 1468Q1740 1567 1658.50 1648.50Q1577 1730 1478 1788Q1379 1846 1265.50 1878Q1152 1910 1029 1910L1029 1910Q906 1910 792.50 1878Q679 1846 580 1788Q481 1730 399.50 1648.50Q318 1567 260 1468Q202 1369 170 1255.50Q138 1142 138 1019L138 1019Q138 896 170 782.50Q202 669 260 570Q318 471 399.50 389.50Q481 308 580 250Q679 192 792.50 160Q906 128 1029 128ZM1402 1024L941 1485L851 1395L1221 1024L851 653L941 563L1402 1024Z"
         }
      }
   ]
}

var KeyboardClassic = {
   name: "KeyboardClassic",
   vendor: "UiFabric",
   unicode: 59237,
   value: "",
   charCode: "E765",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M137 384L1783 384Q1813 384 1838 396Q1863 408 1881 427.50Q1899 447 1909.50 473.50Q1920 500 1920 528L1920 528L1920 1392Q1920 1421 1909.50 1447Q1899 1473 1881 1492.50Q1863 1512 1838 1524Q1813 1536 1783 1536L1783 1536L137 1536Q107 1536 82 1524Q57 1512 39 1492.50Q21 1473 10.50 1447Q0 1421 0 1392L0 1392L0 528Q0 500 10.50 473.50Q21 447 39 427.50Q57 408 82 396Q107 384 137 384L137 384ZM1792 1392L1792 528Q1792 517 1783 512L1783 512L137 512Q128 517 128 528L128 528L128 1392Q128 1403 137 1408L137 1408L1783 1408Q1792 1403 1792 1392L1792 1392ZM384 640L384 768L256 768L256 640L384 640ZM256 1024L256 896L512 896L512 1024L256 1024ZM1408 1024L1408 896L1664 896L1664 1024L1408 1024ZM1408 1280L1408 1152L1664 1152L1664 1280L1408 1280ZM256 1280L256 1152L512 1152L512 1280L256 1280ZM640 1280L640 1152L1280 1152L1280 1280L640 1280ZM640 640L640 768L512 768L512 640L640 640ZM640 1024L640 896L768 896L768 1024L640 1024ZM896 1024L896 896L1024 896L1024 1024L896 1024ZM1152 1024L1152 896L1280 896L1280 1024L1152 1024ZM896 640L896 768L768 768L768 640L896 640ZM1152 640L1152 768L1024 768L1024 640L1152 640ZM1408 640L1408 768L1280 768L1280 640L1408 640ZM1536 768L1536 640L1664 640L1664 768L1536 768Z"
         }
      }
   ]
}

var Emoji2 = {
   name: "Emoji2",
   vendor: "UiFabric",
   unicode: 59246,
   value: "",
   charCode: "E76E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 896L640 896Q613 896 590 886Q567 876 549.50 858.50Q532 841 522 818Q512 795 512 768L512 768Q512 741 522 718Q532 695 549.50 677.50Q567 660 590 650Q613 640 640 640L640 640Q667 640 690 650Q713 660 730.50 677.50Q748 695 758 718Q768 741 768 768L768 768Q768 795 758 818Q748 841 730.50 858.50Q713 876 690 886Q667 896 640 896ZM1408 896L1408 896Q1381 896 1358 886Q1335 876 1317.50 858.50Q1300 841 1290 818Q1280 795 1280 768L1280 768Q1280 741 1290 718Q1300 695 1317.50 677.50Q1335 660 1358 650Q1381 640 1408 640L1408 640Q1435 640 1458 650Q1481 660 1498.50 677.50Q1516 695 1526 718Q1536 741 1536 768L1536 768Q1536 795 1526 818Q1516 841 1498.50 858.50Q1481 876 1458 886Q1435 896 1408 896ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1024 1536L1024 1536Q1097 1536 1165.50 1516Q1234 1496 1293 1459Q1352 1422 1399.50 1369Q1447 1316 1480 1251L1480 1251L1595 1309Q1554 1390 1494 1456Q1434 1522 1360 1568Q1286 1614 1200.50 1639Q1115 1664 1024 1664L1024 1664Q932 1664 847 1639Q762 1614 688 1568Q614 1522 554 1456Q494 1390 453 1309L453 1309L568 1251Q601 1316 648.50 1369Q696 1422 755 1459Q814 1496 882 1516Q950 1536 1024 1536Z"
         }
      }
   ]
}

var WindowsLogo = {
   name: "WindowsLogo",
   vendor: "UiFabric",
   unicode: 59266,
   value: "",
   charCode: "E782",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 896L0 268L768 161L768 896L0 896ZM896 143L1920 0L1920 896L896 896L896 143ZM896 1777L896 1024L1920 1024L1920 1920L896 1777ZM0 1652L0 1024L768 1024L768 1759L0 1652Z"
         }
      }
   ]
}

var Chat = {
   name: "Chat",
   vendor: "UiFabric",
   unicode: 59649,
   value: "",
   charCode: "E901",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536ZM677 1408L1920 1408L1920 256L128 256L128 1408L384 1408L384 1701L677 1408Z"
         }
      }
   ]
}

var Nav2DMapView = {
   name: "Nav2DMapView",
   vendor: "UiFabric",
   unicode: 59392,
   value: "",
   charCode: "E800",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 210L1344 423L2048 189L2048 1603L1344 1838L704 1625L0 1859L0 445L704 210ZM1280 537L768 366L768 1511L1280 1682L1280 537ZM640 366L128 537L128 1682L640 1511L640 366ZM1408 1682L1920 1511L1920 366L1408 537L1408 1682Z"
         }
      }
   ]
}

var StreetsideSplitMinimize = {
   name: "StreetsideSplitMinimize",
   vendor: "UiFabric",
   unicode: 59394,
   value: "",
   charCode: "E802",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1087 779L1363 504L1453 595L1024 1024L595 595L685 504L961 779L961 256L1087 256L1087 779ZM1024 0L1024 0Q1165 0 1295.50 36.50Q1426 73 1540 140Q1654 207 1747.50 300.50Q1841 394 1908 508Q1975 622 2011.50 752.50Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1295.50Q1975 1426 1908 1540Q1841 1654 1747.50 1747.50Q1654 1841 1540 1908Q1426 1975 1295.50 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752.50 2011.50Q622 1975 508 1908Q394 1841 300.50 1747.50Q207 1654 140 1540Q73 1426 36.50 1295.50Q0 1165 0 1024L0 1024Q0 883 36.50 752.50Q73 622 140 508Q207 394 300.50 300.50Q394 207 508 140Q622 73 752.50 36.50Q883 0 1024 0ZM1163 1280L165 1280Q175 1313 187.50 1344.50Q200 1376 214 1407L214 1407L1186 1407L1163 1280ZM1210 1536L814 1536L772 1663L1234 1663L1210 1536ZM589 1807L679 1536L289 1536Q348 1620 423.50 1688.50Q499 1757 589 1807L589 1807ZM1024 1920L1024 1920Q1153 1920 1275 1884L1275 1884L1258 1792L729 1792L706 1862Q783 1891 863 1905.50Q943 1920 1024 1920ZM1341 1536L1397 1839Q1506 1789 1598 1712Q1690 1635 1759 1536L1759 1536L1341 1536ZM1317 1407L1834 1407Q1848 1376 1860.50 1344.50Q1873 1313 1883 1280L1883 1280L1293 1280L1317 1407ZM137 1151L1911 1151Q1920 1088 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1088 137 1151L137 1151Z"
         }
      }
   ]
}

var IncidentTriangle = {
   name: "IncidentTriangle",
   vendor: "UiFabric",
   unicode: 59412,
   value: "",
   charCode: "E814",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 128L1920 2048L0 2048L960 128ZM1024 1792L1024 1664L896 1664L896 1792L1024 1792ZM896 1536L1024 1536L1024 896L896 896L896 1536Z"
         }
      }
   ]
}

var Location = {
   name: "Location",
   vendor: "UiFabric",
   unicode: 59421,
   value: "",
   charCode: "E81D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q1147 128 1261.50 160Q1376 192 1475.50 250.50Q1575 309 1657 391Q1739 473 1797.50 572.50Q1856 672 1888 786.50Q1920 901 1920 1024L1920 1024Q1920 1147 1888 1261.50Q1856 1376 1797.50 1475.50Q1739 1575 1657 1657Q1575 1739 1475.50 1797.50Q1376 1856 1261.50 1888Q1147 1920 1024 1920L1024 1920Q901 1920 786.50 1888Q672 1856 572.50 1797.50Q473 1739 391 1657Q309 1575 250.50 1475.50Q192 1376 160 1262Q128 1148 128 1024L128 1024Q128 901 160 786.50Q192 672 250.50 572.50Q309 473 391 391Q473 309 572.50 250.50Q672 192 786 160Q900 128 1024 128ZM1024 1792L1024 1792Q1130 1792 1228 1764.50Q1326 1737 1411.50 1687Q1497 1637 1567 1567Q1637 1497 1687 1411.50Q1737 1326 1764.50 1228Q1792 1130 1792 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792ZM1024 640L1024 640Q1103 640 1173 670.50Q1243 701 1295 753Q1347 805 1377.50 875Q1408 945 1408 1024L1408 1024Q1408 1103 1377.50 1173Q1347 1243 1295 1295Q1243 1347 1173 1377.50Q1103 1408 1024 1408L1024 1408Q945 1408 875 1377.50Q805 1347 753 1295Q701 1243 670.50 1173Q640 1103 640 1024L640 1024Q640 945 670.50 875Q701 805 753 753Q805 701 875 670.50Q945 640 1024 640Z"
         }
      }
   ]
}

var MapLayers = {
   name: "MapLayers",
   vendor: "UiFabric",
   unicode: 59422,
   value: "",
   charCode: "E81E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 640L1664 832L2048 1024L1664 1216L2048 1408L1024 1920L0 1408L384 1216L0 1024L384 832L0 640L1024 128L2048 640ZM1024 271L286 640L1024 1009L1762 640L1024 271ZM1024 1777L1762 1408L1521 1288L1024 1536L527 1288L286 1408L1024 1777ZM286 1024L1024 1393L1762 1024L1521 904L1024 1152L527 904L286 1024Z"
         }
      }
   ]
}

var SearchNearby = {
   name: "SearchNearby",
   vendor: "UiFabric",
   unicode: 59424,
   value: "",
   charCode: "E820",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1269L1280 1431Q1318 1436 1370.50 1446.50Q1423 1457 1480 1473.50Q1537 1490 1593 1513Q1649 1536 1693 1567.50Q1737 1599 1764.50 1638.50Q1792 1678 1792 1728L1792 1728Q1792 1778 1764.50 1817Q1737 1856 1696.50 1885.50Q1656 1915 1609 1936Q1562 1957 1523 1970L1523 1970Q1459 1992 1388.50 2007Q1318 2022 1245 2031Q1172 2040 1099.50 2044Q1027 2048 960 2048L960 2048Q892 2048 820 2044Q748 2040 675 2031Q602 2022 531.50 2007Q461 1992 397 1970L397 1970Q358 1957 311 1936Q264 1915 223.50 1885.50Q183 1856 155.50 1817Q128 1778 128 1728L128 1728Q128 1678 155.50 1638.50Q183 1599 227 1567.50Q271 1536 327 1513Q383 1490 440 1473.50Q497 1457 549.50 1447Q602 1437 640 1431L640 1431L640 1269Q611 1259 587.50 1241Q564 1223 547 1199Q530 1175 521 1146.50Q512 1118 512 1088L512 1088L512 576Q512 536 527 501Q542 466 568 440Q594 414 629 399Q664 384 704 384L704 384L738 384Q704 324 704 256L704 256Q704 203 724 156.50Q744 110 779 75Q814 40 860.50 20Q907 0 960 0L960 0Q1013 0 1059.50 20Q1106 40 1141 75Q1176 110 1196 156.50Q1216 203 1216 256L1216 256Q1216 324 1182 384L1182 384L1216 384Q1256 384 1291 399Q1326 414 1352 440Q1378 466 1393 501Q1408 536 1408 576L1408 576L1408 1088Q1408 1118 1399 1146.50Q1390 1175 1373 1199Q1356 1223 1332.50 1241Q1309 1259 1280 1269L1280 1269ZM832 256L832 256Q832 283 842 306Q852 329 869.50 346.50Q887 364 910 374Q933 384 960 384L960 384Q987 384 1010 374Q1033 364 1050.50 346.50Q1068 329 1078 306Q1088 283 1088 256L1088 256Q1088 229 1078 206Q1068 183 1050.50 165.50Q1033 148 1010 138Q987 128 960 128L960 128Q933 128 910 138Q887 148 869.50 165.50Q852 183 842 206Q832 229 832 256ZM960 1920L960 1920Q1003 1920 1060 1917.50Q1117 1915 1179.50 1908.50Q1242 1902 1307 1891.50Q1372 1881 1432 1865Q1492 1849 1542.50 1827.50Q1593 1806 1628 1777L1628 1777Q1638 1769 1651 1755.50Q1664 1742 1664 1728L1664 1728Q1664 1714 1651 1700Q1638 1686 1620.50 1673.50Q1603 1661 1585 1651.50Q1567 1642 1557 1637L1557 1637Q1493 1607 1421.50 1589Q1350 1571 1280 1560L1280 1560L1280 1728Q1280 1740 1263 1749Q1246 1758 1224 1764Q1202 1770 1181 1774Q1160 1778 1152 1779L1152 1779L1152 1152Q1170 1152 1192.50 1152.50Q1215 1153 1234.50 1148Q1254 1143 1267 1129.50Q1280 1116 1280 1088L1280 1088L1280 576Q1280 550 1261 531Q1242 512 1216 512L1216 512L704 512Q678 512 659 531Q640 550 640 576L640 576L640 1088Q640 1116 653 1129.50Q666 1143 685.50 1148Q705 1153 727.50 1152.50Q750 1152 768 1152L768 1152L768 1779Q760 1778 739 1774Q718 1770 696 1764Q674 1758 657 1749Q640 1740 640 1728L640 1728L640 1560Q570 1571 498.50 1589Q427 1607 363 1637L363 1637Q353 1642 335 1651.50Q317 1661 299.50 1673.50Q282 1686 269 1700Q256 1714 256 1728L256 1728Q256 1742 269 1755.50Q282 1769 292 1777L292 1777Q326 1806 377 1827.50Q428 1849 488 1865Q548 1881 613 1891.50Q678 1902 740.50 1908.50Q803 1915 860 1917.50Q917 1920 960 1920ZM896 1791L896 1152L1024 1152L1024 1791Q1008 1792 992 1792Q976 1792 960 1792L960 1792Q944 1792 928 1792Q912 1792 896 1791L896 1791Z"
         }
      }
   ]
}

var InternetSharing = {
   name: "InternetSharing",
   vendor: "UiFabric",
   unicode: 59140,
   value: "",
   charCode: "E704",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 2048L896 640L1024 640L1024 2048L896 2048ZM281 153L372 244Q314 302 268.50 370.50Q223 439 192 514Q161 589 144.50 669.50Q128 750 128 832L128 832Q128 914 144.50 994.50Q161 1075 192 1150Q223 1225 268.50 1293.50Q314 1362 372 1420L372 1420L281 1511Q145 1374 72.50 1199.50Q0 1025 0 832L0 832Q0 639 72.50 464.50Q145 290 281 153L281 153ZM1548 244L1639 153Q1775 290 1847.50 464.50Q1920 639 1920 832L1920 832Q1920 1025 1847.50 1199.50Q1775 1374 1639 1511L1639 1511L1548 1420Q1606 1362 1651.50 1293.50Q1697 1225 1728 1150Q1759 1075 1775.50 994.50Q1792 914 1792 832L1792 832Q1792 750 1775.50 669.50Q1759 589 1728 514Q1697 439 1651.50 370.50Q1606 302 1548 244L1548 244ZM1277 515L1367 425Q1448 506 1492 611.50Q1536 717 1536 832L1536 832Q1536 947 1492 1052.50Q1448 1158 1367 1239L1367 1239L1277 1149Q1340 1086 1373.50 1003.50Q1407 921 1407 832L1407 832Q1407 743 1373.50 660.50Q1340 578 1277 515L1277 515ZM553 425L643 515Q580 578 546 660.50Q512 743 512 832L512 832Q512 921 546 1003.50Q580 1086 643 1149L643 1149L553 1239Q472 1158 428 1052.50Q384 947 384 832L384 832Q384 717 428 611.50Q472 506 553 425L553 425Z"
         }
      }
   ]
}

var Brightness = {
   name: "Brightness",
   vendor: "UiFabric",
   unicode: 59142,
   value: "",
   charCode: "E706",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960L1408 960Q1408 1053 1373 1134.50Q1338 1216 1277 1277Q1216 1338 1134.50 1373Q1053 1408 960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1024 0L1024 384L896 384L896 0L1024 0ZM896 1920L896 1536L1024 1536L1024 1920L896 1920ZM1536 896L1920 896L1920 1024L1536 1024L1536 896ZM384 896L384 1024L0 1024L0 896L384 896ZM598 507L507 598L236 326L326 236L598 507ZM1322 1413L1413 1322L1684 1594L1594 1684L1322 1413ZM1684 326L1413 598L1322 507L1594 236L1684 326ZM236 1594L507 1322L598 1413L326 1684L236 1594Z"
         }
      }
   ]
}

var MapPin = {
   name: "MapPin",
   vendor: "UiFabric",
   unicode: 59143,
   value: "",
   charCode: "E707",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 896L1920 2048L0 2048L384 896L896 896L896 634Q840 622 793 593Q746 564 712 522.50Q678 481 659 429Q640 377 640 320L640 320Q640 254 665 196Q690 138 733.50 94.50Q777 51 835.50 25.50Q894 0 960 0L960 0Q1026 0 1084 25.50Q1142 51 1185.50 94.50Q1229 138 1254.50 196Q1280 254 1280 320L1280 320Q1280 377 1261 429Q1242 481 1208 522.50Q1174 564 1127 593Q1080 622 1024 634L1024 634L1024 896L1536 896ZM768 320L768 320Q768 360 783 395Q798 430 824 456Q850 482 885 497Q920 512 960 512L960 512Q1000 512 1035 497Q1070 482 1096 456Q1122 430 1137 395Q1152 360 1152 320L1152 320Q1152 280 1137 245Q1122 210 1096 184Q1070 158 1035 143Q1000 128 960 128L960 128Q920 128 885 143Q850 158 824 184Q798 210 783 245Q768 280 768 320ZM476 1024L178 1920L1742 1920L1444 1024L1024 1024L1024 1504Q1024 1513 1016.50 1519.50Q1009 1526 998.50 1529.50Q988 1533 977.50 1534.50Q967 1536 960 1536L960 1536Q953 1536 942.50 1534.50Q932 1533 921.50 1529.50Q911 1526 903.50 1519.50Q896 1513 896 1504L896 1504L896 1024L476 1024Z"
         }
      }
   ]
}

var Airplane = {
   name: "Airplane",
   vendor: "UiFabric",
   unicode: 59145,
   value: "",
   charCode: "E709",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 768L1792 768Q1844 768 1891 788.50Q1938 809 1972.50 843.50Q2007 878 2027.50 925Q2048 972 2048 1024L2048 1024Q2048 1077 2027.50 1123.50Q2007 1170 1972.50 1204.50Q1938 1239 1891 1259.50Q1844 1280 1792 1280L1792 1280L1344 1280L960 2048L512 2048L768 1280L512 1280L448 1408L0 1408L128 1024L0 640L448 640L512 768L768 768L512 0L960 0L1344 768ZM1265 1152L1792 1152Q1819 1152 1842 1142Q1865 1132 1882.50 1114.50Q1900 1097 1910 1074Q1920 1051 1920 1024L1920 1024Q1920 997 1910 974Q1900 951 1882.50 933.50Q1865 916 1842 906Q1819 896 1792 896L1792 896L1265 896Q1166 704 1072 512.50Q978 321 881 128L881 128L690 128Q754 321 817 512.50Q880 704 946 896L946 896L433 896L369 768L178 768Q199 832 219.50 896Q240 960 263 1024L263 1024Q240 1088 219.50 1152Q199 1216 178 1280L178 1280L369 1280L433 1152L946 1152Q880 1344 817 1535.50Q754 1727 690 1920L690 1920L881 1920Q978 1727 1072 1535.50Q1166 1344 1265 1152L1265 1152Z"
         }
      }
   ]
}

var Tablet = {
   name: "Tablet",
   vendor: "UiFabric",
   unicode: 59146,
   value: "",
   charCode: "E70A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M160 256L1888 256Q1921 256 1950 268.50Q1979 281 2001 303Q2023 325 2035.50 354Q2048 383 2048 416L2048 416L2048 1632Q2048 1665 2035.50 1694Q2023 1723 2001 1745Q1979 1767 1950 1779.50Q1921 1792 1888 1792L1888 1792L160 1792Q127 1792 98 1779.50Q69 1767 47 1745Q25 1723 12.50 1694Q0 1665 0 1632L0 1632L0 416Q0 383 12.50 354Q25 325 47 303Q69 281 98 268.50Q127 256 160 256L160 256ZM1920 1632L1920 1632L1920 416Q1920 402 1911 393Q1902 384 1888 384L1888 384L160 384Q146 384 137 393Q128 402 128 416L128 416L128 1632Q128 1646 137 1655Q146 1664 160 1664L160 1664L1888 1664Q1902 1664 1911 1655Q1920 1646 1920 1632ZM1152 1536L896 1536L896 1408L1152 1408L1152 1536Z"
         }
      }
   ]
}

var QuickNote = {
   name: "QuickNote",
   vendor: "UiFabric",
   unicode: 59147,
   value: "",
   charCode: "E70B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L640 1920L128 1408L128 128ZM309 1408L640 1739L640 1408L309 1408ZM1792 1792L1792 256L256 256L256 1280L768 1280L768 1792L1792 1792Z"
         }
      }
   ]
}

var ChevronUp = {
   name: "ChevronUp",
   vendor: "UiFabric",
   unicode: 59150,
   value: "",
   charCode: "E70E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2045 1443L1955 1533L1024 603L93 1533L3 1443L1024 421L2045 1443Z"
         }
      }
   ]
}

var More = {
   name: "More",
   vendor: "UiFabric",
   unicode: 59154,
   value: "",
   charCode: "E712",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 896L256 896Q283 896 306 906Q329 916 346.50 933.50Q364 951 374 974Q384 997 384 1024L384 1024Q384 1051 374 1074Q364 1097 346.50 1114.50Q329 1132 306 1142Q283 1152 256 1152L256 1152Q229 1152 206 1142Q183 1132 165.50 1114.50Q148 1097 138 1074Q128 1051 128 1024L128 1024Q128 997 138 974Q148 951 165.50 933.50Q183 916 206 906Q229 896 256 896ZM1024 896L1024 896Q1051 896 1074 906Q1097 916 1114.50 933.50Q1132 951 1142 974Q1152 997 1152 1024L1152 1024Q1152 1051 1142 1074Q1132 1097 1114.50 1114.50Q1097 1132 1074 1142Q1051 1152 1024 1152L1024 1152Q997 1152 974 1142Q951 1132 933.50 1114.50Q916 1097 906 1074Q896 1051 896 1024L896 1024Q896 997 906 974Q916 951 933.50 933.50Q951 916 974 906Q997 896 1024 896ZM1792 896L1792 896Q1819 896 1842 906Q1865 916 1882.50 933.50Q1900 951 1910 974Q1920 997 1920 1024L1920 1024Q1920 1051 1910 1074Q1900 1097 1882.50 1114.50Q1865 1132 1842 1142Q1819 1152 1792 1152L1792 1152Q1765 1152 1742 1142Q1719 1132 1701.50 1114.50Q1684 1097 1674 1074Q1664 1051 1664 1024L1664 1024Q1664 997 1674 974Q1684 951 1701.50 933.50Q1719 916 1742 906Q1765 896 1792 896Z"
         }
      }
   ]
}

var Video = {
   name: "Video",
   vendor: "UiFabric",
   unicode: 59156,
   value: "",
   charCode: "E714",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 504L2048 1544L1536 1288L1536 1536L0 1536L0 512L1536 512L1536 760L2048 504ZM1408 1408L1408 640L128 640L128 1408L1408 1408ZM1920 1337L1920 711L1536 904L1536 1144L1920 1337Z"
         }
      }
   ]
}

var Phone = {
   name: "Phone",
   vendor: "UiFabric",
   unicode: 59159,
   value: "",
   charCode: "E717",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1607 1213L1607 1213Q1651 1213 1691.50 1229.50Q1732 1246 1763 1277L1763 1277L1983 1497Q2014 1528 2030.50 1568.50Q2047 1609 2047 1653L2047 1653Q2047 1697 2030.50 1737.50Q2014 1778 1983 1809L1983 1809L1969 1823Q1915 1877 1870 1919Q1825 1961 1776 1989.50Q1727 2018 1667 2033Q1607 2048 1524 2048L1524 2048Q1399 2048 1267 2009Q1135 1970 1004.50 1901Q874 1832 748.50 1737Q623 1642 511.50 1529.50Q400 1417 306 1291.50Q212 1166 144 1035.50Q76 905 38 775Q0 645 0 523L0 523Q0 440 14.50 381Q29 322 57.50 273Q86 224 127.50 179.50Q169 135 223 81L223 81L239 65Q270 34 310 17Q350 0 395 0L395 0Q439 0 479.50 17Q520 34 551 65L551 65L771 285Q802 316 818.50 356.50Q835 397 835 441L835 441Q835 485 820 519.50Q805 554 783 582Q761 610 734.50 633Q708 656 686 678Q664 700 649 722.50Q634 745 634 771L634 771Q634 809 661 836L661 836L1212 1387Q1239 1414 1277 1414L1277 1414Q1303 1414 1325.50 1399Q1348 1384 1370 1362Q1392 1340 1415 1313.50Q1438 1287 1466 1265Q1494 1243 1528.50 1228Q1563 1213 1607 1213ZM1524 1920L1524 1920Q1596 1920 1644.50 1906.50Q1693 1893 1732 1867.50Q1771 1842 1808 1804Q1845 1766 1893 1718L1893 1718Q1920 1691 1920 1653L1920 1653Q1920 1635 1905.50 1610.50Q1891 1586 1868 1559Q1845 1532 1816.50 1503.50Q1788 1475 1760.50 1449.50Q1733 1424 1709.50 1402.50Q1686 1381 1673 1368L1673 1368Q1646 1341 1607 1341L1607 1341Q1581 1341 1559 1356Q1537 1371 1515 1393Q1493 1415 1469.50 1441.50Q1446 1468 1418 1490Q1390 1512 1355.50 1527Q1321 1542 1277 1542L1277 1542Q1233 1542 1192.50 1525.50Q1152 1509 1121 1478L1121 1478L570 927Q539 896 522.50 855.50Q506 815 506 771L506 771Q506 727 521 692.50Q536 658 558 630Q580 602 606.50 578.50Q633 555 655 533Q677 511 692 489Q707 467 707 441L707 441Q707 402 680 375L680 375Q667 362 645.50 338.50Q624 315 598.50 287.50Q573 260 544.50 231.50Q516 203 489 180Q462 157 437.50 142.50Q413 128 395 128L395 128Q357 128 330 155L330 155Q282 203 244.50 240Q207 277 180.50 316Q154 355 140.50 403.50Q127 452 127 523L127 523Q127 635 163.50 754Q200 873 264.50 992Q329 1111 417 1226.50Q505 1342 609 1445Q713 1548 828.50 1635Q944 1722 1062.50 1785.50Q1181 1849 1298.50 1884.50Q1416 1920 1524 1920Z"
         }
      }
   ]
}

var Stop = {
   name: "Stop",
   vendor: "UiFabric",
   unicode: 59162,
   value: "",
   charCode: "E71A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1792 1792L1792 256L256 256L256 1792L1792 1792Z"
         }
      }
   ]
}

var Link = {
   name: "Link",
   vendor: "UiFabric",
   unicode: 59163,
   value: "",
   charCode: "E71B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 768L1536 768L1536 896Q1612 896 1681.50 913.50Q1751 931 1804 969.50Q1857 1008 1888.50 1068.50Q1920 1129 1920 1216L1920 1216Q1920 1282 1894.50 1340Q1869 1398 1825.50 1441.50Q1782 1485 1724 1510.50Q1666 1536 1600 1536L1600 1536L1088 1536Q1022 1536 964 1510.50Q906 1485 862.50 1441.50Q819 1398 793.50 1340Q768 1282 768 1216L768 1216Q768 1129 799.50 1068.50Q831 1008 884 969.50Q937 931 1006.50 913.50Q1076 896 1152 896L1152 896L1152 768L1088 768Q995 768 913.50 803.50Q832 839 771.50 899.50Q711 960 675.50 1041.50Q640 1123 640 1216L640 1216Q640 1309 675.50 1390.50Q711 1472 771.50 1532.50Q832 1593 913.50 1628.50Q995 1664 1088 1664L1088 1664L1600 1664Q1693 1664 1774.50 1628.50Q1856 1593 1916.50 1532.50Q1977 1472 2012.50 1390.50Q2048 1309 2048 1216L2048 1216Q2048 1123 2012.50 1041.50Q1977 960 1916.50 899.50Q1856 839 1774.50 803.50Q1693 768 1600 768L1600 768ZM960 1280L896 1280L896 1152Q972 1152 1041.50 1134.50Q1111 1117 1164 1078.50Q1217 1040 1248.50 979.50Q1280 919 1280 832L1280 832Q1280 766 1254.50 708Q1229 650 1185.50 606.50Q1142 563 1084 537.50Q1026 512 960 512L960 512L448 512Q382 512 324 537.50Q266 563 222.50 606.50Q179 650 153.50 708Q128 766 128 832L128 832Q128 919 159.50 979.50Q191 1040 244 1078.50Q297 1117 366.50 1134.50Q436 1152 512 1152L512 1152L512 1280L448 1280Q355 1280 273.50 1244.50Q192 1209 131.50 1148.50Q71 1088 35.50 1006.50Q0 925 0 832L0 832Q0 739 35.50 657.50Q71 576 131.50 515.50Q192 455 273.50 419.50Q355 384 448 384L448 384L960 384Q1053 384 1134.50 419.50Q1216 455 1276.50 515.50Q1337 576 1372.50 657.50Q1408 739 1408 832L1408 832Q1408 925 1372.50 1006.50Q1337 1088 1276.50 1148.50Q1216 1209 1134.50 1244.50Q1053 1280 960 1280L960 1280Z"
         }
      }
   ]
}

var AllApps = {
   name: "AllApps",
   vendor: "UiFabric",
   unicode: 59165,
   value: "",
   charCode: "E71D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1408L0 1408L0 1024L384 1024L384 1408ZM256 1152L128 1152L128 1280L256 1280L256 1152ZM384 896L0 896L0 512L384 512L384 896ZM256 640L128 640L128 768L256 768L256 640ZM384 384L0 384L0 0L384 0L384 384ZM256 128L128 128L128 256L256 256L256 128ZM1792 768L640 768L640 640L1792 640L1792 768ZM640 1152L1536 1152L1536 1280L640 1280L640 1152ZM640 256L640 128L2048 128L2048 256L640 256ZM384 1920L0 1920L0 1536L384 1536L384 1920ZM256 1664L128 1664L128 1792L256 1792L256 1664ZM1792 1792L640 1792L640 1664L1792 1664L1792 1792Z"
         }
      }
   ]
}

var Zoom = {
   name: "Zoom",
   vendor: "UiFabric",
   unicode: 59166,
   value: "",
   charCode: "E71E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1978L2048 1978Q2048 2006 2031 2027Q2014 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1154 1245Q1058 1324 943.50 1366Q829 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 349 1312Q271 1266 206.50 1201.50Q142 1137 96 1059Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 349Q142 271 206.50 206.50Q271 142 349 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059 96Q1137 142 1201.50 206.50Q1266 271 1312 349Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 829 1366 943.50Q1324 1058 1245 1154L1245 1154Q1260 1169 1302.50 1211Q1345 1253 1404.50 1311Q1464 1369 1534.50 1438.50Q1605 1508 1676.50 1579.50Q1748 1651 1815 1719Q1882 1787 1934 1842Q1986 1897 2017 1933.50Q2048 1970 2048 1978ZM704 1280L704 1280Q823 1280 928 1234.50Q1033 1189 1111 1111Q1189 1033 1234.50 928Q1280 823 1280 704L1280 704Q1280 585 1234.50 480Q1189 375 1111 297Q1033 219 928 173.50Q823 128 704 128L704 128Q585 128 480 173.50Q375 219 297 297Q219 375 173.50 480Q128 585 128 704L128 704Q128 823 173.50 928Q219 1033 297 1111Q375 1189 480 1234.50Q585 1280 704 1280Z"
         }
      }
   ]
}

var ZoomOut = {
   name: "ZoomOut",
   vendor: "UiFabric",
   unicode: 59167,
   value: "",
   charCode: "E71F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1978L2048 1978Q2048 2006 2031 2027Q2014 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1154 1245Q1058 1324 943.50 1366Q829 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 349 1312Q271 1266 206.50 1201.50Q142 1137 96 1059Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 349Q142 271 206.50 206.50Q271 142 349 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059 96Q1137 142 1201.50 206.50Q1266 271 1312 349Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 829 1366 943.50Q1324 1058 1245 1154L1245 1154Q1260 1169 1302.50 1211Q1345 1253 1404.50 1311Q1464 1369 1534.50 1438.50Q1605 1508 1676.50 1579.50Q1748 1651 1815 1719Q1882 1787 1934 1842Q1986 1897 2017 1933.50Q2048 1970 2048 1978ZM704 1280L704 1280Q823 1280 928 1234.50Q1033 1189 1111 1111Q1189 1033 1234.50 928Q1280 823 1280 704L1280 704Q1280 585 1234.50 480Q1189 375 1111 297Q1033 219 928 173.50Q823 128 704 128L704 128Q585 128 480 173.50Q375 219 297 297Q219 375 173.50 480Q128 585 128 704L128 704Q128 823 173.50 928Q219 1033 297 1111Q375 1189 480 1234.50Q585 1280 704 1280ZM384 768L384 640L1024 640L1024 768L384 768Z"
         }
      }
   ]
}

var Microphone = {
   name: "Microphone",
   vendor: "UiFabric",
   unicode: 59168,
   value: "",
   charCode: "E720",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 1536L704 1536Q664 1536 629 1521Q594 1506 568 1480Q542 1454 527 1419Q512 1384 512 1344L512 1344L512 192Q512 152 527 117Q542 82 568 56Q594 30 629 15Q664 0 704 0L704 0L1216 0Q1256 0 1291 15Q1326 30 1352 56Q1378 82 1393 117Q1408 152 1408 192L1408 192L1408 1344Q1408 1384 1393 1419Q1378 1454 1352 1480Q1326 1506 1291 1521Q1256 1536 1216 1536L1216 1536ZM640 192L640 1344Q640 1370 659 1389Q678 1408 704 1408L704 1408L1216 1408Q1242 1408 1261 1389Q1280 1370 1280 1344L1280 1344L1280 192Q1280 166 1261 147Q1242 128 1216 128L1216 128L704 128Q678 128 659 147Q640 166 640 192L640 192ZM1536 1024L1664 1024L1664 1386Q1664 1470 1632 1544Q1600 1618 1545 1673Q1490 1728 1416 1760Q1342 1792 1258 1792L1258 1792L1024 1792L1024 1920L1280 1920L1280 2048L640 2048L640 1920L896 1920L896 1792L662 1792Q578 1792 504 1760Q430 1728 375 1673Q320 1618 288 1544Q256 1470 256 1386L256 1386L256 1024L384 1024L384 1386Q384 1443 406 1494Q428 1545 465.50 1582.50Q503 1620 554 1642Q605 1664 662 1664L662 1664L1258 1664Q1315 1664 1366 1642Q1417 1620 1454.50 1582.50Q1492 1545 1514 1494Q1536 1443 1536 1386L1536 1386L1536 1024Z"
         }
      }
   ]
}

var FavoriteList = {
   name: "FavoriteList",
   vendor: "UiFabric",
   unicode: 59176,
   value: "",
   charCode: "E728",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1264 768L2048 768L2048 896L1170 896Q1134 778 1097.50 662.50Q1061 547 1024 429L1024 429Q987 547 950.50 662.50Q914 778 878 896L878 896L376 896Q478 974 578 1052Q678 1130 781 1207L781 1207Q741 1331 703 1453.50Q665 1576 627 1700L627 1700L1024 1394L1024 1556L384 2048L632 1254L0 768L784 768L1024 0L1264 768ZM1152 1280L1152 1152L2048 1152L2048 1280L1152 1280ZM1152 1664L1152 1536L2048 1536L2048 1664L1152 1664Z"
         }
      }
   ]
}

var PageSolid = {
   name: "PageSolid",
   vendor: "UiFabric",
   unicode: 59177,
   value: "",
   charCode: "E729",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 37L1755 512L1280 512L1280 37ZM1152 640L1792 640L1792 2048L128 2048L128 0L1152 0L1152 640Z"
         }
      }
   ]
}

var Forward = {
   name: "Forward",
   vendor: "UiFabric",
   unicode: 59178,
   value: "",
   charCode: "E72A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1101 83L2042 1024L1101 1965L1011 1875L1798 1088L0 1088L0 960L1798 960L1011 173L1101 83Z"
         }
      }
   ]
}

var Back = {
   name: "Back",
   vendor: "UiFabric",
   unicode: 59179,
   value: "",
   charCode: "E72B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 960L2048 1088L250 1088L1037 1875L947 1965L6 1024L947 83L1037 173L250 960L2048 960Z"
         }
      }
   ]
}

var Refresh = {
   name: "Refresh",
   vendor: "UiFabric",
   unicode: 59180,
   value: "",
   charCode: "E72C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1297 38L1297 38Q1463 83 1601 178.50Q1739 274 1838.50 404.50Q1938 535 1993 693.50Q2048 852 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 884 37 752Q74 620 142.50 503.50Q211 387 309 291.50Q407 196 530 128L530 128L256 128L256 0L768 0L768 512L640 512L640 215Q523 271 428.50 355.50Q334 440 267 545.50Q200 651 164 773Q128 895 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 874 1871.50 735Q1823 596 1736 482Q1649 368 1528.50 284.50Q1408 201 1263 161L1263 161L1297 38Z"
         }
      }
   ]
}

var Lock = {
   name: "Lock",
   vendor: "UiFabric",
   unicode: 59182,
   value: "",
   charCode: "E72E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 896L1792 896L1792 2048L256 2048L256 896L512 896L512 522Q512 414 551 319Q590 224 659 153Q728 82 821.50 41Q915 0 1024 0L1024 0Q1133 0 1226.50 41Q1320 82 1389 153Q1458 224 1497 319Q1536 414 1536 522L1536 522L1536 896ZM640 522L640 896L1408 896L1408 522Q1408 441 1379 369.50Q1350 298 1298.50 244Q1247 190 1176.50 159Q1106 128 1024 128L1024 128Q942 128 871.50 159Q801 190 749.50 244Q698 298 669 369.50Q640 441 640 522L640 522ZM1664 1920L1664 1024L384 1024L384 1920L1664 1920Z"
         }
      }
   ]
}

var BlockedSite = {
   name: "BlockedSite",
   vendor: "UiFabric",
   unicode: 59183,
   value: "",
   charCode: "E72F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1028 960L1314 674L1246 606L960 892L674 606L606 674L892 960L606 1246L674 1314L960 1028L1244 1312L1312 1244L1028 960ZM960 2045L960 2045Q841 1975 723.50 1895.50Q606 1816 499.50 1724.50Q393 1633 301.50 1529Q210 1425 143 1306Q76 1187 38 1053Q0 919 0 768L0 768L0 256Q83 256 161 250Q239 244 313 228Q387 212 459 183Q531 154 603 108L603 108Q688 53 773 26.50Q858 0 960 0L960 0Q1011 0 1057 6.50Q1103 13 1146.50 26.50Q1190 40 1232 60.50Q1274 81 1317 108L1317 108Q1389 154 1461 183Q1533 212 1607 228Q1681 244 1759 250Q1837 256 1920 256L1920 256L1920 768Q1920 919 1882 1053Q1844 1187 1777 1306Q1710 1425 1618.50 1529Q1527 1633 1420.50 1724.50Q1314 1816 1196.50 1895.50Q1079 1975 960 2045ZM128 382L128 382L128 768Q128 895 161.50 1012Q195 1129 253 1234.50Q311 1340 391 1434.50Q471 1529 563 1612.50Q655 1696 756.50 1767Q858 1838 960 1897L960 1897Q1062 1838 1163.50 1767Q1265 1696 1357 1612.50Q1449 1529 1529 1434.50Q1609 1340 1667 1234.50Q1725 1129 1758.50 1012Q1792 895 1792 768L1792 768L1792 382Q1643 374 1506.50 334Q1370 294 1244 213L1244 213Q1176 169 1108.50 148.50Q1041 128 960 128L960 128Q879 128 811.50 148.50Q744 169 676 213L676 213Q550 294 413.50 334Q277 374 128 382Z"
         }
      }
   ]
}

var ReportHacked = {
   name: "ReportHacked",
   vendor: "UiFabric",
   unicode: 59184,
   value: "",
   charCode: "E730",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1408L1024 1536L896 1536L896 1408L1024 1408ZM1024 1280L1024 384L896 384L896 1280L1024 1280ZM960 2045L960 2045Q841 1975 723.50 1895.50Q606 1816 499.50 1724.50Q393 1633 301.50 1529Q210 1425 143 1306Q76 1187 38 1053Q0 919 0 768L0 768L0 256Q83 256 161 250Q239 244 313 228Q387 212 459 183Q531 154 603 108L603 108Q688 53 773 26.50Q858 0 960 0L960 0Q1011 0 1057 6.50Q1103 13 1146.50 26.50Q1190 40 1232 60.50Q1274 81 1317 108L1317 108Q1389 154 1461 183Q1533 212 1607 228Q1681 244 1759 250Q1837 256 1920 256L1920 256L1920 768Q1920 919 1882 1053Q1844 1187 1777 1306Q1710 1425 1618.50 1529Q1527 1633 1420.50 1724.50Q1314 1816 1196.50 1895.50Q1079 1975 960 2045ZM128 382L128 382L128 768Q128 895 161.50 1012Q195 1129 253 1234.50Q311 1340 391 1434.50Q471 1529 563 1612.50Q655 1696 756.50 1767Q858 1838 960 1897L960 1897Q1062 1838 1163.50 1767Q1265 1696 1357 1612.50Q1449 1529 1529 1434.50Q1609 1340 1667 1234.50Q1725 1129 1758.50 1012Q1792 895 1792 768L1792 768L1792 382Q1643 374 1506.50 334Q1370 294 1244 213L1244 213Q1176 169 1108.50 148.50Q1041 128 960 128L960 128Q879 128 811.50 148.50Q744 169 676 213L676 213Q550 294 413.50 334Q277 374 128 382Z"
         }
      }
   ]
}

var Blocked = {
   name: "Blocked",
   vendor: "UiFabric",
   unicode: 59187,
   value: "",
   charCode: "E733",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1295.50 36.50Q1426 73 1540 140Q1654 207 1747.50 300.50Q1841 394 1908 508Q1975 622 2011.50 752.50Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1295.50Q1975 1426 1908 1540Q1841 1654 1747.50 1747.50Q1654 1841 1540 1908Q1426 1975 1295.50 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752.50 2011.50Q622 1975 508 1908Q394 1841 300.50 1747.50Q207 1654 140 1540Q73 1426 36.50 1295.50Q0 1165 0 1024L0 1024Q0 883 36.50 752.50Q73 622 140 508Q207 394 300.50 300.50Q394 207 508 140Q622 73 752.50 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1188 1920 1337.50 1864Q1487 1808 1611 1701L1611 1701L347 437Q240 561 184 710.50Q128 860 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250.50 1476.50Q309 1576 390.50 1657.50Q472 1739 571.50 1797.50Q671 1856 785.50 1888Q900 1920 1024 1920ZM437 347L1701 1611Q1808 1487 1864 1337.50Q1920 1188 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q860 128 710.50 184Q561 240 437 347L437 347Z"
         }
      }
   ]
}

var FavoriteStar = {
   name: "FavoriteStar",
   vendor: "UiFabric",
   unicode: 59188,
   value: "",
   charCode: "E734",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 768L1416 1254L1664 2048L1024 1556L384 2048L632 1254L0 768L784 768L1024 0L1264 768L2048 768ZM1024 1394L1421 1700Q1383 1576 1345 1453.50Q1307 1331 1267 1207L1267 1207Q1370 1130 1470 1052Q1570 974 1672 896L1672 896L1170 896L1024 429L878 896L376 896Q478 974 578 1052Q678 1130 781 1207L781 1207Q741 1331 703 1453.50Q665 1576 627 1700L627 1700L1024 1394Z"
         }
      }
   ]
}

var ReadingMode = {
   name: "ReadingMode",
   vendor: "UiFabric",
   unicode: 59190,
   value: "",
   charCode: "E736",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 256L1920 256L1920 1920L0 1920L0 256L256 256L256 128L640 128Q728 128 809.50 155Q891 182 960 236L960 236Q1029 182 1110.50 155Q1192 128 1280 128L1280 128L1664 128L1664 256ZM1536 256L1280 256Q1210 256 1144 279.50Q1078 303 1024 348L1024 348L1024 1602Q1083 1569 1148 1552.50Q1213 1536 1280 1536L1280 1536L1536 1536L1536 256ZM384 256L384 1536L640 1536Q707 1536 772 1552.50Q837 1569 896 1602L896 1602L896 348Q842 303 776 279.50Q710 256 640 256L640 256L384 256ZM128 384L128 1792L934 1792Q902 1761 869 1737.50Q836 1714 800.50 1697.50Q765 1681 725.50 1672.50Q686 1664 640 1664L640 1664L256 1664L256 384L128 384ZM1792 1792L1792 384L1664 384L1664 1664L1280 1664Q1234 1664 1194.50 1672.50Q1155 1681 1119.50 1697.50Q1084 1714 1051 1737.50Q1018 1761 986 1792L986 1792L1792 1792Z"
         }
      }
   ]
}

var Favicon = {
   name: "Favicon",
   vendor: "UiFabric",
   unicode: 59191,
   value: "",
   charCode: "E737",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1792L0 1792L0 128ZM1920 256L128 256L128 512L1920 512L1920 256ZM128 1664L1920 1664L1920 640L128 640L128 1664Z"
         }
      }
   ]
}

var Checkbox = {
   name: "Checkbox",
   vendor: "UiFabric",
   unicode: 59193,
   value: "",
   charCode: "E739",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1920L1920 128L128 128L128 1920L1920 1920Z"
         }
      }
   ]
}

var CheckboxComposite = {
   name: "CheckboxComposite",
   vendor: "UiFabric",
   unicode: 59194,
   value: "",
   charCode: "E73A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1920L1920 128L128 128L128 1920L1920 1920ZM1709 685L768 1627L339 1197L429 1107L768 1445L1619 595L1709 685Z"
         }
      }
   ]
}

var CheckboxFill = {
   name: "CheckboxFill",
   vendor: "UiFabric",
   unicode: 59195,
   value: "",
   charCode: "E73B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0Z"
         }
      }
   ]
}

var CheckboxCompositeReversed = {
   name: "CheckboxCompositeReversed",
   vendor: "UiFabric",
   unicode: 59197,
   value: "",
   charCode: "E73D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM768 1627L1709 685L1619 595L768 1445L429 1107L339 1197L768 1627Z"
         }
      }
   ]
}

var BackToWindow = {
   name: "BackToWindow",
   vendor: "UiFabric",
   unicode: 59199,
   value: "",
   charCode: "E73F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1280L256 1152L896 1152L896 1792L768 1792L768 1371L93 2045L3 1955L677 1280L256 1280ZM2045 93L1371 768L1792 768L1792 896L1152 896L1152 256L1280 256L1280 677L1955 3L2045 93Z"
         }
      }
   ]
}

var FullScreen = {
   name: "FullScreen",
   vendor: "UiFabric",
   unicode: 59200,
   value: "",
   charCode: "E740",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 128L1920 128L1920 768L1792 768L1792 347L347 1792L768 1792L768 1920L128 1920L128 1280L256 1280L256 1701L1701 256L1280 256L1280 128Z"
         }
      }
   ]
}

var Up = {
   name: "Up",
   vendor: "UiFabric",
   unicode: 59210,
   value: "",
   charCode: "E74A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1965 947L1875 1037L1088 250L1088 2048L960 2048L960 250L173 1037L83 947L1024 6L1965 947Z"
         }
      }
   ]
}

var Down = {
   name: "Down",
   vendor: "UiFabric",
   unicode: 59211,
   value: "",
   charCode: "E74B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1875 1011L1965 1101L1024 2042L83 1101L173 1011L960 1798L960 0L1088 0L1088 1798L1875 1011Z"
         }
      }
   ]
}

var OEM = {
   name: "OEM",
   vendor: "UiFabric",
   unicode: 59212,
   value: "",
   charCode: "E74C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 576L1600 1024L1792 1024L1792 1920L128 1920L128 256L1024 256L1024 448L1472 0L2048 576ZM1472 158L1054 576L1472 994L1890 576L1472 158ZM1344 1024L1024 704L1024 1024L1344 1024ZM256 384L256 1024L896 1024L896 384L256 384ZM896 1792L896 1152L256 1152L256 1792L896 1792ZM1664 1152L1024 1152L1024 1792L1664 1792L1664 1152Z"
         }
      }
   ]
}

var Cloud = {
   name: "Cloud",
   vendor: "UiFabric",
   unicode: 59219,
   value: "",
   charCode: "E753",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1661 896L1661 896Q1741 896 1811.50 926Q1882 956 1934.50 1007.50Q1987 1059 2017.50 1129Q2048 1199 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664L512 1664Q406 1664 312.50 1624Q219 1584 149.50 1514.50Q80 1445 40 1351.50Q0 1258 0 1152L0 1152Q0 1046 40 952.50Q80 859 149.50 789.50Q219 720 312.50 680Q406 640 512 640L512 640Q558 640 605 649L605 649Q645 587 697.50 537.50Q750 488 812 454Q874 420 944 402Q1014 384 1088 384L1088 384Q1199 384 1297.50 423Q1396 462 1472 530.50Q1548 599 1597.50 693Q1647 787 1661 896ZM512 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024L1536 1024L1536 960Q1536 867 1501 785.50Q1466 704 1405 643Q1344 582 1262.50 547Q1181 512 1088 512L1088 512Q1018 512 953 533Q888 554 833.50 592Q779 630 737 683.50Q695 737 670 803L670 803Q595 768 512 768L512 768Q432 768 362.50 798Q293 828 240.50 880.50Q188 933 158 1003Q128 1073 128 1152L128 1152Q128 1232 158 1301.50Q188 1371 240.50 1423.50Q293 1476 362.50 1506Q432 1536 512 1536L512 1536Z"
         }
      }
   ]
}

var Flashlight = {
   name: "Flashlight",
   vendor: "UiFabric",
   unicode: 59220,
   value: "",
   charCode: "E754",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1573 384L2048 384L2048 1536L1573 1536L1317 1280L0 1280L0 640L1317 640L1573 384ZM128 768L128 1152L1280 1152L1280 768L128 768ZM1408 1189L1627 1408L1664 1408L1664 512L1627 512L1408 731L1408 1189ZM1920 1408L1920 512L1792 512L1792 1408L1920 1408ZM1088 896L1088 896Q1114 896 1133 915Q1152 934 1152 960L1152 960Q1152 986 1133 1005Q1114 1024 1088 1024L1088 1024Q1062 1024 1043 1005Q1024 986 1024 960L1024 960Q1024 934 1043 915Q1062 896 1088 896Z"
         }
      }
   ]
}

var Sad = {
   name: "Sad",
   vendor: "UiFabric",
   unicode: 59223,
   value: "",
   charCode: "E757",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 896L640 896Q613 896 590 886Q567 876 549.50 858.50Q532 841 522 818Q512 795 512 768L512 768Q512 741 522 718Q532 695 549.50 677.50Q567 660 590 650Q613 640 640 640L640 640Q667 640 690 650Q713 660 730.50 677.50Q748 695 758 718Q768 741 768 768L768 768Q768 795 758 818Q748 841 730.50 858.50Q713 876 690 886Q667 896 640 896ZM1408 640L1408 640Q1435 640 1458 650Q1481 660 1498.50 677.50Q1516 695 1526 718Q1536 741 1536 768L1536 768Q1536 795 1526 818Q1516 841 1498.50 858.50Q1481 876 1458 886Q1435 896 1408 896L1408 896Q1381 896 1358 886Q1335 876 1317.50 858.50Q1300 841 1290 818Q1280 795 1280 768L1280 768Q1280 741 1290 718Q1300 695 1317.50 677.50Q1335 660 1358 650Q1381 640 1408 640ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1024 1280L1024 1280Q1162 1280 1285.50 1336.50Q1409 1393 1501 1496L1501 1496L1405 1581Q1331 1498 1233.50 1453Q1136 1408 1024 1408L1024 1408Q912 1408 814.50 1453Q717 1498 643 1581L643 1581L547 1496Q639 1393 762.50 1336.50Q886 1280 1024 1280Z"
         }
      }
   ]
}

var RealEstate = {
   name: "RealEstate",
   vendor: "UiFabric",
   unicode: 59224,
   value: "",
   charCode: "E758",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1024L1280 1920L1664 1920L1664 2048L1152 2048L1152 1152L768 1152L768 2048L256 2048L256 987L173 1069L83 979L960 102L1837 979L1747 1069L1664 987L1664 1152L1536 1152L1536 859L960 282L384 859L384 1920L640 1920L640 1024L1280 1024ZM1408 1280L2048 1280L2048 2048L1920 2048L1920 1792L1408 1792L1408 1280ZM1920 1664L1920 1408L1536 1408L1536 1664L1920 1664Z"
         }
      }
   ]
}

var Move = {
   name: "Move",
   vendor: "UiFabric",
   unicode: 59330,
   value: "",
   charCode: "E7C2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1024L245 1024L451 1229L360 1320L0 960L360 600L451 691L245 896L640 896L640 1024ZM1560 600L1920 960L1564 1315L1474 1225L1675 1024L1280 1024L1280 896L1675 896L1469 691L1560 600ZM896 245L695 446L605 356L960 0L1320 360L1229 451L1024 245L1024 640L896 640L896 245ZM1024 1675L1229 1469L1320 1560L960 1920L600 1560L691 1469L896 1675L896 1280L1024 1280L1024 1675Z"
         }
      }
   ]
}

var EraseTool = {
   name: "EraseTool",
   vendor: "UiFabric",
   unicode: 59228,
   value: "",
   charCode: "E75C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2042 864L1115 1792L1536 1792L1536 1920L453 1920L50 1516Q26 1492 13 1459.50Q0 1427 0 1392L0 1392Q0 1357 13 1324.50Q26 1292 51 1267L51 1267L1248 69L2042 864ZM1861 864L1248 250L538 960L1152 1573L1861 864ZM506 1792L933 1792L1061 1664L448 1050L142 1357Q128 1371 128 1392L128 1392Q128 1413 142 1427L142 1427L506 1792Z"
         }
      }
   ]
}

var GripperTool = {
   name: "GripperTool",
   vendor: "UiFabric",
   unicode: 59230,
   value: "",
   charCode: "E75E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1156 0 1272.50 50.50Q1389 101 1476 188Q1563 275 1613.50 391.50Q1664 508 1664 640L1664 640L1664 1408Q1664 1540 1613.50 1656.50Q1563 1773 1476 1860Q1389 1947 1272.50 1997.50Q1156 2048 1024 2048L1024 2048Q892 2048 775.50 1997.50Q659 1947 572 1860Q485 1773 434.50 1656.50Q384 1540 384 1408L384 1408L384 640Q384 508 434.50 391.50Q485 275 572 188Q659 101 775.50 50.50Q892 0 1024 0ZM1024 1024L1024 1024Q1103 1024 1173 993.50Q1243 963 1295 911Q1347 859 1377.50 789Q1408 719 1408 640L1408 640Q1408 561 1377.50 491Q1347 421 1295 369Q1243 317 1173 286.50Q1103 256 1024 256L1024 256Q945 256 875 286.50Q805 317 753 369Q701 421 670.50 491Q640 561 640 640L640 640Q640 719 670.50 789Q701 859 753 911Q805 963 875 993.50Q945 1024 1024 1024ZM1024 373L1024 373Q1079 373 1127.50 394Q1176 415 1212.50 451.50Q1249 488 1270 536.50Q1291 585 1291 640L1291 640Q1291 695 1270 743.50Q1249 792 1212.50 828.50Q1176 865 1127.50 886Q1079 907 1024 907L1024 907Q969 907 920.50 886Q872 865 835.50 828.50Q799 792 778 743.50Q757 695 757 640L757 640Q757 585 778 536.50Q799 488 835.50 451.50Q872 415 920.50 394Q969 373 1024 373Z"
         }
      }
   ]
}

var Dialpad = {
   name: "Dialpad",
   vendor: "UiFabric",
   unicode: 59231,
   value: "",
   charCode: "E75F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 128L640 384L384 384L384 128L640 128ZM1152 128L1152 384L896 384L896 128L1152 128ZM1664 128L1664 384L1408 384L1408 128L1664 128ZM640 640L640 896L384 896L384 640L640 640ZM1152 640L1152 896L896 896L896 640L1152 640ZM1664 640L1664 896L1408 896L1408 640L1664 640ZM640 1152L640 1408L384 1408L384 1152L640 1152ZM1152 1152L1152 1408L896 1408L896 1152L1152 1152ZM1152 1664L1152 1920L896 1920L896 1664L1152 1664ZM1664 1152L1664 1408L1408 1408L1408 1152L1664 1152Z"
         }
      }
   ]
}

var Play = {
   name: "Play",
   vendor: "UiFabric",
   unicode: 59240,
   value: "",
   charCode: "E768",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 128L1792 1024L512 1920L512 128ZM640 374L640 1674L1569 1024L640 374Z"
         }
      }
   ]
}

var Pause = {
   name: "Pause",
   vendor: "UiFabric",
   unicode: 59241,
   value: "",
   charCode: "E769",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1792L640 256L768 256L768 1792L640 1792ZM1280 256L1408 256L1408 1792L1280 1792L1280 256Z"
         }
      }
   ]
}

var ChevronLeft = {
   name: "ChevronLeft",
   vendor: "UiFabric",
   unicode: 59243,
   value: "",
   charCode: "E76B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1533 1955L1443 2045L421 1024L1443 3L1533 93L603 1024L1533 1955Z"
         }
      }
   ]
}

var ChevronRight = {
   name: "ChevronRight",
   vendor: "UiFabric",
   unicode: 59244,
   value: "",
   charCode: "E76C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M605 2045L515 1955L1445 1024L515 93L605 3L1627 1024L605 2045Z"
         }
      }
   ]
}

var InkingTool = {
   name: "InkingTool",
   vendor: "UiFabric",
   unicode: 59245,
   value: "",
   charCode: "E76D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 0L1920 512L1800 512L1351 1408L1279 1408Q1278 1436 1275.50 1478.50Q1273 1521 1267.50 1571.50Q1262 1622 1252.50 1676.50Q1243 1731 1229.50 1784Q1216 1837 1197 1885Q1178 1933 1153 1969Q1128 2005 1096 2026.50Q1064 2048 1024 2048L1024 2048Q971 2048 932 2011Q893 1974 865 1915.50Q837 1857 818.50 1784.50Q800 1712 789.50 1640.50Q779 1569 774.50 1507.50Q770 1446 769 1408L769 1408L697 1408L248 512L128 512L128 0L256 0L256 384L1792 384L1792 0L1920 0ZM1024 1920L1024 1920Q1047 1908 1065 1872.50Q1083 1837 1097 1788Q1111 1739 1120.50 1683Q1130 1627 1136.50 1574Q1143 1521 1146.50 1477Q1150 1433 1151 1408L1151 1408L897 1408Q898 1433 901.50 1477Q905 1521 911.50 1574Q918 1627 927.50 1683Q937 1739 951 1788Q965 1837 983 1872.50Q1001 1908 1024 1920ZM1272 1280L1656 512L392 512L776 1280L1272 1280Z"
         }
      }
   ]
}

var GripperBarHorizontal = {
   name: "GripperBarHorizontal",
   vendor: "UiFabric",
   unicode: 59247,
   value: "",
   charCode: "E76F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 896L0 768L2048 768L2048 896L0 896ZM2048 1280L0 1280L0 1152L2048 1152L2048 1280Z"
         }
      }
   ]
}

var System = {
   name: "System",
   vendor: "UiFabric",
   unicode: 59248,
   value: "",
   charCode: "E770",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1317L2000 1525Q2012 1537 2021 1554Q2030 1571 2036 1590Q2042 1609 2045 1628.50Q2048 1648 2048 1664L2048 1664Q2048 1691 2038 1714Q2028 1737 2010.50 1754.50Q1993 1772 1970 1782Q1947 1792 1920 1792L1920 1792L128 1792Q101 1792 78 1782Q55 1772 37.50 1754.50Q20 1737 10 1714Q0 1691 0 1664L0 1664Q0 1648 3 1628.50Q6 1609 12 1590Q18 1571 27 1554Q36 1537 48 1525L48 1525L256 1317L256 384L1792 384L1792 1317ZM384 512L384 1280L1664 1280L1664 512L384 512ZM128 1664L1920 1664Q1920 1653 1916 1635.50Q1912 1618 1904 1610L1904 1610L1701 1408L347 1408L144 1610Q136 1618 132 1635.50Q128 1653 128 1664L128 1664Z"
         }
      }
   ]
}

var Personalize = {
   name: "Personalize",
   vendor: "UiFabric",
   unicode: 59249,
   value: "",
   charCode: "E771",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1792L1024 1792L1024 1920L1280 1920L1280 2048L640 2048L640 1920L896 1920L896 1792L0 1792L0 640L1024 640L895 768L128 768L128 1664L1792 1664L1792 896L1920 768L1920 1792ZM256 1408L512 1408Q539 1408 562 1398Q585 1388 602.50 1370.50Q620 1353 630 1330Q640 1307 640 1280L640 1280Q640 1231 657.50 1187Q675 1143 705.50 1109Q736 1075 777.50 1052.50Q819 1030 868 1025L868 1025L1579 314Q1607 286 1644 271Q1681 256 1720 256L1720 256Q1761 256 1797.50 271.50Q1834 287 1861 314Q1888 341 1903.50 377.50Q1919 414 1919 456L1919 456Q1919 495 1904 532Q1889 569 1861 597L1861 597L1150 1308Q1145 1356 1123 1398Q1101 1440 1066.50 1470.50Q1032 1501 988.50 1518.50Q945 1536 896 1536L896 1536L256 1536L256 1408ZM1720 384L1720 384Q1691 384 1670 405L1670 405L1225 850Q1282 894 1326 951L1326 951L1771 506Q1792 485 1792 456L1792 456Q1792 426 1770.50 405Q1749 384 1720 384ZM1133 941L1042 1033Q1103 1073 1143 1134L1143 1134L1235 1043Q1193 983 1133 941L1133 941ZM1024 1280L1024 1280Q1024 1253 1014 1230Q1004 1207 986.50 1189.50Q969 1172 946 1162Q923 1152 896 1152L896 1152Q869 1152 846 1162Q823 1172 805.50 1189.50Q788 1207 778 1230Q768 1253 768 1280L768 1280Q768 1348 734 1408L734 1408L896 1408Q922 1408 945.50 1398Q969 1388 986.50 1370.50Q1004 1353 1014 1329.50Q1024 1306 1024 1280Z"
         }
      }
   ]
}

var SearchAndApps = {
   name: "SearchAndApps",
   vendor: "UiFabric",
   unicode: 59251,
   value: "",
   charCode: "E773",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 896L1664 896Q1743 896 1813 926.50Q1883 957 1935 1009Q1987 1061 2017.50 1131Q2048 1201 2048 1280L2048 1280Q2048 1359 2017.50 1429Q1987 1499 1935 1551Q1883 1603 1813 1633.50Q1743 1664 1664 1664L1664 1664Q1604 1664 1547 1646Q1490 1628 1442 1593L1442 1593Q1426 1609 1388.50 1648.50Q1351 1688 1302 1738.50Q1253 1789 1198.50 1843.50Q1144 1898 1096 1943.50Q1048 1989 1011 2018.50Q974 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1970 925.50 1933Q955 1896 1000.50 1848Q1046 1800 1100.50 1745.50Q1155 1691 1205.50 1642Q1256 1593 1295.50 1555.50Q1335 1518 1351 1502L1351 1502Q1316 1454 1298 1397Q1280 1340 1280 1280L1280 1280Q1280 1201 1310.50 1131Q1341 1061 1393 1009Q1445 957 1515 926.50Q1585 896 1664 896ZM1664 1536L1664 1536Q1716 1536 1763 1515.50Q1810 1495 1844.50 1460.50Q1879 1426 1899.50 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1228 1899.50 1181Q1879 1134 1844.50 1099.50Q1810 1065 1763 1044.50Q1716 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044.50Q1518 1065 1483.50 1099.50Q1449 1134 1428.50 1181Q1408 1228 1408 1280L1408 1280Q1408 1333 1428.50 1379.50Q1449 1426 1483.50 1460.50Q1518 1495 1564.50 1515.50Q1611 1536 1664 1536ZM1170 1408L256 1408L256 1152L0 1152L0 0L1536 0L1536 256L1792 256L1792 786Q1760 778 1728 773Q1696 768 1664 768L1664 768L1664 384L384 384L384 1280L1152 1280Q1152 1312 1157 1344Q1162 1376 1170 1408L1170 1408ZM128 1024L256 1024L256 256L1408 256L1408 128L128 128L128 1024Z"
         }
      }
   ]
}

var Globe = {
   name: "Globe",
   vendor: "UiFabric",
   unicode: 59252,
   value: "",
   charCode: "E774",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1500 640L1833 640Q1795 559 1741 487.50Q1687 416 1621 357Q1555 298 1478 252Q1401 206 1317 177L1317 177Q1353 227 1382 283Q1411 339 1433.50 398.50Q1456 458 1472 519Q1488 580 1500 640L1500 640ZM1920 1024L1920 1024Q1920 891 1883 768L1883 768L1520 768Q1528 832 1532 895.50Q1536 959 1536 1024L1536 1024Q1536 1089 1532 1152.50Q1528 1216 1520 1280L1520 1280L1883 1280Q1920 1157 1920 1024ZM1024 1920L1024 1920Q1073 1920 1115.50 1893Q1158 1866 1194 1822Q1230 1778 1258.50 1722.50Q1287 1667 1309 1610Q1331 1553 1346 1500Q1361 1447 1369 1408L1369 1408L679 1408Q687 1447 702 1500Q717 1553 739 1610Q761 1667 789.50 1722.50Q818 1778 854 1822Q890 1866 932.50 1893Q975 1920 1024 1920ZM657 1280L1391 1280Q1399 1216 1403.50 1152.50Q1408 1089 1408 1024L1408 1024Q1408 959 1403.50 895.50Q1399 832 1391 768L1391 768L657 768Q649 832 644.50 895.50Q640 959 640 1024L640 1024Q640 1089 644.50 1152.50Q649 1216 657 1280L657 1280ZM128 1024L128 1024Q128 1157 165 1280L165 1280L528 1280Q520 1216 516 1152.50Q512 1089 512 1024L512 1024Q512 959 516 895.50Q520 832 528 768L528 768L165 768Q128 891 128 1024ZM1024 128L1024 128Q975 128 932.50 155Q890 182 854 226Q818 270 789.50 325.50Q761 381 739 438Q717 495 702 548Q687 601 679 640L679 640L1369 640Q1361 601 1346 548Q1331 495 1309 438Q1287 381 1258.50 325.50Q1230 270 1194 226Q1158 182 1115.50 155Q1073 128 1024 128ZM731 177L731 177Q647 206 570 252Q493 298 427 357Q361 416 307 487.50Q253 559 215 640L215 640L548 640Q560 580 576 519Q592 458 614.50 398.50Q637 339 666 283Q695 227 731 177ZM548 1408L215 1408Q253 1489 307 1560.50Q361 1632 427 1691Q493 1750 570 1796Q647 1842 731 1871L731 1871Q695 1821 666 1765Q637 1709 614.50 1649.50Q592 1590 576 1529Q560 1468 548 1408L548 1408ZM1317 1871L1317 1871Q1401 1842 1478 1796Q1555 1750 1621 1691Q1687 1632 1741 1560.50Q1795 1489 1833 1408L1833 1408L1500 1408Q1488 1468 1472 1529Q1456 1590 1433.50 1649.50Q1411 1709 1382 1765Q1353 1821 1317 1871Z"
         }
      }
   ]
}

var EaseOfAccess = {
   name: "EaseOfAccess",
   vendor: "UiFabric",
   unicode: 59254,
   value: "",
   charCode: "E776",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M131 1024L3 1024Q14 892 64.50 770Q115 648 201 547L201 547L291 638Q222 720 182 819Q142 918 131 1024L131 1024ZM382 547L291 457Q392 371 514 320.50Q636 270 768 259L768 259L768 387Q662 398 563 438Q464 478 382 547L382 547ZM291 1538L201 1629Q115 1528 64.50 1406Q14 1284 3 1152L3 1152L131 1152Q142 1258 182 1357Q222 1456 291 1538L291 1538ZM768 1789L768 1917Q636 1906 514 1855.50Q392 1805 291 1719L291 1719L382 1629Q464 1698 563 1738Q662 1778 768 1789L768 1789ZM1533 1152L1661 1152Q1650 1284 1599.50 1406Q1549 1528 1463 1629L1463 1629L1373 1538Q1442 1456 1482 1357Q1522 1258 1533 1152L1533 1152ZM1282 1629L1373 1719Q1272 1805 1150 1855.50Q1028 1906 896 1917L896 1917L896 1789Q1002 1778 1101 1738Q1200 1698 1282 1629L1282 1629ZM896 128L1024 128L1024 896L1216 896L960 1152L704 896L896 896L896 128ZM2048 960L1792 1216L1792 1024L1269 1024L1397 896L1792 896L1792 704L2048 960Z"
         }
      }
   ]
}

var UpdateRestore = {
   name: "UpdateRestore",
   vendor: "UiFabric",
   unicode: 59255,
   value: "",
   charCode: "E777",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q852 2048 693.50 1993Q535 1938 404.50 1838.50Q274 1739 178.50 1601Q83 1463 38 1297L38 1297L161 1263Q201 1408 284.50 1528.50Q368 1649 482 1736Q596 1823 735 1871.50Q874 1920 1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q895 128 773 164Q651 200 545.50 267Q440 334 355 428.50Q270 523 215 640L215 640L512 640L512 768L0 768L0 256L128 256L128 530Q195 407 291 309Q387 211 503.50 142.50Q620 74 752 37Q884 0 1024 0Z"
         }
      }
   ]
}

var ContactInfo = {
   name: "ContactInfo",
   vendor: "UiFabric",
   unicode: 59257,
   value: "",
   charCode: "E779",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M740 1077L740 1077Q805 1110 857.50 1158.50Q910 1207 947 1266.50Q984 1326 1004 1394.50Q1024 1463 1024 1536L1024 1536L896 1536Q896 1457 865.50 1387Q835 1317 783 1265Q731 1213 661 1182.50Q591 1152 512 1152L512 1152Q433 1152 363 1182.50Q293 1213 241 1265Q189 1317 158.50 1387Q128 1457 128 1536L128 1536L0 1536Q0 1463 20 1394.50Q40 1326 77 1266.50Q114 1207 166.50 1158.50Q219 1110 284 1077L284 1077Q211 1023 169.50 941Q128 859 128 768L128 768Q128 689 158.50 619Q189 549 241 497Q293 445 363 414.50Q433 384 512 384L512 384Q591 384 661 414.50Q731 445 783 497Q835 549 865.50 619Q896 689 896 768L896 768Q896 859 854.50 941Q813 1023 740 1077ZM256 768L256 768Q256 821 276.50 867.50Q297 914 331.50 948.50Q366 983 412.50 1003.50Q459 1024 512 1024L512 1024Q564 1024 611 1003.50Q658 983 692.50 948.50Q727 914 747.50 867.50Q768 821 768 768L768 768Q768 716 747.50 669Q727 622 692.50 587.50Q658 553 611 532.50Q564 512 512 512L512 512Q459 512 412.50 532.50Q366 553 331.50 587.50Q297 622 276.50 669Q256 716 256 768ZM1152 384L2048 384L2048 512L1152 512L1152 384ZM1152 1024L1152 896L2048 896L2048 1024L1152 1024ZM1152 1536L1152 1408L2048 1408L2048 1536L1152 1536Z"
         }
      }
   ]
}

var Unpin = {
   name: "Unpin",
   vendor: "UiFabric",
   unicode: 59258,
   value: "",
   charCode: "E77A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 1152L1472 1152Q1565 1152 1646.50 1187Q1728 1222 1789 1283Q1850 1344 1885 1425.50Q1920 1507 1920 1600L1920 1600Q1920 1693 1885 1774.50Q1850 1856 1789 1917Q1728 1978 1646.50 2013Q1565 2048 1472 2048L1472 2048Q1379 2048 1297.50 2013Q1216 1978 1155 1917Q1094 1856 1059 1774.50Q1024 1693 1024 1600L1024 1600Q1024 1507 1059 1425.50Q1094 1344 1155 1283Q1216 1222 1297.50 1187Q1379 1152 1472 1152ZM1152 1600L1152 1600Q1152 1666 1177 1724.50Q1202 1783 1245.50 1826.50Q1289 1870 1347.50 1895Q1406 1920 1472 1920L1472 1920Q1519 1920 1564 1906.50Q1609 1893 1648 1867L1648 1867L1205 1424Q1179 1463 1165.50 1508Q1152 1553 1152 1600ZM1296 1333L1739 1776Q1765 1737 1778.50 1692Q1792 1647 1792 1600L1792 1600Q1792 1534 1766.50 1476Q1741 1418 1697.50 1374.50Q1654 1331 1596 1305.50Q1538 1280 1472 1280L1472 1280Q1425 1280 1380 1293.50Q1335 1307 1296 1333L1296 1333ZM1300 58L1990 748Q1957 781 1925.50 808.50Q1894 836 1860.50 855Q1827 874 1787.50 884.50Q1748 895 1698 895L1698 895Q1664 895 1633 889L1633 889L1499 1024L1317 1024L1595 746L1605 749Q1628 756 1651 761.50Q1674 767 1698 767L1698 767Q1753 767 1802 741L1802 741L1307 246Q1281 295 1281 350L1281 350Q1281 374 1286.50 397Q1292 420 1299 443L1299 443L1302 453L810 944Q786 934 764 925Q742 916 720 910Q698 904 674.50 900.50Q651 897 624 897L624 897Q567 897 513 913.50Q459 930 413 962L413 962L896 1445L896 1627L704 1434L136 2003L0 2048L45 1912L614 1344L228 958L273 913Q343 843 435 806Q527 769 626 769L626 769Q665 769 703.50 775.50Q742 782 780 794L780 794L1159 415Q1153 384 1153 350L1153 350Q1153 301 1163.50 261.50Q1174 222 1193 188Q1212 154 1239.50 122.50Q1267 91 1300 58L1300 58Z"
         }
      }
   ]
}

var Contact = {
   name: "Contact",
   vendor: "UiFabric",
   unicode: 59259,
   value: "",
   charCode: "E77B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1330 1203L1330 1203Q1466 1250 1575.50 1334.50Q1685 1419 1761.50 1530Q1838 1641 1879 1773Q1920 1905 1920 2048L1920 2048L1792 2048Q1792 1884 1733.50 1743.50Q1675 1603 1572 1500Q1469 1397 1328.50 1338.50Q1188 1280 1024 1280L1024 1280Q917 1280 818 1307Q719 1334 633.50 1383.50Q548 1433 478.50 1502.50Q409 1572 359.50 1657.50Q310 1743 283 1842Q256 1941 256 2048L256 2048L128 2048Q128 1904 170 1772.50Q212 1641 289 1531Q366 1421 475.50 1337Q585 1253 720 1204L720 1204Q642 1162 580 1102Q518 1042 474.50 968.50Q431 895 407.50 811.50Q384 728 384 640L384 640Q384 507 434 390.50Q484 274 571 187Q658 100 774.50 50Q891 0 1024 0L1024 0Q1157 0 1273.50 50Q1390 100 1477 187Q1564 274 1614 390.50Q1664 507 1664 640L1664 640Q1664 728 1640.50 811Q1617 894 1573.50 967Q1530 1040 1468.50 1100.50Q1407 1161 1330 1203ZM512 640L512 640Q512 746 552.50 839Q593 932 662.50 1001.50Q732 1071 825 1111.50Q918 1152 1024 1152L1024 1152Q1130 1152 1223 1111.50Q1316 1071 1385.50 1001.50Q1455 932 1495.50 839Q1536 746 1536 640L1536 640Q1536 534 1495.50 441Q1455 348 1385.50 278.50Q1316 209 1223 168.50Q1130 128 1024 128L1024 128Q918 128 825 168.50Q732 209 662.50 278.50Q593 348 552.50 441Q512 534 512 640Z"
         }
      }
   ]
}

var Memo = {
   name: "Memo",
   vendor: "UiFabric",
   unicode: 59260,
   value: "",
   charCode: "E77C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 512L1600 512Q1693 512 1774.50 547.50Q1856 583 1916.50 643.50Q1977 704 2012.50 785.50Q2048 867 2048 960L2048 960Q2048 1053 2012.50 1134.50Q1977 1216 1916.50 1276.50Q1856 1337 1774.50 1372.50Q1693 1408 1600 1408L1600 1408L448 1408Q355 1408 273.50 1372.50Q192 1337 131.50 1276.50Q71 1216 35.50 1134.50Q0 1053 0 960L0 960Q0 867 35.50 785.50Q71 704 131.50 643.50Q192 583 273.50 547.50Q355 512 448 512L448 512Q541 512 622.50 547.50Q704 583 764.50 643.50Q825 704 860.50 785.50Q896 867 896 960L896 960Q896 981 891.50 1010.50Q887 1040 879 1071.50Q871 1103 859 1135.50Q847 1168 832 1196.50Q817 1225 799 1247Q781 1269 761 1280L761 1280L1287 1280Q1267 1269 1249 1247Q1231 1225 1216 1196.50Q1201 1168 1189 1135.50Q1177 1103 1169 1071.50Q1161 1040 1156.50 1011Q1152 982 1152 960L1152 960Q1152 867 1187.50 785.50Q1223 704 1283.50 643.50Q1344 583 1425.50 547.50Q1507 512 1600 512ZM128 960L128 960Q128 1026 153.50 1084Q179 1142 222.50 1185.50Q266 1229 324 1254.50Q382 1280 448 1280L448 1280Q514 1280 572 1254.50Q630 1229 673.50 1185.50Q717 1142 742.50 1084Q768 1026 768 960L768 960Q768 894 742.50 836Q717 778 673.50 734.50Q630 691 572 665.50Q514 640 448 640L448 640Q382 640 324 665.50Q266 691 222.50 734.50Q179 778 153.50 836Q128 894 128 960ZM1600 1280L1600 1280Q1666 1280 1724 1254.50Q1782 1229 1825.50 1185.50Q1869 1142 1894.50 1084Q1920 1026 1920 960L1920 960Q1920 894 1894.50 836Q1869 778 1825.50 734.50Q1782 691 1724 665.50Q1666 640 1600 640L1600 640Q1534 640 1476 665.50Q1418 691 1374.50 734.50Q1331 778 1305.50 836Q1280 894 1280 960L1280 960Q1280 1026 1305.50 1084Q1331 1142 1374.50 1185.50Q1418 1229 1476 1254.50Q1534 1280 1600 1280Z"
         }
      }
   ]
}

var IncomingCall = {
   name: "IncomingCall",
   vendor: "UiFabric",
   unicode: 59262,
   value: "",
   charCode: "E77E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1530 1307L1530 1307Q1569 1307 1606 1322Q1643 1337 1671 1365L1671 1365Q1692 1386 1718.50 1409.50Q1745 1433 1773 1458.50Q1801 1484 1827 1512Q1853 1540 1874 1569.50Q1895 1599 1907.50 1631Q1920 1663 1920 1697L1920 1697Q1920 1736 1905 1773Q1890 1810 1862 1838L1862 1838Q1811 1889 1770 1928Q1729 1967 1684.50 1994Q1640 2021 1586 2034.50Q1532 2048 1457 2048L1457 2048Q1348 2048 1233 2014Q1118 1980 1004 1920Q890 1860 781 1777Q672 1694 574.50 1596Q477 1498 395 1389Q313 1280 254 1166.50Q195 1053 161.50 939.50Q128 826 128 720L128 720Q128 644 141.50 590Q155 536 181.50 492Q208 448 247 406.50Q286 365 338 314L338 314Q366 286 403 271Q440 256 479 256L479 256Q529 256 575.50 283Q622 310 664 349Q706 388 743 431Q780 474 811 505L811 505Q839 533 854 570Q869 607 869 646L869 646Q869 685 856 716Q843 747 823.50 771.50Q804 796 781.50 816.50Q759 837 739.50 856Q720 875 707 893.50Q694 912 694 933L694 933Q694 945 712.50 971.50Q731 998 762 1033Q793 1068 833.50 1110Q874 1152 917.50 1195Q961 1238 1004.50 1280Q1048 1322 1085.50 1358Q1123 1394 1151.50 1421Q1180 1448 1193 1461L1193 1461Q1214 1482 1243 1482L1243 1482Q1264 1482 1282.50 1469Q1301 1456 1319.50 1436.50Q1338 1417 1358.50 1394.50Q1379 1372 1404 1352.50Q1429 1333 1459.50 1320Q1490 1307 1530 1307ZM1457 1920L1457 1920Q1518 1920 1559.50 1908.50Q1601 1897 1634 1875Q1667 1853 1698.50 1821Q1730 1789 1771 1748L1771 1748Q1792 1727 1792 1698L1792 1698Q1792 1685 1776 1660.50Q1760 1636 1735.50 1606.50Q1711 1577 1680.50 1547Q1650 1517 1621 1492Q1592 1467 1567.50 1451Q1543 1435 1530 1435L1530 1435Q1509 1435 1490 1448Q1471 1461 1452.50 1480.50Q1434 1500 1413.50 1522.50Q1393 1545 1368 1564.50Q1343 1584 1312.50 1597Q1282 1610 1243 1610L1243 1610Q1203 1610 1166.50 1594.50Q1130 1579 1102 1551L1102 1551L625 1074Q597 1046 581.50 1009.50Q566 973 566 933L566 933Q566 894 579 863.50Q592 833 611.50 808Q631 783 653.50 762.50Q676 742 695.50 723Q715 704 728 685.50Q741 667 741 646L741 646Q741 633 725 609Q709 585 684.50 555.50Q660 526 629.50 495.50Q599 465 569.50 440.50Q540 416 516 400Q492 384 479 384L479 384Q449 384 428 405L428 405Q387 446 355 477Q323 508 301 541.50Q279 575 267.50 616Q256 657 256 717L256 717Q256 813 287 915.50Q318 1018 373.50 1121Q429 1224 505 1323Q581 1422 670 1510.50Q759 1599 858.50 1674Q958 1749 1060 1804Q1162 1859 1263 1889.50Q1364 1920 1457 1920ZM1792 896L1792 1024L1152 1024L1152 384L1280 384L1280 805L1875 211L1965 301L1371 896L1792 896Z"
         }
      }
   ]
}

var Paste = {
   name: "Paste",
   vendor: "UiFabric",
   unicode: 59263,
   value: "",
   charCode: "E77F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 768L1920 768L1920 2048L896 2048L896 1920L128 1920L128 256L640 256Q640 204 660.50 157Q681 110 715.50 75.50Q750 41 796.50 20.50Q843 0 896 0L896 0Q948 0 995 20.50Q1042 41 1076.50 75.50Q1111 110 1131.50 157Q1152 204 1152 256L1152 256L1664 256L1664 768ZM768 384L512 384L512 512L1280 512L1280 384L1024 384Q1024 368 1024.50 350.50Q1025 333 1025 315L1025 315Q1025 281 1021.50 247.50Q1018 214 1004.50 187.50Q991 161 965.50 144.50Q940 128 896 128L896 128Q852 128 826.50 144.50Q801 161 787.50 187.50Q774 214 770.50 247.50Q767 281 767 315L767 315Q767 333 767.50 350.50Q768 368 768 384L768 384ZM256 1792L896 1792L896 768L1536 768L1536 384L1408 384L1408 640L384 640L384 384L256 384L256 1792ZM1792 1920L1792 896L1024 896L1024 1920L1792 1920Z"
         }
      }
   ]
}

var Bus = {
   name: "Bus",
   vendor: "UiFabric",
   unicode: 59398,
   value: "",
   charCode: "E806",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 640L1920 640L1920 896L1792 896L1792 1856Q1792 1890 1788.50 1924.50Q1785 1959 1772.50 1986.50Q1760 2014 1734.50 2031Q1709 2048 1664 2048L1664 2048Q1639 2048 1610.50 2049Q1582 2050 1553.50 2048Q1525 2046 1498.50 2039.50Q1472 2033 1452 2019Q1432 2005 1420 1981Q1408 1957 1408 1920L1408 1920L512 1920Q512 1947 502 1970Q492 1993 474.50 2010.50Q457 2028 434 2038Q411 2048 384 2048L384 2048Q315 2048 266 2047Q217 2046 186.50 2029.50Q156 2013 142 1973.50Q128 1934 128 1856L128 1856L128 896L0 896L0 640L128 640L128 320Q128 280 143 245Q158 210 184 184Q210 158 245 143Q280 128 320 128L320 128L1600 128Q1640 128 1675 143Q1710 158 1736 184Q1762 210 1777 245Q1792 280 1792 320L1792 320L1792 640ZM1664 1536L1664 1280L256 1280L256 1536L384 1536Q384 1518 383.50 1495.50Q383 1473 388 1453.50Q393 1434 406.50 1421Q420 1408 448 1408L448 1408Q476 1408 489.50 1421Q503 1434 508 1453.50Q513 1473 512.50 1495.50Q512 1518 512 1536L512 1536L1408 1536Q1408 1518 1407.50 1495.50Q1407 1473 1412 1453.50Q1417 1434 1430.50 1421Q1444 1408 1472 1408L1472 1408Q1500 1408 1513.50 1421Q1527 1434 1532 1453.50Q1537 1473 1536.50 1495.50Q1536 1518 1536 1536L1536 1536L1664 1536ZM256 1152L896 1152L896 640L256 640L256 1152ZM1664 1152L1664 640L1024 640L1024 1152L1664 1152ZM1600 256L320 256Q294 256 275 275Q256 294 256 320L256 320L256 512L1664 512L1664 320Q1664 294 1645 275Q1626 256 1600 256L1600 256ZM256 1792L1664 1792L1664 1664L256 1664L256 1792Z"
         }
      }
   ]
}

var EatDrink = {
   name: "EatDrink",
   vendor: "UiFabric",
   unicode: 59399,
   value: "",
   charCode: "E807",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q986 0 1005 19Q1024 38 1024 64L1024 64L1024 768Q1024 821 1003.50 867.50Q983 914 948.50 948.50Q914 983 867 1003.50Q820 1024 768 1024L768 1024L768 1984Q768 2010 749 2029Q730 2048 704 2048L704 2048Q678 2048 659 2029Q640 2010 640 1984L640 1984L640 1024Q587 1024 540.50 1003.50Q494 983 459.50 948.50Q425 914 404.50 867.50Q384 821 384 768L384 768L384 64Q384 38 403 19Q422 0 448 0L448 0Q474 0 493 19Q512 38 512 64L512 64L512 768Q512 795 522 818Q532 841 549.50 858.50Q567 876 590 886Q613 896 640 896L640 896L640 64Q640 38 659 19Q678 0 704 0L704 0Q730 0 749 19Q768 38 768 64L768 64L768 896Q795 896 818 886Q841 876 858.50 858.50Q876 841 886 818Q896 795 896 768L896 768L896 64Q896 38 915 19Q934 0 960 0ZM1600 0L1664 0L1664 1984Q1664 2010 1645 2029Q1626 2048 1600 2048L1600 2048Q1574 2048 1555 2029Q1536 2010 1536 1984L1536 1984L1536 1408Q1499 1408 1456 1409Q1413 1410 1370.50 1407.50Q1328 1405 1288.50 1395.50Q1249 1386 1218.50 1364.50Q1188 1343 1170 1307.50Q1152 1272 1152 1216L1152 1216L1152 448Q1152 355 1187.50 273.50Q1223 192 1283.50 131.50Q1344 71 1425.50 35.50Q1507 0 1600 0L1600 0ZM1536 1280L1536 134Q1480 145 1433.50 174.50Q1387 204 1352.50 246Q1318 288 1299 339.50Q1280 391 1280 448L1280 448L1280 1216Q1280 1242 1299 1261Q1318 1280 1344 1280L1344 1280L1536 1280Z"
         }
      }
   ]
}

var SeeDo = {
   name: "SeeDo",
   vendor: "UiFabric",
   unicode: 59400,
   value: "",
   charCode: "E808",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 0L1408 0Q1448 0 1486 12.50Q1524 25 1556 48Q1588 71 1612.50 102.50Q1637 134 1650 172L1650 172L2013 1260Q2048 1363 2048 1472L2048 1472Q2048 1565 2012.50 1646.50Q1977 1728 1916.50 1788.50Q1856 1849 1774.50 1884.50Q1693 1920 1600 1920L1600 1920Q1511 1920 1428.50 1886Q1346 1852 1283 1789L1283 1789Q1220 1726 1186 1643.50Q1152 1561 1152 1472L1152 1472L1152 1024L896 1024L896 1472Q896 1561 862 1643.50Q828 1726 765 1789L765 1789Q702 1852 619.50 1886Q537 1920 448 1920L448 1920Q355 1920 273.50 1884.50Q192 1849 131.50 1788.50Q71 1728 35.50 1646.50Q0 1565 0 1472L0 1472Q0 1363 35 1260L35 1260Q40 1246 58 1191.50Q76 1137 102.50 1057.50Q129 978 161.50 881.50Q194 785 227 686.50Q260 588 291 494.50Q322 401 346 329Q370 257 384.50 213Q399 169 399 169L399 169Q414 132 438 100.50Q462 69 493.50 47Q525 25 562 12.50Q599 0 640 0L640 0Q714 0 761.50 24Q809 48 837.50 88.50Q866 129 879 181.50Q892 234 895.50 291Q899 348 897.50 405.50Q896 463 896 512L896 512L1152 512Q1152 463 1150.50 405.50Q1149 348 1152.50 291Q1156 234 1169 181.50Q1182 129 1210.50 88.50Q1239 48 1286.50 24Q1334 0 1408 0ZM448 1792L448 1792Q514 1792 572 1766.50Q630 1741 673.50 1697.50Q717 1654 742.50 1596Q768 1538 768 1472L768 1472Q768 1406 742.50 1348Q717 1290 673.50 1246.50Q630 1203 572 1177.50Q514 1152 448 1152L448 1152Q382 1152 324 1177.50Q266 1203 222.50 1246.50Q179 1290 153.50 1348Q128 1406 128 1472L128 1472Q128 1538 153.50 1596Q179 1654 222.50 1697.50Q266 1741 324 1766.50Q382 1792 448 1792ZM768 1159L768 256Q768 229 758 206Q748 183 730.50 165.50Q713 148 690 138Q667 128 640 128L640 128Q601 128 566.50 152Q532 176 519 214L519 214L230 1080Q281 1053 336 1038.50Q391 1024 448 1024L448 1024Q481 1024 528.50 1033.50Q576 1043 623.50 1060.50Q671 1078 710.50 1103Q750 1128 768 1159L768 1159ZM896 896L1152 896L1152 640L896 640L896 896ZM1280 256L1280 1159Q1298 1128 1337.50 1103Q1377 1078 1424.50 1060.50Q1472 1043 1519.50 1033.50Q1567 1024 1600 1024L1600 1024Q1657 1024 1712 1038.50Q1767 1053 1818 1080L1818 1080L1529 214Q1516 176 1481.50 152Q1447 128 1408 128L1408 128Q1381 128 1358 138Q1335 148 1317.50 165.50Q1300 183 1290 206Q1280 229 1280 256L1280 256ZM1600 1792L1600 1792Q1666 1792 1724 1766.50Q1782 1741 1825.50 1697.50Q1869 1654 1894.50 1596Q1920 1538 1920 1472L1920 1472Q1920 1406 1894.50 1348Q1869 1290 1825.50 1246.50Q1782 1203 1724 1177.50Q1666 1152 1600 1152L1600 1152Q1534 1152 1476 1177.50Q1418 1203 1374.50 1246.50Q1331 1290 1305.50 1348Q1280 1406 1280 1472L1280 1472Q1280 1538 1305.50 1596Q1331 1654 1374.50 1697.50Q1418 1741 1476 1766.50Q1534 1792 1600 1792Z"
         }
      }
   ]
}

var LocationCircle = {
   name: "LocationCircle",
   vendor: "UiFabric",
   unicode: 59406,
   value: "",
   charCode: "E80E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q1147 128 1261.50 160Q1376 192 1475.50 250.50Q1575 309 1657 391Q1739 473 1797.50 572.50Q1856 672 1888 786.50Q1920 901 1920 1024L1920 1024Q1920 1147 1888 1261.50Q1856 1376 1797.50 1475.50Q1739 1575 1657 1657Q1575 1739 1475.50 1797.50Q1376 1856 1261.50 1888Q1147 1920 1024 1920L1024 1920Q901 1920 786.50 1888Q672 1856 572.50 1797.50Q473 1739 391 1657Q309 1575 250.50 1475.50Q192 1376 160 1262Q128 1148 128 1024L128 1024Q128 901 160 786.50Q192 672 250.50 572.50Q309 473 391 391Q473 309 572.50 250.50Q672 192 786 160Q900 128 1024 128ZM1024 1792L1024 1792Q1130 1792 1228 1764.50Q1326 1737 1411.50 1687Q1497 1637 1567 1567Q1637 1497 1687 1411.50Q1737 1326 1764.50 1228Q1792 1130 1792 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792Z"
         }
      }
   ]
}

var Home = {
   name: "Home",
   vendor: "UiFabric",
   unicode: 59407,
   value: "",
   charCode: "E80F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M83 1107L1024 165L1965 1107L1875 1197L1792 1115L1792 1920L1152 1920L1152 1280L896 1280L896 1920L256 1920L256 1115L173 1197L83 1107ZM1280 1792L1664 1792L1664 987L1024 347L384 987L384 1792L768 1792L768 1152L1280 1152L1280 1792Z"
         }
      }
   ]
}

var SwitcherStartEnd = {
   name: "SwitcherStartEnd",
   vendor: "UiFabric",
   unicode: 59408,
   value: "",
   charCode: "E810",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M301 557L211 467L576 102L941 467L851 557L640 347L640 2048L512 2048L512 347L301 557ZM1536 1701L1747 1491L1837 1581L1472 1946L1107 1581L1197 1491L1408 1701L1408 0L1536 0L1536 1701Z"
         }
      }
   ]
}

var ParkingLocation = {
   name: "ParkingLocation",
   vendor: "UiFabric",
   unicode: 59409,
   value: "",
   charCode: "E811",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1763 896L2019 1459Q2048 1523 2048 1592L2048 1592L2048 1664Q2048 1740 2007 1803Q1966 1866 1897 1897L1897 1897Q1866 1966 1803 2007Q1740 2048 1664 2048L1664 2048Q1595 2048 1536 2014Q1477 1980 1442 1920L1442 1920L734 1920Q699 1980 640 2014Q581 2048 512 2048L512 2048Q443 2048 384 2014Q325 1980 290 1920L290 1920L128 1920Q101 1920 78 1910Q55 1900 37.50 1882.50Q20 1865 10 1842Q0 1819 0 1792L0 1792L0 1536Q0 1456 30 1386Q60 1316 112 1264Q164 1212 234 1182Q304 1152 384 1152L384 1152L421 1152L749 824Q776 797 811.50 782.50Q847 768 885 768L885 768L1792 768L1792 896L1763 896ZM1581 896L1280 896L1280 1152L1739 1152L1640 933Q1632 916 1615.50 906Q1599 896 1581 896L1581 896ZM1152 896L885 896Q859 896 840 915L840 915L603 1152L1152 1152L1152 896ZM512 1920L512 1920Q539 1920 562 1910Q585 1900 602.50 1882.50Q620 1865 630 1842Q640 1819 640 1792L640 1792Q640 1765 630 1742Q620 1719 602.50 1701.50Q585 1684 562 1674Q539 1664 512 1664L512 1664Q485 1664 462 1674Q439 1684 421.50 1701.50Q404 1719 394 1742Q384 1765 384 1792L384 1792Q384 1819 394 1842Q404 1865 421.50 1882.50Q439 1900 462 1910Q485 1920 512 1920ZM512 1536L512 1536Q565 1536 611.50 1556Q658 1576 693 1611Q728 1646 748 1692.50Q768 1739 768 1792L768 1792L1152 1792L1152 1280L384 1280Q331 1280 284.50 1300Q238 1320 203 1355Q168 1390 148 1436.50Q128 1483 128 1536L128 1536L128 1792L256 1792Q256 1739 276 1692.50Q296 1646 331 1611Q366 1576 412.50 1556Q459 1536 512 1536ZM1664 1920L1664 1920Q1691 1920 1714 1910Q1737 1900 1754.50 1882.50Q1772 1865 1782 1842Q1792 1819 1792 1792L1792 1792Q1792 1765 1782 1742Q1772 1719 1754.50 1701.50Q1737 1684 1714 1674Q1691 1664 1664 1664L1664 1664Q1637 1664 1614 1674Q1591 1684 1573.50 1701.50Q1556 1719 1546 1742Q1536 1765 1536 1792L1536 1792Q1536 1819 1546 1842Q1556 1865 1573.50 1882.50Q1591 1900 1614 1910Q1637 1920 1664 1920ZM1920 1664L1920 1592Q1920 1551 1903 1512L1903 1512L1797 1280L1280 1280L1280 1792L1408 1792Q1408 1739 1428 1692.50Q1448 1646 1483 1611Q1518 1576 1564.50 1556Q1611 1536 1664 1536L1664 1536Q1706 1536 1745 1549Q1784 1562 1816 1586Q1848 1610 1872 1643.50Q1896 1677 1909 1717L1909 1717Q1920 1690 1920 1664L1920 1664Z"
         }
      }
   ]
}

var MapDirections = {
   name: "MapDirections",
   vendor: "UiFabric",
   unicode: 59414,
   value: "",
   charCode: "E816",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1024L1024 0L2048 1024L1024 2048L0 1024ZM768 1024L768 1611L1024 1867L1867 1024L1024 181L181 1024L640 1483L640 896L1189 896L979 685L1069 595L1434 960L1069 1325L979 1235L1189 1024L768 1024Z"
         }
      }
   ]
}

var CaretHollow = {
   name: "CaretHollow",
   vendor: "UiFabric",
   unicode: 59415,
   value: "",
   charCode: "E817",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1755L640 293L1371 1024L640 1755ZM1189 1024L768 603L768 1445L1189 1024Z"
         }
      }
   ]
}

var CaretSolid = {
   name: "CaretSolid",
   vendor: "UiFabric",
   unicode: 59416,
   value: "",
   charCode: "E818",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M549 1536L549 1536L1536 549L1536 1536L549 1536Z"
         }
      }
   ]
}

var History = {
   name: "History",
   vendor: "UiFabric",
   unicode: 59420,
   value: "",
   charCode: "E81C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 512L1024 512L1024 1061L1389 1427L1299 1517L896 1115L896 512ZM1968 625L1968 625Q2048 817 2048 1024L2048 1024Q2048 1231 1968 1423L1968 1423Q1890 1606 1748 1748L1748 1748Q1606 1890 1423 1968L1423 1968Q1231 2048 1024 2048L1024 2048Q850 2048 688 1991L688 1991Q530 1936 399 1835L399 1835Q269 1734 176 1597L176 1597Q129 1528 94.50 1453Q60 1378 38 1297L38 1297L161 1263Q201 1408 284.50 1529Q368 1650 482 1737Q596 1824 735 1872Q874 1920 1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q894 128 772 164.50Q650 201 544.50 268Q439 335 354.50 429.50Q270 524 215 640L215 640L512 640L512 768L0 768L0 256L128 256L128 530Q145 498 165 467.50Q185 437 207 408L207 408Q301 283 427 192L427 192Q559 98 710 49Q861 0 1024 0L1024 0Q1231 0 1423 80L1423 80Q1606 158 1748 300L1748 300Q1890 442 1968 625Z"
         }
      }
   ]
}

var Work = {
   name: "Work",
   vendor: "UiFabric",
   unicode: 59425,
   value: "",
   charCode: "E821",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 384L2048 384L2048 1664L0 1664L0 384L640 384L640 256Q640 229 650 206Q660 183 677.50 165.50Q695 148 718 138Q741 128 768 128L768 128L1280 128Q1307 128 1330 138Q1353 148 1370.50 165.50Q1388 183 1398 206Q1408 229 1408 256L1408 256L1408 384ZM768 256L768 384L1280 384L1280 256L768 256ZM1920 512L128 512L128 697L768 1016L768 896L1280 896L1280 1016L1920 697L1920 512ZM1152 1024L896 1024L896 1152L1152 1152L1152 1024ZM128 1536L1920 1536L1920 839L1280 1160L1280 1280L768 1280L768 1160L128 839L128 1536Z"
         }
      }
   ]
}

var Recent = {
   name: "Recent",
   vendor: "UiFabric",
   unicode: 59427,
   value: "",
   charCode: "E823",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 2048L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1166 2011.50 1296.50Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048ZM1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128ZM1408 1024L1024 1024L1024 384L896 384L896 1152L1408 1152L1408 1024Z"
         }
      }
   ]
}

var Hotel = {
   name: "Hotel",
   vendor: "UiFabric",
   unicode: 59428,
   value: "",
   charCode: "E824",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1152L2048 1152L2048 1920L1920 1920L1920 1792L128 1792L128 1920L0 1920L0 1152L128 1152L128 1265L384 753L384 128L512 128L512 256L1536 256L1536 128L1664 128L1664 512Q1691 512 1714 522Q1737 532 1754.50 549.50Q1772 567 1782 590Q1792 613 1792 640L1792 640L1792 896Q1792 935 1771 966L1771 966L1920 1265L1920 1152ZM1664 640L1152 640L1152 896L1664 896L1664 640ZM1536 384L512 384L512 768L1024 768L1024 640Q1024 613 1034 590Q1044 567 1061.50 549.50Q1079 532 1102 522Q1125 512 1152 512L1152 512L1536 512L1536 384ZM455 896L264 1280L1784 1280L1656 1024L1152 1024Q1125 1024 1102 1014Q1079 1004 1061.50 986.50Q1044 969 1034 946Q1024 923 1024 896L1024 896L455 896ZM128 1664L1920 1664L1920 1408L128 1408L128 1664Z"
         }
      }
   ]
}

var Bank = {
   name: "Bank",
   vendor: "UiFabric",
   unicode: 59429,
   value: "",
   charCode: "E825",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 768L1792 768L1792 1536Q1792 1537 1801 1563.50Q1810 1590 1823.50 1630.50Q1837 1671 1853 1719Q1869 1767 1883 1809.50Q1897 1852 1907.50 1882.50Q1918 1913 1920 1920L1920 1920L0 1920Q2 1913 12.50 1882.50Q23 1852 37 1809.50Q51 1767 67 1719Q83 1671 96.50 1630.50Q110 1590 119 1563.50Q128 1537 128 1536L128 1536L128 768L0 768L0 640L960 160L1920 640L1920 768ZM960 303L286 640L1634 640L960 303ZM1664 768L1536 768L1536 1536L1664 1536L1664 768ZM1408 768L1280 768L1280 1536L1408 1536L1408 768ZM1152 768L1024 768L1024 1536L1152 1536L1152 768ZM896 768L768 768L768 1536L896 1536L896 768ZM640 768L512 768L512 1536L640 1536L640 768ZM256 768L256 1536L384 1536L384 768L256 768ZM178 1792L1742 1792L1700 1664L220 1664L178 1792Z"
         }
      }
   ]
}

var LocationDot = {
   name: "LocationDot",
   vendor: "UiFabric",
   unicode: 59431,
   value: "",
   charCode: "E827",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1024 640Q1103 640 1173 670.50Q1243 701 1295 753Q1347 805 1377.50 875Q1408 945 1408 1024L1408 1024Q1408 1103 1377.50 1173Q1347 1243 1295 1295Q1243 1347 1173 1377.50Q1103 1408 1024 1408L1024 1408Q945 1408 875 1377.50Q805 1347 753 1295Q701 1243 670.50 1173Q640 1103 640 1024L640 1024Q640 945 670.50 875Q701 805 753 753Q805 701 875 670.50Q945 640 1024 640Z"
         }
      }
   ]
}

var Group = {
   name: "Group",
   vendor: "UiFabric",
   unicode: 59650,
   value: "",
   charCode: "E902",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1850 688L1850 688Q1895 713 1932 749.50Q1969 786 1994.50 829.50Q2020 873 2034 922.50Q2048 972 2048 1024L2048 1024L1920 1024Q1920 972 1899.50 925Q1879 878 1844.50 843.50Q1810 809 1763 788.50Q1716 768 1664 768L1664 768Q1611 768 1564.50 788.50Q1518 809 1483.50 843.50Q1449 878 1428.50 925Q1408 972 1408 1024L1408 1024Q1408 1115 1366.50 1197Q1325 1279 1252 1333L1252 1333Q1317 1366 1369.50 1414.50Q1422 1463 1459 1522.50Q1496 1582 1516 1650.50Q1536 1719 1536 1792L1536 1792L1408 1792Q1408 1713 1377.50 1643Q1347 1573 1295 1521Q1243 1469 1173 1438.50Q1103 1408 1024 1408L1024 1408Q945 1408 875 1438.50Q805 1469 753 1521Q701 1573 670.50 1643Q640 1713 640 1792L640 1792L512 1792Q512 1719 532 1650.50Q552 1582 589 1522.50Q626 1463 678.50 1414.50Q731 1366 796 1333L796 1333Q723 1279 681.50 1197Q640 1115 640 1024L640 1024Q640 972 619.50 925Q599 878 564.50 843.50Q530 809 483 788.50Q436 768 384 768L384 768Q331 768 284.50 788.50Q238 809 203.50 843.50Q169 878 148.50 925Q128 972 128 1024L128 1024L0 1024Q0 972 14 922.50Q28 873 53.50 829.50Q79 786 116 749.50Q153 713 198 688L198 688Q165 653 146.50 607Q128 561 128 512L128 512Q128 460 148.50 413Q169 366 203.50 331.50Q238 297 284.50 276.50Q331 256 384 256L384 256Q436 256 483 276.50Q530 297 564.50 331.50Q599 366 619.50 413Q640 460 640 512L640 512Q640 561 621.50 607Q603 653 570 688L570 688Q652 733 704 812L704 812Q758 732 842.50 686Q927 640 1024 640L1024 640Q1121 640 1205.50 686Q1290 732 1344 812L1344 812Q1396 733 1478 688L1478 688Q1445 653 1426.50 607Q1408 561 1408 512L1408 512Q1408 460 1428.50 413Q1449 366 1483.50 331.50Q1518 297 1564.50 276.50Q1611 256 1664 256L1664 256Q1716 256 1763 276.50Q1810 297 1844.50 331.50Q1879 366 1899.50 413Q1920 460 1920 512L1920 512Q1920 561 1901.50 607Q1883 653 1850 688ZM256 512L256 512Q256 539 266 562Q276 585 293.50 602.50Q311 620 334 630Q357 640 384 640L384 640Q411 640 434 630Q457 620 474.50 602.50Q492 585 502 562Q512 539 512 512L512 512Q512 485 502 462Q492 439 474.50 421.50Q457 404 434 394Q411 384 384 384L384 384Q357 384 334 394Q311 404 293.50 421.50Q276 439 266 462Q256 485 256 512ZM1024 1280L1024 1280Q1076 1280 1123 1259.50Q1170 1239 1204.50 1204.50Q1239 1170 1259.50 1123.50Q1280 1077 1280 1024L1280 1024Q1280 972 1259.50 925Q1239 878 1204.50 843.50Q1170 809 1123 788.50Q1076 768 1024 768L1024 768Q971 768 924.50 788.50Q878 809 843.50 843.50Q809 878 788.50 925Q768 972 768 1024L768 1024Q768 1077 788.50 1123.50Q809 1170 843.50 1204.50Q878 1239 924.50 1259.50Q971 1280 1024 1280ZM1536 512L1536 512Q1536 539 1546 562Q1556 585 1573.50 602.50Q1591 620 1614 630Q1637 640 1664 640L1664 640Q1691 640 1714 630Q1737 620 1754.50 602.50Q1772 585 1782 562Q1792 539 1792 512L1792 512Q1792 485 1782 462Q1772 439 1754.50 421.50Q1737 404 1714 394Q1691 384 1664 384L1664 384Q1637 384 1614 394Q1591 404 1573.50 421.50Q1556 439 1546 462Q1536 485 1536 512Z"
         }
      }
   ]
}

var News = {
   name: "News",
   vendor: "UiFabric",
   unicode: 59648,
   value: "",
   charCode: "E900",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 512L2048 512L2048 1408Q2048 1461 2027.50 1507.50Q2007 1554 1972.50 1588.50Q1938 1623 1891 1643.50Q1844 1664 1792 1664L1792 1664L249 1664Q198 1664 152.50 1644Q107 1624 73.50 1590.50Q40 1557 20 1511.50Q0 1466 0 1415L0 1415L0 256L1792 256L1792 512ZM1920 1408L1920 640L1792 640L1792 1344Q1792 1370 1773 1389Q1754 1408 1728 1408L1728 1408Q1702 1408 1683 1389Q1664 1370 1664 1344L1664 1344L1664 384L128 384L128 1415Q128 1440 137.50 1462Q147 1484 163.50 1500.50Q180 1517 202 1526.50Q224 1536 249 1536L249 1536L1792 1536Q1819 1536 1842 1526Q1865 1516 1882.50 1498.50Q1900 1481 1910 1458Q1920 1435 1920 1408L1920 1408ZM1536 512L1536 640L256 640L256 512L1536 512ZM1536 1280L1536 1408L1024 1408L1024 1280L1536 1280ZM1536 1024L1536 1152L1024 1152L1024 1024L1536 1024ZM1536 768L1536 896L1024 896L1024 768L1536 768ZM896 765L896 1408L256 1408L256 765L896 765ZM384 893L384 1280L768 1280L768 893L384 893Z"
         }
      }
   ]
}

var Edit = {
   name: "Edit",
   vendor: "UiFabric",
   unicode: 59151,
   value: "",
   charCode: "E70F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 335L2048 335Q2048 401 2023 463Q1998 525 1950 573L1950 573L633 1890L0 2048L158 1415L1475 98Q1523 50 1585 25Q1647 0 1713 0L1713 0Q1782 0 1843 26.50Q1904 53 1949.50 98.50Q1995 144 2021.50 205Q2048 266 2048 335ZM1408 347L326 1428Q432 1463 508.50 1539.50Q585 1616 620 1722L620 1722L1701 640L1408 347ZM258 1543L176 1872L505 1790Q495 1744 472.50 1703Q450 1662 418 1630Q386 1598 345 1575.50Q304 1553 258 1543L258 1543ZM1499 256L1792 549Q1817 524 1840 502Q1863 480 1881 455.50Q1899 431 1909.50 402.50Q1920 374 1920 336L1920 336Q1920 293 1903.50 255.50Q1887 218 1858.50 189.50Q1830 161 1792.50 144.50Q1755 128 1712 128L1712 128Q1674 128 1645.50 138.50Q1617 149 1592.50 167Q1568 185 1546 208Q1524 231 1499 256L1499 256Z"
         }
      }
   ]
}

var People = {
   name: "People",
   vendor: "UiFabric",
   unicode: 59158,
   value: "",
   charCode: "E716",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1636 693L1636 693Q1701 726 1753.50 774.50Q1806 823 1843 882.50Q1880 942 1900 1010.50Q1920 1079 1920 1152L1920 1152L1792 1152Q1792 1073 1761.50 1003Q1731 933 1679 881Q1627 829 1557 798.50Q1487 768 1408 768L1408 768Q1329 768 1259 798.50Q1189 829 1137 881Q1085 933 1054.50 1003Q1024 1073 1024 1152L1024 1152Q1024 1243 982.50 1325Q941 1407 868 1461L868 1461Q933 1494 985.50 1542.50Q1038 1591 1075 1650.50Q1112 1710 1132 1778.50Q1152 1847 1152 1920L1152 1920L1024 1920Q1024 1841 993.50 1771Q963 1701 911 1649Q859 1597 789 1566.50Q719 1536 640 1536L640 1536Q561 1536 491 1566.50Q421 1597 369 1649Q317 1701 286.50 1771Q256 1841 256 1920L256 1920L128 1920Q128 1847 148 1778.50Q168 1710 205 1650.50Q242 1591 294.50 1542.50Q347 1494 412 1461L412 1461Q339 1407 297.50 1325Q256 1243 256 1152L256 1152Q256 1073 286.50 1003Q317 933 369 881Q421 829 491 798.50Q561 768 640 768L640 768Q731 768 813 809.50Q895 851 949 924L949 924Q987 849 1046 790Q1105 731 1180 693L1180 693Q1107 639 1065.50 557Q1024 475 1024 384L1024 384Q1024 305 1054.50 235Q1085 165 1137 113Q1189 61 1259 30.50Q1329 0 1408 0L1408 0Q1487 0 1557 30.50Q1627 61 1679 113Q1731 165 1761.50 235Q1792 305 1792 384L1792 384Q1792 475 1750.50 557Q1709 639 1636 693ZM640 1408L640 1408Q692 1408 739 1387.50Q786 1367 820.50 1332.50Q855 1298 875.50 1251.50Q896 1205 896 1152L896 1152Q896 1100 875.50 1053Q855 1006 820.50 971.50Q786 937 739 916.50Q692 896 640 896L640 896Q587 896 540.50 916.50Q494 937 459.50 971.50Q425 1006 404.50 1053Q384 1100 384 1152L384 1152Q384 1205 404.50 1251.50Q425 1298 459.50 1332.50Q494 1367 540.50 1387.50Q587 1408 640 1408ZM1152 384L1152 384Q1152 437 1172.50 483.50Q1193 530 1227.50 564.50Q1262 599 1308.50 619.50Q1355 640 1408 640L1408 640Q1460 640 1507 619.50Q1554 599 1588.50 564.50Q1623 530 1643.50 483.50Q1664 437 1664 384L1664 384Q1664 332 1643.50 285Q1623 238 1588.50 203.50Q1554 169 1507 148.50Q1460 128 1408 128L1408 128Q1355 128 1308.50 148.50Q1262 169 1227.50 203.50Q1193 238 1172.50 285Q1152 332 1152 384Z"
         }
      }
   ]
}

var Search = {
   name: "Search",
   vendor: "UiFabric",
   unicode: 59169,
   value: "",
   charCode: "E721",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 0L1344 0Q1441 0 1531 25Q1621 50 1699 96Q1777 142 1841.50 206.50Q1906 271 1952 349Q1998 427 2023 517Q2048 607 2048 704L2048 704Q2048 801 2023 891Q1998 981 1952 1059Q1906 1137 1841.50 1201.50Q1777 1266 1699 1312Q1621 1358 1531 1383Q1441 1408 1344 1408L1344 1408Q1219 1408 1104.50 1366Q990 1324 894 1245L894 1245L109 2029Q90 2048 64 2048L64 2048Q38 2048 19 2029Q0 2010 0 1984L0 1984Q0 1958 19 1939L19 1939L803 1154Q724 1058 682 943.50Q640 829 640 704L640 704Q640 607 665 517Q690 427 736 349Q782 271 846.50 206.50Q911 142 989 96Q1067 50 1157 25Q1247 0 1344 0ZM1344 1280L1344 1280Q1463 1280 1568 1234.50Q1673 1189 1751 1111Q1829 1033 1874.50 928Q1920 823 1920 704L1920 704Q1920 585 1874.50 480Q1829 375 1751 297Q1673 219 1568 173.50Q1463 128 1344 128L1344 128Q1225 128 1120 173.50Q1015 219 937 297Q859 375 813.50 480Q768 585 768 704L768 704Q768 823 813.50 928Q859 1033 937 1111Q1015 1189 1120 1234.50Q1225 1280 1344 1280Z"
         }
      }
   ]
}

var Camera = {
   name: "Camera",
   vendor: "UiFabric",
   unicode: 59170,
   value: "",
   charCode: "E722",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1499 256L2048 256L2048 1792L0 1792L0 256L549 256L677 128L1371 128L1499 256ZM1920 1664L1920 384L1445 384L1317 256L731 256L603 384L128 384L128 1664L1920 1664ZM1024 512L1024 512Q1130 512 1223.50 552Q1317 592 1386.50 661.50Q1456 731 1496 824.50Q1536 918 1536 1024L1536 1024Q1536 1130 1496 1223.50Q1456 1317 1386.50 1386.50Q1317 1456 1223.50 1496Q1130 1536 1024 1536L1024 1536Q918 1536 824.50 1496Q731 1456 661.50 1386.50Q592 1317 552 1223.50Q512 1130 512 1024L512 1024Q512 918 552 824.50Q592 731 661.50 661.50Q731 592 824.50 552Q918 512 1024 512ZM1024 1408L1024 1408Q1103 1408 1173 1377.50Q1243 1347 1295 1295Q1347 1243 1377.50 1173Q1408 1103 1408 1024L1408 1024Q1408 945 1377.50 875Q1347 805 1295 753Q1243 701 1173 670.50Q1103 640 1024 640L1024 640Q945 640 875 670.50Q805 701 753 753Q701 805 670.50 875Q640 945 640 1024L640 1024Q640 1103 670.50 1173Q701 1243 753 1295Q805 1347 875 1377.50Q945 1408 1024 1408ZM320 512L320 512Q346 512 365 531Q384 550 384 576L384 576Q384 602 365 621Q346 640 320 640L320 640Q294 640 275 621Q256 602 256 576L256 576Q256 550 275 531Q294 512 320 512Z"
         }
      }
   ]
}

var CheckMark = {
   name: "CheckMark",
   vendor: "UiFabric",
   unicode: 59198,
   value: "",
   charCode: "E73E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1747 467L1837 557L768 1627L211 1069L301 979L768 1445L1747 467Z"
         }
      }
   ]
}

var Delete = {
   name: "Delete",
   vendor: "UiFabric",
   unicode: 59213,
   value: "",
   charCode: "E74D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 256L1792 384L1664 384L1664 1856Q1664 1896 1649 1931Q1634 1966 1608 1992Q1582 2018 1547 2033Q1512 2048 1472 2048L1472 2048L448 2048Q408 2048 373 2033Q338 2018 312 1992Q286 1966 271 1931Q256 1896 256 1856L256 1856L256 384L128 384L128 256L640 256L640 128Q640 101 650 78Q660 55 677.50 37.50Q695 20 718 10Q741 0 768 0L768 0L1152 0Q1179 0 1202 10Q1225 20 1242.50 37.50Q1260 55 1270 78Q1280 101 1280 128L1280 128L1280 256L1792 256ZM768 128L768 256L1152 256L1152 128L768 128ZM1536 1856L1536 384L384 384L384 1856Q384 1882 403 1901Q422 1920 448 1920L448 1920L1472 1920Q1498 1920 1517 1901Q1536 1882 1536 1856L1536 1856ZM768 640L768 1664L640 1664L640 640L768 640ZM1024 640L1024 1664L896 1664L896 640L1024 640ZM1280 640L1280 1664L1152 1664L1152 640L1280 640Z"
         }
      }
   ]
}

var Save = {
   name: "Save",
   vendor: "UiFabric",
   unicode: 59214,
   value: "",
   charCode: "E74E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L1792 128Q1819 128 1842 138Q1865 148 1882.50 165.50Q1900 183 1910 206Q1920 229 1920 256L1920 256L1920 1920L357 1920L128 1690L128 256Q128 229 138 206Q148 183 165.50 165.50Q183 148 206 138Q229 128 256 128L256 128ZM512 256L512 896L1536 896L1536 256L512 256ZM1280 1792L1280 1408L640 1408L640 1792L768 1792L768 1536L896 1536L896 1792L1280 1792ZM1792 1792L1792 256L1664 256L1664 1024L384 1024L384 256L256 256L256 1637L410 1792L512 1792L512 1280L1408 1280L1408 1792L1792 1792Z"
         }
      }
   ]
}

var Package = {
   name: "Package",
   vendor: "UiFabric",
   unicode: 59320,
   value: "",
   charCode: "E7B8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 128L2048 768L1920 768L1920 1920L128 1920L128 768L0 768L0 128L2048 128ZM1792 1792L1792 768L256 768L256 1792L1792 1792ZM1920 640L1920 256L128 256L128 640L1920 640ZM1024 1280L1024 1408L384 1408L384 1280L1024 1280ZM896 1664L384 1664L384 1536L896 1536L896 1664Z"
         }
      }
   ]
}

var Error = {
   name: "Error",
   vendor: "UiFabric",
   unicode: 59267,
   value: "",
   charCode: "E783",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1093 0 1215.50 34Q1338 68 1445 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 475Q1852 582 1886 704.50Q1920 827 1920 960L1920 960Q1920 1093 1886 1215.50Q1852 1338 1789.50 1445Q1727 1552 1639.50 1639.50Q1552 1727 1445 1789.50Q1338 1852 1215.50 1886Q1093 1920 960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0ZM960 1792L960 1792Q1074 1792 1180.50 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 846 1762 739.50Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1180.50 158Q1074 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739.50Q128 846 128 960L128 960Q128 1074 158 1180.50Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM896 1152L896 512L1024 512L1024 1152L896 1152ZM896 1408L896 1280L1024 1280L1024 1408L896 1408Z"
         }
      }
   ]
}

var GripperBarVertical = {
   name: "GripperBarVertical",
   vendor: "UiFabric",
   unicode: 59268,
   value: "",
   charCode: "E784",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 2048L768 2048L768 0L896 0L896 2048ZM1152 2048L1152 0L1280 0L1280 2048L1152 2048Z"
         }
      }
   ]
}

var Unlock = {
   name: "Unlock",
   vendor: "UiFabric",
   unicode: 59269,
   value: "",
   charCode: "E785",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 896L1792 896L1792 2048L256 2048L256 896L1408 896L1408 512Q1408 430 1378.50 360Q1349 290 1297.50 238.50Q1246 187 1176 157.50Q1106 128 1024 128L1024 128Q942 128 872 157.50Q802 187 750.50 238.50Q699 290 669.50 360Q640 430 640 512L640 512L512 512Q512 403 551 309.50Q590 216 659 147Q728 78 821.50 39Q915 0 1024 0L1024 0Q1133 0 1226.50 39Q1320 78 1389 147Q1458 216 1497 309.50Q1536 403 1536 512L1536 512L1536 896ZM1664 1920L1664 1024L384 1024L384 1920L1664 1920Z"
         }
      }
   ]
}

var Slideshow = {
   name: "Slideshow",
   vendor: "UiFabric",
   unicode: 59270,
   value: "",
   charCode: "E786",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 768L1280 1024L768 1280L768 768ZM864 923L864 1125L1065 1024L864 923ZM0 256L2048 256L2048 1792L0 1792L0 256ZM1920 1664L1920 384L128 384L128 1664L1920 1664ZM1792 512L1792 1536L256 1536L256 512L1792 512ZM1664 1408L1664 640L384 640L384 1408L1664 1408Z"
         }
      }
   ]
}

var Calendar = {
   name: "Calendar",
   vendor: "UiFabric",
   unicode: 59271,
   value: "",
   charCode: "E787",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 896L768 768L896 768L896 896L768 896ZM1152 1664L1152 1536L1280 1536L1280 1664L1152 1664ZM1536 896L1536 768L1664 768L1664 896L1536 896ZM1152 896L1152 768L1280 768L1280 896L1152 896ZM768 1152L768 1024L896 1024L896 1152L768 1152ZM384 1152L384 1024L512 1024L512 1152L384 1152ZM1536 1152L1536 1024L1664 1024L1664 1152L1536 1152ZM1152 1152L1152 1024L1280 1024L1280 1152L1152 1152ZM768 1408L768 1280L896 1280L896 1408L768 1408ZM384 1408L384 1280L512 1280L512 1408L384 1408ZM1536 1408L1536 1280L1664 1280L1664 1408L1536 1408ZM1152 1408L1152 1280L1280 1280L1280 1408L1152 1408ZM768 1664L768 1536L896 1536L896 1664L768 1664ZM384 1664L384 1536L512 1536L512 1664L384 1664ZM1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256ZM128 1792L1920 1792L1920 640L128 640L128 1792Z"
         }
      }
   ]
}

var Megaphone = {
   name: "Megaphone",
   vendor: "UiFabric",
   unicode: 59273,
   value: "",
   charCode: "E789",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1280L0 768Q14 768 38.50 769Q63 770 86 770L86 770Q97 770 106.50 769.50Q116 769 122 768L122 768L1920 448Q1926 447 1936 446.50Q1946 446 1958 446L1958 446Q1982 446 2008 447Q2034 448 2048 448L2048 448L2048 1600Q2034 1600 2009 1600.50Q1984 1601 1960 1601L1960 1601Q1943 1601 1930 1601Q1917 1601 1909 1599L1909 1599L1146 1463Q1136 1520 1107.50 1569Q1079 1618 1037 1653Q995 1688 942.50 1708Q890 1728 832 1728L832 1728Q766 1728 707.50 1703Q649 1678 605.50 1634.50Q562 1591 537 1532.50Q512 1474 512 1408L512 1408Q512 1380 518 1351L518 1351L122 1280Q114 1279 104.50 1278.50Q95 1278 84 1278L84 1278Q62 1278 39.50 1279Q17 1280 0 1280L0 1280ZM832 1600L832 1600Q867 1600 899 1588Q931 1576 956 1554.50Q981 1533 998 1504Q1015 1475 1021 1440L1021 1440L643 1373Q640 1391 640 1408L640 1408Q640 1448 655 1483Q670 1518 696 1544Q722 1570 757 1585Q792 1600 832 1600ZM1920 1471L1920 577L128 896L128 1152Q135 1152 139 1153L139 1153L1920 1471Z"
         }
      }
   ]
}

var Trim = {
   name: "Trim",
   vendor: "UiFabric",
   unicode: 59274,
   value: "",
   charCode: "E78A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 256L640 384L512 384L512 256L640 256ZM1408 384L1408 256L1536 256L1536 384L1408 384ZM640 512L640 640L512 640L512 512L640 512ZM1408 640L1408 512L1536 512L1536 640L1408 640ZM512 1792L512 1664L640 1664L640 1792L512 1792ZM1408 1792L1408 1664L1536 1664L1536 1792L1408 1792ZM512 1536L512 1408L640 1408L640 1536L512 1536ZM1408 1536L1408 1408L1536 1408L1536 1536L1408 1536ZM0 1280L0 768L128 768L128 1280L0 1280ZM256 1280L256 768L384 768L384 1280L256 1280ZM1664 1280L1664 768L1792 768L1792 1280L1664 1280ZM1920 768L2048 768L2048 1280L1920 1280L1920 768ZM512 1280L512 768L1536 768L1536 1280L512 1280ZM640 896L640 1152L1408 1152L1408 896L640 896Z"
         }
      }
   ]
}

var AutoEnhanceOn = {
   name: "AutoEnhanceOn",
   vendor: "UiFabric",
   unicode: 59277,
   value: "",
   charCode: "E78D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1984L0 1984Q0 1958 19 1939L19 1939L1235 723Q1254 704 1280 704L1280 704Q1306 704 1325 723Q1344 742 1344 768L1344 768Q1344 794 1325 813L1325 813L109 2029Q90 2048 64 2048L64 2048Q38 2048 19 2029Q0 2010 0 1984ZM1408 256L1408 0L1536 0L1536 256L1408 256ZM1291 305L1201 395L1019 214L1110 123L1291 305ZM1152 512L1152 640L896 640L896 512L1152 512ZM1408 1152L1408 896L1536 896L1536 1152L1408 1152ZM1653 847L1743 757L1925 938L1834 1029L1653 847ZM1792 512L2048 512L2048 640L1792 640L1792 512ZM1925 214L1743 395L1653 305L1834 123L1925 214ZM1472 512L1472 512Q1498 512 1517 531Q1536 550 1536 576L1536 576Q1536 602 1517 621Q1498 640 1472 640L1472 640Q1446 640 1427 621Q1408 602 1408 576L1408 576Q1408 550 1427 531Q1446 512 1472 512Z"
         }
      }
   ]
}

var AutoEnhanceOff = {
   name: "AutoEnhanceOff",
   vendor: "UiFabric",
   unicode: 59278,
   value: "",
   charCode: "E78E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 1829L1939 1235L2029 1325L1344 2011L979 1645L1069 1555L1344 1829ZM0 1984L0 1984Q0 1958 19 1939L19 1939L1235 723Q1254 704 1280 704L1280 704Q1306 704 1325 723Q1344 742 1344 768L1344 768Q1344 794 1325 813L1325 813L109 2029Q90 2048 64 2048L64 2048Q38 2048 19 2029Q0 2010 0 1984ZM1408 256L1408 0L1536 0L1536 256L1408 256ZM1291 305L1201 395L1019 214L1110 123L1291 305ZM1152 512L1152 640L896 640L896 512L1152 512ZM1408 1152L1408 896L1536 896L1536 1152L1408 1152ZM1653 847L1743 757L1925 938L1834 1029L1653 847ZM1792 512L2048 512L2048 640L1792 640L1792 512ZM1925 214L1743 395L1653 305L1834 123L1925 214ZM1472 512L1472 512Q1498 512 1517 531Q1536 550 1536 576L1536 576Q1536 602 1517 621Q1498 640 1472 640L1472 640Q1446 640 1427 621Q1408 602 1408 576L1408 576Q1408 550 1427 531Q1446 512 1472 512Z"
         }
      }
   ]
}

var Color = {
   name: "Color",
   vendor: "UiFabric",
   unicode: 59280,
   value: "",
   charCode: "E790",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q971 2048 924.50 2027.50Q878 2007 843.50 1972.50Q809 1938 788.50 1891.50Q768 1845 768 1792L768 1792Q768 1743 777.50 1706.50Q787 1670 801 1640Q815 1610 832 1584Q849 1558 863 1531.50Q877 1505 886.50 1475.50Q896 1446 896 1408L896 1408Q896 1356 875.50 1309Q855 1262 820.50 1227.50Q786 1193 739 1172.50Q692 1152 640 1152L640 1152Q602 1152 572.50 1161.50Q543 1171 516.50 1185Q490 1199 464 1216Q438 1233 408 1247Q378 1261 341 1270.50Q304 1280 256 1280L256 1280Q203 1280 156.50 1259.50Q110 1239 75.50 1204.50Q41 1170 20.50 1123.50Q0 1077 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1051 138 1074Q148 1097 165.50 1114.50Q183 1132 206 1142Q229 1152 256 1152L256 1152Q294 1152 323.50 1142.50Q353 1133 379.50 1119Q406 1105 431.50 1088Q457 1071 486.50 1057Q516 1043 553 1033.50Q590 1024 640 1024L640 1024Q720 1024 790 1054Q860 1084 912 1136Q964 1188 994 1258Q1024 1328 1024 1408L1024 1408Q1024 1457 1014.50 1494.50Q1005 1532 991 1561.50Q977 1591 960 1616.50Q943 1642 929 1668.50Q915 1695 905.50 1724.50Q896 1754 896 1792L896 1792Q896 1819 906 1842Q916 1865 933.50 1882.50Q951 1900 974 1910Q997 1920 1024 1920ZM512 640L512 640Q539 640 562 650Q585 660 602.50 677.50Q620 695 630 718Q640 741 640 768L640 768Q640 795 630 818Q620 841 602.50 858.50Q585 876 562 886Q539 896 512 896L512 896Q485 896 462 886Q439 876 421.50 858.50Q404 841 394 818Q384 795 384 768L384 768Q384 741 394 718Q404 695 421.50 677.50Q439 660 462 650Q485 640 512 640ZM896 384L896 384Q923 384 946 394Q969 404 986.50 421.50Q1004 439 1014 462Q1024 485 1024 512L1024 512Q1024 539 1014 562Q1004 585 986.50 602.50Q969 620 946 630Q923 640 896 640L896 640Q869 640 846 630Q823 620 805.50 602.50Q788 585 778 562Q768 539 768 512L768 512Q768 485 778 462Q788 439 805.50 421.50Q823 404 846 394Q869 384 896 384ZM1408 768L1408 768Q1381 768 1358 758Q1335 748 1317.50 730.50Q1300 713 1290 690Q1280 667 1280 640L1280 640Q1280 613 1290 590Q1300 567 1317.50 549.50Q1335 532 1358 522Q1381 512 1408 512L1408 512Q1435 512 1458 522Q1481 532 1498.50 549.50Q1516 567 1526 590Q1536 613 1536 640L1536 640Q1536 667 1526 690Q1516 713 1498.50 730.50Q1481 748 1458 758Q1435 768 1408 768ZM1536 1024L1536 1024Q1563 1024 1586 1034Q1609 1044 1626.50 1061.50Q1644 1079 1654 1102Q1664 1125 1664 1152L1664 1152Q1664 1179 1654 1202Q1644 1225 1626.50 1242.50Q1609 1260 1586 1270Q1563 1280 1536 1280L1536 1280Q1509 1280 1486 1270Q1463 1260 1445.50 1242.50Q1428 1225 1418 1202Q1408 1179 1408 1152L1408 1152Q1408 1125 1418 1102Q1428 1079 1445.50 1061.50Q1463 1044 1486 1034Q1509 1024 1536 1024ZM1280 1408L1280 1408Q1307 1408 1330 1418Q1353 1428 1370.50 1445.50Q1388 1463 1398 1486Q1408 1509 1408 1536L1408 1536Q1408 1563 1398 1586Q1388 1609 1370.50 1626.50Q1353 1644 1330 1654Q1307 1664 1280 1664L1280 1664Q1253 1664 1230 1654Q1207 1644 1189.50 1626.50Q1172 1609 1162 1586Q1152 1563 1152 1536L1152 1536Q1152 1509 1162 1486Q1172 1463 1189.50 1445.50Q1207 1428 1230 1418Q1253 1408 1280 1408Z"
         }
      }
   ]
}

var SaveAs = {
   name: "SaveAs",
   vendor: "UiFabric",
   unicode: 59282,
   value: "",
   charCode: "E792",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1772 910Q1808 896 1848 896ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836ZM768 1280L768 1536L896 1536L768 1664L293 1664L128 1499L128 256Q128 229 138 206Q148 183 165.50 165.50Q183 148 206 138Q229 128 256 128L256 128L1536 128Q1563 128 1586 138Q1609 148 1626.50 165.50Q1644 183 1654 206Q1664 229 1664 256L1664 256L1664 768L1536 896L1536 256L1408 256L1408 896L384 896L384 256L256 256L256 1445L347 1536L384 1536L384 1024L1280 1024L1280 1152L1152 1280L1152 1152L512 1152L512 1536L640 1536L640 1280L768 1280ZM512 256L512 768L1280 768L1280 256L512 256Z"
         }
      }
   ]
}

var Light = {
   name: "Light",
   vendor: "UiFabric",
   unicode: 59283,
   value: "",
   charCode: "E793",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 512L960 512Q1053 512 1134.50 547.50Q1216 583 1276.50 643.50Q1337 704 1372.50 785.50Q1408 867 1408 960L1408 960Q1408 1053 1372.50 1134.50Q1337 1216 1276.50 1276.50Q1216 1337 1134.50 1372.50Q1053 1408 960 1408L960 1408Q867 1408 785.50 1372.50Q704 1337 643.50 1276.50Q583 1216 547.50 1134.50Q512 1053 512 960L512 960Q512 867 547.50 785.50Q583 704 643.50 643.50Q704 583 785.50 547.50Q867 512 960 512ZM960 1280L960 1280Q1026 1280 1084 1254.50Q1142 1229 1185.50 1185.50Q1229 1142 1254.50 1084Q1280 1026 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q925 640 896 647L896 647L896 1273Q925 1280 960 1280ZM1024 0L1024 384L896 384L896 0L1024 0ZM896 1920L896 1536L1024 1536L1024 1920L896 1920ZM1536 896L1920 896L1920 1024L1536 1024L1536 896ZM384 896L384 1024L0 1024L0 896L384 896ZM598 507L507 598L236 326L326 236L598 507ZM1322 1413L1413 1322L1684 1594L1594 1684L1322 1413ZM1684 326L1413 598L1322 507L1594 236L1684 326ZM236 1594L507 1322L598 1413L326 1684L236 1594Z"
         }
      }
   ]
}

var Filters = {
   name: "Filters",
   vendor: "UiFabric",
   unicode: 59285,
   value: "",
   charCode: "E795",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 0L1600 0Q1640 0 1675 15Q1710 30 1736 56Q1762 82 1777 117Q1792 152 1792 192L1792 192L1792 256L1758 256Q1741 256 1724.50 258Q1708 260 1694.50 266.50Q1681 273 1672.50 285.50Q1664 298 1664 320L1664 320L1664 1152Q1664 1179 1654 1202Q1644 1225 1626.50 1242.50Q1609 1260 1586 1270Q1563 1280 1536 1280L1536 1280L1280 1280L1280 1792Q1280 1845 1260 1891.50Q1240 1938 1205 1973Q1170 2008 1123.50 2028Q1077 2048 1024 2048L1024 2048Q971 2048 924.50 2028Q878 2008 843 1973Q808 1938 788 1891.50Q768 1845 768 1792L768 1792L768 1280L512 1280Q485 1280 462 1270Q439 1260 421.50 1242.50Q404 1225 394 1202Q384 1179 384 1152L384 1152L384 256Q384 203 404 156.50Q424 110 459 75Q494 40 540.50 20Q587 0 640 0L640 0ZM1152 1152L1536 1152L1536 1024L512 1024L512 1152L896 1152L896 1792Q896 1819 906 1842Q916 1865 933.50 1882.50Q951 1900 974 1910Q997 1920 1024 1920L1024 1920Q1051 1920 1074 1910Q1097 1900 1114.50 1882.50Q1132 1865 1142 1842Q1152 1819 1152 1792L1152 1792L1152 1152ZM1536 896L1536 320Q1536 265 1565.50 218Q1595 171 1645 147L1645 147Q1637 137 1625 132.50Q1613 128 1600 128L1600 128L640 128Q613 128 590 138Q567 148 549.50 165.50Q532 183 522 206Q512 229 512 256L512 256L512 896L1536 896Z"
         }
      }
   ]
}

var AspectRatio = {
   name: "AspectRatio",
   vendor: "UiFabric",
   unicode: 59289,
   value: "",
   charCode: "E799",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L0 256L128 256L128 384L0 384ZM0 640L0 512L128 512L128 640L0 640ZM0 896L0 768L128 768L128 896L0 896ZM0 1152L0 1024L128 1024L128 1152L0 1152ZM0 1664L0 1536L128 1536L128 1664L0 1664ZM256 384L256 256L384 256L384 384L256 384ZM256 1664L256 1536L384 1536L384 1664L256 1664ZM1920 1664L1920 1536L2048 1536L2048 1664L1920 1664ZM0 1408L0 1280L128 1280L128 1408L0 1408ZM1920 1408L1920 1280L2048 1280L2048 1408L1920 1408ZM1920 1152L1920 1024L2048 1024L2048 1152L1920 1152ZM1920 896L1920 768L2048 768L2048 896L1920 896ZM1920 640L1920 512L2048 512L2048 640L1920 640ZM1920 256L2048 256L2048 384L1920 384L1920 256ZM1664 1664L1664 1536L1792 1536L1792 1664L1664 1664ZM1664 384L1664 256L1792 256L1792 384L1664 384ZM512 1664L512 256L1536 256L1536 1664L512 1664ZM640 384L640 1536L1408 1536L1408 384L640 384Z"
         }
      }
   ]
}

var Contrast = {
   name: "Contrast",
   vendor: "UiFabric",
   unicode: 59297,
   value: "",
   charCode: "E7A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q959 128 896 137L896 137L896 1911Q959 1920 1024 1920Z"
         }
      }
   ]
}

var Undo = {
   name: "Undo",
   vendor: "UiFabric",
   unicode: 59303,
   value: "",
   charCode: "E7A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1088 4L1088 4Q1184 4 1273 29Q1362 54 1440 100Q1518 146 1582 210Q1646 274 1692 352Q1738 430 1763 519Q1788 608 1788 704L1788 704Q1788 841 1735.50 968.50Q1683 1096 1586 1193L1586 1193L749 2029L659 1939L1495 1102Q1574 1023 1617 919.50Q1660 816 1660 704L1660 704Q1660 587 1614.50 483Q1569 379 1491 301Q1413 223 1309 177.50Q1205 132 1088 132L1088 132Q980 132 897.50 164.50Q815 197 745 250.50Q675 304 610.50 372Q546 440 475 512L475 512L896 512L896 640L256 640L256 0L384 0L384 421Q439 365 489.50 312.50Q540 260 590.50 213.50Q641 167 693.50 128.50Q746 90 805.50 62.50Q865 35 934.50 19.50Q1004 4 1088 4Z"
         }
      }
   ]
}

var Crop = {
   name: "Crop",
   vendor: "UiFabric",
   unicode: 59304,
   value: "",
   charCode: "E7A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1663 1536L2048 1536L2048 1665L1663 1665L1663 2048L1536 2048L1536 1665L383 1665L383 512L0 512L0 385L383 385L383 0L512 0L512 385L1573 385L1938 19L2029 109L1663 475L1663 1536ZM1445 512L512 512L512 1445L1445 512ZM603 1536L1536 1536L1536 603L603 1536Z"
         }
      }
   ]
}

var PhotoCollection = {
   name: "PhotoCollection",
   vendor: "UiFabric",
   unicode: 59306,
   value: "",
   charCode: "E7AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 640L1472 640Q1446 640 1427 621Q1408 602 1408 576L1408 576Q1408 550 1427 531Q1446 512 1472 512L1472 512Q1498 512 1517 531Q1536 550 1536 576L1536 576Q1536 602 1517 621Q1498 640 1472 640ZM1792 512L2048 512L2048 1792L256 1792L256 1536L0 1536L0 256L1792 256L1792 512ZM1243 1408L1573 1408L1216 1050L1050 1216L1243 1408ZM1664 384L128 384L128 933L448 614L960 1126L1216 870L1664 1317L1664 384ZM128 1408L1061 1408L448 794L128 1115L128 1408ZM1920 1664L1920 640L1792 640L1792 1536L384 1536L384 1664L1920 1664Z"
         }
      }
   ]
}

var Album = {
   name: "Album",
   vendor: "UiFabric",
   unicode: 59307,
   value: "",
   charCode: "E7AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L1856 256Q1896 256 1931 271Q1966 286 1992 312Q2018 338 2033 373Q2048 408 2048 448L2048 448L2048 1600Q2048 1640 2033 1675Q2018 1710 1992 1736Q1966 1762 1931 1777Q1896 1792 1856 1792L1856 1792L0 1792L0 256ZM128 384L128 1664L256 1664L256 384L128 384ZM1920 1600L1920 448Q1920 422 1901 403Q1882 384 1856 384L1856 384L384 384L384 1664L1856 1664Q1882 1664 1901 1645Q1920 1626 1920 1600L1920 1600ZM768 1024L768 640L1536 640L1536 1024L768 1024ZM896 768L896 896L1408 896L1408 768L896 768Z"
         }
      }
   ]
}

var OpenWith = {
   name: "OpenWith",
   vendor: "UiFabric",
   unicode: 59308,
   value: "",
   charCode: "E7AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1955 1309L2045 1219L1728 902L1411 1219L1501 1309L1663 1146L1663 1729L1792 1729L1792 1146L1955 1309ZM1792 256L1792 385L639 385L639 256L1792 256ZM1536 1536L1536 1665L639 1665L639 1536L1536 1536ZM384 128L384 512L0 512L0 128L384 128ZM128 256L128 384L256 384L256 256L128 256ZM384 768L384 1152L0 1152L0 768L384 768ZM128 896L128 1024L256 1024L256 896L128 896ZM384 1408L384 1792L0 1792L0 1408L384 1408ZM128 1536L128 1664L256 1664L256 1536L128 1536ZM1536 896L1408 1024L640 1024L640 896L1536 896Z"
         }
      }
   ]
}

var Rotate = {
   name: "Rotate",
   vendor: "UiFabric",
   unicode: 59309,
   value: "",
   charCode: "E7AD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1077 1260 1123.50Q1240 1170 1205 1205Q1170 1240 1123.50 1260Q1077 1280 1024 1280L1024 1280Q971 1280 924.50 1260Q878 1240 843 1205Q808 1170 788 1123.50Q768 1077 768 1024L768 1024Q768 971 788 924.50Q808 878 843 843Q878 808 924.50 788Q971 768 1024 768ZM1024 1152L1024 1152Q1051 1152 1074 1142Q1097 1132 1114.50 1114.50Q1132 1097 1142 1074Q1152 1051 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q997 896 974 906Q951 916 933.50 933.50Q916 951 906 974Q896 997 896 1024L896 1024Q896 1051 906 1074Q916 1097 933.50 1114.50Q951 1132 974 1142Q997 1152 1024 1152ZM2048 1024L2048 1024Q2048 1164 2011 1296Q1974 1428 1905.50 1544.50Q1837 1661 1739 1757Q1641 1853 1518 1920L1518 1920L1792 1920L1792 2048L1280 2048L1280 1536L1408 1536L1408 1833Q1525 1778 1619.50 1693Q1714 1608 1781 1502.50Q1848 1397 1884 1275Q1920 1153 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024Z"
         }
      }
   ]
}

var SIPMove = {
   name: "SIPMove",
   vendor: "UiFabric",
   unicode: 59225,
   value: "",
   charCode: "E759",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M403 659L493 749L219 1024L493 1299L403 1389L37 1024L403 659ZM1024 1829L1299 1555L1389 1645L1024 2011L659 1645L749 1555L1024 1829ZM1645 659L2011 1024L1645 1389L1555 1299L1829 1024L1555 749L1645 659ZM1024 219L749 493L659 403L1024 37L1389 403L1299 493L1024 219ZM1024 640L1024 640Q1103 640 1173 670Q1243 700 1295.50 752.50Q1348 805 1378 875Q1408 945 1408 1024L1408 1024Q1408 1104 1378 1173.50Q1348 1243 1295.50 1295.50Q1243 1348 1173 1378Q1103 1408 1024 1408L1024 1408Q944 1408 874.50 1378Q805 1348 752.50 1295.50Q700 1243 670 1173.50Q640 1104 640 1024L640 1024Q640 945 670 875Q700 805 752.50 752.50Q805 700 874.50 670Q944 640 1024 640ZM1024 1280L1024 1280Q1077 1280 1123.50 1260Q1170 1240 1205 1205Q1240 1170 1260 1123.50Q1280 1077 1280 1024L1280 1024Q1280 971 1260 924.50Q1240 878 1205 843Q1170 808 1123.50 788Q1077 768 1024 768L1024 768Q971 768 924.50 788Q878 808 843 843Q808 878 788 924.50Q768 971 768 1024L768 1024Q768 1077 788 1123.50Q808 1170 843 1205Q878 1240 924.50 1260Q971 1280 1024 1280Z"
         }
      }
   ]
}

var PanoIndicator = {
   name: "PanoIndicator",
   vendor: "UiFabric",
   unicode: 59312,
   value: "",
   charCode: "E7B0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 896L1472 896Q1446 896 1427 877Q1408 858 1408 832L1408 832Q1408 806 1427 787Q1446 768 1472 768L1472 768Q1498 768 1517 787Q1536 806 1536 832L1536 832Q1536 858 1517 877Q1498 896 1472 896ZM0 1767L0 279Q241 394 499.50 451.50Q758 509 1024 509L1024 509Q1290 509 1548.50 451.50Q1807 394 2048 279L2048 279L2048 1767Q1807 1652 1548.50 1594Q1290 1536 1024 1536L1024 1536Q758 1536 499.50 1594Q241 1652 0 1767L0 1767ZM128 1434L128 1577Q281 1518 439 1481Q597 1444 760 1427L760 1427L448 1115L128 1434ZM859 1344L930 1416Q954 1415 978.50 1414.50Q1003 1414 1027 1414L1027 1414Q1224 1414 1418 1444L1418 1444L1088 1115L859 1344ZM1920 1577L1920 1434L1728 1243L1562 1408L1645 1491Q1715 1509 1783.50 1530Q1852 1551 1920 1577L1920 1577ZM1920 1254L1920 469Q1705 552 1480 596Q1255 640 1024 640L1024 640Q793 640 568 596Q343 552 128 469L128 469L128 1254L448 933L768 1254L1088 933L1472 1317L1728 1061L1920 1254Z"
         }
      }
   ]
}

var Translate = {
   name: "Translate",
   vendor: "UiFabric",
   unicode: 59314,
   value: "",
   charCode: "E7B2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M501 896L651 896L992 1920L853 1920L768 1664L384 1664L299 1920L160 1920L501 896ZM427 1536L725 1536L576 1088L427 1536ZM806 544L806 544Q807 504 807 465Q807 426 807 386L807 386Q807 357 807 328Q807 299 806 270L806 270Q806 265 808 259L808 259Q816 257 821 257L821 257Q863 258 904.50 259Q946 260 988 260L988 260L1263 260L1263 249Q1263 219 1262 188Q1261 157 1254 128L1254 128Q1323 128 1391 134L1391 134Q1397 135 1403.50 137Q1410 139 1410 147L1410 147Q1410 153 1407 159Q1404 165 1402 171L1402 171Q1400 176 1398.50 186.50Q1397 197 1396.50 208.50Q1396 220 1396 230.50Q1396 241 1396 247L1396 247L1396 260L1692 260Q1734 260 1775.50 259Q1817 258 1859 257L1859 257Q1866 257 1872 260L1872 260Q1875 265 1875 270L1875 270Q1874 287 1873 305.50Q1872 324 1872 341L1872 341L1872 399Q1872 435 1873 471.50Q1874 508 1875 544L1875 544Q1875 547 1874.50 551Q1874 555 1872 557L1872 557Q1864 559 1859 559L1859 559Q1854 559 1834 559.50Q1814 560 1793 560L1793 560Q1774 560 1759 559Q1744 558 1742 556L1742 556Q1740 548 1739.50 532Q1739 516 1739 496L1739 496Q1739 463 1740 428Q1741 393 1741 376L1741 376L939 376Q939 380 939 390.50Q939 401 939.50 415.50Q940 430 940 446.50Q940 463 940 480L940 480Q940 509 939 532.50Q938 556 936 558L936 558Q928 560 923 560L923 560L821 560Q810 560 808 557Q806 554 806 544ZM1228 1153L1228 1153Q1252 1153 1264.50 1145.50Q1277 1138 1277 1112L1277 1112L1277 922L958 922Q918 922 878 923Q838 924 798 925L798 925Q790 925 786 922L786 922Q784 916 784 911L784 911L784 815Q784 812 784.50 807.50Q785 803 787 801L787 801Q793 799 798 799L798 799Q838 800 878 801Q918 802 958 802L958 802L1277 802Q1275 776 1274.50 749.50Q1274 723 1269 697L1269 697Q1289 699 1308.50 700.50Q1328 702 1348 704L1348 704Q1350 704 1351.50 704.50Q1353 705 1355 705L1355 705Q1390 680 1422 652Q1454 624 1486 595L1486 595L1178 595Q1136 595 1094.50 596Q1053 597 1011 598L1011 598Q1003 598 999 595L999 595Q997 589 997 584L997 584L997 489Q997 485 999 477L999 477Q1007 475 1011 475L1011 475Q1053 476 1094.50 477Q1136 478 1178 478L1178 478L1551 478Q1567 478 1581 473.50Q1595 469 1606 469L1606 469Q1614 469 1629 481Q1644 493 1659 509Q1674 525 1685.50 541.50Q1697 558 1697 566L1697 566Q1697 576 1690.50 581.50Q1684 587 1676 591L1676 591Q1662 598 1649 609Q1636 620 1624 630L1624 630Q1572 673 1519.50 713.50Q1467 754 1410 791L1410 791L1410 802L1731 802Q1771 802 1810 801Q1849 800 1889 799L1889 799Q1896 799 1902 802L1902 802Q1904 810 1904 815L1904 815L1904 911Q1904 915 1902 923L1902 923Q1894 925 1889 925L1889 925Q1849 924 1810 923Q1771 922 1731 922L1731 922L1410 922L1410 955Q1410 1007 1411 1059Q1412 1111 1414 1163L1414 1163L1414 1167Q1414 1191 1405 1215Q1396 1239 1376 1253L1376 1253Q1362 1263 1336.50 1268.50Q1311 1274 1282 1276.50Q1253 1279 1225.50 1279.50Q1198 1280 1182 1280L1182 1280Q1176 1280 1163 1279.50Q1150 1279 1145 1274L1145 1274Q1142 1271 1138 1258Q1134 1245 1132 1240L1132 1240Q1125 1214 1115.50 1191.50Q1106 1169 1092 1146L1092 1146Q1126 1150 1160 1151.50Q1194 1153 1228 1153ZM1965 1363L1875 1453L1792 1371L1792 1536Q1792 1589 1772 1635.50Q1752 1682 1717 1717Q1682 1752 1635.50 1772Q1589 1792 1536 1792L1536 1792L1371 1792L1453 1875L1363 1965L1126 1728L1363 1491L1453 1581L1371 1664L1536 1664Q1563 1664 1586 1654Q1609 1644 1626.50 1626.50Q1644 1609 1654 1586Q1664 1563 1664 1536L1664 1536L1664 1371L1581 1453L1491 1363L1728 1126L1965 1363Z"
         }
      }
   ]
}

var RedEye = {
   name: "RedEye",
   vendor: "UiFabric",
   unicode: 59315,
   value: "",
   charCode: "E7B3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 512L1024 512Q1174 512 1316 551Q1458 590 1588.50 658.50Q1719 727 1834.50 821Q1950 915 2048 1024L2048 1024Q1950 1134 1834.50 1227.50Q1719 1321 1588.50 1389.50Q1458 1458 1316 1497Q1174 1536 1024 1536L1024 1536Q874 1536 732 1497Q590 1458 459.50 1389.50Q329 1321 213 1227.50Q97 1134 0 1024L0 1024Q97 915 213 821Q329 727 459.50 658.50Q590 590 732 551Q874 512 1024 512ZM1408 1024L1408 1024Q1408 945 1377.50 875Q1347 805 1295 753Q1243 701 1173 670.50Q1103 640 1024 640L1024 640Q945 640 875 670.50Q805 701 753 753Q701 805 670.50 875Q640 945 640 1024L640 1024Q640 1103 670.50 1173Q701 1243 753 1295Q805 1347 875 1377.50Q945 1408 1024 1408L1024 1408Q1103 1408 1173 1377.50Q1243 1347 1295 1295Q1347 1243 1377.50 1173Q1408 1103 1408 1024ZM177 1024L177 1024Q271 1115 377 1190.50Q483 1266 604 1317L604 1317Q559 1253 535.50 1177.50Q512 1102 512 1024L512 1024Q512 946 535.50 870.50Q559 795 604 731L604 731Q483 782 377 857.50Q271 933 177 1024ZM1444 1317L1444 1317Q1565 1266 1671 1190.50Q1777 1115 1871 1024L1871 1024Q1777 933 1671 857.50Q1565 782 1444 731L1444 731Q1489 795 1512.50 870.50Q1536 946 1536 1024L1536 1024Q1536 1102 1512.50 1177.50Q1489 1253 1444 1317ZM1024 1152L1024 1152Q997 1152 974 1142Q951 1132 933.50 1114.50Q916 1097 906 1074Q896 1051 896 1024L896 1024Q896 997 906 974Q916 951 933.50 933.50Q951 916 974 906Q997 896 1024 896L1024 896Q1051 896 1074 906Q1097 916 1114.50 933.50Q1132 951 1142 974Q1152 997 1152 1024L1152 1024Q1152 1051 1142 1074Q1132 1097 1114.50 1114.50Q1097 1132 1074 1142Q1051 1152 1024 1152Z"
         }
      }
   ]
}

var ViewOriginal = {
   name: "ViewOriginal",
   vendor: "UiFabric",
   unicode: 59316,
   value: "",
   charCode: "E7B4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1280 896L256 896L256 256L1280 256ZM1152 768L1152 384L384 384L384 768L1152 768ZM1536 640L2048 640L2048 1664L896 1664L896 1536L1920 1536L1920 768L1536 768L1536 1152L768 1152L768 1408L640 1280L640 1152L0 1152L0 0L1536 0L1536 640ZM1408 1024L1408 128L128 128L128 1024L1408 1024ZM390 1488L464 1414L779 1728L460 2046L386 1972L565 1792L384 1792Q304 1792 234.50 1762Q165 1732 112.50 1679.50Q60 1627 30 1557.50Q0 1488 0 1408L0 1408L128 1408Q128 1461 148 1507.50Q168 1554 203 1589Q238 1624 284.50 1644Q331 1664 384 1664L384 1664L565 1664L390 1488Z"
         }
      }
   ]
}

var ThumbnailView = {
   name: "ThumbnailView",
   vendor: "UiFabric",
   unicode: 59318,
   value: "",
   charCode: "E7B6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 1152L640 1152L640 1792L0 1792ZM128 1280L128 1664L512 1664L512 1280L128 1280ZM0 896L0 256L640 256L640 896L0 896ZM128 384L128 768L512 768L512 384L128 384ZM896 384L2048 384L2048 512L896 512L896 384ZM1664 640L1664 768L896 768L896 640L1664 640ZM896 1408L896 1280L2048 1280L2048 1408L896 1408ZM896 1664L896 1536L1664 1536L1664 1664L896 1664Z"
         }
      }
   ]
}

var Telemarketer = {
   name: "Telemarketer",
   vendor: "UiFabric",
   unicode: 59321,
   value: "",
   charCode: "E7B9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 2048L1920 2048L1792 2048Q1792 1942 1764.50 1844Q1737 1746 1687 1660.50Q1637 1575 1567 1505Q1497 1435 1411.50 1385Q1326 1335 1228 1307.50Q1130 1280 1024 1280L1024 1280Q918 1280 820 1307.50Q722 1335 636.50 1385Q551 1435 481 1505Q411 1575 361 1660.50Q311 1746 283.50 1844Q256 1942 256 2048L256 2048L128 2048Q128 1903 170.50 1772Q213 1641 291 1531.50Q369 1422 478.50 1338.50Q588 1255 722 1204L722 1204Q598 1137 512 1024L512 1024L448 1024Q408 1024 373 1009Q338 994 312 968Q286 942 271 907Q256 872 256 832L256 832L256 576Q256 538 270 504Q284 470 308.50 444Q333 418 366 402Q399 386 437 384L437 384Q476 296 536.50 225Q597 154 673.50 104Q750 54 839 27Q928 0 1024 0L1024 0Q1120 0 1209 27Q1298 54 1374.50 104Q1451 154 1511.50 225Q1572 296 1611 384L1611 384Q1649 386 1682 402Q1715 418 1739.50 444Q1764 470 1778 504Q1792 538 1792 576L1792 576L1792 832Q1792 872 1777 907Q1762 942 1736 968Q1710 994 1675 1009Q1640 1024 1600 1024L1600 1024Q1570 1024 1543 1015L1543 1015Q1500 1074 1445.50 1122Q1391 1170 1326 1204L1326 1204Q1460 1255 1569.50 1338.50Q1679 1422 1757 1531.50Q1835 1641 1877.50 1772Q1920 1903 1920 2048ZM1664 832L1664 576Q1664 550 1645 531Q1626 512 1600 512L1600 512Q1574 512 1555 531Q1536 550 1536 576L1536 576L1536 832Q1536 858 1555 877Q1574 896 1600 896L1600 896Q1626 896 1645 877Q1664 858 1664 832L1664 832ZM384 576L384 832Q384 858 403 877Q422 896 448 896L448 896L512 896L512 576Q512 550 493 531Q474 512 448 512L448 512Q422 512 403 531Q384 550 384 576L384 576ZM896 1024L685 1024Q755 1086 842.50 1119Q930 1152 1024 1152L1024 1152Q1086 1152 1145 1137.50Q1204 1123 1257.50 1095.50Q1311 1068 1357.50 1028.50Q1404 989 1440 938L1440 938Q1424 915 1416 887.50Q1408 860 1408 832L1408 832L1408 576Q1408 530 1428.50 489Q1449 448 1487 421L1487 421Q1455 354 1406.50 300Q1358 246 1298 207.50Q1238 169 1168 148.50Q1098 128 1024 128L1024 128Q950 128 880 148.50Q810 169 750 207.50Q690 246 641.50 300Q593 354 561 421L561 421Q599 448 619.50 489Q640 530 640 576L640 576L640 896L768 896Q768 869 778 846Q788 823 805.50 805.50Q823 788 846 778Q869 768 896 768L896 768Q923 768 946 778Q969 788 986.50 805.50Q1004 823 1014 846Q1024 869 1024 896L1024 896Q1024 923 1014 946Q1004 969 986.50 986.50Q969 1004 946 1014Q923 1024 896 1024L896 1024Z"
         }
      }
   ]
}

var Warning = {
   name: "Warning",
   vendor: "UiFabric",
   unicode: 59322,
   value: "",
   charCode: "E7BA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L1920 1920L0 1920L960 0ZM960 286L207 1792L1713 1792L960 286ZM896 768L1024 768L1024 1408L896 1408L896 768ZM896 1664L896 1536L1024 1536L1024 1664L896 1664Z"
         }
      }
   ]
}

var Financial = {
   name: "Financial",
   vendor: "UiFabric",
   unicode: 59323,
   value: "",
   charCode: "E7BB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 2048L1792 896L1920 896L1920 2048L1792 2048ZM512 2048L512 1344L640 1216L640 2048L512 2048ZM256 2048L256 1600L384 1472L384 2048L256 2048ZM768 2048L768 1088L896 960L896 2048L768 2048ZM1024 2047L1024 960L1152 1088L1152 2047L1024 2047ZM1280 1216L1344 1280L1408 1216L1408 2048L1280 2048L1280 1216ZM1536 2048L1536 1088L1664 960L1664 2048L1536 2048ZM0 2048L0 1856L128 1728L128 2048L0 2048ZM1536 256L2048 256L2048 768L1920 768L1920 475L1344 1050L960 666L0 1627L0 1445L960 486L1344 870L1829 384L1536 384L1536 256Z"
         }
      }
   ]
}

var Education = {
   name: "Education",
   vendor: "UiFabric",
   unicode: 59326,
   value: "",
   charCode: "E7BE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 832L1582 1065Q1623 1137 1643.50 1215.50Q1664 1294 1664 1376L1664 1376L1664 1479L1024 1800L384 1479Q384 1419 385.50 1367Q387 1315 394.50 1265.50Q402 1216 418.50 1167.50Q435 1119 466 1065L466 1065L256 960L256 1547Q285 1557 308.50 1575Q332 1593 349 1617Q366 1641 375 1669.50Q384 1698 384 1728L384 1728L384 2048L0 2048L0 1728Q0 1698 9 1669.50Q18 1641 35 1617Q52 1593 75.50 1575Q99 1557 128 1547L128 1547L128 896L0 832L1024 320L2048 832ZM256 1920L256 1728Q256 1702 237 1683Q218 1664 192 1664L192 1664Q166 1664 147 1683Q128 1702 128 1728L128 1728L128 1920L256 1920ZM1024 463L286 832L1024 1201L1762 832L1024 463ZM1024 1656L1536 1400Q1536 1323 1521 1256.50Q1506 1190 1468 1122L1468 1122L1024 1344L580 1122Q547 1180 529.50 1244.50Q512 1309 512 1376L512 1376L512 1400L1024 1656Z"
         }
      }
   ]
}

var ShoppingCart = {
   name: "ShoppingCart",
   vendor: "UiFabric",
   unicode: 59327,
   value: "",
   charCode: "E7BF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M750 1536L1600 1536Q1640 1536 1675 1551Q1710 1566 1736 1592Q1762 1618 1777 1653Q1792 1688 1792 1728L1792 1728Q1792 1768 1777 1803Q1762 1838 1736 1864Q1710 1890 1675 1905Q1640 1920 1600 1920L1600 1920Q1560 1920 1525 1905Q1490 1890 1464 1864Q1438 1838 1423 1803Q1408 1768 1408 1728L1408 1728Q1408 1697 1419 1664L1419 1664L885 1664Q896 1697 896 1728L896 1728Q896 1768 881 1803Q866 1838 840 1864Q814 1890 779 1905Q744 1920 704 1920L704 1920Q664 1920 629 1905Q594 1890 568 1864Q542 1838 527 1803Q512 1768 512 1728L512 1728Q512 1673 541.50 1626Q571 1579 621 1555L621 1555L189 256L0 256L0 128L281 128L366 384L2048 384L1750 1280L665 1280L750 1536ZM1870 512L409 512L622 1152L1657 1152L1870 512ZM768 1728L768 1728Q768 1702 749 1683Q730 1664 704 1664L704 1664Q678 1664 659 1683Q640 1702 640 1728L640 1728Q640 1754 659 1773Q678 1792 704 1792L704 1792Q730 1792 749 1773Q768 1754 768 1728ZM1600 1792L1600 1792Q1626 1792 1645 1773Q1664 1754 1664 1728L1664 1728Q1664 1702 1645 1683Q1626 1664 1600 1664L1600 1664Q1574 1664 1555 1683Q1536 1702 1536 1728L1536 1728Q1536 1754 1555 1773Q1574 1792 1600 1792Z"
         }
      }
   ]
}

var Train = {
   name: "Train",
   vendor: "UiFabric",
   unicode: 59328,
   value: "",
   charCode: "E7C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M576 1536L576 1536Q550 1536 531 1517Q512 1498 512 1472L512 1472Q512 1446 531 1427Q550 1408 576 1408L576 1408Q602 1408 621 1427Q640 1446 640 1472L640 1472Q640 1498 621 1517Q602 1536 576 1536ZM1472 1536L1472 1536Q1446 1536 1427 1517Q1408 1498 1408 1472L1408 1472Q1408 1446 1427 1427Q1446 1408 1472 1408L1472 1408Q1498 1408 1517 1427Q1536 1446 1536 1472L1536 1472Q1536 1498 1517 1517Q1498 1536 1472 1536ZM1280 256L1280 384L768 384L768 256L1280 256ZM1701 2048L1445 1792L603 1792L347 2048L165 2048L423 1790Q388 1786 357.50 1769Q327 1752 304.50 1726.50Q282 1701 269 1668.50Q256 1636 256 1600L256 1600L256 192Q256 152 271 117Q286 82 312 56Q338 30 373 15Q408 0 448 0L448 0L1600 0Q1640 0 1675 15Q1710 30 1736 56Q1762 82 1777 117Q1792 152 1792 192L1792 192L1792 1600Q1792 1636 1779 1668.50Q1766 1701 1743.50 1726.50Q1721 1752 1690.50 1769Q1660 1786 1625 1790L1625 1790L1883 2048L1701 2048ZM1664 1152L1664 640L384 640L384 1152L1664 1152ZM1600 128L448 128Q422 128 403 147Q384 166 384 192L384 192L384 512L1664 512L1664 192Q1664 166 1645 147Q1626 128 1600 128L1600 128ZM384 1280L384 1600Q384 1626 403 1645Q422 1664 448 1664L448 1664L1600 1664Q1626 1664 1645 1645Q1664 1626 1664 1600L1664 1600L1664 1280L384 1280Z"
         }
      }
   ]
}

var Flag = {
   name: "Flag",
   vendor: "UiFabric",
   unicode: 59329,
   value: "",
   charCode: "E7C1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 256L1920 256L1920 1280L1024 1280L1024 1024L384 1024L384 2048L256 2048L256 0L1152 0L1152 256ZM384 896L1024 896L1024 128L384 128L384 896ZM1792 1152L1792 384L1152 384L1152 1152L1792 1152Z"
         }
      }
   ]
}

var Page = {
   name: "Page",
   vendor: "UiFabric",
   unicode: 59331,
   value: "",
   charCode: "E7C3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM256 1920L1664 1920L1664 640L1152 640L1152 128L256 128L256 1920Z"
         }
      }
   ]
}

var TouchPointer = {
   name: "TouchPointer",
   vendor: "UiFabric",
   unicode: 59337,
   value: "",
   charCode: "E7C9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1856 768L1856 768Q1896 768 1931 783Q1966 798 1992 824Q2018 850 2033 885Q2048 920 2048 960L2048 960L2048 1344Q2048 1463 2002.50 1568Q1957 1673 1879 1751Q1801 1829 1696 1874.50Q1591 1920 1472 1920L1472 1920Q1331 1920 1205.50 1864.50Q1080 1809 978 1708L978 1708L659 1390L387 1526L249 1249L0 1499L0 165L896 1061L896 320Q896 280 911 245Q926 210 952 184Q978 158 1013 143Q1048 128 1088 128L1088 128Q1128 128 1163 143Q1198 158 1224 184Q1250 210 1265 245Q1280 280 1280 320L1280 320L1280 651Q1307 641 1339 641L1339 641Q1388 641 1434 664.50Q1480 688 1506 729L1506 729Q1550 704 1600 704L1600 704Q1651 704 1693.50 728Q1736 752 1762 793L1762 793Q1806 768 1856 768ZM586 1283L424 960L614 960L128 475L128 1189L284 1033L445 1354L586 1283ZM1920 1344L1920 960Q1920 934 1901 915Q1882 896 1856 896L1856 896Q1830 896 1811 915Q1792 934 1792 960L1792 960L1792 1088Q1792 1114 1773 1133Q1754 1152 1728 1152L1728 1152Q1702 1152 1683 1133Q1664 1114 1664 1088L1664 1088L1664 896Q1664 870 1645 851Q1626 832 1600 832L1600 832Q1574 832 1555 851Q1536 870 1536 896L1536 896L1536 1024Q1536 1050 1517 1069Q1498 1088 1472 1088L1472 1088Q1446 1088 1427 1069Q1408 1050 1408 1024L1408 1024L1408 832Q1408 806 1389 787Q1370 768 1344 768L1344 768Q1318 768 1299 787Q1280 806 1280 832L1280 832L1280 960Q1280 986 1261 1005Q1242 1024 1216 1024L1216 1024Q1190 1024 1171 1005Q1152 986 1152 960L1152 960L1152 320Q1152 294 1133 275Q1114 256 1088 256L1088 256Q1062 256 1043 275Q1024 294 1024 320L1024 320L1024 1107Q1024 1140 1006 1167.50Q988 1195 957 1208L957 1208Q938 1216 915 1216L915 1216Q871 1216 837 1184L837 1184L762 1109Q741 1088 712 1088L712 1088Q682 1088 661 1109L661 1109Q650 1120 645 1133Q640 1146 640 1160L640 1160Q640 1190 661 1211L661 1211L1069 1619Q1150 1704 1253.50 1748Q1357 1792 1472 1792L1472 1792Q1565 1792 1646.50 1756.50Q1728 1721 1788.50 1660.50Q1849 1600 1884.50 1518.50Q1920 1437 1920 1344L1920 1344Z"
         }
      }
   ]
}

var Merge = {
   name: "Merge",
   vendor: "UiFabric",
   unicode: 59349,
   value: "",
   charCode: "E7D5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1749 1792L1792 1792L1792 2048L1749 2048Q1524 2048 1340 1926L1340 1926Q1177 1819 1061 1625L1061 1625Q1039 1588 1019 1549Q999 1510 981 1468L981 1468Q964 1510 944 1549Q924 1588 902 1625L902 1625Q786 1819 623 1926L623 1926Q438 2048 213 2048L213 2048L171 2048L171 1792L213 1792Q504 1792 682 1494L682 1494Q723 1426 755 1346Q787 1266 808.50 1178.50Q830 1091 841.50 998.50Q853 906 853 811L853 811L853 412L613 472Q605 474 600 474L600 474Q580 474 567.50 459Q555 444 555 426L555 426Q555 407 569 393L569 393L948 14Q962 0 981 0L981 0Q999 0 1015 14L1015 14L1394 393Q1408 407 1408 427L1408 427Q1408 445 1395 459.50Q1382 474 1362 474L1362 474Q1357 474 1349 472L1349 472L1109 412L1109 811Q1109 906 1120.50 998.50Q1132 1091 1154 1178.50Q1176 1266 1208 1346Q1240 1426 1281 1494L1281 1494Q1459 1792 1749 1792L1749 1792Z"
         }
      }
   ]
}

var TurnRight = {
   name: "TurnRight",
   vendor: "UiFabric",
   unicode: 59355,
   value: "",
   charCode: "E7DB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1451 43L1451 43Q1460 43 1495 72Q1530 101 1577.50 145Q1625 189 1677.50 242Q1730 295 1774.50 342Q1819 389 1848 424.50Q1877 460 1877 469L1877 469Q1877 476 1860 498Q1843 520 1815.50 551.50Q1788 583 1752 621Q1716 659 1677.50 697Q1639 735 1601.50 771Q1564 807 1533 834.50Q1502 862 1480 879Q1458 896 1451 896L1451 896Q1431 896 1417.50 881.50Q1404 867 1404 847L1404 847Q1404 844 1408 826Q1412 808 1418 782.50Q1424 757 1431.50 727.50Q1439 698 1446 671.50Q1453 645 1458 624.50Q1463 604 1465 597L1465 597L725 597Q699 597 676 607.50Q653 618 635.50 635.50Q618 653 607.50 676Q597 699 597 725L597 725L597 2048L341 2048L341 725Q341 646 371.50 576.50Q402 507 454.50 454.50Q507 402 576.50 371.50Q646 341 725 341L725 341L1465 341Q1463 333 1458 313Q1453 293 1446 266.50Q1439 240 1431.50 210.50Q1424 181 1418 155.50Q1412 130 1408 112Q1404 94 1404 90L1404 90Q1404 70 1417.50 56.50Q1431 43 1451 43Z"
         }
      }
   ]
}

var Ferry = {
   name: "Ferry",
   vendor: "UiFabric",
   unicode: 59363,
   value: "",
   charCode: "E7E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1487L1768 1792L1920 1792L1920 1920L1704 1920Q1672 1983 1629.50 2015.50Q1587 2048 1536 2048L1536 2048Q1482 2048 1432.50 2026.50Q1383 2005 1345 1964L1345 1964Q1325 1943 1300.50 1931.50Q1276 1920 1248 1920L1248 1920Q1192 1920 1151 1964L1151 1964Q1113 2005 1063.50 2026.50Q1014 2048 960 2048L960 2048Q906 2048 856.50 2026.50Q807 2005 769 1964L769 1964Q749 1943 724 1931.50Q699 1920 672 1920L672 1920Q616 1920 575 1964L575 1964Q537 2005 487.50 2026.50Q438 2048 384 2048L384 2048Q333 2048 290.50 2015.50Q248 1983 216 1920L216 1920L0 1920L0 1792L152 1792L0 1487L0 1330L256 1245L256 768L408 768L536 512L768 512L768 256L1152 256L1152 512L1384 512L1512 768L1664 768L1664 1245L1920 1330L1920 1487ZM896 384L896 512L1024 512L1024 384L896 384ZM616 640L552 768L1368 768L1304 640L616 640ZM384 896L384 1202L960 1010L1536 1202L1536 896L384 896ZM863 1876L863 1876Q878 1893 896 1903L896 1903L896 1166L128 1422L128 1457L330 1860Q345 1891 360 1905.50Q375 1920 384 1920L384 1920Q411 1920 436 1908.50Q461 1897 481 1876L481 1876Q519 1835 568.50 1813.50Q618 1792 672 1792L672 1792Q726 1792 775.50 1813.50Q825 1835 863 1876ZM1590 1860L1792 1457L1792 1422L1024 1166L1024 1903Q1042 1893 1057 1876L1057 1876Q1095 1835 1144.50 1813.50Q1194 1792 1248 1792L1248 1792Q1302 1792 1351.50 1813.50Q1401 1835 1439 1876L1439 1876Q1480 1920 1536 1920L1536 1920Q1545 1920 1560 1905.50Q1575 1891 1590 1860L1590 1860Z"
         }
      }
   ]
}

var Highlight = {
   name: "Highlight",
   vendor: "UiFabric",
   unicode: 59366,
   value: "",
   charCode: "E7E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 0L2048 0L2048 512Q1961 512 1899 531.50Q1837 551 1793.50 586Q1750 621 1723.50 668.50Q1697 716 1683 773Q1669 830 1664 893Q1659 956 1659 1022L1659 1022Q1659 1088 1661.50 1153Q1664 1218 1664 1280L1664 1280L1408 1280L1408 1664L640 2048L640 1280L384 1280Q384 1218 386.50 1153Q389 1088 389 1022L389 1022Q389 956 384 893Q379 830 365 773Q351 716 324.50 668.50Q298 621 254.50 586Q211 551 148.50 531.50Q86 512 0 512L0 512L0 0L128 0L128 384L1920 384L1920 0ZM1280 1585L1280 1280L768 1280L768 1841L1280 1585ZM512 1152L1536 1152Q1536 1107 1535 1064Q1534 1021 1534 978L1534 978Q1534 914 1539 852Q1544 790 1559.50 731.50Q1575 673 1605.50 618Q1636 563 1687 512L1687 512L361 512Q412 563 442.50 618.50Q473 674 488.50 732.50Q504 791 509 852.50Q514 914 514 978L514 978Q514 1021 513 1064Q512 1107 512 1152L512 1152Z"
         }
      }
   ]
}

var PowerButton = {
   name: "PowerButton",
   vendor: "UiFabric",
   unicode: 59368,
   value: "",
   charCode: "E7E8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1088 0L1088 1024L960 1024L960 0L1088 0ZM1260 421L1300 300Q1438 344 1552.50 428Q1667 512 1748.50 625Q1830 738 1875 873Q1920 1008 1920 1152L1920 1152Q1920 1276 1888 1390.50Q1856 1505 1797.50 1604.50Q1739 1704 1657.50 1785.50Q1576 1867 1476.50 1925.50Q1377 1984 1262.50 2016Q1148 2048 1024 2048L1024 2048Q900 2048 785.50 2016Q671 1984 571.50 1925.50Q472 1867 390.50 1785.50Q309 1704 250.50 1604.50Q192 1505 160 1390.50Q128 1276 128 1152L128 1152Q128 1008 173 873Q218 738 299.50 625Q381 512 495.50 428Q610 344 748 300L748 300L788 421Q669 460 571 532Q473 604 403 700Q333 796 294.50 911.50Q256 1027 256 1152L256 1152Q256 1258 283.50 1356Q311 1454 361 1539.50Q411 1625 481 1695Q551 1765 636.50 1815Q722 1865 820 1892.50Q918 1920 1024 1920L1024 1920Q1130 1920 1228 1892.50Q1326 1865 1411.50 1815Q1497 1765 1567 1695Q1637 1625 1687 1539.50Q1737 1454 1764.50 1356Q1792 1258 1792 1152L1792 1152Q1792 1027 1753.50 911.50Q1715 796 1645 700Q1575 604 1477 532Q1379 460 1260 421L1260 421Z"
         }
      }
   ]
}

var Tab = {
   name: "Tab",
   vendor: "UiFabric",
   unicode: 59369,
   value: "",
   charCode: "E7E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L1920 384L1920 2048L512 2048L512 1664L128 1664L128 0L1536 0L1536 384ZM256 128L256 1536L1408 1536L1408 128L256 128ZM1792 1920L1792 512L1536 512L1536 1664L640 1664L640 1920L1792 1920Z"
         }
      }
   ]
}

var Car = {
   name: "Car",
   vendor: "UiFabric",
   unicode: 59396,
   value: "",
   charCode: "E804",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1152L384 1152Q411 1152 434 1162Q457 1172 474.50 1189.50Q492 1207 502 1230Q512 1253 512 1280L512 1280Q512 1307 502 1330Q492 1353 474.50 1370.50Q457 1388 434 1398Q411 1408 384 1408L384 1408Q357 1408 334 1398Q311 1388 293.50 1370.50Q276 1353 266 1330Q256 1307 256 1280L256 1280Q256 1253 266 1230Q276 1207 293.50 1189.50Q311 1172 334 1162Q357 1152 384 1152ZM1664 1152L1664 1152Q1691 1152 1714 1162Q1737 1172 1754.50 1189.50Q1772 1207 1782 1230Q1792 1253 1792 1280L1792 1280Q1792 1307 1782 1330Q1772 1353 1754.50 1370.50Q1737 1388 1714 1398Q1691 1408 1664 1408L1664 1408Q1637 1408 1614 1398Q1591 1388 1573.50 1370.50Q1556 1353 1546 1330Q1536 1307 1536 1280L1536 1280Q1536 1253 1546 1230Q1556 1207 1573.50 1189.50Q1591 1172 1614 1162Q1637 1152 1664 1152ZM2048 896L2011 896L1945 961Q1947 966 1955 991Q1963 1016 1974.50 1050Q1986 1084 1999 1123Q2012 1162 2023 1194.50Q2034 1227 2041 1248.50Q2048 1270 2048 1270L2048 1270L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L1792 2048Q1765 2048 1742 2038Q1719 2028 1701.50 2010.50Q1684 1993 1674 1970Q1664 1947 1664 1920L1664 1920L384 1920Q384 1947 374 1970Q364 1993 346.50 2010.50Q329 2028 306 2038Q283 2048 256 2048L256 2048L128 2048Q101 2048 78 2038Q55 2028 37.50 2010.50Q20 1993 10 1970Q0 1947 0 1920L0 1920L0 1270Q0 1270 7 1248.50Q14 1227 25 1194.50Q36 1162 49 1123Q62 1084 73.50 1050Q85 1016 93 991Q101 966 103 961L103 961L37 896L0 896L0 768L91 768L148 826L222 603Q238 554 268.50 513.50Q299 473 339 444.50Q379 416 426.50 400Q474 384 526 384L526 384L1522 384Q1574 384 1621.50 400Q1669 416 1709 444.50Q1749 473 1779 513.50Q1809 554 1826 603L1826 603L1900 826L1957 768L2048 768L2048 896ZM1522 512L526 512Q463 512 413.50 548Q364 584 344 643L344 643L259 896L1789 896L1704 643Q1684 584 1634.50 548Q1585 512 1522 512L1522 512ZM1408 1792L1408 1743L1304 1536L744 1536L640 1743L640 1792L1408 1792ZM1536 1792L1920 1792L1920 1290Q1920 1290 1914 1271.50Q1908 1253 1898.50 1225Q1889 1197 1878 1163.50Q1867 1130 1857 1100.50Q1847 1071 1839.50 1050Q1832 1029 1831 1024L1831 1024L217 1024Q215 1029 208 1050Q201 1071 191 1100.50Q181 1130 170 1163.50Q159 1197 149.50 1225Q140 1253 134 1271.50Q128 1290 128 1290L128 1290L128 1792L512 1792L512 1713L664 1408L1384 1408L1536 1713L1536 1792Z"
         }
      }
   ]
}

var Admin = {
   name: "Admin",
   vendor: "UiFabric",
   unicode: 59375,
   value: "",
   charCode: "E7EF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 896L2048 896L2048 1280Q2048 1450 1960 1608L1960 1608Q1892 1729 1770 1839L1770 1839Q1722 1883 1675.50 1917Q1629 1951 1592 1974Q1555 1997 1530 2010Q1505 2023 1499 2026L1499 2026L1472 2039Q1452 2029 1448.50 2027Q1445 2025 1444 2025L1444 2025Q1438 2022 1413.50 2009.50Q1389 1997 1351.50 1974Q1314 1951 1267.50 1917.50Q1221 1884 1173 1840L1173 1840Q1113 1785 1066 1727.50Q1019 1670 984 1608L984 1608Q896 1450 896 1280L896 1280L896 896L960 896Q1022 896 1067 890Q1112 884 1146.50 874.50Q1181 865 1207.50 852.50Q1234 840 1258 827L1258 827Q1279 816 1301.50 805.50Q1324 795 1349.50 786.50Q1375 778 1405 773Q1435 768 1472 768L1472 768Q1509 768 1539 773Q1569 778 1594.50 786.50Q1620 795 1642.50 805.50Q1665 816 1686 827L1686 827Q1710 840 1736.50 852.50Q1763 865 1797.50 874.50Q1832 884 1877 890Q1922 896 1984 896L1984 896ZM1920 1280L1920 1022Q1863 1019 1819 1010.50Q1775 1002 1740 990.50Q1705 979 1678 966Q1651 953 1627 941L1627 941Q1608 931 1591 923Q1574 915 1556 909Q1538 903 1517.50 899.50Q1497 896 1472 896L1472 896Q1446 896 1426 899.50Q1406 903 1388 909Q1370 915 1353 923Q1336 931 1317 941L1317 941Q1293 953 1266 966Q1239 979 1204 990.50Q1169 1002 1125 1010.50Q1081 1019 1024 1022L1024 1022L1024 1280Q1024 1367 1050 1442Q1076 1517 1117.50 1581Q1159 1645 1210 1697Q1261 1749 1311 1788.50Q1361 1828 1404 1855Q1447 1882 1472 1896L1472 1896Q1488 1887 1511.50 1873Q1535 1859 1563.50 1839.50Q1592 1820 1624 1795.50Q1656 1771 1688 1742L1688 1742Q1920 1531 1920 1280L1920 1280ZM128 384L128 1152L768 1152L768 1280L0 1280L0 256L1792 256L1792 668Q1781 664 1771 660Q1761 656 1752 651L1752 651Q1732 637 1710 627Q1688 617 1664 608L1664 608L1664 384L128 384Z"
         }
      }
   ]
}

var SDCard = {
   name: "SDCard",
   vendor: "UiFabric",
   unicode: 59377,
   value: "",
   charCode: "E7F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1440 0L1792 352L1792 1920Q1792 1947 1782 1970Q1772 1993 1754.50 2010.50Q1737 2028 1714 2038Q1691 2048 1664 2048L1664 2048L384 2048Q357 2048 334 2038Q311 2028 293.50 2010.50Q276 1993 266 1970Q256 1947 256 1920L256 1920L256 1408L384 1280L384 928L256 768L256 128Q256 101 266 78Q276 55 293.50 37.50Q311 20 334 10Q357 0 384 0L384 0L1440 0ZM1664 1920L1664 405L1387 128L384 128L384 723L512 883L512 1333Q481 1366 448.50 1397.50Q416 1429 384 1461L384 1461L384 1920L1664 1920ZM640 640L640 256L768 256L768 640L640 640ZM896 640L896 256L1024 256L1024 640L896 640ZM1152 640L1152 256L1280 256L1280 640L1152 640Z"
         }
      }
   ]
}

var TVMonitor = {
   name: "TVMonitor",
   vendor: "UiFabric",
   unicode: 59380,
   value: "",
   charCode: "E7F4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L1920 1408L1024 1408L1024 1536L1280 1536L1280 1664L640 1664L640 1536L896 1536L896 1408L0 1408L0 256L1920 256ZM1792 384L128 384L128 1280L1792 1280L1792 384Z"
         }
      }
   ]
}

var Speakers = {
   name: "Speakers",
   vendor: "UiFabric",
   unicode: 59381,
   value: "",
   charCode: "E7F5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 256L512 256L512 1920L1536 1920L1536 256ZM1664 128L1664 2048L384 2048L384 128L1664 128ZM1024 1152L1024 1152Q945 1152 875 1121.50Q805 1091 753 1039Q701 987 670.50 917Q640 847 640 768L640 768Q640 689 670.50 619Q701 549 753 497Q805 445 875 414.50Q945 384 1024 384L1024 384Q1103 384 1173 414.50Q1243 445 1295 497Q1347 549 1377.50 619Q1408 689 1408 768L1408 768Q1408 847 1377.50 917Q1347 987 1295 1039Q1243 1091 1173 1121.50Q1103 1152 1024 1152ZM1024 512L1024 512Q971 512 924.50 532.50Q878 553 843.50 587.50Q809 622 788.50 669Q768 716 768 768L768 768Q768 821 788.50 867.50Q809 914 843.50 948.50Q878 983 924.50 1003.50Q971 1024 1024 1024L1024 1024Q1076 1024 1123 1003.50Q1170 983 1204.50 948.50Q1239 914 1259.50 867.50Q1280 821 1280 768L1280 768Q1280 716 1259.50 669Q1239 622 1204.50 587.50Q1170 553 1123 532.50Q1076 512 1024 512ZM1024 1792L1024 1792Q971 1792 924.50 1771.50Q878 1751 843.50 1716.50Q809 1682 788.50 1635.50Q768 1589 768 1536L768 1536Q768 1484 788.50 1437Q809 1390 843.50 1355.50Q878 1321 924.50 1300.50Q971 1280 1024 1280L1024 1280Q1076 1280 1123 1300.50Q1170 1321 1204.50 1355.50Q1239 1390 1259.50 1437Q1280 1484 1280 1536L1280 1536Q1280 1589 1259.50 1635.50Q1239 1682 1204.50 1716.50Q1170 1751 1123 1771.50Q1076 1792 1024 1792ZM1024 1408L1024 1408Q997 1408 974 1418Q951 1428 933.50 1445.50Q916 1463 906 1486Q896 1509 896 1536L896 1536Q896 1563 906 1586Q916 1609 933.50 1626.50Q951 1644 974 1654Q997 1664 1024 1664L1024 1664Q1051 1664 1074 1654Q1097 1644 1114.50 1626.50Q1132 1609 1142 1586Q1152 1563 1152 1536L1152 1536Q1152 1509 1142 1486Q1132 1463 1114.50 1445.50Q1097 1428 1074 1418Q1051 1408 1024 1408ZM928 768L928 768Q928 749 935.50 731.50Q943 714 956.50 700.50Q970 687 987 679.50Q1004 672 1024 672L1024 672Q1043 672 1060.50 679.50Q1078 687 1091.50 700.50Q1105 714 1112.50 731.50Q1120 749 1120 768L1120 768Q1120 788 1112.50 805Q1105 822 1091.50 835.50Q1078 849 1060.50 856.50Q1043 864 1024 864L1024 864Q1004 864 987 856.50Q970 849 956.50 835.50Q943 822 935.50 805Q928 788 928 768Z"
         }
      }
   ]
}

var UnstackSelected = {
   name: "UnstackSelected",
   vendor: "UiFabric",
   unicode: 59390,
   value: "",
   charCode: "E7FE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 640L2048 640L2048 1792L512 1792L512 1536L256 1536L256 1280L0 1280L0 128L1313 128Q1244 148 1179.50 180Q1115 212 1057 256L1057 256L128 256L128 1152L1408 1152L1408 640L1472 640L1536 704L1536 1280L384 1280L384 1408L1664 1408L1664 768L1792 640L1792 1536L640 1536L640 1664L1920 1664L1920 640ZM1024 896L896 896Q896 808 919 726Q942 644 983.50 573Q1025 502 1083.50 443.50Q1142 385 1213 343.50Q1284 302 1366 279Q1448 256 1536 256L1536 256L1701 256L1555 109L1645 19L1946 320L1645 621L1555 531L1701 384L1536 384Q1430 384 1337 424.50Q1244 465 1174.50 534.50Q1105 604 1064.50 697Q1024 790 1024 896L1024 896Z"
         }
      }
   ]
}

var StackIndicator = {
   name: "StackIndicator",
   vendor: "UiFabric",
   unicode: 59391,
   value: "",
   charCode: "E7FF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1707 512L1707 853L2048 853L2048 1877L683 1877L683 1536L341 1536L341 1195L0 1195L0 171L1365 171L1365 512L1707 512ZM1195 341L171 341L171 1024L1195 1024L1195 341ZM1365 1195L512 1195L512 1365L1536 1365L1536 683L1365 683L1365 1195ZM853 1707L1877 1707L1877 1024L1707 1024L1707 1536L853 1536L853 1707Z"
         }
      }
   ]
}

var MultiSelect = {
   name: "MultiSelect",
   vendor: "UiFabric",
   unicode: 59234,
   value: "",
   charCode: "E762",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 384L2048 384L2048 512L768 512L768 384ZM768 896L768 768L2048 768L2048 896L768 896ZM768 1280L768 1152L2048 1152L2048 1280L768 1280ZM768 1664L768 1536L2048 1536L2048 1664L768 1664ZM192 1276L478 990L546 1058L192 1412L14 1234L82 1166L192 1276ZM192 508L478 222L546 290L192 644L14 466L82 398L192 508Z"
         }
      }
   ]
}

var FavoriteStarFill = {
   name: "FavoriteStarFill",
   vendor: "UiFabric",
   unicode: 59189,
   value: "",
   charCode: "E735",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 768L1416 1254L1664 2048L1024 1556L384 2048L632 1254L0 768L784 768L1024 0L1264 768L2048 768Z"
         }
      }
   ]
}

var Redo = {
   name: "Redo",
   vendor: "UiFabric",
   unicode: 59302,
   value: "",
   charCode: "E7A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 640L1152 512L1573 512Q1502 440 1437.50 372Q1373 304 1303 250.50Q1233 197 1150.50 164.50Q1068 132 960 132L960 132Q843 132 739 177.50Q635 223 557 301Q479 379 433.50 483Q388 587 388 704L388 704Q388 816 431 919.50Q474 1023 553 1102L553 1102L1389 1939L1299 2029L462 1193Q365 1096 312.50 968.50Q260 841 260 704L260 704Q260 608 285 519Q310 430 356 352Q402 274 466 210Q530 146 608 100Q686 54 775 29Q864 4 960 4L960 4Q1044 4 1113.50 19.50Q1183 35 1242.50 62.50Q1302 90 1354.50 128.50Q1407 167 1457.50 213.50Q1508 260 1558 312.50Q1608 365 1664 421L1664 421L1664 0L1792 0L1792 640L1152 640Z"
         }
      }
   ]
}

var Dictionary = {
   name: "Dictionary",
   vendor: "UiFabric",
   unicode: 59437,
   value: "",
   charCode: "E82D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1664 0L1664 2048L256 2048Q203 2048 156.50 2028Q110 2008 75 1973Q40 1938 20 1891.50Q0 1845 0 1792L0 1792L0 256Q0 207 21.50 160.50Q43 114 78.50 78.50Q114 43 160 21.50Q206 0 256 0L256 0ZM1536 1920L1536 1664L256 1664Q229 1664 206 1674Q183 1684 165.50 1701.50Q148 1719 138 1742Q128 1765 128 1792L128 1792Q128 1819 138 1842Q148 1865 165.50 1882.50Q183 1900 206 1910Q229 1920 256 1920L256 1920L1536 1920ZM128 256L128 1570Q188 1536 256 1536L256 1536L1536 1536L1536 128L256 128Q233 128 210 139.50Q187 151 169 169Q151 187 139.50 210Q128 233 128 256L128 256ZM384 768L384 384L1280 384L1280 768L384 768ZM512 512L512 640L1152 640L1152 512L512 512Z"
         }
      }
   ]
}

var ChromeBack = {
   name: "ChromeBack",
   vendor: "UiFabric",
   unicode: 59440,
   value: "",
   charCode: "E830",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 819L2048 1024L392 1024L1066 1698L922 1843L0 922L922 0L1066 145L392 819L2048 819Z"
         }
      }
   ]
}

var CortanaLogoOuter = {
   name: "CortanaLogoOuter",
   vendor: "UiFabric",
   unicode: 59441,
   value: "",
   charCode: "E831",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1907L1024 1907Q1146 1907 1258.50 1875.50Q1371 1844 1469 1786.50Q1567 1729 1648 1648Q1729 1567 1786.50 1469Q1844 1371 1875.50 1258.50Q1907 1146 1907 1024L1907 1024Q1907 902 1875.50 789.50Q1844 677 1786.50 579Q1729 481 1648 400Q1567 319 1469 261.50Q1371 204 1258.50 172.50Q1146 141 1024 141L1024 141Q902 141 789.50 172.50Q677 204 579 261.50Q481 319 400 400Q319 481 261.50 579Q204 677 172.50 789.50Q141 902 141 1024L141 1024Q141 1146 172.50 1258.50Q204 1371 261.50 1469Q319 1567 400 1648Q481 1729 579 1786.50Q677 1844 789.50 1875.50Q902 1907 1024 1907Z"
         }
      }
   ]
}

var CortanaLogoInner = {
   name: "CortanaLogoInner",
   vendor: "UiFabric",
   unicode: 59442,
   value: "",
   charCode: "E832",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q1148 128 1262.50 160Q1377 192 1476.50 250.50Q1576 309 1657.50 390.50Q1739 472 1797.50 571.50Q1856 671 1888 785.50Q1920 900 1920 1024L1920 1024Q1920 1148 1888 1262.50Q1856 1377 1797.50 1476.50Q1739 1576 1657.50 1657.50Q1576 1739 1476.50 1797.50Q1377 1856 1262.50 1888Q1148 1920 1024 1920L1024 1920Q900 1920 785.50 1888Q671 1856 571.50 1797.50Q472 1739 390.50 1657.50Q309 1576 250.50 1476.50Q192 1377 160 1262.50Q128 1148 128 1024L128 1024Q128 900 160 785.50Q192 671 250.50 571.50Q309 472 390.50 390.50Q472 309 571.50 250.50Q671 192 785.50 160Q900 128 1024 128ZM1024 1745L1024 1745Q1123 1745 1215.50 1719Q1308 1693 1388 1646.50Q1468 1600 1534 1534Q1600 1468 1646.50 1388Q1693 1308 1719 1216Q1745 1124 1745 1024L1745 1024Q1745 925 1719 832.50Q1693 740 1646.50 660Q1600 580 1534 514Q1468 448 1388 401.50Q1308 355 1215.50 329Q1123 303 1024 303L1024 303Q925 303 832.50 329Q740 355 660 401.50Q580 448 514 514Q448 580 401.50 660Q355 740 329 832.50Q303 925 303 1024L303 1024Q303 1123 329 1215.50Q355 1308 401.50 1388Q448 1468 514 1534Q580 1600 660 1646.50Q740 1693 832 1719Q924 1745 1024 1745Z"
         }
      }
   ]
}

var ProvisioningPackage = {
   name: "ProvisioningPackage",
   vendor: "UiFabric",
   unicode: 59445,
   value: "",
   charCode: "E835",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1473 769L1521 887L1398 938Q1408 978 1408 1024L1408 1024Q1408 1070 1398 1110L1398 1110L1521 1161L1473 1279L1349 1228Q1303 1303 1228 1349L1228 1349L1279 1473L1161 1521L1110 1398Q1070 1408 1024 1408L1024 1408Q978 1408 938 1398L938 1398L887 1521L769 1473L820 1349Q745 1303 699 1228L699 1228L575 1279L527 1161L650 1110Q640 1070 640 1024L640 1024Q640 978 650 938L650 938L527 887L575 769L699 820Q745 745 820 699L820 699L769 575L887 527L938 650Q978 640 1024 640L1024 640Q1070 640 1110 650L1110 650L1161 527L1279 575L1228 699Q1303 745 1349 820L1349 820L1473 769ZM1024 1280L1024 1280Q1076 1280 1123 1259.50Q1170 1239 1204.50 1204.50Q1239 1170 1259.50 1123.50Q1280 1077 1280 1024L1280 1024Q1280 972 1259.50 925Q1239 878 1204.50 843.50Q1170 809 1123 788.50Q1076 768 1024 768L1024 768Q971 768 924.50 788.50Q878 809 843.50 843.50Q809 878 788.50 925Q768 972 768 1024L768 1024Q768 1077 788.50 1123.50Q809 1170 843.50 1204.50Q878 1239 924.50 1259.50Q971 1280 1024 1280ZM1573 1499L1803 1728L1573 1957L1499 1883L1589 1792L256 1792L256 1280L384 1280L384 1664L1589 1664L1499 1573L1573 1499ZM549 475L475 549L245 320L475 91L549 165L459 256L1792 256L1792 768L1664 768L1664 384L459 384L549 475Z"
         }
      }
   ]
}

var FolderOpen = {
   name: "FolderOpen",
   vendor: "UiFabric",
   unicode: 59448,
   value: "",
   charCode: "E838",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1536 0Q1562 0 1585.50 10Q1609 20 1626.50 37.50Q1644 55 1654 78.50Q1664 102 1664 128L1664 128L1664 1056Q1664 1087 1673.50 1110Q1683 1133 1697 1153.50Q1711 1174 1728 1194.50Q1745 1215 1759 1240Q1773 1265 1782.50 1298Q1792 1331 1792 1376L1792 1376L1792 1664Q1792 1690 1782 1713.50Q1772 1737 1754.50 1754.50Q1737 1772 1713.50 1782Q1690 1792 1664 1792L1664 1792L768 1792L768 1920Q768 1959 746.50 1991Q725 2023 689 2038L689 2038Q666 2048 640 2048L640 2048Q587 2048 549 2010L549 2010L256 1717L256 0ZM640 1920L640 1568Q640 1523 649.50 1490.50Q659 1458 673 1432.50Q687 1407 704 1387Q721 1367 735 1346.50Q749 1326 758.50 1302.50Q768 1279 768 1248L768 1248L768 603L384 219L384 1664L640 1920ZM1664 1664L1664 1376Q1664 1345 1654.50 1322Q1645 1299 1631 1278.50Q1617 1258 1600 1237.50Q1583 1217 1569 1192Q1555 1167 1545.50 1134Q1536 1101 1536 1056L1536 1056L1536 128L475 128L859 512Q877 530 886.50 553.50Q896 577 896 603L896 603L896 1248Q896 1293 886.50 1325.50Q877 1358 863 1383.50Q849 1409 832 1429Q815 1449 801 1469.50Q787 1490 777.50 1513.50Q768 1537 768 1568L768 1568L768 1664L1664 1664Z"
         }
      }
   ]
}

var Pinned = {
   name: "Pinned",
   vendor: "UiFabric",
   unicode: 59456,
   value: "",
   charCode: "E840",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1300 58L1990 748Q1957 781 1925.50 808.50Q1894 836 1860.50 855Q1827 874 1787.50 884.50Q1748 895 1698 895L1698 895Q1664 895 1633 889L1633 889L1254 1268Q1267 1306 1273 1346Q1279 1386 1279 1426L1279 1426Q1279 1491 1266 1544Q1253 1597 1228.50 1644Q1204 1691 1169 1733.50Q1134 1776 1090 1820L1090 1820L704 1434L136 2003L0 2048L45 1912L614 1344L228 958L273 913Q343 843 433.50 806Q524 769 623 769L623 769Q705 769 780 794L780 794L1159 415Q1153 384 1153 350L1153 350Q1153 301 1163.50 261.50Q1174 222 1193 188Q1212 154 1239.50 122.50Q1267 91 1300 58L1300 58ZM1698 767L1698 767Q1753 767 1802 741L1802 741L1307 246Q1281 295 1281 350L1281 350Q1281 378 1287.50 402.50Q1294 427 1302 453L1302 453L810 944Q785 934 763 925Q741 916 719 910Q697 904 673.50 900.50Q650 897 623 897L623 897Q566 897 512.50 913.50Q459 930 413 962L413 962L1086 1635Q1118 1589 1135 1535.50Q1152 1482 1152 1426L1152 1426Q1152 1399 1148.50 1375.50Q1145 1352 1138.50 1329.50Q1132 1307 1123 1285Q1114 1263 1104 1238L1104 1238L1595 746Q1621 754 1645.50 760.50Q1670 767 1698 767Z"
         }
      }
   ]
}

var PinnedFill = {
   name: "PinnedFill",
   vendor: "UiFabric",
   unicode: 59458,
   value: "",
   charCode: "E842",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1300 148L1900 748Q1859 788 1806.50 809.50Q1754 831 1697 831L1697 831Q1653 831 1613 819L1613 819L1180 1252Q1197 1293 1206.50 1336.50Q1216 1380 1216 1425L1216 1425Q1216 1511 1183 1590Q1150 1669 1090 1730L1090 1730L318 958Q379 898 458 865Q537 832 623 832L623 832Q668 832 711.50 841.50Q755 851 796 868L796 868L1229 435Q1217 395 1217 351L1217 351Q1217 294 1238.50 241.50Q1260 189 1300 148L1300 148Z"
         }
      }
   ]
}

var RevToggleKey = {
   name: "RevToggleKey",
   vendor: "UiFabric",
   unicode: 59461,
   value: "",
   charCode: "E845",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M331 512L1152 512Q1307 512 1446.50 570Q1586 628 1695 737L1695 737Q1804 846 1862 985.50Q1920 1125 1920 1280L1920 1280Q1920 1386 1892.50 1484Q1865 1582 1815 1667.50Q1765 1753 1695 1823Q1625 1893 1539.50 1943Q1454 1993 1356 2020.50Q1258 2048 1152 2048L1152 2048L256 2048L256 1920L1152 1920Q1240 1920 1322 1897Q1404 1874 1475 1832.50Q1546 1791 1604.50 1732.50Q1663 1674 1704.50 1603Q1746 1532 1769 1450Q1792 1368 1792 1280L1792 1280Q1792 1192 1769 1110Q1746 1028 1704.50 957Q1663 886 1604.50 827.50Q1546 769 1475 727.50Q1404 686 1322 663Q1240 640 1152 640L1152 640L331 640L757 1067L683 1141L117 576L683 11L757 85L331 512Z"
         }
      }
   ]
}

var USB = {
   name: "USB",
   vendor: "UiFabric",
   unicode: 59534,
   value: "",
   charCode: "E88E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 384L768 256L896 256L896 384L768 384ZM1024 256L1152 256L1152 384L1024 384L1024 256ZM1408 0L1408 512Q1435 512 1458 522Q1481 532 1498.50 549.50Q1516 567 1526 590Q1536 613 1536 640L1536 640L1536 1920Q1536 1947 1526 1970Q1516 1993 1498.50 2010.50Q1481 2028 1458 2038Q1435 2048 1408 2048L1408 2048L512 2048Q485 2048 462 2038Q439 2028 421.50 2010.50Q404 1993 394 1970Q384 1947 384 1920L384 1920L384 640Q384 613 394 590Q404 567 421.50 549.50Q439 532 462 522Q485 512 512 512L512 512L512 0L1408 0ZM640 128L640 512L1280 512L1280 128L640 128ZM1408 1920L1408 640L512 640L512 1920L1408 1920Z"
         }
      }
   ]
}

var CheckboxIndeterminate = {
   name: "CheckboxIndeterminate",
   vendor: "UiFabric",
   unicode: 59196,
   value: "",
   charCode: "E73C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 512L1536 512L1536 1536L512 1536L512 512Z"
         }
      }
   ]
}

var View = {
   name: "View",
   vendor: "UiFabric",
   unicode: 59536,
   value: "",
   charCode: "E890",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 768L1024 768Q1103 768 1173 798Q1243 828 1295.50 880.50Q1348 933 1378 1003Q1408 1073 1408 1152L1408 1152Q1408 1232 1378 1301.50Q1348 1371 1295.50 1423.50Q1243 1476 1173 1506Q1103 1536 1024 1536L1024 1536Q944 1536 874.50 1506Q805 1476 752.50 1423.50Q700 1371 670 1301.50Q640 1232 640 1152L640 1152Q640 1073 670 1003Q700 933 752.50 880.50Q805 828 874.50 798Q944 768 1024 768ZM1024 1408L1024 1408Q1077 1408 1123.50 1388Q1170 1368 1205 1333Q1240 1298 1260 1251.50Q1280 1205 1280 1152L1280 1152Q1280 1099 1260 1052.50Q1240 1006 1205 971Q1170 936 1123.50 916Q1077 896 1024 896L1024 896Q971 896 924.50 916Q878 936 843 971Q808 1006 788 1052.50Q768 1099 768 1152L768 1152Q768 1205 788 1251.50Q808 1298 843 1333Q878 1368 924.50 1388Q971 1408 1024 1408ZM1024 256L1024 256Q1167 256 1308 291.50Q1449 327 1574 396Q1699 465 1800.50 566.50Q1902 668 1966 800L1966 800Q2006 883 2027 971.50Q2048 1060 2048 1152L2048 1152L1920 1152Q1920 1034 1884 931Q1848 828 1784.50 743Q1721 658 1635 591Q1549 524 1449.50 478Q1350 432 1241 408Q1132 384 1024 384L1024 384Q916 384 807 408Q698 432 598.50 478Q499 524 413 591Q327 658 263.50 743Q200 828 164 931Q128 1034 128 1152L128 1152L0 1152Q0 1060 21 971.50Q42 883 82 800L82 800Q146 668 247.50 566.50Q349 465 474 396Q599 327 740 291.50Q881 256 1024 256Z"
         }
      }
   ]
}

var Previous = {
   name: "Previous",
   vendor: "UiFabric",
   unicode: 59538,
   value: "",
   charCode: "E892",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1792L256 1792L256 256L384 256L384 1792ZM1792 1792L704 1024L1792 256L1792 1792ZM926 1024L1664 1545L1664 503L926 1024Z"
         }
      }
   ]
}

var Next = {
   name: "Next",
   vendor: "UiFabric",
   unicode: 59539,
   value: "",
   charCode: "E893",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1792L1664 256L1792 256L1792 1792L1664 1792ZM1344 1024L256 1792L256 256L1344 1024ZM1122 1024L384 503L384 1545L1122 1024Z"
         }
      }
   ]
}

var Clear = {
   name: "Clear",
   vendor: "UiFabric",
   unicode: 59540,
   value: "",
   charCode: "E894",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2029 109L1115 1024L2029 1939L1939 2029L1024 1115L109 2029L19 1939L933 1024L19 109L109 19L1024 933L1939 19L2029 109Z"
         }
      }
   ]
}

var Sync = {
   name: "Sync",
   vendor: "UiFabric",
   unicode: 59541,
   value: "",
   charCode: "E895",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1920L1024 1920Q1178 1920 1319.50 1872.50Q1461 1825 1577.50 1738.50Q1694 1652 1780.50 1530.50Q1867 1409 1912 1261L1912 1261L2034 1299Q1984 1466 1885 1603.50Q1786 1741 1652.50 1840Q1519 1939 1358.50 1993.50Q1198 2048 1024 2048L1024 2048Q887 2048 757 2014Q627 1980 511.50 1915.50Q396 1851 298 1758.50Q200 1666 128 1549L128 1549L128 1792L0 1792L0 1280L512 1280L512 1408L196 1408Q255 1525 342.50 1619.50Q430 1714 538 1780.50Q646 1847 769.50 1883.50Q893 1920 1024 1920ZM1920 256L2048 256L2048 768L1536 768L1536 640L1852 640Q1793 523 1705.50 428.50Q1618 334 1510 267.50Q1402 201 1278.50 164.50Q1155 128 1024 128L1024 128Q870 128 728.50 175.50Q587 223 470.50 309.50Q354 396 267.50 517.50Q181 639 136 787L136 787L14 749Q64 583 163 445Q262 307 395.50 208Q529 109 689.50 54.50Q850 0 1024 0L1024 0Q1161 0 1291 34Q1421 68 1536.50 132.50Q1652 197 1750 289.50Q1848 382 1920 499L1920 499L1920 256Z"
         }
      }
   ]
}

var Download = {
   name: "Download",
   vendor: "UiFabric",
   unicode: 59542,
   value: "",
   charCode: "E896",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 2048L384 2048L384 1920L1536 1920L1536 2048ZM1491 979L1581 1069L960 1695L339 1069L429 979L896 1449L896 0L1024 0L1024 1449L1491 979Z"
         }
      }
   ]
}

var Help = {
   name: "Help",
   vendor: "UiFabric",
   unicode: 59543,
   value: "",
   charCode: "E897",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 2048L896 1920L1024 1920L1024 2048L896 2048ZM960 0L960 0Q1039 0 1112.50 20.50Q1186 41 1250 78.50Q1314 116 1367 169Q1420 222 1457.50 286Q1495 350 1515.50 423.50Q1536 497 1536 576L1536 576Q1536 660 1514 728Q1492 796 1456 852.50Q1420 909 1374 957Q1328 1005 1280 1050Q1232 1095 1186 1139.50Q1140 1184 1104 1234Q1068 1284 1046 1342Q1024 1400 1024 1472L1024 1472L1024 1664L896 1664L896 1472Q896 1388 918 1320Q940 1252 976 1195.50Q1012 1139 1058 1091.50Q1104 1044 1152 999Q1200 954 1246 909Q1292 864 1328 814Q1364 764 1386 706Q1408 648 1408 576L1408 576Q1408 483 1372.50 401.50Q1337 320 1276.50 259.50Q1216 199 1134.50 163.50Q1053 128 960 128L960 128Q867 128 785.50 163.50Q704 199 643.50 259.50Q583 320 547.50 401.50Q512 483 512 576L512 576L384 576Q384 497 404.50 423.50Q425 350 462.50 286Q500 222 553 169Q606 116 670 78.50Q734 41 807.50 20.50Q881 0 960 0Z"
         }
      }
   ]
}

var Upload = {
   name: "Upload",
   vendor: "UiFabric",
   unicode: 59544,
   value: "",
   charCode: "E898",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L1536 0L1536 128L384 128L384 0ZM960 353L1581 979L1491 1069L1024 599L1024 2048L896 2048L896 599L429 1069L339 979L960 353Z"
         }
      }
   ]
}

var Emoji = {
   name: "Emoji",
   vendor: "UiFabric",
   unicode: 59545,
   value: "",
   charCode: "E899",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920ZM640 512L640 512Q667 512 690 522Q713 532 730.50 549.50Q748 567 758 590Q768 613 768 640L768 640L512 640Q512 613 522 590Q532 567 549.50 549.50Q567 532 590 522Q613 512 640 512ZM1408 512L1408 512Q1435 512 1458 522Q1481 532 1498.50 549.50Q1516 567 1526 590Q1536 613 1536 640L1536 640L1280 640Q1280 613 1290 590Q1300 567 1317.50 549.50Q1335 532 1358 522Q1381 512 1408 512ZM1472 768L1472 768Q1512 768 1547 783Q1582 798 1608 824Q1634 850 1649 885Q1664 920 1664 960L1664 960L1664 1024Q1664 1157 1614 1273.50Q1564 1390 1477 1477Q1390 1564 1273.50 1614Q1157 1664 1024 1664L1024 1664Q891 1664 774.50 1614Q658 1564 571 1477Q484 1390 434 1273.50Q384 1157 384 1024L384 1024Q384 976 392 930Q400 884 421 848Q442 812 479.50 790Q517 768 576 768L576 768Q650 768 705 788Q760 808 809.50 832Q859 856 909.50 876Q960 896 1024 896L1024 896Q1088 896 1138.50 876Q1189 856 1238.50 832Q1288 808 1343 788Q1398 768 1472 768ZM1536 1024L1536 960Q1536 934 1517 915Q1498 896 1472 896L1472 896Q1429 896 1393 905.50Q1357 915 1323.50 929Q1290 943 1257.50 960Q1225 977 1189.50 991Q1154 1005 1113.50 1014.50Q1073 1024 1024 1024L1024 1024Q975 1024 934.50 1014.50Q894 1005 858.50 991Q823 977 790.50 960Q758 943 724.50 929Q691 915 655 905.50Q619 896 576 896L576 896Q550 896 531 915Q512 934 512 960L512 960L512 1024Q512 1130 552.50 1223Q593 1316 662.50 1385.50Q732 1455 825 1495.50Q918 1536 1024 1536L1024 1536Q1130 1536 1223 1495.50Q1316 1455 1385.50 1385.50Q1455 1316 1495.50 1223Q1536 1130 1536 1024L1536 1024Z"
         }
      }
   ]
}

var MailForward = {
   name: "MailForward",
   vendor: "UiFabric",
   unicode: 59548,
   value: "",
   charCode: "E89C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 384L2048 384L2048 1280L2048 1408L1920 1280L1920 583L1024 1032L128 583L128 1536L1152 1536L1152 1664L0 1664ZM271 512L1024 888L1777 512L271 512ZM1798 1536L1635 1373L1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1280 1664L1280 1536L1798 1536Z"
         }
      }
   ]
}

var ClosePane = {
   name: "ClosePane",
   vendor: "UiFabric",
   unicode: 59551,
   value: "",
   charCode: "E89F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM1408 512L128 512L128 1408L1408 1408L1408 512ZM1536 1408L1920 1408L1920 512L1536 512L1536 1408ZM899 733L989 643L1306 960L989 1277L899 1187L1061 1024L640 1024L640 896L1061 896L899 733Z"
         }
      }
   ]
}

var OpenPane = {
   name: "OpenPane",
   vendor: "UiFabric",
   unicode: 59552,
   value: "",
   charCode: "E8A0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM1408 512L128 512L128 1408L1408 1408L1408 512ZM1536 1408L1920 1408L1920 512L1536 512L1536 1408ZM859 896L1280 896L1280 1024L859 1024L1021 1187L931 1277L614 960L931 643L1021 733L859 896Z"
         }
      }
   ]
}

var PreviewLink = {
   name: "PreviewLink",
   vendor: "UiFabric",
   unicode: 59553,
   value: "",
   charCode: "E8A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 256L2048 256L2048 1792L0 1792ZM128 1664L1920 1664L1920 384L128 384L128 1664ZM256 512L1792 512L1792 896L256 896L256 512ZM384 768L1664 768L1664 640L384 640L384 768ZM1792 1536L1280 1536L1280 1024L1792 1024L1792 1536ZM1664 1152L1408 1152L1408 1408L1664 1408L1664 1152ZM256 1024L1024 1024L1024 1152L256 1152L256 1024ZM256 1408L1024 1408L1024 1536L256 1536L256 1408Z"
         }
      }
   ]
}

var ZoomIn = {
   name: "ZoomIn",
   vendor: "UiFabric",
   unicode: 59555,
   value: "",
   charCode: "E8A3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1245 1154L2029 1939Q2048 1958 2048 1984L2048 1984Q2048 2010 2029 2029Q2010 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1154 1245Q1058 1324 943.50 1366Q829 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 349 1312Q271 1266 206.50 1201.50Q142 1137 96 1059Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 349Q142 271 206.50 206.50Q271 142 349 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059 96Q1137 142 1201.50 206.50Q1266 271 1312 349Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 829 1366 943.50Q1324 1058 1245 1154L1245 1154ZM704 1280L704 1280Q823 1280 928 1234.50Q1033 1189 1111 1111Q1189 1033 1234.50 928Q1280 823 1280 704L1280 704Q1280 585 1234.50 480Q1189 375 1111 297Q1033 219 928 173.50Q823 128 704 128L704 128Q585 128 480 173.50Q375 219 297 297Q219 375 173.50 480Q128 585 128 704L128 704Q128 823 173.50 928Q219 1033 297 1111Q375 1189 480 1234.50Q585 1280 704 1280ZM768 384L768 640L1024 640L1024 768L768 768L768 1024L640 1024L640 768L384 768L384 640L640 640L640 384L768 384Z"
         }
      }
   ]
}

var Bookmarks = {
   name: "Bookmarks",
   vendor: "UiFabric",
   unicode: 59556,
   value: "",
   charCode: "E8A4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 512L0 512L0 384L128 384L128 512ZM384 512L384 384L2048 384L2048 512L384 512ZM128 1664L0 1664L0 1536L128 1536L128 1664ZM2048 1664L384 1664L384 1536L2048 1536L2048 1664ZM2048 896L896 896L896 768L2048 768L2048 896ZM2048 1280L1408 1280L1408 1152L2048 1152L2048 1280Z"
         }
      }
   ]
}

var Document = {
   name: "Document",
   vendor: "UiFabric",
   unicode: 59557,
   value: "",
   charCode: "E8A5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 293L549 0L1792 0L1792 1755L1499 2048L256 2048L256 293ZM1445 1920L1664 1701L1664 128L603 128L384 347L384 1920L1445 1920Z"
         }
      }
   ]
}

var ProtectedDocument = {
   name: "ProtectedDocument",
   vendor: "UiFabric",
   unicode: 59558,
   value: "",
   charCode: "E8A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1280L1920 1280L1920 2048L1024 2048L1024 1280L1152 1280Q1152 1204 1169.50 1134.50Q1187 1065 1225.50 1012Q1264 959 1324.50 927.50Q1385 896 1472 896L1472 896Q1559 896 1619.50 927.50Q1680 959 1718.50 1012Q1757 1065 1774.50 1134.50Q1792 1204 1792 1280L1792 1280ZM1280 1216L1280 1280L1664 1280L1664 1216Q1664 1176 1649 1141Q1634 1106 1608 1080Q1582 1054 1547 1039Q1512 1024 1472 1024L1472 1024Q1432 1024 1397 1039Q1362 1054 1336 1080Q1310 1106 1295 1141Q1280 1176 1280 1216L1280 1216ZM1792 1920L1792 1408L1152 1408L1152 1920L1792 1920ZM384 347L384 1920L896 1920L896 2048L256 2048L256 293L549 0L1792 0L1792 860Q1763 834 1731 813Q1699 792 1664 776L1664 776L1664 128L603 128L384 347Z"
         }
      }
   ]
}

var OpenInNewWindow = {
   name: "OpenInNewWindow",
   vendor: "UiFabric",
   unicode: 59559,
   value: "",
   charCode: "E8A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L1536 256L1920 256L1920 640L1792 640L1792 475L1336 931L1245 840L1701 384L1536 384ZM1536 1536L1536 1024L1664 896L1664 1664L0 1664L0 512L1280 512L1152 640L128 640L128 1536L1536 1536Z"
         }
      }
   ]
}

var MailFill = {
   name: "MailFill",
   vendor: "UiFabric",
   unicode: 59560,
   value: "",
   charCode: "E8A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 448L64 448L1984 448L1984 1600L64 1600L64 448Z"
         }
      }
   ]
}

var ViewAll = {
   name: "ViewAll",
   vendor: "UiFabric",
   unicode: 59561,
   value: "",
   charCode: "E8A9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1792L128 128L1792 128L1792 1792L128 1792ZM1024 896L1664 896L1664 256L1024 256L1024 896ZM896 896L896 256L256 256L256 896L896 896ZM896 1024L256 1024L256 1664L896 1664L896 1024ZM1024 1024L1024 1664L1664 1664L1664 1024L1024 1024Z"
         }
      }
   ]
}

var Switch = {
   name: "Switch",
   vendor: "UiFabric",
   unicode: 59563,
   value: "",
   charCode: "E8AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M250 1408L2048 1408L2048 1536L250 1536L413 1699L323 1789L6 1472L323 1155L413 1245L250 1408ZM1725 893L1635 803L1798 640L0 640L0 512L1798 512L1635 349L1725 259L2042 576L1725 893Z"
         }
      }
   ]
}

var Rename = {
   name: "Rename",
   vendor: "UiFabric",
   unicode: 59564,
   value: "",
   charCode: "E8AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1025 1149L255 1149L255 895L1025 895L1025 1149ZM1281 1279L1281 1409L-1 1409L-1 639L1281 639L1281 769L129 769L129 1279L1281 1279ZM1663 639L2049 639L2049 1409L1663 1409L1663 1279L1919 1279L1919 769L1663 769L1663 639ZM1537 477L1537 1567Q1648 1663 1792 1663L1792 1663L1793 1663L1793 1793L1792 1793Q1616 1793 1474 1683L1474 1683Q1404 1737 1322.50 1765Q1241 1793 1152 1793L1152 1793L1151 1793L1151 1663L1152 1663Q1297 1663 1407 1570L1407 1570L1407 474Q1355 430 1290.50 407.50Q1226 385 1152 385L1152 385L1151 385L1151 255L1152 255Q1243 255 1324.50 282Q1406 309 1474 361L1474 361Q1612 255 1792 255L1792 255L1793 255L1793 385L1792 385Q1644 385 1537 477L1537 477Z"
         }
      }
   ]
}

var Go = {
   name: "Go",
   vendor: "UiFabric",
   unicode: 59565,
   value: "",
   charCode: "E8AD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0L2048 0L2048 1024L1920 1024L1920 219L93 2045L3 1955L1829 128L1024 128L1024 0Z"
         }
      }
   ]
}

var Remote = {
   name: "Remote",
   vendor: "UiFabric",
   unicode: 59567,
   value: "",
   charCode: "E8AF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M870 1344L259 733L349 643L1050 1344L349 2045L259 1955L870 1344ZM1699 3L1789 93L1178 704L1789 1315L1699 1405L998 704L1699 3Z"
         }
      }
   ]
}

var SelectAll = {
   name: "SelectAll",
   vendor: "UiFabric",
   unicode: 59571,
   value: "",
   charCode: "E8B3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L0 128L0 0L128 0L128 128ZM128 384L0 384L0 256L128 256L128 384ZM128 640L0 640L0 512L128 512L128 640ZM128 896L0 896L0 768L128 768L128 896ZM128 1152L0 1152L0 1024L128 1024L128 1152ZM128 1408L0 1408L0 1280L128 1280L128 1408ZM128 1664L0 1664L0 1536L128 1536L128 1664ZM128 1920L0 1920L0 1792L128 1792L128 1920ZM1920 384L1792 384L1792 256L1920 256L1920 384ZM1920 640L1792 640L1792 512L1920 512L1920 640ZM1920 896L1792 896L1792 768L1920 768L1920 896ZM1920 1152L1792 1152L1792 1024L1920 1024L1920 1152ZM1920 1408L1792 1408L1792 1280L1920 1280L1920 1408ZM1920 1664L1792 1664L1792 1536L1920 1536L1920 1664ZM1920 1920L1792 1920L1792 1792L1920 1792L1920 1920ZM256 0L384 0L384 128L256 128L256 0ZM512 0L640 0L640 128L512 128L512 0ZM768 0L896 0L896 128L768 128L768 0ZM1024 0L1152 0L1152 128L1024 128L1024 0ZM1280 0L1408 0L1408 128L1280 128L1280 0ZM1664 128L1536 128L1536 0L1664 0L1664 128ZM384 1920L256 1920L256 1792L384 1792L384 1920ZM640 1920L512 1920L512 1792L640 1792L640 1920ZM896 1920L768 1920L768 1792L896 1792L896 1920ZM1152 1920L1024 1920L1024 1792L1152 1792L1152 1920ZM1408 1920L1280 1920L1280 1792L1408 1792L1408 1920ZM1664 1920L1536 1920L1536 1792L1664 1792L1664 1920ZM1792 128L1792 0L1920 0L1920 128L1792 128ZM384 384L1536 384L1536 1536L384 1536L384 384ZM1024 896L1408 896L1408 512L1024 512L1024 896ZM896 896L896 512L512 512L512 896L896 896ZM896 1024L512 1024L512 1408L896 1408L896 1024ZM1024 1024L1024 1408L1408 1408L1408 1024L1024 1024Z"
         }
      }
   ]
}

var Orientation = {
   name: "Orientation",
   vendor: "UiFabric",
   unicode: 59572,
   value: "",
   charCode: "E8B4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 768L1408 1664L0 1664L0 768L1408 768ZM1280 1536L1280 896L128 896L128 1536L1280 1536ZM128 512L128 640L0 640L0 512L128 512ZM128 256L128 384L0 384L0 256L128 256ZM128 0L128 128L0 128L0 0L128 0ZM896 0L896 128L768 128L768 0L896 0ZM384 0L384 128L256 128L256 0L384 0ZM640 0L640 128L512 128L512 0L640 0ZM896 256L896 384L768 384L768 256L896 256ZM896 512L896 640L768 640L768 512L896 512ZM1920 128L1627 128Q1729 230 1807.50 325.50Q1886 421 1939.50 525.50Q1993 630 2020.50 751Q2048 872 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 891 1894.50 782Q1869 673 1820.50 578Q1772 483 1700.50 396Q1629 309 1536 219L1536 219L1536 512L1408 512L1408 0L1920 0L1920 128Z"
         }
      }
   ]
}

var Import = {
   name: "Import",
   vendor: "UiFabric",
   unicode: 59573,
   value: "",
   charCode: "E8B5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M467 499L557 589L249 898L1792 898L1792 1026L252 1026L557 1331L467 1421L6 960L467 499ZM1920 1408L1920 512L2048 512L2048 1408L1920 1408Z"
         }
      }
   ]
}

var Folder = {
   name: "Folder",
   vendor: "UiFabric",
   unicode: 59575,
   value: "",
   charCode: "E8B7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1664 0Q1691 0 1714 10Q1737 20 1754.50 37.50Q1772 55 1782 78Q1792 101 1792 128L1792 128L1792 1120Q1792 1151 1801.50 1174.50Q1811 1198 1825 1218.50Q1839 1239 1856 1259Q1873 1279 1887 1304.50Q1901 1330 1910.50 1362.50Q1920 1395 1920 1440L1920 1440L1920 1920Q1920 1947 1910 1970Q1900 1993 1882.50 2010.50Q1865 2028 1842 2038Q1819 2048 1792 2048L1792 2048L256 2048L256 0ZM384 128L384 1920L1536 1920L1536 1440Q1536 1395 1545.50 1362.50Q1555 1330 1569 1304.50Q1583 1279 1600 1259Q1617 1239 1631 1218.50Q1645 1198 1654.50 1174.50Q1664 1151 1664 1120L1664 1120L1664 128L384 128ZM1792 1920L1792 1440Q1792 1416 1787.50 1398Q1783 1380 1774.50 1365Q1766 1350 1754.50 1335.50Q1743 1321 1728 1304L1728 1304Q1713 1321 1701.50 1335.50Q1690 1350 1681.50 1365Q1673 1380 1668.50 1398Q1664 1416 1664 1440L1664 1440L1664 1920L1792 1920Z"
         }
      }
   ]
}

var Picture = {
   name: "Picture",
   vendor: "UiFabric",
   unicode: 59577,
   value: "",
   charCode: "E8B9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 256L1792 512L2048 512L2048 1792L256 1792L256 1536L0 1536L0 256L1792 256ZM1664 384L128 384L128 1408L1664 1408L1664 384ZM384 1664L1920 1664L1920 640L1792 640L1792 1536L384 1536L384 1664ZM1536 1280L256 1280L256 512L1536 512L1536 1280ZM1408 640L384 640L384 1152L1408 1152L1408 640Z"
         }
      }
   ]
}

var ChromeClose = {
   name: "ChromeClose",
   vendor: "UiFabric",
   unicode: 59579,
   value: "",
   charCode: "E8BB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 145L1169 1024L2048 1903L1903 2048L1024 1169L145 2048L0 1903L879 1024L0 145L145 0L1024 879L1903 0L2048 145Z"
         }
      }
   ]
}

var ShowResults = {
   name: "ShowResults",
   vendor: "UiFabric",
   unicode: 59580,
   value: "",
   charCode: "E8BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1792L384 1792L384 1664L2048 1664L2048 1792ZM128 384L0 384L0 256L128 256L128 384ZM128 1408L0 1408L0 1280L128 1280L128 1408ZM2048 1408L384 1408L384 1280L2048 1280L2048 1408ZM384 384L384 256L2048 256L2048 384L384 384ZM2048 768L384 768L384 640L2048 640L2048 768Z"
         }
      }
   ]
}

var Message = {
   name: "Message",
   vendor: "UiFabric",
   unicode: 59581,
   value: "",
   charCode: "E8BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536ZM677 1408L1920 1408L1920 256L128 256L128 1408L384 1408L384 1701L677 1408Z"
         }
      }
   ]
}

var CalendarDay = {
   name: "CalendarDay",
   vendor: "UiFabric",
   unicode: 59583,
   value: "",
   charCode: "E8BF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM128 1792L1920 1792L1920 640L128 640L128 1792ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512ZM384 1024L1664 1024L1664 1664L384 1664L384 1024ZM512 1536L1536 1536L1536 1152L512 1152L512 1536ZM384 768L1664 768L1664 896L384 896L384 768Z"
         }
      }
   ]
}

var CalendarWeek = {
   name: "CalendarWeek",
   vendor: "UiFabric",
   unicode: 59584,
   value: "",
   charCode: "E8C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM384 384L384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384ZM128 640L128 1792L1920 1792L1920 640L128 640ZM896 1664L768 1664L768 768L896 768L896 1664ZM512 1664L384 1664L384 768L512 768L512 1664ZM1664 1664L1536 1664L1536 768L1664 768L1664 1664ZM1280 1664L1152 1664L1152 768L1280 768L1280 1664Z"
         }
      }
   ]
}

var MailReplyAll = {
   name: "MailReplyAll",
   vendor: "UiFabric",
   unicode: 59586,
   value: "",
   charCode: "E8C2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1466Q2019 1443 1987 1426.50Q1955 1410 1920 1398L1920 1398L1920 583L1024 1032L128 583L128 1536L832 1536L832 1664L0 1664L0 384ZM271 512L1024 888L1777 512L271 512ZM1341 1373L1115 1600L1341 1827L1251 1917L933 1600L1251 1283L1341 1373ZM1661 1373L1499 1536Q1549 1536 1609.50 1533.50Q1670 1531 1731 1534Q1792 1537 1849 1548.50Q1906 1560 1950.50 1588.50Q1995 1617 2021.50 1666Q2048 1715 2048 1792L2048 1792Q2048 1845 2027.50 1891.50Q2007 1938 1972.50 1972.50Q1938 2007 1891 2027.50Q1844 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373Z"
         }
      }
   ]
}

var Read = {
   name: "Read",
   vendor: "UiFabric",
   unicode: 59587,
   value: "",
   charCode: "E8C3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 632L1024 120L2048 632L2048 1920L0 1920L0 632ZM1573 1024L1897 700L1024 264L151 700L475 1024L1573 1024ZM128 859L128 1792L1920 1792L1920 859L1627 1152L421 1152L128 859Z"
         }
      }
   ]
}

var Cut = {
   name: "Cut",
   vendor: "UiFabric",
   unicode: 59590,
   value: "",
   charCode: "E8C6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1094 890L1416 1536Q1467 1538 1512.50 1558.50Q1558 1579 1591.50 1614Q1625 1649 1644.50 1695Q1664 1741 1664 1792L1664 1792Q1664 1845 1643.50 1891.50Q1623 1938 1588.50 1972.50Q1554 2007 1507 2027.50Q1460 2048 1408 2048L1408 2048Q1355 2048 1308.50 2027.50Q1262 2007 1227.50 1972.50Q1193 1938 1172.50 1891.50Q1152 1845 1152 1792L1152 1792Q1152 1721 1188.50 1660Q1225 1599 1288 1566L1288 1566L1022 1035L757 1564Q789 1581 814.50 1605Q840 1629 858 1659Q876 1689 886 1722.50Q896 1756 896 1792L896 1792Q896 1845 875.50 1891.50Q855 1938 820.50 1972.50Q786 2007 739 2027.50Q692 2048 640 2048L640 2048Q587 2048 540.50 2027.50Q494 2007 459.50 1972.50Q425 1938 404.50 1891.50Q384 1845 384 1792L384 1792Q384 1741 403 1695.50Q422 1650 455 1615.50Q488 1581 532.50 1560Q577 1539 628 1536L628 1536L950 890L611 212L669 37L1022 745L1375 37L1433 212L1094 890ZM640 1920L640 1920Q667 1920 690 1910Q713 1900 730.50 1882.50Q748 1865 758 1842Q768 1819 768 1792L768 1792Q768 1765 758 1742Q748 1719 730.50 1701.50Q713 1684 690 1674Q667 1664 640 1664L640 1664Q613 1664 590 1674Q567 1684 549.50 1701.50Q532 1719 522 1742Q512 1765 512 1792L512 1792Q512 1819 522 1842Q532 1865 549.50 1882.50Q567 1900 590 1910Q613 1920 640 1920ZM1408 1920L1408 1920Q1435 1920 1458 1910Q1481 1900 1498.50 1882.50Q1516 1865 1526 1842Q1536 1819 1536 1792L1536 1792Q1536 1765 1526 1742Q1516 1719 1498.50 1701.50Q1481 1684 1458 1674Q1435 1664 1408 1664L1408 1664Q1381 1664 1358 1674Q1335 1684 1317.50 1701.50Q1300 1719 1290 1742Q1280 1765 1280 1792L1280 1792Q1280 1819 1290 1842Q1300 1865 1317.50 1882.50Q1335 1900 1358 1910Q1381 1920 1408 1920Z"
         }
      }
   ]
}

var Attach = {
   name: "Attach",
   vendor: "UiFabric",
   unicode: 59171,
   value: "",
   charCode: "E723",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 384L1536 384L1536 1600Q1536 1693 1500.50 1774.50Q1465 1856 1404.50 1916.50Q1344 1977 1262.50 2012.50Q1181 2048 1088 2048L1088 2048Q995 2048 913.50 2012.50Q832 1977 771.50 1916.50Q711 1856 675.50 1774.50Q640 1693 640 1600L640 1600L640 320Q640 254 665.50 196Q691 138 734.50 94.50Q778 51 836 25.50Q894 0 960 0L960 0Q1026 0 1084 25.50Q1142 51 1185.50 94.50Q1229 138 1254.50 196Q1280 254 1280 320L1280 320L1280 1600Q1280 1640 1265 1675Q1250 1710 1224 1736Q1198 1762 1163 1777Q1128 1792 1088 1792L1088 1792Q1048 1792 1013 1777Q978 1762 952 1736Q926 1710 911 1675Q896 1640 896 1600L896 1600L896 512L1024 512L1024 1600Q1024 1626 1043 1645Q1062 1664 1088 1664L1088 1664Q1114 1664 1133 1645Q1152 1626 1152 1600L1152 1600L1152 320Q1152 280 1137 245Q1122 210 1096 184Q1070 158 1035 143Q1000 128 960 128L960 128Q920 128 885 143Q850 158 824 184Q798 210 783 245Q768 280 768 320L768 320L768 1600Q768 1666 793.50 1724Q819 1782 862.50 1825.50Q906 1869 964 1894.50Q1022 1920 1088 1920L1088 1920Q1154 1920 1212 1894.50Q1270 1869 1313.50 1825.50Q1357 1782 1382.50 1724Q1408 1666 1408 1600L1408 1600L1408 384Z"
         }
      }
   ]
}

var Copy = {
   name: "Copy",
   vendor: "UiFabric",
   unicode: 59592,
   value: "",
   charCode: "E8C8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1499 384L1920 805L1920 2048L640 2048L640 1664L128 1664L128 0L987 0L1371 384L1499 384ZM1536 603L1536 768L1701 768L1536 603ZM640 1536L640 384L1189 384L933 128L256 128L256 1536L640 1536ZM1792 1920L1792 896L1408 896L1408 512L768 512L768 1920L1792 1920Z"
         }
      }
   ]
}

var Important = {
   name: "Important",
   vendor: "UiFabric",
   unicode: 59593,
   value: "",
   charCode: "E8C9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1408L1152 1408L896 1408L896 128L1152 128L1152 1408ZM1152 1920L1152 1920L896 1920L896 1664L1152 1664L1152 1920Z"
         }
      }
   ]
}

var MailReply = {
   name: "MailReply",
   vendor: "UiFabric",
   unicode: 59594,
   value: "",
   charCode: "E8CA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1466Q2019 1443 1987 1426.50Q1955 1410 1920 1398L1920 1398L1920 583L1024 1032L128 583L128 1536L1152 1536L1152 1664L0 1664L0 384ZM271 512L1024 888L1777 512L271 512ZM1661 1373L1499 1536Q1549 1536 1609.50 1533.50Q1670 1531 1731 1534Q1792 1537 1849 1548.50Q1906 1560 1950.50 1588.50Q1995 1617 2021.50 1666Q2048 1715 2048 1792L2048 1792Q2048 1845 2027.50 1891.50Q2007 1938 1972.50 1972.50Q1938 2007 1891 2027.50Q1844 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373Z"
         }
      }
   ]
}

var Sort = {
   name: "Sort",
   vendor: "UiFabric",
   unicode: 59595,
   value: "",
   charCode: "E8CB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M576 6L1069 499L979 589L641 252L640 2048L512 2048L513 249L173 589L83 499L576 6ZM1537 1798L1876 1459L1967 1549L1474 2042L980 1549L1071 1459L1409 1797L1408 0L1536 0L1537 1798Z"
         }
      }
   ]
}

var GotoToday = {
   name: "GotoToday",
   vendor: "UiFabric",
   unicode: 59601,
   value: "",
   charCode: "E8D1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L1536 128L1920 128L1920 1920L1152 1920L1152 1792L1792 1792L1792 640L128 640L128 1792L768 1792L768 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1408 128L1408 0L1536 0ZM128 256L128 512L1792 512L1792 256L1536 256L1536 384L1408 384L1408 256L512 256L512 384L384 384L384 256L128 256ZM1277 1571L1187 1661L1024 1499L1024 2048L896 2048L896 1499L733 1661L643 1571L960 1254L1277 1571ZM768 768L1152 768L1152 1152L768 1152L768 768ZM896 1024L1024 1024L1024 896L896 896L896 1024Z"
         }
      }
   ]
}

var Font = {
   name: "Font",
   vendor: "UiFabric",
   unicode: 59602,
   value: "",
   charCode: "E8D2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M830 1220L765 1024L387 1024L302 1280L167 1280L509 256L643 256L911 1058L830 1220ZM430 896L722 896L576 458L430 896ZM1319 640L1704 1575Q1721 1616 1735.50 1648Q1750 1680 1770 1702.50Q1790 1725 1820 1736.50Q1850 1748 1898 1748L1898 1748L1898 1792L1449 1792L1449 1748Q1466 1748 1486.50 1748.50Q1507 1749 1525 1744.50Q1543 1740 1555 1728Q1567 1716 1567 1691L1567 1691Q1567 1677 1560.50 1652Q1554 1627 1544.50 1598Q1535 1569 1523.50 1538.50Q1512 1508 1501.50 1481Q1491 1454 1483 1434.50Q1475 1415 1472 1408L1472 1408L1024 1408Q1021 1416 1012 1435.50Q1003 1455 991.50 1481.50Q980 1508 967.50 1538Q955 1568 944.50 1596.50Q934 1625 927.50 1650Q921 1675 921 1690L921 1690Q921 1714 933.50 1725.50Q946 1737 964 1741.50Q982 1746 1002.50 1746.50Q1023 1747 1039 1748L1039 1748L1039 1792L662 1792L662 1748Q711 1739 738 1727Q765 1715 782 1694.50Q799 1674 812 1643Q825 1612 845 1564L845 1564L1237 640L1319 640ZM1067 1280L1413 1280L1236 899L1067 1280Z"
         }
      }
   ]
}

var FolderFill = {
   name: "FolderFill",
   vendor: "UiFabric",
   unicode: 59605,
   value: "",
   charCode: "E8D5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 64L1664 64Q1690 64 1709 83Q1728 102 1728 128L1728 128L1728 1120Q1728 1177 1748 1213Q1768 1249 1792 1280Q1816 1311 1836 1347Q1856 1383 1856 1440L1856 1440L1856 1920Q1856 1946 1837 1965Q1818 1984 1792 1984L1792 1984L320 1984L320 64L1664 64Z"
         }
      }
   ]
}

var Permissions = {
   name: "Permissions",
   vendor: "UiFabric",
   unicode: 59607,
   value: "",
   charCode: "E8D7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1377 903L2048 1573L2048 2048L1536 2048L1536 1792L1280 1792L1280 1536L1024 1536L1024 1329Q950 1368 869 1388Q788 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 349 1312Q271 1266 206.50 1201.50Q142 1137 96 1059Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 349Q142 271 206.50 206.50Q271 142 349 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059 96Q1137 142 1201.50 206.50Q1266 271 1312 349Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 755 1400 805Q1392 855 1377 903L1377 903ZM1920 1920L1920 1627L1230 937Q1252 880 1266 822.50Q1280 765 1280 704L1280 704Q1280 585 1234.50 480Q1189 375 1111 297Q1033 219 928 173.50Q823 128 704 128L704 128Q585 128 480 173.50Q375 219 297 297Q219 375 173.50 480Q128 585 128 704L128 704Q128 823 173.50 928Q219 1033 297 1111Q375 1189 480 1234.50Q585 1280 704 1280L704 1280Q801 1280 894.50 1247Q988 1214 1063 1152L1063 1152L1152 1152L1152 1408L1408 1408L1408 1664L1664 1664L1664 1920L1920 1920ZM512 384L512 384Q539 384 562 394Q585 404 602.50 421.50Q620 439 630 462Q640 485 640 512L640 512Q640 539 630 562Q620 585 602.50 602.50Q585 620 562 630Q539 640 512 640L512 640Q485 640 462 630Q439 620 421.50 602.50Q404 585 394 562Q384 539 384 512L384 512Q384 485 394 462Q404 439 421.50 421.50Q439 404 462 394Q485 384 512 384Z"
         }
      }
   ]
}

var DisableUpdates = {
   name: "DisableUpdates",
   vendor: "UiFabric",
   unicode: 59608,
   value: "",
   charCode: "E8D8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333ZM512 640L512 768L0 768L0 256L128 256L128 531Q195 409 291.50 310.50Q388 212 504 143Q620 74 752 37Q884 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1063 2044.50 1102Q2041 1141 2035 1179L2035 1179Q2009 1152 1979 1127.50Q1949 1103 1917 1083L1917 1083Q1918 1068 1919 1053.50Q1920 1039 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q895 128 773.50 164.50Q652 201 547 267.50Q442 334 357.50 428.50Q273 523 218 640L218 640L512 640ZM1083 1917L1083 1917Q1103 1949 1127.50 1979Q1152 2009 1179 2035L1179 2035Q1141 2041 1102 2044.50Q1063 2048 1024 2048L1024 2048Q910 2048 800.50 2023Q691 1998 592 1951.50Q493 1905 405 1838Q317 1771 246 1687.50Q175 1604 121.50 1505.50Q68 1407 38 1297L38 1297L161 1263Q201 1408 284.50 1528.50Q368 1649 482 1736Q596 1823 735 1871.50Q874 1920 1024 1920L1024 1920Q1039 1920 1053.50 1919Q1068 1918 1083 1917Z"
         }
      }
   ]
}

var FontColor = {
   name: "FontColor",
   vendor: "UiFabric",
   unicode: 59603,
   value: "",
   charCode: "E8D3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 2048L256 1920L1664 1920L1664 2048L256 2048ZM1276 1280L643 1280L473 1792L338 1792L893 128L1028 128L1582 1792L1447 1792L1276 1280ZM1234 1152L960 331L686 1152L1234 1152Z"
         }
      }
   ]
}

var Unfavorite = {
   name: "Unfavorite",
   vendor: "UiFabric",
   unicode: 59609,
   value: "",
   charCode: "E8D9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1609 992L1609 992Q1484 992 1374.50 1036Q1265 1080 1182.50 1158.50Q1100 1237 1050 1344.50Q1000 1452 994 1579L994 1579L384 2048L632 1254L0 768L784 768L1024 0L1264 768L2048 768L1735 1008Q1704 1001 1672.50 996.50Q1641 992 1609 992ZM1600 1152L1600 1152Q1693 1152 1774.50 1187.50Q1856 1223 1916.50 1283.50Q1977 1344 2012.50 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2012.50 1774.50Q1977 1856 1916.50 1916.50Q1856 1977 1774.50 2012.50Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2012.50Q1344 1977 1283.50 1916.50Q1223 1856 1187.50 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187.50 1425.50Q1223 1344 1283.50 1283.50Q1344 1223 1425.50 1187.50Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305.50 1724Q1331 1782 1374.50 1825.50Q1418 1869 1476 1894.50Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var Italic = {
   name: "Italic",
   vendor: "UiFabric",
   unicode: 59611,
   value: "",
   charCode: "E8DB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1696 128L1568 256L1351 256L882 1664L1248 1664L1120 1792L416 1792L544 1664L705 1664L1174 256L864 256L992 128L1696 128Z"
         }
      }
   ]
}

var Underline = {
   name: "Underline",
   vendor: "UiFabric",
   unicode: 59612,
   value: "",
   charCode: "E8DC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1011 1792L1011 1792Q850 1792 737 1745.50Q624 1699 552.50 1612.50Q481 1526 448 1403.50Q415 1281 415 1129L415 1129L415 128L607 128L607 1116Q607 1225 628.50 1317Q650 1409 699.50 1476.50Q749 1544 830 1582Q911 1620 1031 1620L1031 1620Q1146 1620 1224.50 1583.50Q1303 1547 1351 1482.50Q1399 1418 1420 1328.50Q1441 1239 1441 1134L1441 1134L1441 128L1633 128L1633 1103Q1633 1261 1598.50 1388.50Q1564 1516 1489.50 1605.50Q1415 1695 1297 1743.50Q1179 1792 1011 1792ZM384 2048L384 1920L1664 1920L1664 2048L384 2048Z"
         }
      }
   ]
}

var Bold = {
   name: "Bold",
   vendor: "UiFabric",
   unicode: 59613,
   value: "",
   charCode: "E8DD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1255 901L1255 901Q1347 901 1428.50 936Q1510 971 1570.50 1031.50Q1631 1092 1666 1173Q1701 1254 1701 1346L1701 1346Q1701 1438 1666 1519.50Q1631 1601 1570.50 1661.50Q1510 1722 1428.50 1757Q1347 1792 1255 1792L1255 1792L512 1792L512 128L1255 128Q1335 128 1405 158.50Q1475 189 1527.50 241.50Q1580 294 1610.50 364Q1641 434 1641 514L1641 514Q1641 594 1611 664.50Q1581 735 1528.50 787.50Q1476 840 1405.50 870.50Q1335 901 1255 901ZM1047 366L1047 366L896 366L896 841L1047 841Q1096 841 1139.50 822Q1183 803 1215 771Q1247 739 1266 695.50Q1285 652 1285 603L1285 603Q1285 554 1266 511Q1247 468 1215 435.50Q1183 403 1139.50 384.50Q1096 366 1047 366ZM896 1554L1106 1554Q1155 1554 1198.50 1535.50Q1242 1517 1274 1484.50Q1306 1452 1325 1409Q1344 1366 1344 1317L1344 1317Q1344 1268 1325.50 1224.50Q1307 1181 1274.50 1148.50Q1242 1116 1198.50 1097.50Q1155 1079 1106 1079L1106 1079L896 1079L896 1554Z"
         }
      }
   ]
}

var MoveToFolder = {
   name: "MoveToFolder",
   vendor: "UiFabric",
   unicode: 59614,
   value: "",
   charCode: "E8DE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 896L1792 1120Q1792 1151 1801.50 1174.50Q1811 1198 1825 1218.50Q1839 1239 1856 1259Q1873 1279 1887 1304.50Q1901 1330 1910.50 1362.50Q1920 1395 1920 1440L1920 1440L1920 1920Q1920 1947 1910 1970Q1900 1993 1882.50 2010.50Q1865 2028 1842 2038Q1819 2048 1792 2048L1792 2048L256 2048L256 0L1664 0Q1691 0 1714 10Q1737 20 1754.50 37.50Q1772 55 1782 78Q1792 101 1792 128L1792 128L1792 512L1664 512L1664 128L384 128L384 1920L1536 1920L1536 1440Q1536 1395 1545.50 1362.50Q1555 1330 1569 1304.50Q1583 1279 1600 1259Q1617 1239 1631 1218.50Q1645 1198 1654.50 1174.50Q1664 1151 1664 1120L1664 1120L1664 896L1792 896ZM1792 1920L1792 1440Q1792 1416 1787.50 1398Q1783 1380 1774.50 1365Q1766 1350 1754.50 1335.50Q1743 1321 1728 1304L1728 1304Q1713 1321 1701.50 1335.50Q1690 1350 1681.50 1365Q1673 1380 1668.50 1398Q1664 1416 1664 1440L1664 1440L1664 1920L1792 1920ZM1371 640L2048 640L2048 768L1371 768L1533 931L1443 1021L1126 704L1443 387L1533 477L1371 640Z"
         }
      }
   ]
}

var Dislike = {
   name: "Dislike",
   vendor: "UiFabric",
   unicode: 59616,
   value: "",
   charCode: "E8E0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 256L960 256Q1138 256 1305 325L1305 325Q1377 354 1449.50 369Q1522 384 1600 384L1600 384L2048 384L2048 1280L1631 1280Q1566 1280 1508.50 1304Q1451 1328 1405 1374L1405 1374L783 1995Q758 2020 733 2034Q708 2048 672 2048L672 2048Q639 2048 610 2035.50Q581 2023 559 2001Q537 1979 524.50 1950Q512 1921 512 1888L512 1888Q512 1807 530 1733.50Q548 1660 583 1588L583 1588Q603 1545 617 1500.50Q631 1456 636 1408L636 1408L192 1408Q153 1408 118 1393Q83 1378 56.50 1352Q30 1326 15 1291Q0 1256 0 1216L0 1216Q0 1184 10 1155L10 1155L266 387Q286 328 336 292Q386 256 448 256L448 256ZM1920 1152L1920 512L1600 512Q1421 512 1255 443L1255 443Q1111 384 960 384L960 384L448 384Q428 384 411 396Q394 408 387 428L387 428Q382 442 368.50 482Q355 522 336 578.50Q317 635 294 702.50Q271 770 248 839Q225 908 203.50 973.50Q182 1039 165 1091.50Q148 1144 138 1177.50Q128 1211 128 1216L128 1216Q128 1242 147 1261Q166 1280 192 1280L192 1280L768 1280Q768 1333 765.50 1378.50Q763 1424 755.50 1467Q748 1510 734 1553Q720 1596 697 1644L697 1644Q669 1702 654.50 1762.50Q640 1823 640 1888L640 1888Q640 1902 649 1911Q658 1920 672 1920L672 1920Q678 1920 682.50 1915.50Q687 1911 691 1907L691 1907L1314 1283Q1346 1251 1382.50 1227Q1419 1203 1460 1186L1460 1186Q1540 1152 1631 1152L1631 1152L1920 1152Z"
         }
      }
   ]
}

var Like = {
   name: "Like",
   vendor: "UiFabric",
   unicode: 59617,
   value: "",
   charCode: "E8E1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1412 640L1856 640Q1895 640 1930 655Q1965 670 1991.50 696Q2018 722 2033 757Q2048 792 2048 832L2048 832Q2048 864 2038 893L2038 893L1782 1661Q1772 1690 1754 1714.50Q1736 1739 1712 1756Q1688 1773 1659.50 1782.50Q1631 1792 1600 1792L1600 1792L1088 1792Q909 1792 743 1723L743 1723Q671 1694 598.50 1679Q526 1664 448 1664L448 1664L0 1664L0 768L417 768Q482 768 539.50 744Q597 720 643 674L643 674L1265 53Q1290 28 1315 14Q1340 0 1376 0L1376 0Q1409 0 1438 12.50Q1467 25 1489 47Q1511 69 1523.50 98Q1536 127 1536 160L1536 160Q1536 241 1518 314.50Q1500 388 1465 460L1465 460Q1445 503 1431 547.50Q1417 592 1412 640L1412 640ZM1088 1664L1600 1664Q1620 1664 1637 1652Q1654 1640 1661 1620L1661 1620Q1666 1606 1679.50 1566Q1693 1526 1712 1469.50Q1731 1413 1754 1345.50Q1777 1278 1800 1209Q1823 1140 1844.50 1074.50Q1866 1009 1883 956.50Q1900 904 1910 870.50Q1920 837 1920 832L1920 832Q1920 806 1901 787Q1882 768 1856 768L1856 768L1280 768Q1280 715 1282.50 669.50Q1285 624 1292.50 581Q1300 538 1314 495Q1328 452 1351 404L1351 404Q1379 346 1393.50 285.50Q1408 225 1408 160L1408 160Q1408 146 1399 137Q1390 128 1376 128L1376 128Q1370 128 1365.50 132.50Q1361 137 1357 141L1357 141L734 765Q702 797 665.50 821Q629 845 588 862L588 862Q508 896 417 896L417 896L128 896L128 1536L448 1536Q626 1536 793 1605L793 1605Q937 1664 1088 1664L1088 1664Z"
         }
      }
   ]
}

var AlignRight = {
   name: "AlignRight",
   vendor: "UiFabric",
   unicode: 59618,
   value: "",
   charCode: "E8E2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L0 128L2048 128L2048 256L0 256ZM2048 1792L0 1792L0 1664L2048 1664L2048 1792ZM2048 1024L0 1024L0 896L2048 896L2048 1024ZM2048 640L512 640L512 512L2048 512L2048 640ZM2048 1408L512 1408L512 1280L2048 1280L2048 1408Z"
         }
      }
   ]
}

var AlignCenter = {
   name: "AlignCenter",
   vendor: "UiFabric",
   unicode: 59619,
   value: "",
   charCode: "E8E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L0 128L2048 128L2048 256L0 256ZM256 640L256 512L1792 512L1792 640L256 640ZM256 1408L256 1280L1792 1280L1792 1408L256 1408ZM2048 1792L0 1792L0 1664L2048 1664L2048 1792ZM2048 1024L0 1024L0 896L2048 896L2048 1024Z"
         }
      }
   ]
}

var AlignLeft = {
   name: "AlignLeft",
   vendor: "UiFabric",
   unicode: 59620,
   value: "",
   charCode: "E8E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 256L0 256L0 128ZM2048 1664L2048 1792L0 1792L0 1664L2048 1664ZM2048 896L2048 1024L0 1024L0 896L2048 896ZM1536 512L1536 640L0 640L0 512L1536 512ZM1536 1280L1536 1408L0 1408L0 1280L1536 1280Z"
         }
      }
   ]
}

var OpenFile = {
   name: "OpenFile",
   vendor: "UiFabric",
   unicode: 59621,
   value: "",
   charCode: "E8E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2045 1443L1955 1533L1792 1371L1792 2048L1664 2048L1664 1371L1501 1533L1411 1443L1728 1126L2045 1443ZM256 128L256 1920L1536 1920L1536 2048L128 2048L128 0L1243 0L1792 549L1792 1024L1664 1024L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var ClearSelection = {
   name: "ClearSelection",
   vendor: "UiFabric",
   unicode: 59622,
   value: "",
   charCode: "E8E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1713 896L1713 896Q1782 896 1843 922.50Q1904 949 1949.50 994.50Q1995 1040 2021.50 1101.50Q2048 1163 2048 1232L2048 1232Q2048 1298 2023 1359.50Q1998 1421 1950 1469L1950 1469L1501 1917L1411 1827L1859 1378Q1888 1349 1904 1311Q1920 1273 1920 1232L1920 1232Q1920 1189 1903.50 1151.50Q1887 1114 1858.50 1085.50Q1830 1057 1792.50 1040.50Q1755 1024 1712 1024L1712 1024Q1671 1024 1633 1040Q1595 1056 1566 1085L1566 1085L1371 1280L1536 1280L1536 1408L1152 1408L1152 1024L1280 1024L1280 1189Q1327 1142 1373 1090Q1419 1038 1470.50 995Q1522 952 1581 924Q1640 896 1713 896ZM1792 640L1792 768L1664 768L1664 640L1792 640ZM1792 384L1792 512L1664 512L1664 384L1792 384ZM1792 128L1792 256L1664 256L1664 128L1792 128ZM1536 128L1536 256L1408 256L1408 128L1536 128ZM1280 128L1280 256L1152 256L1152 128L1280 128ZM896 256L896 128L1024 128L1024 256L896 256ZM640 256L640 128L768 128L768 256L640 256ZM384 256L384 128L512 128L512 256L384 256ZM128 256L128 128L256 128L256 256L128 256ZM128 512L128 384L256 384L256 512L128 512ZM128 768L128 640L256 640L256 768L128 768ZM128 1024L128 896L256 896L256 1024L128 1024ZM128 1280L128 1152L256 1152L256 1280L128 1280ZM128 1536L128 1408L256 1408L256 1536L128 1536ZM128 1792L128 1664L256 1664L256 1792L128 1792ZM384 1792L384 1664L512 1664L512 1792L384 1792ZM640 1792L640 1664L768 1664L768 1792L640 1792ZM896 1792L896 1664L1024 1664L1024 1792L896 1792ZM1152 1792L1152 1664L1280 1664L1280 1792L1152 1792Z"
         }
      }
   ]
}

var FontDecrease = {
   name: "FontDecrease",
   vendor: "UiFabric",
   unicode: 59623,
   value: "",
   charCode: "E8E7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M893 768L1027 768L1369 1792L1234 1792L1149 1536L771 1536L686 1792L551 1792L893 768ZM814 1408L1106 1408L960 971L814 1408ZM1408 0L2048 0L1728 320L1408 0Z"
         }
      }
   ]
}

var FontIncrease = {
   name: "FontIncrease",
   vendor: "UiFabric",
   unicode: 59624,
   value: "",
   charCode: "E8E8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M893 128L1027 128L1582 1792L1447 1792L1277 1280L643 1280L473 1792L338 1792L893 128ZM686 1152L1234 1152L960 330L686 1152ZM1728 64L2048 384L1408 384L1728 64Z"
         }
      }
   ]
}

var FontSize = {
   name: "FontSize",
   vendor: "UiFabric",
   unicode: 59625,
   value: "",
   charCode: "E8E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1411 128L1966 1792L1831 1792L1661 1280L1027 1280L857 1792L722 1792L637 1536L259 1536L174 1792L39 1792L381 768L515 768L789 1589L1277 128L1411 128ZM302 1408L594 1408L448 971L302 1408ZM1070 1152L1618 1152L1344 331L1070 1152Z"
         }
      }
   ]
}

var CellPhone = {
   name: "CellPhone",
   vendor: "UiFabric",
   unicode: 59626,
   value: "",
   charCode: "E8EA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1536 0Q1563 0 1586 10Q1609 20 1626.50 37.50Q1644 55 1654 78Q1664 101 1664 128L1664 128L1664 1920Q1664 1947 1654 1970Q1644 1993 1626.50 2010.50Q1609 2028 1586 2038Q1563 2048 1536 2048L1536 2048L512 2048Q485 2048 462 2038Q439 2028 421.50 2010.50Q404 1993 394 1970Q384 1947 384 1920L384 1920L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0ZM1536 1920L1536 128L512 128L512 1920L1536 1920ZM896 1792L896 1664L1152 1664L1152 1792L896 1792Z"
         }
      }
   ]
}

var Tag = {
   name: "Tag",
   vendor: "UiFabric",
   unicode: 59628,
   value: "",
   charCode: "E8EC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 576L1472 576Q1445 576 1422 566Q1399 556 1381.50 538.50Q1364 521 1354 498Q1344 475 1344 448L1344 448Q1344 421 1354 398Q1364 375 1381.50 357.50Q1399 340 1422 330Q1445 320 1472 320L1472 320Q1499 320 1522 330Q1545 340 1562.50 357.50Q1580 375 1590 398Q1600 421 1600 448L1600 448Q1600 475 1590 498Q1580 521 1562.50 538.50Q1545 556 1522 566Q1499 576 1472 576ZM0 1024L1024 0L1920 0L1920 896L896 1920L0 1024ZM896 1739L1792 843L1792 128L1077 128L181 1024L896 1739Z"
         }
      }
   ]
}

var Calculator = {
   name: "Calculator",
   vendor: "UiFabric",
   unicode: 59631,
   value: "",
   charCode: "E8EF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 2048L256 0L1664 0L1664 2048L256 2048ZM384 1920L1536 1920L1536 128L384 128L384 1920ZM512 256L1408 256L1408 640L512 640L512 256ZM640 512L1280 512L1280 384L640 384L640 512ZM512 896L640 896L640 1024L512 1024L512 896ZM1024 1024L896 1024L896 896L1024 896L1024 1024ZM1408 1024L1280 1024L1280 896L1408 896L1408 1024ZM512 1280L640 1280L640 1408L512 1408L512 1280ZM1024 1408L896 1408L896 1280L1024 1280L1024 1408ZM1408 1408L1280 1408L1280 1280L1408 1280L1408 1408ZM512 1664L640 1664L640 1792L512 1792L512 1664ZM1024 1792L896 1792L896 1664L1024 1664L1024 1792ZM1408 1792L1280 1792L1280 1664L1408 1664L1408 1792Z"
         }
      }
   ]
}

var Library = {
   name: "Library",
   vendor: "UiFabric",
   unicode: 59633,
   value: "",
   charCode: "E8F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1792L640 1792L640 256L1024 256L1024 1792ZM896 384L768 384L768 1664L896 1664L896 384ZM512 1792L128 1792L128 256L512 256L512 1792ZM384 384L256 384L256 1664L384 1664L384 384ZM1145 349L1491 233L1975 1683L1629 1799L1145 349ZM1420 375L1287 419L1699 1657L1833 1613L1420 375Z"
         }
      }
   ]
}

var PostUpdate = {
   name: "PostUpdate",
   vendor: "UiFabric",
   unicode: 59635,
   value: "",
   charCode: "E8F3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1536L640 384L2048 384L2048 1536L640 1536ZM768 1408L1920 1408L1920 512L768 512L768 1408ZM512 1024L128 1024L128 896L512 896L512 1024ZM512 768L0 768L0 640L512 640L512 768ZM512 1280L256 1280L256 1152L512 1152L512 1280ZM896 640L1792 640L1792 768L896 768L896 640ZM1792 1280L1408 1280L1408 896L1792 896L1792 1280ZM1664 1024L1536 1024L1536 1152L1664 1152L1664 1024ZM896 1152L1280 1152L1280 1280L896 1280L896 1152ZM896 896L1280 896L1280 1024L896 1024L896 896Z"
         }
      }
   ]
}

var NewFolder = {
   name: "NewFolder",
   vendor: "UiFabric",
   unicode: 59636,
   value: "",
   charCode: "E8F4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L1792 0Q1819 0 1842 10Q1865 20 1882.50 37.50Q1900 55 1910 78Q1920 101 1920 128L1920 128L1920 1120Q1920 1151 1929.50 1174.50Q1939 1198 1953 1218.50Q1967 1239 1984 1259Q2001 1279 2015 1304.50Q2029 1330 2038.50 1362.50Q2048 1395 2048 1440L2048 1440L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L768 2048L768 1920L1664 1920L1664 1440Q1664 1395 1673.50 1362.50Q1683 1330 1697 1304.50Q1711 1279 1728 1259Q1745 1239 1759 1218.50Q1773 1198 1782.50 1174.50Q1792 1151 1792 1120L1792 1120L1792 128L512 128L512 896L384 896L384 0ZM1920 1920L1920 1440Q1920 1416 1915.50 1398Q1911 1380 1902.50 1365Q1894 1350 1882.50 1335.50Q1871 1321 1856 1304L1856 1304Q1841 1321 1829.50 1335.50Q1818 1350 1809.50 1365Q1801 1380 1796.50 1398Q1792 1416 1792 1440L1792 1440L1792 1920L1920 1920ZM896 1536L896 1664L512 1664L512 2048L384 2048L384 1664L0 1664L0 1536L384 1536L384 1152L512 1152L512 1536L896 1536Z"
         }
      }
   ]
}

var CalendarReply = {
   name: "CalendarReply",
   vendor: "UiFabric",
   unicode: 59637,
   value: "",
   charCode: "E8F5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 768L896 896L768 896L768 768L896 768ZM1280 768L1280 896L1152 896L1152 768L1280 768ZM896 1024L896 1152L768 1152L768 1024L896 1024ZM512 1024L512 1152L384 1152L384 1024L512 1024ZM1152 1152L1152 1024L1280 1024L1280 1152L1152 1152ZM1664 768L1664 896L1536 896L1536 768L1664 768ZM1536 1152L1536 1024L1664 1024L1664 1152L1536 1152ZM1152 1408L1152 1280L1280 1280L1280 1408L1152 1408ZM896 1280L896 1408L768 1408L768 1280L896 1280ZM512 1280L512 1408L384 1408L384 1280L512 1280ZM768 1664L768 1536L896 1536L896 1664L768 1664ZM384 1664L384 1536L512 1536L512 1664L384 1664ZM1664 128L2048 128L2048 1508Q2020 1482 1987.50 1463.50Q1955 1445 1920 1432L1920 1432L1920 640L128 640L128 1792L1248 1792L1376 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512ZM1661 1373L1499 1536Q1549 1536 1609.50 1533.50Q1670 1531 1731 1534Q1792 1537 1849 1548.50Q1906 1560 1950.50 1588.50Q1995 1617 2021.50 1666Q2048 1715 2048 1792L2048 1792Q2048 1845 2027.50 1891.50Q2007 1938 1972.50 1972.50Q1938 2007 1891 2027.50Q1844 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373Z"
         }
      }
   ]
}

var UnsyncFolder = {
   name: "UnsyncFolder",
   vendor: "UiFabric",
   unicode: 59638,
   value: "",
   charCode: "E8F6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1664 0Q1691 0 1714 10Q1737 20 1754.50 37.50Q1772 55 1782 78Q1792 101 1792 128L1792 128L1792 1120Q1792 1151 1801.50 1174.50Q1811 1198 1825 1218.50Q1839 1239 1856 1259Q1873 1279 1887 1304.50Q1901 1330 1910.50 1362.50Q1920 1395 1920 1440L1920 1440L1920 1920Q1920 1947 1910 1970Q1900 1993 1882.50 2010.50Q1865 2028 1842 2038Q1819 2048 1792 2048L1792 2048L960 2048L1088 1920L1536 1920L1536 1440Q1536 1395 1545.50 1362.50Q1555 1330 1569 1304.50Q1583 1279 1600 1259Q1617 1239 1631 1218.50Q1645 1198 1654.50 1174.50Q1664 1151 1664 1120L1664 1120L1664 128L384 128L384 998Q352 1002 319.50 1008.50Q287 1015 256 1026L256 1026L256 0ZM1792 1920L1792 1440Q1792 1416 1787.50 1398Q1783 1380 1774.50 1365Q1766 1350 1754.50 1335.50Q1743 1321 1728 1304L1728 1304Q1713 1321 1701.50 1335.50Q1690 1350 1681.50 1365Q1673 1380 1668.50 1398Q1664 1416 1664 1440L1664 1440L1664 1920L1792 1920ZM768 1289L768 1152L896 1152L896 1536L512 1536L512 1408L702 1408Q657 1348 590 1314Q523 1280 448 1280L448 1280Q401 1280 356 1293.50Q311 1307 272 1333L272 1333L715 1776Q751 1720 762 1653L762 1653L889 1675Q880 1728 859 1776.50Q838 1825 806 1868L806 1868L893 1955L803 2045L716 1959Q658 2002 589 2025Q520 2048 448 2048L448 2048Q357 2048 274 2012.50Q191 1977 128 1911L128 1911L128 2048L0 2048L0 1664L384 1664L384 1792L194 1792Q239 1852 306 1886Q373 1920 448 1920L448 1920Q495 1920 540 1906.50Q585 1893 624 1867L624 1867L181 1424Q145 1480 134 1547L134 1547L7 1525Q16 1472 37 1423.50Q58 1375 90 1332L90 1332L3 1245L93 1155L180 1241Q238 1198 307 1175Q376 1152 448 1152L448 1152Q539 1152 622 1187.50Q705 1223 768 1289L768 1289Z"
         }
      }
   ]
}

var SyncFolder = {
   name: "SyncFolder",
   vendor: "UiFabric",
   unicode: 59639,
   value: "",
   charCode: "E8F7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1664 0Q1691 0 1714 10Q1737 20 1754.50 37.50Q1772 55 1782 78Q1792 101 1792 128L1792 128L1792 1120Q1792 1151 1801.50 1174.50Q1811 1198 1825 1218.50Q1839 1239 1856 1259Q1873 1279 1887 1304.50Q1901 1330 1910.50 1362.50Q1920 1395 1920 1440L1920 1440L1920 1920Q1920 1947 1910 1970Q1900 1993 1882.50 2010.50Q1865 2028 1842 2038Q1819 2048 1792 2048L1792 2048L856 2048Q918 1991 963 1920L963 1920L1536 1920L1536 1440Q1536 1395 1545.50 1362.50Q1555 1330 1569 1304.50Q1583 1279 1600 1259Q1617 1239 1631 1218.50Q1645 1198 1654.50 1174.50Q1664 1151 1664 1120L1664 1120L1664 128L384 128L384 998Q352 1002 319.50 1008.50Q287 1015 256 1026L256 1026L256 0ZM1792 1920L1792 1440Q1792 1416 1787.50 1398Q1783 1380 1774.50 1365Q1766 1350 1754.50 1335.50Q1743 1321 1728 1304L1728 1304Q1713 1321 1701.50 1335.50Q1690 1350 1681.50 1365Q1673 1380 1668.50 1398Q1664 1416 1664 1440L1664 1440L1664 1920L1792 1920ZM448 1280L448 1280Q389 1280 336.50 1300Q284 1320 242 1355.50Q200 1391 172 1440Q144 1489 134 1547L134 1547L7 1525Q21 1444 61 1376Q101 1308 159.50 1258Q218 1208 292 1180Q366 1152 448 1152L448 1152Q539 1152 622 1187.50Q705 1223 768 1289L768 1289L768 1152L896 1152L896 1536L512 1536L512 1408L702 1408Q657 1348 590 1314Q523 1280 448 1280ZM762 1653L889 1675Q875 1756 835 1824Q795 1892 736.50 1942Q678 1992 604 2020Q530 2048 448 2048L448 2048Q357 2048 274 2012.50Q191 1977 128 1911L128 1911L128 2048L0 2048L0 1664L384 1664L384 1792L194 1792Q239 1852 306 1886Q373 1920 448 1920L448 1920Q506 1920 559 1900Q612 1880 654 1844.50Q696 1809 724 1760Q752 1711 762 1653L762 1653Z"
         }
      }
   ]
}

var BlockContact = {
   name: "BlockContact",
   vendor: "UiFabric",
   unicode: 59640,
   value: "",
   charCode: "E8F8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1301 1110L1301 1110Q1274 1127 1248.50 1145.50Q1223 1164 1200 1187L1200 1187Q1111 1107 999.50 1065.50Q888 1024 768 1024L768 1024Q634 1024 517 1073.50Q400 1123 313.50 1209.50Q227 1296 177.50 1413Q128 1530 128 1664L128 1664L0 1664Q0 1544 35 1432Q70 1320 135 1225.50Q200 1131 291.50 1059Q383 987 497 945L497 945Q442 910 397.50 862.50Q353 815 321.50 759Q290 703 273 640.50Q256 578 256 512L256 512Q256 406 296.50 313Q337 220 406.50 150.50Q476 81 569 40.50Q662 0 768 0L768 0Q874 0 967 40.50Q1060 81 1129.50 150.50Q1199 220 1239.50 313Q1280 406 1280 512L1280 512Q1280 578 1263 640.50Q1246 703 1214.50 759Q1183 815 1138.50 862.50Q1094 910 1039 945L1039 945Q1113 971 1178.50 1013.50Q1244 1056 1301 1110ZM384 512L384 512Q384 591 414.50 661Q445 731 497 783Q549 835 619 865.50Q689 896 768 896L768 896Q847 896 917 865.50Q987 835 1039 783Q1091 731 1121.50 661Q1152 591 1152 512L1152 512Q1152 433 1121.50 363Q1091 293 1039 241Q987 189 917 158.50Q847 128 768 128L768 128Q689 128 619 158.50Q549 189 497 241Q445 293 414.50 363Q384 433 384 512ZM1600 1152L1600 1152Q1693 1152 1774.50 1187.50Q1856 1223 1916.50 1283.50Q1977 1344 2012.50 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2012.50 1774.50Q1977 1856 1916.50 1916.50Q1856 1977 1774.50 2012.50Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2012.50Q1344 1977 1283.50 1916.50Q1223 1856 1187.50 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187.50 1425.50Q1223 1344 1283.50 1283.50Q1344 1223 1425.50 1187.50Q1507 1152 1600 1152ZM1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600L1280 1600Q1280 1666 1305.50 1724Q1331 1782 1374.50 1825.50Q1418 1869 1476 1894.50Q1534 1920 1600 1920ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var AddFriend = {
   name: "AddFriend",
   vendor: "UiFabric",
   unicode: 59642,
   value: "",
   charCode: "E8FA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1240L1536 1536L1523 1536Q1500 1424 1442 1330Q1384 1236 1300.50 1168Q1217 1100 1113.50 1062Q1010 1024 896 1024L896 1024Q808 1024 726 1047Q644 1070 573 1111.50Q502 1153 443.50 1211.50Q385 1270 343.50 1341Q302 1412 279 1494Q256 1576 256 1664L256 1664L128 1664Q128 1544 163.50 1433Q199 1322 264 1228Q329 1134 420.50 1061Q512 988 624 946L624 946Q511 872 447.50 760Q384 648 384 512L384 512Q384 406 424 312.50Q464 219 533.50 149.50Q603 80 696.50 40Q790 0 896 0L896 0Q1002 0 1095.50 40Q1189 80 1258.50 149.50Q1328 219 1368 312.50Q1408 406 1408 512L1408 512Q1408 578 1391.50 641Q1375 704 1344 760Q1313 816 1268.50 863.50Q1224 911 1168 946L1168 946Q1280 989 1374.50 1064.50Q1469 1140 1536 1240L1536 1240ZM512 512L512 512Q512 592 542 661.50Q572 731 624.50 783.50Q677 836 746.50 866Q816 896 896 896L896 896Q975 896 1045 866Q1115 836 1167.50 783.50Q1220 731 1250 661.50Q1280 592 1280 512L1280 512Q1280 433 1250 363Q1220 293 1167.50 240.50Q1115 188 1045 158Q975 128 896 128L896 128Q816 128 746.50 158Q677 188 624.50 240.50Q572 293 542 363Q512 433 512 512ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408Z"
         }
      }
   ]
}

var Accept = {
   name: "Accept",
   vendor: "UiFabric",
   unicode: 59643,
   value: "",
   charCode: "E8FB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1755L640 1755L19 1133L109 1043L640 1573L1939 275L2029 365L640 1755Z"
         }
      }
   ]
}

var BulletedList = {
   name: "BulletedList",
   vendor: "UiFabric",
   unicode: 59645,
   value: "",
   charCode: "E8FD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1280L0 1280L0 1152L128 1152L128 1280ZM128 896L0 896L0 768L128 768L128 896ZM2048 896L384 896L384 768L2048 768L2048 896ZM128 512L0 512L0 384L128 384L128 512ZM384 512L384 384L2048 384L2048 512L384 512ZM2048 1280L384 1280L384 1152L2048 1152L2048 1280ZM128 1664L0 1664L0 1536L128 1536L128 1664ZM2048 1664L384 1664L384 1536L2048 1536L2048 1664Z"
         }
      }
   ]
}

var Preview = {
   name: "Preview",
   vendor: "UiFabric",
   unicode: 59647,
   value: "",
   charCode: "E8FF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1115 0L1664 549L1664 640L1024 640L1024 0ZM1152 219L1152 512L1445 512L1152 219ZM1664 896L1536 896L1536 768L1664 768L1664 896ZM1664 1152L1536 1152L1536 1024L1664 1024L1664 1152ZM1664 1408L1536 1408L1536 1280L1664 1280L1664 1408ZM1664 1664L1536 1664L1536 1536L1664 1536L1664 1664ZM1664 1920L1536 1920L1536 1792L1664 1792L1664 1920ZM1408 1920L1280 1920L1280 1792L1408 1792L1408 1920ZM1152 1920L1024 1920L1024 1792L1152 1792L1152 1920ZM896 1920L768 1920L768 1792L896 1792L896 1920ZM640 1920L512 1920L512 1792L640 1792L640 1920ZM384 1920L256 1920L256 1792L384 1792L384 1920ZM384 896L256 896L256 768L384 768L384 896ZM384 640L256 640L256 512L384 512L384 640ZM384 384L256 384L256 256L384 256L384 384ZM384 128L256 128L256 0L384 0L384 128ZM640 128L512 128L512 0L640 0L640 128ZM896 128L768 128L768 0L896 0L896 128ZM384 1152L256 1152L256 1024L384 1024L384 1152ZM384 1408L256 1408L256 1280L384 1280L384 1408ZM384 1664L256 1664L256 1536L384 1536L384 1664Z"
         }
      }
   ]
}

var World = {
   name: "World",
   vendor: "UiFabric",
   unicode: 59657,
   value: "",
   charCode: "E909",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M496 883L496 883Q509 883 525 887.50Q541 892 557.50 898Q574 904 589.50 911Q605 918 618 923L618 923Q610 924 601.50 925Q593 926 585 926L585 926Q568 926 554 920.50Q540 915 527.50 908Q515 901 503.50 895.50Q492 890 482 890L482 890Q472 890 464 894Q456 898 448 903L448 903Q448 899 441 899L441 899Q448 892 467 887.50Q486 883 496 883ZM631 928L631 928Q672 928 706 942L706 942Q692 947 678 950.50Q664 954 649 954L649 954Q629 954 613 950L613 950Q618 942 623 939.50Q628 937 631 928ZM1024 0L1024 0Q1165 0 1295.50 37Q1426 74 1539.50 140.50Q1653 207 1747 301Q1841 395 1907.50 508.50Q1974 622 2011 752.50Q2048 883 2048 1024L2048 1024Q2048 1165 2011 1295.50Q1974 1426 1907.50 1539.50Q1841 1653 1747 1747Q1653 1841 1539.50 1907.50Q1426 1974 1295.50 2011Q1165 2048 1024 2048L1024 2048Q883 2048 752.50 2011Q622 1974 508.50 1907.50Q395 1841 301 1747Q207 1653 140.50 1539.50Q74 1426 37 1295.50Q0 1165 0 1024L0 1024Q0 883 37 752.50Q74 622 140.50 508.50Q207 395 301 301Q395 207 508.50 140.50Q622 74 752.50 37Q883 0 1024 0ZM1786 555L1786 555Q1772 533 1758 512.50Q1744 492 1729 472L1729 472Q1727 481 1723.50 485Q1720 489 1720 503L1720 503Q1720 512 1727.50 520.50Q1735 529 1745.50 536Q1756 543 1767 548Q1778 553 1786 555ZM1726 469L1717 457Q1717 465 1714 468L1714 468L1720 468Q1724 468 1726 469L1726 469ZM1024 1920L1024 1920Q1138 1920 1247 1891Q1356 1862 1453.50 1808.50Q1551 1755 1633.50 1678.50Q1716 1602 1778 1507L1778 1507Q1765 1477 1753 1446Q1741 1415 1741 1382L1741 1382Q1741 1346 1744.50 1323.50Q1748 1301 1751 1285Q1754 1269 1755.50 1255.50Q1757 1242 1752 1225Q1747 1208 1734.50 1184Q1722 1160 1698 1122L1698 1122Q1699 1115 1701.50 1103Q1704 1091 1705 1078Q1706 1065 1705.50 1053.50Q1705 1042 1701 1035L1701 1035Q1675 1032 1646.50 1024Q1618 1016 1597 1000L1597 1000L1603 995Q1590 998 1577 1003.50Q1564 1009 1551.50 1014Q1539 1019 1526 1022.50Q1513 1026 1499 1026L1499 1026L1483 1024L1486 1017Q1472 1021 1455.50 1027Q1439 1033 1425 1033L1425 1033Q1415 1033 1396 1026Q1377 1019 1357.50 1009Q1338 999 1323.50 987Q1309 975 1309 964L1309 964L1311 961Q1306 955 1298 950Q1290 945 1282.50 940Q1275 935 1270 929Q1265 923 1265 915L1265 915L1276 906L1253 903L1245 873Q1247 878 1254.50 877Q1262 876 1265 873L1265 873L1229 854L1254 790Q1240 738 1247.50 710Q1255 682 1274 663.50Q1293 645 1318.50 627.50Q1344 610 1367 579L1367 579L1364 567L1430 487L1445 485Q1473 485 1508 482.50Q1543 480 1579 475.50Q1615 471 1650 465.50Q1685 460 1714 453L1714 453Q1682 415 1646.50 381Q1611 347 1572 316L1572 316Q1561 320 1544.50 327.50Q1528 335 1513 345.50Q1498 356 1487.50 369Q1477 382 1477 396L1477 396L1483 415Q1465 444 1443 451.50Q1421 459 1397.50 459.50Q1374 460 1349.50 459Q1325 458 1302 468L1302 468L1286 434L1301 376L1284 351L1457 297Q1446 269 1420.50 255Q1395 241 1366 241L1366 241L1366 231L1422 222Q1329 176 1228.50 152Q1128 128 1024 128L1024 128Q937 128 852 145Q767 162 687.50 194.50Q608 227 535 274Q462 321 400 382L400 382Q426 382 440.50 395.50Q455 409 466.50 424.50Q478 440 491 453.50Q504 467 526 467L526 467L542 455L540 433L573 386L547 312Q552 309 562.50 302Q573 295 579 295L579 295Q609 295 625.50 298Q642 301 653 309.50Q664 318 674 332.50Q684 347 702 370L702 370L738 342Q748 346 770.50 355.50Q793 365 815 377.50Q837 390 854 404Q871 418 871 430L871 430Q871 445 859.50 454Q848 463 831 469Q814 475 793.50 478.50Q773 482 756 486Q739 490 727 496.50Q715 503 715 513L715 513L773 532Q753 549 729.50 563.50Q706 578 682 589L682 589L686 606L594 642L594 670L587 673L592 638L588 637Q581 637 579.50 640Q578 643 579 647Q580 651 581.50 655Q583 659 582 661L582 661L569 654L571 658Q571 661 574.50 667Q578 673 582.50 678.50Q587 684 590.50 688.50Q594 693 594 693L594 693Q594 696 589.50 699Q585 702 580 703.50Q575 705 572 706Q569 707 572 707L572 707Q586 707 577.50 709Q569 711 553 719Q537 727 521.50 742.50Q506 758 506 786L506 786Q506 803 507.50 819Q509 835 506 852L506 852Q492 814 464 794Q436 774 396 774L396 774L353 778L374 792Q357 790 338.50 788Q320 786 302 787.50Q284 789 267.50 795.50Q251 802 238 816L238 816L232 861Q232 893 246.50 913.50Q261 934 295 934L295 934Q325 934 354 924.50Q383 915 411 904L411 904Q402 926 391 946.50Q380 967 375 990L375 990L388 996Q412 980 432 991Q452 1002 471 1023Q490 1044 510 1066.50Q530 1089 553 1098L553 1098L519 1116L439 1071Q440 1073 441.50 1080Q443 1087 440 1083L440 1083L404 1022Q372 1021 335.50 1011.50Q299 1002 263 987.50Q227 973 193.50 954.50Q160 936 135 917L135 917L128 1024Q128 1146 161 1262Q194 1378 254.50 1480Q315 1582 401 1666.50Q487 1751 594 1809L594 1809Q589 1788 593 1767Q597 1746 603.50 1725Q610 1704 616.50 1682.50Q623 1661 623 1640L623 1640Q623 1608 613 1572.50Q603 1537 588.50 1501.50Q574 1466 558 1431Q542 1396 530.50 1364.50Q519 1333 515 1306.50Q511 1280 521 1260L521 1260L506 1253Q512 1239 522.50 1226Q533 1213 543 1199.50Q553 1186 560 1172Q567 1158 567 1142L567 1142Q567 1132 562.50 1120.50Q558 1109 556 1100L556 1100L577 1105Q594 1066 623.50 1051.50Q653 1037 696 1037L696 1037Q701 1037 717 1041.50Q733 1046 751 1052Q769 1058 785.50 1063.50Q802 1069 809 1071L809 1071Q809 1078 817.50 1080.50Q826 1083 826 1087L826 1087L824 1095Q827 1096 838.50 1102.50Q850 1109 862.50 1117Q875 1125 885.50 1133Q896 1141 899 1144L899 1144Q917 1144 948.50 1156Q980 1168 1016 1186.50Q1052 1205 1089.50 1229.50Q1127 1254 1157 1279.50Q1187 1305 1206.50 1329.50Q1226 1354 1226 1373L1226 1373L1192 1409Q1196 1460 1184.50 1487.50Q1173 1515 1150.50 1532Q1128 1549 1097.50 1562Q1067 1575 1033 1596L1033 1596Q1033 1616 1023 1639.50Q1013 1663 997.50 1683.50Q982 1704 961.50 1718Q941 1732 920 1732L920 1732L878 1700Q880 1702 877.50 1707.50Q875 1713 873 1709L873 1709Q883 1728 878 1753Q873 1778 861 1804Q849 1830 834 1853.50Q819 1877 807 1892L807 1892Q861 1906 915 1913Q969 1920 1024 1920Z"
         }
      }
   ]
}

var Comment = {
   name: "Comment",
   vendor: "UiFabric",
   unicode: 59658,
   value: "",
   charCode: "E90A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536L0 128ZM1920 1408L1920 256L128 256L128 1408L384 1408L384 1701L677 1408L1920 1408ZM1280 1024L1280 896L1152 896L1152 640L1408 640L1408 896Q1408 923 1398 946Q1388 969 1370.50 986.50Q1353 1004 1330 1014Q1307 1024 1280 1024L1280 1024ZM768 1024L768 896L640 896L640 640L896 640L896 896Q896 923 886 946Q876 969 858.50 986.50Q841 1004 818 1014Q795 1024 768 1024L768 1024Z"
         }
      }
   ]
}

var DockLeft = {
   name: "DockLeft",
   vendor: "UiFabric",
   unicode: 59660,
   value: "",
   charCode: "E90C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM512 512L128 512L128 1408L512 1408L512 512ZM640 1408L1920 1408L1920 512L640 512L640 1408Z"
         }
      }
   ]
}

var DockRight = {
   name: "DockRight",
   vendor: "UiFabric",
   unicode: 59661,
   value: "",
   charCode: "E90D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM1408 512L128 512L128 1408L1408 1408L1408 512ZM1536 1408L1920 1408L1920 512L1536 512L1536 1408Z"
         }
      }
   ]
}

var Repair = {
   name: "Repair",
   vendor: "UiFabric",
   unicode: 59663,
   value: "",
   charCode: "E90F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 614L1930 220Q1956 265 1977.50 306Q1999 347 2015 389Q2031 431 2039.50 476.50Q2048 522 2048 576L2048 576Q2048 655 2027.50 728.50Q2007 802 1969.50 866Q1932 930 1879 983Q1826 1036 1762 1073.50Q1698 1111 1624.50 1131.50Q1551 1152 1472 1152L1472 1152Q1449 1152 1425.50 1150Q1402 1148 1379 1144L1379 1144L573 1950Q525 1998 463.50 2023Q402 2048 335 2048L335 2048Q266 2048 205 2021.50Q144 1995 98.50 1949.50Q53 1904 26.50 1843Q0 1782 0 1713L0 1713Q0 1646 25 1584.50Q50 1523 98 1475L98 1475L904 669Q900 646 898 622.50Q896 599 896 576L896 576Q896 497 916.50 423.50Q937 350 974.50 286Q1012 222 1065 169Q1118 116 1182 78.50Q1246 41 1319.50 20.50Q1393 0 1472 0L1472 0Q1526 0 1571.50 8.50Q1617 17 1659 33Q1701 49 1742 70.50Q1783 92 1828 118L1828 118L1434 512L1536 614ZM1472 1024L1472 1024Q1565 1024 1646.50 988.50Q1728 953 1788.50 892.50Q1849 832 1884.50 750.50Q1920 669 1920 576L1920 576Q1920 503 1896 435L1896 435L1536 794L1254 512L1613 152Q1545 128 1472 128L1472 128Q1379 128 1297.50 163.50Q1216 199 1155.50 259.50Q1095 320 1059.50 401.50Q1024 483 1024 576L1024 576Q1024 611 1030 644Q1036 677 1044 710L1044 710L189 1566Q160 1595 144 1633Q128 1671 128 1713L128 1713Q128 1755 144.50 1793Q161 1831 189 1859Q217 1887 255 1903.50Q293 1920 335 1920L335 1920Q377 1920 415 1904Q453 1888 482 1859L482 1859L1338 1004Q1371 1012 1404 1018Q1437 1024 1472 1024Z"
         }
      }
   ]
}

var Accounts = {
   name: "Accounts",
   vendor: "UiFabric",
   unicode: 59664,
   value: "",
   charCode: "E910",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1079 2037.50 1138.50Q2027 1198 2006 1255Q1985 1312 1953 1363Q1921 1414 1878.50 1452.50Q1836 1491 1782 1513.50Q1728 1536 1664 1536L1664 1536Q1610 1536 1558.50 1521.50Q1507 1507 1463 1480Q1419 1453 1382.50 1414Q1346 1375 1322 1326L1322 1326Q1292 1373 1253 1411.50Q1214 1450 1168 1478Q1122 1506 1069.50 1521Q1017 1536 960 1536L960 1536Q858 1536 775 1491.50Q692 1447 633.50 1375Q575 1303 543.50 1211Q512 1119 512 1024L512 1024Q512 929 543.50 837Q575 745 633.50 673Q692 601 775 556.50Q858 512 960 512L960 512Q1055 512 1136.50 553Q1218 594 1280 665L1280 665L1280 512L1408 512L1408 1024L1408 1152Q1408 1205 1428 1251.50Q1448 1298 1483 1333Q1518 1368 1564.50 1388Q1611 1408 1664 1408L1664 1408Q1708 1408 1744.50 1389.50Q1781 1371 1809.50 1340.50Q1838 1310 1859 1270.50Q1880 1231 1893.50 1188Q1907 1145 1913.50 1102.50Q1920 1060 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920L1024 1920Q1202 1920 1367 1852L1367 1852L1416 1970Q1322 2009 1223.50 2028.50Q1125 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM960 1408L960 1408Q1035 1408 1094.50 1373.50Q1154 1339 1195 1284Q1236 1229 1258 1160.50Q1280 1092 1280 1024L1280 1024Q1280 956 1258 887.50Q1236 819 1195 764Q1154 709 1094.50 674.50Q1035 640 960 640L960 640Q885 640 825.50 674.50Q766 709 725 764Q684 819 662 887.50Q640 956 640 1024L640 1024Q640 1092 662 1160.50Q684 1229 725 1284Q766 1339 825.50 1373.50Q885 1408 960 1408Z"
         }
      }
   ]
}

var Street = {
   name: "Street",
   vendor: "UiFabric",
   unicode: 59667,
   value: "",
   charCode: "E913",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 987L861 1021L771 931L1408 293L2045 931L1955 1021L1920 987L1920 1536L1536 1536L1536 1152L1280 1152L1280 1536L896 1536L896 987ZM1024 859L1024 1408L1152 1408L1152 1024L1664 1024L1664 1408L1792 1408L1792 859L1408 475L1024 859ZM0 1664L2048 1664L2048 1792L0 1792L0 1664ZM256 1536L256 1146Q200 1135 153.50 1105.50Q107 1076 72.50 1034Q38 992 19 940.50Q0 889 0 832L0 832Q0 759 14 700Q28 641 51 585.50Q74 530 104.50 474.50Q135 419 168 353L168 353Q178 333 194.50 315Q211 297 231 284Q251 271 274 263.50Q297 256 320 256L320 256Q368 256 401 278.50Q434 301 458.50 335Q483 369 501 409Q519 449 537 483L537 483L552 513Q573 555 589.50 590Q606 625 617.50 660.50Q629 696 634.50 737Q640 778 640 832L640 832Q640 889 621 940.50Q602 992 567.50 1034Q533 1076 486 1105.50Q439 1135 384 1146L384 1146L384 1536L256 1536ZM320 384L320 384Q311 384 296.50 402Q282 420 264.50 448Q247 476 229.50 510Q212 544 196.50 575Q181 606 169.50 631Q158 656 154 666L154 666Q139 704 133.50 748Q128 792 128 832L128 832Q128 872 143 907Q158 942 184 968Q210 994 245 1009Q280 1024 320 1024L320 1024Q360 1024 395 1009Q430 994 456 968Q482 942 497 907Q512 872 512 832L512 832Q512 792 506.50 748Q501 704 486 666L486 666Q482 656 470.50 631Q459 606 443.50 575Q428 544 410 510Q392 476 375 448Q358 420 343.50 402Q329 384 320 384Z"
         }
      }
   ]
}

var RadioBullet = {
   name: "RadioBullet",
   vendor: "UiFabric",
   unicode: 59669,
   value: "",
   charCode: "E915",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1024 640Q1103 640 1173 670Q1243 700 1295.50 752.50Q1348 805 1378 875Q1408 945 1408 1024L1408 1024Q1408 1104 1378 1173.50Q1348 1243 1295.50 1295.50Q1243 1348 1173 1378Q1103 1408 1024 1408L1024 1408Q944 1408 874.50 1378Q805 1348 752.50 1295.50Q700 1243 670 1173.50Q640 1104 640 1024L640 1024Q640 945 670 875Q700 805 752.50 752.50Q805 700 874.50 670Q944 640 1024 640Z"
         }
      }
   ]
}

var Stopwatch = {
   name: "Stopwatch",
   vendor: "UiFabric",
   unicode: 59670,
   value: "",
   charCode: "E916",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1152L1408 1152L1408 1280L896 1280L896 640L1024 640L1024 1152ZM1837 301L1639 500Q1774 636 1847 797.50Q1920 959 1920 1152L1920 1152Q1920 1276 1888 1390.50Q1856 1505 1797.50 1604.50Q1739 1704 1657.50 1785.50Q1576 1867 1476.50 1925.50Q1377 1984 1262.50 2016Q1148 2048 1024 2048L1024 2048Q900 2048 785.50 2016Q671 1984 571.50 1925.50Q472 1867 390.50 1785.50Q309 1704 250.50 1604.50Q192 1505 160 1390.50Q128 1276 128 1152L128 1152Q128 1041 154.50 936Q181 831 229.50 738Q278 645 347 565.50Q416 486 501 424.50Q586 363 686 322Q786 281 896 265L896 265L896 128L640 128L640 0L1280 0L1280 128L1024 128L1024 256Q1163 256 1294.50 297Q1426 338 1539 419L1539 419L1747 211L1837 301ZM1024 1920L1024 1920Q1183 1920 1322.50 1859.50Q1462 1799 1566.50 1694.50Q1671 1590 1731.50 1450.50Q1792 1311 1792 1152L1792 1152Q1792 993 1731.50 853.50Q1671 714 1566.50 609.50Q1462 505 1322.50 444.50Q1183 384 1024 384L1024 384Q865 384 725.50 444.50Q586 505 481.50 609.50Q377 714 316.50 853.50Q256 993 256 1152L256 1152Q256 1311 316.50 1450.50Q377 1590 481.50 1694.50Q586 1799 725.50 1859.50Q865 1920 1024 1920Z"
         }
      }
   ]
}

var Clock = {
   name: "Clock",
   vendor: "UiFabric",
   unicode: 59671,
   value: "",
   charCode: "E917",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 2048L1024 2048Q900 2048 785.50 2016Q671 1984 571.50 1925.50Q472 1867 390.50 1785.50Q309 1704 250.50 1604.50Q192 1505 160 1390.50Q128 1276 128 1152L128 1152Q128 1028 160 913.50Q192 799 250.50 699.50Q309 600 390.50 518.50Q472 437 571.50 378.50Q671 320 785.50 288Q900 256 1024 256L1024 256Q1148 256 1262.50 288Q1377 320 1476.50 378.50Q1576 437 1657.50 518.50Q1739 600 1797.50 699.50Q1856 799 1888 913.50Q1920 1028 1920 1152L1920 1152Q1920 1276 1888 1390.50Q1856 1505 1797.50 1604.50Q1739 1704 1657.50 1785.50Q1576 1867 1476.50 1925.50Q1377 1984 1262.50 2016Q1148 2048 1024 2048ZM1024 384L1024 384Q865 384 725.50 444.50Q586 505 481.50 609.50Q377 714 316.50 853.50Q256 993 256 1152L256 1152Q256 1311 316.50 1450.50Q377 1590 481.50 1694.50Q586 1799 725.50 1859.50Q865 1920 1024 1920L1024 1920Q1183 1920 1322.50 1859.50Q1462 1799 1566.50 1694.50Q1671 1590 1731.50 1450.50Q1792 1311 1792 1152L1792 1152Q1792 993 1731.50 853.50Q1671 714 1566.50 609.50Q1462 505 1322.50 444.50Q1183 384 1024 384ZM1408 1152L1024 1152L1024 640L896 640L896 1280L1408 1280L1408 1152Z"
         }
      }
   ]
}

var WorldClock = {
   name: "WorldClock",
   vendor: "UiFabric",
   unicode: 59672,
   value: "",
   charCode: "E918",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 640L896 768L512 768L512 256L640 256L640 640L896 640ZM2048 1408L2048 1408Q2048 1495 2025.50 1576Q2003 1657 1961.50 1728.50Q1920 1800 1862 1858.50Q1804 1917 1733.50 1959.50Q1663 2002 1582 2025Q1501 2048 1414 2048L1414 2048Q1280 2048 1162.50 1998.50Q1045 1949 957.50 1862.50Q870 1776 819 1659Q768 1542 768 1408L768 1408Q768 1276 818.50 1159.50Q869 1043 956 956Q1043 869 1159.50 818.50Q1276 768 1408 768L1408 768Q1540 768 1656.50 818.50Q1773 869 1860 956Q1947 1043 1997.50 1159.50Q2048 1276 2048 1408ZM1408 1920L1408 1920Q1429 1920 1445.50 1904.50Q1462 1889 1474 1865Q1486 1841 1495 1811.50Q1504 1782 1510 1753.50Q1516 1725 1519 1701Q1522 1677 1524 1664L1524 1664L1294 1664Q1295 1677 1299 1701Q1303 1725 1309 1753Q1315 1781 1324 1811Q1333 1841 1345 1865Q1357 1889 1372.50 1904.50Q1388 1920 1408 1920ZM1283 1536L1533 1536Q1536 1472 1536 1408L1536 1408Q1536 1345 1533 1280L1533 1280L1283 1280Q1280 1345 1280 1408L1280 1408Q1280 1472 1283 1536L1283 1536ZM896 1408L896 1408Q896 1440 900 1472Q904 1504 912 1536L912 1536L1155 1536Q1149 1408 1155 1280L1155 1280L912 1280Q904 1312 900 1344Q896 1376 896 1408ZM1408 896L1408 896Q1389 896 1374 911.50Q1359 927 1347 951.50Q1335 976 1326 1005.50Q1317 1035 1310.50 1063.50Q1304 1092 1300 1116Q1296 1140 1295 1152L1295 1152L1520 1152Q1519 1141 1514.50 1117.50Q1510 1094 1503.50 1065.50Q1497 1037 1488 1007Q1479 977 1467 952.50Q1455 928 1440 912Q1425 896 1408 896ZM1904 1280L1661 1280Q1664 1344 1664 1408Q1664 1472 1662 1536L1662 1536L1904 1536Q1912 1504 1916 1472Q1920 1440 1920 1408L1920 1408Q1920 1376 1916 1344Q1912 1312 1904 1280L1904 1280ZM1650 1152L1851 1152Q1808 1077 1743 1020.50Q1678 964 1598 932L1598 932Q1618 985 1630.50 1040Q1643 1095 1650 1152L1650 1152ZM1214 934L1214 934Q1136 966 1071.50 1022.50Q1007 1079 965 1152L965 1152L1165 1152Q1172 1096 1183 1041.50Q1194 987 1214 934ZM1165 1664L965 1664Q1007 1737 1070.50 1793Q1134 1849 1212 1881L1212 1881Q1192 1829 1181.50 1774Q1171 1719 1165 1664L1165 1664ZM1608 1879L1608 1879Q1685 1847 1747 1791.50Q1809 1736 1851 1664L1851 1664L1653 1664Q1648 1719 1637.50 1773Q1627 1827 1608 1879ZM640 0L640 0Q728 0 810 23Q892 46 963 87.50Q1034 129 1092.50 187.50Q1151 246 1192.50 317Q1234 388 1257 470Q1280 552 1280 640L1280 640L1152 640Q1152 534 1111.50 441Q1071 348 1001.50 278.50Q932 209 839 168.50Q746 128 640 128L640 128Q534 128 441 168.50Q348 209 278.50 278.50Q209 348 168.50 441Q128 534 128 640L128 640Q128 746 168.50 839Q209 932 278.50 1001.50Q348 1071 441 1111.50Q534 1152 640 1152L640 1152L640 1280Q552 1280 470 1257Q388 1234 317 1192.50Q246 1151 187.50 1092.50Q129 1034 87.50 963Q46 892 23 810Q0 728 0 640L0 640Q0 508 50.50 391.50Q101 275 188 188Q275 101 391.50 50.50Q508 0 640 0Z"
         }
      }
   ]
}

var AlarmClock = {
   name: "AlarmClock",
   vendor: "UiFabric",
   unicode: 59673,
   value: "",
   charCode: "E919",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1152L1408 1152L1408 1280L896 1280L896 640L1024 640L1024 1152ZM1648 128L1648 128Q1731 128 1804 159.50Q1877 191 1931 245Q1985 299 2016.50 372Q2048 445 2048 528L2048 528Q2048 578 2036 625.50Q2024 673 2001 716Q1978 759 1945 796Q1912 833 1871 860L1871 860Q1896 931 1908 1004Q1920 1077 1920 1152L1920 1152Q1920 1314 1863.50 1465.50Q1807 1617 1701 1739L1701 1739L1901 1939L1811 2029L1611 1829Q1489 1935 1337.50 1991.50Q1186 2048 1024 2048L1024 2048Q862 2048 710.50 1991.50Q559 1935 437 1829L437 1829L237 2029L147 1939L347 1739Q241 1617 184.50 1465.50Q128 1314 128 1152L128 1152Q128 1077 140 1004Q152 931 177 860L177 860Q136 833 103 796Q70 759 47 716Q24 673 12 625.50Q0 578 0 528L0 528Q0 445 31.50 372Q63 299 117 245Q171 191 244 159.50Q317 128 400 128L400 128Q449 128 497 140Q545 152 588 175Q631 198 668 231Q705 264 732 305L732 305Q803 280 876 268Q949 256 1024 256L1024 256Q1099 256 1172 268Q1245 280 1316 305L1316 305Q1343 264 1380 231Q1417 198 1460 175Q1503 152 1550.50 140Q1598 128 1648 128ZM400 256L400 256Q344 256 294.50 277.50Q245 299 208 336Q171 373 149.50 422.50Q128 472 128 528L128 528Q128 590 154.50 645.50Q181 701 229 739L229 739Q293 615 390 518Q487 421 611 357L611 357Q573 309 517.50 282.50Q462 256 400 256ZM1024 1920L1024 1920Q1183 1920 1322.50 1859.50Q1462 1799 1566.50 1694.50Q1671 1590 1731.50 1450.50Q1792 1311 1792 1152L1792 1152Q1792 993 1731.50 853.50Q1671 714 1566.50 609.50Q1462 505 1322.50 444.50Q1183 384 1024 384L1024 384Q865 384 725.50 444.50Q586 505 481.50 609.50Q377 714 316.50 853.50Q256 993 256 1152L256 1152Q256 1311 316.50 1450.50Q377 1590 481.50 1694.50Q586 1799 725.50 1859.50Q865 1920 1024 1920ZM1819 739L1819 739Q1867 701 1893.50 645.50Q1920 590 1920 528L1920 528Q1920 472 1898.50 422.50Q1877 373 1840 336Q1803 299 1753.50 277.50Q1704 256 1648 256L1648 256Q1586 256 1530.50 282.50Q1475 309 1437 357L1437 357Q1561 421 1658 518Q1755 615 1819 739Z"
         }
      }
   ]
}

var Photo = {
   name: "Photo",
   vendor: "UiFabric",
   unicode: 59675,
   value: "",
   charCode: "E91B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 256L2048 256L2048 1792L0 1792ZM128 1664L1920 1664L1920 384L128 384L128 1664ZM256 512L1792 512L1792 1536L256 1536L256 512ZM384 1408L1664 1408L1664 640L384 640L384 1408Z"
         }
      }
   ]
}

var ActionCenter = {
   name: "ActionCenter",
   vendor: "UiFabric",
   unicode: 59676,
   value: "",
   charCode: "E91C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 0L2048 0L2048 1664L1408 1664L1024 2048L640 1664L0 1664ZM1355 1536L1920 1536L1920 128L128 128L128 1536L693 1536L1024 1867L1355 1536Z"
         }
      }
   ]
}

var Hospital = {
   name: "Hospital",
   vendor: "UiFabric",
   unicode: 59677,
   value: "",
   charCode: "E91D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 768L896 768L896 1024L640 1024L640 1280L896 1280L896 1536L1152 1536L1152 1280L1408 1280L1408 1024L1152 1024L1152 768ZM1280 640L1280 896L1536 896L1536 1408L1280 1408L1280 1664L768 1664L768 1408L512 1408L512 896L768 896L768 640L1280 640ZM1536 384L1856 384Q1896 384 1931 399Q1966 414 1992 440Q2018 466 2033 501Q2048 536 2048 576L2048 576L2048 1728Q2048 1768 2033 1803Q2018 1838 1992 1864Q1966 1890 1931 1905Q1896 1920 1856 1920L1856 1920L192 1920Q152 1920 117 1905Q82 1890 56 1864Q30 1838 15 1803Q0 1768 0 1728L0 1728L0 576Q0 536 15 501Q30 466 56 440Q82 414 117 399Q152 384 192 384L192 384L512 384Q512 347 511 302Q510 257 520.50 218.50Q531 180 557.50 154Q584 128 640 128L640 128L1408 128Q1445 128 1469 140Q1493 152 1507 172Q1521 192 1527.50 218.50Q1534 245 1536 273.50Q1538 302 1537 330.50Q1536 359 1536 384L1536 384ZM640 256L640 384L1408 384L1408 256L640 256ZM1920 1728L1920 576Q1920 550 1901 531Q1882 512 1856 512L1856 512L192 512Q166 512 147 531Q128 550 128 576L128 576L128 1728Q128 1754 147 1773Q166 1792 192 1792L192 1792L1856 1792Q1882 1792 1901 1773Q1920 1754 1920 1728L1920 1728Z"
         }
      }
   ]
}

var Timer = {
   name: "Timer",
   vendor: "UiFabric",
   unicode: 59678,
   value: "",
   charCode: "E91E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1837 301L1639 500Q1774 636 1847 797.50Q1920 959 1920 1152L1920 1152Q1920 1276 1888 1390.50Q1856 1505 1797.50 1604.50Q1739 1704 1657.50 1785.50Q1576 1867 1476.50 1925.50Q1377 1984 1262.50 2016Q1148 2048 1024 2048L1024 2048Q900 2048 785.50 2016Q671 1984 571.50 1925.50Q472 1867 390.50 1785.50Q309 1704 250.50 1604.50Q192 1505 160 1390.50Q128 1276 128 1152L128 1152Q128 1041 154.50 936Q181 831 229.50 738Q278 645 347 565.50Q416 486 501 424.50Q586 363 686 322Q786 281 896 265L896 265L896 128L640 128L640 0L1280 0L1280 128L1024 128L1024 256Q1163 256 1294.50 297Q1426 338 1539 419L1539 419L1747 211L1837 301ZM1024 1920L1024 1920Q1183 1920 1322.50 1859.50Q1462 1799 1566.50 1694.50Q1671 1590 1731.50 1450.50Q1792 1311 1792 1152L1792 1152Q1792 993 1731.50 853.50Q1671 714 1566.50 609.50Q1462 505 1322.50 444.50Q1183 384 1024 384L1024 384Q865 384 725.50 444.50Q586 505 481.50 609.50Q377 714 316.50 853.50Q256 993 256 1152L256 1152Q256 1311 316.50 1450.50Q377 1590 481.50 1694.50Q586 1799 725.50 1859.50Q865 1920 1024 1920ZM1152 1024L1664 1024L1664 1152Q1664 1285 1614 1401.50Q1564 1518 1477 1605Q1390 1692 1273.50 1742Q1157 1792 1024 1792L1024 1792Q891 1792 774.50 1742Q658 1692 571 1605.50Q484 1519 434 1402.50Q384 1286 384 1153L384 1153Q384 1065 407 983Q430 901 471.50 830Q513 759 571.50 700.50Q630 642 701 600Q772 558 853.50 535Q935 512 1024 512L1024 512L1152 512L1152 1024ZM1024 1664L1024 1664Q1130 1664 1223.50 1624Q1317 1584 1386.50 1514.50Q1456 1445 1496 1351.50Q1536 1258 1536 1152L1536 1152L1024 1152L1024 640Q917 640 824 680.50Q731 721 661.50 790.50Q592 860 552 954Q512 1048 512 1154L512 1154Q512 1260 552.50 1353Q593 1446 662.50 1515Q732 1584 825 1624Q918 1664 1024 1664Z"
         }
      }
   ]
}

var FullCircleMask = {
   name: "FullCircleMask",
   vendor: "UiFabric",
   unicode: 59679,
   value: "",
   charCode: "E91F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024Z"
         }
      }
   ]
}

var LocationFill = {
   name: "LocationFill",
   vendor: "UiFabric",
   unicode: 59680,
   value: "",
   charCode: "E920",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 192L1024 192Q1139 192 1245.50 221.50Q1352 251 1444.50 305.50Q1537 360 1612.50 435.50Q1688 511 1742.50 603.50Q1797 696 1826.50 802.50Q1856 909 1856 1024L1856 1024Q1856 1139 1826.50 1245.50Q1797 1352 1742.50 1444.50Q1688 1537 1612.50 1612.50Q1537 1688 1444.50 1742.50Q1352 1797 1245.50 1826.50Q1139 1856 1024 1856L1024 1856Q909 1856 802.50 1826.50Q696 1797 603.50 1742.50Q511 1688 435.50 1612.50Q360 1537 305.50 1444.50Q251 1352 221.50 1245.50Q192 1139 192 1024L192 1024Q192 909 221.50 802.50Q251 696 305.50 603.50Q360 511 435.50 435.50Q511 360 603.50 305.50Q696 251 802.50 221.50Q909 192 1024 192Z"
         }
      }
   ]
}

var ChromeMinimize = {
   name: "ChromeMinimize",
   vendor: "UiFabric",
   unicode: 59681,
   value: "",
   charCode: "E921",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 819L2048 819L2048 1024L0 1024L0 819Z"
         }
      }
   ]
}

var ChromeRestore = {
   name: "ChromeRestore",
   vendor: "UiFabric",
   unicode: 59683,
   value: "",
   charCode: "E923",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 0L2048 1638L1638 1638L1638 2048L0 2048L0 410L410 410L410 0L2048 0ZM1434 1843L1434 614L205 614L205 1843L1434 1843ZM1843 1434L1843 205L614 205L614 410L1638 410L1638 1434L1843 1434Z"
         }
      }
   ]
}

var Annotation = {
   name: "Annotation",
   vendor: "UiFabric",
   unicode: 59684,
   value: "",
   charCode: "E924",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1627 512L1115 1024L1792 1024L1664 1152L987 1152L673 1465Q718 1501 743 1553.50Q768 1606 768 1664L768 1664Q768 1717 747.50 1763.50Q727 1810 692.50 1844.50Q658 1879 611 1899.50Q564 1920 512 1920L512 1920Q459 1920 412.50 1899.50Q366 1879 331.50 1844.50Q297 1810 276.50 1763.50Q256 1717 256 1664L256 1664Q256 1612 276.50 1565Q297 1518 331.50 1483.50Q366 1449 412.50 1428.50Q459 1408 512 1408L512 1408L547 1410L805 1152L478 1152Q443 1211 384 1245.50Q325 1280 256 1280L256 1280Q203 1280 156.50 1259.50Q110 1239 75.50 1204.50Q41 1170 20.50 1123.50Q0 1077 0 1024L0 1024Q0 972 20.50 925Q41 878 75.50 843.50Q110 809 156.50 788.50Q203 768 256 768L256 768Q308 768 355 788.50Q402 809 436.50 843.50Q471 878 491.50 925Q512 972 512 1024L512 1024L933 1024L1445 512L1627 512ZM256 1152L256 1152Q283 1152 306 1142Q329 1132 346.50 1114.50Q364 1097 374 1074Q384 1051 384 1024L384 1024Q384 997 374 974Q364 951 346.50 933.50Q329 916 306 906Q283 896 256 896L256 896Q229 896 206 906Q183 916 165.50 933.50Q148 951 138 974Q128 997 128 1024L128 1024Q128 1051 138 1074Q148 1097 165.50 1114.50Q183 1132 206 1142Q229 1152 256 1152ZM512 1792L512 1792Q539 1792 562 1782Q585 1772 602.50 1754.50Q620 1737 630 1714Q640 1691 640 1664L640 1664Q640 1637 630 1614Q620 1591 602.50 1573.50Q585 1556 562 1546Q539 1536 512 1536L512 1536Q485 1536 462 1546Q439 1556 421.50 1573.50Q404 1591 394 1614Q384 1637 384 1664L384 1664Q384 1691 394 1714Q404 1737 421.50 1754.50Q439 1772 462 1782Q485 1792 512 1792ZM1920 384L1920 256L2048 256L2048 384L1920 384ZM1920 0L2048 0L2048 128L1920 128L1920 0ZM1664 128L1664 0L1792 0L1792 128L1664 128ZM1536 0L1536 128L1408 128L1408 0L1536 0ZM1280 0L1280 128L1152 128L1152 0L1280 0ZM1024 0L1024 128L896 128L896 0L1024 0ZM768 0L768 128L640 128L640 0L768 0ZM512 0L512 128L384 128L384 0L512 0ZM512 256L512 384L384 384L384 256L512 256ZM512 512L512 640L384 640L384 512L512 512ZM1920 640L1920 512L2048 512L2048 640L1920 640ZM1920 896L1920 768L2048 768L2048 896L1920 896ZM1920 1152L1920 1024L2048 1024L2048 1152L1920 1152ZM1920 1408L1920 1280L2048 1280L2048 1408L1920 1408ZM1920 1664L1920 1536L2048 1536L2048 1664L1920 1664ZM1664 1664L1664 1536L1792 1536L1792 1664L1664 1664ZM1408 1664L1408 1536L1536 1536L1536 1664L1408 1664ZM1152 1664L1152 1536L1280 1536L1280 1664L1152 1664ZM896 1664L896 1536L1024 1536L1024 1664L896 1664Z"
         }
      }
   ]
}

var Touch = {
   name: "Touch",
   vendor: "UiFabric",
   unicode: 59413,
   value: "",
   charCode: "E815",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 896L1600 896Q1640 896 1675 911Q1710 926 1736 952Q1762 978 1777 1013Q1792 1048 1792 1088L1792 1088L1792 1472Q1792 1591 1746.50 1696Q1701 1801 1623 1879Q1545 1957 1440 2002.50Q1335 2048 1216 2048L1216 2048Q1072 2048 947.50 1993Q823 1938 722 1837L722 1837L250 1365Q222 1337 207 1300Q192 1263 192 1224L192 1224Q192 1182 208 1145.50Q224 1109 251 1082Q278 1055 314.50 1039.50Q351 1024 392 1024L392 1024Q474 1024 533 1083L533 1083L640 1189L640 853Q581 825 534 782.50Q487 740 453.50 687.50Q420 635 402 574Q384 513 384 448L384 448Q384 355 419 273.50Q454 192 515 131Q576 70 657.50 35Q739 0 832 0L832 0Q925 0 1006.50 35Q1088 70 1149 131Q1210 192 1245 273.50Q1280 355 1280 448L1280 448Q1280 541 1243 626.50Q1206 712 1138 775L1138 775Q1173 784 1201.50 805.50Q1230 827 1250 857L1250 857Q1295 832 1344 832L1344 832Q1394 832 1437 855.50Q1480 879 1506 921L1506 921Q1551 896 1600 896ZM512 448L512 448Q512 523 546 591Q580 659 640 704L640 704L640 448Q640 408 655 373Q670 338 696 312Q722 286 757 271Q792 256 832 256L832 256Q872 256 907 271Q942 286 968 312Q994 338 1009 373Q1024 408 1024 448L1024 448L1024 704Q1084 659 1118 591Q1152 523 1152 448L1152 448Q1152 382 1126.50 324Q1101 266 1057.50 222.50Q1014 179 956 153.50Q898 128 832 128L832 128Q766 128 707.50 153.50Q649 179 605.50 222.50Q562 266 537 324Q512 382 512 448ZM1664 1472L1664 1088Q1664 1062 1645 1043Q1626 1024 1600 1024L1600 1024Q1566 1024 1552.50 1043Q1539 1062 1536.50 1090.50Q1534 1119 1536 1152Q1538 1185 1535.50 1213.50Q1533 1242 1519.50 1261Q1506 1280 1472 1280L1472 1280Q1435 1280 1421.50 1256.50Q1408 1233 1406 1197Q1404 1161 1408 1120Q1412 1079 1410 1043Q1408 1007 1394.50 983.50Q1381 960 1344 960L1344 960Q1310 960 1296.50 979Q1283 998 1280.50 1026.50Q1278 1055 1280 1088Q1282 1121 1279.50 1149.50Q1277 1178 1263.50 1197Q1250 1216 1216 1216L1216 1216Q1179 1216 1165.50 1192.50Q1152 1169 1150 1133Q1148 1097 1152 1056Q1156 1015 1154 979Q1152 943 1138.50 919.50Q1125 896 1088 896L1088 896Q1054 896 1040.50 915Q1027 934 1024.50 962.50Q1022 991 1024 1024Q1026 1057 1023.50 1085.50Q1021 1114 1007.50 1133Q994 1152 960 1152L960 1152Q934 1152 915 1133Q896 1114 896 1088L896 1088L896 448Q896 422 877 403Q858 384 832 384L832 384Q806 384 787 403Q768 422 768 448L768 448L768 1235Q768 1258 759.50 1277.50Q751 1297 736.50 1312Q722 1327 702 1335.50Q682 1344 660 1344L660 1344Q638 1344 617.50 1336Q597 1328 581 1312L581 1312L442 1173Q421 1152 392 1152L392 1152Q363 1152 341.50 1173Q320 1194 320 1224L320 1224Q320 1253 341 1274L341 1274L813 1747Q897 1831 997 1875.50Q1097 1920 1216 1920L1216 1920Q1309 1920 1390.50 1884.50Q1472 1849 1532.50 1788.50Q1593 1728 1628.50 1646.50Q1664 1565 1664 1472L1664 1472Z"
         }
      }
   ]
}

var EMI = {
   name: "EMI",
   vendor: "UiFabric",
   unicode: 59185,
   value: "",
   charCode: "E731",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 128L1536 128L1536 1920L1024 1920L1024 1408L896 1408L896 1920L384 1920L384 128ZM1408 1792L1408 256L512 256L512 1792L768 1792L768 1280L1152 1280L1152 1792L1408 1792ZM768 384L768 640L640 640L640 384L768 384ZM1024 384L1024 640L896 640L896 384L1024 384ZM768 768L768 1024L640 1024L640 768L768 768ZM1024 768L1024 1024L896 1024L896 768L1024 768ZM1280 384L1280 640L1152 640L1152 384L1280 384ZM1280 768L1280 1024L1152 1024L1152 768L1280 768Z"
         }
      }
   ]
}

var Fingerprint = {
   name: "Fingerprint",
   vendor: "UiFabric",
   unicode: 59688,
   value: "",
   charCode: "E928",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1216L1024 1216Q1024 1335 978.50 1440Q933 1545 855 1623Q777 1701 672 1746.50Q567 1792 448 1792L448 1792Q422 1792 403 1773Q384 1754 384 1728L384 1728Q384 1702 403 1683Q422 1664 448 1664L448 1664Q541 1664 622.50 1628.50Q704 1593 764.50 1532.50Q825 1472 860.50 1390.50Q896 1309 896 1216L896 1216Q896 1190 915 1171Q934 1152 960 1152L960 1152Q986 1152 1005 1171Q1024 1190 1024 1216ZM960 256L960 256Q829 256 712 287.50Q595 319 478 376L478 376Q462 384 448 384L448 384Q422 384 403 365Q384 346 384 320L384 320Q384 283 418 264L418 264Q476 230 543 204.50Q610 179 680.50 162Q751 145 822.50 136.50Q894 128 960 128L960 128Q1027 128 1098 136.50Q1169 145 1239.50 162Q1310 179 1376.50 204.50Q1443 230 1502 264L1502 264Q1536 283 1536 319L1536 319Q1536 346 1517.50 365Q1499 384 1472 384L1472 384Q1462 384 1456 382.50Q1450 381 1442 376L1442 376Q1327 317 1208.50 286.50Q1090 256 960 256ZM960 384L960 384Q1072 384 1179 413Q1286 442 1382 499L1382 499Q1425 525 1468.50 558Q1512 591 1551 630Q1590 669 1623.50 712Q1657 755 1681 800L1681 800Q1689 816 1689 831L1689 831Q1689 858 1670 877Q1651 896 1625 896L1625 896Q1606 896 1593 887.50Q1580 879 1570 864L1570 864Q1550 833 1530 804Q1510 775 1485 748L1485 748Q1435 692 1375 648Q1315 604 1247.50 574Q1180 544 1107.50 528Q1035 512 960 512L960 512Q839 512 726 552.50Q613 593 519 668L519 668Q496 686 476 706.50Q456 727 435 747L435 747Q424 758 413.50 763Q403 768 388 768L388 768Q361 768 342.50 749Q324 730 324 704L324 704Q324 691 328 681Q332 671 340 661L340 661Q364 630 397 601Q430 572 466.50 546Q503 520 541 498Q579 476 615 459L615 459Q696 421 783 402.50Q870 384 960 384ZM960 640L960 640Q1079 640 1184 685.50Q1289 731 1367 809Q1445 887 1490.50 992Q1536 1097 1536 1216L1536 1216Q1536 1310 1520.50 1402.50Q1505 1495 1473 1583L1473 1583Q1460 1619 1440.50 1662Q1421 1705 1398 1747.50Q1375 1790 1349 1829Q1323 1868 1298 1896L1298 1896Q1287 1907 1275.50 1913.50Q1264 1920 1248 1920L1248 1920Q1222 1920 1203 1901.50Q1184 1883 1184 1856L1184 1856Q1184 1835 1198 1816L1198 1816Q1217 1790 1235 1765Q1253 1740 1270 1712L1270 1712Q1339 1599 1373.50 1473.50Q1408 1348 1408 1216L1408 1216Q1408 1123 1372.50 1041.50Q1337 960 1276.50 899.50Q1216 839 1134.50 803.50Q1053 768 960 768L960 768Q867 768 785.50 803.50Q704 839 643.50 899.50Q583 960 547.50 1041.50Q512 1123 512 1216L512 1216Q512 1242 493 1261Q474 1280 448 1280L448 1280Q422 1280 403 1261Q384 1242 384 1216L384 1216Q384 1097 429.50 992Q475 887 553 809Q631 731 736 685.50Q841 640 960 640ZM960 896L960 896Q1026 896 1084 921.50Q1142 947 1185.50 990.50Q1229 1034 1254.50 1092Q1280 1150 1280 1216L1280 1216Q1280 1319 1254.50 1419Q1229 1519 1181 1609Q1133 1699 1064 1776Q995 1853 908 1909L908 1909Q900 1914 892 1917Q884 1920 873 1920L873 1920Q846 1920 827.50 1901Q809 1882 809 1856L809 1856Q809 1838 816 1826Q823 1814 837 1803L837 1803Q864 1781 890.50 1761.50Q917 1742 942 1717L942 1717Q1043 1617 1097.50 1487.50Q1152 1358 1152 1216L1152 1216Q1152 1176 1137 1141Q1122 1106 1096 1080Q1070 1054 1035 1039Q1000 1024 960 1024L960 1024Q920 1024 885 1039Q850 1054 824 1080Q798 1106 783 1141Q768 1176 768 1216L768 1216Q768 1282 743 1340.50Q718 1399 674.50 1442.50Q631 1486 572.50 1511Q514 1536 448 1536L448 1536Q422 1536 403 1517Q384 1498 384 1472L384 1472Q384 1446 403 1427Q422 1408 448 1408L448 1408Q488 1408 523 1393Q558 1378 584 1352Q610 1326 625 1291Q640 1256 640 1216L640 1216Q640 1150 665 1092Q690 1034 733.50 990.50Q777 947 835.50 921.50Q894 896 960 896Z"
         }
      }
   ]
}

var Handwriting = {
   name: "Handwriting",
   vendor: "UiFabric",
   unicode: 59689,
   value: "",
   charCode: "E929",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1562 384L1562 384Q1588 384 1624.50 381Q1661 378 1700.50 377.50Q1740 377 1779.50 381Q1819 385 1850 399.50Q1881 414 1900.50 441Q1920 468 1920 512L1920 512L1920 1408Q1920 1435 1910 1458Q1900 1481 1882.50 1498.50Q1865 1516 1842 1526Q1819 1536 1792 1536L1792 1536L128 1536Q101 1536 78 1526Q55 1516 37.50 1498.50Q20 1481 10 1458Q0 1435 0 1408L0 1408L0 512Q0 485 10 462Q20 439 37.50 421.50Q55 404 78 394Q101 384 128 384L128 384L998 384L1323 59Q1351 31 1387.50 15.50Q1424 0 1464 0L1464 0Q1505 0 1541 16Q1577 32 1604 59Q1631 86 1647 122.50Q1663 159 1663 200L1663 200Q1663 233 1655.50 257.50Q1648 282 1634.50 303Q1621 324 1602.50 343.50Q1584 363 1562 384ZM1464 128L1464 128Q1435 128 1414 149L1414 149L594 969L560 1104L695 1070L1376 390Q1374 388 1376.50 385Q1379 382 1381 384L1381 384Q1393 372 1419 350Q1445 328 1471 302.50Q1497 277 1516.50 250Q1536 223 1536 200L1536 200Q1536 170 1514.50 149Q1493 128 1464 128ZM1792 1408L1792 512L1434 512L761 1186L384 1280L478 903L870 512L128 512L128 1408L1792 1408Z"
         }
      }
   ]
}

var HorizontalTabKey = {
   name: "HorizontalTabKey",
   vendor: "UiFabric",
   unicode: 59389,
   value: "",
   charCode: "E7FD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M685 301L475 512L2048 512L2048 640L475 640L685 851L595 941L230 576L595 211L685 301ZM0 256L128 256L128 896L0 896L0 256ZM1573 1408L1363 1197L1453 1107L1818 1472L1453 1837L1363 1747L1573 1536L0 1536L0 1408L1573 1408ZM2048 1792L1920 1792L1920 1152L2048 1152L2048 1792Z"
         }
      }
   ]
}

var Completed = {
   name: "Completed",
   vendor: "UiFabric",
   unicode: 59696,
   value: "",
   charCode: "E930",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M832 1254L1491 595L1581 685L832 1434L467 1069L557 979L832 1254ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920Z"
         }
      }
   ]
}

var Label = {
   name: "Label",
   vendor: "UiFabric",
   unicode: 59698,
   value: "",
   charCode: "E932",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1720 128L1720 128Q1761 128 1797 144Q1833 160 1860 187Q1887 214 1903 250.50Q1919 287 1919 328L1919 328Q1919 365 1908.50 393.50Q1898 422 1880 446Q1862 470 1839 492Q1816 514 1792 538L1792 538L1792 1792L256 1792L256 256L1510 256Q1534 232 1556.50 209Q1579 186 1603 168Q1627 150 1655 139Q1683 128 1720 128ZM1720 256L1720 256Q1691 256 1670 277L1670 277L722 1225L688 1360L823 1326L1771 378Q1792 357 1792 328L1792 328Q1792 298 1770.50 277Q1749 256 1720 256ZM1664 1664L1664 666L889 1442L512 1536L606 1159L1382 384L384 384L384 1664L1664 1664Z"
         }
      }
   ]
}

var Shop = {
   name: "Shop",
   vendor: "UiFabric",
   unicode: 59161,
   value: "",
   charCode: "E719",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L1792 512L1792 1792Q1792 1845 1771.50 1891.50Q1751 1938 1716.50 1972.50Q1682 2007 1635 2027.50Q1588 2048 1536 2048L1536 2048L384 2048Q331 2048 284.50 2027.50Q238 2007 203.50 1972.50Q169 1938 148.50 1891.50Q128 1845 128 1792L128 1792L128 512L384 512L384 384Q384 305 414.50 235Q445 165 497 113Q549 61 619 30.50Q689 0 768 0L768 0Q872 0 961 52L961 52Q1050 0 1152 0L1152 0Q1231 0 1301 30.50Q1371 61 1423 113Q1475 165 1505.50 235Q1536 305 1536 384L1536 384L1536 512ZM1408 512L1408 384Q1408 332 1387.50 285Q1367 238 1332.50 203.50Q1298 169 1251 148.50Q1204 128 1152 128L1152 128Q1107 128 1067 143L1067 143Q1096 179 1113 214Q1130 249 1138.50 284Q1147 319 1149.50 355.50Q1152 392 1152 432L1152 432L1152 512L1408 512ZM512 384L512 512L1024 512L1024 384Q1024 332 1003.50 285Q983 238 948.50 203.50Q914 169 867 148.50Q820 128 768 128L768 128Q715 128 668.50 148.50Q622 169 587.50 203.50Q553 238 532.50 285Q512 332 512 384L512 384ZM384 1920L1314 1920Q1280 1860 1280 1792L1280 1792L1280 640L256 640L256 1792Q256 1819 266 1842Q276 1865 293.50 1882.50Q311 1900 334 1910Q357 1920 384 1920L384 1920ZM1664 1792L1664 640L1408 640L1408 1792Q1408 1819 1418 1842Q1428 1865 1445.50 1882.50Q1463 1900 1486 1910Q1509 1920 1536 1920L1536 1920Q1563 1920 1586 1910Q1609 1900 1626.50 1882.50Q1644 1865 1654 1842Q1664 1819 1664 1792L1664 1792Z"
         }
      }
   ]
}

var Heart = {
   name: "Heart",
   vendor: "UiFabric",
   unicode: 60241,
   value: "",
   charCode: "EB51",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1504 128L1504 128Q1617 128 1716 171Q1815 214 1889 287.50Q1963 361 2005.50 460.50Q2048 560 2048 672L2048 672Q2048 781 2006.50 881Q1965 981 1889 1057L1889 1057L1024 1921L159 1057Q83 981 41.50 881Q0 781 0 672L0 672Q0 560 42.50 460.50Q85 361 159 287.50Q233 214 332 171Q431 128 544 128L544 128Q627 128 692 147Q757 166 812.50 199.50Q868 233 918.50 280Q969 327 1024 383L1024 383Q1079 327 1129.50 280Q1180 233 1235.50 199.50Q1291 166 1356 147Q1421 128 1504 128ZM1024 1740L1798 966Q1857 907 1888 831Q1919 755 1919 672L1919 672Q1919 585 1887 509.50Q1855 434 1798.50 378.50Q1742 323 1666.50 291.50Q1591 260 1504 260L1504 260Q1420 260 1355 286.50Q1290 313 1235 356Q1180 399 1129.50 453.50Q1079 508 1024 564L1024 564Q970 510 919 455Q868 400 812.50 356Q757 312 691.50 284Q626 256 544 256L544 256Q458 256 382 288.50Q306 321 249.50 377.50Q193 434 160.50 510Q128 586 128 672L128 672Q128 755 159.50 831Q191 907 250 966L250 966L1024 1740Z"
         }
      }
   ]
}

var HeartFill = {
   name: "HeartFill",
   vendor: "UiFabric",
   unicode: 60242,
   value: "",
   charCode: "EB52",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1889 287L1889 287Q1942 340 1977.50 403Q2013 466 2030.50 534Q2048 602 2048 672.50Q2048 743 2030.50 810.50Q2013 878 1977.50 941Q1942 1004 1889 1057L1889 1057L1024 1921L159 1057Q106 1004 70.50 941Q35 878 17.50 810.50Q0 743 0 672.50Q0 602 17.50 534Q35 466 70.50 403Q106 340 159 287L159 287Q237 210 336 169Q435 128 544 128L544 128Q653 128 752 169Q851 210 929 287L929 287L1024 383L1119 287Q1197 210 1296 169Q1395 128 1504 128L1504 128Q1613 128 1712 169Q1811 210 1889 287Z"
         }
      }
   ]
}

var DecreaseIndentLegacy = {
   name: "DecreaseIndentLegacy",
   vendor: "UiFabric",
   unicode: 58000,
   value: "",
   charCode: "E290",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 512L1024 384L2048 384L2048 512L1024 512ZM2048 1536L1024 1536L1024 1408L2048 1408L2048 1536ZM2048 1024L1024 1024L1024 896L2048 896L2048 1024ZM1024 640L1792 640L1792 768L1024 768L1024 640ZM1024 1152L1792 1152L1792 1280L1024 1280L1024 1152ZM323 643L413 733L250 896L896 896L896 1024L250 1024L413 1187L323 1277L6 960L323 643Z"
         }
      }
   ]
}

var IncreaseIndentLegacy = {
   name: "IncreaseIndentLegacy",
   vendor: "UiFabric",
   unicode: 58001,
   value: "",
   charCode: "E291",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 512L1024 384L2048 384L2048 512L1024 512ZM2048 1536L1024 1536L1024 1408L2048 1408L2048 1536ZM2048 1024L1024 1024L1024 896L2048 896L2048 1024ZM1024 640L1792 640L1792 768L1024 768L1024 640ZM1024 1152L1792 1152L1792 1280L1024 1280L1024 1152ZM646 896L483 733L573 643L890 960L573 1277L483 1187L646 1024L0 1024L0 896L646 896Z"
         }
      }
   ]
}

var SizeLegacy = {
   name: "SizeLegacy",
   vendor: "UiFabric",
   unicode: 58034,
   value: "",
   charCode: "E2B2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 640L1920 1152L2048 1152L2048 1920L0 1920L0 128L1792 128L1792 640L1920 640ZM128 256L128 1792L640 1792L640 640L1664 640L1664 256L128 256ZM768 768L768 1792L1280 1792L1280 1152L1792 1152L1792 768L768 768ZM1408 1792L1920 1792L1920 1280L1408 1280L1408 1792Z"
         }
      }
   ]
}

var MiniLink = {
   name: "MiniLink",
   vendor: "UiFabric",
   unicode: 59186,
   value: "",
   charCode: "E732",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 1408L1728 1408Q1794 1408 1852 1433.50Q1910 1459 1953.50 1502.50Q1997 1546 2022.50 1604Q2048 1662 2048 1728L2048 1728Q2048 1794 2022.50 1852.50Q1997 1911 1953.50 1954.50Q1910 1998 1852 2023Q1794 2048 1728 2048L1728 2048L1472 2048Q1415 2048 1363 2029Q1311 2010 1269.50 1976Q1228 1942 1199 1895Q1170 1848 1158 1792L1158 1792L890 1792Q878 1848 849 1895Q820 1942 778.50 1976Q737 2010 685 2029Q633 2048 576 2048L576 2048L320 2048Q254 2048 195.50 2023Q137 1998 93.50 1954.50Q50 1911 25 1852.50Q0 1794 0 1728L0 1728Q0 1662 25 1604Q50 1546 93.50 1502.50Q137 1459 195.50 1433.50Q254 1408 320 1408L320 1408L576 1408Q633 1408 685 1427Q737 1446 778.50 1480Q820 1514 849 1561Q878 1608 890 1664L890 1664L1158 1664Q1170 1608 1199 1561Q1228 1514 1269.50 1480Q1311 1446 1363 1427Q1415 1408 1472 1408L1472 1408ZM320 1920L576 1920Q606 1920 634.50 1911Q663 1902 687 1885Q711 1868 729 1844.50Q747 1821 757 1792L757 1792L576 1792Q550 1792 531 1773Q512 1754 512 1728L512 1728Q512 1702 531 1683Q550 1664 576 1664L576 1664L757 1664Q747 1635 729 1611.50Q711 1588 687 1571Q663 1554 634.50 1545Q606 1536 576 1536L576 1536L320 1536Q280 1536 245 1551Q210 1566 184 1592Q158 1618 143 1653Q128 1688 128 1728L128 1728Q128 1768 143 1803Q158 1838 184 1864Q210 1890 245 1905Q280 1920 320 1920L320 1920ZM1472 1920L1728 1920Q1768 1920 1803 1905Q1838 1890 1864 1864Q1890 1838 1905 1803Q1920 1768 1920 1728L1920 1728Q1920 1688 1905 1653Q1890 1618 1864 1592Q1838 1566 1803 1551Q1768 1536 1728 1536L1728 1536L1472 1536Q1442 1536 1413.50 1545Q1385 1554 1361 1571Q1337 1588 1319 1611.50Q1301 1635 1291 1664L1291 1664L1472 1664Q1498 1664 1517 1683Q1536 1702 1536 1728L1536 1728Q1536 1754 1517 1773Q1498 1792 1472 1792L1472 1792L1291 1792Q1301 1821 1319 1844.50Q1337 1868 1361 1885Q1385 1902 1413.50 1911Q1442 1920 1472 1920L1472 1920Z"
         }
      }
   ]
}

var FlickDown = {
   name: "FlickDown",
   vendor: "UiFabric",
   unicode: 59701,
   value: "",
   charCode: "E935",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L1024 1024L2048 2048L0 2048L1024 1024Z"
         }
      }
   ]
}

var FlickUp = {
   name: "FlickUp",
   vendor: "UiFabric",
   unicode: 59702,
   value: "",
   charCode: "E936",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L1024 1024L0 0L2048 0L1024 1024Z"
         }
      }
   ]
}

var FlickLeft = {
   name: "FlickLeft",
   vendor: "UiFabric",
   unicode: 59703,
   value: "",
   charCode: "E937",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L1024 1024L0 2048L0 0L1024 1024Z"
         }
      }
   ]
}

var FlickRight = {
   name: "FlickRight",
   vendor: "UiFabric",
   unicode: 59704,
   value: "",
   charCode: "E938",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L1024 1024L2048 0L2048 2048L1024 1024Z"
         }
      }
   ]
}

var MiniExpand = {
   name: "MiniExpand",
   vendor: "UiFabric",
   unicode: 59706,
   value: "",
   charCode: "E93A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 475L1243 1024L1152 933L1701 384L1280 384L1280 256L1920 256L1920 896L1792 896L1792 475ZM1792 1664L1792 1152L1920 1152L1920 1792L128 1792L128 256L1024 256L1024 384L256 384L256 1152L1024 1152L1024 1664L1792 1664ZM896 1280L256 1280L256 1664L896 1664L896 1280Z"
         }
      }
   ]
}

var MiniContract = {
   name: "MiniContract",
   vendor: "UiFabric",
   unicode: 59707,
   value: "",
   charCode: "E93B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1664L1792 1280L1920 1280L1920 1792L128 1792L128 256L896 256L896 384L256 384L256 1152L1024 1152L1024 1664L1792 1664ZM896 1280L256 1280L256 1664L896 1664L896 1280ZM1792 896L1792 1024L1152 1024L1152 384L1280 384L1280 805L1829 256L1920 347L1371 896L1792 896Z"
         }
      }
   ]
}

var ChromeFullScreen = {
   name: "ChromeFullScreen",
   vendor: "UiFabric",
   unicode: 59693,
   value: "",
   charCode: "E92D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1229 0L2048 0L2048 819L1843 819L1843 350L350 1843L819 1843L819 2048L0 2048L0 1229L205 1229L205 1698L1698 205L1229 205L1229 0Z"
         }
      }
   ]
}

var Streaming = {
   name: "Streaming",
   vendor: "UiFabric",
   unicode: 59710,
   value: "",
   charCode: "E93E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 779L1024 779Q1075 779 1119.50 798.50Q1164 818 1197 851Q1230 884 1249.50 928.50Q1269 973 1269 1024L1269 1024Q1269 1075 1249.50 1119.50Q1230 1164 1197 1197Q1164 1230 1119.50 1249.50Q1075 1269 1024 1269L1024 1269Q973 1269 928.50 1249.50Q884 1230 851 1197Q818 1164 798.50 1119.50Q779 1075 779 1024L779 1024Q779 973 798.50 928.50Q818 884 851 851Q884 818 928.50 798.50Q973 779 1024 779ZM1024 1163L1024 1163Q1053 1163 1078.50 1152Q1104 1141 1122.50 1122.50Q1141 1104 1152 1078.50Q1163 1053 1163 1024L1163 1024Q1163 995 1152 969.50Q1141 944 1122.50 925.50Q1104 907 1078.50 896Q1053 885 1024 885L1024 885Q995 885 969.50 896Q944 907 925.50 925.50Q907 944 896 969.50Q885 995 885 1024L885 1024Q885 1053 896 1078.50Q907 1104 925.50 1122.50Q944 1141 969.50 1152Q995 1163 1024 1163ZM1665 383L1740 308Q1812 379 1867 462Q1922 545 1960 636Q1998 727 2017.50 825Q2037 923 2037 1024L2037 1024Q2037 1125 2017.50 1223Q1998 1321 1960 1412Q1922 1503 1867 1586Q1812 1669 1740 1740L1740 1740L1665 1665Q1729 1601 1778.50 1527Q1828 1453 1861.50 1371Q1895 1289 1912.50 1201.50Q1930 1114 1930 1024L1930 1024Q1930 934 1912.50 846.50Q1895 759 1861.50 677Q1828 595 1778.50 521Q1729 447 1665 383L1665 383ZM308 308L383 383Q319 447 269.50 521Q220 595 186 677Q152 759 134.50 846.50Q117 934 117 1024L117 1024Q117 1114 134.50 1201.50Q152 1289 186 1371Q220 1453 269.50 1527Q319 1601 383 1665L383 1665L308 1740Q236 1669 181 1586Q126 1503 88 1412Q50 1321 30.50 1223Q11 1125 11 1024L11 1024Q11 923 30.50 825Q50 727 88 636Q126 545 181 462Q236 379 308 308L308 308ZM1394 654L1469 579Q1558 669 1605.50 783.50Q1653 898 1653 1024L1653 1024Q1653 1150 1605.50 1264.50Q1558 1379 1469 1469L1469 1469L1394 1394Q1468 1320 1507.50 1224.50Q1547 1129 1547 1024L1547 1024Q1547 919 1507.50 823.50Q1468 728 1394 654L1394 654ZM579 579L654 654Q580 728 540.50 823.50Q501 919 501 1024L501 1024Q501 1129 540.50 1224.50Q580 1320 654 1394L654 1394L579 1469Q490 1379 442.50 1264.50Q395 1150 395 1024L395 1024Q395 898 442.50 783.50Q490 669 579 579L579 579Z"
         }
      }
   ]
}

var MusicInCollection = {
   name: "MusicInCollection",
   vendor: "UiFabric",
   unicode: 59712,
   value: "",
   charCode: "E940",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 62L1792 1408Q1792 1470 1762.50 1517.50Q1733 1565 1686.50 1597.50Q1640 1630 1583 1647Q1526 1664 1472 1664L1472 1664Q1418 1664 1361 1647Q1304 1630 1257.50 1597.50Q1211 1565 1181.50 1517.50Q1152 1470 1152 1408L1152 1408Q1152 1347 1181.50 1299Q1211 1251 1257.50 1218.50Q1304 1186 1361 1169Q1418 1152 1472 1152L1472 1152Q1523 1152 1572 1164.50Q1621 1177 1664 1203L1664 1203L1664 226L768 450L768 1664Q768 1726 738.50 1773.50Q709 1821 662.50 1853.50Q616 1886 559 1903Q502 1920 448 1920L448 1920Q394 1920 337 1903Q280 1886 233.50 1853.50Q187 1821 157.50 1773.50Q128 1726 128 1664L128 1664Q128 1603 157.50 1555Q187 1507 233.50 1474.50Q280 1442 337 1425Q394 1408 448 1408L448 1408Q499 1408 548 1420.50Q597 1433 640 1459L640 1459L640 350L1792 62ZM448 1792L448 1792Q475 1792 508 1784Q541 1776 570.50 1760.50Q600 1745 620 1721Q640 1697 640 1664L640 1664Q640 1631 620 1607Q600 1583 570.50 1567.50Q541 1552 508 1544Q475 1536 448 1536L448 1536Q421 1536 388 1544Q355 1552 325.50 1567.50Q296 1583 276 1607Q256 1631 256 1664L256 1664Q256 1697 276 1721Q296 1745 325.50 1760.50Q355 1776 388 1784Q421 1792 448 1792ZM1472 1536L1472 1536Q1499 1536 1532 1528Q1565 1520 1594.50 1504.50Q1624 1489 1644 1465Q1664 1441 1664 1408L1664 1408Q1664 1375 1644 1351Q1624 1327 1594.50 1311.50Q1565 1296 1532 1288Q1499 1280 1472 1280L1472 1280Q1445 1280 1412 1288Q1379 1296 1349.50 1311.50Q1320 1327 1300 1351Q1280 1375 1280 1408L1280 1408Q1280 1441 1300 1465Q1320 1489 1349.50 1504.50Q1379 1520 1412 1528Q1445 1536 1472 1536Z"
         }
      }
   ]
}

var OneDriveLogo = {
   name: "OneDriveLogo",
   vendor: "UiFabric",
   unicode: 59713,
   value: "",
   charCode: "E941",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1660 833L1660 833Q1742 838 1812.50 873Q1883 908 1935.50 964Q1988 1020 2018 1093Q2048 1166 2048 1248L2048 1248Q2048 1334 2015 1409.50Q1982 1485 1925.50 1541.50Q1869 1598 1793.50 1631Q1718 1664 1632 1664L1632 1664L512 1664Q406 1664 313 1623.50Q220 1583 150.50 1513.50Q81 1444 40.50 1351Q0 1258 0 1152L0 1152Q0 1068 26.50 991Q53 914 100 849.50Q147 785 213 736.50Q279 688 359 663L359 663Q396 652 431.50 647Q467 642 505 640L505 640L506 640Q550 573 609 519.50Q668 466 737 428.50Q806 391 882.50 371.50Q959 352 1040 352L1040 352Q1149 352 1249.50 387.50Q1350 423 1432.50 486.50Q1515 550 1574 638.50Q1633 727 1660 833ZM1040 480L1040 480Q927 480 825 526.50Q723 573 651 660L651 660Q689 670 723.50 685.50Q758 701 791 721L791 721L1199 965L1432 867Q1455 857 1478.50 849.50Q1502 842 1528 837L1528 837Q1503 757 1455 691.50Q1407 626 1342.50 579Q1278 532 1201 506Q1124 480 1040 480ZM206 1383L206 1383L1052 1026L725 830Q675 800 620 784Q565 768 507 768L507 768Q429 768 360 799Q291 830 239.50 882.50Q188 935 158 1005Q128 1075 128 1152L128 1152Q128 1212 148 1273.50Q168 1335 206 1383ZM512 1536L1632 1536Q1680 1536 1724 1521Q1768 1506 1806 1477L1806 1477L1189 1108L310 1478Q355 1506 406.50 1521Q458 1536 512 1536L512 1536ZM1335 1046L1889 1378Q1920 1316 1920 1248L1920 1248Q1920 1182 1895 1128Q1870 1074 1827.50 1036.50Q1785 999 1728 978.50Q1671 958 1608 958L1608 958Q1572 958 1536.50 966.50Q1501 975 1467 988Q1433 1001 1400 1016.50Q1367 1032 1335 1046L1335 1046Z"
         }
      }
   ]
}

var CompassNW = {
   name: "CompassNW",
   vendor: "UiFabric",
   unicode: 59714,
   value: "",
   charCode: "E942",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1093 0 1215.50 34Q1338 68 1445 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 475Q1852 582 1886 704.50Q1920 827 1920 960L1920 960Q1920 1093 1886 1215.50Q1852 1338 1789.50 1445Q1727 1552 1639.50 1639.50Q1552 1727 1445 1789.50Q1338 1852 1215.50 1886Q1093 1920 960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0ZM1024 1664L1024 1790Q1126 1782 1220 1750.50Q1314 1719 1396.50 1668Q1479 1617 1548 1548Q1617 1479 1668 1396.50Q1719 1314 1750.50 1220Q1782 1126 1790 1024L1790 1024L1664 1024L1664 896L1790 896Q1782 794 1750.50 700Q1719 606 1668 523.50Q1617 441 1548 372Q1479 303 1396.50 252Q1314 201 1220 169.50Q1126 138 1024 130L1024 130L1024 256L896 256L896 130Q794 138 700 169.50Q606 201 523.50 252Q441 303 372 372Q303 441 252 523.50Q201 606 169.50 700Q138 794 130 896L130 896L256 896L256 1024L130 1024Q138 1126 169.50 1220Q201 1314 252 1396.50Q303 1479 372 1548Q441 1617 523.50 1668Q606 1719 700 1750.50Q794 1782 896 1790L896 1790L896 1664L1024 1664ZM512 512L1109 811L1408 1408L811 1109L512 512ZM889 1031L1172 1172L1031 889L748 748L889 1031Z"
         }
      }
   ]
}

var Code = {
   name: "Code",
   vendor: "UiFabric",
   unicode: 59715,
   value: "",
   charCode: "E943",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1024L128 896Q180 896 227 875.50Q274 855 308.50 820.50Q343 786 363.50 739.50Q384 693 384 640L384 640Q384 569 381 498Q378 427 385.50 359.50Q393 292 417.50 229Q442 166 496 112L496 112Q550 58 621 29Q692 0 768 0L768 0L768 128Q715 128 668.50 148.50Q622 169 587.50 203.50Q553 238 532.50 285Q512 332 512 384L512 384Q512 440 514 494.50Q516 549 514.50 601.50Q513 654 505 703.50Q497 753 478 798Q459 843 426 884Q393 925 341 960L341 960Q393 995 426 1036Q459 1077 478 1122Q497 1167 505 1216.50Q513 1266 514.50 1318.50Q516 1371 514 1425.50Q512 1480 512 1536L512 1536Q512 1589 532.50 1635.50Q553 1682 587.50 1716.50Q622 1751 668.50 1771.50Q715 1792 768 1792L768 1792L768 1920Q692 1920 621 1891Q550 1862 496 1808L496 1808Q442 1754 417.50 1691Q393 1628 385.50 1560.50Q378 1493 381 1422Q384 1351 384 1280L384 1280Q384 1228 363.50 1181Q343 1134 308.50 1099.50Q274 1065 227 1044.50Q180 1024 128 1024L128 1024ZM1280 128L1280 0Q1356 0 1427 29Q1498 58 1552 112L1552 112Q1606 166 1630.50 229Q1655 292 1662.50 359.50Q1670 427 1667 498Q1664 569 1664 640L1664 640Q1664 693 1684.50 739.50Q1705 786 1739.50 820.50Q1774 855 1820.50 875.50Q1867 896 1920 896L1920 896L1920 1024Q1867 1024 1820.50 1044.50Q1774 1065 1739.50 1099.50Q1705 1134 1684.50 1181Q1664 1228 1664 1280L1664 1280Q1664 1351 1667 1422Q1670 1493 1662.50 1560.50Q1655 1628 1630.50 1691Q1606 1754 1552 1808L1552 1808Q1498 1862 1427 1891Q1356 1920 1280 1920L1280 1920L1280 1792Q1332 1792 1379 1771.50Q1426 1751 1460.50 1716.50Q1495 1682 1515.50 1635.50Q1536 1589 1536 1536L1536 1536Q1536 1480 1534 1425.50Q1532 1371 1533.50 1318.50Q1535 1266 1543 1216.50Q1551 1167 1570 1122Q1589 1077 1622 1036Q1655 995 1707 960L1707 960Q1655 925 1622 884Q1589 843 1570 798Q1551 753 1543 703.50Q1535 654 1533.50 601.50Q1532 549 1534 494.50Q1536 440 1536 384L1536 384Q1536 332 1515.50 285Q1495 238 1460.50 203.50Q1426 169 1379 148.50Q1332 128 1280 128L1280 128Z"
         }
      }
   ]
}

var LightningBolt = {
   name: "LightningBolt",
   vendor: "UiFabric",
   unicode: 59717,
   value: "",
   charCode: "E945",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1607 0L1223 768L1883 768L603 2048L313 2048L697 1280L248 1280L888 0L1607 0ZM520 1920L549 1920L1573 896L1016 896L1400 128L967 128L455 1152L904 1152L520 1920Z"
         }
      }
   ]
}

var Info = {
   name: "Info",
   vendor: "UiFabric",
   unicode: 59718,
   value: "",
   charCode: "E946",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0L960 0Q1093 0 1215.50 34Q1338 68 1445 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 475Q1852 582 1886 704.50Q1920 827 1920 960L1920 960Q1920 1093 1886 1215.50Q1852 1338 1789.50 1445Q1727 1552 1639.50 1639.50Q1552 1727 1445 1789.50Q1338 1852 1215.50 1886Q1093 1920 960 1920ZM960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739.50Q128 846 128 960L128 960Q128 1074 158 1180.50Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792L960 1792Q1074 1792 1180.50 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 846 1762 739.50Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1180.50 158Q1074 128 960 128ZM896 1408L896 768L1024 768L1024 1408L896 1408ZM896 640L896 512L1024 512L1024 640L896 640Z"
         }
      }
   ]
}

var CalculatorMultiply = {
   name: "CalculatorMultiply",
   vendor: "UiFabric",
   unicode: 59719,
   value: "",
   charCode: "E947",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1805 205L1805 205L1050 960L1805 1715L1715 1805L960 1050L205 1805L115 1715L870 960L115 205L205 115L960 870L1715 115L1805 205Z"
         }
      }
   ]
}

var CalculatorAddition = {
   name: "CalculatorAddition",
   vendor: "UiFabric",
   unicode: 59720,
   value: "",
   charCode: "E948",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 896L1920 896L1920 1024L1024 1024L1024 1920L896 1920L896 1024L0 1024L0 896L896 896L896 0L1024 0L1024 896L1920 896Z"
         }
      }
   ]
}

var CalculatorSubtract = {
   name: "CalculatorSubtract",
   vendor: "UiFabric",
   unicode: 59721,
   value: "",
   charCode: "E949",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 896L0 896L1920 896L1920 1024L0 1024L0 896Z"
         }
      }
   ]
}

var CalculatorPercentage = {
   name: "CalculatorPercentage",
   vendor: "UiFabric",
   unicode: 59724,
   value: "",
   charCode: "E94C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 384L768 384Q768 464 738 533.50Q708 603 655.50 655.50Q603 708 533 738Q463 768 384 768L384 768Q304 768 234.50 738Q165 708 112.50 655.50Q60 603 30 533.50Q0 464 0 384L0 384Q0 305 30 235Q60 165 112.50 112.50Q165 60 234.50 30Q304 0 384 0L384 0Q463 0 533 30Q603 60 655.50 112.50Q708 165 738 235Q768 305 768 384ZM384 640L384 640Q437 640 483.50 620Q530 600 565 565Q600 530 620 483.50Q640 437 640 384L640 384Q640 331 620 284.50Q600 238 565 203Q530 168 483.50 148Q437 128 384 128L384 128Q331 128 284.50 148Q238 168 203 203Q168 238 148 284.50Q128 331 128 384L128 384Q128 437 148 483.50Q168 530 203 565Q238 600 284.50 620Q331 640 384 640ZM1536 1152L1536 1152Q1615 1152 1685 1182Q1755 1212 1807.50 1264.50Q1860 1317 1890 1387Q1920 1457 1920 1536L1920 1536Q1920 1616 1890 1685.50Q1860 1755 1807.50 1807.50Q1755 1860 1685 1890Q1615 1920 1536 1920L1536 1920Q1456 1920 1386.50 1890Q1317 1860 1264.50 1807.50Q1212 1755 1182 1685.50Q1152 1616 1152 1536L1152 1536Q1152 1457 1182 1387Q1212 1317 1264.50 1264.50Q1317 1212 1386.50 1182Q1456 1152 1536 1152ZM1536 1792L1536 1792Q1589 1792 1635.50 1772Q1682 1752 1717 1717Q1752 1682 1772 1635.50Q1792 1589 1792 1536L1792 1536Q1792 1483 1772 1436.50Q1752 1390 1717 1355Q1682 1320 1635.50 1300Q1589 1280 1536 1280L1536 1280Q1483 1280 1436.50 1300Q1390 1320 1355 1355Q1320 1390 1300 1436.50Q1280 1483 1280 1536L1280 1536Q1280 1589 1300 1635.50Q1320 1682 1355 1717Q1390 1752 1436.50 1772Q1483 1792 1536 1792ZM1368 0L1512 0L552 1920L408 1920L1368 0Z"
         }
      }
   ]
}

var CalculatorEqualTo = {
   name: "CalculatorEqualTo",
   vendor: "UiFabric",
   unicode: 59726,
   value: "",
   charCode: "E94E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1408L0 1408L0 1280L1920 1280L1920 1408ZM0 640L0 512L1920 512L1920 640L0 640Z"
         }
      }
   ]
}

var PrintfaxPrinterFile = {
   name: "PrintfaxPrinterFile",
   vendor: "UiFabric",
   unicode: 59734,
   value: "",
   charCode: "E956",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM640 1280L1280 1280L1280 1408L1408 1408L1408 1024L1280 1024L1280 1152L640 1152L640 1024L512 1024L512 1408L640 1408L640 1280ZM1152 1408L768 1408L768 1536L1152 1536L1152 1408ZM768 1024L1152 1024L1152 640L768 640L768 1024ZM1280 219L1280 512L1573 512L1280 219ZM256 1920L1664 1920L1664 640L1280 640L1280 896L1536 896L1536 1536L1280 1536L1280 1664L640 1664L640 1536L384 1536L384 896L640 896L640 512L1152 512L1152 128L256 128L256 1920Z"
         }
      }
   ]
}

var StorageOptical = {
   name: "StorageOptical",
   vendor: "UiFabric",
   unicode: 59736,
   value: "",
   charCode: "E958",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1077 1260 1123.50Q1240 1170 1205 1205Q1170 1240 1123.50 1260Q1077 1280 1024 1280L1024 1280Q971 1280 924.50 1260Q878 1240 843 1205Q808 1170 788 1123.50Q768 1077 768 1024L768 1024Q768 971 788 924.50Q808 878 843 843Q878 808 924.50 788Q971 768 1024 768ZM1024 1152L1024 1152Q1051 1152 1074 1142Q1097 1132 1114.50 1114.50Q1132 1097 1142 1074Q1152 1051 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q997 896 974 906Q951 916 933.50 933.50Q916 951 906 974Q896 997 896 1024L896 1024Q896 1051 906 1074Q916 1097 933.50 1114.50Q951 1132 974 1142Q997 1152 1024 1152Z"
         }
      }
   ]
}

var Communications = {
   name: "Communications",
   vendor: "UiFabric",
   unicode: 59738,
   value: "",
   charCode: "E95A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 896L1024 896Q1076 896 1123 916.50Q1170 937 1204.50 971.50Q1239 1006 1259.50 1053Q1280 1100 1280 1152L1280 1152Q1280 1205 1259.50 1251.50Q1239 1298 1204.50 1332.50Q1170 1367 1123 1387.50Q1076 1408 1024 1408L1024 1408Q971 1408 924.50 1387.50Q878 1367 843.50 1332.50Q809 1298 788.50 1251.50Q768 1205 768 1152L768 1152Q768 1100 788.50 1053Q809 1006 843.50 971.50Q878 937 924.50 916.50Q971 896 1024 896ZM1024 1280L1024 1280Q1051 1280 1074 1270Q1097 1260 1114.50 1242.50Q1132 1225 1142 1202Q1152 1179 1152 1152L1152 1152Q1152 1125 1142 1102Q1132 1079 1114.50 1061.50Q1097 1044 1074 1034Q1051 1024 1024 1024L1024 1024Q997 1024 974 1034Q951 1044 933.50 1061.50Q916 1079 906 1102Q896 1125 896 1152L896 1152Q896 1179 906 1202Q916 1225 933.50 1242.50Q951 1260 974 1270Q997 1280 1024 1280ZM1024 128L1024 128Q1165 128 1295.50 164.50Q1426 201 1540 268Q1654 335 1747.50 428.50Q1841 522 1908 636Q1975 750 2011.50 880.50Q2048 1011 2048 1152L2048 1152Q2048 1254 2028 1352.50Q2008 1451 1970 1543.50Q1932 1636 1876 1720Q1820 1804 1748 1876L1748 1876L1658 1786Q1721 1723 1769.50 1649.50Q1818 1576 1851.50 1495Q1885 1414 1902.50 1327.50Q1920 1241 1920 1152L1920 1152Q1920 1028 1888 913.50Q1856 799 1797.50 699.50Q1739 600 1657.50 518.50Q1576 437 1476.50 378.50Q1377 320 1262.50 288Q1148 256 1024 256L1024 256Q900 256 785.50 288Q671 320 571.50 378.50Q472 437 390.50 518.50Q309 600 250.50 699.50Q192 799 160 913.50Q128 1028 128 1152L128 1152Q128 1241 145.50 1327.50Q163 1414 196.50 1495Q230 1576 278.50 1649.50Q327 1723 390 1786L390 1786L300 1876Q228 1804 172 1720Q116 1636 78 1543.50Q40 1451 20 1352.50Q0 1254 0 1152L0 1152Q0 1011 36.50 880.50Q73 750 140 636Q207 522 300.50 428.50Q394 335 508 268Q622 201 752.50 164.50Q883 128 1024 128ZM1024 512L1024 512Q1157 512 1273.50 562Q1390 612 1477 699Q1564 786 1614 902.50Q1664 1019 1664 1152L1664 1152Q1664 1280 1615.50 1397Q1567 1514 1477 1605L1477 1605L1386 1514Q1458 1442 1497 1348Q1536 1254 1536 1152L1536 1152Q1536 1046 1495.50 953Q1455 860 1385.50 790.50Q1316 721 1223 680.50Q1130 640 1024 640L1024 640Q918 640 825 680.50Q732 721 662.50 790.50Q593 860 552.50 953Q512 1046 512 1152L512 1152Q512 1254 551 1348Q590 1442 662 1514L662 1514L571 1605Q481 1514 432.50 1397Q384 1280 384 1152L384 1152Q384 1019 434 902.50Q484 786 571 699Q658 612 774.50 562Q891 512 1024 512Z"
         }
      }
   ]
}

var FlashAuto = {
   name: "FlashAuto",
   vendor: "UiFabric",
   unicode: 59740,
   value: "",
   charCode: "E95C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1607 0L1223 768L1883 768L603 2048L313 2048L697 1280L248 1280L888 0L1607 0ZM520 1920L549 1920L1573 896L1016 896L1400 128L967 128L455 1152L904 1152L520 1920ZM1146 2048L1466 1408L1666 1408L1794 2048L1664 2048L1638 1920L1353 1920L1289 2048L1146 2048ZM1557 1512L1417 1792L1613 1792L1557 1512Z"
         }
      }
   ]
}

var Health = {
   name: "Health",
   vendor: "UiFabric",
   unicode: 59742,
   value: "",
   charCode: "E95E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M576 794L347 1024L308 1024L1024 1740L1612 1152L1793 1152L1024 1921L159 1057Q124 1022 97 981.50Q70 941 50 896L50 896L293 896L576 614L1024 1061L1344 742L1499 896L1854 896Q1886 845 1903 788Q1920 731 1920 671L1920 671Q1920 584 1887.50 509Q1855 434 1798.50 378.50Q1742 323 1666.50 291.50Q1591 260 1504 260L1504 260Q1420 260 1355 286.50Q1290 313 1235 356Q1180 399 1129.50 453.50Q1079 508 1024 564L1024 564Q970 510 919 455Q868 400 812.50 356Q757 312 691.50 284Q626 256 544 256L544 256Q458 256 382.50 288.50Q307 321 250.50 377.50Q194 434 161.50 509.50Q129 585 129 671L129 671Q129 718 140 768L140 768L9 768Q4 744 2.50 720Q1 696 1 672L1 672Q1 559 43.50 460Q86 361 159.50 287Q233 213 332 170.50Q431 128 544 128L544 128Q627 128 692 147Q757 166 812.50 199.50Q868 233 918.50 280Q969 327 1024 383L1024 383Q1079 327 1129.50 280Q1180 233 1235.50 199.50Q1291 166 1356 147Q1421 128 1504 128L1504 128Q1616 128 1715 170.50Q1814 213 1887.50 286Q1961 359 2003.50 458Q2046 557 2046 669L2046 669Q2046 766 2012 857.50Q1978 949 1915 1024L1915 1024L1445 1024L1344 922L1024 1243L576 794Z"
         }
      }
   ]
}

var Webcam2 = {
   name: "Webcam2",
   vendor: "UiFabric",
   unicode: 59744,
   value: "",
   charCode: "E960",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 896L1920 896Q1920 1044 1873.50 1181Q1827 1318 1742.50 1431.50Q1658 1545 1540 1629Q1422 1713 1280 1755L1280 1755L1280 1920L1664 1920L1664 2048L384 2048L384 1920L768 1920L768 1755Q625 1713 507.50 1629Q390 1545 305.50 1431.50Q221 1318 174.50 1181Q128 1044 128 896L128 896Q128 772 160 657.50Q192 543 250.50 443.50Q309 344 390.50 262.50Q472 181 571.50 122.50Q671 64 785.50 32Q900 0 1024 0L1024 0Q1148 0 1262.50 32Q1377 64 1476.50 122.50Q1576 181 1657.50 262.50Q1739 344 1797.50 443.50Q1856 543 1888 657.50Q1920 772 1920 896ZM1024 128L1024 128Q918 128 820 155.50Q722 183 636.50 233Q551 283 481 353Q411 423 361 508.50Q311 594 283.50 692Q256 790 256 896L256 896L576 896Q576 803 611 721.50Q646 640 707 579Q768 518 849.50 483Q931 448 1024 448L1024 448Q1117 448 1198.50 483Q1280 518 1341 579Q1402 640 1437 721.50Q1472 803 1472 896L1472 896L1792 896Q1792 790 1764.50 692Q1737 594 1687 508.50Q1637 423 1567 353Q1497 283 1411.50 233Q1326 183 1228 155.50Q1130 128 1024 128ZM1344 896L1344 896Q1344 830 1319 771.50Q1294 713 1250.50 669.50Q1207 626 1148.50 601Q1090 576 1024 576L1024 576Q958 576 899.50 601Q841 626 797.50 669.50Q754 713 729 771.50Q704 830 704 896L704 896Q704 962 729 1020.50Q754 1079 797.50 1122.50Q841 1166 899.50 1191Q958 1216 1024 1216L1024 1216Q1090 1216 1148.50 1191Q1207 1166 1250.50 1122.50Q1294 1079 1319 1020.50Q1344 962 1344 896ZM595 1024L267 1024Q282 1116 318.50 1199.50Q355 1283 408 1354Q461 1425 528.50 1482.50Q596 1540 675 1580Q754 1620 842 1642Q930 1664 1024 1664L1024 1664Q1117 1664 1205.50 1642Q1294 1620 1373 1580Q1452 1540 1519.50 1482.50Q1587 1425 1640 1354Q1693 1283 1729 1199.50Q1765 1116 1781 1024L1781 1024L1453 1024Q1433 1095 1391 1154Q1349 1213 1292 1255Q1235 1297 1166 1320.50Q1097 1344 1024 1344L1024 1344Q950 1344 881.50 1320.50Q813 1297 756 1255Q699 1213 657 1154Q615 1095 595 1024L595 1024ZM896 1920L1152 1920L1152 1783Q1089 1792 1024 1792L1024 1792Q959 1792 896 1783L896 1783L896 1920Z"
         }
      }
   ]
}

var FrontCamera = {
   name: "FrontCamera",
   vendor: "UiFabric",
   unicode: 59755,
   value: "",
   charCode: "E96B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1258 1198L1258 1198Q1349 1234 1424 1294.50Q1499 1355 1552.50 1432.50Q1606 1510 1635 1601.50Q1664 1693 1664 1792L1664 1792L1536 1792Q1536 1686 1495.50 1593Q1455 1500 1385.50 1430.50Q1316 1361 1223 1320.50Q1130 1280 1024 1280L1024 1280Q918 1280 825 1320.50Q732 1361 662.50 1430.50Q593 1500 552.50 1593Q512 1686 512 1792L512 1792L384 1792Q384 1693 413 1601.50Q442 1510 495.50 1432.50Q549 1355 623.50 1294.50Q698 1234 790 1198L790 1198Q719 1144 679.50 1065Q640 986 640 896L640 896Q640 817 670 747Q700 677 752.50 624.50Q805 572 874.50 542Q944 512 1024 512L1024 512Q1103 512 1173 542Q1243 572 1295.50 624.50Q1348 677 1378 747Q1408 817 1408 896L1408 896Q1408 986 1368.50 1065Q1329 1144 1258 1198ZM768 896L768 896Q768 949 788 995.50Q808 1042 843 1077Q878 1112 924.50 1132Q971 1152 1024 1152L1024 1152Q1077 1152 1123.50 1132Q1170 1112 1205 1077Q1240 1042 1260 995.50Q1280 949 1280 896L1280 896Q1280 843 1260 796.50Q1240 750 1205 715Q1170 680 1123.50 660Q1077 640 1024 640L1024 640Q971 640 924.50 660Q878 680 843 715Q808 750 788 796.50Q768 843 768 896ZM0 256L2048 256L2048 1536L1781 1536Q1770 1503 1756 1471Q1742 1439 1725 1408L1725 1408L1920 1408L1920 384L128 384L128 1408L323 1408Q306 1439 292 1471Q278 1503 267 1536L267 1536L0 1536L0 256Z"
         }
      }
   ]
}

var ChevronUpSmall = {
   name: "ChevronUpSmall",
   vendor: "UiFabric",
   unicode: 59757,
   value: "",
   charCode: "E96D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 441L1024 441L2041 1458L1799 1699L1024 924L249 1699L7 1458L1024 441Z"
         }
      }
   ]
}

var ChevronDownSmall = {
   name: "ChevronDownSmall",
   vendor: "UiFabric",
   unicode: 59758,
   value: "",
   charCode: "E96E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1799 349L1799 349L2041 590L1024 1607L7 590L249 349L1024 1124L1799 349Z"
         }
      }
   ]
}

var ChevronLeftSmall = {
   name: "ChevronLeftSmall",
   vendor: "UiFabric",
   unicode: 59759,
   value: "",
   charCode: "E96F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1699 249L1699 249L924 1024L1699 1799L1458 2041L441 1024L1458 7L1699 249Z"
         }
      }
   ]
}

var CommandPrompt = {
   name: "CommandPrompt",
   vendor: "UiFabric",
   unicode: 59222,
   value: "",
   charCode: "E756",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1792L0 1792L0 128ZM1920 256L128 256L128 384L1920 384L1920 256ZM128 1664L1920 1664L1920 512L128 512L128 1664ZM1301 768L1392 768L1649 1408L1558 1408L1301 768ZM736 844L736 844Q683 844 639.50 860.50Q596 877 565.50 908.50Q535 940 518 986.50Q501 1033 501 1092L501 1092Q501 1147 516.50 1192Q532 1237 561.50 1268.50Q591 1300 634 1317Q677 1334 732 1334L732 1334Q767 1334 801.50 1327Q836 1320 859 1309L859 1309L875 1371Q853 1382 812 1390.50Q771 1399 716 1399L716 1399Q653 1399 598.50 1379Q544 1359 504 1320.50Q464 1282 441.50 1225.50Q419 1169 419 1095L419 1095Q419 1025 442 966.50Q465 908 506.50 866.50Q548 825 605.50 802Q663 779 733 779L733 779Q790 779 825 788.50Q860 798 876 806L876 806L857 869Q835 858 804.50 851Q774 844 736 844ZM1024 1024L1024 896L1152 896L1152 1024L1024 1024ZM1024 1280L1024 1152L1152 1152L1152 1280L1024 1280Z"
         }
      }
   ]
}

var ChevronRightSmall = {
   name: "ChevronRightSmall",
   vendor: "UiFabric",
   unicode: 59760,
   value: "",
   charCode: "E970",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M590 7L590 7L1607 1024L590 2041L349 1799L1124 1024L349 249L590 7Z"
         }
      }
   ]
}

var ChevronUpMed = {
   name: "ChevronUpMed",
   vendor: "UiFabric",
   unicode: 59761,
   value: "",
   charCode: "E971",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1902 1511L1902 1511L1024 633L146 1511L25 1390L1024 391L2023 1390L1902 1511Z"
         }
      }
   ]
}

var ChevronDownMed = {
   name: "ChevronDownMed",
   vendor: "UiFabric",
   unicode: 59762,
   value: "",
   charCode: "E972",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1657L1024 1657L25 658L146 537L1024 1415L1902 537L2023 658L1024 1657Z"
         }
      }
   ]
}

var ChevronLeftMed = {
   name: "ChevronLeftMed",
   vendor: "UiFabric",
   unicode: 59763,
   value: "",
   charCode: "E973",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1390 2023L1390 2023L391 1024L1390 25L1511 146L633 1024L1511 1902L1390 2023Z"
         }
      }
   ]
}

var ChevronRightMed = {
   name: "ChevronRightMed",
   vendor: "UiFabric",
   unicode: 59764,
   value: "",
   charCode: "E974",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M658 2023L658 2023L537 1902L1415 1024L537 146L658 25L1657 1024L658 2023Z"
         }
      }
   ]
}

var Devices2 = {
   name: "Devices2",
   vendor: "UiFabric",
   unicode: 59765,
   value: "",
   charCode: "E975",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 894L2048 1663Q2048 1690 2038 1713.50Q2028 1737 2010.50 1754.50Q1993 1772 1970 1782Q1947 1792 1920 1792L1920 1792L896 1792Q869 1792 846 1782Q823 1772 805.50 1754.50Q788 1737 778 1714Q768 1691 768 1664L768 1664L768 1536L122 1536Q97 1536 74.50 1526.50Q52 1517 35.50 1500.50Q19 1484 9.50 1461.50Q0 1439 0 1414L0 1414Q0 1379 11.50 1344Q23 1309 47 1283L47 1283L256 1063L256 256L1664 256L1664 768L1920 768Q1946 768 1969 778Q1992 788 2009.50 805Q2027 822 2037.50 845Q2048 868 2048 894L2048 894ZM128 1408L768 1408L768 1152L348 1152L142 1369Q136 1376 132.50 1387.50Q129 1399 128 1408L128 1408ZM768 1024L768 896Q768 869 778 846Q788 823 805.50 805.50Q823 788 846 778Q869 768 896 768L896 768L1536 768L1536 384L384 384L384 1024L768 1024ZM896 1664L1920 1664L1920 896L896 896L896 1664ZM1280 1536L1280 1408L1536 1408L1536 1536L1280 1536Z"
         }
      }
   ]
}

var PC1 = {
   name: "PC1",
   vendor: "UiFabric",
   unicode: 59767,
   value: "",
   charCode: "E977",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 640L2048 1536L1408 1536L1408 1664L1664 1664L1664 1792L1024 1792L1024 1664L1280 1664L1280 1536L896 1536L896 1792L0 1792L0 128L896 128L896 640L2048 640ZM768 1408L1920 1408L1920 768L768 768L768 1408ZM128 1664L768 1664L768 1536L256 1536L256 1408L640 1408L640 1280L256 1280L256 1152L640 1152L640 640L768 640L768 256L128 256L128 1664ZM256 384L640 384L640 512L256 512L256 384Z"
         }
      }
   ]
}

var PresenceChickletVideo = {
   name: "PresenceChickletVideo",
   vendor: "UiFabric",
   unicode: 59769,
   value: "",
   charCode: "E979",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 760L1536 760L2048 504L2048 1544L1536 1288L1536 1536L0 1536L0 512L1536 512L1536 760Z"
         }
      }
   ]
}

var Reply = {
   name: "Reply",
   vendor: "UiFabric",
   unicode: 59770,
   value: "",
   charCode: "E97A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M475 640L1152 640Q1280 640 1397 688Q1514 736 1605 827L1605 827Q1696 918 1744 1035Q1792 1152 1792 1280L1792 1280Q1792 1413 1742 1529.50Q1692 1646 1605 1733Q1518 1820 1401.50 1870Q1285 1920 1152 1920L1152 1920L1152 1792Q1258 1792 1351 1751.50Q1444 1711 1513.50 1641.50Q1583 1572 1623.50 1479Q1664 1386 1664 1280L1664 1280Q1664 1174 1623.50 1081Q1583 988 1513.50 918.50Q1444 849 1351 808.50Q1258 768 1152 768L1152 768L475 768L877 1171L787 1261L230 704L787 147L877 237L475 640Z"
         }
      }
   ]
}

var HalfAlpha = {
   name: "HalfAlpha",
   vendor: "UiFabric",
   unicode: 59774,
   value: "",
   charCode: "E97E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M950 128L1105 128L1745 2048L1610 2048L1439 1536L615 1536L445 2048L310 2048L950 128ZM1027 300L658 1408L1397 1408L1027 300Z"
         }
      }
   ]
}

var ConstructionCone = {
   name: "ConstructionCone",
   vendor: "UiFabric",
   unicode: 59791,
   value: "",
   charCode: "E98F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1202 128L1650 1920L1920 1920L1920 2048L128 2048L128 1920L398 1920L846 128L1202 128ZM1296 1536L626 1536L530 1920L1518 1920L1102 256L946 256L754 1024L1168 1024L1200 1152L722 1152L658 1408L1264 1408L1296 1536Z"
         }
      }
   ]
}

var DoubleChevronLeftMed = {
   name: "DoubleChevronLeftMed",
   vendor: "UiFabric",
   unicode: 59793,
   value: "",
   charCode: "E991",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1049 25L1170 146L291 1024L1170 1902L1049 2023L50 1024L1049 25ZM1902 25L2023 146L1145 1024L2023 1902L1902 2023L903 1024L1902 25Z"
         }
      }
   ]
}

var Volume0 = {
   name: "Volume0",
   vendor: "UiFabric",
   unicode: 59794,
   value: "",
   charCode: "E992",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M293 640L677 256L768 256L768 1792L678 1792L293 1408L0 1408L0 640L293 640ZM347 1280L640 1573L640 475L347 768L128 768L128 1280L347 1280Z"
         }
      }
   ]
}

var Volume1 = {
   name: "Volume1",
   vendor: "UiFabric",
   unicode: 59795,
   value: "",
   charCode: "E993",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1040 752L1130 662Q1203 735 1241.50 828Q1280 921 1280 1024L1280 1024Q1280 1127 1241.50 1220Q1203 1313 1130 1386L1130 1386L1040 1296Q1094 1242 1123 1171.50Q1152 1101 1152 1024L1152 1024Q1152 947 1123 876.50Q1094 806 1040 752L1040 752ZM293 640L677 256L768 256L768 1792L678 1792L293 1408L0 1408L0 640L293 640ZM640 1573L640 475L347 768L128 768L128 1280L347 1280L640 1573Z"
         }
      }
   ]
}

var Volume2 = {
   name: "Volume2",
   vendor: "UiFabric",
   unicode: 59796,
   value: "",
   charCode: "E994",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1311 481L1402 390Q1528 518 1596 681Q1664 844 1664 1024L1664 1024Q1664 1204 1596 1367Q1528 1530 1402 1658L1402 1658L1311 1567Q1420 1458 1478 1318Q1536 1178 1536 1024L1536 1024Q1536 870 1478 730Q1420 590 1311 481L1311 481ZM1040 752L1130 662Q1203 735 1241.50 828Q1280 921 1280 1024L1280 1024Q1280 1127 1241.50 1220Q1203 1313 1130 1386L1130 1386L1040 1296Q1094 1242 1123 1171.50Q1152 1101 1152 1024L1152 1024Q1152 947 1123 876.50Q1094 806 1040 752L1040 752ZM293 640L677 256L768 256L768 1792L678 1792L293 1408L0 1408L0 640L293 640ZM640 1573L640 475L347 768L128 768L128 1280L347 1280L640 1573Z"
         }
      }
   ]
}

var Volume3 = {
   name: "Volume3",
   vendor: "UiFabric",
   unicode: 59797,
   value: "",
   charCode: "E995",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1582 210L1673 119Q1763 209 1833 314Q1903 419 1950.50 534Q1998 649 2023 773Q2048 897 2048 1024L2048 1024Q2048 1152 2023 1275.50Q1998 1399 1950.50 1514Q1903 1629 1833 1734Q1763 1839 1673 1929L1673 1929L1582 1838Q1663 1757 1726 1662.50Q1789 1568 1832 1464.50Q1875 1361 1897 1250Q1919 1139 1919 1024L1919 1024Q1919 909 1897 798Q1875 687 1832 583.50Q1789 480 1726 385.50Q1663 291 1582 210L1582 210ZM1664 1024L1664 1024Q1664 1204 1596 1367Q1528 1530 1402 1658L1402 1658L1311 1567Q1420 1458 1478 1318Q1536 1178 1536 1024L1536 1024Q1536 870 1478 730Q1420 590 1311 481L1311 481L1402 390Q1528 518 1596 681Q1664 844 1664 1024ZM1040 752L1130 662Q1203 735 1241.50 828Q1280 921 1280 1024L1280 1024Q1280 1127 1241.50 1220Q1203 1313 1130 1386L1130 1386L1040 1296Q1094 1242 1123 1171.50Q1152 1101 1152 1024L1152 1024Q1152 947 1123 876.50Q1094 806 1040 752L1040 752ZM293 640L677 256L768 256L768 1792L678 1792L293 1408L0 1408L0 640L293 640ZM640 1573L640 475L347 768L128 768L128 1280L347 1280L640 1573Z"
         }
      }
   ]
}

var Chart = {
   name: "Chart",
   vendor: "UiFabric",
   unicode: 59801,
   value: "",
   charCode: "E999",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 512L1408 512L1920 512L1920 1024L1792 1024L1792 731L1216 1306L960 1050L256 1755L256 1792L1920 1792L1920 1920L128 1920L128 128L256 128L256 1573L960 870L1216 1126L1701 640L1408 640L1408 512Z"
         }
      }
   ]
}

var Robot = {
   name: "Robot",
   vendor: "UiFabric",
   unicode: 59802,
   value: "",
   charCode: "E99A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 896L640 768L768 768L768 896L640 896ZM1152 896L1152 768L1280 768L1280 896L1152 896ZM1280 1408L1621 1408Q1656 1408 1687 1421.50Q1718 1435 1741.50 1458.50Q1765 1482 1778.50 1513Q1792 1544 1792 1579L1792 1579L1792 2048L1664 2048L1664 1579Q1664 1561 1651.50 1548.50Q1639 1536 1621 1536L1621 1536L299 1536Q281 1536 268.50 1548.50Q256 1561 256 1579L256 1579L256 2048L128 2048L128 1579Q128 1544 141.50 1513Q155 1482 178 1458.50Q201 1435 232.50 1421.50Q264 1408 299 1408L299 1408L640 1408L640 1280L555 1280Q520 1280 488.50 1266.50Q457 1253 434 1230Q411 1207 397.50 1175.50Q384 1144 384 1109L384 1109L384 1024L256 1024L256 768L384 768L384 683Q384 648 397.50 617Q411 586 434 562.50Q457 539 488.50 525.50Q520 512 555 512L555 512L896 512L896 303Q867 286 849.50 256Q832 226 832 192L832 192Q832 165 842 142Q852 119 869.50 101.50Q887 84 910 74Q933 64 960 64L960 64Q987 64 1010 74Q1033 84 1050.50 101.50Q1068 119 1078 142Q1088 165 1088 192L1088 192Q1088 226 1070.50 256Q1053 286 1024 303L1024 303L1024 512L1365 512Q1400 512 1431 525.50Q1462 539 1485.50 562.50Q1509 586 1522.50 617Q1536 648 1536 683L1536 683L1536 768L1664 768L1664 1024L1536 1024L1536 1109Q1536 1144 1522.50 1175.50Q1509 1207 1485.50 1230Q1462 1253 1431 1266.50Q1400 1280 1365 1280L1365 1280L1280 1280L1280 1408ZM512 683L512 1109Q512 1127 524.50 1139.50Q537 1152 555 1152L555 1152L1365 1152Q1383 1152 1395.50 1139.50Q1408 1127 1408 1109L1408 1109L1408 683Q1408 665 1395.50 652.50Q1383 640 1365 640L1365 640L555 640Q537 640 524.50 652.50Q512 665 512 683L512 683ZM768 1280L768 1408L1152 1408L1152 1280L768 1280Z"
         }
      }
   ]
}

var Manufacturing = {
   name: "Manufacturing",
   vendor: "UiFabric",
   unicode: 59804,
   value: "",
   charCode: "E99C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1901 1171L2048 1317L2048 1536L1920 1536L1920 1371L1811 1261L1814 1258Q1774 1280 1725 1280L1725 1280Q1681 1280 1644 1262L1644 1262L1536 1371L1536 1536L1408 1536L1408 1317L1553 1173L1550 1166L1299 604L891 1025Q893 1041 894.50 1056.50Q896 1072 896 1088L896 1088L896 1920L1024 1920L1024 2048L0 2048L0 1920L128 1920L128 1088Q128 1012 156 944.50Q184 877 232.50 825.50Q281 774 346.50 742Q412 710 488 705L488 705L1096 78Q1132 40 1180 20Q1228 0 1280 0L1280 0Q1315 0 1350.50 10.50Q1386 21 1417.50 40.50Q1449 60 1474 86.50Q1499 113 1514 146L1514 146L1898 1004Q1907 1024 1911 1045Q1915 1066 1915 1087L1915 1087Q1915 1111 1909.50 1134.50Q1904 1158 1893 1179L1893 1179L1901 1171ZM256 1920L768 1920L768 1088Q768 1035 748 988.50Q728 942 693 907Q658 872 611.50 852Q565 832 512 832L512 832Q459 832 412.50 852Q366 872 331 907Q296 942 276 988.50Q256 1035 256 1088L256 1088L256 1920ZM1188 167L644 727Q706 750 757 792Q808 834 842 891L842 891L1372 345Q1408 307 1408 256L1408 256Q1408 229 1398 206Q1388 183 1370.50 165.50Q1353 148 1330 138Q1307 128 1280 128L1280 128Q1225 128 1188 167L1188 167ZM1709 896L1489 403Q1471 432 1444.50 456.50Q1418 481 1395 505L1395 505L1592 946L1709 896ZM1725 1152L1725 1152Q1754 1152 1771 1133Q1788 1114 1788 1087L1788 1087Q1788 1067 1778.50 1048.50Q1769 1030 1761 1013L1761 1013L1644 1063Q1650 1078 1656 1094Q1662 1110 1671 1123Q1680 1136 1692.50 1144Q1705 1152 1725 1152ZM512 1024L512 1024Q539 1024 562 1034Q585 1044 602.50 1061.50Q620 1079 630 1102Q640 1125 640 1152L640 1152Q640 1179 630 1202Q620 1225 602.50 1242.50Q585 1260 562 1270Q539 1280 512 1280L512 1280Q485 1280 462 1270Q439 1260 421.50 1242.50Q404 1225 394 1202Q384 1179 384 1152L384 1152Q384 1125 394 1102Q404 1079 421.50 1061.50Q439 1044 462 1034Q485 1024 512 1024Z"
         }
      }
   ]
}

var LockSolid = {
   name: "LockSolid",
   vendor: "UiFabric",
   unicode: 59810,
   value: "",
   charCode: "E9A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 896L1792 896L1792 2048L256 2048L256 896L512 896L512 522Q512 414 551 319Q590 224 659 153Q728 82 821.50 41Q915 0 1024 0L1024 0Q1133 0 1226.50 41Q1320 82 1389 153Q1458 224 1497 319Q1536 414 1536 522L1536 522L1536 896ZM640 522L640 896L1408 896L1408 522Q1408 441 1379 369.50Q1350 298 1298.50 244Q1247 190 1176.50 159Q1106 128 1024 128L1024 128Q942 128 871.50 159Q801 190 749.50 244Q698 298 669 369.50Q640 441 640 522L640 522Z"
         }
      }
   ]
}

var FitPage = {
   name: "FitPage",
   vendor: "UiFabric",
   unicode: 59814,
   value: "",
   charCode: "E9A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 896L1664 896L1664 640L1408 640L1408 512L1792 512L1792 896ZM640 640L384 640L384 896L256 896L256 512L640 512L640 640ZM1664 1152L1792 1152L1792 1536L1408 1536L1408 1408L1664 1408L1664 1152ZM384 1408L640 1408L640 1536L256 1536L256 1152L384 1152L384 1408ZM0 1792L0 256L2048 256L2048 1792L0 1792ZM128 1664L1920 1664L1920 384L128 384L128 1664Z"
         }
      }
   ]
}

var FitWidth = {
   name: "FitWidth",
   vendor: "UiFabric",
   unicode: 59815,
   value: "",
   charCode: "E9A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 256L2048 256L2048 1792L0 1792ZM128 1664L1920 1664L1920 384L128 384L128 1664ZM470 1024L555 1109L469 1195L233 960L469 725L555 811L470 896L896 896L896 1024L470 1024ZM1579 1195L1493 1109L1578 1024L1152 1024L1152 896L1578 896L1493 811L1579 725L1815 960L1579 1195Z"
         }
      }
   ]
}

var BidiLtr = {
   name: "BidiLtr",
   vendor: "UiFabric",
   unicode: 59818,
   value: "",
   charCode: "E9AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1818L128 486L794 1152L128 1818ZM256 794L256 1510L614 1152L256 794ZM1920 256L1792 256L1792 1792L1920 1792L1920 1920L1280 1920L1280 1792L1408 1792L1408 1024L1216 1024Q1123 1024 1041.50 989Q960 954 899 893Q838 832 803 750.50Q768 669 768 576L768 576Q768 483 803 401.50Q838 320 899 259Q960 198 1041.50 163Q1123 128 1216 128L1216 128L1920 128L1920 256ZM1216 896L1408 896L1408 256L1216 256Q1150 256 1091.50 281.50Q1033 307 989.50 350.50Q946 394 921 452Q896 510 896 576L896 576Q896 642 921 700.50Q946 759 989.50 802.50Q1033 846 1091.50 871Q1150 896 1216 896L1216 896ZM1536 1792L1664 1792L1664 256L1536 256L1536 1792Z"
         }
      }
   ]
}

var BidiRtl = {
   name: "BidiRtl",
   vendor: "UiFabric",
   unicode: 59819,
   value: "",
   charCode: "E9AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 128L1152 128L1152 256L1024 256L1024 1792L1152 1792L1152 1920L512 1920L512 1792L640 1792L640 1024L448 1024Q355 1024 273.50 989Q192 954 131 893Q70 832 35 750.50Q0 669 0 576L0 576Q0 483 35 401.50Q70 320 131 259Q192 198 273.50 163Q355 128 448 128L448 128ZM448 896L640 896L640 256L448 256Q382 256 323.50 281.50Q265 307 221.50 350.50Q178 394 153 452Q128 510 128 576L128 576Q128 642 153 700.50Q178 759 221.50 802.50Q265 846 323.50 871Q382 896 448 896L448 896ZM768 1792L896 1792L896 256L768 256L768 1792ZM1254 1152L1920 486L1920 1818L1254 1152ZM1792 1510L1792 794L1434 1152L1792 1510Z"
         }
      }
   ]
}

var RightDoubleQuote = {
   name: "RightDoubleQuote",
   vendor: "UiFabric",
   unicode: 59825,
   value: "",
   charCode: "E9B1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 409L0 66L332 66L332 409Q332 460 325 514Q318 568 302 618.50Q286 669 260.50 714Q235 759 199 792.50Q163 826 114.50 845.50Q66 865 5 865L5 865L5 708Q42 708 69.50 693.50Q97 679 116 655.50Q135 632 146.50 601Q158 570 164.50 537Q171 504 173.50 470.50Q176 437 176 409L176 409L0 409ZM546 66L875 66L875 409Q875 487 859 568Q843 649 805 715Q767 781 704.50 823Q642 865 548 865L548 865L548 708Q603 708 637.50 677.50Q672 647 690.50 601.50Q709 556 715.50 504Q722 452 722 409L722 409L546 409L546 66Z"
         }
      }
   ]
}

var Headset = {
   name: "Headset",
   vendor: "UiFabric",
   unicode: 59739,
   value: "",
   charCode: "E95B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1130 0 1228 27.50Q1326 55 1411.50 105Q1497 155 1567 225Q1637 295 1687 380.50Q1737 466 1764.50 564Q1792 662 1792 768L1792 768L1792 1216Q1792 1256 1777 1291Q1762 1326 1736 1352Q1710 1378 1675 1393Q1640 1408 1600 1408L1600 1408L1408 1408L1408 768L1600 768Q1617 768 1633 771.50Q1649 775 1664 780L1664 780Q1664 645 1615 526.50Q1566 408 1480.50 319.50Q1395 231 1277.50 179.50Q1160 128 1024 128L1024 128Q936 128 854 151Q772 174 701 215.50Q630 257 571.50 315.50Q513 374 471.50 445Q430 516 407 598Q384 680 384 768L384 768L384 780Q399 775 415 771.50Q431 768 448 768L448 768L640 768L640 1408L512 1408L512 1536Q512 1589 532 1635.50Q552 1682 587 1717Q622 1752 668.50 1772Q715 1792 768 1792L768 1792Q768 1765 778 1742Q788 1719 805.50 1701.50Q823 1684 846 1674Q869 1664 896 1664L896 1664L1152 1664Q1179 1664 1202 1674Q1225 1684 1242.50 1701.50Q1260 1719 1270 1742Q1280 1765 1280 1792L1280 1792L1280 1920Q1280 1947 1270 1970Q1260 1993 1242.50 2010.50Q1225 2028 1202 2038Q1179 2048 1152 2048L1152 2048L896 2048Q869 2048 846 2038Q823 2028 805.50 2010.50Q788 1993 778 1970Q768 1947 768 1920L768 1920Q688 1920 618.50 1890Q549 1860 496.50 1807.50Q444 1755 414 1685.50Q384 1616 384 1536L384 1536L384 1396Q355 1386 331.50 1368Q308 1350 291.50 1326.50Q275 1303 265.50 1274.50Q256 1246 256 1216L256 1216L256 768Q256 662 283.50 564Q311 466 361 380.50Q411 295 481 225Q551 155 636.50 105Q722 55 820 27.50Q918 0 1024 0ZM896 1792L896 1920L1152 1920L1152 1792L896 1792ZM512 896L448 896Q422 896 403 915Q384 934 384 960L384 960L384 1216Q384 1242 403 1261Q422 1280 448 1280L448 1280L512 1280L512 896ZM1664 1216L1664 960Q1664 934 1645 915Q1626 896 1600 896L1600 896L1536 896L1536 1280L1600 1280Q1626 1280 1645 1261Q1664 1242 1664 1216L1664 1216Z"
         }
      }
   ]
}

var Sunny = {
   name: "Sunny",
   vendor: "UiFabric",
   unicode: 59837,
   value: "",
   charCode: "E9BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960L1408 960Q1408 1053 1373 1134.50Q1338 1216 1277 1277Q1216 1338 1134.50 1373Q1053 1408 960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1024 0L1024 384L896 384L896 0L1024 0ZM896 1920L896 1536L1024 1536L1024 1920L896 1920ZM1536 896L1920 896L1920 1024L1536 1024L1536 896ZM384 896L384 1024L0 1024L0 896L384 896ZM598 507L507 598L236 326L326 236L598 507ZM1322 1413L1413 1322L1684 1594L1594 1684L1322 1413ZM1684 326L1413 598L1322 507L1594 236L1684 326ZM236 1594L507 1322L598 1413L326 1684L236 1594Z"
         }
      }
   ]
}

var CloudWeather = {
   name: "CloudWeather",
   vendor: "UiFabric",
   unicode: 59838,
   value: "",
   charCode: "E9BE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1661 896L1661 896Q1741 896 1811.50 926Q1882 956 1934.50 1007.50Q1987 1059 2017.50 1129Q2048 1199 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664L512 1664Q406 1664 312.50 1624Q219 1584 149.50 1514.50Q80 1445 40 1351.50Q0 1258 0 1152L0 1152Q0 1046 40 952.50Q80 859 149.50 789.50Q219 720 312.50 680Q406 640 512 640L512 640Q558 640 605 649L605 649Q645 587 697.50 537.50Q750 488 812 454Q874 420 944 402Q1014 384 1088 384L1088 384Q1199 384 1297.50 423Q1396 462 1472 530.50Q1548 599 1597.50 693Q1647 787 1661 896ZM512 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024L1536 1024L1536 960Q1536 867 1501 785.50Q1466 704 1405 643Q1344 582 1262.50 547Q1181 512 1088 512L1088 512Q1018 512 953 533Q888 554 833.50 592Q779 630 737 683.50Q695 737 670 803L670 803Q595 768 512 768L512 768Q432 768 362.50 798Q293 828 240.50 880.50Q188 933 158 1003Q128 1073 128 1152L128 1152Q128 1232 158 1301.50Q188 1371 240.50 1423.50Q293 1476 362.50 1506Q432 1536 512 1536L512 1536Z"
         }
      }
   ]
}

var Cloudy = {
   name: "Cloudy",
   vendor: "UiFabric",
   unicode: 59839,
   value: "",
   charCode: "E9BF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1825 1054 1877.50 1089.50Q1930 1125 1968 1173.50Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L576 1792Q483 1792 401.50 1757Q320 1722 259 1661Q198 1600 163 1518.50Q128 1437 128 1344L128 1344Q128 1269 152 1200L152 1200Q81 1146 40.50 1066Q0 986 0 896L0 896Q0 817 30 747Q60 677 112.50 624.50Q165 572 234.50 542Q304 512 384 512L384 512Q395 512 405.50 512.50Q416 513 427 514L427 514Q454 454 496.50 406.50Q539 359 591.50 325.50Q644 292 705.50 274Q767 256 832 256L832 256Q916 256 991.50 285.50Q1067 315 1126.50 366.50Q1186 418 1225.50 489Q1265 560 1276 643L1276 643Q1360 651 1436.50 683.50Q1513 716 1576.50 768Q1640 820 1687.50 888Q1735 956 1761 1036ZM384 640L384 640Q331 640 284.50 660Q238 680 203 715Q168 750 148 796.50Q128 843 128 896L128 896Q128 950 149.50 998.50Q171 1047 211 1084L211 1084Q274 995 370.50 945.50Q467 896 576 896L576 896Q614 896 651 902Q688 908 723 921L723 921Q755 864 801 817Q847 770 902 734Q957 698 1019 675Q1081 652 1146 644L1146 644Q1135 588 1106.50 540Q1078 492 1036 457.50Q994 423 941.50 403.50Q889 384 832 384L832 384Q770 384 714.50 406.50Q659 429 616.50 468.50Q574 508 547 561.50Q520 615 515 677L515 677Q485 660 452 650Q419 640 384 640ZM576 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1224.50Q1807 1190 1759 1171Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508.50 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664Z"
         }
      }
   ]
}

var PartlyCloudyDay = {
   name: "PartlyCloudyDay",
   vendor: "UiFabric",
   unicode: 59840,
   value: "",
   charCode: "E9C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1825 1054 1877.50 1089.50Q1930 1125 1968 1173.50Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L576 1792Q483 1792 401.50 1757Q320 1722 259 1661Q198 1600 163 1518.50Q128 1437 128 1344L128 1344Q128 1278 147 1215.50Q166 1153 201 1099Q236 1045 285.50 1002.50Q335 960 396 934L396 934Q384 885 384 832L384 832Q384 739 419 657.50Q454 576 515 515Q576 454 657.50 419Q739 384 832 384L832 384Q896 384 957 402Q1018 420 1070.50 453.50Q1123 487 1165.50 534.50Q1208 582 1235 640L1235 640Q1325 643 1408 673Q1491 703 1560.50 755Q1630 807 1682 879Q1734 951 1761 1036ZM832 512L832 512Q766 512 707.50 537.50Q649 563 605.50 606.50Q562 650 537 708Q512 766 512 832L512 832Q512 849 513.50 865.50Q515 882 520 899L520 899Q548 896 576 896L576 896Q614 896 651 902Q688 908 723 921L723 921Q752 870 792.50 826.50Q833 783 881 748.50Q929 714 983.50 689.50Q1038 665 1095 653L1095 653Q1051 587 981 549.50Q911 512 832 512ZM576 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508.50 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664ZM256 768L256 896L0 896L0 768L256 768ZM470 379L379 470L198 289L289 198L470 379ZM896 0L896 256L768 256L768 0L896 0ZM1466 289L1285 470L1194 379L1375 198L1466 289Z"
         }
      }
   ]
}

var PartlyCloudyNight = {
   name: "PartlyCloudyNight",
   vendor: "UiFabric",
   unicode: 59841,
   value: "",
   charCode: "E9C1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1054 1877 1089.50Q1930 1125 1968 1173.50Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1487 2017.50 1557Q1987 1627 1935 1679Q1883 1731 1813 1761.50Q1743 1792 1664 1792L1664 1792L576 1792Q483 1792 401.50 1757Q320 1722 259 1661Q198 1600 163 1518.50Q128 1437 128 1344L128 1344Q128 1266 153 1194.50Q178 1123 227 1063L227 1063Q146 1009 90.50 929Q35 849 14 754L14 754Q72 768 128 768L128 768Q234 768 327.50 728Q421 688 490.50 618.50Q560 549 600 455.50Q640 362 640 256L640 256Q640 200 626 142L626 142Q713 162 786 209Q859 256 912 322Q965 388 994.50 469.50Q1024 551 1024 640L1024 640Q1024 648 1023 657Q1022 666 1021 674L1021 674L1025 673Q1073 658 1119 649Q1165 640 1216 640L1216 640Q1309 640 1395 668.50Q1481 697 1552.50 749.50Q1624 802 1678 875Q1732 948 1761 1036ZM761 348L761 348Q746 453 699 545Q652 637 580.50 708.50Q509 780 417 827Q325 874 220 889L220 889Q263 941 324 973L324 973Q381 935 444 915.50Q507 896 576 896L576 896Q614 896 651 902Q688 908 723 921L723 921Q752 869 792.50 827.50Q833 786 879 749L879 749Q896 695 896 640L896 640Q896 555 861 479Q826 403 761 348ZM576 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1224.50Q1807 1190 1759 1171Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508 877.50Q1449 826 1374 797Q1299 768 1216 768L1216 768Q1139 768 1069.50 792.50Q1000 817 943 861.50Q886 906 844.50 967.50Q803 1029 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664Z"
         }
      }
   ]
}

var ClearNight = {
   name: "ClearNight",
   vendor: "UiFabric",
   unicode: 59842,
   value: "",
   charCode: "E9C2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1536L128 1536Q269 1536 400 1499.50Q531 1463 644.50 1396Q758 1329 851.50 1235.50Q945 1142 1012 1028.50Q1079 915 1115.50 784Q1152 653 1152 512L1152 512Q1152 379 1118 251Q1084 123 1019 8L1019 8Q1147 24 1264 69Q1381 114 1481 184Q1581 254 1662 345.50Q1743 437 1800.50 544.50Q1858 652 1889 773.50Q1920 895 1920 1024L1920 1024Q1920 1165 1883.50 1296Q1847 1427 1780 1540.50Q1713 1654 1619.50 1747.50Q1526 1841 1412.50 1908Q1299 1975 1168 2011.50Q1037 2048 896 2048L896 2048Q758 2048 627 2012Q496 1976 380.50 1908.50Q265 1841 169 1744.50Q73 1648 5 1528L5 1528Q36 1532 66.50 1534Q97 1536 128 1536ZM896 1920L896 1920Q1020 1920 1134.50 1888Q1249 1856 1348.50 1797.50Q1448 1739 1529.50 1657.50Q1611 1576 1669.50 1476.50Q1728 1377 1760 1262.50Q1792 1148 1792 1024L1792 1024Q1792 888 1752 760.50Q1712 633 1639.50 524.50Q1567 416 1464 331Q1361 246 1235 195L1235 195Q1280 350 1280 512L1280 512Q1280 658 1245 794.50Q1210 931 1145 1052.50Q1080 1174 988 1277.50Q896 1381 783 1459.50Q670 1538 538.50 1588.50Q407 1639 262 1656L262 1656Q390 1784 552.50 1852Q715 1920 896 1920Z"
         }
      }
   ]
}

var RainShowersDay = {
   name: "RainShowersDay",
   vendor: "UiFabric",
   unicode: 59843,
   value: "",
   charCode: "E9C3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1536L1042 1827Q1056 1857 1056 1888L1056 1888Q1056 1921 1043.50 1950Q1031 1979 1009 2001Q987 2023 958 2035.50Q929 2048 896 2048L896 2048Q863 2048 834 2035.50Q805 2023 783 2001Q761 1979 748.50 1950Q736 1921 736 1888L736 1888Q736 1857 750 1827L750 1827L896 1536ZM1280 1280L1426 1571Q1440 1601 1440 1632L1440 1632Q1440 1665 1427.50 1694Q1415 1723 1393 1745Q1371 1767 1342 1779.50Q1313 1792 1280 1792L1280 1792Q1247 1792 1218 1779.50Q1189 1767 1167 1745Q1145 1723 1132.50 1694Q1120 1665 1120 1632L1120 1632Q1120 1601 1134 1571L1134 1571L1280 1280ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1556 1792Q1573 1763 1583 1730.50Q1593 1698 1597 1664L1597 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508.50 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L672 1664L608 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1277 147 1214.50Q166 1152 201 1098.50Q236 1045 285.50 1003Q335 961 396 934L396 934Q384 885 384 832L384 832Q384 739 419.50 657.50Q455 576 515.50 515.50Q576 455 657.50 419.50Q739 384 832 384L832 384Q897 384 957.50 402Q1018 420 1070.50 453.50Q1123 487 1165 534.50Q1207 582 1235 640L1235 640Q1325 643 1407.50 673.50Q1490 704 1559.50 756Q1629 808 1681 879.50Q1733 951 1761 1036ZM723 921L723 921Q784 818 881.50 748Q979 678 1096 653L1096 653Q1051 587 981.50 549.50Q912 512 832 512L832 512Q766 512 707.50 537.50Q649 563 605.50 606.50Q562 650 537 708Q512 766 512 832L512 832Q512 864 520 899L520 899Q548 896 576 896L576 896Q650 896 723 921ZM256 768L256 896L0 896L0 768L256 768ZM470 379L379 470L198 289L289 198L470 379ZM896 0L896 256L768 256L768 0L896 0ZM1466 289L1285 470L1194 379L1375 198L1466 289Z"
         }
      }
   ]
}

var Rain = {
   name: "Rain",
   vendor: "UiFabric",
   unicode: 59844,
   value: "",
   charCode: "E9C4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 1536L850 1827Q864 1857 864 1888L864 1888Q864 1921 851.50 1950Q839 1979 817 2001Q795 2023 766 2035.50Q737 2048 704 2048L704 2048Q671 2048 642 2035.50Q613 2023 591 2001Q569 1979 556.50 1950Q544 1921 544 1888L544 1888Q544 1857 558 1827L558 1827L704 1536ZM1472 1536L1618 1827Q1632 1857 1632 1888L1632 1888Q1632 1921 1619.50 1950Q1607 1979 1585 2001Q1563 2023 1534 2035.50Q1505 2048 1472 2048L1472 2048Q1439 2048 1410 2035.50Q1381 2023 1359 2001Q1337 1979 1324.50 1950Q1312 1921 1312 1888L1312 1888Q1312 1857 1326 1827L1326 1827L1472 1536ZM1088 1280L1234 1571Q1248 1601 1248 1632L1248 1632Q1248 1665 1235.50 1694Q1223 1723 1201 1745Q1179 1767 1150 1779.50Q1121 1792 1088 1792L1088 1792Q1055 1792 1026 1779.50Q997 1767 975 1745Q953 1723 940.50 1694Q928 1665 928 1632L928 1632Q928 1601 942 1571L942 1571L1088 1280ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1474 2026 1534.50Q2004 1595 1965 1644.50Q1926 1694 1872 1729Q1818 1764 1754 1780L1754 1780L1694 1660Q1742 1654 1783.50 1632.50Q1825 1611 1855 1577Q1885 1543 1902.50 1500Q1920 1457 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508.50 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1397 273 1446Q290 1495 320.50 1535.50Q351 1576 393.50 1605.50Q436 1635 487 1650L487 1650L430 1764Q363 1741 307.50 1699Q252 1657 212 1602Q172 1547 150 1481.50Q128 1416 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036Z"
         }
      }
   ]
}

var Thunderstorms = {
   name: "Thunderstorms",
   vendor: "UiFabric",
   unicode: 59846,
   value: "",
   charCode: "E9C6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1280 1792L1408 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L832 1664L768 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1269 152 1200L152 1200Q81 1146 40.50 1066Q0 986 0 896L0 896Q0 817 30 747Q60 677 112.50 624.50Q165 572 234.50 542Q304 512 384 512L384 512Q395 512 405.50 512.50Q416 513 427 514L427 514Q454 454 496.50 406.50Q539 359 591.50 325.50Q644 292 705.50 274Q767 256 832 256L832 256Q916 256 991.50 285.50Q1067 315 1126.50 366.50Q1186 418 1225.50 489Q1265 560 1276 643L1276 643Q1360 652 1436 684.50Q1512 717 1575.50 768.50Q1639 820 1687 888Q1735 956 1761 1036ZM723 921L723 921Q757 864 802.50 816.50Q848 769 902.50 733.50Q957 698 1018.50 675Q1080 652 1146 644L1146 644Q1135 588 1106 540Q1077 492 1035.50 457.50Q994 423 941.50 403.50Q889 384 832 384L832 384Q770 384 714.50 406.50Q659 429 616.50 468.50Q574 508 547 561.50Q520 615 515 677L515 677Q485 660 452 650Q419 640 384 640L384 640Q331 640 284.50 660Q238 680 203 715Q168 750 148 796.50Q128 843 128 896L128 896Q128 950 149.50 999Q171 1048 212 1084L212 1084Q275 995 371 945.50Q467 896 576 896L576 896Q650 896 723 921ZM1472 1408L832 2048L1088 1536L864 1536L1056 1152L1280 1152L1152 1408L1472 1408Z"
         }
      }
   ]
}

var RainSnow = {
   name: "RainSnow",
   vendor: "UiFabric",
   unicode: 59847,
   value: "",
   charCode: "E9C7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1511 1504L1511 1504Q1537 1504 1555.50 1523Q1574 1542 1574 1568L1574 1568Q1574 1604 1542 1623L1542 1623L1472 1664L1542 1705Q1574 1724 1574 1760L1574 1760Q1574 1787 1555 1805.50Q1536 1824 1510 1824L1510 1824Q1497 1824 1483.50 1818.50Q1470 1813 1456.50 1805.50Q1443 1798 1430.50 1789.50Q1418 1781 1408 1775L1408 1775Q1408 1794 1409 1819Q1410 1844 1405.50 1866.50Q1401 1889 1387.50 1904.50Q1374 1920 1344 1920L1344 1920Q1314 1920 1300 1904.50Q1286 1889 1281.50 1866.50Q1277 1844 1278.50 1819Q1280 1794 1280 1775L1280 1775Q1269 1781 1257 1789.50Q1245 1798 1231.50 1805.50Q1218 1813 1204.50 1818.50Q1191 1824 1178 1824L1178 1824Q1152 1824 1133 1805.50Q1114 1787 1114 1760L1114 1760Q1114 1724 1146 1705L1146 1705L1216 1664L1146 1623Q1114 1604 1114 1568L1114 1568Q1114 1542 1132.50 1523Q1151 1504 1177 1504L1177 1504Q1190 1504 1204 1509.50Q1218 1515 1231.50 1523Q1245 1531 1257.50 1539Q1270 1547 1280 1553L1280 1553Q1280 1534 1278.50 1509Q1277 1484 1281.50 1461.50Q1286 1439 1300 1423.50Q1314 1408 1344 1408L1344 1408Q1374 1408 1387.50 1423.50Q1401 1439 1405.50 1461.50Q1410 1484 1409 1509Q1408 1534 1408 1553L1408 1553Q1418 1547 1430.50 1539Q1443 1531 1456.50 1523Q1470 1515 1484 1509.50Q1498 1504 1511 1504ZM832 1536L978 1827Q992 1857 992 1888L992 1888Q992 1921 979.50 1950Q967 1979 945 2001Q923 2023 894 2035.50Q865 2048 832 2048L832 2048Q799 2048 770 2035.50Q741 2023 719 2001Q697 1979 684.50 1950Q672 1921 672 1888L672 1888Q672 1857 686 1827L686 1827L832 1536ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1469 2029.50 1525.50Q2011 1582 1977.50 1629Q1944 1676 1896.50 1712Q1849 1748 1792 1768L1792 1768L1792 1629Q1851 1594 1885.50 1535.50Q1920 1477 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L515 1786Q432 1775 361 1736Q290 1697 238.50 1637.50Q187 1578 157.50 1503Q128 1428 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036Z"
         }
      }
   ]
}

var Snow = {
   name: "Snow",
   vendor: "UiFabric",
   unicode: 59848,
   value: "",
   charCode: "E9C8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1478 2024 1541.50Q2000 1605 1957 1655.50Q1914 1706 1855.50 1740.50Q1797 1775 1728 1787L1728 1787L1728 1656Q1770 1645 1805.50 1621.50Q1841 1598 1866.50 1565Q1892 1532 1906 1492Q1920 1452 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1392 269.50 1436.50Q283 1481 308.50 1519Q334 1557 369 1587.50Q404 1618 448 1637L448 1637L448 1773Q377 1752 318 1710Q259 1668 217 1611.50Q175 1555 151.50 1486.50Q128 1418 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM960 1792L1030 1833Q1062 1852 1062 1888L1062 1888Q1062 1915 1043 1933.50Q1024 1952 998 1952L998 1952Q986 1952 972 1946.50Q958 1941 944.50 1933Q931 1925 918.50 1917Q906 1909 896 1903L896 1903Q896 1922 897 1947Q898 1972 893.50 1994.50Q889 2017 875.50 2032.50Q862 2048 832 2048L832 2048Q802 2048 788 2032.50Q774 2017 769.50 1994.50Q765 1972 766.50 1947Q768 1922 768 1903L768 1903Q758 1909 745.50 1917Q733 1925 719.50 1933Q706 1941 692 1946.50Q678 1952 666 1952L666 1952Q640 1952 621 1933.50Q602 1915 602 1888L602 1888Q602 1852 634 1833L634 1833L704 1792L634 1751Q602 1732 602 1696L602 1696Q602 1670 620.50 1651Q639 1632 665 1632L665 1632Q678 1632 692 1637.50Q706 1643 719.50 1651Q733 1659 745.50 1667Q758 1675 768 1681L768 1681Q768 1662 766.50 1637Q765 1612 769.50 1589.50Q774 1567 788 1551.50Q802 1536 832 1536L832 1536Q862 1536 875.50 1551.50Q889 1567 893.50 1589.50Q898 1612 897 1637Q896 1662 896 1681L896 1681Q906 1675 918.50 1667Q931 1659 944.50 1651Q958 1643 972 1637.50Q986 1632 999 1632L999 1632Q1025 1632 1043.50 1651Q1062 1670 1062 1696L1062 1696Q1062 1732 1030 1751L1030 1751L960 1792ZM1472 1664L1542 1705Q1574 1724 1574 1760L1574 1760Q1574 1787 1555 1805.50Q1536 1824 1510 1824L1510 1824Q1498 1824 1484 1818.50Q1470 1813 1456.50 1805Q1443 1797 1430.50 1789Q1418 1781 1408 1775L1408 1775Q1408 1794 1409 1819Q1410 1844 1405.50 1866.50Q1401 1889 1387.50 1904.50Q1374 1920 1344 1920L1344 1920Q1314 1920 1300 1904.50Q1286 1889 1281.50 1866.50Q1277 1844 1278.50 1819Q1280 1794 1280 1775L1280 1775Q1270 1781 1257.50 1789Q1245 1797 1231.50 1805Q1218 1813 1204 1818.50Q1190 1824 1178 1824L1178 1824Q1152 1824 1133 1805.50Q1114 1787 1114 1760L1114 1760Q1114 1724 1146 1705L1146 1705L1216 1664L1146 1623Q1114 1604 1114 1568L1114 1568Q1114 1542 1132.50 1523Q1151 1504 1177 1504L1177 1504Q1190 1504 1204 1509.50Q1218 1515 1231.50 1523Q1245 1531 1257.50 1539Q1270 1547 1280 1553L1280 1553Q1280 1534 1278.50 1509Q1277 1484 1281.50 1461.50Q1286 1439 1300 1423.50Q1314 1408 1344 1408L1344 1408Q1374 1408 1387.50 1423.50Q1401 1439 1405.50 1461.50Q1410 1484 1409 1509Q1408 1534 1408 1553L1408 1553Q1418 1547 1430.50 1539Q1443 1531 1456.50 1523Q1470 1515 1484 1509.50Q1498 1504 1511 1504L1511 1504Q1537 1504 1555.50 1523Q1574 1542 1574 1568L1574 1568Q1574 1604 1542 1623L1542 1623L1472 1664Z"
         }
      }
   ]
}

var BlowingSnow = {
   name: "BlowingSnow",
   vendor: "UiFabric",
   unicode: 59849,
   value: "",
   charCode: "E9C9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 640L1536 640Q1536 720 1506 789.50Q1476 859 1423.50 911.50Q1371 964 1301 994Q1231 1024 1152 1024L1152 1024L0 1024L0 896L1152 896Q1205 896 1251.50 876Q1298 856 1333 821Q1368 786 1388 739.50Q1408 693 1408 640L1408 640Q1408 587 1388 540.50Q1368 494 1333 459Q1298 424 1251.50 404Q1205 384 1152 384L1152 384Q1099 384 1052.50 404Q1006 424 971 459Q936 494 916 540.50Q896 587 896 640L896 640L768 640Q768 561 798 491Q828 421 880.50 368.50Q933 316 1002.50 286Q1072 256 1152 256L1152 256Q1231 256 1301 286Q1371 316 1423.50 368.50Q1476 421 1506 491Q1536 561 1536 640ZM1792 896L1792 896Q1845 896 1891.50 916Q1938 936 1973 971Q2008 1006 2028 1052.50Q2048 1099 2048 1152L2048 1152Q2048 1205 2028 1251.50Q2008 1298 1973 1333Q1938 1368 1891.50 1388Q1845 1408 1792 1408L1792 1408L1630 1408Q1664 1466 1664 1536L1664 1536Q1664 1589 1644 1635.50Q1624 1682 1589 1717Q1554 1752 1507.50 1772Q1461 1792 1408 1792L1408 1792Q1355 1792 1308.50 1772Q1262 1752 1227 1717Q1192 1682 1172 1635.50Q1152 1589 1152 1536L1152 1536L1280 1536Q1280 1562 1290 1585.50Q1300 1609 1317.50 1626.50Q1335 1644 1358.50 1654Q1382 1664 1408 1664L1408 1664Q1434 1664 1457.50 1654Q1481 1644 1498.50 1626.50Q1516 1609 1526 1585.50Q1536 1562 1536 1536L1536 1536Q1536 1509 1526 1486Q1516 1463 1498.50 1445.50Q1481 1428 1458 1418Q1435 1408 1408 1408L1408 1408L0 1408L0 1280L1408 1280L1792 1280Q1818 1280 1841.50 1270Q1865 1260 1882.50 1242.50Q1900 1225 1910 1201.50Q1920 1178 1920 1152L1920 1152Q1920 1125 1910 1102Q1900 1079 1882.50 1061.50Q1865 1044 1842 1034Q1819 1024 1792 1024L1792 1024Q1765 1024 1742 1034Q1719 1044 1701.50 1061.50Q1684 1079 1674 1102Q1664 1125 1664 1152L1664 1152L1536 1152Q1536 1099 1556 1052.50Q1576 1006 1611 971Q1646 936 1692.50 916Q1739 896 1792 896ZM832 1792L902 1833Q934 1852 934 1888L934 1888Q934 1915 915 1933.50Q896 1952 870 1952L870 1952Q858 1952 844 1946.50Q830 1941 816.50 1933Q803 1925 790.50 1917Q778 1909 768 1903L768 1903Q768 1922 769 1947Q770 1972 765.50 1994.50Q761 2017 747.50 2032.50Q734 2048 704 2048L704 2048Q674 2048 660 2032.50Q646 2017 641.50 1994.50Q637 1972 638.50 1947Q640 1922 640 1903L640 1903Q630 1909 617.50 1917Q605 1925 591.50 1933Q578 1941 564 1946.50Q550 1952 538 1952L538 1952Q512 1952 493 1933.50Q474 1915 474 1888L474 1888Q474 1852 506 1833L506 1833L576 1792L506 1751Q474 1732 474 1696L474 1696Q474 1669 492.50 1650.50Q511 1632 538 1632L538 1632Q551 1632 564.50 1637.50Q578 1643 591.50 1650.50Q605 1658 617.50 1666.50Q630 1675 640 1681L640 1681Q640 1662 638.50 1637Q637 1612 641.50 1589.50Q646 1567 660 1551.50Q674 1536 704 1536L704 1536Q734 1536 747.50 1551.50Q761 1567 765.50 1589.50Q770 1612 769 1637Q768 1662 768 1681L768 1681Q778 1675 790.50 1666.50Q803 1658 816.50 1650.50Q830 1643 843.50 1637.50Q857 1632 870 1632L870 1632Q897 1632 915.50 1650.50Q934 1669 934 1696L934 1696Q934 1732 902 1751L902 1751L832 1792ZM154 544L154 544Q128 544 109 525.50Q90 507 90 480L90 480Q90 444 122 425L122 425L192 384L122 343Q90 324 90 288L90 288Q90 261 108.50 242.50Q127 224 154 224L154 224Q167 224 180.50 229.50Q194 235 207.50 242.50Q221 250 233.50 258.50Q246 267 256 273L256 273Q256 254 254.50 229Q253 204 257.50 181.50Q262 159 276 143.50Q290 128 320 128L320 128Q350 128 363.50 143.50Q377 159 381.50 181.50Q386 204 385 229Q384 254 384 273L384 273Q394 267 406.50 258.50Q419 250 432.50 242.50Q446 235 459.50 229.50Q473 224 486 224L486 224Q512 224 531.50 242.50Q551 261 551 288L551 288Q551 306 542 320Q533 334 518 343L518 343L448 384L518 425Q533 434 542 448Q551 462 551 480L551 480Q551 506 531.50 525Q512 544 486 544L486 544Q474 544 460 538.50Q446 533 432.50 525Q419 517 406.50 509Q394 501 384 495L384 495Q384 514 385 539Q386 564 381.50 586.50Q377 609 363.50 624.50Q350 640 320 640L320 640Q290 640 276 624.50Q262 609 257.50 586.50Q253 564 254.50 539Q256 514 256 495L256 495Q246 501 233.50 509Q221 517 207.50 525Q194 533 180 538.50Q166 544 154 544Z"
         }
      }
   ]
}

var Frigid = {
   name: "Frigid",
   vendor: "UiFabric",
   unicode: 59850,
   value: "",
   charCode: "E9CA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L1024 1419Q1053 1429 1076.50 1447Q1100 1465 1117 1489Q1134 1513 1143 1541.50Q1152 1570 1152 1600L1152 1600Q1152 1640 1137 1675Q1122 1710 1096 1736Q1070 1762 1035 1777Q1000 1792 960 1792L960 1792Q920 1792 885 1777Q850 1762 824 1736Q798 1710 783 1675Q768 1640 768 1600L768 1600Q768 1570 777 1541.50Q786 1513 803 1489Q820 1465 843.50 1447Q867 1429 896 1419L896 1419L896 1024L1024 1024ZM1280 320L1280 1319Q1337 1382 1368.50 1460Q1400 1538 1400 1623L1400 1623Q1400 1713 1364.50 1790.50Q1329 1868 1268.50 1925Q1208 1982 1128 2015Q1048 2048 960 2048L960 2048Q872 2048 792 2015Q712 1982 651.50 1925Q591 1868 555.50 1790.50Q520 1713 520 1623L520 1623Q520 1538 551.50 1460Q583 1382 640 1319L640 1319L640 320Q640 254 665 196Q690 138 733.50 94.50Q777 51 835.50 25.50Q894 0 960 0L960 0Q1026 0 1084 25.50Q1142 51 1185.50 94.50Q1229 138 1254.50 196Q1280 254 1280 320L1280 320ZM960 1984L960 1920Q1022 1920 1078.50 1897Q1135 1874 1178 1834Q1221 1794 1246.50 1739Q1272 1684 1272 1621L1272 1621Q1272 1546 1239 1483.50Q1206 1421 1152 1371L1152 1371L1152 320Q1152 280 1137 245Q1122 210 1096 184Q1070 158 1035 143Q1000 128 960 128L960 128Q920 128 885 143Q850 158 824 184Q798 210 783 245Q768 280 768 320L768 320L768 1371Q714 1421 681 1483.50Q648 1546 648 1621L648 1621Q648 1684 673.50 1739Q699 1794 742 1834Q785 1874 841.50 1897Q898 1920 960 1920L960 1920L960 1984Z"
         }
      }
   ]
}

var Fog = {
   name: "Fog",
   vendor: "UiFabric",
   unicode: 59851,
   value: "",
   charCode: "E9CB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173.50Q2006 1223 2027 1283Q2048 1343 2048 1408L2048 1408Q2048 1441 2041.50 1473Q2035 1505 2024 1536L2024 1536L1885 1536Q1902 1507 1911 1474.50Q1920 1442 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1396 273 1445Q290 1494 322 1536L322 1536L173 1536Q151 1491 139.50 1442.50Q128 1394 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM1600 1536L704 1536Q678 1536 659 1517Q640 1498 640 1472L640 1472Q640 1446 659 1427Q678 1408 704 1408L704 1408L1600 1408Q1626 1408 1645 1427Q1664 1446 1664 1472L1664 1472Q1664 1498 1645 1517Q1626 1536 1600 1536L1600 1536ZM320 1664L1856 1664Q1882 1664 1901 1683Q1920 1702 1920 1728L1920 1728Q1920 1754 1901 1773Q1882 1792 1856 1792L1856 1792L320 1792Q294 1792 275 1773Q256 1754 256 1728L256 1728Q256 1702 275 1683Q294 1664 320 1664L320 1664ZM576 1920L1472 1920Q1498 1920 1517 1939Q1536 1958 1536 1984L1536 1984Q1536 2010 1517 2029Q1498 2048 1472 2048L1472 2048L576 2048Q550 2048 531 2029Q512 2010 512 1984L512 1984Q512 1958 531 1939Q550 1920 576 1920L576 1920Z"
         }
      }
   ]
}

var Squalls = {
   name: "Squalls",
   vendor: "UiFabric",
   unicode: 59852,
   value: "",
   charCode: "E9CC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 640L1536 640Q1536 720 1506 789.50Q1476 859 1423.50 911.50Q1371 964 1301 994Q1231 1024 1152 1024L1152 1024L0 1024L0 896L1152 896Q1205 896 1251.50 876Q1298 856 1333 821Q1368 786 1388 739.50Q1408 693 1408 640L1408 640Q1408 587 1388 540.50Q1368 494 1333 459Q1298 424 1251.50 404Q1205 384 1152 384L1152 384Q1099 384 1052.50 404Q1006 424 971 459Q936 494 916 540.50Q896 587 896 640L896 640L768 640Q768 561 798 491Q828 421 880.50 368.50Q933 316 1002.50 286Q1072 256 1152 256L1152 256Q1231 256 1301 286Q1371 316 1423.50 368.50Q1476 421 1506 491Q1536 561 1536 640ZM1792 896L1792 896Q1845 896 1891.50 916Q1938 936 1973 971Q2008 1006 2028 1052.50Q2048 1099 2048 1152L2048 1152Q2048 1205 2028 1251.50Q2008 1298 1973 1333Q1938 1368 1891.50 1388Q1845 1408 1792 1408L1792 1408L1630 1408Q1664 1466 1664 1536L1664 1536Q1664 1589 1644 1635.50Q1624 1682 1589 1717Q1554 1752 1507.50 1772Q1461 1792 1408 1792L1408 1792Q1355 1792 1308.50 1772Q1262 1752 1227 1717Q1192 1682 1172 1635.50Q1152 1589 1152 1536L1152 1536L1280 1536Q1280 1563 1290 1586Q1300 1609 1317.50 1626.50Q1335 1644 1358 1654Q1381 1664 1408 1664L1408 1664Q1435 1664 1458 1654Q1481 1644 1498.50 1626.50Q1516 1609 1526 1586Q1536 1563 1536 1536L1536 1536Q1536 1509 1526 1486Q1516 1463 1498.50 1445.50Q1481 1428 1458 1418Q1435 1408 1408 1408L1408 1408L0 1408L0 1280L1408 1280L1792 1280Q1819 1280 1842 1270Q1865 1260 1882.50 1242.50Q1900 1225 1910 1202Q1920 1179 1920 1152L1920 1152Q1920 1125 1910 1102Q1900 1079 1882.50 1061.50Q1865 1044 1842 1034Q1819 1024 1792 1024L1792 1024Q1765 1024 1742 1034Q1719 1044 1701.50 1061.50Q1684 1079 1674 1102Q1664 1125 1664 1152L1664 1152L1536 1152Q1536 1099 1556 1052.50Q1576 1006 1611 971Q1646 936 1692.50 916Q1739 896 1792 896Z"
         }
      }
   ]
}

var Duststorm = {
   name: "Duststorm",
   vendor: "UiFabric",
   unicode: 59853,
   value: "",
   charCode: "E9CD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 640L1536 640Q1536 720 1506 789.50Q1476 859 1423.50 911.50Q1371 964 1301 994Q1231 1024 1152 1024L1152 1024L0 1024L0 896L1152 896Q1205 896 1251.50 876Q1298 856 1333 821Q1368 786 1388 739.50Q1408 693 1408 640L1408 640Q1408 587 1388 540.50Q1368 494 1333 459Q1298 424 1251.50 404Q1205 384 1152 384L1152 384Q1099 384 1052.50 404Q1006 424 971 459Q936 494 916 540.50Q896 587 896 640L896 640L768 640Q768 561 798 491Q828 421 880.50 368.50Q933 316 1002.50 286Q1072 256 1152 256L1152 256Q1231 256 1301 286Q1371 316 1423.50 368.50Q1476 421 1506 491Q1536 561 1536 640ZM1792 896L1792 896Q1845 896 1891.50 916Q1938 936 1973 971Q2008 1006 2028 1052.50Q2048 1099 2048 1152L2048 1152Q2048 1205 2028 1251.50Q2008 1298 1973 1333Q1938 1368 1891.50 1388Q1845 1408 1792 1408L1792 1408L1630 1408Q1664 1466 1664 1536L1664 1536Q1664 1589 1644 1635.50Q1624 1682 1589 1717Q1554 1752 1507.50 1772Q1461 1792 1408 1792L1408 1792Q1355 1792 1308.50 1772Q1262 1752 1227 1717Q1192 1682 1172 1635.50Q1152 1589 1152 1536L1152 1536L1280 1536Q1280 1563 1290 1586Q1300 1609 1317.50 1626.50Q1335 1644 1358 1654Q1381 1664 1408 1664L1408 1664Q1435 1664 1458 1654Q1481 1644 1498.50 1626.50Q1516 1609 1526 1586Q1536 1563 1536 1536L1536 1536Q1536 1509 1526 1486Q1516 1463 1498.50 1445.50Q1481 1428 1458 1418Q1435 1408 1408 1408L1408 1408L0 1408L0 1280L1408 1280L1792 1280Q1819 1280 1842 1270Q1865 1260 1882.50 1242.50Q1900 1225 1910 1202Q1920 1179 1920 1152L1920 1152Q1920 1125 1910 1102Q1900 1079 1882.50 1061.50Q1865 1044 1842 1034Q1819 1024 1792 1024L1792 1024Q1765 1024 1742 1034Q1719 1044 1701.50 1061.50Q1684 1079 1674 1102Q1664 1125 1664 1152L1664 1152L1536 1152Q1536 1099 1556 1052.50Q1576 1006 1611 971Q1646 936 1692.50 916Q1739 896 1792 896ZM1728 768L1728 768Q1702 768 1683 749Q1664 730 1664 704L1664 704Q1664 678 1683 659Q1702 640 1728 640L1728 640Q1754 640 1773 659Q1792 678 1792 704L1792 704Q1792 730 1773 749Q1754 768 1728 768ZM576 768L576 768Q550 768 531 749Q512 730 512 704L512 704Q512 678 531 659Q550 640 576 640L576 640Q602 640 621 659Q640 678 640 704L640 704Q640 730 621 749Q602 768 576 768ZM960 1536L960 1536Q986 1536 1005 1555Q1024 1574 1024 1600L1024 1600Q1024 1626 1005 1645Q986 1664 960 1664L960 1664Q934 1664 915 1645Q896 1626 896 1600L896 1600Q896 1574 915 1555Q934 1536 960 1536Z"
         }
      }
   ]
}

var Unknown = {
   name: "Unknown",
   vendor: "UiFabric",
   unicode: 59854,
   value: "",
   charCode: "E9CE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 4L960 4Q1092 4 1214 38Q1336 72 1442.50 134.50Q1549 197 1636 284Q1723 371 1785.50 477.50Q1848 584 1882 706Q1916 828 1916 960L1916 960Q1916 1092 1882 1214Q1848 1336 1785.50 1442.50Q1723 1549 1636 1636Q1549 1723 1442.50 1785.50Q1336 1848 1214 1882Q1092 1916 960 1916L960 1916Q828 1916 706 1882Q584 1848 477.50 1785.50Q371 1723 284 1636Q197 1549 134.50 1442.50Q72 1336 38 1214Q4 1092 4 960L4 960Q4 828 38 706Q72 584 134.50 477.50Q197 371 284 284Q371 197 477.50 134.50Q584 72 706 38Q828 4 960 4ZM960 1796L960 1796Q1075 1796 1182 1766Q1289 1736 1382 1681.50Q1475 1627 1551 1551Q1627 1475 1681.50 1382Q1736 1289 1766 1182Q1796 1075 1796 960L1796 960Q1796 845 1766 738Q1736 631 1681.50 538Q1627 445 1551 369Q1475 293 1382 238.50Q1289 184 1182 154Q1075 124 960 124L960 124Q845 124 738 154Q631 184 538 238.50Q445 293 369 369Q293 445 238.50 538Q184 631 154 738Q124 845 124 960L124 960Q124 1075 154 1182Q184 1289 238.50 1382Q293 1475 369 1551Q445 1627 538 1681.50Q631 1736 738 1766Q845 1796 960 1796ZM896 1536L896 1408L1024 1408L1024 1536L896 1536ZM960 448L960 448Q1026 448 1084 473.50Q1142 499 1185.50 542.50Q1229 586 1254.50 644Q1280 702 1280 768L1280 768Q1280 828 1261 872.50Q1242 917 1213.50 953Q1185 989 1152 1018.50Q1119 1048 1090.50 1077.50Q1062 1107 1043 1140.50Q1024 1174 1024 1216L1024 1216L1024 1280L896 1280L896 1216Q896 1156 915 1111.50Q934 1067 962.50 1031Q991 995 1024 965.50Q1057 936 1085.50 906.50Q1114 877 1133 844Q1152 811 1152 768L1152 768Q1152 728 1137 693Q1122 658 1096 632Q1070 606 1035 591Q1000 576 960 576L960 576Q920 576 885 591Q850 606 824 632Q798 658 783 693Q768 728 768 768L768 768L640 768Q640 702 665 644Q690 586 733.50 542.50Q777 499 835.50 473.50Q894 448 960 448Z"
         }
      }
   ]
}

var Precipitation = {
   name: "Precipitation",
   vendor: "UiFabric",
   unicode: 59855,
   value: "",
   charCode: "E9CF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1607 1166Q1635 1223 1649.50 1284Q1664 1345 1664 1408L1664 1408Q1664 1496 1641 1578Q1618 1660 1576.50 1731Q1535 1802 1476.50 1860.50Q1418 1919 1347 1960.50Q1276 2002 1194 2025Q1112 2048 1024 2048L1024 2048Q936 2048 854 2025Q772 2002 701 1960.50Q630 1919 571.50 1860.50Q513 1802 471.50 1731Q430 1660 407 1578Q384 1496 384 1408L384 1408Q384 1345 398.50 1284Q413 1223 441 1166L441 1166L1024 0ZM1024 1920L1024 1920Q1130 1920 1223.50 1880Q1317 1840 1386.50 1770.50Q1456 1701 1496 1607.50Q1536 1514 1536 1408L1536 1408Q1536 1360 1525 1313Q1514 1266 1492 1223L1492 1223L1024 286L556 1223Q534 1266 523 1313Q512 1360 512 1408L512 1408Q512 1514 552 1607.50Q592 1701 661.50 1770.50Q731 1840 824.50 1880Q918 1920 1024 1920Z"
         }
      }
   ]
}

var Ringer = {
   name: "Ringer",
   vendor: "UiFabric",
   unicode: 60047,
   value: "",
   charCode: "EA8F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1536L1792 1536L1792 1664L1280 1664Q1280 1717 1260 1763.50Q1240 1810 1205 1845Q1170 1880 1123.50 1900Q1077 1920 1024 1920L1024 1920Q971 1920 924.50 1900Q878 1880 843 1845Q808 1810 788 1763.50Q768 1717 768 1664L768 1664L256 1664L256 1536L384 1536L384 768Q384 680 407 598Q430 516 471.50 445Q513 374 571.50 315.50Q630 257 701 215.50Q772 174 854 151Q936 128 1024 128L1024 128Q1112 128 1194 151Q1276 174 1347 215.50Q1418 257 1476.50 315.50Q1535 374 1576.50 445Q1618 516 1641 598Q1664 680 1664 768L1664 768L1664 1536ZM512 1536L1536 1536L1536 768Q1536 662 1495.50 569Q1455 476 1385.50 406.50Q1316 337 1223 296.50Q1130 256 1024 256L1024 256Q918 256 825 296.50Q732 337 662.50 406.50Q593 476 552.50 569Q512 662 512 768L512 768L512 1536ZM1024 1792L1024 1792Q1051 1792 1074 1782Q1097 1772 1114.50 1754.50Q1132 1737 1142 1714Q1152 1691 1152 1664L1152 1664L896 1664Q896 1691 906 1714Q916 1737 933.50 1754.50Q951 1772 974 1782Q997 1792 1024 1792Z"
         }
      }
   ]
}

var PDF = {
   name: "PDF",
   vendor: "UiFabric",
   unicode: 60048,
   value: "",
   charCode: "EA90",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 640L1920 1664L1792 1664L1792 2048L128 2048L128 1664L0 1664L0 640L128 640L128 0L1371 0L1792 421L1792 640L1920 640ZM1408 219L1408 384L1573 384L1408 219ZM256 128L256 640L1664 640L1664 512L1280 512L1280 128L256 128ZM1664 1920L1664 1664L256 1664L256 1920L1664 1920ZM1792 1536L1792 768L128 768L128 1536L1792 1536ZM256 896L448 896Q488 896 523 911Q558 926 584 952Q610 978 625 1013Q640 1048 640 1088L640 1088Q640 1128 625 1163Q610 1198 584 1224Q558 1250 523 1265Q488 1280 448 1280L448 1280L384 1280L384 1408L256 1408L256 896ZM384 1152L448 1152Q474 1152 493 1133Q512 1114 512 1088L512 1088Q512 1062 493 1043Q474 1024 448 1024L448 1024L384 1024L384 1152ZM768 896L896 896Q949 896 995.50 916Q1042 936 1077 971Q1112 1006 1132 1052.50Q1152 1099 1152 1152L1152 1152Q1152 1205 1132 1251.50Q1112 1298 1077 1333Q1042 1368 995.50 1388Q949 1408 896 1408L896 1408L768 1408L768 896ZM896 1024L896 1280Q923 1280 946 1270Q969 1260 986.50 1242.50Q1004 1225 1014 1202Q1024 1179 1024 1152L1024 1152Q1024 1125 1014 1102Q1004 1079 986.50 1061.50Q969 1044 946 1034Q923 1024 896 1024L896 1024ZM1280 1408L1280 896L1600 896L1600 1024L1408 1024L1408 1152L1600 1152L1600 1280L1408 1280L1408 1408L1280 1408Z"
         }
      }
   ]
}

var HeartBroken = {
   name: "HeartBroken",
   vendor: "UiFabric",
   unicode: 60050,
   value: "",
   charCode: "EA92",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1504 127L1504 127Q1617 127 1716 169.50Q1815 212 1889 286Q1963 360 2005.50 459Q2048 558 2048 671L2048 671Q2048 780 2006.50 879.50Q1965 979 1889 1055L1889 1055L1024 1920L159 1055Q83 979 41.50 879.50Q0 780 0 671L0 671Q0 558 42.50 459Q85 360 159 286Q233 212 332 169.50Q431 127 544 127L544 127Q655 127 752.50 167.50Q850 208 929 286L929 286Q953 309 976.50 333Q1000 357 1024 381L1024 381Q1048 357 1071.50 333Q1095 309 1119 286L1119 286Q1198 208 1295.50 167.50Q1393 127 1504 127ZM1024 1739L1798 965Q1857 906 1888 830Q1919 754 1919 671L1919 671Q1919 584 1886.50 508.50Q1854 433 1798 376.50Q1742 320 1666.50 287.50Q1591 255 1504 255L1504 255Q1420 255 1345 286Q1270 317 1210 376L1210 376Q1144 441 1081.50 507Q1019 573 955 639L955 639L1339 1023L1037 1324L947 1234L1158 1023L774 639L937 475Q911 452 887 426Q863 400 838 376L838 376Q778 317 703.50 286Q629 255 544 255L544 255Q457 255 381.50 287.50Q306 320 249.50 376.50Q193 433 160.50 508.50Q128 584 128 671L128 671Q128 753 160 830Q192 907 250 965L250 965L1024 1739Z"
         }
      }
   ]
}

var StoreLogo16 = {
   name: "StoreLogo16",
   vendor: "UiFabric",
   unicode: 60054,
   value: "",
   charCode: "EA96",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1649 512L1920 512L1920 1772Q1920 1802 1908.50 1829Q1897 1856 1876.50 1876.50Q1856 1897 1829 1908.50Q1802 1920 1772 1920L1772 1920L148 1920Q118 1920 91 1908.50Q64 1897 43.50 1876.50Q23 1856 11.50 1829Q0 1802 0 1772L0 1772L0 512L525 512L525 448Q525 358 559 279Q593 200 652.50 140.50Q712 81 791 47Q870 13 960 13L960 13Q1050 13 1129 47Q1208 81 1267.50 140.50Q1327 200 1361 279Q1395 358 1395 448L1395 448L1395 512L1547 512Q1545 466 1537.50 428.50Q1530 391 1516 361L1516 361Q1501 263 1454 178L1454 178Q1506 199 1542 231Q1578 263 1601 305.50Q1624 348 1635 400Q1646 452 1649 512L1649 512ZM627 448L627 512L783 512Q787 440 802 381Q817 322 849 276L849 276Q873 261 901 252Q929 243 960 243L960 243Q1003 243 1044 262L1044 262Q1000 274 970.50 295.50Q941 317 923 348Q905 379 896.50 420Q888 461 885 512L885 512L1293 512L1293 448Q1293 379 1266.50 318.50Q1240 258 1195 213Q1150 168 1089.50 141.50Q1029 115 960 115L960 115Q891 115 830.50 141.50Q770 168 725 213Q680 258 653.50 318.50Q627 379 627 448L627 448ZM896 1664L896 1280L512 1280L512 1664L896 1664ZM896 1152L896 768L512 768L512 1152L896 1152ZM1408 1664L1408 1280L1024 1280L1024 1664L1408 1664ZM1408 1152L1408 768L1024 768L1024 1152L1408 1152Z"
         }
      }
   ]
}

var MultiSelectMirrored = {
   name: "MultiSelectMirrored",
   vendor: "UiFabric",
   unicode: 60056,
   value: "",
   charCode: "EA98",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1294 384L1294 384L1294 512L14 512L14 384L1294 384ZM1294 896L1294 896L14 896L14 768L1294 768L1294 896ZM1294 1280L1294 1280L14 1280L14 1152L1294 1152L1294 1280ZM1294 1664L1294 1664L14 1664L14 1536L1294 1536L1294 1664ZM1694 1276L1694 1276L1980 990L2048 1058L1694 1412L1516 1234L1584 1166L1694 1276ZM1694 508L1694 508L1980 222L2048 290L1694 644L1516 466L1584 398L1694 508Z"
         }
      }
   ]
}

var Broom = {
   name: "Broom",
   vendor: "UiFabric",
   unicode: 60057,
   value: "",
   charCode: "EA99",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 0L1984 0Q2010 0 2029 19Q2048 38 2048 64L2048 64Q2048 90 2029 109L2029 109L1299 839Q1353 908 1380.50 989Q1408 1070 1408 1157L1408 1157Q1408 1260 1369 1354.50Q1330 1449 1257 1522L1257 1522L1189 1590L962 2044L4 1086L458 859L526 791Q599 718 693.50 679Q788 640 891 640L891 640Q978 640 1059 667.50Q1140 695 1209 749L1209 749L1939 19Q1958 0 1984 0ZM927 1828L1069 1543L505 979L220 1121L927 1828ZM603 896L1152 1445Q1213 1385 1246.50 1314.50Q1280 1244 1280 1157L1280 1157Q1280 1076 1249.50 1005.50Q1219 935 1166 882Q1113 829 1042.50 798.50Q972 768 891 768L891 768Q804 768 733.50 801Q663 834 603 896L603 896Z"
         }
      }
   ]
}

var StoreLogoMed20 = {
   name: "StoreLogoMed20",
   vendor: "UiFabric",
   unicode: 59908,
   value: "",
   charCode: "EA04",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1626 512L1946 512L1946 1797Q1946 1828 1934 1855Q1922 1882 1902 1902.50Q1882 1923 1855 1934.50Q1828 1946 1797 1946L1797 1946L148 1946Q118 1946 91 1934.50Q64 1923 43.50 1902.50Q23 1882 11.50 1855Q0 1828 0 1797L0 1797L0 512L512 512L512 461Q512 366 548.50 282Q585 198 647.50 135.50Q710 73 794 36.50Q878 0 973 0L973 0Q1068 0 1152 36.50Q1236 73 1298.50 135.50Q1361 198 1397.50 282Q1434 366 1434 461L1434 461L1434 512L1544 512Q1542 495 1540 480Q1538 465 1536 451L1536 451Q1534 380 1517 315.50Q1500 251 1468 193L1468 193Q1611 293 1626 512L1626 512ZM614 461L614 512L729 512Q737 425 771.50 354Q806 283 862 231L862 231Q912 205 973 205L973 205Q1010 205 1046 216L1046 216Q949 248 887 326Q825 404 812 512L812 512L1331 512L1331 461Q1331 387 1303 321.50Q1275 256 1226 207.50Q1177 159 1112 130.50Q1047 102 973 102L973 102Q899 102 833.50 130.50Q768 159 719 207.50Q670 256 642 321.50Q614 387 614 461L614 461ZM922 1638L922 1229L512 1229L512 1638L922 1638ZM922 1126L922 717L512 717L512 1126L922 1126ZM1434 1638L1434 1229L1024 1229L1024 1638L1434 1638ZM1434 1126L1434 717L1024 717L1024 1126L1434 1126Z"
         }
      }
   ]
}

var Info2 = {
   name: "Info2",
   vendor: "UiFabric",
   unicode: 59935,
   value: "",
   charCode: "EA1F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 2048L896 2048L896 512L1152 512L1152 2048ZM896 256L896 0L1152 0L1152 256L896 256Z"
         }
      }
   ]
}

var MusicInCollectionFill = {
   name: "MusicInCollectionFill",
   vendor: "UiFabric",
   unicode: 59958,
   value: "",
   charCode: "EA36",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 62L1792 1408Q1792 1470 1762.50 1517.50Q1733 1565 1686.50 1597.50Q1640 1630 1583 1647Q1526 1664 1472 1664L1472 1664Q1418 1664 1361 1647Q1304 1630 1257.50 1597.50Q1211 1565 1181.50 1517.50Q1152 1470 1152 1408L1152 1408Q1152 1347 1181.50 1299Q1211 1251 1257.50 1218.50Q1304 1186 1361 1169Q1418 1152 1472 1152L1472 1152Q1523 1152 1572 1164.50Q1621 1177 1664 1203L1664 1203L1664 226L768 450L768 1664Q768 1726 738.50 1773.50Q709 1821 662.50 1853.50Q616 1886 559 1903Q502 1920 448 1920L448 1920Q394 1920 337 1903Q280 1886 233.50 1853.50Q187 1821 157.50 1773.50Q128 1726 128 1664L128 1664Q128 1603 157.50 1555Q187 1507 233.50 1474.50Q280 1442 337 1425Q394 1408 448 1408L448 1408Q499 1408 548 1420.50Q597 1433 640 1459L640 1459L640 350L1792 62Z"
         }
      }
   ]
}

var List = {
   name: "List",
   vendor: "UiFabric",
   unicode: 59959,
   value: "",
   charCode: "EA37",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1536L0 1536L0 1408L1280 1408L1280 1536ZM0 1024L0 896L2048 896L2048 1024L0 1024ZM0 384L1664 384L1664 512L0 512L0 384Z"
         }
      }
   ]
}

var Asterisk = {
   name: "Asterisk",
   vendor: "UiFabric",
   unicode: 59960,
   value: "",
   charCode: "EA38",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1943 568L1943 568L1152 1024L1943 1480L1879 1592L1088 1135L1088 2048L960 2048L960 1135L169 1592L105 1480L896 1024L105 568L169 456L960 913L960 0L1088 0L1088 913L1879 456L1943 568Z"
         }
      }
   ]
}

var ErrorBadge = {
   name: "ErrorBadge",
   vendor: "UiFabric",
   unicode: 59961,
   value: "",
   charCode: "EA39",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1148 1920 1262.50 1888Q1377 1856 1476.50 1797.50Q1576 1739 1657.50 1657.50Q1739 1576 1797.50 1476.50Q1856 1377 1888 1262.50Q1920 1148 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q900 128 785.50 160Q671 192 571.50 250.50Q472 309 390.50 390.50Q309 472 250.50 571.50Q192 671 160 785.50Q128 900 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250.50 1476.50Q309 1576 390.50 1657.50Q472 1739 571.50 1797.50Q671 1856 785.50 1888Q900 1920 1024 1920ZM1377 581L1467 671L1115 1024L1467 1377L1377 1467L1024 1115L671 1467L581 1377L933 1024L581 671L671 581L1024 933L1377 581Z"
         }
      }
   ]
}

var CircleRing = {
   name: "CircleRing",
   vendor: "UiFabric",
   unicode: 59962,
   value: "",
   charCode: "EA3A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1148 1920 1262.50 1888Q1377 1856 1476.50 1797.50Q1576 1739 1657.50 1657.50Q1739 1576 1797.50 1476.50Q1856 1377 1888 1262.50Q1920 1148 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q900 128 785.50 160Q671 192 571.50 250.50Q472 309 390.50 390.50Q309 472 250.50 571.50Q192 671 160 785.50Q128 900 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250.50 1476.50Q309 1576 390.50 1657.50Q472 1739 571.50 1797.50Q671 1856 785.50 1888Q900 1920 1024 1920Z"
         }
      }
   ]
}

var CircleFill = {
   name: "CircleFill",
   vendor: "UiFabric",
   unicode: 59963,
   value: "",
   charCode: "EA3B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M32 1024L32 1024Q32 887 67.50 760Q103 633 167.50 523Q232 413 322.50 322.50Q413 232 523 167.50Q633 103 760 67.50Q887 32 1024 32L1024 32Q1161 32 1288 67.50Q1415 103 1525 167.50Q1635 232 1725.50 322.50Q1816 413 1880.50 523Q1945 633 1980.50 760Q2016 887 2016 1024L2016 1024Q2016 1161 1980.50 1288Q1945 1415 1880.50 1525Q1816 1635 1725.50 1725.50Q1635 1816 1525 1880.50Q1415 1945 1288 1980.50Q1161 2016 1024 2016L1024 2016Q887 2016 760 1980.50Q633 1945 523 1880.50Q413 1816 322.50 1725.50Q232 1635 167.50 1525Q103 1415 67.50 1288Q32 1161 32 1024Z"
         }
      }
   ]
}

var Record2 = {
   name: "Record2",
   vendor: "UiFabric",
   unicode: 59967,
   value: "",
   charCode: "EA3F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920Z"
         }
      }
   ]
}

var ThumbnailViewMirrored = {
   name: "ThumbnailViewMirrored",
   vendor: "UiFabric",
   unicode: 60007,
   value: "",
   charCode: "EA67",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1792L2048 1152L1408 1152L1408 1792L2048 1792ZM1920 1280L1920 1664L1536 1664L1536 1280L1920 1280ZM2048 896L2048 256L1408 256L1408 896L2048 896ZM1920 384L1920 768L1536 768L1536 384L1920 384ZM1152 384L0 384L0 512L1152 512L1152 384ZM384 640L384 768L1152 768L1152 640L384 640ZM1152 1408L1152 1280L0 1280L0 1408L1152 1408ZM1152 1664L1152 1536L384 1536L384 1664L1152 1664Z"
         }
      }
   ]
}

var ShowResultsMirrored = {
   name: "ShowResultsMirrored",
   vendor: "UiFabric",
   unicode: 60005,
   value: "",
   charCode: "EA65",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L1664 1792L1664 1664L0 1664L0 1792ZM1920 384L2048 384L2048 256L1920 256L1920 384ZM1920 1408L2048 1408L2048 1280L1920 1280L1920 1408ZM0 1408L1664 1408L1664 1280L0 1280L0 1408ZM1664 384L1664 256L0 256L0 384L1664 384ZM0 768L1664 768L1664 640L0 640L0 768Z"
         }
      }
   ]
}

var SendMirrored = {
   name: "SendMirrored",
   vendor: "UiFabric",
   unicode: 60003,
   value: "",
   charCode: "EA63",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M51 960L2030 77L1810 960L2030 1843L51 960ZM503 899L1693 899L1842 301L503 899ZM515 1027L1842 1619L1695 1027L515 1027Z"
         }
      }
   ]
}

var ParkingLocationMirrored = {
   name: "ParkingLocationMirrored",
   vendor: "UiFabric",
   unicode: 59998,
   value: "",
   charCode: "EA5E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M285 896L29 1459Q0 1523 0 1592L0 1592L0 1664Q0 1740 41 1803Q82 1866 151 1897L151 1897Q182 1966 245 2007Q308 2048 384 2048L384 2048Q453 2048 512 2014Q571 1980 606 1920L606 1920L1314 1920Q1349 1980 1408 2014Q1467 2048 1536 2048L1536 2048Q1605 2048 1664 2014Q1723 1980 1758 1920L1758 1920L1920 1920Q1947 1920 1970 1910Q1993 1900 2010.50 1882.50Q2028 1865 2038 1842Q2048 1819 2048 1792L2048 1792L2048 1536Q2048 1456 2018 1386Q1988 1316 1936 1264Q1884 1212 1814 1182Q1744 1152 1664 1152L1664 1152L1627 1152L1299 824Q1272 797 1236.50 782.50Q1201 768 1163 768L1163 768L256 768L256 896L285 896ZM467 896L768 896L768 1152L309 1152L408 933Q416 916 432.50 906Q449 896 467 896L467 896ZM896 896L1163 896Q1189 896 1208 915L1208 915L1445 1152L896 1152L896 896ZM1536 1920L1536 1920Q1509 1920 1486 1910Q1463 1900 1445.50 1882.50Q1428 1865 1418 1842Q1408 1819 1408 1792L1408 1792Q1408 1765 1418 1742Q1428 1719 1445.50 1701.50Q1463 1684 1486 1674Q1509 1664 1536 1664L1536 1664Q1563 1664 1586 1674Q1609 1684 1626.50 1701.50Q1644 1719 1654 1742Q1664 1765 1664 1792L1664 1792Q1664 1819 1654 1842Q1644 1865 1626.50 1882.50Q1609 1900 1586 1910Q1563 1920 1536 1920ZM1536 1536L1536 1536Q1483 1536 1436.50 1556Q1390 1576 1355 1611Q1320 1646 1300 1692.50Q1280 1739 1280 1792L1280 1792L896 1792L896 1280L1664 1280Q1717 1280 1763.50 1300Q1810 1320 1845 1355Q1880 1390 1900 1436.50Q1920 1483 1920 1536L1920 1536L1920 1792L1792 1792Q1792 1739 1772 1692.50Q1752 1646 1717 1611Q1682 1576 1635.50 1556Q1589 1536 1536 1536ZM384 1920L384 1920Q357 1920 334 1910Q311 1900 293.50 1882.50Q276 1865 266 1842Q256 1819 256 1792L256 1792Q256 1765 266 1742Q276 1719 293.50 1701.50Q311 1684 334 1674Q357 1664 384 1664L384 1664Q411 1664 434 1674Q457 1684 474.50 1701.50Q492 1719 502 1742Q512 1765 512 1792L512 1792Q512 1819 502 1842Q492 1865 474.50 1882.50Q457 1900 434 1910Q411 1920 384 1920ZM128 1664L128 1592Q128 1551 145 1512L145 1512L251 1280L768 1280L768 1792L640 1792Q640 1739 620 1692.50Q600 1646 565 1611Q530 1576 483.50 1556Q437 1536 384 1536L384 1536Q342 1536 303 1549Q264 1562 232 1586Q200 1610 176 1643.50Q152 1677 139 1717L139 1717Q128 1690 128 1664L128 1664Z"
         }
      }
   ]
}

var OpenWithMirrored = {
   name: "OpenWithMirrored",
   vendor: "UiFabric",
   unicode: 59996,
   value: "",
   charCode: "EA5C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M90 1309L0 1219L317 902L634 1219L544 1309L382 1146L382 1729L253 1729L253 1146L90 1309ZM253 256L253 385L1406 385L1406 256L253 256ZM509 1536L509 1665L1406 1665L1406 1536L509 1536ZM1661 128L1661 512L2045 512L2045 128L1661 128ZM1917 256L1917 384L1789 384L1789 256L1917 256ZM1661 768L1661 1152L2045 1152L2045 768L1661 768ZM1917 896L1917 1024L1789 1024L1789 896L1917 896ZM1661 1408L1661 1792L2045 1792L2045 1408L1661 1408ZM1917 1536L1917 1664L1789 1664L1789 1536L1917 1536ZM509 896L637 1024L1405 1024L1405 896L509 896Z"
         }
      }
   ]
}

var OpenPaneMirrored = {
   name: "OpenPaneMirrored",
   vendor: "UiFabric",
   unicode: 59995,
   value: "",
   charCode: "EA5B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1536L2048 384L0 384L0 1536L2048 1536ZM640 512L1920 512L1920 1408L640 1408L640 512ZM512 1408L128 1408L128 512L512 512L512 1408ZM1189 896L768 896L768 1024L1189 1024L1027 1187L1117 1277L1434 960L1117 643L1027 733L1189 896Z"
         }
      }
   ]
}

var MiniExpandMirrored = {
   name: "MiniExpandMirrored",
   vendor: "UiFabric",
   unicode: 59994,
   value: "",
   charCode: "EA5A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 475L805 1024L896 933L347 384L768 384L768 256L128 256L128 896L256 896L256 475ZM256 1664L256 1152L128 1152L128 1792L1920 1792L1920 256L1024 256L1024 384L1792 384L1792 1152L1024 1152L1024 1664L256 1664ZM1152 1280L1792 1280L1792 1664L1152 1664L1152 1280Z"
         }
      }
   ]
}

var MiniContractMirrored = {
   name: "MiniContractMirrored",
   vendor: "UiFabric",
   unicode: 59993,
   value: "",
   charCode: "EA59",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1664L256 1280L128 1280L128 1792L1920 1792L1920 256L1152 256L1152 384L1792 384L1792 1152L1024 1152L1024 1664L256 1664ZM1152 1280L1792 1280L1792 1664L1152 1664L1152 1280ZM256 896L256 1024L896 1024L896 384L768 384L768 805L219 256L128 347L677 896L256 896Z"
         }
      }
   ]
}

var MailReplyAllMirrored = {
   name: "MailReplyAllMirrored",
   vendor: "UiFabric",
   unicode: 59992,
   value: "",
   charCode: "EA58",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L0 384L0 1466Q29 1443 61 1426.50Q93 1410 128 1398L128 1398L128 583L1024 1032L1920 583L1920 1536L1216 1536L1216 1664L2048 1664L2048 384ZM1777 512L1024 888L271 512L1777 512ZM707 1373L933 1600L707 1827L797 1917L1115 1600L797 1283L707 1373ZM387 1373L549 1536Q499 1536 438.50 1533.50Q378 1531 317 1534Q256 1537 199 1548.50Q142 1560 97.50 1588.50Q53 1617 26.50 1666Q0 1715 0 1792L0 1792Q0 1845 20.50 1891.50Q41 1938 75.50 1972.50Q110 2007 157 2027.50Q204 2048 256 2048L256 2048L256 1920Q229 1920 206 1910Q183 1900 165.50 1882.50Q148 1865 138 1842Q128 1819 128 1792L128 1792Q128 1765 138 1742Q148 1719 165.50 1701.50Q183 1684 206 1674Q229 1664 256 1664L256 1664L549 1664L387 1827L477 1917L794 1600L477 1283L387 1373Z"
         }
      }
   ]
}

var MailReplyMirrored = {
   name: "MailReplyMirrored",
   vendor: "UiFabric",
   unicode: 59991,
   value: "",
   charCode: "EA57",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L0 384L0 1466Q29 1443 61 1426.50Q93 1410 128 1398L128 1398L128 583L1024 1032L1920 583L1920 1536L896 1536L896 1664L2048 1664L2048 384ZM1777 512L1024 888L271 512L1777 512ZM387 1373L549 1536Q499 1536 438.50 1533.50Q378 1531 317 1534Q256 1537 199 1548.50Q142 1560 97.50 1588.50Q53 1617 26.50 1666Q0 1715 0 1792L0 1792Q0 1845 20.50 1891.50Q41 1938 75.50 1972.50Q110 2007 157 2027.50Q204 2048 256 2048L256 2048L256 1920Q229 1920 206 1910Q183 1900 165.50 1882.50Q148 1865 138 1842Q128 1819 128 1792L128 1792Q128 1765 138 1742Q148 1719 165.50 1701.50Q183 1684 206 1674Q229 1664 256 1664L256 1664L549 1664L387 1827L477 1917L794 1600L477 1283L387 1373Z"
         }
      }
   ]
}

var MailForwardMirrored = {
   name: "MailForwardMirrored",
   vendor: "UiFabric",
   unicode: 59990,
   value: "",
   charCode: "EA56",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1664L2048 384L0 384L0 1280L0 1408L128 1280L128 583L1024 1032L1920 583L1920 1536L896 1536L896 1664L2048 1664ZM1777 512L1024 888L271 512L1777 512ZM250 1536L413 1373L323 1283L6 1600L323 1917L413 1827L250 1664L768 1664L768 1536L250 1536Z"
         }
      }
   ]
}

var ListMirrored = {
   name: "ListMirrored",
   vendor: "UiFabric",
   unicode: 59989,
   value: "",
   charCode: "EA55",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1536L2048 1536L2048 1408L768 1408L768 1536ZM2048 1024L2048 896L0 896L0 1024L2048 1024ZM2048 384L384 384L384 512L2048 512L2048 384Z"
         }
      }
   ]
}

var ImportAllMirrored = {
   name: "ImportAllMirrored",
   vendor: "UiFabric",
   unicode: 59987,
   value: "",
   charCode: "EA53",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1805 897L1030 896L1030 1024L1802 1025L1513 1315L1603 1405L2048 960L1603 515L1513 605L1805 897ZM902 1408L902 512L6 512L6 1408L902 1408ZM390 896L134 896L134 640L390 640L390 896ZM518 896L518 640L774 640L774 896L518 896ZM518 1024L774 1024L774 1280L518 1280L518 1024ZM390 1024L390 1280L134 1280L134 1024L390 1024Z"
         }
      }
   ]
}

var ImportMirrored = {
   name: "ImportMirrored",
   vendor: "UiFabric",
   unicode: 59986,
   value: "",
   charCode: "EA52",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1587 499L1497 589L1805 898L262 898L262 1026L1802 1026L1497 1331L1587 1421L2048 960L1587 499ZM134 1408L134 512L6 512L6 1408L134 1408Z"
         }
      }
   ]
}

var HelpMirrored = {
   name: "HelpMirrored",
   vendor: "UiFabric",
   unicode: 59985,
   value: "",
   charCode: "EA51",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 2048L1024 1920L896 1920L896 2048L1024 2048ZM960 0L960 0Q881 0 807.50 20.50Q734 41 670 78.50Q606 116 553 169Q500 222 462.50 286Q425 350 404.50 423.50Q384 497 384 576L384 576Q384 660 406 728Q428 796 464 852.50Q500 909 546 957Q592 1005 640 1050Q688 1095 734 1139.50Q780 1184 816 1234Q852 1284 874 1342Q896 1400 896 1472L896 1472L896 1664L1024 1664L1024 1472Q1024 1388 1002 1320Q980 1252 944 1195.50Q908 1139 862 1091.50Q816 1044 768 999Q720 954 674 909Q628 864 592 814Q556 764 534 706Q512 648 512 576L512 576Q512 483 547.50 401.50Q583 320 643.50 259.50Q704 199 785.50 163.50Q867 128 960 128L960 128Q1053 128 1134.50 163.50Q1216 199 1276.50 259.50Q1337 320 1372.50 401.50Q1408 483 1408 576L1408 576L1536 576Q1536 497 1515.50 423.50Q1495 350 1457.50 286Q1420 222 1367 169Q1314 116 1250 78.50Q1186 41 1112.50 20.50Q1039 0 960 0Z"
         }
      }
   ]
}

var GoMirrored = {
   name: "GoMirrored",
   vendor: "UiFabric",
   unicode: 59983,
   value: "",
   charCode: "EA4F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1027 0L1027 0L3 0L3 1024L131 1024L131 219L1958 2045L2048 1955L222 128L1027 128L1027 0Z"
         }
      }
   ]
}

var DoubleChevronLeftMedMirrored = {
   name: "DoubleChevronLeftMedMirrored",
   vendor: "UiFabric",
   unicode: 59981,
   value: "",
   charCode: "EA4D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 25L903 146L1782 1024L903 1902L1024 2023L2023 1024L1024 25ZM171 25L50 146L928 1024L50 1902L171 2023L1170 1024L171 25Z"
         }
      }
   ]
}

var DockLeftMirrored = {
   name: "DockLeftMirrored",
   vendor: "UiFabric",
   unicode: 59980,
   value: "",
   charCode: "EA4C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1536L2048 384L0 384L0 1536L2048 1536ZM1536 512L1920 512L1920 1408L1536 1408L1536 512ZM1408 1408L128 1408L128 512L1408 512L1408 1408Z"
         }
      }
   ]
}

var ClosePaneMirrored = {
   name: "ClosePaneMirrored",
   vendor: "UiFabric",
   unicode: 59977,
   value: "",
   charCode: "EA49",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1536L2048 384L0 384L0 1536L2048 1536ZM640 512L1920 512L1920 1408L640 1408L640 512ZM512 1408L128 1408L128 512L512 512L512 1408ZM1149 733L1059 643L742 960L1059 1277L1149 1187L987 1024L1408 1024L1408 896L987 896L1149 733Z"
         }
      }
   ]
}

var ClearSelectionMirrored = {
   name: "ClearSelectionMirrored",
   vendor: "UiFabric",
   unicode: 59976,
   value: "",
   charCode: "EA48",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M463 896L463 896Q394 896 333 922.50Q272 949 226.50 994.50Q181 1040 154.50 1101.50Q128 1163 128 1232L128 1232Q128 1298 153 1359.50Q178 1421 226 1469L226 1469L675 1917L765 1827L317 1378Q288 1349 272 1311Q256 1273 256 1232L256 1232Q256 1189 272.50 1151.50Q289 1114 317.50 1085.50Q346 1057 383.50 1040.50Q421 1024 464 1024L464 1024Q505 1024 543 1040Q581 1056 610 1085L610 1085L805 1280L640 1280L640 1408L1024 1408L1024 1024L896 1024L896 1189Q849 1142 803 1090Q757 1038 705.50 995Q654 952 595 924Q536 896 463 896ZM384 640L384 768L512 768L512 640L384 640ZM384 384L384 512L512 512L512 384L384 384ZM384 128L384 256L512 256L512 128L384 128ZM640 128L640 256L768 256L768 128L640 128ZM896 128L896 256L1024 256L1024 128L896 128ZM1280 256L1280 128L1152 128L1152 256L1280 256ZM1536 256L1536 128L1408 128L1408 256L1536 256ZM1792 256L1792 128L1664 128L1664 256L1792 256ZM2048 256L2048 128L1920 128L1920 256L2048 256ZM2048 512L2048 384L1920 384L1920 512L2048 512ZM2048 768L2048 640L1920 640L1920 768L2048 768ZM2048 1024L2048 896L1920 896L1920 1024L2048 1024ZM2048 1280L2048 1152L1920 1152L1920 1280L2048 1280ZM2048 1536L2048 1408L1920 1408L1920 1536L2048 1536ZM2048 1792L2048 1664L1920 1664L1920 1792L2048 1792ZM1792 1792L1792 1664L1664 1664L1664 1792L1792 1792ZM1536 1792L1536 1664L1408 1664L1408 1792L1536 1792ZM1280 1792L1280 1664L1152 1664L1152 1792L1280 1792ZM1024 1792L1024 1664L896 1664L896 1792L1024 1792Z"
         }
      }
   ]
}

var ChromeBackMirrored = {
   name: "ChromeBackMirrored",
   vendor: "UiFabric",
   unicode: 59975,
   value: "",
   charCode: "EA47",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M7 819L7 1024L1663 1024L989 1698L1133 1843L2055 922L1133 0L989 145L1663 819L7 819Z"
         }
      }
   ]
}

var CaretSolidMirrored = {
   name: "CaretSolidMirrored",
   vendor: "UiFabric",
   unicode: 59974,
   value: "",
   charCode: "EA46",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1536L1536 1536L549 549L549 1536L1536 1536Z"
         }
      }
   ]
}

var CaretHollowMirrored = {
   name: "CaretHollowMirrored",
   vendor: "UiFabric",
   unicode: 59973,
   value: "",
   charCode: "EA45",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1371 1755L1371 293L640 1024L1371 1755ZM822 1024L1243 603L1243 1445L822 1024Z"
         }
      }
   ]
}

var BulletedListMirrored = {
   name: "BulletedListMirrored",
   vendor: "UiFabric",
   unicode: 59970,
   value: "",
   charCode: "EA42",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1280L2048 1280L2048 1152L1920 1152L1920 1280ZM1920 896L2048 896L2048 768L1920 768L1920 896ZM0 896L1664 896L1664 768L0 768L0 896ZM1920 512L2048 512L2048 384L1920 384L1920 512ZM1664 512L1664 384L0 384L0 512L1664 512ZM0 1280L1664 1280L1664 1152L0 1152L0 1280ZM1920 1664L2048 1664L2048 1536L1920 1536L1920 1664ZM0 1664L1664 1664L1664 1536L0 1536L0 1664Z"
         }
      }
   ]
}

var BookmarksMirrored = {
   name: "BookmarksMirrored",
   vendor: "UiFabric",
   unicode: 59969,
   value: "",
   charCode: "EA41",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 512L2048 512L2048 384L1920 384L1920 512ZM1664 512L1664 384L0 384L0 512L1664 512ZM1920 1664L2048 1664L2048 1536L1920 1536L1920 1664ZM0 1664L1664 1664L1664 1536L0 1536L0 1664ZM0 896L1152 896L1152 768L0 768L0 896ZM0 1280L640 1280L640 1152L0 1152L0 1280Z"
         }
      }
   ]
}

var AllAppsMirrored = {
   name: "AllAppsMirrored",
   vendor: "UiFabric",
   unicode: 59968,
   value: "",
   charCode: "EA40",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1408L2048 1408L2048 1024L1664 1024L1664 1408ZM1792 1152L1920 1152L1920 1280L1792 1280L1792 1152ZM1664 896L2048 896L2048 512L1664 512L1664 896ZM1792 640L1920 640L1920 768L1792 768L1792 640ZM1664 384L2048 384L2048 0L1664 0L1664 384ZM1792 128L1920 128L1920 256L1792 256L1792 128ZM256 768L1408 768L1408 640L256 640L256 768ZM1408 1152L512 1152L512 1280L1408 1280L1408 1152ZM1408 256L1408 128L0 128L0 256L1408 256ZM1664 1920L2048 1920L2048 1536L1664 1536L1664 1920ZM1792 1664L1920 1664L1920 1792L1792 1792L1792 1664ZM256 1792L1408 1792L1408 1664L256 1664L256 1792Z"
         }
      }
   ]
}

var Media = {
   name: "Media",
   vendor: "UiFabric",
   unicode: 60009,
   value: "",
   charCode: "EA69",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 894L2048 670L2048 1568Q2048 1619 2025.50 1660Q2003 1701 1967 1730.50Q1931 1760 1885 1776Q1839 1792 1792 1792L1792 1792Q1745 1792 1699 1776Q1653 1760 1617 1730.50Q1581 1701 1558.50 1660Q1536 1619 1536 1568L1536 1568Q1536 1517 1558.50 1475.50Q1581 1434 1617 1405Q1653 1376 1699 1360Q1745 1344 1792 1344L1792 1344Q1858 1344 1920 1375L1920 1375L1920 834L1280 994L1280 1696Q1280 1747 1257.50 1788Q1235 1829 1199 1858.50Q1163 1888 1117 1904Q1071 1920 1024 1920L1024 1920Q977 1920 931 1904Q885 1888 849 1858.50Q813 1829 790.50 1788Q768 1747 768 1696L768 1696Q768 1645 790.50 1603.50Q813 1562 849 1533Q885 1504 931 1488Q977 1472 1024 1472L1024 1472Q1090 1472 1152 1503L1152 1503L1152 894ZM1024 1792L1024 1792Q1044 1792 1066.50 1786Q1089 1780 1108 1768Q1127 1756 1139.50 1738Q1152 1720 1152 1696L1152 1696Q1152 1672 1139.50 1654Q1127 1636 1108 1624Q1089 1612 1066.50 1606Q1044 1600 1024 1600L1024 1600Q1004 1600 981.50 1606Q959 1612 940 1624Q921 1636 908.50 1654Q896 1672 896 1696L896 1696Q896 1720 908.50 1738Q921 1756 940 1768Q959 1780 981.50 1786Q1004 1792 1024 1792ZM1792 1664L1792 1664Q1812 1664 1834.50 1658Q1857 1652 1876 1640Q1895 1628 1907.50 1610Q1920 1592 1920 1568L1920 1568Q1920 1544 1907.50 1526Q1895 1508 1876 1496Q1857 1484 1834.50 1478Q1812 1472 1792 1472L1792 1472Q1772 1472 1749.50 1478Q1727 1484 1708 1496Q1689 1508 1676.50 1526Q1664 1544 1664 1568L1664 1568Q1664 1592 1676.50 1610Q1689 1628 1708 1640Q1727 1652 1749.50 1658Q1772 1664 1792 1664ZM384 512L384 640L256 640L256 512L384 512ZM256 896L256 768L384 768L384 896L256 896ZM1152 640L1152 512L1280 512L1280 640L1152 640ZM1024 1152L1024 1280L0 1280L0 128L1536 128L1536 640L1408 672L1408 256L1280 256L1280 384L1152 384L1152 256L384 256L384 384L256 384L256 256L128 256L128 1152L256 1152L256 1024L384 1024L384 1152L1024 1152Z"
         }
      }
   ]
}

var Devices3 = {
   name: "Devices3",
   vendor: "UiFabric",
   unicode: 60012,
   value: "",
   charCode: "EA6C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 896L256 384L1920 384L1920 1408L1152 1408L1152 1536L1408 1536L1408 1664L768 1664L768 1536L1024 1536L1024 1408L640 1408L640 1664L128 1664L128 896L256 896ZM256 1536L512 1536L512 1024L256 1024L256 1536ZM640 896L640 1280L1792 1280L1792 512L384 512L384 896L640 896Z"
         }
      }
   ]
}

var FlashOff = {
   name: "FlashOff",
   vendor: "UiFabric",
   unicode: 60014,
   value: "",
   charCode: "EA6E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 1152L1472 1152Q1565 1152 1646.50 1187.50Q1728 1223 1788.50 1283.50Q1849 1344 1884.50 1425.50Q1920 1507 1920 1600L1920 1600Q1920 1693 1884.50 1774.50Q1849 1856 1788.50 1916.50Q1728 1977 1646.50 2012.50Q1565 2048 1472 2048L1472 2048Q1379 2048 1297.50 2012.50Q1216 1977 1155.50 1916.50Q1095 1856 1059.50 1774.50Q1024 1693 1024 1600L1024 1600Q1024 1507 1059.50 1425.50Q1095 1344 1155.50 1283.50Q1216 1223 1297.50 1187.50Q1379 1152 1472 1152ZM1152 1600L1152 1600Q1152 1666 1177 1724.50Q1202 1783 1245.50 1826.50Q1289 1870 1347.50 1895Q1406 1920 1472 1920L1472 1920Q1519 1920 1564 1906.50Q1609 1893 1648 1867L1648 1867L1205 1424Q1179 1463 1165.50 1508Q1152 1553 1152 1600ZM1296 1333L1739 1776Q1765 1737 1778.50 1692Q1792 1647 1792 1600L1792 1600Q1792 1534 1766.50 1476Q1741 1418 1697.50 1374.50Q1654 1331 1596 1305.50Q1538 1280 1472 1280L1472 1280Q1425 1280 1380 1293.50Q1335 1307 1296 1333L1296 1333ZM1573 896L1016 896L1400 128L967 128L455 1152L904 1152L520 1920L549 1920L896 1573L896 1755L603 2048L313 2048L697 1280L248 1280L888 0L1607 0L1223 768L1883 768L1627 1024L1445 1024L1573 896Z"
         }
      }
   ]
}

var Focus = {
   name: "Focus",
   vendor: "UiFabric",
   unicode: 60015,
   value: "",
   charCode: "EA6F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 120L1024 120Q1149 120 1264.50 152.50Q1380 185 1480.50 243.50Q1581 302 1663.50 384.50Q1746 467 1804.50 567.50Q1863 668 1895.50 783.50Q1928 899 1928 1024L1928 1024Q1928 1149 1895.50 1264.50Q1863 1380 1804.50 1480.50Q1746 1581 1663.50 1663.50Q1581 1746 1480.50 1804.50Q1380 1863 1264.50 1895.50Q1149 1928 1024 1928L1024 1928Q899 1928 783.50 1895.50Q668 1863 567.50 1804.50Q467 1746 384.50 1663.50Q302 1581 243.50 1480.50Q185 1380 152.50 1264.50Q120 1149 120 1024L120 1024Q120 899 152.50 783.50Q185 668 243.50 567.50Q302 467 384.50 384.50Q467 302 567.50 243.50Q668 185 783.50 152.50Q899 120 1024 120ZM1024 1800L1024 1800Q1131 1800 1230 1772Q1329 1744 1415.50 1693.50Q1502 1643 1572.50 1572.50Q1643 1502 1693.50 1415.50Q1744 1329 1772 1230Q1800 1131 1800 1024L1800 1024Q1800 917 1772 818Q1744 719 1693.50 632.50Q1643 546 1572.50 475.50Q1502 405 1415.50 354.50Q1329 304 1230 276Q1131 248 1024 248L1024 248Q917 248 818 276Q719 304 632.50 354.50Q546 405 475.50 475.50Q405 546 354.50 632.50Q304 719 276 818Q248 917 248 1024L248 1024Q248 1131 276 1230Q304 1329 354.50 1415.50Q405 1502 475.50 1572.50Q546 1643 632.50 1693.50Q719 1744 818 1772Q917 1800 1024 1800ZM744 640L1304 640Q1325 640 1344 648Q1363 656 1377.50 670.50Q1392 685 1400 704Q1408 723 1408 744L1408 744L1408 1304Q1408 1325 1400 1344Q1392 1363 1377.50 1377.50Q1363 1392 1344 1400Q1325 1408 1304 1408L1304 1408L744 1408Q723 1408 704 1400Q685 1392 670.50 1377.50Q656 1363 648 1344Q640 1325 640 1304L640 1304L640 744Q640 723 648 704Q656 685 670.50 670.50Q685 656 704 648Q723 640 744 640L744 640ZM1280 1280L1280 768L768 768L768 1280L1280 1280Z"
         }
      }
   ]
}

var VideoLightOff = {
   name: "VideoLightOff",
   vendor: "UiFabric",
   unicode: 60020,
   value: "",
   charCode: "EA74",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 960L1024 960Q1024 934 1043 915Q1062 896 1088 896L1088 896Q1114 896 1133 915Q1152 934 1152 960L1152 960Q1152 986 1133 1005Q1114 1024 1088 1024L1088 1024Q1062 1024 1043 1005Q1024 986 1024 960ZM1600 1152L1600 1152Q1693 1152 1774.50 1187.50Q1856 1223 1916.50 1283.50Q1977 1344 2012.50 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2012.50 1774.50Q1977 1856 1916.50 1916.50Q1856 1977 1774.50 2012.50Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2012.50Q1344 1977 1283.50 1916.50Q1223 1856 1187.50 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187.50 1425.50Q1223 1344 1283.50 1283.50Q1344 1223 1425.50 1187.50Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333ZM1573 384L2048 384L2048 1192Q1991 1130 1920 1085L1920 1085L1920 512L1792 512L1792 1026Q1761 1015 1728.50 1008.50Q1696 1002 1664 998L1664 998L1664 512L1627 512L1408 731L1408 1026Q1374 1037 1342 1051.50Q1310 1066 1280 1085L1280 1085L1280 768L128 768L128 1152L1192 1152Q1130 1209 1085 1280L1085 1280L0 1280L0 640L1317 640L1573 384Z"
         }
      }
   ]
}

var Lightbulb = {
   name: "Lightbulb",
   vendor: "UiFabric",
   unicode: 60032,
   value: "",
   charCode: "EA80",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1057 0 1147 25Q1237 50 1315.50 96Q1394 142 1458 206Q1522 270 1568 348.50Q1614 427 1639 517Q1664 607 1664 704L1664 704Q1664 849 1609 973Q1554 1097 1452 1198L1452 1198Q1369 1280 1324.50 1381Q1280 1482 1280 1600L1280 1600L1280 1856Q1280 1896 1265 1931Q1250 1966 1224 1992Q1198 2018 1163 2033Q1128 2048 1088 2048L1088 2048L832 2048Q792 2048 757 2033Q722 2018 696 1992Q670 1966 655 1931Q640 1896 640 1856L640 1856L640 1600Q640 1482 595.50 1381Q551 1280 468 1198L468 1198Q366 1097 311 973Q256 849 256 704L256 704Q256 607 281 517Q306 427 352 348.50Q398 270 462 206Q526 142 604.50 96Q683 50 773 25Q863 0 960 0ZM832 1920L1088 1920Q1114 1920 1133 1901Q1152 1882 1152 1856L1152 1856L1152 1664L768 1664L768 1856Q768 1882 787 1901Q806 1920 832 1920L832 1920ZM765 1536L1155 1536Q1168 1407 1221 1302Q1274 1197 1364 1106L1364 1106Q1447 1022 1491.50 922.50Q1536 823 1536 704L1536 704Q1536 585 1490.50 480Q1445 375 1367 297Q1289 219 1184 173.50Q1079 128 960 128L960 128Q841 128 736 173.50Q631 219 553 297Q475 375 429.50 480Q384 585 384 704L384 704Q384 823 428.50 922.50Q473 1022 556 1106L556 1106Q646 1197 699 1302Q752 1407 765 1536L765 1536Z"
         }
      }
   ]
}

var StatusTriangle = {
   name: "StatusTriangle",
   vendor: "UiFabric",
   unicode: 60034,
   value: "",
   charCode: "EA82",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 896L1472 896L2048 2048L896 2048L1472 896Z"
         }
      }
   ]
}

var SortLines = {
   name: "SortLines",
   vendor: "UiFabric",
   unicode: 59856,
   value: "",
   charCode: "E9D0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 128L384 1638L547 1475L637 1565L320 1883L3 1565L93 1475L256 1638L256 128L384 128ZM1280 1280L768 1280L768 1152L1280 1152L1280 1280ZM1664 896L768 896L768 768L1664 768L1664 896ZM768 512L768 384L2048 384L2048 512L768 512Z"
         }
      }
   ]
}

var Ribbon = {
   name: "Ribbon",
   vendor: "UiFabric",
   unicode: 59857,
   value: "",
   charCode: "E9D1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L1024 1024Q944 1024 874.50 994Q805 964 752.50 911.50Q700 859 670 789.50Q640 720 640 640L640 640Q640 561 670 491Q700 421 752.50 368.50Q805 316 874.50 286Q944 256 1024 256L1024 256Q1103 256 1173 286Q1243 316 1295.50 368.50Q1348 421 1378 491Q1408 561 1408 640L1408 640Q1408 720 1378 789.50Q1348 859 1295.50 911.50Q1243 964 1173 994Q1103 1024 1024 1024ZM1024 384L1024 384Q971 384 924.50 404Q878 424 843 459Q808 494 788 540.50Q768 587 768 640L768 640Q768 693 788 739.50Q808 786 843 821Q878 856 924.50 876Q971 896 1024 896L1024 896Q1077 896 1123.50 876Q1170 856 1205 821Q1240 786 1260 739.50Q1280 693 1280 640L1280 640Q1280 587 1260 540.50Q1240 494 1205 459Q1170 424 1123.50 404Q1077 384 1024 384ZM1664 640L1664 640Q1664 744 1631.50 842.50Q1599 941 1536 1024L1536 1024L1536 2048L1024 1792L512 2048L512 1024Q449 941 416.50 842.50Q384 744 384 640L384 640Q384 507 434 390.50Q484 274 571 187Q658 100 774.50 50Q891 0 1024 0L1024 0Q1157 0 1273.50 50Q1390 100 1477 187Q1564 274 1614 390.50Q1664 507 1664 640ZM1024 128L1024 128Q918 128 825 168.50Q732 209 662.50 278.50Q593 348 552.50 441Q512 534 512 640L512 640Q512 746 552.50 839Q593 932 662.50 1001.50Q732 1071 825 1111.50Q918 1152 1024 1152L1024 1152Q1130 1152 1223 1111.50Q1316 1071 1385.50 1001.50Q1455 932 1495.50 839Q1536 746 1536 640L1536 640Q1536 534 1495.50 441Q1455 348 1385.50 278.50Q1316 209 1223 168.50Q1130 128 1024 128ZM1024 1664L1408 1856L1408 1152Q1325 1215 1226.50 1247.50Q1128 1280 1024 1280L1024 1280Q920 1280 821.50 1247.50Q723 1215 640 1152L640 1152L640 1856L1024 1664Z"
         }
      }
   ]
}

var AreaChart = {
   name: "AreaChart",
   vendor: "UiFabric",
   unicode: 59858,
   value: "",
   charCode: "E9D2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 129L256 1792L1920 1793L1920 1921L128 1920L128 129L256 129ZM1472 486L1920 933L1920 1664L384 1664L384 760L704 600L1139 818L1472 486ZM1165 974L704 744L512 839L512 1280L945 1280L1485 1010L1792 1317L1792 987L1472 666L1165 974ZM512 1408L512 1536L1792 1536L1792 1499L1459 1166L975 1408L512 1408Z"
         }
      }
   ]
}

var Assign = {
   name: "Assign",
   vendor: "UiFabric",
   unicode: 59859,
   value: "",
   charCode: "E9D3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1693 1411L2011 1728L1693 2045L1603 1955L1766 1792L1152 1792L1152 1664L1766 1664L1603 1501L1693 1411ZM384 1920L1387 1920L1515 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256L1792 256L1792 1329L1664 1201L1664 384L1536 384L1536 640L512 640L512 384L384 384L384 1920ZM896 384L640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384Z"
         }
      }
   ]
}

var FlowChart = {
   name: "FlowChart",
   vendor: "UiFabric",
   unicode: 59860,
   value: "",
   charCode: "E9D4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1408L1408 1152L2048 1152L2048 1792L1408 1792L1408 1536L992 1536L576 1952L96 1472L512 1056L512 640L256 640L256 0L896 0L896 640L640 640L640 1056L992 1408L1408 1408ZM768 128L384 128L384 512L768 512L768 128ZM288 1472L576 1760L864 1472L576 1184L288 1472ZM1536 1664L1920 1664L1920 1280L1536 1280L1536 1664Z"
         }
      }
   ]
}

var CheckList = {
   name: "CheckList",
   vendor: "UiFabric",
   unicode: 59861,
   value: "",
   charCode: "E9D5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 896L640 896L640 768L2048 768L2048 896ZM640 512L640 384L2048 384L2048 512L640 512ZM2048 1280L640 1280L640 1152L2048 1152L2048 1280ZM2048 1664L640 1664L640 1536L2048 1536L2048 1664ZM109 387L192 469L403 259L493 349L192 650L19 477L109 387ZM109 771L192 853L403 643L493 733L192 1034L19 861L109 771ZM109 1155L192 1237L403 1027L493 1117L192 1418L19 1245L109 1155ZM109 1539L192 1621L403 1411L493 1501L192 1802L19 1629L109 1539Z"
         }
      }
   ]
}

var Diagnostic = {
   name: "Diagnostic",
   vendor: "UiFabric",
   unicode: 59865,
   value: "",
   charCode: "E9D9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1792 256L256 256L256 1280L406 1280L515 1171Q534 1152 560 1152L560 1152Q586 1152 605 1171L605 1171L782 1347L1026 400Q1031 379 1048.50 365.50Q1066 352 1088 352L1088 352Q1111 352 1128 365.50Q1145 379 1150 401L1150 401L1252 818L1408 818Q1430 818 1447.50 831.50Q1465 845 1470 866L1470 866L1542 1152L1792 1152L1792 256ZM256 1792L1792 1792L1792 1280L1492 1280Q1469 1280 1452 1266.50Q1435 1253 1430 1231L1430 1231L1358 946L1202 946Q1179 946 1162 932.50Q1145 919 1140 897L1140 897L1086 679L878 1488Q873 1509 855.50 1522.50Q838 1536 816 1536L816 1536Q790 1536 771 1517L771 1517L560 1306L477 1389Q458 1408 432 1408L432 1408L256 1408L256 1792Z"
         }
      }
   ]
}

var Generate = {
   name: "Generate",
   vendor: "UiFabric",
   unicode: 59866,
   value: "",
   charCode: "E9DA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1693 1411L2011 1728L1693 2045L1603 1955L1766 1792L1152 1792L1152 1664L1766 1664L1603 1501L1693 1411ZM256 1920L1342 1920L1470 2048L128 2048L128 0L1243 0L1792 549L1792 1283L1664 1155L1664 640L1152 640L1152 128L256 128L256 1920ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var Total = {
   name: "Total",
   vendor: "UiFabric",
   unicode: 59871,
   value: "",
   charCode: "E9DF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 128L1792 384L1664 384L1664 256L475 256L1243 1024L475 1792L1664 1792L1664 1664L1792 1664L1792 1920L256 1920L256 1829L1061 1024L256 219L256 128L1792 128Z"
         }
      }
   ]
}

var Equalizer = {
   name: "Equalizer",
   vendor: "UiFabric",
   unicode: 59881,
   value: "",
   charCode: "E9E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L2048 256L2048 384L1280 384L1280 448Q1280 488 1265 523Q1250 558 1224 584Q1198 610 1163 625Q1128 640 1088 640L1088 640Q1048 640 1013 625Q978 610 952 584Q926 558 911 523Q896 488 896 448L896 448L896 384L0 384L0 256L896 256L896 192Q896 152 911 117Q926 82 952 56Q978 30 1013 15Q1048 0 1088 0L1088 0Q1128 0 1163 15Q1198 30 1224 56Q1250 82 1265 117Q1280 152 1280 192L1280 192L1280 256ZM1600 1280L1600 1280Q1640 1280 1675 1295Q1710 1310 1736 1336Q1762 1362 1777 1397Q1792 1432 1792 1472L1792 1472L1792 1536L2048 1536L2048 1664L1792 1664L1792 1728Q1792 1768 1777 1803Q1762 1838 1736 1864Q1710 1890 1675 1905Q1640 1920 1600 1920L1600 1920Q1560 1920 1525 1905Q1490 1890 1464 1864Q1438 1838 1423 1803Q1408 1768 1408 1728L1408 1728L1408 1664L0 1664L0 1536L1408 1536L1408 1472Q1408 1432 1423 1397Q1438 1362 1464 1336Q1490 1310 1525 1295Q1560 1280 1600 1280ZM448 640L448 640Q488 640 523 655Q558 670 584 696Q610 722 625 757Q640 792 640 832L640 832L640 896L2048 896L2048 1024L640 1024L640 1088Q640 1128 625 1163Q610 1198 584 1224Q558 1250 523 1265Q488 1280 448 1280L448 1280Q408 1280 373 1265Q338 1250 312 1224Q286 1198 271 1163Q256 1128 256 1088L256 1088L256 1024L0 1024L0 896L256 896L256 832Q256 792 271 757Q286 722 312 696Q338 670 373 655Q408 640 448 640ZM512 1088L512 832Q512 806 493 787Q474 768 448 768L448 768Q422 768 403 787Q384 806 384 832L384 832L384 1088Q384 1114 403 1133Q422 1152 448 1152L448 1152Q474 1152 493 1133Q512 1114 512 1088L512 1088ZM1152 448L1152 192Q1152 166 1133 147Q1114 128 1088 128L1088 128Q1062 128 1043 147Q1024 166 1024 192L1024 192L1024 448Q1024 474 1043 493Q1062 512 1088 512L1088 512Q1114 512 1133 493Q1152 474 1152 448L1152 448ZM1664 1728L1664 1472Q1664 1446 1645 1427Q1626 1408 1600 1408L1600 1408Q1574 1408 1555 1427Q1536 1446 1536 1472L1536 1472L1536 1728Q1536 1754 1555 1773Q1574 1792 1600 1792L1600 1792Q1626 1792 1645 1773Q1664 1754 1664 1728L1664 1728Z"
         }
      }
   ]
}

var BarChartHorizontal = {
   name: "BarChartHorizontal",
   vendor: "UiFabric",
   unicode: 59883,
   value: "",
   charCode: "E9EB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 256L1536 256L1536 640L384 640L384 256ZM512 512L1408 512L1408 384L512 384L512 512ZM384 768L1280 768L1280 1152L384 1152L384 768ZM512 1024L1152 1024L1152 896L512 896L512 1024ZM384 1280L1792 1280L1792 1664L384 1664L384 1280ZM512 1536L1664 1536L1664 1408L512 1408L512 1536ZM256 128L256 1792L1920 1792L1920 1920L128 1920L128 128L256 128Z"
         }
      }
   ]
}

var BarChartVertical = {
   name: "BarChartVertical",
   vendor: "UiFabric",
   unicode: 59884,
   value: "",
   charCode: "E9EC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 512L768 512L768 1664L384 1664L384 512ZM512 1536L640 1536L640 640L512 640L512 1536ZM896 768L1280 768L1280 1664L896 1664L896 768ZM1024 1536L1152 1536L1152 896L1024 896L1024 1536ZM1408 256L1792 256L1792 1664L1408 1664L1408 256ZM1536 1536L1664 1536L1664 384L1536 384L1536 1536ZM256 128L256 1792L1920 1792L1920 1920L128 1920L128 128L256 128Z"
         }
      }
   ]
}

var TriangleSolid = {
   name: "TriangleSolid",
   vendor: "UiFabric",
   unicode: 59912,
   value: "",
   charCode: "EA08",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 146L1024 146L2048 1920L0 1920L1024 146Z"
         }
      }
   ]
}

var UpgradeAnalysis = {
   name: "UpgradeAnalysis",
   vendor: "UiFabric",
   unicode: 59915,
   value: "",
   charCode: "EA0B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 933L1277 1251L1187 1341L1024 1178L1024 1728L896 1728L896 1178L733 1341L643 1251L960 933ZM1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363ZM256 128L256 1920L1152 1920L1152 2048L128 2048L128 0L1243 0L1792 549L1792 1283L1664 1411L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var VideoSolid = {
   name: "VideoSolid",
   vendor: "UiFabric",
   unicode: 59916,
   value: "",
   charCode: "EA0C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1408L0 1408L0 512L1408 512L1408 1408ZM1536 1152L1536 768L2048 512L2048 1408L1536 1152Z"
         }
      }
   ]
}

var VolumeDisabled = {
   name: "VolumeDisabled",
   vendor: "UiFabric",
   unicode: 60037,
   value: "",
   charCode: "EA85",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM858 768L640 768L640 1280L762 1280Q754 1312 748 1344Q742 1376 739 1408L739 1408L512 1408L512 640L805 640L1189 256L1280 256L1280 762Q1213 780 1152 810L1152 810L1152 475L858 768ZM1619 1235L1709 1325L1562 1472L1709 1619L1619 1709L1472 1563L1325 1709L1235 1619L1381 1472L1235 1325L1325 1235L1472 1382L1619 1235Z"
         }
      }
   ]
}

var Puzzle = {
   name: "Puzzle",
   vendor: "UiFabric",
   unicode: 60038,
   value: "",
   charCode: "EA86",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 896L1600 896Q1573 896 1550 906Q1527 916 1509.50 933.50Q1492 951 1482 974Q1472 997 1472 1024L1472 1024Q1472 1051 1482 1074Q1492 1097 1509.50 1114.50Q1527 1132 1550 1142Q1573 1152 1600 1152L1600 1152L1792 1152L1792 1664L1408 1664L1408 1728Q1408 1781 1388 1827.50Q1368 1874 1333 1909Q1298 1944 1251.50 1964Q1205 1984 1152 1984L1152 1984Q1099 1984 1052.50 1964Q1006 1944 971 1909Q936 1874 916 1827.50Q896 1781 896 1728L896 1728L896 1664L512 1664L512 1280L448 1280Q395 1280 348.50 1260Q302 1240 267 1205Q232 1170 212 1123.50Q192 1077 192 1024L192 1024Q192 971 212 924.50Q232 878 267 843Q302 808 348.50 788Q395 768 448 768L448 768L512 768L512 384L896 384L896 320Q896 267 916 220.50Q936 174 971 139Q1006 104 1052.50 84Q1099 64 1152 64L1152 64Q1205 64 1251.50 84Q1298 104 1333 139Q1368 174 1388 220.50Q1408 267 1408 320L1408 320L1408 384L1792 384L1792 896ZM1664 1280L1600 1280Q1547 1280 1500.50 1260Q1454 1240 1419 1205Q1384 1170 1364 1123.50Q1344 1077 1344 1024L1344 1024Q1344 971 1364 924.50Q1384 878 1419 843Q1454 808 1500.50 788Q1547 768 1600 768L1600 768L1664 768L1664 512L1280 512L1280 320Q1280 293 1270 270Q1260 247 1242.50 229.50Q1225 212 1202 202Q1179 192 1152 192L1152 192Q1125 192 1102 202Q1079 212 1061.50 229.50Q1044 247 1034 270Q1024 293 1024 320L1024 320L1024 512L640 512L640 896L448 896Q421 896 398 906Q375 916 357.50 933.50Q340 951 330 974Q320 997 320 1024L320 1024Q320 1051 330 1074Q340 1097 357.50 1114.50Q375 1132 398 1142Q421 1152 448 1152L448 1152L640 1152L640 1536L1024 1536L1024 1728Q1024 1755 1034 1778Q1044 1801 1061.50 1818.50Q1079 1836 1102 1846Q1125 1856 1152 1856L1152 1856Q1179 1856 1202 1846Q1225 1836 1242.50 1818.50Q1260 1801 1270 1778Q1280 1755 1280 1728L1280 1728L1280 1536L1664 1536L1664 1280Z"
         }
      }
   ]
}

var EmojiNeutral = {
   name: "EmojiNeutral",
   vendor: "UiFabric",
   unicode: 60039,
   value: "",
   charCode: "EA87",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1536L640 1408L1408 1408L1408 1536L640 1536ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM768 896L768 896Q768 923 758 946Q748 969 730.50 986.50Q713 1004 690 1014Q667 1024 640 1024L640 1024Q613 1024 590 1014Q567 1004 549.50 986.50Q532 969 522 946Q512 923 512 896L512 896Q512 869 522 846Q532 823 549.50 805.50Q567 788 590 778Q613 768 640 768L640 768Q667 768 690 778Q713 788 730.50 805.50Q748 823 758 846Q768 869 768 896ZM1408 768L1408 768Q1435 768 1458 778Q1481 788 1498.50 805.50Q1516 823 1526 846Q1536 869 1536 896L1536 896Q1536 923 1526 946Q1516 969 1498.50 986.50Q1481 1004 1458 1014Q1435 1024 1408 1024L1408 1024Q1381 1024 1358 1014Q1335 1004 1317.50 986.50Q1300 969 1290 946Q1280 923 1280 896L1280 896Q1280 869 1290 846Q1300 823 1317.50 805.50Q1335 788 1358 778Q1381 768 1408 768Z"
         }
      }
   ]
}

var EmojiDisappointed = {
   name: "EmojiDisappointed",
   vendor: "UiFabric",
   unicode: 60040,
   value: "",
   charCode: "EA88",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1280L1024 1280Q1096 1280 1173 1296Q1250 1312 1320 1344.50Q1390 1377 1448 1427Q1506 1477 1540 1545L1540 1545L1425 1602Q1399 1551 1353 1514.50Q1307 1478 1251.50 1454Q1196 1430 1136 1419Q1076 1408 1024 1408L1024 1408Q970 1408 910.50 1418.50Q851 1429 795.50 1452.50Q740 1476 694.50 1513Q649 1550 623 1602L623 1602L508 1545Q542 1476 599.50 1425.50Q657 1375 727 1343Q797 1311 874 1295.50Q951 1280 1024 1280ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM820 801L767 917Q720 896 670 896L670 896Q635 896 601.50 906Q568 916 539.50 934.50Q511 953 488.50 979Q466 1005 451 1037L451 1037L334 984Q356 935 391 895Q426 855 470 827Q514 799 564.50 783.50Q615 768 669 768L669 768Q749 768 820 801L820 801ZM1280 917L1228 801Q1263 784 1301.50 776Q1340 768 1379 768L1379 768Q1433 768 1483.50 783.50Q1534 799 1578 827Q1622 855 1656.50 895Q1691 935 1714 984L1714 984L1597 1037Q1582 1005 1559.50 979Q1537 953 1508.50 934.50Q1480 916 1446.50 906Q1413 896 1378 896L1378 896Q1326 896 1280 917L1280 917Z"
         }
      }
   ]
}

var HomeSolid = {
   name: "HomeSolid",
   vendor: "UiFabric",
   unicode: 60042,
   value: "",
   charCode: "EA8A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 166L1024 166L1965 1107L1875 1197L1792 1115L1792 1920L1280 1920L1280 1280L768 1280L768 1920L256 1920L256 1115L173 1197L83 1107L1024 166Z"
         }
      }
   ]
}

var AddToShoppingList = {
   name: "AddToShoppingList",
   vendor: "UiFabric",
   unicode: 60058,
   value: "",
   charCode: "EA9A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 768L640 896L512 896L512 768L640 768ZM1536 768L1536 896L768 896L768 768L1536 768ZM512 1280L512 1152L640 1152L640 1280L512 1280ZM768 1280L768 1152L1536 1152L1536 1280L768 1280ZM640 384L640 512L512 512L512 384L640 384ZM1536 384L1536 512L768 512L768 384L1536 384ZM1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408L1792 1664ZM384 128L384 1664L1280 1664L1280 1792L256 1792L256 0L1792 0L1792 1280L1664 1280L1664 128L384 128Z"
         }
      }
   ]
}

var Cocktails = {
   name: "Cocktails",
   vendor: "UiFabric",
   unicode: 60061,
   value: "",
   charCode: "EA9D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 64L1792 64Q1792 90 1773 109L1773 109L1024 859L1024 1920L1344 1920Q1370 1920 1389 1939Q1408 1958 1408 1984L1408 1984Q1408 2010 1389 2029Q1370 2048 1344 2048L1344 2048L576 2048Q550 2048 531 2029Q512 2010 512 1984L512 1984Q512 1958 531 1939Q550 1920 576 1920L576 1920L896 1920L896 859L147 109Q128 90 128 64L128 64Q128 38 147 19Q166 0 192 0L192 0L1728 0Q1754 0 1773 19Q1792 38 1792 64ZM1573 128L346 128L960 742L1573 128Z"
         }
      }
   ]
}

var Wines = {
   name: "Wines",
   vendor: "UiFabric",
   unicode: 60095,
   value: "",
   charCode: "EABF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 704L1536 704Q1536 814 1497 912.50Q1458 1011 1389 1087.50Q1320 1164 1226.50 1214Q1133 1264 1024 1277L1024 1277L1024 1920L1216 1920Q1242 1920 1261 1939Q1280 1958 1280 1984L1280 1984Q1280 2010 1261 2029Q1242 2048 1216 2048L1216 2048L704 2048Q678 2048 659 2029Q640 2010 640 1984L640 1984Q640 1958 659 1939Q678 1920 704 1920L704 1920L896 1920L896 1277Q787 1264 693.50 1214Q600 1164 531 1087.50Q462 1011 423 912.50Q384 814 384 704L384 704Q384 616 398.50 531.50Q413 447 441 363L441 363L562 0L1358 0L1479 363Q1507 447 1521.50 531.50Q1536 616 1536 704ZM512 704L512 704Q512 797 547.50 878.50Q583 960 643.50 1020.50Q704 1081 785.50 1116.50Q867 1152 960 1152L960 1152Q1053 1152 1134.50 1116.50Q1216 1081 1276.50 1020.50Q1337 960 1372.50 878.50Q1408 797 1408 704L1408 704Q1408 628 1394.50 555Q1381 482 1360.50 411Q1340 340 1315 269.50Q1290 199 1266 128L1266 128L654 128L562 405Q538 478 525 552Q512 626 512 704Z"
         }
      }
   ]
}

var Articles = {
   name: "Articles",
   vendor: "UiFabric",
   unicode: 60097,
   value: "",
   charCode: "EAC1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 768L1536 768L1536 896L512 896L512 768ZM512 256L1280 256L1280 384L512 384L512 256ZM1536 1792L1024 1792L1024 1152L1536 1152L1536 1792ZM1408 1280L1152 1280L1152 1664L1408 1664L1408 1280ZM512 512L1536 512L1536 640L512 640L512 512ZM256 2048L256 0L1792 0L1792 2048L256 2048ZM384 1920L1664 1920L1664 128L384 128L384 1920ZM512 1664L896 1664L896 1792L512 1792L512 1664ZM512 1152L896 1152L896 1280L512 1280L512 1152ZM512 1408L896 1408L896 1536L512 1536L512 1408Z"
         }
      }
   ]
}

var Cycling = {
   name: "Cycling",
   vendor: "UiFabric",
   unicode: 60103,
   value: "",
   charCode: "EAC7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1152L384 1152Q463 1152 533 1182Q603 1212 655.50 1264.50Q708 1317 738 1387Q768 1457 768 1536L768 1536Q768 1616 738 1685.50Q708 1755 655.50 1807.50Q603 1860 533 1890Q463 1920 384 1920L384 1920Q304 1920 234.50 1890Q165 1860 112.50 1807.50Q60 1755 30 1685.50Q0 1616 0 1536L0 1536Q0 1457 30 1387Q60 1317 112.50 1264.50Q165 1212 234.50 1182Q304 1152 384 1152ZM384 1792L384 1792Q437 1792 483.50 1772Q530 1752 565 1717Q600 1682 620 1635.50Q640 1589 640 1536L640 1536Q640 1483 620 1436.50Q600 1390 565 1355Q530 1320 483.50 1300Q437 1280 384 1280L384 1280Q331 1280 284.50 1300Q238 1320 203 1355Q168 1390 148 1436.50Q128 1483 128 1536L128 1536Q128 1589 148 1635.50Q168 1682 203 1717Q238 1752 284.50 1772Q331 1792 384 1792ZM1664 1152L1664 1152Q1743 1152 1813 1182Q1883 1212 1935.50 1264.50Q1988 1317 2018 1387Q2048 1457 2048 1536L2048 1536Q2048 1616 2018 1685.50Q1988 1755 1935.50 1807.50Q1883 1860 1813 1890Q1743 1920 1664 1920L1664 1920Q1584 1920 1514.50 1890Q1445 1860 1392.50 1807.50Q1340 1755 1310 1685.50Q1280 1616 1280 1536L1280 1536Q1280 1457 1310 1387Q1340 1317 1392.50 1264.50Q1445 1212 1514.50 1182Q1584 1152 1664 1152ZM1664 1792L1664 1792Q1717 1792 1763.50 1772Q1810 1752 1845 1717Q1880 1682 1900 1635.50Q1920 1589 1920 1536L1920 1536Q1920 1483 1900 1436.50Q1880 1390 1845 1355Q1810 1320 1763.50 1300Q1717 1280 1664 1280L1664 1280Q1611 1280 1564.50 1300Q1518 1320 1483 1355Q1448 1390 1428 1436.50Q1408 1483 1408 1536L1408 1536Q1408 1589 1428 1635.50Q1448 1682 1483 1717Q1518 1752 1564.50 1772Q1611 1792 1664 1792ZM1728 1088L1408 1088Q1382 1088 1363 1069L1363 1069L1248 955L1146 1056Q1155 1065 1167.50 1076Q1180 1087 1190.50 1099Q1201 1111 1208.50 1124Q1216 1137 1216 1152L1216 1152L1216 1600Q1216 1640 1201 1675Q1186 1710 1160 1736Q1134 1762 1099 1777Q1064 1792 1024 1792L1024 1792Q984 1792 949 1777Q914 1762 888 1736Q862 1710 847 1675Q832 1640 832 1600L832 1600L832 1306Q805 1279 778 1251.50Q751 1224 723 1197L723 1197Q684 1159 662 1120.50Q640 1082 640 1025L640 1025Q640 995 646 971Q652 947 663 926Q674 905 690.50 886Q707 867 727 847L727 847L1156 418Q1154 410 1153 401Q1152 392 1152 384L1152 384Q1152 331 1172 284.50Q1192 238 1227 203Q1262 168 1308.50 148Q1355 128 1408 128L1408 128Q1461 128 1507.50 148Q1554 168 1589 203Q1624 238 1644 284.50Q1664 331 1664 384L1664 384Q1664 426 1651 464.50Q1638 503 1614.50 535Q1591 567 1558 590.50Q1525 614 1485 627L1485 627L1562 704L1728 704Q1768 704 1803 719Q1838 734 1864 760Q1890 786 1905 821Q1920 856 1920 896L1920 896Q1920 936 1905 971Q1890 1006 1864 1032Q1838 1058 1803 1073Q1768 1088 1728 1088L1728 1088ZM1408 256L1408 256Q1381 256 1358 266Q1335 276 1317.50 293.50Q1300 311 1290 334Q1280 357 1280 384L1280 384Q1280 411 1290 434Q1300 457 1317.50 474.50Q1335 492 1358 502Q1381 512 1408 512L1408 512Q1435 512 1458 502Q1481 492 1498.50 474.50Q1516 457 1526 434Q1536 411 1536 384L1536 384Q1536 357 1526 334Q1516 311 1498.50 293.50Q1481 276 1458 266Q1435 256 1408 256ZM992 1056L992 1056Q992 1030 1011 1011L1011 1011L1203 819Q1222 800 1248 800L1248 800Q1274 800 1293 819L1293 819L1434 960L1728 960Q1754 960 1773 941Q1792 922 1792 896L1792 896Q1792 870 1773 851Q1754 832 1728 832L1728 832L1536 832Q1510 832 1491 813L1491 813L1216 538L813 941Q795 959 781.50 977.50Q768 996 768 1024L768 1024Q768 1050 780 1068Q792 1086 809 1103L809 1103L941 1235Q960 1254 960 1280L960 1280L960 1600Q960 1626 979 1645Q998 1664 1024 1664L1024 1664Q1050 1664 1069 1645Q1088 1626 1088 1600L1088 1600L1088 1178L1011 1101Q992 1082 992 1056Z"
         }
      }
   ]
}

var DietPlanNotebook = {
   name: "DietPlanNotebook",
   vendor: "UiFabric",
   unicode: 60104,
   value: "",
   charCode: "EAC8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1668 0L1668 129L1792 129L1792 2048L256 2048L256 129L382 129L382 0L510 0L510 129L768 129L768 0L896 0L896 129L1154 129L1154 0L1282 0L1282 129L1540 129L1540 0L1668 0ZM384 1920L1664 1920L1664 257L384 257L384 1920ZM640 513L1408 513L1408 641L640 641L640 513ZM1408 1666L640 1666L640 1538L1408 1538L1408 1666ZM1408 1153L640 1153L640 1025L1408 1025L1408 1153Z"
         }
      }
   ]
}

var Pill = {
   name: "Pill",
   vendor: "UiFabric",
   unicode: 60107,
   value: "",
   charCode: "EACB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 704L1536 704Q1562 704 1581 723Q1600 742 1600 768L1600 768Q1600 794 1581 813Q1562 832 1536 832L1536 832Q1510 832 1491 813Q1472 794 1472 768L1472 768Q1472 742 1491 723Q1510 704 1536 704ZM1344 896L1344 896Q1370 896 1389 915Q1408 934 1408 960L1408 960Q1408 986 1389 1005Q1370 1024 1344 1024L1344 1024Q1318 1024 1299 1005Q1280 986 1280 960L1280 960Q1280 933 1298.50 914.50Q1317 896 1344 896ZM1152 704L1152 704Q1178 704 1197 723Q1216 742 1216 768L1216 768Q1216 794 1197 813Q1178 832 1152 832L1152 832Q1126 832 1107 813Q1088 794 1088 768L1088 768Q1088 742 1107 723Q1126 704 1152 704ZM1531 0L1531 0Q1638 0 1732.50 40.50Q1827 81 1897 151Q1967 221 2007.50 315.50Q2048 410 2048 517L2048 517Q2048 620 2009 714.50Q1970 809 1897 882L1897 882L882 1897Q809 1970 714.50 2009Q620 2048 517 2048L517 2048Q410 2048 315.50 2007.50Q221 1967 151 1897Q81 1827 40.50 1732.50Q0 1638 0 1531L0 1531Q0 1428 39 1333.50Q78 1239 151 1166L151 1166L1166 151Q1239 78 1333.50 39Q1428 0 1531 0ZM517 1920L517 1920Q595 1920 665 1891Q735 1862 791 1806L791 1806L1255 1342L706 793L242 1257Q187 1312 157.50 1383Q128 1454 128 1532L128 1532Q128 1613 158.50 1683.50Q189 1754 242 1806.50Q295 1859 365.50 1889.50Q436 1920 517 1920ZM1346 1252L1806 791Q1861 736 1890.50 665.50Q1920 595 1920 517L1920 517Q1920 436 1889.50 365.50Q1859 295 1806 242Q1753 189 1682.50 158.50Q1612 128 1531 128L1531 128Q1453 128 1382.50 157.50Q1312 187 1257 242L1257 242L796 702L1346 1252Z"
         }
      }
   ]
}

var ExerciseTracker = {
   name: "ExerciseTracker",
   vendor: "UiFabric",
   unicode: 60108,
   value: "",
   charCode: "EACC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 640L128 640Q170 640 195 660Q220 680 238.50 704Q257 728 275 748Q293 768 320 768L320 768Q368 768 405 749Q442 730 473.50 701.50Q505 673 534.50 640Q564 607 598 578.50Q632 550 672.50 531Q713 512 768 512L768 512Q804 512 838 523.50Q872 535 901 555L901 555L902 557Q919 569 934.50 581.50Q950 594 967 606L967 606Q979 594 992.50 585Q1006 576 1024 576L1024 576Q1051 576 1069.50 595.50Q1088 615 1088 641L1088 641Q1088 661 1075 679L1075 679Q1107 699 1139 717.50Q1171 736 1203 754L1203 754Q1219 737 1237 720.50Q1255 704 1280 704L1280 704Q1306 704 1325 723Q1344 742 1344 768L1344 768Q1344 784 1337.50 794Q1331 804 1323 816L1323 816Q1357 833 1391.50 849Q1426 865 1461 880L1461 880Q1477 864 1494.50 848Q1512 832 1536 832L1536 832Q1562 832 1581 851Q1600 870 1600 896L1600 896Q1600 917 1588 933L1588 933Q1651 959 1715.50 981Q1780 1003 1844 1027L1844 1027Q1878 1040 1914.50 1060.50Q1951 1081 1980.50 1109Q2010 1137 2029 1172Q2048 1207 2048 1248L2048 1248L2048 1280Q2048 1336 2020.50 1381Q1993 1426 1951 1461.50Q1909 1497 1858.50 1523Q1808 1549 1763 1566L1763 1566Q1618 1621 1462.50 1642.50Q1307 1664 1152 1664L1152 1664L1024 1664Q982 1664 948.50 1654Q915 1644 886 1632Q857 1620 829 1610Q801 1600 768 1600L768 1600Q741 1600 717.50 1606.50Q694 1613 670 1625L670 1625Q632 1644 593.50 1654Q555 1664 512 1664L512 1664L192 1664Q152 1664 117 1649Q82 1634 56 1608Q30 1582 15 1547Q0 1512 0 1472L0 1472L0 768Q0 741 10 718Q20 695 37.50 677.50Q55 660 78 650Q101 640 128 640ZM1920 1280L1920 1248Q1920 1232 1906.50 1216.50Q1893 1201 1874 1187.50Q1855 1174 1834.50 1163.50Q1814 1153 1801 1148L1801 1148Q1723 1118 1645.50 1091Q1568 1064 1491 1032L1491 1032L1389 1133Q1370 1152 1344 1152L1344 1152Q1318 1152 1299 1133Q1280 1114 1280 1088L1280 1088Q1280 1073 1289.50 1057.50Q1299 1042 1312 1027.50Q1325 1013 1339.50 1000Q1354 987 1364 977L1364 977Q1329 961 1295 944.50Q1261 928 1227 911L1227 911L1133 1005Q1114 1024 1088 1024L1088 1024Q1062 1024 1043 1005Q1024 986 1024 960L1024 960Q1024 934 1043 915L1043 915L1109 848Q1077 830 1045.50 811Q1014 792 983 772L983 772L877 877Q858 896 832 896L832 896Q806 896 787 877Q768 858 768 832L768 832Q768 806 787 787L787 787L876 698Q852 679 826.50 659.50Q801 640 768 640L768 640Q740 640 715 652Q690 664 671 684L671 684L670 684Q630 724 593.50 762Q557 800 517.50 830Q478 860 430.50 878Q383 896 320 896L320 896Q288 896 262 887Q236 878 214.50 862Q193 846 174 825Q155 804 138 780L138 780Q132 772 128 769L128 769L128 1280L1920 1280ZM192 1536L512 1536Q545 1536 572.50 1526Q600 1516 629 1504Q658 1492 691 1482Q724 1472 768 1472L768 1472Q812 1472 849.50 1482Q887 1492 926 1511L926 1511Q961 1528 993.50 1533Q1026 1538 1064 1538L1064 1538Q1151 1538 1248.50 1533.50Q1346 1529 1443.50 1515.50Q1541 1502 1633 1476.50Q1725 1451 1802 1408L1802 1408L128 1408L128 1472Q128 1498 147 1517Q166 1536 192 1536L192 1536Z"
         }
      }
   ]
}

var HandsFree = {
   name: "HandsFree",
   vendor: "UiFabric",
   unicode: 60112,
   value: "",
   charCode: "EAD0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 256L1600 256Q1640 256 1675 271Q1710 286 1736 312Q1762 338 1777 373Q1792 408 1792 448L1792 448L1792 1344Q1792 1463 1746.50 1568Q1701 1673 1623 1751Q1545 1829 1440 1874.50Q1335 1920 1216 1920L1216 1920Q1072 1920 947.50 1865Q823 1810 722 1709L722 1709L250 1237Q222 1209 207 1172Q192 1135 192 1096L192 1096Q192 1054 208 1017.50Q224 981 251 954Q278 927 314.50 911.50Q351 896 392 896L392 896Q432 896 468 911.50Q504 927 533 955L533 955L640 1061L640 320Q640 280 655 245Q670 210 696 184Q722 158 757 143Q792 128 832 128L832 128Q869 128 903 142L903 142Q911 111 929 85Q947 59 971.50 40Q996 21 1026 10.50Q1056 0 1088 0L1088 0Q1120 0 1150 10.50Q1180 21 1204.50 40Q1229 59 1247 85Q1265 111 1273 142L1273 142Q1307 128 1344 128L1344 128Q1376 128 1406 138.50Q1436 149 1460.50 168Q1485 187 1503 213Q1521 239 1529 270L1529 270Q1563 256 1600 256ZM1664 1344L1664 448Q1664 422 1645 403Q1626 384 1600 384L1600 384Q1574 384 1555 403Q1536 422 1536 448L1536 448L1536 896Q1536 922 1517 941Q1498 960 1472 960L1472 960Q1446 960 1427 941Q1408 922 1408 896L1408 896L1408 320Q1408 294 1389 275Q1370 256 1344 256L1344 256Q1318 256 1299 275Q1280 294 1280 320L1280 320L1280 832Q1280 858 1261 877Q1242 896 1216 896L1216 896Q1190 896 1171 877Q1152 858 1152 832L1152 832L1152 192Q1152 166 1133 147Q1114 128 1088 128L1088 128Q1062 128 1043 147Q1024 166 1024 192L1024 192L1024 832Q1024 858 1005 877Q986 896 960 896L960 896Q934 896 915 877Q896 858 896 832L896 832L896 320Q896 294 877 275Q858 256 832 256L832 256Q806 256 787 275Q768 294 768 320L768 320L768 1107Q768 1130 759.50 1149.50Q751 1169 736.50 1184Q722 1199 702 1207.50Q682 1216 660 1216L660 1216Q638 1216 617.50 1208Q597 1200 581 1184L581 1184L442 1045Q421 1024 392 1024L392 1024Q363 1024 341.50 1045Q320 1066 320 1096L320 1096Q320 1125 341 1146L341 1146L813 1619Q897 1703 997 1747.50Q1097 1792 1216 1792L1216 1792Q1309 1792 1390.50 1756.50Q1472 1721 1532.50 1660.50Q1593 1600 1628.50 1518.50Q1664 1437 1664 1344L1664 1344Z"
         }
      }
   ]
}

var Medical = {
   name: "Medical",
   vendor: "UiFabric",
   unicode: 60116,
   value: "",
   charCode: "EAD4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 640L1728 640Q1794 640 1852 665.50Q1910 691 1953.50 734.50Q1997 778 2022.50 836Q2048 894 2048 960L2048 960Q2048 1017 2029 1069Q2010 1121 1976 1162.50Q1942 1204 1895 1233Q1848 1262 1792 1274L1792 1274L1792 1376Q1792 1465 1770 1549.50Q1748 1634 1707.50 1709Q1667 1784 1609.50 1846Q1552 1908 1480.50 1953Q1409 1998 1326 2023Q1243 2048 1152 2048L1152 2048Q1061 2048 978 2023Q895 1998 823.50 1953Q752 1908 694.50 1846Q637 1784 596.50 1709Q556 1634 534 1549.50Q512 1465 512 1376L512 1376L512 1147Q389 1136 293.50 1088Q198 1040 133 962Q68 884 34 781Q0 678 0 558L0 558L0 0L320 0Q346 0 365 19Q384 38 384 64L384 64Q384 90 365 109Q346 128 320 128L320 128L128 128L128 558Q128 664 157.50 750Q187 836 244 897Q301 958 384.50 991Q468 1024 576 1024L576 1024Q677 1024 760 993Q843 962 901.50 904Q960 846 992 763.50Q1024 681 1024 579L1024 579L1024 128L832 128Q806 128 787 109Q768 90 768 64L768 64Q768 38 787 19Q806 0 832 0L832 0L1152 0L1152 558Q1152 678 1118 781Q1084 884 1019 962Q954 1040 858.50 1088Q763 1136 640 1147L640 1147L640 1376Q640 1483 678.50 1581.50Q717 1680 785.50 1755Q854 1830 947.50 1875Q1041 1920 1152 1920L1152 1920Q1263 1920 1356.50 1875Q1450 1830 1518.50 1755Q1587 1680 1625.50 1581.50Q1664 1483 1664 1376L1664 1376L1664 1274Q1608 1262 1561 1233Q1514 1204 1480 1162.50Q1446 1121 1427 1069Q1408 1017 1408 960L1408 960Q1408 894 1433 836Q1458 778 1501.50 734.50Q1545 691 1603.50 665.50Q1662 640 1728 640ZM1728 1152L1728 1152Q1768 1152 1803 1137Q1838 1122 1864 1096Q1890 1070 1905 1035Q1920 1000 1920 960L1920 960Q1920 920 1905 885Q1890 850 1864 824Q1838 798 1803 783Q1768 768 1728 768L1728 768Q1688 768 1653 783Q1618 798 1592 824Q1566 850 1551 885Q1536 920 1536 960L1536 960Q1536 1000 1551 1035Q1566 1070 1592 1096Q1618 1122 1653 1137Q1688 1152 1728 1152Z"
         }
      }
   ]
}

var Running = {
   name: "Running",
   vendor: "UiFabric",
   unicode: 60122,
   value: "",
   charCode: "EADA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1627 768L1792 768Q1832 768 1867 783Q1902 798 1928 824Q1954 850 1969 885Q1984 920 1984 960L1984 960Q1984 1000 1969 1035Q1954 1070 1928 1096Q1902 1122 1867 1137Q1832 1152 1792 1152L1792 1152L1472 1152Q1446 1152 1427 1133L1427 1133L1280 987L1178 1088L1389 1299Q1408 1318 1408 1344L1408 1344L1408 1728Q1408 1768 1393 1803Q1378 1838 1352 1864Q1326 1890 1291 1905Q1256 1920 1216 1920L1216 1920Q1176 1920 1141 1905Q1106 1890 1080 1864Q1054 1838 1039 1803Q1024 1768 1024 1728L1024 1728L1024 1499L896 1371L749 1517Q730 1536 704 1536L704 1536L256 1536Q216 1536 181 1521Q146 1506 120 1480Q94 1454 79 1419Q64 1384 64 1344L64 1344Q64 1304 79 1269Q94 1234 120 1208Q146 1182 181 1167Q216 1152 256 1152L256 1152L549 1152L629 1073Q576 1050 544 1002Q512 954 512 896L512 896L512 512Q512 485 522 462Q532 439 549.50 421.50Q567 404 590 394Q613 384 640 384L640 384L1152 384Q1152 331 1172 284.50Q1192 238 1227 203Q1262 168 1308.50 148Q1355 128 1408 128L1408 128Q1461 128 1507.50 148Q1554 168 1589 203Q1624 238 1644 284.50Q1664 331 1664 384L1664 384Q1664 426 1651 464.50Q1638 503 1614.50 535Q1591 567 1558.50 591Q1526 615 1486 628L1486 628L1627 768ZM1408 256L1408 256Q1381 256 1358 266Q1335 276 1317.50 293.50Q1300 311 1290 334Q1280 357 1280 384L1280 384Q1280 411 1290 434Q1300 457 1317.50 474.50Q1335 492 1358 502Q1381 512 1408 512L1408 512Q1432 512 1455 502.50Q1478 493 1496 476.50Q1514 460 1525 438.50Q1536 417 1536 392L1536 392Q1536 364 1527 339Q1518 314 1501.50 295.50Q1485 277 1461 266.50Q1437 256 1408 256ZM1499 1024L1792 1024Q1818 1024 1837 1005Q1856 986 1856 960L1856 960Q1856 928 1838 914Q1820 900 1792 896Q1764 892 1729 894.50Q1694 897 1661 898.50Q1628 900 1599.50 896.50Q1571 893 1555 877L1555 877L1189 512L640 512L640 896Q640 922 659 941Q678 960 704 960L704 960Q741 960 754.50 936.50Q768 913 770 877Q772 841 768 800Q764 759 766 723Q768 687 781.50 663.50Q795 640 832 640L832 640L1024 640Q1050 640 1069 659Q1088 678 1088 704L1088 704Q1088 730 1069 749Q1050 768 1024 768L1024 768L896 768L896 960Q896 986 877 1005L877 1005L621 1261Q602 1280 576 1280L576 1280L256 1280Q230 1280 211 1299Q192 1318 192 1344L192 1344Q192 1370 211 1389Q230 1408 256 1408L256 1408L677 1408L851 1235Q870 1216 896 1216L896 1216Q922 1216 941 1235L941 1235L1133 1427Q1152 1446 1152 1472L1152 1472L1152 1728Q1152 1754 1171 1773Q1190 1792 1216 1792L1216 1792Q1242 1792 1261 1773Q1280 1754 1280 1728L1280 1728L1280 1371L1043 1133Q1024 1114 1024 1088L1024 1088Q1024 1062 1043 1043L1043 1043L1235 851Q1254 832 1280 832L1280 832Q1306 832 1325 851L1325 851L1499 1024Z"
         }
      }
   ]
}

var Weights = {
   name: "Weights",
   vendor: "UiFabric",
   unicode: 60123,
   value: "",
   charCode: "EADB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2042 480L1883 640L2011 768L1728 1050L1408 731L731 1408L1050 1728L768 2011L640 1883L480 2042L288 1851Q278 1860 267.50 1872Q257 1884 245.50 1894.50Q234 1905 220.50 1912.50Q207 1920 192 1920L192 1920Q166 1920 147 1901Q128 1882 128 1856L128 1856Q128 1841 135.50 1827.50Q143 1814 153.50 1802.50Q164 1791 176 1780.50Q188 1770 197 1760L197 1760L6 1568L165 1408L37 1280L320 998L640 1317L1317 640L998 320L1280 37L1408 165L1568 6L1760 197Q1770 188 1780.50 176Q1791 164 1802.50 153.50Q1814 143 1827.50 135.50Q1841 128 1856 128L1856 128Q1882 128 1901 147Q1920 166 1920 192L1920 192Q1920 207 1912.50 220.50Q1905 234 1894.50 245.50Q1884 257 1872 267.50Q1860 278 1851 288L1851 288L2042 480ZM480 1861L549 1792L256 1499L187 1568L480 1861ZM768 1829L870 1728L320 1178L219 1280L768 1829ZM1568 187L1499 256L1792 549L1861 480L1568 187ZM1728 870L1829 768L1280 219L1178 320L1728 870Z"
         }
      }
   ]
}

var Trackers = {
   name: "Trackers",
   vendor: "UiFabric",
   unicode: 60127,
   value: "",
   charCode: "EADF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384L640 384ZM1664 1920L1664 384L1536 384L1536 640L512 640L512 384L384 384L384 1920L1664 1920ZM1024 1024L1024 896L1536 896L1536 1024L1024 1024ZM1024 1408L1024 1280L1536 1280L1536 1408L1024 1408ZM1024 1792L1024 1664L1536 1664L1536 1792L1024 1792ZM704 870L851 723L941 813L704 1050L531 877L621 787L704 870ZM704 1254L851 1107L941 1197L704 1434L531 1261L621 1171L704 1254ZM704 1638L851 1491L941 1581L704 1818L531 1645L621 1555L704 1638Z"
         }
      }
   ]
}

var Vaccination = {
   name: "Vaccination",
   vendor: "UiFabric",
   unicode: 60128,
   value: "",
   charCode: "EAE0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2045 547L1955 637L1856 538L1690 704L1789 803L1699 893L1600 794L731 1664L474 1664L272 1867L0 1957L384 1573L384 1317L1254 448L1155 349L1245 259L1344 358L1510 192L1411 93L1501 3L2045 547ZM512 1536L677 1536L1509 704L1344 539L1115 768L1197 851L1107 941L1024 859L922 960L1005 1043L915 1133L832 1050L731 1152L813 1235L723 1325L640 1243L512 1371L512 1536ZM1435 448L1600 613L1765 448L1600 283L1435 448Z"
         }
      }
   ]
}

var AddNotes = {
   name: "AddNotes",
   vendor: "UiFabric",
   unicode: 60131,
   value: "",
   charCode: "EAE3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L0 256L2048 256L2048 384L0 384ZM2048 896L0 896L0 768L2048 768L2048 896ZM1280 1408L0 1408L0 1280L1280 1280L1280 1408ZM1280 1920L0 1920L0 1792L1280 1792L1280 1920ZM1662 1280L1790 1280L1790 1536L2046 1536L2046 1664L1790 1664L1790 1920L1662 1920L1662 1664L1406 1664L1406 1536L1662 1536L1662 1280Z"
         }
      }
   ]
}

var AllCurrency = {
   name: "AllCurrency",
   vendor: "UiFabric",
   unicode: 60132,
   value: "",
   charCode: "EAE4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M959 1026L959 1026Q911 1024 860 1014Q809 1004 766 983L766 983Q749 975 739 959.50Q729 944 729 925L729 925Q729 899 748 880Q767 861 793 861L793 861Q806 861 820 867L820 867Q886 896 958 897L958 897L958 678Q921 665 886.50 646Q852 627 825.50 600.50Q799 574 783 540Q767 506 767 463L767 463Q767 422 783.50 389Q800 356 826.50 331.50Q853 307 887.50 290.50Q922 274 958 266L958 266Q958 237 974 215.50Q990 194 1022 194L1022 194Q1049 194 1067.50 212.50Q1086 231 1086 258L1086 258Q1121 260 1152.50 267.50Q1184 275 1217 284L1217 284L1173 404Q1152 396 1130 392Q1108 388 1086 386L1086 386L1086 586Q1120 598 1154.50 618Q1189 638 1216.50 665Q1244 692 1261 726Q1278 760 1278 800L1278 800Q1278 844 1263 880Q1248 916 1222.50 943Q1197 970 1161.50 988.50Q1126 1007 1086 1016L1086 1016Q1086 1044 1068.50 1064Q1051 1084 1022 1084L1022 1084Q997 1084 979 1067Q961 1050 959 1026ZM1086 727L1086 883Q1114 872 1132 852.50Q1150 833 1150 801L1150 801Q1150 789 1143.50 778Q1137 767 1127.50 757.50Q1118 748 1107 740.50Q1096 733 1086 727L1086 727ZM895 463L895 463Q895 491 915.50 509.50Q936 528 958 539L958 539L958 400Q955 401 945 405.50Q935 410 933 412L933 412Q919 417 907 432Q895 447 895 463ZM1640 814L1640 814Q1732 850 1807 910Q1882 970 1935.50 1047.50Q1989 1125 2018.50 1216.50Q2048 1308 2048 1407L2048 1407Q2048 1495 2025 1577Q2002 1659 1960.50 1730Q1919 1801 1860.50 1859.50Q1802 1918 1731 1960Q1660 2002 1578 2025Q1496 2048 1408 2048L1408 2048Q1304 2048 1206 2015Q1108 1982 1025 1919L1025 1919Q941 1982 843 2015Q745 2048 640 2048L640 2048Q551 2048 469.50 2025Q388 2002 317 1960.50Q246 1919 187.50 1860.50Q129 1802 87.50 1730.50Q46 1659 23 1577.50Q0 1496 0 1407L0 1407Q0 1308 29.50 1216.50Q59 1125 112.50 1047.50Q166 970 241 910Q316 850 408 814L408 814Q384 730 384 641L384 641Q384 553 407 471Q430 389 471.50 318Q513 247 571.50 188.50Q630 130 701 88Q772 46 854 23Q936 0 1024 0L1024 0Q1112 0 1194 23Q1276 46 1347 88Q1418 130 1476.50 188.50Q1535 247 1576.50 318Q1618 389 1641 471Q1664 553 1664 641L1664 641Q1664 730 1640 814ZM1024 128L1024 128Q918 128 824.50 168.50Q731 209 661.50 279Q592 349 552 442Q512 535 512 641L512 641Q512 747 552 840.50Q592 934 661.50 1003.50Q731 1073 824.50 1113.50Q918 1154 1024 1154L1024 1154Q1130 1154 1223.50 1113.50Q1317 1073 1386.50 1003.50Q1456 934 1496 840.50Q1536 747 1536 641L1536 641Q1536 535 1496 442Q1456 349 1386.50 279Q1317 209 1223.50 168.50Q1130 128 1024 128ZM640 1920L640 1920Q746 1920 839.50 1879.50Q933 1839 1002.50 1769.50Q1072 1700 1112 1606.50Q1152 1513 1152 1407L1152 1407Q1152 1339 1132 1273L1132 1273Q1078 1282 1024 1282L1024 1282Q919 1282 820.50 1249Q722 1216 638 1152L638 1152Q631 1156 625 1157L625 1157Q537 1183 491.50 1248.50Q446 1314 446 1405L446 1405L446 1407L572 1407Q598 1407 617 1426Q636 1445 636 1471L636 1471Q636 1502 619 1515.50Q602 1529 578 1533.50Q554 1538 527 1536.50Q500 1535 481 1535L481 1535Q516 1594 574.50 1627.50Q633 1661 702 1661L702 1661Q731 1661 756.50 1655Q782 1649 808 1638L808 1638Q821 1633 834 1633L834 1633Q860 1633 879 1651.50Q898 1670 898 1696L898 1696Q898 1725 875.50 1743Q853 1761 821.50 1771.50Q790 1782 757 1785.50Q724 1789 702 1789L702 1789Q641 1789 584.50 1770.50Q528 1752 480.50 1719Q433 1686 397 1639Q361 1592 340 1535L340 1535Q324 1535 309 1532Q294 1529 282.50 1522Q271 1515 264 1502.50Q257 1490 257 1471L257 1471Q257 1445 274.50 1427Q292 1409 318 1407L318 1407Q318 1351 332 1297.50Q346 1244 373 1197.50Q400 1151 440.50 1114Q481 1077 534 1054L534 1054Q511 1025 490.50 994Q470 963 453 930L453 930Q379 959 319.50 1007.50Q260 1056 217 1118.50Q174 1181 151 1254.50Q128 1328 128 1407L128 1407Q128 1513 168 1606.50Q208 1700 277.50 1769.50Q347 1839 440.50 1879.50Q534 1920 640 1920ZM1408 1920L1408 1920Q1514 1920 1607.50 1879.50Q1701 1839 1770.50 1769.50Q1840 1700 1880 1606.50Q1920 1513 1920 1407L1920 1407Q1920 1328 1897 1254.50Q1874 1181 1831 1119Q1788 1057 1728 1008.50Q1668 960 1595 931L1595 931Q1557 1005 1502 1067Q1447 1129 1378 1175L1378 1175L1471 1301L1611 1114Q1630 1088 1662 1088L1662 1088Q1689 1088 1708 1107Q1727 1126 1727 1153L1727 1153Q1727 1173 1714 1191L1714 1191L1534 1430L1534 1535Q1553 1535 1575.50 1534.50Q1598 1534 1617.50 1539Q1637 1544 1650.50 1557.50Q1664 1571 1664 1599L1664 1599Q1664 1627 1650.50 1640.50Q1637 1654 1617.50 1659Q1598 1664 1575.50 1663.50Q1553 1663 1534 1663L1534 1663Q1534 1682 1534.50 1704.50Q1535 1727 1530 1746.50Q1525 1766 1511.50 1779.50Q1498 1793 1470 1793L1470 1793Q1442 1793 1428.50 1779.50Q1415 1766 1410 1746.50Q1405 1727 1405.50 1704.50Q1406 1682 1406 1663L1406 1663Q1387 1663 1365 1663.50Q1343 1664 1323.50 1659Q1304 1654 1291 1640.50Q1278 1627 1278 1599L1278 1599Q1278 1571 1291 1557.50Q1304 1544 1323.50 1539Q1343 1534 1365.50 1534.50Q1388 1535 1406 1535L1406 1535L1406 1430L1264 1236L1258 1238Q1270 1279 1275 1322Q1280 1365 1280 1407L1280 1407Q1280 1525 1239.50 1633.50Q1199 1742 1121 1830L1121 1830Q1185 1874 1257.50 1897Q1330 1920 1408 1920Z"
         }
      }
   ]
}

var BarChart4 = {
   name: "BarChart4",
   vendor: "UiFabric",
   unicode: 60135,
   value: "",
   charCode: "EAE7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 2048L0 2048L0 1408L384 1408L384 2048ZM896 2048L512 2048L512 896L896 896L896 2048ZM1536 2048L1536 896L1920 896L1920 2048L1536 2048ZM1408 2048L1024 2048L1024 384L1408 384L1408 2048Z"
         }
      }
   ]
}

var CirclePlus = {
   name: "CirclePlus",
   vendor: "UiFabric",
   unicode: 60142,
   value: "",
   charCode: "EAEE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1148 1920 1262.50 1888Q1377 1856 1476.50 1797.50Q1576 1739 1657.50 1657.50Q1739 1576 1797.50 1476.50Q1856 1377 1888 1262.50Q1920 1148 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q900 128 785.50 160Q671 192 571.50 250.50Q472 309 390.50 390.50Q309 472 250.50 571.50Q192 671 160 785.50Q128 900 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250 1476.50Q308 1576 390 1658Q472 1740 571.50 1798Q671 1856 785.50 1888Q900 1920 1024 1920ZM1088 512L1088 959L1536 959L1536 1087L1088 1087L1088 1536L960 1536L960 1087L512 1087L512 959L960 959L960 512L1088 512Z"
         }
      }
   ]
}

var Coffee = {
   name: "Coffee",
   vendor: "UiFabric",
   unicode: 60143,
   value: "",
   charCode: "EAEF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 1024L448 1024Q504 1024 549.50 1049.50Q595 1075 631 1117Q667 1159 692.50 1213Q718 1267 735 1324Q752 1381 760 1436Q768 1491 768 1536L768 1536Q768 1581 760 1636Q752 1691 735 1748Q718 1805 692.50 1859Q667 1913 631 1955Q595 1997 549.50 2022.50Q504 2048 448 2048L448 2048Q413 2048 384 2031L384 2031Q355 2048 320 2048L320 2048Q264 2048 218.50 2022.50Q173 1997 137 1955Q101 1913 75.50 1859Q50 1805 33 1748Q16 1691 8 1636Q0 1581 0 1536L0 1536Q0 1491 8 1436Q16 1381 33 1324Q50 1267 75.50 1213Q101 1159 137 1117Q173 1075 218.50 1049.50Q264 1024 320 1024L320 1024Q355 1024 384 1041L384 1041Q413 1024 448 1024ZM127 1536L127 1536Q127 1581 134 1627Q141 1673 155 1717.50Q169 1762 191 1803.50Q213 1845 242 1879L242 1879Q258 1898 276.50 1909Q295 1920 320 1920L320 1920L320 1152Q295 1152 276.50 1163Q258 1174 242 1193L242 1193Q213 1228 191 1269Q169 1310 155 1354.50Q141 1399 134 1445Q127 1491 127 1536ZM448 1152L448 1920Q473 1920 491.50 1909Q510 1898 526 1879L526 1879Q555 1845 576.50 1803.50Q598 1762 612.50 1717.50Q627 1673 634 1627Q641 1581 641 1536L641 1536Q641 1491 634 1445Q627 1399 612.50 1354.50Q598 1310 576.50 1269Q555 1228 526 1193L526 1193Q510 1174 491.50 1163Q473 1152 448 1152L448 1152ZM2048 1600L2048 1600Q2048 1635 2031 1664L2031 1664Q2048 1693 2048 1728L2048 1728Q2048 1784 2022.50 1829.50Q1997 1875 1955 1911Q1913 1947 1859 1972.50Q1805 1998 1748 2015Q1691 2032 1636 2040Q1581 2048 1536 2048L1536 2048Q1491 2048 1436 2040Q1381 2032 1324 2015Q1267 1998 1213 1972.50Q1159 1947 1117 1911Q1075 1875 1049.50 1829.50Q1024 1784 1024 1728L1024 1728Q1024 1693 1041 1664L1041 1664Q1024 1635 1024 1600L1024 1600Q1024 1544 1049.50 1498.50Q1075 1453 1117 1417Q1159 1381 1213 1355.50Q1267 1330 1324 1313Q1381 1296 1436 1288Q1491 1280 1536 1280L1536 1280Q1581 1280 1636 1288Q1691 1296 1748 1313Q1805 1330 1859 1355.50Q1913 1381 1955 1417Q1997 1453 2022.50 1498.50Q2048 1544 2048 1600ZM1536 1407L1536 1407Q1491 1407 1445 1414Q1399 1421 1354.50 1435.50Q1310 1450 1268.50 1471.50Q1227 1493 1193 1522L1193 1522Q1174 1538 1163 1556.50Q1152 1575 1152 1600L1152 1600L1920 1600Q1920 1575 1909 1556.50Q1898 1538 1879 1522L1879 1522Q1844 1493 1803 1471.50Q1762 1450 1717.50 1435.50Q1673 1421 1627 1414Q1581 1407 1536 1407ZM1536 1921L1536 1921Q1581 1921 1627 1914Q1673 1907 1717.50 1893Q1762 1879 1803 1857Q1844 1835 1879 1806L1879 1806Q1898 1790 1909 1771.50Q1920 1753 1920 1728L1920 1728L1152 1728Q1152 1753 1163 1771.50Q1174 1790 1193 1806L1193 1806Q1227 1835 1268.50 1857Q1310 1879 1354.50 1893Q1399 1907 1445 1914Q1491 1921 1536 1921ZM1152 1007L1152 1007Q1123 1024 1088 1024L1088 1024Q1032 1024 986.50 998.50Q941 973 905 931Q869 889 843.50 835Q818 781 801 724Q784 667 776 612Q768 557 768 512L768 512Q768 467 776 412Q784 357 801 300Q818 243 843.50 189Q869 135 905 93Q941 51 986.50 25.50Q1032 0 1088 0L1088 0Q1123 0 1152 17L1152 17Q1181 0 1216 0L1216 0Q1272 0 1317.50 25.50Q1363 51 1399 93Q1435 135 1460.50 189Q1486 243 1503 300Q1520 357 1528 412Q1536 467 1536 512L1536 512Q1536 557 1528 612Q1520 667 1503 724Q1486 781 1460.50 835Q1435 889 1399 931Q1363 973 1317.50 998.50Q1272 1024 1216 1024L1216 1024Q1181 1024 1152 1007ZM1409 512L1409 512Q1409 467 1402 421Q1395 375 1380.50 330.50Q1366 286 1344.50 245Q1323 204 1294 169L1294 169Q1278 150 1259.50 139Q1241 128 1216 128L1216 128L1216 896Q1241 896 1259.50 885Q1278 874 1294 855L1294 855Q1323 821 1344.50 779.50Q1366 738 1380.50 693.50Q1395 649 1402 603Q1409 557 1409 512ZM895 512L895 512Q895 557 902 603Q909 649 923 693.50Q937 738 959 779.50Q981 821 1010 855L1010 855Q1026 874 1044.50 885Q1063 896 1088 896L1088 896L1088 128Q1063 128 1044.50 139Q1026 150 1010 169L1010 169Q981 204 959 245Q937 286 923 330.50Q909 375 902 421Q895 467 895 512Z"
         }
      }
   ]
}

var Cotton = {
   name: "Cotton",
   vendor: "UiFabric",
   unicode: 60147,
   value: "",
   charCode: "EAF3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1504 393L1504 393Q1595 411 1671 457Q1747 503 1802.50 569.50Q1858 636 1889 719.50Q1920 803 1920 896L1920 896Q1920 997 1882.50 1087.50Q1845 1178 1780 1247.50Q1715 1317 1627 1359.50Q1539 1402 1438 1407L1438 1407Q1367 1513 1259.50 1580Q1152 1647 1024 1661L1024 1661L1024 2048L896 2048L896 1661Q768 1647 660.50 1580Q553 1513 482 1407L482 1407Q381 1402 293 1359.50Q205 1317 140 1247.50Q75 1178 37.50 1087.50Q0 997 0 896L0 896Q0 803 31 719.50Q62 636 117.50 569.50Q173 503 249 457Q325 411 416 393L416 393Q445 305 499 233Q553 161 624.50 109Q696 57 781.50 28.50Q867 0 960 0L960 0Q1053 0 1138.50 28.50Q1224 57 1295.50 109Q1367 161 1421 233Q1475 305 1504 393ZM1363 1280L1408 1280Q1487 1280 1557 1250Q1627 1220 1679.50 1167.50Q1732 1115 1762 1045.50Q1792 976 1792 896L1792 896Q1792 817 1762 747Q1732 677 1679.50 624.50Q1627 572 1557 542Q1487 512 1408 512L1408 512Q1406 512 1405 512.50Q1404 513 1402 513L1402 513Q1390 431 1351 360.50Q1312 290 1253 238Q1194 186 1119 157Q1044 128 960 128L960 128Q876 128 801 157Q726 186 667 238Q608 290 569 360.50Q530 431 518 513L518 513Q516 513 515 512.50Q514 512 512 512L512 512Q432 513 362 543Q292 573 240 624.50Q188 676 158 746Q128 816 128 896L128 896Q128 976 158 1045.50Q188 1115 240.50 1167.50Q293 1220 362.50 1250Q432 1280 512 1280L512 1280L557 1280Q581 1331 616 1373.50Q651 1416 695 1448.50Q739 1481 789.50 1502Q840 1523 896 1531L896 1531L896 1402Q840 1390 793 1361Q746 1332 712 1290.50Q678 1249 659 1197Q640 1145 640 1088L640 1088L768 1088Q768 1118 777 1146.50Q786 1175 803 1199Q820 1223 843.50 1241Q867 1259 896 1269L896 1269L896 896L1024 896L1024 1269Q1053 1259 1076.50 1241Q1100 1223 1117 1199Q1134 1175 1143 1146.50Q1152 1118 1152 1088L1152 1088L1280 1088Q1280 1145 1261 1197Q1242 1249 1208 1290.50Q1174 1332 1127 1361Q1080 1390 1024 1402L1024 1402L1024 1531Q1079 1523 1130 1502Q1181 1481 1225 1448.50Q1269 1416 1304 1373.50Q1339 1331 1363 1280L1363 1280Z"
         }
      }
   ]
}

var Currency = {
   name: "Currency",
   vendor: "UiFabric",
   unicode: 60149,
   value: "",
   charCode: "EAF5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 261L512 920Q576 952 644.50 991Q713 1030 768.50 1080.50Q824 1131 860 1195.50Q896 1260 896 1344L896 1344Q896 1427 867 1502.50Q838 1578 787 1637.50Q736 1697 665.50 1736.50Q595 1776 512 1787L512 1787L512 1920L384 1920L384 1788Q275 1775 179.50 1718.50Q84 1662 15 1577L15 1577L113 1495Q165 1558 234 1601.50Q303 1645 384 1659L384 1659L384 1000Q341 979 296 954.50Q251 930 208 901.50Q165 873 127.50 839.50Q90 806 61.50 766Q33 726 16.50 679Q0 632 0 576L0 576Q0 493 29 417.50Q58 342 109 282.50Q160 223 230.50 183.50Q301 144 384 133L384 133L384 0L512 0L512 132Q621 145 716.50 201.50Q812 258 881 343L881 343L783 425Q731 362 662 318.50Q593 275 512 261L512 261ZM128 576L128 576Q128 627 153 669.50Q178 712 215.50 747.50Q253 783 298 810Q343 837 384 856L384 856L384 262Q328 274 281 303Q234 332 200 373.50Q166 415 147 467Q128 519 128 576ZM512 1064L512 1658Q568 1646 615 1617Q662 1588 696 1546.50Q730 1505 749 1453Q768 1401 768 1344L768 1344Q768 1293 743 1250Q718 1207 680.50 1172Q643 1137 597.50 1110Q552 1083 512 1064L512 1064ZM1935 1559L2033 1641Q1976 1710 1897.50 1751Q1819 1792 1728 1792L1728 1792Q1645 1792 1575 1764Q1505 1736 1446.50 1688.50Q1388 1641 1341.50 1578Q1295 1515 1260 1444Q1225 1373 1202 1298Q1179 1223 1167 1152L1167 1152L1024 1152L1024 1024L1154 1024Q1153 1008 1152.50 992Q1152 976 1152 960L1152 960Q1152 944 1152.50 928Q1153 912 1154 896L1154 896L1024 896L1024 768L1167 768Q1179 697 1202 622Q1225 547 1260 476Q1295 405 1341.50 342Q1388 279 1446.50 231.50Q1505 184 1575 156Q1645 128 1728 128L1728 128Q1820 128 1897.50 169Q1975 210 2033 279L2033 279L1935 361Q1897 314 1843.50 285Q1790 256 1728 256L1728 256Q1665 256 1611.50 279.50Q1558 303 1513 342Q1468 381 1432.50 433Q1397 485 1370 541.50Q1343 598 1325 656.50Q1307 715 1297 768L1297 768L1536 768L1536 896L1282 896Q1281 912 1280.50 928Q1280 944 1280 960L1280 960Q1280 976 1280.50 992Q1281 1008 1282 1024L1282 1024L1536 1024L1536 1152L1297 1152Q1307 1205 1325 1263.50Q1343 1322 1370 1378.50Q1397 1435 1432.50 1487Q1468 1539 1513 1578Q1558 1617 1611.50 1640.50Q1665 1664 1728 1664L1728 1664Q1790 1664 1843.50 1635Q1897 1606 1935 1559L1935 1559Z"
         }
      }
   ]
}

var Market = {
   name: "Market",
   vendor: "UiFabric",
   unicode: 60156,
   value: "",
   charCode: "EAFC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 384L2048 384L2048 1024L1986 1024L1920 1024L1920 603L1152 1371L768 987L93 1661L3 1571L768 805L1152 1189L1829 512L1408 512L1408 384Z"
         }
      }
   ]
}

var Money = {
   name: "Money",
   vendor: "UiFabric",
   unicode: 60157,
   value: "",
   charCode: "EAFD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 384L2048 384L2048 1664L128 1664L128 1408L0 1408L0 256L1792 256L1792 384ZM1664 384L1536 384Q1536 411 1546 434Q1556 457 1573.50 474.50Q1591 492 1614 502Q1637 512 1664 512L1664 512L1664 384ZM128 384L128 512Q155 512 178 502Q201 492 218.50 474.50Q236 457 246 434Q256 411 256 384L256 384L128 384ZM128 640L128 1024Q181 1024 227.50 1044Q274 1064 309 1099Q344 1134 364 1180.50Q384 1227 384 1280L384 1280L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024L1664 1024L1664 640Q1611 640 1564.50 620Q1518 600 1483 565Q1448 530 1428 483.50Q1408 437 1408 384L1408 384L384 384Q384 437 364 483.50Q344 530 309 565Q274 600 227.50 620Q181 640 128 640L128 640ZM1664 1280L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280L1664 1280ZM128 1152L128 1280L256 1280Q256 1253 246 1230Q236 1207 218.50 1189.50Q201 1172 178 1162Q155 1152 128 1152L128 1152ZM1920 1536L1920 512L1792 512L1792 1408L256 1408L256 1536L1920 1536ZM448 896L448 896Q422 896 403 877Q384 858 384 832L384 832Q384 806 403 787Q422 768 448 768L448 768Q474 768 493 787Q512 806 512 832L512 832Q512 858 493 877Q474 896 448 896ZM1344 896L1344 896Q1318 896 1299 877Q1280 858 1280 832L1280 832Q1280 806 1299 787Q1318 768 1344 768L1344 768Q1370 768 1389 787Q1408 806 1408 832L1408 832Q1408 858 1389 877Q1370 896 1344 896ZM896 1152L896 1152Q843 1152 796.50 1132Q750 1112 715 1077Q680 1042 660 995.50Q640 949 640 896L640 896L640 768Q640 715 660 668.50Q680 622 715 587Q750 552 796.50 532Q843 512 896 512L896 512Q949 512 995.50 532Q1042 552 1077 587Q1112 622 1132 668.50Q1152 715 1152 768L1152 768L1152 896Q1152 949 1132 995.50Q1112 1042 1077 1077Q1042 1112 995.50 1132Q949 1152 896 1152ZM768 768L768 896Q768 923 778 946Q788 969 805.50 986.50Q823 1004 846 1014Q869 1024 896 1024L896 1024Q923 1024 946 1014Q969 1004 986.50 986.50Q1004 969 1014 946Q1024 923 1024 896L1024 896L1024 768Q1024 741 1014 718Q1004 695 986.50 677.50Q969 660 946 650Q923 640 896 640L896 640Q869 640 846 650Q823 660 805.50 677.50Q788 695 778 718Q768 741 768 768L768 768Z"
         }
      }
   ]
}

var PieDouble = {
   name: "PieDouble",
   vendor: "UiFabric",
   unicode: 60164,
   value: "",
   charCode: "EB04",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1061L1024 128Q1082 128 1137.50 131Q1193 134 1247 142.50Q1301 151 1354.50 165.50Q1408 180 1462 203L1462 203Q1595 260 1703.50 351Q1812 442 1888.50 557.50Q1965 673 2006.50 808Q2048 943 2048 1088L2048 1088Q2048 1221 2014 1343.50Q1980 1466 1917.50 1573Q1855 1680 1767.50 1767.50Q1680 1855 1573 1917.50Q1466 1980 1343.50 2014Q1221 2048 1088 2048L1088 2048Q893 2048 720 1976Q547 1904 409 1767L409 1767L364 1722L1024 1061ZM1088 1920L1088 1920Q1203 1920 1309 1890Q1415 1860 1507.50 1806Q1600 1752 1676 1676Q1752 1600 1806 1507.50Q1860 1415 1890 1309Q1920 1203 1920 1088L1920 1088Q1920 980 1893 878.50Q1866 777 1817 687.50Q1768 598 1698 522.50Q1628 447 1543 391Q1458 335 1359 300.50Q1260 266 1152 258L1152 258L1152 1115L547 1720Q661 1818 799.50 1869Q938 1920 1088 1920ZM896 0L896 896L0 896Q0 772 32 657.50Q64 543 122.50 443.50Q181 344 262.50 262.50Q344 181 443.50 122.50Q543 64 657.50 32Q772 0 896 0L896 0ZM768 768L768 138Q647 159 541.50 214.50Q436 270 353 353Q270 436 214.50 541.50Q159 647 138 768L138 768L768 768ZM0 1024L864 1024L240 1648Q122 1520 61 1359Q0 1198 0 1024L0 1024ZM555 1152L138 1152Q151 1233 179 1309.50Q207 1386 252 1455L252 1455L555 1152Z"
         }
      }
   ]
}

var PieSingle = {
   name: "PieSingle",
   vendor: "UiFabric",
   unicode: 60165,
   value: "",
   charCode: "EB05",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 896L1152 0Q1276 0 1390.50 32Q1505 64 1604.50 122.50Q1704 181 1785.50 262.50Q1867 344 1925.50 443.50Q1984 543 2016 657.50Q2048 772 2048 896L2048 896L1152 896ZM1280 138L1280 768L1910 768Q1889 647 1833.50 541.50Q1778 436 1695 353Q1612 270 1506.50 214.50Q1401 159 1280 138L1280 138ZM1024 128L1024 1024L1920 1024Q1920 1083 1917 1138Q1914 1193 1905.50 1247Q1897 1301 1882.50 1354.50Q1868 1408 1845 1462L1845 1462Q1788 1596 1697 1704Q1606 1812 1490.50 1888.50Q1375 1965 1240 2006.50Q1105 2048 960 2048L960 2048Q827 2048 704.50 2014Q582 1980 475 1917.50Q368 1855 280.50 1767.50Q193 1680 130.50 1573Q68 1466 34 1343.50Q0 1221 0 1088L0 1088Q0 955 34 832.50Q68 710 130.50 603Q193 496 280.50 408.50Q368 321 475 258.50Q582 196 704.50 162Q827 128 960 128L960 128L1024 128ZM1790 1152L896 1152L896 258Q788 266 689 300.50Q590 335 505 391Q420 447 350 522.50Q280 598 231 687.50Q182 777 155 878.50Q128 980 128 1088L128 1088Q128 1203 158 1309Q188 1415 242 1507.50Q296 1600 372 1676Q448 1752 540.50 1806Q633 1860 739 1890Q845 1920 960 1920L960 1920Q1068 1920 1169.50 1893Q1271 1866 1360.50 1817Q1450 1768 1525.50 1698Q1601 1628 1657 1543Q1713 1458 1747.50 1359Q1782 1260 1790 1152L1790 1152Z"
         }
      }
   ]
}

var RemoveFilter = {
   name: "RemoveFilter",
   vendor: "UiFabric",
   unicode: 60168,
   value: "",
   charCode: "EB08",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1920L128 128L1920 128L1920 1920L128 1920ZM256 1792L1792 1792L1792 256L256 256L256 1792ZM1024 1115L621 1517L531 1427L933 1024L531 621L621 531L1024 933L1427 531L1517 621L1115 1024L1517 1427L1427 1517L1024 1115Z"
         }
      }
   ]
}

var Savings = {
   name: "Savings",
   vendor: "UiFabric",
   unicode: 60171,
   value: "",
   charCode: "EB0B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M576 768L576 768Q602 768 621 787Q640 806 640 832L640 832Q640 858 621 877Q602 896 576 896L576 896Q550 896 531 877Q512 858 512 832L512 832Q512 806 531 787Q550 768 576 768ZM1678 444L1678 444Q1762 483 1830.50 543.50Q1899 604 1947.50 680Q1996 756 2022 843.50Q2048 931 2048 1024L2048 1024Q2048 1103 2030 1178Q2012 1253 1979 1322Q1946 1391 1898.50 1452Q1851 1513 1792 1565L1792 1565L1792 1728Q1792 1768 1777 1803Q1762 1838 1736 1864Q1710 1890 1675 1905Q1640 1920 1600 1920L1600 1920L1472 1920Q1442 1920 1413.50 1911Q1385 1902 1361 1885Q1337 1868 1319 1844.50Q1301 1821 1291 1792L1291 1792L1013 1792Q1003 1821 985 1844.50Q967 1868 943 1885Q919 1902 890.50 1911Q862 1920 832 1920L832 1920L704 1920Q664 1920 629 1905Q594 1890 568 1864Q542 1838 527 1803Q512 1768 512 1728L512 1728L512 1648Q444 1630 383.50 1595Q323 1560 275 1511Q227 1462 192.50 1402Q158 1342 142 1273L142 1273Q110 1265 84 1247Q58 1229 39.50 1204.50Q21 1180 10.50 1150Q0 1120 0 1088L0 1088L0 960Q0 926 11.50 894.50Q23 863 44 837.50Q65 812 93.50 794.50Q122 777 156 771L156 771Q230 667 318 577Q406 487 512 415L512 415L512 57L911 256L1034 256Q1048 200 1079 153Q1110 106 1153 72Q1196 38 1249 19Q1302 0 1360 0L1360 0Q1429 0 1490.50 26.50Q1552 53 1597.50 98.50Q1643 144 1669.50 205.50Q1696 267 1696 336L1696 336Q1696 392 1678 444ZM1360 128L1360 128Q1317 128 1279 144.50Q1241 161 1213 189Q1185 217 1168.50 255Q1152 293 1152 336L1152 336Q1152 371 1162 401L1162 401L1504 486Q1534 457 1551 417.50Q1568 378 1568 336L1568 336Q1568 293 1551.50 255Q1535 217 1507 189Q1479 161 1441 144.50Q1403 128 1360 128ZM1664 1728L1664 1506Q1721 1460 1768 1407Q1815 1354 1849 1294Q1883 1234 1901.50 1167Q1920 1100 1920 1024L1920 1024Q1920 948 1898 876.50Q1876 805 1836 744Q1796 683 1739.50 634.50Q1683 586 1614 555L1614 555Q1597 576 1576.50 593.50Q1556 611 1533 625L1533 625L1071 510Q1056 479 1044 449Q1032 419 1027 384L1027 384L881 384L640 264L640 482Q570 529 514 573.50Q458 618 410 666.50Q362 715 317.50 770.50Q273 826 226 896L226 896Q209 896 191.50 897.50Q174 899 160 905Q146 911 137 924Q128 937 128 960L128 960L128 1088Q128 1114 147 1133Q166 1152 192 1152L192 1152L256 1152Q256 1232 286 1301.50Q316 1371 368.50 1423.50Q421 1476 490.50 1506Q560 1536 640 1536L640 1536L640 1728Q640 1754 659 1773Q678 1792 704 1792L704 1792L832 1792Q858 1792 877 1773Q896 1754 896 1728L896 1728L896 1664L1408 1664Q1408 1682 1407.50 1704.50Q1407 1727 1412 1746.50Q1417 1766 1430.50 1779Q1444 1792 1472 1792L1472 1792L1600 1792Q1626 1792 1645 1773Q1664 1754 1664 1728L1664 1728Z"
         }
      }
   ]
}

var Sell = {
   name: "Sell",
   vendor: "UiFabric",
   unicode: 60172,
   value: "",
   charCode: "EB0C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1089 1381L1555 915L1645 1005L1025 1627L403 1005L493 915L961 1382L960 384L1088 384L1089 1381Z"
         }
      }
   ]
}

var StockDown = {
   name: "StockDown",
   vendor: "UiFabric",
   unicode: 60175,
   value: "",
   charCode: "EB0F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 384L384 384L1664 384L1024 1664L384 384Z"
         }
      }
   ]
}

var StockUp = {
   name: "StockUp",
   vendor: "UiFabric",
   unicode: 60177,
   value: "",
   charCode: "EB11",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 384L1024 384L1664 1664L384 1664L1024 384Z"
         }
      }
   ]
}

var Source = {
   name: "Source",
   vendor: "UiFabric",
   unicode: 60187,
   value: "",
   charCode: "EB1B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 641L1151 641L1151 768L256 768L256 641ZM256 1153L1151 1153L1151 1280L256 1280L256 1153ZM1407 129L1407 385L2048 385L2048 1792L639 1792L639 1536L0 1536L0 129L1407 129ZM1280 256L127 256L127 385L1280 385L1280 256ZM127 512L127 1409L1280 1409L1280 512L127 512ZM768 1665L1919 1665L1919 768L1407 768L1407 897L1792 897L1792 1024L1407 1024L1407 1153L1792 1153L1792 1280L1407 1280L1407 1409L1792 1409L1792 1536L768 1536L768 1665ZM1407 641L1919 641L1919 512L1407 512L1407 641ZM256 897L1151 897L1151 1024L256 1024L256 897Z"
         }
      }
   ]
}

var MSNVideos = {
   name: "MSNVideos",
   vendor: "UiFabric",
   unicode: 60188,
   value: "",
   charCode: "EB1C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1148 1920 1262.50 1888Q1377 1856 1476.50 1797.50Q1576 1739 1657.50 1657.50Q1739 1576 1797.50 1476.50Q1856 1377 1888 1262.50Q1920 1148 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q900 128 785.50 160Q671 192 571.50 250.50Q472 309 390.50 390.50Q309 472 250.50 571.50Q192 671 160 785.50Q128 900 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250 1476.50Q308 1576 390 1658Q472 1740 571.50 1798Q671 1856 785.50 1888Q900 1920 1024 1920ZM768 1536L768 512L1536 1021L768 1536ZM896 750L896 1296L1305 1022L896 750Z"
         }
      }
   ]
}

var Cricket = {
   name: "Cricket",
   vendor: "UiFabric",
   unicode: 60190,
   value: "",
   charCode: "EB1E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1408L1280 1408Q1333 1408 1379.50 1428Q1426 1448 1461 1483Q1496 1518 1516 1564.50Q1536 1611 1536 1664L1536 1664Q1536 1717 1516 1763.50Q1496 1810 1461 1845Q1426 1880 1379.50 1900Q1333 1920 1280 1920L1280 1920Q1227 1920 1180.50 1900Q1134 1880 1099 1845Q1064 1810 1044 1763.50Q1024 1717 1024 1664L1024 1664Q1024 1611 1044 1564.50Q1064 1518 1099 1483Q1134 1448 1180.50 1428Q1227 1408 1280 1408ZM1280 1792L1280 1792Q1307 1792 1330 1782Q1353 1772 1370.50 1754.50Q1388 1737 1398 1714Q1408 1691 1408 1664L1408 1664Q1408 1637 1398 1614Q1388 1591 1370.50 1573.50Q1353 1556 1330 1546Q1307 1536 1280 1536L1280 1536Q1253 1536 1230 1546Q1207 1556 1189.50 1573.50Q1172 1591 1162 1614Q1152 1637 1152 1664L1152 1664Q1152 1691 1162 1714Q1172 1737 1189.50 1754.50Q1207 1772 1230 1782Q1253 1792 1280 1792ZM1984 0L1984 0Q2010 0 2029 19Q2048 38 2048 64L2048 64Q2048 90 2029 109L2029 109L1483 656Q1509 695 1522.50 740Q1536 785 1536 832L1536 832L1536 859L347 2048L0 1701L1189 512Q1247 512 1294.50 522.50Q1342 533 1392 565L1392 565L1939 19Q1958 0 1984 0ZM347 1867L1406 807Q1402 775 1387.50 746.50Q1373 718 1351.50 696.50Q1330 675 1301.50 660.50Q1273 646 1241 642L1241 642L181 1701L347 1867Z"
         }
      }
   ]
}

var Golf = {
   name: "Golf",
   vendor: "UiFabric",
   unicode: 60191,
   value: "",
   charCode: "EB1F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1057 0 1147 25Q1237 50 1315 96Q1393 142 1457.50 206.50Q1522 271 1568 349Q1614 427 1639 517Q1664 607 1664 704L1664 704Q1664 801 1639 891Q1614 981 1568 1059Q1522 1137 1457.50 1201.50Q1393 1266 1315 1312Q1237 1358 1147 1383Q1057 1408 960 1408L960 1408Q863 1408 773 1383Q683 1358 605 1312Q527 1266 462.50 1201.50Q398 1137 352 1059Q306 981 281 891Q256 801 256 704L256 704Q256 607 281 517Q306 427 352 349Q398 271 462.50 206.50Q527 142 605 96Q683 50 773 25Q863 0 960 0ZM960 1280L960 1280Q1079 1280 1184 1234.50Q1289 1189 1367 1111Q1445 1033 1490.50 928Q1536 823 1536 704L1536 704Q1536 585 1490.50 480Q1445 375 1367 297Q1289 219 1184 173.50Q1079 128 960 128L960 128Q841 128 736 173.50Q631 219 553 297Q475 375 429.50 480Q384 585 384 704L384 704Q384 823 429.50 928Q475 1033 553 1111Q631 1189 736 1234.50Q841 1280 960 1280ZM1088 1024L1088 1024Q1114 1024 1133 1043Q1152 1062 1152 1088L1152 1088Q1152 1114 1133 1133Q1114 1152 1088 1152L1088 1152Q1062 1152 1043 1133Q1024 1114 1024 1088L1024 1088Q1024 1062 1043 1043Q1062 1024 1088 1024ZM1216 896L1216 896Q1242 896 1261 915Q1280 934 1280 960L1280 960Q1280 986 1261 1005Q1242 1024 1216 1024L1216 1024Q1190 1024 1171 1005Q1152 986 1152 960L1152 960Q1152 934 1171 915Q1190 896 1216 896ZM1344 768L1344 768Q1370 768 1389 787Q1408 806 1408 832L1408 832Q1408 858 1389 877Q1370 896 1344 896L1344 896Q1318 896 1299 877Q1280 858 1280 832L1280 832Q1280 806 1299 787Q1318 768 1344 768ZM832 896L832 896Q806 896 787 877Q768 858 768 832L768 832Q768 806 787 787Q806 768 832 768L832 768Q858 768 877 787Q896 806 896 832L896 832Q896 858 877 877Q858 896 832 896ZM960 768L960 768Q934 768 915 749Q896 730 896 704L896 704Q896 678 915 659Q934 640 960 640L960 640Q986 640 1005 659Q1024 678 1024 704L1024 704Q1024 730 1005 749Q986 768 960 768ZM1088 640L1088 640Q1062 640 1043 621Q1024 602 1024 576L1024 576Q1024 550 1043 531Q1062 512 1088 512L1088 512Q1114 512 1133 531Q1152 550 1152 576L1152 576Q1152 602 1133 621Q1114 640 1088 640ZM1344 640L1344 640Q1318 640 1299 621Q1280 602 1280 576L1280 576Q1280 550 1299 531Q1318 512 1344 512L1344 512Q1370 512 1389 531Q1408 550 1408 576L1408 576Q1408 602 1389 621Q1370 640 1344 640ZM960 896L960 896Q986 896 1005 915Q1024 934 1024 960L1024 960Q1024 986 1005 1005Q986 1024 960 1024L960 1024Q934 1024 915 1005Q896 986 896 960L896 960Q896 934 915 915Q934 896 960 896ZM832 1024L832 1024Q858 1024 877 1043Q896 1062 896 1088L896 1088Q896 1114 877 1133Q858 1152 832 1152L832 1152Q806 1152 787 1133Q768 1114 768 1088L768 1088Q768 1062 787 1043Q806 1024 832 1024ZM1088 768L1088 768Q1114 768 1133 787Q1152 806 1152 832L1152 832Q1152 858 1133 877Q1114 896 1088 896L1088 896Q1062 896 1043 877Q1024 858 1024 832L1024 832Q1024 806 1043 787Q1062 768 1088 768ZM1216 768L1216 768Q1190 768 1171 749Q1152 730 1152 704L1152 704Q1152 678 1171 659Q1190 640 1216 640L1216 640Q1242 640 1261 659Q1280 678 1280 704L1280 704Q1280 730 1261 749Q1242 768 1216 768ZM1251 1479L1309 1593L1024 1735L1024 2048L896 2048L896 1735L611 1593L669 1479L960 1624L1251 1479Z"
         }
      }
   ]
}

var Baseball = {
   name: "Baseball",
   vendor: "UiFabric",
   unicode: 60192,
   value: "",
   charCode: "EB20",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM384 512L384 512Q410 512 429 531Q448 550 448 576L448 576Q448 602 429 621Q410 640 384 640L384 640Q358 640 339 621Q320 602 320 576L320 576Q320 550 339 531Q358 512 384 512ZM640 576L640 576Q666 576 685 595Q704 614 704 640L704 640Q704 666 685 685Q666 704 640 704L640 704Q614 704 595 685Q576 666 576 640L576 640Q576 614 595 595Q614 576 640 576ZM896 640L896 640Q922 640 941 659Q960 678 960 704L960 704Q960 730 941 749Q922 768 896 768L896 768Q870 768 851 749Q832 730 832 704L832 704Q832 678 851 659Q870 640 896 640ZM1152 640L1152 640Q1178 640 1197 659Q1216 678 1216 704L1216 704Q1216 730 1197 749Q1178 768 1152 768L1152 768Q1126 768 1107 749Q1088 730 1088 704L1088 704Q1088 678 1107 659Q1126 640 1152 640ZM1408 576L1408 576Q1434 576 1453 595Q1472 614 1472 640L1472 640Q1472 666 1453 685Q1434 704 1408 704L1408 704Q1382 704 1363 685Q1344 666 1344 640L1344 640Q1344 614 1363 595Q1382 576 1408 576ZM1600 576L1600 576Q1600 550 1619 531Q1638 512 1664 512L1664 512Q1690 512 1709 531Q1728 550 1728 576L1728 576Q1728 602 1709 621Q1690 640 1664 640L1664 640Q1638 640 1619 621Q1600 602 1600 576ZM1664 1408L1664 1408Q1690 1408 1709 1427Q1728 1446 1728 1472L1728 1472Q1728 1498 1709 1517Q1690 1536 1664 1536L1664 1536Q1638 1536 1619 1517Q1600 1498 1600 1472L1600 1472Q1600 1446 1619 1427Q1638 1408 1664 1408ZM1408 1344L1408 1344Q1434 1344 1453 1363Q1472 1382 1472 1408L1472 1408Q1472 1434 1453 1453Q1434 1472 1408 1472L1408 1472Q1382 1472 1363 1453Q1344 1434 1344 1408L1344 1408Q1344 1382 1363 1363Q1382 1344 1408 1344ZM1152 1280L1152 1280Q1178 1280 1197 1299Q1216 1318 1216 1344L1216 1344Q1216 1370 1197 1389Q1178 1408 1152 1408L1152 1408Q1126 1408 1107 1389Q1088 1370 1088 1344L1088 1344Q1088 1318 1107 1299Q1126 1280 1152 1280ZM896 1280L896 1280Q922 1280 941 1299Q960 1318 960 1344L960 1344Q960 1370 941 1389Q922 1408 896 1408L896 1408Q870 1408 851 1389Q832 1370 832 1344L832 1344Q832 1318 851 1299Q870 1280 896 1280ZM640 1344L640 1344Q666 1344 685 1363Q704 1382 704 1408L704 1408Q704 1434 685 1453Q666 1472 640 1472L640 1472Q614 1472 595 1453Q576 1434 576 1408L576 1408Q576 1382 595 1363Q614 1344 640 1344ZM384 1408L384 1408Q410 1408 429 1427Q448 1446 448 1472L448 1472Q448 1498 429 1517Q410 1536 384 1536L384 1536Q358 1536 339 1517Q320 1498 320 1472L320 1472Q320 1446 339 1427Q358 1408 384 1408Z"
         }
      }
   ]
}

var Soccer = {
   name: "Soccer",
   vendor: "UiFabric",
   unicode: 60193,
   value: "",
   charCode: "EB21",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 893L1261 1344L787 1344L640 893L1024 614L1408 893ZM1168 1216L1257 941L1024 772L791 941L880 1216L1168 1216ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1814 991L1911 895Q1889 744 1817 607L1817 607L1682 587L1647 822L1814 991ZM1236 263L1175 141Q1137 134 1099.50 131Q1062 128 1024 128L1024 128Q986 128 948.50 131Q911 134 873 141L873 141L812 263L1024 369L1236 263ZM366 587L231 607Q159 744 137 895L137 895L234 991L401 822L366 587ZM405 1515L383 1649Q490 1759 628 1827L628 1827L748 1765L639 1554L405 1515ZM921 1819L788 1888Q905 1920 1024 1920L1024 1920Q1143 1920 1260 1888L1260 1888L1127 1819L1325 1438L1748 1368L1773 1515Q1839 1414 1876 1300.50Q1913 1187 1919 1066L1919 1066L1812 1172L1511 866L1575 441L1723 463Q1648 369 1550.50 298.50Q1453 228 1341 186L1341 186L1408 320L1024 512L640 320L707 186Q595 228 497.50 298.50Q400 369 325 463L325 463L473 441L537 866L236 1172L129 1066Q135 1187 172 1300.50Q209 1414 275 1515L275 1515L300 1368L723 1438L921 1819ZM1300 1765L1420 1827Q1558 1759 1665 1649L1665 1649L1643 1515L1409 1554L1300 1765Z"
         }
      }
   ]
}

var MoreSports = {
   name: "MoreSports",
   vendor: "UiFabric",
   unicode: 60194,
   value: "",
   charCode: "EB22",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M531 1261L621 1171L877 1427L787 1517L531 1261ZM1216 0L1216 0Q1331 0 1437.50 29.50Q1544 59 1636.50 113.50Q1729 168 1804.50 243.50Q1880 319 1934.50 411.50Q1989 504 2018.50 610.50Q2048 717 2048 832L2048 832Q2048 978 2000 1111Q1952 1244 1865.50 1352Q1779 1460 1660 1536Q1541 1612 1399 1644L1399 1644Q1408 1718 1408 1792L1408 1792Q1408 1845 1388 1891.50Q1368 1938 1333 1973Q1298 2008 1251.50 2028Q1205 2048 1152 2048L1152 2048Q993 2048 845.50 2007Q698 1966 570 1891Q442 1816 337 1711Q232 1606 157 1478Q82 1350 41 1202.50Q0 1055 0 896L0 896Q0 843 20 796.50Q40 750 75 715Q110 680 156.50 660Q203 640 256 640L256 640Q330 640 404 649L404 649Q436 507 512 388Q588 269 696 182.50Q804 96 937 48Q1070 0 1216 0ZM1757 382L1570 569Q1618 604 1675 622Q1732 640 1792 640L1792 640Q1842 640 1890 628L1890 628Q1870 560 1836 498Q1802 436 1757 382L1757 382ZM1479 478L1666 291Q1612 246 1550 212Q1488 178 1420 158L1420 158Q1408 206 1408 256L1408 256Q1408 316 1426 373Q1444 430 1479 478L1479 478ZM1295 133L1295 133Q1275 130 1255.50 129Q1236 128 1216 128L1216 128Q1092 128 976.50 170.50Q861 213 766 292L766 292L1216 742L1388 570Q1335 503 1307.50 422.50Q1280 342 1280 256L1280 256Q1280 193 1295 133ZM1126 832L675 382Q622 445 585 518.50Q548 592 530 673L530 673Q667 705 793 772Q919 839 1024 933L1024 933L1126 832ZM1152 1920L1152 1920Q1179 1920 1202 1910Q1225 1900 1242.50 1882.50Q1260 1865 1270 1842Q1280 1819 1280 1792L1280 1792Q1280 1651 1243.50 1520Q1207 1389 1140 1275.50Q1073 1162 979.50 1068.50Q886 975 772.50 908Q659 841 528 804.50Q397 768 256 768L256 768Q229 768 206 778Q183 788 165.50 805.50Q148 823 138 846Q128 869 128 896L128 896Q128 1037 164.50 1168Q201 1299 268 1412.50Q335 1526 428.50 1619.50Q522 1713 635.50 1780Q749 1847 880 1883.50Q1011 1920 1152 1920ZM1216 922L1115 1024Q1209 1129 1276 1255Q1343 1381 1375 1518L1375 1518Q1456 1500 1529.50 1463Q1603 1426 1666 1373L1666 1373L1216 922ZM1306 832L1756 1282Q1835 1187 1877.50 1071.50Q1920 956 1920 832L1920 832Q1920 812 1919 792.50Q1918 773 1915 753L1915 753Q1855 768 1792 768L1792 768Q1706 768 1625.50 740.50Q1545 713 1478 660L1478 660L1306 832Z"
         }
      }
   ]
}

var AutoRacing = {
   name: "AutoRacing",
   vendor: "UiFabric",
   unicode: 60196,
   value: "",
   charCode: "EB24",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1214.50 34.50Q1337 69 1444 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 476Q1851 583 1885.50 705.50Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1214.50Q1851 1337 1788.50 1444Q1726 1551 1638.50 1638.50Q1551 1726 1444 1788.50Q1337 1851 1214.50 1885.50Q1092 1920 960 1920L960 1920Q828 1920 705.50 1885.50Q583 1851 476 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444Q69 1337 34.50 1214.50Q0 1092 0 960L0 960Q0 828 34.50 705.50Q69 583 131.50 476Q194 369 281.50 281.50Q369 194 476 131.50Q583 69 705.50 34.50Q828 0 960 0ZM960 1792L960 1792Q1075 1792 1181 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM1133 877L1132 876Q1152 916 1152 960L1152 960Q1152 1000 1137 1035Q1122 1070 1096 1096Q1070 1122 1035 1137Q1000 1152 960 1152L960 1152Q920 1152 885 1137Q850 1122 824 1096Q798 1070 783 1035Q768 1000 768 960L768 960Q768 920 783 885Q798 850 824 824Q850 798 885 783Q920 768 960 768L960 768Q1004 768 1044 788L1044 788L1043 787L1411 419L1501 509L1133 877ZM960 1024L960 1024Q986 1024 1005 1005Q1024 986 1024 960L1024 960Q1024 934 1005 915Q986 896 960 896L960 896Q934 896 915 915Q896 934 896 960L896 960Q896 986 915 1005Q934 1024 960 1024ZM1484 724L1600 672Q1631 740 1646.50 812.50Q1662 885 1662 960L1662 960Q1662 1100 1609.50 1229.50Q1557 1359 1458 1458L1458 1458L1367 1367Q1448 1286 1492 1182Q1536 1078 1536 963L1536 963Q1536 839 1484 724L1484 724ZM1248 320L1196 436Q1081 384 957 384L957 384Q878 384 805 404.50Q732 425 668 463Q604 501 552 553.50Q500 606 462.50 670Q425 734 404.50 807.50Q384 881 384 960L384 960Q384 1075 428 1180.50Q472 1286 553 1367L553 1367L462 1458Q362 1358 309 1229.50Q256 1101 256 960L256 960Q256 863 281 773Q306 683 352 605Q398 527 462 463Q526 399 604 353.50Q682 308 772 283Q862 258 960 258L960 258Q1035 258 1107.50 273.50Q1180 289 1248 320L1248 320Z"
         }
      }
   ]
}

var CollegeHoops = {
   name: "CollegeHoops",
   vendor: "UiFabric",
   unicode: 60197,
   value: "",
   charCode: "EB25",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1093 0 1215.50 34Q1338 68 1445 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 475Q1852 582 1886 704.50Q1920 827 1920 960L1920 960Q1920 1093 1886 1215.50Q1852 1338 1789.50 1445Q1727 1552 1639.50 1639.50Q1552 1727 1445 1789.50Q1338 1852 1215.50 1886Q1093 1920 960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0ZM1790 1024L1411 1024Q1421 1152 1470.50 1270Q1520 1388 1605 1485L1605 1485Q1686 1387 1732.50 1269Q1779 1151 1790 1024L1790 1024ZM1411 896L1790 896Q1779 769 1732.50 651Q1686 533 1605 435L1605 435Q1520 532 1470.50 650Q1421 768 1411 896L1411 896ZM1516 342L1516 342Q1413 249 1287.50 195Q1162 141 1024 130L1024 130L1024 896L1282 896Q1293 741 1352.50 599Q1412 457 1516 342ZM896 896L896 130Q758 141 632.50 195Q507 249 404 342L404 342Q508 457 567.50 599Q627 741 638 896L638 896L896 896ZM315 1485L315 1485Q400 1388 449.50 1270Q499 1152 509 1024L509 1024L130 1024Q141 1151 187.50 1269Q234 1387 315 1485ZM130 896L509 896Q499 768 449.50 650Q400 532 315 435L315 435Q234 533 187.50 651Q141 769 130 896L130 896ZM404 1578L404 1578Q507 1671 632.50 1725Q758 1779 896 1790L896 1790L896 1024L638 1024Q627 1179 567.50 1321Q508 1463 404 1578ZM1024 1024L1024 1790Q1162 1779 1287.50 1725Q1413 1671 1516 1578L1516 1578Q1412 1463 1352.50 1321Q1293 1179 1282 1024L1282 1024L1024 1024Z"
         }
      }
   ]
}

var CollegeFootball = {
   name: "CollegeFootball",
   vendor: "UiFabric",
   unicode: 60198,
   value: "",
   charCode: "EB26",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L1536 0Q1642 0 1735.50 40Q1829 80 1898.50 149.50Q1968 219 2008 312.50Q2048 406 2048 512L2048 512Q2048 724 1993 920Q1938 1116 1838 1287Q1738 1458 1598 1598Q1458 1738 1287 1838Q1116 1938 920 1993Q724 2048 512 2048L512 2048Q406 2048 312.50 2008Q219 1968 149.50 1898.50Q80 1829 40 1735.50Q0 1642 0 1536L0 1536Q0 1324 55 1128Q110 932 210 761Q310 590 450 450Q590 310 761 210Q932 110 1128 55Q1324 0 1536 0ZM1920 512L1920 512Q1920 433 1890 363Q1860 293 1807.50 240.50Q1755 188 1685 158Q1615 128 1536 128L1536 128Q1468 128 1401 134.50Q1334 141 1268 154L1268 154L1894 780Q1907 714 1913.50 647Q1920 580 1920 512ZM128 1536L128 1536Q128 1616 158 1685.50Q188 1755 240.50 1807.50Q293 1860 362.50 1890Q432 1920 512 1920L512 1920Q580 1920 647 1913.50Q714 1907 780 1894L780 1894L154 1268Q141 1334 134.50 1401Q128 1468 128 1536ZM190 1123L925 1858Q1092 1807 1239.50 1717.50Q1387 1628 1507.50 1507.50Q1628 1387 1717.50 1239.50Q1807 1092 1858 925L1858 925L1123 190Q956 241 808.50 330.50Q661 420 540.50 540.50Q420 661 330.50 808.50Q241 956 190 1123L190 1123ZM723 1235L1235 723L1325 813L813 1325L723 1235Z"
         }
      }
   ]
}

var ProFootball = {
   name: "ProFootball",
   vendor: "UiFabric",
   unicode: 60199,
   value: "",
   charCode: "EB27",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L1536 0Q1642 0 1735.50 40Q1829 80 1898.50 149.50Q1968 219 2008 312.50Q2048 406 2048 512L2048 512Q2048 724 1993 920Q1938 1116 1838 1287Q1738 1458 1598 1598Q1458 1738 1287 1838Q1116 1938 920 1993Q724 2048 512 2048L512 2048Q406 2048 312.50 2008Q219 1968 149.50 1898.50Q80 1829 40 1735.50Q0 1642 0 1536L0 1536Q0 1324 55 1128Q110 932 210 761Q310 590 450 450Q590 310 761 210Q932 110 1128 55Q1324 0 1536 0ZM512 1920L512 1920Q706 1920 885.50 1869.50Q1065 1819 1221.50 1727.50Q1378 1636 1507 1507Q1636 1378 1727.50 1221.50Q1819 1065 1869.50 885.50Q1920 706 1920 512L1920 512Q1920 433 1890 363Q1860 293 1807.50 240.50Q1755 188 1685 158Q1615 128 1536 128L1536 128Q1342 128 1162.50 178.50Q983 229 826.50 320.50Q670 412 541 541Q412 670 320.50 826.50Q229 983 178.50 1162.50Q128 1342 128 1536L128 1536Q128 1616 158 1685.50Q188 1755 240.50 1807.50Q293 1860 362.50 1890Q432 1920 512 1920ZM1171 685L1261 595L1453 787L1363 877L1312 827L1211 928L1261 979L1171 1069L1120 1018L1018 1120L1069 1171L979 1261L928 1211L827 1312L877 1363L787 1453L595 1261L685 1171L736 1221L837 1120L787 1069L877 979L928 1030L1030 928L979 877L1069 787L1120 837L1221 736L1171 685Z"
         }
      }
   ]
}

var ProHockey = {
   name: "ProHockey",
   vendor: "UiFabric",
   unicode: 60200,
   value: "",
   charCode: "EB28",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1324 0L1324 0Q1402 0 1473.50 23Q1545 46 1601 102L1601 102L1946 447Q2002 503 2025 574.50Q2048 646 2048 724L2048 724Q2048 828 2014 940Q1980 1052 1919 1164.50Q1858 1277 1775 1386.50Q1692 1496 1594 1594Q1496 1692 1386.50 1775Q1277 1858 1164.50 1919Q1052 1980 940 2014Q828 2048 724 2048L724 2048Q647 2048 575 2025Q503 2002 447 1946L447 1946L102 1601Q46 1545 23 1473.50Q0 1402 0 1324L0 1324Q0 1220 34 1108Q68 996 128.50 883Q189 770 272.50 661Q356 552 454 454Q552 356 661 272.50Q770 189 883 128.50Q996 68 1108 34Q1220 0 1324 0ZM128 1327L128 1327Q128 1448 193.50 1511Q259 1574 379 1574L379 1574Q469 1574 568.50 1542.50Q668 1511 769 1455Q870 1399 969 1323Q1068 1247 1157.50 1157.50Q1247 1068 1323 969Q1399 870 1455 769Q1511 668 1542.50 568.50Q1574 469 1574 379L1574 379Q1574 258 1510 193Q1446 128 1325 128L1325 128Q1234 128 1134.50 159.50Q1035 191 933.50 247Q832 303 733 379.50Q634 456 544.50 545.50Q455 635 379 734.50Q303 834 247 935Q191 1036 159.50 1136Q128 1236 128 1327ZM721 1920L721 1920Q812 1920 912 1888.50Q1012 1857 1113.50 1801Q1215 1745 1314.50 1669Q1414 1593 1503.50 1503.50Q1593 1414 1669 1314.50Q1745 1215 1801 1113.50Q1857 1012 1888.50 912Q1920 812 1920 721L1920 721Q1920 670 1905.50 622.50Q1891 575 1855 538L1855 538L1703 385Q1701 488 1666.50 599.50Q1632 711 1571.50 822.50Q1511 934 1428 1042Q1345 1150 1247.50 1247.50Q1150 1345 1042 1428Q934 1511 822.50 1571.50Q711 1632 599.50 1667Q488 1702 385 1703L385 1703L538 1855Q575 1891 622.50 1905.50Q670 1920 721 1920Z"
         }
      }
   ]
}

var Rugby = {
   name: "Rugby",
   vendor: "UiFabric",
   unicode: 60205,
   value: "",
   charCode: "EB2D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L1536 0Q1642 0 1735.50 40Q1829 80 1898.50 149.50Q1968 219 2008 312.50Q2048 406 2048 512L2048 512Q2048 724 1993 920Q1938 1116 1838 1287Q1738 1458 1598 1598Q1458 1738 1287 1838Q1116 1938 920 1993Q724 2048 512 2048L512 2048Q406 2048 312.50 2008Q219 1968 149.50 1898.50Q80 1829 40 1735.50Q0 1642 0 1536L0 1536Q0 1324 55 1128Q110 932 210 761Q310 590 450 450Q590 310 761 210Q932 110 1128 55Q1324 0 1536 0ZM1536 128L1536 128Q1342 128 1162.50 178.50Q983 229 826.50 320.50Q670 412 541 541Q412 670 320.50 826.50Q229 983 178.50 1162.50Q128 1342 128 1536L128 1536Q128 1596 146 1653Q164 1710 199 1758L199 1758L1758 199Q1710 164 1653 146Q1596 128 1536 128ZM512 1920L512 1920Q706 1920 885.50 1869.50Q1065 1819 1221.50 1727.50Q1378 1636 1507 1507Q1636 1378 1727.50 1221.50Q1819 1065 1869.50 885.50Q1920 706 1920 512L1920 512Q1920 452 1902 395Q1884 338 1849 290L1849 290L290 1849Q338 1884 395 1902Q452 1920 512 1920Z"
         }
      }
   ]
}

var SubstitutionsIn = {
   name: "SubstitutionsIn",
   vendor: "UiFabric",
   unicode: 60209,
   value: "",
   charCode: "EB31",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1278L1045 0L1920 1278L1408 1278L1408 2048L638 2048L638 1278L128 1278ZM1280 1920L1280 1150L1677 1150L1042 223L377 1150L766 1150L766 1920L1280 1920Z"
         }
      }
   ]
}

var Tennis = {
   name: "Tennis",
   vendor: "UiFabric",
   unicode: 60211,
   value: "",
   charCode: "EB33",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1089 137 1152L137 1152Q259 1150 356.50 1103Q454 1056 530 980Q606 904 661.50 806Q717 708 756 603L756 603Q780 537 810.50 472.50Q841 408 878 347.50Q915 287 959.50 231.50Q1004 176 1057 129L1057 129Q1049 128 1040.50 128Q1032 128 1024 128ZM165 1279L165 1279Q197 1387 255 1483Q313 1579 391 1657Q469 1735 565 1793Q661 1851 769 1883L769 1883Q777 1743 831.50 1631Q886 1519 972.50 1432Q1059 1345 1170 1281Q1281 1217 1403 1172L1403 1172Q1469 1148 1541 1112Q1613 1076 1680 1029.50Q1747 983 1803 927Q1859 871 1893 806L1893 806Q1863 686 1802.50 581Q1742 476 1657 391Q1572 306 1467 245.50Q1362 185 1242 155L1242 155Q1177 189 1121 245Q1065 301 1018.50 368Q972 435 936 507Q900 579 876 645L876 645Q831 767 767 878Q703 989 616 1075.50Q529 1162 417 1216.50Q305 1271 165 1279ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 1016 1920 1007.50Q1920 999 1919 991L1919 991Q1872 1044 1816.50 1088.50Q1761 1133 1700.50 1170Q1640 1207 1575.50 1237.50Q1511 1268 1445 1292L1445 1292Q1340 1331 1242 1386.50Q1144 1442 1068 1518Q992 1594 945 1691.50Q898 1789 896 1911L896 1911Q959 1920 1024 1920Z"
         }
      }
   ]
}

var Arrivals = {
   name: "Arrivals",
   vendor: "UiFabric",
   unicode: 60212,
   value: "",
   charCode: "EB34",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1216L1920 1216Q1920 1256 1905 1291Q1890 1326 1864 1352Q1838 1378 1803 1393Q1768 1408 1728 1408L1728 1408L128 1408L0 896L384 896L416 1024L672 1024L512 384L832 384L1152 1024L1728 1024Q1768 1024 1803 1039Q1838 1054 1864 1080Q1890 1106 1905 1141Q1920 1176 1920 1216ZM164 1024L228 1280L1728 1280Q1754 1280 1773 1261Q1792 1242 1792 1216L1792 1216Q1792 1190 1773 1171Q1754 1152 1728 1152L1728 1152L1073 1152Q995 990 914.50 831.50Q834 673 753 512L753 512L676 512Q716 673 755.50 832Q795 991 836 1152L836 1152L316 1152Q308 1120 300 1088Q292 1056 284 1024L284 1024L164 1024ZM640 1664L2048 1664L2048 1792L640 1792L640 1664Z"
         }
      }
   ]
}

var Website = {
   name: "Website",
   vendor: "UiFabric",
   unicode: 60225,
   value: "",
   charCode: "EB41",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1573 896L1621 1040L1669 896L1744 896L1659 1152L1584 1152L1536 1008L1488 1152L1413 1152L1328 896L1403 896L1451 1040L1499 896L1573 896ZM1109 1040L1157 896L1232 896L1147 1152L1072 1152L1024 1008L976 1152L901 1152L816 896L891 896L939 1040L987 896L1061 896L1109 1040ZM597 1040L645 896L720 896L635 1152L560 1152L512 1008L464 1152L389 1152L304 896L379 896L427 1040L475 896L549 896L597 1040Z"
         }
      }
   ]
}

var Drop = {
   name: "Drop",
   vendor: "UiFabric",
   unicode: 60226,
   value: "",
   charCode: "EB42",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1019 0L1606 1166Q1664 1280 1664 1408L1664 1408Q1664 1496 1641 1578Q1618 1660 1576.50 1731Q1535 1802 1476.50 1860.50Q1418 1919 1347 1960.50Q1276 2002 1194 2025Q1112 2048 1024 2048L1024 2048Q936 2048 854 2025Q772 2002 701 1960.50Q630 1919 571.50 1860.50Q513 1802 471.50 1731Q430 1660 407 1578Q384 1496 384 1408L384 1408Q384 1281 440 1167L440 1167L1019 0Z"
         }
      }
   ]
}

var HistoricalWeather = {
   name: "HistoricalWeather",
   vendor: "UiFabric",
   unicode: 60227,
   value: "",
   charCode: "EB43",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1664L128 1664L2048 1664L2048 1792L0 1792L0 256L128 256L128 697L653 434L993 774L1452 889L1939 403L2029 493L1492 1031L927 890L627 590L128 839L128 1136L648 1021L1167 1280L1521 1280L1955 1063L2013 1177L1551 1408L1137 1408L632 1155L128 1267L128 1664Z"
         }
      }
   ]
}

var SkiResorts = {
   name: "SkiResorts",
   vendor: "UiFabric",
   unicode: 60229,
   value: "",
   charCode: "EB45",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1215 1153L1472 640L2046 1792L0 1792L768 256L1215 1153ZM1648 1280L1472 927L1287 1296L1334 1391L1445 1280L1648 1280ZM768 933L898 803L768 543L638 803L768 933ZM577 924L207 1664L1328 1664L958 924L768 1115L577 924ZM1395 1512L1470 1664L1839 1664L1712 1408L1499 1408L1395 1512Z"
         }
      }
   ]
}

var Snowflake = {
   name: "Snowflake",
   vendor: "UiFabric",
   unicode: 60230,
   value: "",
   charCode: "EB46",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1871 1276L1871 1276L1904 1400L1704 1453L1757 1654L1633 1687L1570 1450L1024 1135L1024 1766L1197 1939L1107 2029L960 1883L813 2029L723 1939L896 1766L896 1135L350 1450L287 1687L163 1654L216 1453L16 1400L49 1276L286 1339L832 1024L286 709L49 772L16 648L216 595L163 394L287 361L350 598L896 913L896 282L723 109L813 19L960 165L1107 19L1197 109L1024 282L1024 913L1570 598L1633 361L1757 394L1704 595L1904 648L1871 772L1634 709L1088 1024L1634 1339L1871 1276Z"
         }
      }
   ]
}

var BusSolid = {
   name: "BusSolid",
   vendor: "UiFabric",
   unicode: 60231,
   value: "",
   charCode: "EB47",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 640L1920 640L1920 896L1792 896L1792 1856L1792 1920Q1792 1947 1782 1970Q1772 1993 1754.50 2010.50Q1737 2028 1714 2038Q1691 2048 1664 2048L1664 2048L1536 2048Q1509 2048 1486 2038Q1463 2028 1445.50 2010.50Q1428 1993 1418 1970Q1408 1947 1408 1920L1408 1920L512 1920Q512 1947 502 1970Q492 1993 474.50 2010.50Q457 2028 434 2038Q411 2048 384 2048L384 2048L256 2048Q229 2048 206 2038Q183 2028 165.50 2010.50Q148 1993 138 1970Q128 1947 128 1920L128 1920L128 1856L128 896L0 896L0 640L128 640L128 320Q128 280 143 245Q158 210 184 184Q210 158 245 143Q280 128 320 128L320 128L1600 128Q1640 128 1675 143Q1710 158 1736 184Q1762 210 1777 245Q1792 280 1792 320L1792 320L1792 640ZM256 640L256 1152L896 1152L896 640L256 640ZM512 1536L512 1472Q512 1446 493 1427Q474 1408 448 1408L448 1408Q422 1408 403 1427Q384 1446 384 1472L384 1472L384 1536L512 1536ZM1664 1792L1664 1664L256 1664L256 1792L1664 1792ZM1408 1536L1536 1536L1536 1472Q1536 1446 1517 1427Q1498 1408 1472 1408L1472 1408Q1446 1408 1427 1427Q1408 1446 1408 1472L1408 1472L1408 1536ZM1664 1152L1664 640L1024 640L1024 1152L1664 1152Z"
         }
      }
   ]
}

var FerrySolid = {
   name: "FerrySolid",
   vendor: "UiFabric",
   unicode: 60232,
   value: "",
   charCode: "EB48",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1487L1768 1792L1920 1792L1920 1920L1704 1920Q1692 1944 1675 1967Q1658 1990 1637 2008Q1616 2026 1591 2037Q1566 2048 1536 2048L1536 2048Q1495 2048 1465 2038.50Q1435 2029 1411.50 2015Q1388 2001 1369.50 1984.50Q1351 1968 1332.50 1954Q1314 1940 1294 1930.50Q1274 1921 1248 1921L1248 1921Q1222 1921 1202 1930.50Q1182 1940 1164 1953.50Q1146 1967 1127.50 1983.50Q1109 2000 1086 2013.50Q1063 2027 1032.50 2036.50Q1002 2046 960 2046L960 2046Q918 2046 887.50 2036.50Q857 2027 834 2013.50Q811 2000 792.50 1983.50Q774 1967 756 1953.50Q738 1940 718 1930.50Q698 1921 672 1921L672 1921Q646 1921 626 1930.50Q606 1940 587.50 1954Q569 1968 550.50 1984.50Q532 2001 508.50 2015Q485 2029 455 2038.50Q425 2048 384 2048L384 2048Q353 2048 328 2037.50Q303 2027 282.50 2009Q262 1991 245.50 1968Q229 1945 216 1920L216 1920L214 1917L0 1920L0 1792L152 1792L0 1487L0 1330L256 1245L256 768L408 768L536 512L768 512L768 256L1152 256L1152 512L1384 512L1512 768L1664 768L1664 1245L1920 1330L1920 1487ZM896 384L896 512L1024 512L1024 384L896 384ZM960 1010L1536 1202L1536 896L384 896L384 1202L960 1010Z"
         }
      }
   ]
}

var EndPointSolid = {
   name: "EndPointSolid",
   vendor: "UiFabric",
   unicode: 60235,
   value: "",
   charCode: "EB4B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 2048L256 2048L256 0L1024 0L1024 1024L384 1024L384 2048ZM1152 1280L1152 256L1920 256L1920 1280L1152 1280Z"
         }
      }
   ]
}

var AirplaneSolid = {
   name: "AirplaneSolid",
   vendor: "UiFabric",
   unicode: 60236,
   value: "",
   charCode: "EB4C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1312 768L1856 768Q1896 768 1931 783Q1966 798 1992 824Q2018 850 2033 885Q2048 920 2048 960L2048 960Q2048 1000 2033 1035Q2018 1070 1992 1096Q1966 1122 1931 1137Q1896 1152 1856 1152L1856 1152L1312 1152L928 1920L662 1920L918 1152L256 1152L189 1280L0 1280L108 960L0 640L189 640L256 768L918 768L662 0L928 0L1312 768Z"
         }
      }
   ]
}

var TrainSolid = {
   name: "TrainSolid",
   vendor: "UiFabric",
   unicode: 60237,
   value: "",
   charCode: "EB4D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1624 1790L1882 2048L1701 2048L1445 1792L602 1792L346 2048L165 2048L424 1790Q388 1786 357 1769Q326 1752 303.50 1726.50Q281 1701 268.50 1668.50Q256 1636 256 1600L256 1600L256 192Q256 152 271 117Q286 82 312 56Q338 30 373 15Q408 0 448 0L448 0L1600 0Q1640 0 1675 15Q1710 30 1736 56Q1762 82 1777 117Q1792 152 1792 192L1792 192L1792 1600Q1792 1636 1779 1668.50Q1766 1701 1743.50 1726.50Q1721 1752 1690.50 1769Q1660 1786 1624 1790L1624 1790ZM768 256L768 384L1280 384L1280 256L768 256ZM384 1152L1664 1152L1664 640L384 640L384 1152ZM576 1536L576 1536Q602 1536 621 1517Q640 1498 640 1472L640 1472Q640 1446 621 1427Q602 1408 576 1408L576 1408Q550 1408 531 1427Q512 1446 512 1472L512 1472Q512 1498 531 1517Q550 1536 576 1536ZM1472 1536L1472 1536Q1498 1536 1517 1517Q1536 1498 1536 1472L1536 1472Q1536 1446 1517 1427Q1498 1408 1472 1408L1472 1408Q1446 1408 1427 1427Q1408 1446 1408 1472L1408 1472Q1408 1498 1427 1517Q1446 1536 1472 1536Z"
         }
      }
   ]
}

var ContactLock = {
   name: "ContactLock",
   vendor: "UiFabric",
   unicode: 62464,
   value: "",
   charCode: "F400",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1357 1051L1357 1051Q1337 1077 1323 1106.50Q1309 1136 1299 1168L1299 1168Q1213 1098 1110 1061Q1007 1024 896 1024L896 1024Q808 1024 726 1047Q644 1070 573 1111.50Q502 1153 443.50 1211.50Q385 1270 343.50 1341Q302 1412 279 1494Q256 1576 256 1664L256 1664L128 1664Q128 1544 163.50 1433Q199 1322 264 1228Q329 1134 420.50 1061Q512 988 624 946L624 946Q568 911 523.50 863.50Q479 816 448 760Q417 704 400.50 641Q384 578 384 512L384 512Q384 406 424.50 313Q465 220 534.50 150.50Q604 81 697 40.50Q790 0 896 0L896 0Q1002 0 1095 40.50Q1188 81 1257.50 150.50Q1327 220 1367.50 313Q1408 406 1408 512L1408 512Q1408 578 1391.50 641Q1375 704 1344 760Q1313 816 1268 863.50Q1223 911 1167 946L1167 946Q1271 986 1357 1051ZM512 512L512 512Q512 592 542 661.50Q572 731 624.50 783.50Q677 836 746.50 866Q816 896 896 896L896 896Q975 896 1045 866Q1115 836 1167.50 783.50Q1220 731 1250 661.50Q1280 592 1280 512L1280 512Q1280 433 1250 363Q1220 293 1167.50 240.50Q1115 188 1045 158Q975 128 896 128L896 128Q816 128 746.50 158Q677 188 624.50 240.50Q572 293 542 363Q512 433 512 512ZM1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1408 1408L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408ZM1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920Z"
         }
      }
   ]
}

var DeclineCall = {
   name: "DeclineCall",
   vendor: "UiFabric",
   unicode: 62469,
   value: "",
   charCode: "F405",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 512L1024 512Q1099 512 1183.50 520Q1268 528 1354 545.50Q1440 563 1525.50 589.50Q1611 616 1689 653.50Q1767 691 1834.50 739.50Q1902 788 1953 848L1953 848Q1996 899 2022 959.50Q2048 1020 2048 1088L2048 1088L2048 1216Q2048 1256 2033 1291Q2018 1326 1992 1352Q1966 1378 1931 1393Q1896 1408 1856 1408L1856 1408L1600 1408Q1560 1408 1525 1393Q1490 1378 1464 1352Q1438 1326 1423 1291Q1408 1256 1408 1216L1408 1216L1408 1088Q1408 1062 1389 1043Q1370 1024 1344 1024L1344 1024L704 1024Q678 1024 659 1043Q640 1062 640 1088L640 1088L640 1216Q640 1256 625 1291Q610 1326 584 1352Q558 1378 523 1393Q488 1408 448 1408L448 1408L192 1408Q152 1408 117 1393Q82 1378 56 1352Q30 1326 15 1291Q0 1256 0 1216L0 1216L0 1088Q0 1020 26 959.50Q52 899 95 848L95 848Q146 788 213.50 739.50Q281 691 359 653.50Q437 616 522.50 589.50Q608 563 694 545.50Q780 528 864 520Q948 512 1024 512ZM1920 1216L1920 1088Q1920 1036 1895 989.50Q1870 943 1831.50 904.50Q1793 866 1747 835.50Q1701 805 1660 783L1660 783Q1590 746 1511.50 719Q1433 692 1351 674.50Q1269 657 1186 648.50Q1103 640 1024 640L1024 640Q945 640 862 648.50Q779 657 697 674.50Q615 692 536.50 719Q458 746 388 783L388 783Q347 805 301 835.50Q255 866 216.50 904.50Q178 943 153 989.50Q128 1036 128 1088L128 1088L128 1216Q128 1242 147 1261Q166 1280 192 1280L192 1280L448 1280Q474 1280 493 1261Q512 1242 512 1216L512 1216L512 1088Q512 1048 527 1013Q542 978 568 952Q594 926 629 911Q664 896 704 896L704 896L1344 896Q1384 896 1419 911Q1454 926 1480 952Q1506 978 1521 1013Q1536 1048 1536 1088L1536 1088L1536 1216Q1536 1242 1555 1261Q1574 1280 1600 1280L1600 1280L1856 1280Q1882 1280 1901 1261Q1920 1242 1920 1216L1920 1216Z"
         }
      }
   ]
}

var Game = {
   name: "Game",
   vendor: "UiFabric",
   unicode: 59388,
   value: "",
   charCode: "E7FC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1879 553L1879 553Q1961 635 2004.50 739.50Q2048 844 2048 960L2048 960Q2048 995 2046 1044Q2044 1093 2037.50 1150Q2031 1207 2018.50 1267.50Q2006 1328 1986 1386L1986 1386Q1956 1472 1916 1526.50Q1876 1581 1833 1611.50Q1790 1642 1746 1653Q1702 1664 1664 1664L1664 1664Q1631 1664 1603.50 1652.50Q1576 1641 1551.50 1623Q1527 1605 1505.50 1581.50Q1484 1558 1463 1534L1463 1534Q1442 1510 1421.50 1488Q1401 1466 1379 1448.50Q1357 1431 1332.50 1420Q1308 1409 1279 1408L1279 1408L769 1408Q740 1409 715.50 1420Q691 1431 669 1448.50Q647 1466 626.50 1488Q606 1510 585 1534L585 1534Q564 1558 542.50 1581.50Q521 1605 496.50 1623Q472 1641 444.50 1652.50Q417 1664 384 1664L384 1664Q346 1664 302 1653Q258 1642 215 1611.50Q172 1581 132 1526.50Q92 1472 62 1386L62 1386Q42 1328 29.50 1267.50Q17 1207 10.50 1150Q4 1093 2 1044Q0 995 0 960L0 960Q0 844 43.50 739.50Q87 635 169 553L169 553Q250 471 355 427.50Q460 384 576 384L576 384L1472 384Q1588 384 1692.50 427.50Q1797 471 1879 553ZM1865 1344L1865 1344Q1884 1291 1895 1234Q1906 1177 1911.50 1124.50Q1917 1072 1918.50 1029Q1920 986 1920 960L1920 960Q1920 867 1884.50 785.50Q1849 704 1788.50 643.50Q1728 583 1646.50 547.50Q1565 512 1472 512L1472 512L576 512Q483 512 401.50 547.50Q320 583 259.50 643.50Q199 704 163.50 785.50Q128 867 128 960L128 960Q128 986 129.50 1029Q131 1072 136.50 1124.50Q142 1177 153 1234Q164 1291 183 1344L183 1344Q208 1416 238 1455Q268 1494 296.50 1512Q325 1530 348.50 1533Q372 1536 384 1536L384 1536Q406 1536 432.50 1509.50Q459 1483 488 1450L488 1450Q512 1422 539.50 1392.50Q567 1363 600.50 1338.50Q634 1314 675 1298Q716 1282 766 1280L766 1280L767 1280L1282 1280Q1332 1282 1373 1298Q1414 1314 1447.50 1338.50Q1481 1363 1508.50 1392.50Q1536 1422 1560 1450L1560 1450Q1589 1483 1615.50 1509.50Q1642 1536 1664 1536L1664 1536Q1676 1536 1699.50 1533Q1723 1530 1751.50 1512Q1780 1494 1810 1455Q1840 1416 1865 1344ZM512 768L512 896L640 896L640 1024L512 1024L512 1152L384 1152L384 1024L256 1024L256 896L384 896L384 768L512 768ZM1664 1024L1664 1024Q1691 1024 1714 1034Q1737 1044 1754.50 1061.50Q1772 1079 1782 1102Q1792 1125 1792 1152L1792 1152Q1792 1179 1782 1202Q1772 1225 1754.50 1242.50Q1737 1260 1714 1270Q1691 1280 1664 1280L1664 1280Q1637 1280 1614 1270Q1591 1260 1573.50 1242.50Q1556 1225 1546 1202Q1536 1179 1536 1152L1536 1152Q1536 1125 1546 1102Q1556 1079 1573.50 1061.50Q1591 1044 1614 1034Q1637 1024 1664 1024ZM1408 768L1408 768Q1435 768 1458 778Q1481 788 1498.50 805.50Q1516 823 1526 846Q1536 869 1536 896L1536 896Q1536 923 1526 946Q1516 969 1498.50 986.50Q1481 1004 1458 1014Q1435 1024 1408 1024L1408 1024Q1381 1024 1358 1014Q1335 1004 1317.50 986.50Q1300 969 1290 946Q1280 923 1280 896L1280 896Q1280 869 1290 846Q1300 823 1317.50 805.50Q1335 788 1358 778Q1381 768 1408 768Z"
         }
      }
   ]
}

var PaymentCard = {
   name: "PaymentCard",
   vendor: "UiFabric",
   unicode: 59591,
   value: "",
   charCode: "E8C7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M160 256L1888 256Q1921 256 1950 268.50Q1979 281 2001 303Q2023 325 2035.50 354Q2048 383 2048 416L2048 416L2048 1504Q2048 1537 2035.50 1566Q2023 1595 2001 1617Q1979 1639 1950 1651.50Q1921 1664 1888 1664L1888 1664L160 1664Q127 1664 98 1651.50Q69 1639 47 1617Q25 1595 12.50 1566Q0 1537 0 1504L0 1504L0 416Q0 383 12.50 354Q25 325 47 303Q69 281 98 268.50Q127 256 160 256L160 256ZM1888 384L160 384Q146 384 137 393Q128 402 128 416L128 416L128 640L1920 640L1920 416Q1920 402 1911 393Q1902 384 1888 384L1888 384ZM160 1536L1888 1536Q1902 1536 1911 1527Q1920 1518 1920 1504L1920 1504L1920 768L128 768L128 1504Q128 1518 137 1527Q146 1536 160 1536L160 1536ZM1408 1280L1408 1152L1664 1152L1664 1280L1408 1280Z"
         }
      }
   ]
}

var LineChart = {
   name: "LineChart",
   vendor: "UiFabric",
   unicode: 59878,
   value: "",
   charCode: "E9E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M705 978L705 978L256 1427L256 1793L1920 1793L1920 1921L128 1921L128 129L256 129L256 1261L705 812L960 1069L1664 365L1920 621L1920 787L1664 531L960 1235L705 978Z"
         }
      }
   ]
}

var Freezing = {
   name: "Freezing",
   vendor: "UiFabric",
   unicode: 59887,
   value: "",
   charCode: "E9EF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 320L1792 1288Q1853 1351 1886.50 1431.50Q1920 1512 1920 1600L1920 1600Q1920 1693 1885 1774.50Q1850 1856 1789 1917Q1728 1978 1646.50 2013Q1565 2048 1472 2048L1472 2048Q1379 2048 1297.50 2013Q1216 1978 1155 1917Q1094 1856 1059 1774.50Q1024 1693 1024 1600L1024 1600Q1024 1512 1057.50 1431.50Q1091 1351 1152 1288L1152 1288L1152 320Q1152 254 1177 196Q1202 138 1245.50 94.50Q1289 51 1347.50 25.50Q1406 0 1472 0L1472 0Q1538 0 1596 25.50Q1654 51 1697.50 94.50Q1741 138 1766.50 196Q1792 254 1792 320L1792 320ZM1472 1920L1472 1920Q1538 1920 1596 1895Q1654 1870 1697.50 1826.50Q1741 1783 1766.50 1724.50Q1792 1666 1792 1600L1792 1600Q1792 1517 1758 1457Q1724 1397 1664 1344L1664 1344L1664 320Q1664 280 1649 245Q1634 210 1608 184Q1582 158 1547 143Q1512 128 1472 128L1472 128Q1432 128 1397 143Q1362 158 1336 184Q1310 210 1295 245Q1280 280 1280 320L1280 320L1280 1344Q1220 1397 1186 1457Q1152 1517 1152 1600L1152 1600Q1152 1666 1177 1724.50Q1202 1783 1245.50 1826.50Q1289 1870 1347.50 1895Q1406 1920 1472 1920ZM1536 1024L1536 1419Q1565 1429 1588.50 1447Q1612 1465 1629 1489Q1646 1513 1655 1541.50Q1664 1570 1664 1600L1664 1600Q1664 1640 1649 1675Q1634 1710 1608 1736Q1582 1762 1547 1777Q1512 1792 1472 1792L1472 1792Q1432 1792 1397 1777Q1362 1762 1336 1736Q1310 1710 1295 1675Q1280 1640 1280 1600L1280 1600Q1280 1570 1289 1541.50Q1298 1513 1315 1489Q1332 1465 1355.50 1447Q1379 1429 1408 1419L1408 1419L1408 1024L1536 1024ZM128 384L1024 384L896 1152L810 636L672 1280L530 616L448 1024L355 558L256 1152L128 384Z"
         }
      }
   ]
}

var FunnelChart = {
   name: "FunnelChart",
   vendor: "UiFabric",
   unicode: 59889,
   value: "",
   charCode: "E9F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 2048L0 0L2048 0L1024 2048ZM1713 384L1841 128L207 128L335 384L1713 384ZM1265 1280L783 1280L1024 1762L1265 1280ZM719 1152L1329 1152L1457 896L591 896L719 1152ZM527 768L1521 768L1649 512L399 512L527 768Z"
         }
      }
   ]
}

var Processing = {
   name: "Processing",
   vendor: "UiFabric",
   unicode: 59893,
   value: "",
   charCode: "E9F5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M961 895L837 844Q814 881 783.50 911.50Q753 942 716 965L716 965L767 1089L649 1137L598 1014Q558 1024 512 1024L512 1024Q466 1024 426 1014L426 1014L375 1137L257 1089L308 965Q271 942 240.50 911.50Q210 881 187 844L187 844L63 895L15 777L138 726Q128 686 128 640L128 640Q128 594 138 554L138 554L15 503L63 385L187 436Q233 361 308 315L308 315L257 191L375 143L426 266Q466 256 512 256L512 256Q558 256 598 266L598 266L649 143L767 191L716 315Q791 361 837 436L837 436L961 385L1009 503L886 554Q896 594 896 640L896 640Q896 686 886 726L886 726L1009 777L961 895ZM512 896L512 896Q565 896 611.50 876Q658 856 693 821Q728 786 748 739.50Q768 693 768 640L768 640Q768 587 748 540.50Q728 494 693 459Q658 424 611.50 404Q565 384 512 384L512 384Q459 384 412.50 404Q366 424 331 459Q296 494 276 540.50Q256 587 256 640L256 640Q256 693 276 739.50Q296 786 331 821Q366 856 412.50 876Q459 896 512 896ZM1920 1344L1920 1344Q1920 1399 1906 1455L1906 1455L2043 1511L1995 1630L1857 1573Q1798 1671 1701 1729L1701 1729L1758 1866L1639 1915L1583 1778Q1527 1792 1472 1792L1472 1792Q1417 1792 1361 1778L1361 1778L1305 1915L1186 1866L1243 1729Q1145 1671 1087 1573L1087 1573L949 1630L901 1511L1038 1455Q1024 1399 1024 1344L1024 1344Q1024 1289 1038 1233L1038 1233L901 1177L949 1058L1087 1115Q1145 1018 1243 959L1243 959L1186 821L1305 773L1361 910Q1417 896 1472 896L1472 896Q1527 896 1583 910L1583 910L1639 773L1758 821L1701 959Q1798 1018 1857 1115L1857 1115L1995 1058L2043 1177L1906 1233Q1920 1289 1920 1344ZM1472 1664L1472 1664Q1538 1664 1596 1639Q1654 1614 1697.50 1570.50Q1741 1527 1766.50 1468.50Q1792 1410 1792 1344L1792 1344Q1792 1278 1766.50 1220Q1741 1162 1697.50 1118.50Q1654 1075 1596 1049.50Q1538 1024 1472 1024L1472 1024Q1406 1024 1347.50 1049.50Q1289 1075 1245.50 1118.50Q1202 1162 1177 1220Q1152 1278 1152 1344L1152 1344Q1152 1410 1177 1468.50Q1202 1527 1245.50 1570.50Q1289 1614 1347.50 1639Q1406 1664 1472 1664Z"
         }
      }
   ]
}

var Quantity = {
   name: "Quantity",
   vendor: "UiFabric",
   unicode: 59896,
   value: "",
   charCode: "E9F8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 761L1472 600L2047 888L2047 1670L1472 1958L896 1672L896 1351L576 1510L0 1224L1 440L576 152L1151 440L1152 761ZM1472 1111L1840 927L1472 744L1104 927L1472 1111ZM576 663L944 479L576 296L208 479L576 663ZM512 774L129 583L128 1144L512 1335L512 774ZM640 774L640 1335L897 1208L897 888L1024 825L1023 583L640 774ZM1408 1222L1025 1031L1024 1592L1408 1783L1408 1222ZM1536 1222L1536 1783L1919 1591L1919 1031L1536 1222Z"
         }
      }
   ]
}

var ReportDocument = {
   name: "ReportDocument",
   vendor: "UiFabric",
   unicode: 59897,
   value: "",
   charCode: "E9F9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L256 2048L256 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM384 1920L1664 1920L1664 640L1152 640L1152 128L384 128L384 1920ZM896 1792L896 1408L1152 1408L1152 1792L896 1792ZM512 1792L512 1152L768 1152L768 1792L512 1792ZM1280 1792L1280 896L1536 896L1536 1792L1280 1792Z"
         }
      }
   ]
}

var StackColumnChart = {
   name: "StackColumnChart",
   vendor: "UiFabric",
   unicode: 59900,
   value: "",
   charCode: "E9FC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 129L256 1792L1920 1792L1920 1920L128 1920L128 129L256 129ZM1408 256L1792 256L1792 1664L1408 1664L1408 256ZM1536 768L1536 1536L1664 1536L1664 768L1536 768ZM1536 640L1664 640L1664 384L1536 384L1536 640ZM896 256L1280 256L1280 1664L896 1664L896 256ZM1024 1536L1152 1536L1152 1280L1024 1280L1024 1536ZM1024 1152L1152 1152L1152 384L1024 384L1024 1152ZM384 256L768 256L768 1664L384 1664L384 256ZM512 1536L640 1536L640 1024L512 1024L512 1536ZM512 896L640 896L640 384L512 384L512 896Z"
         }
      }
   ]
}

var SnowShowerDay = {
   name: "SnowShowerDay",
   vendor: "UiFabric",
   unicode: 59901,
   value: "",
   charCode: "E9FD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1478 2024 1541.50Q2000 1605 1957 1655.50Q1914 1706 1855.50 1740.50Q1797 1775 1728 1787L1728 1787L1728 1656Q1770 1645 1805.50 1621.50Q1841 1598 1866.50 1565Q1892 1532 1906 1492Q1920 1452 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1392 269.50 1436.50Q283 1481 308.50 1519Q334 1557 369 1587.50Q404 1618 448 1637L448 1637L448 1773Q377 1752 318 1710Q259 1668 217 1611.50Q175 1555 151.50 1486.50Q128 1418 128 1344L128 1344Q128 1277 147 1214.50Q166 1152 201 1098.50Q236 1045 285.50 1003Q335 961 396 934L396 934Q384 885 384 832L384 832Q384 739 419 657.50Q454 576 515 515Q576 454 657.50 419Q739 384 832 384L832 384Q896 384 957 402Q1018 420 1070.50 453.50Q1123 487 1165.50 534.50Q1208 582 1235 640L1235 640Q1325 643 1407.50 673.50Q1490 704 1559.50 756Q1629 808 1681 879.50Q1733 951 1761 1036ZM723 921L723 921Q784 818 881 748Q978 678 1095 653L1095 653Q1051 587 981 549.50Q911 512 832 512L832 512Q766 512 707.50 537.50Q649 563 605.50 606.50Q562 650 537 708Q512 766 512 832L512 832Q512 849 513.50 865.50Q515 882 520 899L520 899Q548 896 576 896L576 896Q650 896 723 921ZM256 768L256 896L0 896L0 768L256 768ZM470 379L379 470L198 289L289 198L470 379ZM896 0L896 256L768 256L768 0L896 0ZM1466 289L1285 470L1194 379L1375 198L1466 289ZM960 1792L1030 1833Q1062 1852 1062 1888L1062 1888Q1062 1915 1043 1933.50Q1024 1952 998 1952L998 1952Q986 1952 972 1946.50Q958 1941 944.50 1933Q931 1925 918.50 1917Q906 1909 896 1903L896 1903Q896 1922 897 1947Q898 1972 893.50 1994.50Q889 2017 875.50 2032.50Q862 2048 832 2048L832 2048Q802 2048 788 2032.50Q774 2017 769.50 1994.50Q765 1972 766.50 1947Q768 1922 768 1903L768 1903Q758 1909 745.50 1917Q733 1925 719.50 1933Q706 1941 692 1946.50Q678 1952 666 1952L666 1952Q640 1952 621 1933.50Q602 1915 602 1888L602 1888Q602 1852 634 1833L634 1833L704 1792L634 1751Q602 1732 602 1696L602 1696Q602 1670 620.50 1651Q639 1632 665 1632L665 1632Q678 1632 692 1637.50Q706 1643 719.50 1651Q733 1659 745.50 1667Q758 1675 768 1681L768 1681Q768 1662 766.50 1637Q765 1612 769.50 1589.50Q774 1567 788 1551.50Q802 1536 832 1536L832 1536Q862 1536 875.50 1551.50Q889 1567 893.50 1589.50Q898 1612 897 1637Q896 1662 896 1681L896 1681Q906 1675 918.50 1667Q931 1659 944.50 1651Q958 1643 972 1637.50Q986 1632 999 1632L999 1632Q1025 1632 1043.50 1651Q1062 1670 1062 1696L1062 1696Q1062 1732 1030 1751L1030 1751L960 1792ZM1511 1504L1511 1504Q1537 1504 1555.50 1523Q1574 1542 1574 1568L1574 1568Q1574 1604 1542 1623L1542 1623L1472 1664L1542 1705Q1574 1724 1574 1760L1574 1760Q1574 1787 1555 1805.50Q1536 1824 1510 1824L1510 1824Q1498 1824 1484 1818.50Q1470 1813 1456.50 1805Q1443 1797 1430.50 1789Q1418 1781 1408 1775L1408 1775Q1408 1794 1409 1819Q1410 1844 1405.50 1866.50Q1401 1889 1387.50 1904.50Q1374 1920 1344 1920L1344 1920Q1314 1920 1300 1904.50Q1286 1889 1281.50 1866.50Q1277 1844 1278.50 1819Q1280 1794 1280 1775L1280 1775Q1270 1781 1257.50 1789Q1245 1797 1231.50 1805Q1218 1813 1204 1818.50Q1190 1824 1178 1824L1178 1824Q1152 1824 1133 1805.50Q1114 1787 1114 1760L1114 1760Q1114 1724 1146 1705L1146 1705L1216 1664L1146 1623Q1114 1604 1114 1568L1114 1568Q1114 1542 1132.50 1523Q1151 1504 1177 1504L1177 1504Q1190 1504 1204 1509.50Q1218 1515 1231.50 1523Q1245 1531 1257.50 1539Q1270 1547 1280 1553L1280 1553Q1280 1534 1278.50 1509Q1277 1484 1281.50 1461.50Q1286 1439 1300 1423.50Q1314 1408 1344 1408L1344 1408Q1374 1408 1387.50 1423.50Q1401 1439 1405.50 1461.50Q1410 1484 1409 1509Q1408 1534 1408 1553L1408 1553Q1418 1547 1430.50 1539Q1443 1531 1456.50 1523Q1470 1515 1484 1509.50Q1498 1504 1511 1504Z"
         }
      }
   ]
}

var HailDay = {
   name: "HailDay",
   vendor: "UiFabric",
   unicode: 59904,
   value: "",
   charCode: "EA00",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 768L256 896L0 896L0 768L256 768ZM470 379L379 470L198 289L289 198L470 379ZM896 0L896 256L768 256L768 0L896 0ZM1466 289L1285 470L1194 379L1375 198L1466 289ZM1280 1296L1280 1296Q1303 1296 1323.50 1305Q1344 1314 1359 1329Q1374 1344 1383 1364.50Q1392 1385 1392 1408L1392 1408Q1392 1431 1383 1451.50Q1374 1472 1359 1487Q1344 1502 1323.50 1511Q1303 1520 1280 1520L1280 1520Q1257 1520 1236.50 1511Q1216 1502 1201 1487Q1186 1472 1177 1451.50Q1168 1431 1168 1408L1168 1408Q1168 1385 1177 1364.50Q1186 1344 1201 1329Q1216 1314 1236.50 1305Q1257 1296 1280 1296ZM1280 1680L1280 1680Q1303 1680 1323.50 1689Q1344 1698 1359 1713Q1374 1728 1383 1748.50Q1392 1769 1392 1792L1392 1792Q1392 1815 1383 1835.50Q1374 1856 1359 1871Q1344 1886 1323.50 1895Q1303 1904 1280 1904L1280 1904Q1257 1904 1236.50 1895Q1216 1886 1201 1871Q1186 1856 1177 1835.50Q1168 1815 1168 1792L1168 1792Q1168 1769 1177 1748.50Q1186 1728 1201 1713Q1216 1698 1236.50 1689Q1257 1680 1280 1680ZM896 1424L896 1424Q919 1424 939.50 1433Q960 1442 975 1457Q990 1472 999 1492.50Q1008 1513 1008 1536L1008 1536Q1008 1559 999 1579.50Q990 1600 975 1615Q960 1630 939.50 1639Q919 1648 896 1648L896 1648Q873 1648 852.50 1639Q832 1630 817 1615Q802 1600 793 1579.50Q784 1559 784 1536L784 1536Q784 1513 793 1492.50Q802 1472 817 1457Q832 1442 852.50 1433Q873 1424 896 1424ZM896 1808L896 1808Q919 1808 939.50 1817Q960 1826 975 1841Q990 1856 999 1876.50Q1008 1897 1008 1920L1008 1920Q1008 1943 999 1963.50Q990 1984 975 1999Q960 2014 939.50 2023Q919 2032 896 2032L896 2032Q873 2032 852.50 2023Q832 2014 817 1999Q802 1984 793 1963.50Q784 1943 784 1920L784 1920Q784 1897 793 1876.50Q802 1856 817 1841Q832 1826 852.50 1817Q873 1808 896 1808ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1536 1792L1536 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L640 1664L640 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1278 147 1215.50Q166 1153 201 1099.50Q236 1046 285.50 1003.50Q335 961 396 934L396 934Q384 885 384 832L384 832Q384 739 419.50 657.50Q455 576 515.50 515.50Q576 455 657.50 419.50Q739 384 832 384L832 384Q897 384 957.50 402Q1018 420 1070.50 453.50Q1123 487 1165 534.50Q1207 582 1235 640L1235 640Q1325 643 1408 673.50Q1491 704 1560 756Q1629 808 1681 879.50Q1733 951 1761 1036ZM723 921L723 921Q784 818 881.50 748Q979 678 1096 653L1096 653Q1051 587 981.50 549.50Q912 512 832 512L832 512Q766 512 707.50 537.50Q649 563 605.50 606.50Q562 650 537 708Q512 766 512 832L512 832Q512 864 520 899L520 899Q548 896 576 896L576 896Q650 896 723 921Z"
         }
      }
   ]
}

var WorkFlow = {
   name: "WorkFlow",
   vendor: "UiFabric",
   unicode: 59905,
   value: "",
   charCode: "EA01",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 512L640 512L640 215Q508 278 404 379Q300 480 232 609L232 609L113 560Q183 423 289.50 313Q396 203 530 128L530 128L256 128L256 0L768 0L768 512ZM1935 560L1816 609Q1753 488 1656.50 391.50Q1560 295 1439 232L1439 232L1488 114Q1632 188 1746.50 302Q1861 416 1935 560L1935 560ZM128 1024L128 1024Q128 1092 138 1159Q148 1226 169 1291L169 1291L51 1340Q0 1187 0 1024L0 1024Q0 861 51 708L51 708L170 757Q150 822 139 889Q128 956 128 1024ZM112 1488L231 1439Q294 1560 391 1657Q488 1754 609 1817L609 1817L560 1936Q416 1861 301.50 1746.50Q187 1632 112 1488L112 1488ZM1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829ZM2048 1024L1920 1024Q1920 956 1909 889Q1898 822 1878 757L1878 757L1997 708Q2048 861 2048 1024L2048 1024ZM707 1997L757 1879Q822 1900 889 1910Q956 1920 1024 1920L1024 1920L1024 2048Q860 2048 707 1997L707 1997Z"
         }
      }
   ]
}

var LightSnow = {
   name: "LightSnow",
   vendor: "UiFabric",
   unicode: 59906,
   value: "",
   charCode: "EA02",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1536 1792L1536 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L640 1664L640 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM1216 1728L1342 1801Q1356 1809 1365 1824Q1374 1839 1374 1856L1374 1856Q1374 1882 1355 1901Q1336 1920 1310 1920L1310 1920Q1293 1920 1278 1911L1278 1911L1152 1839L1152 1984Q1152 2010 1133 2029Q1114 2048 1088 2048L1088 2048Q1062 2048 1043 2029Q1024 2010 1024 1984L1024 1984L1024 1839L898 1911Q883 1920 866 1920L866 1920Q840 1920 821 1901Q802 1882 802 1856L802 1856Q802 1839 811 1824Q820 1809 834 1801L834 1801L960 1728L834 1655Q820 1647 811 1632Q802 1617 802 1600L802 1600Q802 1574 821 1555Q840 1536 866 1536L866 1536Q883 1536 898 1545L898 1545L1024 1617L1024 1472Q1024 1446 1043 1427Q1062 1408 1088 1408L1088 1408Q1114 1408 1133 1427Q1152 1446 1152 1472L1152 1472L1152 1617L1278 1545Q1293 1536 1310 1536L1310 1536Q1336 1536 1355 1555Q1374 1574 1374 1600L1374 1600Q1374 1617 1365 1632Q1356 1647 1342 1655L1342 1655L1216 1728Z"
         }
      }
   ]
}

var HourGlass = {
   name: "HourGlass",
   vendor: "UiFabric",
   unicode: 59907,
   value: "",
   charCode: "EA03",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 256L1664 256Q1664 362 1633.50 462.50Q1603 563 1543 651L1543 651Q1512 696 1478 733Q1444 770 1405.50 800.50Q1367 831 1324 857Q1281 883 1232 906L1232 906Q1195 923 1173.50 952.50Q1152 982 1152 1024L1152 1024Q1152 1066 1173.50 1095.50Q1195 1125 1232 1142L1232 1142Q1281 1165 1324 1191Q1367 1217 1405.50 1247.50Q1444 1278 1478 1315Q1512 1352 1543 1397L1543 1397Q1603 1485 1633.50 1585.50Q1664 1686 1664 1792L1664 1792L1792 1792L1792 1920L128 1920L128 1792L256 1792Q256 1686 286.50 1585.50Q317 1485 377 1397L377 1397Q409 1350 443 1313.50Q477 1277 514.50 1247Q552 1217 595 1192Q638 1167 688 1143L688 1143Q724 1126 746 1096Q768 1066 768 1024L768 1024Q768 982 746.50 952.50Q725 923 688 906L688 906Q639 883 596 857Q553 831 514.50 800.50Q476 770 442 733Q408 696 377 651L377 651Q317 563 286.50 462.50Q256 362 256 256L256 256L128 256L128 128L1792 128L1792 256ZM1024 1024L1024 1024Q1024 942 1067 882Q1110 822 1182 787L1182 787Q1211 773 1238 759.50Q1265 746 1291 727L1291 727Q1349 687 1394.50 634.50Q1440 582 1471.50 521.50Q1503 461 1519.50 393.50Q1536 326 1536 256L1536 256L384 256Q384 326 400.50 393.50Q417 461 448.50 521.50Q480 582 525.50 634.50Q571 687 629 727L629 727Q655 746 682 759.50Q709 773 738 787L738 787Q810 822 853 882Q896 942 896 1024L896 1024Q896 1106 853 1166Q810 1226 738 1261L738 1261Q709 1275 682 1288.50Q655 1302 629 1321L629 1321Q571 1361 525.50 1413.50Q480 1466 448.50 1526.50Q417 1587 400.50 1654.50Q384 1722 384 1792L384 1792L1536 1792Q1536 1722 1519.50 1654.50Q1503 1587 1471.50 1526.50Q1440 1466 1394.50 1413.50Q1349 1361 1291 1321L1291 1321Q1265 1302 1238 1288.50Q1211 1275 1182 1261L1182 1261Q1110 1226 1067 1166Q1024 1106 1024 1024Z"
         }
      }
   ]
}

var TimeSheet = {
   name: "TimeSheet",
   vendor: "UiFabric",
   unicode: 59909,
   value: "",
   charCode: "EA05",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 256L1920 256L1920 1920L128 1920L128 256L384 256L384 384L256 384L256 1792L1792 1792L1792 384L1664 384L1664 256ZM1536 0L1536 640L512 640L512 0L1536 0ZM1408 512L1408 128L640 128L640 512L1408 512ZM1024 1024L1024 1152L1152 1152L1152 1280L896 1280L896 1024L1024 1024ZM576 1216L576 1216Q576 1123 611 1041.50Q646 960 707 899Q768 838 849.50 803Q931 768 1024 768L1024 768Q1117 768 1198.50 803Q1280 838 1341 899Q1402 960 1437 1041.50Q1472 1123 1472 1216L1472 1216Q1472 1309 1437 1390.50Q1402 1472 1341 1533Q1280 1594 1198.50 1629Q1117 1664 1024 1664L1024 1664Q931 1664 849.50 1629Q768 1594 707 1533Q646 1472 611 1390.50Q576 1309 576 1216ZM1344 1216L1344 1216Q1344 1150 1318.50 1092Q1293 1034 1249.50 990.50Q1206 947 1148 921.50Q1090 896 1024 896L1024 896Q958 896 899.50 921.50Q841 947 797.50 990.50Q754 1034 729 1092Q704 1150 704 1216L704 1216Q704 1282 729 1340.50Q754 1399 797.50 1442.50Q841 1486 899.50 1511Q958 1536 1024 1536L1024 1536Q1090 1536 1148 1511Q1206 1486 1249.50 1442.50Q1293 1399 1318.50 1340.50Q1344 1282 1344 1216Z"
         }
      }
   ]
}

var RainShowersNight = {
   name: "RainShowersNight",
   vendor: "UiFabric",
   unicode: 59919,
   value: "",
   charCode: "EA0F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1536L1042 1827Q1056 1857 1056 1888L1056 1888Q1056 1921 1043.50 1950Q1031 1979 1009 2001Q987 2023 958 2035.50Q929 2048 896 2048L896 2048Q863 2048 834 2035.50Q805 2023 783 2001Q761 1979 748.50 1950Q736 1921 736 1888L736 1888Q736 1857 750 1827L750 1827L896 1536ZM1280 1280L1426 1571Q1440 1601 1440 1632L1440 1632Q1440 1665 1427.50 1694Q1415 1723 1393 1745Q1371 1767 1342 1779.50Q1313 1792 1280 1792L1280 1792Q1247 1792 1218 1779.50Q1189 1767 1167 1745Q1145 1723 1132.50 1694Q1120 1665 1120 1632L1120 1632Q1120 1601 1134 1571L1134 1571L1280 1280ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1556 1792Q1573 1763 1583 1730.50Q1593 1698 1597 1664L1597 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508.50 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L672 1664L608 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1267 153.50 1195Q179 1123 227 1063L227 1063Q146 1009 90.50 929Q35 849 14 754L14 754Q72 768 128 768L128 768Q234 768 327.50 728Q421 688 490.50 618.50Q560 549 600 455.50Q640 362 640 256L640 256Q640 227 636 198.50Q632 170 626 142L626 142Q713 162 786 209Q859 256 912 322Q965 388 994.50 469.50Q1024 551 1024 640L1024 640Q1024 648 1024 657Q1024 666 1023 674L1023 674Q1070 657 1118 648.50Q1166 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM324 974L324 974Q380 936 444 916Q508 896 576 896L576 896Q650 896 723 921L723 921Q784 819 880 749L880 749Q888 723 892 695.50Q896 668 896 640L896 640Q896 555 861 479Q826 403 761 348L761 348Q746 453 699 545Q652 637 580.50 708.50Q509 780 417 827Q325 874 220 889L220 889Q242 915 268.50 936Q295 957 324 974Z"
         }
      }
   ]
}

var SnowShowerNight = {
   name: "SnowShowerNight",
   vendor: "UiFabric",
   unicode: 59921,
   value: "",
   charCode: "EA11",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1478 2024 1541.50Q2000 1605 1957 1655.50Q1914 1706 1855.50 1740.50Q1797 1775 1728 1787L1728 1787L1728 1656Q1770 1645 1805.50 1621.50Q1841 1598 1866.50 1565Q1892 1532 1906 1492Q1920 1452 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508 877.50Q1449 826 1374 797Q1299 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1392 269.50 1436.50Q283 1481 308.50 1519Q334 1557 369 1587.50Q404 1618 448 1637L448 1637L448 1773Q377 1752 318 1710Q259 1668 217 1611.50Q175 1555 151.50 1486.50Q128 1418 128 1344L128 1344Q128 1267 153.50 1195.50Q179 1124 227 1064L227 1064Q146 1009 90.50 929.50Q35 850 14 754L14 754Q72 768 128 768L128 768Q234 768 327.50 728Q421 688 490.50 618.50Q560 549 600 455.50Q640 362 640 256L640 256Q640 200 626 142L626 142Q713 162 786 209Q859 256 912 322Q965 388 994.50 469.50Q1024 551 1024 640L1024 640Q1024 648 1023.50 657Q1023 666 1022 674L1022 674Q1069 657 1117.50 648.50Q1166 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM723 921L723 921Q783 820 879 750L879 750Q896 694 896 640L896 640Q896 555 861 479Q826 403 761 348L761 348Q746 453 699 545Q652 637 580.50 708.50Q509 780 417 827Q325 874 220 889L220 889Q262 940 324 974L324 974Q380 936 444 916Q508 896 576 896L576 896Q650 896 723 921ZM960 1792L1030 1833Q1062 1852 1062 1888L1062 1888Q1062 1915 1043 1933.50Q1024 1952 998 1952L998 1952Q986 1952 972 1946.50Q958 1941 944.50 1933Q931 1925 918.50 1917Q906 1909 896 1903L896 1903Q896 1922 897 1947Q898 1972 893.50 1994.50Q889 2017 875.50 2032.50Q862 2048 832 2048L832 2048Q802 2048 788 2032.50Q774 2017 769.50 1994.50Q765 1972 766.50 1947Q768 1922 768 1903L768 1903Q758 1909 745.50 1917Q733 1925 719.50 1933Q706 1941 692 1946.50Q678 1952 666 1952L666 1952Q640 1952 620.50 1933Q601 1914 601 1888L601 1888Q601 1870 610 1856Q619 1842 634 1833L634 1833L704 1792L634 1751Q619 1742 610 1728Q601 1714 601 1696L601 1696Q601 1670 620 1651Q639 1632 665 1632L665 1632Q678 1632 692 1637.50Q706 1643 719.50 1651Q733 1659 745.50 1667Q758 1675 768 1681L768 1681Q768 1662 766.50 1637Q765 1612 769.50 1589.50Q774 1567 788 1551.50Q802 1536 832 1536L832 1536Q862 1536 875.50 1551.50Q889 1567 893.50 1589.50Q898 1612 897 1637Q896 1662 896 1681L896 1681Q906 1675 918.50 1667Q931 1659 944.50 1651Q958 1643 972 1637.50Q986 1632 999 1632L999 1632Q1025 1632 1043.50 1651Q1062 1670 1062 1696L1062 1696Q1062 1732 1030 1751L1030 1751L960 1792ZM1511 1504L1511 1504Q1537 1504 1555.50 1523Q1574 1542 1574 1568L1574 1568Q1574 1604 1542 1623L1542 1623L1472 1664L1542 1705Q1574 1724 1574 1760L1574 1760Q1574 1787 1555 1805.50Q1536 1824 1510 1824L1510 1824Q1498 1824 1484 1818.50Q1470 1813 1456.50 1805Q1443 1797 1430.50 1789Q1418 1781 1408 1775L1408 1775Q1408 1794 1409 1819Q1410 1844 1405.50 1866.50Q1401 1889 1387.50 1904.50Q1374 1920 1344 1920L1344 1920Q1314 1920 1300 1904.50Q1286 1889 1281.50 1866.50Q1277 1844 1278.50 1819Q1280 1794 1280 1775L1280 1775Q1270 1781 1257.50 1789Q1245 1797 1231.50 1805Q1218 1813 1204 1818.50Q1190 1824 1178 1824L1178 1824Q1152 1824 1132.50 1805Q1113 1786 1113 1760L1113 1760Q1113 1742 1122 1728Q1131 1714 1146 1705L1146 1705L1216 1664L1146 1623Q1131 1614 1122 1600Q1113 1586 1113 1568L1113 1568Q1113 1542 1132 1523Q1151 1504 1177 1504L1177 1504Q1190 1504 1204 1509.50Q1218 1515 1231.50 1523Q1245 1531 1257.50 1539Q1270 1547 1280 1553L1280 1553Q1280 1534 1278.50 1509Q1277 1484 1281.50 1461.50Q1286 1439 1300 1423.50Q1314 1408 1344 1408L1344 1408Q1374 1408 1387.50 1423.50Q1401 1439 1405.50 1461.50Q1410 1484 1409 1509Q1408 1534 1408 1553L1408 1553Q1418 1547 1430.50 1539Q1443 1531 1456.50 1523Q1470 1515 1484 1509.50Q1498 1504 1511 1504Z"
         }
      }
   ]
}

var Teamwork = {
   name: "Teamwork",
   vendor: "UiFabric",
   unicode: 59922,
   value: "",
   charCode: "EA12",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1088L1664 1088Q1730 1088 1788.50 1113Q1847 1138 1890.50 1181.50Q1934 1225 1959 1283.50Q1984 1342 1984 1408L1984 1408Q1984 1460 1967.50 1509Q1951 1558 1920 1600L1920 1600L1920 2024L1664 1896L1408 2024L1408 1600Q1377 1558 1360.50 1509Q1344 1460 1344 1408L1344 1408Q1344 1342 1369 1283.50Q1394 1225 1437.50 1181.50Q1481 1138 1539.50 1113Q1598 1088 1664 1088ZM1664 1216L1664 1216Q1624 1216 1589 1231Q1554 1246 1528 1272Q1502 1298 1487 1333Q1472 1368 1472 1408L1472 1408Q1472 1448 1487 1483Q1502 1518 1528 1544Q1554 1570 1589 1585Q1624 1600 1664 1600L1664 1600Q1704 1600 1739 1585Q1774 1570 1800 1544Q1826 1518 1841 1483Q1856 1448 1856 1408L1856 1408Q1856 1368 1841 1333Q1826 1298 1800 1272Q1774 1246 1739 1231Q1704 1216 1664 1216ZM1664 1752L1792 1816L1792 1701Q1732 1728 1664 1728L1664 1728Q1596 1728 1536 1701L1536 1701L1536 1816L1664 1752ZM1664 512L1664 512Q1611 512 1564.50 532Q1518 552 1483 587Q1448 622 1428 668.50Q1408 715 1408 768L1408 768Q1408 860 1366.50 941.50Q1325 1023 1251 1078L1251 1078Q1270 1087 1287.50 1098Q1305 1109 1322 1121L1322 1121L1247 1225Q1198 1190 1141 1171Q1084 1152 1024 1152L1024 1152Q944 1152 874.50 1182Q805 1212 752.50 1264.50Q700 1317 670 1387Q640 1457 640 1536L640 1536L512 1536Q512 1463 532 1394.50Q552 1326 589 1266.50Q626 1207 678.50 1158.50Q731 1110 796 1077L796 1077Q722 1022 681 941Q640 860 640 768L640 768Q640 715 620 668.50Q600 622 565 587Q530 552 483.50 532Q437 512 384 512L384 512Q331 512 284.50 532Q238 552 203 587Q168 622 148 668.50Q128 715 128 768L128 768L0 768Q0 716 14 666.50Q28 617 53.50 573.50Q79 530 115.50 494Q152 458 198 432L198 432Q165 397 146.50 351Q128 305 128 256L128 256Q128 203 148 156.50Q168 110 203 75Q238 40 284.50 20Q331 0 384 0L384 0Q437 0 483.50 20Q530 40 565 75Q600 110 620 156.50Q640 203 640 256L640 256Q640 305 621.50 351Q603 397 570 432L570 432Q652 477 704 556L704 556Q731 516 766 484Q801 452 842 430Q883 408 929.50 396Q976 384 1024 384L1024 384Q1072 384 1118 396Q1164 408 1205.50 430Q1247 452 1282 484Q1317 516 1344 556L1344 556Q1396 477 1478 432L1478 432Q1445 397 1426.50 351Q1408 305 1408 256L1408 256Q1408 203 1428 156.50Q1448 110 1483 75Q1518 40 1564.50 20Q1611 0 1664 0L1664 0Q1717 0 1763.50 20Q1810 40 1845 75Q1880 110 1900 156.50Q1920 203 1920 256L1920 256Q1920 305 1901.50 351Q1883 397 1850 432L1850 432Q1896 458 1932.50 494Q1969 530 1994.50 573.50Q2020 617 2034 666.50Q2048 716 2048 768L2048 768L1920 768Q1920 715 1900 668.50Q1880 622 1845 587Q1810 552 1763.50 532Q1717 512 1664 512ZM1536 256L1536 256Q1536 283 1546 306Q1556 329 1573.50 346.50Q1591 364 1614 374Q1637 384 1664 384L1664 384Q1691 384 1714 374Q1737 364 1754.50 346.50Q1772 329 1782 306Q1792 283 1792 256L1792 256Q1792 229 1782 206Q1772 183 1754.50 165.50Q1737 148 1714 138Q1691 128 1664 128L1664 128Q1637 128 1614 138Q1591 148 1573.50 165.50Q1556 183 1546 206Q1536 229 1536 256ZM256 256L256 256Q256 283 266 306Q276 329 293.50 346.50Q311 364 334 374Q357 384 384 384L384 384Q411 384 434 374Q457 364 474.50 346.50Q492 329 502 306Q512 283 512 256L512 256Q512 229 502 206Q492 183 474.50 165.50Q457 148 434 138Q411 128 384 128L384 128Q357 128 334 138Q311 148 293.50 165.50Q276 183 266 206Q256 229 256 256ZM768 768L768 768Q768 821 788 867.50Q808 914 843 949Q878 984 924.50 1004Q971 1024 1024 1024L1024 1024Q1077 1024 1123.50 1004Q1170 984 1205 949Q1240 914 1260 867.50Q1280 821 1280 768L1280 768Q1280 715 1260 668.50Q1240 622 1205 587Q1170 552 1123.50 532Q1077 512 1024 512L1024 512Q971 512 924.50 532Q878 552 843 587Q808 622 788 668.50Q768 715 768 768Z"
         }
      }
   ]
}

var HailNight = {
   name: "HailNight",
   vendor: "UiFabric",
   unicode: 59923,
   value: "",
   charCode: "EA13",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1296L1280 1296Q1303 1296 1323.50 1305Q1344 1314 1359 1329Q1374 1344 1383 1364.50Q1392 1385 1392 1408L1392 1408Q1392 1431 1383 1451.50Q1374 1472 1359 1487Q1344 1502 1323.50 1511Q1303 1520 1280 1520L1280 1520Q1257 1520 1236.50 1511Q1216 1502 1201 1487Q1186 1472 1177 1451.50Q1168 1431 1168 1408L1168 1408Q1168 1385 1177 1364.50Q1186 1344 1201 1329Q1216 1314 1236.50 1305Q1257 1296 1280 1296ZM1280 1680L1280 1680Q1303 1680 1323.50 1689Q1344 1698 1359 1713Q1374 1728 1383 1748.50Q1392 1769 1392 1792L1392 1792Q1392 1815 1383 1835.50Q1374 1856 1359 1871Q1344 1886 1323.50 1895Q1303 1904 1280 1904L1280 1904Q1257 1904 1236.50 1895Q1216 1886 1201 1871Q1186 1856 1177 1835.50Q1168 1815 1168 1792L1168 1792Q1168 1769 1177 1748.50Q1186 1728 1201 1713Q1216 1698 1236.50 1689Q1257 1680 1280 1680ZM896 1424L896 1424Q919 1424 939.50 1433Q960 1442 975 1457Q990 1472 999 1492.50Q1008 1513 1008 1536L1008 1536Q1008 1559 999 1579.50Q990 1600 975 1615Q960 1630 939.50 1639Q919 1648 896 1648L896 1648Q873 1648 852.50 1639Q832 1630 817 1615Q802 1600 793 1579.50Q784 1559 784 1536L784 1536Q784 1513 793 1492.50Q802 1472 817 1457Q832 1442 852.50 1433Q873 1424 896 1424ZM896 1808L896 1808Q919 1808 939.50 1817Q960 1826 975 1841Q990 1856 999 1876.50Q1008 1897 1008 1920L1008 1920Q1008 1943 999 1963.50Q990 1984 975 1999Q960 2014 939.50 2023Q919 2032 896 2032L896 2032Q873 2032 852.50 2023Q832 2014 817 1999Q802 1984 793 1963.50Q784 1943 784 1920L784 1920Q784 1897 793 1876.50Q802 1856 817 1841Q832 1826 852.50 1817Q873 1808 896 1808ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1536 1792L1536 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508 877.50Q1449 826 1374 797Q1299 768 1216 768L1216 768Q1140 768 1070 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L640 1664L640 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1267 153.50 1195Q179 1123 227 1063L227 1063Q146 1009 90.50 929Q35 849 14 754L14 754Q72 768 128 768L128 768Q234 768 327.50 728Q421 688 490.50 618.50Q560 549 600 455.50Q640 362 640 256L640 256Q640 227 636 198.50Q632 170 626 142L626 142Q713 162 786 209Q859 256 912 322Q965 388 994.50 469.50Q1024 551 1024 640L1024 640Q1024 648 1024 657Q1024 666 1023 674L1023 674Q1115 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM324 974L324 974Q380 936 444 916Q508 896 576 896L576 896Q650 896 723 921L723 921Q784 819 880 749L880 749Q888 723 892 695.50Q896 668 896 640L896 640Q896 555 861 479Q826 403 761 348L761 348Q746 453 699 545Q652 637 580.50 708.50Q509 780 417 827Q325 874 220 889L220 889Q242 915 268.50 936Q295 957 324 974Z"
         }
      }
   ]
}

var PeopleAdd = {
   name: "PeopleAdd",
   vendor: "UiFabric",
   unicode: 59925,
   value: "",
   charCode: "EA15",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 896L1280 896Q1200 896 1130.50 926Q1061 956 1008.50 1008.50Q956 1061 926 1131Q896 1201 896 1280L896 1280Q896 1372 855 1453Q814 1534 740 1589L740 1589Q805 1622 857.50 1670.50Q910 1719 947 1778.50Q984 1838 1004 1906.50Q1024 1975 1024 2048L1024 2048L896 2048Q896 1969 866 1899Q836 1829 783.50 1776.50Q731 1724 661 1694Q591 1664 512 1664L512 1664Q432 1664 362.50 1694Q293 1724 240.50 1776.50Q188 1829 158 1899Q128 1969 128 2048L128 2048L0 2048Q0 1975 20 1906.50Q40 1838 77 1778.50Q114 1719 166.50 1670.50Q219 1622 284 1589L284 1589Q210 1534 169 1453Q128 1372 128 1280L128 1280Q128 1201 158 1131Q188 1061 240.50 1008.50Q293 956 362.50 926Q432 896 512 896L512 896Q604 896 685 937Q766 978 821 1052L821 1052Q859 977 918 918Q977 859 1052 821L1052 821Q978 766 937 685Q896 604 896 512L896 512Q896 433 926 363Q956 293 1008.50 240.50Q1061 188 1130.50 158Q1200 128 1280 128L1280 128Q1359 128 1429 158Q1499 188 1551.50 240.50Q1604 293 1634 363Q1664 433 1664 512L1664 512Q1664 604 1623 685Q1582 766 1508 821L1508 821Q1573 854 1625.50 902.50Q1678 951 1715 1010.50Q1752 1070 1772 1138.50Q1792 1207 1792 1280L1792 1280L1664 1280Q1664 1201 1634 1131Q1604 1061 1551.50 1008.50Q1499 956 1429 926Q1359 896 1280 896ZM1024 512L1024 512Q1024 565 1044 611.50Q1064 658 1099 693Q1134 728 1180.50 748Q1227 768 1280 768L1280 768Q1333 768 1379.50 748Q1426 728 1461 693Q1496 658 1516 611.50Q1536 565 1536 512L1536 512Q1536 459 1516 412.50Q1496 366 1461 331Q1426 296 1379.50 276Q1333 256 1280 256L1280 256Q1227 256 1180.50 276Q1134 296 1099 331Q1064 366 1044 412.50Q1024 459 1024 512ZM512 1536L512 1536Q565 1536 611.50 1516Q658 1496 693 1461Q728 1426 748 1379.50Q768 1333 768 1280L768 1280Q768 1227 748 1180.50Q728 1134 693 1099Q658 1064 611.50 1044Q565 1024 512 1024L512 1024Q459 1024 412.50 1044Q366 1064 331 1099Q296 1134 276 1180.50Q256 1227 256 1280L256 1280Q256 1333 276 1379.50Q296 1426 331 1461Q366 1496 412.50 1516Q459 1536 512 1536ZM2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408L1792 1664L2048 1664Z"
         }
      }
   ]
}

var Glasses = {
   name: "Glasses",
   vendor: "UiFabric",
   unicode: 59926,
   value: "",
   charCode: "EA16",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 512L1280 512Q1296 512 1309 519L1309 519L2048 888L2048 1024Q2022 1024 2003 1043Q1984 1062 1984 1088L1984 1088L1984 1216Q1984 1309 1948.50 1390.50Q1913 1472 1852.50 1532.50Q1792 1593 1710.50 1628.50Q1629 1664 1536 1664L1536 1664Q1443 1664 1361.50 1628.50Q1280 1593 1219.50 1532.50Q1159 1472 1123.50 1390.50Q1088 1309 1088 1216L1088 1216Q1088 1190 1069 1171Q1050 1152 1024 1152L1024 1152Q998 1152 979 1171Q960 1190 960 1216L960 1216Q960 1309 924.50 1390.50Q889 1472 828.50 1532.50Q768 1593 686.50 1628.50Q605 1664 512 1664L512 1664Q419 1664 337.50 1628.50Q256 1593 195.50 1532.50Q135 1472 99.50 1390.50Q64 1309 64 1216L64 1216L64 1088Q64 1062 45 1043Q26 1024 0 1024L0 1024L0 888L739 519Q752 512 768 512L768 512Q794 512 813 531L813 531Q823 541 837.50 553.50Q852 566 865 580Q878 594 887 609Q896 624 896 640L896 640Q896 666 877 685Q858 704 832 704L832 704Q807 704 789.50 687.50Q772 671 755 654L755 654L271 896L768 896Q806 896 833.50 905.50Q861 915 882.50 929Q904 943 921 960Q938 977 953.50 991Q969 1005 986 1014.50Q1003 1024 1024 1024L1024 1024Q1045 1024 1062 1014.50Q1079 1005 1094.50 991Q1110 977 1127 960Q1144 943 1165.50 929Q1187 915 1214.50 905.50Q1242 896 1280 896L1280 896L1777 896L1293 654Q1276 671 1258.50 687.50Q1241 704 1216 704L1216 704Q1190 704 1171 685Q1152 666 1152 640L1152 640Q1152 624 1161 609Q1170 594 1183 580Q1196 566 1210.50 553.50Q1225 541 1235 531L1235 531Q1254 512 1280 512ZM832 1216L832 1152Q832 1126 822 1102.50Q812 1079 794.50 1061.50Q777 1044 753.50 1034Q730 1024 704 1024L704 1024L256 1024Q230 1024 211 1043Q192 1062 192 1088L192 1088L192 1216Q192 1282 217 1340.50Q242 1399 285.50 1442.50Q329 1486 387.50 1511Q446 1536 512 1536L512 1536Q578 1536 636 1511Q694 1486 737.50 1442.50Q781 1399 806.50 1340.50Q832 1282 832 1216L832 1216ZM1536 1536L1536 1536Q1602 1536 1660 1511Q1718 1486 1761.50 1442.50Q1805 1399 1830.50 1340.50Q1856 1282 1856 1216L1856 1216Q1856 1194 1855 1169Q1854 1144 1854 1119Q1854 1094 1856.50 1069.50Q1859 1045 1867 1024L1867 1024L1344 1024Q1318 1024 1294.50 1034Q1271 1044 1253.50 1061.50Q1236 1079 1226 1102.50Q1216 1126 1216 1152L1216 1152L1216 1216Q1216 1282 1241 1340.50Q1266 1399 1309.50 1442.50Q1353 1486 1411.50 1511Q1470 1536 1536 1536Z"
         }
      }
   ]
}

var DateTime2 = {
   name: "DateTime2",
   vendor: "UiFabric",
   unicode: 59927,
   value: "",
   charCode: "EA17",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 128L1792 993Q1852 1034 1899.50 1086.50Q1947 1139 1980 1200.50Q2013 1262 2030.50 1331Q2048 1400 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1381 2048 1296 2020.50Q1211 1993 1139.50 1942.50Q1068 1892 1013.50 1821Q959 1750 929 1664L929 1664L128 1664L128 128L384 128L384 0L512 0L512 128L1408 128L1408 0L1536 0L1536 128L1792 128ZM384 256L256 256L256 512L1664 512L1664 256L1536 256L1536 384L1408 384L1408 256L512 256L512 384L384 384L384 256ZM256 1536L899 1536Q896 1505 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896L1472 896Q1572 896 1664 929L1664 929L1664 640L256 640L256 1536ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1536 1152L1536 1408L1728 1408L1728 1536L1408 1536L1408 1152L1536 1152Z"
         }
      }
   ]
}

var Shield = {
   name: "Shield",
   vendor: "UiFabric",
   unicode: 59928,
   value: "",
   charCode: "EA18",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1011 0 1057 6.50Q1103 13 1146.50 26.50Q1190 40 1232 60.50Q1274 81 1317 108L1317 108Q1389 154 1461 183Q1533 212 1607 228Q1681 244 1759 250Q1837 256 1920 256L1920 256L1920 768Q1920 914 1883.50 1045Q1847 1176 1782.50 1293.50Q1718 1411 1630 1515Q1542 1619 1439 1710.50Q1336 1802 1221.50 1881Q1107 1960 991 2027L991 2027L960 2045L929 2027Q813 1960 698.50 1881Q584 1802 481 1710.50Q378 1619 290 1515Q202 1411 137.50 1293.50Q73 1176 36.50 1045Q0 914 0 768L0 768L0 256Q83 256 161 250Q239 244 313 228Q387 212 459 183Q531 154 603 108L603 108Q688 53 773 26.50Q858 0 960 0ZM1792 768L1792 382Q1643 374 1506.50 334Q1370 294 1244 213L1244 213Q1176 169 1108.50 148.50Q1041 128 960 128L960 128Q879 128 811.50 148.50Q744 169 676 213L676 213Q550 294 413.50 334Q277 374 128 382L128 382L128 768Q128 895 161.50 1012Q195 1129 253 1235Q311 1341 391 1435.50Q471 1530 563 1613Q655 1696 756.50 1767Q858 1838 960 1897L960 1897Q1062 1838 1163.50 1767Q1265 1696 1357 1613Q1449 1530 1529 1435.50Q1609 1341 1667 1235Q1725 1129 1758.50 1012Q1792 895 1792 768L1792 768Z"
         }
      }
   ]
}

var Header1 = {
   name: "Header1",
   vendor: "UiFabric",
   unicode: 59929,
   value: "",
   charCode: "EA19",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1686 384L1792 384L1792 1792L1664 1792L1664 646Q1598 705 1515 736.50Q1432 768 1344 768L1344 768L1344 640Q1398 640 1447.50 624.50Q1497 609 1539 580.50Q1581 552 1614.50 512Q1648 472 1669 423L1669 423L1686 384ZM896 1024L896 384L1024 384L1024 1792L896 1792L896 1152L256 1152L256 1792L128 1792L128 384L256 384L256 1024L896 1024Z"
         }
      }
   ]
}

var PageAdd = {
   name: "PageAdd",
   vendor: "UiFabric",
   unicode: 59930,
   value: "",
   charCode: "EA1A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1408L1664 1664L1920 1664L1920 1792L1664 1792L1664 2048L1536 2048L1536 1792L1280 1792L1280 1664L1536 1664L1536 1408L1664 1408ZM1024 128L384 128L384 1664L1152 1664L1152 1792L256 1792L256 0L1115 0L1664 549L1664 1280L1536 1280L1536 640L1024 640L1024 128ZM1445 512L1152 219L1152 512L1445 512Z"
         }
      }
   ]
}

var NumberedList = {
   name: "NumberedList",
   vendor: "UiFabric",
   unicode: 59932,
   value: "",
   charCode: "EA1C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 384L2048 384L2048 512L512 512L512 384ZM512 1024L512 896L2048 896L2048 1024L512 1024ZM512 1536L512 1408L2048 1408L2048 1536L512 1536ZM135 640L135 349Q121 360 97.50 370.50Q74 381 55 381L55 381L55 312Q86 301 114 288Q142 275 168 255L168 255L217 255L217 640L135 640ZM134 769L134 769Q159 769 181.50 775.50Q204 782 220.50 795.50Q237 809 246.50 829Q256 849 256 876L256 876Q256 907 244 930.50Q232 954 214.50 972.50Q197 991 176 1005.50Q155 1020 137.50 1032.50Q120 1045 108 1057.50Q96 1070 96 1083L96 1083L256 1083L256 1152L5 1152Q5 1129 5.50 1111Q6 1093 15 1072L15 1072Q30 1038 56 1014.50Q82 991 107.50 971Q133 951 152 931Q171 911 171 884L171 884Q171 857 156 846Q141 835 116 835L116 835Q90 835 66.50 846Q43 857 23 874L23 874L23 801Q73 769 134 769ZM170 1467L170 1468Q206 1473 231 1495Q256 1517 256 1556L256 1556Q256 1587 243.50 1609Q231 1631 211 1644.50Q191 1658 164.50 1664.50Q138 1671 111 1671L111 1671Q87 1671 62.50 1667Q38 1663 16 1652L16 1652L16 1579Q35 1593 57.50 1600Q80 1607 104 1607L104 1607Q130 1607 150.50 1596Q171 1585 171 1555L171 1555Q171 1533 158 1522.50Q145 1512 126.50 1507.50Q108 1503 88 1503Q68 1503 54 1503L54 1503L54 1439Q68 1439 86 1439Q104 1439 120.50 1435.50Q137 1432 148.50 1422Q160 1412 160 1391L160 1391Q160 1365 143.50 1355Q127 1345 104 1345L104 1345Q65 1345 30 1369L30 1369L30 1301Q52 1290 75.50 1285.50Q99 1281 123 1281L123 1281Q145 1281 167 1286Q189 1291 206 1302.50Q223 1314 234 1332Q245 1350 245 1375L245 1375Q245 1413 225.50 1435.50Q206 1458 170 1467L170 1467Z"
         }
      }
   ]
}

var PowerBILogo = {
   name: "PowerBILogo",
   vendor: "UiFabric",
   unicode: 59934,
   value: "",
   charCode: "EA1E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M288 256L1760 256Q1820 256 1872.50 278.50Q1925 301 1964 340Q2003 379 2025.50 431.50Q2048 484 2048 544L2048 544L2048 1312Q2048 1368 2028 1417Q2008 1466 1973.50 1504Q1939 1542 1892.50 1566.50Q1846 1591 1792 1597L1792 1597L1792 1469Q1819 1463 1842.50 1449Q1866 1435 1883.50 1414Q1901 1393 1910.50 1367Q1920 1341 1920 1312L1920 1312L1920 544Q1920 511 1907.50 482Q1895 453 1873 431Q1851 409 1822 396.50Q1793 384 1760 384L1760 384L288 384Q255 384 226 396.50Q197 409 175 431Q153 453 140.50 482Q128 511 128 544L128 544L128 1312Q128 1345 140.50 1374Q153 1403 175 1425Q197 1447 226 1459.50Q255 1472 288 1472L288 1472L320 1472L320 1600L288 1600Q228 1600 175.50 1577.50Q123 1555 84 1516Q45 1477 22.50 1424.50Q0 1372 0 1312L0 1312L0 544Q0 484 22.50 431.50Q45 379 84 340Q123 301 175.50 278.50Q228 256 288 256L288 256ZM576 1312L576 1312Q603 1312 626 1322Q649 1332 666.50 1349.50Q684 1367 694 1390Q704 1413 704 1440L704 1440L704 1632Q704 1659 694 1682Q684 1705 666.50 1722.50Q649 1740 626 1750Q603 1760 576 1760L576 1760Q549 1760 526 1750Q503 1740 485.50 1722.50Q468 1705 458 1682Q448 1659 448 1632L448 1632L448 1440Q448 1413 458 1390Q468 1367 485.50 1349.50Q503 1332 526 1322Q549 1312 576 1312ZM896 928L896 928Q923 928 946 938Q969 948 986.50 965.50Q1004 983 1014 1006Q1024 1029 1024 1056L1024 1056L1024 1632Q1024 1659 1014 1682Q1004 1705 986.50 1722.50Q969 1740 946 1750Q923 1760 896 1760L896 1760Q869 1760 846 1750Q823 1740 805.50 1722.50Q788 1705 778 1682Q768 1659 768 1632L768 1632L768 1056Q768 1029 778 1006Q788 983 805.50 965.50Q823 948 846 938Q869 928 896 928ZM1216 1056L1216 1056Q1243 1056 1266 1066Q1289 1076 1306.50 1093.50Q1324 1111 1334 1134Q1344 1157 1344 1184L1344 1184L1344 1632Q1344 1659 1334 1682Q1324 1705 1306.50 1722.50Q1289 1740 1266 1750Q1243 1760 1216 1760L1216 1760Q1189 1760 1166 1750Q1143 1740 1125.50 1722.50Q1108 1705 1098 1682Q1088 1659 1088 1632L1088 1632L1088 1184Q1088 1157 1098 1134Q1108 1111 1125.50 1093.50Q1143 1076 1166 1066Q1189 1056 1216 1056ZM1536 672L1536 672Q1563 672 1586 682Q1609 692 1626.50 709.50Q1644 727 1654 750Q1664 773 1664 800L1664 800L1664 1632Q1664 1659 1654 1682Q1644 1705 1626.50 1722.50Q1609 1740 1586 1750Q1563 1760 1536 1760L1536 1760Q1509 1760 1486 1750Q1463 1740 1445.50 1722.50Q1428 1705 1418 1682Q1408 1659 1408 1632L1408 1632L1408 800Q1408 773 1418 750Q1428 727 1445.50 709.50Q1463 692 1486 682Q1509 672 1536 672Z"
         }
      }
   ]
}

var Lamp = {
   name: "Lamp",
   vendor: "UiFabric",
   unicode: 60185,
   value: "",
   charCode: "EB19",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 896L1024 1920L1408 1920L1408 2048L512 2048L512 1920L896 1920L896 896L231 896L530 0L1390 0L1689 896L1280 896L1280 1088Q1280 1114 1261 1133Q1242 1152 1216 1152L1216 1152Q1190 1152 1171 1133Q1152 1114 1152 1088L1152 1088L1152 896L1024 896ZM622 128L409 768L1511 768L1298 128L622 128Z"
         }
      }
   ]
}

var Design = {
   name: "Design",
   vendor: "UiFabric",
   unicode: 60220,
   value: "",
   charCode: "EB3C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1317L1280 128L2048 128L2048 2048L0 2048L0 37L1280 1317ZM128 347L128 1920L1701 1920L128 347ZM1792 1792L1755 1792L1883 1920L1920 1920L1920 256L1408 256L1408 384L1664 384L1664 512L1408 512L1408 640L1664 640L1664 768L1408 768L1408 896L1792 896L1792 1024L1408 1024L1408 1152L1664 1152L1664 1280L1408 1280L1408 1408L1664 1408L1664 1536L1499 1536L1627 1664L1792 1664L1792 1792ZM384 1664L384 1061L987 1664L384 1664ZM677 1536L512 1371L512 1536L677 1536Z"
         }
      }
   ]
}

var Ticket = {
   name: "Ticket",
   vendor: "UiFabric",
   unicode: 60244,
   value: "",
   charCode: "EB54",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L2048 896Q2021 896 1998 906Q1975 916 1957.50 933.50Q1940 951 1930 974Q1920 997 1920 1024L1920 1024Q1920 1051 1930 1074Q1940 1097 1957.50 1114.50Q1975 1132 1998 1142Q2021 1152 2048 1152L2048 1152L2048 1664L0 1664L0 1152Q27 1152 50 1142Q73 1132 90.50 1114.50Q108 1097 118 1074Q128 1051 128 1024L128 1024Q128 997 118 974Q108 951 90.50 933.50Q73 916 50 906Q27 896 0 896L0 896L0 384L2048 384ZM1920 802L1920 512L128 512L128 802Q188 837 222 896Q256 955 256 1024L256 1024Q256 1093 222 1152Q188 1211 128 1246L128 1246L128 1536L1920 1536L1920 1246Q1860 1211 1826 1152Q1792 1093 1792 1024L1792 1024Q1792 955 1826 896Q1860 837 1920 802L1920 802Z"
         }
      }
   ]
}

var WifiWarning4 = {
   name: "WifiWarning4",
   vendor: "UiFabric",
   unicode: 60259,
   value: "",
   charCode: "EB63",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L576 896L1152 2048L0 2048ZM181 1936L971 1936L576 1146L181 1936ZM512 1728L512 1408L640 1408L640 1728L512 1728ZM512 1920L512 1792L640 1792L640 1920L512 1920ZM1728 1536L1728 1536Q1768 1536 1803 1551Q1838 1566 1864 1592Q1890 1618 1905 1653Q1920 1688 1920 1728L1920 1728Q1920 1768 1905 1803Q1890 1838 1864 1864Q1838 1890 1803 1905Q1768 1920 1728 1920L1728 1920Q1688 1920 1653 1905Q1618 1890 1592 1864Q1566 1838 1551 1803Q1536 1768 1536 1728L1536 1728Q1536 1688 1551 1653Q1566 1618 1592 1592Q1618 1566 1653 1551Q1688 1536 1728 1536ZM825 1037L763 913Q872 787 1004 689Q1136 591 1284 523Q1432 455 1592.50 419.50Q1753 384 1920 384L1920 384L1920 512Q1760 512 1606.50 547.50Q1453 583 1313 650Q1173 717 1049 815Q925 913 825 1037L825 1037ZM1022 1429L954 1294Q1034 1171 1140 1073.50Q1246 976 1370.50 908Q1495 840 1634 804Q1773 768 1920 768L1920 768L1920 896Q1779 896 1646.50 933Q1514 970 1398 1039.50Q1282 1109 1185.50 1207.50Q1089 1306 1022 1429L1022 1429ZM1267 1920L1175 1736Q1207 1608 1277.50 1500.50Q1348 1393 1447 1315.50Q1546 1238 1667 1195Q1788 1152 1920 1152L1920 1152L1920 1280Q1832 1280 1750 1303Q1668 1326 1597 1367.50Q1526 1409 1467.50 1467.50Q1409 1526 1367.50 1597Q1326 1668 1303 1750Q1280 1832 1280 1920L1280 1920L1267 1920Z"
         }
      }
   ]
}

var Devices4 = {
   name: "Devices4",
   vendor: "UiFabric",
   unicode: 60262,
   value: "",
   charCode: "EB66",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1664L1792 1664L1792 1920L896 1920L896 1664L640 1664L640 1024Q640 997 650 974Q660 951 677.50 933.50Q695 916 718 906Q741 896 768 896L768 896L896 896L896 512L1536 512L1536 256L384 256L384 896L546 896Q512 956 512 1024L512 1024L347 1024L136 1235Q128 1243 128 1254L128 1254Q128 1265 135.50 1272.50Q143 1280 154 1280L154 1280L512 1280L512 1408L154 1408Q122 1408 94 1396Q66 1384 45 1363Q24 1342 12 1314Q0 1286 0 1254L0 1254Q0 1223 11.50 1194.50Q23 1166 45 1144L45 1144L256 933L256 128L1664 128L1664 512L1792 512L1792 896L1920 896Q1947 896 1970 906Q1993 916 2010.50 933.50Q2028 951 2038 974Q2048 997 2048 1024L2048 1024ZM1024 640L1024 896L1664 896L1664 640L1024 640ZM1664 1792L1664 1536L1024 1536L1024 1792L1664 1792ZM1920 1536L1920 1024L768 1024L768 1536L896 1536L896 1408L1792 1408L1792 1536L1920 1536ZM960 1280L960 1280Q934 1280 915 1261Q896 1242 896 1216L896 1216Q896 1190 915 1171Q934 1152 960 1152L960 1152Q986 1152 1005 1171Q1024 1190 1024 1216L1024 1216Q1024 1242 1005 1261Q986 1280 960 1280Z"
         }
      }
   ]
}

var Door = {
   name: "Door",
   vendor: "UiFabric",
   unicode: 60277,
   value: "",
   charCode: "EB75",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L1664 0L1664 2048L384 2048L384 0ZM1536 1920L1536 128L512 128L512 1920L1536 1920ZM1344 1152L1344 1152Q1318 1152 1299 1133Q1280 1114 1280 1088L1280 1088Q1280 1062 1299 1043Q1318 1024 1344 1024L1344 1024Q1370 1024 1389 1043Q1408 1062 1408 1088L1408 1088Q1408 1114 1389 1133Q1370 1152 1344 1152Z"
         }
      }
   ]
}

var GiftCard = {
   name: "GiftCard",
   vendor: "UiFabric",
   unicode: 60302,
   value: "",
   charCode: "EB8E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M112 256L1936 256Q1959 256 1979.50 265Q2000 274 2015 289Q2030 304 2039 324.50Q2048 345 2048 368L2048 368L2048 1552Q2048 1575 2039 1595.50Q2030 1616 2015 1631Q2000 1646 1979.50 1655Q1959 1664 1936 1664L1936 1664L112 1664Q89 1664 68.50 1655Q48 1646 33 1631Q18 1616 9 1595.50Q0 1575 0 1552L0 1552L0 368Q0 345 9 324.50Q18 304 33 289Q48 274 68.50 265Q89 256 112 256L112 256ZM1920 768L1920 384L640 384L640 523Q673 512 704 512L704 512Q744 512 779 527Q814 542 840 568Q866 594 881 629Q896 664 896 704L896 704Q896 735 885 768L885 768L1920 768ZM384 704L384 704Q384 730 403 749Q422 768 448 768L448 768L512 768L512 704Q512 678 493 659Q474 640 448 640L448 640Q422 640 403 659Q384 678 384 704ZM640 768L704 768Q730 768 749 749Q768 730 768 704L768 704Q768 678 749 659Q730 640 704 640L704 640Q678 640 659 659Q640 678 640 704L640 704L640 768ZM512 384L128 384L128 768L267 768Q256 735 256 704L256 704Q256 664 271 629Q286 594 312 568Q338 542 373 527Q408 512 448 512L448 512Q479 512 512 523L512 523L512 384ZM128 896L128 1536L512 1536L512 987L365 1133L275 1043L421 896L128 896ZM640 1536L1920 1536L1920 896L731 896L877 1043L787 1133L640 987L640 1536Z"
         }
      }
   ]
}

var DoubleBookmark = {
   name: "DoubleBookmark",
   vendor: "UiFabric",
   unicode: 60303,
   value: "",
   charCode: "EB8F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1792 0L1792 1767L1536 1639L1536 2024L896 1704L256 2024L256 256L512 256L512 0ZM896 1560L1408 1816L1408 384L384 384L384 1816L896 1560ZM1536 1496L1664 1560L1664 128L640 128L640 256L1536 256L1536 1496Z"
         }
      }
   ]
}

var StatusErrorFull = {
   name: "StatusErrorFull",
   vendor: "UiFabric",
   unicode: 60304,
   value: "",
   charCode: "EB90",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1479 1366L1137 1024L1479 682L1366 569L1024 911L682 569L569 682L911 1024L569 1366L682 1479L1024 1137L1366 1479L1479 1366Z"
         }
      }
   ]
}

var NUIFace = {
   name: "NUIFace",
   vendor: "UiFabric",
   unicode: 60264,
   value: "",
   charCode: "EB68",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1019 1575L1019 1575Q918 1575 819.50 1549Q721 1523 632.50 1474.50Q544 1426 469 1357Q394 1288 342 1201L342 1201Q325 1175 325 1145L325 1145Q325 1124 333 1105Q341 1086 355.50 1072Q370 1058 388.50 1050Q407 1042 428 1042L428 1042Q456 1042 478 1055Q500 1068 516 1091L516 1091Q610 1227 736.50 1298Q863 1369 1032 1369L1032 1369Q1192 1369 1318.50 1294.50Q1445 1220 1534 1091L1534 1091Q1549 1069 1569.50 1055.50Q1590 1042 1618 1042L1618 1042Q1663 1042 1694 1070Q1725 1098 1725 1145L1725 1145Q1725 1160 1721 1172.50Q1717 1185 1709 1198L1709 1198Q1685 1242 1651.50 1280Q1618 1318 1582 1353L1582 1353Q1467 1462 1322 1518.50Q1177 1575 1019 1575ZM815 579L815 579Q815 612 802 642Q789 672 767 694.50Q745 717 715.50 730Q686 743 652 743L652 743Q618 743 588.50 730Q559 717 537 695Q515 673 502 643.50Q489 614 489 580L489 580Q489 546 501.50 516Q514 486 536 463.50Q558 441 587.50 428Q617 415 651 415L651 415Q685 415 714.50 428Q744 441 766.50 463.50Q789 486 802 515.50Q815 545 815 579ZM1235 579L1235 579Q1235 545 1248 515Q1261 485 1283 463Q1305 441 1335 428Q1365 415 1399 415L1399 415Q1433 415 1462.50 428Q1492 441 1514 463.50Q1536 486 1548.50 515.50Q1561 545 1561 579L1561 579Q1561 613 1548 642.50Q1535 672 1513 694.50Q1491 717 1461.50 730Q1432 743 1398 743L1398 743Q1364 743 1334.50 730Q1305 717 1283 694.50Q1261 672 1248 642.50Q1235 613 1235 579Z"
         }
      }
   ]
}

var AzureLogo = {
   name: "AzureLogo",
   vendor: "UiFabric",
   unicode: 60266,
   value: "",
   charCode: "EB6A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M938 1055L1197 343L2048 1818L467 1818L1435 1647L938 1055ZM521 741L1129 230L470 1644L0 1644L521 741Z"
         }
      }
   ]
}

var BingLogo = {
   name: "BingLogo",
   vendor: "UiFabric",
   unicode: 60267,
   value: "",
   charCode: "EB6B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M877 697L877 697L1728 995L1728 1432L768 1984L384 1769L384 64L768 198L768 1548L1309 1237L1043 1113L877 697Z"
         }
      }
   ]
}

var MSNLogo = {
   name: "MSNLogo",
   vendor: "UiFabric",
   unicode: 60268,
   value: "",
   charCode: "EB6C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1260 698L1260 698Q1260 847 1236.50 991.50Q1213 1136 1166 1279L1166 1279Q1143 1350 1121.50 1419Q1100 1488 1075.50 1553.50Q1051 1619 1021 1680Q991 1741 951 1796Q911 1851 858 1900.50Q805 1950 734 1991L734 1991Q689 2017 640 2032.50Q591 2048 539 2048L539 2048Q483 2048 442 2029.50Q401 2011 374 1978Q347 1945 333.50 1900.50Q320 1856 320 1803L320 1803Q320 1736 346 1664Q372 1592 414 1525Q456 1458 510 1402Q564 1346 620 1311L620 1311Q627 1307 633 1304.50Q639 1302 647 1302L647 1302Q652 1302 669 1308.50Q686 1315 708.50 1325.50Q731 1336 757 1348.50Q783 1361 806.50 1372.50Q830 1384 849 1393.50Q868 1403 877 1407L877 1407Q891 1413 904.50 1416.50Q918 1420 932 1425L932 1425L936 1417Q910 1397 884 1377Q858 1357 833 1335L833 1335Q697 1218 611 1078Q525 938 489 762L489 762Q476 697 466.50 632Q457 567 457 501L457 501Q457 487 457.50 473.50Q458 460 459 446L459 446Q462 399 473 347.50Q484 296 503 246.50Q522 197 549.50 152.50Q577 108 614 74Q651 40 697 20Q743 0 799 0L799 0Q844 0 887 13.50Q930 27 969 50L969 50Q1041 92 1094.50 160Q1148 228 1184 308.50Q1220 389 1238.50 476Q1257 563 1259 642L1259 642Q1260 656 1260 670Q1260 684 1260 698ZM1763 586L1763 586Q1785 586 1799 596Q1813 606 1820.50 621Q1828 636 1831 655Q1834 674 1834 692L1834 692Q1834 773 1802 860.50Q1770 948 1721.50 1033Q1673 1118 1616.50 1195Q1560 1272 1512 1333L1512 1333Q1477 1377 1436 1411.50Q1395 1446 1341 1464L1341 1464L1344 1471L1434 1471Q1424 1539 1411.50 1599.50Q1399 1660 1378 1716.50Q1357 1773 1324.50 1825.50Q1292 1878 1243 1929L1243 1929Q1234 1938 1221 1949Q1208 1960 1193.50 1969.50Q1179 1979 1163.50 1985.50Q1148 1992 1135 1992L1135 1992Q1113 1992 1099 1979.50Q1085 1967 1077.50 1948.50Q1070 1930 1067 1909Q1064 1888 1064 1871L1064 1871Q1064 1836 1078.50 1779Q1093 1722 1116 1653.50Q1139 1585 1167.50 1511.50Q1196 1438 1224 1369.50Q1252 1301 1276.50 1243Q1301 1185 1316 1149L1316 1149Q1361 1043 1413 940.50Q1465 838 1539 750L1539 750Q1568 716 1601.50 684.50Q1635 653 1669 624L1669 624Q1686 610 1713.50 598Q1741 586 1763 586Z"
         }
      }
   ]
}

var OutlookLogoInverse = {
   name: "OutlookLogoInverse",
   vendor: "UiFabric",
   unicode: 60269,
   value: "",
   charCode: "EB6D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M672 1027L672 1027Q672 1066 663 1101.50Q654 1137 635 1165Q616 1193 585 1209.50Q554 1226 511 1226L511 1226Q469 1226 439 1208.50Q409 1191 390 1162.50Q371 1134 362 1098Q353 1062 353 1025L353 1025Q353 987 362 950.50Q371 914 390.50 885.50Q410 857 441 839.50Q472 822 515 822L515 822Q559 822 589 840Q619 858 637.50 887Q656 916 664 952.50Q672 989 672 1027ZM2048 1024L2048 1024L2048 1824Q2048 1864 2020 1892Q1992 1920 1952 1920L1952 1920L608 1920Q568 1920 540 1892Q512 1864 512 1824L512 1824L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L640 512L640 218Q640 180 666 154Q692 128 730 128L730 128L1830 128Q1868 128 1894 154Q1920 180 1920 218L1920 218L1920 256L1920 926L2026 987L2027 987Q2036 993 2042 1003Q2048 1013 2048 1024ZM1792 320L1536 320L1536 576L1792 576L1792 320ZM1792 704L1536 704L1536 960L1792 960L1792 704ZM1796 1088L1536 1088L1536 1244L1796 1088ZM1408 320L1088 320L1088 576L1408 576L1408 320ZM1408 704L1088 704L1088 960L1408 960L1408 704ZM1408 1088L1088 1088L1088 1261L1294 1389L1408 1321L1408 1088ZM960 320L768 320L768 512L939 512Q944 512 949.50 513Q955 514 960 516L960 516L960 320ZM510 1364L510 1364Q587 1364 647 1337.50Q707 1311 748 1264.50Q789 1218 810.50 1155Q832 1092 832 1018L832 1018Q832 947 811 886Q790 825 750 780Q710 735 652 709.50Q594 684 520 684L520 684Q441 684 380 709.50Q319 735 277 781.50Q235 828 213.50 892Q192 956 192 1032L192 1032Q192 1104 214 1165Q236 1226 277 1270Q318 1314 377 1339Q436 1364 510 1364ZM640 1536L640 1792L1697 1792L1024 1372L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L640 1536ZM1416 1465L1920 1781L1920 1163L1416 1465Z"
         }
      }
   ]
}

var OfficeLogo = {
   name: "OfficeLogo",
   vendor: "UiFabric",
   unicode: 60270,
   value: "",
   charCode: "EB6E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 405L1792 405L1792 1643Q1792 1708 1754 1758.50Q1716 1809 1653 1827L1653 1827L1098 1986Q1087 1989 1074.50 1990.50Q1062 1992 1051 1992L1051 1992Q1019 1992 993 1983.50Q967 1975 940 1960L940 1960L577 1755Q557 1744 545.50 1725.50Q534 1707 534 1684L534 1684Q534 1649 558.50 1624.50Q583 1600 618 1600L618 1600L1088 1600L1088 458L735 584Q692 599 666 637Q640 675 640 720L640 720L640 1371Q640 1411 620 1444.50Q600 1478 565 1497L565 1497L398 1588Q375 1600 352 1600L352 1600Q312 1600 284 1572Q256 1544 256 1504L256 1504L256 587Q256 537 282.50 491Q309 445 353 420L353 420L949 81Q969 70 992 64Q1015 58 1038 58L1038 58Q1055 58 1068.50 60.50Q1082 63 1098 68L1098 68L1653 221Q1684 230 1709.50 247.50Q1735 265 1753.50 289.50Q1772 314 1782 343.50Q1792 373 1792 405ZM1664 1643L1664 1643L1664 405Q1664 383 1651 366.50Q1638 350 1617 344L1617 344L1344 269Q1312 260 1280 250.50Q1248 241 1216 233L1216 233L1216 1819L1617 1704Q1638 1698 1651 1681.50Q1664 1665 1664 1643Z"
         }
      }
   ]
}

var SkypeLogo = {
   name: "SkypeLogo",
   vendor: "UiFabric",
   unicode: 60271,
   value: "",
   charCode: "EB6F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1894 1151L1894 1151Q1929 1214 1947.50 1283.50Q1966 1353 1966 1425L1966 1425Q1966 1541 1922 1643Q1878 1745 1802 1820.50Q1726 1896 1624 1940Q1522 1984 1406 1984L1406 1984Q1331 1984 1258.50 1964Q1186 1944 1121 1906L1121 1906Q1095 1909 1068 1911Q1041 1913 1015 1913L1015 1913Q893 1913 779.50 1881.50Q666 1850 567.50 1792.50Q469 1735 387.50 1654.50Q306 1574 248.50 1475.50Q191 1377 159 1263.50Q127 1150 127 1028L127 1028Q127 996 130 963.50Q133 931 138 899L138 899Q102 836 83 765.50Q64 695 64 623L64 623Q64 507 108 405Q152 303 228.50 227.50Q305 152 407 108Q509 64 625 64L625 64Q703 64 778.50 85.50Q854 107 920 148L920 148Q944 146 967.50 144.50Q991 143 1015 143L1015 143Q1137 143 1250.50 174.50Q1364 206 1462.50 263.50Q1561 321 1642.50 401.50Q1724 482 1781.50 580.50Q1839 679 1871 792.50Q1903 906 1903 1028L1903 1028Q1903 1059 1900.50 1089.50Q1898 1120 1894 1151ZM1375 1245L1375 1245Q1375 1181 1353.50 1133Q1332 1085 1296.50 1049Q1261 1013 1215.50 986.50Q1170 960 1122.50 939.50Q1075 919 1029.50 901Q984 883 948.50 864.50Q913 846 891.50 824Q870 802 870 772L870 772Q870 743 884 724Q898 705 920 693.50Q942 682 967.50 677Q993 672 1017 672L1017 672Q1044 672 1066.50 675Q1089 678 1110.50 684Q1132 690 1153.50 698.50Q1175 707 1199 717L1199 717Q1224 727 1246 727L1246 727Q1289 727 1313.50 699Q1338 671 1338 629L1338 629Q1338 596 1321.50 572.50Q1305 549 1278.50 532.50Q1252 516 1218 506Q1184 496 1149.50 491Q1115 486 1082.50 484Q1050 482 1027 482L1027 482Q959 482 889 498.50Q819 515 762 551Q705 587 668.50 643Q632 699 632 778L632 778Q632 841 653.50 888.50Q675 936 710.50 971.50Q746 1007 791.50 1033.50Q837 1060 884.50 1081Q932 1102 977.50 1120.50Q1023 1139 1058.50 1158.50Q1094 1178 1115.50 1201.50Q1137 1225 1137 1256L1137 1256Q1137 1287 1124 1307Q1111 1327 1091 1338Q1071 1349 1045 1353.50Q1019 1358 994 1358L994 1358Q947 1358 912 1346.50Q877 1335 848 1321.50Q819 1308 792 1296.50Q765 1285 735 1285L735 1285Q691 1285 662.50 1310.50Q634 1336 634 1381L634 1381Q634 1417 653 1443.50Q672 1470 702.50 1488.50Q733 1507 772 1518.50Q811 1530 850 1536.50Q889 1543 925.50 1545.50Q962 1548 988 1548L988 1548Q1061 1548 1131 1532.50Q1201 1517 1255 1481.50Q1309 1446 1342 1388Q1375 1330 1375 1245Z"
         }
      }
   ]
}

var EditMirrored = {
   name: "EditMirrored",
   vendor: "UiFabric",
   unicode: 60286,
   value: "",
   charCode: "EB7E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 335L0 335Q0 401 25 463Q50 525 98 573L98 573L1415 1890L2048 2048L1890 1415L573 98Q525 50 463 25Q401 0 335 0L335 0Q266 0 205 26.50Q144 53 98.50 98.50Q53 144 26.50 205Q0 266 0 335ZM640 347L1722 1428Q1616 1463 1539.50 1539.50Q1463 1616 1428 1722L1428 1722L347 640L640 347ZM1790 1543L1872 1872L1543 1790Q1553 1744 1575.50 1703Q1598 1662 1630 1630Q1662 1598 1703 1575.50Q1744 1553 1790 1543L1790 1543ZM549 256L256 549Q231 524 208 502Q185 480 167 455.50Q149 431 138.50 402.50Q128 374 128 336L128 336Q128 293 144.50 255.50Q161 218 189.50 189.50Q218 161 255.50 144.50Q293 128 336 128L336 128Q374 128 402.50 138.50Q431 149 455.50 167Q480 185 502 208Q524 231 549 256L549 256Z"
         }
      }
   ]
}

var Certificate = {
   name: "Certificate",
   vendor: "UiFabric",
   unicode: 60309,
   value: "",
   charCode: "EB95",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1280L896 1280Q896 1362 862.50 1436.50Q829 1511 768 1566L768 1566L768 2024L512 1896L256 2024L256 1566Q195 1511 161.50 1436.50Q128 1362 128 1280L128 1280Q128 1201 158 1131Q188 1061 240.50 1008.50Q293 956 362.50 926Q432 896 512 896L512 896Q591 896 661 926.50Q731 957 783 1009Q835 1061 865.50 1131Q896 1201 896 1280ZM512 1536L512 1536Q565 1536 611.50 1516Q658 1496 693 1461Q728 1426 748 1379.50Q768 1333 768 1280L768 1280Q768 1227 748 1180.50Q728 1134 693 1099Q658 1064 611.50 1044Q565 1024 512 1024L512 1024Q459 1024 412.50 1044Q366 1064 331 1099Q296 1134 276 1180.50Q256 1227 256 1280L256 1280Q256 1333 276 1379.50Q296 1426 331 1461Q366 1496 412.50 1516Q459 1536 512 1536ZM640 1816L640 1642Q579 1664 517 1664L517 1664Q447 1664 384 1642L384 1642L384 1816L512 1752L640 1816ZM1371 0L1920 549L1920 2048L896 2048L896 1920L1792 1920L1792 640L1280 640L1280 128L384 128L384 752Q351 760 318.50 772Q286 784 256 800L256 800L256 0L1371 0ZM1408 512L1701 512L1408 219L1408 512Z"
         }
      }
   ]
}

var FastForward = {
   name: "FastForward",
   vendor: "UiFabric",
   unicode: 60317,
   value: "",
   charCode: "EB9D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1674L1152 379L1958 1024L1152 1674ZM1754 1024L1280 645L1280 1407L1754 1024ZM1062 1024L256 1674L256 379L1062 1024ZM858 1024L384 645L384 1407L858 1024Z"
         }
      }
   ]
}

var Rewind = {
   name: "Rewind",
   vendor: "UiFabric",
   unicode: 60318,
   value: "",
   charCode: "EB9E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 379L896 1674L90 1024L896 379ZM294 1024L768 1407L768 645L294 1024ZM1792 1674L986 1024L1792 379L1792 1674ZM1190 1024L1664 1407L1664 645L1190 1024Z"
         }
      }
   ]
}

var Photo2 = {
   name: "Photo2",
   vendor: "UiFabric",
   unicode: 60319,
   value: "",
   charCode: "EB9F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1792L0 1792L0 256ZM1920 384L128 384L128 1061L576 614L1216 1254L1472 998L1920 1445L1920 384ZM128 1243L128 1664L1445 1664L576 794L128 1243ZM1627 1664L1920 1664L1920 1627L1472 1178L1306 1344L1627 1664ZM1600 768L1600 768Q1574 768 1555 749Q1536 730 1536 704L1536 704Q1536 678 1555 659Q1574 640 1600 640L1600 640Q1626 640 1645 659Q1664 678 1664 704L1664 704Q1664 730 1645 749Q1626 768 1600 768Z"
         }
      }
   ]
}

var OpenSource = {
   name: "OpenSource",
   vendor: "UiFabric",
   unicode: 60354,
   value: "",
   charCode: "EBC2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 704L1792 704Q1792 762 1772.50 814Q1753 866 1718 908Q1683 950 1635 979Q1587 1008 1530 1018L1530 1018Q1519 1075 1490.50 1123Q1462 1171 1420 1206Q1378 1241 1326 1260.50Q1274 1280 1216 1280L1216 1280L832 1280Q800 1280 771 1290Q742 1300 718 1318Q694 1336 676 1361.50Q658 1387 649 1417L649 1417Q703 1430 748.50 1459.50Q794 1489 826.50 1530Q859 1571 877.50 1622Q896 1673 896 1728L896 1728Q896 1794 870.50 1852.50Q845 1911 801.50 1954.50Q758 1998 700 2023Q642 2048 576 2048L576 2048Q510 2048 451.50 2023Q393 1998 349.50 1954.50Q306 1911 281 1852.50Q256 1794 256 1728L256 1728Q256 1671 275 1619Q294 1567 328 1525.50Q362 1484 409 1455Q456 1426 512 1415L512 1415L512 633Q456 622 409 593Q362 564 328 522.50Q294 481 275 429Q256 377 256 320L256 320Q256 254 281 196Q306 138 349.50 94.50Q393 51 451.50 25.50Q510 0 576 0L576 0Q642 0 700 25.50Q758 51 801.50 94.50Q845 138 870.50 196Q896 254 896 320L896 320Q896 377 877 429Q858 481 824 522.50Q790 564 743 593Q696 622 640 633L640 633L640 1218Q682 1186 731 1169Q780 1152 832 1152L832 1152L1216 1152Q1248 1152 1277 1142Q1306 1132 1330 1114Q1354 1096 1372 1070.50Q1390 1045 1399 1015L1399 1015Q1345 1002 1299.50 973Q1254 944 1221.50 902.50Q1189 861 1170.50 810.50Q1152 760 1152 704L1152 704Q1152 638 1177 580Q1202 522 1245.50 478.50Q1289 435 1347.50 409.50Q1406 384 1472 384L1472 384Q1538 384 1596 409.50Q1654 435 1697.50 478.50Q1741 522 1766.50 580Q1792 638 1792 704ZM384 320L384 320Q384 360 399 395Q414 430 440 456Q466 482 501 497Q536 512 576 512L576 512Q616 512 651 497Q686 482 712 456Q738 430 753 395Q768 360 768 320L768 320Q768 280 753 245Q738 210 712 184Q686 158 651 143Q616 128 576 128L576 128Q536 128 501 143Q466 158 440 184Q414 210 399 245Q384 280 384 320ZM768 1728L768 1728Q768 1688 753 1653Q738 1618 712 1592Q686 1566 651 1551Q616 1536 576 1536L576 1536Q536 1536 501 1551Q466 1566 440 1592Q414 1618 399 1653Q384 1688 384 1728L384 1728Q384 1768 399 1803Q414 1838 440 1864Q466 1890 501 1905Q536 1920 576 1920L576 1920Q616 1920 651 1905Q686 1890 712 1864Q738 1838 753 1803Q768 1768 768 1728ZM1472 896L1472 896Q1512 896 1547 881Q1582 866 1608 840Q1634 814 1649 779Q1664 744 1664 704L1664 704Q1664 664 1649 629Q1634 594 1608 568Q1582 542 1547 527Q1512 512 1472 512L1472 512Q1432 512 1397 527Q1362 542 1336 568Q1310 594 1295 629Q1280 664 1280 704L1280 704Q1280 744 1295 779Q1310 814 1336 840Q1362 866 1397 881Q1432 896 1472 896Z"
         }
      }
   ]
}

var WindDirection = {
   name: "WindDirection",
   vendor: "UiFabric",
   unicode: 60390,
   value: "",
   charCode: "EBE6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0L1707 2048L1024 1365L341 2048L1024 0Z"
         }
      }
   ]
}

var Family = {
   name: "Family",
   vendor: "UiFabric",
   unicode: 60378,
   value: "",
   charCode: "EBDA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1790 1717L1790 1717Q1888 1765 1952.50 1852.50Q2017 1940 2033 2048L2033 2048L1923 2048Q1912 1991 1882 1942Q1852 1893 1809 1857.50Q1766 1822 1712 1802Q1658 1782 1600 1782L1600 1782Q1541 1782 1487.50 1802Q1434 1822 1391 1857.50Q1348 1893 1318 1942Q1288 1991 1277 2048L1277 2048L1167 2048Q1183 1940 1247.50 1852.50Q1312 1765 1410 1717L1410 1717Q1353 1672 1321.50 1608Q1290 1544 1290 1472L1290 1472Q1290 1427 1302.50 1384.50Q1315 1342 1338.50 1305.50Q1362 1269 1395 1239.50Q1428 1210 1469 1191L1469 1191Q1442 1152 1407 1121.50Q1372 1091 1331 1069Q1290 1047 1244.50 1035.50Q1199 1024 1152 1024L1152 1024Q1072 1024 999 1055.50Q926 1087 872 1146L872 1146Q896 1211 896 1280L896 1280Q896 1372 855 1453Q814 1534 740 1589L740 1589Q805 1622 857.50 1670.50Q910 1719 947 1778.50Q984 1838 1004 1906.50Q1024 1975 1024 2048L1024 2048L896 2048Q896 1969 866 1899Q836 1829 783.50 1776.50Q731 1724 661 1694Q591 1664 512 1664L512 1664Q432 1664 362.50 1694Q293 1724 240.50 1776.50Q188 1829 158 1899Q128 1969 128 2048L128 2048L0 2048Q0 1975 20 1906.50Q40 1838 77 1778.50Q114 1719 166.50 1670.50Q219 1622 284 1589L284 1589Q210 1534 169 1453Q128 1372 128 1280L128 1280Q128 1201 158 1131Q188 1061 240.50 1008.50Q293 956 362.50 926Q432 896 512 896L512 896Q597 896 673.50 932Q750 968 805 1032L805 1032Q831 1007 861.50 986.50Q892 966 924 949L924 949Q850 894 809 813Q768 732 768 640L768 640Q768 561 798 491Q828 421 880.50 368.50Q933 316 1002.50 286Q1072 256 1152 256L1152 256Q1231 256 1301 286Q1371 316 1423.50 368.50Q1476 421 1506 491Q1536 561 1536 640L1536 640Q1536 732 1495 813Q1454 894 1380 949L1380 949Q1450 986 1506.50 1039Q1563 1092 1601 1162L1601 1162Q1665 1162 1721.50 1186.50Q1778 1211 1820 1253Q1862 1295 1886 1351.50Q1910 1408 1910 1472L1910 1472Q1910 1544 1878.50 1608Q1847 1672 1790 1717ZM512 1536L512 1536Q565 1536 611.50 1516Q658 1496 693 1461Q728 1426 748 1379.50Q768 1333 768 1280L768 1280Q768 1227 748 1180.50Q728 1134 693 1099Q658 1064 611.50 1044Q565 1024 512 1024L512 1024Q459 1024 412.50 1044Q366 1064 331 1099Q296 1134 276 1180.50Q256 1227 256 1280L256 1280Q256 1333 276 1379.50Q296 1426 331 1461Q366 1496 412.50 1516Q459 1536 512 1536ZM896 640L896 640Q896 693 916 739.50Q936 786 971 821Q1006 856 1052.50 876Q1099 896 1152 896L1152 896Q1205 896 1251.50 876Q1298 856 1333 821Q1368 786 1388 739.50Q1408 693 1408 640L1408 640Q1408 587 1388 540.50Q1368 494 1333 459Q1298 424 1251.50 404Q1205 384 1152 384L1152 384Q1099 384 1052.50 404Q1006 424 971 459Q936 494 916 540.50Q896 587 896 640ZM1600 1270L1600 1270Q1558 1270 1521.50 1286Q1485 1302 1457.50 1329.50Q1430 1357 1414 1393.50Q1398 1430 1398 1472L1398 1472Q1398 1514 1414 1550.50Q1430 1587 1457.50 1614.50Q1485 1642 1521.50 1658Q1558 1674 1600 1674L1600 1674Q1642 1674 1678.50 1658Q1715 1642 1742.50 1614.50Q1770 1587 1786 1550.50Q1802 1514 1802 1472L1802 1472Q1802 1430 1786 1393.50Q1770 1357 1742.50 1329.50Q1715 1302 1678.50 1286Q1642 1270 1600 1270Z"
         }
      }
   ]
}

var CloudDownload = {
   name: "CloudDownload",
   vendor: "UiFabric",
   unicode: 60371,
   value: "",
   charCode: "EBD3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1629 769L1629 769Q1717 775 1793.50 812Q1870 849 1926.50 909.50Q1983 970 2015.50 1049Q2048 1128 2048 1216L2048 1216Q2048 1309 2012.50 1390.50Q1977 1472 1916.50 1532.50Q1856 1593 1774.50 1628.50Q1693 1664 1600 1664L1600 1664L1536 1664L1536 1536L1600 1536Q1666 1536 1724.50 1511Q1783 1486 1826.50 1442.50Q1870 1399 1895 1340.50Q1920 1282 1920 1216L1920 1216Q1920 1150 1895 1091.50Q1870 1033 1826.50 989.50Q1783 946 1724.50 921Q1666 896 1600 896L1600 896Q1582 896 1564.50 898Q1547 900 1530 904L1530 904Q1520 820 1481 748.50Q1442 677 1383 624.50Q1324 572 1248 542Q1172 512 1088 512L1088 512Q1018 512 953 533Q888 554 833.50 592Q779 630 737 683.50Q695 737 670 803L670 803Q595 768 512 768L512 768Q432 768 362.50 798Q293 828 240.50 880.50Q188 933 158 1003Q128 1073 128 1152L128 1152Q128 1232 158 1301.50Q188 1371 240.50 1423.50Q293 1476 362.50 1506Q432 1536 512 1536L512 1536L640 1536L640 1664L512 1664Q406 1664 313 1623.50Q220 1583 150.50 1513.50Q81 1444 40.50 1351Q0 1258 0 1152L0 1152Q0 1046 40.50 953Q81 860 150.50 790.50Q220 721 313 680.50Q406 640 512 640L512 640Q558 640 605 649L605 649Q645 588 698 539Q751 490 813 455.50Q875 421 945 402.50Q1015 384 1088 384L1088 384Q1179 384 1263.50 412Q1348 440 1419.50 490.50Q1491 541 1545 612Q1599 683 1629 769ZM1152 1024L1152 1701L1299 1555L1389 1645L1088 1946L787 1645L877 1555L1024 1701L1024 1024L1152 1024Z"
         }
      }
   ]
}

var Movers = {
   name: "Movers",
   vendor: "UiFabric",
   unicode: 60365,
   value: "",
   charCode: "EBCD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM426 980L1024 381L1621 979L1530 1069L1090 629L1090 1664L962 1664L962 624L516 1070L426 980Z"
         }
      }
   ]
}

var RectangularClipping = {
   name: "RectangularClipping",
   vendor: "UiFabric",
   unicode: 62471,
   value: "",
   charCode: "F407",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1408L1920 1408L1920 384L128 384L128 1664L1152 1664L1152 1792L0 1792L0 256ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408Z"
         }
      }
   ]
}

var TabletMode = {
   name: "TabletMode",
   vendor: "UiFabric",
   unicode: 60412,
   value: "",
   charCode: "EBFC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L1920 1035Q1949 1045 1972.50 1063Q1996 1081 2013 1105Q2030 1129 2039 1157.50Q2048 1186 2048 1216L2048 1216L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1362 2048 1263.50 2009Q1165 1970 1088 1901Q1011 1832 961 1738.50Q911 1645 899 1536L899 1536L128 1536Q101 1536 78 1526Q55 1516 37.50 1498.50Q20 1481 10 1458Q0 1435 0 1408L0 1408L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L1792 128Q1819 128 1842 138Q1865 148 1882.50 165.50Q1900 183 1910 206Q1920 229 1920 256L1920 256ZM896 1408L896 1280Q896 1227 916 1180.50Q936 1134 971 1099Q1006 1064 1052.50 1044Q1099 1024 1152 1024L1152 1024L1152 704Q1152 664 1167 629Q1182 594 1208 568Q1234 542 1269 527Q1304 512 1344 512L1344 512Q1384 512 1418.50 527Q1453 542 1479 568Q1505 594 1520 629Q1535 664 1535 704L1535 704Q1535 785 1535.50 864Q1536 943 1536 1024L1536 1024L1792 1024L1792 256L128 256L128 1408L896 1408ZM1920 1472L1920 1216Q1920 1190 1901 1171Q1882 1152 1856 1152L1856 1152L1408 1152L1408 704Q1408 678 1389 659Q1370 640 1344 640L1344 640Q1318 640 1299 659Q1280 678 1280 704L1280 704L1280 1472Q1280 1498 1261 1517Q1242 1536 1216 1536L1216 1536Q1190 1536 1171 1517Q1152 1498 1152 1472L1152 1472L1152 1152Q1125 1152 1102 1162Q1079 1172 1061.50 1189.50Q1044 1207 1034 1230Q1024 1253 1024 1280L1024 1280L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Z"
         }
      }
   ]
}

var ReminderTime = {
   name: "ReminderTime",
   vendor: "UiFabric",
   unicode: 60409,
   value: "",
   charCode: "EBF9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363ZM896 384L1024 384L1024 896L1408 896L1408 1024L896 1024L896 384ZM960 1792L960 1792Q976 1792 992 1791Q1008 1790 1024 1789L1024 1789L1138 1903Q1093 1911 1049 1915.50Q1005 1920 960 1920L960 1920Q828 1920 705.50 1885.50Q583 1851 476 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444Q69 1337 34.50 1214.50Q0 1092 0 960L0 960Q0 828 34.50 705.50Q69 583 131.50 476Q194 369 281.50 281.50Q369 194 476 131.50Q583 69 705.50 34.50Q828 0 960 0L960 0Q1092 0 1214.50 34.50Q1337 69 1444 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 476Q1851 583 1885.50 705.50Q1920 828 1920 960L1920 960Q1920 1010 1914 1061L1914 1061L1746 1230Q1792 1097 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792Z"
         }
      }
   ]
}

var ReminderGroup = {
   name: "ReminderGroup",
   vendor: "UiFabric",
   unicode: 60408,
   value: "",
   charCode: "EBF8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363ZM736 1462L736 1462Q802 1495 855 1543Q908 1591 945.50 1650Q983 1709 1003.50 1778Q1024 1847 1024 1920L1024 1920L896 1920Q896 1841 866 1771Q836 1701 783.50 1648.50Q731 1596 661 1566Q591 1536 512 1536L512 1536Q432 1536 362.50 1566Q293 1596 240.50 1648.50Q188 1701 158 1771Q128 1841 128 1920L128 1920L0 1920Q0 1847 20.50 1778Q41 1709 78.50 1650Q116 1591 169 1543Q222 1495 288 1462L288 1462Q213 1408 170.50 1327Q128 1246 128 1152L128 1152Q128 1073 158 1003Q188 933 240.50 880.50Q293 828 362.50 798Q432 768 512 768L512 768Q606 768 687 810.50Q768 853 822 928L822 928Q860 852 920 792Q980 732 1056 694L1056 694Q981 640 938.50 559Q896 478 896 384L896 384Q896 305 926 235Q956 165 1008.50 112.50Q1061 60 1130.50 30Q1200 0 1280 0L1280 0Q1359 0 1429 30Q1499 60 1551.50 112.50Q1604 165 1634 235Q1664 305 1664 384L1664 384Q1664 478 1621.50 559Q1579 640 1504 694L1504 694Q1570 727 1623 775Q1676 823 1713.50 882Q1751 941 1771.50 1010Q1792 1079 1792 1152L1792 1152L1664 1152Q1664 1073 1634 1003Q1604 933 1551.50 880.50Q1499 828 1429 798Q1359 768 1280 768L1280 768Q1200 768 1130.50 798Q1061 828 1008.50 880.50Q956 933 926 1003Q896 1073 896 1152L896 1152Q896 1246 853.50 1327Q811 1408 736 1462ZM1024 384L1024 384Q1024 437 1044 483.50Q1064 530 1099 565Q1134 600 1180.50 620Q1227 640 1280 640L1280 640Q1333 640 1379.50 620Q1426 600 1461 565Q1496 530 1516 483.50Q1536 437 1536 384L1536 384Q1536 331 1516 284.50Q1496 238 1461 203Q1426 168 1379.50 148Q1333 128 1280 128L1280 128Q1227 128 1180.50 148Q1134 168 1099 203Q1064 238 1044 284.50Q1024 331 1024 384ZM256 1152L256 1152Q256 1205 276 1251.50Q296 1298 331 1333Q366 1368 412.50 1388Q459 1408 512 1408L512 1408Q565 1408 611.50 1388Q658 1368 693 1333Q728 1298 748 1251.50Q768 1205 768 1152L768 1152Q768 1099 748 1052.50Q728 1006 693 971Q658 936 611.50 916Q565 896 512 896L512 896Q459 896 412.50 916Q366 936 331 971Q296 1006 276 1052.50Q256 1099 256 1152Z"
         }
      }
   ]
}

var ReminderPerson = {
   name: "ReminderPerson",
   vendor: "UiFabric",
   unicode: 60407,
   value: "",
   charCode: "EBF7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363ZM1683 1437L1595 1525Q1484 1403 1336 1341.50Q1188 1280 1024 1280L1024 1280Q916 1280 817.50 1307Q719 1334 633.50 1383.50Q548 1433 478.50 1502.50Q409 1572 359.50 1657.50Q310 1743 283 1841.50Q256 1940 256 2048L256 2048L128 2048Q128 1905 169.50 1773Q211 1641 288 1530Q365 1419 474.50 1335Q584 1251 719 1203L719 1203Q641 1161 579 1101Q517 1041 473.50 968Q430 895 407 812Q384 729 384 640L384 640Q384 507 434 390.50Q484 274 571 187Q658 100 774.50 50Q891 0 1024 0L1024 0Q1157 0 1273.50 50Q1390 100 1477 187Q1564 274 1614 390.50Q1664 507 1664 640L1664 640Q1664 729 1640.50 812Q1617 895 1573.50 968Q1530 1041 1468 1101Q1406 1161 1328 1203L1328 1203Q1430 1239 1520 1298.50Q1610 1358 1683 1437L1683 1437ZM512 640L512 640Q512 746 552.50 839Q593 932 662.50 1001.50Q732 1071 825 1111.50Q918 1152 1024 1152L1024 1152Q1130 1152 1223 1111.50Q1316 1071 1385.50 1001.50Q1455 932 1495.50 839Q1536 746 1536 640L1536 640Q1536 534 1495.50 441Q1455 348 1385.50 278.50Q1316 209 1223 168.50Q1130 128 1024 128L1024 128Q918 128 825 168.50Q732 209 662.50 278.50Q593 348 552.50 441Q512 534 512 640Z"
         }
      }
   ]
}

var DeliveryTruck = {
   name: "DeliveryTruck",
   vendor: "UiFabric",
   unicode: 60404,
   value: "",
   charCode: "EBF4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1073L2048 1536L1524 1536Q1514 1565 1496 1588.50Q1478 1612 1454.50 1628.50Q1431 1645 1402.50 1654.50Q1374 1664 1344 1664L1344 1664Q1314 1664 1285.50 1654.50Q1257 1645 1233.50 1628.50Q1210 1612 1192 1588.50Q1174 1565 1164 1536L1164 1536L628 1536Q618 1565 600 1588.50Q582 1612 558.50 1628.50Q535 1645 506.50 1654.50Q478 1664 448 1664L448 1664Q418 1664 389.50 1654.50Q361 1645 337.50 1628.50Q314 1612 296 1588.50Q278 1565 268 1536L268 1536L0 1536L0 384L1408 384L1408 512L1768 512L2048 1073ZM128 512L128 1408L268 1408Q278 1380 296 1356Q314 1332 337.50 1315.50Q361 1299 389.50 1289.50Q418 1280 448 1280L448 1280Q478 1280 506.50 1289.50Q535 1299 558.50 1315.50Q582 1332 600 1356Q618 1380 628 1408L628 1408L1164 1408Q1178 1367 1208.50 1336.50Q1239 1306 1280 1292L1280 1292L1280 512L128 512ZM448 1536L448 1536Q474 1536 493 1517Q512 1498 512 1472L512 1472Q512 1446 493 1427Q474 1408 448 1408L448 1408Q422 1408 403 1427Q384 1446 384 1472L384 1472Q384 1498 403 1517Q422 1536 448 1536ZM1344 1536L1344 1536Q1370 1536 1389 1517Q1408 1498 1408 1472L1408 1472Q1408 1446 1389 1427Q1370 1408 1344 1408L1344 1408Q1318 1408 1299 1427Q1280 1446 1280 1472L1280 1472Q1280 1498 1299 1517Q1318 1536 1344 1536ZM1920 1408L1920 1103L1688 640L1408 640L1408 1292Q1449 1306 1479.50 1336.50Q1510 1367 1524 1408L1524 1408L1920 1408Z"
         }
      }
   ]
}

var JS = {
   name: "JS",
   vendor: "UiFabric",
   unicode: 60400,
   value: "",
   charCode: "EBF0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1801 1801L1801 247L247 247L247 1801L1801 1801ZM1493 1461L1493 1461Q1493 1425 1467.50 1400.50Q1442 1376 1403 1355Q1364 1334 1319.50 1313.50Q1275 1293 1236 1265Q1197 1237 1171.50 1197.50Q1146 1158 1146 1100L1146 1100Q1146 1045 1171 1006Q1196 967 1236 942.50Q1276 918 1324.50 907Q1373 896 1420 896L1420 896Q1439 896 1461.50 897Q1484 898 1506.50 900.50Q1529 903 1550.50 908Q1572 913 1590 922L1590 922L1590 1044Q1555 1018 1513 1008.50Q1471 999 1428 999L1428 999Q1405 999 1378.50 1003Q1352 1007 1329 1018Q1306 1029 1291 1048Q1276 1067 1276 1096L1276 1096Q1276 1122 1286 1140Q1296 1158 1316 1173L1316 1173Q1342 1193 1372.50 1206Q1403 1219 1432 1233L1432 1233Q1466 1249 1500 1271Q1534 1293 1561.50 1320.50Q1589 1348 1606 1382.50Q1623 1417 1623 1459L1623 1459Q1623 1519 1598 1558.50Q1573 1598 1533 1621.50Q1493 1645 1443 1654.50Q1393 1664 1343 1664L1343 1664Q1325 1664 1297.50 1661Q1270 1658 1241.50 1652.50Q1213 1647 1187 1639.50Q1161 1632 1147 1622L1147 1622L1147 1495Q1164 1510 1187.50 1522.50Q1211 1535 1237 1544Q1263 1553 1289.50 1557.50Q1316 1562 1339 1562L1339 1562Q1364 1562 1391.50 1558.50Q1419 1555 1441.50 1544Q1464 1533 1478.50 1513Q1493 1493 1493 1461ZM767 1664L767 1664Q726 1664 687.50 1651.50Q649 1639 617 1615.50Q585 1592 560.50 1559.50Q536 1527 524 1488L524 1488L627 1456Q643 1499 678.50 1527.50Q714 1556 762 1556L762 1556Q800 1556 823.50 1537.50Q847 1519 859.50 1490.50Q872 1462 876.50 1429Q881 1396 881 1366L881 1366L881 908L1004 908L1004 1385Q1004 1441 990 1492Q976 1543 947 1581Q918 1619 873.50 1641.50Q829 1664 767 1664Z"
         }
      }
   ]
}

var CSS = {
   name: "CSS",
   vendor: "UiFabric",
   unicode: 60399,
   value: "",
   charCode: "EBEF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1664L1792 1064L1920 936L1920 1792L0 1792L0 128L1631 128Q1591 154 1558 188.50Q1525 223 1492 256L1492 256L128 256L128 512L1236 512L1108 640L128 640L128 1664L1792 1664ZM1848 256L1848 256Q1890 256 1926 271.50Q1962 287 1989 313.50Q2016 340 2031.50 376Q2047 412 2047 454L2047 454Q2047 487 2039 511.50Q2031 536 2017.50 557Q2004 578 1985.50 597.50Q1967 617 1946 638L1946 638L1818 766L1277 1308Q1271 1356 1249 1397.50Q1227 1439 1193 1469Q1159 1499 1115.50 1516.50Q1072 1534 1024 1534L1024 1534L384 1534L384 1408L640 1408Q667 1408 690 1397.50Q713 1387 730.50 1369Q748 1351 758 1327.50Q768 1304 768 1278L768 1278Q768 1230 785.50 1186.50Q803 1143 833 1109Q863 1075 904.50 1053Q946 1031 994 1025L994 1025L1381 638L1707 313Q1735 285 1771.50 270.50Q1808 256 1848 256ZM861 1406L1024 1406Q1050 1406 1073.50 1396Q1097 1386 1114.50 1368.50Q1132 1351 1142 1327.50Q1152 1304 1152 1278L1152 1278Q1152 1252 1142 1228.50Q1132 1205 1114.50 1187.50Q1097 1170 1073.50 1160Q1050 1150 1024 1150L1024 1150Q998 1150 974.50 1160Q951 1170 933.50 1187.50Q916 1205 906 1228.50Q896 1252 896 1278L896 1278Q896 1347 861 1406L861 1406ZM1247 1156L1362 1041Q1341 1012 1315.50 986Q1290 960 1261 940L1261 940L1146 1055Q1212 1090 1247 1156L1247 1156ZM1454 949L1899 505Q1920 484 1920 454L1920 454Q1920 425 1899 404Q1878 383 1848 383L1848 383Q1817 383 1797 403L1797 403L1352 848Q1410 891 1454 949L1454 949Z"
         }
      }
   ]
}

var F12DevTools = {
   name: "F12DevTools",
   vendor: "UiFabric",
   unicode: 60398,
   value: "",
   charCode: "EBEE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1536L1962 1536L1834 1408L1920 1408L1920 384L128 384L128 1408L640 1408L640 1536L0 1536L0 256ZM768 523L1781 1536L1205 1536Q987 1755 768 1973L768 1973L768 523ZM1152 1408L1472 1408L896 832L896 1664L1152 1408Z"
         }
      }
   ]
}

var BrowserScreenShot = {
   name: "BrowserScreenShot",
   vendor: "UiFabric",
   unicode: 60397,
   value: "",
   charCode: "EBED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1024L1920 1024L1920 640L128 640L128 1664L640 1664L640 1792L0 1792L0 128ZM128 512L1920 512L1920 256L128 256L128 512ZM1627 1024L1755 1152L2048 1152L2048 2048L768 2048L768 1152L1061 1152L1189 1024L1627 1024ZM1920 1920L1920 1280L1701 1280L1573 1152L1243 1152L1115 1280L896 1280L896 1920L1920 1920ZM1408 1280L1408 1280Q1461 1280 1507.50 1300Q1554 1320 1589 1355Q1624 1390 1644 1436.50Q1664 1483 1664 1536L1664 1536Q1664 1589 1644 1635.50Q1624 1682 1589 1717Q1554 1752 1507.50 1772Q1461 1792 1408 1792L1408 1792Q1355 1792 1308.50 1772Q1262 1752 1227 1717Q1192 1682 1172 1635.50Q1152 1589 1152 1536L1152 1536Q1152 1483 1172 1436.50Q1192 1390 1227 1355Q1262 1320 1308.50 1300Q1355 1280 1408 1280ZM1408 1664L1408 1664Q1435 1664 1458 1654Q1481 1644 1498.50 1626.50Q1516 1609 1526 1586Q1536 1563 1536 1536L1536 1536Q1536 1509 1526 1486Q1516 1463 1498.50 1445.50Q1481 1428 1458 1418Q1435 1408 1408 1408L1408 1408Q1381 1408 1358 1418Q1335 1428 1317.50 1445.50Q1300 1463 1290 1486Q1280 1509 1280 1536L1280 1536Q1280 1563 1290 1586Q1300 1609 1317.50 1626.50Q1335 1644 1358 1654Q1381 1664 1408 1664Z"
         }
      }
   ]
}

var SiteScan = {
   name: "SiteScan",
   vendor: "UiFabric",
   unicode: 60396,
   value: "",
   charCode: "EBEC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1159Q2020 1131 1987.50 1108.50Q1955 1086 1920 1069L1920 1069L1920 640L128 640L128 1664L1216 1664L1088 1792L0 1792L0 128ZM128 512L1920 512L1920 256L128 256L128 512ZM1411 1466L1411 1466Q1411 1400 1436 1343Q1461 1286 1504 1243.50Q1547 1201 1604.50 1177Q1662 1153 1728 1153L1728 1153Q1795 1153 1853 1178Q1911 1203 1954 1246.50Q1997 1290 2022 1348Q2047 1406 2047 1473L2047 1473Q2047 1538 2022.50 1595.50Q1998 1653 1956 1696Q1914 1739 1857 1764Q1800 1789 1734 1789L1734 1789Q1686 1789 1640 1775.50Q1594 1762 1553 1737L1553 1737L1352 1938Q1329 1961 1307 1984.50Q1285 2008 1261 2029L1261 2029Q1251 2038 1241.50 2043Q1232 2048 1218 2048L1218 2048Q1192 2048 1172 2028Q1152 2008 1152 1982L1152 1982Q1152 1968 1157 1958.50Q1162 1949 1171 1939L1171 1939Q1192 1915 1215.50 1893Q1239 1871 1262 1848L1262 1848Q1313 1797 1362.50 1747Q1412 1697 1463 1646L1463 1646Q1438 1605 1424.50 1559.50Q1411 1514 1411 1466ZM1539 1478L1539 1478Q1539 1516 1553.50 1549Q1568 1582 1592.50 1607Q1617 1632 1650.50 1646Q1684 1660 1722 1660L1722 1660Q1761 1660 1796.50 1644.50Q1832 1629 1860 1602Q1888 1575 1904.50 1540Q1921 1505 1921 1466L1921 1466Q1921 1430 1905.50 1396.50Q1890 1363 1864 1336.50Q1838 1310 1804 1294.50Q1770 1279 1734 1279L1734 1279Q1695 1279 1659.50 1295.50Q1624 1312 1597.50 1340Q1571 1368 1555 1403.50Q1539 1439 1539 1478Z"
         }
      }
   ]
}

var Bug = {
   name: "Bug",
   vendor: "UiFabric",
   unicode: 60392,
   value: "",
   charCode: "EBE8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1608 897L1608 897Q1673 899 1730 924.50Q1787 950 1829 993Q1871 1036 1895.50 1093.50Q1920 1151 1920 1216L1920 1216L1920 1408L1792 1408L1792 1216Q1792 1184 1781.50 1154.50Q1771 1125 1752.50 1100.50Q1734 1076 1708 1058.50Q1682 1041 1651 1032L1651 1032Q1657 1061 1660.50 1091.50Q1664 1122 1664 1152L1664 1152L1664 1408Q1664 1415 1663 1421Q1662 1427 1661 1434L1661 1434L1667 1428Q1727 1488 1759 1566Q1791 1644 1791 1729L1791 1729Q1791 1814 1759 1891.50Q1727 1969 1667 2029L1667 2029L1577 1939Q1619 1897 1641 1843.50Q1663 1790 1663 1730L1663 1730Q1663 1662 1632 1598L1632 1598Q1601 1698 1541.50 1781Q1482 1864 1402 1923Q1322 1982 1225.50 2015Q1129 2048 1024 2048L1024 2048Q919 2048 822.50 2015Q726 1982 646 1923Q566 1864 506.50 1781Q447 1698 416 1598L416 1598Q385 1662 385 1730L385 1730Q385 1790 407 1843.50Q429 1897 471 1939L471 1939L381 2029Q321 1969 288.50 1891.50Q256 1814 256 1729L256 1729Q256 1644 288.50 1566Q321 1488 381 1428L381 1428L387 1434Q386 1427 385 1421Q384 1415 384 1408L384 1408L384 1152Q384 1122 387.50 1091.50Q391 1061 397 1032L397 1032Q366 1041 340 1058.50Q314 1076 295.50 1100.50Q277 1125 266.50 1154.50Q256 1184 256 1216L256 1216L256 1408L128 1408L128 1216Q128 1151 152.50 1093.50Q177 1036 219 993Q261 950 318 924.50Q375 899 440 897L440 897Q471 827 520 762L520 762Q463 752 414.50 723.50Q366 695 331 653Q296 611 276 558.50Q256 506 256 448L256 448L256 256L384 256L384 448Q384 488 399 523Q414 558 440 584Q466 610 501 625Q536 640 576 640L576 640L640 640L640 643Q687 608 736 584L736 584Q721 552 712.50 517.50Q704 483 704 448L704 448Q704 378 735 313L735 313L595 173L685 83L812 210Q857 171 910.50 149.50Q964 128 1024 128L1024 128Q1084 128 1137.50 149.50Q1191 171 1236 210L1236 210L1363 83L1453 173L1313 313Q1344 378 1344 448L1344 448Q1344 483 1335.50 517.50Q1327 552 1312 584L1312 584Q1338 597 1361.50 611.50Q1385 626 1408 643L1408 643L1408 640L1472 640Q1512 640 1547 625Q1582 610 1608 584Q1634 558 1649 523Q1664 488 1664 448L1664 448L1664 256L1792 256L1792 448Q1792 506 1772 558.50Q1752 611 1717 653Q1682 695 1633.50 723.50Q1585 752 1528 762L1528 762Q1577 827 1608 897ZM1024 256L1024 256Q984 256 949 271Q914 286 888 312Q862 338 847 373Q832 408 832 448L832 448Q832 498 856 538L856 538Q898 527 939.50 520.50Q981 514 1024 514L1024 514Q1067 514 1108.50 520.50Q1150 527 1192 538L1192 538Q1216 498 1216 448L1216 448Q1216 408 1201 373Q1186 338 1160 312Q1134 286 1099 271Q1064 256 1024 256ZM1536 1408L1536 1152Q1536 1048 1495 955Q1454 862 1384.50 792Q1315 722 1222 681Q1129 640 1024 640L1024 640Q919 640 826 681Q733 722 663.50 792Q594 862 553 955Q512 1048 512 1152L512 1152L512 1408Q512 1514 552.50 1607Q593 1700 662.50 1769.50Q732 1839 825 1879.50Q918 1920 1024 1920L1024 1920Q1130 1920 1223 1879.50Q1316 1839 1385.50 1769.50Q1455 1700 1495.50 1607Q1536 1514 1536 1408L1536 1408Z"
         }
      }
   ]
}

var StopSolid = {
   name: "StopSolid",
   vendor: "UiFabric",
   unicode: 61077,
   value: "",
   charCode: "EE95",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L128 128L1920 128L1920 1920L128 1920L128 128Z"
         }
      }
   ]
}

var Umbrella = {
   name: "Umbrella",
   vendor: "UiFabric",
   unicode: 60420,
   value: "",
   charCode: "EC04",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 128L960 128Q1143 128 1311.50 194.50Q1480 261 1614 386L1614 386Q1751 514 1825 671.50Q1899 829 1916 1015L1916 1015Q1916 1017 1916.50 1018.50Q1917 1020 1917 1022L1917 1022Q1917 1034 1912.50 1045.50Q1908 1057 1899.50 1066Q1891 1075 1880 1080.50Q1869 1086 1857 1086L1857 1086Q1851 1086 1842.50 1084.50Q1834 1083 1828 1081L1828 1081Q1820 1077 1814 1072.50Q1808 1068 1802 1061L1802 1061Q1761 1013 1713 986.50Q1665 960 1600 960L1600 960Q1539 960 1485 987.50Q1431 1015 1395 1064L1395 1064Q1386 1076 1379.50 1088.50Q1373 1101 1366 1114L1366 1114Q1357 1131 1342 1141.50Q1327 1152 1307 1152L1307 1152L1253 1152Q1233 1152 1218 1141.50Q1203 1131 1194 1114L1194 1114Q1179 1086 1162.50 1063Q1146 1040 1126 1021.50Q1106 1003 1081 990Q1056 977 1024 968L1024 968L1024 1664Q1024 1716 1003.50 1762.50Q983 1809 948 1844Q913 1879 866.50 1899.50Q820 1920 768 1920L768 1920Q716 1920 669.50 1899.50Q623 1879 588 1844Q553 1809 532.50 1762.50Q512 1716 512 1664L512 1664Q512 1646 511.50 1623.50Q511 1601 516 1581.50Q521 1562 534.50 1549Q548 1536 576 1536L576 1536Q604 1536 617.50 1549Q631 1562 636 1581.50Q641 1601 640.50 1623.50Q640 1646 640 1664L640 1664Q640 1690 650.50 1713Q661 1736 678.50 1753.50Q696 1771 719 1781.50Q742 1792 768 1792L768 1792Q793 1792 816.50 1781.50Q840 1771 857.50 1753.50Q875 1736 885.50 1713Q896 1690 896 1664L896 1664L896 968Q864 977 839 990Q814 1003 794 1021.50Q774 1040 757.50 1063Q741 1086 726 1114L726 1114Q717 1131 702 1141.50Q687 1152 667 1152L667 1152L613 1152Q593 1152 578 1141.50Q563 1131 554 1114L554 1114Q547 1101 540.50 1088.50Q534 1076 525 1064L525 1064Q489 1015 435 987.50Q381 960 320 960L320 960Q254 960 207 986.50Q160 1013 118 1061L118 1061Q107 1073 95.50 1079.50Q84 1086 67 1086L67 1086Q41 1086 22 1066.50Q3 1047 3 1021L3 1021L3 1017Q14 892 53.50 777Q93 662 157.50 563.50Q222 465 307.50 384.50Q393 304 496 247Q599 190 716 159Q833 128 960 128ZM1600 832L1600 832Q1642 832 1682.50 841Q1723 850 1761 868L1761 868Q1724 733 1646.50 620.50Q1569 508 1463 427Q1357 346 1228.50 301Q1100 256 960 256L960 256Q820 256 691 301Q562 346 456 427Q350 508 273 620.50Q196 733 159 868L159 868Q197 850 237.50 841Q278 832 320 832L320 832Q417 832 501.50 877.50Q586 923 640 1004L640 1004Q694 923 778.50 877.50Q863 832 960 832L960 832Q1057 832 1141.50 877.50Q1226 923 1280 1004L1280 1004Q1334 923 1418.50 877.50Q1503 832 1600 832Z"
         }
      }
   ]
}

var NetworkTower = {
   name: "NetworkTower",
   vendor: "UiFabric",
   unicode: 60421,
   value: "",
   charCode: "EC05",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1277 886L1188 794Q1233 751 1257.50 695Q1282 639 1282 576L1282 576Q1282 513 1257.50 457Q1233 401 1188 358L1188 358L1277 266Q1341 328 1375.50 407.50Q1410 487 1410 576L1410 576Q1410 665 1375.50 744.50Q1341 824 1277 886L1277 886ZM1366 174L1455 82Q1505 130 1544.50 187Q1584 244 1611 307Q1638 370 1652 438Q1666 506 1666 576L1666 576Q1666 646 1652 714Q1638 782 1611 845Q1584 908 1544.50 965Q1505 1022 1455 1070L1455 1070L1366 978Q1449 898 1493.50 794.50Q1538 691 1538 576L1538 576Q1538 461 1493.50 357.50Q1449 254 1366 174L1366 174ZM732 794L643 886Q579 824 544.50 744.50Q510 665 510 576L510 576Q510 487 544.50 407.50Q579 328 643 266L643 266L732 358Q687 401 662.50 457Q638 513 638 576L638 576Q638 639 662.50 695Q687 751 732 794L732 794ZM554 978L465 1070Q415 1022 375.50 965Q336 908 309 845Q282 782 268 714Q254 646 254 576L254 576Q254 506 268 438Q282 370 309 307Q336 244 375.50 187Q415 130 465 82L465 82L554 174Q471 254 426.50 357.50Q382 461 382 576L382 576Q382 691 426.50 794.50Q471 898 554 978L554 978ZM1152 576L1152 576Q1152 621 1132.50 660.50Q1113 700 1078 727L1078 727L1475 1920L1341 1920L1255 1664L665 1664L579 1920L445 1920L842 727Q807 700 787.50 660.50Q768 621 768 576L768 576Q768 536 783 501Q798 466 824 440Q850 414 885 399Q920 384 960 384L960 384Q1000 384 1035 399Q1070 414 1096 440Q1122 466 1137 501Q1152 536 1152 576ZM960 512L960 512Q934 512 915 531Q896 550 896 576L896 576Q896 602 915 621Q934 640 960 640L960 640Q986 640 1005 621Q1024 602 1024 576L1024 576Q1024 550 1005 531Q986 512 960 512ZM1085 1152L960 778L835 1152L1085 1152ZM707 1536L1213 1536L1127 1280L793 1280L707 1536Z"
         }
      }
   ]
}

var CityNext = {
   name: "CityNext",
   vendor: "UiFabric",
   unicode: 60422,
   value: "",
   charCode: "EC06",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 768L1280 37L1920 677L1920 2048L1792 2048L1792 731L1408 347L1408 768L1536 768L1536 2048L1152 2048L1152 1664L1024 1664L1024 2048L640 2048L640 768L1024 768L1024 640L256 640L256 2048L128 2048L128 512L1152 512L1152 768L1280 768ZM1280 1920L1408 1920L1408 896L768 896L768 1920L896 1920L896 1536L1280 1536L1280 1920ZM512 896L384 896L384 768L512 768L512 896ZM512 1152L384 1152L384 1024L512 1024L512 1152ZM512 1408L384 1408L384 1280L512 1280L512 1408ZM512 1664L384 1664L384 1536L512 1536L512 1664ZM512 1920L384 1920L384 1792L512 1792L512 1920ZM1152 1024L1280 1024L1280 1152L1152 1152L1152 1024ZM1152 1280L1280 1280L1280 1408L1152 1408L1152 1280ZM896 1024L1024 1024L1024 1152L896 1152L896 1024ZM896 1280L1024 1280L1024 1408L896 1408L896 1280Z"
         }
      }
   ]
}

var CityNext2 = {
   name: "CityNext2",
   vendor: "UiFabric",
   unicode: 60423,
   value: "",
   charCode: "EC07",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 768L512 1024L384 1024L384 768L512 768ZM768 768L768 1024L640 1024L640 768L768 768ZM1024 768L1024 1024L896 1024L896 768L1024 768ZM512 1152L512 1408L384 1408L384 1152L512 1152ZM768 1152L768 1408L640 1408L640 1152L768 1152ZM1024 1152L1024 1408L896 1408L896 1152L1024 1152ZM1280 768L1408 768Q1514 768 1607.50 808Q1701 848 1770.50 917.50Q1840 987 1880 1080.50Q1920 1174 1920 1280L1920 1280L1920 2048L1792 2048L1792 1280Q1792 1201 1762 1131Q1732 1061 1679.50 1008.50Q1627 956 1557 926Q1487 896 1408 896L1408 896L1280 896L1280 2048L768 2048L768 1664L640 1664L640 2048L128 2048L128 512L256 512L256 256L512 256L512 0L896 0L896 256L1152 256L1152 512L1280 512L1280 768ZM640 128L640 256L768 256L768 128L640 128ZM384 384L384 512L1024 512L1024 384L384 384ZM1152 1920L1152 640L256 640L256 1920L512 1920L512 1536L896 1536L896 1920L1152 1920ZM1408 1280L1408 1152L1664 1152L1664 1280L1408 1280ZM1408 1536L1408 1408L1664 1408L1664 1536L1408 1536ZM1408 1792L1408 1664L1664 1664L1664 1792L1408 1792ZM1408 2048L1408 1920L1664 1920L1664 2048L1408 2048Z"
         }
      }
   ]
}

var Section = {
   name: "Section",
   vendor: "UiFabric",
   unicode: 60428,
   value: "",
   charCode: "EC0C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M428 576L1620 576Q1643 576 1666.50 584.50Q1690 593 1710.50 607.50Q1731 622 1747 641.50Q1763 661 1771 683L1771 683L2048 1472L0 1472L278 683Q286 661 301.50 641.50Q317 622 337 607.50Q357 593 380.50 584.50Q404 576 428 576L428 576ZM1620 704L428 704Q425 704 420.50 706.50Q416 709 411 712Q406 715 402.50 718.50Q399 722 398 725L398 725L181 1344L1867 1344L1650 725Q1649 722 1645.50 718.50Q1642 715 1637 712Q1632 709 1627.50 706.50Q1623 704 1620 704L1620 704Z"
         }
      }
   ]
}

var OneNoteLogoInverse = {
   name: "OneNoteLogoInverse",
   vendor: "UiFabric",
   unicode: 60429,
   value: "",
   charCode: "EC0D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM389 1359L389 939L631 1359L783 1359L783 689L635 689L635 1118L402 689L241 689L241 1359L389 1359ZM1664 1792L1920 1792L1920 1536L1664 1536L1664 1792ZM1664 1408L1920 1408L1920 1152L1664 1152L1664 1408ZM1664 1024L1920 1024L1920 768L1664 768L1664 1024ZM1536 640L1920 640L1920 256L640 256L640 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L640 1536L640 1792L1536 1792L1536 640Z"
         }
      }
   ]
}

var ToggleFilled = {
   name: "ToggleFilled",
   vendor: "UiFabric",
   unicode: 60433,
   value: "",
   charCode: "EC11",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1582 1490L1582 1490L466 1490Q370 1490 285 1453Q200 1416 137 1353Q74 1290 37 1205Q0 1120 0 1024L0 1024Q0 928 37 843Q74 758 137 695Q200 632 285 595Q370 558 466 558L466 558L1582 558Q1678 558 1763 595Q1848 632 1911 695Q1974 758 2011 843Q2048 928 2048 1024L2048 1024Q2048 1120 2011 1205Q1974 1290 1911 1353Q1848 1416 1763 1453Q1678 1490 1582 1490Z"
         }
      }
   ]
}

var ToggleBorder = {
   name: "ToggleBorder",
   vendor: "UiFabric",
   unicode: 60434,
   value: "",
   charCode: "EC12",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M466 558L1582 558Q1678 558 1763 595Q1848 632 1911 695Q1974 758 2011 843Q2048 928 2048 1024L2048 1024Q2048 1120 2011 1205Q1974 1290 1911 1353Q1848 1416 1763 1453Q1678 1490 1582 1490L1582 1490L466 1490Q370 1490 285 1453Q200 1416 137 1353Q74 1290 37 1205Q0 1120 0 1024L0 1024Q0 928 37 843Q74 758 137 695Q200 632 285 595Q370 558 466 558L466 558ZM466 1396L1582 1396Q1659 1396 1727 1366.50Q1795 1337 1845.50 1286.50Q1896 1236 1925.50 1168.50Q1955 1101 1955 1024L1955 1024Q1955 947 1925.50 879.50Q1896 812 1845.50 761.50Q1795 711 1727 681.50Q1659 652 1582 652L1582 652L466 652Q389 652 321 681.50Q253 711 202.50 761.50Q152 812 122.50 879.50Q93 947 93 1024L93 1024Q93 1101 122.50 1168.50Q152 1236 202.50 1286.50Q253 1337 321 1366.50Q389 1396 466 1396L466 1396Z"
         }
      }
   ]
}

var SliderThumb = {
   name: "SliderThumb",
   vendor: "UiFabric",
   unicode: 60435,
   value: "",
   charCode: "EC13",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1365 341L1365 341L1365 1707Q1365 1777 1338 1839Q1311 1901 1264.50 1947.50Q1218 1994 1156 2021Q1094 2048 1024 2048L1024 2048Q954 2048 892 2021Q830 1994 783.50 1947.50Q737 1901 710 1839Q683 1777 683 1707L683 1707L683 341Q683 271 710 209Q737 147 783.50 100.50Q830 54 892 27Q954 0 1024 0L1024 0Q1094 0 1156 27Q1218 54 1264.50 100.50Q1311 147 1338 209Q1365 271 1365 341Z"
         }
      }
   ]
}

var ToggleThumb = {
   name: "ToggleThumb",
   vendor: "UiFabric",
   unicode: 60436,
   value: "",
   charCode: "EC14",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1031 0L1031 0Q1174 0 1305 36.50Q1436 73 1549 139.50Q1662 206 1754 300Q1846 394 1911.50 508Q1977 622 2012.50 753Q2048 884 2048 1026L2048 1026Q2048 1166 2011.50 1296Q1975 1426 1909 1539.50Q1843 1653 1750 1747Q1657 1841 1544 1907.50Q1431 1974 1301 2011Q1171 2048 1031 2048L1031 2048Q891 2048 760 2011.50Q629 1975 514.50 1908Q400 1841 305.50 1747.50Q211 1654 143 1540.50Q75 1427 37.50 1297Q0 1167 0 1026L0 1026Q0 883 37 751.50Q74 620 141 506Q208 392 302 299Q396 206 510.50 139.50Q625 73 756.50 36.50Q888 0 1031 0Z"
         }
      }
   ]
}

var Documentation = {
   name: "Documentation",
   vendor: "UiFabric",
   unicode: 60439,
   value: "",
   charCode: "EC17",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 512L1920 512L1920 1920L768 1920L768 1664L512 1664L512 1408L256 1408L256 0L987 0L1243 256L1664 256L1664 512ZM1024 219L1024 384L1189 384L1024 219ZM384 1280L1280 1280L1280 512L896 512L896 128L384 128L384 1280ZM640 1536L1536 1536L1536 384L1408 384L1408 1408L640 1408L640 1536ZM1793 1792L1793 640L1664 640L1664 1664L896 1664L896 1792L1793 1792Z"
         }
      }
   ]
}

var Badge = {
   name: "Badge",
   vendor: "UiFabric",
   unicode: 60443,
   value: "",
   charCode: "EC1B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 641L1792 641Q1792 664 1804 693.50Q1816 723 1833.50 753Q1851 783 1870 810Q1889 837 1904 854L1904 854Q1976 940 2012 1032Q2048 1124 2048 1238L2048 1238Q2048 1346 2001.50 1438.50Q1955 1531 1879 1605L1879 1605Q1841 1642 1794 1676Q1747 1710 1695.50 1738.50Q1644 1767 1590.50 1788.50Q1537 1810 1485 1823L1485 1823Q1371 1851 1265.50 1887Q1160 1923 1055 1976L1055 1976Q1039 1984 1024 1984L1024 1984Q1009 1984 993 1976L993 1976Q888 1923 782.50 1887Q677 1851 563 1823L563 1823Q511 1810 457.50 1788.50Q404 1767 352.50 1738.50Q301 1710 254 1676Q207 1642 169 1605L169 1605Q93 1531 46.50 1438.50Q0 1346 0 1238L0 1238Q0 1124 36 1032.50Q72 941 144 854L144 854Q158 837 177.50 810Q197 783 214.50 753Q232 723 244 693.50Q256 664 256 641L256 641Q256 575 229 527.50Q202 480 154 438L154 438Q141 427 135 414.50Q129 402 129 385L129 385Q129 360 147 342L147 342L402 83Q411 74 423.50 69Q436 64 448 64L448 64Q463 64 473 69Q483 74 494 84L494 84Q536 122 581.50 140Q627 158 684 158L684 158Q721 158 762 149.50Q803 141 841.50 124.50Q880 108 913.50 84.50Q947 61 970 30L970 30Q981 16 993.50 8Q1006 0 1024 0L1024 0Q1042 0 1054.50 8Q1067 16 1078 30L1078 30Q1100 61 1134 84.50Q1168 108 1206.50 124.50Q1245 141 1286 149.50Q1327 158 1364 158L1364 158Q1421 158 1466.50 140Q1512 122 1554 84L1554 84Q1565 74 1575 69Q1585 64 1599 64L1599 64Q1627 64 1646 83L1646 83L1901 342Q1919 360 1919 385L1919 385Q1919 402 1913 414.50Q1907 427 1894 438L1894 438Q1846 480 1819 527.50Q1792 575 1792 641ZM1024 1848L1024 1848Q1105 1806 1189.50 1775.50Q1274 1745 1361 1722L1361 1722Q1385 1715 1409 1710Q1433 1705 1457 1698L1457 1698Q1509 1684 1563.50 1660.50Q1618 1637 1669 1605.50Q1720 1574 1766 1534.50Q1812 1495 1846 1448Q1880 1401 1900 1347Q1920 1293 1920 1233L1920 1233Q1920 1160 1904.50 1110Q1889 1060 1863.50 1018.50Q1838 977 1805 936.50Q1772 896 1738 842L1738 842Q1724 821 1711 796.50Q1698 772 1687.50 746Q1677 720 1670.50 693.50Q1664 667 1664 641L1664 641Q1664 569 1689.50 503Q1715 437 1763 384L1763 384L1596 215Q1545 251 1485.50 268.50Q1426 286 1364 286L1364 286Q1323 286 1276 277Q1229 268 1183.50 252Q1138 236 1096 213Q1054 190 1024 162L1024 162Q993 190 951.50 213Q910 236 864 252Q818 268 771.50 277Q725 286 684 286L684 286Q622 286 562.50 268.50Q503 251 452 215L452 215L285 384Q333 437 358.50 503Q384 569 384 641L384 641Q384 667 377.50 693.50Q371 720 360.50 746Q350 772 336.50 796.50Q323 821 310 842L310 842Q276 896 243 936.50Q210 977 184.50 1018.50Q159 1060 143.50 1110Q128 1160 128 1233L128 1233Q128 1293 148 1347Q168 1401 202 1448Q236 1495 282 1534.50Q328 1574 379 1605.50Q430 1637 484.50 1660.50Q539 1684 591 1698L591 1698Q615 1705 639 1710Q663 1715 687 1722L687 1722Q774 1745 858.50 1775.50Q943 1806 1024 1848Z"
         }
      }
   ]
}

var Giftbox = {
   name: "Giftbox",
   vendor: "UiFabric",
   unicode: 60447,
   value: "",
   charCode: "EC1F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1500 768L1792 768L1792 2048L128 2048L128 768L420 768Q385 709 385 640L385 640Q385 587 405 540.50Q425 494 459.50 459Q494 424 540.50 404Q587 384 640 384L640 384Q737 384 821.50 429.50Q906 475 960 556L960 556Q1014 475 1098.50 429.50Q1183 384 1280 384L1280 384Q1333 384 1379.50 404Q1426 424 1461 459Q1496 494 1516 540.50Q1536 587 1536 640L1536 640Q1536 674 1526.50 706.50Q1517 739 1500 768L1500 768ZM896 1920L896 896L256 896L256 1920L896 1920ZM640 768L896 768Q896 715 876 668.50Q856 622 821 587Q786 552 739.50 532Q693 512 640 512L640 512Q613 512 590 522Q567 532 549.50 549.50Q532 567 522 590Q512 613 512 640L512 640Q512 667 522 690Q532 713 549.50 730.50Q567 748 590 758Q613 768 640 768L640 768ZM1280 512L1280 512Q1227 512 1180.50 532Q1134 552 1099 587Q1064 622 1044 668.50Q1024 715 1024 768L1024 768L1280 768Q1307 768 1330 758Q1353 748 1370.50 730.50Q1388 713 1398 690Q1408 667 1408 640L1408 640Q1408 613 1398 590Q1388 567 1370.50 549.50Q1353 532 1330 522Q1307 512 1280 512ZM1664 1920L1664 896L1024 896L1024 1920L1664 1920Z"
         }
      }
   ]
}

var VisualStudioLogo = {
   name: "VisualStudioLogo",
   vendor: "UiFabric",
   unicode: 60450,
   value: "",
   charCode: "EC22",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 832L1472 128L1920 299L1920 1728L1472 1920L768 1216L299 1579L128 1472L128 577L299 469L768 832ZM320 768L320 1280L576 1024L320 768ZM1024 1024L1472 1408L1472 640L1024 1024Z"
         }
      }
   ]
}

var HomeGroup = {
   name: "HomeGroup",
   vendor: "UiFabric",
   unicode: 60454,
   value: "",
   charCode: "EC26",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M320 640L320 640Q386 640 444 665.50Q502 691 545.50 734.50Q589 778 614.50 836Q640 894 640 960L640 960Q640 1026 614.50 1084.50Q589 1143 545.50 1186.50Q502 1230 444 1255Q386 1280 320 1280L320 1280Q254 1280 195.50 1255Q137 1230 93.50 1186.50Q50 1143 25 1084.50Q0 1026 0 960L0 960Q0 894 25 836Q50 778 93.50 734.50Q137 691 195.50 665.50Q254 640 320 640ZM320 1152L320 1152Q360 1152 395 1137Q430 1122 456 1096Q482 1070 497 1035Q512 1000 512 960L512 960Q512 920 497 885Q482 850 456 824Q430 798 395 783Q360 768 320 768L320 768Q280 768 245 783Q210 798 184 824Q158 850 143 885Q128 920 128 960L128 960Q128 1000 143 1035Q158 1070 184 1096Q210 1122 245 1137Q280 1152 320 1152ZM1852 1230L1852 1230Q1898 1260 1934.50 1301Q1971 1342 1996 1390Q2021 1438 2034.50 1491.50Q2048 1545 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1550 1162 1506L1162 1506Q1074 1477 1001.50 1423Q929 1369 877 1297Q825 1225 796.50 1139Q768 1053 768 960L768 960Q768 841 813.50 736Q859 631 937 553Q1015 475 1120 429.50Q1225 384 1344 384L1344 384Q1362 384 1380 385Q1398 386 1416 388L1416 388Q1408 353 1408 320L1408 320Q1408 254 1433 196Q1458 138 1501.50 94.50Q1545 51 1603.50 25.50Q1662 0 1728 0L1728 0Q1794 0 1852 25.50Q1910 51 1953.50 94.50Q1997 138 2022.50 196Q2048 254 2048 320L2048 320Q2048 373 2031 422.50Q2014 472 1983 512.50Q1952 553 1909 583Q1866 613 1815 628L1815 628Q1867 701 1893.50 785.50Q1920 870 1920 960L1920 960Q1920 1031 1903 1099Q1886 1167 1852 1230ZM1536 320L1536 320Q1536 382 1573 431L1573 431Q1608 446 1641 466Q1674 486 1704 510L1704 510Q1710 511 1716 511.50Q1722 512 1728 512L1728 512Q1768 512 1803 497Q1838 482 1864 456Q1890 430 1905 395Q1920 360 1920 320L1920 320Q1920 280 1905 245Q1890 210 1864 184Q1838 158 1803 143Q1768 128 1728 128L1728 128Q1688 128 1653 143Q1618 158 1592 184Q1566 210 1551 245Q1536 280 1536 320ZM896 960L896 960Q896 1032 918.50 1099.50Q941 1167 982 1223.50Q1023 1280 1080 1322Q1137 1364 1206 1386L1206 1386Q1268 1277 1371 1214.50Q1474 1152 1600 1152L1600 1152Q1671 1152 1737 1173L1737 1173Q1764 1124 1778 1070Q1792 1016 1792 960L1792 960Q1792 865 1753.50 779Q1715 693 1646 629L1646 629L1642 628Q1607 599 1572.50 578Q1538 557 1496 539L1496 539L1495 538Q1422 512 1344 512L1344 512Q1251 512 1169.50 547.50Q1088 583 1027.50 643.50Q967 704 931.50 785.50Q896 867 896 960ZM1600 1920L1600 1920Q1666 1920 1724 1895Q1782 1870 1825.50 1826.50Q1869 1783 1894.50 1724.50Q1920 1666 1920 1600L1920 1600Q1920 1530 1894 1471.50Q1868 1413 1823 1370.50Q1778 1328 1718 1304Q1658 1280 1590 1280L1590 1280Q1526 1280 1469.50 1306.50Q1413 1333 1371 1377.50Q1329 1422 1304.50 1479.50Q1280 1537 1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920Z"
         }
      }
   ]
}

var MyNetwork = {
   name: "MyNetwork",
   vendor: "UiFabric",
   unicode: 60455,
   value: "",
   charCode: "EC27",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1836 512L1836 517Q1878 604 1899 701.50Q1920 799 1920 896L1920 896Q1920 1027 1884 1148.50Q1848 1270 1781.50 1375Q1715 1480 1620 1565Q1525 1650 1408 1706L1408 1706L1408 1792L768 1792L768 1920L1024 1920L1024 2048L384 2048L384 1920L640 1920L640 1792L0 1792L0 896L128 896Q128 772 160 657.50Q192 543 250.50 443.50Q309 344 390.50 262.50Q472 181 571.50 122.50Q671 64 785.50 32Q900 0 1024 0L1024 0Q1154 0 1276 36Q1398 72 1503.50 138.50Q1609 205 1693.50 300Q1778 395 1834 512L1834 512L1836 512ZM1372 512L1689 512Q1616 385 1502 294.50Q1388 204 1248 161L1248 161Q1296 239 1325.50 330.50Q1355 422 1372 512L1372 512ZM1792 896L1792 896Q1792 764 1748 640L1748 640L1392 640Q1408 768 1408 895Q1408 1022 1408 1152L1408 1152L1748 1152Q1792 1028 1792 896ZM768 896L1280 896Q1280 831 1276 767.50Q1272 704 1264 640L1264 640L784 640Q776 704 772 767.50Q768 831 768 896L768 896ZM1024 133L1024 133Q995 133 968.50 154.50Q942 176 919.50 210.50Q897 245 878.50 288Q860 331 845.50 373Q831 415 821 452Q811 489 806 512L806 512L1242 512Q1237 489 1227 452Q1217 415 1202.50 373Q1188 331 1169.50 288Q1151 245 1128.50 210.50Q1106 176 1079.50 154.50Q1053 133 1024 133ZM800 161L800 161Q660 204 546 294.50Q432 385 359 512L359 512L676 512Q693 422 722.50 330.50Q752 239 800 161ZM656 640L300 640Q256 764 256 896L256 896L640 896Q640 831 644 767.50Q648 704 656 640L656 640ZM128 1024L128 1664L1280 1664L1280 1024L128 1024ZM1408 1280L1408 1561Q1496 1510 1567.50 1439Q1639 1368 1690 1280L1690 1280L1408 1280Z"
         }
      }
   ]
}

var ExcelLogoInverse = {
   name: "ExcelLogoInverse",
   vendor: "UiFabric",
   unicode: 60456,
   value: "",
   charCode: "EC28",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM387 1360L512 1133L633 1360L816 1360L613 1030L812 706L637 706L525 911Q523 914 521.50 917.50Q520 921 518 925L518 925Q491 870 463 815.50Q435 761 407 706L407 706L221 706L415 1032L203 1360L387 1360ZM640 1792L1216 1792L1216 1536L640 1536L640 1792ZM1024 1408L1216 1408L1216 1088L1024 1088L1024 1408ZM1024 960L1216 960L1216 640L1024 640L1024 960ZM640 512L1216 512L1216 256L640 256L640 512ZM1344 1792L1920 1792L1920 1536L1344 1536L1344 1792ZM1344 1408L1920 1408L1920 1088L1344 1088L1344 1408ZM1344 960L1920 960L1920 640L1344 640L1344 960ZM1344 512L1920 512L1920 256L1344 256L1344 512Z"
         }
      }
   ]
}

var WordLogoInverse = {
   name: "WordLogoInverse",
   vendor: "UiFabric",
   unicode: 60457,
   value: "",
   charCode: "EC29",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM386 1360L515 956L638 1360L778 1360L912 688L771 688L691 1085L578 701L459 701L339 1087L259 688L112 688L246 1360L386 1360ZM640 1792L1920 1792L1920 1536L640 1536L640 1792ZM1024 1408L1920 1408L1920 1088L1024 1088L1024 1408ZM1024 960L1920 960L1920 640L1024 640L1024 960ZM640 512L1920 512L1920 256L640 256L640 512Z"
         }
      }
   ]
}

var PowerPointLogoInverse = {
   name: "PowerPointLogoInverse",
   vendor: "UiFabric",
   unicode: 60458,
   value: "",
   charCode: "EC2A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 128L1152 128Q1276 128 1390.50 160Q1505 192 1604.50 250.50Q1704 309 1785.50 390.50Q1867 472 1925.50 571.50Q1984 671 2016 785.50Q2048 900 2048 1024L2048 1024Q2048 1148 2016 1262.50Q1984 1377 1925.50 1476.50Q1867 1576 1785.50 1657.50Q1704 1739 1604.50 1797.50Q1505 1856 1390.50 1888Q1276 1920 1152 1920L1152 1920Q1042 1920 937 1894Q832 1868 737.50 1818.50Q643 1769 561.50 1697.50Q480 1626 417 1536L417 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L417 512Q480 422 561.50 350.50Q643 279 737.50 229.50Q832 180 937 154Q1042 128 1152 128ZM1216 259L1216 259L1216 960L1917 960Q1905 820 1846.50 697.50Q1788 575 1694.50 481.50Q1601 388 1478 329.50Q1355 271 1216 259ZM767 905L767 905Q767 847 747.50 805.50Q728 764 694 738Q660 712 614 700Q568 688 514 688L514 688L243 688L243 1359L400 1359L400 1125L506 1125Q555 1125 601.50 1110.50Q648 1096 685 1068.50Q722 1041 744.50 1000Q767 959 767 905ZM1152 1792L1152 1792Q1252 1792 1345 1767.50Q1438 1743 1520.50 1697.50Q1603 1652 1672 1588.50Q1741 1525 1793 1446.50Q1845 1368 1877 1277Q1909 1186 1917 1087L1917 1087L1089 1087L1089 259Q941 271 810 336.50Q679 402 580 512L580 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L580 1536Q635 1597 700.50 1644.50Q766 1692 839 1725Q912 1758 991 1775Q1070 1792 1152 1792ZM400 819L496 819Q545 819 574 838.50Q603 858 603 910L603 910Q603 933 592.50 947.50Q582 962 566 971Q550 980 530 983.50Q510 987 492 987L492 987L400 987L400 819Z"
         }
      }
   ]
}

var Commitments = {
   name: "Commitments",
   vendor: "UiFabric",
   unicode: 60493,
   value: "",
   charCode: "EC4D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 0L1344 0Q1370 0 1389 19L1389 19L2029 659Q2048 678 2048 704L2048 704Q2048 730 2029 749L2029 749L1786 992Q1811 1017 1835 1040Q1859 1063 1877.50 1087.50Q1896 1112 1907.50 1141Q1919 1170 1919 1208L1919 1208Q1919 1248 1904 1284Q1889 1320 1863 1347Q1837 1374 1802 1390Q1767 1406 1727 1407L1727 1407Q1725 1448 1710 1482.50Q1695 1517 1669.50 1542.50Q1644 1568 1609.50 1583Q1575 1598 1535 1599L1535 1599Q1534 1639 1518 1674Q1502 1709 1475 1735.50Q1448 1762 1412 1777Q1376 1792 1336 1792L1336 1792Q1304 1792 1271 1781L1271 1781Q1260 1812 1241.50 1837.50Q1223 1863 1198 1881.50Q1173 1900 1143 1910Q1113 1920 1080 1920L1080 1920Q1054 1920 1034 1915.50Q1014 1911 996.50 1902Q979 1893 962.50 1880Q946 1867 928 1851L928 1851Q893 1883 859.50 1901.50Q826 1920 776 1920L776 1920Q736 1920 700 1905Q664 1890 637 1864Q610 1838 594 1803Q578 1768 577 1727L577 1727Q538 1726 503 1711Q468 1696 442 1670Q416 1644 401 1609Q386 1574 385 1535L385 1535Q345 1534 310.50 1519Q276 1504 250.50 1478Q225 1452 209.50 1417Q194 1382 193 1343L193 1343Q152 1342 117 1326Q82 1310 56 1283Q30 1256 15 1220.50Q0 1185 0 1145L0 1145Q0 1104 15.50 1068Q31 1032 59 1003L59 1003L165 896L19 749Q0 730 0 704L0 704Q0 678 19 659L19 659L659 19Q678 0 704 0L704 0Q730 0 749 19L749 19L881 151Q894 147 931.50 134Q969 121 1018 104.50Q1067 88 1121.50 69.50Q1176 51 1223.50 35.50Q1271 20 1304 10Q1337 0 1344 0ZM312 960L312 960Q283 960 262 981L262 981L149 1093Q128 1114 128 1144L128 1144Q128 1174 148.50 1194.50Q169 1215 199 1215L199 1215Q230 1215 250 1195L250 1195L363 1083Q384 1062 384 1032L384 1032Q384 1002 363 981Q342 960 312 960ZM504 1152L504 1152Q490 1152 476.50 1157.50Q463 1163 453 1173L453 1173L341 1286Q320 1307 320 1337L320 1337Q320 1366 341 1386.50Q362 1407 392 1407L392 1407Q406 1407 419.50 1402Q433 1397 443 1387L443 1387L555 1274Q576 1253 576 1224L576 1224Q576 1194 555 1173Q534 1152 504 1152ZM696 1344L696 1344Q667 1344 646 1365L646 1365L533 1477Q512 1498 512 1528L512 1528Q512 1558 532.50 1578.50Q553 1599 583 1599L583 1599Q614 1599 634 1579L634 1579L747 1467Q768 1446 768 1416L768 1416Q768 1386 747 1365Q726 1344 696 1344ZM704 1721L704 1721Q704 1750 725 1770.50Q746 1791 776 1791L776 1791Q790 1791 803.50 1786Q817 1781 827 1771L827 1771L939 1658Q960 1637 960 1608L960 1608Q960 1578 938.50 1557Q917 1536 888 1536L888 1536Q874 1536 860.50 1541.50Q847 1547 837 1557L837 1557L725 1670Q704 1691 704 1721ZM1720 1280L1720 1280Q1749 1280 1770.50 1259Q1792 1238 1792 1209L1792 1209Q1792 1179 1771 1158L1771 1158L1139 525Q1136 522 1129 519.50Q1122 517 1114.50 515.50Q1107 514 1099.50 513Q1092 512 1088 512L1088 512Q1062 512 1038.50 522Q1015 532 997.50 549.50Q980 567 970 590.50Q960 614 960 640L960 640Q960 693 940 739.50Q920 786 885 821Q850 856 803.50 876Q757 896 704 896L704 896Q664 896 629 881Q594 866 568 840Q542 814 527 779Q512 744 512 704L512 704Q512 680 517 650.50Q522 621 533 599L533 599L720 224Q729 208 747 198L747 198L704 155L154 704L289 838Q334 833 374 844.50Q414 856 444 881.50Q474 907 492 944.50Q510 982 511 1027L511 1027Q551 1029 586 1043.50Q621 1058 646.50 1083.50Q672 1109 687 1143.50Q702 1178 703 1219L703 1219Q743 1221 778 1235.50Q813 1250 838.50 1275.50Q864 1301 879 1335.50Q894 1370 895 1411L895 1411Q936 1413 971 1428Q1006 1443 1032 1469.50Q1058 1496 1073 1531Q1088 1566 1088 1608L1088 1608Q1088 1653 1070 1692Q1052 1731 1018 1760L1018 1760Q1033 1774 1045.50 1783Q1058 1792 1080 1792L1080 1792Q1109 1792 1130.50 1771Q1152 1750 1152 1721L1152 1721Q1152 1691 1131 1670L1131 1670L1221 1579L1286 1643Q1309 1664 1336 1664L1336 1664Q1365 1664 1386.50 1643Q1408 1622 1408 1593L1408 1593Q1408 1563 1387 1542L1387 1542L1274 1429L1365 1339L1477 1451Q1498 1472 1528 1472L1528 1472Q1558 1472 1579 1451Q1600 1430 1600 1400L1600 1400Q1600 1370 1579 1349L1579 1349L1466 1237L1557 1146L1670 1259Q1691 1280 1720 1280ZM1696 902L1893 704L1327 137L823 305L649 653Q644 662 642 678Q640 694 640 704L640 704Q640 730 659 749Q678 768 704 768L704 768Q731 768 754 758Q777 748 794.50 730.50Q812 713 822 690Q832 667 832 640L832 640Q832 587 852 540.50Q872 494 907 459Q942 424 988.50 404Q1035 384 1088 384L1088 384Q1104 384 1122.50 387Q1141 390 1160 395.50Q1179 401 1195.50 409.50Q1212 418 1224 430L1224 430L1696 902Z"
         }
      }
   ]
}

var SpeedHigh = {
   name: "SpeedHigh",
   vendor: "UiFabric",
   unicode: 60490,
   value: "",
   charCode: "EC4A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1214.50 34.50Q1337 69 1444 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 476Q1851 583 1885.50 705.50Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1214.50Q1851 1337 1788.50 1444Q1726 1551 1638.50 1638.50Q1551 1726 1444 1788.50Q1337 1851 1214.50 1885.50Q1092 1920 960 1920L960 1920Q828 1920 705.50 1885.50Q583 1851 476 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444Q69 1337 34.50 1214.50Q0 1092 0 960L0 960Q0 828 34.50 705.50Q69 583 131.50 476Q194 369 281.50 281.50Q369 194 476 131.50Q583 69 705.50 34.50Q828 0 960 0ZM960 1792L960 1792Q1075 1792 1181 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM1133 877L1132 876Q1152 916 1152 960L1152 960Q1152 1000 1137 1035Q1122 1070 1096 1096Q1070 1122 1035 1137Q1000 1152 960 1152L960 1152Q920 1152 885 1137Q850 1122 824 1096Q798 1070 783 1035Q768 1000 768 960L768 960Q768 920 783 885Q798 850 824 824Q850 798 885 783Q920 768 960 768L960 768Q1004 768 1044 788L1044 788L1043 787L1411 419L1501 509L1133 877ZM960 1024L960 1024Q986 1024 1005 1005Q1024 986 1024 960L1024 960Q1024 934 1005 915Q986 896 960 896L960 896Q934 896 915 915Q896 934 896 960L896 960Q896 986 915 1005Q934 1024 960 1024ZM1484 724L1600 672Q1631 740 1646.50 812.50Q1662 885 1662 960L1662 960Q1662 1100 1609.50 1229.50Q1557 1359 1458 1458L1458 1458L1367 1367Q1448 1286 1492 1182Q1536 1078 1536 963L1536 963Q1536 839 1484 724L1484 724ZM1248 320L1196 436Q1081 384 957 384L957 384Q878 384 805 404.50Q732 425 668 463Q604 501 552 553.50Q500 606 462.50 670Q425 734 404.50 807.50Q384 881 384 960L384 960Q384 1075 428 1180.50Q472 1286 553 1367L553 1367L462 1458Q362 1358 309 1229.50Q256 1101 256 960L256 960Q256 863 281 773Q306 683 352 605Q398 527 462 463Q526 399 604 353.50Q682 308 772 283Q862 258 960 258L960 258Q1035 258 1107.50 273.50Q1180 289 1248 320L1248 320Z"
         }
      }
   ]
}

var Cafe = {
   name: "Cafe",
   vendor: "UiFabric",
   unicode: 60466,
   value: "",
   charCode: "EC32",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M127 512L1663 512Q1742 512 1812 542Q1882 572 1934.50 624.50Q1987 677 2017 747Q2047 817 2047 896L2047 896Q2047 976 2017 1045.50Q1987 1115 1934.50 1167.50Q1882 1220 1812 1250Q1742 1280 1663 1280L1663 1280L1560 1280Q1516 1357 1455 1422Q1394 1487 1320 1536L1320 1536L1599 1536Q1625 1536 1644 1555Q1663 1574 1663 1600L1663 1600Q1663 1626 1644 1645Q1625 1664 1599 1664L1599 1664L191 1664Q165 1664 146 1645Q127 1626 127 1600L127 1600Q127 1574 146 1555Q165 1536 191 1536L191 1536L470 1536Q389 1482 325.50 1412Q262 1342 218 1259.50Q174 1177 150.50 1085Q127 993 127 896L127 896L127 512ZM895 1536L895 1536Q983 1536 1065 1513Q1147 1490 1218 1448.50Q1289 1407 1347.50 1348.50Q1406 1290 1447.50 1219Q1489 1148 1512 1066Q1535 984 1535 896L1535 896L1535 640L255 640L255 896Q255 984 278 1066Q301 1148 342.50 1219Q384 1290 442.50 1348.50Q501 1407 572 1448.50Q643 1490 725 1513Q807 1536 895 1536ZM1619 1152L1663 1152Q1716 1152 1762.50 1132Q1809 1112 1844 1077Q1879 1042 1899 995.50Q1919 949 1919 896L1919 896Q1919 843 1899 796.50Q1879 750 1844 715Q1809 680 1762.50 660Q1716 640 1663 640L1663 640Q1663 705 1664.50 770Q1666 835 1663 899Q1660 963 1650.50 1026.50Q1641 1090 1619 1152L1619 1152Z"
         }
      }
   ]
}

var EdgeOldLogo = {
   name: "EdgeOldLogo",
   vendor: "UiFabric",
   unicode: 60512,
   value: "",
   charCode: "EC60",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1983 961L1983 1216L674 1216Q674 1290 697 1350Q720 1410 760 1456.50Q800 1503 854 1536.50Q908 1570 969 1592Q1030 1614 1095.50 1624.50Q1161 1635 1225 1635L1225 1635Q1306 1635 1378 1622Q1450 1609 1518.50 1586.50Q1587 1564 1654 1533Q1721 1502 1791 1465L1791 1465L1791 1899Q1713 1937 1636.50 1964.50Q1560 1992 1482 2011Q1404 2030 1323 2039Q1242 2048 1155 2048L1155 2048Q1040 2048 933 2021.50Q826 1995 732 1945.50Q638 1896 560 1825Q482 1754 426 1665Q370 1576 339 1471Q308 1366 308 1248L308 1248Q308 1122 342.50 1007.50Q377 893 442 797Q507 701 600.50 626.50Q694 552 811 505L811 505Q747 569 711.50 656.50Q676 744 666 832L666 832L1395 832Q1395 722 1372.50 639.50Q1350 557 1300 502.50Q1250 448 1171 420.50Q1092 393 980 393L980 393Q848 393 716 432.50Q584 472 465 542Q346 612 246 707.50Q146 803 78 915L78 915Q93 785 133.50 666.50Q174 548 237.50 446.50Q301 345 386 262.50Q471 180 574.50 121.50Q678 63 798 31.50Q918 0 1053 0L1053 0Q1131 0 1209.50 14Q1288 28 1362 53L1362 53Q1510 104 1626 194.50Q1742 285 1821 403.50Q1900 522 1941.50 664.50Q1983 807 1983 961L1983 961Z"
         }
      }
   ]
}

var PlaybackRate1x = {
   name: "PlaybackRate1x",
   vendor: "UiFabric",
   unicode: 60503,
   value: "",
   charCode: "EC57",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1164 2011 1296Q1974 1428 1905 1544Q1836 1660 1737.50 1756.50Q1639 1853 1517 1920L1517 1920L1792 1920L1792 2048L1280 2048L1280 1536L1408 1536L1408 1830Q1525 1775 1619.50 1690.50Q1714 1606 1780.50 1501Q1847 1396 1883.50 1274.50Q1920 1153 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1174 176 1313Q224 1452 311 1566Q398 1680 519 1763.50Q640 1847 785 1887L785 1887L751 2010Q641 1979 542.50 1926Q444 1873 360.50 1802Q277 1731 210 1643Q143 1555 96.50 1456Q50 1357 25 1248Q0 1139 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024ZM768 581L1536 1024L768 1467L768 581ZM896 802L896 1246L1280 1024L896 802Z"
         }
      }
   ]
}

var MicOff = {
   name: "MicOff",
   vendor: "UiFabric",
   unicode: 60500,
   value: "",
   charCode: "EC54",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1536L704 1536Q664 1536 629 1521Q594 1506 568 1480Q542 1454 527 1419Q512 1384 512 1344L512 1344L512 192Q512 152 527 117Q542 82 568 56Q594 30 629 15Q664 0 704 0L704 0L1216 0Q1256 0 1291 15Q1326 30 1352 56Q1378 82 1393 117Q1408 152 1408 192L1408 192L1408 1026Q1374 1037 1342 1051.50Q1310 1066 1280 1085L1280 1085L1280 192Q1280 166 1261 147Q1242 128 1216 128L1216 128L704 128Q678 128 659 147Q640 166 640 192L640 192L640 1344Q640 1370 659 1389Q678 1408 704 1408L704 1408L896 1408L1026 1408Q1024 1410 1023.50 1428.50Q1023 1447 1023 1469Q1023 1491 1023.50 1511Q1024 1531 1024 1536L1024 1536ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333ZM1024 1920L1085 1920Q1130 1991 1192 2048L1192 2048L640 2048L640 1920L896 1920L896 1792L662 1792Q578 1792 504 1760Q430 1728 375 1673Q320 1618 288 1544Q256 1470 256 1386L256 1386L256 1024L384 1024L384 1386Q384 1443 406 1494Q428 1545 465.50 1582.50Q503 1620 554 1642Q605 1664 662 1664L662 1664L1024 1664L1024 1920Z"
         }
      }
   ]
}

var MusicNote = {
   name: "MusicNote",
   vendor: "UiFabric",
   unicode: 60495,
   value: "",
   charCode: "EC4F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1152 0Q1152 104 1198 186.50Q1244 269 1321 335L1321 335Q1420 421 1478 528Q1536 635 1536 768L1536 768L1408 768Q1408 664 1362 581.50Q1316 499 1239 433L1239 433Q1215 413 1193.50 391Q1172 369 1152 345L1152 345L1152 1760Q1152 1769 1149 1781.50Q1146 1794 1142 1807Q1138 1820 1132.50 1832Q1127 1844 1123 1852L1123 1852Q1098 1900 1059 1937Q1020 1974 973 1998.50Q926 2023 873 2035.50Q820 2048 768 2048L768 2048Q700 2048 631.50 2026Q563 2004 508 1963Q453 1922 418.50 1862.50Q384 1803 384 1728L384 1728Q384 1653 418.50 1593.50Q453 1534 508 1493Q563 1452 631.50 1430Q700 1408 768 1408L768 1408Q837 1408 903 1428.50Q969 1449 1024 1491L1024 1491L1024 0ZM768 1920L768 1920Q809 1920 854 1908Q899 1896 937 1872Q975 1848 999.50 1812Q1024 1776 1024 1728L1024 1728Q1024 1680 999.50 1644Q975 1608 937 1584Q899 1560 854 1548Q809 1536 768 1536L768 1536Q727 1536 682 1548Q637 1560 599 1584Q561 1608 536.50 1644Q512 1680 512 1728L512 1728Q512 1776 536.50 1812Q561 1848 599 1872Q637 1896 682 1908Q727 1920 768 1920Z"
         }
      }
   ]
}

var ThisPC = {
   name: "ThisPC",
   vendor: "UiFabric",
   unicode: 60494,
   value: "",
   charCode: "EC4E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1152L0 0L1920 0L1920 1152L1024 1152L1024 1280L1280 1280L1280 1408L640 1408L640 1280L896 1280L896 1152L0 1152ZM128 1024L1792 1024L1792 128L128 128L128 1024ZM0 1870L228 1536L1692 1536L1920 1870L1920 1920L0 1920L0 1870ZM296 1664L208 1792L1712 1792L1624 1664L296 1664Z"
         }
      }
   ]
}

var CompletedSolid = {
   name: "CompletedSolid",
   vendor: "UiFabric",
   unicode: 60513,
   value: "",
   charCode: "EC61",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM832 1480L1627 685L1491 549L832 1208L557 933L421 1069L832 1480Z"
         }
      }
   ]
}

var AlbumRemove = {
   name: "AlbumRemove",
   vendor: "UiFabric",
   unicode: 60514,
   value: "",
   charCode: "EC62",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L1856 256Q1896 256 1931 271Q1966 286 1992 312Q2018 338 2033 373Q2048 408 2048 448L2048 448L2048 1216L1920 1216L1920 448Q1920 422 1901 403Q1882 384 1856 384L1856 384L384 384L384 1664L1216 1664L1216 1792L0 1792L0 256ZM256 1664L256 384L128 384L128 1664L256 1664ZM1536 640L1536 1024L768 1024L768 640L1536 640ZM1408 896L1408 768L896 768L896 896L1408 896ZM1904 1363L1994 1453L1768 1680L1994 1906L1904 1996L1678 1770L1453 1994L1363 1904L1587 1680L1363 1455L1453 1365L1678 1589L1904 1363Z"
         }
      }
   ]
}

var MessageFill = {
   name: "MessageFill",
   vendor: "UiFabric",
   unicode: 60528,
   value: "",
   charCode: "EC70",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536L0 128Z"
         }
      }
   ]
}

var TabletSelected = {
   name: "TabletSelected",
   vendor: "UiFabric",
   unicode: 60532,
   value: "",
   charCode: "EC74",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1536L896 1408L1152 1408L1152 1536L896 1536ZM160 256L1888 256Q1921 256 1950 268.50Q1979 281 2001 303Q2023 325 2035.50 354Q2048 383 2048 416L2048 416L2048 1259L1920 1136L1920 416Q1920 402 1911 393Q1902 384 1888 384L1888 384L160 384Q146 384 137 393Q128 402 128 416L128 416L128 1632Q128 1646 137 1655Q146 1664 160 1664L160 1664L960 1664L1088 1792L160 1792Q127 1792 98 1779.50Q69 1767 47 1745Q25 1723 12.50 1694Q0 1665 0 1632L0 1632L0 416Q0 383 12.50 354Q25 325 47 303Q69 281 98 268.50Q127 256 160 256L160 256ZM1472 1814L1939 1347L2029 1438L1472 1995L1203 1726L1293 1635L1472 1814Z"
         }
      }
   ]
}

var MobileSelected = {
   name: "MobileSelected",
   vendor: "UiFabric",
   unicode: 60533,
   value: "",
   charCode: "EC75",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M832 1664L1073 1664L1016 1720L1088 1792L832 1792L832 1664ZM512 1920L1216 1920L1344 2048L512 2048Q485 2048 462 2038Q439 2028 421.50 2010.50Q404 1993 394 1970Q384 1947 384 1920L384 1920L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0L1536 0Q1563 0 1586 10Q1609 20 1626.50 37.50Q1644 55 1654 78Q1664 101 1664 128L1664 128L1664 1392L1536 1520L1536 128L512 128L512 1920ZM1939 1347L2029 1438L1472 1995L1203 1726L1293 1635L1472 1814L1939 1347Z"
         }
      }
   ]
}

var LaptopSelected = {
   name: "LaptopSelected",
   vendor: "UiFabric",
   unicode: 60534,
   value: "",
   charCode: "EC76",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1073 1536L1016 1592L1088 1664L128 1664Q103 1664 80 1653.50Q57 1643 39 1625Q21 1607 10.50 1584Q0 1561 0 1536L0 1536Q0 1520 3.50 1500Q7 1480 13.50 1461Q20 1442 29.50 1424.50Q39 1407 51 1395L51 1395L256 1189L256 384L1664 384L1664 1189L1573 1280L347 1280L144 1482Q141 1485 138 1492.50Q135 1500 132.50 1508Q130 1516 129 1524Q128 1532 128 1536L128 1536L1073 1536ZM384 512L384 1152L1536 1152L1536 512L384 512ZM1939 1219L2029 1310L1472 1867L1203 1598L1293 1507L1472 1686L1939 1219Z"
         }
      }
   ]
}

var TVMonitorSelected = {
   name: "TVMonitorSelected",
   vendor: "UiFabric",
   unicode: 60535,
   value: "",
   charCode: "EC77",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1280L1716 1280L1588 1408L1024 1408L1024 1664L640 1664L640 1536L896 1536L896 1408L0 1408L0 256L1920 256L1920 1076L1792 1204L1792 384L128 384L128 1280ZM1472 1750L1939 1283L2029 1374L1472 1931L1203 1662L1293 1571L1472 1750Z"
         }
      }
   ]
}

var DeveloperTools = {
   name: "DeveloperTools",
   vendor: "UiFabric",
   unicode: 60538,
   value: "",
   charCode: "EC7A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1024L1664 1152L1536 1152L1536 1856Q1536 1896 1521 1931Q1506 1966 1480 1992Q1454 2018 1419 2033Q1384 2048 1344 2048L1344 2048Q1304 2048 1269 2033Q1234 2018 1208 1992Q1182 1966 1167 1931Q1152 1896 1152 1856L1152 1856L1152 1152L1024 1152L1024 1024L1280 1024L1280 475L1152 347L1152 0L1536 0L1536 347L1408 475L1408 1024L1664 1024ZM1280 128L1280 293L1344 358L1408 293L1408 128L1280 128ZM1408 1856L1408 1152L1280 1152L1280 1856Q1280 1882 1299 1901Q1318 1920 1344 1920L1344 1920Q1370 1920 1389 1901Q1408 1882 1408 1856L1408 1856ZM704 0L704 0Q770 0 828 25.50Q886 51 929.50 94.50Q973 138 998.50 196Q1024 254 1024 320L1024 320Q1024 395 990 462.50Q956 530 896 575L896 575L896 1856Q896 1896 881 1931Q866 1966 840 1992Q814 2018 779 2033Q744 2048 704 2048L704 2048Q664 2048 629 2033Q594 2018 568 1992Q542 1966 527 1931Q512 1896 512 1856L512 1856L512 575Q452 530 418 462.50Q384 395 384 320L384 320Q384 254 409 196Q434 138 477.50 94.50Q521 51 579.50 25.50Q638 0 704 0ZM768 1856L768 504Q796 488 819.50 470Q843 452 860 430.50Q877 409 886.50 382Q896 355 896 320L896 320Q896 290 886.50 262Q877 234 860.50 210Q844 186 820 168Q796 150 768 140L768 140L768 320L704 384L640 320L640 140Q611 150 587.50 168Q564 186 547.50 210Q531 234 521.50 262Q512 290 512 320L512 320Q512 355 521.50 382Q531 409 548 430.50Q565 452 588.50 470Q612 488 640 504L640 504L640 1856Q640 1882 659 1901Q678 1920 704 1920L704 1920Q730 1920 749 1901Q768 1882 768 1856L768 1856Z"
         }
      }
   ]
}

var Shapes = {
   name: "Shapes",
   vendor: "UiFabric",
   unicode: 60540,
   value: "",
   charCode: "EC7C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 128L2048 1280L1629 1280L1999 1920L595 1920L862 1457Q796 1495 724 1515.50Q652 1536 576 1536L576 1536Q457 1536 352 1490.50Q247 1445 169 1367Q91 1289 45.50 1184Q0 1079 0 960L0 960Q0 841 45.50 736Q91 631 169 553Q247 475 352 429.50Q457 384 576 384L576 384Q661 384 742.50 408.50Q824 433 896 481L896 481L896 128L2048 128ZM576 1408L576 1408Q669 1408 750.50 1372.50Q832 1337 892.50 1276Q953 1215 988.50 1133.50Q1024 1052 1024 960L1024 960Q1024 868 988.50 786.50Q953 705 892.50 644Q832 583 750.50 547.50Q669 512 576 512L576 512Q483 512 401.50 547.50Q320 583 259.50 643.50Q199 704 163.50 785.50Q128 867 128 960L128 960Q128 1053 163.50 1134.50Q199 1216 259.50 1276.50Q320 1337 401.50 1372.50Q483 1408 576 1408ZM817 1792L1777 1792Q1656 1583 1537 1376Q1418 1169 1297 960L1297 960Q1176 1169 1057 1376Q938 1583 817 1792L817 1792ZM1920 1152L1920 256L1024 256L1024 603Q1085 678 1118 768.50Q1151 859 1152 956L1152 956L1297 704L1555 1152L1920 1152Z"
         }
      }
   ]
}

var InsertTextBox = {
   name: "InsertTextBox",
   vendor: "UiFabric",
   unicode: 60541,
   value: "",
   charCode: "EC7D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 388L2048 388L2048 1912L268 1912L268 1528L384 1528L384 1796L1932 1796L1932 504L1152 504L1152 388ZM374 1228L374 1272L0 1272L0 1228Q19 1225 38 1222.50Q57 1220 75 1215L75 1215Q89 1211 105.50 1189Q122 1167 137 1140Q152 1113 164.50 1086.50Q177 1060 183 1046L183 1046L571 128L653 128L1035 1056Q1044 1078 1056.50 1106Q1069 1134 1085.50 1159.50Q1102 1185 1123.50 1203.50Q1145 1222 1172 1225L1172 1225Q1200 1228 1228 1228L1228 1228L1228 1272L782 1272L782 1228Q799 1228 819 1228.50Q839 1229 856.50 1224.50Q874 1220 886 1208.50Q898 1197 898 1172L898 1172Q898 1150 887 1111.50Q876 1073 861 1032Q846 991 830.50 952.50Q815 914 805 891L805 891L359 891Q350 914 332.50 952.50Q315 991 298.50 1032Q282 1073 269.50 1111Q257 1149 257 1171L257 1171Q257 1195 269 1206.50Q281 1218 299 1222Q317 1226 337.50 1226.50Q358 1227 374 1228L374 1228ZM570 385L402 763L746 763L570 385Z"
         }
      }
   ]
}

var POI = {
   name: "POI",
   vendor: "UiFabric",
   unicode: 60591,
   value: "",
   charCode: "ECAF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1112 0 1194 23Q1276 46 1347 87.50Q1418 129 1476.50 187.50Q1535 246 1576.50 317Q1618 388 1641 470Q1664 552 1664 640L1664 640Q1664 709 1647.50 771.50Q1631 834 1600 896L1600 896L1024 2048L448 896Q417 834 400.50 771.50Q384 709 384 640L384 640Q384 552 407 470Q430 388 471.50 317Q513 246 571.50 187.50Q630 129 701 87.50Q772 46 854 23Q936 0 1024 0ZM1024 1798L1500 846Q1500 845 1500.50 845Q1501 845 1501 844L1501 844Q1526 797 1539 745Q1552 693 1552 640L1552 640Q1552 531 1510.50 435Q1469 339 1397 267Q1325 195 1229 153.50Q1133 112 1024 112L1024 112Q915 112 819 153.50Q723 195 651 267Q579 339 537.50 435Q496 531 496 640L496 640Q496 693 509 745Q522 797 547 844L547 844Q547 845 547.50 845Q548 845 548 846L548 846L1024 1798ZM1024 264L1024 264Q1102 264 1170.50 293.50Q1239 323 1290 374Q1341 425 1370.50 493.50Q1400 562 1400 640L1400 640Q1400 718 1370.50 786.50Q1341 855 1290 906Q1239 957 1170.50 986.50Q1102 1016 1024 1016L1024 1016Q946 1016 877.50 986.50Q809 957 758 906Q707 855 677.50 786.50Q648 718 648 640L648 640Q648 562 677.50 493.50Q707 425 758 374Q809 323 877.50 293.50Q946 264 1024 264ZM1024 904L1024 904Q1079 904 1127 883.50Q1175 863 1211 827Q1247 791 1267.50 743Q1288 695 1288 640L1288 640Q1288 585 1267.50 537Q1247 489 1211 453Q1175 417 1127 396.50Q1079 376 1024 376L1024 376Q969 376 921 396.50Q873 417 837 453Q801 489 780.50 537Q760 585 760 640L760 640Q760 695 780.50 743Q801 791 837 827Q873 863 921 883.50Q969 904 1024 904Z"
         }
      }
   ]
}

var Calories = {
   name: "Calories",
   vendor: "UiFabric",
   unicode: 60589,
   value: "",
   charCode: "ECAD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 0L1280 64Q1280 243 1346 394Q1412 545 1536 672L1536 672Q1660 799 1726 950Q1792 1101 1792 1280L1792 1280Q1792 1386 1764.50 1484Q1737 1582 1687 1667.50Q1637 1753 1567 1823Q1497 1893 1411.50 1943Q1326 1993 1228 2020.50Q1130 2048 1024 2048L1024 2048Q918 2048 820 2020.50Q722 1993 636.50 1943Q551 1893 481 1823Q411 1753 361 1667.50Q311 1582 283.50 1484Q256 1386 256 1280L256 1280Q256 1196 274 1115Q292 1034 326 959.50Q360 885 410 819Q460 753 523 698L523 698Q530 736 542 776.50Q554 817 570.50 856.50Q587 896 608 932.50Q629 969 654 999L654 999Q674 1024 706 1024L706 1024Q733 1024 751.50 1005Q770 986 770 959L770 959Q770 948 766.50 939Q763 930 757 921L757 921Q729 880 707.50 840Q686 800 671 758Q656 716 648 671Q640 626 640 576L640 576Q640 457 685.50 352Q731 247 809 169Q887 91 992 45.50Q1097 0 1216 0L1216 0L1280 0ZM1024 1920L1024 1920Q1157 1920 1273.50 1870Q1390 1820 1477 1733Q1564 1646 1614 1529.50Q1664 1413 1664 1280L1664 1280Q1664 1129 1608 999Q1552 869 1446 763L1446 763Q1316 632 1241.50 474Q1167 316 1154 132L1154 132Q1071 143 1000.50 182.50Q930 222 878 281.50Q826 341 797 416.50Q768 492 768 576L768 576Q768 654 791 717.50Q814 781 859 843L859 843Q878 869 888.50 897.50Q899 926 899 959L899 959Q899 999 883.50 1034Q868 1069 842 1095.50Q816 1122 781 1137Q746 1152 706 1152L706 1152Q660 1152 625 1134.50Q590 1117 563 1088.50Q536 1060 514.50 1024Q493 988 475 952L475 952Q429 1025 406.50 1109.50Q384 1194 384 1280L384 1280Q384 1413 434 1529.50Q484 1646 571 1733Q658 1820 774.50 1870Q891 1920 1024 1920Z"
         }
      }
   ]
}

var Photo2Remove = {
   name: "Photo2Remove",
   vendor: "UiFabric",
   unicode: 60588,
   value: "",
   charCode: "ECAC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 576L1408 576Q1408 550 1427 531Q1446 512 1472 512L1472 512Q1498 512 1517 531Q1536 550 1536 576L1536 576Q1536 602 1517 621Q1498 640 1472 640L1472 640Q1446 640 1427 621Q1408 602 1408 576ZM2045 1373L1818 1600L2045 1827L1955 1917L1728 1690L1501 1917L1411 1827L1638 1600L1411 1373L1501 1283L1728 1510L1955 1283L2045 1373ZM1392 1536L1457 1600L1392 1664L0 1664L0 256L1792 256L1792 1264L1728 1329L1664 1264L1664 384L128 384L128 805L320 614L832 1126L1088 870L1411 1192L1320 1283L1088 1050L922 1216L1243 1536L1392 1536ZM128 1536L1061 1536L320 794L128 987L128 1536Z"
         }
      }
   ]
}

var Photo2Add = {
   name: "Photo2Add",
   vendor: "UiFabric",
   unicode: 60587,
   value: "",
   charCode: "ECAB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 576L1408 576Q1408 550 1427 531Q1446 512 1472 512L1472 512Q1498 512 1517 531Q1536 550 1536 576L1536 576Q1536 602 1517 621Q1498 640 1472 640L1472 640Q1446 640 1427 621Q1408 602 1408 576ZM1792 1536L2048 1536L2048 1664L1792 1664L1792 1920L1664 1920L1664 1664L1408 1664L1408 1536L1664 1536L1664 1280L1792 1280L1792 1536ZM1088 1050L922 1216L1280 1573L1280 1664L0 1664L0 256L1792 256L1792 1152L1664 1152L1664 384L128 384L128 805L320 614L832 1126L1088 870L1536 1317L1536 1408L1445 1408L1088 1050ZM1061 1536L320 794L128 987L128 1536L1061 1536Z"
         }
      }
   ]
}

var AppIconDefault = {
   name: "AppIconDefault",
   vendor: "UiFabric",
   unicode: 60586,
   value: "",
   charCode: "ECAA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1920L0 0L1920 0L1920 1024L1024 1024L1024 1920L0 1920ZM128 1792L896 1792L896 1024L128 1024L128 1792ZM128 896L896 896L896 128L128 128L128 896ZM1024 896L1792 896L1792 128L1024 128L1024 896Z"
         }
      }
   ]
}

var CloudAdd = {
   name: "CloudAdd",
   vendor: "UiFabric",
   unicode: 60585,
   value: "",
   charCode: "ECA9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1629 769L1629 769Q1717 775 1793.50 812Q1870 849 1926.50 909.50Q1983 970 2015.50 1049Q2048 1128 2048 1216L2048 1216Q2048 1309 2012.50 1390.50Q1977 1472 1916.50 1532.50Q1856 1593 1774.50 1628.50Q1693 1664 1600 1664L1600 1664L1536 1664L1536 1536L1600 1536Q1666 1536 1724.50 1511Q1783 1486 1826.50 1442.50Q1870 1399 1895 1340.50Q1920 1282 1920 1216L1920 1216Q1920 1150 1895 1091.50Q1870 1033 1826.50 989.50Q1783 946 1724.50 921Q1666 896 1600 896L1600 896Q1582 896 1564.50 898Q1547 900 1530 904L1530 904Q1520 820 1481 748.50Q1442 677 1383 624.50Q1324 572 1248 542Q1172 512 1088 512L1088 512Q1018 512 953 533Q888 554 833.50 592Q779 630 737 683.50Q695 737 670 803L670 803Q595 768 512 768L512 768Q432 768 362.50 798Q293 828 240.50 880.50Q188 933 158 1003Q128 1073 128 1152L128 1152Q128 1232 158 1301.50Q188 1371 240.50 1423.50Q293 1476 362.50 1506Q432 1536 512 1536L512 1536L640 1536L640 1664L512 1664Q406 1664 313 1623.50Q220 1583 150.50 1513.50Q81 1444 40.50 1351Q0 1258 0 1152L0 1152Q0 1046 40.50 953Q81 860 150.50 790.50Q220 721 313 680.50Q406 640 512 640L512 640Q558 640 605 649L605 649Q645 588 698 539Q751 490 813 455.50Q875 421 945 402.50Q1015 384 1088 384L1088 384Q1179 384 1263.50 412Q1348 440 1419.50 490.50Q1491 541 1545 612Q1599 683 1629 769ZM1024 1280L1152 1280L1152 1536L1408 1536L1408 1664L1152 1664L1152 1920L1024 1920L1024 1664L768 1664L768 1536L1024 1536L1024 1280Z"
         }
      }
   ]
}

var DRM = {
   name: "DRM",
   vendor: "UiFabric",
   unicode: 60584,
   value: "",
   charCode: "ECA8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1215Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q828 1920 705 1885.50Q582 1851 475.50 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444.50Q69 1338 34.50 1215.50Q0 1093 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 704.50 34.50Q827 0 960 0ZM1536 1024L1536 896L384 896L384 1024L1536 1024Z"
         }
      }
   ]
}

var PartyLeader = {
   name: "PartyLeader",
   vendor: "UiFabric",
   unicode: 60583,
   value: "",
   charCode: "ECA7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1168 946L1168 946Q1206 961 1242 979Q1278 997 1312 1020L1312 1020Q1290 1044 1272 1070.50Q1254 1097 1239 1126L1239 1126Q1162 1076 1074.50 1050Q987 1024 896 1024L896 1024Q808 1024 726 1047Q644 1070 573 1111.50Q502 1153 443.50 1211.50Q385 1270 343.50 1341Q302 1412 279 1494Q256 1576 256 1664L256 1664L128 1664Q128 1544 163.50 1433Q199 1322 264 1228Q329 1134 420.50 1061Q512 988 624 946L624 946Q511 872 447.50 760Q384 648 384 512L384 512Q384 406 424 312.50Q464 219 533.50 149.50Q603 80 696.50 40Q790 0 896 0L896 0Q1002 0 1095.50 40Q1189 80 1258.50 149.50Q1328 219 1368 312.50Q1408 406 1408 512L1408 512Q1408 578 1391.50 641Q1375 704 1344 760Q1313 816 1268.50 863.50Q1224 911 1168 946ZM512 512L512 512Q512 592 542 661.50Q572 731 624.50 783.50Q677 836 746.50 866Q816 896 896 896L896 896Q975 896 1045 866Q1115 836 1167.50 783.50Q1220 731 1250 661.50Q1280 592 1280 512L1280 512Q1280 433 1250 363Q1220 293 1167.50 240.50Q1115 188 1045 158Q975 128 896 128L896 128Q816 128 746.50 158Q677 188 624.50 240.50Q572 293 542 363Q512 433 512 512ZM1984 1344L1984 1344Q1984 1396 1967.50 1445Q1951 1494 1920 1536L1920 1536L1920 2048L1664 1920L1408 2048L1408 1536Q1377 1494 1360.50 1445Q1344 1396 1344 1344L1344 1344Q1344 1278 1369 1220Q1394 1162 1437.50 1118.50Q1481 1075 1539.50 1049.50Q1598 1024 1664 1024L1664 1024Q1730 1024 1788 1049.50Q1846 1075 1889.50 1118.50Q1933 1162 1958.50 1220Q1984 1278 1984 1344ZM1664 1152L1664 1152Q1624 1152 1589 1167Q1554 1182 1528 1208Q1502 1234 1487 1269Q1472 1304 1472 1344L1472 1344Q1472 1384 1487 1419Q1502 1454 1528 1480Q1554 1506 1589 1521Q1624 1536 1664 1536L1664 1536Q1704 1536 1739 1521Q1774 1506 1800 1480Q1826 1454 1841 1419Q1856 1384 1856 1344L1856 1344Q1856 1304 1841 1269Q1826 1234 1800 1208Q1774 1182 1739 1167Q1704 1152 1664 1152ZM1792 1841L1792 1841L1792 1637Q1732 1664 1664 1664L1664 1664Q1596 1664 1536 1637L1536 1637L1536 1841Q1568 1825 1600 1809.50Q1632 1794 1664 1777L1664 1777Q1696 1794 1728 1809.50Q1760 1825 1792 1841Z"
         }
      }
   ]
}

var Org = {
   name: "Org",
   vendor: "UiFabric",
   unicode: 60582,
   value: "",
   charCode: "ECA6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 896L1664 1280L1920 1280L1920 1920L1280 1920L1280 1280L1536 1280L1536 1024L384 1024L384 1280L640 1280L640 1920L0 1920L0 1280L256 1280L256 896L896 896L896 640L640 640L640 0L1280 0L1280 640L1024 640L1024 896L1664 896ZM1152 128L768 128L768 512L1152 512L1152 128ZM128 1792L512 1792L512 1408L128 1408L128 1792ZM1408 1792L1792 1792L1792 1408L1408 1408L1408 1792Z"
         }
      }
   ]
}

var Tiles = {
   name: "Tiles",
   vendor: "UiFabric",
   unicode: 60581,
   value: "",
   charCode: "ECA5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L1280 256L1280 896L0 896L0 256ZM128 768L1152 768L1152 384L128 384L128 768ZM1408 896L1408 256L2048 256L2048 896L1408 896ZM1536 768L1920 768L1920 384L1536 384L1536 768ZM2048 1664L768 1664L768 1024L2048 1024L2048 1664ZM1920 1152L896 1152L896 1536L1920 1536L1920 1152ZM640 1664L0 1664L0 1024L640 1024L640 1664ZM512 1152L128 1152L128 1536L512 1536L512 1152Z"
         }
      }
   ]
}

var Cake = {
   name: "Cake",
   vendor: "UiFabric",
   unicode: 60580,
   value: "",
   charCode: "ECA4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 256L1216 256Q1190 256 1171 237Q1152 218 1152 192L1152 192Q1152 180 1160 161Q1168 142 1178.50 121Q1189 100 1199.50 81Q1210 62 1216 51L1216 51Q1222 62 1232.50 81Q1243 100 1253.50 121Q1264 142 1272 161Q1280 180 1280 192L1280 192Q1280 218 1261 237Q1242 256 1216 256ZM1536 384L2048 896L2048 2048L0 2048L0 896L1152 512L1152 352Q1152 343 1159.50 336.50Q1167 330 1177.50 326.50Q1188 323 1198.50 321.50Q1209 320 1216 320L1216 320Q1223 320 1233.50 321.50Q1244 323 1254.50 326.50Q1265 330 1272.50 336.50Q1280 343 1280 352L1280 352L1280 469L1536 384ZM1216 768L1216 768Q1209 768 1198.50 766.50Q1188 765 1177.50 761.50Q1167 758 1159.50 751.50Q1152 745 1152 736L1152 736L1152 647L405 896L1867 896L1501 530L1280 604L1280 736Q1280 745 1272.50 751.50Q1265 758 1254.50 761.50Q1244 765 1233.50 766.50Q1223 768 1216 768ZM1920 1024L128 1024L128 1408L1920 1408L1920 1024ZM128 1920L1920 1920L1920 1536L128 1536L128 1920Z"
         }
      }
   ]
}

var Event = {
   name: "Event",
   vendor: "UiFabric",
   unicode: 60579,
   value: "",
   charCode: "ECA3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM384 384L384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384ZM128 640L128 1792L1920 1792L1920 640L128 640Z"
         }
      }
   ]
}

var DateTime = {
   name: "DateTime",
   vendor: "UiFabric",
   unicode: 60562,
   value: "",
   charCode: "EC92",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 128L1792 993Q1852 1034 1899.50 1086.50Q1947 1139 1980 1200.50Q2013 1262 2030.50 1331Q2048 1400 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1381 2048 1296 2020.50Q1211 1993 1139.50 1942.50Q1068 1892 1013.50 1821Q959 1750 929 1664L929 1664L128 1664L128 128L384 128L384 0L512 0L512 128L1408 128L1408 0L1536 0L1536 128L1792 128ZM384 256L256 256L256 512L1664 512L1664 256L1536 256L1536 384L1408 384L1408 256L512 256L512 384L384 384L384 256ZM256 1536L899 1536Q896 1505 896 1472L896 1472Q896 1386 920.50 1305Q945 1224 993 1152L993 1152L896 1152L896 1024L1024 1024L1024 1110Q1065 1059 1115.50 1019.50Q1166 980 1223.50 952.50Q1281 925 1344 910.50Q1407 896 1472 896L1472 896Q1572 896 1664 929L1664 929L1664 640L256 640L256 1536ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1536 1152L1536 1408L1728 1408L1728 1536L1408 1536L1408 1152L1536 1152ZM384 1152L384 1024L512 1024L512 1152L384 1152ZM640 1152L640 1024L768 1024L768 1152L640 1152ZM640 896L640 768L768 768L768 896L640 896ZM384 1408L384 1280L512 1280L512 1408L384 1408ZM640 1408L640 1280L768 1280L768 1408L640 1408ZM1024 768L1024 896L896 896L896 768L1024 768ZM1280 768L1280 896L1152 896L1152 768L1280 768ZM1536 768L1536 896L1408 896L1408 768L1536 768Z"
         }
      }
   ]
}

var ScrollUpDown = {
   name: "ScrollUpDown",
   vendor: "UiFabric",
   unicode: 60559,
   value: "",
   charCode: "EC8F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1619 813L1024 219L429 813L339 723L1024 37L1709 723L1619 813ZM429 1235L1024 1829L1619 1235L1709 1325L1024 2011L339 1325L429 1235Z"
         }
      }
   ]
}

var CloudUpload = {
   name: "CloudUpload",
   vendor: "UiFabric",
   unicode: 60558,
   value: "",
   charCode: "EC8E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1629 769L1629 769Q1717 775 1793.50 812Q1870 849 1926.50 909.50Q1983 970 2015.50 1049Q2048 1128 2048 1216L2048 1216Q2048 1309 2012.50 1390.50Q1977 1472 1916.50 1532.50Q1856 1593 1774.50 1628.50Q1693 1664 1600 1664L1600 1664L1280 1664L1280 1536L1600 1536Q1666 1536 1724.50 1511Q1783 1486 1826.50 1442.50Q1870 1399 1895 1340.50Q1920 1282 1920 1216L1920 1216Q1920 1150 1895 1091.50Q1870 1033 1826.50 989.50Q1783 946 1724.50 921Q1666 896 1600 896L1600 896Q1582 896 1564.50 898Q1547 900 1530 904L1530 904Q1520 820 1481 748.50Q1442 677 1383 624.50Q1324 572 1248 542Q1172 512 1088 512L1088 512Q1018 512 953 533Q888 554 833.50 592Q779 630 737 683.50Q695 737 670 803L670 803Q595 768 512 768L512 768Q432 768 362.50 798Q293 828 240.50 880.50Q188 933 158 1003Q128 1073 128 1152L128 1152Q128 1232 158 1301.50Q188 1371 240.50 1423.50Q293 1476 362.50 1506Q432 1536 512 1536L512 1536L896 1536L896 1664L512 1664Q406 1664 313 1623.50Q220 1583 150.50 1513.50Q81 1444 40.50 1351Q0 1258 0 1152L0 1152Q0 1046 40.50 953Q81 860 150.50 790.50Q220 721 313 680.50Q406 640 512 640L512 640Q558 640 605 649L605 649Q645 588 698 539Q751 490 813 455.50Q875 421 945 402.50Q1015 384 1088 384L1088 384Q1179 384 1263.50 412Q1348 440 1419.50 490.50Q1491 541 1545 612Q1599 683 1629 769ZM1389 1299L1299 1389L1152 1243L1152 1920L1024 1920L1024 1243L877 1389L787 1299L1088 998L1389 1299Z"
         }
      }
   ]
}

var DOM = {
   name: "DOM",
   vendor: "UiFabric",
   unicode: 60557,
   value: "",
   charCode: "EC8D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 768L1536 1280L1024 1280L1024 1024L640 1024L640 1536L1024 1536L1024 1408L1536 1408L1536 1920L1024 1920L1024 1664L512 1664L512 512L384 512L384 0L896 0L896 512L640 512L640 896L1024 896L1024 768L1536 768ZM1422 882L1138 882L1138 1166L1422 1166L1422 882ZM498 114L498 398L782 398L782 114L498 114ZM1422 1522L1138 1522L1138 1806L1422 1806L1422 1522Z"
         }
      }
   ]
}

var OfflineStorage = {
   name: "OfflineStorage",
   vendor: "UiFabric",
   unicode: 60556,
   value: "",
   charCode: "EC8C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 128L960 128Q1030 128 1118 136Q1206 144 1294.50 164Q1383 184 1462.50 217.50Q1542 251 1594 302L1594 302Q1625 332 1644.50 367.50Q1664 403 1664 448L1664 448L1664 1600Q1664 1645 1644.50 1680.50Q1625 1716 1594 1746L1594 1746Q1542 1797 1462.50 1830.50Q1383 1864 1294.50 1884Q1206 1904 1118 1912Q1030 1920 960 1920L960 1920Q890 1920 802 1912Q714 1904 625.50 1884Q537 1864 457.50 1830.50Q378 1797 326 1746L326 1746Q295 1716 275.50 1680.50Q256 1645 256 1600L256 1600L256 448Q256 403 275.50 367.50Q295 332 326 302L326 302Q378 251 457.50 217.50Q537 184 625.50 164Q714 144 802 136Q890 128 960 128ZM960 256L960 256Q909 256 853.50 259.50Q798 263 742.50 271.50Q687 280 633 293.50Q579 307 531 326L531 326Q516 332 491 344.50Q466 357 442 373Q418 389 401 408.50Q384 428 384 448L384 448Q384 456 387 463Q390 470 395 477L395 477Q416 509 455.50 533Q495 557 544.50 575Q594 593 650 605.50Q706 618 762 625.50Q818 633 869 636.50Q920 640 960 640L960 640Q1000 640 1051 636.50Q1102 633 1158 625.50Q1214 618 1270 605.50Q1326 593 1375.50 575Q1425 557 1464 533Q1503 509 1525 477L1525 477Q1530 470 1533 463Q1536 456 1536 448L1536 448Q1536 428 1519 408.50Q1502 389 1478 373Q1454 357 1429 344.50Q1404 332 1389 326L1389 326Q1341 307 1287 293.50Q1233 280 1177.50 271.50Q1122 263 1066.50 259.50Q1011 256 960 256ZM960 1792L960 1792Q1011 1792 1066.50 1788.50Q1122 1785 1178 1776.50Q1234 1768 1288 1755Q1342 1742 1389 1722L1389 1722Q1404 1716 1429 1703.50Q1454 1691 1478 1675Q1502 1659 1519 1640Q1536 1621 1536 1600L1536 1600L1536 1406Q1479 1444 1407 1469Q1335 1494 1258 1509Q1181 1524 1104 1530Q1027 1536 960 1536L960 1536Q893 1536 816 1530Q739 1524 662 1509Q585 1494 513 1469Q441 1444 384 1406L384 1406L384 1600Q384 1621 401 1640Q418 1659 442 1675Q466 1691 491 1703.50Q516 1716 531 1722L531 1722Q578 1742 632 1755Q686 1768 742 1776.50Q798 1785 853.50 1788.50Q909 1792 960 1792ZM960 1408L960 1408Q1011 1408 1066.50 1404.50Q1122 1401 1178 1392.50Q1234 1384 1288 1371Q1342 1358 1389 1338L1389 1338Q1404 1332 1429 1319.50Q1454 1307 1478 1291Q1502 1275 1519 1256Q1536 1237 1536 1216L1536 1216L1536 1022Q1479 1060 1407 1085Q1335 1110 1258 1125Q1181 1140 1104 1146Q1027 1152 960 1152L960 1152Q893 1152 816 1146Q739 1140 662 1125Q585 1110 513 1085Q441 1060 384 1022L384 1022L384 1216Q384 1237 401 1256Q418 1275 442 1291Q466 1307 491 1319.50Q516 1332 531 1338L531 1338Q578 1358 632 1371Q686 1384 742 1392.50Q798 1401 853.50 1404.50Q909 1408 960 1408ZM960 1024L960 1024Q1012 1024 1067 1020.50Q1122 1017 1177.50 1008.50Q1233 1000 1287 987Q1341 974 1389 954L1389 954Q1404 948 1429 935.50Q1454 923 1478 907Q1502 891 1519 871.50Q1536 852 1536 832L1536 832L1536 638Q1479 675 1407.50 700Q1336 725 1258.50 740Q1181 755 1104 761.50Q1027 768 960 768L960 768Q893 768 816 761.50Q739 755 661.50 740Q584 725 512.50 700Q441 675 384 638L384 638L384 832Q384 852 401 871.50Q418 891 442 907Q466 923 491 935.50Q516 948 531 954L531 954Q579 974 633 987Q687 1000 742.50 1008.50Q798 1017 853 1020.50Q908 1024 960 1024Z"
         }
      }
   ]
}

var WebComponents = {
   name: "WebComponents",
   vendor: "UiFabric",
   unicode: 60555,
   value: "",
   charCode: "EC8B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 256L1024 1024L1792 1024L1792 1920L128 1920L128 256L1024 256ZM896 384L256 384L256 1024L896 1024L896 384ZM256 1792L896 1792L896 1152L256 1152L256 1792ZM1024 1792L1664 1792L1664 1152L1024 1152L1024 1792ZM1280 768L1280 0L2048 0L2048 768L1280 768ZM1408 640L1920 640L1920 128L1408 128L1408 640Z"
         }
      }
   ]
}

var LowerBrightness = {
   name: "LowerBrightness",
   vendor: "UiFabric",
   unicode: 60554,
   value: "",
   charCode: "EC8A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960L1408 960Q1408 1053 1373 1134.50Q1338 1216 1277 1277Q1216 1338 1134.50 1373Q1053 1408 960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1024 192L1024 384L896 384L896 192L1024 192ZM598 507L507 598L372 462L462 372L598 507ZM384 896L384 1024L192 1024L192 896L384 896ZM372 1458L507 1322L598 1413L462 1548L372 1458ZM896 1728L896 1536L1024 1536L1024 1728L896 1728ZM1322 1413L1413 1322L1548 1458L1458 1548L1322 1413ZM1536 896L1728 896L1728 1024L1536 1024L1536 896ZM1548 462L1413 598L1322 507L1458 372L1548 462Z"
         }
      }
   ]
}

var ExploreContent = {
   name: "ExploreContent",
   vendor: "UiFabric",
   unicode: 60621,
   value: "",
   charCode: "ECCD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L2048 0L2048 1792L1920 1792L1920 128L256 128L256 0ZM128 1920L128 256L1792 256L1792 1920L128 1920ZM256 384L256 1792L1664 1792L1664 384L256 384ZM1024 640L1024 1024L1408 1024L1408 1152L1024 1152L1024 1536L896 1536L896 1152L512 1152L512 1024L896 1024L896 640L1024 640Z"
         }
      }
   ]
}

var RadioBtnOn = {
   name: "RadioBtnOn",
   vendor: "UiFabric",
   unicode: 60619,
   value: "",
   charCode: "ECCB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1024 352L1024 352Q1117 352 1202.50 376Q1288 400 1363 444Q1438 488 1499 549Q1560 610 1604 685Q1648 760 1672 845.50Q1696 931 1696 1024L1696 1024Q1696 1117 1672 1202.50Q1648 1288 1604 1363Q1560 1438 1499 1499Q1438 1560 1363 1604Q1288 1648 1202.50 1672Q1117 1696 1024 1696L1024 1696Q931 1696 845.50 1672Q760 1648 685 1604Q610 1560 549 1499Q488 1438 444 1363Q400 1288 376 1202.50Q352 1117 352 1024L352 1024Q352 931 376 845.50Q400 760 444 685Q488 610 549 549Q610 488 685 444Q760 400 845.50 376Q931 352 1024 352Z"
         }
      }
   ]
}

var RadioBtnOff = {
   name: "RadioBtnOff",
   vendor: "UiFabric",
   unicode: 60618,
   value: "",
   charCode: "ECCA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920Z"
         }
      }
   ]
}

var AddTo = {
   name: "AddTo",
   vendor: "UiFabric",
   unicode: 60616,
   value: "",
   charCode: "ECC8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1088 640L1088 960L1408 960L1408 1088L1088 1088L1088 1408L960 1408L960 1088L640 1088L640 960L960 960L960 640L1088 640ZM1024 128L1024 128Q1148 128 1262.50 160Q1377 192 1476.50 250.50Q1576 309 1657.50 390.50Q1739 472 1797.50 571.50Q1856 671 1888 785.50Q1920 900 1920 1024L1920 1024Q1920 1148 1888 1262.50Q1856 1377 1797.50 1476.50Q1739 1576 1657.50 1657.50Q1576 1739 1476.50 1797.50Q1377 1856 1262.50 1888Q1148 1920 1024 1920L1024 1920Q900 1920 785.50 1888Q671 1856 571.50 1797.50Q472 1739 390.50 1657.50Q309 1576 250.50 1476.50Q192 1377 160 1262.50Q128 1148 128 1024L128 1024Q128 900 160 785.50Q192 671 250.50 571.50Q309 472 390.50 390.50Q472 309 571.50 250.50Q671 192 785.50 160Q900 128 1024 128ZM1024 1792L1024 1792Q1130 1792 1228 1764.50Q1326 1737 1411.50 1687Q1497 1637 1567 1567Q1637 1497 1687 1411.50Q1737 1326 1764.50 1228Q1792 1130 1792 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792Z"
         }
      }
   ]
}

var RemoveContent = {
   name: "RemoveContent",
   vendor: "UiFabric",
   unicode: 60615,
   value: "",
   charCode: "ECC7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1955 1155L2045 1245L1690 1600L2045 1955L1955 2045L1600 1690L1245 2045L1155 1955L1510 1600L1155 1245L1245 1155L1600 1510L1955 1155ZM256 256L256 1792L1120 1792L992 1920L128 1920L128 128L1920 128L1920 992L1792 1120L1792 256L256 256Z"
         }
      }
   ]
}

var Embed = {
   name: "Embed",
   vendor: "UiFabric",
   unicode: 60622,
   value: "",
   charCode: "ECCE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M37 1024L467 595L557 685L219 1024L557 1363L467 1453L37 1024ZM1491 685L1581 595L2011 1024L1581 1453L1491 1363L1829 1024L1491 685ZM835 1792L701 1792L1213 256L1347 256L835 1792Z"
         }
      }
   ]
}

var PageHeader = {
   name: "PageHeader",
   vendor: "UiFabric",
   unicode: 60654,
   value: "",
   charCode: "ECEE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M127 2048L127 0L1919 0L1919 2048L127 2048ZM256 1921L1792 1921L1792 129L256 129L256 1921ZM383 258L1663 258L1663 897L383 897L383 258ZM512 768L1536 768L1536 387L512 387L512 768ZM383 1024L1663 1024L1663 1665L383 1665L383 1024ZM512 1536L1536 1536L1536 1153L512 1153L512 1536Z"
         }
      }
   ]
}

var Toolbox = {
   name: "Toolbox",
   vendor: "UiFabric",
   unicode: 60653,
   value: "",
   charCode: "ECED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 256L1408 512L2048 512L2048 1664L0 1664L0 512L640 512L640 256L1408 256ZM1280 384L768 384L768 512L1280 512L1280 384ZM1920 896L1920 640L128 640L128 896L512 896L512 768L640 768L640 896L1408 896L1408 768L1536 768L1536 896L1920 896ZM128 1024L128 1536L1920 1536L1920 1024L1536 1024L1536 1152L1408 1152L1408 1024L640 1024L640 1152L512 1152L512 1024L128 1024Z"
         }
      }
   ]
}

var FangBody = {
   name: "FangBody",
   vendor: "UiFabric",
   unicode: 60651,
   value: "",
   charCode: "ECEB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1709 1668L1709 1668Q1755 1676 1793.50 1699Q1832 1722 1860 1755.50Q1888 1789 1904 1831.50Q1920 1874 1920 1920L1920 1920L1920 2048L384 2048Q304 2048 234 2018Q164 1988 112 1936Q60 1884 30 1814Q0 1744 0 1664L0 1664Q0 1585 30 1515Q60 1445 112.50 1392.50Q165 1340 234.50 1310Q304 1280 384 1280L384 1280L384 1408Q331 1408 284.50 1428Q238 1448 203 1483Q168 1518 148 1564.50Q128 1611 128 1664L128 1664Q128 1717 148 1763.50Q168 1810 203 1845Q238 1880 284.50 1900Q331 1920 384 1920L384 1920Q409 1920 433 1910.50Q457 1901 475 1883L475 1883Q493 1865 502.50 1841Q512 1817 512 1792L512 1792Q512 1596 585 1415L585 1415Q620 1327 670.50 1251.50Q721 1176 786 1108L786 1108Q903 985 963.50 833.50Q1024 682 1024 512L1024 512L1024 384Q1024 331 1044 284.50Q1064 238 1099 203Q1134 168 1180.50 148Q1227 128 1280 128L1280 128L1472 128Q1534 128 1582 149Q1630 170 1676 210L1676 210Q1702 233 1729.50 244.50Q1757 256 1792 256L1792 256Q1819 256 1842 266Q1865 276 1882.50 293.50Q1900 311 1910 334Q1920 357 1920 384L1920 384L1920 512Q1920 552 1905 587Q1890 622 1864 648Q1838 674 1803 689Q1768 704 1728 704L1728 704L1664 704L1664 1408Q1664 1474 1675 1539.50Q1686 1605 1709 1668ZM1536 1920L1792 1920Q1792 1894 1782 1870.50Q1772 1847 1754.50 1829.50Q1737 1812 1713.50 1802Q1690 1792 1664 1792L1664 1792L1621 1792Q1601 1743 1585.50 1697Q1570 1651 1559 1604.50Q1548 1558 1542 1509.50Q1536 1461 1536 1408L1536 1408L1536 704Q1536 677 1546 654Q1556 631 1573.50 613.50Q1591 596 1614 586Q1637 576 1664 576L1664 576Q1682 576 1704.50 576.50Q1727 577 1746.50 572Q1766 567 1779 553.50Q1792 540 1792 512L1792 512L1792 384Q1747 384 1714 374.50Q1681 365 1656 351Q1631 337 1610.50 320Q1590 303 1569.50 289Q1549 275 1526 265.50Q1503 256 1472 256L1472 256L1280 256Q1254 256 1230.50 266Q1207 276 1189.50 293.50Q1172 311 1162 334.50Q1152 358 1152 384L1152 384L1152 576Q1152 602 1171 621Q1190 640 1216 640L1216 640Q1244 640 1257.50 627Q1271 614 1276 594.50Q1281 575 1280.50 552.50Q1280 530 1280 512L1280 512L1408 512L1408 576Q1408 616 1393 651Q1378 686 1352 712Q1326 738 1291 753Q1256 768 1216 768L1216 768Q1168 768 1125 745L1125 745Q1093 876 1031.50 987.50Q970 1099 878 1196L878 1196Q761 1319 700.50 1470.50Q640 1622 640 1792L640 1792Q640 1860 606 1920L606 1920L1408 1920Q1408 1893 1398 1870Q1388 1847 1370.50 1829.50Q1353 1812 1330 1802Q1307 1792 1280 1792L1280 1792L1152 1792Q1152 1739 1132 1692.50Q1112 1646 1077 1611Q1042 1576 995.50 1556Q949 1536 896 1536L896 1536L896 1408Q958 1408 1014.50 1426.50Q1071 1445 1118 1478.50Q1165 1512 1201 1559Q1237 1606 1258 1664L1258 1664L1280 1664L1280 1152L1408 1152L1408 1698Q1468 1733 1502 1792Q1536 1851 1536 1920L1536 1920Z"
         }
      }
   ]
}

var Blocked2 = {
   name: "Blocked2",
   vendor: "UiFabric",
   unicode: 60644,
   value: "",
   charCode: "ECE4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1215Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q828 1920 705 1885.50Q582 1851 475.50 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444.50Q69 1338 34.50 1215.50Q0 1093 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 704.50 34.50Q827 0 960 0ZM960 1792L960 1792Q1075 1792 1181.50 1762.50Q1288 1733 1380.50 1678.50Q1473 1624 1548.50 1548.50Q1624 1473 1678.50 1380.50Q1733 1288 1762.50 1181.50Q1792 1075 1792 960L1792 960Q1792 845 1762.50 738.50Q1733 632 1678.50 539.50Q1624 447 1548.50 371.50Q1473 296 1380.50 241.50Q1288 187 1181.50 157.50Q1075 128 960 128L960 128Q845 128 738.50 157.50Q632 187 539.50 241.50Q447 296 371.50 371.50Q296 447 241.50 539.50Q187 632 157.50 738.50Q128 845 128 960L128 960Q128 1075 157.50 1181.50Q187 1288 241.50 1380.50Q296 1473 371.50 1548.50Q447 1624 539.50 1678.50Q632 1733 738.50 1762.50Q845 1792 960 1792ZM384 1024L384 896L1536 896L1536 1024L384 1024Z"
         }
      }
   ]
}

var Hot = {
   name: "Hot",
   vendor: "UiFabric",
   unicode: 60642,
   value: "",
   charCode: "ECE2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 320L1024 1420Q1052 1430 1076 1448Q1100 1466 1116.50 1489.50Q1133 1513 1142.50 1541.50Q1152 1570 1152 1600L1152 1600Q1152 1640 1137 1675Q1122 1710 1096 1736Q1070 1762 1035 1777Q1000 1792 960 1792L960 1792Q920 1792 885 1777Q850 1762 824 1736Q798 1710 783 1675Q768 1640 768 1600L768 1600Q768 1570 777.50 1541.50Q787 1513 803.50 1489.50Q820 1466 843.50 1448Q867 1430 896 1420L896 1420L896 320Q896 294 915 275Q934 256 960 256L960 256Q986 256 1005 275Q1024 294 1024 320L1024 320ZM1280 320L1280 1319Q1337 1382 1369 1459Q1401 1536 1401 1621L1401 1621Q1401 1711 1365.50 1789Q1330 1867 1269 1924.50Q1208 1982 1128 2015Q1048 2048 960 2048L960 2048Q871 2048 791.50 2015Q712 1982 651 1924.50Q590 1867 554.50 1789Q519 1711 519 1621L519 1621Q519 1536 551 1459Q583 1382 640 1319L640 1319L640 320Q640 254 665 196Q690 138 733.50 94.50Q777 51 835.50 25.50Q894 0 960 0L960 0Q1026 0 1084 25.50Q1142 51 1185.50 94.50Q1229 138 1254.50 196Q1280 254 1280 320L1280 320ZM960 1920L960 1920Q1022 1920 1078.50 1897Q1135 1874 1178 1834Q1221 1794 1246.50 1739Q1272 1684 1272 1621L1272 1621Q1272 1546 1239 1483.50Q1206 1421 1152 1371L1152 1371L1152 320Q1152 280 1137 245Q1122 210 1096 184Q1070 158 1035 143Q1000 128 960 128L960 128Q920 128 885 143Q850 158 824 184Q798 210 783 245Q768 280 768 320L768 320L768 1371Q714 1421 681 1483.50Q648 1546 648 1621L648 1621Q648 1684 673.50 1739Q699 1794 742 1834Q785 1874 841.50 1897Q898 1920 960 1920Z"
         }
      }
   ]
}

var ProgressLoopOuter = {
   name: "ProgressLoopOuter",
   vendor: "UiFabric",
   unicode: 60639,
   value: "",
   charCode: "ECDF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 3L960 131Q832 140 715 184Q598 228 498 300Q398 372 320 470.50Q242 569 194 687L194 687L73 648Q127 510 217 395.50Q307 281 422.50 197Q538 113 675 62.50Q812 12 960 3L960 3ZM1976 648L1854 687Q1806 569 1728 470.50Q1650 372 1550 300Q1450 228 1332.50 184Q1215 140 1088 131L1088 131L1088 3Q1236 12 1373 62.50Q1510 113 1625.50 197Q1741 281 1831 395.50Q1921 510 1976 648L1976 648ZM128 1024L128 1024Q128 1123 149.50 1218.50Q171 1314 212 1401.50Q253 1489 312 1567Q371 1645 447 1709L447 1709L372 1813Q284 1740 215 1650.50Q146 1561 98 1460Q50 1359 25 1249Q0 1139 0 1024L0 1024Q0 959 8.50 895.50Q17 832 33 769L33 769L155 809Q142 862 135 916Q128 970 128 1024ZM1893 809L2015 769Q2031 832 2039.50 895.50Q2048 959 2048 1024L2048 1024Q2048 1139 2023 1249Q1998 1359 1950 1460Q1902 1561 1833 1650.50Q1764 1740 1676 1813L1676 1813L1601 1709Q1677 1645 1736 1567Q1795 1489 1836 1401.50Q1877 1314 1898.50 1218.50Q1920 1123 1920 1024L1920 1024Q1920 970 1913 916Q1906 862 1893 809L1893 809ZM1024 1920L1024 1920Q1151 1920 1270.50 1885.50Q1390 1851 1497 1784L1497 1784L1572 1887Q1449 1966 1309.50 2007Q1170 2048 1024 2048L1024 2048Q878 2048 738.50 2007Q599 1966 476 1887L476 1887L551 1784Q658 1851 777.50 1885.50Q897 1920 1024 1920Z"
         }
      }
   ]
}

var ProgressLoopInner = {
   name: "ProgressLoopInner",
   vendor: "UiFabric",
   unicode: 60638,
   value: "",
   charCode: "ECDE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 1024L448 1024Q448 1084 460.50 1142Q473 1200 496 1254L496 1254L385 1318Q353 1249 336.50 1174.50Q320 1100 320 1024L320 1024Q320 933 342.50 848Q365 763 406 688Q447 613 505 549.50Q563 486 634 438.50Q705 391 787.50 361Q870 331 960 323L960 323L960 452Q851 464 757.50 513.50Q664 563 595 640Q526 717 487 815.50Q448 914 448 1024ZM1088 452L1088 323Q1178 331 1260.50 361Q1343 391 1414 438.50Q1485 486 1543 549.50Q1601 613 1642 688Q1683 763 1705.50 848Q1728 933 1728 1024L1728 1024Q1728 1101 1711.50 1175.50Q1695 1250 1663 1319L1663 1319L1552 1255Q1575 1200 1587.50 1142Q1600 1084 1600 1024L1600 1024Q1600 914 1561 815.50Q1522 717 1453 640Q1384 563 1290.50 513.50Q1197 464 1088 452L1088 452ZM1024 1600L1024 1600Q1093 1600 1158.50 1584Q1224 1568 1283.50 1537.50Q1343 1507 1394.50 1463.50Q1446 1420 1487 1365L1487 1365L1598 1430Q1548 1500 1484.50 1555.50Q1421 1611 1347.50 1649Q1274 1687 1192 1707.50Q1110 1728 1024 1728L1024 1728Q938 1728 856 1707.50Q774 1687 700 1648.50Q626 1610 562 1554.50Q498 1499 449 1429L449 1429L561 1365Q602 1420 653.50 1463.50Q705 1507 764.50 1537.50Q824 1568 889.50 1584Q955 1600 1024 1600Z"
         }
      }
   ]
}

var Product = {
   name: "Product",
   vendor: "UiFabric",
   unicode: 60636,
   value: "",
   charCode: "ECDC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 536L960 120L1792 536L1792 1576L960 1991L128 1576L128 536ZM1340 698L1585 576L960 264L719 384L1340 698ZM335 576L960 888L1198 770L576 456L335 576ZM896 1000L256 680L256 1496L896 1816L896 1000ZM1024 1000L1024 1816L1664 1496L1664 680L1024 1000Z"
         }
      }
   ]
}

var ChatInviteFriend = {
   name: "ChatInviteFriend",
   vendor: "UiFabric",
   unicode: 60670,
   value: "",
   charCode: "ECFE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1762 1590L1762 1590Q1828 1622 1880.50 1670.50Q1933 1719 1970.50 1778.50Q2008 1838 2028 1906.50Q2048 1975 2048 2048L2048 2048L1920 2048Q1920 1969 1889.50 1899Q1859 1829 1807 1777Q1755 1725 1685 1694.50Q1615 1664 1536 1664L1536 1664Q1457 1664 1387 1694.50Q1317 1725 1265 1777Q1213 1829 1182.50 1899Q1152 1969 1152 2048L1152 2048L1024 2048Q1024 1975 1044 1906.50Q1064 1838 1101.50 1778.50Q1139 1719 1191.50 1670.50Q1244 1622 1310 1590L1310 1590Q1235 1536 1193.50 1454.50Q1152 1373 1152 1280L1152 1280Q1152 1201 1182 1131Q1212 1061 1264.50 1008.50Q1317 956 1386.50 926Q1456 896 1536 896L1536 896Q1615 896 1685 926Q1755 956 1807.50 1008.50Q1860 1061 1890 1131Q1920 1201 1920 1280L1920 1280Q1920 1373 1878.50 1454.50Q1837 1536 1762 1590ZM1536 1536L1536 1536Q1589 1536 1635.50 1516Q1682 1496 1717 1461Q1752 1426 1772 1379.50Q1792 1333 1792 1280L1792 1280Q1792 1227 1772 1180.50Q1752 1134 1717 1099Q1682 1064 1635.50 1044Q1589 1024 1536 1024L1536 1024Q1483 1024 1436.50 1044Q1390 1064 1355 1099Q1320 1134 1300 1180.50Q1280 1227 1280 1280L1280 1280Q1280 1333 1300 1379.50Q1320 1426 1355 1461Q1390 1496 1436.50 1516Q1483 1536 1536 1536ZM0 128L2048 128L2048 1152Q2048 1104 2039 1068Q2030 1032 2013.50 1001Q1997 970 1973.50 941Q1950 912 1920 878L1920 878L1920 256L128 256L128 1408L384 1408L384 1675L651 1408L1041 1408Q1049 1442 1062.50 1474Q1076 1506 1093 1536L1093 1536L704 1536L256 1984L256 1536L0 1536L0 128Z"
         }
      }
   ]
}

var Brush = {
   name: "Brush",
   vendor: "UiFabric",
   unicode: 60671,
   value: "",
   charCode: "ECFF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1803 128L1803 128Q1854 128 1898.50 147.50Q1943 167 1976 200Q2009 233 2028.50 277.50Q2048 322 2048 373L2048 373Q2048 422 2029.50 466.50Q2011 511 1976 546L1976 546Q1673 849 1370.50 1152Q1068 1455 765 1758L765 1758Q759 1819 732 1872Q705 1925 662.50 1964Q620 2003 564.50 2025.50Q509 2048 448 2048L448 2048L192 2048Q152 2048 117 2033Q82 2018 56 1992Q30 1966 15 1931Q0 1896 0 1856L0 1856L0 1792L64 1792Q90 1792 109 1773Q128 1754 128 1728L128 1728Q128 1667 150.50 1611.50Q173 1556 212 1513.50Q251 1471 304 1444Q357 1417 418 1411L418 1411Q721 1108 1024 805.50Q1327 503 1630 200L1630 200Q1665 165 1709.50 146.50Q1754 128 1803 128ZM692 1319L576 1435Q631 1459 674 1502Q717 1545 741 1600L741 1600L857 1484Q796 1380 692 1319L692 1319ZM192 1920L448 1920Q488 1920 523 1905Q558 1890 584 1864Q610 1838 625 1803Q640 1768 640 1728L640 1728Q640 1688 625 1653Q610 1618 584 1592Q558 1566 523 1551Q488 1536 448 1536L448 1536Q408 1536 373 1551Q338 1566 312 1592Q286 1618 271 1653Q256 1688 256 1728L256 1728Q256 1783 226.50 1830Q197 1877 147 1901L147 1901Q165 1920 192 1920L192 1920ZM950 1391L1886 456Q1920 422 1920 373L1920 373Q1920 349 1911 327.50Q1902 306 1886 290Q1870 274 1848.50 265Q1827 256 1803 256L1803 256Q1754 256 1720 290L1720 290L785 1226Q884 1292 950 1391L950 1391Z"
         }
      }
   ]
}

var Shirt = {
   name: "Shirt",
   vendor: "UiFabric",
   unicode: 60672,
   value: "",
   charCode: "ED00",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 128L2048 384L1920 896L1664 896L1664 1920L384 1920L384 896L128 896L0 384L768 128Q768 181 788 227.50Q808 274 843 309Q878 344 924.50 364Q971 384 1024 384L1024 384Q1077 384 1123.50 364Q1170 344 1205 309Q1240 274 1260 227.50Q1280 181 1280 128L1280 128ZM1820 768L1895 468L1371 293Q1347 343 1310.50 383.50Q1274 424 1229 452.50Q1184 481 1131.50 496.50Q1079 512 1024 512L1024 512Q968 512 916 496.50Q864 481 819 452.50Q774 424 737.50 383.50Q701 343 677 293L677 293L153 468L228 768L512 768L512 1792L1536 1792L1536 768L1820 768Z"
         }
      }
   ]
}

var Crown = {
   name: "Crown",
   vendor: "UiFabric",
   unicode: 60673,
   value: "",
   charCode: "ED01",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1793 321L1793 321Q1833 321 1868 336Q1903 351 1929 377Q1955 403 1970 438Q1985 473 1985 513L1985 513Q1985 553 1969.50 588Q1954 623 1928 649Q1902 675 1867 690Q1832 705 1792 705L1792 705L1792 1921L256 1921L256 705Q216 705 181.50 690Q147 675 121 648.50Q95 622 80 587Q65 552 65 513L65 513Q65 473 80 438Q95 403 121 377Q147 351 182 336Q217 321 257 321L257 321Q297 321 332 336Q367 351 393 377Q419 403 434 438Q449 473 449 513L449 513Q449 568 419.50 615.50Q390 663 340 686L340 686L701 1165L961 694Q932 684 908.50 666Q885 648 868 624Q851 600 842 571.50Q833 543 833 513L833 513Q833 473 848 438Q863 403 889 377Q915 351 950 336Q985 321 1025 321L1025 321Q1065 321 1100 336Q1135 351 1161 377Q1187 403 1202 438Q1217 473 1217 513L1217 513Q1217 574 1182.50 623Q1148 672 1091 693L1091 693L1354 1166L1708 685Q1659 661 1630 614.50Q1601 568 1601 513L1601 513Q1601 473 1616 438Q1631 403 1657 377Q1683 351 1718 336Q1753 321 1793 321ZM961 513L961 513Q961 540 980.50 558.50Q1000 577 1026 577L1026 577L1026 576L1027 577Q1053 576 1071 557.50Q1089 539 1089 513L1089 513Q1089 487 1070 468Q1051 449 1025 449L1025 449Q999 449 980 468Q961 487 961 513ZM193 513L193 513Q193 539 211.50 558Q230 577 256 577L256 577L256 576L257 577Q283 577 302 558Q321 539 321 513L321 513Q321 487 302 468Q283 449 257 449L257 449Q231 449 212 468Q193 487 193 513ZM1663 1792L1663 964L1339 1405L1027 842L718 1401L385 960L385 1792L1663 1792ZM1792 572L1792 577Q1818 577 1837.50 558.50Q1857 540 1857 513L1857 513Q1857 487 1838 468Q1819 449 1793 449L1793 449Q1767 449 1748 468Q1729 487 1729 513L1729 513Q1729 538 1746 556.50Q1763 575 1788 577L1788 577L1792 572Z"
         }
      }
   ]
}

var Diamond = {
   name: "Diamond",
   vendor: "UiFabric",
   unicode: 60674,
   value: "",
   charCode: "ED02",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1391 256L1928 829L1024 1942L120 829L657 256L1391 256ZM786 768L1262 768L1118 384L930 384L786 768ZM1269 896L779 896L1024 1754L1269 896ZM814 384L686 384L327 768L670 768L814 384ZM665 896L314 896L856 1563L665 896ZM1383 896L1192 1563L1734 896L1383 896ZM1378 768L1721 768L1362 384L1234 384L1378 768Z"
         }
      }
   ]
}

var Glimmer = {
   name: "Glimmer",
   vendor: "UiFabric",
   unicode: 60660,
   value: "",
   charCode: "ECF4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1280L1792 0L2048 0L2048 1280L1792 1280ZM1280 2048L0 2048L0 1792L1280 1792L1280 2048ZM1382 1562L486 666L666 486L1562 1382L1382 1562Z"
         }
      }
   ]
}

var ScaleUp = {
   name: "ScaleUp",
   vendor: "UiFabric",
   unicode: 60681,
   value: "",
   charCode: "ED09",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1536L256 1536L256 512L1792 512L1792 1536ZM1664 640L384 640L384 1408L1664 1408L1664 640ZM1664 384L1664 256L2048 256L2048 640L1920 640L1920 384L1664 384ZM384 384L128 384L128 640L0 640L0 256L384 256L384 384ZM1664 1664L1920 1664L1920 1408L2048 1408L2048 1792L1664 1792L1664 1664ZM0 1408L128 1408L128 1664L384 1664L384 1792L0 1792L0 1408Z"
         }
      }
   ]
}

var ResetDevice = {
   name: "ResetDevice",
   vendor: "UiFabric",
   unicode: 60688,
   value: "",
   charCode: "ED10",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1792L1280 1792L1280 1664L1536 1664L1536 1792ZM768 768L768 1152L640 1152L640 768L768 768ZM640 1408L640 1280L768 1280L768 1408L640 1408ZM1280 1088L1280 1088Q1280 1207 1234.50 1312Q1189 1417 1111 1495Q1033 1573 928 1618.50Q823 1664 704 1664L704 1664Q585 1664 480 1618.50Q375 1573 297 1495Q219 1417 173.50 1312Q128 1207 128 1088L128 1088L128 1024L256 1024L256 1088Q256 1181 291.50 1262.50Q327 1344 387.50 1404.50Q448 1465 529.50 1500.50Q611 1536 704 1536L704 1536Q797 1536 878.50 1500.50Q960 1465 1020.50 1404.50Q1081 1344 1116.50 1262.50Q1152 1181 1152 1088L1152 1088Q1152 995 1116.50 913.50Q1081 832 1020.50 771.50Q960 711 878.50 675.50Q797 640 704 640L704 640L282 640L429 787L339 877L37 576L339 275L429 365L282 512L704 512Q823 512 928 557.50Q1033 603 1111 681Q1189 759 1234.50 864Q1280 969 1280 1088ZM896 0L1920 0Q1947 0 1970 10Q1993 20 2010.50 37.50Q2028 55 2038 78Q2048 101 2048 128L2048 128L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L896 2048Q869 2048 846 2038Q823 2028 805.50 2010.50Q788 1993 778 1970Q768 1947 768 1920L768 1920L768 1821Q800 1818 832 1812Q864 1806 896 1798L896 1798L896 1920L1920 1920L1920 128L896 128L896 378Q864 370 832 364Q800 358 768 355L768 355L768 128Q768 101 778 78Q788 55 805.50 37.50Q823 20 846 10Q869 0 896 0L896 0Z"
         }
      }
   ]
}

var QRCode = {
   name: "QRCode",
   vendor: "UiFabric",
   unicode: 60692,
   value: "",
   charCode: "ED14",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 640L384 640L384 384L640 384L640 640ZM896 896L128 896L128 128L896 128L896 896ZM768 256L256 256L256 768L768 768L768 256ZM640 1664L384 1664L384 1408L640 1408L640 1664ZM896 1920L128 1920L128 1152L896 1152L896 1920ZM768 1280L256 1280L256 1792L768 1792L768 1280ZM1408 384L1664 384L1664 640L1408 640L1408 384ZM1152 896L1152 128L1920 128L1920 896L1152 896ZM1280 768L1792 768L1792 256L1280 256L1280 768ZM1152 1664L1152 1536L1280 1536L1280 1664L1152 1664ZM1408 1152L1408 1280L1280 1280L1280 1408L1152 1408L1152 1152L1408 1152ZM1536 1152L1664 1152L1664 1280L1536 1280L1536 1152ZM1408 1280L1536 1280L1536 1536L1280 1536L1280 1408L1408 1408L1408 1280ZM1280 1792L1280 1664L1536 1664L1536 1792L1408 1792L1408 1920L1152 1920L1152 1792L1280 1792ZM1792 1920L1536 1920L1536 1792L1792 1792L1792 1920ZM1920 1536L1920 1792L1792 1792L1792 1536L1920 1536ZM1664 1280L1792 1280L1792 1152L1920 1152L1920 1408L1792 1408L1792 1536L1664 1536L1664 1280ZM1664 1664L1536 1664L1536 1536L1664 1536L1664 1664Z"
         }
      }
   ]
}

var Feedback = {
   name: "Feedback",
   vendor: "UiFabric",
   unicode: 60693,
   value: "",
   charCode: "ED15",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M958 1328L958 1328Q1059 1368 1142 1434.50Q1225 1501 1284 1587Q1343 1673 1375.50 1774Q1408 1875 1408 1984L1408 1984L1408 2048L1280 2048L1280 1984Q1280 1865 1234.50 1760Q1189 1655 1111 1577Q1033 1499 928 1453.50Q823 1408 704 1408L704 1408Q585 1408 480 1453.50Q375 1499 297 1577Q219 1655 173.50 1760Q128 1865 128 1984L128 1984L128 2048L0 2048L0 1984Q0 1875 32.50 1774Q65 1673 124 1587Q183 1501 266 1434.50Q349 1368 450 1328L450 1328Q405 1297 369 1256Q333 1215 308 1167.50Q283 1120 269.50 1067.50Q256 1015 256 960L256 960Q256 867 291.50 785.50Q327 704 387.50 643.50Q448 583 529.50 547.50Q611 512 704 512L704 512Q797 512 878.50 547.50Q960 583 1020.50 643.50Q1081 704 1116.50 785.50Q1152 867 1152 960L1152 960Q1152 1015 1138.50 1067.50Q1125 1120 1100 1167.50Q1075 1215 1039 1256Q1003 1297 958 1328ZM704 1280L704 1280Q770 1280 828 1255Q886 1230 929.50 1186.50Q973 1143 998.50 1084.50Q1024 1026 1024 960L1024 960Q1024 894 998.50 836Q973 778 929.50 734.50Q886 691 828 665.50Q770 640 704 640L704 640Q638 640 579.50 665.50Q521 691 477.50 734.50Q434 778 409 836Q384 894 384 960L384 960Q384 1026 409 1084.50Q434 1143 477.50 1186.50Q521 1230 579.50 1255Q638 1280 704 1280ZM512 0L2048 0L2048 1024L1792 1024L1408 1408L1408 1024L1280 1024L1280 896L1536 896L1536 1099L1739 896L1920 896L1920 128L640 128L640 358Q608 362 575.50 368.50Q543 375 512 386L512 386L512 0Z"
         }
      }
   ]
}

var SharepointLogoInverse = {
   name: "SharepointLogoInverse",
   vendor: "UiFabric",
   unicode: 60696,
   value: "",
   charCode: "ED18",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1152L2048 1152Q2048 1258 2007.50 1351Q1967 1444 1897.50 1513.50Q1828 1583 1735 1623.50Q1642 1664 1536 1664L1536 1664Q1471 1664 1406 1647L1406 1647Q1397 1732 1358.50 1805.50Q1320 1879 1260 1933Q1200 1987 1123 2017.50Q1046 2048 960 2048L960 2048Q867 2048 785.50 2012.50Q704 1977 643.50 1916.50Q583 1856 547.50 1774.50Q512 1693 512 1600L512 1600Q512 1584 513.50 1568Q515 1552 517 1536L517 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L387 512Q399 403 449 309.50Q499 216 576 147Q653 78 751.50 39Q850 0 960 0L960 0Q1079 0 1184 45.50Q1289 91 1367 169Q1445 247 1490.50 352Q1536 457 1536 576L1536 576Q1536 592 1535 608Q1534 624 1532 640L1532 640Q1638 640 1732 680Q1826 720 1896.50 789Q1967 858 2007.50 951.50Q2048 1045 2048 1152ZM960 128L960 128Q877 128 801.50 157Q726 186 667 237.50Q608 289 568.50 359.50Q529 430 517 512L517 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 1019L1042 1016Q1060 952 1094 894.50Q1128 837 1174.50 790.50Q1221 744 1278 710Q1335 676 1400 658L1400 658Q1408 615 1408 576L1408 576Q1408 483 1372.50 401.50Q1337 320 1276.50 259.50Q1216 199 1134.50 163.50Q1053 128 960 128ZM522 1357L522 1357Q568 1357 612.50 1347.50Q657 1338 692 1316Q727 1294 748.50 1258Q770 1222 770 1168L770 1168Q770 1114 747.50 1078Q725 1042 691 1018Q657 994 618 978.50Q579 963 545 949.50Q511 936 488.50 921Q466 906 466 883L466 883Q466 866 478 855.50Q490 845 506.50 839Q523 833 541 831Q559 829 571 829L571 829Q622 829 661 842Q700 855 742 881L742 881L742 729Q718 722 697.50 717Q677 712 657 708.50Q637 705 615.50 703.50Q594 702 568 702L568 702Q524 702 478 712Q432 722 394.50 744Q357 766 333.50 802Q310 838 310 890L310 890Q310 941 332.50 975Q355 1009 389 1033Q423 1057 462 1073.50Q501 1090 535 1104.50Q569 1119 591.50 1135Q614 1151 614 1174L614 1174Q614 1193 603.50 1204Q593 1215 577 1221Q561 1227 543.50 1228.50Q526 1230 512 1230L512 1230Q452 1230 405.50 1210Q359 1190 311 1157L311 1157L311 1317Q413 1357 522 1357ZM960 1920L960 1920Q1026 1920 1084 1895Q1142 1870 1185.50 1826.50Q1229 1783 1254.50 1724.50Q1280 1666 1280 1600L1280 1600Q1280 1543 1261 1491Q1242 1439 1208 1397.50Q1174 1356 1127 1327Q1080 1298 1024 1286L1024 1286L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L646 1536Q640 1568 640 1600L640 1600Q640 1666 665 1724.50Q690 1783 733.50 1826.50Q777 1870 835.50 1895Q894 1920 960 1920ZM1536 1536L1536 1536Q1615 1536 1685 1506Q1755 1476 1807.50 1423.50Q1860 1371 1890 1301.50Q1920 1232 1920 1152L1920 1152Q1920 1073 1890 1003Q1860 933 1807.50 880.50Q1755 828 1685 798Q1615 768 1536 768L1536 768Q1457 768 1387.50 798.50Q1318 829 1265.50 881.50Q1213 934 1182.50 1003.50Q1152 1073 1152 1152L1152 1152Q1152 1163 1152.50 1174Q1153 1185 1154 1196L1154 1196Q1201 1219 1241 1251.50Q1281 1284 1312.50 1324.50Q1344 1365 1366 1412Q1388 1459 1399 1510L1399 1510Q1466 1536 1536 1536Z"
         }
      }
   ]
}

var YammerLogo = {
   name: "YammerLogo",
   vendor: "UiFabric",
   unicode: 60697,
   value: "",
   charCode: "ED19",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2004 1025L2004 1025Q2004 1067 2001.50 1118Q1999 1169 1993.50 1221.50Q1988 1274 1980 1324Q1972 1374 1960 1414L1960 1414Q1955 1432 1941.50 1443.50Q1928 1455 1908 1455L1908 1455Q1899 1455 1870 1448Q1841 1441 1807 1431.50Q1773 1422 1742.50 1413Q1712 1404 1699 1401L1699 1401Q1678 1479 1644.50 1562.50Q1611 1646 1568 1725.50Q1525 1805 1473 1878Q1421 1951 1364 2008L1364 2008Q1355 2016 1345.50 2020.50Q1336 2025 1324 2025L1324 2025Q1302 2025 1287 2010L1287 2010L812 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L812 512L1286 38Q1301 23 1323 23L1323 23Q1336 23 1344.50 27Q1353 31 1362 40L1362 40Q1388 66 1410.50 93.50Q1433 121 1454 150L1454 150Q1626 378 1699 651L1699 651Q1717 646 1747.50 637Q1778 628 1809.50 619Q1841 610 1868.50 603.50Q1896 597 1908 597L1908 597Q1928 597 1941.50 608.50Q1955 620 1960 638L1960 638Q1972 679 1980.50 728.50Q1989 778 1994.50 829.50Q2000 881 2002 931.50Q2004 982 2004 1025ZM784 760L784 760Q784 729 763 708Q742 687 711 687L711 687Q691 687 673.50 697.50Q656 708 646 726L646 726L516 971L390 726Q378 703 357.50 695Q337 687 313 687L313 687Q282 687 261 708Q240 729 240 760L240 760Q240 780 249 796L249 796L426 1111Q428 1115 429.50 1121Q431 1127 431 1132L431 1132L431 1288Q431 1326 456.50 1343.50Q482 1361 516 1361L516 1361Q540 1361 554.50 1352Q569 1343 577 1328Q585 1313 588 1293.50Q591 1274 591 1252L591 1252Q591 1226 589 1200Q587 1174 587 1152L587 1152Q587 1138 588 1127.50Q589 1117 594 1109L594 1109L774 796Q784 778 784 760ZM1320 185L1320 185L982 524Q1001 535 1012.50 554.50Q1024 574 1024 597L1024 597L1024 831L1575 684Q1537 542 1474 421Q1411 300 1320 185ZM1576 1368L1576 1367L1024 1219L1024 1451Q1024 1474 1012.50 1493.50Q1001 1513 982 1524L982 1524L1321 1863Q1410 1754 1475 1629Q1540 1504 1576 1368L1576 1368ZM1851 1309L1851 1309Q1864 1238 1870 1167.50Q1876 1097 1876 1025L1876 1025Q1876 953 1870 882.50Q1864 812 1851 742L1851 742Q1643 798 1437.50 852.50Q1232 907 1024 963L1024 963Q1023 979 1023 994Q1023 1009 1023 1025L1023 1025Q1023 1041 1023 1056.50Q1023 1072 1024 1087L1024 1087Q1232 1143 1437.50 1197Q1643 1251 1851 1309Z"
         }
      }
   ]
}

var Hide = {
   name: "Hide",
   vendor: "UiFabric",
   unicode: 60698,
   value: "",
   charCode: "ED1A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 896L1024 896Q1051 896 1074 906Q1097 916 1114.50 933.50Q1132 951 1142 974Q1152 997 1152 1024L1152 1024Q1152 1051 1142 1074Q1132 1097 1114.50 1114.50Q1097 1132 1074 1142Q1051 1152 1024 1152L1024 1152Q997 1152 974 1142Q951 1132 933.50 1114.50Q916 1097 906 1074Q896 1051 896 1024L896 1024Q896 997 906 974Q916 951 933.50 933.50Q951 916 974 906Q997 896 1024 896ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333ZM640 1024L640 1024Q640 1098 666 1163.50Q692 1229 738 1280Q784 1331 846.50 1364Q909 1397 982 1406L982 1406Q1001 1408 1020.50 1408Q1040 1408 1059 1408L1059 1408Q1037 1471 1030 1536L1030 1536Q878 1536 735.50 1497.50Q593 1459 462.50 1391Q332 1323 215.50 1229Q99 1135 0 1024L0 1024Q97 915 213 821Q329 727 459.50 658.50Q590 590 732 551Q874 512 1024 512L1024 512Q1177 512 1320 548.50Q1463 585 1592.50 652Q1722 719 1837 813.50Q1952 908 2048 1024L2048 1024L1957 1115L1949 1106Q1841 980 1716.50 881.50Q1592 783 1437 721L1437 721Q1485 787 1510.50 865Q1536 943 1536 1024L1536 1024L1536 1030Q1471 1037 1408 1059L1408 1059L1408 1024Q1408 945 1377.50 875Q1347 805 1295 753Q1243 701 1173 670.50Q1103 640 1024 640L1024 640Q945 640 875 670.50Q805 701 753 753Q701 805 670.50 875Q640 945 640 1024ZM603 1315L603 1315Q558 1251 535 1176.50Q512 1102 512 1024L512 1024Q512 946 535 871.50Q558 797 603 733L603 733Q483 785 377 859Q271 933 177 1024L177 1024Q271 1115 377 1189Q483 1263 603 1315Z"
         }
      }
   ]
}

var Uneditable = {
   name: "Uneditable",
   vendor: "UiFabric",
   unicode: 60701,
   value: "",
   charCode: "ED1D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 1152L1472 1152Q1565 1152 1646.50 1187Q1728 1222 1789 1283Q1850 1344 1885 1425.50Q1920 1507 1920 1600L1920 1600Q1920 1693 1885 1774.50Q1850 1856 1789 1917Q1728 1978 1646.50 2013Q1565 2048 1472 2048L1472 2048Q1379 2048 1297.50 2013Q1216 1978 1155 1917Q1094 1856 1059 1774.50Q1024 1693 1024 1600L1024 1600Q1024 1507 1059 1425.50Q1094 1344 1155 1283Q1216 1222 1297.50 1187Q1379 1152 1472 1152ZM1152 1600L1152 1600Q1152 1666 1177 1724.50Q1202 1783 1245.50 1826.50Q1289 1870 1347.50 1895Q1406 1920 1472 1920L1472 1920Q1519 1920 1564 1906.50Q1609 1893 1648 1867L1648 1867L1205 1424Q1179 1463 1165.50 1508Q1152 1553 1152 1600ZM1296 1333L1739 1776Q1765 1737 1778.50 1692Q1792 1647 1792 1600L1792 1600Q1792 1534 1766.50 1476Q1741 1418 1697.50 1374.50Q1654 1331 1596 1305.50Q1538 1280 1472 1280L1472 1280Q1425 1280 1380 1293.50Q1335 1307 1296 1333L1296 1333ZM1712 0L1712 0Q1782 0 1843 26.50Q1904 53 1949.50 98.50Q1995 144 2021.50 205Q2048 266 2048 336L2048 336Q2048 402 2023 463.50Q1998 525 1950 573L1950 573L1499 1024L1317 1024L1701 640L1408 347L326 1428Q378 1445 424.50 1473Q471 1501 509 1539Q547 1577 575 1623.50Q603 1670 620 1722L620 1722L896 1445L896 1627L633 1890L0 2048L158 1415Q161 1412 164.50 1409Q168 1406 171 1403L171 1403L1475 98Q1523 50 1584.50 25Q1646 0 1712 0ZM176 1872L505 1790Q495 1744 472.50 1703Q450 1662 418 1630Q386 1598 345 1575.50Q304 1553 258 1543L258 1543L176 1872ZM1499 256L1792 549Q1817 524 1840 502Q1863 480 1881 455.50Q1899 431 1909.50 402.50Q1920 374 1920 336L1920 336Q1920 293 1903.50 255Q1887 217 1859 189Q1831 161 1793 144.50Q1755 128 1712 128L1712 128Q1674 128 1645.50 138.50Q1617 149 1592.50 167Q1568 185 1546 208Q1524 231 1499 256L1499 256Z"
         }
      }
   ]
}

var OpenFolderHorizontal = {
   name: "OpenFolderHorizontal",
   vendor: "UiFabric",
   unicode: 60709,
   value: "",
   charCode: "ED25",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 768L1920 768Q1946 768 1969.50 778Q1993 788 2010.50 805.50Q2028 823 2038 846Q2048 869 2048 895L2048 895Q2048 925 2034 953L2034 953L1615 1792L0 1792L0 384Q0 357 10 334Q20 311 37.50 293.50Q55 276 78 266Q101 256 128 256L128 256L480 256Q525 256 557.50 265.50Q590 275 615.50 289Q641 303 661 320Q681 337 701.50 351Q722 365 745.50 374.50Q769 384 800 384L800 384L1536 384Q1563 384 1586 394Q1609 404 1626.50 421.50Q1644 439 1654 462Q1664 485 1664 512L1664 512L1664 768ZM128 384L128 1457L437 839Q454 806 484.50 787Q515 768 552 768L552 768L1536 768L1536 512L800 512Q755 512 722.50 502.50Q690 493 664.50 479Q639 465 619 448Q599 431 578.50 417Q558 403 534.50 393.50Q511 384 480 384L480 384L128 384ZM1536 1664L1920 896L552 896L168 1664L1536 1664Z"
         }
      }
   ]
}

var ReturnToSession = {
   name: "ReturnToSession",
   vendor: "UiFabric",
   unicode: 60708,
   value: "",
   charCode: "ED24",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1706 512L885 512Q730 512 590.50 570Q451 628 342 737L342 737Q233 846 175 985.50Q117 1125 117 1280L117 1280Q117 1386 144.50 1484Q172 1582 222 1667.50Q272 1753 342 1823Q412 1893 497.50 1943Q583 1993 681 2020.50Q779 2048 885 2048L885 2048L1781 2048L1781 1920L885 1920Q797 1920 715 1897Q633 1874 562 1832.50Q491 1791 432.50 1732.50Q374 1674 332.50 1603Q291 1532 268 1450Q245 1368 245 1280L245 1280Q245 1192 268 1110Q291 1028 332.50 957Q374 886 432.50 827.50Q491 769 562 727.50Q633 686 715 663Q797 640 885 640L885 640L1706 640L1280 1067L1354 1141L1920 576L1354 11L1280 85L1706 512Z"
         }
      }
   ]
}

var CalendarMirrored = {
   name: "CalendarMirrored",
   vendor: "UiFabric",
   unicode: 60712,
   value: "",
   charCode: "ED28",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 896L1280 768L1152 768L1152 896L1280 896ZM896 1664L896 1536L768 1536L768 1664L896 1664ZM512 896L512 768L384 768L384 896L512 896ZM896 896L896 768L768 768L768 896L896 896ZM1280 1152L1280 1024L1152 1024L1152 1152L1280 1152ZM1664 1152L1664 1024L1536 1024L1536 1152L1664 1152ZM512 1152L512 1024L384 1024L384 1152L512 1152ZM896 1152L896 1024L768 1024L768 1152L896 1152ZM1280 1408L1280 1280L1152 1280L1152 1408L1280 1408ZM1664 1408L1664 1280L1536 1280L1536 1408L1664 1408ZM512 1408L512 1280L384 1280L384 1408L512 1408ZM896 1408L896 1280L768 1280L768 1408L896 1408ZM1280 1664L1280 1536L1152 1536L1152 1664L1280 1664ZM1664 1664L1664 1536L1536 1536L1536 1664L1664 1664ZM384 128L0 128L0 1920L2048 1920L2048 128L1664 128L1664 0L1536 0L1536 128L512 128L512 0L384 0L384 128ZM1664 256L1920 256L1920 512L128 512L128 256L384 256L384 384L512 384L512 256L1536 256L1536 384L1664 384L1664 256ZM1920 1792L128 1792L128 640L1920 640L1920 1792Z"
         }
      }
   ]
}

var TrackersMirrored = {
   name: "TrackersMirrored",
   vendor: "UiFabric",
   unicode: 61074,
   value: "",
   charCode: "EE92",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384L640 384ZM1664 1920L1664 384L1536 384L1536 640L512 640L512 384L384 384L384 1920L1664 1920ZM512 1024L512 896L1024 896L1024 1024L512 1024ZM512 1408L512 1280L1024 1280L1024 1408L512 1408ZM512 1792L512 1664L1024 1664L1024 1792L512 1792ZM1280 870L1427 723L1517 813L1280 1050L1107 877L1197 787L1280 870ZM1280 1254L1427 1107L1517 1197L1280 1434L1107 1261L1197 1171L1280 1254ZM1280 1638L1427 1491L1517 1581L1280 1818L1107 1645L1197 1555L1280 1638Z"
         }
      }
   ]
}

var SkipForward30 = {
   name: "SkipForward30",
   vendor: "UiFabric",
   unicode: 60733,
   value: "",
   charCode: "ED3D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 1477L704 1480Q748 1484 786.50 1500.50Q825 1517 854 1545Q883 1573 899.50 1610.50Q916 1648 916 1694L916 1694Q916 1761 890 1811.50Q864 1862 820 1895.50Q776 1929 719 1946Q662 1963 601 1963L601 1963Q548 1963 495 1953Q442 1943 397 1914L397 1914L397 1804Q487 1876 604 1876L604 1876Q644 1876 681.50 1865.50Q719 1855 747.50 1834Q776 1813 793.50 1780.50Q811 1748 811 1703L811 1703Q811 1657 796 1626.50Q781 1596 756 1576Q731 1556 698 1546Q665 1536 629 1532Q593 1528 556 1527.50Q519 1527 486 1527L486 1527L486 1441Q533 1441 584.50 1439Q636 1437 679 1422Q722 1407 750 1373Q778 1339 778 1275L778 1275Q778 1193 732 1158Q686 1123 609 1123L609 1123Q559 1123 514.50 1140Q470 1157 431 1187L431 1187L431 1087Q477 1059 529 1047.50Q581 1036 635 1036L635 1036Q684 1036 728.50 1049.50Q773 1063 807.50 1090Q842 1117 862.50 1157Q883 1197 883 1250L883 1250Q883 1342 837.50 1397.50Q792 1453 704 1477L704 1477ZM1366 1036L1366 1036Q1428 1036 1472.50 1056.50Q1517 1077 1548.50 1112Q1580 1147 1599 1193.50Q1618 1240 1629 1291Q1640 1342 1643.50 1394.50Q1647 1447 1647 1495L1647 1495Q1647 1544 1642 1597.50Q1637 1651 1624.50 1703Q1612 1755 1590 1802Q1568 1849 1535 1885Q1502 1921 1455.50 1942Q1409 1963 1347 1963L1347 1963Q1288 1963 1244 1942.50Q1200 1922 1168.50 1888Q1137 1854 1117 1809Q1097 1764 1085 1714.50Q1073 1665 1068.50 1614Q1064 1563 1064 1517L1064 1517Q1064 1467 1068.50 1411.50Q1073 1356 1085 1303Q1097 1250 1118.50 1201.50Q1140 1153 1173.50 1116Q1207 1079 1254.50 1057.50Q1302 1036 1366 1036ZM1357 1876L1357 1876Q1400 1876 1431 1857Q1462 1838 1482.50 1807Q1503 1776 1515 1736.50Q1527 1697 1533.50 1656Q1540 1615 1541.50 1575.50Q1543 1536 1543 1505L1543 1505Q1543 1475 1541.50 1435Q1540 1395 1534 1352.50Q1528 1310 1516.50 1269Q1505 1228 1484.50 1195.50Q1464 1163 1434 1143Q1404 1123 1361 1123L1361 1123Q1316 1123 1284.50 1143Q1253 1163 1231.50 1195.50Q1210 1228 1197.50 1269.50Q1185 1311 1178.50 1354.50Q1172 1398 1170.50 1439Q1169 1480 1169 1512L1169 1512Q1169 1543 1171 1582.50Q1173 1622 1179 1662.50Q1185 1703 1197.50 1741.50Q1210 1780 1230.50 1810Q1251 1840 1282 1858Q1313 1876 1357 1876ZM1920 384L2048 384L2048 896L1536 896L1536 768L1852 768Q1793 651 1705.50 556.50Q1618 462 1510 395.50Q1402 329 1278 292.50Q1154 256 1024 256L1024 256Q869 256 728 303.50Q587 351 470.50 437.50Q354 524 267.50 645.50Q181 767 136 915L136 915L14 877Q47 766 102.50 667.50Q158 569 232 485.50Q306 402 395.50 336Q485 270 586 223.50Q687 177 797.50 152.50Q908 128 1024 128L1024 128Q1160 128 1290.50 162.50Q1421 197 1537 261.50Q1653 326 1750.50 418.50Q1848 511 1920 627L1920 627L1920 384Z"
         }
      }
   ]
}

var SkipBack10 = {
   name: "SkipBack10",
   vendor: "UiFabric",
   unicode: 60732,
   value: "",
   charCode: "ED3C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M462 1252L462 1148Q496 1139 532.50 1123.50Q569 1108 605 1089Q641 1070 674 1048Q707 1026 734 1004L734 1004L773 1004L773 1920L670 1920L670 1146Q655 1161 628.50 1178Q602 1195 572 1209.50Q542 1224 512.50 1235.50Q483 1247 462 1252L462 1252ZM1366 1009L1366 1009Q1428 1009 1472.50 1029.50Q1517 1050 1548.50 1085Q1580 1120 1599 1166.50Q1618 1213 1629 1264Q1640 1315 1643.50 1367.50Q1647 1420 1647 1468L1647 1468Q1647 1517 1642 1570.50Q1637 1624 1624 1676Q1611 1728 1589.50 1775Q1568 1822 1534.50 1858Q1501 1894 1455 1915Q1409 1936 1347 1936L1347 1936Q1288 1936 1244.50 1915.50Q1201 1895 1169.50 1861Q1138 1827 1117.50 1782Q1097 1737 1085 1687.50Q1073 1638 1068.50 1587Q1064 1536 1064 1490L1064 1490Q1064 1440 1068.50 1384.50Q1073 1329 1085 1276Q1097 1223 1118 1174.50Q1139 1126 1173 1089Q1207 1052 1254 1030.50Q1301 1009 1366 1009ZM1357 1848L1357 1848Q1400 1848 1431 1829Q1462 1810 1482.50 1779.50Q1503 1749 1515 1709.50Q1527 1670 1533.50 1629Q1540 1588 1541.50 1548.50Q1543 1509 1543 1478L1543 1478Q1543 1448 1541.50 1408Q1540 1368 1534 1325.50Q1528 1283 1516.50 1242Q1505 1201 1484.50 1168.50Q1464 1136 1434 1116Q1404 1096 1361 1096L1361 1096Q1316 1096 1284.50 1116Q1253 1136 1231.50 1168.50Q1210 1201 1197.50 1242.50Q1185 1284 1178.50 1327.50Q1172 1371 1170.50 1412Q1169 1453 1169 1485L1169 1485Q1169 1516 1171 1555.50Q1173 1595 1179 1635Q1185 1675 1197.50 1713.50Q1210 1752 1230.50 1782Q1251 1812 1282 1830Q1313 1848 1357 1848ZM1038 128L1038 128Q1211 128 1372 182.50Q1533 237 1666.50 336Q1800 435 1899 573Q1998 711 2048 877L2048 877L1926 915Q1881 767 1795 645.50Q1709 524 1592 437.50Q1475 351 1333.50 303.50Q1192 256 1038 256L1038 256Q908 256 784 292.50Q660 329 552 395.50Q444 462 356 556.50Q268 651 210 768L210 768L526 768L526 896L14 896L14 384L142 384L142 627Q214 511 311.50 418.50Q409 326 525 261.50Q641 197 771 162.50Q901 128 1038 128Z"
         }
      }
   ]
}

var OutOfOffice = {
   name: "OutOfOffice",
   vendor: "UiFabric",
   unicode: 60724,
   value: "",
   charCode: "ED34",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1024L1600 1024Q1626 1024 1645 1043Q1664 1062 1664 1088L1664 1088Q1664 1114 1645 1133Q1626 1152 1600 1152L1600 1152Q1574 1152 1555 1133Q1536 1114 1536 1088L1536 1088Q1536 1062 1555 1043Q1574 1024 1600 1024ZM768 2048L768 1280L896 1280L896 2048L768 2048ZM768 0L1920 0L1920 2048L1792 2048L1792 128L896 128L896 896L768 896L768 0ZM557 813L347 1024L1152 1024L1152 1152L347 1152L557 1363L467 1453L102 1088L467 723L557 813Z"
         }
      }
   ]
}

var SwayLogoInverse = {
   name: "SwayLogoInverse",
   vendor: "UiFabric",
   unicode: 60713,
   value: "",
   charCode: "ED29",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1696L128 352L1152 128L1152 1920L128 1696ZM411 1228L411 1415Q416 1418 427.50 1423.50Q439 1429 452.50 1435Q466 1441 478.50 1446Q491 1451 497 1453L497 1453Q526 1463 557.50 1467.50Q589 1472 620 1472L620 1472Q667 1472 709 1460Q751 1448 783.50 1423Q816 1398 837.50 1361Q859 1324 865 1274L865 1274L865 1279L866 1269L865 1274Q869 1251 869 1224L869 1224Q869 1173 853 1132Q837 1091 810 1056Q783 1021 748 991.50Q713 962 675 935L675 935Q648 915 634.50 894.50Q621 874 621 839L621 839Q621 795 650 771.50Q679 748 721 748L721 748Q736 748 753.50 751.50Q771 755 789 761Q807 767 823.50 775.50Q840 784 851 793L851 793L851 607Q817 593 783 584.50Q749 576 712 576L712 576Q686 576 660.50 577.50Q635 579 609 585L609 585Q562 596 526 620Q490 644 466 678Q442 712 430 753.50Q418 795 418 842L418 842Q418 901 435 941.50Q452 982 478 1011Q504 1040 533.50 1061.50Q563 1083 589 1103.50Q615 1124 632 1147.50Q649 1171 649 1203L649 1203Q649 1248 619.50 1268Q590 1288 549 1288L549 1288Q503 1288 473 1272.50Q443 1257 411 1228L411 1228ZM1280 256L1792 256Q1818 256 1841.50 266Q1865 276 1882.50 293.50Q1900 311 1910 334.50Q1920 358 1920 384L1920 384L1920 1024L1551 654Q1545 648 1529.50 644Q1514 640 1506 640L1506 640Q1486 640 1467 654L1467 654Q1450 667 1434.50 682Q1419 697 1404 712L1404 712Q1373 742 1342 772Q1311 802 1280 833L1280 833L1280 256ZM1792 512L1792 384L1664 384L1664 512L1792 512ZM1280 1152L1280 1024L1920 1024L1920 1664Q1920 1690 1910 1713.50Q1900 1737 1882.50 1754.50Q1865 1772 1841.50 1782Q1818 1792 1792 1792L1792 1792L1280 1792L1280 1536L1408 1536L1408 1408L1280 1408L1280 1280L1408 1280L1408 1152L1280 1152ZM1536 1152L1536 1280L1792 1280L1792 1152L1536 1152ZM1536 1408L1536 1536L1792 1536L1792 1408L1536 1408Z"
         }
      }
   ]
}

var Trophy = {
   name: "Trophy",
   vendor: "UiFabric",
   unicode: 60735,
   value: "",
   charCode: "ED3F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 256L1664 256L1664 703Q1664 760 1644.50 812.50Q1625 865 1590.50 906.50Q1556 948 1508 977Q1460 1006 1404 1017L1404 1017Q1395 1092 1362.50 1157.50Q1330 1223 1279.50 1274.50Q1229 1326 1164 1359.50Q1099 1393 1024 1403L1024 1403L1024 1536L1408 1536L1408 1792L1536 1792L1536 1920L384 1920L384 1792L512 1792L512 1536L896 1536L896 1403Q821 1393 756 1359.50Q691 1326 640.50 1274.50Q590 1223 557.50 1157.50Q525 1092 516 1017L516 1017Q460 1006 412 977Q364 948 329.50 906.50Q295 865 275.50 812.50Q256 760 256 703L256 703L256 256L512 256L512 128L1408 128L1408 256ZM1280 1664L640 1664L640 1792L1280 1792L1280 1664ZM384 384L384 703Q384 733 393.50 761.50Q403 790 419.50 813.50Q436 837 459.50 855.50Q483 874 512 884L512 884L512 384L384 384ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960L1280 256L640 256L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1536 703L1536 384L1408 384L1408 884Q1436 874 1460 855.50Q1484 837 1500.50 813.50Q1517 790 1526.50 761.50Q1536 733 1536 703L1536 703Z"
         }
      }
   ]
}

var EmojiTabSymbols = {
   name: "EmojiTabSymbols",
   vendor: "UiFabric",
   unicode: 60760,
   value: "",
   charCode: "ED58",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1287L1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1856 1408Q1811 1348 1743 1314Q1675 1280 1600 1280L1600 1280Q1549 1280 1502 1295.50Q1455 1311 1415 1339Q1375 1367 1345 1406Q1315 1445 1298 1493L1298 1493L1178 1451Q1202 1384 1244 1329Q1286 1274 1341.50 1234.50Q1397 1195 1463 1173.50Q1529 1152 1600 1152L1600 1152Q1691 1152 1774 1187Q1857 1222 1920 1287L1920 1287ZM448 0L448 0Q541 0 622.50 35Q704 70 765 131Q826 192 861 273.50Q896 355 896 448L896 448Q896 541 861 622.50Q826 704 765 765Q704 826 622.50 861Q541 896 448 896L448 896Q355 896 273.50 861Q192 826 131 765Q70 704 35 622.50Q0 541 0 448L0 448Q0 355 35 273.50Q70 192 131 131Q192 70 273.50 35Q355 0 448 0ZM128 448L128 448Q128 514 153 572.50Q178 631 221.50 674.50Q265 718 323.50 743Q382 768 448 768L448 768Q495 768 540 754.50Q585 741 624 715L624 715L181 272Q155 311 141.50 356Q128 401 128 448ZM272 181L715 624Q741 585 754.50 540Q768 495 768 448L768 448Q768 382 742.50 324Q717 266 673.50 222.50Q630 179 572 153.50Q514 128 448 128L448 128Q401 128 356 141.50Q311 155 272 181L272 181ZM512 1152L512 1536L896 1536L896 1664L512 1664L512 2048L384 2048L384 1664L0 1664L0 1536L384 1536L384 1152L512 1152ZM1600 1920L1600 1920Q1651 1920 1698 1904.50Q1745 1889 1784.50 1861Q1824 1833 1854.50 1794Q1885 1755 1902 1707L1902 1707L2022 1749Q1998 1816 1956 1871Q1914 1926 1858.50 1965.50Q1803 2005 1737 2026.50Q1671 2048 1600 2048L1600 2048Q1509 2048 1426 2013Q1343 1978 1280 1913L1280 1913L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1344 1792Q1389 1852 1457 1886Q1525 1920 1600 1920ZM1600 890L1230 521Q1192 483 1172 434Q1152 385 1152 332L1152 332Q1152 276 1173 227Q1194 178 1230 142Q1266 106 1314.50 85Q1363 64 1419 64L1419 64Q1470 64 1516.50 82Q1563 100 1600 134L1600 134Q1637 100 1683.50 82Q1730 64 1781 64L1781 64Q1836 64 1885 85Q1934 106 1970 142Q2006 178 2027 227Q2048 276 2048 332L2048 332Q2048 385 2028 434Q2008 483 1970 521L1970 521L1600 890ZM1420 192L1420 192Q1391 192 1365.50 203Q1340 214 1321 233Q1302 252 1291 277.50Q1280 303 1280 332L1280 332Q1280 360 1290.50 385Q1301 410 1321 430L1321 430L1600 709L1879 430Q1920 389 1920 332L1920 332Q1920 303 1909 277.50Q1898 252 1879 233Q1860 214 1834.50 203Q1809 192 1780 192L1780 192Q1723 192 1682 233L1682 233L1600 315L1518 233Q1498 213 1473 202.50Q1448 192 1420 192Z"
         }
      }
   ]
}

var ReopenPages = {
   name: "ReopenPages",
   vendor: "UiFabric",
   unicode: 60752,
   value: "",
   charCode: "ED50",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 128L1536 640L2048 640L2048 1920L512 1920L512 1408L0 1408L0 128L1536 128ZM1920 896L1920 768L1536 768L1536 896L1920 896ZM1408 384L1408 256L128 256L128 384L1408 384ZM1408 512L128 512L128 1280L1408 1280L1408 512ZM640 1408L640 1792L1920 1792L1920 1024L1536 1024L1536 1408L640 1408Z"
         }
      }
   ]
}

var EventInfo = {
   name: "EventInfo",
   vendor: "UiFabric",
   unicode: 60811,
   value: "",
   charCode: "ED8B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256ZM128 1792L1920 1792L1920 640L128 640L128 1792ZM896 1664L896 1024L1024 1024L1024 1664L896 1664ZM960 768L960 768Q986 768 1005 787Q1024 806 1024 832L1024 832Q1024 858 1005 877Q986 896 960 896L960 896Q934 896 915 877Q896 858 896 832L896 832Q896 806 915 787Q934 768 960 768Z"
         }
      }
   ]
}

var RemoveEvent = {
   name: "RemoveEvent",
   vendor: "UiFabric",
   unicode: 60810,
   value: "",
   charCode: "ED8A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM384 384L384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384ZM128 640L128 1792L1920 1792L1920 640L128 640ZM1024 1126L1299 851L1389 941L1115 1216L1389 1491L1299 1581L1024 1306L749 1581L659 1491L933 1216L659 941L749 851L1024 1126Z"
         }
      }
   ]
}

var Waffle = {
   name: "Waffle",
   vendor: "UiFabric",
   unicode: 60809,
   value: "",
   charCode: "ED89",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 640L384 640L384 384L640 384L640 640ZM1152 640L896 640L896 384L1152 384L1152 640ZM1408 640L1408 384L1664 384L1664 640L1408 640ZM640 1152L384 1152L384 896L640 896L640 1152ZM1152 1152L896 1152L896 896L1152 896L1152 1152ZM1664 1152L1408 1152L1408 896L1664 896L1664 1152ZM640 1664L384 1664L384 1408L640 1408L640 1664ZM1152 1664L896 1664L896 1408L1152 1408L1152 1664ZM1664 1664L1408 1664L1408 1408L1664 1408L1664 1664Z"
         }
      }
   ]
}

var VoicemailReply = {
   name: "VoicemailReply",
   vendor: "UiFabric",
   unicode: 60808,
   value: "",
   charCode: "ED88",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1549 1124L1392 1280L384 1280Q304 1280 234.50 1250Q165 1220 112.50 1167.50Q60 1115 30 1045.50Q0 976 0 896L0 896Q0 817 30 747Q60 677 112.50 624.50Q165 572 234.50 542Q304 512 384 512L384 512Q463 512 533 542Q603 572 655.50 624.50Q708 677 738 747Q768 817 768 896L768 896Q768 968 742 1033.50Q716 1099 668 1152L668 1152L1380 1152Q1332 1099 1306 1033.50Q1280 968 1280 896L1280 896Q1280 817 1310 747Q1340 677 1392.50 624.50Q1445 572 1514.50 542Q1584 512 1664 512L1664 512Q1743 512 1813 542Q1883 572 1935.50 624.50Q1988 677 2018 747Q2048 817 2048 896L2048 896Q2048 964 2025 1026Q2002 1088 1961 1138Q1920 1188 1864 1223Q1808 1258 1741 1272L1741 1272L1616 1147Q1628 1149 1640 1150.50Q1652 1152 1664 1152L1664 1152Q1717 1152 1763.50 1132Q1810 1112 1845 1077Q1880 1042 1900 995.50Q1920 949 1920 896L1920 896Q1920 843 1900 796.50Q1880 750 1845 715Q1810 680 1763.50 660Q1717 640 1664 640L1664 640Q1611 640 1564.50 660Q1518 680 1483 715Q1448 750 1428 796.50Q1408 843 1408 896L1408 896Q1408 969 1446 1030Q1484 1091 1549 1124L1549 1124ZM384 1152L384 1152Q437 1152 483.50 1132Q530 1112 565 1077Q600 1042 620 995.50Q640 949 640 896L640 896Q640 843 620 796.50Q600 750 565 715Q530 680 483.50 660Q437 640 384 640L384 640Q331 640 284.50 660Q238 680 203 715Q168 750 148 796.50Q128 843 128 896L128 896Q128 949 148 995.50Q168 1042 203 1077Q238 1112 284.50 1132Q331 1152 384 1152ZM1499 1536L1792 1536Q1845 1536 1891.50 1556Q1938 1576 1973 1611Q2008 1646 2028 1692.50Q2048 1739 2048 1792L2048 1792Q2048 1845 2028 1891.50Q2008 1938 1973 1973Q1938 2008 1891.50 2028Q1845 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373L1499 1536Z"
         }
      }
   ]
}

var VoicemailForward = {
   name: "VoicemailForward",
   vendor: "UiFabric",
   unicode: 60807,
   value: "",
   charCode: "ED87",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1635 1373L1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1280 1664L1280 1536L1798 1536L1635 1373ZM1676 1151L1547 1280L384 1280Q304 1280 234.50 1250Q165 1220 112.50 1167.50Q60 1115 30 1045.50Q0 976 0 896L0 896Q0 817 30 747Q60 677 112.50 624.50Q165 572 234.50 542Q304 512 384 512L384 512Q463 512 533 542Q603 572 655.50 624.50Q708 677 738 747Q768 817 768 896L768 896Q768 968 742 1033.50Q716 1099 668 1152L668 1152L1380 1152Q1332 1099 1306 1033.50Q1280 968 1280 896L1280 896Q1280 817 1310 747Q1340 677 1392.50 624.50Q1445 572 1514.50 542Q1584 512 1664 512L1664 512Q1743 512 1813 542Q1883 572 1935.50 624.50Q1988 677 2018 747Q2048 817 2048 896L2048 896Q2048 948 2034 997Q2020 1046 1994.50 1089Q1969 1132 1933 1168Q1897 1204 1852 1229L1852 1229L1757 1134Q1793 1119 1823 1095Q1853 1071 1874.50 1040Q1896 1009 1908 972Q1920 935 1920 896L1920 896Q1920 843 1900 796.50Q1880 750 1845 715Q1810 680 1763.50 660Q1717 640 1664 640L1664 640Q1611 640 1564.50 660Q1518 680 1483 715Q1448 750 1428 796.50Q1408 843 1408 896L1408 896Q1408 949 1428 995.50Q1448 1042 1483 1077Q1518 1112 1564.50 1132Q1611 1152 1664 1152L1664 1152Q1667 1152 1670 1151.50Q1673 1151 1676 1151L1676 1151ZM384 1152L384 1152Q437 1152 483.50 1132Q530 1112 565 1077Q600 1042 620 995.50Q640 949 640 896L640 896Q640 843 620 796.50Q600 750 565 715Q530 680 483.50 660Q437 640 384 640L384 640Q331 640 284.50 660Q238 680 203 715Q168 750 148 796.50Q128 843 128 896L128 896Q128 949 148 995.50Q168 1042 203 1077Q238 1112 284.50 1132Q331 1152 384 1152Z"
         }
      }
   ]
}

var Table = {
   name: "Table",
   vendor: "UiFabric",
   unicode: 60806,
   value: "",
   charCode: "ED86",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1792L128 256L1792 256L1792 1792L128 1792ZM1152 1024L768 1024L768 1280L1152 1280L1152 1024ZM768 896L1152 896L1152 640L768 640L768 896ZM256 896L640 896L640 640L256 640L256 896ZM640 1024L256 1024L256 1280L640 1280L640 1024ZM256 1664L640 1664L640 1408L256 1408L256 1664ZM768 1664L1152 1664L1152 1408L768 1408L768 1664ZM1280 1664L1664 1664L1664 1408L1280 1408L1280 1664ZM1280 1280L1664 1280L1664 1024L1280 1024L1280 1280ZM1280 896L1664 896L1664 640L1280 640L1280 896ZM256 384L256 512L1664 512L1664 384L256 384Z"
         }
      }
   ]
}

var SecurityGroup = {
   name: "SecurityGroup",
   vendor: "UiFabric",
   unicode: 60805,
   value: "",
   charCode: "ED85",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M867 1461L867 1461Q932 1494 985 1542Q1038 1590 1075 1650Q1112 1710 1132 1778.50Q1152 1847 1152 1920L1152 1920L1024 1920Q1024 1841 994 1771Q964 1701 911.50 1648.50Q859 1596 789 1566Q719 1536 640 1536L640 1536Q560 1536 490.50 1566Q421 1596 368.50 1648.50Q316 1701 286 1771Q256 1841 256 1920L256 1920L128 1920Q128 1847 148 1778.50Q168 1710 205 1650Q242 1590 295 1542Q348 1494 413 1461L413 1461Q339 1407 297.50 1325.50Q256 1244 256 1152L256 1152Q256 1073 286 1003Q316 933 368.50 880.50Q421 828 490.50 798Q560 768 640 768L640 768Q732 768 813.50 809.50Q895 851 949 925L949 925Q987 850 1046.50 790.50Q1106 731 1181 694L1181 694Q1107 639 1065.50 557.50Q1024 476 1024 384L1024 384Q1024 305 1054 235Q1084 165 1136.50 112.50Q1189 60 1258.50 30Q1328 0 1408 0L1408 0Q1487 0 1557 30Q1627 60 1679.50 112.50Q1732 165 1762 235Q1792 305 1792 384L1792 384Q1792 478 1749 561Q1706 644 1629 698L1629 698Q1676 723 1719 757.50Q1762 792 1797.50 834Q1833 876 1860 924.50Q1887 973 1903 1024L1903 1024L1769 1024Q1747 972 1710 925.50Q1673 879 1625 844Q1577 809 1521.50 789Q1466 769 1408 769L1408 769Q1328 769 1258.50 799Q1189 829 1136.50 881Q1084 933 1054 1003Q1024 1073 1024 1152L1024 1152Q1024 1244 982.50 1325.50Q941 1407 867 1461ZM1408 128L1408 128Q1355 128 1308.50 148Q1262 168 1227 203Q1192 238 1172 284.50Q1152 331 1152 384L1152 384Q1152 437 1172 483.50Q1192 530 1227 565Q1262 600 1308.50 620Q1355 640 1408 640L1408 640Q1461 640 1507.50 620Q1554 600 1589 565Q1624 530 1644 483.50Q1664 437 1664 384L1664 384Q1664 331 1644 284.50Q1624 238 1589 203Q1554 168 1507.50 148Q1461 128 1408 128ZM384 1152L384 1152Q384 1205 404 1251.50Q424 1298 459 1333Q494 1368 540.50 1388Q587 1408 640 1408L640 1408Q693 1408 739.50 1388Q786 1368 821 1333Q856 1298 876 1251.50Q896 1205 896 1152L896 1152Q896 1099 876 1052.50Q856 1006 821 971Q786 936 739.50 916Q693 896 640 896L640 896Q587 896 540.50 916Q494 936 459 971Q424 1006 404 1052.50Q384 1099 384 1152ZM1984 1536L2048 1536L2048 2048L1408 2048L1408 1536L1472 1536L1472 1408Q1472 1355 1492 1308.50Q1512 1262 1547 1227Q1582 1192 1628.50 1172Q1675 1152 1728 1152L1728 1152Q1781 1152 1827.50 1172Q1874 1192 1909 1227Q1944 1262 1964 1308.50Q1984 1355 1984 1408L1984 1408L1984 1536ZM1600 1408L1600 1536L1856 1536L1856 1408Q1856 1381 1846 1358Q1836 1335 1818.50 1317.50Q1801 1300 1778 1290Q1755 1280 1728 1280L1728 1280Q1701 1280 1678 1290Q1655 1300 1637.50 1317.50Q1620 1335 1610 1358Q1600 1381 1600 1408L1600 1408ZM1920 1920L1920 1664L1536 1664L1536 1920L1920 1920Z"
         }
      }
   ]
}

var MailRepeat = {
   name: "MailRepeat",
   vendor: "UiFabric",
   unicode: 60804,
   value: "",
   charCode: "ED84",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1664L2048 1664Q2050 1742 2018 1810Q1986 1878 1932 1929.50Q1878 1981 1808 2012Q1738 2043 1664 2047L1664 2047L1655 2047L1653 2048L1642 2048Q1533 2048 1438 2004.50Q1343 1961 1280 1869L1280 1869L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1384 1792Q1403 1821 1430 1844.50Q1457 1868 1488.50 1885Q1520 1902 1554 1911Q1588 1920 1623 1920L1623 1920Q1679 1920 1728 1905.50Q1777 1891 1815.50 1862Q1854 1833 1880.50 1790.50Q1907 1748 1918 1692L1918 1692L1919 1690L1919 1679L1920 1677L1920 1664ZM1920 1331L1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1816 1408Q1797 1379 1770 1355.50Q1743 1332 1711.50 1315Q1680 1298 1645.50 1289Q1611 1280 1577 1280L1577 1280Q1521 1280 1472 1294.50Q1423 1309 1384.50 1338Q1346 1367 1319.50 1409.50Q1293 1452 1282 1508L1282 1508L1281 1510L1281 1521L1280 1523L1280 1536L1152 1536Q1150 1458 1181.50 1390Q1213 1322 1267 1270.50Q1321 1219 1391.50 1188Q1462 1157 1536 1153L1536 1153L1545 1153L1547 1152L1558 1152Q1667 1152 1762 1195.50Q1857 1239 1920 1331L1920 1331ZM0 384L2048 384L2048 1024L1920 1024L1920 648L1024 1095L128 648L128 1536L1024 1536L1024 1664L0 1664L0 384ZM143 512L1024 953L1905 512L143 512Z"
         }
      }
   ]
}

var MailPause = {
   name: "MailPause",
   vendor: "UiFabric",
   unicode: 60803,
   value: "",
   charCode: "ED83",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 384L2048 384L2048 1152L1920 1152L1920 648L1024 1095L128 648L128 1536L1408 1536L1408 1664L0 1664ZM1905 512L143 512L1024 953L1905 512ZM1920 2048L1792 2048L1792 1280L1920 1280L1920 2048ZM1664 2048L1536 2048L1536 1280L1664 1280L1664 2048Z"
         }
      }
   ]
}

var MailLowImportance = {
   name: "MailLowImportance",
   vendor: "UiFabric",
   unicode: 60802,
   value: "",
   charCode: "ED82",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 384L2048 384L2048 1579L1920 1451L1920 648L1024 1095L128 648L128 1536L1461 1536L1333 1664L0 1664ZM1905 512L143 512L1024 953L1905 512ZM1792 1024L1792 1798L1939 1651L2029 1741L1728 2042L1427 1741L1517 1651L1664 1798L1664 1024L1792 1024Z"
         }
      }
   ]
}

var MailCheck = {
   name: "MailCheck",
   vendor: "UiFabric",
   unicode: 60801,
   value: "",
   charCode: "ED81",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829ZM0 384L2048 384L2048 1291Q2016 1259 1983 1227.50Q1950 1196 1920 1162L1920 1162L1920 648L1024 1095L128 648L128 1536L1227 1536L1099 1664L0 1664L0 384ZM143 512L1024 953L1905 512L143 512Z"
         }
      }
   ]
}

var MailAlert = {
   name: "MailAlert",
   vendor: "UiFabric",
   unicode: 60800,
   value: "",
   charCode: "ED80",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1068Q1993 989 1920 929L1920 929L1920 648L1638 788Q1597 779 1555.50 773.50Q1514 768 1472 768L1472 768Q1449 768 1425.50 770Q1402 772 1379 775L1379 775L1905 512L143 512L1007 944Q982 967 959 991Q936 1015 916 1041L916 1041L128 648L128 1536L771 1536Q774 1568 780.50 1600Q787 1632 795 1664L795 1664L0 1664L0 384ZM1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1408 1536L1408 1152L1536 1152L1536 1536L1408 1536ZM1408 1792L1408 1664L1536 1664L1536 1792L1408 1792Z"
         }
      }
   ]
}

var Cat = {
   name: "Cat",
   vendor: "UiFabric",
   unicode: 60799,
   value: "",
   charCode: "ED7F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 463L2048 576Q2048 616 2033 651Q2018 686 1992 712Q1966 738 1931 753Q1896 768 1856 768L1856 768L1792 768L1792 1408Q1792 1474 1803 1539.50Q1814 1605 1837 1668L1837 1668Q1883 1676 1921.50 1699Q1960 1722 1988 1755.50Q2016 1789 2032 1831.50Q2048 1874 2048 1920L2048 1920Q2048 1938 2048.50 1960.50Q2049 1983 2044 2002.50Q2039 2022 2025.50 2035Q2012 2048 1984 2048L1984 2048L512 2048Q406 2048 313 2007.50Q220 1967 150.50 1897.50Q81 1828 40.50 1735Q0 1642 0 1536L0 1536Q0 1457 30 1387Q60 1317 112.50 1264.50Q165 1212 234.50 1182Q304 1152 384 1152L384 1152Q410 1152 433.50 1142Q457 1132 474.50 1114.50Q492 1097 502 1073.50Q512 1050 512 1024L512 1024Q512 997 502 974Q492 951 474.50 933.50Q457 916 434 906Q411 896 384 896L384 896L384 768Q437 768 483.50 788Q530 808 565 843Q600 878 620 924.50Q640 971 640 1024L640 1024Q640 1077 620 1123.50Q600 1170 565 1205Q530 1240 483.50 1260Q437 1280 384 1280L384 1280Q331 1280 284.50 1300Q238 1320 203 1355Q168 1390 148 1436.50Q128 1483 128 1536L128 1536Q128 1616 158 1685.50Q188 1755 240.50 1807.50Q293 1860 362.50 1890Q432 1920 512 1920L512 1920Q538 1920 561.50 1910Q585 1900 602.50 1882.50Q620 1865 630 1841.50Q640 1818 640 1792L640 1792Q640 1594 709.50 1422.50Q779 1251 914 1108L914 1108Q1031 984 1091.50 833.50Q1152 683 1152 512L1152 512L1152 384Q1152 305 1182 235Q1212 165 1264.50 112.50Q1317 60 1386.50 30Q1456 0 1536 0L1536 0L1664 0L1664 113Q1664 130 1673.50 146Q1683 162 1699 170L1699 170Q1760 200 1820.50 230Q1881 260 1942 291L1942 291Q1991 316 2019.50 362Q2048 408 2048 463L2048 463ZM1664 1920L1920 1920Q1920 1894 1910 1870.50Q1900 1847 1882.50 1829.50Q1865 1812 1841.50 1802Q1818 1792 1792 1792L1792 1792Q1771 1792 1756.50 1781.50Q1742 1771 1733 1753L1733 1753Q1715 1719 1702 1675Q1689 1631 1680.50 1584.50Q1672 1538 1668 1492Q1664 1446 1664 1408L1664 1408L1664 768Q1664 741 1674 718Q1684 695 1701.50 677.50Q1719 660 1742 650Q1765 640 1792 640L1792 640Q1810 640 1832.50 640.50Q1855 641 1874.50 636Q1894 631 1907 617.50Q1920 604 1920 576L1920 576L1920 463Q1920 446 1910.50 430Q1901 414 1885 406L1885 406Q1824 376 1763.50 346Q1703 316 1642 285L1642 285Q1597 262 1569.50 220.50Q1542 179 1538 128L1538 128Q1485 128 1438 148Q1391 168 1356 202.50Q1321 237 1300.50 283.50Q1280 330 1280 384L1280 384L1280 512Q1280 709 1210.50 881Q1141 1053 1006 1196L1006 1196Q889 1320 828.50 1470.50Q768 1621 768 1792L768 1792Q768 1826 758.50 1858.50Q749 1891 732 1920L732 1920L1536 1920Q1536 1894 1526 1870.50Q1516 1847 1498.50 1829.50Q1481 1812 1457.50 1802Q1434 1792 1408 1792L1408 1792L1152 1792L1152 1664L1408 1664Q1416 1664 1423.50 1665Q1431 1666 1439 1667L1439 1667L1346 1296L1470 1264L1589 1739Q1625 1775 1644.50 1822Q1664 1869 1664 1920L1664 1920ZM1600 384L1600 384Q1626 384 1645 403Q1664 422 1664 448L1664 448Q1664 474 1645 493Q1626 512 1600 512L1600 512Q1574 512 1555 493Q1536 474 1536 448L1536 448Q1536 422 1555 403Q1574 384 1600 384Z"
         }
      }
   ]
}

var Balloons = {
   name: "Balloons",
   vendor: "UiFabric",
   unicode: 60798,
   value: "",
   charCode: "ED7E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 768L1728 768Q1702 768 1683 749Q1664 730 1664 704L1664 704Q1664 664 1649 629Q1634 594 1608 568Q1582 542 1547 527Q1512 512 1472 512L1472 512Q1446 512 1427 493Q1408 474 1408 448L1408 448Q1408 422 1427 403Q1446 384 1472 384L1472 384Q1538 384 1596.50 409Q1655 434 1698.50 477.50Q1742 521 1767 579.50Q1792 638 1792 704L1792 704Q1792 730 1773 749Q1754 768 1728 768ZM576 256L576 256Q642 256 700.50 281Q759 306 802.50 349.50Q846 393 871 451.50Q896 510 896 576L896 576Q896 602 877 621Q858 640 832 640L832 640Q806 640 787 621Q768 602 768 576L768 576Q768 536 753 501Q738 466 712 440Q686 414 651 399Q616 384 576 384L576 384Q550 384 531 365Q512 346 512 320L512 320Q512 294 531 275Q550 256 576 256ZM1536 1513L1536 1513Q1536 1533 1534.50 1559Q1533 1585 1537.50 1608Q1542 1631 1556 1647.50Q1570 1664 1600 1664L1600 1664Q1666 1664 1724.50 1689Q1783 1714 1826.50 1757.50Q1870 1801 1895 1859.50Q1920 1918 1920 1984L1920 1984Q1920 2010 1901 2029Q1882 2048 1856 2048L1856 2048Q1830 2048 1811 2029Q1792 2010 1792 1984L1792 1984Q1792 1944 1777 1909Q1762 1874 1736 1848Q1710 1822 1675 1807Q1640 1792 1600 1792L1600 1792Q1560 1792 1525 1777Q1490 1762 1464 1736Q1438 1710 1423 1675Q1408 1640 1408 1600L1408 1600L1408 1513Q1269 1447 1161 1340Q1053 1233 987 1094L987 1094Q921 1188 833 1262Q745 1336 640 1385L640 1385L640 1472Q640 1512 655 1547Q670 1582 696 1608Q722 1634 757 1649Q792 1664 832 1664L832 1664Q885 1664 932 1663.50Q979 1663 1022 1670.50Q1065 1678 1105 1698Q1145 1718 1186 1758L1186 1758Q1232 1804 1256 1861.50Q1280 1919 1280 1984L1280 1984Q1280 2010 1261 2029Q1242 2048 1216 2048L1216 2048Q1190 2048 1171 2029Q1152 2010 1152 1984L1152 1984Q1152 1944 1137 1909Q1122 1874 1096 1848Q1070 1822 1035 1807Q1000 1792 960 1792L960 1792L832 1792Q766 1792 707.50 1767Q649 1742 605.50 1698.50Q562 1655 537 1596.50Q512 1538 512 1472L512 1472L512 1385Q395 1330 300 1245Q205 1160 138.50 1054.50Q72 949 36 827.50Q0 706 0 576L0 576Q0 457 45.50 352Q91 247 169 169Q247 91 352 45.50Q457 0 576 0L576 0Q653 0 726 20Q799 40 864 77.50Q929 115 983 168.50Q1037 222 1075 289L1075 289Q1155 211 1257.50 169.50Q1360 128 1472 128L1472 128Q1591 128 1696 173.50Q1801 219 1879 297Q1957 375 2002.50 480Q2048 585 2048 704L2048 704Q2048 834 2012 955.50Q1976 1077 1909.50 1182.50Q1843 1288 1748 1373Q1653 1458 1536 1513ZM576 1274L576 1274Q679 1227 761.50 1154.50Q844 1082 902.50 991Q961 900 992.50 794.50Q1024 689 1024 576L1024 576Q1024 483 988.50 401.50Q953 320 892.50 259.50Q832 199 750.50 163.50Q669 128 576 128L576 128Q483 128 401.50 163.50Q320 199 259.50 259.50Q199 320 163.50 401.50Q128 483 128 576L128 576Q128 689 159.50 794.50Q191 900 249.50 991Q308 1082 390.50 1154.50Q473 1227 576 1274ZM1068 955L1068 955Q1093 1029 1133 1096Q1173 1163 1224.50 1220Q1276 1277 1338.50 1323Q1401 1369 1472 1402L1472 1402Q1575 1355 1657.50 1282.50Q1740 1210 1798.50 1119Q1857 1028 1888.50 922.50Q1920 817 1920 704L1920 704Q1920 611 1884.50 529.50Q1849 448 1788.50 387.50Q1728 327 1646.50 291.50Q1565 256 1472 256L1472 256Q1372 256 1283 298.50Q1194 341 1130 418L1130 418Q1141 456 1146.50 496Q1152 536 1152 576L1152 576Q1152 675 1131 770.50Q1110 866 1068 955Z"
         }
      }
   ]
}

var VisioLogoInverse = {
   name: "VisioLogoInverse",
   vendor: "UiFabric",
   unicode: 60797,
   value: "",
   charCode: "ED7D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 597L1984 597L1984 1387Q1984 1422 1959 1447Q1934 1472 1899 1472L1899 1472L1470 1472Q1464 1567 1424 1648.50Q1384 1730 1319.50 1790.50Q1255 1851 1170.50 1885.50Q1086 1920 992 1920L992 1920Q908 1920 830 1891Q752 1862 689 1811Q626 1760 582 1689.50Q538 1619 523 1536L523 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L518 512Q512 497 512 480L512 480Q512 445 537 420L537 420L932 25Q957 0 992 0L992 0Q1027 0 1052 25L1052 25L1447 420Q1472 445 1472 480L1472 480Q1472 497 1466 512L1466 512L1899 512Q1934 512 1959 537Q1984 562 1984 597ZM1326 480L992 146L658 480L690 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 782L1326 480ZM429 1360L592 1360L847 688L681 688Q639 811 596 932Q553 1053 513 1177L513 1177Q472 1054 431 932.50Q390 811 348 688L348 688L178 688L429 1360ZM992 1792L992 1792Q1065 1792 1129 1764.50Q1193 1737 1241 1689Q1289 1641 1316.50 1577Q1344 1513 1344 1440L1344 1440Q1344 1373 1319 1312Q1294 1251 1251 1203Q1208 1155 1149.50 1125Q1091 1095 1024 1090L1024 1090L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L655 1536Q672 1592 704 1639Q736 1686 780 1720Q824 1754 878 1773Q932 1792 992 1792ZM1461 1344L1856 1344L1856 640L1347 640Q1336 651 1310.50 677.50Q1285 704 1251.50 737.50Q1218 771 1181.50 808Q1145 845 1113 876Q1081 907 1056.50 929Q1032 951 1024 954L1024 954L1024 962Q1104 965 1176.50 996Q1249 1027 1307 1078.50Q1365 1130 1405 1198Q1445 1266 1461 1344L1461 1344Z"
         }
      }
   ]
}

var SocialListeningLogo = {
   name: "SocialListeningLogo",
   vendor: "UiFabric",
   unicode: 60796,
   value: "",
   charCode: "ED7C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M277 128L1771 128Q1800 128 1825.50 139Q1851 150 1870 169Q1889 188 1900 213.50Q1911 239 1911 268L1911 268L1911 533L1662 533Q1645 492 1609.50 468Q1574 444 1530 444L1530 444Q1501 444 1475 455Q1449 466 1429.50 485.50Q1410 505 1399 531Q1388 557 1388 586L1388 586Q1388 605 1393.50 622.50Q1399 640 1408 656L1408 656L1143 962Q1110 941 1069 941L1069 941Q1031 941 999 960Q967 979 947 1011L947 1011L603 834Q608 816 608 799L608 799Q608 770 597 744Q586 718 566.50 698.50Q547 679 521 668Q495 657 466 657L466 657Q421 657 385 682.50Q349 708 333 750L333 750L137 749L137 268Q137 239 148 213.50Q159 188 178 169Q197 150 222.50 139Q248 128 277 128L277 128ZM1530 728L1530 728Q1557 728 1581 718.50Q1605 709 1623.50 692.50Q1642 676 1654.50 653.50Q1667 631 1670 604L1670 604L1911 604L1911 1268Q1911 1297 1900 1322.50Q1889 1348 1870 1367Q1851 1386 1825.50 1397Q1800 1408 1771 1408L1771 1408L1108 1408L575 1920L611 1408L277 1408Q248 1408 222.50 1397Q197 1386 178 1367Q159 1348 148 1322.50Q137 1297 137 1268L137 1268L137 820L326 821Q330 847 342.50 869Q355 891 374 907Q393 923 416.50 932Q440 941 466 941L466 941Q495 941 522 929Q549 917 569 896L569 896L928 1080Q928 1081 927.50 1081.50Q927 1082 927 1083L927 1083Q926 1112 937.50 1137.50Q949 1163 969 1182.50Q989 1202 1015 1213Q1041 1224 1069 1224L1069 1224Q1098 1224 1124 1213Q1150 1202 1169.50 1183Q1189 1164 1200 1138Q1211 1112 1211 1083L1211 1083Q1211 1045 1192 1014L1192 1014L1457 707Q1474 717 1492 722.50Q1510 728 1530 728Z"
         }
      }
   ]
}

var LyncLogo = {
   name: "LyncLogo",
   vendor: "UiFabric",
   unicode: 60793,
   value: "",
   charCode: "ED79",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1662 797L1389 797Q1360 797 1331.50 801Q1303 805 1280 824L1280 824L1280 638Q1293 636 1304.50 631.50Q1316 627 1329 625L1329 625Q1326 620 1317.50 610.50Q1309 601 1301 590.50Q1293 580 1286.50 569.50Q1280 559 1280 552L1280 552L1280 506Q1280 492 1287.50 481Q1295 470 1306.50 462.50Q1318 455 1332 451Q1346 447 1358 447L1358 447Q1375 447 1391.50 454.50Q1408 462 1418 476L1418 476L1662 797ZM2048 1017L2048 1017Q2048 1086 2025 1150Q2002 1214 1960 1265.50Q1918 1317 1860.50 1352Q1803 1387 1734 1399L1734 1399Q1750 1421 1767 1443Q1784 1465 1784 1494L1784 1494Q1784 1528 1760.50 1552Q1737 1576 1703 1576L1703 1576Q1682 1576 1669 1569.50Q1656 1563 1643 1546L1643 1546L1399 1232Q1470 1233 1540.50 1233.50Q1611 1234 1682 1234L1682 1234Q1693 1234 1708 1230.50Q1723 1227 1733 1223L1733 1223Q1766 1212 1792.50 1191Q1819 1170 1838.50 1143Q1858 1116 1868.50 1084Q1879 1052 1879 1017L1879 1017Q1879 979 1866.50 942Q1854 905 1830 875L1830 875Q1822 865 1820.50 863.50Q1819 862 1818.50 862.50Q1818 863 1816.50 861.50Q1815 860 1807 851L1807 851L1625 631L1701 631L1701 630Q1776 635 1839.50 668.50Q1903 702 1949.50 755Q1996 808 2022 876Q2048 944 2048 1017ZM1280 1377L1280 1204L1436 1401L1367 1401Q1341 1401 1321.50 1396Q1302 1391 1280 1377L1280 1377ZM64 1782L64 272L1216 67L1216 1981L64 1782ZM466 642L466 1394L855 1416L853 1273L596 1269L596 626L466 642Z"
         }
      }
   ]
}

var ExchangeLogoInverse = {
   name: "ExchangeLogoInverse",
   vendor: "UiFabric",
   unicode: 60792,
   value: "",
   charCode: "ED78",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 256L2048 672Q2048 697 2038 721.50Q2028 746 2011 763L2011 763L1749 1024L2011 1285Q2028 1302 2038 1326.50Q2048 1351 2048 1376L2048 1376L2048 1792Q2048 1819 2038 1842Q2028 1865 2010.50 1882.50Q1993 1900 1970 1910Q1947 1920 1920 1920L1920 1920L1504 1920Q1479 1920 1454.50 1910Q1430 1900 1413 1883L1413 1883L1152 1621L891 1883Q874 1900 849.50 1910Q825 1920 800 1920L800 1920L384 1920Q357 1920 334 1910Q311 1900 293.50 1882.50Q276 1865 266 1842Q256 1819 256 1792L256 1792L256 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L256 512L256 256Q256 229 266 206Q276 183 293.50 165.50Q311 148 334 138Q357 128 384 128L384 128L800 128Q825 128 849.50 138Q874 148 891 165L891 165L1152 427L1413 165Q1430 148 1454.50 138Q1479 128 1504 128L1504 128L1920 128Q1947 128 1970 138Q1993 148 2010.50 165.50Q2028 183 2038 206Q2048 229 2048 256L2048 256ZM800 256L384 256L384 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 480L800 256ZM288 688L288 1360L736 1360L736 1225L445 1225L445 1089L705 1089L705 954L445 954L445 824L722 824L722 688L288 688ZM1920 1792L1920 1376L1696 1152L1381 1152Q1360 1152 1341.50 1160Q1323 1168 1309.50 1181.50Q1296 1195 1288 1213.50Q1280 1232 1280 1253L1280 1253L1280 1568L1504 1792L1920 1792ZM1568 1024L1920 672L1920 256L1504 256L1152 608L1152 795Q1152 861 1117.50 916.50Q1083 972 1024 1001L1024 1001L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L384 1536L384 1792L800 1792L1152 1440L1152 1253Q1152 1205 1170 1163.50Q1188 1122 1219 1091Q1250 1060 1291.50 1042Q1333 1024 1381 1024L1381 1024L1568 1024Z"
         }
      }
   ]
}

var DelveLogoInverse = {
   name: "DelveLogoInverse",
   vendor: "UiFabric",
   unicode: 60790,
   value: "",
   charCode: "ED76",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1664L1280 1280L1536 1280L1536 1664L1280 1664ZM1600 384L1984 384L1984 832L1600 832L1600 384ZM1280 1216L1280 384L1536 384L1536 1216L1280 1216ZM1600 1664L1600 896L1984 896L1984 1664L1600 1664ZM761 1006L761 1006Q761 1049 752.50 1096.50Q744 1144 723 1183.50Q702 1223 667 1248.50Q632 1274 578 1274L578 1274Q559 1274 540.50 1273.50Q522 1273 503 1272L503 1272L503 762Q522 760 540.50 759Q559 758 579 758L579 758Q631 758 666 780.50Q701 803 722 838.50Q743 874 752 918Q761 962 761 1006ZM64 1791L64 263L1216 56L1216 1992L64 1791ZM376 626L376 1409Q433 1414 490 1419.50Q547 1425 604 1425L604 1425Q661 1425 706.50 1407Q752 1389 786.50 1358.50Q821 1328 845.50 1286.50Q870 1245 886 1198Q902 1151 909 1101Q916 1051 916 1003L916 1003Q916 927 903 855.50Q890 784 856.50 728.50Q823 673 765.50 639.50Q708 606 620 606L620 606Q559 606 497.50 613.50Q436 621 376 626L376 626Z"
         }
      }
   ]
}

var AdminYLogoInverse32 = {
   name: "AdminYLogoInverse32",
   vendor: "UiFabric",
   unicode: 60787,
   value: "",
   charCode: "ED73",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1406 1025L1406 1025Q1406 1051 1396 1074Q1386 1097 1369 1114Q1352 1131 1329 1141Q1306 1151 1280 1151L1280 1151L1280 898Q1306 898 1329 908Q1352 918 1369 935.50Q1386 953 1396 976Q1406 999 1406 1025ZM64 1781L64 273L1216 68L1216 1980L64 1781ZM487 646L321 660L527 1168L527 1452L686 1466L686 1168L934 608L750 624L631 945Q625 961 621.50 977Q618 993 615 1010L615 1010L613 1010Q610 993 606.50 976Q603 959 597 943L597 943L487 646ZM1831 1027L2016 1109L1954 1348L1744 1320Q1727 1346 1708.50 1370Q1690 1394 1669 1416L1669 1416L1742 1605L1529 1730L1402 1564Q1342 1577 1280 1579L1280 1579L1280 1370Q1351 1370 1414 1343Q1477 1316 1524 1269.50Q1571 1223 1598 1160Q1625 1097 1625 1026L1625 1026Q1625 955 1598 892Q1571 829 1524 782Q1477 735 1414 708Q1351 681 1280 681L1280 681L1280 467L1285 467L1364 289L1602 352L1575 555Q1628 589 1674 635L1674 635L1860 564L1984 777L1818 904Q1824 932 1827.50 960Q1831 988 1831 1017L1831 1017L1831 1027Z"
         }
      }
   ]
}

var AdminSLogoInverse32 = {
   name: "AdminSLogoInverse32",
   vendor: "UiFabric",
   unicode: 60786,
   value: "",
   charCode: "ED72",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 1782L64 272L1216 67L1216 1981L64 1782ZM677 619L677 619Q623 619 579 636.50Q535 654 504 686Q473 718 456 762.50Q439 807 439 860L439 860Q439 919 457.50 958Q476 997 506 1027Q536 1057 574 1082.50Q612 1108 652 1139L652 1139Q669 1153 678 1172.50Q687 1192 687 1214L687 1214Q687 1252 663.50 1272Q640 1292 604 1292L604 1292Q581 1292 558 1285.50Q535 1279 513.50 1267.50Q492 1256 473.50 1240Q455 1224 442 1205L442 1205L442 1378Q481 1404 526 1418Q571 1432 619 1432L619 1432Q669 1432 710 1416.50Q751 1401 780 1372Q809 1343 824.50 1302Q840 1261 840 1210L840 1210Q840 1148 820.50 1105.50Q801 1063 772 1033.50Q743 1004 709.50 983.50Q676 963 647 943Q618 923 598.50 899.50Q579 876 579 842L579 842Q579 820 587.50 804Q596 788 610 778Q624 768 643 763.50Q662 759 682 759L682 759Q715 759 751 772.50Q787 786 811 810L811 810L811 641Q780 630 744.50 624.50Q709 619 677 619ZM1408 1024L1408 1024Q1408 1050 1398 1073.50Q1388 1097 1370.50 1114.50Q1353 1132 1329.50 1142Q1306 1152 1280 1152L1280 1152L1280 897Q1307 897 1330 907Q1353 917 1370.50 934Q1388 951 1398 974Q1408 997 1408 1024ZM1837 1027L2024 1110L1961 1351L1749 1323Q1732 1349 1713.50 1373.50Q1695 1398 1673 1419L1673 1419L1747 1611L1531 1737L1403 1569Q1343 1584 1280 1584L1280 1584L1280 1374Q1352 1374 1415.50 1346.50Q1479 1319 1526 1272Q1573 1225 1600.50 1161.50Q1628 1098 1628 1026L1628 1026Q1628 954 1600.50 890.50Q1573 827 1526 779.50Q1479 732 1415.50 704.50Q1352 677 1280 677L1280 677L1280 461L1285 461L1364 281L1605 345L1578 550Q1605 567 1630 587.50Q1655 608 1678 631L1678 631L1866 559L1991 774L1824 903Q1837 962 1837 1027L1837 1027Z"
         }
      }
   ]
}

var AdminPLogoInverse32 = {
   name: "AdminPLogoInverse32",
   vendor: "UiFabric",
   unicode: 60785,
   value: "",
   charCode: "ED71",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1024L1408 1024Q1408 1050 1398 1073.50Q1388 1097 1370.50 1114.50Q1353 1132 1329.50 1142Q1306 1152 1280 1152L1280 1152L1280 897Q1307 897 1330 907Q1353 917 1370.50 934Q1388 951 1398 974Q1408 997 1408 1024ZM1837 1027L2024 1110L1961 1351L1749 1323Q1732 1349 1713.50 1373.50Q1695 1398 1673 1419L1673 1419L1747 1611L1531 1737L1403 1569Q1343 1584 1280 1584L1280 1584L1280 1374Q1352 1374 1415.50 1346.50Q1479 1319 1526 1272Q1573 1225 1600.50 1161.50Q1628 1098 1628 1026L1628 1026Q1628 954 1600.50 890.50Q1573 827 1526 779.50Q1479 732 1415.50 704.50Q1352 677 1280 677L1280 677L1280 461L1285 461L1364 281L1605 345L1578 550Q1605 567 1630 587.50Q1655 608 1678 631L1678 631L1866 559L1991 774L1824 903Q1837 962 1837 1027L1837 1027ZM769 850L769 850Q769 922 731 951Q693 980 626 980L626 980Q613 980 601 979.50Q589 979 576 979L576 979L576 728Q593 727 609.50 726Q626 725 643 725L643 725Q769 725 769 850ZM64 1782L64 272L1216 67L1216 1981L64 1782ZM427 597L427 1387L576 1405L576 1117Q651 1119 718.50 1107.50Q786 1096 836 1064Q886 1032 915.50 976Q945 920 945 832L945 832Q945 710 880 646Q815 582 694 582L694 582Q628 582 561 587.50Q494 593 427 597L427 597Z"
         }
      }
   ]
}

var AdminOLogoInverse32 = {
   name: "AdminOLogoInverse32",
   vendor: "UiFabric",
   unicode: 60784,
   value: "",
   charCode: "ED70",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1406 1025L1406 1025Q1406 1051 1396 1074Q1386 1097 1369 1114Q1352 1131 1329 1141Q1306 1151 1280 1151L1280 1151L1280 898Q1306 898 1329 908Q1352 918 1369 935.50Q1386 953 1396 976Q1406 999 1406 1025ZM1831 1027L2017 1109L1954 1348L1745 1320Q1728 1346 1709 1370Q1690 1394 1669 1416L1669 1416L1742 1606L1529 1730L1402 1564Q1342 1577 1280 1579L1280 1579L1280 1370Q1351 1370 1414 1343Q1477 1316 1524 1269.50Q1571 1223 1598 1160Q1625 1097 1625 1026L1625 1026Q1625 954 1598 891.50Q1571 829 1524 782Q1477 735 1414 708Q1351 681 1280 681L1280 681L1280 467L1285 467L1364 289L1602 352L1576 555Q1602 572 1627 592Q1652 612 1674 635L1674 635L1860 564L1984 777L1818 904Q1824 932 1827.50 960Q1831 988 1831 1017L1831 1017L1831 1027ZM628 1279L628 1279Q586 1279 556 1252Q526 1225 507.50 1186.50Q489 1148 480.50 1104.50Q472 1061 472 1028L472 1028Q472 995 480.50 952Q489 909 507.50 870Q526 831 556 804.50Q586 778 628 778L628 778Q670 778 700 804.50Q730 831 748.50 869.50Q767 908 775.50 951.50Q784 995 784 1028L784 1028Q784 1061 775.50 1104.50Q767 1148 748.50 1187Q730 1226 700 1252.50Q670 1279 628 1279ZM64 1782L64 272L1216 67L1216 1981L64 1782ZM639 628L639 628Q589 628 547 645.50Q505 663 471.50 693.50Q438 724 412.50 763.50Q387 803 370 847.50Q353 892 344.50 938.50Q336 985 336 1028L336 1028Q336 1071 344.50 1117.50Q353 1164 370 1208.50Q387 1253 412.50 1292.50Q438 1332 471.50 1362.50Q505 1393 547 1410.50Q589 1428 639 1428L639 1428Q714 1428 771 1390Q828 1352 866 1293Q904 1234 923 1163.50Q942 1093 942 1028L942 1028Q942 963 923 892.50Q904 822 866 763Q828 704 771 666Q714 628 639 628Z"
         }
      }
   ]
}

var AdminMLogoInverse32 = {
   name: "AdminMLogoInverse32",
   vendor: "UiFabric",
   unicode: 60783,
   value: "",
   charCode: "ED6F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1405 1024L1405 1024Q1405 1050 1395 1073Q1385 1096 1368 1113Q1351 1130 1328.50 1140Q1306 1150 1280 1150L1280 1150L1280 899Q1306 899 1328.50 909Q1351 919 1368 936Q1385 953 1395 976Q1405 999 1405 1024ZM1827 1027L2011 1109L1948 1345L1741 1318Q1707 1371 1666 1413L1666 1413L1738 1601L1527 1724L1401 1560Q1339 1574 1280 1574L1280 1574L1280 1367Q1351 1367 1413 1340.50Q1475 1314 1521.50 1267.50Q1568 1221 1595 1159Q1622 1097 1622 1026L1622 1026Q1622 955 1595 893Q1568 831 1521.50 784.50Q1475 738 1413 711Q1351 684 1280 684L1280 684L1280 472L1285 472L1363 295L1599 358L1573 559Q1627 594 1671 639L1671 639L1855 568L1978 779L1814 905Q1827 963 1827 1027L1827 1027ZM64 1785L64 269L1216 64L1216 1984L64 1785ZM261 663L261 1393L374 1402L374 988Q374 940 372.50 891.50Q371 843 369 795L369 795L372 794Q376 820 379.50 846Q383 872 390 898L390 898L530 1414L645 1423L798 881Q806 854 810.50 826.50Q815 799 820 771L820 771L823 771Q821 816 819.50 859Q818 902 818 947L818 947L818 1437L974 1450L974 605L751 623L619 1100Q611 1128 605 1155.50Q599 1183 594 1212L594 1212L591 1212Q585 1156 570 1100L570 1100L447 648L261 663Z"
         }
      }
   ]
}

var AdminLLogoInverse32 = {
   name: "AdminLLogoInverse32",
   vendor: "UiFabric",
   unicode: 60782,
   value: "",
   charCode: "ED6E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 1782L64 272L1216 67L1216 1981L64 1782ZM462 642L462 1394L853 1416L850 1273L594 1269L594 626L462 642ZM1406 1025L1406 1025Q1406 1051 1396 1074Q1386 1097 1369 1114Q1352 1131 1329 1141Q1306 1151 1280 1151L1280 1151L1280 898Q1306 898 1329 908Q1352 918 1369 935.50Q1386 953 1396 976Q1406 999 1406 1025ZM1831 1027L2016 1109L1954 1348L1744 1320Q1727 1346 1708.50 1370Q1690 1394 1669 1416L1669 1416L1742 1605L1529 1730L1402 1564Q1342 1577 1280 1579L1280 1579L1280 1370Q1351 1370 1414 1343Q1477 1316 1524 1269.50Q1571 1223 1598 1160Q1625 1097 1625 1026L1625 1026Q1625 955 1598 892Q1571 829 1524 782Q1477 735 1414 708Q1351 681 1280 681L1280 681L1280 467L1285 467L1364 289L1602 352L1575 555Q1628 589 1674 635L1674 635L1860 564L1984 777L1818 904Q1824 932 1827.50 960Q1831 988 1831 1017L1831 1017L1831 1027Z"
         }
      }
   ]
}

var AdminELogoInverse32 = {
   name: "AdminELogoInverse32",
   vendor: "UiFabric",
   unicode: 60781,
   value: "",
   charCode: "ED6D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 1781L64 273L1216 68L1216 1980L64 1781ZM447 628L447 1424L824 1454L824 1297L582 1285L582 1098L792 1100L792 944L582 948L582 766L808 753L808 596L447 628ZM1406 1025L1406 1025Q1406 1051 1396 1074Q1386 1097 1369 1114Q1352 1131 1329 1141Q1306 1151 1280 1151L1280 1151L1280 898Q1306 898 1329 908Q1352 918 1369 935.50Q1386 953 1396 976Q1406 999 1406 1025ZM1831 1027L2016 1109L1954 1348L1744 1320Q1727 1346 1708.50 1370Q1690 1394 1669 1416L1669 1416L1742 1605L1529 1730L1402 1564Q1342 1577 1280 1579L1280 1579L1280 1370Q1351 1370 1414 1343Q1477 1316 1524 1269.50Q1571 1223 1598 1160Q1625 1097 1625 1026L1625 1026Q1625 955 1598 892Q1571 829 1524 782Q1477 735 1414 708Q1351 681 1280 681L1280 681L1280 467L1285 467L1364 289L1602 352L1575 555Q1628 589 1674 635L1674 635L1860 564L1984 777L1818 904Q1824 932 1827.50 960Q1831 988 1831 1017L1831 1017L1831 1027Z"
         }
      }
   ]
}

var AdminDLogoInverse32 = {
   name: "AdminDLogoInverse32",
   vendor: "UiFabric",
   unicode: 60780,
   value: "",
   charCode: "ED6C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M761 999L761 999Q761 1043 752 1090.50Q743 1138 722 1177Q701 1216 665 1241.50Q629 1267 575 1267L575 1267Q557 1267 539 1266Q521 1265 503 1264L503 1264L503 754Q523 753 542.50 752Q562 751 582 751L582 751Q633 751 667.50 773.50Q702 796 723 832Q744 868 752.50 912Q761 956 761 999ZM64 1781L64 273L1216 68L1216 1980L64 1781ZM376 618L376 1402Q433 1406 490 1411.50Q547 1417 604 1417L604 1417Q690 1417 749.50 1378.50Q809 1340 846 1279Q883 1218 899.50 1143Q916 1068 916 995L916 995Q916 919 903 847.50Q890 776 856.50 720.50Q823 665 765.50 631.50Q708 598 620 598L620 598Q559 598 497.50 605.50Q436 613 376 618L376 618ZM1406 1025L1406 1025Q1406 1051 1396 1074Q1386 1097 1369 1114Q1352 1131 1329 1141Q1306 1151 1280 1151L1280 1151L1280 898Q1306 898 1329 908Q1352 918 1369 935.50Q1386 953 1396 976Q1406 999 1406 1025ZM1831 1027L2016 1109L1954 1348L1744 1320Q1727 1346 1708.50 1370Q1690 1394 1669 1416L1669 1416L1742 1605L1529 1730L1402 1564Q1342 1577 1280 1579L1280 1579L1280 1370Q1351 1370 1414 1343Q1477 1316 1524 1269.50Q1571 1223 1598 1160Q1625 1097 1625 1026L1625 1026Q1625 955 1598 892Q1571 829 1524 782Q1477 735 1414 708Q1351 681 1280 681L1280 681L1280 467L1285 467L1364 289L1602 352L1575 555Q1628 589 1674 635L1674 635L1860 564L1984 777L1818 904Q1824 932 1827.50 960Q1831 988 1831 1017L1831 1017L1831 1027Z"
         }
      }
   ]
}

var AdminCLogoInverse32 = {
   name: "AdminCLogoInverse32",
   vendor: "UiFabric",
   unicode: 60779,
   value: "",
   charCode: "ED6B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1406 1025L1406 1025Q1406 1051 1396 1074Q1386 1097 1369 1114Q1352 1131 1329 1141Q1306 1151 1280 1151L1280 1151L1280 898Q1306 898 1329 908Q1352 918 1369 935.50Q1386 953 1396 976Q1406 999 1406 1025ZM1832 1027L2017 1109L1954 1348L1745 1320Q1728 1346 1709 1370Q1690 1394 1669 1416L1669 1416L1742 1606L1529 1730L1402 1564Q1372 1572 1341.50 1575Q1311 1578 1280 1579L1280 1579L1280 1370Q1351 1370 1414 1343Q1477 1316 1524 1269.50Q1571 1223 1598 1160Q1625 1097 1625 1026L1625 1026Q1625 955 1598 892Q1571 829 1524 782Q1477 735 1414.50 708Q1352 681 1280 681L1280 681L1280 467L1285 467L1364 289L1602 352L1576 555Q1602 572 1627 592Q1652 612 1674 635L1674 635L1860 564L1984 777L1819 904Q1825 935 1828.50 965.50Q1832 996 1832 1027L1832 1027ZM64 1781L64 273L1216 68L1216 1980L64 1781ZM740 627L740 627Q647 627 576 658Q505 689 457 744Q409 799 384 874.50Q359 950 359 1039L359 1039Q359 1122 380.50 1191.50Q402 1261 445 1311Q488 1361 553.50 1388.50Q619 1416 706 1416L706 1416Q744 1416 783.50 1410.50Q823 1405 858 1388L858 1388L858 1226Q786 1269 703 1269L703 1269Q650 1269 612 1249Q574 1229 549 1195.50Q524 1162 512 1118.50Q500 1075 500 1027L500 1027Q500 976 513 930.50Q526 885 553 850.50Q580 816 620.50 796Q661 776 717 776L717 776Q755 776 790.50 785.50Q826 795 858 815L858 815L858 644Q829 634 799.50 630.50Q770 627 740 627Z"
         }
      }
   ]
}

var AdminALogoInverse32 = {
   name: "AdminALogoInverse32",
   vendor: "UiFabric",
   unicode: 60778,
   value: "",
   charCode: "ED6A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1407 1025L1407 1025Q1407 1051 1397 1074Q1387 1097 1369.50 1114Q1352 1131 1329 1141Q1306 1151 1280 1151L1280 1151L1280 897Q1306 897 1329 907Q1352 917 1369.50 934.50Q1387 952 1397 975.50Q1407 999 1407 1025ZM1834 1027L2020 1109L1957 1349L1747 1321Q1730 1347 1711.50 1371Q1693 1395 1671 1417L1671 1417L1744 1608L1530 1733L1402 1566Q1342 1581 1280 1581L1280 1581L1280 1372Q1352 1372 1415 1345Q1478 1318 1525 1270.50Q1572 1223 1599 1160Q1626 1097 1626 1025L1626 1025Q1626 954 1599 891Q1572 828 1525 781Q1478 734 1415 706.50Q1352 679 1280 679L1280 679L1280 464L1285 464L1364 286L1604 349L1577 553Q1604 570 1628.50 590Q1653 610 1676 633L1676 633L1863 562L1987 776L1821 903Q1834 962 1834 1027L1834 1027ZM616 779L619 779Q636 859 655 937.50Q674 1016 693 1096L693 1096L542 1094Q561 1015 580 936.50Q599 858 616 779L616 779ZM64 1782L64 272L1216 67L1216 1981L64 1782ZM543 651L340 1371L474 1379L514 1220L725 1227L769 1397L925 1407L701 641L543 651Z"
         }
      }
   ]
}

var AccessLogo = {
   name: "AccessLogo",
   vendor: "UiFabric",
   unicode: 60777,
   value: "",
   charCode: "ED69",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 64L1280 64Q1417 64 1554 79L1554 79Q1578 82 1623.50 88.50Q1669 95 1724 106.50Q1779 118 1836.50 134.50Q1894 151 1941 173.50Q1988 196 2018 224.50Q2048 253 2048 288L2048 288L2048 1760Q2048 1795 2018 1823.50Q1988 1852 1941 1874.50Q1894 1897 1836.50 1913.50Q1779 1930 1724 1941.50Q1669 1953 1623.50 1960Q1578 1967 1554 1969L1554 1969Q1417 1984 1280 1984L1280 1984Q1142 1984 1006 1969L1006 1969Q982 1967 936.50 1960Q891 1953 836 1941.50Q781 1930 723.50 1913.50Q666 1897 619 1874.50Q572 1852 542 1823.50Q512 1795 512 1760L512 1760L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 288Q512 253 542 224.50Q572 196 619 173.50Q666 151 723.50 134.50Q781 118 836 106.50Q891 95 936.50 88.50Q982 82 1006 79L1006 79Q1142 64 1280 64ZM1280 192L1280 192Q1215 192 1135 196.50Q1055 201 972.50 212Q890 223 812 241.50Q734 260 674 288L674 288Q736 317 813.50 335.50Q891 354 972.50 364.50Q1054 375 1133.50 379.50Q1213 384 1280 384L1280 384Q1347 384 1426.50 379.50Q1506 375 1587.50 364.50Q1669 354 1746.50 335.50Q1824 317 1886 288L1886 288Q1826 260 1748 241.50Q1670 223 1587.50 212Q1505 201 1425 196.50Q1345 192 1280 192ZM352 1360L403 1207L620 1207L671 1360L842 1360L597 688L430 688L182 1360L352 1360ZM1920 1739L1920 1739L1920 1436Q1854 1465 1772.50 1484Q1691 1503 1605 1514.50Q1519 1526 1435 1531Q1351 1536 1280 1536L1280 1536Q1207 1536 1134.50 1531.50Q1062 1527 990 1519L990 1519Q967 1536 939 1536L939 1536L640 1536L640 1739Q669 1762 718 1780Q767 1798 826.50 1811Q886 1824 951 1832.50Q1016 1841 1077.50 1846.50Q1139 1852 1192 1854Q1245 1856 1280 1856L1280 1856Q1315 1856 1368 1854Q1421 1852 1482.50 1846.50Q1544 1841 1609 1832.50Q1674 1824 1733.50 1811Q1793 1798 1842 1780Q1891 1762 1920 1739ZM1920 1293L1920 1293L1920 924Q1854 953 1772.50 972Q1691 991 1605 1002.50Q1519 1014 1435 1019Q1351 1024 1280 1024L1280 1024Q1216 1024 1152 1020.50Q1088 1017 1024 1011L1024 1011L1024 1395Q1088 1402 1152 1405Q1216 1408 1280 1408L1280 1408Q1317 1408 1370 1406Q1423 1404 1483.50 1398.50Q1544 1393 1608 1384.50Q1672 1376 1731 1363Q1790 1350 1839.50 1333Q1889 1316 1920 1293ZM1920 781L1920 781L1920 412Q1854 441 1772.50 460Q1691 479 1605 490.50Q1519 502 1435 507Q1351 512 1280 512L1280 512Q1209 512 1125 507Q1041 502 955 490.50Q869 479 787.50 460Q706 441 640 412L640 412L640 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 883Q1088 890 1152 893Q1216 896 1280 896L1280 896Q1317 896 1370 894Q1423 892 1483.50 886.50Q1544 881 1608 872.50Q1672 864 1731 851Q1790 838 1839 821Q1888 804 1920 781ZM578 1077L442 1077L511 868L578 1077Z"
         }
      }
   ]
}

var AADLogo = {
   name: "AADLogo",
   vendor: "UiFabric",
   unicode: 60776,
   value: "",
   charCode: "ED68",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 140L2048 1310L1024 1908L0 1310L1024 140ZM1522 1370L1522 1370Q1552 1370 1579 1358.50Q1606 1347 1625.50 1327.50Q1645 1308 1656.50 1281Q1668 1254 1668 1224L1668 1224Q1668 1194 1656.50 1167.50Q1645 1141 1625 1121.50Q1605 1102 1578.50 1090.50Q1552 1079 1522 1079L1522 1079Q1490 1079 1460 1093L1460 1093L1146 734Q1169 699 1169 655L1169 655Q1169 625 1157.50 598.50Q1146 572 1126.50 552.50Q1107 533 1080.50 521.50Q1054 510 1024 510L1024 510Q994 510 967.50 521.50Q941 533 921 552.50Q901 572 889.50 598.50Q878 625 878 655L878 655Q878 676 884.50 696.50Q891 717 902 734L902 734L588 1093Q558 1079 526 1079L526 1079Q496 1079 469.50 1090.50Q443 1102 423 1121.50Q403 1141 391.50 1167.50Q380 1194 380 1224L380 1224Q380 1254 391.50 1281Q403 1308 422.50 1327.50Q442 1347 469 1358.50Q496 1370 526 1370L526 1370Q554 1370 580 1359.50Q606 1349 626 1329L626 1329L883 1479Q878 1499 878 1515L878 1515Q878 1545 889.50 1571.50Q901 1598 921 1618Q941 1638 967.50 1649.50Q994 1661 1024 1661L1024 1661Q1054 1661 1080.50 1649.50Q1107 1638 1127 1618Q1147 1598 1158.50 1571.50Q1170 1545 1170 1515L1170 1515Q1170 1499 1165 1479L1165 1479L1421 1329Q1441 1349 1467 1359.50Q1493 1370 1522 1370ZM648 1145L962 787Q967 789 972.50 791Q978 793 984 795L984 795L984 1375Q949 1386 923 1410L923 1410L666 1260Q671 1240 671 1224L671 1224Q671 1180 648 1145L648 1145ZM1086 787L1400 1145Q1377 1180 1377 1224L1377 1224Q1377 1244 1381 1260L1381 1260L1125 1410Q1099 1386 1064 1375L1064 1375L1064 795Q1070 793 1075.50 791Q1081 789 1086 787L1086 787Z"
         }
      }
   ]
}

var OfficeVideoLogoInverse = {
   name: "OfficeVideoLogoInverse",
   vendor: "UiFabric",
   unicode: 60794,
   value: "",
   charCode: "ED7A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 1791L64 263L1216 56L1216 1992L64 1791ZM489 651L489 656L331 656L551 1415L715 1415L905 641L747 641Q718 781 690 920Q662 1059 631 1199L631 1199Q596 1061 560.50 925Q525 789 489 651L489 651ZM1504 1344L1504 1344Q1438 1344 1380 1315Q1322 1286 1280 1235L1280 1235L1280 877Q1322 826 1380 797Q1438 768 1504 768L1504 768Q1564 768 1616.50 790.50Q1669 813 1708 852Q1747 891 1769.50 943.50Q1792 996 1792 1056L1792 1056Q1792 1116 1769.50 1168.50Q1747 1221 1708 1260Q1669 1299 1616.50 1321.50Q1564 1344 1504 1344ZM1408 909L1408 1203L1648 1056L1408 909ZM1280 512L1920 512Q1947 512 1970 522Q1993 532 2010.50 549.50Q2028 567 2038 590Q2048 613 2048 640L2048 640L2048 1472Q2048 1499 2038 1522Q2028 1545 2010.50 1562.50Q1993 1580 1970 1590Q1947 1600 1920 1600L1920 1600L1280 1600L1280 1472L1920 1472L1920 640L1280 640L1280 512Z"
         }
      }
   ]
}

var DateTimeMirrored = {
   name: "DateTimeMirrored",
   vendor: "UiFabric",
   unicode: 61075,
   value: "",
   charCode: "EE93",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 128L1792 993Q1852 1034 1899.50 1086.50Q1947 1139 1980 1200.50Q2013 1262 2030.50 1331Q2048 1400 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1381 2048 1296 2020.50Q1211 1993 1139.50 1942.50Q1068 1892 1013.50 1821Q959 1750 929 1664L929 1664L128 1664L128 128L384 128L384 0L512 0L512 128L1408 128L1408 0L1536 0L1536 128L1792 128ZM384 256L256 256L256 512L1664 512L1664 256L1536 256L1536 384L1408 384L1408 256L512 256L512 384L384 384L384 256ZM256 1536L899 1536Q896 1505 896 1472L896 1472Q896 1386 920.50 1305Q945 1224 993 1152L993 1152L896 1152L896 1024L1024 1024L1024 1110Q1065 1059 1115.50 1019.50Q1166 980 1223.50 952.50Q1281 925 1344 910.50Q1407 896 1472 896L1472 896Q1572 896 1664 929L1664 929L1664 640L256 640L256 1536ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1536 1152L1536 1408L1728 1408L1728 1536L1408 1536L1408 1152L1536 1152ZM384 1152L384 1024L512 1024L512 1152L384 1152ZM640 1152L640 1024L768 1024L768 1152L640 1152ZM640 896L640 768L768 768L768 896L640 896ZM640 1408L640 1280L768 1280L768 1408L640 1408ZM1024 768L1024 896L896 896L896 768L1024 768ZM1280 768L1280 896L1152 896L1152 768L1280 768ZM384 896L384 768L512 768L512 896L384 896Z"
         }
      }
   ]
}

var HardDrive = {
   name: "HardDrive",
   vendor: "UiFabric",
   unicode: 60834,
   value: "",
   charCode: "EDA2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M192 640L1856 640Q1896 640 1931 655Q1966 670 1992 696Q2018 722 2033 757Q2048 792 2048 832L2048 832L2048 1408L0 1408L0 832Q0 792 15 757Q30 722 56 696Q82 670 117 655Q152 640 192 640L192 640ZM1920 1280L1920 832Q1920 806 1901 787Q1882 768 1856 768L1856 768L192 768Q166 768 147 787Q128 806 128 832L128 832L128 1280L1920 1280ZM1664 1024L1664 896L1792 896L1792 1024L1664 1024ZM1408 1024L1408 896L1536 896L1536 1024L1408 1024Z"
         }
      }
   ]
}

var Unsubscribe = {
   name: "Unsubscribe",
   vendor: "UiFabric",
   unicode: 60832,
   value: "",
   charCode: "EDA0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1546 153L1920 1276Q1921 1278 1921.50 1304.50Q1922 1331 1922 1373.50Q1922 1416 1922 1470.50Q1922 1525 1921.50 1582.50Q1921 1640 1921 1696Q1921 1752 1920.50 1798.50Q1920 1845 1920 1877.50Q1920 1910 1920 1920L1920 1920L0 1920L0 1276L373 158L475 257L134 1280L552 1280L680 1536L1240 1536L1368 1280L1786 1280L1445 256L1546 153ZM1792 1792L1792 1408L1448 1408L1320 1664L600 1664L472 1408L128 1408L128 1792L1792 1792ZM621 877L531 787L869 448L531 109L621 19L960 358L1299 19L1389 109L1050 448L1389 787L1299 877L960 538L621 877Z"
         }
      }
   ]
}

var CircleHalfFull = {
   name: "CircleHalfFull",
   vendor: "UiFabric",
   unicode: 60830,
   value: "",
   charCode: "ED9E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q1148 128 1262.50 160Q1377 192 1476.50 250.50Q1576 309 1657.50 390.50Q1739 472 1797.50 571.50Q1856 671 1888 785.50Q1920 900 1920 1024L1920 1024Q1920 1148 1888 1262.50Q1856 1377 1797.50 1476.50Q1739 1576 1657.50 1657.50Q1576 1739 1476.50 1797.50Q1377 1856 1262.50 1888Q1148 1920 1024 1920L1024 1920Q900 1920 785.50 1888Q671 1856 571.50 1797.50Q472 1739 390.50 1657.50Q309 1576 250.50 1476.50Q192 1377 160 1262.50Q128 1148 128 1024L128 1024Q128 900 160 785.50Q192 671 250.50 571.50Q309 472 390.50 390.50Q472 309 571.50 250.50Q671 192 785.50 160Q900 128 1024 128ZM1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256Z"
         }
      }
   ]
}

var Timeline = {
   name: "Timeline",
   vendor: "UiFabric",
   unicode: 60828,
   value: "",
   charCode: "ED9C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L1920 1110Q1983 1187 2015.50 1279.50Q2048 1372 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1372 929 1280L929 1280L0 1280L0 256L256 256L256 384L128 384L128 640L896 640L896 384L768 384L768 256L1152 256L1152 384L1024 384L1024 640L1792 640L1792 384L1664 384L1664 256L1920 256ZM128 1152L993 1152Q1033 1092 1086 1044.50Q1139 997 1200.50 964Q1262 931 1331 913.50Q1400 896 1472 896L1472 896Q1558 896 1639 920.50Q1720 945 1792 993L1792 993L1792 768L128 768L128 1152ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1536 1152L1536 1408L1728 1408L1728 1536L1408 1536L1408 1152L1536 1152Z"
         }
      }
   ]
}

var NotePinned = {
   name: "NotePinned",
   vendor: "UiFabric",
   unicode: 60826,
   value: "",
   charCode: "ED9A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1792L1792 1271Q1853 1298 1920 1307L1920 1307L1920 1920L677 1920L128 1371L128 128L1920 128L1920 357Q1853 366 1792 393L1792 393L1792 256L256 256L256 1280L768 1280L768 1792L1792 1792ZM640 1701L640 1408L347 1408L640 1701ZM1984 512L2048 512L2048 1152L1984 1152Q1906 1152 1841 1118.50Q1776 1085 1729 1024L1729 1024L1619 1024Q1591 1083 1549 1130.50Q1507 1178 1454.50 1211Q1402 1244 1341.50 1262Q1281 1280 1216 1280L1216 1280L1152 1280L1152 896L640 896L512 832L640 768L1152 768L1152 384L1216 384Q1281 384 1341.50 402Q1402 420 1454.50 453Q1507 486 1549 533.50Q1591 581 1619 640L1619 640L1729 640Q1776 579 1841 545.50Q1906 512 1984 512L1984 512ZM1920 1013L1920 651Q1896 659 1879 671Q1862 683 1848.50 697.50Q1835 712 1823.50 730Q1812 748 1800 768L1800 768L1531 768L1516 725Q1488 646 1425 591Q1362 536 1280 519L1280 519L1280 1145Q1362 1128 1425 1073Q1488 1018 1516 939L1516 939L1531 896L1800 896Q1812 916 1823.50 934Q1835 952 1848.50 966.50Q1862 981 1879 993Q1896 1005 1920 1013L1920 1013Z"
         }
      }
   ]
}

var NoteReply = {
   name: "NoteReply",
   vendor: "UiFabric",
   unicode: 60824,
   value: "",
   charCode: "ED98",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1499 1536L1792 1536Q1845 1536 1891.50 1556Q1938 1576 1973 1611Q2008 1646 2028 1692.50Q2048 1739 2048 1792L2048 1792Q2048 1845 2028 1891.50Q2008 1938 1973 1973Q1938 2008 1891.50 2028Q1845 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373L1499 1536ZM768 1792L1219 1792L1347 1920L677 1920L128 1371L128 128L1920 128L1920 1406L1792 1278L1792 256L256 256L256 1280L768 1280L768 1792ZM640 1701L640 1408L347 1408L640 1701Z"
         }
      }
   ]
}

var AddPhone = {
   name: "AddPhone",
   vendor: "UiFabric",
   unicode: 60822,
   value: "",
   charCode: "ED96",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1402 1307L1402 1307Q1441 1307 1478 1322Q1515 1337 1543 1365L1543 1365L1734 1556Q1762 1584 1777 1621Q1792 1658 1792 1697L1792 1697Q1792 1736 1777 1773Q1762 1810 1734 1838L1734 1838L1638 1934Q1575 1996 1495 2022Q1415 2048 1329 2048L1329 2048Q1222 2048 1107.50 2014.50Q993 1981 879.50 1921Q766 1861 656.50 1779Q547 1697 449.50 1599.50Q352 1502 269.50 1392.50Q187 1283 127 1169.50Q67 1056 33.50 942Q0 828 0 720L0 720Q0 643 13.50 589Q27 535 53.50 491Q80 447 119 406Q158 365 210 314L210 314Q238 286 275 271Q312 256 351 256L351 256Q390 256 427 271Q464 286 492 314L492 314L683 505Q711 533 726 570Q741 607 741 646L741 646Q741 685 728 715.50Q715 746 695.50 771.50Q676 797 653.50 817.50Q631 838 611.50 857Q592 876 579 894.50Q566 913 566 933L566 933Q566 962 587 983L587 983L1065 1461Q1086 1482 1115 1482L1115 1482Q1136 1482 1154.50 1469Q1173 1456 1191.50 1436.50Q1210 1417 1230.50 1394.50Q1251 1372 1276 1352.50Q1301 1333 1331.50 1320Q1362 1307 1402 1307ZM1331 1920L1331 1920Q1391 1920 1432 1908.50Q1473 1897 1506.50 1875Q1540 1853 1571 1821Q1602 1789 1643 1748L1643 1748Q1664 1727 1664 1698L1664 1698Q1664 1668 1643 1647L1643 1647L1452 1456Q1431 1435 1401 1435L1401 1435Q1380 1435 1362 1448Q1344 1461 1325 1480.50Q1306 1500 1285.50 1522.50Q1265 1545 1240.50 1564.50Q1216 1584 1185 1597Q1154 1610 1115 1610L1115 1610Q1075 1610 1038.50 1594.50Q1002 1579 974 1551L974 1551L497 1074Q469 1046 453.50 1009.50Q438 973 438 933L438 933Q438 894 451 863.50Q464 833 483.50 808Q503 783 525.50 762.50Q548 742 567.50 723Q587 704 600 685.50Q613 667 613 646L613 646Q613 617 592 596L592 596L401 405Q380 384 351 384L351 384Q321 384 300 405L300 405Q259 446 227 477Q195 508 173 541.50Q151 575 139.50 616Q128 657 128 717L128 717Q128 812 159 914Q190 1016 245 1118.50Q300 1221 375.50 1320Q451 1419 540 1508Q629 1597 728 1672.50Q827 1748 929.50 1803Q1032 1858 1134 1889Q1236 1920 1331 1920ZM1664 384L2048 384L2048 512L1664 512L1664 896L1536 896L1536 512L1152 512L1152 384L1536 384L1536 0L1664 0L1664 384Z"
         }
      }
   ]
}

var PeoplePause = {
   name: "PeoplePause",
   vendor: "UiFabric",
   unicode: 60820,
   value: "",
   charCode: "ED94",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1152L1792 1152Q1792 1073 1762 1003Q1732 933 1679.50 880.50Q1627 828 1557 798Q1487 768 1408 768L1408 768Q1328 768 1258.50 798Q1189 828 1136.50 880.50Q1084 933 1054 1003Q1024 1073 1024 1152L1024 1152Q1024 1244 983 1325Q942 1406 868 1461L868 1461Q933 1494 985.50 1542.50Q1038 1591 1075 1650.50Q1112 1710 1132 1778.50Q1152 1847 1152 1920L1152 1920L1024 1920Q1024 1841 994 1771Q964 1701 911.50 1648.50Q859 1596 789 1566Q719 1536 640 1536L640 1536Q560 1536 490.50 1566Q421 1596 368.50 1648.50Q316 1701 286 1771Q256 1841 256 1920L256 1920L128 1920Q128 1847 148 1778.50Q168 1710 205 1650.50Q242 1591 294.50 1542.50Q347 1494 412 1461L412 1461Q338 1406 297 1325Q256 1244 256 1152L256 1152Q256 1073 286 1003Q316 933 368.50 880.50Q421 828 490.50 798Q560 768 640 768L640 768Q732 768 813 809Q894 850 949 924L949 924Q987 849 1046 790Q1105 731 1180 693L1180 693Q1106 638 1065 557Q1024 476 1024 384L1024 384Q1024 305 1054 235Q1084 165 1136.50 112.50Q1189 60 1258.50 30Q1328 0 1408 0L1408 0Q1487 0 1557 30Q1627 60 1679.50 112.50Q1732 165 1762 235Q1792 305 1792 384L1792 384Q1792 476 1751 557Q1710 638 1636 693L1636 693Q1701 726 1753.50 774.50Q1806 823 1843 882.50Q1880 942 1900 1010.50Q1920 1079 1920 1152L1920 1152ZM640 1408L640 1408Q693 1408 739.50 1388Q786 1368 821 1333Q856 1298 876 1251.50Q896 1205 896 1152L896 1152Q896 1099 876 1052.50Q856 1006 821 971Q786 936 739.50 916Q693 896 640 896L640 896Q587 896 540.50 916Q494 936 459 971Q424 1006 404 1052.50Q384 1099 384 1152L384 1152Q384 1205 404 1251.50Q424 1298 459 1333Q494 1368 540.50 1388Q587 1408 640 1408ZM1152 384L1152 384Q1152 437 1172 483.50Q1192 530 1227 565Q1262 600 1308.50 620Q1355 640 1408 640L1408 640Q1461 640 1507.50 620Q1554 600 1589 565Q1624 530 1644 483.50Q1664 437 1664 384L1664 384Q1664 331 1644 284.50Q1624 238 1589 203Q1554 168 1507.50 148Q1461 128 1408 128L1408 128Q1355 128 1308.50 148Q1262 168 1227 203Q1192 238 1172 284.50Q1152 331 1152 384ZM1792 2048L1792 1280L1920 1280L1920 2048L1792 2048ZM1408 2048L1408 1280L1536 1280L1536 2048L1408 2048Z"
         }
      }
   ]
}

var PeopleRepeat = {
   name: "PeopleRepeat",
   vendor: "UiFabric",
   unicode: 60818,
   value: "",
   charCode: "ED92",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1817 1408Q1776 1346 1708.50 1313Q1641 1280 1568 1280L1568 1280Q1514 1280 1462 1298.50Q1410 1317 1369.50 1350.50Q1329 1384 1304.50 1431Q1280 1478 1280 1536L1280 1536L1152 1536Q1152 1451 1186.50 1380.50Q1221 1310 1279 1259Q1337 1208 1412 1180Q1487 1152 1568 1152L1568 1152Q1620 1152 1670 1163.50Q1720 1175 1766 1198Q1812 1221 1851 1254.50Q1890 1288 1920 1331L1920 1331L1920 1152ZM1632 1920L1632 1920Q1686 1920 1737.50 1901.50Q1789 1883 1829.50 1849.50Q1870 1816 1895 1769Q1920 1722 1920 1664L1920 1664L2048 1664Q2048 1749 2013.50 1819.50Q1979 1890 1921 1941Q1863 1992 1788 2020Q1713 2048 1632 2048L1632 2048Q1580 2048 1530 2036.50Q1480 2025 1434 2002Q1388 1979 1349 1946Q1310 1913 1280 1869L1280 1869L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1383 1792Q1424 1854 1491.50 1887Q1559 1920 1632 1920ZM1408 768L1408 768Q1329 768 1259 798Q1189 828 1137 880Q1085 932 1054.50 1002Q1024 1072 1024 1151L1024 1151Q1024 1244 982.50 1325.50Q941 1407 866 1462L866 1462Q911 1485 951 1516Q991 1547 1024 1585L1024 1585L922 1664Q868 1603 794.50 1569.50Q721 1536 640 1536L640 1536Q560 1536 490.50 1566Q421 1596 368.50 1648.50Q316 1701 286 1771Q256 1841 256 1920L256 1920L128 1920Q128 1847 148 1778.50Q168 1710 205 1650Q242 1590 295 1542Q348 1494 413 1461L413 1461Q339 1407 297.50 1325.50Q256 1244 256 1152L256 1152Q256 1073 286 1003Q316 933 368.50 880.50Q421 828 490.50 798Q560 768 640 768L640 768Q732 768 813.50 809.50Q895 851 949 925L949 925Q987 850 1046.50 790.50Q1106 731 1181 693L1181 693Q1107 639 1065.50 557.50Q1024 476 1024 384L1024 384Q1024 305 1054 235Q1084 165 1136.50 112.50Q1189 60 1258.50 30Q1328 0 1408 0L1408 0Q1487 0 1557 30Q1627 60 1679.50 112.50Q1732 165 1762 235Q1792 305 1792 384L1792 384Q1792 476 1751 557.50Q1710 639 1635 693L1635 693Q1735 743 1804.50 829.50Q1874 916 1902 1024L1902 1024L1768 1024Q1748 967 1712 919.50Q1676 872 1629 838.50Q1582 805 1525.50 786.50Q1469 768 1408 768ZM1408 128L1408 128Q1355 128 1308.50 148Q1262 168 1227 203Q1192 238 1172 284.50Q1152 331 1152 384L1152 384Q1152 437 1172 483.50Q1192 530 1227 565Q1262 600 1308.50 620Q1355 640 1408 640L1408 640Q1461 640 1507.50 620Q1554 600 1589 565Q1624 530 1644 483.50Q1664 437 1664 384L1664 384Q1664 331 1644 284.50Q1624 238 1589 203Q1554 168 1507.50 148Q1461 128 1408 128ZM640 1408L640 1408Q693 1408 739.50 1388Q786 1368 821 1333Q856 1298 876 1251.50Q896 1205 896 1152L896 1152Q896 1099 876 1052Q856 1005 821.50 970.50Q787 936 740 916Q693 896 640 896L640 896Q587 896 540.50 916Q494 936 459 971Q424 1006 404 1052.50Q384 1099 384 1152L384 1152Q384 1205 404 1251.50Q424 1298 459 1333Q494 1368 540.50 1388Q587 1408 640 1408Z"
         }
      }
   ]
}

var RemoveLink = {
   name: "RemoveLink",
   vendor: "UiFabric",
   unicode: 60816,
   value: "",
   charCode: "ED90",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 384L960 384Q1053 384 1134 419.50Q1215 455 1276 515.50Q1337 576 1372 657.50Q1407 739 1407 832L1407 832Q1407 925 1372 1006.50Q1337 1088 1276 1148.50Q1215 1209 1134 1244.50Q1053 1280 960 1280L960 1280L896 1280L896 1152L960 1152Q1026 1152 1084 1127Q1142 1102 1185.50 1058.50Q1229 1015 1254.50 956.50Q1280 898 1280 832L1280 832Q1280 766 1254.50 708Q1229 650 1185.50 606.50Q1142 563 1084 537.50Q1026 512 960 512L960 512L448 512Q382 512 323.50 537.50Q265 563 221.50 606.50Q178 650 153 708Q128 766 128 832L128 832Q128 898 153 956.50Q178 1015 221.50 1058.50Q265 1102 323.50 1127Q382 1152 448 1152L448 1152L512 1152L512 1280L448 1280Q355 1280 273.50 1244.50Q192 1209 131.50 1148.50Q71 1088 35.50 1006.50Q0 925 0 832L0 832Q0 739 35.50 657.50Q71 576 131.50 515.50Q192 455 273.50 419.50Q355 384 448 384L448 384ZM2037 1312L1918 1193Q1913 1130 1886.50 1076Q1860 1022 1817.50 982Q1775 942 1719 919Q1663 896 1600 896L1600 896L1536 896L1536 768L1600 768Q1693 768 1774.50 803.50Q1856 839 1916.50 899.50Q1977 960 2012.50 1041.50Q2048 1123 2048 1216L2048 1216Q2048 1263 2037 1312L2037 1312ZM768 1216L768 1216Q768 1282 793 1340.50Q818 1399 861.50 1442.50Q905 1486 963.50 1511Q1022 1536 1088 1536L1088 1536L1264 1536L1392 1664L1088 1664Q995 1664 913.50 1628.50Q832 1593 771.50 1532.50Q711 1472 675.50 1390.50Q640 1309 640 1216L640 1216Q640 1123 675.50 1041.50Q711 960 771.50 899.50Q832 839 913.50 803.50Q995 768 1088 768L1088 768L1152 768L1152 896L1088 896Q1022 896 963.50 921.50Q905 947 861.50 990.50Q818 1034 793 1092Q768 1150 768 1216ZM1955 1411L2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var AddOnlineMeeting = {
   name: "AddOnlineMeeting",
   vendor: "UiFabric",
   unicode: 60814,
   value: "",
   charCode: "ED8E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1123 2029 1219.50Q2010 1316 1973 1408L1973 1408L1664 1408L1664 1280L1882 1280Q1920 1154 1920 1024L1920 1024Q1920 891 1883 768L1883 768L1520 768Q1528 832 1532 895.50Q1536 959 1536 1024L1536 1024L1408 1024Q1408 959 1403.50 895.50Q1399 832 1391 768L1391 768L657 768Q649 832 644.50 895.50Q640 959 640 1024L640 1024Q640 1089 644.50 1152.50Q649 1216 657 1280L657 1280L1280 1280L1280 1408L679 1408Q687 1447 702 1500.50Q717 1554 739 1610.50Q761 1667 789.50 1722.50Q818 1778 854 1822Q890 1866 932.50 1893Q975 1920 1024 1920L1024 1920Q1054 1920 1081 1908.50Q1108 1897 1132 1878.50Q1156 1860 1176.50 1837.50Q1197 1815 1213 1792L1213 1792L1280 1792L1280 2014Q1217 2031 1153 2039.50Q1089 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM731 177L731 177Q646 206 569.50 252Q493 298 427 357Q361 416 307.50 487.50Q254 559 215 640L215 640L548 640Q559 581 575.50 519.50Q592 458 614.50 398.50Q637 339 666 282.50Q695 226 731 177ZM731 1871L731 1871Q695 1822 666 1765.50Q637 1709 614.50 1649.50Q592 1590 575.50 1528.50Q559 1467 548 1408L548 1408L215 1408Q254 1489 307.50 1560.50Q361 1632 427 1691.50Q493 1751 569.50 1796.50Q646 1842 731 1871ZM165 1280L528 1280Q520 1216 516 1152.50Q512 1089 512 1024L512 1024Q512 959 516 895.50Q520 832 528 768L528 768L165 768Q128 891 128 1024L128 1024Q128 1157 165 1280L165 1280ZM679 640L1369 640Q1361 601 1346 548Q1331 495 1309 438Q1287 381 1258.50 325.50Q1230 270 1194 226Q1158 182 1115.50 155Q1073 128 1024 128L1024 128Q975 128 932.50 155Q890 182 854 226Q818 270 789.50 325.50Q761 381 739 438Q717 495 702 548Q687 601 679 640L679 640ZM1500 640L1833 640Q1794 559 1740.50 487.50Q1687 416 1621 357Q1555 298 1478.50 252Q1402 206 1317 177L1317 177Q1353 226 1382 282.50Q1411 339 1433.50 398.50Q1456 458 1472.50 519.50Q1489 581 1500 640L1500 640ZM1536 1152L1536 1536L1920 1536L1920 1664L1536 1664L1536 2048L1408 2048L1408 1664L1024 1664L1024 1536L1408 1536L1408 1152L1536 1152Z"
         }
      }
   ]
}

var ForwardEvent = {
   name: "ForwardEvent",
   vendor: "UiFabric",
   unicode: 60812,
   value: "",
   charCode: "ED8C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1425L1920 1297L1920 640L128 640L128 1792L1419 1792L1547 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256ZM1798 1536L1635 1373L1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1280 1664L1280 1536L1798 1536Z"
         }
      }
   ]
}

var WipePhone = {
   name: "WipePhone",
   vendor: "UiFabric",
   unicode: 60813,
   value: "",
   charCode: "ED8D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1664L534 1664Q514 1716 514 1771L514 1771Q514 1776 514.50 1781.50Q515 1787 515 1792L515 1792L384 1792L384 1664ZM2042 1376L1499 1920L1792 1920L1792 2048L837 2048L690 1900Q666 1875 653 1843Q640 1811 640 1776L640 1776Q640 1741 653 1708.50Q666 1676 691 1651L691 1651L1504 837L2042 1376ZM1861 1376L1504 1018L1115 1408L1472 1766L1861 1376ZM890 1920L1317 1920L1382 1856L1024 1499L782 1741Q768 1755 768 1776L768 1776Q768 1797 782 1811L782 1811L890 1920ZM128 1920L550 1920Q571 1961 597.50 1988.50Q624 2016 657 2048L657 2048L128 2048Q101 2048 78 2038Q55 2028 37.50 2010.50Q20 1993 10 1970Q0 1947 0 1920L0 1920L0 128Q0 101 10 78Q20 55 37.50 37.50Q55 20 78 10Q101 0 128 0L128 0L1152 0Q1179 0 1202 10Q1225 20 1242.50 37.50Q1260 55 1270 78Q1280 101 1280 128L1280 128L1280 880L1152 1008L1152 128L128 128L128 1920Z"
         }
      }
   ]
}

var JoinOnlineMeeting = {
   name: "JoinOnlineMeeting",
   vendor: "UiFabric",
   unicode: 60815,
   value: "",
   charCode: "ED8F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M918 1881L918 1881Q908 1919 902.50 1958.50Q897 1998 896 2038L896 2038Q768 2023 652 1978Q536 1933 436.50 1862.50Q337 1792 256.50 1700.50Q176 1609 119 1501Q62 1393 31 1272.50Q0 1152 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0L1024 0Q1165 0 1295.50 36.50Q1426 73 1540 140Q1654 207 1747.50 300.50Q1841 394 1908 508Q1975 622 2011.50 752.50Q2048 883 2048 1024L2048 1024L1977 1024Q1963 1001 1947.50 979Q1932 957 1913 937L1913 937Q1907 850 1882 768L1882 768L657 768Q649 832 644.50 895.50Q640 959 640 1024L640 1024Q640 1089 644.50 1152.50Q649 1216 657 1280L657 1280L1024 1280Q1024 1312 1029 1344Q1034 1376 1042 1408L1042 1408L679 1408Q691 1465 711.50 1533Q732 1601 761.50 1666.50Q791 1732 830 1788.50Q869 1845 918 1881ZM1499 640L1833 640Q1794 559 1740.50 488Q1687 417 1621 357.50Q1555 298 1478.50 252.50Q1402 207 1317 178L1317 178Q1353 228 1381.50 284Q1410 340 1432.50 399.50Q1455 459 1471 519.50Q1487 580 1499 640L1499 640ZM1024 128L1024 128Q974 128 931.50 155Q889 182 853.50 226Q818 270 789.50 325.50Q761 381 739 438Q717 495 702 548Q687 601 679 640L679 640L1369 640Q1361 601 1346 548Q1331 495 1309 438Q1287 381 1258.50 325.50Q1230 270 1194.50 226Q1159 182 1116 155Q1073 128 1024 128ZM732 177L732 177Q647 206 570 251.50Q493 297 427 356.50Q361 416 307 487.50Q253 559 215 640L215 640L549 640Q560 585 576.50 522.50Q593 460 616 398.50Q639 337 668 279.50Q697 222 732 177ZM128 1024L128 1024Q128 1157 165 1280L165 1280L528 1280Q520 1216 516 1152.50Q512 1089 512 1024L512 1024Q512 959 516 895.50Q520 832 528 768L528 768L165 768Q128 891 128 1024ZM548 1408L213 1408Q252 1489 305.50 1560.50Q359 1632 425.50 1691Q492 1750 569 1795.50Q646 1841 731 1870L731 1870Q695 1820 666.50 1764Q638 1708 615.50 1649Q593 1590 576.50 1529Q560 1468 548 1408L548 1408ZM1762 1589L1762 1589Q1827 1622 1880 1670Q1933 1718 1970.50 1778Q2008 1838 2028 1906.50Q2048 1975 2048 2048L2048 2048L1920 2048Q1920 1969 1890 1899Q1860 1829 1807.50 1776.50Q1755 1724 1685 1694Q1615 1664 1536 1664L1536 1664Q1456 1664 1386.50 1694Q1317 1724 1264.50 1776.50Q1212 1829 1182 1899Q1152 1969 1152 2048L1152 2048L1024 2048Q1024 1975 1044 1906.50Q1064 1838 1101 1778Q1138 1718 1191 1670Q1244 1622 1309 1589L1309 1589Q1234 1535 1193 1453.50Q1152 1372 1152 1280L1152 1280Q1152 1201 1182 1131Q1212 1061 1264.50 1008.50Q1317 956 1386.50 926Q1456 896 1536 896L1536 896Q1615 896 1685 926Q1755 956 1807.50 1008.50Q1860 1061 1890 1131Q1920 1201 1920 1280L1920 1280Q1920 1372 1878.50 1453.50Q1837 1535 1762 1589ZM1536 1536L1536 1536Q1589 1536 1635.50 1516Q1682 1496 1717 1461Q1752 1426 1772 1379.50Q1792 1333 1792 1280L1792 1280Q1792 1227 1772 1180.50Q1752 1134 1717 1099Q1682 1064 1635.50 1044Q1589 1024 1536 1024L1536 1024Q1483 1024 1436.50 1044Q1390 1064 1355 1099Q1320 1134 1300 1180.50Q1280 1227 1280 1280L1280 1280Q1280 1333 1300 1379.50Q1320 1426 1355 1461Q1390 1496 1436.50 1516Q1483 1536 1536 1536Z"
         }
      }
   ]
}

var PeopleBlock = {
   name: "PeopleBlock",
   vendor: "UiFabric",
   unicode: 60817,
   value: "",
   charCode: "ED91",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 768L1408 768Q1328 768 1258.50 798Q1189 828 1136.50 880.50Q1084 933 1054 1003Q1024 1073 1024 1152L1024 1152Q1024 1244 983 1325Q942 1406 868 1461L868 1461Q933 1494 985.50 1542.50Q1038 1591 1075 1650.50Q1112 1710 1132 1778.50Q1152 1847 1152 1920L1152 1920L1024 1920Q1024 1841 994 1771Q964 1701 911.50 1648.50Q859 1596 789 1566Q719 1536 640 1536L640 1536Q560 1536 490.50 1566Q421 1596 368.50 1648.50Q316 1701 286 1771Q256 1841 256 1920L256 1920L128 1920Q128 1847 148 1778.50Q168 1710 205 1650.50Q242 1591 294.50 1542.50Q347 1494 412 1461L412 1461Q338 1406 297 1325Q256 1244 256 1152L256 1152Q256 1073 286 1003Q316 933 368.50 880.50Q421 828 490.50 798Q560 768 640 768L640 768Q732 768 813 809Q894 850 949 924L949 924Q987 849 1046 790Q1105 731 1180 693L1180 693Q1106 638 1065 557Q1024 476 1024 384L1024 384Q1024 305 1054 235Q1084 165 1136.50 112.50Q1189 60 1258.50 30Q1328 0 1408 0L1408 0Q1487 0 1557 30Q1627 60 1679.50 112.50Q1732 165 1762 235Q1792 305 1792 384L1792 384Q1792 476 1751 557Q1710 638 1636 693L1636 693Q1701 726 1753.50 774.50Q1806 823 1843 882.50Q1880 942 1900 1010.50Q1920 1079 1920 1152L1920 1152L1792 1152Q1792 1073 1762 1003Q1732 933 1679.50 880.50Q1627 828 1557 798Q1487 768 1408 768ZM1152 384L1152 384Q1152 437 1172 483.50Q1192 530 1227 565Q1262 600 1308.50 620Q1355 640 1408 640L1408 640Q1461 640 1507.50 620Q1554 600 1589 565Q1624 530 1644 483.50Q1664 437 1664 384L1664 384Q1664 331 1644 284.50Q1624 238 1589 203Q1554 168 1507.50 148Q1461 128 1408 128L1408 128Q1355 128 1308.50 148Q1262 168 1227 203Q1192 238 1172 284.50Q1152 331 1152 384ZM640 1408L640 1408Q693 1408 739.50 1388Q786 1368 821 1333Q856 1298 876 1251.50Q896 1205 896 1152L896 1152Q896 1099 876 1052.50Q856 1006 821 971Q786 936 739.50 916Q693 896 640 896L640 896Q587 896 540.50 916Q494 936 459 971Q424 1006 404 1052.50Q384 1099 384 1152L384 1152Q384 1205 404 1251.50Q424 1298 459 1333Q494 1368 540.50 1388Q587 1408 640 1408ZM2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411L2045 1502Z"
         }
      }
   ]
}

var PeopleAlert = {
   name: "PeopleAlert",
   vendor: "UiFabric",
   unicode: 60819,
   value: "",
   charCode: "ED93",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1536 1536L1408 1536L1408 1152L1536 1152L1536 1536ZM1536 1792L1408 1792L1408 1664L1536 1664L1536 1792ZM914 1044L914 1044Q848 1128 811.50 1228.50Q775 1329 770 1435L770 1435Q716 1483 650 1509.50Q584 1536 512 1536L512 1536Q432 1536 362.50 1566Q293 1596 240.50 1648.50Q188 1701 158 1771Q128 1841 128 1920L128 1920L0 1920Q0 1847 20 1778.50Q40 1710 77 1650Q114 1590 167 1542Q220 1494 285 1461L285 1461Q211 1407 169.50 1325.50Q128 1244 128 1152L128 1152Q128 1073 158 1003Q188 933 240.50 880.50Q293 828 362.50 798Q432 768 512 768L512 768Q605 768 686.50 809.50Q768 851 822 926L822 926Q859 851 918 791Q977 731 1052 693L1052 693Q978 638 937 557Q896 476 896 384L896 384Q896 305 926 235Q956 165 1008.50 112.50Q1061 60 1130.50 30Q1200 0 1280 0L1280 0Q1359 0 1429 30Q1499 60 1551.50 112.50Q1604 165 1634 235Q1664 305 1664 384L1664 384Q1664 464 1634 533.50Q1604 603 1551.50 655.50Q1499 708 1429 738Q1359 768 1280 768L1280 768Q1216 768 1157.50 788Q1099 808 1050.50 844.50Q1002 881 966.50 932Q931 983 914 1044ZM1024 384L1024 384Q1024 437 1044 483.50Q1064 530 1099 565Q1134 600 1180.50 620Q1227 640 1280 640L1280 640Q1333 640 1379.50 620Q1426 600 1461 565Q1496 530 1516 483.50Q1536 437 1536 384L1536 384Q1536 331 1516 284.50Q1496 238 1461 203Q1426 168 1379.50 148Q1333 128 1280 128L1280 128Q1227 128 1180.50 148Q1134 168 1099 203Q1064 238 1044 284.50Q1024 331 1024 384ZM512 1408L512 1408Q565 1408 611.50 1388Q658 1368 693 1333Q728 1298 748 1251.50Q768 1205 768 1152L768 1152Q768 1099 748 1052.50Q728 1006 693 971Q658 936 611.50 916Q565 896 512 896L512 896Q459 896 412.50 916Q366 936 331 971Q296 1006 276 1052.50Q256 1099 256 1152L256 1152Q256 1205 276 1251.50Q296 1298 331 1333Q366 1368 412.50 1388Q459 1408 512 1408Z"
         }
      }
   ]
}

var TransferCall = {
   name: "TransferCall",
   vendor: "UiFabric",
   unicode: 60821,
   value: "",
   charCode: "ED95",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1402 1307L1402 1307Q1441 1307 1478 1322Q1515 1337 1543 1365L1543 1365L1734 1556Q1762 1584 1777 1621Q1792 1658 1792 1697L1792 1697Q1792 1736 1777 1773Q1762 1810 1734 1838L1734 1838L1638 1934Q1575 1996 1495 2022Q1415 2048 1329 2048L1329 2048Q1222 2048 1107.50 2014.50Q993 1981 879.50 1921Q766 1861 656.50 1779Q547 1697 449.50 1599.50Q352 1502 269.50 1392.50Q187 1283 127 1169.50Q67 1056 33.50 942Q0 828 0 720L0 720Q0 643 13.50 589Q27 535 53.50 491Q80 447 119 406Q158 365 210 314L210 314Q238 286 275 271Q312 256 351 256L351 256Q390 256 427 271Q464 286 492 314L492 314L683 505Q711 533 726 570Q741 607 741 646L741 646Q741 685 728 715.50Q715 746 695.50 771.50Q676 797 653.50 817.50Q631 838 611.50 857Q592 876 579 894.50Q566 913 566 933L566 933Q566 962 587 983L587 983L1065 1461Q1086 1482 1115 1482L1115 1482Q1136 1482 1154.50 1469Q1173 1456 1191.50 1436.50Q1210 1417 1230.50 1394.50Q1251 1372 1276 1352.50Q1301 1333 1331.50 1320Q1362 1307 1402 1307ZM1331 1920L1331 1920Q1391 1920 1432 1908.50Q1473 1897 1506.50 1875Q1540 1853 1571 1821Q1602 1789 1643 1748L1643 1748Q1664 1727 1664 1698L1664 1698Q1664 1668 1643 1647L1643 1647L1452 1456Q1431 1435 1401 1435L1401 1435Q1380 1435 1362 1448Q1344 1461 1325 1480.50Q1306 1500 1285.50 1522.50Q1265 1545 1240.50 1564.50Q1216 1584 1185 1597Q1154 1610 1115 1610L1115 1610Q1075 1610 1038.50 1594.50Q1002 1579 974 1551L974 1551L497 1074Q469 1046 453.50 1009.50Q438 973 438 933L438 933Q438 894 451 863.50Q464 833 483.50 808Q503 783 525.50 762.50Q548 742 567.50 723Q587 704 600 685.50Q613 667 613 646L613 646Q613 617 592 596L592 596L401 405Q380 384 351 384L351 384Q321 384 300 405L300 405Q259 446 227 477Q195 508 173 541.50Q151 575 139.50 616Q128 657 128 717L128 717Q128 812 159 914Q190 1016 245 1118.50Q300 1221 375.50 1320Q451 1419 540 1508Q629 1597 728 1672.50Q827 1748 929.50 1803Q1032 1858 1134 1889Q1236 1920 1331 1920ZM1536 640L2048 640L2048 1152L1920 1152L1920 859L1581 1197L1491 1107L1829 768L1536 768L1536 640ZM1408 512L1408 640L896 640L896 128L1024 128L1024 421L1363 83L1453 173L1115 512L1408 512Z"
         }
      }
   ]
}

var UnknownCall = {
   name: "UnknownCall",
   vendor: "UiFabric",
   unicode: 60823,
   value: "",
   charCode: "ED97",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1402 1307L1402 1307Q1441 1307 1478 1322Q1515 1337 1543 1365L1543 1365L1734 1556Q1762 1584 1777 1621Q1792 1658 1792 1697L1792 1697Q1792 1736 1777 1773Q1762 1810 1734 1838L1734 1838L1638 1934Q1575 1996 1495 2022Q1415 2048 1329 2048L1329 2048Q1222 2048 1107.50 2014.50Q993 1981 879.50 1921Q766 1861 656.50 1779Q547 1697 449.50 1599.50Q352 1502 269.50 1392.50Q187 1283 127 1169.50Q67 1056 33.50 942Q0 828 0 720L0 720Q0 643 13.50 589Q27 535 53.50 491Q80 447 119 406Q158 365 210 314L210 314Q238 286 275 271Q312 256 351 256L351 256Q390 256 427 271Q464 286 492 314L492 314L683 505Q711 533 726 570Q741 607 741 646L741 646Q741 685 728 715.50Q715 746 695.50 771.50Q676 797 653.50 817.50Q631 838 611.50 857Q592 876 579 894.50Q566 913 566 933L566 933Q566 962 587 983L587 983L1065 1461Q1086 1482 1115 1482L1115 1482Q1136 1482 1154.50 1469Q1173 1456 1191.50 1436.50Q1210 1417 1230.50 1394.50Q1251 1372 1276 1352.50Q1301 1333 1331.50 1320Q1362 1307 1402 1307ZM1331 1920L1331 1920Q1391 1920 1432 1908.50Q1473 1897 1506.50 1875Q1540 1853 1571 1821Q1602 1789 1643 1748L1643 1748Q1664 1727 1664 1698L1664 1698Q1664 1668 1643 1647L1643 1647L1452 1456Q1431 1435 1401 1435L1401 1435Q1380 1435 1362 1448Q1344 1461 1325 1480.50Q1306 1500 1285.50 1522.50Q1265 1545 1240.50 1564.50Q1216 1584 1185 1597Q1154 1610 1115 1610L1115 1610Q1075 1610 1038.50 1594.50Q1002 1579 974 1551L974 1551L497 1074Q469 1046 453.50 1009.50Q438 973 438 933L438 933Q438 894 451 863.50Q464 833 483.50 808Q503 783 525.50 762.50Q548 742 567.50 723Q587 704 600 685.50Q613 667 613 646L613 646Q613 617 592 596L592 596L401 405Q380 384 351 384L351 384Q321 384 300 405L300 405Q259 446 227 477Q195 508 173 541.50Q151 575 139.50 616Q128 657 128 717L128 717Q128 812 159 914Q190 1016 245 1118.50Q300 1221 375.50 1320Q451 1419 540 1508Q629 1597 728 1672.50Q827 1748 929.50 1803Q1032 1858 1134 1889Q1236 1920 1331 1920ZM1664 1152L1664 1024L1792 1024L1792 1152L1664 1152ZM1728 64L1728 64Q1794 64 1852 89.50Q1910 115 1953.50 158.50Q1997 202 2022.50 260Q2048 318 2048 384L2048 384Q2048 444 2029 488.50Q2010 533 1981.50 569Q1953 605 1920 634.50Q1887 664 1858.50 693.50Q1830 723 1811 756.50Q1792 790 1792 832L1792 832L1792 896L1664 896L1664 832Q1664 772 1683 727.50Q1702 683 1730.50 647Q1759 611 1792 581.50Q1825 552 1853.50 522.50Q1882 493 1901 460Q1920 427 1920 384L1920 384Q1920 344 1905 309Q1890 274 1864 248Q1838 222 1803 207Q1768 192 1728 192L1728 192Q1688 192 1653 207Q1618 222 1592 248Q1566 274 1551 309Q1536 344 1536 384L1536 384L1408 384Q1408 318 1433 260Q1458 202 1501.50 158.50Q1545 115 1603.50 89.50Q1662 64 1728 64Z"
         }
      }
   ]
}

var NoteForward = {
   name: "NoteForward",
   vendor: "UiFabric",
   unicode: 60825,
   value: "",
   charCode: "ED99",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1280 1664L1280 1536L1798 1536L1635 1373L1725 1283ZM768 1792L1376 1792L1503 1920L677 1920L128 1371L128 128L1920 128L1920 1251L1792 1123L1792 256L256 256L256 1280L768 1280L768 1792ZM640 1701L640 1408L347 1408L640 1701Z"
         }
      }
   ]
}

var RemoveOccurrence = {
   name: "RemoveOccurrence",
   vendor: "UiFabric",
   unicode: 60827,
   value: "",
   charCode: "ED9B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L2048 256L2048 768L1536 768L1536 640L1852 640Q1793 523 1705.50 428.50Q1618 334 1510 267.50Q1402 201 1278.50 164.50Q1155 128 1024 128L1024 128Q870 128 728.50 175.50Q587 223 470.50 309.50Q354 396 267.50 517.50Q181 639 136 787L136 787L14 749Q64 583 163 445Q262 307 395.50 208Q529 109 689.50 54.50Q850 0 1024 0L1024 0Q1161 0 1291 34Q1421 68 1536.50 132.50Q1652 197 1750 289.50Q1848 382 1920 499L1920 499L1920 256ZM1024 1920L1024 1920Q1063 1920 1101.50 1915.50Q1140 1911 1178 1903L1178 1903L1286 2011Q1255 2019 1223.50 2025.50Q1192 2032 1160 2037L1160 2037L1152 1973L1160 2037Q1126 2042 1092.50 2045Q1059 2048 1024 2048L1024 2048Q886 2048 756.50 2014Q627 1980 511.50 1915.50Q396 1851 298.50 1758.50Q201 1666 128 1549L128 1549L128 1792L0 1792L0 1280L512 1280L512 1408L196 1408Q255 1525 342.50 1619.50Q430 1714 538 1780.50Q646 1847 769.50 1883.50Q893 1920 1024 1920ZM1955 1411L2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var EditNote = {
   name: "EditNote",
   vendor: "UiFabric",
   unicode: 60829,
   value: "",
   charCode: "ED9D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 256L384 1920L796 1920L764 2048L256 2048L256 128L384 128L384 0L512 0L512 128L768 128L768 0L896 0L896 128L1152 128L1152 0L1280 0L1280 128L1536 128L1536 0L1664 0L1664 128L1792 128L1792 776Q1758 781 1725.50 793Q1693 805 1664 824L1664 824L1664 256L384 256ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1772 910Q1808 896 1848 896ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836Z"
         }
      }
   ]
}

var Room = {
   name: "Room",
   vendor: "UiFabric",
   unicode: 60831,
   value: "",
   charCode: "ED9F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1792L1773 1792L1478 1792L1005 1887L768 1934L768 779L1408 651L1408 640L640 640L640 1792L128 1792L128 128ZM1408 782L896 885L896 1778L1408 1675L1408 782ZM1536 1664L1792 1664L1792 256L256 256L256 1664L512 1664L512 512L1536 512L1536 1664Z"
         }
      }
   ]
}

var Subscribe = {
   name: "Subscribe",
   vendor: "UiFabric",
   unicode: 60833,
   value: "",
   charCode: "EDA1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1537 128L1920 1276Q1921 1278 1921.50 1305Q1922 1332 1922 1374.50Q1922 1417 1922 1471Q1922 1525 1921.50 1582.50Q1921 1640 1921 1696Q1921 1752 1920.50 1798.50Q1920 1845 1920 1877.50Q1920 1910 1920 1920L1920 1920L0 1920Q0 1910 0 1877.50Q0 1845-0.50 1798.50Q-1 1752-1 1696Q-1 1640-1.50 1582.50Q-2 1525-2 1471Q-2 1417-2 1374.50Q-2 1332-1.50 1305Q-1 1278 0 1276L0 1276L383 128L768 128L768 256L475 256L134 1280L552 1280L680 1536L1240 1536L1368 1280L1786 1280L1445 256L1152 256L1152 128L1537 128ZM1792 1792L1792 1408L1448 1408L1320 1664L600 1664L472 1408L128 1408L128 1792L1792 1792ZM602 640L896 933L896 0L1024 0L1024 933L1318 640L1408 730L960 1178L512 730L602 640Z"
         }
      }
   ]
}

var RecurringTask = {
   name: "RecurringTask",
   vendor: "UiFabric",
   unicode: 60850,
   value: "",
   charCode: "EDB2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1541 1280 1488.50 1300Q1436 1320 1394 1355.50Q1352 1391 1324 1440Q1296 1489 1286 1547L1286 1547L1159 1525Q1173 1444 1213 1376Q1253 1308 1311.50 1258Q1370 1208 1444 1180Q1518 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289L1920 1289L1920 1152ZM1600 1920L1600 1920Q1658 1920 1711 1900Q1764 1880 1806 1844.50Q1848 1809 1876 1760Q1904 1711 1914 1653L1914 1653L2041 1675Q2027 1756 1987 1824Q1947 1892 1888.50 1942Q1830 1992 1756 2020Q1682 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920ZM333 819L576 1061L1203 435L1293 525L576 1243L243 909L333 819ZM128 128L128 1408L1040 1408Q1029 1439 1022 1471Q1015 1503 1012 1536L1012 1536L0 1536L0 0L1536 0L1536 1012Q1503 1015 1471 1022Q1439 1029 1408 1040L1408 1040L1408 128L128 128Z"
         }
      }
   ]
}

var ProjectLogoInverse = {
   name: "ProjectLogoInverse",
   vendor: "UiFabric",
   unicode: 60884,
   value: "",
   charCode: "EDD4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M400 819L496 819Q545 819 574 838.50Q603 858 603 910L603 910Q603 933 592.50 947.50Q582 962 566 971Q550 980 530 983.50Q510 987 492 987L492 987L400 987L400 819ZM2048 1365L2048 1365L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L789 1920Q754 1920 729 1895Q704 1870 704 1835L704 1835L704 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L256 512L256 213Q256 178 281 153Q306 128 341 128L341 128L1259 128Q1294 128 1319 153Q1344 178 1344 213L1344 213L1344 704L1579 704Q1614 704 1639 729Q1664 754 1664 789L1664 789L1664 1280L1963 1280Q1998 1280 2023 1305Q2048 1330 2048 1365ZM1536 1280L1536 832L1024 832L1024 1280L1536 1280ZM767 905L767 905Q767 847 747.50 805.50Q728 764 694 738Q660 712 614 700Q568 688 514 688L514 688L243 688L243 1359L400 1359L400 1125L506 1125Q555 1125 601.50 1110.50Q648 1096 685 1068.50Q722 1041 744.50 1000Q767 959 767 905ZM384 256L384 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 704L1216 704L1216 256L384 256ZM832 1792L1920 1792L1920 1408L1024 1408L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L832 1536L832 1792Z"
         }
      }
   ]
}

var PowerApps = {
   name: "PowerApps",
   vendor: "UiFabric",
   unicode: 60882,
   value: "",
   charCode: "EDD2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M288 256L1760 256Q1820 256 1872.50 278.50Q1925 301 1964 340Q2003 379 2025.50 431.50Q2048 484 2048 544L2048 544L2048 1312Q2048 1367 2028.50 1416Q2009 1465 1974.50 1503.50Q1940 1542 1893 1566.50Q1846 1591 1792 1597L1792 1597L1792 1469Q1820 1463 1843.50 1448.50Q1867 1434 1884 1413Q1901 1392 1910.50 1366.50Q1920 1341 1920 1312L1920 1312L1920 544Q1920 511 1907.50 482Q1895 453 1873 431Q1851 409 1822 396.50Q1793 384 1760 384L1760 384L288 384Q255 384 226 396.50Q197 409 175 431Q153 453 140.50 482Q128 511 128 544L128 544L128 1312Q128 1341 137.50 1366.50Q147 1392 164 1413Q181 1434 204.50 1448.50Q228 1463 256 1469L256 1469L256 1597Q202 1591 155 1566.50Q108 1542 73.50 1503.50Q39 1465 19.50 1416Q0 1367 0 1312L0 1312L0 544Q0 484 22.50 431.50Q45 379 84 340Q123 301 175.50 278.50Q228 256 288 256L288 256ZM1507 1588L1507 1588Q1507 1614 1488 1633L1488 1633L1351 1770Q1332 1789 1305 1789L1305 1789Q1278 1789 1259 1770L1259 1770L1122 1633Q1103 1614 1103 1588L1103 1588Q1103 1561 1122 1542L1122 1542L1259 1405Q1278 1386 1305 1386L1305 1386Q1332 1386 1351 1405L1351 1405L1488 1542Q1507 1561 1507 1588ZM1792 1302L1792 1302Q1792 1328 1773 1347L1773 1347L1636 1484Q1617 1503 1590 1503L1590 1503Q1564 1503 1545 1484L1545 1484L1408 1347Q1389 1328 1389 1302L1389 1302Q1389 1275 1408 1256L1408 1256L1545 1118Q1564 1099 1590 1099L1590 1099Q1617 1099 1636 1118L1636 1118L1773 1256Q1792 1275 1792 1302ZM734 1789L734 1789Q708 1789 689 1770L689 1770L310 1392Q301 1383 290 1373Q279 1363 269.50 1352Q260 1341 253.50 1329Q247 1317 247 1302L247 1302Q247 1287 253.50 1274.50Q260 1262 269.50 1251Q279 1240 290 1230Q301 1220 310 1211L310 1211L689 833Q708 814 734 814L734 814Q761 814 780 833L780 833L1158 1211Q1167 1220 1178.50 1230Q1190 1240 1199.50 1251Q1209 1262 1215.50 1274.50Q1222 1287 1222 1302L1222 1302Q1222 1317 1215.50 1329Q1209 1341 1199.50 1352Q1190 1363 1178.50 1373Q1167 1383 1158 1392L1158 1392L780 1770Q761 1789 734 1789ZM936 1302L936 1302Q936 1275 917 1256L917 1256L780 1118Q761 1099 734 1099L734 1099Q708 1099 689 1118L689 1118L551 1256Q532 1275 532 1302L532 1302Q532 1329 550 1347Q568 1365 586 1382L586 1382L689 1484Q708 1503 734 1503L734 1503Q761 1503 780 1484L780 1484L882 1382Q900 1364 918 1346.50Q936 1329 936 1302ZM1305 1217L1305 1217Q1278 1217 1259 1198L1259 1198L1122 1061Q1103 1042 1103 1016L1103 1016Q1103 989 1122 970L1122 970L1259 833Q1278 814 1305 814L1305 814Q1332 814 1351 833L1351 833L1488 970Q1507 989 1507 1016L1507 1016Q1507 1042 1488 1061L1488 1061L1351 1198Q1332 1217 1305 1217Z"
         }
      }
   ]
}

var OneNoteEduLogoInverse = {
   name: "OneNoteEduLogoInverse",
   vendor: "UiFabric",
   unicode: 60880,
   value: "",
   charCode: "EDD0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1856 832L1888 832Q1902 832 1911 841Q1920 850 1920 864L1920 864L1920 1120Q1920 1134 1911 1143Q1902 1152 1888 1152L1888 1152L1856 1152L1856 832ZM1856 1216L1888 1216Q1902 1216 1911 1225Q1920 1234 1920 1248L1920 1248L1920 1504Q1920 1518 1911 1527Q1902 1536 1888 1536L1888 1536L1856 1536L1856 1216ZM1792 448L1888 448Q1902 448 1911 457Q1920 466 1920 480L1920 480L1920 736Q1920 750 1911 759Q1902 768 1888 768L1888 768L1792 768L1792 1680Q1792 1700 1778 1714Q1764 1728 1744 1728L1744 1728L1216 1728L1216 1536L1600 1536L1600 1472L1216 1472L1216 1344L1600 1344L1600 1280L1216 1280L1216 829L1456 916L1615 852L1615 990Q1615 997 1620 1001.50Q1625 1006 1632 1006L1632 1006Q1639 1006 1644 1001.50Q1649 997 1649 990L1649 990L1649 840L1713 812L1455 697L1216 791L1216 320L1744 320Q1764 320 1778 334Q1792 348 1792 368L1792 368L1792 448ZM1453 1072L1453 1072Q1469 1072 1487.50 1070.50Q1506 1069 1523 1064Q1540 1059 1555 1050Q1570 1041 1580 1026L1580 1026L1579 903Q1574 905 1555 912.50Q1536 920 1515 928.50Q1494 937 1476.50 943.50Q1459 950 1456 950L1456 950Q1417 938 1378.50 923.50Q1340 909 1302 895L1302 895Q1301 921 1300.50 948Q1300 975 1300 1001L1300 1001Q1300 1022 1318.50 1035.50Q1337 1049 1362 1057Q1387 1065 1413 1068.50Q1439 1072 1453 1072ZM128 1741L128 307L1152 134L1152 1914L128 1741ZM413 688L413 1342L515 1347L515 867L786 1362L922 1370L922 660L795 668L795 1019Q795 1050 794 1081.50Q793 1113 795 1144L795 1144L543 683L413 688Z"
         }
      }
   ]
}

var OfficeAssistantLogo = {
   name: "OfficeAssistantLogo",
   vendor: "UiFabric",
   unicode: 60878,
   value: "",
   charCode: "EDCE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1604 1254L1604 1254Q1683 1254 1752 1284Q1821 1314 1872.50 1366Q1924 1418 1954 1487Q1984 1556 1984 1635L1984 1635Q1984 1713 1954 1782.50Q1924 1852 1872.50 1903.50Q1821 1955 1751.50 1985Q1682 2015 1604 2015L1604 2015Q1526 2015 1456.50 1985Q1387 1955 1335.50 1903.50Q1284 1852 1254 1782.50Q1224 1713 1224 1635L1224 1635Q1224 1556 1254 1487Q1284 1418 1335.50 1366Q1387 1314 1456 1284Q1525 1254 1604 1254ZM1602 1419L1602 1419Q1582 1419 1565.50 1428Q1549 1437 1537.50 1451.50Q1526 1466 1519.50 1484Q1513 1502 1513 1521L1513 1521Q1513 1540 1519.50 1558Q1526 1576 1537.50 1590.50Q1549 1605 1565.50 1613.50Q1582 1622 1602 1622L1602 1622Q1622 1622 1638 1613.50Q1654 1605 1665.50 1590.50Q1677 1576 1683.50 1558Q1690 1540 1690 1521L1690 1521Q1690 1503 1683.50 1484.50Q1677 1466 1665.50 1451.50Q1654 1437 1638 1428Q1622 1419 1602 1419ZM1424 1844L1783 1844Q1783 1816 1782 1780.50Q1781 1745 1772 1714Q1763 1683 1742 1661.50Q1721 1640 1681 1640L1681 1640L1676 1640Q1662 1655 1643 1664.50Q1624 1674 1603 1674L1603 1674Q1583 1674 1564 1664.50Q1545 1655 1531 1640L1531 1640Q1490 1640 1468 1660.50Q1446 1681 1436 1711.50Q1426 1742 1425 1778Q1424 1814 1424 1844L1424 1844ZM1578 204L1578 1192Q1490 1197 1413.50 1233.50Q1337 1270 1281 1330Q1225 1390 1192.50 1468.50Q1160 1547 1160 1635L1160 1635Q1160 1724 1195 1808L1195 1808L1048 1853L77 1503L1051 1620L1051 329L403 481L403 1354L64 1501L64 390L1049 33L1578 204Z"
         }
      }
   ]
}

var Dynamics365Logo = {
   name: "Dynamics365Logo",
   vendor: "UiFabric",
   unicode: 60876,
   value: "",
   charCode: "EDCC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 675L876 914L512 1960L512 675ZM512 1960L1664 719L1664 1313L512 1960ZM1613 675L1264 959L512 591L512 90L1613 675Z"
         }
      }
   ]
}

var DelveAnalyticsLogo = {
   name: "DelveAnalyticsLogo",
   vendor: "UiFabric",
   unicode: 60874,
   value: "",
   charCode: "EDCA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1166 2011.50 1296.50Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 998 19 979Q38 960 64 960L64 960Q90 960 109 979Q128 998 128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q998 128 979 109Q960 90 960 64L960 64Q960 38 979 19Q998 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024ZM1024 1664L1024 1664Q998 1664 979 1645Q960 1626 960 1600L960 1600Q960 1574 979 1555Q998 1536 1024 1536L1024 1536Q1130 1536 1223 1495.50Q1316 1455 1385.50 1385.50Q1455 1316 1495.50 1223Q1536 1130 1536 1024L1536 1024Q1536 918 1495.50 825Q1455 732 1385.50 662.50Q1316 593 1223 552.50Q1130 512 1024 512L1024 512Q998 512 979 493Q960 474 960 448L960 448Q960 422 979 403Q998 384 1024 384L1024 384Q1157 384 1273.50 434Q1390 484 1477 571Q1564 658 1614 774.50Q1664 891 1664 1024L1664 1024Q1664 1157 1614 1273.50Q1564 1390 1477 1477Q1390 1564 1273.50 1614Q1157 1664 1024 1664ZM960 832L960 832Q960 806 979 787Q998 768 1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1050 1261 1069Q1242 1088 1216 1088L1216 1088Q1190 1088 1171 1069Q1152 1050 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q998 896 979 877Q960 858 960 832Z"
         }
      }
   ]
}

var ClassNotebookLogoInverse = {
   name: "ClassNotebookLogoInverse",
   vendor: "UiFabric",
   unicode: 60872,
   value: "",
   charCode: "EDC8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 1782L64 272L1216 67L1216 1981L64 1782ZM344 665L344 1362L452 1368L452 991Q452 958 453 924Q454 890 452 856L452 856L742 1384L887 1393L887 635L751 643L751 1151L482 659L344 665ZM1931 1265L2004 1265Q2021 1265 2034.50 1278.50Q2048 1292 2048 1309L2048 1309L2048 1617Q2048 1634 2034.50 1647.50Q2021 1661 2004 1661L2004 1661L1931 1661L1931 1265ZM1899 404L1992 404Q2015 404 2031.50 420.50Q2048 437 2048 460L2048 460L2048 742Q2048 762 2034 775Q2020 788 2001 788L2001 788L1899 788L1899 1713Q1899 1736 1882 1753Q1865 1770 1842 1770L1842 1770L1280 1770L1280 1535L1771 1535L1771 1450L1280 1450L1280 1343L1771 1343L1771 1257L1280 1257L1280 276L1831 276Q1859 276 1873.50 288.50Q1888 301 1893.50 320.50Q1899 340 1899 362.50Q1899 385 1899 404L1899 404ZM1751 708L1808 649L1751 591L1763 511L1683 497L1645 425L1572 461L1499 425L1461 497L1381 511L1392 591L1336 649L1392 708L1381 788L1459 802L1472 830L1472 1090L1568 993L1664 1090L1664 830L1681 802L1762 788L1751 708ZM1572 547L1572 547Q1593 547 1611.50 555Q1630 563 1644 577Q1658 591 1666 609.50Q1674 628 1674 649L1674 649Q1674 670 1666 688.50Q1658 707 1644 721Q1630 735 1611.50 743Q1593 751 1572 751L1572 751Q1551 751 1532.50 743Q1514 735 1500 721Q1486 707 1478 688.50Q1470 670 1470 649L1470 649Q1470 628 1478 609.50Q1486 591 1500 577Q1514 563 1532.50 555Q1551 547 1572 547ZM1931 825L2004 825Q2021 825 2034.50 838.50Q2048 852 2048 869L2048 869L2048 1177Q2048 1194 2034.50 1207.50Q2021 1221 2004 1221L2004 1221L1931 1221L1931 825Z"
         }
      }
   ]
}

var PenWorkspace = {
   name: "PenWorkspace",
   vendor: "UiFabric",
   unicode: 60870,
   value: "",
   charCode: "EDC6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1747 290L1747 290Q1761 298 1770 313Q1779 328 1779 345L1779 345Q1779 353 1777 360Q1775 367 1772 374L1772 374L1065 1789Q1056 1808 1037 1817L1037 1817L864 1904Q832 1920 795 1920L795 1920Q790 1920 785.50 1920Q781 1920 776 1919L776 1919L729 2013Q721 2029 705.50 2038.50Q690 2048 672 2048L672 2048Q646 2048 627 2029Q608 2010 608 1984L608 1984Q608 1972 615 1954Q622 1936 631.50 1916.50Q641 1897 651 1880Q661 1863 666 1852L666 1852Q640 1812 640 1765L640 1765L640 1600Q640 1584 647 1571L647 1571L1223 419L1158 387L921 861Q913 877 897.50 886.50Q882 896 864 896L864 896Q838 896 819 877Q800 858 800 832L800 832Q800 819 807 803L807 803L1046 325Q1062 293 1089 274.50Q1116 256 1152 256L1152 256Q1187 256 1218.50 273Q1250 290 1280 305L1280 305L1351 163Q1359 146 1374.50 137Q1390 128 1408 128L1408 128Q1421 128 1430 132L1430 132Q1442 108 1453.50 84.50Q1465 61 1479.50 42Q1494 23 1515 11.50Q1536 0 1568 0L1568 0Q1600 0 1629 15L1629 15L1723 62Q1755 78 1773.50 104.50Q1792 131 1792 168L1792 168Q1792 202 1776.50 231.50Q1761 261 1747 290ZM1574 131L1545 189L1632 232L1661 174L1574 131ZM960 1712L1629 374L1437 278L768 1615L768 1765Q768 1776 776 1784Q784 1792 795 1792L795 1792Q799 1792 811.50 1787Q824 1782 840.50 1774Q857 1766 875.50 1756.50Q894 1747 911 1738Q928 1729 941 1722Q954 1715 960 1712L960 1712ZM1792 768L1792 768Q1845 768 1891.50 788Q1938 808 1973 843Q2008 878 2028 924.50Q2048 971 2048 1024L2048 1024Q2048 1077 2028 1123.50Q2008 1170 1973 1205Q1938 1240 1891.50 1260Q1845 1280 1792 1280L1792 1280L1504 1280L1568 1152L1792 1152Q1819 1152 1842 1142Q1865 1132 1882.50 1114.50Q1900 1097 1910 1074Q1920 1051 1920 1024L1920 1024Q1920 997 1910 974Q1900 951 1882.50 933.50Q1865 916 1842 906Q1819 896 1792 896L1792 896Q1766 896 1747 877Q1728 858 1728 832L1728 832Q1728 806 1747 787Q1766 768 1792 768ZM128 1600L128 1600Q128 1666 153 1724.50Q178 1783 221.50 1826.50Q265 1870 323.50 1895Q382 1920 448 1920L448 1920L492 1920Q487 1935 483.50 1951Q480 1967 480 1984L480 1984Q480 2001 483.50 2017Q487 2033 492 2048L492 2048L448 2048Q355 2048 273.50 2012.50Q192 1977 131.50 1916.50Q71 1856 35.50 1774.50Q0 1693 0 1600L0 1600Q0 1507 35.50 1425.50Q71 1344 131.50 1283.50Q192 1223 273.50 1187.50Q355 1152 448 1152L448 1152L672 1152L608 1280L448 1280Q382 1280 323.50 1305.50Q265 1331 221.50 1374.50Q178 1418 153 1476Q128 1534 128 1600Z"
         }
      }
   ]
}

var NumberField = {
   name: "NumberField",
   vendor: "UiFabric",
   unicode: 60868,
   value: "",
   charCode: "EDC4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1152L1024 1280L640 1280Q640 1243 640 1205Q640 1167 654 1132L654 1132Q665 1104 687.50 1077.50Q710 1051 737 1025Q764 999 792 974.50Q820 950 843.50 926Q867 902 881.50 878.50Q896 855 896 832L896 832Q896 806 877 787Q858 768 832 768L832 768Q809 768 791.50 782Q774 796 769 819L769 819L644 793Q650 760 667.50 732Q685 704 711 683.50Q737 663 768 651.50Q799 640 832 640L832 640Q872 640 907 655Q942 670 968 696Q994 722 1009 757Q1024 792 1024 832L1024 832Q1024 871 1012.50 902.50Q1001 934 982 960.50Q963 987 938 1011Q913 1035 887 1057.50Q861 1080 835.50 1103Q810 1126 789 1152L789 1152L1024 1152ZM0 256L2048 256L2048 1664L0 1664L0 256ZM1920 1536L1920 384L128 384L128 1536L1920 1536ZM397 1280L397 787Q368 804 329 818Q290 832 256 832L256 832L256 704Q267 704 287 698Q307 692 327 682.50Q347 673 363.50 662Q380 651 385 640L385 640L512 640L512 1280L397 1280ZM1320 1280L1320 1280Q1278 1280 1238.50 1266Q1199 1252 1164 1229L1164 1229L1164 1102Q1184 1117 1199.50 1128Q1215 1139 1231 1146Q1247 1153 1265.50 1156Q1284 1159 1310 1159L1310 1159Q1332 1159 1352 1154.50Q1372 1150 1387.50 1139.50Q1403 1129 1412 1112Q1421 1095 1421 1070L1421 1070Q1421 1039 1397 1025.50Q1373 1012 1341 1008Q1309 1004 1275.50 1005.50Q1242 1007 1223 1007L1223 1007L1223 910Q1250 910 1281 910Q1312 910 1339 902.50Q1366 895 1384 876.50Q1402 858 1402 820L1402 820Q1402 778 1376.50 764Q1351 750 1313 750L1313 750Q1273 750 1244 768Q1215 786 1186 811L1186 811L1186 681Q1220 658 1262 649Q1304 640 1344 640L1344 640Q1380 640 1414 650Q1448 660 1474.50 679.50Q1501 699 1517 728.50Q1533 758 1533 797L1533 797Q1533 845 1513.50 882.50Q1494 920 1452 943L1452 943Q1496 958 1524 996Q1552 1034 1552 1081L1552 1081Q1552 1128 1532 1165Q1512 1202 1479.50 1227.50Q1447 1253 1405 1266.50Q1363 1280 1320 1280Z"
         }
      }
   ]
}

var TextBox = {
   name: "TextBox",
   vendor: "UiFabric",
   unicode: 60866,
   value: "",
   charCode: "EDC2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1920L1920 128L128 128L128 1920L1920 1920ZM451 734L397 894L283 894L518 266L635 266L869 894L754 894L698 734L451 734ZM575 359L573 359Q571 369 569.50 379Q568 389 565 399L565 399L478 649L671 649L583 399Q580 390 578.50 379.50Q577 369 575 359L575 359ZM1033 829L1033 894L931 894L931 230L1033 230L1033 524L1034 524Q1060 481 1097.50 458Q1135 435 1186 435L1186 435Q1234 435 1268.50 453.50Q1303 472 1325 503Q1347 534 1357 574Q1367 614 1367 657L1367 657Q1367 705 1355.50 749.50Q1344 794 1320 828.50Q1296 863 1258 883.50Q1220 904 1166 904L1166 904Q1080 904 1034 829L1034 829L1033 829ZM1032 651L1032 706Q1032 730 1040 751.50Q1048 773 1062 789Q1076 805 1096.50 814.50Q1117 824 1142 824L1142 824Q1177 824 1200 809Q1223 794 1237 770Q1251 746 1257 716Q1263 686 1263 657L1263 657Q1263 631 1257 605.50Q1251 580 1238 560Q1225 540 1203.50 528Q1182 516 1152 516L1152 516Q1123 516 1100.50 527Q1078 538 1063 556.50Q1048 575 1040 599.50Q1032 624 1032 651L1032 651ZM1664 904L1664 904Q1614 904 1573 887.50Q1532 871 1503 841.50Q1474 812 1458 771Q1442 730 1442 680L1442 680Q1442 625 1459 580Q1476 535 1507.50 502.50Q1539 470 1583.50 452.50Q1628 435 1684 435L1684 435Q1712 435 1739 440Q1766 445 1792 456L1792 456L1792 551Q1770 535 1744.50 525.50Q1719 516 1692 516L1692 516Q1657 516 1630 528.50Q1603 541 1584.50 562Q1566 583 1556 612Q1546 641 1546 674L1546 674Q1546 740 1583 782Q1620 824 1688 824L1688 824Q1717 824 1743 813.50Q1769 803 1792 785L1792 785L1792 873Q1763 890 1730 897Q1697 904 1664 904ZM438 1792L438 1792Q390 1792 355.50 1773Q321 1754 299 1722.50Q277 1691 266.50 1651Q256 1611 256 1568L256 1568Q256 1521 267.50 1477Q279 1433 304 1398.50Q329 1364 366.50 1343.50Q404 1323 457 1323L457 1323Q500 1323 534 1340.50Q568 1358 589 1396L589 1396L591 1396L591 1118L692 1118L692 1782L591 1782L591 1705L589 1705Q539 1792 438 1792ZM482 1404L482 1404Q447 1404 423.50 1418Q400 1432 386 1454.50Q372 1477 366 1505.50Q360 1534 360 1564L360 1564Q360 1591 366 1617.50Q372 1644 386 1665Q400 1686 421.50 1699Q443 1712 475 1712L475 1712Q503 1712 525 1701Q547 1690 562 1671Q577 1652 584.50 1627.50Q592 1603 592 1577L592 1577L592 1518Q592 1470 561.50 1437Q531 1404 482 1404ZM1012 1323L1012 1323Q1063 1323 1099 1340.50Q1135 1358 1158.50 1388Q1182 1418 1193 1459Q1204 1500 1204 1546L1204 1546L1204 1585L899 1585Q901 1648 938 1681.50Q975 1715 1037 1715L1037 1715Q1073 1715 1106.50 1703.50Q1140 1692 1169 1672L1169 1672L1169 1753Q1133 1776 1091 1784Q1049 1792 1007 1792L1007 1792Q953 1792 913.50 1774.50Q874 1757 848 1726Q822 1695 809 1652.50Q796 1610 796 1559L796 1559Q796 1511 811 1468.50Q826 1426 854 1393.50Q882 1361 922 1342Q962 1323 1012 1323ZM899 1513L1106 1513Q1106 1490 1100.50 1469Q1095 1448 1083.50 1432.50Q1072 1417 1053.50 1407.50Q1035 1398 1010 1398L1010 1398Q986 1398 966.50 1407.50Q947 1417 933 1433Q919 1449 910.50 1470Q902 1491 899 1513L899 1513ZM1332 1333L1332 1261Q1332 1225 1344.50 1197Q1357 1169 1379 1149Q1401 1129 1430.50 1118.50Q1460 1108 1495 1108L1495 1108Q1510 1108 1525 1110Q1540 1112 1554 1117L1554 1117L1554 1201Q1533 1189 1507 1189L1507 1189Q1466 1189 1449.50 1212Q1433 1235 1433 1273L1433 1273L1433 1333L1537 1333L1537 1413L1434 1413L1434 1782L1332 1782L1332 1413L1256 1413L1256 1333L1332 1333Z"
         }
      }
   ]
}

var Ascending = {
   name: "Ascending",
   vendor: "UiFabric",
   unicode: 60864,
   value: "",
   charCode: "EDC0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 1152L1216 1024L1728 1024L1408 1664L1728 1664L1728 1792L1216 1792L1536 1152L1216 1152ZM512 128L512 1638L675 1475L765 1565L448 1883L131 1565L221 1475L384 1638L384 128L512 128ZM1621 768L1323 768L1280 896L1152 896L1408 128L1536 128L1792 896L1664 896L1621 768ZM1579 640L1472 320L1365 640L1579 640Z"
         }
      }
   ]
}

var DoubleChevronLeft = {
   name: "DoubleChevronLeft",
   vendor: "UiFabric",
   unicode: 60862,
   value: "",
   charCode: "EDBE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1957 0L2048 91L1115 1024L2048 1957L1957 2048L933 1024L1957 0ZM1061 0L1152 91L219 1024L1152 1957L1061 2048L37 1024L1061 0Z"
         }
      }
   ]
}

var Split = {
   name: "Split",
   vendor: "UiFabric",
   unicode: 60860,
   value: "",
   charCode: "EDBC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1592 685L1683 595L2048 960L1683 1325L1592 1235L1803 1024L1152 1024L1152 896L1803 896L1592 685ZM365 595L456 685L245 896L896 896L896 1024L245 1024L456 1235L365 1325L0 960L365 595Z"
         }
      }
   ]
}

var TaskManagerMirrored = {
   name: "TaskManagerMirrored",
   vendor: "UiFabric",
   unicode: 60856,
   value: "",
   charCode: "EDB8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1920L0 128L2048 128L2048 1920L0 1920ZM1920 512L1920 256L128 256L128 512L1920 512ZM128 640L128 1792L1920 1792L1920 640L128 640ZM1792 1152L1408 1152L1408 768L1792 768L1792 1152ZM1664 896L1536 896L1536 1024L1664 1024L1664 896ZM1792 1664L1408 1664L1408 1280L1792 1280L1792 1664ZM1664 1408L1536 1408L1536 1536L1664 1536L1664 1408ZM1152 1024L384 1024L384 896L1152 896L1152 1024ZM1152 1536L384 1536L384 1408L1152 1408L1152 1536Z"
         }
      }
   ]
}

var TaskManager = {
   name: "TaskManager",
   vendor: "UiFabric",
   unicode: 60855,
   value: "",
   charCode: "EDB7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1920L0 128L2048 128L2048 1920L0 1920ZM1920 512L1920 256L128 256L128 512L1920 512ZM128 640L128 1792L1920 1792L1920 640L128 640ZM640 1152L256 1152L256 768L640 768L640 1152ZM512 896L384 896L384 1024L512 1024L512 896ZM640 1664L256 1664L256 1280L640 1280L640 1664ZM512 1408L384 1408L384 1536L512 1536L512 1408ZM1664 1024L896 1024L896 896L1664 896L1664 1024ZM1664 1536L896 1536L896 1408L1664 1408L1664 1536Z"
         }
      }
   ]
}

var Combine = {
   name: "Combine",
   vendor: "UiFabric",
   unicode: 60859,
   value: "",
   charCode: "EDBB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1371 896L2048 896L2048 1024L1371 1024L1581 1235L1491 1325L1126 960L1491 595L1581 685L1371 896ZM677 896L467 685L557 595L922 960L557 1325L467 1235L677 1024L0 1024L0 896L677 896Z"
         }
      }
   ]
}

var DoubleChevronUp = {
   name: "DoubleChevronUp",
   vendor: "UiFabric",
   unicode: 60861,
   value: "",
   charCode: "EDBD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M91 2048L0 1957L1024 933L2048 1957L1957 2048L1024 1115L91 2048ZM1957 1152L1024 219L91 1152L0 1061L1024 37L2048 1061L1957 1152Z"
         }
      }
   ]
}

var DoubleChevronRight = {
   name: "DoubleChevronRight",
   vendor: "UiFabric",
   unicode: 60863,
   value: "",
   charCode: "EDBF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 91L91 0L1115 1024L91 2048L0 1957L933 1024L0 91ZM896 91L987 0L2011 1024L987 2048L896 1957L1829 1024L896 91Z"
         }
      }
   ]
}

var Descending = {
   name: "Descending",
   vendor: "UiFabric",
   unicode: 60865,
   value: "",
   charCode: "EDC1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 768L1728 896L1216 896L1536 256L1216 256L1216 128L1728 128L1408 768L1728 768ZM512 128L512 1638L675 1475L765 1565L448 1883L131 1565L221 1475L384 1638L384 128L512 128ZM1792 1792L1664 1792L1621 1664L1323 1664L1280 1792L1152 1792L1408 1024L1536 1024L1792 1792ZM1472 1216L1365 1536L1579 1536L1472 1216Z"
         }
      }
   ]
}

var TextField = {
   name: "TextField",
   vendor: "UiFabric",
   unicode: 60867,
   value: "",
   charCode: "EDC3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1664L0 1664L0 256ZM1920 1536L1920 384L128 384L128 1536L1920 1536ZM451 1118L397 1278L283 1278L518 650L635 650L869 1278L754 1278L698 1118L451 1118ZM575 743L573 743Q571 753 569.50 763Q568 773 565 783L565 783L478 1033L671 1033L583 783Q580 774 578.50 763.50Q577 753 575 743L575 743ZM1033 1213L1033 1278L931 1278L931 614L1033 614L1033 908L1034 908Q1060 865 1097.50 842Q1135 819 1186 819L1186 819Q1234 819 1268.50 837.50Q1303 856 1325 887Q1347 918 1357 958Q1367 998 1367 1041L1367 1041Q1367 1089 1355.50 1133.50Q1344 1178 1320 1212.50Q1296 1247 1258 1267.50Q1220 1288 1166 1288L1166 1288Q1080 1288 1034 1213L1034 1213L1033 1213ZM1032 1035L1032 1090Q1032 1114 1040 1135.50Q1048 1157 1062 1173Q1076 1189 1096.50 1198.50Q1117 1208 1142 1208L1142 1208Q1177 1208 1200 1193Q1223 1178 1237 1154Q1251 1130 1257 1100Q1263 1070 1263 1041L1263 1041Q1263 1015 1257 989.50Q1251 964 1238 944Q1225 924 1203.50 912Q1182 900 1152 900L1152 900Q1123 900 1100.50 911Q1078 922 1063 940.50Q1048 959 1040 983.50Q1032 1008 1032 1035L1032 1035ZM1664 1288L1664 1288Q1614 1288 1573 1271.50Q1532 1255 1503 1225.50Q1474 1196 1458 1155Q1442 1114 1442 1064L1442 1064Q1442 1009 1459 964Q1476 919 1507.50 886.50Q1539 854 1583.50 836.50Q1628 819 1684 819L1684 819Q1712 819 1739 824Q1766 829 1792 840L1792 840L1792 935Q1770 919 1744.50 909.50Q1719 900 1692 900L1692 900Q1657 900 1630 912.50Q1603 925 1584.50 946Q1566 967 1556 996Q1546 1025 1546 1058L1546 1058Q1546 1124 1583 1166Q1620 1208 1688 1208L1688 1208Q1717 1208 1743 1197.50Q1769 1187 1792 1169L1792 1169L1792 1257Q1763 1274 1730 1281Q1697 1288 1664 1288Z"
         }
      }
   ]
}

var Dropdown = {
   name: "Dropdown",
   vendor: "UiFabric",
   unicode: 60869,
   value: "",
   charCode: "EDC5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 256L2048 256L2048 1664L0 1664ZM128 1536L1920 1536L1920 384L128 384L128 1536ZM1280 896L1792 896L1536 1152L1280 896Z"
         }
      }
   ]
}

var BookingsLogo = {
   name: "BookingsLogo",
   vendor: "UiFabric",
   unicode: 60871,
   value: "",
   charCode: "EDC7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 1280Q827 1280 710.50 1230Q594 1180 507 1093Q420 1006 370 889.50Q320 773 320 640L320 640L320 0L960 0ZM1088 1280L1088 640Q1221 640 1337.50 690Q1454 740 1541 827Q1628 914 1678 1030.50Q1728 1147 1728 1280L1728 1280L1088 1280ZM320 2048L320 1408L1728 1408Q1728 1541 1678 1657.50Q1628 1774 1541 1861Q1454 1948 1337.50 1998Q1221 2048 1088 2048L1088 2048L320 2048Z"
         }
      }
   ]
}

var DocsLogoInverse = {
   name: "DocsLogoInverse",
   vendor: "UiFabric",
   unicode: 60875,
   value: "",
   charCode: "EDCB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M761 999L761 999Q761 1043 752 1090.50Q743 1138 722 1177Q701 1216 665 1241.50Q629 1267 575 1267L575 1267Q557 1267 539 1266Q521 1265 503 1264L503 1264L503 754Q523 753 542.50 752Q562 751 582 751L582 751Q633 751 667.50 773.50Q702 796 723 832Q744 868 752.50 912Q761 956 761 999ZM64 1781L64 273L1216 68L1216 1980L64 1781ZM376 618L376 1402Q433 1406 490 1411.50Q547 1417 604 1417L604 1417Q690 1417 749.50 1378.50Q809 1340 846 1279Q883 1218 899.50 1143Q916 1068 916 995L916 995Q916 919 903 847.50Q890 776 856.50 720.50Q823 665 765.50 631.50Q708 598 620 598L620 598Q559 598 497.50 605.50Q436 613 376 618L376 618ZM1884 360L1884 1044L1401 1044L1401 1527L1280 1527L1280 924L1723 924L1723 843L1280 843L1280 723L1723 723L1723 642L1280 642L1280 521L1723 521L1723 441L1280 441L1280 320L1843 320Q1860 320 1872 331.50Q1884 343 1884 360L1884 360ZM1481 1125L2004 1125L2004 1728L1481 1728L1481 1125ZM1723 1406L1723 1205Q1681 1205 1644.50 1220.50Q1608 1236 1580.50 1263.50Q1553 1291 1537 1327.50Q1521 1364 1521 1406L1521 1406L1723 1406ZM1763 1648L1763 1648Q1805 1648 1841.50 1632Q1878 1616 1905 1589Q1932 1562 1948 1525.50Q1964 1489 1964 1447L1964 1447Q1964 1405 1948 1368.50Q1932 1332 1905 1305Q1878 1278 1841.50 1262Q1805 1246 1763 1246L1763 1246L1763 1447L1562 1447Q1562 1489 1578 1525.50Q1594 1562 1621 1589Q1648 1616 1684.50 1632Q1721 1648 1763 1648Z"
         }
      }
   ]
}

var DynamicSMBLogo = {
   name: "DynamicSMBLogo",
   vendor: "UiFabric",
   unicode: 60877,
   value: "",
   charCode: "EDCD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M708 1231L937 1200L1164 975L1164 2048L708 2048L708 1231ZM93 2048L93 1314L565 1251L565 2048L93 2048ZM1303 2048L1303 837L1775 372L1775 2048L1303 2048ZM1722 27L1966 0Q1970-1 1973 2Q1976 5 1976 9L1976 9L1976 11L1933 244Q1933 246 1931 248.50Q1929 251 1927 251L1927 251Q1920 251 1917 248L1917 248L1839 168L895 1100Q889 1106 879 1108L879 1108L103 1212Q90 1214 81 1205Q72 1196 72 1184L72 1184Q72 1173 79 1166Q86 1159 96 1157L96 1157L862 1053L1800 128Q1796 124 1782 110.50Q1768 97 1752.50 81.50Q1737 66 1725 52.50Q1713 39 1713 36L1713 36Q1713 29 1722 27L1722 27Z"
         }
      }
   ]
}

var OfficeStoreLogo = {
   name: "OfficeStoreLogo",
   vendor: "UiFabric",
   unicode: 60879,
   value: "",
   charCode: "EDCF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L1536 512L2048 512L2048 1856Q2048 1896 2033 1931Q2018 1966 1992 1992Q1966 2018 1931 2033Q1896 2048 1856 2048L1856 2048L192 2048Q152 2048 117 2033Q82 2018 56 1992Q30 1966 15 1931Q0 1896 0 1856L0 1856L0 512L512 512Q512 406 552 312.50Q592 219 661.50 149.50Q731 80 824.50 40Q918 0 1024 0L1024 0Q1130 0 1223.50 40Q1317 80 1386.50 149.50Q1456 219 1496 312.50Q1536 406 1536 512ZM1024 128L1024 128Q944 128 874.50 158Q805 188 752.50 240.50Q700 293 670 363Q640 433 640 512L640 512L1408 512Q1408 433 1378 363Q1348 293 1295.50 240.50Q1243 188 1173 158Q1103 128 1024 128ZM1920 1856L1920 1856L1920 640L128 640L128 1856Q128 1882 147 1901Q166 1920 192 1920L192 1920L1856 1920Q1882 1920 1901 1901Q1920 1882 1920 1856Z"
         }
      }
   ]
}

var PlannerLogo = {
   name: "PlannerLogo",
   vendor: "UiFabric",
   unicode: 60881,
   value: "",
   charCode: "EDD1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M277 64L1771 64Q1806 64 1831 89Q1856 114 1856 149L1856 149L1856 1131Q1856 1166 1831 1191Q1806 1216 1771 1216L1771 1216L1280 1216L1280 1515Q1280 1550 1255 1575Q1230 1600 1195 1600L1195 1600L768 1600L768 1898Q768 1916 761.50 1931.50Q755 1947 743.50 1958.50Q732 1970 716.50 1977Q701 1984 683 1984L683 1984L277 1984Q259 1984 243.50 1977Q228 1970 216.50 1958.50Q205 1947 198.50 1931.50Q192 1916 192 1898L192 1898L192 149Q192 114 217 89Q242 64 277 64L277 64ZM1152 704L1152 192L768 192L768 704L1152 704ZM640 192L320 192L320 960L640 960L640 192ZM320 1856L640 1856L640 1088L320 1088L320 1856ZM768 1472L1152 1472L1152 832L768 832L768 1472ZM1280 1088L1728 1088L1728 192L1280 192L1280 1088Z"
         }
      }
   ]
}

var Suitcase = {
   name: "Suitcase",
   vendor: "UiFabric",
   unicode: 60883,
   value: "",
   charCode: "EDD3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 384L1856 384Q1896 384 1931 399Q1966 414 1992 440Q2018 466 2033 501Q2048 536 2048 576L2048 576L2048 1728Q2048 1768 2033 1803Q2018 1838 1992 1864Q1966 1890 1931 1905Q1896 1920 1856 1920L1856 1920L192 1920Q152 1920 117 1905Q82 1890 56 1864Q30 1838 15 1803Q0 1768 0 1728L0 1728L0 576Q0 536 15 501Q30 466 56 440Q82 414 117 399Q152 384 192 384L192 384L640 384L640 256Q640 229 650 206Q660 183 677.50 165.50Q695 148 718 138Q741 128 768 128L768 128L1280 128Q1307 128 1330 138Q1353 148 1370.50 165.50Q1388 183 1398 206Q1408 229 1408 256L1408 256L1408 384ZM768 256L768 384L1280 384L1280 256L768 256ZM1536 512L512 512L512 1792L1536 1792L1536 512ZM128 576L128 1728Q128 1754 147 1773Q166 1792 192 1792L192 1792L384 1792L384 512L192 512Q166 512 147 531Q128 550 128 576L128 576ZM1920 1728L1920 576Q1920 550 1901 531Q1882 512 1856 512L1856 512L1664 512L1664 1792L1856 1792Q1882 1792 1901 1773Q1920 1754 1920 1728L1920 1728Z"
         }
      }
   ]
}

var CaretLeft8 = {
   name: "CaretLeft8",
   vendor: "UiFabric",
   unicode: 60885,
   value: "",
   charCode: "EDD5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 2048L512 1024L1536 0L1536 2048ZM874 1024L1280 1430L1280 618L874 1024Z"
         }
      }
   ]
}

var CaretRight8 = {
   name: "CaretRight8",
   vendor: "UiFabric",
   unicode: 60886,
   value: "",
   charCode: "EDD6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 2048L512 0L1536 1024L512 2048ZM1174 1024L768 618L768 1430L1174 1024Z"
         }
      }
   ]
}

var CaretUp8 = {
   name: "CaretUp8",
   vendor: "UiFabric",
   unicode: 60887,
   value: "",
   charCode: "EDD7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L1024 512L2048 1536L0 1536ZM1430 1280L1024 874L618 1280L1430 1280Z"
         }
      }
   ]
}

var CaretDown8 = {
   name: "CaretDown8",
   vendor: "UiFabric",
   unicode: 60888,
   value: "",
   charCode: "EDD8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1536L0 512L2048 512L1024 1536ZM1430 768L618 768L1024 1174L1430 768Z"
         }
      }
   ]
}

var CaretLeftSolid8 = {
   name: "CaretLeftSolid8",
   vendor: "UiFabric",
   unicode: 60889,
   value: "",
   charCode: "EDD9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 1024L512 1024L1536 0L1536 2048L512 1024Z"
         }
      }
   ]
}

var CaretRightSolid8 = {
   name: "CaretRightSolid8",
   vendor: "UiFabric",
   unicode: 60890,
   value: "",
   charCode: "EDDA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L512 0L1536 1024L512 2048L512 0Z"
         }
      }
   ]
}

var CaretUpSolid8 = {
   name: "CaretUpSolid8",
   vendor: "UiFabric",
   unicode: 60891,
   value: "",
   charCode: "EDDB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 512L1024 512L2048 1536L0 1536L1024 512Z"
         }
      }
   ]
}

var CaretDownSolid8 = {
   name: "CaretDownSolid8",
   vendor: "UiFabric",
   unicode: 60892,
   value: "",
   charCode: "EDDC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 512L0 512L2048 512L1024 1536L0 512Z"
         }
      }
   ]
}

var ClearFormatting = {
   name: "ClearFormatting",
   vendor: "UiFabric",
   unicode: 60893,
   value: "",
   charCode: "EDDD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1946 1216L1243 1920L1664 1920L1664 2048L677 2048L429 1800Q402 1773 387.50 1737.50Q373 1702 373 1664L373 1664Q373 1626 387.50 1590.50Q402 1555 429 1528L429 1528L864 1093L799 896L353 896L268 1152L128 1152L512 0L640 0L969 988L1344 614L1946 1216ZM396 768L756 768L576 228L396 768ZM1766 1216L1344 794L794 1344L1216 1766L1766 1216ZM731 1920L1061 1920L1126 1856L704 1434L520 1619Q501 1638 501 1664L501 1664Q501 1690 520 1709L520 1709L731 1920Z"
         }
      }
   ]
}

var Superscript = {
   name: "Superscript",
   vendor: "UiFabric",
   unicode: 60894,
   value: "",
   charCode: "EDDE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1863 328L1701 486Q1695 492 1690.50 498.50Q1686 505 1681 512L1681 512L1920 512L1920 640L1536 640L1536 576Q1536 524 1555 482Q1574 440 1602.50 405Q1631 370 1664 341Q1697 312 1725.50 287Q1754 262 1773 239Q1792 216 1792 192L1792 192Q1792 166 1773 147Q1754 128 1728 128L1728 128Q1702 128 1683 147Q1664 166 1664 192L1664 192L1536 192Q1536 152 1551 117Q1566 82 1592 56Q1618 30 1653 15Q1688 0 1728 0L1728 0Q1768 0 1803 15Q1838 30 1864 56Q1890 82 1905 117Q1920 152 1920 192L1920 192Q1920 230 1905 265.50Q1890 301 1864 328L1864 328L1863 328ZM1280 512L1440 512L1056 1024L1440 1536L1280 1536L976 1131L672 1536L512 1536L896 1024L512 512L672 512L976 917L1280 512Z"
         }
      }
   ]
}

var Subscript = {
   name: "Subscript",
   vendor: "UiFabric",
   unicode: 60895,
   value: "",
   charCode: "EDDF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1863 1736L1701 1894Q1695 1900 1690.50 1906.50Q1686 1913 1681 1920L1681 1920L1920 1920L1920 2048L1536 2048L1536 1984Q1536 1932 1555 1890Q1574 1848 1602.50 1813Q1631 1778 1664 1749Q1697 1720 1725.50 1695Q1754 1670 1773 1647Q1792 1624 1792 1600L1792 1600Q1792 1574 1773 1555Q1754 1536 1728 1536L1728 1536Q1702 1536 1683 1555Q1664 1574 1664 1600L1664 1600L1536 1600Q1536 1560 1551 1525Q1566 1490 1592 1464Q1618 1438 1653 1423Q1688 1408 1728 1408L1728 1408Q1768 1408 1803 1423Q1838 1438 1864 1464Q1890 1490 1905 1525Q1920 1560 1920 1600L1920 1600Q1920 1638 1905 1673.50Q1890 1709 1864 1736L1864 1736L1863 1736ZM1280 512L1440 512L1056 1024L1440 1536L1280 1536L976 1131L672 1536L512 1536L896 1024L512 512L672 512L976 917L1280 512Z"
         }
      }
   ]
}

var Strikethrough = {
   name: "Strikethrough",
   vendor: "UiFabric",
   unicode: 60896,
   value: "",
   charCode: "EDE0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1977 1152L2048 1152L2048 1280L1973 1280Q1963 1380 1928 1469.50Q1893 1559 1833 1627Q1773 1695 1689 1735Q1605 1775 1497 1775L1497 1775Q1273 1775 1161 1578L1161 1578L1157 1578L1157 1750L1024 1750L1024 1280L896 1280L896 1750L763 1750L763 1561L759 1561Q707 1662 618 1718.50Q529 1775 414 1775L414 1775Q344 1775 283 1755.50Q222 1736 177 1697.50Q132 1659 106 1602Q80 1545 80 1471L80 1471Q80 1420 92.50 1371Q105 1322 135 1280L135 1280L0 1280L0 1152L332 1152Q334 1152 348.50 1149Q363 1146 381.50 1142Q400 1138 417 1134Q434 1130 440 1129L440 1129L763 1082Q763 1021 752 965.50Q741 910 714 867.50Q687 825 641 800Q595 775 525 775L525 775Q426 775 340 811.50Q254 848 179 911L179 911L179 766Q215 741 259 721Q303 701 350 687.50Q397 674 444.50 667Q492 660 536 660L536 660Q632 660 700.50 688Q769 716 812.50 768Q856 820 876 893Q896 966 896 1057L896 1057L896 1152L1024 1152L1024 173L1157 173L1157 889L1161 889Q1221 778 1319 719Q1417 660 1544 660L1544 660Q1653 660 1733 699.50Q1813 739 1866 806.50Q1919 874 1946.50 963.50Q1974 1053 1977 1152L1977 1152ZM763 1280L763 1280L314 1280Q257 1309 237 1356Q217 1403 217 1463L217 1463Q217 1512 234.50 1549Q252 1586 282 1610.50Q312 1635 352.50 1647.50Q393 1660 438 1660L438 1660Q492 1660 538.50 1644.50Q585 1629 623 1601Q661 1573 690.50 1533Q720 1493 738 1444L738 1444Q754 1402 758.50 1363.50Q763 1325 763 1280ZM1157 1152L1157 1152L1840 1152Q1837 1079 1817 1011Q1797 943 1757.50 890.50Q1718 838 1658.50 806.50Q1599 775 1517 775L1517 775Q1435 775 1369.50 804.50Q1304 834 1258 885Q1212 936 1186 1005Q1160 1074 1157 1152ZM1835 1280L1835 1280L1157 1280L1157 1307Q1157 1379 1181.50 1443.50Q1206 1508 1250 1556Q1294 1604 1355.50 1632Q1417 1660 1492 1660L1492 1660Q1574 1660 1634.50 1628Q1695 1596 1737 1543Q1779 1490 1803 1421.50Q1827 1353 1835 1280Z"
         }
      }
   ]
}

var Export = {
   name: "Export",
   vendor: "UiFabric",
   unicode: 60897,
   value: "",
   charCode: "EDE1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1587 499L1497 589L1805 898L262 898L262 1026L1802 1026L1497 1331L1587 1421L2048 960L1587 499ZM134 1408L134 512L6 512L6 1408L134 1408Z"
         }
      }
   ]
}

var ExportMirrored = {
   name: "ExportMirrored",
   vendor: "UiFabric",
   unicode: 60898,
   value: "",
   charCode: "EDE2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M467 499L557 589L249 898L1792 898L1792 1026L252 1026L557 1331L467 1421L6 960L467 499ZM1920 1408L1920 512L2048 512L2048 1408L1920 1408Z"
         }
      }
   ]
}

var SingleBookmark = {
   name: "SingleBookmark",
   vendor: "UiFabric",
   unicode: 60927,
   value: "",
   charCode: "EDFF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L1664 0L1664 2048L1024 1725L384 2048L384 0ZM1536 1840L1536 128L512 128L512 1840Q641 1775 768 1710Q895 1645 1024 1581L1024 1581Q1153 1645 1280 1710Q1407 1775 1536 1840L1536 1840Z"
         }
      }
   ]
}

var SingleBookmarkSolid = {
   name: "SingleBookmarkSolid",
   vendor: "UiFabric",
   unicode: 60928,
   value: "",
   charCode: "EE00",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L384 0L1664 0L1664 2048L1024 1725L384 2048L384 0Z"
         }
      }
   ]
}

var DoubleChevronDown = {
   name: "DoubleChevronDown",
   vendor: "UiFabric",
   unicode: 60932,
   value: "",
   charCode: "EE04",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1957 0L2048 91L1024 1115L0 91L91 0L1024 933L1957 0ZM91 896L1024 1829L1957 896L2048 987L1024 2011L0 987L91 896Z"
         }
      }
   ]
}

var ProductVariant = {
   name: "ProductVariant",
   vendor: "UiFabric",
   unicode: 60976,
   value: "",
   charCode: "EE30",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 354L1344 2L2048 354L2048 1139L1920 1075L1920 497L1408 753L1408 1011L1280 1075L1280 753L768 497L768 724L640 660L640 354ZM847 394L1344 642L1521 553L1058 288L847 394ZM1195 220L1659 485L1841 394L1344 145L1195 220ZM1152 1059L1152 1139L1024 1203L1024 1202L640 1394L640 1849L1024 1656L1024 1800L576 2024L0 1735L0 1059L576 771L1152 1059ZM128 1656L512 1849L512 1394L128 1202L128 1656ZM207 1099L576 1283L945 1099L576 914L207 1099ZM1152 1809L1152 1282L1600 1058L2048 1282L2048 1809L1600 2033L1152 1809ZM1280 1730L1536 1858L1536 1553L1280 1425L1280 1730ZM1664 1858L1920 1730L1920 1425L1664 1553L1664 1858ZM1359 1321L1600 1442L1841 1321L1600 1201L1359 1321Z"
         }
      }
   ]
}

var ProductRelease = {
   name: "ProductRelease",
   vendor: "UiFabric",
   unicode: 60974,
   value: "",
   charCode: "EE2E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1409L896 1537L896 936L256 616L256 1496L800 1769L769 1896L128 1576L128 472L960 57L1792 472L1792 742Q1722 753 1664 787L1664 787L1664 616L1024 936L1024 1409ZM960 199L754 302L1338 636L1585 512L960 199ZM335 512L960 825L1200 705L616 371L335 512ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1772 910Q1808 896 1848 896ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836Z"
         }
      }
   ]
}

var RecruitmentManagement = {
   name: "RecruitmentManagement",
   vendor: "UiFabric",
   unicode: 60946,
   value: "",
   charCode: "EE12",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1280L2048 1280L2048 2048L1024 2048L1024 1280L1280 1280L1280 1024L1792 1024L1792 1280ZM1408 1152L1408 1280L1664 1280L1664 1152L1408 1152ZM1920 1920L1920 1664L1792 1664L1792 1792L1664 1792L1664 1664L1408 1664L1408 1792L1280 1792L1280 1664L1152 1664L1152 1920L1920 1920ZM1920 1536L1920 1408L1152 1408L1152 1536L1920 1536ZM1723 896L1565 896Q1511 835 1436.50 801.50Q1362 768 1280 768L1280 768Q1200 768 1130.50 798Q1061 828 1008.50 880.50Q956 933 926 1003Q896 1073 896 1152L896 1152Q896 1244 854.50 1325.50Q813 1407 739 1461L739 1461Q784 1484 823.50 1514.50Q863 1545 896 1582L896 1582L896 1920Q896 1841 866 1771Q836 1701 783.50 1648.50Q731 1596 661 1566Q591 1536 512 1536L512 1536Q432 1536 362.50 1566Q293 1596 240.50 1648.50Q188 1701 158 1771Q128 1841 128 1920L128 1920L0 1920Q0 1847 20 1778.50Q40 1710 77 1650Q114 1590 167 1542Q220 1494 285 1461L285 1461Q211 1407 169.50 1325.50Q128 1244 128 1152L128 1152Q128 1073 158 1003Q188 933 240.50 880.50Q293 828 362.50 798Q432 768 512 768L512 768Q604 768 685.50 809.50Q767 851 821 925L821 925Q859 850 918.50 790.50Q978 731 1053 693L1053 693Q979 639 937.50 557.50Q896 476 896 384L896 384Q896 305 926 235Q956 165 1008.50 112.50Q1061 60 1130.50 30Q1200 0 1280 0L1280 0Q1359 0 1429 30Q1499 60 1551.50 112.50Q1604 165 1634 235Q1664 305 1664 384L1664 384Q1664 476 1622.50 557.50Q1581 639 1507 693L1507 693Q1575 727 1630 778.50Q1685 830 1723 896L1723 896ZM512 1408L512 1408Q565 1408 611.50 1388Q658 1368 693 1333Q728 1298 748 1251.50Q768 1205 768 1152L768 1152Q768 1099 748 1052.50Q728 1006 693 971Q658 936 611.50 916Q565 896 512 896L512 896Q459 896 412.50 916Q366 936 331 971Q296 1006 276 1052.50Q256 1099 256 1152L256 1152Q256 1205 276 1251.50Q296 1298 331 1333Q366 1368 412.50 1388Q459 1408 512 1408ZM1024 384L1024 384Q1024 437 1044 483.50Q1064 530 1099 565Q1134 600 1180.50 620Q1227 640 1280 640L1280 640Q1333 640 1379.50 620Q1426 600 1461 565Q1496 530 1516 483.50Q1536 437 1536 384L1536 384Q1536 331 1516 284.50Q1496 238 1461 203Q1426 168 1379.50 148Q1333 128 1280 128L1280 128Q1227 128 1180.50 148Q1134 168 1099 203Q1064 238 1044 284.50Q1024 331 1024 384Z"
         }
      }
   ]
}

var ReplyAll = {
   name: "ReplyAll",
   vendor: "UiFabric",
   unicode: 60938,
   value: "",
   charCode: "EE0A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M859 640L1408 640Q1536 640 1653 688Q1770 736 1861 827L1861 827Q1952 918 2000 1035Q2048 1152 2048 1280L2048 1280Q2048 1413 1998 1529.50Q1948 1646 1861 1733Q1774 1820 1657.50 1870Q1541 1920 1408 1920L1408 1920L1408 1792Q1514 1792 1607 1751.50Q1700 1711 1769.50 1641.50Q1839 1572 1879.50 1479Q1920 1386 1920 1280L1920 1280Q1920 1174 1879.50 1081Q1839 988 1769.50 918.50Q1700 849 1607 808.50Q1514 768 1408 768L1408 768L859 768L1261 1171L1171 1261L614 704L1171 147L1261 237L859 640ZM749 237L282 704L749 1171L659 1261L102 704L659 147L749 237Z"
         }
      }
   ]
}

var FollowUser = {
   name: "FollowUser",
   vendor: "UiFabric",
   unicode: 60933,
   value: "",
   charCode: "EE05",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1677 1235L2042 1600L1677 1965L1587 1875L1798 1664L1152 1664L1152 1536L1798 1536L1587 1325L1677 1235ZM1468 1350L1351 1402Q1312 1316 1251.50 1246.50Q1191 1177 1115 1127.50Q1039 1078 950.50 1051Q862 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1547 35.50 1435Q71 1323 136.50 1227.50Q202 1132 293.50 1058.50Q385 985 496 946L496 946Q440 910 395.50 863Q351 816 320 760Q289 704 272.50 641.50Q256 579 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 649 1216.50 760.50Q1153 872 1040 946L1040 946Q1112 973 1176 1013.50Q1240 1054 1294.50 1105.50Q1349 1157 1392.50 1219Q1436 1281 1468 1350L1468 1350ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512Z"
         }
      }
   ]
}

var WorkforceManagement = {
   name: "WorkforceManagement",
   vendor: "UiFabric",
   unicode: 60943,
   value: "",
   charCode: "EE0F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1024L1792 1280L2048 1280L2048 2048L1024 2048L1024 1280L1280 1280L1280 1024L1792 1024ZM1408 1152L1408 1280L1664 1280L1664 1152L1408 1152ZM1920 1920L1920 1664L1792 1664L1792 1792L1664 1792L1664 1664L1408 1664L1408 1792L1280 1792L1280 1664L1152 1664L1152 1920L1920 1920ZM1920 1408L1152 1408L1152 1536L1920 1536L1920 1408ZM896 896L896 896Q896 989 854.50 1070.50Q813 1152 738 1206L738 1206Q783 1229 823 1259Q863 1289 896 1326L896 1326L896 1664Q896 1585 866 1515Q836 1445 783.50 1392.50Q731 1340 661 1310Q591 1280 512 1280L512 1280Q432 1280 362.50 1310Q293 1340 240.50 1392.50Q188 1445 158 1515Q128 1585 128 1664L128 1664L0 1664Q0 1591 20 1522.50Q40 1454 77.50 1394Q115 1334 168 1286Q221 1238 286 1205L286 1205Q211 1151 169.50 1069.50Q128 988 128 896L128 896Q128 817 158 747Q188 677 240.50 624.50Q293 572 362.50 542Q432 512 512 512L512 512Q584 512 649.50 537.50Q715 563 768 611L768 611Q800 582 839 560L839 560Q805 525 786.50 479Q768 433 768 384L768 384Q768 331 788 284.50Q808 238 843 203Q878 168 924.50 148Q971 128 1024 128L1024 128Q1077 128 1123.50 148Q1170 168 1205 203Q1240 238 1260 284.50Q1280 331 1280 384L1280 384Q1280 433 1261.50 479Q1243 525 1209 560L1209 560Q1292 606 1344 684L1344 684Q1396 606 1479 560L1479 560Q1445 525 1426.50 479Q1408 433 1408 384L1408 384Q1408 331 1428 284.50Q1448 238 1483 203Q1518 168 1564.50 148Q1611 128 1664 128L1664 128Q1717 128 1763.50 148Q1810 168 1845 203Q1880 238 1900 284.50Q1920 331 1920 384L1920 384Q1920 433 1901.50 479Q1883 525 1849 560L1849 560Q1895 585 1932 621Q1969 657 1994.50 700.50Q2020 744 2034 794Q2048 844 2048 896L2048 896L1920 896Q1920 843 1900 796.50Q1880 750 1845 715Q1810 680 1763.50 660Q1717 640 1664 640L1664 640Q1611 640 1564.50 660Q1518 680 1483 715Q1448 750 1428 796.50Q1408 843 1408 896L1408 896L1280 896Q1280 843 1260 796.50Q1240 750 1205 715Q1170 680 1123.50 660Q1077 640 1024 640L1024 640Q975 640 929 658.50Q883 677 848 711L848 711Q872 753 884 800Q896 847 896 896ZM1664 256L1664 256Q1637 256 1614 266Q1591 276 1573.50 293.50Q1556 311 1546 334Q1536 357 1536 384L1536 384Q1536 411 1546 434Q1556 457 1573.50 474.50Q1591 492 1614 502Q1637 512 1664 512L1664 512Q1691 512 1714 502Q1737 492 1754.50 474.50Q1772 457 1782 434Q1792 411 1792 384L1792 384Q1792 357 1782 334Q1772 311 1754.50 293.50Q1737 276 1714 266Q1691 256 1664 256ZM1024 256L1024 256Q997 256 974 266Q951 276 933.50 293.50Q916 311 906 334Q896 357 896 384L896 384Q896 411 906 434Q916 457 933.50 474.50Q951 492 974 502Q997 512 1024 512L1024 512Q1051 512 1074 502Q1097 492 1114.50 474.50Q1132 457 1142 434Q1152 411 1152 384L1152 384Q1152 357 1142 334Q1132 311 1114.50 293.50Q1097 276 1074 266Q1051 256 1024 256ZM512 1152L512 1152Q565 1152 611.50 1132Q658 1112 693 1077Q728 1042 748 995.50Q768 949 768 896L768 896Q768 843 748 796.50Q728 750 693 715Q658 680 611.50 660Q565 640 512 640L512 640Q459 640 412.50 660Q366 680 331 715Q296 750 276 796.50Q256 843 256 896L256 896Q256 949 276 995.50Q296 1042 331 1077Q366 1112 412.50 1132Q459 1152 512 1152Z"
         }
      }
   ]
}

var Questionnaire = {
   name: "Questionnaire",
   vendor: "UiFabric",
   unicode: 60953,
   value: "",
   charCode: "EE19",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM1664 1920L1664 640L1152 640L1152 128L256 128L256 1920L1664 1920ZM384 1280L384 896L768 896L768 1280L384 1280ZM512 1024L512 1152L640 1152L640 1024L512 1024ZM384 768L384 384L768 384L768 768L384 768ZM512 512L512 640L640 640L640 512L512 512ZM896 1152L896 1024L1536 1024L1536 1152L896 1152ZM384 1792L384 1408L768 1408L768 1792L384 1792ZM512 1536L512 1664L640 1664L640 1536L512 1536ZM896 1664L896 1536L1536 1536L1536 1664L896 1664Z"
         }
      }
   ]
}

var ManagerSelfService = {
   name: "ManagerSelfService",
   vendor: "UiFabric",
   unicode: 60963,
   value: "",
   charCode: "EE23",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 896L2048 1792L1821 1792Q1869 1845 1894.50 1910.50Q1920 1976 1920 2048L1920 2048L1792 2048Q1792 1995 1772 1948.50Q1752 1902 1717 1867Q1682 1832 1635.50 1812Q1589 1792 1536 1792L1536 1792Q1483 1792 1436.50 1812Q1390 1832 1355 1867Q1320 1902 1300 1948.50Q1280 1995 1280 2048L1280 2048L1152 2048Q1152 1995 1132 1948.50Q1112 1902 1077 1867Q1042 1832 995.50 1812Q949 1792 896 1792L896 1792Q843 1792 796.50 1812Q750 1832 715 1867Q680 1902 660 1948.50Q640 1995 640 2048L640 2048L512 2048Q512 1996 526 1946Q540 1896 565.50 1852.50Q591 1809 628 1773Q665 1737 711 1712L711 1712Q677 1677 658.50 1631Q640 1585 640 1536L640 1536Q640 1467 674.50 1408.50Q709 1350 768 1316L768 1316L768 1024Q768 994 781.50 967Q795 940 819 922L819 922Q764 849 683.50 808.50Q603 768 512 768L512 768Q432 768 362.50 798Q293 828 240.50 880.50Q188 933 158 1003Q128 1073 128 1152L128 1152L0 1152Q0 1079 20 1010.50Q40 942 77.50 882Q115 822 168 774Q221 726 286 693L286 693Q211 639 169.50 557.50Q128 476 128 384L128 384Q128 305 158 235Q188 165 240.50 112.50Q293 60 362.50 30Q432 0 512 0L512 0Q591 0 661 30Q731 60 783.50 112.50Q836 165 866 235Q896 305 896 384L896 384Q896 477 854.50 558.50Q813 640 738 694L738 694Q806 728 861.50 779Q917 830 955 896L955 896L1312 896Q1343 896 1366 886.50Q1389 877 1409.50 863Q1430 849 1450.50 832Q1471 815 1496.50 801Q1522 787 1554.50 777.50Q1587 768 1632 768L1632 768L1920 768Q1947 768 1970 778Q1993 788 2010.50 805.50Q2028 823 2038 846Q2048 869 2048 896L2048 896ZM512 640L512 640Q565 640 611.50 620Q658 600 693 565Q728 530 748 483.50Q768 437 768 384L768 384Q768 331 748 284.50Q728 238 693 203Q658 168 611.50 148Q565 128 512 128L512 128Q459 128 412.50 148Q366 168 331 203Q296 238 276 284.50Q256 331 256 384L256 384Q256 437 276 483.50Q296 530 331 565Q366 600 412.50 620Q459 640 512 640ZM896 1664L896 1664Q923 1664 946 1654Q969 1644 986.50 1626.50Q1004 1609 1014 1586Q1024 1563 1024 1536L1024 1536Q1024 1509 1014 1486Q1004 1463 986.50 1445.50Q969 1428 946 1418Q923 1408 896 1408L896 1408Q869 1408 846 1418Q823 1428 805.50 1445.50Q788 1463 778 1486Q768 1509 768 1536L768 1536Q768 1563 778 1586Q788 1609 805.50 1626.50Q823 1644 846 1654Q869 1664 896 1664ZM1536 1664L1536 1664Q1563 1664 1586 1654Q1609 1644 1626.50 1626.50Q1644 1609 1654 1586Q1664 1563 1664 1536L1664 1536Q1664 1509 1654 1486Q1644 1463 1626.50 1445.50Q1609 1428 1586 1418Q1563 1408 1536 1408L1536 1408Q1509 1408 1486 1418Q1463 1428 1445.50 1445.50Q1428 1463 1418 1486Q1408 1509 1408 1536L1408 1536Q1408 1563 1418 1586Q1428 1609 1445.50 1626.50Q1463 1644 1486 1654Q1509 1664 1536 1664ZM1920 1664L1920 1152L1632 1152Q1587 1152 1554 1142.50Q1521 1133 1496 1119Q1471 1105 1450.50 1088Q1430 1071 1409.50 1057Q1389 1043 1366 1033.50Q1343 1024 1312 1024L1312 1024L896 1024L896 1280Q949 1280 995.50 1300Q1042 1320 1077 1355Q1112 1390 1132 1436.50Q1152 1483 1152 1536L1152 1536Q1152 1585 1133.50 1631Q1115 1677 1081 1712L1081 1712Q1164 1758 1216 1836L1216 1836Q1268 1758 1351 1712L1351 1712Q1317 1677 1298.50 1631Q1280 1585 1280 1536L1280 1536Q1280 1483 1300 1436.50Q1320 1390 1355 1355Q1390 1320 1436.50 1300Q1483 1280 1536 1280L1536 1280Q1589 1280 1635.50 1300Q1682 1320 1717 1355Q1752 1390 1772 1436.50Q1792 1483 1792 1536L1792 1536Q1792 1570 1782.50 1602.50Q1773 1635 1756 1664L1756 1664L1920 1664ZM1920 1024L1920 896L1632 896Q1609 896 1591 901Q1573 906 1557 914.50Q1541 923 1525.50 934.50Q1510 946 1494 960L1494 960Q1510 974 1525.50 985.50Q1541 997 1557 1005.50Q1573 1014 1591 1019Q1609 1024 1632 1024L1632 1024L1920 1024Z"
         }
      }
   ]
}

var ProductionFloorManagement = {
   name: "ProductionFloorManagement",
   vendor: "UiFabric",
   unicode: 60969,
   value: "",
   charCode: "EE29",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 384L640 768L256 768L256 384L640 384ZM1152 384L1152 768L768 768L768 384L1152 384ZM1024 640L1024 512L896 512L896 640L1024 640ZM1664 384L1664 768L1280 768L1280 384L1664 384ZM1536 640L1536 512L1408 512L1408 640L1536 640ZM1408 1280L1408 1280Q1408 1253 1418 1230Q1428 1207 1445.50 1189.50Q1463 1172 1486 1162Q1509 1152 1536 1152L1536 1152Q1563 1152 1586 1162Q1609 1172 1626.50 1189.50Q1644 1207 1654 1230Q1664 1253 1664 1280L1664 1280Q1664 1307 1654 1330Q1644 1353 1626.50 1370.50Q1609 1388 1586 1398Q1563 1408 1536 1408L1536 1408Q1509 1408 1486 1398Q1463 1388 1445.50 1370.50Q1428 1353 1418 1330Q1408 1307 1408 1280ZM256 1280L256 1280Q256 1253 266 1230Q276 1207 293.50 1189.50Q311 1172 334 1162Q357 1152 384 1152L384 1152Q411 1152 434 1162Q457 1172 474.50 1189.50Q492 1207 502 1230Q512 1253 512 1280L512 1280Q512 1307 502 1330Q492 1353 474.50 1370.50Q457 1388 434 1398Q411 1408 384 1408L384 1408Q357 1408 334 1398Q311 1388 293.50 1370.50Q276 1353 266 1330Q256 1307 256 1280ZM640 1280L640 1280Q640 1253 650 1230Q660 1207 677.50 1189.50Q695 1172 718 1162Q741 1152 768 1152L768 1152Q795 1152 818 1162Q841 1172 858.50 1189.50Q876 1207 886 1230Q896 1253 896 1280L896 1280Q896 1307 886 1330Q876 1353 858.50 1370.50Q841 1388 818 1398Q795 1408 768 1408L768 1408Q741 1408 718 1398Q695 1388 677.50 1370.50Q660 1353 650 1330Q640 1307 640 1280ZM1280 1280L1280 1280Q1280 1307 1270 1330Q1260 1353 1242.50 1370.50Q1225 1388 1202 1398Q1179 1408 1152 1408L1152 1408Q1125 1408 1102 1398Q1079 1388 1061.50 1370.50Q1044 1353 1034 1330Q1024 1307 1024 1280L1024 1280Q1024 1253 1034 1230Q1044 1207 1061.50 1189.50Q1079 1172 1102 1162Q1125 1152 1152 1152L1152 1152Q1179 1152 1202 1162Q1225 1172 1242.50 1189.50Q1260 1207 1270 1230Q1280 1253 1280 1280ZM128 1280L128 1280Q128 1333 148 1379.50Q168 1426 203 1461Q238 1496 284.50 1516Q331 1536 384 1536L384 1536L1024 1536L1024 1664L384 1664Q305 1664 235 1633.50Q165 1603 113 1551Q61 1499 30.50 1429Q0 1359 0 1280L0 1280Q0 1201 30.50 1131Q61 1061 113 1009Q165 957 235 926.50Q305 896 384 896L384 896L1536 896Q1607 896 1671 921Q1735 946 1785.50 989.50Q1836 1033 1869.50 1092.50Q1903 1152 1914 1222L1914 1222L1779 1357Q1785 1338 1788.50 1319Q1792 1300 1792 1280L1792 1280Q1792 1227 1772 1180.50Q1752 1134 1717 1099Q1682 1064 1635.50 1044Q1589 1024 1536 1024L1536 1024L384 1024Q331 1024 284.50 1044Q238 1064 203 1099Q168 1134 148 1180.50Q128 1227 128 1280ZM1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363Z"
         }
      }
   ]
}

var ReplyMirrored = {
   name: "ReplyMirrored",
   vendor: "UiFabric",
   unicode: 60981,
   value: "",
   charCode: "EE35",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1547 640L870 640Q742 640 625 688Q508 736 417 827L417 827Q326 918 278 1035Q230 1152 230 1280L230 1280Q230 1413 280 1529.50Q330 1646 417 1733Q504 1820 620.50 1870Q737 1920 870 1920L870 1920L870 1792Q764 1792 671 1751.50Q578 1711 508.50 1641.50Q439 1572 398.50 1479Q358 1386 358 1280L358 1280Q358 1174 398.50 1081Q439 988 508.50 918.50Q578 849 671 808.50Q764 768 870 768L870 768L1547 768L1145 1171L1235 1261L1792 704L1235 147L1145 237L1547 640Z"
         }
      }
   ]
}

var ReplyAllMirrored = {
   name: "ReplyAllMirrored",
   vendor: "UiFabric",
   unicode: 60982,
   value: "",
   charCode: "EE36",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1291 640L742 640Q614 640 497 688Q380 736 289 827L289 827Q198 918 150 1035Q102 1152 102 1280L102 1280Q102 1413 152 1529.50Q202 1646 289 1733Q376 1820 492.50 1870Q609 1920 742 1920L742 1920L742 1792Q636 1792 543 1751.50Q450 1711 380.50 1641.50Q311 1572 270.50 1479Q230 1386 230 1280L230 1280Q230 1174 270.50 1081Q311 988 380.50 918.50Q450 849 543 808.50Q636 768 742 768L742 768L1291 768L889 1171L979 1261L1536 704L979 147L889 237L1291 640ZM1401 237L1868 704L1401 1171L1491 1261L2048 704L1491 147L1401 237Z"
         }
      }
   ]
}

var Medal = {
   name: "Medal",
   vendor: "UiFabric",
   unicode: 60984,
   value: "",
   charCode: "EE38",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 256L2048 256Q2048 323 2028 376.50Q2008 430 1972 485L1972 485L1456 1260Q1495 1322 1515.50 1392.50Q1536 1463 1536 1536L1536 1536Q1536 1642 1496 1735.50Q1456 1829 1386.50 1898.50Q1317 1968 1223.50 2008Q1130 2048 1024 2048L1024 2048Q918 2048 824.50 2008Q731 1968 661.50 1898.50Q592 1829 552 1735.50Q512 1642 512 1536L512 1536Q512 1463 532.50 1392.50Q553 1322 592 1260L592 1260L76 485Q40 430 20 376.50Q0 323 0 256L0 256Q0 203 20 156.50Q40 110 75 75Q110 40 156.50 20Q203 0 256 0L256 0L1792 0Q1845 0 1891.50 20Q1938 40 1973 75Q2008 110 2028 156.50Q2048 203 2048 256ZM1406 384L1576 128L472 128L642 384L1406 384ZM1320 512L728 512L1024 957L1320 512ZM128 256L128 256Q128 302 142 338Q156 374 181 412L181 412L679 1158Q730 1111 791.50 1079.50Q853 1048 922 1034L922 1034L318 128L256 128Q229 128 206 138Q183 148 165.50 165.50Q148 183 138 206Q128 229 128 256ZM1024 1920L1024 1920Q1103 1920 1173 1890Q1243 1860 1295.50 1807.50Q1348 1755 1378 1685.50Q1408 1616 1408 1536L1408 1536Q1408 1457 1378 1387Q1348 1317 1295.50 1264.50Q1243 1212 1173 1182Q1103 1152 1024 1152L1024 1152Q944 1152 874.50 1182Q805 1212 752.50 1264.50Q700 1317 670 1387Q640 1457 640 1536L640 1536Q640 1616 670 1685.50Q700 1755 752.50 1807.50Q805 1860 874.50 1890Q944 1920 1024 1920ZM1868 411L1868 410Q1893 376 1906.50 337Q1920 298 1920 256L1920 256Q1920 229 1910 206Q1900 183 1882.50 165.50Q1865 148 1842 138Q1819 128 1792 128L1792 128L1730 128L1126 1034Q1195 1048 1256.50 1079.50Q1318 1111 1369 1158L1369 1158L1868 411Z"
         }
      }
   ]
}

var AddGroup = {
   name: "AddGroup",
   vendor: "UiFabric",
   unicode: 60989,
   value: "",
   charCode: "EE3D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1250 1333L1250 1333Q1318 1367 1373 1418.50Q1428 1470 1466 1536L1466 1536L1309 1536Q1255 1475 1180.50 1441.50Q1106 1408 1024 1408L1024 1408Q944 1408 874.50 1438Q805 1468 752.50 1520.50Q700 1573 670 1643Q640 1713 640 1792L640 1792L512 1792Q512 1719 532 1650.50Q552 1582 589.50 1522Q627 1462 680 1414Q733 1366 798 1333L798 1333Q723 1279 681.50 1197.50Q640 1116 640 1024L640 1024Q640 971 620 924.50Q600 878 565 843Q530 808 483.50 788Q437 768 384 768L384 768Q331 768 284.50 788Q238 808 203 843Q168 878 148 924.50Q128 971 128 1024L128 1024L0 1024Q0 972 14 922Q28 872 53.50 828.50Q79 785 116 749Q153 713 199 688L199 688Q165 653 146.50 607Q128 561 128 512L128 512Q128 459 148 412.50Q168 366 203 331Q238 296 284.50 276Q331 256 384 256L384 256Q437 256 483.50 276Q530 296 565 331Q600 366 620 412.50Q640 459 640 512L640 512Q640 561 621.50 607Q603 653 569 688L569 688Q611 711 644.50 743Q678 775 704 813L704 813Q731 773 766 741Q801 709 842 686.50Q883 664 929.50 652Q976 640 1024 640L1024 640Q1072 640 1118 652Q1164 664 1205.50 686.50Q1247 709 1282 741Q1317 773 1344 813L1344 813Q1370 775 1403.50 743Q1437 711 1479 688L1479 688Q1445 653 1426.50 607Q1408 561 1408 512L1408 512Q1408 459 1428 412.50Q1448 366 1483 331Q1518 296 1564.50 276Q1611 256 1664 256L1664 256Q1717 256 1763.50 276Q1810 296 1845 331Q1880 366 1900 412.50Q1920 459 1920 512L1920 512Q1920 561 1901.50 607Q1883 653 1849 688L1849 688Q1895 713 1932 749Q1969 785 1994.50 828.50Q2020 872 2034 922Q2048 972 2048 1024L2048 1024L1920 1024Q1920 971 1900 924.50Q1880 878 1845 843Q1810 808 1763.50 788Q1717 768 1664 768L1664 768Q1611 768 1564.50 788Q1518 808 1483 843Q1448 878 1428 924.50Q1408 971 1408 1024L1408 1024Q1408 1116 1366.50 1197.50Q1325 1279 1250 1333ZM1664 384L1664 384Q1637 384 1614 394Q1591 404 1573.50 421.50Q1556 439 1546 462Q1536 485 1536 512L1536 512Q1536 539 1546 562Q1556 585 1573.50 602.50Q1591 620 1614 630Q1637 640 1664 640L1664 640Q1691 640 1714 630Q1737 620 1754.50 602.50Q1772 585 1782 562Q1792 539 1792 512L1792 512Q1792 485 1782 462Q1772 439 1754.50 421.50Q1737 404 1714 394Q1691 384 1664 384ZM384 640L384 640Q411 640 434 630Q457 620 474.50 602.50Q492 585 502 562Q512 539 512 512L512 512Q512 485 502 462Q492 439 474.50 421.50Q457 404 434 394Q411 384 384 384L384 384Q357 384 334 394Q311 404 293.50 421.50Q276 439 266 462Q256 485 256 512L256 512Q256 539 266 562Q276 585 293.50 602.50Q311 620 334 630Q357 640 384 640ZM1024 1280L1024 1280Q1077 1280 1123.50 1260Q1170 1240 1205 1205Q1240 1170 1260 1123.50Q1280 1077 1280 1024L1280 1024Q1280 971 1260 924.50Q1240 878 1205 843Q1170 808 1123.50 788Q1077 768 1024 768L1024 768Q971 768 924.50 788Q878 808 843 843Q808 878 788 924.50Q768 971 768 1024L768 1024Q768 1077 788 1123.50Q808 1170 843 1205Q878 1240 924.50 1260Q971 1280 1024 1280ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408Z"
         }
      }
   ]
}

var QuestionnaireMirrored = {
   name: "QuestionnaireMirrored",
   vendor: "UiFabric",
   unicode: 61003,
   value: "",
   charCode: "EE4B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM1664 1920L1664 640L1152 640L1152 128L256 128L256 1920L1664 1920ZM1152 1280L1152 896L1536 896L1536 1280L1152 1280ZM1280 1024L1280 1152L1408 1152L1408 1024L1280 1024ZM384 1152L384 1024L1024 1024L1024 1152L384 1152ZM384 640L384 512L1024 512L1024 640L384 640ZM1152 1792L1152 1408L1536 1408L1536 1792L1152 1792ZM1280 1536L1280 1664L1408 1664L1408 1536L1280 1536ZM384 1664L384 1536L1024 1536L1024 1664L384 1664Z"
         }
      }
   ]
}

var CloudImportExport = {
   name: "CloudImportExport",
   vendor: "UiFabric",
   unicode: 61013,
   value: "",
   charCode: "EE55",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1629 769L1629 769Q1717 775 1793.50 812Q1870 849 1926.50 909.50Q1983 970 2015.50 1049Q2048 1128 2048 1216L2048 1216Q2048 1309 2012.50 1390.50Q1977 1472 1916.50 1532.50Q1856 1593 1774.50 1628.50Q1693 1664 1600 1664L1600 1664L1536 1664L1536 1536L1600 1536Q1666 1536 1724.50 1511Q1783 1486 1826.50 1442.50Q1870 1399 1895 1340.50Q1920 1282 1920 1216L1920 1216Q1920 1150 1895 1091.50Q1870 1033 1826.50 989.50Q1783 946 1724.50 921Q1666 896 1600 896L1600 896Q1582 896 1564.50 898Q1547 900 1530 904L1530 904Q1520 820 1481 748.50Q1442 677 1383 624.50Q1324 572 1248 542Q1172 512 1088 512L1088 512Q1018 512 953 533Q888 554 833.50 592Q779 630 737 683.50Q695 737 670 803L670 803Q595 768 512 768L512 768Q432 768 362.50 798Q293 828 240.50 880.50Q188 933 158 1003Q128 1073 128 1152L128 1152Q128 1213 146.50 1269Q165 1325 198.50 1372.50Q232 1420 279.50 1456Q327 1492 384 1512L384 1512L384 1646Q300 1624 229.50 1577Q159 1530 108 1464.50Q57 1399 28.50 1319Q0 1239 0 1152L0 1152Q0 1046 40.50 953Q81 860 150.50 790.50Q220 721 313 680.50Q406 640 512 640L512 640Q558 640 605 649L605 649Q645 588 698 539Q751 490 813 455.50Q875 421 945 402.50Q1015 384 1088 384L1088 384Q1179 384 1263.50 412Q1348 440 1419.50 490.50Q1491 541 1545 612Q1599 683 1629 769ZM896 1024L896 1701L1043 1555L1133 1645L832 1946L531 1645L621 1555L768 1701L768 1024L896 1024ZM1645 1299L1555 1389L1408 1243L1408 1920L1280 1920L1280 1243L1133 1389L1043 1299L1344 998L1645 1299Z"
         }
      }
   ]
}

var MyMoviesTV = {
   name: "MyMoviesTV",
   vendor: "UiFabric",
   unicode: 61036,
   value: "",
   charCode: "EE6C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M713 896L1920 896L1920 1728Q1920 1768 1905 1803Q1890 1838 1864 1864Q1838 1890 1803 1905Q1768 1920 1728 1920L1728 1920L320 1920Q280 1920 245 1905Q210 1890 184 1864Q158 1838 143 1803Q128 1768 128 1728L128 1728L128 1221Q128 1184 129.50 1154Q131 1124 131.50 1094.50Q132 1065 131.50 1035Q131 1005 128 968L128 968Q126 947 122 929.50Q118 912 113.50 896Q109 880 103.50 863.50Q98 847 93 826L93 826L22 541L1760 107L1884 604L713 896ZM1033 684L681 508L360 588L712 764L1033 684ZM872 461L1224 637L1546 556L1194 381L872 461ZM521 812L178 641L239 882L521 812ZM1727 504L1667 262L1385 333L1727 504ZM1792 1728L1792 1024L256 1024L256 1728Q256 1754 275 1773Q294 1792 320 1792L320 1792L1728 1792Q1754 1792 1773 1773Q1792 1754 1792 1728L1792 1728Z"
         }
      }
   ]
}

var AwayStatus = {
   name: "AwayStatus",
   vendor: "UiFabric",
   unicode: 61034,
   value: "",
   charCode: "EE6A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1536 1152L1536 1024L1024 1024L1024 384L896 384L896 1152L1536 1152Z"
         }
      }
   ]
}

var SortUp = {
   name: "SortUp",
   vendor: "UiFabric",
   unicode: 61032,
   value: "",
   charCode: "EE68",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1453 499L1453 499L1363 589L1025 252L1024 2048L896 2048L897 249L557 589L467 499L960 6L1453 499Z"
         }
      }
   ]
}

var GroupedDescending = {
   name: "GroupedDescending",
   vendor: "UiFabric",
   unicode: 61030,
   value: "",
   charCode: "EE66",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1920L384 1920L384 1792L1920 1792L1920 1920ZM384 1317L384 128L1920 128L1920 256L512 256L512 1317L805 1024L896 1115L448 1562L0 1115L91 1024L384 1317ZM1920 768L1024 768L1024 640L1920 640L1920 768ZM1920 1152L1024 1152L1024 1024L1920 1024L1920 1152ZM1920 1536L1024 1536L1024 1408L1920 1408L1920 1536Z"
         }
      }
   ]
}

var CaretSolid16 = {
   name: "CaretSolid16",
   vendor: "UiFabric",
   unicode: 61026,
   value: "",
   charCode: "EE62",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 2048L2048 0L2048 2048L0 2048Z"
         }
      }
   ]
}

var TemporaryUser = {
   name: "TemporaryUser",
   vendor: "UiFabric",
   unicode: 61016,
   value: "",
   charCode: "EE58",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1024L1536 1024Q1642 1024 1735.50 1064Q1829 1104 1898.50 1173.50Q1968 1243 2008 1336.50Q2048 1430 2048 1536L2048 1536Q2048 1642 2008 1735.50Q1968 1829 1898.50 1898.50Q1829 1968 1735.50 2008Q1642 2048 1536 2048L1536 2048Q1430 2048 1336.50 2008Q1243 1968 1173.50 1898.50Q1104 1829 1064 1735.50Q1024 1642 1024 1536L1024 1536Q1024 1430 1064 1336.50Q1104 1243 1173.50 1173.50Q1243 1104 1336.50 1064Q1430 1024 1536 1024ZM1536 1920L1536 1920Q1615 1920 1685 1890Q1755 1860 1807.50 1807.50Q1860 1755 1890 1685.50Q1920 1616 1920 1536L1920 1536Q1920 1457 1890 1387Q1860 1317 1807.50 1264.50Q1755 1212 1685 1182Q1615 1152 1536 1152L1536 1152Q1456 1152 1386.50 1182Q1317 1212 1264.50 1264.50Q1212 1317 1182 1387Q1152 1457 1152 1536L1152 1536Q1152 1616 1182 1685.50Q1212 1755 1264.50 1807.50Q1317 1860 1386.50 1890Q1456 1920 1536 1920ZM1536 1280L1536 1536L1728 1536L1728 1664L1408 1664L1408 1280L1536 1280ZM1170 1012L1170 1012Q1142 1032 1117 1054Q1092 1076 1069 1101L1069 1101Q1000 1064 923.50 1044Q847 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q383 872 319.50 760Q256 648 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760.50Q1185 817 1140 864.50Q1095 912 1039 946L1039 946Q1109 974 1170 1012ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512Z"
         }
      }
   ]
}

var GroupedAscending = {
   name: "GroupedAscending",
   vendor: "UiFabric",
   unicode: 61031,
   value: "",
   charCode: "EE67",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 256L384 128L1920 128L1920 256L384 256ZM805 1024L512 731L512 1792L1920 1792L1920 1920L384 1920L384 731L91 1024L0 933L448 486L896 933L805 1024ZM1920 1408L1024 1408L1024 1280L1920 1280L1920 1408ZM1920 1024L1024 1024L1024 896L1920 896L1920 1024ZM1920 640L1024 640L1024 512L1920 512L1920 640Z"
         }
      }
   ]
}

var SortDown = {
   name: "SortDown",
   vendor: "UiFabric",
   unicode: 61033,
   value: "",
   charCode: "EE69",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1364 1459L1364 1459L1455 1549L962 2042L468 1549L559 1459L897 1797L896 3L1024 3L1025 1798L1364 1459Z"
         }
      }
   ]
}

var SyncToPC = {
   name: "SyncToPC",
   vendor: "UiFabric",
   unicode: 61038,
   value: "",
   charCode: "EE6E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L2048 256L2048 768L1536 768L1536 640L1852 640Q1793 523 1705.50 428.50Q1618 334 1510 267.50Q1402 201 1278.50 164.50Q1155 128 1024 128L1024 128Q870 128 728.50 175.50Q587 223 470.50 309.50Q354 396 267.50 517.50Q181 639 136 787L136 787L14 749Q64 583 163 445Q262 307 395.50 208Q529 109 689.50 54.50Q850 0 1024 0L1024 0Q1161 0 1291 34Q1421 68 1536.50 132.50Q1652 197 1750 289.50Q1848 382 1920 499L1920 499L1920 256ZM511 1408L196 1408Q255 1525 342.50 1619.50Q430 1714 538 1780.50Q646 1847 769.50 1883.50Q893 1920 1024 1920L1024 1920L1152 1920L1152 2038Q1120 2042 1088 2045Q1056 2048 1024 2048L1024 2048Q888 2048 758 2013.50Q628 1979 512 1914Q396 1849 298 1757Q200 1665 128 1549L128 1549L128 1792L0 1792L0 1280L511 1280L511 1408ZM1152 1792L1152 1152L2048 1152L2048 1792L1664 1792L1664 1920L1791 1920L1791 2048L1408 2048L1408 1920L1536 1920L1536 1792L1152 1792ZM1280 1280L1280 1664L1920 1664L1920 1280L1280 1280Z"
         }
      }
   ]
}

var WifiEthernet = {
   name: "WifiEthernet",
   vendor: "UiFabric",
   unicode: 61047,
   value: "",
   charCode: "EE77",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1792L1408 1792Q1435 1792 1458 1802Q1481 1812 1498.50 1829.50Q1516 1847 1526 1870Q1536 1893 1536 1920L1536 1920Q1536 1947 1526 1970Q1516 1993 1498.50 2010.50Q1481 2028 1458 2038Q1435 2048 1408 2048L1408 2048Q1381 2048 1358 2038Q1335 2028 1317.50 2010.50Q1300 1993 1290 1970Q1280 1947 1280 1920L1280 1920Q1280 1893 1290 1870Q1300 1847 1317.50 1829.50Q1335 1812 1358 1802Q1381 1792 1408 1792ZM1024 2048L896 2048Q896 1915 946 1798.50Q996 1682 1083 1595Q1170 1508 1286.50 1458Q1403 1408 1536 1408L1536 1408L1536 1536Q1430 1536 1337 1576.50Q1244 1617 1174.50 1686.50Q1105 1756 1064.50 1849Q1024 1942 1024 2048L1024 2048ZM640 2048L512 2048Q512 1907 548.50 1776Q585 1645 651.50 1531Q718 1417 811.50 1323.50Q905 1230 1019 1163.50Q1133 1097 1263.50 1060.50Q1394 1024 1536 1024L1536 1024L1536 1152Q1412 1152 1298 1184Q1184 1216 1084.50 1274.50Q985 1333 903 1415Q821 1497 762.50 1596.50Q704 1696 672 1810.50Q640 1925 640 2048L640 2048ZM2048 128L2048 896L1792 896L1792 2048L1664 2048L1664 896L1408 896L1408 128L2048 128ZM1920 256L1536 256L1536 384L1920 384L1920 256ZM1536 768L1920 768L1920 512L1792 512L1792 640L1664 640L1664 512L1536 512L1536 768ZM1280 664L1280 794Q1131 825 997.50 887.50Q864 950 750 1038.50Q636 1127 544.50 1239Q453 1351 389 1480Q325 1609 290.50 1752.50Q256 1896 256 2048L256 2048L128 2048Q128 1879 167 1719Q206 1559 278.50 1415.50Q351 1272 454 1148.50Q557 1025 685 927.50Q813 830 963 762.50Q1113 695 1280 664L1280 664Z"
         }
      }
   ]
}

var AustralianRules = {
   name: "AustralianRules",
   vendor: "UiFabric",
   unicode: 61040,
   value: "",
   charCode: "EE70",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L1536 0Q1642 0 1735.50 40Q1829 80 1898.50 149.50Q1968 219 2008 312.50Q2048 406 2048 512L2048 512Q2048 724 1993 920Q1938 1116 1838 1287Q1738 1458 1598 1598Q1458 1738 1287 1838Q1116 1938 920 1993Q724 2048 512 2048L512 2048Q406 2048 312.50 2008Q219 1968 149.50 1898.50Q80 1829 40 1735.50Q0 1642 0 1536L0 1536Q0 1324 55 1128Q110 932 210 761Q310 590 450 450Q590 310 761 210Q932 110 1128 55Q1324 0 1536 0ZM1536 128L1536 128Q1342 128 1162.50 178.50Q983 229 826.50 320.50Q670 412 541 541Q412 670 320.50 826.50Q229 983 178.50 1162.50Q128 1342 128 1536L128 1536Q128 1596 146 1653Q164 1710 199 1758L199 1758L646 1312L563 1229Q544 1210 544 1184L544 1184Q544 1158 563 1139Q582 1120 608 1120L608 1120Q634 1120 653 1139L653 1139L736 1221L837 1120L755 1037Q736 1018 736 992L736 992Q736 966 755 947Q774 928 800 928L800 928Q826 928 845 947L845 947L928 1030L1030 928L947 845Q928 826 928 800L928 800Q928 774 947 755Q966 736 992 736L992 736Q1018 736 1037 755L1037 755L1120 837L1221 736L1139 653Q1120 634 1120 608L1120 608Q1120 582 1139 563Q1158 544 1184 544L1184 544Q1210 544 1229 563L1229 563L1312 646L1758 199Q1710 164 1653 146Q1596 128 1536 128ZM512 1920L512 1920Q706 1920 885.50 1869.50Q1065 1819 1221.50 1727.50Q1378 1636 1507 1507Q1636 1378 1727.50 1221.50Q1819 1065 1869.50 885.50Q1920 706 1920 512L1920 512Q1920 452 1902 395Q1884 338 1849 290L1849 290L1402 736L1485 819Q1504 838 1504 864L1504 864Q1504 890 1485 909Q1466 928 1440 928L1440 928Q1426 928 1415.50 923Q1405 918 1395 909L1395 909L1312 827L1211 928L1293 1011Q1312 1030 1312 1056L1312 1056Q1312 1082 1293 1101Q1274 1120 1248 1120L1248 1120Q1222 1120 1203 1101L1203 1101L1120 1018L1018 1120L1101 1203Q1120 1222 1120 1248L1120 1248Q1120 1274 1101 1293Q1082 1312 1056 1312L1056 1312Q1042 1312 1031.50 1307Q1021 1302 1011 1293L1011 1293L928 1211L827 1312L909 1395Q928 1414 928 1440L928 1440Q928 1466 909 1485Q890 1504 864 1504L864 1504Q838 1504 819 1485L819 1485L736 1402L290 1849Q338 1884 395 1902Q452 1920 512 1920Z"
         }
      }
   ]
}

var GenericScan = {
   name: "GenericScan",
   vendor: "UiFabric",
   unicode: 61039,
   value: "",
   charCode: "EE6F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 640L0 640L0 128L512 128L512 256L128 256L128 640ZM0 1408L128 1408L128 1792L512 1792L512 1920L0 1920L0 1408ZM1536 1792L1920 1792L1920 1408L2048 1408L2048 1920L1536 1920L1536 1792ZM1536 256L1536 128L2048 128L2048 640L1920 640L1920 256L1536 256ZM512 1408L384 1408L384 640L512 640L512 1408ZM896 1408L768 1408L768 640L896 640L896 1408ZM1280 1408L1152 1408L1152 640L1280 640L1280 1408ZM1536 640L1664 640L1664 1408L1536 1408L1536 640Z"
         }
      }
   ]
}

var CalendarAgenda = {
   name: "CalendarAgenda",
   vendor: "UiFabric",
   unicode: 61082,
   value: "",
   charCode: "EE9A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM384 384L384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384ZM128 640L128 1792L1920 1792L1920 640L128 640ZM1664 1024L384 1024L384 896L1664 896L1664 1024ZM1664 1408L384 1408L384 1280L1664 1280L1664 1408Z"
         }
      }
   ]
}

var DoubleChevronLeft12 = {
   name: "DoubleChevronLeft12",
   vendor: "UiFabric",
   unicode: 61080,
   value: "",
   charCode: "EE98",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1049 25L1170 146L291 1024L1170 1902L1049 2023L50 1024L1049 25ZM1902 25L2023 146L1145 1024L2023 1902L1902 2023L903 1024L1902 25Z"
         }
      }
   ]
}

var DoubleChevronUp12 = {
   name: "DoubleChevronUp12",
   vendor: "UiFabric",
   unicode: 61078,
   value: "",
   charCode: "EE96",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1902 1170L1024 291L146 1170L25 1049L1024 50L2023 1049L1902 1170ZM146 2023L25 1902L1024 903L2023 1902L1902 2023L1024 1145L146 2023Z"
         }
      }
   ]
}

var DoubleChevronDown12 = {
   name: "DoubleChevronDown12",
   vendor: "UiFabric",
   unicode: 61079,
   value: "",
   charCode: "EE97",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M146 878L1024 1757L1902 878L2023 999L1024 1998L25 999L146 878ZM1902 25L2023 146L1024 1145L25 146L146 25L1024 903L1902 25Z"
         }
      }
   ]
}

var DoubleChevronRight12 = {
   name: "DoubleChevronRight12",
   vendor: "UiFabric",
   unicode: 61081,
   value: "",
   charCode: "EE99",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M878 146L999 25L1998 1024L999 2023L878 1902L1757 1024L878 146ZM25 146L146 25L1145 1024L146 2023L25 1902L903 1024L25 146Z"
         }
      }
   ]
}

var ConnectVirtualMachine = {
   name: "ConnectVirtualMachine",
   vendor: "UiFabric",
   unicode: 61085,
   value: "",
   charCode: "EE9D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 128L1792 1280L1024 1280L1024 1408L1152 1408L1152 1536L1408 1536L1408 1664L1792 1664L1792 1792L1408 1792L1408 1920L512 1920L512 1792L128 1792L128 1664L512 1664L512 1536L768 1536L768 1408L896 1408L896 1280L128 1280L128 128L1792 128ZM1280 1792L1280 1664L1024 1664L1024 1536L896 1536L896 1664L640 1664L640 1792L1280 1792ZM256 256L256 1152L1664 1152L1664 256L256 256Z"
         }
      }
   ]
}

var IssueTrackingMirrored = {
   name: "IssueTrackingMirrored",
   vendor: "UiFabric",
   unicode: 61121,
   value: "",
   charCode: "EEC1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 2048L256 0L1792 0L1792 2048L256 2048ZM384 1920L1664 1920L1664 128L384 128L384 1920ZM512 512L1024 512L1024 640L512 640L512 512ZM512 1024L1024 1024L1024 1152L512 1152L512 1024ZM512 1536L1024 1536L1024 1664L512 1664L512 1536ZM1427 339L1517 429L1280 666L1107 493L1197 403L1280 486L1427 339ZM1427 851L1517 941L1280 1178L1107 1005L1197 915L1280 998L1427 851ZM1427 1363L1517 1453L1280 1690L1107 1517L1197 1427L1280 1510L1427 1363Z"
         }
      }
   ]
}

var CustomListMirrored = {
   name: "CustomListMirrored",
   vendor: "UiFabric",
   unicode: 61119,
   value: "",
   charCode: "EEBF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 2048L1792 0L256 0L256 2048L1792 2048ZM1664 1920L384 1920L384 128L1664 128L1664 1920ZM1280 384L512 384L512 512L1280 512L1280 384ZM1280 768L640 768L640 896L1280 896L1280 768ZM1280 1152L896 1152L896 1280L1280 1280L1280 1152ZM1280 1536L512 1536L512 1664L1280 1664L1280 1536ZM1536 384L1408 384L1408 512L1536 512L1536 384ZM1536 768L1408 768L1408 896L1536 896L1536 768ZM1536 1152L1408 1152L1408 1280L1536 1280L1536 1152ZM1536 1536L1408 1536L1408 1664L1536 1664L1536 1536Z"
         }
      }
   ]
}

var ContactCard = {
   name: "ContactCard",
   vendor: "UiFabric",
   unicode: 61117,
   value: "",
   charCode: "EEBD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 768L1792 896L1152 896L1152 768L1792 768ZM1536 1152L1536 1280L1152 1280L1152 1152L1536 1152ZM0 256L2048 256L2048 1792L0 1792L0 256ZM1920 1664L1920 384L128 384L128 1664L1920 1664ZM640 1152L640 1152Q587 1152 540.50 1172Q494 1192 459 1227Q424 1262 404 1308.50Q384 1355 384 1408L384 1408L256 1408Q256 1356 270 1306.50Q284 1257 309.50 1213.50Q335 1170 371.50 1134Q408 1098 454 1072L454 1072Q421 1037 402.50 991Q384 945 384 896L384 896Q384 843 404 796.50Q424 750 459 715Q494 680 540.50 660Q587 640 640 640L640 640Q693 640 739.50 660Q786 680 821 715Q856 750 876 796.50Q896 843 896 896L896 896Q896 945 877.50 991Q859 1037 826 1072L826 1072Q872 1098 908.50 1134Q945 1170 970.50 1213.50Q996 1257 1010 1306.50Q1024 1356 1024 1408L1024 1408L896 1408Q896 1355 876 1308.50Q856 1262 821 1227Q786 1192 739.50 1172Q693 1152 640 1152ZM512 896L512 896Q512 923 522 946Q532 969 549.50 986.50Q567 1004 590 1014Q613 1024 640 1024L640 1024Q667 1024 690 1014Q713 1004 730.50 986.50Q748 969 758 946Q768 923 768 896L768 896Q768 869 758 846Q748 823 730.50 805.50Q713 788 690 778Q667 768 640 768L640 768Q613 768 590 778Q567 788 549.50 805.50Q532 823 522 846Q512 869 512 896Z"
         }
      }
   ]
}

var ReportLibrary = {
   name: "ReportLibrary",
   vendor: "UiFabric",
   unicode: 61115,
   value: "",
   charCode: "EEBB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 768L1920 768L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L256 1664L256 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM384 896L2048 896L2048 2048L384 2048L384 896ZM1920 1920L1920 1024L512 1024L512 1920L1920 1920ZM1792 1152L1792 1280L1408 1280L1408 1152L1792 1152ZM1664 1408L1664 1536L1408 1536L1408 1408L1664 1408ZM1664 1664L1664 1792L1408 1792L1408 1664L1664 1664ZM1280 1152L1280 1792L640 1792L640 1152L1280 1152ZM1152 1664L1152 1280L768 1280L768 1664L1152 1664Z"
         }
      }
   ]
}

var FormLibrary = {
   name: "FormLibrary",
   vendor: "UiFabric",
   unicode: 61113,
   value: "",
   charCode: "EEB9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 835L1920 707L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L768 1664L768 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM896 640L1627 640L2048 1061L2048 2048L896 2048L896 640ZM1664 859L1664 1024L1829 1024L1664 859ZM1920 1920L1920 1152L1536 1152L1536 768L1024 768L1024 1920L1920 1920ZM1152 1792L1152 1664L1664 1664L1664 1792L1152 1792ZM1408 1408L1408 1536L1152 1536L1152 1408L1408 1408ZM1408 1152L1408 1280L1152 1280L1152 1152L1408 1152ZM1408 896L1408 1024L1152 1024L1152 896L1408 896Z"
         }
      }
   ]
}

var DataConnectionLibrary = {
   name: "DataConnectionLibrary",
   vendor: "UiFabric",
   unicode: 61111,
   value: "",
   charCode: "EEB7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 640L1627 640L2048 1061L2048 2048L896 2048L896 640ZM1664 859L1664 1024L1829 1024L1664 859ZM1024 1920L1920 1920L1920 1152L1536 1152L1536 768L1024 768L1024 1920ZM1152 1792L1152 1280L1280 1280L1280 1792L1152 1792ZM1408 1792L1408 1536L1536 1536L1536 1792L1408 1792ZM1664 1792L1664 1408L1792 1408L1792 1792L1664 1792ZM128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 835L1920 707L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L768 1664L768 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384Z"
         }
      }
   ]
}

var AddEvent = {
   name: "AddEvent",
   vendor: "UiFabric",
   unicode: 61109,
   value: "",
   charCode: "EEB5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM384 384L384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384ZM128 640L128 1792L1920 1792L1920 640L128 640ZM960 768L1088 768L1088 1152L1472 1152L1472 1280L1088 1280L1088 1664L960 1664L960 1280L576 1280L576 1152L960 1152L960 768Z"
         }
      }
   ]
}

var AssetLibrary = {
   name: "AssetLibrary",
   vendor: "UiFabric",
   unicode: 61110,
   value: "",
   charCode: "EEB6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 1024L1920 1024L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L896 1664L896 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM1024 2048L1024 1152L2048 1152L2048 2048L1024 2048ZM1920 1280L1152 1280L1152 1408L1280 1408L1280 1536L1152 1536L1152 1664L1280 1664L1280 1792L1152 1792L1152 1920L1920 1920L1920 1792L1792 1792L1792 1664L1920 1664L1920 1536L1792 1536L1792 1408L1920 1408L1920 1280ZM1147 936L1029 985Q1012 944 976 920Q940 896 896 896L896 896L896 1344Q896 1388 876.50 1423.50Q857 1459 825 1484Q793 1509 753 1522.50Q713 1536 672 1536L672 1536Q631 1536 591 1522.50Q551 1509 519 1484Q487 1459 467.50 1423.50Q448 1388 448 1344L448 1344Q448 1300 467.50 1264.50Q487 1229 519 1204Q551 1179 591 1165.50Q631 1152 672 1152L672 1152Q723 1152 768 1170L768 1170L768 768L896 768Q937 768 975.50 780Q1014 792 1047 814Q1080 836 1105.50 867Q1131 898 1147 936L1147 936ZM672 1408L672 1408Q685 1408 701.50 1404Q718 1400 733 1392Q748 1384 758 1372Q768 1360 768 1344L768 1344Q768 1328 758 1316Q748 1304 733 1296Q718 1288 701.50 1284Q685 1280 672 1280L672 1280Q659 1280 642.50 1284Q626 1288 611 1296Q596 1304 586 1316Q576 1328 576 1344L576 1344Q576 1360 586 1372Q596 1384 611 1392Q626 1400 642.50 1404Q659 1408 672 1408Z"
         }
      }
   ]
}

var DocLibrary = {
   name: "DocLibrary",
   vendor: "UiFabric",
   unicode: 61112,
   value: "",
   charCode: "EEB8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 640L1627 640L2048 1061L2048 2048L896 2048L896 640ZM1664 859L1664 1024L1829 1024L1664 859ZM1024 1920L1920 1920L1920 1152L1536 1152L1536 768L1024 768L1024 1920ZM128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 835L1920 707L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L768 1664L768 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384Z"
         }
      }
   ]
}

var FormLibraryMirrored = {
   name: "FormLibraryMirrored",
   vendor: "UiFabric",
   unicode: 61114,
   value: "",
   charCode: "EEBA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 835L1920 707L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L768 1664L768 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM896 640L1627 640L2048 1061L2048 2048L896 2048L896 640ZM1664 859L1664 1024L1829 1024L1664 859ZM1024 1920L1920 1920L1920 1152L1536 1152L1536 768L1024 768L1024 1920ZM1280 1792L1280 1664L1792 1664L1792 1792L1280 1792ZM1536 1536L1536 1408L1792 1408L1792 1536L1536 1536Z"
         }
      }
   ]
}

var ReportLibraryMirrored = {
   name: "ReportLibraryMirrored",
   vendor: "UiFabric",
   unicode: 61116,
   value: "",
   charCode: "EEBC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 768L1920 768L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L256 1664L256 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM384 896L2048 896L2048 2048L384 2048L384 896ZM1920 1920L1920 1024L512 1024L512 1920L1920 1920ZM1024 1152L1024 1280L640 1280L640 1152L1024 1152ZM768 1536L768 1408L1024 1408L1024 1536L768 1536ZM768 1792L768 1664L1024 1664L1024 1792L768 1792ZM1792 1152L1792 1792L1152 1792L1152 1152L1792 1152ZM1664 1664L1664 1280L1280 1280L1280 1664L1664 1664Z"
         }
      }
   ]
}

var CustomList = {
   name: "CustomList",
   vendor: "UiFabric",
   unicode: 61118,
   value: "",
   charCode: "EEBE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 2048L256 0L1792 0L1792 2048L256 2048ZM384 1920L1664 1920L1664 128L384 128L384 1920ZM768 384L1536 384L1536 512L768 512L768 384ZM768 768L1408 768L1408 896L768 896L768 768ZM768 1152L1152 1152L1152 1280L768 1280L768 1152ZM768 1536L1536 1536L1536 1664L768 1664L768 1536ZM512 384L640 384L640 512L512 512L512 384ZM512 768L640 768L640 896L512 896L512 768ZM512 1152L640 1152L640 1280L512 1280L512 1152ZM512 1536L640 1536L640 1664L512 1664L512 1536Z"
         }
      }
   ]
}

var IssueTracking = {
   name: "IssueTracking",
   vendor: "UiFabric",
   unicode: 61120,
   value: "",
   charCode: "EEC0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 2048L256 0L1792 0L1792 2048L256 2048ZM384 1920L1664 1920L1664 128L384 128L384 1920ZM1024 512L1536 512L1536 640L1024 640L1024 512ZM1024 1024L1536 1024L1536 1152L1024 1152L1024 1024ZM1024 1536L1536 1536L1536 1664L1024 1664L1024 1536ZM851 339L941 429L704 666L531 493L621 403L704 486L851 339ZM851 851L941 941L704 1178L531 1005L621 915L704 998L851 851ZM851 1363L941 1453L704 1690L531 1517L621 1427L704 1510L851 1363Z"
         }
      }
   ]
}

var PictureLibrary = {
   name: "PictureLibrary",
   vendor: "UiFabric",
   unicode: 61122,
   value: "",
   charCode: "EEC2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 896L1920 896L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L512 1664L512 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM640 2048L640 1024L2048 1024L2048 2048L640 2048ZM768 1755L768 1920L1573 1920L1088 1434L768 1755ZM1595 1760L1755 1920L1894 1920L1664 1690L1595 1760ZM1920 1152L768 1152L768 1573L1088 1254L1504 1670L1664 1510L1920 1766L1920 1152ZM1728 1408L1728 1408Q1702 1408 1683 1389Q1664 1370 1664 1344L1664 1344Q1664 1318 1683 1299Q1702 1280 1728 1280L1728 1280Q1754 1280 1773 1299Q1792 1318 1792 1344L1792 1344Q1792 1370 1773 1389Q1754 1408 1728 1408Z"
         }
      }
   ]
}

var DocumentSet = {
   name: "DocumentSet",
   vendor: "UiFabric",
   unicode: 61142,
   value: "",
   charCode: "EED6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 0L1792 1280L1920 1280L1920 2048L128 2048L128 640L256 640L256 256L384 256L384 0L1792 0ZM1664 128L512 128L512 256L1536 256L1536 1280L1664 1280L1664 128ZM1408 384L384 384L384 640L731 640L1371 1280L1408 1280L1408 384ZM256 1920L1792 1920L1792 1408L1317 1408L677 768L256 768L256 1920Z"
         }
      }
   ]
}

var ArrowUpRight8 = {
   name: "ArrowUpRight8",
   vendor: "UiFabric",
   unicode: 61140,
   value: "",
   charCode: "EED4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L256 0L2048 0L2048 1792L1792 1792L1792 437L219 2011L37 1829L1611 256L256 256L256 0Z"
         }
      }
   ]
}

var TriangleLeft12 = {
   name: "TriangleLeft12",
   vendor: "UiFabric",
   unicode: 61138,
   value: "",
   charCode: "EED2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 2048L0 1024L2048 0L2048 2048ZM382 1024L1877 1772L1877 276L382 1024Z"
         }
      }
   ]
}

var TriangleUp12 = {
   name: "TriangleUp12",
   vendor: "UiFabric",
   unicode: 61136,
   value: "",
   charCode: "EED0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L1024 0L2048 2048L0 2048ZM1772 1877L1024 382L276 1877L1772 1877Z"
         }
      }
   ]
}

var TriangleSolidLeft12 = {
   name: "TriangleSolidLeft12",
   vendor: "UiFabric",
   unicode: 61134,
   value: "",
   charCode: "EECE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1024L0 1024L2048 0L2048 2048L0 1024Z"
         }
      }
   ]
}

var TriangleSolidUp12 = {
   name: "TriangleSolidUp12",
   vendor: "UiFabric",
   unicode: 61132,
   value: "",
   charCode: "EECC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0L2048 2048L0 2048L1024 0Z"
         }
      }
   ]
}

var OfflineOneDriveParachute = {
   name: "OfflineOneDriveParachute",
   vendor: "UiFabric",
   unicode: 61128,
   value: "",
   charCode: "EEC8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1408L960 1408Q1026 1408 1084 1433.50Q1142 1459 1185.50 1502.50Q1229 1546 1254.50 1604Q1280 1662 1280 1728L1280 1728Q1280 1794 1254.50 1852.50Q1229 1911 1185.50 1954.50Q1142 1998 1084 2023Q1026 2048 960 2048L960 2048Q894 2048 835.50 2023Q777 1998 733.50 1954.50Q690 1911 665 1852.50Q640 1794 640 1728L640 1728Q640 1662 665 1604Q690 1546 733.50 1502.50Q777 1459 835.50 1433.50Q894 1408 960 1408ZM960 1920L960 1920Q1000 1920 1035 1905Q1070 1890 1096 1864Q1122 1838 1137 1803Q1152 1768 1152 1728L1152 1728Q1152 1688 1137 1653Q1122 1618 1096 1592Q1070 1566 1035 1551Q1000 1536 960 1536L960 1536Q920 1536 885 1551Q850 1566 824 1592Q798 1618 783 1653Q768 1688 768 1728L768 1728Q768 1768 783 1803Q798 1838 824 1864Q850 1890 885 1905Q920 1920 960 1920ZM960 0L960 0Q1092 0 1214.50 34.50Q1337 69 1444 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 476Q1851 583 1885.50 705.50Q1920 828 1920 960L1920 960L1920 991L1324 1468Q1305 1442 1283 1418.50Q1261 1395 1235 1375L1235 1375L1783 936Q1693 901 1598.50 882.50Q1504 864 1407 864L1407 864Q1308 864 1211.50 883Q1115 902 1024 939L1024 939L1024 1285Q1008 1283 992 1281.50Q976 1280 960 1280L960 1280Q944 1280 928 1281.50Q912 1283 896 1285L896 1285L896 940Q711 864 511 864L511 864Q414 864 320.50 882.50Q227 901 137 936L137 936L685 1375Q659 1395 637 1418.50Q615 1442 596 1468L596 1468L0 991L0 960Q0 828 34.50 705.50Q69 583 131.50 476Q194 369 281.50 281.50Q369 194 476 131.50Q583 69 705.50 34.50Q828 0 960 0ZM960 827L968 824Q1075 782 1182.50 759Q1290 736 1405 736L1405 736Q1595 736 1775 798L1775 798Q1746 653 1671 530Q1596 407 1487.50 317.50Q1379 228 1243.50 178Q1108 128 960 128L960 128Q811 128 676 178Q541 228 432.50 317Q324 406 249 529Q174 652 145 797L145 797Q326 736 514 736L514 736Q569 736 626.50 741.50Q684 747 741.50 758.50Q799 770 854.50 787Q910 804 960 827L960 827Z"
         }
      }
   ]
}

var OfficeAddinsLogo = {
   name: "OfficeAddinsLogo",
   vendor: "UiFabric",
   unicode: 61127,
   value: "",
   charCode: "EEC7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1728L128 1216L512 1024L896 1216L896 1728L512 1920L128 1728ZM384 512L1152 128L1920 512L1920 1536L1152 1920L1024 1856L1024 1120L512 864L384 928L384 512Z"
         }
      }
   ]
}

var OfflineOneDriveParachuteDisabled = {
   name: "OfflineOneDriveParachuteDisabled",
   vendor: "UiFabric",
   unicode: 61129,
   value: "",
   charCode: "EEC9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1421L960 1421Q1023 1421 1079 1445Q1135 1469 1177 1511Q1219 1553 1243 1609Q1267 1665 1267 1728L1267 1728Q1267 1791 1243 1847Q1219 1903 1177 1945Q1135 1987 1079 2011Q1023 2035 960 2035L960 2035Q897 2035 841 2011Q785 1987 743 1945Q701 1903 677 1847Q653 1791 653 1728L653 1728Q653 1665 677 1609Q701 1553 743 1511Q785 1469 841 1445Q897 1421 960 1421ZM960 1933L960 1933Q1002 1933 1039.50 1917Q1077 1901 1105 1873Q1133 1845 1149 1807.50Q1165 1770 1165 1728L1165 1728Q1165 1686 1149 1648.50Q1133 1611 1105 1583Q1077 1555 1039.50 1539Q1002 1523 960 1523L960 1523Q918 1523 880.50 1539Q843 1555 815 1583Q787 1611 771 1648.50Q755 1686 755 1728L755 1728Q755 1770 771 1807.50Q787 1845 815 1873Q843 1901 880.50 1917Q918 1933 960 1933ZM1596 1250L2029 1683L1939 1773L275 109L365 19L478 131Q588 67 710 33.50Q832 0 960 0L960 0Q1092 0 1214.50 34.50Q1337 69 1444 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 476Q1851 583 1885.50 705.50Q1920 828 1920 960L1920 960L1920 991L1596 1250ZM1505 1159L1783 936Q1693 901 1599 883Q1505 865 1408 865L1408 865Q1362 865 1317 869Q1272 873 1227 881L1227 881L1505 1159ZM960 128L960 128Q858 128 760 152.50Q662 177 572 225L572 225L1120 774Q1191 756 1262.50 746.50Q1334 737 1407 737L1407 737Q1501 737 1593.50 752.50Q1686 768 1775 798L1775 798Q1746 653 1671 530Q1596 407 1487.50 317.50Q1379 228 1243.50 178Q1108 128 960 128ZM137 936L685 1375Q659 1395 637 1418.50Q615 1442 596 1468L596 1468L0 991Q0 792 63 618.50Q126 445 265 299L265 299L356 390Q276 475 222 578.50Q168 682 145 797L145 797Q233 768 324.50 752.50Q416 737 510 737L510 737Q564 737 616.50 742Q669 747 722 757L722 757L1024 1058L1024 1269Q1008 1267 992 1265.50Q976 1264 960 1264L960 1264Q944 1264 928 1265.50Q912 1267 896 1269L896 1269L896 940Q711 864 511 864L511 864Q414 864 320.50 882.50Q227 901 137 936L137 936ZM1235 1375L1294 1328L1385 1419L1324 1468Q1305 1442 1283 1418.50Q1261 1395 1235 1375L1235 1375Z"
         }
      }
   ]
}

var LargeGrid = {
   name: "LargeGrid",
   vendor: "UiFabric",
   unicode: 61131,
   value: "",
   charCode: "EECB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1792L128 128L1792 128L1792 1792L128 1792ZM1664 896L1664 256L256 256L256 896L1664 896ZM896 1024L256 1024L256 1664L896 1664L896 1024ZM1024 1024L1024 1664L1664 1664L1664 1024L1024 1024Z"
         }
      }
   ]
}

var TriangleSolidDown12 = {
   name: "TriangleSolidDown12",
   vendor: "UiFabric",
   unicode: 61133,
   value: "",
   charCode: "EECD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L0 0L2048 0L1024 2048L0 0Z"
         }
      }
   ]
}

var TriangleSolidRight12 = {
   name: "TriangleSolidRight12",
   vendor: "UiFabric",
   unicode: 61135,
   value: "",
   charCode: "EECF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L0 0L2048 1024L0 2048L0 0Z"
         }
      }
   ]
}

var TriangleDown12 = {
   name: "TriangleDown12",
   vendor: "UiFabric",
   unicode: 61137,
   value: "",
   charCode: "EED1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 2048L0 0L2048 0L1024 2048ZM1772 171L276 171L1024 1666L1772 171Z"
         }
      }
   ]
}

var TriangleRight12 = {
   name: "TriangleRight12",
   vendor: "UiFabric",
   unicode: 61139,
   value: "",
   charCode: "EED3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 0L2048 1024L0 2048ZM1666 1024L171 276L171 1772L1666 1024Z"
         }
      }
   ]
}

var ArrowDownRight8 = {
   name: "ArrowDownRight8",
   vendor: "UiFabric",
   unicode: 61141,
   value: "",
   charCode: "EED5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 256L1792 256L2048 256L2048 2048L256 2048L256 1792L1611 1792L37 219L219 37L1792 1611L1792 256Z"
         }
      }
   ]
}

var GoToDashboard = {
   name: "GoToDashboard",
   vendor: "UiFabric",
   unicode: 61165,
   value: "",
   charCode: "EEED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1133 877L1132 876Q1152 916 1152 960L1152 960Q1152 1000 1137 1035Q1122 1070 1096 1096Q1070 1122 1035 1137Q1000 1152 960 1152L960 1152Q920 1152 885 1137Q850 1122 824 1096Q798 1070 783 1035Q768 1000 768 960L768 960Q768 920 783 885Q798 850 824 824Q850 798 885 783Q920 768 960 768L960 768Q1004 768 1044 788L1044 788L1043 787L1411 419L1501 509L1133 877ZM960 1024L960 1024Q986 1024 1005 1005Q1024 986 1024 960L1024 960Q1024 934 1005 915Q986 896 960 896L960 896Q934 896 915 915Q896 934 896 960L896 960Q896 986 915 1005Q934 1024 960 1024ZM1458 1458L1367 1367Q1448 1286 1492 1182Q1536 1078 1536 963L1536 963Q1536 839 1484 724L1484 724L1600 672Q1631 740 1646.50 812.50Q1662 885 1662 960L1662 960Q1662 1100 1609.50 1229.50Q1557 1359 1458 1458L1458 1458ZM1248 320L1196 436Q1081 384 957 384L957 384Q878 384 805 404.50Q732 425 668 463Q604 501 552 553.50Q500 606 462.50 670Q425 734 404.50 807.50Q384 881 384 960L384 960Q384 1075 428 1180.50Q472 1286 553 1367L553 1367L462 1458Q362 1358 309 1229.50Q256 1101 256 960L256 960Q256 863 281 773Q306 683 352 605Q398 527 462 463Q526 399 604 353.50Q682 308 772 283Q862 258 960 258L960 258Q1035 258 1107.50 273.50Q1180 289 1248 320L1248 320ZM128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792L960 1792Q976 1792 992 1791Q1008 1790 1024 1789L1024 1789L1024 1917Q1008 1918 992 1919Q976 1920 960 1920L960 1920Q828 1920 705.50 1885.50Q583 1851 476 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444Q69 1337 34.50 1214.50Q0 1092 0 960L0 960Q0 828 34.50 705.50Q69 583 131.50 476Q194 369 281.50 281.50Q369 194 476 131.50Q583 69 705.50 34.50Q828 0 960 0L960 0Q1092 0 1214.50 34.50Q1337 69 1444 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 476Q1851 583 1885.50 705.50Q1920 828 1920 960L1920 960Q1920 1058 1900 1153.50Q1880 1249 1841 1340L1841 1340L1742 1241Q1792 1105 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960ZM1728 1408L2048 1728L1728 2048L1637 1957L1803 1792L1152 1792L1152 1664L1803 1664L1637 1499L1728 1408Z"
         }
      }
   ]
}

var ArrowUpRightMirrored8 = {
   name: "ArrowUpRightMirrored8",
   vendor: "UiFabric",
   unicode: 61167,
   value: "",
   charCode: "EEEF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 0L1792 0L0 0L0 1792L256 1792L256 437L1829 2011L2011 1829L437 256L1792 256L1792 0Z"
         }
      }
   ]
}

var CompanyDirectory = {
   name: "CompanyDirectory",
   vendor: "UiFabric",
   unicode: 61197,
   value: "",
   charCode: "EF0D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1920 0L1920 2048L256 2048L256 1794L128 1794L128 1666L256 1666L256 1409L128 1409L128 1281L256 1281L256 769L128 769L128 641L256 641L256 385L128 385L128 257L256 257L256 0ZM1792 1920L1792 128L384 128L384 1920L1792 1920ZM1664 384L1664 512L1024 512L1024 384L1664 384ZM1664 640L1664 768L1024 768L1024 640L1664 640ZM704 1660L704 1660Q665 1660 630.50 1645.50Q596 1631 570.50 1605.50Q545 1580 530.50 1545.50Q516 1511 516 1472L516 1472Q516 1433 530.50 1399Q545 1365 570.50 1339.50Q596 1314 630.50 1299Q665 1284 704 1284L704 1284Q743 1284 777 1299Q811 1314 836.50 1339.50Q862 1365 877 1399Q892 1433 892 1472L892 1472Q892 1511 877 1545.50Q862 1580 836.50 1605.50Q811 1631 777 1645.50Q743 1660 704 1660ZM704 1404L704 1404Q675 1404 655.50 1423.50Q636 1443 636 1472L636 1472Q636 1501 655.50 1520.50Q675 1540 704 1540L704 1540Q733 1540 752.50 1520.50Q772 1501 772 1472L772 1472Q772 1443 752.50 1423.50Q733 1404 704 1404ZM704 764L704 764Q665 764 630.50 749.50Q596 735 570.50 709.50Q545 684 530.50 649.50Q516 615 516 576L516 576Q516 537 530.50 503Q545 469 570.50 443.50Q596 418 630.50 403Q665 388 704 388L704 388Q743 388 777 403Q811 418 836.50 443.50Q862 469 877 503Q892 537 892 576L892 576Q892 615 877 649.50Q862 684 836.50 709.50Q811 735 777 749.50Q743 764 704 764ZM704 508L704 508Q675 508 655.50 527.50Q636 547 636 576L636 576Q636 605 655.50 624.50Q675 644 704 644L704 644Q733 644 752.50 624.50Q772 605 772 576L772 576Q772 547 752.50 527.50Q733 508 704 508ZM1664 1280L1664 1408L1024 1408L1024 1280L1664 1280ZM1664 1536L1664 1664L1024 1664L1024 1536L1664 1536Z"
         }
      }
   ]
}

var ArrowDownRightMirrored8 = {
   name: "ArrowDownRightMirrored8",
   vendor: "UiFabric",
   unicode: 61168,
   value: "",
   charCode: "EEF0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 256L256 256L0 256L0 2048L1792 2048L1792 1792L437 1792L2011 219L1829 37L256 1611L256 256Z"
         }
      }
   ]
}

var DelveAnalytics = {
   name: "DelveAnalytics",
   vendor: "UiFabric",
   unicode: 61166,
   value: "",
   charCode: "EEEE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1166 2011.50 1296.50Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 998 19 979Q38 960 64 960L64 960Q90 960 109 979Q128 998 128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q998 128 979 109Q960 90 960 64L960 64Q960 38 979 19Q998 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024ZM1024 1664L1024 1664Q998 1664 979 1645Q960 1626 960 1600L960 1600Q960 1574 979 1555Q998 1536 1024 1536L1024 1536Q1130 1536 1223 1495.50Q1316 1455 1385.50 1385.50Q1455 1316 1495.50 1223Q1536 1130 1536 1024L1536 1024Q1536 918 1495.50 825Q1455 732 1385.50 662.50Q1316 593 1223 552.50Q1130 512 1024 512L1024 512Q998 512 979 493Q960 474 960 448L960 448Q960 422 979 403Q998 384 1024 384L1024 384Q1157 384 1273.50 434Q1390 484 1477 571Q1564 658 1614 774.50Q1664 891 1664 1024L1664 1024Q1664 1157 1614 1273.50Q1564 1390 1477 1477Q1390 1564 1273.50 1614Q1157 1664 1024 1664ZM960 832L960 832Q960 806 979 787Q998 768 1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1050 1261 1069Q1242 1088 1216 1088L1216 1088Q1190 1088 1171 1069Q1152 1050 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q998 896 979 877Q960 858 960 832Z"
         }
      }
   ]
}

var OpenEnrollment = {
   name: "OpenEnrollment",
   vendor: "UiFabric",
   unicode: 61212,
   value: "",
   charCode: "EF1C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838ZM640 768L640 896L512 896L512 768L640 768ZM1536 768L1536 896L768 896L768 768L1536 768ZM512 1280L512 1152L640 1152L640 1280L512 1280ZM640 384L640 512L512 512L512 384L640 384ZM1536 384L1536 512L768 512L768 384L1536 384ZM384 128L384 1664L827 1664L795 1792L256 1792L256 0L1792 0L1792 743Q1725 753 1664 787L1664 787L1664 128L384 128ZM768 1280L768 1152L1282 1152L1154 1280L768 1280Z"
         }
      }
   ]
}

var CompanyDirectoryMirrored = {
   name: "CompanyDirectoryMirrored",
   vendor: "UiFabric",
   unicode: 61227,
   value: "",
   charCode: "EF2B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 0L128 0L128 2048L1792 2048L1792 1794L1920 1794L1920 1666L1792 1666L1792 1409L1920 1409L1920 1281L1792 1281L1792 769L1920 769L1920 641L1792 641L1792 385L1920 385L1920 257L1792 257L1792 0ZM256 1920L256 128L1664 128L1664 1920L256 1920ZM384 384L384 512L1024 512L1024 384L384 384ZM384 640L384 768L1024 768L1024 640L384 640ZM1344 1660L1344 1660Q1383 1660 1417.50 1645.50Q1452 1631 1477.50 1605.50Q1503 1580 1517.50 1545.50Q1532 1511 1532 1472L1532 1472Q1532 1433 1517.50 1399Q1503 1365 1477.50 1339.50Q1452 1314 1417.50 1299Q1383 1284 1344 1284L1344 1284Q1305 1284 1271 1299Q1237 1314 1211.50 1339.50Q1186 1365 1171 1399Q1156 1433 1156 1472L1156 1472Q1156 1511 1171 1545.50Q1186 1580 1211.50 1605.50Q1237 1631 1271 1645.50Q1305 1660 1344 1660ZM1344 1404L1344 1404Q1373 1404 1392.50 1423.50Q1412 1443 1412 1472L1412 1472Q1412 1501 1392.50 1520.50Q1373 1540 1344 1540L1344 1540Q1315 1540 1295.50 1520.50Q1276 1501 1276 1472L1276 1472Q1276 1443 1295.50 1423.50Q1315 1404 1344 1404ZM1344 764L1344 764Q1383 764 1417.50 749.50Q1452 735 1477.50 709.50Q1503 684 1517.50 649.50Q1532 615 1532 576L1532 576Q1532 537 1517.50 503Q1503 469 1477.50 443.50Q1452 418 1417.50 403Q1383 388 1344 388L1344 388Q1305 388 1271 403Q1237 418 1211.50 443.50Q1186 469 1171 503Q1156 537 1156 576L1156 576Q1156 615 1171 649.50Q1186 684 1211.50 709.50Q1237 735 1271 749.50Q1305 764 1344 764ZM1344 508L1344 508Q1373 508 1392.50 527.50Q1412 547 1412 576L1412 576Q1412 605 1392.50 624.50Q1373 644 1344 644L1344 644Q1315 644 1295.50 624.50Q1276 605 1276 576L1276 576Q1276 547 1295.50 527.50Q1315 508 1344 508ZM384 1280L384 1408L1024 1408L1024 1280L384 1280ZM384 1536L384 1664L1024 1664L1024 1536L384 1536Z"
         }
      }
   ]
}

var OneDriveAdd = {
   name: "OneDriveAdd",
   vendor: "UiFabric",
   unicode: 61234,
   value: "",
   charCode: "EF32",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1024L1280 1408L1664 1408L1664 1536L1280 1536L1280 1920L1152 1920L1152 1536L768 1536L768 1408L1152 1408L1152 1024L1280 1024ZM1878 931L1878 931Q1963 973 2005.50 1048.50Q2048 1124 2048 1218L2048 1218Q2048 1274 2029 1326.50Q2010 1379 1976 1422Q1942 1465 1895 1494.50Q1848 1524 1792 1533L1792 1533L1792 1401Q1820 1392 1844 1373.50Q1868 1355 1884.50 1330Q1901 1305 1910.50 1276Q1920 1247 1920 1218L1920 1218Q1920 1182 1909 1148.50Q1898 1115 1877 1089Q1856 1063 1825.50 1046.50Q1795 1030 1757 1027L1757 1027Q1760 969 1744.50 918.50Q1729 868 1696.50 830.50Q1664 793 1617 771Q1570 749 1510 749L1510 749Q1479 749 1442 757Q1405 765 1378 781L1378 781Q1333 715 1268.50 677.50Q1204 640 1123 640L1123 640Q1101 640 1079 642.50Q1057 645 1036 650L1036 650Q987 662 947 689Q907 716 877 754Q847 792 829.50 838Q812 884 808 933L808 933Q760 935 716.50 950.50Q673 966 640.50 994.50Q608 1023 588.50 1063.50Q569 1104 569 1155L569 1155Q569 1208 585 1258.50Q601 1309 640 1347L640 1347L640 1499Q606 1483 576.50 1460Q547 1437 524 1408L524 1408L363 1408Q290 1408 224.50 1378Q159 1348 109 1298Q59 1248 29.50 1181.50Q0 1115 0 1043L0 1043Q0 928 54.50 837.50Q109 747 216 700L216 700Q228 622 264.50 555.50Q301 489 356.50 440.50Q412 392 482 364Q552 336 632 336L632 336Q656 336 680 338.50Q704 341 727 347L727 347Q798 267 893.50 221.50Q989 176 1096 176L1096 176Q1145 176 1192.50 185.50Q1240 195 1285 213L1285 213Q1426 269 1506 377Q1586 485 1609 631L1609 631L1610 634Q1664 647 1709 675Q1754 703 1788.50 742Q1823 781 1846 829Q1869 877 1878 931ZM1419 631L1479 623Q1466 554 1431 495.50Q1396 437 1345 394.50Q1294 352 1230 328Q1166 304 1096 304L1096 304Q1045 304 997.50 318Q950 332 908.50 358Q867 384 833 420.50Q799 457 774 501L774 501Q745 483 705 473.50Q665 464 632 464L632 464Q570 464 516.50 488Q463 512 423.50 553.50Q384 595 361.50 649.50Q339 704 339 765L339 765Q339 773 339.50 781.50Q340 790 341 798L341 798Q292 802 252.50 823Q213 844 185.50 877Q158 910 143 952.50Q128 995 128 1043L128 1043Q128 1090 147.50 1132.50Q167 1175 199 1208Q231 1241 273.50 1260.50Q316 1280 363 1280L363 1280L458 1280Q448 1250 444.50 1218.50Q441 1187 441 1155L441 1155Q441 1092 459.50 1038.50Q478 985 512 943Q546 901 594 870.50Q642 840 701 822L701 822Q724 749 764 691.50Q804 634 858 594Q912 554 979 533Q1046 512 1123 512L1123 512Q1208 512 1283 542Q1358 572 1419 631L1419 631Z"
         }
      }
   ]
}

var ProfileSearch = {
   name: "ProfileSearch",
   vendor: "UiFabric",
   unicode: 61237,
   value: "",
   charCode: "EF35",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1468 1139L1468 1139Q1416 1182 1379 1235L1379 1235Q1296 1193 1205.50 1172.50Q1115 1152 1022 1152L1022 1152Q914 1152 815.50 1179Q717 1206 632 1255.50Q547 1305 477.50 1374.50Q408 1444 359 1529.50Q310 1615 283 1714Q256 1813 256 1920L256 1920L128 1920Q128 1774 171.50 1639Q215 1504 295 1392Q375 1280 488.50 1196Q602 1112 742 1067L742 1067Q688 1031 645.50 984Q603 937 573.50 882Q544 827 528 766Q512 705 512 640L512 640Q512 534 552.50 441Q593 348 662.50 278.50Q732 209 825 168.50Q918 128 1024 128L1024 128Q1130 128 1223 168.50Q1316 209 1385.50 278.50Q1455 348 1495.50 441Q1536 534 1536 640L1536 640Q1536 705 1520 766.50Q1504 828 1474.50 883Q1445 938 1402 985Q1359 1032 1305 1068L1305 1068Q1348 1082 1388.50 1099.50Q1429 1117 1468 1139ZM640 640L640 640Q640 720 670 789.50Q700 859 752.50 911.50Q805 964 874.50 994Q944 1024 1024 1024L1024 1024Q1103 1024 1173 994Q1243 964 1295.50 911.50Q1348 859 1378 789.50Q1408 720 1408 640L1408 640Q1408 561 1378 491Q1348 421 1295.50 368.50Q1243 316 1173 286Q1103 256 1024 256L1024 256Q944 256 874.50 286Q805 316 752.50 368.50Q700 421 670 491Q640 561 640 640ZM1730 1151L1730 1151Q1796 1151 1855 1176.50Q1914 1202 1957.50 1245.50Q2001 1289 2026.50 1347.50Q2052 1406 2052 1472L2052 1472Q2052 1538 2026.50 1596.50Q2001 1655 1957.50 1698.50Q1914 1742 1855 1767.50Q1796 1793 1730 1793L1730 1793Q1633 1793 1553 1739L1553 1739L1261 2031Q1242 2050 1216 2050L1216 2050Q1190 2050 1171 2031Q1152 2012 1152 1986L1152 1986Q1152 1960 1171 1941L1171 1941L1463 1649Q1409 1569 1409 1472L1409 1472Q1409 1406 1434.50 1347.50Q1460 1289 1503.50 1245.50Q1547 1202 1605.50 1176.50Q1664 1151 1730 1151ZM1730 1665L1730 1665Q1770 1665 1805 1650Q1840 1635 1866.50 1608.50Q1893 1582 1908.50 1547Q1924 1512 1924 1472L1924 1472Q1924 1432 1908.50 1397Q1893 1362 1867 1335.50Q1841 1309 1805.50 1294Q1770 1279 1730 1279L1730 1279Q1690 1279 1655 1294.50Q1620 1310 1593.50 1336Q1567 1362 1552 1397Q1537 1432 1537 1472L1537 1472Q1537 1512 1552 1547Q1567 1582 1593.50 1608.50Q1620 1635 1655 1650Q1690 1665 1730 1665Z"
         }
      }
   ]
}

var Header2 = {
   name: "Header2",
   vendor: "UiFabric",
   unicode: 61238,
   value: "",
   charCode: "EF36",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1024L768 384L896 384L896 1792L768 1792L768 1152L128 1152L128 1792L0 1792L0 384L128 384L128 1024L768 1024ZM1954 757L1954 757Q1954 839 1935 904Q1916 969 1882.50 1023Q1849 1077 1804 1122Q1759 1167 1706.50 1208Q1654 1249 1597.50 1289Q1541 1329 1485 1373L1485 1373Q1463 1390 1440 1410Q1417 1430 1396 1452Q1375 1474 1358 1499Q1341 1524 1332 1551L1332 1551Q1324 1576 1320.50 1607Q1317 1638 1317 1664L1317 1664L1920 1664L1920 1792L1152 1792Q1152 1735 1153.50 1679Q1155 1623 1171 1567L1171 1567Q1190 1502 1226.50 1449.50Q1263 1397 1310 1352Q1357 1307 1411 1267.50Q1465 1228 1519 1188Q1573 1148 1622 1106Q1671 1064 1709 1014Q1747 964 1769.50 904.50Q1792 845 1792 770L1792 770Q1792 711 1774 664.50Q1756 618 1723 585.50Q1690 553 1642.50 535.50Q1595 518 1537 518L1537 518Q1489 518 1443 531.50Q1397 545 1355 568Q1313 591 1275 622Q1237 653 1206 687L1206 687L1206 517Q1245 480 1284.50 454.50Q1324 429 1367 413.50Q1410 398 1457 391Q1504 384 1557 384L1557 384Q1642 384 1714.50 409Q1787 434 1840.50 482Q1894 530 1924 599.50Q1954 669 1954 757Z"
         }
      }
   ]
}

var Header3 = {
   name: "Header3",
   vendor: "UiFabric",
   unicode: 61239,
   value: "",
   charCode: "EF37",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1024L768 384L896 384L896 1792L768 1792L768 1152L128 1152L128 1792L0 1792L0 384L128 384L128 1024L768 1024ZM1619 1054L1619 1058Q1686 1065 1744.50 1090.50Q1803 1116 1846.50 1157.50Q1890 1199 1915 1256Q1940 1313 1940 1383L1940 1383Q1940 1486 1900.50 1562.50Q1861 1639 1794.50 1690Q1728 1741 1641.50 1766.50Q1555 1792 1461 1792L1461 1792Q1381 1792 1301 1777Q1221 1762 1152 1718L1152 1718L1152 1551Q1290 1659 1467 1659L1467 1659Q1528 1659 1585 1643.50Q1642 1628 1685.50 1596Q1729 1564 1755 1514.50Q1781 1465 1781 1397L1781 1397Q1781 1328 1758.50 1281Q1736 1234 1698 1204.50Q1660 1175 1609.50 1159.50Q1559 1144 1504.50 1137.50Q1450 1131 1394 1130.50Q1338 1130 1288 1130L1288 1130L1288 998Q1335 998 1386.50 997.50Q1438 997 1487.50 991Q1537 985 1581 970.50Q1625 956 1658.50 928Q1692 900 1711.50 856.50Q1731 813 1731 748L1731 748Q1731 686 1713 642Q1695 598 1662 570Q1629 542 1581.50 529Q1534 516 1475 516L1475 516Q1399 516 1331.50 541.50Q1264 567 1204 613L1204 613L1204 462Q1275 420 1354 402Q1433 384 1514 384L1514 384Q1588 384 1656.50 404.50Q1725 425 1777 465.50Q1829 506 1860 567Q1891 628 1891 709L1891 709Q1891 848 1820.50 932.50Q1750 1017 1619 1054L1619 1054Z"
         }
      }
   ]
}

var Header4 = {
   name: "Header4",
   vendor: "UiFabric",
   unicode: 61240,
   value: "",
   charCode: "EF38",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1024L768 1024L768 384L896 384L896 1792L768 1792L768 1152L128 1152L128 1792L0 1792L0 384L128 384L128 1024ZM1920 384L1920 1280L2048 1280L2048 1408L1920 1408L1920 1792L1792 1792L1792 1408L1152 1408L1152 1323L1823 384L1920 384ZM1340 1280L1792 1280L1792 648L1340 1280Z"
         }
      }
   ]
}

var RingerSolid = {
   name: "RingerSolid",
   vendor: "UiFabric",
   unicode: 61242,
   value: "",
   charCode: "EF3A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1536L1792 1536L1792 1664L1280 1664Q1280 1717 1260 1763.50Q1240 1810 1205 1845Q1170 1880 1123.50 1900Q1077 1920 1024 1920L1024 1920Q971 1920 924.50 1900Q878 1880 843 1845Q808 1810 788 1763.50Q768 1717 768 1664L768 1664L256 1664L256 1536L384 1536L384 768Q384 680 407 598Q430 516 471.50 445Q513 374 571.50 315.50Q630 257 701 215.50Q772 174 854 151Q936 128 1024 128L1024 128Q1112 128 1194 151Q1276 174 1347 215.50Q1418 257 1476.50 315.50Q1535 374 1576.50 445Q1618 516 1641 598Q1664 680 1664 768L1664 768L1664 1536Z"
         }
      }
   ]
}

var Flow = {
   name: "Flow",
   vendor: "UiFabric",
   unicode: 61328,
   value: "",
   charCode: "EF90",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 512L1408 256L2048 256L2048 896L1408 896L1408 640L1288 640L839 1536L640 1536L640 1792L0 1792L0 1152L640 1152L640 1408L760 1408L1209 512L1408 512ZM128 1664L512 1664L512 1280L128 1280L128 1664ZM1536 768L1920 768L1920 384L1536 384L1536 768Z"
         }
      }
   ]
}

var Breadcrumb = {
   name: "Breadcrumb",
   vendor: "UiFabric",
   unicode: 61324,
   value: "",
   charCode: "EF8C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 640L256 512L1792 512L1792 640L256 640ZM1792 1024L640 1024L640 896L1792 896L1792 1024ZM1792 1408L1024 1408L1024 1280L1792 1280L1792 1408Z"
         }
      }
   ]
}

var EmptyRecycleBin = {
   name: "EmptyRecycleBin",
   vendor: "UiFabric",
   unicode: 61320,
   value: "",
   charCode: "EF88",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M935 1589L782 1589Q750 1589 734 1560L734 1560Q728 1549 713 1522Q698 1495 681.50 1465.50Q665 1436 652.50 1410.50Q640 1385 640 1376L640 1376Q640 1360 647.50 1342Q655 1324 665.50 1306Q676 1288 686.50 1271.50Q697 1255 704 1244L704 1244L640 1193L837 1193L884 1387L807 1326L752 1437L935 1437L935 1589ZM1105 1124L1013 945L929 1110L802 1046L862 927Q876 897 910 897L910 897L1131 896Q1163 896 1179 926L1179 926L1233 1027L1291 983L1261 1190L1043 1170L1105 1124ZM1135 1597L1135 1664L1011 1498L1135 1346L1135 1449L1298 1449L1231 1326L1353 1254Q1357 1263 1366.50 1279.50Q1376 1296 1385 1314Q1394 1332 1401 1349Q1408 1366 1408 1376L1408 1376Q1408 1388 1402 1400L1402 1400L1317 1568Q1310 1582 1297 1589.50Q1284 1597 1269 1597L1269 1597L1135 1597ZM1480 1776L1734 640L1866 640L1595 1851Q1465 1948 1326.50 1998Q1188 2048 1025 2048L1025 2048Q863 2048 724 1997.50Q585 1947 456 1851L456 1851L137 441Q134 427 131 413Q128 399 128 384L128 384Q128 326 157.50 278.50Q187 231 235 194Q283 157 344 128.50Q405 100 467.50 80Q530 60 588.50 47Q647 34 691 27L691 27Q856 0 1024 0L1024 0Q1075 0 1125.50 2.50Q1176 5 1227 10L1227 10Q1161 30 1099.50 59.50Q1038 89 982 129L982 129Q934 130 876 134Q818 138 755.50 146Q693 154 629.50 167Q566 180 506.50 199Q447 218 395.50 243.50Q344 269 306 301L306 301Q288 317 272 338Q256 359 256 384L256 384Q256 399 262 412.50Q268 426 278 438.50Q288 451 299.50 461.50Q311 472 322 480L322 480Q364 512 418.50 536Q473 560 534 577.50Q595 595 660 607Q725 619 789 626.50Q853 634 913 637Q973 640 1024 640L1024 640Q1035 640 1046 639.50Q1057 639 1068 639L1068 639L1069 640L1701 640Q1627 675 1542.50 699.50Q1458 724 1369.50 739Q1281 754 1193 761Q1105 768 1024 768L1024 768Q940 768 846 760.50Q752 753 657.50 736Q563 719 473.50 691Q384 663 310 622L310 622L570 1776Q670 1846 787 1881.50Q904 1917 1026 1917L1026 1917Q1147 1917 1263.50 1881.50Q1380 1846 1480 1776L1480 1776ZM1920 0L2048 0L2048 512L1536 512L1536 384L1828 384Q1752 324 1661 293Q1570 262 1473 262L1473 262Q1359 262 1254.50 305Q1150 348 1069 429L1069 429L979 339Q1078 240 1205.50 187Q1333 134 1473 134L1473 134Q1595 134 1710 175Q1825 216 1920 294L1920 294L1920 0Z"
         }
      }
   ]
}

var OfficeFormsLogoInverse = {
   name: "OfficeFormsLogoInverse",
   vendor: "UiFabric",
   unicode: 61318,
   value: "",
   charCode: "EF86",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1664L1344 1664L1344 1216L1792 1216L1792 1664ZM1664 1344L1472 1344L1472 1536L1664 1536L1664 1344ZM1568 896L1568 896Q1508 896 1455.50 873.50Q1403 851 1364 812Q1325 773 1302.50 720.50Q1280 668 1280 608L1280 608Q1280 548 1302.50 495.50Q1325 443 1364 404Q1403 365 1455.50 342.50Q1508 320 1568 320L1568 320Q1628 320 1680.50 342.50Q1733 365 1772 404Q1811 443 1833.50 495.50Q1856 548 1856 608L1856 608Q1856 668 1833.50 720.50Q1811 773 1772 812Q1733 851 1680.50 873.50Q1628 896 1568 896ZM1568 448L1568 448Q1535 448 1506 460.50Q1477 473 1455 495Q1433 517 1420.50 546Q1408 575 1408 608L1408 608Q1408 641 1420.50 670Q1433 699 1455 721Q1477 743 1506 755.50Q1535 768 1568 768L1568 768Q1601 768 1630 755.50Q1659 743 1681 721Q1703 699 1715.50 670Q1728 641 1728 608L1728 608Q1728 575 1715.50 546Q1703 517 1681 495Q1659 473 1630 460.50Q1601 448 1568 448ZM597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM1920 256L640 256L640 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 960L1920 960L1920 256ZM461 1360L461 1102L720 1102L720 966L461 966L461 824L739 824L739 688L304 688L304 1360L461 1360ZM640 1536L640 1792L1920 1792L1920 1088L1024 1088L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L640 1536Z"
         }
      }
   ]
}

var ClosedCaption = {
   name: "ClosedCaption",
   vendor: "UiFabric",
   unicode: 61316,
   value: "",
   charCode: "EF84",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L1920 128L1920 1536L1152 1536L1152 2048L768 1536L0 1536L0 128ZM960 1341L960 1341Q990 1341 1040.50 1340Q1091 1339 1151 1335.50Q1211 1332 1275 1326.50Q1339 1321 1395.50 1311Q1452 1301 1496 1286.50Q1540 1272 1560 1252L1560 1252Q1577 1235 1590 1204Q1603 1173 1612.50 1134.50Q1622 1096 1629 1052.50Q1636 1009 1640 968Q1644 927 1646 891.50Q1648 856 1648 832L1648 832Q1648 809 1646 773Q1644 737 1640 695.50Q1636 654 1629 610.50Q1622 567 1612 527.50Q1602 488 1589 457Q1576 426 1560 409L1560 409Q1541 390 1497.50 376.50Q1454 363 1397 353.50Q1340 344 1275 338Q1210 332 1150 328.50Q1090 325 1039.50 324Q989 323 960 323L960 323Q931 323 880.50 324Q830 325 770 328.50Q710 332 645 338Q580 344 523 353.50Q466 363 422.50 376.50Q379 390 360 409L360 409Q343 426 330 457Q317 488 307.50 527Q298 566 291 609.50Q284 653 280 694.50Q276 736 274 771.50Q272 807 272 831L272 831Q272 855 274 890.50Q276 926 280 967.50Q284 1009 290.50 1052Q297 1095 307 1134Q317 1173 330 1204Q343 1235 360 1252L360 1252Q375 1267 403.50 1278.50Q432 1290 464 1298Q496 1306 527.50 1311Q559 1316 579 1319L579 1319Q674 1331 769 1336Q864 1341 960 1341Z"
         }
      }
   ]
}

var SkypeMinus = {
   name: "SkypeMinus",
   vendor: "UiFabric",
   unicode: 61314,
   value: "",
   charCode: "EF82",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1591 823L1591 823Q1633 823 1669.50 839Q1706 855 1733 882Q1760 909 1776 945.50Q1792 982 1792 1024L1792 1024Q1792 1066 1776 1102.50Q1760 1139 1733 1166Q1706 1193 1669.50 1209Q1633 1225 1591 1225L1591 1225L395 1225Q353 1225 316.50 1209Q280 1193 253 1166Q226 1139 210.50 1102.50Q195 1066 195 1024L195 1024Q195 982 210.50 945.50Q226 909 253 882Q280 855 316.50 839Q353 823 395 823L395 823L1591 823Z"
         }
      }
   ]
}

var SkypeCheck = {
   name: "SkypeCheck",
   vendor: "UiFabric",
   unicode: 61312,
   value: "",
   charCode: "EF80",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1570 437L1570 437Q1612 437 1648.50 452.50Q1685 468 1712 495Q1739 522 1754.50 558.50Q1770 595 1770 637L1770 637Q1770 677 1755 714Q1740 751 1712 779L1712 779L918 1574Q890 1602 853 1617.50Q816 1633 776 1633L776 1633Q736 1633 699 1617.50Q662 1602 634 1574L634 1574L272 1212Q244 1184 228.50 1147Q213 1110 213 1070L213 1070Q213 1028 229 991.50Q245 955 272 928Q299 901 335.50 885.50Q372 870 414 870L414 870Q454 870 491 885Q528 900 556 928L556 928L776 1148L1428 495Q1456 467 1493 452Q1530 437 1570 437Z"
         }
      }
   ]
}

var SkypeCircleClock = {
   name: "SkypeCircleClock",
   vendor: "UiFabric",
   unicode: 61310,
   value: "",
   charCode: "EF7E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1345 1453L1345 1453Q1367 1453 1386.50 1444.50Q1406 1436 1421 1421Q1436 1406 1444.50 1386.50Q1453 1367 1453 1345L1453 1345Q1453 1300 1421 1268L1421 1268L1132 979L1132 455Q1132 433 1123.50 413Q1115 393 1100.50 378.50Q1086 364 1066 355.50Q1046 347 1024 347L1024 347Q1001 347 981.50 355.50Q962 364 947.50 378.50Q933 393 924.50 413Q916 433 916 455L916 455L916 1024Q916 1045 924 1065.50Q932 1086 947 1101L947 1101L1268 1421Q1300 1453 1345 1453Z"
         }
      }
   ]
}

var Tiles2 = {
   name: "Tiles2",
   vendor: "UiFabric",
   unicode: 61308,
   value: "",
   charCode: "EF7C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 2048L256 2048L256 768L896 768L896 2048ZM768 896L384 896L384 1920L768 1920L768 896ZM896 640L256 640L256 0L896 0L896 640ZM768 128L384 128L384 512L768 512L768 128ZM1024 1280L1024 0L1664 0L1664 1280L1024 1280ZM1152 1152L1536 1152L1536 128L1152 128L1152 1152ZM1664 2048L1024 2048L1024 1408L1664 1408L1664 2048ZM1536 1536L1152 1536L1152 1920L1536 1920L1536 1536Z"
         }
      }
   ]
}

var AirTickets = {
   name: "AirTickets",
   vendor: "UiFabric",
   unicode: 61306,
   value: "",
   charCode: "EF7A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1774 640L2048 640L2048 1792L0 1792L0 640L440 640Q441 640 473.50 629.50Q506 619 560 601Q614 583 686.50 559Q759 535 840.50 507.50Q922 480 1009.50 450.50Q1097 421 1181 393Q1265 365 1342.50 339Q1420 313 1481.50 292.50Q1543 272 1584.50 258Q1626 244 1640 239L1640 239L1774 640ZM1560 401L842 640L1639 640L1560 401ZM1920 1664L1920 768L128 768L128 1664L1920 1664ZM1536 896L1664 896L1664 1024L1536 1024L1536 896ZM1536 1152L1664 1152L1664 1280L1536 1280L1536 1152ZM1664 1408L1664 1536L1536 1536L1536 1408L1664 1408ZM1792 1024L1792 1152L1664 1152L1664 1024L1792 1024ZM1792 1280L1792 1408L1664 1408L1664 1280L1792 1280ZM853 1280L469 1280L384 1024L512 1024L576 1152L853 1152L768 896L896 896L1024 1152L1280 1152Q1306 1152 1325 1171Q1344 1190 1344 1216L1344 1216Q1344 1242 1325 1261Q1306 1280 1280 1280L1280 1280L1024 1280L896 1536L768 1536L853 1280Z"
         }
      }
   ]
}

var Starburst = {
   name: "Starburst",
   vendor: "UiFabric",
   unicode: 61304,
   value: "",
   charCode: "EF78",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L1664 1280L1760 1760L1280 1664L1024 2048L768 1664L288 1760L384 1280L0 1024L384 768L288 288L768 384L1024 0L1280 384L1760 288L1664 768L2048 1024ZM1221 1522L1221 1522Q1316 1539 1409.50 1558Q1503 1577 1597 1597L1597 1597Q1577 1503 1558 1409.50Q1539 1316 1522 1221L1522 1221Q1597 1172 1670 1123Q1743 1074 1817 1024L1817 1024Q1743 974 1670 925Q1597 876 1522 827L1522 827Q1540 732 1559 638.50Q1578 545 1597 451L1597 451Q1503 471 1409.50 490Q1316 509 1221 526L1221 526Q1172 451 1123 378Q1074 305 1024 231L1024 231Q974 305 925 378Q876 451 827 526L827 526Q732 509 638.50 490Q545 471 451 451L451 451Q471 545 490 638.50Q509 732 526 827L526 827Q451 876 378 925Q305 974 231 1024L231 1024Q305 1074 378 1123Q451 1172 526 1221L526 1221Q508 1316 489 1409.50Q470 1503 451 1597L451 1597Q545 1577 638.50 1558Q732 1539 827 1522L827 1522Q876 1597 925 1670Q974 1743 1024 1817L1024 1817Q1074 1743 1123 1670Q1172 1597 1221 1522Z"
         }
      }
   ]
}

var Sections = {
   name: "Sections",
   vendor: "UiFabric",
   unicode: 61302,
   value: "",
   charCode: "EF76",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1548 896L1728 896Q1752 896 1775 904Q1798 912 1817 925.50Q1836 939 1850.50 958.50Q1865 978 1874 1000L1874 1000Q1879 1014 1894.50 1052.50Q1910 1091 1929 1140.50Q1948 1190 1969 1245Q1990 1300 2007.50 1348Q2025 1396 2036.50 1430Q2048 1464 2048 1472L2048 1472Q2048 1499 2029 1517.50Q2010 1536 1984 1536L1984 1536L832 1536Q806 1536 787 1517.50Q768 1499 768 1472L768 1472Q768 1460 776.50 1434Q785 1408 796.50 1378Q808 1348 819.50 1321Q831 1294 836 1280L836 1280L448 1280Q422 1280 403 1261.50Q384 1243 384 1216L384 1216Q384 1204 392.50 1178Q401 1152 412.50 1122Q424 1092 435.50 1065Q447 1038 452 1024L452 1024L64 1024Q38 1024 19 1005.50Q0 987 0 960L0 960Q0 952 11.50 917.50Q23 883 40.50 835.50Q58 788 79 732.50Q100 677 119 627Q138 577 153 538.50Q168 500 174 486L174 486Q191 441 231.50 412.50Q272 384 320 384L320 384L960 384Q984 384 1007 392Q1030 400 1049 413.50Q1068 427 1082.50 446.50Q1097 466 1106 488L1106 488L1164 640L1344 640Q1368 640 1391 648Q1414 656 1433 669.50Q1452 683 1466.50 702.50Q1481 722 1490 744L1490 744L1548 896ZM156 896L500 896L558 742Q575 697 615.50 668.50Q656 640 704 640L704 640L1027 640L986 531Q984 525 975.50 518.50Q967 512 960 512L960 512L320 512Q313 512 305 518Q297 524 295 530L295 530L156 896ZM540 1152L884 1152L942 998Q959 953 999.50 924.50Q1040 896 1088 896L1088 896L1411 896L1370 787Q1368 781 1359.50 774.50Q1351 768 1344 768L1344 768L704 768Q697 768 689 774Q681 780 679 786L679 786Q644 878 609.50 969Q575 1060 540 1152L540 1152ZM924 1408L1892 1408L1754 1043Q1752 1037 1743.50 1030.50Q1735 1024 1728 1024L1728 1024L1088 1024Q1081 1024 1073 1030Q1065 1036 1063 1042L1063 1042L1021 1152Q997 1216 973 1280Q949 1344 924 1408L924 1408Z"
         }
      }
   ]
}

var GroupedList = {
   name: "GroupedList",
   vendor: "UiFabric",
   unicode: 61300,
   value: "",
   charCode: "EF74",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 384L640 384L640 256L1024 256L1024 384ZM1152 384L1152 256L1920 256L1920 384L1152 384ZM512 640L0 640L0 128L512 128L512 640ZM384 256L128 256L128 512L384 512L384 256ZM1024 1024L640 1024L640 896L1024 896L1024 1024ZM1920 1024L1152 1024L1152 896L1920 896L1920 1024ZM512 1280L0 1280L0 768L512 768L512 1280ZM384 896L128 896L128 1152L384 1152L384 896ZM1024 1664L640 1664L640 1536L1024 1536L1024 1664ZM1920 1664L1152 1664L1152 1536L1920 1536L1920 1664ZM512 1920L0 1920L0 1408L512 1408L512 1920ZM384 1536L128 1536L128 1792L384 1792L384 1536Z"
         }
      }
   ]
}

var PowerPointDocument = {
   name: "PowerPointDocument",
   vendor: "UiFabric",
   unicode: 61298,
   value: "",
   charCode: "EF72",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 475L2048 475L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L640 2048Q613 2048 590 2038Q567 2028 549.50 2010.50Q532 1993 522 1970Q512 1947 512 1920L512 1920L512 1664L115 1664Q91 1664 70.50 1655Q50 1646 34 1630Q18 1614 9 1593.50Q0 1573 0 1549L0 1549L0 627Q0 603 9 582.50Q18 562 34 546Q50 530 70.50 521Q91 512 115 512L115 512L512 512L512 128Q512 101 522 78Q532 55 549.50 37.50Q567 20 590 10Q613 0 640 0L640 0L1573 0Q1599 0 1622.50 9.50Q1646 19 1664 37L1664 37L2011 384Q2029 402 2038.50 425.50Q2048 449 2048 475ZM1829 384L1664 219L1664 384L1829 384ZM626 752L368 752L368 1424L518 1424L518 1198L618 1198Q670 1198 715 1182.50Q760 1167 793.50 1137Q827 1107 846.50 1064.50Q866 1022 866 968L866 968Q866 912 848.50 871Q831 830 799 803.50Q767 777 723 764.50Q679 752 626 752L626 752ZM640 1920L1920 1920L1920 512L1664 512Q1637 512 1614 502Q1591 492 1573.50 474.50Q1556 457 1546 434Q1536 411 1536 384L1536 384L1536 128L640 128L640 512L1037 512Q1061 512 1081.50 521Q1102 530 1118 546Q1134 562 1143 582.50Q1152 603 1152 627L1152 627L1152 1549Q1152 1573 1143 1593.50Q1134 1614 1118 1630Q1102 1646 1081.50 1655Q1061 1664 1037 1664L1037 1664L640 1664L640 1920ZM1536 1024L1536 640Q1615 640 1685 670Q1755 700 1807.50 752.50Q1860 805 1890 875Q1920 945 1920 1024L1920 1024L1536 1024ZM1408 768L1408 768L1408 1152L1792 1152Q1792 1232 1762 1301.50Q1732 1371 1679.50 1423.50Q1627 1476 1557 1506Q1487 1536 1408 1536L1408 1536Q1375 1536 1343 1529.50Q1311 1523 1280 1512L1280 1512L1280 792Q1311 781 1343 774.50Q1375 768 1408 768ZM604 1068L604 1068L518 1068L518 883L608 883Q655 883 682 903Q709 923 709 973L709 973Q709 1025 681 1046.50Q653 1068 604 1068Z"
         }
      }
   ]
}

var PublicFolder = {
   name: "PublicFolder",
   vendor: "UiFabric",
   unicode: 61296,
   value: "",
   charCode: "EF70",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1635 1373L1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1130 1664L1293 1827L1203 1917L886 1600L1203 1283L1293 1373L1130 1536L1798 1536L1635 1373ZM128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 1408L1920 1280L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1536L768 1536L768 1664L0 1664L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384Z"
         }
      }
   ]
}

var PublicContactCard = {
   name: "PublicContactCard",
   vendor: "UiFabric",
   unicode: 61294,
   value: "",
   charCode: "EF6E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 768L1792 896L1152 896L1152 768L1792 768ZM1152 1280L1152 1152L1536 1152L1536 1280L1152 1280ZM826 1072L826 1072Q872 1098 908.50 1134Q945 1170 970.50 1213.50Q996 1257 1010 1306.50Q1024 1356 1024 1408L1024 1408L896 1408Q896 1355 876 1308.50Q856 1262 821 1227Q786 1192 739.50 1172Q693 1152 640 1152L640 1152Q587 1152 540.50 1172Q494 1192 459 1227Q424 1262 404 1308.50Q384 1355 384 1408L384 1408L256 1408Q256 1356 270 1306.50Q284 1257 309.50 1213.50Q335 1170 371.50 1134Q408 1098 454 1072L454 1072Q421 1037 402.50 991Q384 945 384 896L384 896Q384 843 404 796.50Q424 750 459 715Q494 680 540.50 660Q587 640 640 640L640 640Q693 640 739.50 660Q786 680 821 715Q856 750 876 796.50Q896 843 896 896L896 896Q896 945 877.50 991Q859 1037 826 1072ZM512 896L512 896Q512 923 522 946Q532 969 549.50 986.50Q567 1004 590 1014Q613 1024 640 1024L640 1024Q667 1024 690 1014Q713 1004 730.50 986.50Q748 969 758 946Q768 923 768 896L768 896Q768 869 758 846Q748 823 730.50 805.50Q713 788 690 778Q667 768 640 768L640 768Q613 768 590 778Q567 788 549.50 805.50Q532 823 522 846Q512 869 512 896ZM1638 1501L1729 1411L2046 1728L1729 2045L1638 1955L1801 1792L1143 1792L1306 1955L1215 2045L898 1728L1215 1411L1306 1501L1143 1664L1801 1664L1638 1501ZM0 256L2048 256L2048 1472L1920 1344L1920 384L128 384L128 1664L768 1664L768 1792L0 1792L0 256Z"
         }
      }
   ]
}

var DocumentSearch = {
   name: "DocumentSearch",
   vendor: "UiFabric",
   unicode: 61292,
   value: "",
   charCode: "EF6C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 896L1664 896Q1743 896 1813 926Q1883 956 1935 1008.50Q1987 1061 2017 1131Q2047 1201 2047 1280L2047 1280Q2047 1360 2017 1429.50Q1987 1499 1935 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547 1646Q1490 1628 1442 1593L1442 1593L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1351 1502Q1316 1454 1298 1397Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536ZM384 1664L1008 1664L880 1792L256 1792L256 0L1115 0L1664 549L1664 768L1536 768L1536 640L1024 640L1024 128L384 128L384 1664ZM1152 219L1152 512L1445 512L1152 219Z"
         }
      }
   ]
}

var SunQuestionMark = {
   name: "SunQuestionMark",
   vendor: "UiFabric",
   unicode: 61290,
   value: "",
   charCode: "EF6A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960L1408 960Q1408 1053 1373 1134.50Q1338 1216 1277 1277Q1216 1338 1134.50 1373Q1053 1408 960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1024 0L1024 384L896 384L896 0L1024 0ZM896 1920L896 1536L1024 1536L1024 1920L896 1920ZM384 896L384 1024L0 1024L0 896L384 896ZM598 507L507 598L236 326L326 236L598 507ZM1594 236L1684 326L1413 598L1322 507L1594 236ZM236 1594L507 1322L598 1413L326 1684L236 1594ZM1664 2048L1664 1920L1792 1920L1792 2048L1664 2048ZM1728 1152L1728 1152Q1781 1152 1827.50 1172Q1874 1192 1909 1227Q1944 1262 1964 1308.50Q1984 1355 1984 1408L1984 1408Q1984 1454 1970 1489Q1956 1524 1934.50 1552Q1913 1580 1888 1602.50Q1863 1625 1841.50 1647Q1820 1669 1806 1692Q1792 1715 1792 1744L1792 1744L1792 1792L1664 1792L1664 1744Q1664 1697 1678 1662.50Q1692 1628 1713.50 1600Q1735 1572 1760 1549.50Q1785 1527 1806.50 1505Q1828 1483 1842 1460Q1856 1437 1856 1408L1856 1408Q1856 1381 1846 1358Q1836 1335 1818.50 1317.50Q1801 1300 1778 1290Q1755 1280 1728 1280L1728 1280Q1701 1280 1678 1290Q1655 1300 1637.50 1317.50Q1620 1335 1610 1358Q1600 1381 1600 1408L1600 1408L1472 1408Q1472 1355 1492 1308.50Q1512 1262 1547 1227Q1582 1192 1628.50 1172Q1675 1152 1728 1152Z"
         }
      }
   ]
}

var Boards = {
   name: "Boards",
   vendor: "UiFabric",
   unicode: 61288,
   value: "",
   charCode: "EF68",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 256L1664 512L1920 512L1920 2048L640 2048L640 1792L384 1792L384 1536L128 1536L128 0L1408 0L1408 256L1664 256ZM256 1408L384 1408L384 256L1280 256L1280 128L256 128L256 1408ZM512 1664L640 1664L640 512L1536 512L1536 384L512 384L512 1664ZM768 1920L1792 1920L1792 640L768 640L768 1920Z"
         }
      }
   ]
}

var CollapseMenu = {
   name: "CollapseMenu",
   vendor: "UiFabric",
   unicode: 61286,
   value: "",
   charCode: "EF66",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 768L128 768L128 640L1920 640L1920 768ZM128 256L128 128L1920 128L1920 256L128 256ZM1920 1280L128 1280L128 1152L1920 1152L1920 1280ZM1920 1792L128 1792L128 1664L1920 1664L1920 1792Z"
         }
      }
   ]
}

var InboxCheck = {
   name: "InboxCheck",
   vendor: "UiFabric",
   unicode: 61284,
   value: "",
   charCode: "EF64",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1453 173L832 794L467 429L557 339L832 614L1363 83L1453 173ZM1618 370L1920 1276Q1921 1278 1921.50 1305Q1922 1332 1922 1374.50Q1922 1417 1922 1471Q1922 1525 1921.50 1582.50Q1921 1640 1921 1696Q1921 1752 1920.50 1798.50Q1920 1845 1920 1877.50Q1920 1910 1920 1920L1920 1920L0 1920Q0 1910 0 1877.50Q0 1845-0.50 1798.50Q-1 1752-1 1696Q-1 1640-1.50 1582.50Q-2 1525-2 1471Q-2 1417-2 1374.50Q-2 1332-1.50 1305Q-1 1278 0 1276L0 1276L238 562L339 664L134 1280L552 1280L680 1536L1240 1536L1368 1280L1786 1280L1517 471L1618 370ZM1792 1792L1792 1408L1448 1408L1320 1664L600 1664L472 1408L128 1408L128 1792L1792 1792Z"
         }
      }
   ]
}

var Lifesaver = {
   name: "Lifesaver",
   vendor: "UiFabric",
   unicode: 61282,
   value: "",
   charCode: "EF62",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1920 1024L1920 1024Q1920 952 1908.50 881Q1897 810 1874 741L1874 741Q1813 761 1752.50 781Q1692 801 1631 821L1631 821Q1664 919 1664 1024L1664 1024Q1664 1130 1631 1227L1631 1227L1874 1307Q1897 1238 1908.50 1167Q1920 1096 1920 1024ZM128 1024L128 1024Q128 1096 139.50 1167Q151 1238 174 1307L174 1307Q235 1287 295.50 1267Q356 1247 417 1227L417 1227Q384 1130 384 1024L384 1024Q384 919 417 821L417 821L174 741Q151 810 139.50 881Q128 952 128 1024ZM512 1024L512 1024Q512 1130 552.50 1223Q593 1316 662.50 1385.50Q732 1455 825 1495.50Q918 1536 1024 1536L1024 1536Q1130 1536 1223 1495.50Q1316 1455 1385.50 1385.50Q1455 1316 1495.50 1223Q1536 1130 1536 1024L1536 1024Q1536 918 1495.50 825Q1455 732 1385.50 662.50Q1316 593 1223 552.50Q1130 512 1024 512L1024 512Q918 512 825 552.50Q732 593 662.50 662.50Q593 732 552.50 825Q512 918 512 1024ZM1227 417L1307 174Q1238 151 1167 139.50Q1096 128 1024 128L1024 128Q952 128 881 139.50Q810 151 741 174L741 174Q761 235 781 295.50Q801 356 821 417L821 417Q918 384 1024 384L1024 384Q1129 384 1227 417L1227 417ZM821 1631L741 1874Q810 1897 881 1908.50Q952 1920 1024 1920L1024 1920Q1096 1920 1167 1908.50Q1238 1897 1307 1874L1307 1874Q1287 1813 1267 1752.50Q1247 1692 1227 1631L1227 1631Q1129 1664 1024 1664L1024 1664Q918 1664 821 1631L821 1631Z"
         }
      }
   ]
}

var EditStyle = {
   name: "EditStyle",
   vendor: "UiFabric",
   unicode: 61280,
   value: "",
   charCode: "EF60",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1120 1093L1055 896L609 896L524 1152L384 1152L768 0L896 0L1226 988L1120 1093ZM652 768L1012 768L832 228L652 768ZM1593 899L1593 899Q1635 899 1671.50 913.50Q1708 928 1734.50 954Q1761 980 1776.50 1015.50Q1792 1051 1792 1094L1792 1094Q1792 1133 1777 1170Q1762 1207 1734 1235L1734 1235L1017 1952L640 2046L734 1669L1451 953Q1479 925 1516.50 912Q1554 899 1593 899ZM951 1836L1643 1145Q1664 1124 1664 1094L1664 1094Q1664 1062 1643.50 1043.50Q1623 1025 1592 1025L1592 1025Q1578 1025 1565 1029Q1552 1033 1542 1043L1542 1043L850 1735L816 1870L951 1836Z"
         }
      }
   ]
}

var ReplyAlt = {
   name: "ReplyAlt",
   vendor: "UiFabric",
   unicode: 61278,
   value: "",
   charCode: "EF5E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 896L1920 896L1920 1024L475 1024L877 1427L787 1517L230 960L787 403L877 493L475 896L1920 896Z"
         }
      }
   ]
}

var Fax = {
   name: "Fax",
   vendor: "UiFabric",
   unicode: 61276,
   value: "",
   charCode: "EF5C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M320 1024L320 1024Q346 1024 365 1043Q384 1062 384 1088L384 1088Q384 1114 365 1133Q346 1152 320 1152L320 1152Q294 1152 275 1133Q256 1114 256 1088L256 1088Q256 1062 275 1043Q294 1024 320 1024ZM1408 384L1536 384Q1643 384 1741 433L1741 433Q1831 478 1890 551.50Q1949 625 1984.50 713Q2020 801 2034 898Q2048 995 2048 1088L2048 1088Q2048 1181 2034 1278Q2020 1375 1984.50 1463Q1949 1551 1890 1624.50Q1831 1698 1741 1743L1741 1743Q1643 1792 1536 1792L1536 1792L1408 1792L1408 2048L384 2048L384 1792L0 1792L0 896Q0 869 10 846Q20 823 37.50 805.50Q55 788 78 778Q101 768 128 768L128 768L384 768L384 0L1408 0L1408 384ZM512 128L512 768L1280 768L1280 128L512 128ZM1280 1920L1280 1408L512 1408L512 1920L1280 1920ZM384 1280L1536 1280L1536 896L128 896L128 1664L384 1664L384 1280ZM1472 1664L1536 1664Q1610 1664 1667.50 1638Q1725 1612 1767.50 1568Q1810 1524 1839.50 1466Q1869 1408 1886.50 1344Q1904 1280 1912 1214Q1920 1148 1920 1088L1920 1088Q1920 1028 1912 962Q1904 896 1886.50 832Q1869 768 1839.50 710Q1810 652 1767.50 608Q1725 564 1667.50 538Q1610 512 1536 512L1536 512L1472 512Q1446 512 1427 531Q1408 550 1408 576L1408 576L1408 704Q1408 732 1421 745.50Q1434 759 1453.50 764Q1473 769 1495.50 768.50Q1518 768 1536 768L1536 768Q1563 768 1586 778Q1609 788 1626.50 805.50Q1644 823 1654 846Q1664 869 1664 896L1664 896L1664 1280Q1664 1307 1654 1330Q1644 1353 1626.50 1370.50Q1609 1388 1586 1398Q1563 1408 1536 1408L1536 1408Q1518 1408 1495.50 1407.50Q1473 1407 1453.50 1412Q1434 1417 1421 1430.50Q1408 1444 1408 1472L1408 1472L1408 1600Q1408 1626 1427 1645Q1446 1664 1472 1664L1472 1664Z"
         }
      }
   ]
}

var ReceiptReply = {
   name: "ReceiptReply",
   vendor: "UiFabric",
   unicode: 61274,
   value: "",
   charCode: "EF5A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 256L704 256Q801 256 891 281Q981 306 1059.50 352Q1138 398 1202 462Q1266 526 1312 604.50Q1358 683 1383 773Q1408 863 1408 960L1408 960Q1408 1057 1383 1147Q1358 1237 1312 1315.50Q1266 1394 1202 1458Q1138 1522 1059.50 1568Q981 1614 891 1639Q801 1664 704 1664L704 1664Q607 1664 517 1639Q427 1614 348.50 1568Q270 1522 206 1458Q142 1394 96 1315.50Q50 1237 25 1147Q0 1057 0 960L0 960Q0 863 25 773Q50 683 96 604.50Q142 526 206 462Q270 398 348.50 352Q427 306 517 281Q607 256 704 256ZM704 1536L704 1536Q823 1536 928 1490.50Q1033 1445 1111 1367Q1189 1289 1234.50 1184Q1280 1079 1280 960L1280 960Q1280 841 1234.50 736Q1189 631 1111 553Q1033 475 928 429.50Q823 384 704 384L704 384Q585 384 480 429.50Q375 475 297 553Q219 631 173.50 736Q128 841 128 960L128 960Q128 1079 173.50 1184Q219 1289 297 1367Q375 1445 480 1490.50Q585 1536 704 1536ZM685 685L475 896L1152 896L1152 1024L475 1024L685 1235L595 1325L230 960L595 595L685 685ZM1664 1024L1664 896L2048 896L2048 1024L1664 1024ZM1536 512L2048 512L2048 640L1536 640L1536 512ZM1664 1408L1664 1280L2048 1280L2048 1408L1664 1408Z"
         }
      }
   ]
}

var PlayerSettings = {
   name: "PlayerSettings",
   vendor: "UiFabric",
   unicode: 61272,
   value: "",
   charCode: "EF58",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1547 35.50 1435Q71 1323 136.50 1227.50Q202 1132 293.50 1058.50Q385 985 496 946L496 946Q440 910 395.50 863Q351 816 320 760Q289 704 272.50 641.50Q256 579 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 579 1263.50 641.50Q1247 704 1216 760Q1185 816 1140.50 863Q1096 910 1040 946L1040 946Q1109 972 1172 1010.50Q1235 1049 1289 1099L1289 1099L1202 1194Q1113 1112 1001 1068Q889 1024 768 1024ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369L2038 1488ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792Z"
         }
      }
   ]
}

var ViewAll2 = {
   name: "ViewAll2",
   vendor: "UiFabric",
   unicode: 61270,
   value: "",
   charCode: "EF56",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L896 0L896 896L0 896L0 0ZM128 768L768 768L768 128L128 128L128 768ZM1920 1920L0 1920L0 1024L1920 1024L1920 1920ZM1792 1152L128 1152L128 1792L1792 1792L1792 1152ZM1024 896L1024 0L1920 0L1920 896L1024 896ZM1152 768L1792 768L1792 128L1152 128L1152 768Z"
         }
      }
   ]
}

var CaretTopLeftSolid8 = {
   name: "CaretTopLeftSolid8",
   vendor: "UiFabric",
   unicode: 61268,
   value: "",
   charCode: "EF54",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L0 0L1984 0L0 1984L0 0Z"
         }
      }
   ]
}

var SidePanel = {
   name: "SidePanel",
   vendor: "UiFabric",
   unicode: 61266,
   value: "",
   charCode: "EF52",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 256L2048 256L2048 1664L0 1664ZM512 640L128 640L128 1536L512 1536L512 640ZM640 1536L1920 1536L1920 640L640 640L640 1536ZM128 384L128 512L1920 512L1920 384L128 384Z"
         }
      }
   ]
}

var MarketDown = {
   name: "MarketDown",
   vendor: "UiFabric",
   unicode: 61250,
   value: "",
   charCode: "EF42",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1024L1920 1024L2048 1024L2048 1664L1408 1664L1408 1536L1829 1536L1152 859L768 1243L3 477L93 387L768 1061L1152 677L1920 1445L1920 1024Z"
         }
      }
   ]
}

var Eyedropper = {
   name: "Eyedropper",
   vendor: "UiFabric",
   unicode: 61244,
   value: "",
   charCode: "EF3C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1758 0L1758 0Q1818 0 1871 23Q1924 46 1963 85Q2002 124 2025 177Q2048 230 2048 290L2048 290Q2048 348 2026 401.50Q2004 455 1963 496L1963 496L1723 736Q1756 768 1774 808.50Q1792 849 1792 896L1792 896Q1792 942 1774.50 982Q1757 1022 1725 1054L1725 1054L1568 1211L1408 1050L603 1855L577 1856Q526 1858 489.50 1873Q453 1888 425.50 1909.50Q398 1931 375.50 1955Q353 1979 328 2000Q303 2021 273 2034.50Q243 2048 200 2048L200 2048Q159 2048 122.50 2032Q86 2016 59 1989Q32 1962 16 1925.50Q0 1889 0 1848L0 1848Q0 1805 13.50 1774.50Q27 1744 48 1719.50Q69 1695 93 1672.50Q117 1650 138.50 1622.50Q160 1595 175 1559Q190 1523 192 1471L192 1471L193 1445L998 640L837 480L994 323Q1026 291 1066 273.50Q1106 256 1152 256L1152 256Q1199 256 1239.50 274Q1280 292 1312 325L1312 325L1552 85Q1593 44 1646.50 22Q1700 0 1758 0ZM548 1729L1317 960L1088 731L319 1500Q314 1551 300 1591Q286 1631 264 1665.50Q242 1700 212.50 1731.50Q183 1763 149 1798L149 1798Q128 1819 128 1849L128 1849Q128 1878 149 1899Q170 1920 199 1920L199 1920Q229 1920 250 1899L250 1899Q285 1865 317 1835.50Q349 1806 383 1784Q417 1762 457 1748Q497 1734 548 1729L548 1729ZM1542 736L1872 405Q1920 357 1920 291L1920 291Q1920 258 1907 228Q1894 198 1872 176Q1850 154 1820 141Q1790 128 1757 128L1757 128Q1691 128 1643 176L1643 176L1312 506L1218 412Q1190 384 1152 384L1152 384Q1131 384 1112.50 394Q1094 404 1077.50 419Q1061 434 1046 450.50Q1031 467 1018 480L1018 480L1568 1030L1636 962Q1664 934 1664 896L1664 896Q1664 876 1656.50 859.50Q1649 843 1635 829L1635 829L1542 736Z"
         }
      }
   ]
}

var CalendarWorkWeek = {
   name: "CalendarWorkWeek",
   vendor: "UiFabric",
   unicode: 61265,
   value: "",
   charCode: "EF51",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM384 384L384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384ZM128 640L128 1792L1920 1792L1920 640L128 640ZM1664 1152L384 1152L384 768L1664 768L1664 1152ZM1536 896L512 896L512 1024L1536 1024L1536 896Z"
         }
      }
   ]
}

var GlobeFavorite = {
   name: "GlobeFavorite",
   vendor: "UiFabric",
   unicode: 61267,
   value: "",
   charCode: "EF53",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1696 1537L2031 1537L1765 1734L1867 2047L1600 1854L1334 2048L1435 1734L1169 1537L1504 1537L1601 1227L1696 1537ZM1410 1408L679 1408Q687 1445 702 1497Q717 1549 739 1606Q761 1663 790 1719Q819 1775 854.50 1820Q890 1865 932.50 1892.50Q975 1920 1024 1920L1024 1920Q1060 1920 1093 1903Q1126 1886 1152 1862L1152 1862L1152 2040Q1120 2044 1088 2046Q1056 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1123 2029 1219.50Q2010 1316 1973 1408L1973 1408L1792 1408L1792 1280L1883 1280Q1920 1157 1920 1024L1920 1024Q1920 891 1883 768L1883 768L1520 768Q1521 780 1525 816Q1529 852 1532 892.50Q1535 933 1536.50 966.50Q1538 1000 1536 1007L1536 1007L1410 1408ZM657 1280L1391 1280Q1400 1216 1404 1152.50Q1408 1089 1408 1024L1408 1024Q1408 959 1404 895.50Q1400 832 1391 768L1391 768L657 768Q648 832 644 895.50Q640 959 640 1024L640 1024Q640 1089 644 1152.50Q648 1216 657 1280L657 1280ZM1500 640L1833 640Q1795 559 1741 487Q1687 415 1621 356Q1555 297 1477.50 251.50Q1400 206 1315 177L1315 177Q1351 226 1380.50 282Q1410 338 1432.50 398Q1455 458 1471.50 519Q1488 580 1500 640L1500 640ZM1024 128L1024 128Q975 128 932.50 155.50Q890 183 854.50 228Q819 273 790 329Q761 385 739 442Q717 499 702 551Q687 603 679 640L679 640L1369 640Q1361 603 1346 551Q1331 499 1309 442Q1287 385 1258 329Q1229 273 1193.50 228Q1158 183 1115.50 155.50Q1073 128 1024 128ZM733 177L733 177Q648 206 570.50 251.50Q493 297 427 356Q361 415 307 487Q253 559 215 640L215 640L548 640Q560 580 576.50 519Q593 458 615.50 398Q638 338 667.50 282Q697 226 733 177ZM128 1024L128 1024Q128 1157 165 1280L165 1280L528 1280Q520 1216 516 1152.50Q512 1089 512 1024L512 1024Q512 959 516 895.50Q520 832 528 768L528 768L165 768Q128 891 128 1024ZM548 1408L215 1408Q253 1489 307 1561Q361 1633 427 1692Q493 1751 570.50 1796.50Q648 1842 733 1871L733 1871Q697 1822 667.50 1766Q638 1710 615.50 1650Q593 1590 576.50 1529Q560 1468 548 1408L548 1408Z"
         }
      }
   ]
}

var CaretTopRightSolid8 = {
   name: "CaretTopRightSolid8",
   vendor: "UiFabric",
   unicode: 61269,
   value: "",
   charCode: "EF55",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 0L64 0L2048 0L2048 1984L64 0Z"
         }
      }
   ]
}

var DocumentReply = {
   name: "DocumentReply",
   vendor: "UiFabric",
   unicode: 61271,
   value: "",
   charCode: "EF57",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1499 1536L1792 1536Q1845 1536 1891.50 1556Q1938 1576 1973 1611Q2008 1646 2028 1692.50Q2048 1739 2048 1792L2048 1792Q2048 1845 2028 1891.50Q2008 1938 1973 1973Q1938 2008 1891.50 2028Q1845 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373L1499 1536ZM256 1920L1347 1920L1475 2048L128 2048L128 0L1243 0L1792 549L1792 1278L1664 1150L1664 640L1152 640L1152 128L256 128L256 1920ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var ReceiptForward = {
   name: "ReceiptForward",
   vendor: "UiFabric",
   unicode: 61273,
   value: "",
   charCode: "EF59",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 256L704 256Q801 256 891 281Q981 306 1059.50 352Q1138 398 1202 462Q1266 526 1312 604.50Q1358 683 1383 773Q1408 863 1408 960L1408 960Q1408 1057 1383 1147Q1358 1237 1312 1315.50Q1266 1394 1202 1458Q1138 1522 1059.50 1568Q981 1614 891 1639Q801 1664 704 1664L704 1664Q607 1664 517 1639Q427 1614 348.50 1568Q270 1522 206 1458Q142 1394 96 1315.50Q50 1237 25 1147Q0 1057 0 960L0 960Q0 863 25 773Q50 683 96 604.50Q142 526 206 462Q270 398 348.50 352Q427 306 517 281Q607 256 704 256ZM704 1536L704 1536Q823 1536 928 1490.50Q1033 1445 1111 1367Q1189 1289 1234.50 1184Q1280 1079 1280 960L1280 960Q1280 841 1234.50 736Q1189 631 1111 553Q1033 475 928 429.50Q823 384 704 384L704 384Q585 384 480 429.50Q375 475 297 553Q219 631 173.50 736Q128 841 128 960L128 960Q128 1079 173.50 1184Q219 1289 297 1367Q375 1445 480 1490.50Q585 1536 704 1536ZM723 685L813 595L1178 960L813 1325L723 1235L933 1024L256 1024L256 896L933 896L723 685ZM1664 1024L1664 896L2048 896L2048 1024L1664 1024ZM1536 512L2048 512L2048 640L1536 640L1536 512ZM1664 1408L1664 1280L2048 1280L2048 1408L1664 1408Z"
         }
      }
   ]
}

var ReceiptCheck = {
   name: "ReceiptCheck",
   vendor: "UiFabric",
   unicode: 61275,
   value: "",
   charCode: "EF5B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 256L704 256Q801 256 891 281Q981 306 1059.50 352Q1138 398 1202 462Q1266 526 1312 604.50Q1358 683 1383 773Q1408 863 1408 960L1408 960Q1408 1057 1383 1147Q1358 1237 1312 1315.50Q1266 1394 1202 1458Q1138 1522 1059.50 1568Q981 1614 891 1639Q801 1664 704 1664L704 1664Q607 1664 517 1639Q427 1614 348.50 1568Q270 1522 206 1458Q142 1394 96 1315.50Q50 1237 25 1147Q0 1057 0 960L0 960Q0 863 25 773Q50 683 96 604.50Q142 526 206 462Q270 398 348.50 352Q427 306 517 281Q607 256 704 256ZM704 1536L704 1536Q823 1536 928 1490.50Q1033 1445 1111 1367Q1189 1289 1234.50 1184Q1280 1079 1280 960L1280 960Q1280 841 1234.50 736Q1189 631 1111 553Q1033 475 928 429.50Q823 384 704 384L704 384Q585 384 480 429.50Q375 475 297 553Q219 631 173.50 736Q128 841 128 960L128 960Q128 1079 173.50 1184Q219 1289 297 1367Q375 1445 480 1490.50Q585 1536 704 1536ZM576 1126L979 723L1069 813L576 1306L339 1069L429 979L576 1126ZM1664 1024L1664 896L2048 896L2048 1024L1664 1024ZM1536 512L2048 512L2048 640L1536 640L1536 512ZM1664 1408L1664 1280L2048 1280L2048 1408L1664 1408Z"
         }
      }
   ]
}

var RecurringEvent = {
   name: "RecurringEvent",
   vendor: "UiFabric",
   unicode: 61277,
   value: "",
   charCode: "EF5D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 640L256 1536L1024 1536L1024 1664L128 1664L128 128L384 128L384 0L512 0L512 128L1408 128L1408 0L1536 0L1536 128L1792 128L1792 1024L1664 1024L1664 640L256 640ZM384 256L256 256L256 512L1664 512L1664 256L1536 256L1536 384L1408 384L1408 256L512 256L512 384L384 384L384 256ZM1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1541 1280 1488.50 1300Q1436 1320 1394 1355.50Q1352 1391 1324 1440Q1296 1489 1286 1547L1286 1547L1159 1525Q1173 1444 1213 1376Q1253 1308 1311.50 1258Q1370 1208 1444 1180Q1518 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289L1920 1289L1920 1152ZM1600 1920L1600 1920Q1658 1920 1711 1900Q1764 1880 1806 1844.50Q1848 1809 1876 1760Q1904 1711 1914 1653L1914 1653L2041 1675Q2027 1756 1987 1824Q1947 1892 1888.50 1942Q1830 1992 1756 2020Q1682 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920Z"
         }
      }
   ]
}

var ReplyAllAlt = {
   name: "ReplyAllAlt",
   vendor: "UiFabric",
   unicode: 61279,
   value: "",
   charCode: "EF5F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M859 896L1920 896L1920 1024L859 1024L1261 1427L1171 1517L614 960L1171 403L1261 493L859 896ZM659 403L749 493L282 960L749 1427L659 1517L102 960L659 403Z"
         }
      }
   ]
}

var EditMail = {
   name: "EditMail",
   vendor: "UiFabric",
   unicode: 61281,
   value: "",
   charCode: "EF61",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M990 1669L1707 953Q1735 925 1772.50 912Q1810 899 1848 899L1848 899Q1890 899 1926 913.50Q1962 928 1988.50 954Q2015 980 2030.50 1016Q2046 1052 2046 1094L2046 1094Q2046 1133 2031 1170Q2016 1207 1988 1235L1988 1235L1273 1952L896 2046L990 1669ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1062 1899.50 1043.50Q1879 1025 1848 1025L1848 1025Q1834 1025 1821 1029Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836ZM0 384L2048 384L2048 834Q2019 813 1987 799.50Q1955 786 1920 778L1920 778L1920 648L1024 1095L128 648L128 1536L942 1536L814 1664L0 1664L0 384ZM143 512L1024 953L1905 512L143 512Z"
         }
      }
   ]
}

var LifesaverLock = {
   name: "LifesaverLock",
   vendor: "UiFabric",
   unicode: 61283,
   value: "",
   charCode: "EF63",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1408 1408L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024ZM1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920ZM512 1024L512 1024Q512 1130 552.50 1223Q593 1316 662.50 1385.50Q732 1455 825 1495.50Q918 1536 1024 1536L1024 1536Q1056 1536 1088 1532Q1120 1528 1152 1520L1152 1520L1152 1651Q1120 1657 1088 1660.50Q1056 1664 1024 1664L1024 1664Q972 1664 921.50 1656Q871 1648 822 1631L822 1631L741 1874Q810 1897 881 1908.50Q952 1920 1024 1920L1024 1920Q1089 1920 1152 1911L1152 1911L1152 2040Q1120 2044 1088 2046Q1056 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1104 2036 1183L2036 1183Q2021 1128 1991.50 1080Q1962 1032 1919 994L1919 994Q1916 864 1874 741L1874 741Q1813 761 1752.50 781.50Q1692 802 1631 822L1631 822Q1637 840 1642 858.50Q1647 877 1651 896L1651 896L1520 896Q1498 811 1450.50 740.50Q1403 670 1337.50 619Q1272 568 1191.50 540Q1111 512 1024 512L1024 512Q918 512 825 552.50Q732 593 662.50 662.50Q593 732 552.50 825Q512 918 512 1024ZM1024 128L1024 128Q952 128 881 139.50Q810 151 741 174L741 174Q761 235 781.50 295.50Q802 356 822 417L822 417Q871 400 921.50 392Q972 384 1024 384L1024 384Q1076 384 1126.50 392Q1177 400 1226 417L1226 417L1307 174Q1238 151 1167 139.50Q1096 128 1024 128ZM417 1226L417 1226Q400 1177 392 1126.50Q384 1076 384 1024L384 1024Q384 972 392 921.50Q400 871 417 822L417 822L174 741Q151 810 139.50 881Q128 952 128 1024L128 1024Q128 1096 139.50 1167Q151 1238 174 1307L174 1307Q235 1287 295.50 1266.50Q356 1246 417 1226Z"
         }
      }
   ]
}

var FolderSearch = {
   name: "FolderSearch",
   vendor: "UiFabric",
   unicode: 61285,
   value: "",
   charCode: "EF65",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 987Q1990 935 1920 904L1920 904L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L1091 1664L963 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM1728 1024L1728 1024Q1794 1024 1852 1049.50Q1910 1075 1953.50 1118.50Q1997 1162 2022.50 1220Q2048 1278 2048 1344L2048 1344Q2048 1410 2022.50 1468.50Q1997 1527 1953.50 1570.50Q1910 1614 1852 1639Q1794 1664 1728 1664L1728 1664Q1681 1664 1636 1650.50Q1591 1637 1552 1611L1552 1611L1133 2029Q1114 2048 1088 2048L1088 2048Q1062 2048 1043 2029Q1024 2010 1024 1984L1024 1984Q1024 1958 1043 1939L1043 1939L1461 1520Q1435 1481 1421.50 1436Q1408 1391 1408 1344L1408 1344Q1408 1278 1433 1220Q1458 1162 1501.50 1118.50Q1545 1075 1603.50 1049.50Q1662 1024 1728 1024ZM1728 1536L1728 1536Q1768 1536 1803 1521Q1838 1506 1864 1480Q1890 1454 1905 1419Q1920 1384 1920 1344L1920 1344Q1920 1304 1905 1269Q1890 1234 1864 1208Q1838 1182 1803 1167Q1768 1152 1728 1152L1728 1152Q1688 1152 1653 1167Q1618 1182 1592 1208Q1566 1234 1551 1269Q1536 1304 1536 1344L1536 1344Q1536 1384 1551 1419Q1566 1454 1592 1480Q1618 1506 1653 1521Q1688 1536 1728 1536Z"
         }
      }
   ]
}

var ExpandMenu = {
   name: "ExpandMenu",
   vendor: "UiFabric",
   unicode: 61287,
   value: "",
   charCode: "EF67",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 768L128 128L1920 128L1920 768L128 768ZM1920 1792L128 1792L128 1152L1920 1152L1920 1792Z"
         }
      }
   ]
}

var SunAdd = {
   name: "SunAdd",
   vendor: "UiFabric",
   unicode: 61289,
   value: "",
   charCode: "EF69",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960L1408 960Q1408 1053 1373 1134.50Q1338 1216 1277 1277Q1216 1338 1134.50 1373Q1053 1408 960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1024 0L1024 384L896 384L896 0L1024 0ZM896 1920L896 1536L1024 1536L1024 1920L896 1920ZM1536 1024L1536 896L1920 896L1920 1024L1536 1024ZM384 896L384 1024L0 1024L0 896L384 896ZM598 507L507 598L236 326L326 236L598 507ZM1684 326L1413 598L1322 507L1594 236L1684 326ZM236 1594L507 1322L598 1413L326 1684L236 1594ZM2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408L1792 1664L2048 1664Z"
         }
      }
   ]
}

var LandscapeOrientation = {
   name: "LandscapeOrientation",
   vendor: "UiFabric",
   unicode: 61291,
   value: "",
   charCode: "EF6B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1499 128L2048 677L2048 1792L0 1792L0 128L1499 128ZM1536 347L1536 640L1829 640L1536 347ZM128 1664L1920 1664L1920 768L1408 768L1408 256L128 256L128 1664Z"
         }
      }
   ]
}

var PublicCalendar = {
   name: "PublicCalendar",
   vendor: "UiFabric",
   unicode: 61293,
   value: "",
   charCode: "EF6D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1638 1373L1729 1283L2046 1600L1729 1917L1638 1827L1801 1664L1143 1664L1306 1827L1215 1917L898 1600L1215 1283L1306 1373L1143 1536L1801 1536L1638 1373ZM1664 640L256 640L256 1536L768 1536L768 1664L128 1664L128 128L384 128L384 0L512 0L512 128L1408 128L1408 0L1536 0L1536 128L1792 128L1792 1152L1664 1152L1664 640ZM384 384L384 256L256 256L256 512L1664 512L1664 256L1536 256L1536 384L1408 384L1408 256L512 256L512 384L384 384Z"
         }
      }
   ]
}

var PublicEmail = {
   name: "PublicEmail",
   vendor: "UiFabric",
   unicode: 61295,
   value: "",
   charCode: "EF6F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1798 1536L1635 1373L1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1130 1664L1293 1827L1203 1917L886 1600L1203 1283L1293 1373L1130 1536L1798 1536ZM0 1664L0 384L2048 384L2048 1408L1920 1280L1920 583L1024 1032L128 583L128 1536L768 1536L768 1664L0 1664ZM1777 512L271 512L1024 888L1777 512Z"
         }
      }
   ]
}

var WordDocument = {
   name: "WordDocument",
   vendor: "UiFabric",
   unicode: 61297,
   value: "",
   charCode: "EF71",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 475L2048 475L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L640 2048Q613 2048 590 2038Q567 2028 549.50 2010.50Q532 1993 522 1970Q512 1947 512 1920L512 1920L512 1664L115 1664Q91 1664 70.50 1655Q50 1646 34 1630Q18 1614 9 1593.50Q0 1573 0 1549L0 1549L0 627Q0 603 9 582.50Q18 562 34 546Q50 530 70.50 521Q91 512 115 512L115 512L512 512L512 128Q512 101 522 78Q532 55 549.50 37.50Q567 20 590 10Q613 0 640 0L640 0L1573 0Q1599 0 1622.50 9.50Q1646 19 1664 37L1664 37L2011 384Q2029 402 2038.50 425.50Q2048 449 2048 475ZM1829 384L1664 219L1664 384L1829 384ZM170 752L320 1424L481 1424Q483 1416 490.50 1381Q498 1346 508 1297.50Q518 1249 529.50 1194.50Q541 1140 551 1094Q561 1048 567.50 1018Q574 988 575 987L575 987Q575 987 582 1017.50Q589 1048 599.50 1094Q610 1140 622 1194.50Q634 1249 645 1297.50Q656 1346 664 1381.50Q672 1417 674 1424L674 1424L834 1424L982 752L834 752L754 1190L654 752L502 752L406 1192L320 752L170 752ZM640 1664L640 1920L1920 1920L1920 512L1664 512Q1637 512 1614 502Q1591 492 1573.50 474.50Q1556 457 1546 434Q1536 411 1536 384L1536 384L1536 128L640 128L640 512L1037 512Q1061 512 1081.50 521Q1102 530 1118 546Q1134 562 1143 582.50Q1152 603 1152 627L1152 627L1152 1549Q1152 1573 1143 1593.50Q1134 1614 1118 1630Q1102 1646 1081.50 1655Q1061 1664 1037 1664L1037 1664L640 1664ZM1792 896L1280 896L1280 768L1792 768L1792 896ZM1792 1152L1280 1152L1280 1024L1792 1024L1792 1152ZM1792 1408L1280 1408L1280 1280L1792 1280L1792 1408Z"
         }
      }
   ]
}

var ExcelDocument = {
   name: "ExcelDocument",
   vendor: "UiFabric",
   unicode: 61299,
   value: "",
   charCode: "EF73",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 475L2048 475L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L640 2048Q613 2048 590 2038Q567 2028 549.50 2010.50Q532 1993 522 1970Q512 1947 512 1920L512 1920L512 1664L115 1664Q91 1664 70.50 1655Q50 1646 34 1630Q18 1614 9 1593.50Q0 1573 0 1549L0 1549L0 627Q0 603 9 582.50Q18 562 34 546Q50 530 70.50 521Q91 512 115 512L115 512L512 512L512 128Q512 101 522 78Q532 55 549.50 37.50Q567 20 590 10Q613 0 640 0L640 0L1573 0Q1599 0 1622.50 9.50Q1646 19 1664 37L1664 37L2011 384Q2029 402 2038.50 425.50Q2048 449 2048 475ZM1829 384L1664 219L1664 384L1829 384ZM478 1087L261 1424L450 1424Q452 1420 462.50 1401Q473 1382 487 1356Q501 1330 516.50 1301Q532 1272 545.50 1247.50Q559 1223 568.50 1206.50Q578 1190 578 1190L578 1190Q605 1249 638.50 1308Q672 1367 703 1424L703 1424L890 1424L681 1085L886 752L707 752Q676 809 646.50 866Q617 923 584 978L584 978Q555 921 527 865Q499 809 470 752L470 752L279 752L478 1087ZM640 1664L640 1920L1920 1920L1920 512L1664 512Q1637 512 1614 502Q1591 492 1573.50 474.50Q1556 457 1546 434Q1536 411 1536 384L1536 384L1536 128L640 128L640 512L1037 512Q1061 512 1081.50 521Q1102 530 1118 546Q1134 562 1143 582.50Q1152 603 1152 627L1152 627L1152 1549Q1152 1573 1143 1593.50Q1134 1614 1118 1630Q1102 1646 1081.50 1655Q1061 1664 1037 1664L1037 1664L640 1664ZM1792 896L1280 896L1280 768L1792 768L1792 896ZM1792 1152L1280 1152L1280 1024L1792 1024L1792 1152ZM1792 1408L1280 1408L1280 1280L1792 1280L1792 1408Z"
         }
      }
   ]
}

var ClassroomLogo = {
   name: "ClassroomLogo",
   vendor: "UiFabric",
   unicode: 61301,
   value: "",
   charCode: "EF75",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q976 0 999 10Q1022 20 1045 34Q1068 48 1089 63Q1110 78 1122 88L1122 88Q1190 141 1262 211Q1334 281 1401 362Q1468 443 1527.50 532.50Q1587 622 1631.50 715.50Q1676 809 1702 903.50Q1728 998 1728 1088L1728 1088Q1728 1248 1677 1375Q1626 1502 1533.50 1591.50Q1441 1681 1311 1731.50Q1181 1782 1024 1789L1024 1789L1024 2048L896 2048L896 1789Q738 1782 608.50 1731.50Q479 1681 386.50 1591.50Q294 1502 243 1375Q192 1248 192 1088L192 1088Q192 998 218 903.50Q244 809 288.50 715.50Q333 622 392.50 532.50Q452 443 519 362Q586 281 657.50 211Q729 141 798 88L798 88Q810 78 831 63Q852 48 875 34Q898 20 920.50 10Q943 0 960 0ZM896 1661L896 192Q833 237 766 299Q699 361 635 433.50Q571 506 514 587Q457 668 413.50 752.50Q370 837 345 922Q320 1007 320 1088L320 1088Q320 1221 361 1324.50Q402 1428 477 1500.50Q552 1573 658.50 1613.50Q765 1654 896 1661L896 1661ZM1024 192L1024 716Q1072 713 1120.50 698.50Q1169 684 1214 661Q1259 638 1299 607Q1339 576 1372 541L1372 541Q1298 444 1211 354Q1124 264 1024 192L1024 192ZM1024 809L1024 1096Q1096 1096 1171 1081.50Q1246 1067 1316 1038Q1386 1009 1447 964.50Q1508 920 1551 860L1551 860Q1525 794 1491 732.50Q1457 671 1417 613L1417 613Q1380 652 1334.50 686.50Q1289 721 1238 747Q1187 773 1132.50 789Q1078 805 1024 809L1024 809ZM1024 1184L1024 1661Q1155 1654 1261.50 1613.50Q1368 1573 1443 1501Q1518 1429 1559 1325.50Q1600 1222 1600 1088L1600 1088Q1600 1053 1592.50 1025.50Q1585 998 1574 966L1574 966Q1524 1023 1459.50 1063.50Q1395 1104 1322.50 1130.50Q1250 1157 1173.50 1170Q1097 1183 1024 1184L1024 1184Z"
         }
      }
   ]
}

var EditPhoto = {
   name: "EditPhoto",
   vendor: "UiFabric",
   unicode: 61303,
   value: "",
   charCode: "EF77",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 576L1536 576Q1536 550 1555 531Q1574 512 1600 512L1600 512Q1626 512 1645 531Q1664 550 1664 576L1664 576Q1664 602 1645 621Q1626 640 1600 640L1600 640Q1574 640 1555 621Q1536 602 1536 576ZM128 1243L128 1664L860 1664L828 1792L0 1792L0 256L2048 256L2048 836Q2020 814 1987.50 799Q1955 784 1920 776L1920 776L1920 384L128 384L128 1061L576 614L960 998L1216 742L1477 1002L1386 1093L1216 922L1050 1088L1221 1258L1130 1349L576 794L128 1243ZM1920 1664L1920 1486L2048 1358L2048 1792L1614 1792L1742 1664L1920 1664ZM2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1670L1707 953Q1735 925 1772.50 912Q1810 899 1848 899L1848 899Q1890 899 1926.50 913.50Q1963 928 1990 954Q2017 980 2032.50 1015.50Q2048 1051 2048 1094ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1062 1899.50 1043.50Q1879 1025 1848 1025L1848 1025Q1834 1025 1821 1029Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836Z"
         }
      }
   ]
}

var ShareiOS = {
   name: "ShareiOS",
   vendor: "UiFabric",
   unicode: 61305,
   value: "",
   charCode: "EF79",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1408L1024 250L749 525L659 435L1088 6L1517 435L1427 525L1152 250L1152 1408L1024 1408ZM1280 768L1280 640L1792 640L1792 2048L384 2048L384 640L896 640L896 768L512 768L512 1920L1664 1920L1664 768L1280 768Z"
         }
      }
   ]
}

var PencilReply = {
   name: "PencilReply",
   vendor: "UiFabric",
   unicode: 61307,
   value: "",
   charCode: "EF7B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 336L2048 336Q2048 402 2023 463.50Q1998 525 1950 573L1950 573L633 1890L0 2048L158 1415L1475 98Q1523 50 1584.50 25Q1646 0 1712 0L1712 0Q1782 0 1843 26.50Q1904 53 1949.50 98.50Q1995 144 2021.50 205Q2048 266 2048 336ZM1920 336L1920 336Q1920 293 1903.50 255Q1887 217 1859 189Q1831 161 1793 144.50Q1755 128 1712 128L1712 128Q1674 128 1645.50 138.50Q1617 149 1592.50 167Q1568 185 1546 208Q1524 231 1499 256L1499 256L1792 549Q1817 524 1840 502Q1863 480 1881 455.50Q1899 431 1909.50 402.50Q1920 374 1920 336ZM1408 347L326 1428Q433 1463 509 1539Q585 1615 620 1722L620 1722L1701 640L1408 347ZM258 1543L176 1872L505 1790Q495 1744 472.50 1703Q450 1662 418 1630Q386 1598 345 1575.50Q304 1553 258 1543L258 1543ZM1499 1536L1792 1536Q1845 1536 1891.50 1556Q1938 1576 1973 1611Q2008 1646 2028 1692.50Q2048 1739 2048 1792L2048 1792Q2048 1845 2028 1891.50Q2008 1938 1973 1973Q1938 2008 1891.50 2028Q1845 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1253 1600L1571 1283L1661 1373L1499 1536Z"
         }
      }
   ]
}

var SkypeCircleCheck = {
   name: "SkypeCircleCheck",
   vendor: "UiFabric",
   unicode: 61309,
   value: "",
   charCode: "EF7D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM907 1347L907 1347Q929 1347 949 1338.50Q969 1330 984 1315L984 1315L1413 886Q1428 871 1436 851Q1444 831 1444 810L1444 810Q1444 788 1435.50 768Q1427 748 1412.50 733.50Q1398 719 1378 710.50Q1358 702 1336 702L1336 702Q1315 702 1294.50 710Q1274 718 1259 733L1259 733L907 1085L789 967Q757 935 712 935L712 935Q690 935 670 943.50Q650 952 635 967Q620 982 611.50 1001.50Q603 1021 603 1043L603 1043Q603 1064 611.50 1084.50Q620 1105 635 1120L635 1120L830 1315Q845 1330 865.50 1338.50Q886 1347 907 1347Z"
         }
      }
   ]
}

var SkypeCircleMinus = {
   name: "SkypeCircleMinus",
   vendor: "UiFabric",
   unicode: 61311,
   value: "",
   charCode: "EF7F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM701 1132L1347 1132Q1369 1132 1389 1123.50Q1409 1115 1423.50 1100.50Q1438 1086 1446.50 1066.50Q1455 1047 1455 1024L1455 1024Q1455 1002 1446.50 982Q1438 962 1423.50 947.50Q1409 933 1389 924.50Q1369 916 1347 916L1347 916L701 916Q678 916 658.50 924.50Q639 933 624.50 947.50Q610 962 601.50 982Q593 1002 593 1024L593 1024Q593 1047 601.50 1066.50Q610 1086 624.50 1100.50Q639 1115 658.50 1123.50Q678 1132 701 1132L701 1132Z"
         }
      }
   ]
}

var SkypeClock = {
   name: "SkypeClock",
   vendor: "UiFabric",
   unicode: 61313,
   value: "",
   charCode: "EF81",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1171L1431 1705Q1459 1733 1474 1770.50Q1489 1808 1489 1847L1489 1847Q1489 1889 1473.50 1925.50Q1458 1962 1431 1989Q1404 2016 1367.50 2032Q1331 2048 1289 2048L1289 2048Q1206 2048 1147 1989L1147 1989L553 1396Q525 1368 510 1330.50Q495 1293 495 1254L495 1254L495 201Q495 159 510.50 122.50Q526 86 553 59Q580 32 616.50 16Q653 0 695 0L695 0Q737 0 773.50 16Q810 32 837 59Q864 86 880 122.50Q896 159 896 201L896 201L896 1171Z"
         }
      }
   ]
}

var SkypeMessage = {
   name: "SkypeMessage",
   vendor: "UiFabric",
   unicode: 61315,
   value: "",
   charCode: "EF83",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 87L1024 87Q1151 87 1276.50 95.50Q1402 104 1527 130L1527 130Q1652 156 1753.50 218.50Q1855 281 1925 388L1925 388Q1991 490 2019.50 611.50Q2048 733 2048 853L2048 853Q2048 951 2032.50 1038.50Q2017 1126 1982.50 1204Q1948 1282 1893 1351Q1838 1420 1759 1480L1759 1480Q1605 1598 1453 1713.50Q1301 1829 1147 1946L1147 1946Q1127 1961 1100 1961L1100 1961Q1083 1961 1069.50 1954Q1056 1947 1045.50 1935.50Q1035 1924 1029.50 1909.50Q1024 1895 1024 1879L1024 1879L1024 1597L770 1597Q709 1597 645.50 1592Q582 1587 520 1574Q458 1561 399 1538Q340 1515 289 1480L289 1480Q211 1426 156 1355.50Q101 1285 66.50 1204Q32 1123 16 1034Q0 945 0 853L0 853Q0 729 28.50 611Q57 493 126 388L126 388Q198 279 296 217.50Q394 156 521 130L521 130Q646 104 771.50 95.50Q897 87 1024 87ZM576 1024L1088 1024Q1114 1024 1133 1005Q1152 986 1152 960L1152 960Q1152 934 1133 915Q1114 896 1088 896L1088 896L576 896Q550 896 531 915Q512 934 512 960L512 960Q512 986 531 1005Q550 1024 576 1024L576 1024ZM580 768L1468 768Q1497 768 1516.50 750.50Q1536 733 1536 704L1536 704Q1536 675 1516.50 657.50Q1497 640 1468 640L1468 640L580 640Q552 640 532 657.50Q512 675 512 704L512 704Q512 733 532 750.50Q552 768 580 768L580 768Z"
         }
      }
   ]
}

var ATPLogo = {
   name: "ATPLogo",
   vendor: "UiFabric",
   unicode: 61317,
   value: "",
   charCode: "EF85",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1013 0 1058.50 6.50Q1104 13 1147 26.50Q1190 40 1231.50 60Q1273 80 1317 108L1317 108Q1391 154 1462.50 183Q1534 212 1607 228Q1680 244 1757 250Q1834 256 1920 256L1920 256L1920 608Q1920 765 1889.50 916.50Q1859 1068 1800.50 1208Q1742 1348 1658 1474Q1574 1600 1467.50 1707.50Q1361 1815 1233 1901.50Q1105 1988 960 2048L960 2048Q815 1988 687 1901.50Q559 1815 452.50 1707.50Q346 1600 262 1474Q178 1348 119.50 1208Q61 1068 30.50 917Q0 766 0 608L0 608L0 256Q87 256 164 250Q241 244 313.50 228Q386 212 457.50 183Q529 154 604 107L604 107Q647 80 689 60Q731 40 773.50 26.50Q816 13 862 6.50Q908 0 960 0ZM1792 608L1792 382Q1640 375 1506 333.50Q1372 292 1243 212L1243 212Q1175 169 1108.50 148.50Q1042 128 960 128L960 128Q878 128 811 149Q744 170 676 213L676 213Q548 293 413.50 334Q279 375 128 382L128 382L128 608Q128 818 186.50 1014.50Q245 1211 353 1380.50Q461 1550 615 1685Q769 1820 960 1908L960 1908Q1151 1820 1305 1685Q1459 1550 1567 1380.50Q1675 1211 1733.50 1014.50Q1792 818 1792 608L1792 608ZM960 256L960 256Q1022 256 1070.50 270.50Q1119 285 1171 318L1171 318Q1286 391 1407 435.50Q1528 480 1664 499L1664 499L1664 608Q1664 790 1614.50 962.50Q1565 1135 1473.50 1285.50Q1382 1436 1252 1559Q1122 1682 960 1766L960 1766Q798 1682 667.50 1559Q537 1436 445.50 1285.50Q354 1135 305 962.50Q256 790 256 608L256 608L256 499Q392 480 512 436.50Q632 393 747 319L747 319Q798 287 848 271.50Q898 256 960 256ZM1312 896L1056 896L1184 640L960 640L736 1088L928 1088L736 1472L1312 896Z"
         }
      }
   ]
}

var RecycleBin = {
   name: "RecycleBin",
   vendor: "UiFabric",
   unicode: 61319,
   value: "",
   charCode: "EF87",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M807 1326L752 1437L935 1437L935 1589L782 1589Q750 1589 734 1560L734 1560Q728 1549 713 1522Q698 1495 681.50 1465.50Q665 1436 652.50 1410.50Q640 1385 640 1376L640 1376Q640 1360 647.50 1342Q655 1324 665.50 1306Q676 1288 686.50 1271.50Q697 1255 704 1244L704 1244L640 1193L837 1193L884 1387L807 1326ZM802 1046L862 927Q869 913 881.50 904.50Q894 896 910 896L910 896L1131 896Q1163 896 1179 926L1179 926L1233 1027L1291 983L1261 1190L1043 1170L1105 1124L1013 945L929 1110L802 1046ZM1298 1449L1231 1326L1353 1254Q1357 1263 1366.50 1279.50Q1376 1296 1385 1314Q1394 1332 1401 1349Q1408 1366 1408 1376L1408 1376Q1408 1388 1402 1400L1402 1400L1317 1568Q1310 1582 1297 1589.50Q1284 1597 1269 1597L1269 1597L1135 1597L1135 1664L1011 1498L1135 1346L1135 1449L1298 1449ZM1024 0L1024 0Q1102 0 1180 6Q1258 12 1336 23L1336 23Q1381 30 1441.50 43Q1502 56 1567 76Q1632 96 1695 124.50Q1758 153 1808 191Q1858 229 1889 277Q1920 325 1920 384L1920 384Q1920 401 1917 414.50Q1914 428 1910 444L1910 444L1595 1851Q1465 1948 1326.50 1998Q1188 2048 1025 2048L1025 2048Q863 2048 724 1998Q585 1948 456 1851L456 1851L137 441Q134 427 131 413Q128 399 128 384L128 384Q128 325 159 277Q190 229 240 191Q290 153 353 124.50Q416 96 481 76Q546 56 606.50 43Q667 30 712 23L712 23Q790 12 868 6Q946 0 1024 0ZM1480 1776L1739 622Q1665 663 1575.50 691Q1486 719 1391.50 736Q1297 753 1202.50 760.50Q1108 768 1024 768L1024 768Q940 768 846 760.50Q752 753 657.50 736Q563 719 473.50 691Q384 663 310 622L310 622L570 1776Q670 1846 787 1881.50Q904 1917 1026 1917L1026 1917Q1147 1917 1263.50 1881.50Q1380 1846 1480 1776L1480 1776ZM1024 640L1024 640Q1074 640 1135.50 637Q1197 634 1263 626Q1329 618 1396 605.50Q1463 593 1526 574Q1589 555 1643.50 529Q1698 503 1739 469L1739 469Q1757 454 1774.50 432Q1792 410 1792 384L1792 384Q1792 358 1774.50 336Q1757 314 1739 299L1739 299Q1698 265 1643.50 239Q1589 213 1526 194Q1463 175 1396 162.50Q1329 150 1263 142Q1197 134 1135.50 131Q1074 128 1024 128L1024 128Q973 128 912 131Q851 134 785 142Q719 150 652 162.50Q585 175 522 194Q459 213 404.50 239Q350 265 309 299L309 299Q291 314 273.50 336Q256 358 256 384L256 384Q256 410 273.50 432Q291 454 309 469L309 469Q350 503 404.50 529Q459 555 522 574Q585 593 652 605.50Q719 618 785 626Q851 634 912 637Q973 640 1024 640Z"
         }
      }
   ]
}

var Hide2 = {
   name: "Hide2",
   vendor: "UiFabric",
   unicode: 61321,
   value: "",
   charCode: "EF89",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333ZM0 1024L1 1026L0 1029L0 1024ZM1911 1041L1911 1041Q1893 937 1848 848Q1803 759 1737 686Q1671 613 1589 557Q1507 501 1414 462.50Q1321 424 1222 404Q1123 384 1024 384L1024 384Q915 384 806.50 408Q698 432 598.50 478Q499 524 413 591Q327 658 263.50 743Q200 828 164 931Q128 1034 128 1152L128 1152L0 1152Q0 1016 40.50 897Q81 778 153 678.50Q225 579 322.50 500.50Q420 422 533.50 367.50Q647 313 772 284.50Q897 256 1024 256L1024 256Q1149 256 1273.50 284.50Q1398 313 1511 366.50Q1624 420 1721.50 497.50Q1819 575 1891 673.50Q1963 772 2004.50 890Q2046 1008 2048 1143L2048 1143Q1987 1084 1911 1041ZM1024 896L1024 896Q971 896 924.50 916Q878 936 843 971Q808 1006 788 1052.50Q768 1099 768 1152L768 1152Q768 1200 785 1243.50Q802 1287 831.50 1321Q861 1355 901.50 1377.50Q942 1400 990 1406L990 1406Q970 1470 964 1531L964 1531Q894 1520 835 1486Q776 1452 732.50 1401.50Q689 1351 664.50 1287Q640 1223 640 1152L640 1152Q640 1073 670 1003Q700 933 752.50 880.50Q805 828 874.50 798Q944 768 1024 768L1024 768Q1081 768 1135 784.50Q1189 801 1235 831.50Q1281 862 1317.50 905Q1354 948 1377 1000L1377 1000Q1315 1023 1262 1057L1262 1057Q1247 1021 1223 991Q1199 961 1168 940Q1137 919 1100 907.50Q1063 896 1024 896Z"
         }
      }
   ]
}

var BirthdayCake = {
   name: "BirthdayCake",
   vendor: "UiFabric",
   unicode: 61325,
   value: "",
   charCode: "EF8D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1920L1920 1920L1920 2048L0 2048L0 1920L128 1920L128 1344Q128 1278 153 1220Q178 1162 221.50 1118.50Q265 1075 323.50 1049.50Q382 1024 448 1024L448 1024L896 1024L896 672Q896 663 903.50 656.50Q911 650 921.50 646.50Q932 643 943 641.50Q954 640 960 640L960 640Q966 640 977 641.50Q988 643 998.50 646.50Q1009 650 1016.50 656.50Q1024 663 1024 672L1024 672L1024 1024L1472 1024Q1538 1024 1596 1049.50Q1654 1075 1697.50 1118.50Q1741 1162 1766.50 1220Q1792 1278 1792 1344L1792 1344L1792 1920ZM1472 1152L448 1152Q411 1152 378 1165Q345 1178 319.50 1201Q294 1224 277.50 1255.50Q261 1287 257 1323L257 1323Q294 1364 343.50 1386Q393 1408 448 1408L448 1408Q514 1408 562.50 1381.50Q611 1355 653 1306L653 1306Q664 1294 675.50 1287Q687 1280 704 1280L704 1280Q721 1280 732.50 1287Q744 1294 755 1306L755 1306Q797 1355 845.50 1381.50Q894 1408 960 1408L960 1408Q1026 1408 1074.50 1381.50Q1123 1355 1165 1306L1165 1306Q1176 1294 1187.50 1287Q1199 1280 1216 1280L1216 1280Q1233 1280 1244.50 1287Q1256 1294 1267 1306L1267 1306Q1309 1355 1357.50 1381.50Q1406 1408 1472 1408L1472 1408Q1527 1408 1576.50 1386Q1626 1364 1663 1323L1663 1323Q1659 1287 1642.50 1255.50Q1626 1224 1600.50 1201Q1575 1178 1542 1165Q1509 1152 1472 1152L1472 1152ZM256 1485L256 1920L1664 1920L1664 1485Q1616 1509 1571 1522.50Q1526 1536 1472 1536L1472 1536Q1400 1536 1335 1511.50Q1270 1487 1216 1439L1216 1439Q1162 1487 1097 1511.50Q1032 1536 960 1536L960 1536Q888 1536 823 1511.50Q758 1487 704 1439L704 1439Q650 1487 585 1511.50Q520 1536 448 1536L448 1536Q394 1536 349 1522.50Q304 1509 256 1485L256 1485ZM960 512L960 512Q934 512 915 493Q896 474 896 448L896 448Q896 436 904 417Q912 398 922.50 377Q933 356 943.50 337Q954 318 960 307L960 307Q966 318 976.50 337Q987 356 997.50 377Q1008 398 1016 417Q1024 436 1024 448L1024 448Q1024 474 1005 493Q986 512 960 512Z"
         }
      }
   ]
}

var ClearFilter = {
   name: "ClearFilter",
   vendor: "UiFabric",
   unicode: 61327,
   value: "",
   charCode: "EF8F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 347L0 128L2048 128L2048 347L1280 1115L1280 1920L768 1920L768 1115L0 347ZM1152 1061L1920 293L1920 256L128 256L128 293L896 1061L896 1792L1152 1792L1152 1061ZM1728 1510L1957 1280L2048 1371L1818 1600L2048 1829L1957 1920L1728 1690L1499 1920L1408 1829L1638 1600L1408 1371L1499 1280L1728 1510Z"
         }
      }
   ]
}

var FixedAssetManagement = {
   name: "FixedAssetManagement",
   vendor: "UiFabric",
   unicode: 61331,
   value: "",
   charCode: "EF93",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1024L1792 1280L2048 1280L2048 2048L1024 2048L1024 1280L1280 1280L1280 1024L1792 1024ZM1664 1152L1408 1152L1408 1280L1664 1280L1664 1152ZM1152 1920L1920 1920L1920 1664L1792 1664L1792 1792L1664 1792L1664 1664L1408 1664L1408 1792L1280 1792L1280 1664L1152 1664L1152 1920ZM1152 1536L1920 1536L1920 1408L1152 1408L1152 1536ZM512 1024L1152 1024L1152 1152L896 1152L896 1408L640 1408L640 1280L768 1280L768 1152L512 1152L512 1408L0 1408L0 640L128 640L128 128L1664 128L1664 896L1536 896L1536 256L256 256L256 640L512 640L512 1024ZM128 1280L384 1280L384 768L128 768L128 1280Z"
         }
      }
   ]
}

var TimeEntry = {
   name: "TimeEntry",
   vendor: "UiFabric",
   unicode: 61333,
   value: "",
   charCode: "EF95",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1152L1536 1408L1728 1408L1728 1536L1408 1536L1408 1152L1536 1152ZM1280 384L1280 512L256 512L256 384L1280 384ZM1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM256 768L1166 768Q1057 816 966 896L966 896L256 896L256 768ZM256 1152L775 1152Q761 1183 749.50 1215Q738 1247 729 1280L729 1280L256 1280L256 1152ZM256 1664L256 1536L707 1536Q710 1568 715.50 1600Q721 1632 729 1664L729 1664L256 1664ZM128 1920L850 1920Q900 1991 966 2048L966 2048L0 2048L0 0L1536 0L1536 707Q1520 706 1504 705Q1488 704 1472 704L1472 704Q1456 704 1440 705Q1424 706 1408 707L1408 707L1408 128L128 128L128 1920Z"
         }
      }
   ]
}

var Compare = {
   name: "Compare",
   vendor: "UiFabric",
   unicode: 61527,
   value: "",
   charCode: "F057",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L1603 256L1817 896L1920 896L1920 1024L1898 1024Q1878 1081 1841.50 1128.50Q1805 1176 1757.50 1209.50Q1710 1243 1653.50 1261.50Q1597 1280 1536 1280L1536 1280Q1475 1280 1418.50 1261.50Q1362 1243 1314.50 1209.50Q1267 1176 1230.50 1128.50Q1194 1081 1174 1024L1174 1024L1152 1024L1152 896L1255 896L1469 256L1024 256L1024 1666Q1191 1677 1340.50 1741.50Q1490 1806 1613 1920L1613 1920L1792 1920L1792 2048L128 2048L128 1920L307 1920Q430 1806 579.50 1741.50Q729 1677 896 1666L896 1666L896 256L451 256L665 896L768 896L768 1024L746 1024Q726 1081 689.50 1128.50Q653 1176 605.50 1209.50Q558 1243 501.50 1261.50Q445 1280 384 1280L384 1280Q323 1280 266.50 1261.50Q210 1243 162.50 1209.50Q115 1176 78.50 1128.50Q42 1081 22 1024L22 1024L0 1024L0 896L103 896L317 256L0 256L0 128L896 128L896 0L1024 0L1024 128L1920 128L1920 256ZM530 896L384 458L238 896L530 896ZM384 1152L384 1152Q453 1152 512 1118Q571 1084 606 1024L606 1024L162 1024Q197 1084 256 1118Q315 1152 384 1152ZM516 1920L1404 1920Q1304 1857 1191 1824.50Q1078 1792 960 1792L960 1792Q842 1792 729 1824.50Q616 1857 516 1920L516 1920ZM1682 896L1536 458L1390 896L1682 896ZM1536 1152L1536 1152Q1605 1152 1664 1118Q1723 1084 1758 1024L1758 1024L1314 1024Q1349 1084 1408 1118Q1467 1152 1536 1152Z"
         }
      }
   ]
}

var MessageFriendRequest = {
   name: "MessageFriendRequest",
   vendor: "UiFabric",
   unicode: 61525,
   value: "",
   charCode: "F055",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1152Q2036 1129 2021.50 1103Q2007 1077 1990.50 1051.50Q1974 1026 1956 1002Q1938 978 1920 960L1920 960L1920 640L1024 1088L128 640L128 1536L1088 1536L1152 1664L0 1664L0 384ZM1024 953L1905 512L143 512L1024 953ZM1808 1587L1808 1587Q1863 1616 1907.50 1658.50Q1952 1701 1983.50 1752.50Q2015 1804 2031.50 1862.50Q2048 1921 2048 1984L2048 1984L2048 2048L1920 2048L1920 1984Q1920 1918 1894.50 1860Q1869 1802 1825.50 1758.50Q1782 1715 1724 1689.50Q1666 1664 1600 1664L1600 1664Q1534 1664 1475.50 1689.50Q1417 1715 1373.50 1758.50Q1330 1802 1305 1860Q1280 1918 1280 1984L1280 1984L1280 2048L1152 2048L1152 1984Q1152 1921 1168.50 1862.50Q1185 1804 1216.50 1752.50Q1248 1701 1292 1658.50Q1336 1616 1392 1587L1392 1587Q1338 1541 1309 1477.50Q1280 1414 1280 1344L1280 1344Q1280 1278 1305 1220Q1330 1162 1373.50 1118.50Q1417 1075 1475.50 1049.50Q1534 1024 1600 1024L1600 1024Q1666 1024 1724 1049.50Q1782 1075 1825.50 1118.50Q1869 1162 1894.50 1220Q1920 1278 1920 1344L1920 1344Q1920 1414 1891 1477.50Q1862 1541 1808 1587ZM1408 1344L1408 1344Q1408 1384 1423 1419Q1438 1454 1464 1480Q1490 1506 1525 1521Q1560 1536 1600 1536L1600 1536Q1640 1536 1675 1521Q1710 1506 1736 1480Q1762 1454 1777 1419Q1792 1384 1792 1344L1792 1344Q1792 1304 1777 1269Q1762 1234 1736 1208Q1710 1182 1675 1167Q1640 1152 1600 1152L1600 1152Q1560 1152 1525 1167Q1490 1182 1464 1208Q1438 1234 1423 1269Q1408 1304 1408 1344Z"
         }
      }
   ]
}

var Archive = {
   name: "Archive",
   vendor: "UiFabric",
   unicode: 61503,
   value: "",
   charCode: "F03F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 768L1920 768L1920 1920L128 1920L128 768L0 768L0 128ZM256 1792L1792 1792L1792 768L256 768L256 1792ZM128 640L1920 640L1920 256L128 256L128 640ZM1408 1024L1408 1152L640 1152L640 1024L1408 1024Z"
         }
      }
   ]
}

var PageShared = {
   name: "PageShared",
   vendor: "UiFabric",
   unicode: 61485,
   value: "",
   charCode: "F02D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1850 1712L1850 1712Q1896 1737 1932.50 1773Q1969 1809 1994.50 1853Q2020 1897 2034 1946.50Q2048 1996 2048 2048L2048 2048L1920 2048Q1920 1995 1900 1948.50Q1880 1902 1845 1867Q1810 1832 1763.50 1812Q1717 1792 1664 1792L1664 1792Q1611 1792 1564.50 1812Q1518 1832 1483 1867Q1448 1902 1428 1948.50Q1408 1995 1408 2048L1408 2048L1280 2048Q1280 1996 1294 1946.50Q1308 1897 1333.50 1853Q1359 1809 1395.50 1773Q1432 1737 1478 1712L1478 1712Q1445 1677 1426.50 1631Q1408 1585 1408 1536L1408 1536Q1408 1483 1428 1436.50Q1448 1390 1483 1355Q1518 1320 1564.50 1300Q1611 1280 1664 1280L1664 1280Q1717 1280 1763.50 1300Q1810 1320 1845 1355Q1880 1390 1900 1436.50Q1920 1483 1920 1536L1920 1536Q1920 1585 1901.50 1631Q1883 1677 1850 1712ZM1536 1536L1536 1536Q1536 1563 1546 1586Q1556 1609 1573.50 1626.50Q1591 1644 1614 1654Q1637 1664 1664 1664L1664 1664Q1691 1664 1714 1654Q1737 1644 1754.50 1626.50Q1772 1609 1782 1586Q1792 1563 1792 1536L1792 1536Q1792 1509 1782 1486Q1772 1463 1754.50 1445.50Q1737 1428 1714 1418Q1691 1408 1664 1408L1664 1408Q1637 1408 1614 1418Q1591 1428 1573.50 1445.50Q1556 1463 1546 1486Q1536 1509 1536 1536ZM1664 640L1152 640L1152 128L256 128L256 1920L1136 1920Q1128 1952 1124 1984Q1120 2016 1120 2048L1120 2048L128 2048L128 0L1243 0L1792 549L1792 1140Q1729 1120 1664 1120L1664 1120L1664 640ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var TextDocumentShared = {
   name: "TextDocumentShared",
   vendor: "UiFabric",
   unicode: 61483,
   value: "",
   charCode: "F02B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 896L1408 1024L512 1024L512 896L1408 896ZM512 1280L512 1152L1408 1152L1408 1208Q1367 1240 1336 1280L1336 1280L512 1280ZM512 1536L512 1408L1268 1408Q1248 1471 1248 1536L1248 1536L512 1536ZM256 128L256 1920L1136 1920Q1120 1981 1120 2048L1120 2048L128 2048L128 0L1243 0L1792 549L1792 1140Q1729 1120 1664 1120L1664 1120L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM1848 1713L1848 1713Q1894 1738 1931 1774Q1968 1810 1994 1853.50Q2020 1897 2034 1946.50Q2048 1996 2048 2048L2048 2048L1920 2048Q1920 1995 1900 1948.50Q1880 1902 1845 1867Q1810 1832 1763.50 1812Q1717 1792 1664 1792L1664 1792Q1611 1792 1564.50 1812Q1518 1832 1483 1867Q1448 1902 1428 1948.50Q1408 1995 1408 2048L1408 2048L1280 2048Q1280 1996 1294 1946.50Q1308 1897 1334 1853.50Q1360 1810 1397 1774Q1434 1738 1480 1713L1480 1713Q1446 1678 1427 1632Q1408 1586 1408 1536L1408 1536Q1408 1483 1428 1436.50Q1448 1390 1483 1355Q1518 1320 1564.50 1300Q1611 1280 1664 1280L1664 1280Q1717 1280 1763.50 1300Q1810 1320 1845 1355Q1880 1390 1900 1436.50Q1920 1483 1920 1536L1920 1536Q1920 1586 1901 1632Q1882 1678 1848 1713ZM1664 1664L1664 1664Q1691 1664 1714 1654Q1737 1644 1754.50 1626.50Q1772 1609 1782 1586Q1792 1563 1792 1536L1792 1536Q1792 1509 1782 1486Q1772 1463 1754.50 1445.50Q1737 1428 1714 1418Q1691 1408 1664 1408L1664 1408Q1637 1408 1614 1418Q1591 1428 1573.50 1445.50Q1556 1463 1546 1486Q1536 1509 1536 1536L1536 1536Q1536 1563 1546 1586Q1556 1609 1573.50 1626.50Q1591 1644 1614 1654Q1637 1664 1664 1664Z"
         }
      }
   ]
}

var TextDocument = {
   name: "TextDocument",
   vendor: "UiFabric",
   unicode: 61481,
   value: "",
   charCode: "F029",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 0L1243 0L1792 549L1792 2048L128 2048L128 0ZM1573 512L1280 219L1280 512L1573 512ZM256 128L256 1920L1664 1920L1664 640L1152 640L1152 128L256 128ZM1408 1024L512 1024L512 896L1408 896L1408 1024ZM1408 1280L512 1280L512 1152L1408 1152L1408 1280ZM1408 1536L512 1536L512 1408L1408 1408L1408 1536Z"
         }
      }
   ]
}

var SurveyQuestions = {
   name: "SurveyQuestions",
   vendor: "UiFabric",
   unicode: 61467,
   value: "",
   charCode: "F01B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1791L896 1663L1024 1663L1024 1791L896 1791ZM960 703L960 703Q1026 703 1084 728.50Q1142 754 1185.50 797.50Q1229 841 1254.50 899Q1280 957 1280 1023L1280 1023Q1280 1083 1261 1128Q1242 1173 1213.50 1208.50Q1185 1244 1152 1273.50Q1119 1303 1090.50 1333Q1062 1363 1043 1396Q1024 1429 1024 1471L1024 1471L1024 1535L896 1535L896 1471Q896 1411 915 1366.50Q934 1322 962.50 1286.50Q991 1251 1024 1221Q1057 1191 1085.50 1161.50Q1114 1132 1133 1099Q1152 1066 1152 1023L1152 1023Q1152 984 1137 949Q1122 914 1095.50 887.50Q1069 861 1034 846Q999 831 960 831L960 831Q921 831 886 846Q851 861 824.50 887.50Q798 914 783 949Q768 984 768 1023L768 1023L640 1023Q640 957 665 899Q690 841 733.50 797.50Q777 754 835.50 728.50Q894 703 960 703ZM1248 0L1792 549L1792 2048L128 2048L128 0L1248 0ZM1285 220L1285 512L1575 512L1285 220ZM256 1920L1664 1920L1664 640L1157 640L1157 128L256 128L256 1920Z"
         }
      }
   ]
}

var Relationship = {
   name: "Relationship",
   vendor: "UiFabric",
   unicode: 61443,
   value: "",
   charCode: "F003",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 0L2048 640L1408 640L1408 482L691 960L1408 1438L1408 1280L2048 1280L2048 1920L1408 1920L1408 1592L640 1080L640 1280L0 1280L0 640L640 640L640 840L1408 328L1408 0L2048 0ZM1920 1408L1536 1408L1536 1792L1920 1792L1920 1408ZM128 1152L512 1152L512 768L128 768L128 1152ZM1920 128L1536 128L1536 512L1920 512L1920 128Z"
         }
      }
   ]
}

var ScatterChart = {
   name: "ScatterChart",
   vendor: "UiFabric",
   unicode: 61419,
   value: "",
   charCode: "EFEB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L256 128L256 1792L1920 1792L1920 1920L128 1920L128 128ZM1536 256L1792 256L1792 512L1536 512L1536 256ZM512 384L768 384L768 640L512 640L512 384ZM1024 768L1280 768L1280 1024L1024 1024L1024 768ZM512 1280L768 1280L768 1536L512 1536L512 1280ZM1664 1408L1664 1152L1920 1152L1920 1408L1664 1408Z"
         }
      }
   ]
}

var DeactivateOrders = {
   name: "DeactivateOrders",
   vendor: "UiFabric",
   unicode: 61409,
   value: "",
   charCode: "EFE1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411L2045 1502ZM512 512L512 640L384 640L384 512L512 512ZM512 768L512 896L384 896L384 768L512 768ZM384 1152L384 1024L512 1024L512 1152L384 1152ZM256 128L256 1920L1280 1920L1280 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1280L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM1024 512L1024 640L640 640L640 512L1024 512ZM1024 768L1024 896L640 896L640 768L1024 768ZM640 1152L640 1024L1024 1024L1024 1152L640 1152Z"
         }
      }
   ]
}

var EditContact = {
   name: "EditContact",
   vendor: "UiFabric",
   unicode: 61395,
   value: "",
   charCode: "EFD3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1333 1145L1243 1236Q1198 1185 1143.50 1145.50Q1089 1106 1028 1079Q967 1052 901.50 1038Q836 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q383 872 319.50 760Q256 648 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140.50 863.50Q1096 911 1040 946L1040 946Q1124 978 1198 1028.50Q1272 1079 1333 1145L1333 1145ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1772 910Q1808 896 1848 896ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836Z"
         }
      }
   ]
}

var Database = {
   name: "Database",
   vendor: "UiFabric",
   unicode: 61383,
   value: "",
   charCode: "EFC7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 128L960 128Q1032 128 1119.50 136Q1207 144 1294.50 163.50Q1382 183 1461 217Q1540 251 1594 302L1594 302Q1625 331 1644.50 368Q1664 405 1664 448L1664 448L1664 1600Q1664 1645 1644.50 1680.50Q1625 1716 1594 1746L1594 1746Q1542 1797 1462.50 1830.50Q1383 1864 1294.50 1884Q1206 1904 1118 1912Q1030 1920 960 1920L960 1920Q888 1920 800.50 1912Q713 1904 625.50 1884.50Q538 1865 459 1831Q380 1797 326 1746L326 1746Q295 1717 275.50 1680Q256 1643 256 1600L256 1600L256 448Q256 403 275.50 367.50Q295 332 326 302L326 302Q378 251 457.50 217.50Q537 184 625.50 164Q714 144 802 136Q890 128 960 128ZM960 256L960 256Q909 256 853.50 259.50Q798 263 742 271.50Q686 280 632.50 293.50Q579 307 531 326L531 326Q516 332 491 344.50Q466 357 442 373Q418 389 401 408.50Q384 428 384 448L384 448Q384 456 387 463Q390 470 395 477L395 477Q416 509 455.50 533Q495 557 544.50 575Q594 593 650 605.50Q706 618 761.50 625.50Q817 633 868.50 636.50Q920 640 960 640L960 640Q1000 640 1051.50 636.50Q1103 633 1158.50 625.50Q1214 618 1270 605.50Q1326 593 1375.50 575Q1425 557 1464 533Q1503 509 1525 477L1525 477Q1530 470 1533 463Q1536 456 1536 448L1536 448Q1536 428 1519 408.50Q1502 389 1478 373Q1454 357 1429 344.50Q1404 332 1389 326L1389 326Q1341 307 1287.50 293.50Q1234 280 1178 271.50Q1122 263 1066.50 259.50Q1011 256 960 256ZM960 1792L960 1792Q1011 1792 1066.50 1788.50Q1122 1785 1178 1776.50Q1234 1768 1287.50 1755Q1341 1742 1389 1722L1389 1722Q1404 1716 1429 1703.50Q1454 1691 1478 1675Q1502 1659 1519 1639.50Q1536 1620 1536 1600L1536 1600L1536 638Q1479 675 1407 700Q1335 725 1257.50 740Q1180 755 1103 761.50Q1026 768 960 768L960 768Q894 768 816.50 761.50Q739 755 662 740Q585 725 513 700Q441 675 384 638L384 638L384 1600Q384 1620 401 1639.50Q418 1659 442 1675Q466 1691 491 1703.50Q516 1716 531 1722L531 1722Q579 1742 632.50 1755Q686 1768 742 1776.50Q798 1785 853.50 1788.50Q909 1792 960 1792Z"
         }
      }
   ]
}

var CRMProcesses = {
   name: "CRMProcesses",
   vendor: "UiFabric",
   unicode: 61361,
   value: "",
   charCode: "EFB1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM128 512L128 1408L421 1408L870 960L421 512L128 512ZM603 1408L1920 1408L1920 512L603 512L1050 960L603 1408Z"
         }
      }
   ]
}

var PageEdit = {
   name: "PageEdit",
   vendor: "UiFabric",
   unicode: 61366,
   value: "",
   charCode: "EFB6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838ZM256 128L256 1920L763 1920L731 2048L128 2048L128 0L1243 0L1792 549L1792 743Q1725 753 1664 787L1664 787L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var PageArrowRight = {
   name: "PageArrowRight",
   vendor: "UiFabric",
   unicode: 61368,
   value: "",
   charCode: "EFB8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1725 1411L2042 1728L1725 2045L1635 1955L1798 1792L1152 1792L1152 1664L1798 1664L1635 1501L1725 1411ZM256 1920L1374 1920L1502 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1280L1664 640L1152 640L1152 128L256 128L256 1920ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var PageRemove = {
   name: "PageRemove",
   vendor: "UiFabric",
   unicode: 61370,
   value: "",
   charCode: "EFBA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411L2045 1502ZM256 128L256 1920L1280 1920L1280 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1280L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var DataManagementSettings = {
   name: "DataManagementSettings",
   vendor: "UiFabric",
   unicode: 61384,
   value: "",
   charCode: "EFC8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1796L960 1796Q1008 1796 1058 1793L1058 1793Q1083 1859 1120 1916L1120 1916Q1080 1920 1040 1922Q1000 1924 960 1924L960 1924Q826 1924 698 1902L698 1902Q661 1896 614 1884.50Q567 1873 518 1855.50Q469 1838 422 1814.50Q375 1791 338 1760Q301 1729 278.50 1690.50Q256 1652 256 1604L256 1604L256 452Q256 407 275.50 371.50Q295 336 326 306L326 306Q360 272 407.50 246Q455 220 510 200.50Q565 181 625 168Q685 155 744 147Q803 139 858 135.50Q913 132 960 132L960 132Q1032 132 1119.50 140Q1207 148 1294.50 167.50Q1382 187 1461 221Q1540 255 1594 306L1594 306Q1625 335 1644.50 372Q1664 409 1664 452L1664 452L1664 1024L1536 1024L1536 642Q1476 679 1404.50 704Q1333 729 1257.50 744Q1182 759 1105.50 765.50Q1029 772 960 772L960 772Q891 772 814.50 765.50Q738 759 662 744Q586 729 515 704Q444 679 384 642L384 642L384 1604Q384 1624 398.50 1641Q413 1658 427 1669L427 1669Q474 1706 541.50 1730.50Q609 1755 683 1769.50Q757 1784 830 1790Q903 1796 960 1796ZM960 260L960 260Q909 260 853.50 263.50Q798 267 742 275.50Q686 284 632 297.50Q578 311 531 330L531 330Q516 336 491 348.50Q466 361 442 377Q418 393 401 412Q384 431 384 452L384 452Q384 460 387 467Q390 474 395 481L395 481Q417 513 458 538Q499 563 550 581Q601 599 658.50 611Q716 623 771 630.50Q826 638 875.50 641Q925 644 960 644L960 644Q995 644 1044.50 641Q1094 638 1149 630.50Q1204 623 1261.50 611Q1319 599 1370 581Q1421 563 1461.50 538.50Q1502 514 1525 481L1525 481Q1530 474 1533 467Q1536 460 1536 452L1536 452Q1536 431 1519 412Q1502 393 1478 377Q1454 361 1429 348.50Q1404 336 1389 330L1389 330Q1342 311 1288 297.50Q1234 284 1178 275.50Q1122 267 1066.50 263.50Q1011 260 960 260ZM2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369L2038 1488ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792Z"
         }
      }
   ]
}

var CRMServices = {
   name: "CRMServices",
   vendor: "UiFabric",
   unicode: 61394,
   value: "",
   charCode: "EFD2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1275 1088L1185 1179Q1097 1104 990 1064Q883 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q383 872 319.50 760Q256 648 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140.50 863.50Q1096 911 1040 946L1040 946Q1105 971 1164 1007Q1223 1043 1275 1088L1275 1088ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1728 768L1728 768Q1794 768 1852 793.50Q1910 819 1953.50 862.50Q1997 906 2022.50 964Q2048 1022 2048 1088L2048 1088Q2048 1154 2022.50 1212.50Q1997 1271 1953.50 1314.50Q1910 1358 1852 1383Q1794 1408 1728 1408L1728 1408Q1705 1408 1683 1405L1683 1405L1096 1992Q1069 2019 1033.50 2033.50Q998 2048 960 2048L960 2048Q920 2048 885 2033Q850 2018 824 1992Q798 1966 783 1931Q768 1896 768 1856L768 1856Q768 1818 782.50 1782.50Q797 1747 824 1720L824 1720L1411 1133Q1408 1111 1408 1088L1408 1088Q1408 1022 1433 964Q1458 906 1501.50 862.50Q1545 819 1603.50 793.50Q1662 768 1728 768ZM1728 1280L1728 1280Q1768 1280 1803 1265Q1838 1250 1864 1224Q1890 1198 1905 1163Q1920 1128 1920 1088L1920 1088Q1920 1047 1901 1006L1901 1006L1755 1152L1664 1152L1664 1061L1810 915Q1769 896 1728 896L1728 896Q1688 896 1653 911Q1618 926 1592 952Q1566 978 1551 1013Q1536 1048 1536 1088L1536 1088Q1536 1129 1555 1170L1555 1170L915 1811Q896 1830 896 1856L896 1856Q896 1882 915 1901Q934 1920 960 1920L960 1920Q986 1920 1005 1901L1005 1901L1646 1261Q1687 1280 1728 1280Z"
         }
      }
   ]
}

var ConnectContacts = {
   name: "ConnectContacts",
   vendor: "UiFabric",
   unicode: 61396,
   value: "",
   charCode: "EFD4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1632 1462L1632 1462Q1698 1495 1751 1543Q1804 1591 1841.50 1650Q1879 1709 1899.50 1778Q1920 1847 1920 1920L1920 1920L1792 1920Q1792 1841 1762 1771Q1732 1701 1679.50 1648.50Q1627 1596 1557 1566Q1487 1536 1408 1536L1408 1536Q1328 1536 1258.50 1566Q1189 1596 1136.50 1648.50Q1084 1701 1054 1771Q1024 1841 1024 1920L1024 1920L896 1920Q896 1847 916.50 1778Q937 1709 974.50 1650Q1012 1591 1065 1543Q1118 1495 1184 1462L1184 1462Q1109 1408 1066.50 1327Q1024 1246 1024 1152L1024 1152Q1024 1073 994 1003Q964 933 911.50 880.50Q859 828 789 798Q719 768 640 768L640 768Q560 768 490.50 798Q421 828 368.50 880.50Q316 933 286 1003Q256 1073 256 1152L256 1152L128 1152Q128 1079 148.50 1010Q169 941 206.50 882Q244 823 297 775Q350 727 416 694L416 694Q341 640 298.50 559Q256 478 256 384L256 384Q256 305 286 235Q316 165 368.50 112.50Q421 60 490.50 30Q560 0 640 0L640 0Q719 0 789 30Q859 60 911.50 112.50Q964 165 994 235Q1024 305 1024 384L1024 384Q1024 478 981.50 559Q939 640 864 694L864 694Q940 732 1000 792Q1060 852 1098 928L1098 928Q1152 853 1233 810.50Q1314 768 1408 768L1408 768Q1487 768 1557 798Q1627 828 1679.50 880.50Q1732 933 1762 1003Q1792 1073 1792 1152L1792 1152Q1792 1246 1749.50 1327Q1707 1408 1632 1462ZM640 640L640 640Q693 640 739.50 620Q786 600 821 565Q856 530 876 483.50Q896 437 896 384L896 384Q896 331 876 284.50Q856 238 821 203Q786 168 739.50 148Q693 128 640 128L640 128Q587 128 540.50 148Q494 168 459 203Q424 238 404 284.50Q384 331 384 384L384 384Q384 437 404 483.50Q424 530 459 565Q494 600 540.50 620Q587 640 640 640ZM1408 1408L1408 1408Q1461 1408 1507.50 1388Q1554 1368 1589 1333Q1624 1298 1644 1251.50Q1664 1205 1664 1152L1664 1152Q1664 1099 1644 1052.50Q1624 1006 1589 971Q1554 936 1507.50 916Q1461 896 1408 896L1408 896Q1355 896 1308.50 916Q1262 936 1227 971Q1192 1006 1172 1052.50Q1152 1099 1152 1152L1152 1152Q1152 1205 1172 1251.50Q1192 1298 1227 1333Q1262 1368 1308.50 1388Q1355 1408 1408 1408ZM1536 640L1536 256L1152 256L1152 128L1664 128L1664 640L1536 640Z"
         }
      }
   ]
}

var AppIconDefaultAdd = {
   name: "AppIconDefaultAdd",
   vendor: "UiFabric",
   unicode: 61402,
   value: "",
   charCode: "EFDA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1920 0L1920 1024L1024 1024L1024 1920L0 1920L0 0ZM128 1792L896 1792L896 1024L128 1024L128 1792ZM128 896L896 896L896 128L128 128L128 896ZM1024 896L1792 896L1792 128L1024 128L1024 896ZM1664 1152L1664 1536L2048 1536L2048 1664L1664 1664L1664 2048L1536 2048L1536 1664L1152 1664L1152 1536L1536 1536L1536 1152L1664 1152Z"
         }
      }
   ]
}

var AppIconDefaultList = {
   name: "AppIconDefaultList",
   vendor: "UiFabric",
   unicode: 61406,
   value: "",
   charCode: "EFDE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1664L1280 1664L1280 1536L1408 1536L1408 1664ZM2048 1664L1536 1664L1536 1536L2048 1536L2048 1664ZM1408 1920L1280 1920L1280 1792L1408 1792L1408 1920ZM2048 1920L1536 1920L1536 1792L2048 1792L2048 1920ZM1408 1408L1280 1408L1280 1280L1408 1280L1408 1408ZM1536 1408L1536 1280L2048 1280L2048 1408L1536 1408ZM0 0L1920 0L1920 1024L1024 1024L1024 1920L0 1920L0 0ZM128 1792L896 1792L896 1024L128 1024L128 1792ZM128 896L896 896L896 128L128 128L128 896ZM1024 896L1792 896L1792 128L1024 128L1024 896Z"
         }
      }
   ]
}

var ActivateOrders = {
   name: "ActivateOrders",
   vendor: "UiFabric",
   unicode: 61408,
   value: "",
   charCode: "EFE0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363ZM1024 512L1024 640L640 640L640 512L1024 512ZM1024 768L1024 896L640 896L640 768L1024 768ZM640 1152L640 1024L1024 1024L1024 1152L640 1152ZM512 512L512 640L384 640L384 512L512 512ZM512 768L512 896L384 896L384 768L512 768ZM384 1152L384 1024L512 1024L512 1152L384 1152ZM1664 640L1152 640L1152 128L256 128L256 1920L1152 1920L1152 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1408L1664 640ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var ProductCatalog = {
   name: "ProductCatalog",
   vendor: "UiFabric",
   unicode: 61416,
   value: "",
   charCode: "EFE8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1792L128 1792Q128 1819 138 1842Q148 1865 165.50 1882.50Q183 1900 206 1910Q229 1920 256 1920L256 1920L896 1920L1153 2048L256 2048Q203 2048 156.50 2028Q110 2008 75 1973Q40 1938 20 1891.50Q0 1845 0 1792L0 1792L0 256Q0 207 21.50 160.50Q43 114 78.50 78.50Q114 43 160 21.50Q206 0 256 0L256 0L1664 0L1664 681L1536 617L1536 128L256 128Q233 128 210 139.50Q187 151 169 169Q151 187 139.50 210Q128 233 128 256L128 256L128 1572Q157 1555 189.50 1545.50Q222 1536 256 1536L256 1536L768 1536L768 1664L256 1664Q229 1664 206 1674Q183 1684 165.50 1701.50Q148 1719 138 1742Q128 1765 128 1792ZM1472 728L2048 1015L2048 1777L1472 2064L896 1777L896 1015L1472 728ZM1841 1055L1472 871L1103 1055L1472 1239L1841 1055ZM1024 1158L1024 1698L1408 1889L1408 1350L1024 1158ZM1536 1889L1920 1698L1920 1158L1536 1350L1536 1889Z"
         }
      }
   ]
}

var AccountActivity = {
   name: "AccountActivity",
   vendor: "UiFabric",
   unicode: 61428,
   value: "",
   charCode: "EFF4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM896 384L640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384ZM1664 1920L1664 384L1536 384L1536 640L512 640L512 384L384 384L384 1920L1664 1920ZM1259 719L1259 719Q1301 719 1337.50 734.50Q1374 750 1401 776.50Q1428 803 1443.50 839Q1459 875 1459 917L1459 917Q1459 956 1444 993Q1429 1030 1401 1058L1401 1058L875 1589L517 1657L592 1306L1118 776Q1146 748 1183 733.50Q1220 719 1259 719ZM812 1470L1310 968Q1331 945 1331 917L1331 917Q1331 886 1310.50 866.50Q1290 847 1259 847L1259 847Q1245 847 1232 851.50Q1219 856 1209 866L1209 866L710 1369L683 1495L812 1470Z"
         }
      }
   ]
}

var DocumentManagement = {
   name: "DocumentManagement",
   vendor: "UiFabric",
   unicode: 61436,
   value: "",
   charCode: "EFFC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369L2038 1488ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792ZM1664 640L1152 640L1152 128L256 128L256 1920L1152 1920L1152 2048L128 2048L128 0L1243 0L1792 549L1792 1024L1664 1024L1664 640ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var CRMReport = {
   name: "CRMReport",
   vendor: "UiFabric",
   unicode: 61438,
   value: "",
   charCode: "EFFE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L1536 1536L1152 1536L1152 384L1536 384ZM1408 512L1280 512L1280 1408L1408 1408L1408 512ZM1024 640L1024 1536L640 1536L640 640L1024 640ZM896 768L768 768L768 1408L896 1408L896 768ZM128 512L128 0L1920 0L1920 1920L128 1920L128 1536L0 1536L0 1408L128 1408L128 640L0 640L0 512L128 512ZM256 1792L1792 1792L1792 128L256 128L256 512L384 512L384 640L256 640L256 1408L384 1408L384 1536L256 1536L256 1792Z"
         }
      }
   ]
}

var KnowledgeArticle = {
   name: "KnowledgeArticle",
   vendor: "UiFabric",
   unicode: 61440,
   value: "",
   charCode: "F000",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM1664 1920L1664 640L1152 640L1152 128L256 128L256 1920L1664 1920ZM1024 512L1024 640L384 640L384 512L1024 512ZM384 896L384 768L1536 768L1536 896L384 896ZM384 1152L384 1024L1536 1024L1536 1152L384 1152ZM384 1408L384 1280L1536 1280L1536 1408L384 1408ZM384 1664L384 1536L1536 1536L1536 1664L384 1664Z"
         }
      }
   ]
}

var HomeVerify = {
   name: "HomeVerify",
   vendor: "UiFabric",
   unicode: 61454,
   value: "",
   charCode: "F00E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1152L1280 1483L1152 1611L1152 1280L896 1280L896 1920L256 1920L256 1115L173 1197L83 1107L1024 165L1965 1107L1875 1197L1792 1115L1792 1329L1664 1457L1664 987L1024 347L384 987L384 1792L768 1792L768 1152L1280 1152ZM1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829Z"
         }
      }
   ]
}

var ZipFolder = {
   name: "ZipFolder",
   vendor: "UiFabric",
   unicode: 61458,
   value: "",
   charCode: "F012",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1792 0Q1819 0 1842 10Q1865 20 1882.50 37.50Q1900 55 1910 78Q1920 101 1920 128L1920 128L1920 608Q1920 653 1910.50 685.50Q1901 718 1887 743.50Q1873 769 1856 789Q1839 809 1825 829.50Q1811 850 1801.50 873.50Q1792 897 1792 928L1792 928L1792 1920Q1792 1947 1782 1970Q1772 1993 1754.50 2010.50Q1737 2028 1714 2038Q1691 2048 1664 2048L1664 2048L256 2048L256 0ZM896 128L640 128L640 512L896 512L896 128ZM1664 1920L1664 928Q1664 897 1654.50 873.50Q1645 850 1631 829.50Q1617 809 1600 789Q1583 769 1569 743.50Q1555 718 1545.50 685.50Q1536 653 1536 608L1536 608L1536 128L1024 128L1024 640L768 640L768 768L640 768L640 640L512 640L512 128L384 128L384 1920L768 1920L768 1792L896 1792L896 1920L1664 1920ZM1792 608L1792 128L1664 128L1664 608Q1664 632 1668.50 650Q1673 668 1681.50 683Q1690 698 1701.50 712.50Q1713 727 1728 744L1728 744Q1743 727 1754.50 712.50Q1766 698 1774.50 683Q1783 668 1787.50 650Q1792 632 1792 608L1792 608ZM640 1024L640 896L768 896L768 1024L640 1024ZM640 1280L640 1152L768 1152L768 1280L640 1280ZM640 1536L640 1408L768 1408L768 1536L640 1536ZM640 1664L768 1664L768 1792L640 1792L640 1664ZM896 896L768 896L768 768L896 768L896 896ZM896 1152L768 1152L768 1024L896 1024L896 1152ZM896 1408L768 1408L768 1280L896 1280L896 1408ZM896 1664L768 1664L768 1536L896 1536L896 1664Z"
         }
      }
   ]
}

var PageCheckedOut = {
   name: "PageCheckedOut",
   vendor: "UiFabric",
   unicode: 61484,
   value: "",
   charCode: "F02C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 128L256 128L256 1920L1408 1920L1408 2048L128 2048L128 0L1243 0L1792 549L1792 1472L1664 1344L1664 640L1152 640L1152 128ZM1573 512L1280 219L1280 512L1573 512ZM1920 1829L1920 1536L2048 1536L2048 2048L1536 2048L1536 1920L1829 1920L1427 1517L1517 1427L1920 1829Z"
         }
      }
   ]
}

var SaveAndClose = {
   name: "SaveAndClose",
   vendor: "UiFabric",
   unicode: 61496,
   value: "",
   charCode: "F038",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 768L1152 768Q1179 768 1202 778Q1225 788 1242.50 805.50Q1260 823 1270 846Q1280 869 1280 896L1280 896L1280 2048L165 2048L0 1883L0 896Q0 869 10 846Q20 823 37.50 805.50Q55 788 78 778Q101 768 128 768L128 768ZM896 896L384 896L384 1280L896 1280L896 896ZM640 1920L896 1920L896 1664L384 1664L384 1920L512 1920L512 1792L640 1792L640 1920ZM1152 1920L1152 896L1024 896L1024 1408L256 1408L256 896L128 896L128 1829L219 1920L256 1920L256 1536L1024 1536L1024 1920L1152 1920ZM512 128L512 640L384 640L384 0L896 0L896 128L512 128ZM1664 0L1920 0L1920 1024L1408 1024L1408 896L1792 896L1792 128L1664 128L1664 0ZM640 256L1349 256L1187 93L1277 3L1595 320L1277 637L1187 547L1349 384L768 384L768 640L640 640L640 256ZM1408 325L1414 320L1408 315L1408 325Z"
         }
      }
   ]
}

var Script = {
   name: "Script",
   vendor: "UiFabric",
   unicode: 61498,
   value: "",
   charCode: "F03A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1792 0Q1845 0 1891.50 20Q1938 40 1973 75Q2008 110 2028 156.50Q2048 203 2048 256L2048 256Q2048 309 2028 355.50Q2008 402 1973 437Q1938 472 1891.50 492Q1845 512 1792 512L1792 512L1664 512L1664 1792Q1664 1845 1644 1891.50Q1624 1938 1589 1973Q1554 2008 1507.50 2028Q1461 2048 1408 2048L1408 2048L256 2048Q203 2048 156.50 2028Q110 2008 75 1973Q40 1938 20 1891.50Q0 1845 0 1792L0 1792Q0 1739 20 1692.50Q40 1646 75 1611Q110 1576 156.50 1556Q203 1536 256 1536L256 1536L256 256Q256 203 276 156.50Q296 110 331 75Q366 40 412.50 20Q459 0 512 0L512 0ZM256 1920L1186 1920Q1152 1860 1152 1792L1152 1792Q1152 1724 1186 1664L1186 1664L256 1664Q229 1664 206 1674Q183 1684 165.50 1701.50Q148 1719 138 1742Q128 1765 128 1792L128 1792Q128 1819 138 1842Q148 1865 165.50 1882.50Q183 1900 206 1910Q229 1920 256 1920L256 1920ZM1408 1920L1408 1920Q1435 1920 1458 1910Q1481 1900 1498.50 1882.50Q1516 1865 1526 1842Q1536 1819 1536 1792L1536 1792L1536 256Q1536 188 1570 128L1570 128L512 128Q485 128 462 138Q439 148 421.50 165.50Q404 183 394 206Q384 229 384 256L384 256L384 1536L1408 1536Q1434 1536 1453 1555Q1472 1574 1472 1600L1472 1600Q1472 1626 1453 1645Q1434 1664 1408 1664L1408 1664Q1383 1664 1359 1673.50Q1335 1683 1317 1701L1317 1701Q1299 1719 1289.50 1743Q1280 1767 1280 1792L1280 1792Q1280 1819 1290 1842Q1300 1865 1317.50 1882.50Q1335 1900 1358 1910Q1381 1920 1408 1920ZM1664 384L1792 384Q1819 384 1842 374Q1865 364 1882.50 346.50Q1900 329 1910 306Q1920 283 1920 256L1920 256Q1920 229 1910 206Q1900 183 1882.50 165.50Q1865 148 1842 138Q1819 128 1792 128L1792 128Q1765 128 1742 138Q1719 148 1701.50 165.50Q1684 183 1674 206Q1664 229 1664 256L1664 256L1664 384ZM512 512L512 384L1408 384L1408 512L512 512ZM512 768L512 640L1408 640L1408 768L512 768ZM512 1024L512 896L1408 896L1408 1024L512 1024ZM512 1280L512 1152L1408 1152L1408 1280L512 1280Z"
         }
      }
   ]
}

var ActivityFeed = {
   name: "ActivityFeed",
   vendor: "UiFabric",
   unicode: 61526,
   value: "",
   charCode: "F056",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 768L128 1088L128 768L0 768L0 128L1664 128L1664 768L448 768ZM128 256L128 640L256 640L256 779L395 640L1536 640L1536 256L128 256ZM384 1024L2048 1024L2048 1664L1920 1664L1920 1984L1600 1664L384 1664L384 1024ZM1920 1536L1920 1152L512 1152L512 1536L1653 1536L1792 1675L1792 1536L1920 1536Z"
         }
      }
   ]
}

var ArrowUpRight = {
   name: "ArrowUpRight",
   vendor: "UiFabric",
   unicode: 61545,
   value: "",
   charCode: "F069",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 256L384 256L1792 256L1792 1664L1664 1664L1664 475L347 1792L256 1701L1573 384L384 384L384 256Z"
         }
      }
   ]
}

var EventDate = {
   name: "EventDate",
   vendor: "UiFabric",
   unicode: 61529,
   value: "",
   charCode: "F059",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256ZM128 1792L1920 1792L1920 640L128 640L128 1792ZM1280 896L1408 896L1408 1536L1280 1536L1280 1050Q1253 1064 1218 1076Q1183 1088 1152 1088L1152 1088L1152 960Q1164 960 1183 954Q1202 948 1222 938.50Q1242 929 1258 918Q1274 907 1280 897L1280 897L1280 896ZM1024 1088L1024 1088Q1024 1127 1012.50 1158.50Q1001 1190 982 1216.50Q963 1243 938 1267Q913 1291 887 1313.50Q861 1336 835.50 1359Q810 1382 789 1408L789 1408L1024 1408L1024 1536L640 1536Q640 1519 639.50 1500Q639 1481 639.50 1461.50Q640 1442 643 1423.50Q646 1405 653 1388L653 1388Q664 1361 686.50 1334.50Q709 1308 736 1282Q763 1256 791 1231Q819 1206 842.50 1182Q866 1158 881 1134.50Q896 1111 896 1088L896 1088Q896 1061 877 1042.50Q858 1024 832 1024L832 1024Q809 1024 791.50 1038Q774 1052 769 1075L769 1075L644 1049Q650 1016 667.50 988Q685 960 711 939.50Q737 919 768 907.50Q799 896 832 896L832 896Q872 896 907 911Q942 926 968 952Q994 978 1009 1013Q1024 1048 1024 1088Z"
         }
      }
   ]
}

var CaretRight = {
   name: "CaretRight",
   vendor: "UiFabric",
   unicode: 61547,
   value: "",
   charCode: "F06B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M506 2074L506-26L1556 1024L506 2074ZM1375 1024L634 282L634 1766L1375 1024Z"
         }
      }
   ]
}

var SetAction = {
   name: "SetAction",
   vendor: "UiFabric",
   unicode: 61553,
   value: "",
   charCode: "F071",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1664 0L1664 128L0 128L0 0ZM0 512L1015 512L948 640L0 640L0 512ZM0 1152L0 1024L747 1024L680 1152L0 1152ZM1838 384L1512 1024L2080 1024L1004 2048L747 2048L1051 1408L691 1408L1226 384L1838 384ZM949 1920L953 1920L1760 1152L1304 1152L1629 512L1304 512L902 1280L1253 1280L949 1920Z"
         }
      }
   ]
}

var SearchIssue = {
   name: "SearchIssue",
   vendor: "UiFabric",
   unicode: 61594,
   value: "",
   charCode: "F09A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 576L1664 576Q1664 695 1618.50 800Q1573 905 1495 983Q1417 1061 1312 1106.50Q1207 1152 1088 1152L1088 1152Q989 1152 897 1120Q805 1088 728 1026L728 1026L109 1645Q90 1664 64 1664L64 1664Q38 1664 19 1645Q0 1626 0 1600L0 1600Q0 1574 19 1555L19 1555L638 936Q576 859 544 767Q512 675 512 576L512 576Q512 457 557.50 352Q603 247 681 169Q759 91 864 45.50Q969 0 1088 0L1088 0Q1207 0 1312 45.50Q1417 91 1495 169Q1573 247 1618.50 352Q1664 457 1664 576ZM640 576L640 576Q640 669 675.50 750.50Q711 832 771.50 892.50Q832 953 913.50 988.50Q995 1024 1088 1024L1088 1024Q1181 1024 1262.50 988.50Q1344 953 1404.50 892.50Q1465 832 1500.50 750.50Q1536 669 1536 576L1536 576Q1536 483 1500.50 401.50Q1465 320 1404.50 259.50Q1344 199 1262.50 163.50Q1181 128 1088 128L1088 128Q995 128 913.50 163.50Q832 199 771.50 259.50Q711 320 675.50 401.50Q640 483 640 576ZM1664 2048L1664 1920L1792 1920L1792 2048L1664 2048ZM1728 1216L1728 1216Q1781 1216 1827.50 1236Q1874 1256 1909 1291Q1944 1326 1964 1372.50Q1984 1419 1984 1472L1984 1472Q1984 1519 1967 1561Q1950 1603 1918 1637L1918 1637L1917 1637L1822 1733Q1808 1747 1802 1761Q1796 1775 1793.50 1790.50Q1791 1806 1791.50 1822.50Q1792 1839 1792 1856L1792 1856L1664 1856L1664 1808Q1664 1762 1678 1727Q1692 1692 1713.50 1664Q1735 1636 1760 1613.50Q1785 1591 1806.50 1569Q1828 1547 1842 1524Q1856 1501 1856 1472L1856 1472Q1856 1445 1846 1422Q1836 1399 1818.50 1381.50Q1801 1364 1778 1354Q1755 1344 1728 1344L1728 1344Q1701 1344 1678 1354Q1655 1364 1637.50 1381.50Q1620 1399 1610 1422Q1600 1445 1600 1472L1600 1472L1472 1472Q1472 1419 1492 1372.50Q1512 1326 1547 1291Q1582 1256 1628.50 1236Q1675 1216 1728 1216Z"
         }
      }
   ]
}

var PowerApps2Logo = {
   name: "PowerApps2Logo",
   vendor: "UiFabric",
   unicode: 61586,
   value: "",
   charCode: "F092",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1355 1121L1355 1121Q1386 1121 1408 1143L1408 1143L1567 1303Q1589 1325 1589 1356L1589 1356Q1589 1386 1567 1408L1567 1408L1408 1568Q1386 1590 1355 1590L1355 1590Q1324 1590 1302 1568L1302 1568L1143 1408Q1121 1386 1121 1356L1121 1356Q1121 1325 1143 1303L1143 1303L1302 1143Q1324 1121 1355 1121ZM1686 790L1686 790Q1717 790 1739 812L1739 812L1898 971Q1920 993 1920 1024L1920 1024Q1920 1055 1898 1077L1898 1077L1739 1236Q1717 1258 1686 1258L1686 1258Q1655 1258 1633 1236L1633 1236L1474 1077Q1452 1055 1452 1024L1452 1024Q1452 993 1474 971L1474 971L1633 812Q1655 790 1686 790ZM1258 1024L1258 1024Q1258 1041 1250.50 1055.50Q1243 1070 1232 1082.50Q1221 1095 1208.50 1106Q1196 1117 1185 1128L1185 1128L746 1567Q724 1589 693 1589L693 1589Q662 1589 640 1567L640 1567L202 1128Q191 1117 178 1106Q165 1095 154 1082.50Q143 1070 135.50 1056Q128 1042 128 1024L128 1024Q128 1007 135.50 992.50Q143 978 154 965Q165 952 178 941Q191 930 202 919L202 919L640 481Q662 459 693 459L693 459Q724 459 746 481L746 481L1185 919Q1196 930 1208.50 941Q1221 952 1232 965Q1243 978 1250.50 992.50Q1258 1007 1258 1024ZM693 1258L693 1258Q724 1258 746 1236L746 1236L864 1117Q874 1107 885.50 1097Q897 1087 906 1076Q915 1065 921 1052.50Q927 1040 927 1024L927 1024Q927 993 905 971L905 971L746 812Q724 790 693 790L693 790Q662 790 640 812L640 812L481 971Q459 993 459 1024L459 1024Q459 1040 465 1052.50Q471 1065 480 1076Q489 1087 500 1097Q511 1107 522 1117L522 1117L640 1236Q662 1258 693 1258ZM1355 927L1355 927Q1324 927 1302 905L1302 905L1143 745Q1121 723 1121 693L1121 693Q1121 662 1143 640L1143 640L1302 481Q1324 459 1355 459L1355 459Q1386 459 1408 481L1408 481L1567 640Q1589 662 1589 693L1589 693Q1589 723 1567 745L1567 745L1408 905Q1386 927 1355 927Z"
         }
      }
   ]
}

var PowerAppsLogo = {
   name: "PowerAppsLogo",
   vendor: "UiFabric",
   unicode: 61585,
   value: "",
   charCode: "F091",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M288 256L1760 256Q1820 256 1872.50 278.50Q1925 301 1964 340Q2003 379 2025.50 431.50Q2048 484 2048 544L2048 544L2048 1312Q2048 1367 2028.50 1416Q2009 1465 1974.50 1503.50Q1940 1542 1893 1566.50Q1846 1591 1792 1597L1792 1597L1792 1469Q1820 1463 1843.50 1448.50Q1867 1434 1884 1413Q1901 1392 1910.50 1366.50Q1920 1341 1920 1312L1920 1312L1920 544Q1920 511 1907.50 482Q1895 453 1873 431Q1851 409 1822 396.50Q1793 384 1760 384L1760 384L288 384Q255 384 226 396.50Q197 409 175 431Q153 453 140.50 482Q128 511 128 544L128 544L128 1312Q128 1341 137.50 1366.50Q147 1392 164 1413Q181 1434 204.50 1448.50Q228 1463 256 1469L256 1469L256 1597Q202 1591 155 1566.50Q108 1542 73.50 1503.50Q39 1465 19.50 1416Q0 1367 0 1312L0 1312L0 544Q0 484 22.50 431.50Q45 379 84 340Q123 301 175.50 278.50Q228 256 288 256L288 256ZM1305 1386L1305 1386Q1332 1386 1351 1405L1351 1405L1488 1542Q1507 1561 1507 1588L1507 1588Q1507 1614 1488 1633L1488 1633L1351 1770Q1332 1789 1305 1789L1305 1789Q1278 1789 1259 1770L1259 1770L1122 1633Q1103 1614 1103 1588L1103 1588Q1103 1561 1122 1542L1122 1542L1259 1405Q1278 1386 1305 1386ZM1590 1099L1590 1099Q1617 1099 1636 1118L1636 1118L1773 1256Q1792 1275 1792 1302L1792 1302Q1792 1328 1773 1347L1773 1347L1636 1484Q1617 1503 1590 1503L1590 1503Q1564 1503 1545 1484L1545 1484L1408 1347Q1389 1328 1389 1302L1389 1302Q1389 1275 1408 1256L1408 1256L1545 1118Q1564 1099 1590 1099ZM1222 1302L1222 1302Q1222 1317 1215.50 1329Q1209 1341 1199.50 1352Q1190 1363 1178.50 1373Q1167 1383 1158 1392L1158 1392L780 1770Q761 1789 734 1789L734 1789Q708 1789 689 1770L689 1770L310 1392Q301 1383 290 1373Q279 1363 269.50 1352Q260 1341 253.50 1329Q247 1317 247 1302L247 1302Q247 1287 253.50 1274.50Q260 1262 269.50 1251Q279 1240 290 1230Q301 1220 310 1211L310 1211L689 833Q708 814 734 814L734 814Q761 814 780 833L780 833L1158 1211Q1167 1220 1178.50 1230Q1190 1240 1199.50 1251Q1209 1262 1215.50 1274.50Q1222 1287 1222 1302ZM734 1503L734 1503Q761 1503 780 1484L780 1484L882 1382Q900 1364 918 1346.50Q936 1329 936 1302L936 1302Q936 1275 917 1256L917 1256L780 1118Q761 1099 734 1099L734 1099Q708 1099 689 1118L689 1118L551 1256Q532 1275 532 1302L532 1302Q532 1329 550 1347Q568 1365 586 1382L586 1382L689 1484Q708 1503 734 1503ZM1507 1016L1507 1016Q1507 1042 1488 1061L1488 1061L1351 1198Q1332 1217 1305 1217L1305 1217Q1278 1217 1259 1198L1259 1198L1122 1061Q1103 1042 1103 1016L1103 1016Q1103 989 1122 970L1122 970L1259 833Q1278 814 1305 814L1305 814Q1332 814 1351 833L1351 833L1488 970Q1507 989 1507 1016Z"
         }
      }
   ]
}

var CaretSolidUp = {
   name: "CaretSolidUp",
   vendor: "UiFabric",
   unicode: 61584,
   value: "",
   charCode: "F090",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 384L1024 384L2048 1408L0 1408L1024 384Z"
         }
      }
   ]
}

var CaretSolidRight = {
   name: "CaretSolidRight",
   vendor: "UiFabric",
   unicode: 61583,
   value: "",
   charCode: "F08F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 0L640 0L1664 1024L640 2048L640 0Z"
         }
      }
   ]
}

var CaretSolidDown = {
   name: "CaretSolidDown",
   vendor: "UiFabric",
   unicode: 61582,
   value: "",
   charCode: "F08E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 640L0 640L2048 640L1024 1664L0 640Z"
         }
      }
   ]
}

var CaretSolidLeft = {
   name: "CaretSolidLeft",
   vendor: "UiFabric",
   unicode: 61581,
   value: "",
   charCode: "F08D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1024L384 1024L1408 0L1408 2048L384 1024Z"
         }
      }
   ]
}

var ChatBot = {
   name: "ChatBot",
   vendor: "UiFabric",
   unicode: 61579,
   value: "",
   charCode: "F08B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 896L768 1024L640 1024L640 896L768 896ZM1280 896L1280 1024L1152 1024L1152 896L1280 896ZM1664 896L1792 896L1792 1152L1664 1152L1664 1472Q1664 1512 1649 1547Q1634 1582 1608 1608Q1582 1634 1547 1649Q1512 1664 1472 1664L1472 1664L1208 1664L768 2040L768 1664L448 1664Q408 1664 373 1649Q338 1634 312 1608Q286 1582 271 1547Q256 1512 256 1472L256 1472L256 1152L128 1152L128 896L256 896L256 704Q256 664 271 629Q286 594 312 568Q338 542 373 527Q408 512 448 512L448 512L896 512L896 303Q867 286 849.50 256Q832 226 832 192L832 192Q832 165 842 142Q852 119 869.50 101.50Q887 84 910 74Q933 64 960 64L960 64Q987 64 1010 74Q1033 84 1050.50 101.50Q1068 119 1078 142Q1088 165 1088 192L1088 192Q1088 226 1070.50 256Q1053 286 1024 303L1024 303L1024 512L1472 512Q1512 512 1547 527Q1582 542 1608 568Q1634 594 1649 629Q1664 664 1664 704L1664 704L1664 896ZM1536 1472L1536 704Q1536 678 1517 659Q1498 640 1472 640L1472 640L448 640Q422 640 403 659Q384 678 384 704L384 704L384 1472Q384 1498 403 1517Q422 1536 448 1536L448 1536L896 1536L896 1762L1160 1536L1472 1536Q1498 1536 1517 1517Q1536 1498 1536 1472L1536 1472ZM595 1257L685 1166Q740 1221 811 1250.50Q882 1280 960 1280L960 1280Q1038 1280 1109 1250.50Q1180 1221 1235 1166L1235 1166L1325 1257Q1252 1330 1157.50 1369Q1063 1408 960 1408L960 1408Q857 1408 762.50 1369Q668 1330 595 1257L595 1257Z"
         }
      }
   ]
}

var SearchIssueMirrored = {
   name: "SearchIssueMirrored",
   vendor: "UiFabric",
   unicode: 61595,
   value: "",
   charCode: "F09B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 576L1664 576Q1664 695 1618.50 800Q1573 905 1495 983Q1417 1061 1312 1106.50Q1207 1152 1088 1152L1088 1152Q989 1152 897 1120Q805 1088 728 1026L728 1026L109 1645Q90 1664 64 1664L64 1664Q38 1664 19 1645Q0 1626 0 1600L0 1600Q0 1574 19 1555L19 1555L638 936Q576 859 544 767Q512 675 512 576L512 576Q512 457 557.50 352Q603 247 681 169Q759 91 864 45.50Q969 0 1088 0L1088 0Q1207 0 1312 45.50Q1417 91 1495 169Q1573 247 1618.50 352Q1664 457 1664 576ZM640 576L640 576Q640 669 675.50 750.50Q711 832 771.50 892.50Q832 953 913.50 988.50Q995 1024 1088 1024L1088 1024Q1181 1024 1262.50 988.50Q1344 953 1404.50 892.50Q1465 832 1500.50 750.50Q1536 669 1536 576L1536 576Q1536 483 1500.50 401.50Q1465 320 1404.50 259.50Q1344 199 1262.50 163.50Q1181 128 1088 128L1088 128Q995 128 913.50 163.50Q832 199 771.50 259.50Q711 320 675.50 401.50Q640 483 640 576ZM1664 2048L1664 1920L1792 1920L1792 2048L1664 2048ZM1728 1216L1728 1216Q1781 1216 1827.50 1236Q1874 1256 1909 1291Q1944 1326 1964 1372.50Q1984 1419 1984 1472L1984 1472L1856 1472Q1856 1445 1846 1422Q1836 1399 1818.50 1381.50Q1801 1364 1778 1354Q1755 1344 1728 1344L1728 1344Q1701 1344 1678 1354Q1655 1364 1637.50 1381.50Q1620 1399 1610 1422Q1600 1445 1600 1472L1600 1472Q1600 1501 1614 1524Q1628 1547 1649.50 1569Q1671 1591 1696 1613.50Q1721 1636 1742.50 1664Q1764 1692 1778 1727Q1792 1762 1792 1808L1792 1808L1792 1856L1664 1856Q1664 1839 1664.50 1822.50Q1665 1806 1662.50 1790.50Q1660 1775 1653.50 1761Q1647 1747 1634 1733L1634 1733Q1604 1703 1575 1675.50Q1546 1648 1523 1618Q1500 1588 1486 1553Q1472 1518 1472 1472L1472 1472Q1472 1419 1492 1372.50Q1512 1326 1547 1291Q1582 1256 1628.50 1236Q1675 1216 1728 1216Z"
         }
      }
   ]
}

var FabricAssetLibrary = {
   name: "FabricAssetLibrary",
   vendor: "UiFabric",
   unicode: 61596,
   value: "",
   charCode: "F09C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1024L1920 1024L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L896 1536L896 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM2048 2048L1024 2048L1024 1152L2048 1152L2048 2048ZM1280 1792L1152 1792L1152 1920L1920 1920L1920 1792L1792 1792L1792 1664L1920 1664L1920 1536L1792 1536L1792 1408L1920 1408L1920 1280L1152 1280L1152 1408L1280 1408L1280 1536L1152 1536L1152 1664L1280 1664L1280 1792ZM640 768L768 768Q809 768 847.50 780Q886 792 919 814Q952 836 977.50 867Q1003 898 1019 936L1019 936L901 985Q884 944 848 920Q812 896 768 896L768 896L768 1216Q768 1260 748 1295.50Q728 1331 696.50 1356Q665 1381 624.50 1394.50Q584 1408 544 1408L544 1408Q503 1408 463 1394.50Q423 1381 391 1356Q359 1331 339.50 1295.50Q320 1260 320 1216L320 1216Q320 1172 339.50 1136.50Q359 1101 391 1076Q423 1051 463 1037.50Q503 1024 544 1024L544 1024Q596 1024 640 1043L640 1043L640 768ZM544 1280L544 1280Q557 1280 573.50 1276Q590 1272 605 1264Q620 1256 630 1244Q640 1232 640 1216L640 1216Q640 1200 630 1188Q620 1176 605 1168Q590 1160 573.50 1156Q557 1152 544 1152L544 1152Q531 1152 514.50 1156Q498 1160 483 1168Q468 1176 458 1188Q448 1200 448 1216L448 1216Q448 1232 458 1244Q468 1256 483 1264Q498 1272 514.50 1276Q531 1280 544 1280Z"
         }
      }
   ]
}

var FabricPictureLibrary = {
   name: "FabricPictureLibrary",
   vendor: "UiFabric",
   unicode: 61612,
   value: "",
   charCode: "F0AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 896L1920 896L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L512 1536L512 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM2048 2048L640 2048L640 1024L2048 1024L2048 2048ZM1499 1792L1627 1920L1829 1920L1600 1690L1499 1792ZM1920 1152L768 1152L768 1701L1088 1382L1408 1701L1600 1510L1920 1829L1920 1152ZM1088 1562L768 1883L768 1920L1445 1920L1088 1562ZM1728 1408L1728 1408Q1702 1408 1683 1389Q1664 1370 1664 1344L1664 1344Q1664 1318 1683 1299Q1702 1280 1728 1280L1728 1280Q1754 1280 1773 1299Q1792 1318 1792 1344L1792 1344Q1792 1370 1773 1389Q1754 1408 1728 1408Z"
         }
      }
   ]
}

var FabricFolderFill = {
   name: "FabricFolderFill",
   vendor: "UiFabric",
   unicode: 61610,
   value: "",
   charCode: "F0AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 512L1984 512L1984 1536Q1984 1562 1965 1581Q1946 1600 1920 1600L1920 1600L128 1600Q102 1600 83 1581Q64 1562 64 1536L64 1536L64 256Q64 230 83 211Q102 192 128 192L128 192L864 192Q905 192 932.50 211Q960 230 981 258.50Q1002 287 1021.50 320Q1041 353 1066.50 381.50Q1092 410 1127 429Q1162 448 1216 448L1216 448L1920 448Q1946 448 1965 467Q1984 486 1984 512Z"
         }
      }
   ]
}

var FabricOpenFolderHorizontal = {
   name: "FabricOpenFolderHorizontal",
   vendor: "UiFabric",
   unicode: 61608,
   value: "",
   charCode: "F0A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2005 896L2005 896Q2005 928 1990 956L1990 956L1650 1595Q1633 1627 1603 1645.50Q1573 1664 1536 1664L1536 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L736 128Q773 128 805 141.50Q837 155 863.50 177.50Q890 200 912 228.50Q934 257 951 287L951 287Q964 310 976.50 328Q989 346 1004 358.50Q1019 371 1039 377.50Q1059 384 1088 384L1088 384L1664 384Q1691 384 1714 394Q1737 404 1754.50 421.50Q1772 439 1782 462Q1792 485 1792 512L1792 512L1792 768Q1806 768 1820.50 767.50Q1835 767 1849 767L1849 767Q1891 767 1926.50 777.50Q1962 788 1987 830L1987 830Q2005 860 2005 896ZM736 256L128 256L128 1329L373 839Q390 806 420.50 787Q451 768 488 768L488 768L1664 768L1664 512L1088 512Q1026 512 983.50 493Q941 474 911 445.50Q881 417 860 384Q839 351 820.50 322.50Q802 294 782.50 275Q763 256 736 256L736 256ZM168 1536L1536 1536L1877 896L488 896L168 1536Z"
         }
      }
   ]
}

var FabricUnsyncFolder = {
   name: "FabricUnsyncFolder",
   vendor: "UiFabric",
   unicode: 61606,
   value: "",
   charCode: "F0A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1024L1920 1024L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L1024 1536L1024 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1920 1289L1920 1289L1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333L1867 1776Q1903 1720 1914 1653L1914 1653L2041 1675Q2023 1781 1959 1868L1959 1868L2048 1957L1957 2048L1868 1959Q1810 2003 1741 2025.50Q1672 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1297 1480 1286 1547L1286 1547L1159 1525Q1177 1419 1241 1332L1241 1332L1152 1243L1243 1152L1332 1241Q1390 1197 1459 1174.50Q1528 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289Z"
         }
      }
   ]
}

var FabricFolderSearch = {
   name: "FabricFolderSearch",
   vendor: "UiFabric",
   unicode: 61604,
   value: "",
   charCode: "F0A4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 895Q2020 867 1987.50 844.50Q1955 822 1920 803L1920 803L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L1024 1536L1024 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547.50 1645.50Q1491 1627 1442 1592L1442 1592L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1352 1502Q1317 1453 1298.50 1396.50Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var FabricReportLibraryMirrored = {
   name: "FabricReportLibraryMirrored",
   vendor: "UiFabric",
   unicode: 61602,
   value: "",
   charCode: "F0A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 768L1920 768L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L256 1536L256 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM384 2048L384 896L2048 896L2048 2048L384 2048ZM512 1920L1920 1920L1920 1024L512 1024L512 1920ZM640 1152L1024 1152L1024 1280L640 1280L640 1152ZM1024 1536L768 1536L768 1408L1024 1408L1024 1536ZM1024 1792L768 1792L768 1664L1024 1664L1024 1792ZM1152 1152L1792 1152L1792 1792L1152 1792L1152 1152ZM1280 1664L1664 1664L1664 1280L1280 1280L1280 1664Z"
         }
      }
   ]
}

var FabricFormLibraryMirrored = {
   name: "FabricFormLibraryMirrored",
   vendor: "UiFabric",
   unicode: 61600,
   value: "",
   charCode: "F0A0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 963L1920 835L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L768 1536L768 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM896 2048L896 768L1627 768L2048 1189L2048 2048L896 2048ZM1024 1920L1920 1920L1920 1280L1536 1280L1536 896L1024 896L1024 1920ZM1829 1152L1664 987L1664 1152L1829 1152ZM1792 1792L1280 1792L1280 1664L1792 1664L1792 1792ZM1792 1536L1536 1536L1536 1408L1792 1408L1792 1536Z"
         }
      }
   ]
}

var FabricDocLibrary = {
   name: "FabricDocLibrary",
   vendor: "UiFabric",
   unicode: 61598,
   value: "",
   charCode: "F09E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 963L1920 835L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L768 1536L768 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM896 2048L896 768L1627 768L2048 1189L2048 2048L896 2048ZM1024 1920L1920 1920L1920 1280L1536 1280L1536 896L1024 896L1024 1920ZM1829 1152L1664 987L1664 1152L1829 1152Z"
         }
      }
   ]
}

var FabricDataConnectionLibrary = {
   name: "FabricDataConnectionLibrary",
   vendor: "UiFabric",
   unicode: 61597,
   value: "",
   charCode: "F09D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 963L1920 835L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L768 1536L768 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM896 2048L896 768L1627 768L2048 1189L2048 2048L896 2048ZM1024 1920L1920 1920L1920 1280L1536 1280L1536 896L1024 896L1024 1920ZM1829 1152L1664 987L1664 1152L1829 1152ZM1280 1792L1152 1792L1152 1280L1280 1280L1280 1792ZM1536 1792L1408 1792L1408 1536L1536 1536L1536 1792ZM1664 1408L1792 1408L1792 1792L1664 1792L1664 1408Z"
         }
      }
   ]
}

var FabricFormLibrary = {
   name: "FabricFormLibrary",
   vendor: "UiFabric",
   unicode: 61599,
   value: "",
   charCode: "F09F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 963L1920 835L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L768 1536L768 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM896 2048L896 768L1627 768L2048 1189L2048 2048L896 2048ZM1024 1920L1920 1920L1920 1280L1536 1280L1536 896L1024 896L1024 1920ZM1829 1152L1664 987L1664 1152L1829 1152ZM1664 1792L1152 1792L1152 1664L1664 1664L1664 1792ZM1152 1408L1408 1408L1408 1536L1152 1536L1152 1408ZM1152 1152L1408 1152L1408 1280L1152 1280L1152 1152Z"
         }
      }
   ]
}

var FabricReportLibrary = {
   name: "FabricReportLibrary",
   vendor: "UiFabric",
   unicode: 61601,
   value: "",
   charCode: "F0A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 768L1920 768L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L256 1536L256 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM384 2048L384 896L2048 896L2048 2048L384 2048ZM512 1920L1920 1920L1920 1024L512 1024L512 1920ZM1408 1152L1792 1152L1792 1280L1408 1280L1408 1152ZM1408 1408L1664 1408L1664 1536L1408 1536L1408 1408ZM1408 1664L1664 1664L1664 1792L1408 1792L1408 1664ZM640 1152L1280 1152L1280 1792L640 1792L640 1152ZM768 1664L1152 1664L1152 1280L768 1280L768 1664Z"
         }
      }
   ]
}

var FabricPublicFolder = {
   name: "FabricPublicFolder",
   vendor: "UiFabric",
   unicode: 61603,
   value: "",
   charCode: "F0A3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1379L1920 1251L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L768 1536L768 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 230 10 206.50Q20 183 37.50 165.50Q55 148 78.50 138Q102 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1798 1536L1635 1373L1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1130 1664L1293 1827L1203 1917L886 1600L1203 1283L1293 1373L1130 1536L1798 1536Z"
         }
      }
   ]
}

var FabricMovetoFolder = {
   name: "FabricMovetoFolder",
   vendor: "UiFabric",
   unicode: 61605,
   value: "",
   charCode: "F0A5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1536Q2048 1563 2038 1586Q2028 1609 2010.50 1626.50Q1993 1644 1970 1654Q1947 1664 1920 1664L1920 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 1280L128 1280L128 1536L1920 1536L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 896L0 896L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM749 1389L659 1299L805 1152L0 1152L0 1024L805 1024L659 877L749 787L1050 1088L749 1389Z"
         }
      }
   ]
}

var FabricSyncFolder = {
   name: "FabricSyncFolder",
   vendor: "UiFabric",
   unicode: 61607,
   value: "",
   charCode: "F0A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1024L1920 1024L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L1024 1536L1024 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1920 1289L1920 1289L1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1541 1280 1488.50 1300Q1436 1320 1394 1355.50Q1352 1391 1324 1440Q1296 1489 1286 1547L1286 1547L1159 1525Q1173 1444 1213 1375.50Q1253 1307 1311.50 1257.50Q1370 1208 1444 1180Q1518 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289ZM1600 1920L1600 1920Q1659 1920 1711.50 1900Q1764 1880 1806 1844.50Q1848 1809 1876 1760Q1904 1711 1914 1653L1914 1653L2041 1675Q2027 1756 1987 1824.50Q1947 1893 1888.50 1942.50Q1830 1992 1756 2020Q1682 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920Z"
         }
      }
   ]
}

var FabricFolder = {
   name: "FabricFolder",
   vendor: "UiFabric",
   unicode: 61609,
   value: "",
   charCode: "F0A9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1536Q2048 1563 2038 1586Q2028 1609 2010.50 1626.50Q1993 1644 1970 1654Q1947 1664 1920 1664L1920 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1039.50 228.50Q1061 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM864 256L864 256L128 256L128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256ZM128 1536L1920 1536L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536Z"
         }
      }
   ]
}

var FabricNewFolder = {
   name: "FabricNewFolder",
   vendor: "UiFabric",
   unicode: 61611,
   value: "",
   charCode: "F0AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1408L1920 1408L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L1024 1536L1024 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1536 1152L1664 1152L1664 1536L2048 1536L2048 1664L1664 1664L1664 2048L1536 2048L1536 1664L1152 1664L1152 1536L1536 1536L1536 1152Z"
         }
      }
   ]
}

var PhotoVideoMedia = {
   name: "PhotoVideoMedia",
   vendor: "UiFabric",
   unicode: 61617,
   value: "",
   charCode: "F0B1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 640L256 512L384 512L384 640L256 640ZM256 896L256 768L384 768L384 896L256 896ZM1280 512L1280 640L1152 640L1152 512L1280 512ZM1536 768L2048 768L2048 1920L512 1920L512 1280L0 1280L0 128L1536 128L1536 768ZM1920 1445L1920 896L640 896L640 1445L960 1126L1408 1573L1728 1254L1920 1445ZM384 1152L512 1152L512 768L1408 768L1408 256L1280 256L1280 384L1152 384L1152 256L384 256L384 384L256 384L256 256L128 256L128 1152L256 1152L256 1024L384 1024L384 1152ZM640 1627L640 1792L1445 1792L960 1306L640 1627ZM1627 1792L1920 1792L1920 1627L1728 1434L1499 1664L1627 1792ZM1472 1152L1472 1152Q1446 1152 1427 1133Q1408 1114 1408 1088L1408 1088Q1408 1062 1427 1043Q1446 1024 1472 1024L1472 1024Q1498 1024 1517 1043Q1536 1062 1536 1088L1536 1088Q1536 1114 1517 1133Q1498 1152 1472 1152Z"
         }
      }
   ]
}

var AddFavorite = {
   name: "AddFavorite",
   vendor: "UiFabric",
   unicode: 61640,
   value: "",
   charCode: "F0C8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1504 1536L1370 1536L1267 1207L1672 896L1170 896L1024 429L886 896L384 896L781 1207L627 1700L1024 1394L1280 1591L1280 1753L1024 1556L384 2048L632 1254L0 768L784 768L1024 0L1264 768L2048 768L1416 1254L1504 1536ZM1664 1408L1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408Z"
         }
      }
   ]
}

var AddFavoriteFill = {
   name: "AddFavoriteFill",
   vendor: "UiFabric",
   unicode: 61641,
   value: "",
   charCode: "F0C9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1860 832L1860 832L1341 1231L1431 1517L1408 1536L1280 1536L1280 1614L1241 1642L1024 1475L505 1874L707 1231L188 832L831 832L1024 214L1217 832L1860 832Z"
         }
      }
   ]
}

var BufferTimeBefore = {
   name: "BufferTimeBefore",
   vendor: "UiFabric",
   unicode: 61647,
   value: "",
   charCode: "F0CF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 320L1024 320Q1121 320 1211 345Q1301 370 1379.50 416Q1458 462 1522 526Q1586 590 1632 668.50Q1678 747 1703 837Q1728 927 1728 1024L1728 1024Q1728 1121 1703 1211Q1678 1301 1632 1379.50Q1586 1458 1522 1522Q1458 1586 1379.50 1632Q1301 1678 1211 1703Q1121 1728 1024 1728L1024 1728Q927 1728 837 1703Q747 1678 668.50 1632Q590 1586 526 1522Q462 1458 416 1379.50Q370 1301 345 1211Q320 1121 320 1024L320 1024Q320 927 345 837Q370 747 416 668.50Q462 590 526 526Q590 462 668.50 416Q747 370 837 345Q927 320 1024 320ZM1024 1600L1024 1600Q1143 1600 1248 1554.50Q1353 1509 1431 1431Q1509 1353 1554.50 1248Q1600 1143 1600 1024L1600 1024Q1600 905 1554.50 800Q1509 695 1431 617Q1353 539 1248 493.50Q1143 448 1024 448L1024 448Q905 448 800 493.50Q695 539 617 617Q539 695 493.50 800Q448 905 448 1024L448 1024Q448 1143 493.50 1248Q539 1353 617 1431Q695 1509 800 1554.50Q905 1600 1024 1600ZM1024 640L1024 1024L1280 1024L1280 1152L896 1152L896 640L1024 640ZM1748 300L1658 390Q1530 263 1367 195.50Q1204 128 1024 128L1024 128Q844 128 681 195.50Q518 263 390 390L390 390L300 300Q372 228 456 172Q540 116 632.50 77.50Q725 39 823.50 19.50Q922 0 1024 0L1024 0Q1126 0 1224.50 19.50Q1323 39 1415.50 77.50Q1508 116 1592 172Q1676 228 1748 300L1748 300Z"
         }
      }
   ]
}

var BufferTimeAfter = {
   name: "BufferTimeAfter",
   vendor: "UiFabric",
   unicode: 61648,
   value: "",
   charCode: "F0D0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1728L1024 1728Q927 1728 837 1703Q747 1678 668.50 1632Q590 1586 526 1522Q462 1458 416 1379.50Q370 1301 345 1211Q320 1121 320 1024L320 1024Q320 927 345 837Q370 747 416 668.50Q462 590 526 526Q590 462 668.50 416Q747 370 837 345Q927 320 1024 320L1024 320Q1121 320 1211 345Q1301 370 1379.50 416Q1458 462 1522 526Q1586 590 1632 668.50Q1678 747 1703 837Q1728 927 1728 1024L1728 1024Q1728 1121 1703 1211Q1678 1301 1632 1379.50Q1586 1458 1522 1522Q1458 1586 1379.50 1632Q1301 1678 1211 1703Q1121 1728 1024 1728ZM1024 448L1024 448Q905 448 800 493.50Q695 539 617 617Q539 695 493.50 800Q448 905 448 1024L448 1024Q448 1143 493.50 1248Q539 1353 617 1431Q695 1509 800 1554.50Q905 1600 1024 1600L1024 1600Q1143 1600 1248 1554.50Q1353 1509 1431 1431Q1509 1353 1554.50 1248Q1600 1143 1600 1024L1600 1024Q1600 905 1554.50 800Q1509 695 1431 617Q1353 539 1248 493.50Q1143 448 1024 448ZM1280 1024L1280 1152L896 1152L896 640L1024 640L1024 1024L1280 1024ZM1658 1658L1748 1748Q1676 1820 1592 1876Q1508 1932 1415.50 1970.50Q1323 2009 1224.50 2028.50Q1126 2048 1024 2048L1024 2048Q922 2048 823.50 2028.50Q725 2009 632.50 1970.50Q540 1932 456 1876Q372 1820 300 1748L300 1748L390 1658Q518 1785 681 1852.50Q844 1920 1024 1920L1024 1920Q1204 1920 1367 1852.50Q1530 1785 1658 1658L1658 1658Z"
         }
      }
   ]
}

var BufferTimeBoth = {
   name: "BufferTimeBoth",
   vendor: "UiFabric",
   unicode: 61649,
   value: "",
   charCode: "F0D1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 320L1024 320Q1121 320 1211 345Q1301 370 1379.50 416Q1458 462 1522 526Q1586 590 1632 668.50Q1678 747 1703 837Q1728 927 1728 1024L1728 1024Q1728 1121 1703 1211Q1678 1301 1632 1379.50Q1586 1458 1522 1522Q1458 1586 1379.50 1632Q1301 1678 1211 1703Q1121 1728 1024 1728L1024 1728Q927 1728 837 1703Q747 1678 668.50 1632Q590 1586 526 1522Q462 1458 416 1379.50Q370 1301 345 1211Q320 1121 320 1024L320 1024Q320 927 345 837Q370 747 416 668.50Q462 590 526 526Q590 462 668.50 416Q747 370 837 345Q927 320 1024 320ZM1024 1600L1024 1600Q1143 1600 1248 1554.50Q1353 1509 1431 1431Q1509 1353 1554.50 1248Q1600 1143 1600 1024L1600 1024Q1600 905 1554.50 800Q1509 695 1431 617Q1353 539 1248 493.50Q1143 448 1024 448L1024 448Q905 448 800 493.50Q695 539 617 617Q539 695 493.50 800Q448 905 448 1024L448 1024Q448 1143 493.50 1248Q539 1353 617 1431Q695 1509 800 1554.50Q905 1600 1024 1600ZM1024 640L1024 1024L1280 1024L1280 1152L896 1152L896 640L1024 640ZM1748 300L1658 390Q1530 263 1367 195.50Q1204 128 1024 128L1024 128Q844 128 681 195.50Q518 263 390 390L390 390L300 300Q372 228 456 172Q540 116 632.50 77.50Q725 39 823.50 19.50Q922 0 1024 0L1024 0Q1126 0 1224.50 19.50Q1323 39 1415.50 77.50Q1508 116 1592 172Q1676 228 1748 300L1748 300ZM300 1748L390 1658Q518 1785 681 1852.50Q844 1920 1024 1920L1024 1920Q1204 1920 1367 1852.50Q1530 1785 1658 1658L1658 1658L1748 1748Q1676 1820 1592 1876Q1508 1932 1415.50 1970.50Q1323 2009 1224.50 2028.50Q1126 2048 1024 2048L1024 2048Q922 2048 823.50 2028.50Q725 2009 632.50 1970.50Q540 1932 456 1876Q372 1820 300 1748L300 1748Z"
         }
      }
   ]
}

var PublishContent = {
   name: "PublishContent",
   vendor: "UiFabric",
   unicode: 61652,
   value: "",
   charCode: "F0D4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1664L896 347L493 749L403 659L960 102L1517 659L1427 749L1024 347L1024 1664L896 1664ZM1664 1920L1664 1664L1792 1664L1792 2048L128 2048L128 1664L256 1664L256 1920L1664 1920Z"
         }
      }
   ]
}

var ClipboardList = {
   name: "ClipboardList",
   vendor: "UiFabric",
   unicode: 61667,
   value: "",
   charCode: "F0E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384L640 384ZM1664 1920L1664 384L1536 384L1536 640L512 640L512 384L384 384L384 1920L1664 1920ZM768 1024L768 896L1536 896L1536 1024L768 1024ZM768 1408L768 1280L1536 1280L1536 1408L768 1408ZM768 1792L768 1664L1536 1664L1536 1792L768 1792ZM512 1024L512 896L640 896L640 1024L512 1024ZM512 1408L512 1280L640 1280L640 1408L512 1408ZM512 1792L512 1664L640 1664L640 1792L512 1792Z"
         }
      }
   ]
}

var ClipboardListMirrored = {
   name: "ClipboardListMirrored",
   vendor: "UiFabric",
   unicode: 61668,
   value: "",
   charCode: "F0E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 256L256 256L256 2048L1792 2048L1792 256L1280 256Q1280 203 1260 156.50Q1240 110 1205 75Q1170 40 1123.50 20Q1077 0 1024 0L1024 0Q971 0 924.50 20Q878 40 843 75Q808 110 788 156.50Q768 203 768 256L768 256ZM1408 384L1408 512L640 512L640 384L896 384L896 256Q896 229 906 206Q916 183 933.50 165.50Q951 148 974 138Q997 128 1024 128L1024 128Q1051 128 1074 138Q1097 148 1114.50 165.50Q1132 183 1142 206Q1152 229 1152 256L1152 256L1152 384L1408 384ZM384 1920L384 384L512 384L512 640L1536 640L1536 384L1664 384L1664 1920L384 1920ZM1280 1024L1280 896L512 896L512 1024L1280 1024ZM1280 1408L1280 1280L512 1280L512 1408L1280 1408ZM1280 1792L1280 1664L512 1664L512 1792L1280 1792ZM1536 1024L1536 896L1408 896L1408 1024L1536 1024ZM1536 1408L1536 1280L1408 1280L1408 1408L1536 1408ZM1536 1792L1536 1664L1408 1664L1408 1792L1536 1792Z"
         }
      }
   ]
}

var CannedChat = {
   name: "CannedChat",
   vendor: "UiFabric",
   unicode: 61682,
   value: "",
   charCode: "F0F2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536ZM677 1408L1920 1408L1920 256L128 256L128 1408L384 1408L384 1701L677 1408ZM384 512L1664 512L1664 640L384 640L384 512ZM384 768L1664 768L1664 896L384 896L384 768ZM384 1024L1664 1024L1664 1152L384 1152L384 1024Z"
         }
      }
   ]
}

var SkypeForBusinessLogo = {
   name: "SkypeForBusinessLogo",
   vendor: "UiFabric",
   unicode: 61692,
   value: "",
   charCode: "F0FC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1973 1191L1973 1191Q2010 1256 2029 1328Q2048 1400 2048 1475L2048 1475Q2048 1554 2027.50 1627Q2007 1700 1969.50 1764Q1932 1828 1880 1880Q1828 1932 1764 1969.50Q1700 2007 1627 2027.50Q1554 2048 1475 2048L1475 2048Q1400 2048 1328 2029Q1256 2010 1191 1973L1191 1973Q1149 1980 1107.50 1983.50Q1066 1987 1024 1987L1024 1987Q891 1987 768 1952.50Q645 1918 538 1855.50Q431 1793 343 1705Q255 1617 192.50 1510Q130 1403 95.50 1280Q61 1157 61 1024L61 1024Q61 982 64.50 940.50Q68 899 75 857L75 857Q38 792 19 720Q0 648 0 573L0 573Q0 494 20.50 421Q41 348 78.50 284Q116 220 168 168Q220 116 284 78.50Q348 41 421 20.50Q494 0 573 0L573 0Q648 0 720 19Q792 38 857 75L857 75Q899 68 940.50 64.50Q982 61 1024 61L1024 61Q1157 61 1280 95.50Q1403 130 1510 192.50Q1617 255 1705 343Q1793 431 1855.50 538Q1918 645 1952.50 768Q1987 891 1987 1024L1987 1024Q1987 1066 1983.50 1107.50Q1980 1149 1973 1191ZM1475 1902L1475 1902Q1563 1902 1641 1868.50Q1719 1835 1777 1777Q1835 1719 1868.50 1641Q1902 1563 1902 1475L1902 1475Q1902 1436 1896 1403.50Q1890 1371 1879.50 1340.50Q1869 1310 1854 1280.50Q1839 1251 1820 1218L1820 1218Q1829 1169 1835 1121.50Q1841 1074 1841 1024L1841 1024Q1841 911 1812 807Q1783 703 1729.50 612Q1676 521 1601.50 446.50Q1527 372 1436 318.50Q1345 265 1241 236Q1137 207 1024 207L1024 207Q974 207 926.50 213Q879 219 830 228L830 228Q797 209 767.50 194Q738 179 707.50 168.50Q677 158 644.50 152Q612 146 573 146L573 146Q485 146 407 179.50Q329 213 271 271Q213 329 179.50 407Q146 485 146 573L146 573Q146 612 152 644.50Q158 677 168.50 707.50Q179 738 194 767.50Q209 797 228 830L228 830Q219 879 213 926.50Q207 974 207 1024L207 1024Q207 1137 236 1241Q265 1345 318.50 1436Q372 1527 446.50 1601.50Q521 1676 612 1729.50Q703 1783 807 1812Q911 1841 1024 1841L1024 1841Q1074 1841 1121.50 1835Q1169 1829 1218 1820L1218 1820Q1251 1839 1280.50 1854Q1310 1869 1340.50 1879.50Q1371 1890 1403.50 1896Q1436 1902 1475 1902ZM807 760L807 760Q807 791 825.50 812.50Q844 834 871 848Q898 862 928 870.50Q958 879 982 884L982 884L1199 932Q1264 947 1319 972.50Q1374 998 1414 1037.50Q1454 1077 1476.50 1131Q1499 1185 1499 1255L1499 1255Q1499 1321 1480 1373Q1461 1425 1427.50 1465.50Q1394 1506 1349 1534.50Q1304 1563 1251.50 1581Q1199 1599 1142 1607.50Q1085 1616 1028 1616L1028 1616Q970 1616 907 1607.50Q844 1599 785 1578.50Q726 1558 674.50 1524.50Q623 1491 588 1440L588 1440Q571 1415 560 1386.50Q549 1358 549 1327L549 1327Q549 1303 558 1283.50Q567 1264 582.50 1250Q598 1236 618.50 1228.50Q639 1221 662 1221L662 1221Q697 1221 719.50 1236.50Q742 1252 761 1275.50Q780 1299 799.50 1326Q819 1353 848 1376.50Q877 1400 920 1415.50Q963 1431 1028 1431L1028 1431Q1062 1431 1099 1421.50Q1136 1412 1167.50 1393Q1199 1374 1219.50 1344.50Q1240 1315 1240 1275L1240 1275Q1240 1250 1230.50 1230.50Q1221 1211 1205 1196.50Q1189 1182 1168.50 1173Q1148 1164 1126 1158L1126 1158L834 1084Q771 1068 720 1043Q669 1018 632.50 981Q596 944 576.50 893Q557 842 557 774L557 774Q557 680 597 614.50Q637 549 701 509Q765 469 845.50 451Q926 433 1007 433L1007 433Q1042 433 1088.50 440Q1135 447 1184.50 460.50Q1234 474 1281.50 495.50Q1329 517 1366.50 546Q1404 575 1427 612Q1450 649 1450 694L1450 694Q1450 719 1440 737.50Q1430 756 1413.50 768.50Q1397 781 1375.50 787Q1354 793 1332 793L1332 793Q1303 793 1282.50 780.50Q1262 768 1244 749.50Q1226 731 1206.50 709Q1187 687 1159 668.50Q1131 650 1090.50 637.50Q1050 625 991 625L991 625Q959 625 926 632Q893 639 866.50 654.50Q840 670 823.50 696Q807 722 807 760Z"
         }
      }
   ]
}

var TabCenter = {
   name: "TabCenter",
   vendor: "UiFabric",
   unicode: 61696,
   value: "",
   charCode: "F100",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 640L1920 640L1920 1920L512 1920L512 1408L128 1408L128 128L1536 128L1536 640ZM640 1792L1792 1792L1792 1024L640 1024L640 1792ZM256 1280L512 1280L512 640L1408 640L1408 512L256 512L256 1280ZM1408 256L256 256L256 384L1408 384L1408 256ZM1792 896L1792 768L640 768L640 896L1792 896Z"
         }
      }
   ]
}

var PageCheckedin = {
   name: "PageCheckedin",
   vendor: "UiFabric",
   unicode: 61700,
   value: "",
   charCode: "F104",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L1280 1920L1280 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1280L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM2029 1939L1939 2029L1536 1627L1536 1920L1408 1920L1408 1408L1920 1408L1920 1536L1627 1536L2029 1939Z"
         }
      }
   ]
}

var PageList = {
   name: "PageList",
   vendor: "UiFabric",
   unicode: 61702,
   value: "",
   charCode: "F106",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1792 0L1792 1792L256 1792L256 0ZM1664 1664L1664 128L384 128L384 1664L1664 1664ZM640 768L640 896L512 896L512 768L640 768ZM1536 768L1536 896L768 896L768 768L1536 768ZM640 1152L640 1280L512 1280L512 1152L640 1152ZM1536 1152L1536 1280L768 1280L768 1152L1536 1152ZM640 384L640 512L512 512L512 384L640 384ZM1536 384L1536 512L768 512L768 384L1536 384Z"
         }
      }
   ]
}

var ReadOutLoud = {
   name: "ReadOutLoud",
   vendor: "UiFabric",
   unicode: 61714,
   value: "",
   charCode: "F112",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1152L928 1152L1312 768L1408 768L1408 2048L1312 2048L928 1664L640 1664L640 1152ZM981 1536L1280 1835L1280 981L981 1280L768 1280L768 1536L981 1536ZM1514 1046L1605 955Q1696 1046 1744 1163Q1792 1280 1792 1408L1792 1408Q1792 1536 1744 1653Q1696 1770 1605 1861L1605 1861L1514 1770Q1586 1698 1625 1604.50Q1664 1511 1664 1408L1664 1408Q1664 1305 1625 1211.50Q1586 1118 1514 1046L1514 1046ZM2048 1408L2048 1408Q2048 1588 1980 1751Q1912 1914 1786 2042L1786 2042L1695 1951Q1804 1842 1862 1702Q1920 1562 1920 1408L1920 1408Q1920 1254 1862 1114Q1804 974 1695 865L1695 865L1786 774Q1912 902 1980 1065Q2048 1228 2048 1408ZM614 128L614 128L128 128L128 1664L512 1664L512 1792L0 1792L0 0L614 0Q722 0 811.50 42Q901 84 960 177L960 177Q1018 84 1108 42Q1198 0 1306 0L1306 0L1920 0L1920 685Q1894 650 1858.50 618Q1823 586 1792 555L1792 555L1792 128L1306 128Q1218 128 1150.50 165Q1083 202 1046 284L1046 284Q1043 290 1039.50 300Q1036 310 1032.50 321Q1029 332 1026.50 342.50Q1024 353 1024 360L1024 360L1024 830L896 958L896 360Q896 353 893.50 342.50Q891 332 887.50 321Q884 310 880.50 300Q877 290 874 284L874 284Q837 202 769.50 165Q702 128 614 128Z"
         }
      }
   ]
}

var ScreenPreviewOn = {
   name: "ScreenPreviewOn",
   vendor: "UiFabric",
   unicode: 61726,
   value: "",
   charCode: "F11E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L1920 384L1920 1664L0 1664L0 384ZM1796 1540L1796 508L124 508L124 1540L1796 1540ZM768 640L1280 1024L768 1408L768 640ZM880 864L880 1184L1093 1024L880 864Z"
         }
      }
   ]
}

var CaretBottomLeftSolid8 = {
   name: "CaretBottomLeftSolid8",
   vendor: "UiFabric",
   unicode: 61729,
   value: "",
   charCode: "F121",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 64L1984 2048L0 2048L0 64Z"
         }
      }
   ]
}

var CaretBottomRightSolid8 = {
   name: "CaretBottomRightSolid8",
   vendor: "UiFabric",
   unicode: 61730,
   value: "",
   charCode: "F122",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 2048L2048 64L2048 2048L64 2048Z"
         }
      }
   ]
}

var FolderHorizontal = {
   name: "FolderHorizontal",
   vendor: "UiFabric",
   unicode: 61739,
   value: "",
   charCode: "F12B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L608 256Q653 256 685.50 265.50Q718 275 743.50 289Q769 303 789 320Q809 337 829.50 351Q850 365 873.50 374.50Q897 384 928 384L928 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512L2048 512L2048 1792L0 1792L0 384Q0 357 10 334Q20 311 37.50 293.50Q55 276 78 266Q101 256 128 256L128 256ZM608 384L128 384L128 512L608 512Q632 512 650 507.50Q668 503 683 494.50Q698 486 712.50 474.50Q727 463 744 448L744 448Q727 433 712.50 421.50Q698 410 683 401.50Q668 393 650 388.50Q632 384 608 384L608 384ZM1920 1664L1920 512L928 512Q897 512 873.50 521.50Q850 531 829.50 545Q809 559 789 576Q769 593 743.50 607Q718 621 685.50 630.50Q653 640 608 640L608 640L128 640L128 1664L1920 1664Z"
         }
      }
   ]
}

var MicrosoftStaffhubLogo = {
   name: "MicrosoftStaffhubLogo",
   vendor: "UiFabric",
   unicode: 61744,
   value: "",
   charCode: "F130",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM947 1655L947 1655Q1035 1655 1120.50 1637Q1206 1619 1273 1576.50Q1340 1534 1381 1464Q1422 1394 1422 1291L1422 1291Q1422 1215 1395.50 1158Q1369 1101 1325 1058Q1281 1015 1223.50 982Q1166 949 1105 919L1105 919Q1089 911 1068 900.50Q1047 890 1025.50 878Q1004 866 984.50 853Q965 840 953 827L953 827Q933 807 924.50 784Q916 761 916 732L916 732Q916 697 932 673.50Q948 650 972.50 635.50Q997 621 1027.50 615Q1058 609 1087 609L1087 609Q1124 609 1157.50 613.50Q1191 618 1222.50 627Q1254 636 1284.50 649.50Q1315 663 1347 681L1347 681Q1351 683 1354 683L1354 683Q1368 683 1368 669L1368 669L1368 449Q1368 440 1359 436L1359 436Q1330 423 1293.50 415Q1257 407 1218 402Q1179 397 1141 395Q1103 393 1072 393L1072 393Q987 393 907 414Q827 435 764.50 479.50Q702 524 664 592.50Q626 661 626 756L626 756Q626 826 647.50 878.50Q669 931 705 971.50Q741 1012 786.50 1042.50Q832 1073 879 1098Q926 1123 971.50 1145.50Q1017 1168 1053 1193Q1089 1218 1110.50 1247Q1132 1276 1132 1315L1132 1315Q1132 1351 1115.50 1375Q1099 1399 1073 1413.50Q1047 1428 1015.50 1433.50Q984 1439 954 1439L954 1439Q908 1439 869 1432Q830 1425 795 1411Q760 1397 725.50 1377.50Q691 1358 654 1332L654 1332Q650 1330 646 1330L646 1330Q641 1330 636.50 1333.50Q632 1337 632 1343L632 1343L632 1579Q632 1587 639 1591L639 1591Q672 1609 710 1621.50Q748 1634 788.50 1641.50Q829 1649 869.50 1652Q910 1655 947 1655Z"
         }
      }
   ]
}

var GiftboxOpen = {
   name: "GiftboxOpen",
   vendor: "UiFabric",
   unicode: 61747,
   value: "",
   charCode: "F133",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M192 480L192 480Q169 426 127.50 384.50Q86 343 32 320L32 320Q86 297 127.50 255.50Q169 214 192 160L192 160Q215 214 256.50 255.50Q298 297 352 320L352 320Q298 343 256.50 384.50Q215 426 192 480ZM1856 544L1856 544Q1879 598 1920.50 639.50Q1962 681 2016 704L2016 704Q1962 727 1920.50 768.50Q1879 810 1856 864L1856 864Q1833 810 1791.50 768.50Q1750 727 1696 704L1696 704Q1750 681 1791.50 639.50Q1833 598 1856 544ZM1472 640L1472 640Q1425 531 1343 449Q1261 367 1152 320L1152 320Q1261 273 1343 191Q1425 109 1472 0L1472 0Q1519 109 1601 191Q1683 273 1792 320L1792 320Q1683 367 1601 449Q1519 531 1472 640ZM1472 194L1472 194Q1416 265 1346 320L1346 320Q1416 376 1472 446L1472 446Q1527 376 1598 320L1598 320Q1527 265 1472 194ZM747 785L747 785Q700 785 658.50 765.50Q617 746 586 713Q555 680 537.50 637Q520 594 520 548L520 548Q520 489 544.50 437.50Q569 386 610 347.50Q651 309 704.50 286.50Q758 264 816 264L816 264Q900 264 965.50 299.50Q1031 335 1076 393Q1121 451 1144.50 525Q1168 599 1168 676L1168 676Q1168 781 1134 872.50Q1100 964 1040.50 1039Q981 1114 900 1171.50Q819 1229 726 1268L726 1268Q717 1272 703 1272L703 1272Q680 1272 664 1255.50Q648 1239 648 1216L648 1216Q648 1180 682 1164L682 1164Q758 1128 822.50 1086.50Q887 1045 935.50 991.50Q984 938 1014.50 869.50Q1045 801 1054 712L1054 712Q1055 702 1055.50 692.50Q1056 683 1056 673L1056 673Q1056 621 1041 568Q1026 515 996 472Q966 429 921 402.50Q876 376 816 376L816 376Q782 376 749 389.50Q716 403 690 426Q664 449 648 480.50Q632 512 632 548L632 548Q632 571 641 593.50Q650 616 665.50 633.50Q681 651 702.50 662Q724 673 748 673L748 673Q772 673 786 665.50Q800 658 809 646Q818 634 823.50 621Q829 608 835.50 596Q842 584 852.50 576.50Q863 569 881 569L881 569Q904 569 921 586Q938 603 938 626L938 626Q938 631 936 639L936 639Q928 671 909.50 698Q891 725 866 744.50Q841 764 810.50 774.50Q780 785 747 785ZM1261 896L1627 896L1901 1171L1811 1261L1664 1115L1664 2048L256 2048L256 1115L109 1261L19 1171L293 896L848 896Q813 937 770.50 968.50Q728 1000 680 1024L680 1024L384 1024L384 1920L1536 1920L1536 1024L1205 1024Q1222 993 1236 961Q1250 929 1261 896L1261 896Z"
         }
      }
   ]
}

var StatusCircleOuter = {
   name: "StatusCircleOuter",
   vendor: "UiFabric",
   unicode: 61750,
   value: "",
   charCode: "F136",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 128L960 128Q1092 128 1214.50 162.50Q1337 197 1444 259.50Q1551 322 1638.50 409.50Q1726 497 1788.50 604Q1851 711 1885.50 833.50Q1920 956 1920 1088L1920 1088Q1920 1220 1885.50 1342.50Q1851 1465 1788.50 1572Q1726 1679 1638.50 1766.50Q1551 1854 1444 1916.50Q1337 1979 1214.50 2013.50Q1092 2048 960 2048L960 2048Q828 2048 705.50 2013.50Q583 1979 476 1916.50Q369 1854 281.50 1766.50Q194 1679 131.50 1572Q69 1465 34.50 1342.50Q0 1220 0 1088L0 1088Q0 956 34.50 833.50Q69 711 131.50 604Q194 497 281.50 409.50Q369 322 476 259.50Q583 197 705.50 162.50Q828 128 960 128Z"
         }
      }
   ]
}

var StatusCircleInner = {
   name: "StatusCircleInner",
   vendor: "UiFabric",
   unicode: 61751,
   value: "",
   charCode: "F137",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 256L960 256Q1075 256 1181 286Q1287 316 1379.50 370Q1472 424 1548 500Q1624 576 1678 668.50Q1732 761 1762 867Q1792 973 1792 1088L1792 1088Q1792 1203 1762 1309Q1732 1415 1678 1507.50Q1624 1600 1548 1676Q1472 1752 1379.50 1806Q1287 1860 1181 1890Q1075 1920 960 1920L960 1920Q845 1920 739 1890Q633 1860 540.50 1806Q448 1752 372 1676Q296 1600 242 1507.50Q188 1415 158 1309Q128 1203 128 1088L128 1088Q128 973 158 867Q188 761 242 668.50Q296 576 372 500Q448 424 540.50 370Q633 316 739 286Q845 256 960 256Z"
         }
      }
   ]
}

var StatusCircleRing = {
   name: "StatusCircleRing",
   vendor: "UiFabric",
   unicode: 61752,
   value: "",
   charCode: "F138",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 256L960 256Q1075 256 1181.50 285.50Q1288 315 1380.50 369.50Q1473 424 1548.50 499.50Q1624 575 1678.50 667.50Q1733 760 1762.50 866.50Q1792 973 1792 1088L1792 1088Q1792 1203 1762.50 1309.50Q1733 1416 1678.50 1508.50Q1624 1601 1548.50 1676.50Q1473 1752 1380.50 1806.50Q1288 1861 1181.50 1890.50Q1075 1920 960 1920L960 1920Q845 1920 738.50 1890.50Q632 1861 539.50 1806.50Q447 1752 371.50 1676.50Q296 1601 241.50 1508.50Q187 1416 157.50 1309.50Q128 1203 128 1088L128 1088Q128 973 157.50 866.50Q187 760 241.50 667.50Q296 575 371.50 499.50Q447 424 539.50 369.50Q632 315 738.50 285.50Q845 256 960 256ZM960 1792L960 1792Q1057 1792 1147 1767Q1237 1742 1315 1696Q1393 1650 1457.50 1585.50Q1522 1521 1568 1443Q1614 1365 1639 1275Q1664 1185 1664 1088L1664 1088Q1664 991 1639 901Q1614 811 1568 733Q1522 655 1457.50 590.50Q1393 526 1315 480Q1237 434 1147 409Q1057 384 960 384L960 384Q863 384 773 409Q683 434 605 480Q527 526 462.50 590.50Q398 655 352 733Q306 811 281 901Q256 991 256 1088L256 1088Q256 1185 281 1275Q306 1365 352 1443Q398 1521 462.50 1585.50Q527 1650 605 1696Q683 1742 773 1767Q863 1792 960 1792Z"
         }
      }
   ]
}

var StatusTriangleOuter = {
   name: "StatusTriangleOuter",
   vendor: "UiFabric",
   unicode: 61753,
   value: "",
   charCode: "F139",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 128L1920 2048L0 2048L960 128Z"
         }
      }
   ]
}

var StatusTriangleInner = {
   name: "StatusTriangleInner",
   vendor: "UiFabric",
   unicode: 61754,
   value: "",
   charCode: "F13A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 512L1664 1920L256 1920L960 512Z"
         }
      }
   ]
}

var StatusTriangleExclamation = {
   name: "StatusTriangleExclamation",
   vendor: "UiFabric",
   unicode: 61755,
   value: "",
   charCode: "F13B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1664L1024 1792L896 1792L896 1664L1024 1664ZM1024 896L1024 1536L896 1536L896 896L1024 896Z"
         }
      }
   ]
}

var StatusCircleExclamation = {
   name: "StatusCircleExclamation",
   vendor: "UiFabric",
   unicode: 61756,
   value: "",
   charCode: "F13C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1536L896 1408L1024 1408L1024 1536L896 1536ZM896 640L1024 640L1024 1280L896 1280L896 640Z"
         }
      }
   ]
}

var StatusCircleErrorX = {
   name: "StatusCircleErrorX",
   vendor: "UiFabric",
   unicode: 61757,
   value: "",
   charCode: "F13D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1421 717L1050 1088L1421 1459L1331 1549L960 1178L589 1549L499 1459L870 1088L499 717L589 627L960 998L1331 627L1421 717Z"
         }
      }
   ]
}

var StatusCircleCheckmark = {
   name: "StatusCircleCheckmark",
   vendor: "UiFabric",
   unicode: 61758,
   value: "",
   charCode: "F13E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1363 851L1453 941L832 1562L467 1197L557 1107L832 1382L1363 851Z"
         }
      }
   ]
}

var StatusCircleInfo = {
   name: "StatusCircleInfo",
   vendor: "UiFabric",
   unicode: 61759,
   value: "",
   charCode: "F13F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1536L896 896L1024 896L1024 1536L896 1536ZM896 640L1024 640L1024 768L896 768L896 640Z"
         }
      }
   ]
}

var StatusCircleBlock = {
   name: "StatusCircleBlock",
   vendor: "UiFabric",
   unicode: 61760,
   value: "",
   charCode: "F140",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 256L960 256Q1075 256 1181.50 285.50Q1288 315 1380.50 369.50Q1473 424 1548.50 499.50Q1624 575 1678.50 667.50Q1733 760 1762.50 866.50Q1792 973 1792 1088L1792 1088Q1792 1203 1762.50 1309.50Q1733 1416 1678.50 1508.50Q1624 1601 1548.50 1676.50Q1473 1752 1380.50 1806.50Q1288 1861 1181.50 1890.50Q1075 1920 960 1920L960 1920Q845 1920 738.50 1890.50Q632 1861 539.50 1806.50Q447 1752 371.50 1676.50Q296 1601 241.50 1508.50Q187 1416 157.50 1309.50Q128 1203 128 1088L128 1088Q128 973 157.50 866.50Q187 760 241.50 667.50Q296 575 371.50 499.50Q447 424 539.50 369.50Q632 315 738.50 285.50Q845 256 960 256ZM960 1792L960 1792Q1084 1792 1199.50 1750.50Q1315 1709 1410 1629L1410 1629L419 638Q339 733 297.50 848.50Q256 964 256 1088L256 1088Q256 1185 281 1275Q306 1365 352 1443Q398 1521 462.50 1585.50Q527 1650 605 1696Q683 1742 773 1767Q863 1792 960 1792ZM510 547L1501 1538Q1581 1443 1622.50 1327.50Q1664 1212 1664 1088L1664 1088Q1664 991 1639 901Q1614 811 1568 733Q1522 655 1457.50 590.50Q1393 526 1315 480Q1237 434 1147 409Q1057 384 960 384L960 384Q836 384 720.50 425.50Q605 467 510 547L510 547Z"
         }
      }
   ]
}

var StatusCircleBlock2 = {
   name: "StatusCircleBlock2",
   vendor: "UiFabric",
   unicode: 61761,
   value: "",
   charCode: "F141",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 1024L1408 1024L1408 1152L512 1152L512 1024Z"
         }
      }
   ]
}

var StatusCircleQuestionMark = {
   name: "StatusCircleQuestionMark",
   vendor: "UiFabric",
   unicode: 61762,
   value: "",
   charCode: "F142",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1664L896 1536L1024 1536L1024 1664L896 1664ZM960 576L960 576Q1026 576 1084 601.50Q1142 627 1185.50 670.50Q1229 714 1254.50 772Q1280 830 1280 896L1280 896Q1280 956 1261 1000.50Q1242 1045 1213.50 1081Q1185 1117 1152 1146.50Q1119 1176 1090.50 1205.50Q1062 1235 1043 1268.50Q1024 1302 1024 1344L1024 1344L1024 1408L896 1408L896 1344Q896 1284 915 1239.50Q934 1195 962.50 1159Q991 1123 1024 1093.50Q1057 1064 1085.50 1034.50Q1114 1005 1133 972Q1152 939 1152 896L1152 896Q1152 856 1137 821Q1122 786 1096 760Q1070 734 1035 719Q1000 704 960 704L960 704Q920 704 885 719Q850 734 824 760Q798 786 783 821Q768 856 768 896L768 896L640 896Q640 830 665 772Q690 714 733.50 670.50Q777 627 835.50 601.50Q894 576 960 576Z"
         }
      }
   ]
}

var StatusCircleSync = {
   name: "StatusCircleSync",
   vendor: "UiFabric",
   unicode: 61763,
   value: "",
   charCode: "F143",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 640L1408 640L1408 1024L1024 1024L1024 896L1214 896Q1169 836 1102 802Q1035 768 960 768L960 768Q901 768 848.50 788Q796 808 754 843.50Q712 879 684 928Q656 977 646 1035L646 1035L519 1013Q533 932 573 864Q613 796 671.50 746Q730 696 804 668Q878 640 960 640L960 640Q1051 640 1134 675.50Q1217 711 1280 777L1280 777L1280 640ZM960 1408L960 1408Q1018 1408 1071 1388Q1124 1368 1166 1332.50Q1208 1297 1236 1248Q1264 1199 1274 1141L1274 1141L1401 1163Q1387 1244 1347 1312Q1307 1380 1248.50 1430Q1190 1480 1116 1508Q1042 1536 960 1536L960 1536Q869 1536 786 1500.50Q703 1465 640 1399L640 1399L640 1536L512 1536L512 1152L896 1152L896 1280L706 1280Q751 1340 818 1374Q885 1408 960 1408Z"
         }
      }
   ]
}

var Toll = {
   name: "Toll",
   vendor: "UiFabric",
   unicode: 61792,
   value: "",
   charCode: "F160",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1768L768 1920L896 1920L896 2048L0 2048L0 0L1024 0L1024 384L768 384L768 1304L1853 762L2038 1133L768 1768ZM768 1448L768 1624L1024 1496L1024 1320L768 1448ZM1152 1256L1152 1432L1408 1304L1408 1128L1152 1256ZM1866 1075L1795 934L1536 1064L1536 1240L1866 1075ZM384 1280L640 1280L640 640L384 640L384 1280ZM128 128L128 256L896 256L896 128L128 128ZM128 1920L640 1920L640 1408L256 1408L256 512L640 512L640 384L128 384L128 1920Z"
         }
      }
   ]
}

var ExploreContentSingle = {
   name: "ExploreContentSingle",
   vendor: "UiFabric",
   unicode: 61796,
   value: "",
   charCode: "F164",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L1792 256L1792 1920L128 1920L128 256ZM1664 1792L1664 384L256 384L256 1792L1664 1792ZM896 1536L896 1152L512 1152L512 1024L896 1024L896 640L1024 640L1024 1024L1408 1024L1408 1152L1024 1152L1024 1536L896 1536Z"
         }
      }
   ]
}

var CollapseContent = {
   name: "CollapseContent",
   vendor: "UiFabric",
   unicode: 61797,
   value: "",
   charCode: "F165",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L2048 0L2048 1792L1920 1792L1920 128L256 128L256 0ZM128 1920L128 256L1792 256L1792 1920L128 1920ZM256 384L256 1792L1664 1792L1664 384L256 384ZM512 1152L512 1024L1408 1024L1408 1152L512 1152Z"
         }
      }
   ]
}

var CollapseContentSingle = {
   name: "CollapseContentSingle",
   vendor: "UiFabric",
   unicode: 61798,
   value: "",
   charCode: "F166",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L1792 256L1792 1920L128 1920L128 256ZM1664 1792L1664 384L256 384L256 1792L1664 1792ZM1408 1024L1408 1152L512 1152L512 1024L1408 1024Z"
         }
      }
   ]
}

var InfoSolid = {
   name: "InfoSolid",
   vendor: "UiFabric",
   unicode: 61799,
   value: "",
   charCode: "F167",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1215Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q828 1920 705 1885.50Q582 1851 475.50 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444.50Q69 1338 34.50 1215.50Q0 1093 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 704.50 34.50Q827 0 960 0ZM1024 1408L1024 768L896 768L896 1408L1024 1408ZM1024 640L1024 512L896 512L896 640L1024 640Z"
         }
      }
   ]
}

var GroupList = {
   name: "GroupList",
   vendor: "UiFabric",
   unicode: 61800,
   value: "",
   charCode: "F168",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 768L640 640L2048 640L2048 768L640 768ZM640 256L2048 256L2048 384L640 384L640 256ZM128 128L384 128L384 256L256 256L256 768L384 768L384 896L128 896L128 128ZM640 1664L640 1536L2048 1536L2048 1664L640 1664ZM640 1280L640 1152L2048 1152L2048 1280L640 1280ZM128 1024L384 1024L384 1152L256 1152L256 1664L384 1664L384 1792L128 1792L128 1024Z"
         }
      }
   ]
}

var ProgressRingDots = {
   name: "ProgressRingDots",
   vendor: "UiFabric",
   unicode: 61802,
   value: "",
   charCode: "F16A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 96L1024 96Q1057 96 1086 108.50Q1115 121 1137 143Q1159 165 1171.50 194Q1184 223 1184 256L1184 256Q1184 289 1171.50 318Q1159 347 1137 369Q1115 391 1086 403.50Q1057 416 1024 416L1024 416Q991 416 962 403.50Q933 391 911 369Q889 347 876.50 318Q864 289 864 256L864 256Q864 223 876.50 194Q889 165 911 143Q933 121 962 108.50Q991 96 1024 96ZM337 481L337 481Q337 451 348 425Q359 399 378.50 379.50Q398 360 424.50 348.50Q451 337 481 337L481 337Q511 337 537 348.50Q563 360 582.50 379.50Q602 399 613.50 425Q625 451 625 481L625 481Q625 511 613.50 537.50Q602 564 582.50 583.50Q563 603 537 614Q511 625 481 625L481 625Q451 625 424.50 614Q398 603 378.50 583.50Q359 564 348 537.50Q337 511 337 481ZM256 896L256 896Q283 896 306 906Q329 916 346.50 933.50Q364 951 374 974Q384 997 384 1024L384 1024Q384 1051 374 1074Q364 1097 346.50 1114.50Q329 1132 306 1142Q283 1152 256 1152L256 1152Q229 1152 206 1142Q183 1132 165.50 1114.50Q148 1097 138 1074Q128 1051 128 1024L128 1024Q128 997 138 974Q148 951 165.50 933.50Q183 916 206 906Q229 896 256 896ZM369 1567L369 1567Q369 1544 378 1523.50Q387 1503 402 1488Q417 1473 437.50 1464Q458 1455 481 1455L481 1455Q504 1455 524.50 1464Q545 1473 560 1488Q575 1503 584 1523.50Q593 1544 593 1567L593 1567Q593 1590 584 1610.50Q575 1631 560 1646Q545 1661 524.50 1670Q504 1679 481 1679L481 1679Q458 1679 437.50 1670Q417 1661 402 1646Q387 1631 378 1610.50Q369 1590 369 1567ZM1024 1696L1024 1696Q1064 1696 1092 1724Q1120 1752 1120 1792L1120 1792Q1120 1832 1092 1860Q1064 1888 1024 1888L1024 1888Q984 1888 956 1860Q928 1832 928 1792L928 1792Q928 1752 956 1724Q984 1696 1024 1696ZM1487 1567L1487 1567Q1487 1533 1510 1510Q1533 1487 1567 1487L1567 1487Q1601 1487 1624 1510Q1647 1533 1647 1567L1647 1567Q1647 1601 1624 1624Q1601 1647 1567 1647L1567 1647Q1533 1647 1510 1624Q1487 1601 1487 1567ZM1792 960L1792 960Q1818 960 1837 979Q1856 998 1856 1024L1856 1024Q1856 1050 1837 1069Q1818 1088 1792 1088L1792 1088Q1766 1088 1747 1069Q1728 1050 1728 1024L1728 1024Q1728 998 1747 979Q1766 960 1792 960ZM1567 305L1567 305Q1603 305 1635 319Q1667 333 1691 357Q1715 381 1729 413Q1743 445 1743 481L1743 481Q1743 517 1729 549Q1715 581 1691 605Q1667 629 1635 643Q1603 657 1567 657L1567 657Q1531 657 1499 643Q1467 629 1443 605Q1419 581 1405 549Q1391 517 1391 481L1391 481Q1391 445 1405 413Q1419 381 1443 357Q1467 333 1499 319Q1531 305 1567 305Z"
         }
      }
   ]
}

var CheckboxIndeterminateCombo = {
   name: "CheckboxIndeterminateCombo",
   vendor: "UiFabric",
   unicode: 61806,
   value: "",
   charCode: "F16E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1920L1920 128L128 128L128 1920L1920 1920ZM1536 512L1536 1536L512 1536L512 512L1536 512Z"
         }
      }
   ]
}

var CaloriesAdd = {
   name: "CaloriesAdd",
   vendor: "UiFabric",
   unicode: 61810,
   value: "",
   charCode: "F172",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1280L384 1280Q384 1368 407 1450Q430 1532 471.50 1603Q513 1674 571.50 1732.50Q630 1791 701 1832.50Q772 1874 854 1897Q936 1920 1024 1920L1024 1920Q1090 1920 1155 1906.50Q1220 1893 1280 1866L1280 1866L1280 2003Q1157 2048 1024 2048L1024 2048Q918 2048 820 2020.50Q722 1993 636.50 1943Q551 1893 481 1823Q411 1753 361 1667.50Q311 1582 283.50 1484Q256 1386 256 1280L256 1280Q256 1196 274 1115Q292 1034 326 960Q360 886 410 819.50Q460 753 523 698L523 698Q529 735 541.50 776Q554 817 570.50 857Q587 897 608.50 934Q630 971 654 999L654 999Q676 1024 706 1024L706 1024Q733 1024 751.50 1005Q770 986 770 959L770 959Q770 948 766.50 939Q763 930 757 921L757 921Q701 839 670.50 758Q640 677 640 576L640 576Q640 457 685.50 352Q731 247 809 169Q887 91 992 45.50Q1097 0 1216 0L1216 0L1280 0L1280 64Q1280 241 1346 394Q1412 547 1536 672L1536 672Q1660 797 1726 950Q1792 1103 1792 1280L1792 1280L1664 1280Q1664 1128 1608 999Q1552 870 1446 763L1446 763Q1316 631 1242 474.50Q1168 318 1154 132L1154 132Q1071 143 1000.50 182.50Q930 222 878 281.50Q826 341 797 416.50Q768 492 768 576L768 576Q768 655 791.50 717Q815 779 859 843L859 843Q878 871 888.50 897.50Q899 924 899 959L899 959Q899 999 883.50 1034Q868 1069 842 1095.50Q816 1122 781 1137Q746 1152 706 1152L706 1152Q660 1152 625 1134.50Q590 1117 562.50 1088.50Q535 1060 514 1024Q493 988 475 952L475 952Q430 1027 407 1110Q384 1193 384 1280ZM1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408L1792 1664Z"
         }
      }
   ]
}

var BranchFork = {
   name: "BranchFork",
   vendor: "UiFabric",
   unicode: 61811,
   value: "",
   charCode: "F173",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1581 1107L1946 1472L1581 1837L1491 1747L1701 1536L0 1536L0 1408L384 1408L384 512L1317 512L1107 301L1197 211L1562 576L1197 941L1107 851L1317 640L512 640L512 1408L1701 1408L1491 1197L1581 1107Z"
         }
      }
   ]
}

var MuteChat = {
   name: "MuteChat",
   vendor: "UiFabric",
   unicode: 61818,
   value: "",
   charCode: "F17A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333ZM0 128L2048 128L2048 1217Q2020 1184 1988.50 1155Q1957 1126 1920 1103L1920 1103L1920 256L128 256L128 1408L384 1408L384 1675L651 1408L1043 1408Q1021 1471 1014 1536L1014 1536L704 1536L256 1984L256 1536L0 1536L0 128Z"
         }
      }
   ]
}

var AddHome = {
   name: "AddHome",
   vendor: "UiFabric",
   unicode: 61819,
   value: "",
   charCode: "F17B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1664L768 1664L768 1024L1280 1024L1280 1792L1152 1792L1152 1152L896 1152L896 1792L256 1792L256 987L173 1069L83 979L1024 37L1965 979L1875 1069L1792 987L1792 1280L1664 1280L1664 859L1024 219L384 859L384 1664ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408Z"
         }
      }
   ]
}

var AddWork = {
   name: "AddWork",
   vendor: "UiFabric",
   unicode: 61820,
   value: "",
   charCode: "F17C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 384L2048 384L2048 1408L1920 1408L1920 839L1280 1160L1280 1280L768 1280L768 1160L128 839L128 1536L1280 1536L1280 1664L0 1664L0 384L640 384L640 256Q640 229 650 206Q660 183 677.50 165.50Q695 148 718 138Q741 128 768 128L768 128L1280 128Q1307 128 1330 138Q1353 148 1370.50 165.50Q1388 183 1398 206Q1408 229 1408 256L1408 256L1408 384ZM768 256L768 384L1280 384L1280 256L768 256ZM1152 1152L1152 1024L896 1024L896 1152L1152 1152ZM1280 1016L1920 697L1920 512L128 512L128 697L768 1016L768 896L1280 896L1280 1016ZM1792 1280L1792 1536L2048 1536L2048 1664L1792 1664L1792 1920L1664 1920L1664 1664L1408 1664L1408 1536L1664 1536L1664 1280L1792 1280Z"
         }
      }
   ]
}

var ScreenTime = {
   name: "ScreenTime",
   vendor: "UiFabric",
   unicode: 61826,
   value: "",
   charCode: "F182",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L1920 1024Q1983 1107 2015.50 1205.50Q2048 1304 2048 1408L2048 1408Q2048 1541 1998 1657.50Q1948 1774 1861 1861Q1774 1948 1657.50 1998Q1541 2048 1408 2048L1408 2048Q1275 2048 1158.50 1998Q1042 1948 955 1861Q868 1774 818 1657.50Q768 1541 768 1408L768 1408L128 1408Q101 1408 78 1398Q55 1388 37.50 1370.50Q20 1353 10 1330Q0 1307 0 1280L0 1280L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L1792 128Q1819 128 1842 138Q1865 148 1882.50 165.50Q1900 183 1910 206Q1920 229 1920 256L1920 256ZM128 1280L781 1280Q803 1168 861 1074Q919 980 1003 912Q1087 844 1190.50 806Q1294 768 1408 768L1408 768Q1512 768 1610.50 800.50Q1709 833 1792 896L1792 896L1792 256L128 256L128 1280ZM1408 1920L1408 1920Q1514 1920 1607 1879.50Q1700 1839 1769.50 1769.50Q1839 1700 1879.50 1607Q1920 1514 1920 1408L1920 1408Q1920 1302 1879.50 1209Q1839 1116 1769.50 1046.50Q1700 977 1607 936.50Q1514 896 1408 896L1408 896Q1302 896 1209 936.50Q1116 977 1046.50 1046.50Q977 1116 936.50 1209Q896 1302 896 1408L896 1408Q896 1514 936.50 1607Q977 1700 1046.50 1769.50Q1116 1839 1209 1879.50Q1302 1920 1408 1920ZM1408 1024L1408 1408L1664 1408L1664 1536L1280 1536L1280 1024L1408 1024Z"
         }
      }
   ]
}

var MobileReport = {
   name: "MobileReport",
   vendor: "UiFabric",
   unicode: 61834,
   value: "",
   charCode: "F18A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L1920 384L1920 640L1536 640L1536 384ZM0 1664L0 1024L384 1024L384 1664L0 1664ZM512 1664L512 384L896 384L896 1664L512 1664ZM1152 768L1792 768Q1819 768 1842 778Q1865 788 1882.50 805.50Q1900 823 1910 846Q1920 869 1920 896L1920 896L1920 1920Q1920 1947 1910 1970Q1900 1993 1882.50 2010.50Q1865 2028 1842 2038Q1819 2048 1792 2048L1792 2048L1152 2048Q1125 2048 1102 2038Q1079 2028 1061.50 2010.50Q1044 1993 1034 1970Q1024 1947 1024 1920L1024 1920L1024 896Q1024 869 1034 846Q1044 823 1061.50 805.50Q1079 788 1102 778Q1125 768 1152 768L1152 768ZM1792 1920L1792 896L1152 896L1152 1920L1792 1920ZM1280 1792L1280 1664L1664 1664L1664 1792L1280 1792ZM1408 0L1408 640L1024 640L1024 0L1408 0Z"
         }
      }
   ]
}

var ScaleVolume = {
   name: "ScaleVolume",
   vendor: "UiFabric",
   unicode: 61836,
   value: "",
   charCode: "F18C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L512 128L219 128L557 467L467 557L128 219L128 512L0 512L0 0L512 0ZM1536 128L1536 0L2048 0L2048 512L1920 512L1920 219L1581 557L1491 467L1829 128L1536 128ZM128 1829L467 1491L557 1581L219 1920L512 1920L512 2048L0 2048L0 1536L128 1536L128 1829ZM1581 1491L1920 1829L1920 1536L2048 1536L2048 2048L1536 2048L1536 1920L1829 1920L1491 1581L1581 1491ZM1408 1408L640 1408L640 640L1408 640L1408 1408ZM1280 768L768 768L768 1280L1280 1280L1280 768Z"
         }
      }
   ]
}

var HardDriveGroup = {
   name: "HardDriveGroup",
   vendor: "UiFabric",
   unicode: 61839,
   value: "",
   charCode: "F18F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1408L1664 1536L1536 1536L1536 1408L1664 1408ZM1408 1408L1408 1536L1280 1536L1280 1408L1408 1408ZM1664 896L1664 1024L1536 1024L1536 896L1664 896ZM1408 896L1408 1024L1280 1024L1280 896L1408 896ZM320 128L1728 128Q1768 128 1803 143Q1838 158 1864 184Q1890 210 1905 245Q1920 280 1920 320L1920 320L1920 1792L128 1792L128 320Q128 280 143 245Q158 210 184 184Q210 158 245 143Q280 128 320 128L320 128ZM1792 1664L1792 1280L256 1280L256 1664L1792 1664ZM1792 1152L1792 768L256 768L256 1152L1792 1152ZM256 640L1792 640L1792 320Q1792 294 1773 275Q1754 256 1728 256L1728 256L320 256Q294 256 275 275Q256 294 256 320L256 320L256 640ZM1536 512L1536 384L1664 384L1664 512L1536 512ZM1280 512L1280 384L1408 384L1408 512L1280 512Z"
         }
      }
   ]
}

var FastMode = {
   name: "FastMode",
   vendor: "UiFabric",
   unicode: 61850,
   value: "",
   charCode: "F19A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1022 1L1428 385Q1481 381 1538 391.50Q1595 402 1649.50 424.50Q1704 447 1753.50 480.50Q1803 514 1840 557.50Q1877 601 1898.50 653Q1920 705 1920 764L1920 764Q1920 827 1893.50 875.50Q1867 924 1823.50 957Q1780 990 1725 1006.50Q1670 1023 1612 1023L1612 1023Q1569 1023 1531 1016L1531 1016Q1533 1034 1534.50 1052Q1536 1070 1536 1088L1536 1088Q1536 1139 1527.50 1185.50Q1519 1232 1505 1280L1505 1280L415 1280Q403 1231 393.50 1185Q384 1139 384 1088L384 1088Q384 1072 385 1056Q386 1040 388 1024L388 1024Q334 1024 287 1004.50Q240 985 204.50 950.50Q169 916 148.50 869Q128 822 128 768L128 768Q128 715 148 668.50Q168 622 203 587Q238 552 284.50 532Q331 512 384 512L384 512Q453 512 510.50 545.50Q568 579 604 638L604 638Q689 569 780.50 540.50Q872 512 980 512L980 512Q938 461 917 400.50Q896 340 896 275L896 275Q896 233 907 197Q918 161 936 128Q954 95 976.50 64Q999 33 1022 1L1022 1ZM256 768L256 768Q256 795 266 818Q276 841 293.50 858.50Q311 876 334 886Q357 896 384 896L384 896Q404 896 422 890L422 890Q453 805 507 736L507 736Q496 695 461.50 667.50Q427 640 384 640L384 640Q357 640 334 650Q311 660 293.50 677.50Q276 695 266 718Q256 741 256 768ZM888 1152L1403 1152Q1406 1136 1407 1120Q1408 1104 1408 1088L1408 1088Q1408 1058 1403 1029Q1398 1000 1390 971L1390 971Q1348 950 1309.50 921Q1271 892 1240 856Q1209 820 1187 777.50Q1165 735 1158 688L1158 688Q1112 665 1062 652.50Q1012 640 960 640L960 640Q869 640 788 676Q707 712 645.50 773.50Q584 835 548 916Q512 997 512 1088L512 1088Q512 1104 513.50 1120Q515 1136 517 1152L517 1152L757 1152Q768 1114 768 1077L768 1077Q768 1020 744 968.50Q720 917 676 880L676 880L758 782Q824 837 859.50 912.50Q895 988 895 1075L895 1075Q895 1095 893.50 1114Q892 1133 888 1152L888 1152ZM1613 895L1613 895Q1643 895 1675 888Q1707 881 1733 865Q1759 849 1775.50 824Q1792 799 1792 763L1792 763Q1792 708 1759 662Q1726 616 1676.50 582.50Q1627 549 1569.50 530.50Q1512 512 1463 512L1463 512Q1443 512 1424 515Q1405 518 1385 521L1385 521L1043 198Q1034 219 1029 235.50Q1024 252 1024 275L1024 275Q1024 313 1035 348Q1046 383 1066 413Q1086 443 1114 466.50Q1142 490 1177 505L1177 505Q1209 519 1244.50 523Q1280 527 1314 532L1314 532Q1305 557 1294 584.50Q1283 612 1283 639L1283 639Q1283 698 1315 745Q1347 792 1396 825.50Q1445 859 1503 877Q1561 895 1613 895Z"
         }
      }
   ]
}

var ToggleLeft = {
   name: "ToggleLeft",
   vendor: "UiFabric",
   unicode: 61854,
   value: "",
   charCode: "F19E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1130 2008 1223.50Q1968 1317 1898.50 1386.50Q1829 1456 1735.50 1496Q1642 1536 1536 1536L1536 1536L512 1536Q406 1536 312.50 1496Q219 1456 149.50 1386.50Q80 1317 40 1223.50Q0 1130 0 1024L0 1024Q0 918 40 824.50Q80 731 149.50 661.50Q219 592 312.50 552Q406 512 512 512L512 512L1536 512Q1642 512 1735.50 552Q1829 592 1898.50 661.50Q1968 731 2008 824.50Q2048 918 2048 1024ZM512 1408L1536 1408Q1615 1408 1685 1378Q1755 1348 1807.50 1295.50Q1860 1243 1890 1173.50Q1920 1104 1920 1024L1920 1024Q1920 945 1890 875Q1860 805 1807.50 752.50Q1755 700 1685 670Q1615 640 1536 640L1536 640L512 640Q432 640 362.50 670Q293 700 240.50 752.50Q188 805 158 875Q128 945 128 1024L128 1024Q128 1104 158 1173.50Q188 1243 240.50 1295.50Q293 1348 362.50 1378Q432 1408 512 1408L512 1408ZM512 768L512 768Q565 768 611.50 788Q658 808 693 843Q728 878 748 924.50Q768 971 768 1024L768 1024Q768 1077 748 1123.50Q728 1170 693 1205Q658 1240 611.50 1260Q565 1280 512 1280L512 1280Q459 1280 412.50 1260Q366 1240 331 1205Q296 1170 276 1123.50Q256 1077 256 1024L256 1024Q256 971 276 924.50Q296 878 331 843Q366 808 412.50 788Q459 768 512 768Z"
         }
      }
   ]
}

var ToggleRight = {
   name: "ToggleRight",
   vendor: "UiFabric",
   unicode: 61855,
   value: "",
   charCode: "F19F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1898 662L1898 662Q1971 735 2009.50 828Q2048 921 2048 1024L2048 1024Q2048 1127 2009.50 1220Q1971 1313 1898 1386L1898 1386Q1825 1459 1732 1497.50Q1639 1536 1536 1536L1536 1536L512 1536Q409 1536 316 1497.50Q223 1459 150 1386L150 1386Q77 1313 38.50 1220Q0 1127 0 1024L0 1024Q0 921 38.50 828Q77 735 150 662L150 662Q223 589 316 550.50Q409 512 512 512L512 512L1536 512Q1639 512 1732 550.50Q1825 589 1898 662ZM512 1408L1536 1408Q1615 1408 1685 1378Q1755 1348 1807.50 1295.50Q1860 1243 1890 1173.50Q1920 1104 1920 1024L1920 1024Q1920 945 1890 875Q1860 805 1807.50 752.50Q1755 700 1685 670Q1615 640 1536 640L1536 640L512 640Q432 640 362.50 670Q293 700 240.50 752.50Q188 805 158 875Q128 945 128 1024L128 1024Q128 1104 158 1173.50Q188 1243 240.50 1295.50Q293 1348 362.50 1378Q432 1408 512 1408L512 1408ZM1536 768L1536 768Q1589 768 1635.50 788Q1682 808 1717 843Q1752 878 1772 924.50Q1792 971 1792 1024L1792 1024Q1792 1077 1772 1123.50Q1752 1170 1717 1205Q1682 1240 1635.50 1260Q1589 1280 1536 1280L1536 1280Q1483 1280 1436.50 1260Q1390 1240 1355 1205Q1320 1170 1300 1123.50Q1280 1077 1280 1024L1280 1024Q1280 971 1300 924.50Q1320 878 1355 843Q1390 808 1436.50 788Q1483 768 1536 768Z"
         }
      }
   ]
}

var FullView = {
   name: "FullView",
   vendor: "UiFabric",
   unicode: 61858,
   value: "",
   charCode: "F1A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1664L1664 1664L1664 1280L1792 1280L1792 1792L1280 1792L1280 1664ZM1280 384L1280 256L1792 256L1792 768L1664 768L1664 384L1280 384ZM384 768L256 768L256 256L768 256L768 384L384 384L384 768ZM256 1280L384 1280L384 1664L768 1664L768 1792L256 1792L256 1280Z"
         }
      }
   ]
}

var FocusView = {
   name: "FocusView",
   vendor: "UiFabric",
   unicode: 61859,
   value: "",
   charCode: "F1A3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 640L640 640L640 256L768 256L768 768L256 768L256 640ZM640 1408L256 1408L256 1280L768 1280L768 1792L640 1792L640 1408ZM1408 1792L1280 1792L1280 1280L1792 1280L1792 1408L1408 1408L1408 1792ZM1408 256L1408 640L1792 640L1792 768L1280 768L1280 256L1408 256Z"
         }
      }
   ]
}

var CircleShape = {
   name: "CircleShape",
   vendor: "UiFabric",
   unicode: 61861,
   value: "",
   charCode: "F1A5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1148 1920 1262.50 1888Q1377 1856 1476.50 1797.50Q1576 1739 1657.50 1657.50Q1739 1576 1797.50 1476.50Q1856 1377 1888 1262.50Q1920 1148 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q900 128 785.50 160Q671 192 571.50 250.50Q472 309 390.50 390.50Q309 472 250.50 571.50Q192 671 160 785.50Q128 900 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250.50 1476.50Q309 1576 390.50 1657.50Q472 1739 571.50 1797.50Q671 1856 785.50 1888Q900 1920 1024 1920Z"
         }
      }
   ]
}

var SquareShape = {
   name: "SquareShape",
   vendor: "UiFabric",
   unicode: 61862,
   value: "",
   charCode: "F1A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1792 1792L1792 256L256 256L256 1792L1792 1792Z"
         }
      }
   ]
}

var TriangleShape = {
   name: "TriangleShape",
   vendor: "UiFabric",
   unicode: 61863,
   value: "",
   charCode: "F1A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L1920 1920L0 1920L960 0ZM960 286L207 1792L1713 1792L960 286Z"
         }
      }
   ]
}

var DropShape = {
   name: "DropShape",
   vendor: "UiFabric",
   unicode: 61864,
   value: "",
   charCode: "F1A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1607 1166Q1635 1223 1649.50 1284Q1664 1345 1664 1408L1664 1408Q1664 1496 1641 1578Q1618 1660 1576.50 1731Q1535 1802 1476.50 1860.50Q1418 1919 1347 1960.50Q1276 2002 1194 2025Q1112 2048 1024 2048L1024 2048Q936 2048 854 2025Q772 2002 701 1960.50Q630 1919 571.50 1860.50Q513 1802 471.50 1731Q430 1660 407 1578Q384 1496 384 1408L384 1408Q384 1345 398.50 1284Q413 1223 441 1166L441 1166L1024 0ZM1024 1920L1024 1920Q1130 1920 1223.50 1880Q1317 1840 1386.50 1770.50Q1456 1701 1496 1607.50Q1536 1514 1536 1408L1536 1408Q1536 1360 1525 1313Q1514 1266 1492 1223L1492 1223L1024 286L556 1223Q534 1266 523 1313Q512 1360 512 1408L512 1408Q512 1514 552 1607.50Q592 1701 661.50 1770.50Q731 1840 824.50 1880Q918 1920 1024 1920Z"
         }
      }
   ]
}

var RectangleShape = {
   name: "RectangleShape",
   vendor: "UiFabric",
   unicode: 61865,
   value: "",
   charCode: "F1A9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1664L0 1664L0 384ZM1920 1536L1920 512L128 512L128 1536L1920 1536Z"
         }
      }
   ]
}

var CubeShape = {
   name: "CubeShape",
   vendor: "UiFabric",
   unicode: 61866,
   value: "",
   charCode: "F1AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 152L1792 569L1792 1607L960 2024L128 1607L128 569L960 152ZM1585 608L960 296L335 608L960 920L1585 608ZM256 711L256 1528L896 1849L896 1032L256 711ZM1024 1849L1664 1528L1664 711L1024 1032L1024 1849Z"
         }
      }
   ]
}

var Trophy2 = {
   name: "Trophy2",
   vendor: "UiFabric",
   unicode: 61870,
   value: "",
   charCode: "F1AE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 256L1792 256Q1819 256 1842 266Q1865 276 1882.50 293.50Q1900 311 1910 334Q1920 357 1920 384L1920 384L1920 576Q1920 662 1889.50 739Q1859 816 1805 876Q1751 936 1677.50 974.50Q1604 1013 1519 1022L1519 1022Q1500 1084 1467.50 1138Q1435 1192 1391.50 1236Q1348 1280 1295 1313.50Q1242 1347 1181 1369L1181 1369Q1216 1403 1239.50 1445.50Q1263 1488 1274 1536L1274 1536L1344 1536Q1384 1536 1419 1551Q1454 1566 1480 1592Q1506 1618 1521 1653Q1536 1688 1536 1728L1536 1728L1536 1920L384 1920L384 1728Q384 1688 399 1653Q414 1618 440 1592Q466 1566 501 1551Q536 1536 576 1536L576 1536L646 1536Q657 1488 680.50 1445.50Q704 1403 739 1369L739 1369Q678 1347 625 1313.50Q572 1280 528.50 1236Q485 1192 452.50 1138Q420 1084 401 1022L401 1022Q315 1013 242 974.50Q169 936 115 876Q61 816 30.50 739Q0 662 0 576L0 576L0 384Q0 357 10 334Q20 311 37.50 293.50Q55 276 78 266Q101 256 128 256L128 256L384 256L384 128L1536 128L1536 256ZM1408 256L512 256L512 384L1408 384L1408 256ZM128 384L128 576Q128 633 147 685Q166 737 200 778.50Q234 820 281 849Q328 878 384 890L384 890L384 384L128 384ZM1408 1792L1408 1728Q1408 1702 1389 1683Q1370 1664 1344 1664L1344 1664L576 1664Q550 1664 531 1683Q512 1702 512 1728L512 1728L512 1792L1408 1792ZM779 1536L1141 1536Q1131 1507 1113 1483.50Q1095 1460 1071 1443Q1047 1426 1018.50 1417Q990 1408 960 1408L960 1408Q930 1408 901.50 1417Q873 1426 849 1443Q825 1460 807 1483.50Q789 1507 779 1536L779 1536ZM960 1280L960 1280Q1041 1280 1121.50 1253Q1202 1226 1265.50 1176.50Q1329 1127 1368.50 1056Q1408 985 1408 896L1408 896L1408 512L512 512L512 896Q512 985 551.50 1056Q591 1127 654.50 1176.50Q718 1226 798.50 1253Q879 1280 960 1280ZM1792 576L1792 384L1536 384L1536 890Q1592 878 1639 849Q1686 820 1720 778.50Q1754 737 1773 685Q1792 633 1792 576L1792 576Z"
         }
      }
   ]
}

var BucketColor = {
   name: "BucketColor",
   vendor: "UiFabric",
   unicode: 61878,
   value: "",
   charCode: "F1B6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1389 659L1690 960L832 1818L102 1088L768 421L768 192Q768 152 783 117Q798 82 824 56Q850 30 885 15Q920 0 960 0L960 0Q1000 0 1035 15Q1070 30 1096 56Q1122 82 1137 117Q1152 152 1152 192L1152 192L1152 832L1024 832L1024 192Q1024 166 1005 147Q986 128 960 128L960 128Q934 128 915 147Q896 166 896 192L896 192L896 475L347 1024L1445 1024L1510 960L1299 749L1389 659ZM347 1152L832 1638L1317 1152L347 1152ZM1728 1151L1979 1590Q1999 1625 2009 1664Q2019 1703 2019 1744L2019 1744Q2019 1805 1997 1860Q1975 1915 1936 1957Q1897 1999 1843.50 2023.50Q1790 2048 1728 2048L1728 2048Q1666 2048 1612 2024Q1558 2000 1518 1959.50Q1478 1919 1454.50 1864.50Q1431 1810 1431 1749L1431 1749Q1431 1670 1471 1601L1471 1601L1728 1151ZM1728 1920L1728 1920Q1764 1920 1794.50 1905.50Q1825 1891 1846.50 1866.50Q1868 1842 1880 1810Q1892 1778 1892 1743L1892 1743Q1892 1694 1868 1653L1868 1653L1728 1409L1582 1665Q1559 1705 1559 1749L1559 1749Q1559 1784 1572.50 1815Q1586 1846 1609 1869Q1632 1892 1662.50 1906Q1693 1920 1728 1920Z"
         }
      }
   ]
}

var BucketColorFill = {
   name: "BucketColorFill",
   vendor: "UiFabric",
   unicode: 61879,
   value: "",
   charCode: "F1B7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M832 1728L192 1088L1472 1088L832 1728ZM1728 1280L1923 1622Q1955 1678 1955 1744L1955 1744Q1955 1791 1938.50 1834Q1922 1877 1892 1910.50Q1862 1944 1821 1964Q1780 1984 1732 1984L1732 1984Q1683 1984 1640 1965.50Q1597 1947 1564.50 1915.50Q1532 1884 1513.50 1841Q1495 1798 1495 1749L1495 1749Q1495 1687 1526 1633L1526 1633L1728 1280Z"
         }
      }
   ]
}

var Taskboard = {
   name: "Taskboard",
   vendor: "UiFabric",
   unicode: 61890,
   value: "",
   charCode: "F1C2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L1920 128L1920 1920L0 1920L0 128ZM1792 1280L1792 256L1024 256L1024 1280L1792 1280ZM896 256L128 256L128 640L896 640L896 256ZM128 768L128 1792L896 1792L896 768L128 768ZM1024 1792L1792 1792L1792 1408L1024 1408L1024 1792Z"
         }
      }
   ]
}

var SingleColumn = {
   name: "SingleColumn",
   vendor: "UiFabric",
   unicode: 61907,
   value: "",
   charCode: "F1D3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 256L1920 256L1920 1792L0 1792ZM128 1664L1792 1664L1792 384L128 384L128 1664Z"
         }
      }
   ]
}

var DoubleColumn = {
   name: "DoubleColumn",
   vendor: "UiFabric",
   unicode: 61908,
   value: "",
   charCode: "F1D4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1792L0 1792L0 256L896 256L896 1792ZM768 384L128 384L128 1664L768 1664L768 384ZM1024 1792L1024 256L1920 256L1920 1792L1024 1792ZM1152 1664L1792 1664L1792 384L1152 384L1152 1664Z"
         }
      }
   ]
}

var TripleColumn = {
   name: "TripleColumn",
   vendor: "UiFabric",
   unicode: 61909,
   value: "",
   charCode: "F1D5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1792L128 1792L128 256L640 256L640 1792ZM512 384L256 384L256 1664L512 1664L512 384ZM1280 1792L768 1792L768 256L1280 256L1280 1792ZM1152 384L896 384L896 1664L1152 1664L1152 384ZM1408 1792L1408 256L1920 256L1920 1792L1408 1792ZM1536 1664L1792 1664L1792 384L1536 384L1536 1664Z"
         }
      }
   ]
}

var ColumnLeftTwoThirds = {
   name: "ColumnLeftTwoThirds",
   vendor: "UiFabric",
   unicode: 61910,
   value: "",
   charCode: "F1D6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1792L0 1792L0 256L1280 256L1280 1792ZM1152 384L128 384L128 1664L1152 1664L1152 384ZM1408 1792L1408 256L2048 256L2048 1792L1408 1792ZM1536 1664L1920 1664L1920 384L1536 384L1536 1664Z"
         }
      }
   ]
}

var ColumnRightTwoThirds = {
   name: "ColumnRightTwoThirds",
   vendor: "UiFabric",
   unicode: 61911,
   value: "",
   charCode: "F1D7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1792L768 256L2048 256L2048 1792L768 1792ZM896 1664L1920 1664L1920 384L896 384L896 1664ZM640 1792L0 1792L0 256L640 256L640 1792ZM512 384L128 384L128 1664L512 1664L512 384Z"
         }
      }
   ]
}

var AccessLogoFill = {
   name: "AccessLogoFill",
   vendor: "UiFabric",
   unicode: 61915,
   value: "",
   charCode: "F1DB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var AnalyticsLogo = {
   name: "AnalyticsLogo",
   vendor: "UiFabric",
   unicode: 61918,
   value: "",
   charCode: "F1DE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1166 2011.50 1296.50Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 998 19 979Q38 960 64 960L64 960Q90 960 109 979Q128 998 128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q998 128 979 109Q960 90 960 64L960 64Q960 38 979 19Q998 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024ZM1024 1664L1024 1664Q998 1664 979 1645Q960 1626 960 1600L960 1600Q960 1574 979 1555Q998 1536 1024 1536L1024 1536Q1130 1536 1223 1495.50Q1316 1455 1385.50 1385.50Q1455 1316 1495.50 1223Q1536 1130 1536 1024L1536 1024Q1536 918 1495.50 825Q1455 732 1385.50 662.50Q1316 593 1223 552.50Q1130 512 1024 512L1024 512Q998 512 979 493Q960 474 960 448L960 448Q960 422 979 403Q998 384 1024 384L1024 384Q1157 384 1273.50 434Q1390 484 1477 571Q1564 658 1614 774.50Q1664 891 1664 1024L1664 1024Q1664 1157 1614 1273.50Q1564 1390 1477 1477Q1390 1564 1273.50 1614Q1157 1664 1024 1664ZM960 832L960 832Q960 806 979 787Q998 768 1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1050 1261 1069Q1242 1088 1216 1088L1216 1088Q1190 1088 1171 1069Q1152 1050 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q998 896 979 877Q960 858 960 832Z"
         }
      }
   ]
}

var AnalyticsQuery = {
   name: "AnalyticsQuery",
   vendor: "UiFabric",
   unicode: 61919,
   value: "",
   charCode: "F1DF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q900 128 786 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024ZM1024 384L1024 384Q1157 384 1273.50 434Q1390 484 1477 571Q1564 658 1614 774.50Q1664 891 1664 1024L1664 1024L1536 1024Q1536 918 1495.50 825Q1455 732 1385.50 662.50Q1316 593 1223 552.50Q1130 512 1024 512L1024 512Q918 512 825 552.50Q732 593 662.50 662.50Q593 732 552.50 825Q512 918 512 1024L512 1024Q512 1127 550.50 1220Q589 1313 662 1386L662 1386L571 1477Q480 1386 432 1269Q384 1152 384 1024L384 1024Q384 891 434 774.50Q484 658 571 571Q658 484 774.50 434Q891 384 1024 384ZM1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1077 1260 1123.50Q1240 1170 1205 1205Q1170 1240 1123.50 1260Q1077 1280 1024 1280L1024 1280Q971 1280 924.50 1260Q878 1240 843 1205Q808 1170 788 1123.50Q768 1077 768 1024L768 1024Q768 971 788 924.50Q808 878 843 843Q878 808 924.50 788Q971 768 1024 768ZM1024 1152L1024 1152Q1051 1152 1074 1142Q1097 1132 1114.50 1114.50Q1132 1097 1142 1074Q1152 1051 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q997 896 974 906Q951 916 933.50 933.50Q916 951 906 974Q896 997 896 1024L896 1024Q896 1051 906 1074Q916 1097 933.50 1114.50Q951 1132 974 1142Q997 1152 1024 1152Z"
         }
      }
   ]
}

var AnalyticsReport = {
   name: "AnalyticsReport",
   vendor: "UiFabric",
   unicode: 61921,
   value: "",
   charCode: "F1E1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1024L128 1024Q128 1173 174.50 1309.50Q221 1446 305.50 1559Q390 1672 508 1756Q626 1840 768 1882L768 1882L768 2014Q599 1970 458 1875.50Q317 1781 215 1650Q113 1519 56.50 1359Q0 1199 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0L1024 0Q1159 0 1284.50 33.50Q1410 67 1520.50 128.50Q1631 190 1723.50 277Q1816 364 1884.50 470.50Q1953 577 1994.50 700Q2036 823 2045 957L2045 957L1891 803Q1853 655 1770.50 530.50Q1688 406 1573 317Q1458 228 1317.50 178Q1177 128 1024 128L1024 128Q900 128 786 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024ZM1024 512L1024 512Q918 512 825 552.50Q732 593 662.50 662.50Q593 732 552.50 825Q512 918 512 1024L512 1024Q512 1127 550.50 1220Q589 1313 662 1386L662 1386L571 1477Q480 1386 432 1269Q384 1152 384 1024L384 1024Q384 936 407 854Q430 772 471.50 701Q513 630 571.50 571.50Q630 513 701 471.50Q772 430 854 407Q936 384 1024 384L1024 384Q1099 384 1171 401.50Q1243 419 1308.50 452Q1374 485 1431 532.50Q1488 580 1533 640L1533 640L1359 640Q1289 578 1203.50 545Q1118 512 1024 512ZM896 768L1627 768L2048 1189L2048 2048L896 2048L896 768ZM1829 1152L1664 987L1664 1152L1829 1152ZM1024 1920L1920 1920L1920 1280L1536 1280L1536 896L1024 896L1024 1920ZM1664 1408L1792 1408L1792 1792L1664 1792L1664 1408ZM1280 1792L1152 1792L1152 1280L1280 1280L1280 1792ZM1536 1792L1408 1792L1408 1536L1536 1536L1536 1792Z"
         }
      }
   ]
}

var NewAnalyticsQuery = {
   name: "NewAnalyticsQuery",
   vendor: "UiFabric",
   unicode: 61920,
   value: "",
   charCode: "F1E0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q900 128 786 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024ZM1664 1024L1664 1024L1536 1024Q1536 918 1495.50 825Q1455 732 1385.50 662.50Q1316 593 1223 552.50Q1130 512 1024 512L1024 512Q918 512 825 552.50Q732 593 662.50 662.50Q593 732 552.50 825Q512 918 512 1024L512 1024Q512 1127 550.50 1220Q589 1313 662 1386L662 1386L571 1477Q480 1386 432 1269Q384 1152 384 1024L384 1024Q384 891 434 774.50Q484 658 571 571Q658 484 774.50 434Q891 384 1024 384L1024 384Q1157 384 1273.50 434Q1390 484 1477 571Q1564 658 1614 774.50Q1664 891 1664 1024ZM1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1077 1260 1123.50Q1240 1170 1205 1205Q1170 1240 1123.50 1260Q1077 1280 1024 1280L1024 1280Q971 1280 924.50 1260Q878 1240 843 1205Q808 1170 788 1123.50Q768 1077 768 1024L768 1024Q768 971 788 924.50Q808 878 843 843Q878 808 924.50 788Q971 768 1024 768ZM1024 1152L1024 1152Q1051 1152 1074 1142Q1097 1132 1114.50 1114.50Q1132 1097 1142 1074Q1152 1051 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q997 896 974 906Q951 916 933.50 933.50Q916 951 906 974Q896 997 896 1024L896 1024Q896 1051 906 1074Q916 1097 933.50 1114.50Q951 1132 974 1142Q997 1152 1024 1152ZM1664 1408L1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408Z"
         }
      }
   ]
}

var ExcelLogoFill = {
   name: "ExcelLogoFill",
   vendor: "UiFabric",
   unicode: 61926,
   value: "",
   charCode: "F1E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var ExcelLogo = {
   name: "ExcelLogo",
   vendor: "UiFabric",
   unicode: 61925,
   value: "",
   charCode: "F1E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM387 1360L512 1133L633 1360L816 1360L613 1030L812 706L637 706L525 911Q523 914 521.50 917.50Q520 921 518 925L518 925Q491 870 463 815.50Q435 761 407 706L407 706L221 706L415 1032L203 1360L387 1360ZM640 1792L1216 1792L1216 1536L640 1536L640 1792ZM1024 1408L1216 1408L1216 1088L1024 1088L1024 1408ZM1024 960L1216 960L1216 640L1024 640L1024 960ZM640 512L1216 512L1216 256L640 256L640 512ZM1344 1792L1920 1792L1920 1536L1344 1536L1344 1792ZM1344 1408L1920 1408L1920 1088L1344 1088L1344 1408ZM1344 960L1920 960L1920 640L1344 640L1344 960ZM1344 512L1920 512L1920 256L1344 256L1344 512Z"
         }
      }
   ]
}

var OneNoteLogo = {
   name: "OneNoteLogo",
   vendor: "UiFabric",
   unicode: 61927,
   value: "",
   charCode: "F1E7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM389 1359L389 939L631 1359L783 1359L783 689L635 689L635 1118L402 689L241 689L241 1359L389 1359ZM1664 1792L1920 1792L1920 1536L1664 1536L1664 1792ZM1664 1408L1920 1408L1920 1152L1664 1152L1664 1408ZM1664 1024L1920 1024L1920 768L1664 768L1664 1024ZM1536 640L1920 640L1920 256L640 256L640 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L640 1536L640 1792L1536 1792L1536 640Z"
         }
      }
   ]
}

var FlameSolid = {
   name: "FlameSolid",
   vendor: "UiFabric",
   unicode: 61939,
   value: "",
   charCode: "F1F3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1821 1315L1821 1315Q1821 1417 1795 1510.50Q1769 1604 1721.50 1685.50Q1674 1767 1607 1834Q1540 1901 1458.50 1948.50Q1377 1996 1283.50 2022Q1190 2048 1088 2048L1088 2048Q986 2048 892.50 2022Q799 1996 717.50 1948.50Q636 1901 569 1834Q502 1767 454.50 1685.50Q407 1604 381 1510.50Q355 1417 355 1315L355 1315Q355 1216 380.50 1119.50Q406 1023 459 939L459 939Q480 981 504 1022Q528 1063 559.50 1095.50Q591 1128 631 1148Q671 1168 724 1168L724 1168Q770 1168 810 1150.50Q850 1133 880 1103Q910 1073 927.50 1033Q945 993 945 947L945 947Q945 908 933 877Q921 846 899 814L899 814Q873 777 853.50 742Q834 707 821 670.50Q808 634 801.50 595Q795 556 795 509L795 509Q795 414 828.50 327Q862 240 921 171.50Q980 103 1061 57.50Q1142 12 1237 0L1237 0Q1252 214 1337 392.50Q1422 571 1571 723L1571 723Q1693 848 1757 994Q1821 1140 1821 1315Z"
         }
      }
   ]
}

var OneNoteLogoFill = {
   name: "OneNoteLogoFill",
   vendor: "UiFabric",
   unicode: 61928,
   value: "",
   charCode: "F1E8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var PowerPointLogo = {
   name: "PowerPointLogo",
   vendor: "UiFabric",
   unicode: 61931,
   value: "",
   charCode: "F1EB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 128L1152 128Q1276 128 1390.50 160Q1505 192 1604.50 250.50Q1704 309 1785.50 390.50Q1867 472 1925.50 571.50Q1984 671 2016 785.50Q2048 900 2048 1024L2048 1024Q2048 1148 2016 1262.50Q1984 1377 1925.50 1476.50Q1867 1576 1785.50 1657.50Q1704 1739 1604.50 1797.50Q1505 1856 1390.50 1888Q1276 1920 1152 1920L1152 1920Q1042 1920 937 1894Q832 1868 737.50 1818.50Q643 1769 561.50 1697.50Q480 1626 417 1536L417 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L417 512Q480 422 561.50 350.50Q643 279 737.50 229.50Q832 180 937 154Q1042 128 1152 128ZM1216 259L1216 259L1216 960L1917 960Q1905 820 1846.50 697.50Q1788 575 1694.50 481.50Q1601 388 1478 329.50Q1355 271 1216 259ZM767 905L767 905Q767 847 747.50 805.50Q728 764 694 738Q660 712 614 700Q568 688 514 688L514 688L243 688L243 1359L400 1359L400 1125L506 1125Q555 1125 601.50 1110.50Q648 1096 685 1068.50Q722 1041 744.50 1000Q767 959 767 905ZM1152 1792L1152 1792Q1252 1792 1345 1767.50Q1438 1743 1520.50 1697.50Q1603 1652 1672 1588.50Q1741 1525 1793 1446.50Q1845 1368 1877 1277Q1909 1186 1917 1087L1917 1087L1089 1087L1089 259Q941 271 810 336.50Q679 402 580 512L580 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L580 1536Q635 1597 700.50 1644.50Q766 1692 839 1725Q912 1758 991 1775Q1070 1792 1152 1792ZM400 819L496 819Q545 819 574 838.50Q603 858 603 910L603 910Q603 933 592.50 947.50Q582 962 566 971Q550 980 530 983.50Q510 987 492 987L492 987L400 987L400 819Z"
         }
      }
   ]
}

var PowerPointLogoFill = {
   name: "PowerPointLogoFill",
   vendor: "UiFabric",
   unicode: 61932,
   value: "",
   charCode: "F1EC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var OutlookLogo = {
   name: "OutlookLogo",
   vendor: "UiFabric",
   unicode: 61929,
   value: "",
   charCode: "F1E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M672 1027L672 1027Q672 1066 663 1101.50Q654 1137 635 1165Q616 1193 585 1209.50Q554 1226 511 1226L511 1226Q469 1226 439 1208.50Q409 1191 390 1162.50Q371 1134 362 1098Q353 1062 353 1025L353 1025Q353 987 362 950.50Q371 914 390.50 885.50Q410 857 441 839.50Q472 822 515 822L515 822Q559 822 589 840Q619 858 637.50 887Q656 916 664 952.50Q672 989 672 1027ZM2048 1024L2048 1024L2048 1824Q2048 1864 2020 1892Q1992 1920 1952 1920L1952 1920L608 1920Q568 1920 540 1892Q512 1864 512 1824L512 1824L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L640 512L640 218Q640 180 666 154Q692 128 730 128L730 128L1830 128Q1868 128 1894 154Q1920 180 1920 218L1920 218L1920 256L1920 926L2026 987L2027 987Q2036 993 2042 1003Q2048 1013 2048 1024ZM1792 320L1536 320L1536 576L1792 576L1792 320ZM1792 704L1536 704L1536 960L1792 960L1792 704ZM1796 1088L1536 1088L1536 1244L1796 1088ZM1408 320L1088 320L1088 576L1408 576L1408 320ZM1408 704L1088 704L1088 960L1408 960L1408 704ZM1408 1088L1088 1088L1088 1261L1294 1389L1408 1321L1408 1088ZM960 320L768 320L768 512L939 512Q944 512 949.50 513Q955 514 960 516L960 516L960 320ZM510 1364L510 1364Q587 1364 647 1337.50Q707 1311 748 1264.50Q789 1218 810.50 1155Q832 1092 832 1018L832 1018Q832 947 811 886Q790 825 750 780Q710 735 652 709.50Q594 684 520 684L520 684Q441 684 380 709.50Q319 735 277 781.50Q235 828 213.50 892Q192 956 192 1032L192 1032Q192 1104 214 1165Q236 1226 277 1270Q318 1314 377 1339Q436 1364 510 1364ZM640 1536L640 1792L1697 1792L1024 1372L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L640 1536ZM1416 1465L1920 1781L1920 1163L1416 1465Z"
         }
      }
   ]
}

var OutlookLogoFill = {
   name: "OutlookLogoFill",
   vendor: "UiFabric",
   unicode: 61930,
   value: "",
   charCode: "F1EA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var WordLogo = {
   name: "WordLogo",
   vendor: "UiFabric",
   unicode: 61923,
   value: "",
   charCode: "F1E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM386 1360L515 956L638 1360L778 1360L912 688L771 688L691 1085L578 701L459 701L339 1087L259 688L112 688L246 1360L386 1360ZM640 1792L1920 1792L1920 1536L640 1536L640 1792ZM1024 1408L1920 1408L1920 1088L1024 1088L1024 1408ZM1024 960L1920 960L1920 640L1024 640L1024 960ZM640 512L1920 512L1920 256L640 256L640 512Z"
         }
      }
   ]
}

var WordLogoFill = {
   name: "WordLogoFill",
   vendor: "UiFabric",
   unicode: 61924,
   value: "",
   charCode: "F1E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var PublisherLogo = {
   name: "PublisherLogo",
   vendor: "UiFabric",
   unicode: 61933,
   value: "",
   charCode: "F1ED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M400 819L496 819Q545 819 574 838.50Q603 858 603 910L603 910Q603 933 592.50 947.50Q582 962 566 971Q550 980 530 983.50Q510 987 492 987L492 987L400 987L400 819ZM2048 337L2048 337L2048 1711Q2048 1744 2024 1768Q2000 1792 1967 1792L1967 1792L1792 1792L1792 1833Q1792 1869 1766.50 1894.50Q1741 1920 1705 1920L1705 1920L599 1920Q563 1920 537.50 1894.50Q512 1869 512 1833L512 1833L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 215Q512 179 537.50 153.50Q563 128 599 128L599 128L1705 128Q1741 128 1766.50 153.50Q1792 179 1792 215L1792 215L1792 256L1967 256Q2000 256 2024 280Q2048 304 2048 337ZM767 905L767 905Q767 847 747.50 805.50Q728 764 694 738Q660 712 614 700Q568 688 514 688L514 688L243 688L243 1359L400 1359L400 1125L506 1125Q555 1125 601.50 1110.50Q648 1096 685 1068.50Q722 1041 744.50 1000Q767 959 767 905ZM640 1792L1664 1792L1664 1536L640 1536L640 1792ZM1024 1408L1664 1408L1664 1088L1024 1088L1024 1408ZM1024 960L1664 960L1664 256L640 256L640 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 960ZM1792 1664L1920 1664L1920 384L1792 384L1792 1664Z"
         }
      }
   ]
}

var PublisherLogoFill = {
   name: "PublisherLogoFill",
   vendor: "UiFabric",
   unicode: 61934,
   value: "",
   charCode: "F1EE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var ScheduleEventAction = {
   name: "ScheduleEventAction",
   vendor: "UiFabric",
   unicode: 61935,
   value: "",
   charCode: "F1EF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L2048 128L2048 640L128 640L128 1792L1024 1792L1024 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512ZM1499 768L2017 768L1779 1152L2048 1152L1376 2048L1112 2048L1368 1536L1112 1536L1499 768ZM1335 1890L1792 1280L1549 1280L1787 896L1578 896L1320 1408L1576 1408L1335 1890Z"
         }
      }
   ]
}

var SaveAll = {
   name: "SaveAll",
   vendor: "UiFabric",
   unicode: 61955,
   value: "",
   charCode: "F203",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 768L1920 768Q1947 768 1970 778Q1993 788 2010.50 805.50Q2028 823 2038 846Q2048 869 2048 896L2048 896L2048 2048L933 2048L768 1883L768 896Q768 869 778 846Q788 823 805.50 805.50Q823 788 846 778Q869 768 896 768L896 768ZM1664 896L1152 896L1152 1280L1664 1280L1664 896ZM1408 1920L1664 1920L1664 1664L1152 1664L1152 1920L1280 1920L1280 1792L1408 1792L1408 1920ZM1920 1920L1920 896L1792 896L1792 1408L1024 1408L1024 896L896 896L896 1829L987 1920L1024 1920L1024 1536L1792 1536L1792 1920L1920 1920ZM1024 640L256 640L256 128L128 128L128 1061L219 1152L256 1152L256 768L640 768L640 896L384 896L384 1152L512 1152L512 1024L640 1024L640 1280L165 1280L0 1115L0 128Q0 101 10 78Q20 55 37.50 37.50Q55 20 78 10Q101 0 128 0L128 0L1152 0Q1179 0 1202 10Q1225 20 1242.50 37.50Q1260 55 1270 78Q1280 101 1280 128L1280 128L1280 640L1152 640L1152 128L1024 128L1024 640ZM384 128L384 512L896 512L896 128L384 128Z"
         }
      }
   ]
}

var ServerProcesses = {
   name: "ServerProcesses",
   vendor: "UiFabric",
   unicode: 61950,
   value: "",
   charCode: "F1FE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1989 1369L2038 1488L1914 1539Q1926 1601 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1848 1804 1826.50 1826Q1805 1848 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1274 1600 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1601 1274 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1804 1352 1826 1373.50Q1848 1395 1865 1421L1865 1421L1989 1369ZM1673 1777L1673 1777Q1710 1762 1736.50 1734.50Q1763 1707 1777 1673Q1791 1639 1791.50 1601Q1792 1563 1777 1527L1777 1527Q1763 1491 1736 1464Q1709 1437 1673 1423L1673 1423Q1638 1408 1600 1408L1600 1408Q1561 1408 1527 1423L1527 1423Q1491 1437 1464 1464Q1437 1491 1423 1527L1423 1527Q1392 1600 1423 1673L1423 1673Q1437 1709 1464 1736Q1491 1763 1527 1777L1527 1777Q1600 1808 1673 1777ZM0 128L2048 128L2048 1024L1920 1024L1920 640L128 640L128 1664L1024 1664L1024 1792L0 1792L0 128ZM128 512L1920 512L1920 256L128 256L128 512ZM1024 1408L896 1408L896 1268Q865 1257 836 1234L836 1234L715 1303L651 1193L771 1123Q768 1107 768 1088L768 1088Q768 1070 771 1053L771 1053L651 983L715 873L836 942Q865 919 896 908L896 908L896 768L1024 768L1024 908Q1041 914 1055.50 922.50Q1070 931 1084 942L1084 942L1205 873L1269 983L1149 1053Q1152 1070 1152 1088L1152 1088Q1152 1107 1149 1123L1149 1123L1269 1193L1205 1303L1084 1234Q1070 1245 1055.50 1253.50Q1041 1262 1024 1268L1024 1268L1024 1408ZM864 1088L864 1088Q864 1128 892 1156Q920 1184 960 1184L960 1184Q1000 1184 1028 1156Q1056 1128 1056 1088L1056 1088Q1056 1048 1028 1020Q1000 992 960 992L960 992Q920 992 892 1020Q864 1048 864 1088Z"
         }
      }
   ]
}

var Server = {
   name: "Server",
   vendor: "UiFabric",
   unicode: 61953,
   value: "",
   charCode: "F201",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1280 384L640 384L640 256L1280 256ZM1280 1280L1280 1408L640 1408L640 1280L1280 1280ZM1280 1536L1280 1664L640 1664L640 1536L1280 1536ZM512 0L1408 0Q1435 0 1458 10Q1481 20 1498.50 37.50Q1516 55 1526 78Q1536 101 1536 128L1536 128L1536 1920L384 1920L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0ZM1408 1792L1408 128L512 128L512 1792L1408 1792Z"
         }
      }
   ]
}

var RegistryEditor = {
   name: "RegistryEditor",
   vendor: "UiFabric",
   unicode: 61951,
   value: "",
   charCode: "F1FF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 512L1152 896L1536 896L1664 896L1664 1024L1664 1408L1664 1536L1664 1920L1664 2048L1536 2048L1152 2048L1024 2048L640 2048L512 2048L128 2048L0 2048L0 1920L0 1536L0 1408L0 1024L0 896L0 512L0 384L128 384L512 384L640 384L1024 384L1152 384L1152 512ZM1024 512L640 512L640 896L1024 896L1024 512ZM640 1408L1024 1408L1024 1024L640 1024L640 1408ZM512 512L128 512L128 896L512 896L512 512ZM512 1024L128 1024L128 1408L512 1408L512 1024ZM128 1920L512 1920L512 1536L128 1536L128 1920ZM640 1920L1024 1920L1024 1536L640 1536L640 1920ZM1152 1920L1536 1920L1536 1536L1152 1536L1152 1920ZM1152 1024L1152 1408L1536 1408L1536 1024L1152 1024ZM1600 64L1984 448L1600 832L1216 448L1600 64ZM1839 448L1600 209L1361 448L1600 687L1839 448Z"
         }
      }
   ]
}

var PowerShell = {
   name: "PowerShell",
   vendor: "UiFabric",
   unicode: 61949,
   value: "",
   charCode: "F1FD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L0 128L2048 128L2048 1792L0 1792L0 128ZM1920 256L1920 256L128 256L128 384L1920 384L1920 256ZM128 1664L128 1664L1920 1664L1920 512L128 512L128 1664ZM896 1536L896 1536L896 1408L1536 1408L1536 1536L896 1536ZM549 716L549 716L1070 1088L549 1460L475 1356L850 1088L475 820L549 716Z"
         }
      }
   ]
}

var LinkedInLogo = {
   name: "LinkedInLogo",
   vendor: "UiFabric",
   unicode: 61962,
   value: "",
   charCode: "F20A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M151 0L1896 0Q1927 0 1954.50 11.50Q1982 23 2003 43Q2024 63 2036 90Q2048 117 2048 148L2048 148L2048 1900Q2048 1931 2036 1958Q2024 1985 2003 2005Q1982 2025 1954.50 2036.50Q1927 2048 1896 2048L1896 2048L151 2048Q120 2048 92.50 2036.50Q65 2025 44.50 2005Q24 1985 12 1958Q0 1931 0 1900L0 1900L0 148Q0 117 12 90Q24 63 44.50 43Q65 23 92.50 11.50Q120 0 151 0L151 0ZM303 1728L607 1728L607 768L303 768L303 1728ZM455 634L455 634Q491 634 523.50 620.50Q556 607 580 583Q604 559 618 527Q632 495 632 458L632 458Q632 421 618 389Q604 357 580 333Q556 309 523.50 295.50Q491 282 455 282L455 282Q419 282 387 296Q355 310 331 334Q307 358 293 390Q279 422 279 458L279 458Q279 494 293 526Q307 558 331 582Q355 606 387 620Q419 634 455 634ZM1441 1728L1745 1728L1745 1209Q1745 1110 1731 1025Q1717 940 1677.50 877.50Q1638 815 1567 779.50Q1496 744 1381 744L1381 744Q1338 744 1295.50 754Q1253 764 1215 784Q1177 804 1145.50 833Q1114 862 1093 901L1093 901L1089 901L1089 768L798 768L798 1728L1101 1728L1101 1262Q1101 1214 1107.50 1168.50Q1114 1123 1133.50 1088Q1153 1053 1188.50 1032Q1224 1011 1283 1011L1283 1011Q1341 1011 1373 1035Q1405 1059 1420 1096.50Q1435 1134 1438 1180Q1441 1226 1441 1270L1441 1270L1441 1728Z"
         }
      }
   ]
}

var FilterDescending = {
   name: "FilterDescending",
   vendor: "UiFabric",
   unicode: 61979,
   value: "",
   charCode: "F21B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1794 1024L1795 1667L1958 1504L2048 1594L1733 1911L1408 1586L1498 1496L1667 1666L1667 1024L1794 1024ZM896 1792L1152 1792L1152 1061L1920 293L1920 256L128 256L128 293L896 1061L896 1792ZM2048 128L2048 347L1280 1115L1280 1920L768 1920L768 1115L0 347L0 128L2048 128Z"
         }
      }
   ]
}

var SidePanelMirrored = {
   name: "SidePanelMirrored",
   vendor: "UiFabric",
   unicode: 61985,
   value: "",
   charCode: "F221",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1664L0 1664L0 256ZM1920 1536L1920 640L1536 640L1536 1536L1920 1536ZM128 640L128 1536L1408 1536L1408 640L128 640ZM128 512L1920 512L1920 384L128 384L128 512Z"
         }
      }
   ]
}

var FilterAscending = {
   name: "FilterAscending",
   vendor: "UiFabric",
   unicode: 61978,
   value: "",
   charCode: "F21A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1501 1437L1411 1347L1728 1030L2045 1347L1955 1437L1792 1274L1792 1920L1664 1920L1664 1274L1501 1437ZM0 347L0 128L2048 128L2048 347L1280 1115L1280 1920L768 1920L768 1115L0 347ZM1152 1061L1920 293L1920 256L128 256L128 293L896 1061L896 1792L1152 1792L1152 1061Z"
         }
      }
   ]
}

var Decimals = {
   name: "Decimals",
   vendor: "UiFabric",
   unicode: 61976,
   value: "",
   charCode: "F218",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M465 265L465 265Q555 265 620 297Q685 329 730 382.50Q775 436 802.50 506.50Q830 577 845 653.50Q860 730 865 807.50Q870 885 870 954L870 954Q870 1025 863 1104.50Q856 1184 838 1261.50Q820 1339 789.50 1410.50Q759 1482 710.50 1536Q662 1590 594.50 1622.50Q527 1655 436 1655L436 1655Q350 1655 286 1624Q222 1593 176.50 1541.50Q131 1490 101.50 1422Q72 1354 55.50 1279.50Q39 1205 32.50 1130Q26 1055 26 988L26 988Q26 915 32 833Q38 751 55 670.50Q72 590 102.50 516.50Q133 443 182 387Q231 331 300.50 298Q370 265 465 265ZM449 1550L449 1550Q516 1550 564.50 1520.50Q613 1491 646 1442.50Q679 1394 699 1332Q719 1270 729.50 1205Q740 1140 743 1078.50Q746 1017 746 968L746 968Q746 920 743.50 857.50Q741 795 731.50 728.50Q722 662 703.50 597.50Q685 533 653 482.50Q621 432 573 401Q525 370 457 370L457 370Q386 370 336 401Q286 432 252 482.50Q218 533 197.50 598Q177 663 166.50 730.50Q156 798 153 862.50Q150 927 150 978L150 978Q150 1028 153 1089.50Q156 1151 166.50 1214.50Q177 1278 196.50 1338.50Q216 1399 249.50 1446Q283 1493 331.50 1521.50Q380 1550 449 1550ZM1023 1434L1023 1434Q1067 1434 1096.50 1463.50Q1126 1493 1126 1537L1126 1537Q1126 1558 1118 1576.50Q1110 1595 1095.50 1608.50Q1081 1622 1062.50 1630Q1044 1638 1023 1638L1023 1638Q979 1638 950.50 1609.50Q922 1581 922 1537L922 1537Q922 1493 950 1463.50Q978 1434 1023 1434ZM1617 265L1617 265Q1707 265 1772 297Q1837 329 1882 382.50Q1927 436 1954.50 506.50Q1982 577 1997 653.50Q2012 730 2017 807.50Q2022 885 2022 954L2022 954Q2022 1025 2015 1104.50Q2008 1184 1990 1261.50Q1972 1339 1941.50 1410.50Q1911 1482 1862.50 1536Q1814 1590 1746.50 1622.50Q1679 1655 1588 1655L1588 1655Q1502 1655 1438 1624Q1374 1593 1328.50 1541.50Q1283 1490 1253.50 1422Q1224 1354 1207.50 1279.50Q1191 1205 1184.50 1130Q1178 1055 1178 988L1178 988Q1178 915 1184 833Q1190 751 1207 670.50Q1224 590 1254.50 516.50Q1285 443 1334 387Q1383 331 1452.50 298Q1522 265 1617 265ZM1601 1550L1601 1550Q1668 1550 1716.50 1520.50Q1765 1491 1798 1442.50Q1831 1394 1851 1332Q1871 1270 1881.50 1205Q1892 1140 1895 1078.50Q1898 1017 1898 968L1898 968Q1898 920 1895.50 857.50Q1893 795 1883.50 728.50Q1874 662 1855.50 597.50Q1837 533 1805 482.50Q1773 432 1725 401Q1677 370 1609 370L1609 370Q1538 370 1488 401Q1438 432 1404 482.50Q1370 533 1349.50 598Q1329 663 1318.50 730.50Q1308 798 1305 862.50Q1302 927 1302 978L1302 978Q1302 1028 1305 1089.50Q1308 1151 1318.50 1214.50Q1329 1278 1348.50 1338.50Q1368 1399 1401.50 1446Q1435 1493 1483.50 1521.50Q1532 1550 1601 1550Z"
         }
      }
   ]
}

var ProtectRestrict = {
   name: "ProtectRestrict",
   vendor: "UiFabric",
   unicode: 61994,
   value: "",
   charCode: "F22A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1600 1920L1600 1920Q1666 1920 1724 1895Q1782 1870 1825.50 1826.50Q1869 1783 1894.50 1724.50Q1920 1666 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1534 1280 1475.50 1305.50Q1417 1331 1373.50 1374.50Q1330 1418 1305 1476Q1280 1534 1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920ZM1408 1664L1408 1536L1792 1536L1792 1664L1408 1664ZM384 1920L1056 1920Q1081 1956 1110 1988.50Q1139 2021 1173 2048L1173 2048L256 2048L256 896L512 896L512 522Q512 414 551 319Q590 224 659 153Q728 82 821.50 41Q915 0 1024 0L1024 0Q1133 0 1226.50 41Q1320 82 1389 153Q1458 224 1497 319Q1536 414 1536 522L1536 522L1536 896L1792 896L1792 1024L384 1024L384 1920ZM640 522L640 896L1408 896L1408 522Q1408 441 1379 369.50Q1350 298 1298.50 244Q1247 190 1176.50 159Q1106 128 1024 128L1024 128Q942 128 871.50 159Q801 190 749.50 244Q698 298 669 369.50Q640 441 640 522L640 522Z"
         }
      }
   ]
}

var IOT = {
   name: "IOT",
   vendor: "UiFabric",
   unicode: 61996,
   value: "",
   charCode: "F22C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 896L1792 896Q1845 896 1891.50 916Q1938 936 1973 971Q2008 1006 2028 1052.50Q2048 1099 2048 1152L2048 1152Q2048 1205 2028 1251.50Q2008 1298 1973 1333Q1938 1368 1891.50 1388Q1845 1408 1792 1408L1792 1408Q1742 1408 1698 1390Q1654 1372 1619.50 1340.50Q1585 1309 1563 1266.50Q1541 1224 1537 1174L1537 1174L1387 1149Q1363 1218 1315.50 1273.50Q1268 1329 1204 1363L1204 1363L1262 1537Q1267 1536 1271 1536Q1275 1536 1280 1536L1280 1536Q1333 1536 1379.50 1556Q1426 1576 1461 1611Q1496 1646 1516 1692.50Q1536 1739 1536 1792L1536 1792Q1536 1845 1516 1891.50Q1496 1938 1461 1973Q1426 2008 1379.50 2028Q1333 2048 1280 2048L1280 2048Q1227 2048 1180.50 2028Q1134 2008 1099 1973Q1064 1938 1044 1891.50Q1024 1845 1024 1792L1024 1792Q1024 1726 1055.50 1669Q1087 1612 1141 1577L1141 1577L1083 1403Q1069 1405 1054 1406.50Q1039 1408 1024 1408L1024 1408Q932 1408 850.50 1366.50Q769 1325 714 1251L714 1251L506 1354Q512 1381 512 1408L512 1408Q512 1461 492 1507.50Q472 1554 437 1589Q402 1624 355.50 1644Q309 1664 256 1664L256 1664Q203 1664 156.50 1644Q110 1624 75 1589Q40 1554 20 1507.50Q0 1461 0 1408L0 1408Q0 1355 20 1308.50Q40 1262 75 1227Q110 1192 156.50 1172Q203 1152 256 1152L256 1152Q312 1152 362 1175Q412 1198 449 1240L449 1240L657 1136Q640 1080 640 1024L640 1024Q640 953 665 887Q690 821 738 768L738 768L617 617Q566 640 512 640L512 640Q459 640 412.50 620Q366 600 331 565Q296 530 276 483.50Q256 437 256 384L256 384Q256 331 276 284.50Q296 238 331 203Q366 168 412.50 148Q459 128 512 128L512 128Q565 128 611.50 148Q658 168 693 203Q728 238 748 284.50Q768 331 768 384L768 384Q768 469 717 537L717 537L837 688Q880 665 927.50 652.50Q975 640 1024 640L1024 640Q1107 640 1181 673L1181 673L1345 427Q1314 392 1297 348Q1280 304 1280 256L1280 256Q1280 203 1300 156.50Q1320 110 1355 75Q1390 40 1436.50 20Q1483 0 1536 0L1536 0Q1589 0 1635.50 20Q1682 40 1717 75Q1752 110 1772 156.50Q1792 203 1792 256L1792 256Q1792 309 1772 355.50Q1752 402 1717 437Q1682 472 1635.50 492Q1589 512 1536 512L1536 512Q1494 512 1452 498L1452 498L1287 745Q1345 799 1376.50 871.50Q1408 944 1408 1023L1408 1023L1558 1048Q1573 1014 1597.50 985.50Q1622 957 1652.50 937.50Q1683 918 1718.50 907Q1754 896 1792 896ZM1536 128L1536 128Q1509 128 1486 138Q1463 148 1445.50 165.50Q1428 183 1418 206Q1408 229 1408 256L1408 256Q1408 283 1418 306Q1428 329 1445.50 346.50Q1463 364 1486 374Q1509 384 1536 384L1536 384Q1563 384 1586 374Q1609 364 1626.50 346.50Q1644 329 1654 306Q1664 283 1664 256L1664 256Q1664 229 1654 206Q1644 183 1626.50 165.50Q1609 148 1586 138Q1563 128 1536 128ZM256 1536L256 1536Q283 1536 306 1526Q329 1516 346.50 1498.50Q364 1481 374 1458Q384 1435 384 1408L384 1408Q384 1381 374 1358Q364 1335 346.50 1317.50Q329 1300 306 1290Q283 1280 256 1280L256 1280Q229 1280 206 1290Q183 1300 165.50 1317.50Q148 1335 138 1358Q128 1381 128 1408L128 1408Q128 1435 138 1458Q148 1481 165.50 1498.50Q183 1516 206 1526Q229 1536 256 1536ZM1408 1792L1408 1792Q1408 1765 1398 1742Q1388 1719 1370.50 1701.50Q1353 1684 1330 1674Q1307 1664 1280 1664L1280 1664Q1253 1664 1230 1674Q1207 1684 1189.50 1701.50Q1172 1719 1162 1742Q1152 1765 1152 1792L1152 1792Q1152 1819 1162 1842Q1172 1865 1189.50 1882.50Q1207 1900 1230 1910Q1253 1920 1280 1920L1280 1920Q1307 1920 1330 1910Q1353 1900 1370.50 1882.50Q1388 1865 1398 1842Q1408 1819 1408 1792ZM384 384L384 384Q384 411 394 434Q404 457 421.50 474.50Q439 492 462 502Q485 512 512 512L512 512Q539 512 562 502Q585 492 602.50 474.50Q620 457 630 434Q640 411 640 384L640 384Q640 357 630 334Q620 311 602.50 293.50Q585 276 562 266Q539 256 512 256L512 256Q485 256 462 266Q439 276 421.50 293.50Q404 311 394 334Q384 357 384 384ZM1024 1280L1024 1280Q1077 1280 1123.50 1260Q1170 1240 1205 1205Q1240 1170 1260 1123.50Q1280 1077 1280 1024L1280 1024Q1280 971 1260 924.50Q1240 878 1205 843Q1170 808 1123.50 788Q1077 768 1024 768L1024 768Q971 768 924.50 788Q878 808 843 843Q808 878 788 924.50Q768 971 768 1024L768 1024Q768 1077 788 1123.50Q808 1170 843 1205Q878 1240 924.50 1260Q971 1280 1024 1280ZM1792 1280L1792 1280Q1819 1280 1842 1270Q1865 1260 1882.50 1242.50Q1900 1225 1910 1202Q1920 1179 1920 1152L1920 1152Q1920 1125 1910 1102Q1900 1079 1882.50 1061.50Q1865 1044 1842 1034Q1819 1024 1792 1024L1792 1024Q1765 1024 1742 1034Q1719 1044 1701.50 1061.50Q1684 1079 1674 1102Q1664 1125 1664 1152L1664 1152Q1664 1179 1674 1202Q1684 1225 1701.50 1242.50Q1719 1260 1742 1270Q1765 1280 1792 1280Z"
         }
      }
   ]
}

var UnknownMirrored = {
   name: "UnknownMirrored",
   vendor: "UiFabric",
   unicode: 61998,
   value: "",
   charCode: "F22E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 4L960 4Q1092 4 1214 38Q1336 72 1442.50 134.50Q1549 197 1636 284Q1723 371 1785.50 477.50Q1848 584 1882 706Q1916 828 1916 960L1916 960Q1916 1092 1882 1214Q1848 1336 1785.50 1442.50Q1723 1549 1636 1636Q1549 1723 1442.50 1785.50Q1336 1848 1214 1882Q1092 1916 960 1916L960 1916Q828 1916 706 1882Q584 1848 477.50 1785.50Q371 1723 284 1636Q197 1549 134.50 1442.50Q72 1336 38 1214Q4 1092 4 960L4 960Q4 828 38 706Q72 584 134.50 477.50Q197 371 284 284Q371 197 477.50 134.50Q584 72 706 38Q828 4 960 4ZM960 1796L960 1796Q1075 1796 1182 1766Q1289 1736 1382 1681.50Q1475 1627 1551 1551Q1627 1475 1681.50 1382Q1736 1289 1766 1182Q1796 1075 1796 960L1796 960Q1796 845 1766 738Q1736 631 1681.50 538Q1627 445 1551 369Q1475 293 1382 238.50Q1289 184 1182 154Q1075 124 960 124L960 124Q845 124 738 154Q631 184 538 238.50Q445 293 369 369Q293 445 238.50 538Q184 631 154 738Q124 845 124 960L124 960Q124 1075 154 1182Q184 1289 238.50 1382Q293 1475 369 1551Q445 1627 538 1681.50Q631 1736 738 1766Q845 1796 960 1796ZM896 1536L896 1408L1024 1408L1024 1536L896 1536ZM960 448L960 448Q1026 448 1084 473.50Q1142 499 1185.50 542.50Q1229 586 1254.50 644Q1280 702 1280 768L1280 768L1152 768Q1152 728 1137 693Q1122 658 1096 632Q1070 606 1035 591Q1000 576 960 576L960 576Q920 576 885 591Q850 606 824 632Q798 658 783 693Q768 728 768 768L768 768Q768 810 787 843.50Q806 877 834.50 906.50Q863 936 896 965.50Q929 995 957.50 1031Q986 1067 1005 1111.50Q1024 1156 1024 1216L1024 1216L1024 1280L896 1280L896 1216Q896 1174 877 1140.50Q858 1107 829.50 1077.50Q801 1048 768 1018.50Q735 989 706.50 953Q678 917 659 872.50Q640 828 640 768L640 768Q640 702 665 644Q690 586 733.50 542.50Q777 499 835.50 473.50Q894 448 960 448Z"
         }
      }
   ]
}

var PublicContactCardMirrored = {
   name: "PublicContactCardMirrored",
   vendor: "UiFabric",
   unicode: 62000,
   value: "",
   charCode: "F230",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 768L256 896L896 896L896 768L256 768ZM896 1280L896 1152L512 1152L512 1280L896 1280ZM1222 1072L1222 1072Q1176 1098 1139.50 1134Q1103 1170 1077.50 1213.50Q1052 1257 1038 1306.50Q1024 1356 1024 1408L1024 1408L1152 1408Q1152 1355 1172 1308.50Q1192 1262 1227 1227Q1262 1192 1308.50 1172Q1355 1152 1408 1152L1408 1152Q1461 1152 1507.50 1172Q1554 1192 1589 1227Q1624 1262 1644 1308.50Q1664 1355 1664 1408L1664 1408L1792 1408Q1792 1356 1778 1306.50Q1764 1257 1738.50 1213.50Q1713 1170 1676.50 1134Q1640 1098 1594 1072L1594 1072Q1627 1037 1645.50 991Q1664 945 1664 896L1664 896Q1664 843 1644 796.50Q1624 750 1589 715Q1554 680 1507.50 660Q1461 640 1408 640L1408 640Q1355 640 1308.50 660Q1262 680 1227 715Q1192 750 1172 796.50Q1152 843 1152 896L1152 896Q1152 945 1170.50 991Q1189 1037 1222 1072ZM1536 896L1536 896Q1536 923 1526 946Q1516 969 1498.50 986.50Q1481 1004 1458 1014Q1435 1024 1408 1024L1408 1024Q1381 1024 1358 1014Q1335 1004 1317.50 986.50Q1300 969 1290 946Q1280 923 1280 896L1280 896Q1280 869 1290 846Q1300 823 1317.50 805.50Q1335 788 1358 778Q1381 768 1408 768L1408 768Q1435 768 1458 778Q1481 788 1498.50 805.50Q1516 823 1526 846Q1536 869 1536 896ZM410 1501L319 1411L2 1728L319 2045L410 1955L247 1792L905 1792L742 1955L833 2045L1150 1728L833 1411L742 1501L905 1664L247 1664L410 1501ZM2048 256L0 256L0 1472L128 1344L128 384L1920 384L1920 1664L1280 1664L1280 1792L2048 1792L2048 256Z"
         }
      }
   ]
}

var GridViewSmall = {
   name: "GridViewSmall",
   vendor: "UiFabric",
   unicode: 62002,
   value: "",
   charCode: "F232",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1792 128L1792 1792L128 1792L128 128ZM1664 640L1664 256L1280 256L1280 640L1664 640ZM768 1152L1152 1152L1152 768L768 768L768 1152ZM1152 1280L768 1280L768 1664L1152 1664L1152 1280ZM640 1152L640 768L256 768L256 1152L640 1152ZM768 640L1152 640L1152 256L768 256L768 640ZM1280 768L1280 1152L1664 1152L1664 768L1280 768ZM640 256L256 256L256 640L640 640L640 256ZM256 1280L256 1664L640 1664L640 1280L256 1280ZM1280 1664L1664 1664L1664 1280L1280 1280L1280 1664Z"
         }
      }
   ]
}

var GridViewLarge = {
   name: "GridViewLarge",
   vendor: "UiFabric",
   unicode: 62004,
   value: "",
   charCode: "F234",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1792 128L1792 1792L128 1792L128 128ZM1664 1664L1664 256L256 256L256 1664L1664 1664Z"
         }
      }
   ]
}

var StepInsert = {
   name: "StepInsert",
   vendor: "UiFabric",
   unicode: 62018,
   value: "",
   charCode: "F242",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 256L1920 256L1920 1664L128 1664L128 1024L640 1024L640 640L1152 640L1152 256ZM1792 1536L1792 384L1280 384L1280 768L768 768L768 1152L256 1152L256 1536L1792 1536ZM355 547L518 384L0 384L0 256L518 256L355 93L445 3L762 320L445 637L355 547Z"
         }
      }
   ]
}

var StepSharedAdd = {
   name: "StepSharedAdd",
   vendor: "UiFabric",
   unicode: 62020,
   value: "",
   charCode: "F244",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 768L2048 768L2048 1920L896 1920L896 1664L128 1664L128 1024L640 1024L640 640L1152 640L1152 256L1920 256L1920 768ZM256 1536L896 1536L896 1280L1408 1280L1408 768L1792 768L1792 384L1280 384L1280 768L768 768L768 1152L256 1152L256 1536ZM1920 1792L1920 896L1536 896L1536 1408L1024 1408L1024 1792L1920 1792ZM256 640L256 384L0 384L0 256L256 256L256 0L384 0L384 256L640 256L640 384L384 384L384 640L256 640Z"
         }
      }
   ]
}

var ViewDashboard = {
   name: "ViewDashboard",
   vendor: "UiFabric",
   unicode: 62022,
   value: "",
   charCode: "F246",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM1920 640L1920 128L1280 128L1280 640L1920 640ZM1280 768L1280 1280L1920 1280L1920 768L1280 768ZM1152 128L128 128L128 1280L1152 1280L1152 128ZM128 1408L128 1920L768 1920L768 1408L128 1408ZM896 1920L1920 1920L1920 1408L896 1408L896 1920Z"
         }
      }
   ]
}

var ViewListGroup = {
   name: "ViewListGroup",
   vendor: "UiFabric",
   unicode: 62024,
   value: "",
   charCode: "F248",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L384 2048L384 768L0 768L0 0ZM128 640L640 640L640 128L128 128L128 640ZM512 768L512 1280L1024 1280L1024 768L512 768ZM1024 1920L1024 1408L512 1408L512 1920L1024 1920ZM1920 1920L1920 1408L1152 1408L1152 1920L1920 1920ZM1920 1280L1920 768L1152 768L1152 1280L1920 1280ZM768 640L1920 640L1920 128L768 128L768 640Z"
         }
      }
   ]
}

var TriggerAuto = {
   name: "TriggerAuto",
   vendor: "UiFabric",
   unicode: 62026,
   value: "",
   charCode: "F24A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M549 1920L1058 1411Q1043 1457 1033.50 1504.50Q1024 1552 1024 1600L1024 1600Q1024 1606 1024.50 1612.50Q1025 1619 1025 1625L1025 1625L603 2048L313 2048L697 1280L248 1280L888 0L1607 0L1223 768L1883 768L1625 1025L1615 1025Q1561 1025 1512 1033Q1463 1041 1411 1058L1411 1058L1573 896L1016 896L1400 128L967 128L455 1152L904 1152L520 1920L549 1920ZM2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369L2038 1488ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792Z"
         }
      }
   ]
}

var PivotChart = {
   name: "PivotChart",
   vendor: "UiFabric",
   unicode: 62028,
   value: "",
   charCode: "F24C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1920L1920 128L128 128L128 1920L1920 1920ZM640 256L640 640L256 640L256 256L640 256ZM512 512L512 384L384 384L384 512L512 512ZM640 768L640 1792L256 1792L256 768L640 768ZM512 1664L512 896L384 896L384 1664L512 1664ZM1792 256L1792 640L768 640L768 256L1792 256ZM1664 512L1664 384L896 384L896 512L1664 512ZM1069 1619L979 1709L742 1472L979 1235L1069 1325L987 1408L1280 1408Q1307 1408 1330 1398Q1353 1388 1370.50 1370.50Q1388 1353 1398 1330Q1408 1307 1408 1280L1408 1280L1408 987L1325 1069L1235 979L1472 742L1709 979L1619 1069L1536 987L1536 1280Q1536 1333 1516 1379.50Q1496 1426 1461 1461Q1426 1496 1379.50 1516Q1333 1536 1280 1536L1280 1536L987 1536L1069 1619Z"
         }
      }
   ]
}

var StackedLineChart = {
   name: "StackedLineChart",
   vendor: "UiFabric",
   unicode: 62030,
   value: "",
   charCode: "F24E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1107L702 848L297 1203L957 1533L1920 931L1920 1069L963 1667L256 1314L256 1793L1920 1793L1920 1921L128 1921L128 129L256 129L256 1082L708 686L960 941L1664 237L1920 493L1920 659L1664 403L960 1107Z"
         }
      }
   ]
}

var BuildQueueNew = {
   name: "BuildQueueNew",
   vendor: "UiFabric",
   unicode: 62032,
   value: "",
   charCode: "F250",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L2048 0L2048 1024L1536 1024L1536 1536L1024 1536L1024 2048L0 2048L0 1024L512 1024L512 512L1024 512L1024 0ZM896 1920L896 1152L128 1152L128 1920L896 1920ZM1408 1408L1408 640L640 640L640 1024L1024 1024L1024 1408L1408 1408ZM1920 896L1920 128L1152 128L1152 512L1536 512L1536 896L1920 896ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408Z"
         }
      }
   ]
}

var BuildQueue = {
   name: "BuildQueue",
   vendor: "UiFabric",
   unicode: 62031,
   value: "",
   charCode: "F24F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 0L2048 1024L1536 1024L1536 1536L1024 1536L1024 2048L0 2048L0 1024L512 1024L512 512L1024 512L1024 0L2048 0ZM896 1920L896 1152L128 1152L128 1920L896 1920ZM1408 1408L1408 640L640 640L640 1024L1024 1024L1024 1408L1408 1408ZM1920 896L1920 128L1152 128L1152 512L1536 512L1536 896L1920 896Z"
         }
      }
   ]
}

var StackedBarChart = {
   name: "StackedBarChart",
   vendor: "UiFabric",
   unicode: 62029,
   value: "",
   charCode: "F24D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1792L1919 1792L1919 1920L128 1920L128 128L256 128L256 384L1280 384L1280 896L256 896L256 1024L1792 1024L1792 1536L256 1536L256 1792ZM1152 512L768 512L768 768L1152 768L1152 512ZM640 512L256 512L256 768L640 768L640 512ZM1664 1152L1024 1152L1024 1408L1664 1408L1664 1152ZM896 1152L256 1152L256 1408L896 1408L896 1152Z"
         }
      }
   ]
}

var TriggerUser = {
   name: "TriggerUser",
   vendor: "UiFabric",
   unicode: 62027,
   value: "",
   charCode: "F24B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1223 768L1883 768L603 2048L313 2048L697 1280L248 1280L888 0L1607 0L1223 768ZM549 1920L1573 896L1016 896L1400 128L967 128L455 1152L904 1152L520 1920L549 1920ZM1848 1713L1848 1713Q1894 1738 1931 1774Q1968 1810 1994 1853.50Q2020 1897 2034 1946.50Q2048 1996 2048 2048L2048 2048L1920 2048Q1920 1995 1900 1948.50Q1880 1902 1845 1867Q1810 1832 1763.50 1812Q1717 1792 1664 1792L1664 1792Q1611 1792 1564.50 1812Q1518 1832 1483 1867Q1448 1902 1428 1948.50Q1408 1995 1408 2048L1408 2048L1280 2048Q1280 1996 1294 1946.50Q1308 1897 1334 1853.50Q1360 1810 1397 1774Q1434 1738 1480 1713L1480 1713Q1446 1678 1427 1632Q1408 1586 1408 1536L1408 1536Q1408 1483 1428 1436.50Q1448 1390 1483 1355Q1518 1320 1564.50 1300Q1611 1280 1664 1280L1664 1280Q1717 1280 1763.50 1300Q1810 1320 1845 1355Q1880 1390 1900 1436.50Q1920 1483 1920 1536L1920 1536Q1920 1586 1901 1632Q1882 1678 1848 1713ZM1664 1664L1664 1664Q1691 1664 1714 1654Q1737 1644 1754.50 1626.50Q1772 1609 1782 1586Q1792 1563 1792 1536L1792 1536Q1792 1509 1782 1486Q1772 1463 1754.50 1445.50Q1737 1428 1714 1418Q1691 1408 1664 1408L1664 1408Q1637 1408 1614 1418Q1591 1428 1573.50 1445.50Q1556 1463 1546 1486Q1536 1509 1536 1536L1536 1536Q1536 1563 1546 1586Q1556 1609 1573.50 1626.50Q1591 1644 1614 1654Q1637 1664 1664 1664Z"
         }
      }
   ]
}

var ViewListTree = {
   name: "ViewListTree",
   vendor: "UiFabric",
   unicode: 62025,
   value: "",
   charCode: "F249",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L768 2048L768 1408L384 1408L384 768L0 768L0 0ZM128 640L640 640L640 128L128 128L128 640ZM512 1280L1024 1280L1024 768L512 768L512 1280ZM1408 1920L1408 1408L896 1408L896 1920L1408 1920ZM1920 1920L1920 1408L1536 1408L1536 1920L1920 1920ZM1920 1280L1920 768L1152 768L1152 1280L1920 1280ZM768 640L1920 640L1920 128L768 128L768 640Z"
         }
      }
   ]
}

var ViewList = {
   name: "ViewList",
   vendor: "UiFabric",
   unicode: 62023,
   value: "",
   charCode: "F247",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM128 128L128 640L640 640L640 128L128 128ZM128 768L128 1280L640 1280L640 768L128 768ZM640 1920L640 1408L128 1408L128 1920L640 1920ZM1920 1920L1920 1408L768 1408L768 1920L1920 1920ZM1920 1280L1920 768L768 768L768 1280L1920 1280ZM768 640L1920 640L1920 128L768 128L768 640Z"
         }
      }
   ]
}

var StepSharedInsert = {
   name: "StepSharedInsert",
   vendor: "UiFabric",
   unicode: 62021,
   value: "",
   charCode: "F245",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 768L2048 768L2048 1920L896 1920L896 1664L128 1664L128 1024L640 1024L640 640L1152 640L1152 256L1920 256L1920 768ZM256 1536L896 1536L896 1280L1408 1280L1408 768L1792 768L1792 384L1280 384L1280 768L768 768L768 1152L256 1152L256 1536ZM1920 1792L1920 896L1536 896L1536 1408L1024 1408L1024 1792L1920 1792ZM355 547L518 384L0 384L0 256L518 256L355 93L445 3L762 320L445 637L355 547Z"
         }
      }
   ]
}

var StepShared = {
   name: "StepShared",
   vendor: "UiFabric",
   unicode: 62019,
   value: "",
   charCode: "F243",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 768L2048 768L2048 1920L896 1920L896 1664L128 1664L128 1024L640 1024L640 640L1152 640L1152 256L1920 256L1920 768ZM256 1536L896 1536L896 1280L1408 1280L1408 768L1792 768L1792 384L1280 384L1280 768L768 768L768 1152L256 1152L256 1536ZM1920 1792L1920 896L1536 896L1536 1408L1024 1408L1024 1792L1920 1792Z"
         }
      }
   ]
}

var Step = {
   name: "Step",
   vendor: "UiFabric",
   unicode: 62017,
   value: "",
   charCode: "F241",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 256L1920 256L1920 1664L128 1664L128 1024L640 1024L640 640L1152 640L1152 256ZM1792 1536L1792 384L1280 384L1280 768L768 768L768 1152L256 1152L256 1536L1792 1536Z"
         }
      }
   ]
}

var GridViewMedium = {
   name: "GridViewMedium",
   vendor: "UiFabric",
   unicode: 62003,
   value: "",
   charCode: "F233",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1792 128L1792 1792L128 1792L128 128ZM1664 896L1664 256L1024 256L1024 896L1664 896ZM896 256L256 256L256 896L896 896L896 256ZM256 1024L256 1664L896 1664L896 1024L256 1024ZM1024 1664L1664 1664L1664 1024L1024 1024L1024 1664Z"
         }
      }
   ]
}

var Blog = {
   name: "Blog",
   vendor: "UiFabric",
   unicode: 61995,
   value: "",
   charCode: "F22B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 1536L731 1536L256 2011L256 1536L0 1536L0 0ZM1920 128L128 128L128 384L1920 384L1920 128ZM677 1408L1920 1408L1920 512L128 512L128 1408L384 1408L384 1701L677 1408ZM1280 1280L1280 640L1792 640L1792 1280L1280 1280ZM1408 768L1408 1152L1664 1152L1664 768L1408 768ZM256 896L256 768L1152 768L1152 896L256 896ZM256 1152L256 1024L1152 1024L1152 1152L256 1152Z"
         }
      }
   ]
}

var UserFollowed = {
   name: "UserFollowed",
   vendor: "UiFabric",
   unicode: 62044,
   value: "",
   charCode: "F25C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 1626L1397 1550Q1376 1436 1318.50 1340Q1261 1244 1177.50 1173.50Q1094 1103 989 1063.50Q884 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1547 35.50 1435Q71 1323 136.50 1227.50Q202 1132 293.50 1058.50Q385 985 496 946L496 946Q440 910 395.50 863Q351 816 320 760Q289 704 272.50 641Q256 578 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140.50 863.50Q1096 911 1040 946L1040 946Q1139 984 1223 1046Q1307 1108 1370.50 1189Q1434 1270 1475 1366.50Q1516 1463 1529 1568L1529 1568L1472 1626ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363Z"
         }
      }
   ]
}

var ContactLink = {
   name: "ContactLink",
   vendor: "UiFabric",
   unicode: 62047,
   value: "",
   charCode: "F25F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 512L1792 640L1152 640L1152 512L1792 512ZM1152 896L1152 768L1664 768L1664 896L1152 896ZM1788 1414L1788 1414Q1844 1425 1892 1453.50Q1940 1482 1974.50 1524Q2009 1566 2028.50 1618.50Q2048 1671 2048 1728L2048 1728Q2048 1794 2022.50 1852.50Q1997 1911 1953.50 1954.50Q1910 1998 1852 2023Q1794 2048 1728 2048L1728 2048L1472 2048Q1406 2048 1347.50 2023Q1289 1998 1245.50 1954.50Q1202 1911 1177 1852.50Q1152 1794 1152 1728L1152 1728Q1152 1671 1171 1619Q1190 1567 1224 1525.50Q1258 1484 1305 1455Q1352 1426 1408 1414L1408 1414L1408 1547Q1379 1557 1355.50 1575Q1332 1593 1315 1617Q1298 1641 1289 1669.50Q1280 1698 1280 1728L1280 1728Q1280 1768 1295 1803Q1310 1838 1336 1864Q1362 1890 1397 1905Q1432 1920 1472 1920L1472 1920L1728 1920Q1768 1920 1803 1905Q1838 1890 1864 1864Q1890 1838 1905 1803Q1920 1768 1920 1728L1920 1728Q1920 1697 1910.50 1668Q1901 1639 1883 1615Q1865 1591 1840.50 1573Q1816 1555 1786 1545L1786 1545Q1792 1509 1792 1472L1792 1472Q1792 1458 1791 1443Q1790 1428 1788 1414ZM1344 1280L1088 1280Q1048 1280 1013 1295Q978 1310 952 1336Q926 1362 911 1397Q896 1432 896 1472L896 1472Q896 1504 905.50 1532.50Q915 1561 933 1585Q951 1609 975.50 1627Q1000 1645 1030 1655L1030 1655Q1024 1691 1024 1728L1024 1728Q1024 1742 1025 1757Q1026 1772 1028 1786L1028 1786Q972 1776 924 1747Q876 1718 841.50 1676Q807 1634 787.50 1581.50Q768 1529 768 1472L768 1472Q768 1406 793 1348Q818 1290 861.50 1246.50Q905 1203 963.50 1177.50Q1022 1152 1088 1152L1088 1152L1344 1152Q1410 1152 1468 1177.50Q1526 1203 1569.50 1246.50Q1613 1290 1638.50 1348Q1664 1406 1664 1472L1664 1472Q1664 1526 1643.50 1577.50Q1623 1629 1588 1671Q1553 1713 1506.50 1743.50Q1460 1774 1408 1786L1408 1786L1408 1653Q1451 1644 1476 1629.50Q1501 1615 1514.50 1593Q1528 1571 1532 1541Q1536 1511 1536 1472L1536 1472Q1536 1432 1521 1397Q1506 1362 1480 1336Q1454 1310 1419 1295Q1384 1280 1344 1280L1344 1280ZM0 0L2048 0L2048 1371Q1991 1320 1920 1290L1920 1290L1920 128L128 128L128 1408L615 1408Q613 1424 610.50 1439.50Q608 1455 608 1472L608 1472Q608 1488 610 1504Q612 1520 614 1536L614 1536L0 1536L0 0ZM384 1152L256 1152Q256 1100 270 1050.50Q284 1001 310 957.50Q336 914 373 878Q410 842 456 817L456 817Q422 782 403 736Q384 690 384 640L384 640Q384 587 404 540.50Q424 494 459 459Q494 424 540.50 404Q587 384 640 384L640 384Q693 384 739.50 404Q786 424 821 459Q856 494 876 540.50Q896 587 896 640L896 640Q896 690 877 736Q858 782 824 817L824 817Q887 852 933.50 907.50Q980 963 1004 1031L1004 1031Q940 1041 880 1067L880 1067Q866 1029 842 997.50Q818 966 786.50 943.50Q755 921 717.50 908.50Q680 896 640 896L640 896Q587 896 540.50 916Q494 936 459 971Q424 1006 404 1052.50Q384 1099 384 1152L384 1152ZM640 512L640 512Q613 512 590 522Q567 532 549.50 549.50Q532 567 522 590Q512 613 512 640L512 640Q512 667 522 690Q532 713 549.50 730.50Q567 748 590 758Q613 768 640 768L640 768Q667 768 690 758Q713 748 730.50 730.50Q748 713 758 690Q768 667 768 640L768 640Q768 613 758 590Q748 567 730.50 549.50Q713 532 690 522Q667 512 640 512Z"
         }
      }
   ]
}

var Stack = {
   name: "Stack",
   vendor: "UiFabric",
   unicode: 62063,
   value: "",
   charCode: "F26F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 384L1792 640L2048 640L2048 1792L512 1792L512 1536L256 1536L256 1280L0 1280L0 128L1536 128L1536 384L1792 384ZM1408 256L128 256L128 1152L1408 1152L1408 256ZM1536 1280L384 1280L384 1408L1664 1408L1664 512L1536 512L1536 1280ZM640 1664L1920 1664L1920 768L1792 768L1792 1536L640 1536L640 1664Z"
         }
      }
   ]
}

var Bullseye = {
   name: "Bullseye",
   vendor: "UiFabric",
   unicode: 62066,
   value: "",
   charCode: "F272",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1024 640Q944 640 874.50 670Q805 700 752.50 752.50Q700 805 670 875Q640 945 640 1024L640 1024Q640 1104 670 1173.50Q700 1243 752.50 1295.50Q805 1348 874.50 1378Q944 1408 1024 1408L1024 1408Q1103 1408 1173 1378Q1243 1348 1295.50 1295.50Q1348 1243 1378 1173.50Q1408 1104 1408 1024L1408 1024Q1408 960 1386 896L1386 896L1520 896Q1528 928 1532 960Q1536 992 1536 1024L1536 1024Q1536 1130 1495.50 1223Q1455 1316 1385.50 1385.50Q1316 1455 1223 1495.50Q1130 1536 1024 1536L1024 1536Q918 1536 825 1495.50Q732 1455 662.50 1385.50Q593 1316 553 1223Q513 1130 513 1024L513 1024Q513 918 553 825Q593 732 662.50 662.50Q732 593 825 552.50Q918 512 1024 512L1024 512Q1056 512 1088 516Q1120 520 1152 528L1152 528L1152 662Q1088 640 1024 640ZM1789 896L1890 795Q1920 908 1920 1024L1920 1024Q1920 1147 1888 1261.50Q1856 1376 1797.50 1475.50Q1739 1575 1657 1657Q1575 1739 1475.50 1797.50Q1376 1856 1261.50 1888Q1147 1920 1024 1920L1024 1920Q901 1920 786.50 1888Q672 1856 572.50 1797.50Q473 1739 391 1657Q309 1575 250.50 1475.50Q192 1376 160 1262Q128 1148 128 1024L128 1024Q128 901 160 786.50Q192 672 250.50 572.50Q309 473 391 391Q473 309 572.50 250.50Q672 192 786 160Q900 128 1024 128L1024 128Q1140 128 1253 158L1253 158L1152 259L1152 267Q1120 262 1088 259Q1056 256 1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792L1024 1792Q1130 1792 1228 1764.50Q1326 1737 1411.50 1687Q1497 1637 1567 1567Q1637 1497 1687 1411.50Q1737 1326 1764.50 1228Q1792 1130 1792 1024L1792 1024Q1792 992 1789 960Q1786 928 1781 896L1781 896L1789 896ZM1057 900L1280 677L1280 390L1664 6L1664 384L2042 384L1658 768L1371 768L1148 991Q1152 1006 1152 1024L1152 1024Q1152 1051 1142 1074Q1132 1097 1114.50 1114.50Q1097 1132 1074 1142Q1051 1152 1024 1152L1024 1152Q997 1152 974 1142Q951 1132 933.50 1114.50Q916 1097 906 1074Q896 1051 896 1024L896 1024Q896 997 906 974Q916 951 933.50 933.50Q951 916 974 906Q997 896 1024 896L1024 896Q1042 896 1057 900L1057 900ZM1408 443L1408 640L1605 640L1733 512L1536 512L1536 315L1408 443Z"
         }
      }
   ]
}

var VennDiagram = {
   name: "VennDiagram",
   vendor: "UiFabric",
   unicode: 62067,
   value: "",
   charCode: "F273",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1503 545L1503 545Q1624 583 1724.50 654.50Q1825 726 1897 822.50Q1969 919 2008.50 1036Q2048 1153 2048 1280L2048 1280Q2048 1386 2020.50 1484Q1993 1582 1943 1667.50Q1893 1753 1823 1823Q1753 1893 1667.50 1943Q1582 1993 1484 2020.50Q1386 2048 1280 2048L1280 2048Q1152 2048 1035.50 2008.50Q919 1969 822.50 1897Q726 1825 654 1725Q582 1625 545 1503L545 1503Q423 1466 323 1394Q223 1322 151 1225.50Q79 1129 39.50 1012.50Q0 896 0 768L0 768Q0 662 27.50 564Q55 466 105 380.50Q155 295 225 225Q295 155 380.50 105Q466 55 564 27.50Q662 0 768 0L768 0Q895 0 1012 39.50Q1129 79 1225.50 151Q1322 223 1393.50 323.50Q1465 424 1503 545ZM128 768L128 768Q128 864 155.50 953.50Q183 1043 234 1120Q285 1197 356.50 1257.50Q428 1318 516 1356L516 1356Q514 1337 513 1318Q512 1299 512 1280L512 1280Q512 1174 539.50 1076Q567 978 617 892.50Q667 807 737 737Q807 667 892.50 617Q978 567 1076 539.50Q1174 512 1280 512L1280 512Q1299 512 1318 513Q1337 514 1356 516L1356 516Q1318 428 1257.50 356.50Q1197 285 1120 234Q1043 183 953.50 155.50Q864 128 768 128L768 128Q680 128 598 151Q516 174 445 215.50Q374 257 315.50 315.50Q257 374 215.50 445Q174 516 151 598Q128 680 128 768ZM640 1280L640 1280Q640 1336 651 1397L651 1397Q712 1408 768 1408L768 1408Q808 1408 847.50 1403Q887 1398 925 1389L925 1389L659 1123Q650 1161 645 1200.50Q640 1240 640 1280ZM701 1006L1042 1347Q1115 1311 1179 1258L1179 1258L790 869Q737 933 701 1006L701 1006ZM869 790L1258 1179Q1311 1115 1347 1042L1347 1042L1006 701Q933 737 869 790L869 790ZM1408 768L1408 768Q1408 712 1397 651L1397 651Q1336 640 1280 640L1280 640Q1240 640 1200.50 645Q1161 650 1123 659L1123 659L1389 925Q1398 887 1403 847.50Q1408 808 1408 768ZM1280 1920L1280 1920Q1368 1920 1450 1897Q1532 1874 1603 1832.50Q1674 1791 1732.50 1732.50Q1791 1674 1832.50 1603Q1874 1532 1897 1450Q1920 1368 1920 1280L1920 1280Q1920 1184 1892.50 1094.50Q1865 1005 1814 928Q1763 851 1691.50 790.50Q1620 730 1532 692L1532 692Q1534 711 1535 730Q1536 749 1536 768L1536 768Q1536 874 1508.50 972Q1481 1070 1431 1155.50Q1381 1241 1311 1311Q1241 1381 1155.50 1431Q1070 1481 972 1508.50Q874 1536 768 1536L768 1536Q749 1536 730 1535Q711 1534 692 1532L692 1532Q730 1620 790.50 1691.50Q851 1763 928 1814Q1005 1865 1094.50 1892.50Q1184 1920 1280 1920Z"
         }
      }
   ]
}

var FiveTileGrid = {
   name: "FiveTileGrid",
   vendor: "UiFabric",
   unicode: 62068,
   value: "",
   charCode: "F274",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 256L2048 256L2048 1664L0 1664ZM1408 384L1024 384L1024 896L1408 896L1408 384ZM128 1536L896 1536L896 384L128 384L128 1536ZM1024 1536L1408 1536L1408 1024L1024 1024L1024 1536ZM1536 1536L1920 1536L1920 1024L1536 1024L1536 1536ZM1536 384L1536 896L1920 896L1920 384L1536 384Z"
         }
      }
   ]
}

var FocalPoint = {
   name: "FocalPoint",
   vendor: "UiFabric",
   unicode: 62071,
   value: "",
   charCode: "F277",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 768L1344 768Q1318 768 1299 749Q1280 730 1280 704L1280 704Q1280 678 1299 659Q1318 640 1344 640L1344 640Q1370 640 1389 659Q1408 678 1408 704L1408 704Q1408 730 1389 749Q1370 768 1344 768ZM2029 1811L1939 1901L1676 1639Q1633 1681 1589 1718Q1545 1755 1494 1787L1494 1787L1645 1939L1555 2029L1373 1850Q1206 1920 1024 1920L1024 1920Q919 1920 818.50 1896.50Q718 1873 627 1828Q536 1783 456.50 1717.50Q377 1652 313 1569L313 1569L109 1773L19 1683L241 1460Q184 1361 156 1249.50Q128 1138 128 1024L128 1024Q128 900 160 785.50Q192 671 250.50 571.50Q309 472 390.50 390.50Q472 309 571.50 250.50Q671 192 785.50 160Q900 128 1024 128L1024 128Q1148 128 1262.50 160Q1377 192 1476.50 250.50Q1576 309 1657.50 390.50Q1739 472 1797.50 571.50Q1856 671 1888 785.50Q1920 900 1920 1024L1920 1024Q1920 1163 1879 1294.50Q1838 1426 1757 1539L1757 1539L2029 1811ZM256 1024L256 1024Q256 1113 276.50 1199Q297 1285 336 1365L336 1365L704 998L1088 1382L1344 1126L1665 1447Q1727 1352 1759.50 1244.50Q1792 1137 1792 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024ZM1024 1792L1024 1792Q1153 1792 1275 1750L1275 1750L704 1178L405 1478Q459 1552 528 1610Q597 1668 676.50 1708.50Q756 1749 844 1770.50Q932 1792 1024 1792ZM1178 1472L1400 1693Q1452 1664 1498 1627.50Q1544 1591 1585 1548L1585 1548L1344 1306L1178 1472Z"
         }
      }
   ]
}

var Insert = {
   name: "Insert",
   vendor: "UiFabric",
   unicode: 62072,
   value: "",
   charCode: "F278",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 0L2048 0L2048 896L640 896L640 0ZM1920 768L1920 128L768 128L768 768L1920 768ZM640 2048L640 1152L2048 1152L2048 2048L640 2048ZM768 1280L768 1920L1920 1920L1920 1280L768 1280ZM19 749L109 659L475 1024L109 1389L19 1299L293 1024L19 749Z"
         }
      }
   ]
}

var RingerRemove = {
   name: "RingerRemove",
   vendor: "UiFabric",
   unicode: 62073,
   value: "",
   charCode: "F279",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 255L1024 255Q918 255 824.50 295.50Q731 336 661.50 405.50Q592 475 551.50 568.50Q511 662 511 768L511 768L511 1536L1219 1536L1347 1664L1280 1664Q1280 1717 1260 1763.50Q1240 1810 1205 1845Q1170 1880 1123.50 1900Q1077 1920 1024 1920L1024 1920Q971 1920 924.50 1900Q878 1880 843 1845Q808 1810 788 1763.50Q768 1717 768 1664L768 1664L256 1664L256 1536L385 1536L385 768Q385 680 408 598Q431 516 472.50 445Q514 374 572 315.50Q630 257 701 215.50Q772 174 854 151Q936 128 1024 128L1024 128Q1112 128 1194 151Q1276 174 1347 215.50Q1418 257 1476.50 315.50Q1535 374 1576.50 445Q1618 516 1641 598Q1664 680 1664 768L1664 768L1664 1347L1537 1221L1537 768Q1537 662 1496.50 568.50Q1456 475 1386.50 405.50Q1317 336 1223.50 295.50Q1130 255 1024 255ZM1144 1664L904 1664Q904 1689 913.50 1710.50Q923 1732 939.50 1748.50Q956 1765 977.50 1774.50Q999 1784 1024 1784L1024 1784Q1049 1784 1070.50 1774.50Q1092 1765 1108.50 1748.50Q1125 1732 1134.50 1710.50Q1144 1689 1144 1664L1144 1664ZM2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411L2045 1502Z"
         }
      }
   ]
}

var TeamsLogoInverse = {
   name: "TeamsLogoInverse",
   vendor: "UiFabric",
   unicode: 62074,
   value: "",
   charCode: "F27A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1760 704L1760 704Q1713 704 1672.50 686.50Q1632 669 1601.50 638.50Q1571 608 1553.50 567.50Q1536 527 1536 480L1536 480Q1536 434 1553.50 393Q1571 352 1601.50 321.50Q1632 291 1672.50 273.50Q1713 256 1760 256L1760 256Q1806 256 1847 273.50Q1888 291 1918.50 321.50Q1949 352 1966.50 393Q1984 434 1984 480L1984 480Q1984 527 1966.50 567.50Q1949 608 1918.50 638.50Q1888 669 1847 686.50Q1806 704 1760 704ZM1760 384L1760 384Q1720 384 1692 412Q1664 440 1664 480L1664 480Q1664 520 1692 548Q1720 576 1760 576L1760 576Q1800 576 1828 548Q1856 520 1856 480L1856 480Q1856 440 1828 412Q1800 384 1760 384ZM2048 864L2048 864L2048 1340Q2048 1406 2023 1464.50Q1998 1523 1954.50 1566.50Q1911 1610 1852.50 1635Q1794 1660 1728 1660L1728 1660Q1690 1660 1650.50 1651Q1611 1642 1578 1623L1578 1623Q1553 1704 1505 1770.50Q1457 1837 1392.50 1884.50Q1328 1932 1250 1958Q1172 1984 1088 1984L1088 1984Q990 1984 903.50 1950Q817 1916 749.50 1856Q682 1796 637.50 1714Q593 1632 580 1536L580 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L818 512Q789 451 789 384L789 384Q789 322 812.50 267.50Q836 213 876.50 172.50Q917 132 971.50 108.50Q1026 85 1088 85L1088 85Q1150 85 1204.50 108.50Q1259 132 1299.50 172.50Q1340 213 1363.50 267.50Q1387 322 1387 384L1387 384Q1387 446 1363.50 500.50Q1340 555 1299.50 595.50Q1259 636 1204.50 659.50Q1150 683 1088 683L1088 683Q1072 683 1056 681Q1040 679 1024 676L1024 676L1024 768L1952 768Q1992 768 2020 796Q2048 824 2048 864ZM1088 213L1088 213Q1053 213 1021.50 226.50Q990 240 967 263.50Q944 287 930.50 318Q917 349 917 384L917 384Q917 419 930.50 450.50Q944 482 967 505Q990 528 1021.50 541.50Q1053 555 1088 555L1088 555Q1123 555 1154 541.50Q1185 528 1208.50 505Q1232 482 1245.50 450.50Q1259 419 1259 384L1259 384Q1259 349 1245.50 318Q1232 287 1208.50 263.50Q1185 240 1154 226.50Q1123 213 1088 213ZM592 1360L592 848L784 848L784 688L240 688L240 848L432 848L432 1360L592 1360ZM1472 1472L1472 1472L1472 896L1024 896L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L709 1536Q722 1605 756.50 1664Q791 1723 840.50 1765.50Q890 1808 953 1832Q1016 1856 1088 1856L1088 1856Q1167 1856 1237 1826Q1307 1796 1359.50 1743.50Q1412 1691 1442 1621.50Q1472 1552 1472 1472ZM1920 1340L1920 1340L1920 896L1600 896L1600 1481Q1626 1507 1659 1519.50Q1692 1532 1728 1532L1728 1532Q1768 1532 1803 1517Q1838 1502 1864 1476Q1890 1450 1905 1415Q1920 1380 1920 1340Z"
         }
      }
   ]
}

var TeamsLogo = {
   name: "TeamsLogo",
   vendor: "UiFabric",
   unicode: 62075,
   value: "",
   charCode: "F27B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1760 704L1760 704Q1713 704 1672.50 686.50Q1632 669 1601.50 638.50Q1571 608 1553.50 567.50Q1536 527 1536 480L1536 480Q1536 434 1553.50 393Q1571 352 1601.50 321.50Q1632 291 1672.50 273.50Q1713 256 1760 256L1760 256Q1806 256 1847 273.50Q1888 291 1918.50 321.50Q1949 352 1966.50 393Q1984 434 1984 480L1984 480Q1984 527 1966.50 567.50Q1949 608 1918.50 638.50Q1888 669 1847 686.50Q1806 704 1760 704ZM1760 384L1760 384Q1720 384 1692 412Q1664 440 1664 480L1664 480Q1664 520 1692 548Q1720 576 1760 576L1760 576Q1800 576 1828 548Q1856 520 1856 480L1856 480Q1856 440 1828 412Q1800 384 1760 384ZM2048 864L2048 864L2048 1340Q2048 1406 2023 1464.50Q1998 1523 1954.50 1566.50Q1911 1610 1852.50 1635Q1794 1660 1728 1660L1728 1660Q1690 1660 1650.50 1651Q1611 1642 1578 1623L1578 1623Q1553 1704 1505 1770.50Q1457 1837 1392.50 1884.50Q1328 1932 1250 1958Q1172 1984 1088 1984L1088 1984Q990 1984 903.50 1950Q817 1916 749.50 1856Q682 1796 637.50 1714Q593 1632 580 1536L580 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L818 512Q789 451 789 384L789 384Q789 322 812.50 267.50Q836 213 876.50 172.50Q917 132 971.50 108.50Q1026 85 1088 85L1088 85Q1150 85 1204.50 108.50Q1259 132 1299.50 172.50Q1340 213 1363.50 267.50Q1387 322 1387 384L1387 384Q1387 446 1363.50 500.50Q1340 555 1299.50 595.50Q1259 636 1204.50 659.50Q1150 683 1088 683L1088 683Q1072 683 1056 681Q1040 679 1024 676L1024 676L1024 768L1952 768Q1992 768 2020 796Q2048 824 2048 864ZM1088 213L1088 213Q1053 213 1021.50 226.50Q990 240 967 263.50Q944 287 930.50 318Q917 349 917 384L917 384Q917 419 930.50 450.50Q944 482 967 505Q990 528 1021.50 541.50Q1053 555 1088 555L1088 555Q1123 555 1154 541.50Q1185 528 1208.50 505Q1232 482 1245.50 450.50Q1259 419 1259 384L1259 384Q1259 349 1245.50 318Q1232 287 1208.50 263.50Q1185 240 1154 226.50Q1123 213 1088 213ZM592 1360L592 848L784 848L784 688L240 688L240 848L432 848L432 1360L592 1360ZM1472 1472L1472 1472L1472 896L1024 896L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L709 1536Q722 1605 756.50 1664Q791 1723 840.50 1765.50Q890 1808 953 1832Q1016 1856 1088 1856L1088 1856Q1167 1856 1237 1826Q1307 1796 1359.50 1743.50Q1412 1691 1442 1621.50Q1472 1552 1472 1472ZM1920 1340L1920 1340L1920 896L1600 896L1600 1481Q1626 1507 1659 1519.50Q1692 1532 1728 1532L1728 1532Q1768 1532 1803 1517Q1838 1502 1864 1476Q1890 1450 1905 1415Q1920 1380 1920 1340Z"
         }
      }
   ]
}

var TeamsLogoFill = {
   name: "TeamsLogoFill",
   vendor: "UiFabric",
   unicode: 62076,
   value: "",
   charCode: "F27C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var SkypeForBusinessLogoFill = {
   name: "SkypeForBusinessLogoFill",
   vendor: "UiFabric",
   unicode: 62077,
   value: "",
   charCode: "F27D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1905 1203L1905 1203Q1944 1264 1964 1333.50Q1984 1403 1984 1475L1984 1475Q1984 1580 1944 1673Q1904 1766 1835 1835Q1766 1904 1673 1944Q1580 1984 1475 1984L1475 1984Q1397 1984 1333.50 1964Q1270 1944 1203 1906L1203 1906Q1112 1923 1024 1923L1024 1923Q900 1923 785 1891Q670 1859 570.50 1800.50Q471 1742 388.50 1659.50Q306 1577 247.50 1477.50Q189 1378 157 1263Q125 1148 125 1024L125 1024Q125 936 142 845L142 845Q104 778 84 714.50Q64 651 64 573L64 573Q64 468 104 375Q144 282 213 213Q282 144 375 104Q468 64 573 64L573 64Q651 64 714.50 84Q778 104 845 142L845 142Q936 125 1024 125L1024 125Q1148 125 1263 157Q1378 189 1477.50 247.50Q1577 306 1659.50 388.50Q1742 471 1800.50 570.50Q1859 670 1891 785Q1923 900 1923 1024L1923 1024Q1923 1069 1919.50 1114.50Q1916 1160 1905 1203Z"
         }
      }
   ]
}

var SharepointLogo = {
   name: "SharepointLogo",
   vendor: "UiFabric",
   unicode: 62078,
   value: "",
   charCode: "F27E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1152L2048 1152Q2048 1258 2007.50 1351Q1967 1444 1897.50 1513.50Q1828 1583 1735 1623.50Q1642 1664 1536 1664L1536 1664Q1471 1664 1406 1647L1406 1647Q1397 1732 1358.50 1805.50Q1320 1879 1260 1933Q1200 1987 1123 2017.50Q1046 2048 960 2048L960 2048Q867 2048 785.50 2012.50Q704 1977 643.50 1916.50Q583 1856 547.50 1774.50Q512 1693 512 1600L512 1600Q512 1584 513.50 1568Q515 1552 517 1536L517 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L387 512Q399 403 449 309.50Q499 216 576 147Q653 78 751.50 39Q850 0 960 0L960 0Q1079 0 1184 45.50Q1289 91 1367 169Q1445 247 1490.50 352Q1536 457 1536 576L1536 576Q1536 592 1535 608Q1534 624 1532 640L1532 640Q1638 640 1732 680Q1826 720 1896.50 789Q1967 858 2007.50 951.50Q2048 1045 2048 1152ZM960 128L960 128Q877 128 801.50 157Q726 186 667 237.50Q608 289 568.50 359.50Q529 430 517 512L517 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 1019L1042 1016Q1060 952 1094 894.50Q1128 837 1174.50 790.50Q1221 744 1278 710Q1335 676 1400 658L1400 658Q1408 615 1408 576L1408 576Q1408 483 1372.50 401.50Q1337 320 1276.50 259.50Q1216 199 1134.50 163.50Q1053 128 960 128ZM522 1357L522 1357Q568 1357 612.50 1347.50Q657 1338 692 1316Q727 1294 748.50 1258Q770 1222 770 1168L770 1168Q770 1114 747.50 1078Q725 1042 691 1018Q657 994 618 978.50Q579 963 545 949.50Q511 936 488.50 921Q466 906 466 883L466 883Q466 866 478 855.50Q490 845 506.50 839Q523 833 541 831Q559 829 571 829L571 829Q622 829 661 842Q700 855 742 881L742 881L742 729Q718 722 697.50 717Q677 712 657 708.50Q637 705 615.50 703.50Q594 702 568 702L568 702Q524 702 478 712Q432 722 394.50 744Q357 766 333.50 802Q310 838 310 890L310 890Q310 941 332.50 975Q355 1009 389 1033Q423 1057 462 1073.50Q501 1090 535 1104.50Q569 1119 591.50 1135Q614 1151 614 1174L614 1174Q614 1193 603.50 1204Q593 1215 577 1221Q561 1227 543.50 1228.50Q526 1230 512 1230L512 1230Q452 1230 405.50 1210Q359 1190 311 1157L311 1157L311 1317Q413 1357 522 1357ZM960 1920L960 1920Q1026 1920 1084 1895Q1142 1870 1185.50 1826.50Q1229 1783 1254.50 1724.50Q1280 1666 1280 1600L1280 1600Q1280 1543 1261 1491Q1242 1439 1208 1397.50Q1174 1356 1127 1327Q1080 1298 1024 1286L1024 1286L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L646 1536Q640 1568 640 1600L640 1600Q640 1666 665 1724.50Q690 1783 733.50 1826.50Q777 1870 835.50 1895Q894 1920 960 1920ZM1536 1536L1536 1536Q1615 1536 1685 1506Q1755 1476 1807.50 1423.50Q1860 1371 1890 1301.50Q1920 1232 1920 1152L1920 1152Q1920 1073 1890 1003Q1860 933 1807.50 880.50Q1755 828 1685 798Q1615 768 1536 768L1536 768Q1457 768 1387.50 798.50Q1318 829 1265.50 881.50Q1213 934 1182.50 1003.50Q1152 1073 1152 1152L1152 1152Q1152 1163 1152.50 1174Q1153 1185 1154 1196L1154 1196Q1201 1219 1241 1251.50Q1281 1284 1312.50 1324.50Q1344 1365 1366 1412Q1388 1459 1399 1510L1399 1510Q1466 1536 1536 1536Z"
         }
      }
   ]
}

var SharepointLogoFill = {
   name: "SharepointLogoFill",
   vendor: "UiFabric",
   unicode: 62079,
   value: "",
   charCode: "F27F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var DelveLogo = {
   name: "DelveLogo",
   vendor: "UiFabric",
   unicode: 62080,
   value: "",
   charCode: "F280",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 256L1920 256Q1946 256 1965 275Q1984 294 1984 320L1984 320L1984 1728Q1984 1754 1965 1773Q1946 1792 1920 1792L1920 1792L1216 1792L1216 1992L64 1791L64 263L1216 56L1216 256ZM604 1425L604 1425Q661 1425 706.50 1407Q752 1389 786.50 1358.50Q821 1328 845.50 1286.50Q870 1245 886 1198Q902 1151 909 1101Q916 1051 916 1003L916 1003Q916 927 903 855.50Q890 784 856.50 728.50Q823 673 765.50 639.50Q708 606 620 606L620 606Q559 606 497.50 613.50Q436 621 376 626L376 626L376 1409Q433 1414 490 1419.50Q547 1425 604 1425ZM1472 1728L1472 1408L1216 1408L1216 1728L1472 1728ZM1472 1344L1472 320L1216 320L1216 1344L1472 1344ZM1920 1728L1920 768L1536 768L1536 1728L1920 1728ZM1920 704L1920 320L1536 320L1536 704L1920 704ZM503 1272L503 762Q522 760 540.50 759Q559 758 579 758L579 758Q631 758 666 780.50Q701 803 722 838.50Q743 874 752 918Q761 962 761 1006L761 1006Q761 1049 752.50 1096.50Q744 1144 723 1183.50Q702 1223 667 1248.50Q632 1274 578 1274L578 1274Q559 1274 540.50 1273.50Q522 1273 503 1272L503 1272Z"
         }
      }
   ]
}

var DelveLogoFill = {
   name: "DelveLogoFill",
   vendor: "UiFabric",
   unicode: 62081,
   value: "",
   charCode: "F281",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M620 574L620 574Q715 574 778.50 609.50Q842 645 879.50 704.50Q917 764 932.50 841.50Q948 919 948 1003L948 1003Q948 1083 929.50 1163.50Q911 1244 869.50 1309.50Q828 1375 762.50 1416Q697 1457 604 1457L604 1457Q539 1457 474 1450.50Q409 1444 344 1439L344 1439L344 596Q410 590 482 582Q554 574 620 574ZM1184 288L1952 288L1952 1760L1184 1760L1184 288Z"
         }
      }
   ]
}

var OfficeVideoLogo = {
   name: "OfficeVideoLogo",
   vendor: "UiFabric",
   unicode: 62082,
   value: "",
   charCode: "F282",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 512L1920 512Q1946 512 1965 531Q1984 550 1984 576L1984 576L1984 1536Q1984 1562 1965 1581Q1946 1600 1920 1600L1920 1600L1216 1600L1216 1992L64 1791L64 263L1216 56L1216 512ZM715 1415L905 641L747 641Q718 781 690 920Q662 1059 631 1199L631 1199Q596 1061 560.50 925.50Q525 790 489 656L489 656L331 656L551 1415L715 1415ZM1920 1536L1920 576L1216 576L1216 875Q1258 824 1316 796Q1374 768 1440 768L1440 768Q1500 768 1552.50 790.50Q1605 813 1644 852Q1683 891 1705.50 943.50Q1728 996 1728 1056L1728 1056Q1728 1116 1705.50 1168.50Q1683 1221 1644 1260Q1605 1299 1552.50 1321.50Q1500 1344 1440 1344L1440 1344Q1374 1344 1316 1316Q1258 1288 1216 1237L1216 1237L1216 1536L1920 1536ZM1344 1203L1584 1056L1344 909L1344 1203Z"
         }
      }
   ]
}

var OfficeVideoLogoFill = {
   name: "OfficeVideoLogoFill",
   vendor: "UiFabric",
   unicode: 62083,
   value: "",
   charCode: "F283",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1184 544L1952 544L1952 1568L1184 1568L1184 544ZM629 1092L729 608L938 608L734 1437L533 1437L295 614L505 614L629 1092Z"
         }
      }
   ]
}

var ExchangeLogo = {
   name: "ExchangeLogo",
   vendor: "UiFabric",
   unicode: 62084,
   value: "",
   charCode: "F284",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 256L2048 672Q2048 697 2038 721.50Q2028 746 2011 763L2011 763L1749 1024L2011 1285Q2028 1302 2038 1326.50Q2048 1351 2048 1376L2048 1376L2048 1792Q2048 1819 2038 1842Q2028 1865 2010.50 1882.50Q1993 1900 1970 1910Q1947 1920 1920 1920L1920 1920L1504 1920Q1479 1920 1454.50 1910Q1430 1900 1413 1883L1413 1883L1152 1621L891 1883Q874 1900 849.50 1910Q825 1920 800 1920L800 1920L384 1920Q357 1920 334 1910Q311 1900 293.50 1882.50Q276 1865 266 1842Q256 1819 256 1792L256 1792L256 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L256 512L256 256Q256 229 266 206Q276 183 293.50 165.50Q311 148 334 138Q357 128 384 128L384 128L800 128Q825 128 849.50 138Q874 148 891 165L891 165L1152 427L1413 165Q1430 148 1454.50 138Q1479 128 1504 128L1504 128L1920 128Q1947 128 1970 138Q1993 148 2010.50 165.50Q2028 183 2038 206Q2048 229 2048 256L2048 256ZM800 256L384 256L384 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 480L800 256ZM288 688L288 1360L736 1360L736 1225L445 1225L445 1089L705 1089L705 954L445 954L445 824L722 824L722 688L288 688ZM1920 1792L1920 1376L1696 1152L1381 1152Q1360 1152 1341.50 1160Q1323 1168 1309.50 1181.50Q1296 1195 1288 1213.50Q1280 1232 1280 1253L1280 1253L1280 1568L1504 1792L1920 1792ZM1568 1024L1920 672L1920 256L1504 256L1152 608L1152 795Q1152 861 1117.50 916.50Q1083 972 1024 1001L1024 1001L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L384 1536L384 1792L800 1792L1152 1440L1152 1253Q1152 1205 1170 1163.50Q1188 1122 1219 1091Q1250 1060 1291.50 1042Q1333 1024 1381 1024L1381 1024L1568 1024Z"
         }
      }
   ]
}

var ExchangeLogoFill = {
   name: "ExchangeLogoFill",
   vendor: "UiFabric",
   unicode: 62085,
   value: "",
   charCode: "F285",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var Signin = {
   name: "Signin",
   vendor: "UiFabric",
   unicode: 62086,
   value: "",
   charCode: "F286",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 1152L1728 1152Q1754 1152 1773 1171Q1792 1190 1792 1216L1792 1216Q1792 1242 1773 1261Q1754 1280 1728 1280L1728 1280Q1702 1280 1683 1261Q1664 1242 1664 1216L1664 1216Q1664 1190 1683 1171Q1702 1152 1728 1152ZM1196 1026L1125 1133Q1046 1079 955 1051.50Q864 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1547 35.50 1435Q71 1323 136.50 1227.50Q202 1132 293.50 1058.50Q385 985 496 946L496 946Q440 910 395.50 863Q351 816 320 760Q289 704 272.50 641.50Q256 579 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 579 1263.50 641.50Q1247 704 1216 760Q1185 816 1140.50 863Q1096 910 1040 946L1040 946Q1121 975 1196 1026L1196 1026ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1599 1664 1536 1641L1536 1641L1536 1792L1408 1792L1408 1920L1280 1920L1280 2048L896 2048L896 1766L1291 1370Q1280 1324 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1315 1417 1344Q1426 1373 1438 1405L1438 1405L1024 1818L1024 1920L1152 1920L1152 1792L1280 1792L1280 1664L1408 1664L1408 1573L1501 1481Q1541 1504 1578 1520Q1615 1536 1664 1536Z"
         }
      }
   ]
}

var DocumentApproval = {
   name: "DocumentApproval",
   vendor: "UiFabric",
   unicode: 62091,
   value: "",
   charCode: "F28B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363ZM1664 640L1152 640L1152 128L256 128L256 1920L1152 1920L1152 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1408L1664 640ZM1280 219L1280 512L1573 512L1280 219Z"
         }
      }
   ]
}

var CloneToDesktop = {
   name: "CloneToDesktop",
   vendor: "UiFabric",
   unicode: 62092,
   value: "",
   charCode: "F28C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1408L1024 1536L1280 1536L1280 1664L640 1664L640 1536L896 1536L896 1408L0 1408L0 256L1920 256L1920 1024L1792 1024L1792 384L128 384L128 1280L1536 1280L1536 1408L1024 1408ZM1955 1539L2045 1629L1728 1946L1411 1629L1501 1539L1664 1701L1664 1152L1792 1152L1792 1701L1955 1539Z"
         }
      }
   ]
}

var InstallToDrive = {
   name: "InstallToDrive",
   vendor: "UiFabric",
   unicode: 62093,
   value: "",
   charCode: "F28D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M320 640L1728 640Q1794 640 1852 665.50Q1910 691 1953.50 734.50Q1997 778 2022.50 836Q2048 894 2048 960L2048 960L2048 1408L1920 1408L1920 960Q1920 920 1905 885Q1890 850 1864 824Q1838 798 1803 783Q1768 768 1728 768L1728 768L320 768Q280 768 245 783Q210 798 184 824Q158 850 143 885Q128 920 128 960L128 960L128 1280L1536 1280L1536 1408L0 1408L0 960Q0 894 25 836Q50 778 93.50 734.50Q137 691 195.50 665.50Q254 640 320 640L320 640ZM1792 1701L1955 1539L2045 1629L1728 1946L1411 1629L1501 1539L1664 1701L1664 1152L1792 1152L1792 1701ZM1792 896L1792 1024L1664 1024L1664 896L1792 896ZM1408 1024L1408 896L1536 896L1536 1024L1408 1024Z"
         }
      }
   ]
}

var Blur = {
   name: "Blur",
   vendor: "UiFabric",
   unicode: 62094,
   value: "",
   charCode: "F28E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L384 128L256 128L256 0L384 0ZM640 0L640 128L512 128L512 0L640 0ZM896 0L896 128L768 128L768 0L896 0ZM1152 256L1152 384L1024 384L1024 256L1152 256ZM1408 512L1408 640L1280 640L1280 512L1408 512ZM1664 768L1664 896L1536 896L1536 768L1664 768ZM1152 0L1152 128L1024 128L1024 0L1152 0ZM1536 256L1536 384L1408 384L1408 256L1536 256ZM1664 512L1536 512L1536 384L1664 384L1664 512ZM1792 896L1792 768L1920 768L1920 896L1792 896ZM640 256L640 384L512 384L512 256L640 256ZM896 256L896 384L768 384L768 256L896 256ZM1152 512L1152 640L1024 640L1024 512L1152 512ZM1408 768L1408 896L1280 896L1280 768L1408 768ZM896 512L896 640L768 640L768 512L896 512ZM1152 768L1152 896L1024 896L1024 768L1152 768ZM1408 1024L1408 1152L1280 1152L1280 1024L1408 1024ZM384 384L256 384L256 256L384 256L384 384ZM512 512L384 512L384 384L512 384L512 512ZM640 640L512 640L512 512L640 512L640 640ZM768 768L640 768L640 640L768 640L768 768ZM896 896L768 896L768 768L896 768L896 896ZM1024 1024L896 1024L896 896L1024 896L1024 1024ZM1152 1152L1024 1152L1024 1024L1152 1024L1152 1152ZM1280 1280L1152 1280L1152 1152L1280 1152L1280 1280ZM1408 1408L1280 1408L1280 1280L1408 1280L1408 1408ZM1536 1536L1408 1536L1408 1408L1536 1408L1536 1536ZM1664 1664L1536 1664L1536 1536L1664 1536L1664 1664ZM1664 1792L1664 1664L1792 1664L1792 1792L1920 1792L1920 1920L0 1920L0 0L128 0L128 128L256 128L256 256L128 256L128 1792L1664 1792ZM1792 1664L1792 1536L1920 1536L1920 1664L1792 1664ZM1792 1408L1792 1280L1920 1280L1920 1408L1792 1408ZM1792 1152L1792 1024L1920 1024L1920 1152L1792 1152ZM1664 1280L1664 1408L1536 1408L1536 1280L1664 1280ZM1536 1152L1536 1024L1664 1024L1664 1152L1536 1152ZM1536 0L1536 128L1408 128L1408 0L1536 0ZM1792 512L1792 384L1920 384L1920 512L1792 512ZM1792 0L1920 0L1920 128L1792 128L1792 0Z"
         }
      }
   ]
}

var Build = {
   name: "Build",
   vendor: "UiFabric",
   unicode: 62095,
   value: "",
   charCode: "F28F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1024L640 1280L384 1280L384 1024L640 1024ZM1792 768L1920 768L1920 1920L128 1920L128 768L256 768L256 1408L1792 1408L1792 768ZM896 1792L896 1536L640 1536L640 1792L896 1792ZM1408 1792L1408 1536L1152 1536L1152 1792L1408 1792ZM896 1280L896 1024L1152 1024L1152 1280L896 1280ZM1664 1024L1664 1280L1408 1280L1408 1024L1664 1024ZM1261 621L960 922L659 621L749 531L896 677L896 0L1024 0L1024 677L1171 531L1261 621Z"
         }
      }
   ]
}

var ProcessMetaTask = {
   name: "ProcessMetaTask",
   vendor: "UiFabric",
   unicode: 62096,
   value: "",
   charCode: "F290",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M827 985L951 1037Q986 986 1037 951L1037 951L985 827L1104 778L1155 902Q1185 896 1216 896L1216 896Q1247 896 1277 902L1277 902L1328 778L1447 827L1395 951Q1421 968 1442.50 989.50Q1464 1011 1481 1037L1481 1037L1605 985L1654 1104L1530 1155Q1536 1185 1536 1216L1536 1216Q1536 1247 1530 1277L1530 1277L1654 1328L1605 1447L1481 1395Q1464 1421 1442.50 1442.50Q1421 1464 1395 1481L1395 1481L1447 1605L1328 1654L1277 1530Q1247 1536 1216 1536L1216 1536Q1185 1536 1155 1530L1155 1530L1104 1654L985 1605L1037 1481Q986 1446 951 1395L951 1395L827 1447L778 1328L902 1277Q896 1247 896 1216L896 1216Q896 1185 902 1155L902 1155L778 1104L827 985ZM1408 1216L1408 1216Q1408 1176 1393 1141Q1378 1106 1352 1080Q1326 1054 1291 1039Q1256 1024 1216 1024L1216 1024Q1176 1024 1141 1039Q1106 1054 1080 1080Q1054 1106 1039 1141Q1024 1176 1024 1216L1024 1216Q1024 1256 1039 1291Q1054 1326 1080 1352Q1106 1378 1141 1393Q1176 1408 1216 1408L1216 1408Q1255 1408 1290 1393Q1325 1378 1351.50 1351.50Q1378 1325 1393 1290Q1408 1255 1408 1216ZM331 919L267 809L387 739Q384 721 384 704L384 704Q384 687 387 669L387 669L267 599L331 489L452 558Q481 535 512 524L512 524L512 384L640 384L640 524Q671 535 700 558L700 558L821 489L885 599L765 669Q768 687 768 704L768 704Q768 721 765 739L765 739L885 809L821 919L700 850Q686 861 671.50 869.50Q657 878 640 884L640 884L640 1024L512 1024L512 884Q495 878 480.50 869.50Q466 861 452 850L452 850L331 919ZM576 608L576 608Q536 608 508 636Q480 664 480 704L480 704Q480 744 508 772Q536 800 576 800L576 800Q616 800 644 772Q672 744 672 704L672 704Q672 664 644 636Q616 608 576 608ZM0 0L1920 0L1920 2048L0 2048L0 0ZM1792 1920L1792 128L128 128L128 1920L1792 1920Z"
         }
      }
   ]
}

var BranchFork2 = {
   name: "BranchFork2",
   vendor: "UiFabric",
   unicode: 62097,
   value: "",
   charCode: "F291",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 320L1792 320Q1792 377 1772.50 429.50Q1753 482 1718.50 523.50Q1684 565 1636.50 594Q1589 623 1533 634L1533 634Q1523 735 1480 824Q1437 913 1369.50 981Q1302 1049 1213.50 1093Q1125 1137 1024 1149L1024 1149L1024 1414Q1080 1426 1127 1455Q1174 1484 1208 1525.50Q1242 1567 1261 1619Q1280 1671 1280 1728L1280 1728Q1280 1794 1254.50 1852.50Q1229 1911 1185.50 1954.50Q1142 1998 1084 2023Q1026 2048 960 2048L960 2048Q894 2048 835.50 2023Q777 1998 733.50 1954.50Q690 1911 665 1852.50Q640 1794 640 1728L640 1728Q640 1671 659 1619Q678 1567 712 1525.50Q746 1484 793 1455Q840 1426 896 1414L896 1414L896 1149Q795 1137 706.50 1093Q618 1049 550.50 981Q483 913 440 824Q397 735 387 634L387 634Q331 623 283.50 594Q236 565 201.50 523.50Q167 482 147.50 429.50Q128 377 128 320L128 320Q128 254 153 196Q178 138 221.50 94.50Q265 51 323.50 25.50Q382 0 448 0L448 0Q514 0 572 25.50Q630 51 673.50 94.50Q717 138 742.50 196Q768 254 768 320L768 320Q768 376 749.50 427.50Q731 479 697.50 520.50Q664 562 617.50 591.50Q571 621 516 633L516 633Q526 717 565.50 788.50Q605 860 664.50 912.50Q724 965 800 994.50Q876 1024 960 1024L960 1024Q1044 1024 1120 994.50Q1196 965 1255.50 912.50Q1315 860 1354 788.50Q1393 717 1404 633L1404 633Q1349 621 1302.50 591.50Q1256 562 1222.50 520.50Q1189 479 1170.50 427.50Q1152 376 1152 320L1152 320Q1152 254 1177 196Q1202 138 1245.50 94.50Q1289 51 1347.50 25.50Q1406 0 1472 0L1472 0Q1538 0 1596 25.50Q1654 51 1697.50 94.50Q1741 138 1766.50 196Q1792 254 1792 320ZM256 320L256 320Q256 360 271 395Q286 430 312 456Q338 482 373 497Q408 512 448 512L448 512Q488 512 523 497Q558 482 584 456Q610 430 625 395Q640 360 640 320L640 320Q640 280 625 245Q610 210 584 184Q558 158 523 143Q488 128 448 128L448 128Q408 128 373 143Q338 158 312 184Q286 210 271 245Q256 280 256 320ZM1152 1728L1152 1728Q1152 1688 1137 1653Q1122 1618 1096 1592Q1070 1566 1035 1551Q1000 1536 960 1536L960 1536Q920 1536 885 1551Q850 1566 824 1592Q798 1618 783 1653Q768 1688 768 1728L768 1728Q768 1768 783 1803Q798 1838 824 1864Q850 1890 885 1905Q920 1920 960 1920L960 1920Q1000 1920 1035 1905Q1070 1890 1096 1864Q1122 1838 1137 1803Q1152 1768 1152 1728ZM1472 512L1472 512Q1512 512 1547 497Q1582 482 1608 456Q1634 430 1649 395Q1664 360 1664 320L1664 320Q1664 280 1649 245Q1634 210 1608 184Q1582 158 1547 143Q1512 128 1472 128L1472 128Q1432 128 1397 143Q1362 158 1336 184Q1310 210 1295 245Q1280 280 1280 320L1280 320Q1280 360 1295 395Q1310 430 1336 456Q1362 482 1397 497Q1432 512 1472 512Z"
         }
      }
   ]
}

var BranchLocked = {
   name: "BranchLocked",
   vendor: "UiFabric",
   unicode: 62098,
   value: "",
   charCode: "F292",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1408 1408L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408ZM1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920ZM1536 704L1536 704Q1536 762 1516.50 814Q1497 866 1462 908Q1427 950 1379 979Q1331 1008 1274 1018L1274 1018Q1263 1075 1234.50 1123Q1206 1171 1164 1206Q1122 1241 1070 1260.50Q1018 1280 960 1280L960 1280L576 1280Q544 1280 515 1290Q486 1300 462 1318Q438 1336 420 1361.50Q402 1387 393 1417L393 1417Q447 1430 492.50 1459.50Q538 1489 570.50 1530Q603 1571 621.50 1622Q640 1673 640 1728L640 1728Q640 1794 614.50 1852.50Q589 1911 545.50 1954.50Q502 1998 444 2023Q386 2048 320 2048L320 2048Q254 2048 196 2023Q138 1998 94.50 1954.50Q51 1911 26 1852.50Q1 1794 1 1728L1 1728Q1 1671 20 1619.50Q39 1568 72.50 1526Q106 1484 153 1455Q200 1426 256 1415L256 1415L256 633Q200 622 153 593Q106 564 72.50 522Q39 480 20 428.50Q1 377 1 320L1 320Q1 254 26 196Q51 138 94.50 94.50Q138 51 196 25.50Q254 0 320 0L320 0Q386 0 444 25.50Q502 51 545.50 94.50Q589 138 614.50 196Q640 254 640 320L640 320Q640 377 621 429Q602 481 568 522.50Q534 564 487 593Q440 622 384 633L384 633L384 1218Q426 1186 475 1169Q524 1152 576 1152L576 1152L960 1152Q992 1152 1021 1142Q1050 1132 1074 1114Q1098 1096 1116 1070.50Q1134 1045 1143 1015L1143 1015Q1089 1002 1043.50 973Q998 944 965.50 902.50Q933 861 914.50 810.50Q896 760 896 704L896 704Q896 638 921 580Q946 522 989.50 478.50Q1033 435 1091.50 409.50Q1150 384 1216 384L1216 384Q1282 384 1340 409.50Q1398 435 1441.50 478.50Q1485 522 1510.50 580Q1536 638 1536 704ZM128 320L128 320Q128 360 143 395Q158 430 184 456Q210 482 245 497Q280 512 320 512L320 512Q360 512 395 497Q430 482 456 456Q482 430 497 395Q512 360 512 320L512 320Q512 280 497 245Q482 210 456 184Q430 158 395 143Q360 128 320 128L320 128Q280 128 245 143Q210 158 184 184Q158 210 143 245Q128 280 128 320ZM512 1728L512 1728Q512 1688 497 1653Q482 1618 456 1592Q430 1566 395 1551Q360 1536 320 1536L320 1536Q280 1536 245 1551Q210 1566 184 1592Q158 1618 143 1653Q128 1688 128 1728L128 1728Q128 1768 143 1803Q158 1838 184 1864Q210 1890 245 1905Q280 1920 320 1920L320 1920Q360 1920 395 1905Q430 1890 456 1864Q482 1838 497 1803Q512 1768 512 1728ZM1216 896L1216 896Q1256 896 1291 881Q1326 866 1352 840Q1378 814 1393 779Q1408 744 1408 704L1408 704Q1408 664 1393 629Q1378 594 1352 568Q1326 542 1291 527Q1256 512 1216 512L1216 512Q1176 512 1141 527Q1106 542 1080 568Q1054 594 1039 629Q1024 664 1024 704L1024 704Q1024 744 1039 779Q1054 814 1080 840Q1106 866 1141 881Q1176 896 1216 896Z"
         }
      }
   ]
}

var BranchCommit = {
   name: "BranchCommit",
   vendor: "UiFabric",
   unicode: 62099,
   value: "",
   charCode: "F293",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 960L1408 960Q1408 1043 1379 1118.50Q1350 1194 1299 1253.50Q1248 1313 1177.50 1352.50Q1107 1392 1024 1403L1024 1403L1024 1920L896 1920L896 1403Q813 1392 742.50 1352.50Q672 1313 621 1253.50Q570 1194 541 1118.50Q512 1043 512 960L512 960Q512 877 541 801.50Q570 726 621 666.50Q672 607 742.50 567.50Q813 528 896 517L896 517L896 0L1024 0L1024 517Q1107 528 1177.50 567.50Q1248 607 1299 666.50Q1350 726 1379 801.50Q1408 877 1408 960ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280Z"
         }
      }
   ]
}

var BranchCompare = {
   name: "BranchCompare",
   vendor: "UiFabric",
   unicode: 62100,
   value: "",
   charCode: "F294",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 576L1664 1414Q1720 1426 1767 1455Q1814 1484 1848 1525.50Q1882 1567 1901 1619Q1920 1671 1920 1728L1920 1728Q1920 1794 1894.50 1852.50Q1869 1911 1825.50 1954.50Q1782 1998 1724 2023Q1666 2048 1600 2048L1600 2048Q1534 2048 1475.50 2023Q1417 1998 1373.50 1954.50Q1330 1911 1305 1852.50Q1280 1794 1280 1728L1280 1728Q1280 1671 1299 1619Q1318 1567 1352 1525.50Q1386 1484 1433 1455Q1480 1426 1536 1414L1536 1414L1536 576Q1536 536 1521 501Q1506 466 1480 440Q1454 414 1419 399Q1384 384 1344 384L1344 384L1178 384L1341 547L1251 637L933 320L1251 3L1341 93L1178 256L1344 256Q1410 256 1468 281.50Q1526 307 1569.50 350.50Q1613 394 1638.50 452Q1664 510 1664 576L1664 576ZM1600 1920L1600 1920Q1640 1920 1675 1905Q1710 1890 1736 1864Q1762 1838 1777 1803Q1792 1768 1792 1728L1792 1728Q1792 1688 1777 1653Q1762 1618 1736 1592Q1710 1566 1675 1551Q1640 1536 1600 1536L1600 1536Q1560 1536 1525 1551Q1490 1566 1464 1592Q1438 1618 1423 1653Q1408 1688 1408 1728L1408 1728Q1408 1768 1423 1803Q1438 1838 1464 1864Q1490 1890 1525 1905Q1560 1920 1600 1920ZM707 1501L797 1411L1115 1728L797 2045L707 1955L870 1792L704 1792Q638 1792 579.50 1767Q521 1742 477.50 1698.50Q434 1655 409 1596.50Q384 1538 384 1472L384 1472L384 634Q328 622 281 593Q234 564 200 522.50Q166 481 147 429Q128 377 128 320L128 320Q128 254 153 196Q178 138 221.50 94.50Q265 51 323.50 25.50Q382 0 448 0L448 0Q514 0 572 25.50Q630 51 673.50 94.50Q717 138 742.50 196Q768 254 768 320L768 320Q768 377 749 429Q730 481 696 522.50Q662 564 615 593Q568 622 512 634L512 634L512 1472Q512 1512 527 1547Q542 1582 568 1608Q594 1634 629 1649Q664 1664 704 1664L704 1664L870 1664L707 1501ZM256 320L256 320Q256 360 271 395Q286 430 312 456Q338 482 373 497Q408 512 448 512L448 512Q488 512 523 497Q558 482 584 456Q610 430 625 395Q640 360 640 320L640 320Q640 280 625 245Q610 210 584 184Q558 158 523 143Q488 128 448 128L448 128Q408 128 373 143Q338 158 312 184Q286 210 271 245Q256 280 256 320Z"
         }
      }
   ]
}

var BranchMerge = {
   name: "BranchMerge",
   vendor: "UiFabric",
   unicode: 62101,
   value: "",
   charCode: "F295",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1024L1600 1024Q1666 1024 1724 1049.50Q1782 1075 1825.50 1118.50Q1869 1162 1894.50 1220Q1920 1278 1920 1344L1920 1344Q1920 1410 1894.50 1468.50Q1869 1527 1825.50 1570.50Q1782 1614 1724 1639Q1666 1664 1600 1664L1600 1664Q1543 1664 1491 1644.50Q1439 1625 1397 1590.50Q1355 1556 1326 1509Q1297 1462 1286 1406L1286 1406Q1187 1400 1093.50 1370Q1000 1340 917 1290Q834 1240 763.50 1172Q693 1104 640 1020L640 1020L640 1414Q696 1426 743 1455Q790 1484 824 1525.50Q858 1567 877 1619Q896 1671 896 1728L896 1728Q896 1794 870.50 1852.50Q845 1911 801.50 1954.50Q758 1998 700 2023Q642 2048 576 2048L576 2048Q510 2048 451.50 2023Q393 1998 349.50 1954.50Q306 1911 281 1852.50Q256 1794 256 1728L256 1728Q256 1671 275 1619Q294 1567 328 1525.50Q362 1484 409 1455Q456 1426 512 1414L512 1414L512 634Q456 622 409 593Q362 564 328 522.50Q294 481 275 429Q256 377 256 320L256 320Q256 254 281 196Q306 138 349.50 94.50Q393 51 451.50 25.50Q510 0 576 0L576 0Q642 0 700 25.50Q758 51 801.50 94.50Q845 138 870.50 196Q896 254 896 320L896 320Q896 377 877 428.50Q858 480 824.50 521.50Q791 563 744 592Q697 621 642 633L642 633Q652 762 706 874.50Q760 987 846.50 1073.50Q933 1160 1045.50 1214Q1158 1268 1287 1278L1287 1278Q1299 1223 1328 1176Q1357 1129 1398.50 1095.50Q1440 1062 1491.50 1043Q1543 1024 1600 1024ZM384 320L384 320Q384 360 399 395Q414 430 440 456Q466 482 501 497Q536 512 576 512L576 512Q616 512 651 497Q686 482 712 456Q738 430 753 395Q768 360 768 320L768 320Q768 280 753 245Q738 210 712 184Q686 158 651 143Q616 128 576 128L576 128Q536 128 501 143Q466 158 440 184Q414 210 399 245Q384 280 384 320ZM768 1728L768 1728Q768 1688 753 1653Q738 1618 712 1592Q686 1566 651 1551Q616 1536 576 1536L576 1536Q536 1536 501 1551Q466 1566 440 1592Q414 1618 399 1653Q384 1688 384 1728L384 1728Q384 1768 399 1803Q414 1838 440 1864Q466 1890 501 1905Q536 1920 576 1920L576 1920Q616 1920 651 1905Q686 1890 712 1864Q738 1838 753 1803Q768 1768 768 1728ZM1600 1536L1600 1536Q1640 1536 1675 1521Q1710 1506 1736 1480Q1762 1454 1777 1419Q1792 1384 1792 1344L1792 1344Q1792 1304 1777 1269Q1762 1234 1736 1208Q1710 1182 1675 1167Q1640 1152 1600 1152L1600 1152Q1560 1152 1525 1167Q1490 1182 1464 1208Q1438 1234 1423 1269Q1408 1304 1408 1344L1408 1344Q1408 1384 1423 1419Q1438 1454 1464 1480Q1490 1506 1525 1521Q1560 1536 1600 1536Z"
         }
      }
   ]
}

var BranchPullRequest = {
   name: "BranchPullRequest",
   vendor: "UiFabric",
   unicode: 62102,
   value: "",
   charCode: "F296",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 320L768 320Q768 377 749 429Q730 481 696 522.50Q662 564 615 593Q568 622 512 634L512 634L512 1414Q568 1426 615 1455Q662 1484 696 1525.50Q730 1567 749 1619Q768 1671 768 1728L768 1728Q768 1794 742.50 1852.50Q717 1911 673.50 1954.50Q630 1998 572 2023Q514 2048 448 2048L448 2048Q382 2048 323.50 2023Q265 1998 221.50 1954.50Q178 1911 153 1852.50Q128 1794 128 1728L128 1728Q128 1671 147 1619Q166 1567 200 1525.50Q234 1484 281 1455Q328 1426 384 1414L384 1414L384 634Q328 622 281 593Q234 564 200 522.50Q166 481 147 429Q128 377 128 320L128 320Q128 254 153 196Q178 138 221.50 94.50Q265 51 323.50 25.50Q382 0 448 0L448 0Q514 0 572 25.50Q630 51 673.50 94.50Q717 138 742.50 196Q768 254 768 320ZM256 320L256 320Q256 360 271 395Q286 430 312 456Q338 482 373 497Q408 512 448 512L448 512Q488 512 523 497Q558 482 584 456Q610 430 625 395Q640 360 640 320L640 320Q640 280 625 245Q610 210 584 184Q558 158 523 143Q488 128 448 128L448 128Q408 128 373 143Q338 158 312 184Q286 210 271 245Q256 280 256 320ZM640 1728L640 1728Q640 1688 625 1653Q610 1618 584 1592Q558 1566 523 1551Q488 1536 448 1536L448 1536Q408 1536 373 1551Q338 1566 312 1592Q286 1618 271 1653Q256 1688 256 1728L256 1728Q256 1768 271 1803Q286 1838 312 1864Q338 1890 373 1905Q408 1920 448 1920L448 1920Q488 1920 523 1905Q558 1890 584 1864Q610 1838 625 1803Q640 1768 640 1728ZM1664 576L1664 1414Q1720 1426 1767 1455Q1814 1484 1848 1525.50Q1882 1567 1901 1619Q1920 1671 1920 1728L1920 1728Q1920 1794 1894.50 1852.50Q1869 1911 1825.50 1954.50Q1782 1998 1724 2023Q1666 2048 1600 2048L1600 2048Q1534 2048 1475.50 2023Q1417 1998 1373.50 1954.50Q1330 1911 1305 1852.50Q1280 1794 1280 1728L1280 1728Q1280 1671 1299 1619Q1318 1567 1352 1525.50Q1386 1484 1433 1455Q1480 1426 1536 1414L1536 1414L1536 576Q1536 536 1521 501Q1506 466 1480 440Q1454 414 1419 399Q1384 384 1344 384L1344 384L1178 384L1341 547L1251 637L933 320L1251 3L1341 93L1178 256L1344 256Q1410 256 1468 281.50Q1526 307 1569.50 350.50Q1613 394 1638.50 452Q1664 510 1664 576L1664 576ZM1600 1920L1600 1920Q1640 1920 1675 1905Q1710 1890 1736 1864Q1762 1838 1777 1803Q1792 1768 1792 1728L1792 1728Q1792 1688 1777 1653Q1762 1618 1736 1592Q1710 1566 1675 1551Q1640 1536 1600 1536L1600 1536Q1560 1536 1525 1551Q1490 1566 1464 1592Q1438 1618 1423 1653Q1408 1688 1408 1728L1408 1728Q1408 1768 1423 1803Q1438 1838 1464 1864Q1490 1890 1525 1905Q1560 1920 1600 1920Z"
         }
      }
   ]
}

var BranchSearch = {
   name: "BranchSearch",
   vendor: "UiFabric",
   unicode: 62103,
   value: "",
   charCode: "F297",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1274 1018L1274 1018Q1263 1075 1234.50 1123Q1206 1171 1164 1206Q1122 1241 1070 1260.50Q1018 1280 960 1280L960 1280L576 1280Q544 1280 515 1290Q486 1300 462 1318Q438 1336 420 1361.50Q402 1387 393 1417L393 1417Q447 1430 492.50 1459.50Q538 1489 570.50 1530Q603 1571 621.50 1622Q640 1673 640 1728L640 1728Q640 1794 614.50 1852.50Q589 1911 545.50 1954.50Q502 1998 444 2023Q386 2048 320 2048L320 2048Q254 2048 196 2023Q138 1998 94.50 1954.50Q51 1911 26 1852.50Q1 1794 1 1728L1 1728Q1 1671 20 1619.50Q39 1568 72.50 1526Q106 1484 153 1455Q200 1426 256 1415L256 1415L256 633Q200 622 153 593Q106 564 72.50 522Q39 480 20 428.50Q1 377 1 320L1 320Q1 254 26 196Q51 138 94.50 94.50Q138 51 196 25.50Q254 0 320 0L320 0Q386 0 444 25.50Q502 51 545.50 94.50Q589 138 614.50 196Q640 254 640 320L640 320Q640 377 621 429Q602 481 568 522.50Q534 564 487 593Q440 622 384 633L384 633L384 1218Q426 1186 475 1169Q524 1152 576 1152L576 1152L960 1152Q992 1152 1021 1142Q1050 1132 1074 1114Q1098 1096 1116 1070.50Q1134 1045 1143 1015L1143 1015Q1089 1002 1043.50 973Q998 944 965.50 902.50Q933 861 914.50 810.50Q896 760 896 704L896 704Q896 638 921 580Q946 522 989.50 478.50Q1033 435 1091.50 409.50Q1150 384 1216 384L1216 384Q1282 384 1340 409.50Q1398 435 1441.50 478.50Q1485 522 1510.50 580Q1536 638 1536 704L1536 704Q1536 762 1516.50 814Q1497 866 1462 908Q1427 950 1379 979Q1331 1008 1274 1018ZM1024 704L1024 704Q1024 744 1039 779Q1054 814 1080 840Q1106 866 1141 881Q1176 896 1216 896L1216 896Q1256 896 1291 881Q1326 866 1352 840Q1378 814 1393 779Q1408 744 1408 704L1408 704Q1408 664 1393 629Q1378 594 1352 568Q1326 542 1291 527Q1256 512 1216 512L1216 512Q1176 512 1141 527Q1106 542 1080 568Q1054 594 1039 629Q1024 664 1024 704ZM128 320L128 320Q128 360 143 395Q158 430 184 456Q210 482 245 497Q280 512 320 512L320 512Q360 512 395 497Q430 482 456 456Q482 430 497 395Q512 360 512 320L512 320Q512 280 497 245Q482 210 456 184Q430 158 395 143Q360 128 320 128L320 128Q280 128 245 143Q210 158 184 184Q158 210 143 245Q128 280 128 320ZM512 1728L512 1728Q512 1688 497 1653Q482 1618 456 1592Q430 1566 395 1551Q360 1536 320 1536L320 1536Q280 1536 245 1551Q210 1566 184 1592Q158 1618 143 1653Q128 1688 128 1728L128 1728Q128 1768 143 1803Q158 1838 184 1864Q210 1890 245 1905Q280 1920 320 1920L320 1920Q360 1920 395 1905Q430 1890 456 1864Q482 1838 497 1803Q512 1768 512 1728ZM1728 1024L1728 1024Q1794 1024 1852 1049.50Q1910 1075 1953.50 1118.50Q1997 1162 2022.50 1220Q2048 1278 2048 1344L2048 1344Q2048 1410 2022.50 1468.50Q1997 1527 1953.50 1570.50Q1910 1614 1852 1639Q1794 1664 1728 1664L1728 1664Q1681 1664 1636 1650.50Q1591 1637 1552 1611L1552 1611L1133 2029Q1114 2048 1088 2048L1088 2048Q1062 2048 1043 2029Q1024 2010 1024 1984L1024 1984Q1024 1958 1043 1939L1043 1939L1461 1520Q1435 1481 1421.50 1436Q1408 1391 1408 1344L1408 1344Q1408 1278 1433 1220Q1458 1162 1501.50 1118.50Q1545 1075 1603.50 1049.50Q1662 1024 1728 1024ZM1728 1536L1728 1536Q1768 1536 1803 1521Q1838 1506 1864 1480Q1890 1454 1905 1419Q1920 1384 1920 1344L1920 1344Q1920 1304 1905 1269Q1890 1234 1864 1208Q1838 1182 1803 1167Q1768 1152 1728 1152L1728 1152Q1688 1152 1653 1167Q1618 1182 1592 1208Q1566 1234 1551 1269Q1536 1304 1536 1344L1536 1344Q1536 1384 1551 1419Q1566 1454 1592 1480Q1618 1506 1653 1521Q1688 1536 1728 1536Z"
         }
      }
   ]
}

var BranchShelveset = {
   name: "BranchShelveset",
   vendor: "UiFabric",
   unicode: 62104,
   value: "",
   charCode: "F298",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1536L896 1019Q813 1008 742.50 968.50Q672 929 621 869.50Q570 810 541 734.50Q512 659 512 576L512 576Q512 483 547 401.50Q582 320 643 259Q704 198 785.50 163Q867 128 960 128L960 128Q1053 128 1134.50 163Q1216 198 1277 259Q1338 320 1373 401.50Q1408 483 1408 576L1408 576Q1408 659 1379 734.50Q1350 810 1299 869.50Q1248 929 1177.50 968.50Q1107 1008 1024 1019L1024 1019L1024 1536L896 1536ZM960 256L960 256Q894 256 835.50 281.50Q777 307 733.50 350.50Q690 394 665 452Q640 510 640 576L640 576Q640 642 665 700.50Q690 759 733.50 802.50Q777 846 835.50 871Q894 896 960 896L960 896Q1026 896 1084 871Q1142 846 1185.50 802.50Q1229 759 1254.50 700.50Q1280 642 1280 576L1280 576Q1280 510 1254.50 452Q1229 394 1185.50 350.50Q1142 307 1084 281.50Q1026 256 960 256ZM1792 1152L1920 1152L1920 1920L0 1920L0 1152L128 1152L128 1792L1792 1792L1792 1152Z"
         }
      }
   ]
}

var RawSource = {
   name: "RawSource",
   vendor: "UiFabric",
   unicode: 62105,
   value: "",
   charCode: "F299",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 384L896 512L0 512L0 384L896 384ZM384 896L384 768L1280 768L1280 896L384 896ZM1408 896L1408 768L2048 768L2048 896L1408 896ZM1024 384L2048 384L2048 512L1024 512L1024 384ZM384 1280L384 1152L1664 1152L1664 1280L384 1280ZM0 1664L0 1536L1280 1536L1280 1664L0 1664Z"
         }
      }
   ]
}

var RowsGroup = {
   name: "RowsGroup",
   vendor: "UiFabric",
   unicode: 62107,
   value: "",
   charCode: "F29B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1024L0 896Q53 896 99.50 876Q146 856 181 821Q216 786 236 739.50Q256 693 256 640L256 640Q256 560 286 490Q316 420 368 368Q420 316 490 286Q560 256 640 256L640 256L640 384Q587 384 540.50 404Q494 424 459 459Q424 494 404 540.50Q384 587 384 640L384 640Q384 737 339 821.50Q294 906 213 960L213 960Q294 1014 339 1098.50Q384 1183 384 1280L384 1280Q384 1333 404 1379.50Q424 1426 459 1461Q494 1496 540.50 1516Q587 1536 640 1536L640 1536L640 1664Q560 1664 490 1634Q420 1604 368 1552Q316 1500 286 1430Q256 1360 256 1280L256 1280Q256 1227 236 1180.50Q216 1134 181 1099Q146 1064 99.50 1044Q53 1024 0 1024L0 1024ZM768 256L2048 256L2048 896L768 896L768 256ZM1920 768L1920 384L896 384L896 768L1920 768ZM768 1664L768 1024L2048 1024L2048 1664L768 1664ZM896 1152L896 1536L1920 1536L1920 1152L896 1152Z"
         }
      }
   ]
}

var Deploy = {
   name: "Deploy",
   vendor: "UiFabric",
   unicode: 62109,
   value: "",
   charCode: "F29D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M659 1171L960 870L1261 1171L1171 1261L1024 1115L1024 1792L896 1792L896 1115L749 1261L659 1171ZM768 640L768 128L1280 128L1280 640L768 640ZM896 256L896 512L1152 512L1152 256L896 256ZM128 640L128 128L640 128L640 640L128 640ZM1408 128L1920 128L1920 640L1408 640L1408 128Z"
         }
      }
   ]
}

var ServerEnviroment = {
   name: "ServerEnviroment",
   vendor: "UiFabric",
   unicode: 62111,
   value: "",
   charCode: "F29F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 512L768 384L1280 384L1280 512L768 512ZM768 1280L768 1152L1280 1152L1280 1280L768 1280ZM768 1536L768 1408L1280 1408L1280 1536L768 1536ZM1778 1408L1938 2048L110 2048L270 1408L512 1408L512 256Q512 230 522 206.50Q532 183 549.50 165.50Q567 148 590.50 138Q614 128 640 128L640 128L1408 128Q1434 128 1457.50 138Q1481 148 1498.50 165.50Q1516 183 1526 206.50Q1536 230 1536 256L1536 256L1536 1408L1778 1408ZM640 256L640 1664L1408 1664L1408 256L640 256ZM274 1920L1774 1920L1678 1536L1536 1536L1536 1792L512 1792L512 1536L370 1536L274 1920Z"
         }
      }
   ]
}

var HighlightMappedShapes = {
   name: "HighlightMappedShapes",
   vendor: "UiFabric",
   unicode: 62113,
   value: "",
   charCode: "F2A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 640L2048 640L2048 1280L1152 1280L1152 1024L979 1024L640 1250L640 1408L1024 1408L1024 2048L128 2048L128 1408L512 1408L512 1250L77 960L512 670L512 512L384 512Q331 512 284.50 492Q238 472 203 437Q168 402 148 355.50Q128 309 128 256L128 256Q128 203 148 156.50Q168 110 203 75Q238 40 284.50 20Q331 0 384 0L384 0L768 0Q821 0 867.50 20Q914 40 949 75Q984 110 1004 156.50Q1024 203 1024 256L1024 256Q1024 309 1004 355.50Q984 402 949 437Q914 472 867.50 492Q821 512 768 512L768 512L640 512L640 670L979 896L1152 896L1152 640ZM384 384L768 384Q795 384 818 374Q841 364 858.50 346.50Q876 329 886 306Q896 283 896 256L896 256Q896 229 886 206Q876 183 858.50 165.50Q841 148 818 138Q795 128 768 128L768 128L384 128Q357 128 334 138Q311 148 293.50 165.50Q276 183 266 206Q256 229 256 256L256 256Q256 283 266 306Q276 329 293.50 346.50Q311 364 334 374Q357 384 384 384L384 384ZM768 1664L384 1664L384 1792L768 1792L768 1664ZM576 1139L845 960L576 781L307 960L576 1139ZM1792 1024L1792 896L1408 896L1408 1024L1792 1024Z"
         }
      }
   ]
}

var VisioLogo = {
   name: "VisioLogo",
   vendor: "UiFabric",
   unicode: 62119,
   value: "",
   charCode: "F2A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 597L1984 597L1984 1387Q1984 1422 1959 1447Q1934 1472 1899 1472L1899 1472L1470 1472Q1464 1567 1424 1648.50Q1384 1730 1319.50 1790.50Q1255 1851 1170.50 1885.50Q1086 1920 992 1920L992 1920Q908 1920 830 1891Q752 1862 689 1811Q626 1760 582 1689.50Q538 1619 523 1536L523 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L518 512Q512 497 512 480L512 480Q512 445 537 420L537 420L932 25Q957 0 992 0L992 0Q1027 0 1052 25L1052 25L1447 420Q1472 445 1472 480L1472 480Q1472 497 1466 512L1466 512L1899 512Q1934 512 1959 537Q1984 562 1984 597ZM1326 480L992 146L658 480L690 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 782L1326 480ZM429 1360L592 1360L847 688L681 688Q639 811 596 932Q553 1053 513 1177L513 1177Q472 1054 431 932.50Q390 811 348 688L348 688L178 688L429 1360ZM992 1792L992 1792Q1065 1792 1129 1764.50Q1193 1737 1241 1689Q1289 1641 1316.50 1577Q1344 1513 1344 1440L1344 1440Q1344 1373 1319 1312Q1294 1251 1251 1203Q1208 1155 1149.50 1125Q1091 1095 1024 1090L1024 1090L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L655 1536Q672 1592 704 1639Q736 1686 780 1720Q824 1754 878 1773Q932 1792 992 1792ZM1461 1344L1856 1344L1856 640L1347 640Q1336 651 1310.50 677.50Q1285 704 1251.50 737.50Q1218 771 1181.50 808Q1145 845 1113 876Q1081 907 1056.50 929Q1032 951 1024 954L1024 954L1024 962Q1104 965 1176.50 996Q1249 1027 1307 1078.50Q1365 1130 1405 1198Q1445 1266 1461 1344L1461 1344Z"
         }
      }
   ]
}

var VisioDocument = {
   name: "VisioDocument",
   vendor: "UiFabric",
   unicode: 62121,
   value: "",
   charCode: "F2A9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 475L2048 475L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L640 2048Q613 2048 590 2038Q567 2028 549.50 2010.50Q532 1993 522 1970Q512 1947 512 1920L512 1920L512 1664L115 1664Q91 1664 70.50 1655Q50 1646 34 1630Q18 1614 9 1593.50Q0 1573 0 1549L0 1549L0 627Q0 603 9 582.50Q18 562 34 546Q50 530 70.50 521Q91 512 115 512L115 512L512 512L512 128Q512 101 522 78Q532 55 549.50 37.50Q567 20 590 10Q613 0 640 0L640 0L1573 0Q1599 0 1622.50 9.50Q1646 19 1664 37L1664 37L2011 384Q2029 402 2038.50 425.50Q2048 449 2048 475ZM1829 384L1664 219L1664 384L1829 384ZM489 1414L493 1424L656 1424L911 752L745 752L598 1179Q593 1195 587.50 1210Q582 1225 577 1241L577 1241Q536 1118 494.50 996.50Q453 875 411 752L411 752L241 752L489 1414ZM640 1664L640 1920L1920 1920L1920 512L1664 512Q1637 512 1614 502Q1591 492 1573.50 474.50Q1556 457 1546 434Q1536 411 1536 384L1536 384L1536 128L640 128L640 512L1037 512Q1061 512 1081.50 521Q1102 530 1118 546Q1134 562 1143 582.50Q1152 603 1152 627L1152 627L1152 1549Q1152 1573 1143 1593.50Q1134 1614 1118 1630Q1102 1646 1081.50 1655Q1061 1664 1037 1664L1037 1664L640 1664ZM1408 832L1600 640L1792 832L1664 960L1664 1408L1408 1408L1408 1536L1280 1536L1280 1152L1408 1152L1408 1280L1536 1280L1536 960L1408 832Z"
         }
      }
   ]
}

var TimelineDelivery = {
   name: "TimelineDelivery",
   vendor: "UiFabric",
   unicode: 62123,
   value: "",
   charCode: "F2AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 896L1280 1024L897 1024L897 896L1280 896ZM896 640L896 768L256 768L256 640L896 640ZM0 256L2048 256L2048 960Q2048 930 2036 899Q2024 868 2005.50 838.50Q1987 809 1964.50 783.50Q1942 758 1921 739L1921 739L1921 384L1408 384L1408 768L1280 768L1280 384L768 384L768 512L640 512L640 384L128 384L128 1537L640 1537L640 896L768 896L768 1664L0 1664L0 256ZM1850 1200L1850 1200Q1896 1226 1932.50 1262Q1969 1298 1994.50 1341.50Q2020 1385 2034 1434.50Q2048 1484 2048 1536L2048 1536L1920 1536Q1920 1483 1900 1436.50Q1880 1390 1845 1355Q1810 1320 1763.50 1300Q1717 1280 1664 1280L1664 1280Q1611 1280 1564.50 1300Q1518 1320 1483 1355Q1448 1390 1428 1436.50Q1408 1483 1408 1536L1408 1536Q1408 1585 1389.50 1631Q1371 1677 1338 1712L1338 1712Q1384 1738 1420.50 1774Q1457 1810 1482.50 1853.50Q1508 1897 1522 1946.50Q1536 1996 1536 2048L1536 2048L1408 2048Q1408 1995 1388 1948.50Q1368 1902 1333 1867Q1298 1832 1251.50 1812Q1205 1792 1152 1792L1152 1792Q1099 1792 1052.50 1812Q1006 1832 971 1867Q936 1902 916 1948.50Q896 1995 896 2048L896 2048L768 2048Q768 1996 782 1946.50Q796 1897 821.50 1853.50Q847 1810 883.50 1774Q920 1738 966 1712L966 1712Q933 1677 914.50 1631Q896 1585 896 1536L896 1536Q896 1483 916 1436.50Q936 1390 971 1355Q1006 1320 1052.50 1300Q1099 1280 1152 1280L1152 1280Q1201 1280 1247 1298.50Q1293 1317 1328 1350L1328 1350Q1382 1254 1478 1200L1478 1200Q1445 1165 1426.50 1119Q1408 1073 1408 1024L1408 1024Q1408 971 1428 924.50Q1448 878 1483 843Q1518 808 1564.50 788Q1611 768 1664 768L1664 768Q1717 768 1763.50 788Q1810 808 1845 843Q1880 878 1900 924.50Q1920 971 1920 1024L1920 1024Q1920 1073 1901.50 1119Q1883 1165 1850 1200ZM1152 1664L1152 1664Q1179 1664 1202 1654Q1225 1644 1242.50 1626.50Q1260 1609 1270 1586Q1280 1563 1280 1536L1280 1536Q1280 1509 1270 1486Q1260 1463 1242.50 1445.50Q1225 1428 1202 1418Q1179 1408 1152 1408L1152 1408Q1125 1408 1102 1418Q1079 1428 1061.50 1445.50Q1044 1463 1034 1486Q1024 1509 1024 1536L1024 1536Q1024 1563 1034 1586Q1044 1609 1061.50 1626.50Q1079 1644 1102 1654Q1125 1664 1152 1664ZM1536 1024L1536 1024Q1536 1051 1546 1074Q1556 1097 1573.50 1114.50Q1591 1132 1614 1142Q1637 1152 1664 1152L1664 1152Q1691 1152 1714 1142Q1737 1132 1754.50 1114.50Q1772 1097 1782 1074Q1792 1051 1792 1024L1792 1024Q1792 997 1782 974Q1772 951 1754.50 933.50Q1737 916 1714 906Q1691 896 1664 896L1664 896Q1637 896 1614 906Q1591 916 1573.50 933.50Q1556 951 1546 974Q1536 997 1536 1024Z"
         }
      }
   ]
}

var TeamFavorite = {
   name: "TeamFavorite",
   vendor: "UiFabric",
   unicode: 62125,
   value: "",
   charCode: "F2AD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M868 1461L868 1461Q933 1494 985.50 1542.50Q1038 1591 1075 1650.50Q1112 1710 1132 1778.50Q1152 1847 1152 1920L1152 1920L1024 1920Q1024 1841 994 1771Q964 1701 911.50 1648.50Q859 1596 789 1566Q719 1536 640 1536L640 1536Q560 1536 490.50 1566Q421 1596 368.50 1648.50Q316 1701 286 1771Q256 1841 256 1920L256 1920L128 1920Q128 1847 148 1778.50Q168 1710 205 1650.50Q242 1591 294.50 1542.50Q347 1494 412 1461L412 1461Q338 1406 297 1325Q256 1244 256 1152L256 1152Q256 1073 286 1003Q316 933 368.50 880.50Q421 828 490.50 798Q560 768 640 768L640 768Q732 768 813 809Q894 850 949 924L949 924Q987 849 1046 790Q1105 731 1180 693L1180 693Q1106 638 1065 557Q1024 476 1024 384L1024 384Q1024 305 1054 235Q1084 165 1136.50 112.50Q1189 60 1258.50 30Q1328 0 1408 0L1408 0Q1487 0 1557 30Q1627 60 1679.50 112.50Q1732 165 1762 235Q1792 305 1792 384L1792 384Q1792 476 1751 557Q1710 638 1636 693L1636 693Q1701 726 1753.50 774.50Q1806 823 1843 882.50Q1880 942 1900 1010.50Q1920 1079 1920 1152L1920 1152L1792 1152Q1792 1073 1762 1003Q1732 933 1679.50 880.50Q1627 828 1557 798Q1487 768 1408 768L1408 768Q1328 768 1258.50 798Q1189 828 1136.50 880.50Q1084 933 1054 1003Q1024 1073 1024 1152L1024 1152Q1024 1244 983 1325Q942 1406 868 1461ZM1152 384L1152 384Q1152 437 1172 483.50Q1192 530 1227 565Q1262 600 1308.50 620Q1355 640 1408 640L1408 640Q1461 640 1507.50 620Q1554 600 1589 565Q1624 530 1644 483.50Q1664 437 1664 384L1664 384Q1664 331 1644 284.50Q1624 238 1589 203Q1554 168 1507.50 148Q1461 128 1408 128L1408 128Q1355 128 1308.50 148Q1262 168 1227 203Q1192 238 1172 284.50Q1152 331 1152 384ZM384 1152L384 1152Q384 1205 404 1251.50Q424 1298 459 1333Q494 1368 540.50 1388Q587 1408 640 1408L640 1408Q693 1408 739.50 1388Q786 1368 821 1333Q856 1298 876 1251.50Q896 1205 896 1152L896 1152Q896 1099 876 1052.50Q856 1006 821 971Q786 936 739.50 916Q693 896 640 896L640 896Q587 896 540.50 916Q494 936 459 971Q424 1006 404 1052.50Q384 1099 384 1152ZM1772 1688L1888 2048L1600 1823L1312 2048L1428 1688L1152 1472L1497 1472L1600 1152L1703 1472L2048 1472L1772 1688Z"
         }
      }
   ]
}

var TaskGroupMirrored = {
   name: "TaskGroupMirrored",
   vendor: "UiFabric",
   unicode: 62127,
   value: "",
   charCode: "F2AF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 256L0 256L0 1152L2048 1152L2048 256ZM128 1024L128 384L1920 384L1920 1024L128 1024ZM256 512L256 640L1280 640L1280 512L256 512ZM640 768L640 896L1280 896L1280 768L640 768ZM1408 512L1408 896L1792 896L1792 512L1408 512ZM1536 768L1536 640L1664 640L1664 768L1536 768ZM1792 1408L1792 1280L256 1280L256 1408L1792 1408ZM1536 1664L1536 1536L512 1536L512 1664L1536 1664Z"
         }
      }
   ]
}

var AssessmentGroupTemplate = {
   name: "AssessmentGroupTemplate",
   vendor: "UiFabric",
   unicode: 62129,
   value: "",
   charCode: "F2B1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 512L256 1792L768 1792L768 1920L128 1920L128 0L1920 0L1920 1024L1792 1024L1792 512L256 512ZM256 128L256 384L1792 384L1792 128L256 128ZM1920 1152L2048 1152L2048 2048L896 2048L896 1152L1024 1152L1024 1920L1920 1920L1920 1152ZM1664 1792L1664 1664L1792 1664L1792 1792L1664 1792ZM1792 1408L1792 1536L1664 1536L1664 1408L1792 1408ZM1792 1152L1792 1280L1664 1280L1664 1152L1792 1152ZM1408 1792L1408 1664L1536 1664L1536 1792L1408 1792ZM1536 1408L1536 1536L1408 1536L1408 1408L1536 1408ZM1280 1792L1152 1792L1152 1664L1280 1664L1280 1792Z"
         }
      }
   ]
}

var CommentAdd = {
   name: "CommentAdd",
   vendor: "UiFabric",
   unicode: 62131,
   value: "",
   charCode: "F2B3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1152L1920 1152L1920 256L128 256L128 1408L384 1408L384 1701L677 1408L1152 1408L1152 1536L731 1536L256 2011L256 1536L0 1536L0 128ZM1792 1152L1792 1408L2048 1408L2048 1536L1792 1536L1792 1792L1664 1792L1664 1536L1408 1536L1408 1408L1664 1408L1664 1152L1792 1152Z"
         }
      }
   ]
}

var CommentPrevious = {
   name: "CommentPrevious",
   vendor: "UiFabric",
   unicode: 62133,
   value: "",
   charCode: "F2B5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1152L1920 1152L1920 256L128 256L128 1408L384 1408L384 1701L677 1408L899 1408L835 1472L899 1536L731 1536L256 2011L256 1536L0 1536L0 128ZM1597 1245L1434 1408L2048 1408L2048 1536L1434 1536L1597 1699L1507 1789L1189 1472L1507 1155L1597 1245Z"
         }
      }
   ]
}

var LocaleLanguage = {
   name: "LocaleLanguage",
   vendor: "UiFabric",
   unicode: 62135,
   value: "",
   charCode: "F2B7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M423 1152L601 1152L896 2038L896 2048L765 2048L679 1792L345 1792L259 2048L128 2048L128 2038L423 1152ZM387 1664L637 1664L512 1290L387 1664ZM1143 512L893 512Q896 577 896 640L896 640Q896 672 895.50 704Q895 736 894 768L894 768L768 768L768 896L523 896Q528 928 533.50 960Q539 992 547 1024L547 1024L418 1024Q410 992 405.50 960Q401 928 397 896L397 896L188 896Q208 932 234.50 964Q261 996 291 1024L291 1024L256 1024L211 1114Q110 1023 55 899.50Q0 776 0 640L0 640Q0 552 23 470Q46 388 87.50 317Q129 246 187.50 187.50Q246 129 317 87.50Q388 46 470 23Q552 0 640 0L640 0Q728 0 810 23Q892 46 963 87.50Q1034 129 1092.50 187.50Q1151 246 1192.50 317Q1234 388 1257 470Q1280 552 1280 640L1280 640Q1280 672 1276.50 704Q1273 736 1267 768L1267 768L1143 768Q1160 703 1160 640L1160 640Q1160 577 1143 512L1143 512ZM640 120L640 120Q621 120 605.50 136Q590 152 577.50 177.50Q565 203 556 233.50Q547 264 540.50 293.50Q534 323 530 347.50Q526 372 524 384L524 384L755 384Q753 373 749 348.50Q745 324 738.50 295Q732 266 722.50 235Q713 204 700.50 178.50Q688 153 673 136.50Q658 120 640 120ZM137 768L387 768Q384 704 384 640L384 640Q384 577 387 512L387 512L137 512Q120 577 120 640L120 640Q120 703 137 768L137 768ZM188 384L398 384Q404 326 416 268Q428 210 450 156L450 156Q367 189 299.50 247.50Q232 306 188 384L188 384ZM513 768L767 768Q770 704 770 640L770 640Q770 577 767 512L767 512L513 512Q510 577 510 640L510 640Q510 704 513 768L513 768ZM825 155L825 155Q848 209 861 267Q874 325 881 384L881 384L1092 384Q1047 306 978.50 246.50Q910 187 825 155ZM1391 900L1391 889Q1391 859 1390 828Q1389 797 1382 768L1382 768Q1451 768 1519 774L1519 774Q1525 775 1531.50 777Q1538 779 1538 787L1538 787Q1538 792 1535 799Q1532 806 1530 811L1530 811Q1528 817 1526.50 827Q1525 837 1524.50 848.50Q1524 860 1524 870.50Q1524 881 1524 887L1524 887L1524 900L1820 900Q1862 900 1903.50 899Q1945 898 1987 897L1987 897Q1994 897 2000 900L2000 900Q2003 905 2003 910L2003 910Q2002 927 2001 945.50Q2000 964 2000 981L2000 981L2000 1039Q2000 1075 2001 1111.50Q2002 1148 2003 1184L2003 1184Q2003 1187 2002.50 1191Q2002 1195 2000 1197L2000 1197Q1992 1199 1987 1199L1987 1199Q1982 1199 1962 1199.50Q1942 1200 1921 1200L1921 1200Q1902 1200 1887 1199Q1872 1198 1870 1196L1870 1196Q1868 1188 1867.50 1172Q1867 1156 1867 1136L1867 1136Q1867 1103 1868 1068Q1869 1033 1869 1016L1869 1016L1067 1016Q1067 1020 1067 1030.50Q1067 1041 1067.50 1055.50Q1068 1070 1068 1086.50Q1068 1103 1068 1120L1068 1120Q1068 1149 1067 1172.50Q1066 1196 1064 1198L1064 1198Q1056 1200 1051 1200L1051 1200L949 1200Q938 1200 936 1197Q934 1194 934 1184L934 1184Q935 1144 935 1105Q935 1066 935 1026L935 1026Q935 997 935 968Q935 939 934 910L934 910Q934 905 936 899L936 899Q944 897 949 897L949 897Q991 898 1032.50 899Q1074 900 1116 900L1116 900L1391 900ZM2030 1442L2030 1442Q2032 1450 2032 1455L2032 1455L2032 1551Q2032 1555 2030 1563L2030 1563Q2022 1565 2017 1565L2017 1565Q1977 1564 1938 1563Q1899 1562 1859 1562L1859 1562L1538 1562L1538 1595Q1538 1647 1539 1699Q1540 1751 1542 1803L1542 1803L1542 1807Q1542 1831 1533 1855Q1524 1879 1504 1893L1504 1893Q1490 1903 1464.50 1908.50Q1439 1914 1410 1916.50Q1381 1919 1353.50 1919.50Q1326 1920 1310 1920L1310 1920Q1304 1920 1291 1919.50Q1278 1919 1273 1914L1273 1914Q1270 1911 1266 1898Q1262 1885 1260 1880L1260 1880Q1253 1854 1243.50 1831.50Q1234 1809 1220 1786L1220 1786Q1254 1790 1288 1791.50Q1322 1793 1356 1793L1356 1793Q1380 1793 1392.50 1785.50Q1405 1778 1405 1752L1405 1752L1405 1562L1086 1562Q1046 1562 1006 1563Q966 1564 926 1565L926 1565Q918 1565 914 1562L914 1562Q912 1556 912 1551L912 1551L912 1455Q912 1452 912.50 1447.50Q913 1443 915 1441L915 1441Q921 1439 926 1439L926 1439Q966 1440 1006 1441Q1046 1442 1086 1442L1086 1442L1405 1442Q1403 1416 1402.50 1389.50Q1402 1363 1397 1337L1397 1337Q1417 1339 1436.50 1340.50Q1456 1342 1476 1344L1476 1344Q1478 1344 1479.50 1344.50Q1481 1345 1483 1345L1483 1345Q1518 1320 1550 1292Q1582 1264 1614 1235L1614 1235L1306 1235Q1264 1235 1222.50 1236Q1181 1237 1139 1238L1139 1238Q1131 1238 1127 1235L1127 1235Q1125 1229 1125 1224L1125 1224L1125 1129Q1125 1125 1127 1117L1127 1117Q1135 1115 1139 1115L1139 1115Q1181 1116 1222.50 1117Q1264 1118 1306 1118L1306 1118L1679 1118Q1695 1118 1709 1113.50Q1723 1109 1734 1109L1734 1109Q1742 1109 1757 1121Q1772 1133 1787 1149Q1802 1165 1813.50 1181.50Q1825 1198 1825 1206L1825 1206Q1825 1216 1818.50 1221.50Q1812 1227 1804 1231L1804 1231Q1790 1238 1777 1249Q1764 1260 1752 1270L1752 1270Q1700 1313 1647.50 1353.50Q1595 1394 1538 1431L1538 1431L1538 1442L1859 1442Q1899 1442 1938 1441Q1977 1440 2017 1439L2017 1439Q2024 1439 2030 1442Z"
         }
      }
   ]
}

var UserSync = {
   name: "UserSync",
   vendor: "UiFabric",
   unicode: 62137,
   value: "",
   charCode: "F2B9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1350 1046L1350 1046Q1318 1061 1287.50 1079Q1257 1097 1229 1119L1229 1119Q1154 1072 1069 1048Q984 1024 896 1024L896 1024Q808 1024 726 1047Q644 1070 573 1111.50Q502 1153 443.50 1211.50Q385 1270 343.50 1341Q302 1412 279 1494Q256 1576 256 1664L256 1664L128 1664Q128 1544 163.50 1433Q199 1322 264 1228Q329 1134 420.50 1061Q512 988 624 946L624 946Q511 872 447.50 760Q384 648 384 512L384 512Q384 406 424 312.50Q464 219 533.50 149.50Q603 80 696.50 40Q790 0 896 0L896 0Q1002 0 1095.50 40Q1189 80 1258.50 149.50Q1328 219 1368 312.50Q1408 406 1408 512L1408 512Q1408 578 1391.50 641Q1375 704 1344 760Q1313 816 1268.50 863.50Q1224 911 1168 946L1168 946Q1264 983 1350 1046ZM512 512L512 512Q512 592 542 661.50Q572 731 624.50 783.50Q677 836 746.50 866Q816 896 896 896L896 896Q975 896 1045 866Q1115 836 1167.50 783.50Q1220 731 1250 661.50Q1280 592 1280 512L1280 512Q1280 433 1250 363Q1220 293 1167.50 240.50Q1115 188 1045 158Q975 128 896 128L896 128Q816 128 746.50 158Q677 188 624.50 240.50Q572 293 542 363Q512 433 512 512ZM1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1541 1280 1488.50 1300Q1436 1320 1394 1355.50Q1352 1391 1324 1440Q1296 1489 1286 1547L1286 1547L1159 1525Q1173 1444 1213 1376Q1253 1308 1311.50 1258Q1370 1208 1444 1180Q1518 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289L1920 1289L1920 1152ZM1600 1920L1600 1920Q1658 1920 1711 1900Q1764 1880 1806 1844.50Q1848 1809 1876 1760Q1904 1711 1914 1653L1914 1653L2041 1675Q2027 1756 1987 1824Q1947 1892 1888.50 1942Q1830 1992 1756 2020Q1682 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920Z"
         }
      }
   ]
}

var StreamingOff = {
   name: "StreamingOff",
   vendor: "UiFabric",
   unicode: 62139,
   value: "",
   charCode: "F2BB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1269 1024L1269 1024Q1269 1075 1249.50 1119.50Q1230 1164 1197 1197Q1164 1230 1119.50 1249.50Q1075 1269 1024 1269L1024 1269Q973 1269 928.50 1249.50Q884 1230 851 1197Q818 1164 798.50 1119.50Q779 1075 779 1024L779 1024Q779 973 798.50 928.50Q818 884 851 851Q884 818 928.50 798.50Q973 779 1024 779L1024 779Q1075 779 1119.50 798.50Q1164 818 1197 851Q1230 884 1249.50 928.50Q1269 973 1269 1024ZM1024 1163L1024 1163Q1053 1163 1078.50 1152Q1104 1141 1122.50 1122.50Q1141 1104 1152 1078.50Q1163 1053 1163 1024L1163 1024Q1163 995 1152 969.50Q1141 944 1122.50 925.50Q1104 907 1078.50 896Q1053 885 1024 885L1024 885Q995 885 969.50 896Q944 907 925.50 925.50Q907 944 896 969.50Q885 995 885 1024L885 1024Q885 1053 896 1078.50Q907 1104 925.50 1122.50Q944 1141 969.50 1152Q995 1163 1024 1163ZM308 308L383 383Q319 447 269.50 521Q220 595 186 676.50Q152 758 134.50 845.50Q117 933 117 1024L117 1024Q117 1115 134.50 1202.50Q152 1290 186 1371.50Q220 1453 269.50 1527Q319 1601 383 1665L383 1665L308 1740Q164 1596 87.50 1412Q11 1228 11 1024L11 1024Q11 820 87.50 636Q164 452 308 308L308 308ZM579 579L654 654Q579 729 540 824Q501 919 501 1024L501 1024Q501 1129 540 1224Q579 1319 654 1394L654 1394L579 1469Q490 1379 442.50 1264.50Q395 1150 395 1024L395 1024Q395 898 442.50 783.50Q490 669 579 579L579 579ZM1600 992L1600 992Q1573 992 1546 995L1546 995Q1541 898 1501.50 810.50Q1462 723 1394 654L1394 654L1469 579Q1553 663 1599.50 770Q1646 877 1651 995L1651 995Q1625 992 1600 992ZM1928 1090L1928 1090Q1930 1073 1930 1057Q1930 1041 1930 1025L1930 1025Q1930 935 1912.50 847Q1895 759 1861.50 677.50Q1828 596 1778.50 521.50Q1729 447 1665 383L1665 383L1740 308Q1811 379 1866 462Q1921 545 1958.50 636.50Q1996 728 2015.50 825.50Q2035 923 2035 1024L2035 1024Q2035 1060 2032.50 1096Q2030 1132 2025 1168L2025 1168Q2003 1146 1978.50 1126.50Q1954 1107 1928 1090ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var ArrowTallUpLeft = {
   name: "ArrowTallUpLeft",
   vendor: "UiFabric",
   unicode: 62141,
   value: "",
   charCode: "F2BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2029 1939L1939 2029L128 219L128 1152L0 1152L0 0L1152 0L1152 128L219 128L2029 1939Z"
         }
      }
   ]
}

var ArrowTallDownLeft = {
   name: "ArrowTallDownLeft",
   vendor: "UiFabric",
   unicode: 62143,
   value: "",
   charCode: "F2BF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2029 109L219 1920L1152 1920L1152 2048L0 2048L0 896L128 896L128 1829L1939 19L2029 109Z"
         }
      }
   ]
}

var FieldEmpty = {
   name: "FieldEmpty",
   vendor: "UiFabric",
   unicode: 62145,
   value: "",
   charCode: "F2C1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1664L0 1664L0 256ZM1920 1536L1920 384L128 384L128 1536L1920 1536Z"
         }
      }
   ]
}

var FieldChanged = {
   name: "FieldChanged",
   vendor: "UiFabric",
   unicode: 62147,
   value: "",
   charCode: "F2C3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1025 1408L256 1408L256 512L1792 512L1792 744Q1737 752 1685 776Q1633 800 1594 839L1594 839L1025 1408ZM128 1536L897 1536L846 1588L827 1664L0 1664L0 256L2048 256L2048 796Q2019 777 1986.50 765Q1954 753 1920 746L1920 746L1920 384L128 384L128 1536ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1772 910Q1808 896 1848 896ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836Z"
         }
      }
   ]
}

var RingerOff = {
   name: "RingerOff",
   vendor: "UiFabric",
   unicode: 62149,
   value: "",
   charCode: "F2C5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M996 1664L896 1664Q896 1690 906 1713.50Q916 1737 933 1754.50Q950 1772 973.50 1782Q997 1792 1023 1792L1023 1792Q1046 1857 1080 1913L1080 1913Q1066 1916 1052 1918Q1038 1920 1024 1920L1024 1920Q971 1920 924.50 1900Q878 1880 843 1845Q808 1810 788 1763.50Q768 1717 768 1664L768 1664L256 1664L256 1536L384 1536L384 768Q384 680 407 598Q430 516 471.50 445Q513 374 571.50 315.50Q630 257 701 215.50Q772 174 854 151Q936 128 1024 128L1024 128Q1112 128 1194 151Q1276 174 1347 215.50Q1418 257 1476.50 315.50Q1535 374 1576.50 445Q1618 516 1641 598Q1664 680 1664 768L1664 768L1664 996Q1648 994 1632 993Q1616 992 1600 992L1600 992Q1584 992 1568 993Q1552 994 1536 996L1536 996L1536 768Q1536 662 1495.50 569Q1455 476 1385.50 406.50Q1316 337 1223 296.50Q1130 256 1024 256L1024 256Q918 256 825 296.50Q732 337 662.50 406.50Q593 476 552.50 569Q512 662 512 768L512 768L512 1536L996 1536Q994 1552 993 1568Q992 1584 992 1600L992 1600Q992 1616 993 1632Q994 1648 996 1664L996 1664ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var BulletedList2 = {
   name: "BulletedList2",
   vendor: "UiFabric",
   unicode: 62151,
   value: "",
   charCode: "F2C7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 384L2048 384L2048 512L512 512L512 384ZM512 1024L512 896L2048 896L2048 1024L512 1024ZM512 1536L512 1408L2048 1408L2048 1536L512 1536ZM0 640L0 256L384 256L384 640L0 640ZM128 384L128 512L256 512L256 384L128 384ZM0 1152L0 768L384 768L384 1152L0 1152ZM128 896L128 1024L256 1024L256 896L128 896ZM0 1664L0 1280L384 1280L384 1664L0 1664ZM128 1408L128 1536L256 1536L256 1408L128 1408Z"
         }
      }
   ]
}

var ImageCrosshair = {
   name: "ImageCrosshair",
   vendor: "UiFabric",
   unicode: 62153,
   value: "",
   charCode: "F2C9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M832 1126L1088 870L1280 1061L1280 1243L1088 1050L922 1216L987 1280L805 1280L320 794L128 987L128 1536L768 1536L768 1664L0 1664L0 256L1792 256L1792 1280L1664 1280L1664 384L128 384L128 805L320 614L832 1126ZM1472 512L1472 512Q1498 512 1517 531Q1536 550 1536 576L1536 576Q1536 602 1517 621Q1498 640 1472 640L1472 640Q1446 640 1427 621Q1408 602 1408 576L1408 576Q1408 550 1427 531Q1446 512 1472 512ZM1408 1280L1408 896L1536 896L1536 1280L1408 1280ZM1408 2048L1408 1664L1536 1664L1536 2048L1408 2048ZM896 1536L896 1408L1280 1408L1280 1536L896 1536ZM1664 1408L2048 1408L2048 1536L1664 1536L1664 1408Z"
         }
      }
   ]
}

var Repo = {
   name: "Repo",
   vendor: "UiFabric",
   unicode: 62155,
   value: "",
   charCode: "F2CB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 128L2048 768L1920 768L1920 1920L128 1920L128 768L0 768L0 128L2048 128ZM1792 1792L1792 768L1280 768L1280 1536L1024 1408L768 1536L768 768L256 768L256 1792L1792 1792ZM896 768L896 1329Q928 1313 960 1297.50Q992 1282 1024 1265L1024 1265Q1056 1282 1088 1297.50Q1120 1313 1152 1329L1152 1329L1152 768L896 768ZM1920 640L1920 256L128 256L128 640L1920 640Z"
         }
      }
   ]
}

var FolderQuery = {
   name: "FolderQuery",
   vendor: "UiFabric",
   unicode: 62157,
   value: "",
   charCode: "F2CD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 1024L1920 1024L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L768 1664L768 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM1280 1408L1280 1152L2048 1152L2048 1792L1664 1792L1664 2048L896 2048L896 1408L1280 1408ZM1536 1920L1536 1792L1280 1792L1280 1536L1024 1536L1024 1920L1536 1920ZM1536 1664L1536 1536L1408 1536L1408 1664L1536 1664ZM1920 1280L1408 1280L1408 1408L1664 1408L1664 1664L1920 1664L1920 1280Z"
         }
      }
   ]
}

var FolderListMirrored = {
   name: "FolderListMirrored",
   vendor: "UiFabric",
   unicode: 62159,
   value: "",
   charCode: "F2CF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 1280L1920 1280L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L1024 1664L1024 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM1152 2048L1152 1920L1792 1920L1792 2048L1152 2048ZM1920 2048L1920 1920L2048 1920L2048 2048L1920 2048ZM1920 1792L1920 1664L2048 1664L2048 1792L1920 1792ZM1152 1792L1152 1664L1792 1664L1792 1792L1152 1792ZM1920 1536L1920 1408L2048 1408L2048 1536L1920 1536ZM1152 1536L1152 1408L1792 1408L1792 1536L1152 1536Z"
         }
      }
   ]
}

var POISolid = {
   name: "POISolid",
   vendor: "UiFabric",
   unicode: 62161,
   value: "",
   charCode: "F2D1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1112 0 1194 23Q1276 46 1347 87.50Q1418 129 1476.50 187.50Q1535 246 1576.50 317Q1618 388 1641 470Q1664 552 1664 640L1664 640Q1664 709 1647.50 771.50Q1631 834 1600 896L1600 896L1024 2048L448 896Q417 834 400.50 771.50Q384 709 384 640L384 640Q384 552 407 470Q430 388 471.50 317Q513 246 571.50 187.50Q630 129 701 87.50Q772 46 854 23Q936 0 1024 0ZM1024 896L1024 896Q1077 896 1123.50 876Q1170 856 1205 821Q1240 786 1260 739.50Q1280 693 1280 640L1280 640Q1280 587 1260 540.50Q1240 494 1205 459Q1170 424 1123.50 404Q1077 384 1024 384L1024 384Q971 384 924.50 404Q878 424 843 459Q808 494 788 540.50Q768 587 768 640L768 640Q768 693 788 739.50Q808 786 843 821Q878 856 924.50 876Q971 896 1024 896Z"
         }
      }
   ]
}

var BoxSubtractSolid = {
   name: "BoxSubtractSolid",
   vendor: "UiFabric",
   unicode: 62163,
   value: "",
   charCode: "F2D3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1920 0L1920 1920L0 1920L0 0ZM1536 1024L1536 896L384 896L384 1024L1536 1024Z"
         }
      }
   ]
}

var BoxMultiplySolid = {
   name: "BoxMultiplySolid",
   vendor: "UiFabric",
   unicode: 62165,
   value: "",
   charCode: "F2D5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1920 0L1920 1920L0 1920L0 0ZM1415 1302L1073 960L1415 618L1302 505L960 847L618 505L505 618L847 960L505 1302L618 1415L960 1073L1302 1415L1415 1302Z"
         }
      }
   ]
}

var BoxCheckmarkSolid = {
   name: "BoxCheckmarkSolid",
   vendor: "UiFabric",
   unicode: 62167,
   value: "",
   charCode: "F2D7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1920 0L1920 1920L0 1920L0 0ZM768 1416L1562 621L1427 486L768 1144L493 870L358 1005L768 1416Z"
         }
      }
   ]
}

var CirclePause = {
   name: "CirclePause",
   vendor: "UiFabric",
   unicode: 62169,
   value: "",
   charCode: "F2D9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1148 1920 1262.50 1888Q1377 1856 1476.50 1797.50Q1576 1739 1657.50 1657.50Q1739 1576 1797.50 1476.50Q1856 1377 1888 1262.50Q1920 1148 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q900 128 785.50 160Q671 192 571.50 250.50Q472 309 390.50 390.50Q309 472 250.50 571.50Q192 671 160 785.50Q128 900 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250.50 1476.50Q309 1576 390.50 1657.50Q472 1739 571.50 1797.50Q671 1856 785.50 1888Q900 1920 1024 1920ZM1152 1408L1152 640L1280 640L1280 1408L1152 1408ZM768 1408L768 640L896 640L896 1408L768 1408Z"
         }
      }
   ]
}

var CircleStopSolid = {
   name: "CircleStopSolid",
   vendor: "UiFabric",
   unicode: 62171,
   value: "",
   charCode: "F2DB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1408 1408L1408 640L640 640L640 1408L1408 1408Z"
         }
      }
   ]
}

var NavigateBack = {
   name: "NavigateBack",
   vendor: "UiFabric",
   unicode: 62173,
   value: "",
   charCode: "F2DD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1093 0 1215.50 34Q1338 68 1445 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 475Q1852 582 1886 704.50Q1920 827 1920 960L1920 960Q1920 1093 1886 1215.50Q1852 1338 1789.50 1445Q1727 1552 1639.50 1639.50Q1552 1727 1445 1789.50Q1338 1852 1215.50 1886Q1093 1920 960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0ZM960 1792L960 1792Q1075 1792 1181 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM1005 622L727 896L1408 896L1408 1024L727 1024L1005 1298L915 1390L481 960L915 530L1005 622Z"
         }
      }
   ]
}

var NavigateForward = {
   name: "NavigateForward",
   vendor: "UiFabric",
   unicode: 62175,
   value: "",
   charCode: "F2DF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1093 0 1215.50 34Q1338 68 1445 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 475Q1852 582 1886 704.50Q1920 827 1920 960L1920 960Q1920 1093 1886 1215.50Q1852 1338 1789.50 1445Q1727 1552 1639.50 1639.50Q1552 1727 1445 1789.50Q1338 1852 1215.50 1886Q1093 1920 960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0ZM960 1792L960 1792Q1075 1792 1181 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM1193 896L915 622L1005 530L1439 960L1005 1390L915 1298L1193 1024L512 1024L512 896L1193 896Z"
         }
      }
   ]
}

var UnknownSolid = {
   name: "UnknownSolid",
   vendor: "UiFabric",
   unicode: 62177,
   value: "",
   charCode: "F2E1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1215Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q828 1920 705 1885.50Q582 1851 475.50 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444.50Q69 1338 34.50 1215.50Q0 1093 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 704.50 34.50Q827 0 960 0ZM1024 1536L1024 1408L896 1408L896 1536L1024 1536ZM1032 1280L1032 1239Q1032 1202 1039 1169Q1046 1136 1075 1107L1075 1107Q1114 1068 1152 1032.50Q1190 997 1220.50 958Q1251 919 1269.50 873Q1288 827 1288 768L1288 768Q1288 700 1262 640.50Q1236 581 1191.50 536.50Q1147 492 1087.50 466Q1028 440 960 440L960 440Q892 440 832.50 466Q773 492 728.50 536.50Q684 581 658 640.50Q632 700 632 768L632 768L776 768Q776 730 790.50 696.50Q805 663 830 638Q855 613 888.50 598.50Q922 584 960 584L960 584Q998 584 1031.50 598.50Q1065 613 1090 638Q1115 663 1129.50 696.50Q1144 730 1144 768L1144 768Q1144 809 1125 841Q1106 873 1077.50 902.50Q1049 932 1016 962Q983 992 954.50 1028Q926 1064 907 1109.50Q888 1155 888 1216L888 1216L888 1280L1032 1280Z"
         }
      }
   ]
}

var CircleAddition = {
   name: "CircleAddition",
   vendor: "UiFabric",
   unicode: 62179,
   value: "",
   charCode: "F2E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1093 0 1215.50 34Q1338 68 1445 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 475Q1852 582 1886 704.50Q1920 827 1920 960L1920 960Q1920 1093 1886 1215.50Q1852 1338 1789.50 1445Q1727 1552 1639.50 1639.50Q1552 1727 1445 1789.50Q1338 1852 1215.50 1886Q1093 1920 960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0ZM960 1792L960 1792Q1075 1792 1181 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM1024 384L1024 896L1536 896L1536 1024L1024 1024L1024 1536L896 1536L896 1024L384 1024L384 896L896 896L896 384L1024 384Z"
         }
      }
   ]
}

var FilePDB = {
   name: "FilePDB",
   vendor: "UiFabric",
   unicode: 62181,
   value: "",
   charCode: "F2E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L1152 1920L1152 2048L128 2048L128 0L1243 0L1792 549L1792 1024L1664 1024L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152Z"
         }
      }
   ]
}

var FileSQL = {
   name: "FileSQL",
   vendor: "UiFabric",
   unicode: 62183,
   value: "",
   charCode: "F2E7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L384 1920L384 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1280L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM675 1558L675 1558Q675 1584 694.50 1602.50Q714 1621 742.50 1637Q771 1653 805 1669Q839 1685 867.50 1706.50Q896 1728 915.50 1757.50Q935 1787 935 1829L935 1829Q935 1874 916.50 1903.50Q898 1933 868 1950.50Q838 1968 800.50 1975Q763 1982 726 1982L726 1982Q711 1982 691 1980Q671 1978 650.50 1974.50Q630 1971 611 1965Q592 1959 579 1951L579 1951L579 1856Q591 1868 609 1877.50Q627 1887 646.50 1893Q666 1899 686 1902.50Q706 1906 723 1906L723 1906Q742 1906 762 1903.50Q782 1901 799 1892.50Q816 1884 827 1869.50Q838 1855 838 1831L838 1831Q838 1804 818.50 1785.50Q799 1767 770.50 1751.50Q742 1736 708 1720.50Q674 1705 645.50 1684Q617 1663 597.50 1633.50Q578 1604 578 1561L578 1561Q578 1520 597 1491Q616 1462 646 1443.50Q676 1425 712.50 1416.50Q749 1408 784 1408L784 1408Q814 1408 849 1411.50Q884 1415 911 1428L911 1428L911 1519Q885 1500 853 1492.50Q821 1485 789 1485L789 1485Q772 1485 752 1488.50Q732 1492 715 1500Q698 1508 686.50 1522Q675 1536 675 1558ZM1535 1688L1535 1688Q1535 1723 1529.50 1757Q1524 1791 1511 1822.50Q1498 1854 1478 1882Q1458 1910 1430 1932L1430 1932L1591 2048L1451 2048L1351 1971Q1329 1976 1308.50 1979Q1288 1982 1266 1982L1266 1982Q1204 1982 1154.50 1961Q1105 1940 1071 1902.50Q1037 1865 1019 1813.50Q1001 1762 1001 1702L1001 1702Q1001 1639 1019 1585Q1037 1531 1072 1491.50Q1107 1452 1158 1430Q1209 1408 1275 1408L1275 1408Q1336 1408 1384.50 1430Q1433 1452 1466.50 1489.50Q1500 1527 1517.50 1578.50Q1535 1630 1535 1688ZM1266 1902L1266 1902Q1312 1902 1344.50 1885.50Q1377 1869 1398 1841Q1419 1813 1428.50 1775.50Q1438 1738 1438 1697L1438 1697Q1438 1657 1429 1619Q1420 1581 1400 1552.50Q1380 1524 1348 1506.50Q1316 1489 1270 1489L1270 1489Q1226 1489 1194 1506.50Q1162 1524 1140.50 1553Q1119 1582 1108.50 1619.50Q1098 1657 1098 1696L1098 1696Q1098 1735 1108 1772Q1118 1809 1138.50 1838Q1159 1867 1190.50 1884.50Q1222 1902 1266 1902ZM1729 1895L1945 1895L1945 1973L1637 1973L1637 1417L1729 1417L1729 1895Z"
         }
      }
   ]
}

var FileASPX = {
   name: "FileASPX",
   vendor: "UiFabric",
   unicode: 62185,
   value: "",
   charCode: "F2E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L768 1920L768 2048L128 2048L128 0L1243 0L1792 549L1792 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM1408 768L1408 768Q1541 768 1657.50 818Q1774 868 1861 955Q1948 1042 1998 1158.50Q2048 1275 2048 1408L2048 1408Q2048 1541 1998 1657.50Q1948 1774 1861 1861Q1774 1948 1657.50 1998Q1541 2048 1408 2048L1408 2048Q1275 2048 1158.50 1998Q1042 1948 955 1861Q868 1774 818 1657.50Q768 1541 768 1408L768 1408Q768 1275 818 1158.50Q868 1042 955 955Q1042 868 1158.50 818Q1275 768 1408 768ZM1408 1920L1408 1920Q1429 1920 1445 1905.50Q1461 1891 1473.50 1867.50Q1486 1844 1494.50 1815Q1503 1786 1509 1757.50Q1515 1729 1518.50 1704.50Q1522 1680 1524 1664L1524 1664L1294 1664Q1296 1678 1299.50 1703Q1303 1728 1309.50 1756.50Q1316 1785 1325 1814Q1334 1843 1346 1866.50Q1358 1890 1373.50 1905Q1389 1920 1408 1920ZM1283 1536L1534 1536Q1535 1504 1535.50 1472Q1536 1440 1536 1408L1536 1408Q1536 1345 1533 1280L1533 1280L1283 1280Q1280 1345 1280 1408L1280 1408Q1280 1472 1283 1536L1283 1536ZM896 1408L896 1408Q896 1440 900 1472Q904 1504 912 1536L912 1536L1155 1536Q1152 1472 1152 1408L1152 1408Q1152 1345 1155 1280L1155 1280L912 1280Q904 1312 900 1344Q896 1376 896 1408ZM1408 896L1408 896Q1389 896 1374 911Q1359 926 1347 950Q1335 974 1326 1003Q1317 1032 1311 1060.50Q1305 1089 1301 1113.50Q1297 1138 1295 1152L1295 1152L1520 1152Q1518 1139 1514 1114.50Q1510 1090 1503 1061.50Q1496 1033 1487 1003.50Q1478 974 1466.50 950Q1455 926 1440 911Q1425 896 1408 896ZM1904 1280L1661 1280Q1664 1345 1664 1408L1664 1408Q1664 1440 1663.50 1472Q1663 1504 1662 1536L1662 1536L1904 1536Q1912 1504 1916 1472Q1920 1440 1920 1408L1920 1408Q1920 1376 1916 1344Q1912 1312 1904 1280L1904 1280ZM1649 1152L1851 1152Q1808 1077 1743 1021Q1678 965 1598 933L1598 933Q1619 985 1630.50 1040.50Q1642 1096 1649 1152L1649 1152ZM1214 934L1214 934Q1136 966 1071.50 1022Q1007 1078 965 1152L965 1152L1165 1152Q1178 1041 1214 934ZM1165 1664L965 1664Q1007 1737 1071 1793Q1135 1849 1213 1881L1213 1881Q1192 1830 1181.50 1774.50Q1171 1719 1165 1664L1165 1664ZM1607 1879L1607 1879Q1684 1847 1746.50 1791.50Q1809 1736 1851 1664L1851 1664L1653 1664Q1648 1715 1637.50 1773.50Q1627 1832 1607 1879Z"
         }
      }
   ]
}

var FileSass = {
   name: "FileSass",
   vendor: "UiFabric",
   unicode: 62187,
   value: "",
   charCode: "F2EB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 2048L128 2048L128 0L1243 0L1792 549L1792 1408L1664 1408L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM512 256L512 384L384 384L384 256L512 256ZM512 512L512 640L384 640L384 512L512 512ZM384 896L384 768L512 768L512 896L384 896ZM486 1575L486 1575Q486 1596 494 1611Q502 1626 519 1639L519 1639Q540 1656 566 1666.50Q592 1677 615 1689L615 1689Q644 1704 672.50 1721.50Q701 1739 723.50 1761.50Q746 1784 760 1812.50Q774 1841 774 1877L774 1877Q774 1927 753.50 1959.50Q733 1992 700 2012Q667 2032 625.50 2040Q584 2048 542 2048L542 2048Q526 2048 503.50 2046Q481 2044 457 2039.50Q433 2035 412 2028.50Q391 2022 378 2013L378 2013L378 1907Q391 1920 411 1930Q431 1940 453.50 1947.50Q476 1955 498 1959Q520 1963 538 1963L538 1963Q559 1963 582 1960Q605 1957 623.50 1948Q642 1939 654.50 1922.50Q667 1906 667 1879L667 1879Q667 1849 645.50 1828.50Q624 1808 592 1790.50Q560 1773 522.50 1756Q485 1739 453 1715.50Q421 1692 399.50 1659Q378 1626 378 1578L378 1578Q378 1532 399 1499.50Q420 1467 453 1447Q486 1427 526.50 1417.50Q567 1408 606 1408L606 1408Q638 1408 678.50 1411.50Q719 1415 748 1430L748 1430L748 1531Q718 1510 683 1502Q648 1494 612 1494L612 1494Q593 1494 571 1497.50Q549 1501 530 1510Q511 1519 498.50 1535Q486 1551 486 1575ZM1044 1568L1044 1568Q1130 1568 1174 1610Q1218 1652 1218 1739L1218 1739L1218 2037L1116 2037L1116 1966Q1069 2048 976 2048L976 2048Q913 2048 872.50 2014Q832 1980 832 1914L832 1914Q832 1878 843 1851.50Q854 1825 873.50 1807Q893 1789 921 1778.50Q949 1768 982 1763L982 1763L1118 1743Q1118 1696 1095.50 1670.50Q1073 1645 1025 1645L1025 1645Q983 1645 946 1660Q909 1675 877 1702L877 1702L877 1611Q915 1588 957.50 1578Q1000 1568 1044 1568ZM1118 1852L1118 1812L1021 1825Q983 1830 957 1845Q931 1860 931 1903L931 1903Q931 1937 954 1953Q977 1969 1008 1969L1008 1969Q1033 1969 1053 1959.50Q1073 1950 1087.50 1934.50Q1102 1919 1110 1897.50Q1118 1876 1118 1852L1118 1852ZM1448 1700L1448 1700Q1448 1722 1464.50 1735Q1481 1748 1505.50 1758.50Q1530 1769 1559 1779.50Q1588 1790 1612.50 1806Q1637 1822 1653.50 1847Q1670 1872 1670 1911L1670 1911Q1670 1949 1651 1975.50Q1632 2002 1603.50 2018Q1575 2034 1540 2041Q1505 2048 1474 2048L1474 2048Q1441 2048 1408 2042.50Q1375 2037 1344 2023L1344 2023L1344 1927Q1373 1948 1405.50 1959.50Q1438 1971 1473 1971L1473 1971Q1487 1971 1503.50 1969Q1520 1967 1534 1961Q1548 1955 1557.50 1944Q1567 1933 1567 1915L1567 1915Q1567 1893 1550.50 1879.50Q1534 1866 1509 1856Q1484 1846 1455.50 1835.50Q1427 1825 1402 1809Q1377 1793 1360.50 1768Q1344 1743 1344 1704L1344 1704Q1344 1668 1361.50 1642Q1379 1616 1406.50 1599.50Q1434 1583 1467 1575.50Q1500 1568 1531 1568L1531 1568Q1592 1568 1645 1587L1645 1587L1645 1678Q1595 1645 1534 1645L1534 1645Q1521 1645 1506 1647.50Q1491 1650 1478 1656.50Q1465 1663 1456.50 1673.50Q1448 1684 1448 1700ZM1826 1700L1826 1700Q1826 1722 1842.50 1735Q1859 1748 1883.50 1758.50Q1908 1769 1937 1779.50Q1966 1790 1990.50 1806Q2015 1822 2031.50 1847Q2048 1872 2048 1911L2048 1911Q2048 1950 2029.50 1976Q2011 2002 1982.50 2018Q1954 2034 1919.50 2041Q1885 2048 1853 2048L1853 2048Q1820 2048 1786.50 2042.50Q1753 2037 1723 2023L1723 2023L1723 1927Q1751 1948 1783.50 1959.50Q1816 1971 1851 1971L1851 1971Q1865 1971 1881.50 1969Q1898 1967 1912 1961Q1926 1955 1935.50 1944Q1945 1933 1945 1915L1945 1915Q1945 1893 1928.50 1879.50Q1912 1866 1887.50 1856Q1863 1846 1834 1835.50Q1805 1825 1780.50 1809Q1756 1793 1739.50 1768.50Q1723 1744 1723 1704L1723 1704Q1723 1668 1740.50 1642Q1758 1616 1785.50 1599.50Q1813 1583 1846 1575.50Q1879 1568 1910 1568L1910 1568Q1970 1568 2024 1587L2024 1587L2024 1678Q1974 1645 1913 1645L1913 1645Q1901 1645 1885.50 1647.50Q1870 1650 1857 1656.50Q1844 1663 1835 1673.50Q1826 1684 1826 1700Z"
         }
      }
   ]
}

var FileHTML = {
   name: "FileHTML",
   vendor: "UiFabric",
   unicode: 62189,
   value: "",
   charCode: "F2ED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L512 1920L512 2048L128 2048L128 0L1243 0L1755 512L1792 512L1792 1280L1664 1280L1664 640L1152 640L1152 128L256 128ZM1280 512L1573 512L1280 219L1280 512ZM787 1427L877 1517L666 1728L877 1939L787 2029L486 1728L787 1427ZM1216 1536L1216 1536Q1256 1536 1291 1551Q1326 1566 1352 1592Q1378 1618 1393 1653Q1408 1688 1408 1728L1408 1728Q1408 1768 1393 1803Q1378 1838 1352 1864Q1326 1890 1291 1905Q1256 1920 1216 1920L1216 1920Q1176 1920 1141 1905Q1106 1890 1080 1864Q1054 1838 1039 1803Q1024 1768 1024 1728L1024 1728Q1024 1688 1039 1653Q1054 1618 1080 1592Q1106 1566 1141 1551Q1176 1536 1216 1536ZM1645 1427L1946 1728L1645 2029L1555 1939L1766 1728L1555 1517L1645 1427Z"
         }
      }
   ]
}

var CSharpLanguage = {
   name: "CSharpLanguage",
   vendor: "UiFabric",
   unicode: 62191,
   value: "",
   charCode: "F2EF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1047L0 1047Q0 906 44.50 784.50Q89 663 171 574Q253 485 370 434.50Q487 384 632 384L632 384Q706 384 780.50 394.50Q855 405 924 435L924 435L924 590Q856 552 782.50 533.50Q709 515 631 515L631 515Q515 515 425.50 555.50Q336 596 275.50 667Q215 738 183.50 833.50Q152 929 152 1039L152 1039Q152 1143 181 1233Q210 1323 267 1390Q324 1457 407.50 1495.50Q491 1534 601 1534L601 1534Q687 1534 768.50 1515Q850 1496 924 1451L924 1451L924 1592Q845 1634 757.50 1649Q670 1664 582 1664L582 1664Q444 1664 336 1617.50Q228 1571 153 1488.50Q78 1406 39 1293Q0 1180 0 1047ZM2018 830L1789 830L1733 1094L1980 1094L1956 1187L1715 1187L1637 1536L1527 1536L1602 1187L1383 1187L1309 1536L1199 1536L1273 1187L1042 1187L1060 1094L1293 1094L1347 830L1103 830L1121 737L1365 737L1439 384L1550 384L1476 737L1697 737L1773 384L1881 384L1807 737L2038 737L2018 830ZM1623 1094L1680 830L1458 830L1400 1094L1623 1094Z"
         }
      }
   ]
}

var VisualBasicLanguage = {
   name: "VisualBasicLanguage",
   vendor: "UiFabric",
   unicode: 62193,
   value: "",
   charCode: "F2F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M543 1512L543 1512Q552 1454 572 1397L572 1397L929 384L1088 384L621 1664L458 1664L0 384L165 384L514 1399Q524 1427 530.50 1455Q537 1483 543 1512ZM1763 980L1763 984Q1827 992 1880 1016.50Q1933 1041 1970 1081.50Q2007 1122 2027.50 1176Q2048 1230 2048 1296L2048 1296Q2048 1385 2014 1453.50Q1980 1522 1923 1568.50Q1866 1615 1791 1639.50Q1716 1664 1633 1664L1633 1664L1260 1664L1260 384L1624 384Q1693 384 1757.50 401Q1822 418 1872.50 453.50Q1923 489 1953.50 544.50Q1984 600 1984 677L1984 677Q1984 787 1926 867Q1868 947 1763 980L1763 980ZM1410 520L1410 933L1563 933Q1618 933 1666 920Q1714 907 1750 879.50Q1786 852 1806.50 809Q1827 766 1827 706L1827 706Q1827 651 1806.50 615Q1786 579 1752.50 558Q1719 537 1674.50 528.50Q1630 520 1582 520L1582 520L1410 520ZM1410 1528L1613 1528Q1669 1528 1719.50 1515Q1770 1502 1808 1474Q1846 1446 1868.50 1402Q1891 1358 1891 1295L1891 1295Q1891 1226 1864.50 1182Q1838 1138 1795 1112.50Q1752 1087 1696 1077.50Q1640 1068 1582 1068L1582 1068L1410 1068L1410 1528Z"
         }
      }
   ]
}

var CPlusPlusLanguage = {
   name: "CPlusPlusLanguage",
   vendor: "UiFabric",
   unicode: 62195,
   value: "",
   charCode: "F2F3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1280L1920 1408L1408 1408L1408 1920L1280 1920L1280 1408L768 1408L768 1280L1280 1280L1280 768L1408 768L1408 1280L1920 1280ZM1152 640L640 640L640 1152L512 1152L512 640L0 640L0 512L512 512L512 0L640 0L640 512L1152 512L1152 640Z"
         }
      }
   ]
}

var FSharpLanguage = {
   name: "FSharpLanguage",
   vendor: "UiFabric",
   unicode: 62197,
   value: "",
   charCode: "F2F5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M144 1664L144 384L794 384L794 520L294 520L294 962L757 962L757 1097L294 1097L294 1664L144 1664ZM1890 830L1661 830L1605 1094L1852 1094L1828 1187L1587 1187L1509 1536L1399 1536L1474 1187L1254 1187L1181 1536L1071 1536L1145 1187L914 1187L932 1094L1165 1094L1218 830L975 830L993 737L1237 737L1311 384L1422 384L1348 737L1569 737L1645 384L1753 384L1679 737L1910 737L1890 830ZM1495 1094L1552 830L1330 830L1272 1094L1495 1094Z"
         }
      }
   ]
}

var TypeScriptLanguage = {
   name: "TypeScriptLanguage",
   vendor: "UiFabric",
   unicode: 62199,
   value: "",
   charCode: "F2F7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M154 520L154 384L1042 384L1042 520L673 520L673 1664L523 1664L523 520L154 520ZM1298 702L1298 702Q1298 748 1315.50 783Q1333 818 1368 847L1368 847Q1412 883 1464 909.50Q1516 936 1567 961L1567 961Q1624 990 1682.50 1024Q1741 1058 1788.50 1102Q1836 1146 1865.50 1202Q1895 1258 1895 1331L1895 1331Q1895 1427 1856.50 1491Q1818 1555 1756 1593.50Q1694 1632 1614.50 1648Q1535 1664 1454 1664L1454 1664Q1423 1664 1380.50 1659Q1338 1654 1294 1645Q1250 1636 1210 1623Q1170 1610 1144 1593L1144 1593L1144 1422Q1173 1448 1214 1468.50Q1255 1489 1301 1503.50Q1347 1518 1393 1526Q1439 1534 1477 1534L1477 1534Q1526 1534 1573.50 1526Q1621 1518 1658.50 1496Q1696 1474 1719.50 1437Q1743 1400 1743 1341L1743 1341Q1743 1289 1717.50 1249.50Q1692 1210 1650 1178Q1608 1146 1554 1118.50Q1500 1091 1444.50 1063Q1389 1035 1335 1003Q1281 971 1239 930.50Q1197 890 1171.50 837.50Q1146 785 1146 715L1146 715Q1146 627 1184.50 564.50Q1223 502 1284.50 462Q1346 422 1423 403Q1500 384 1576 384L1576 384Q1606 384 1641.50 385.50Q1677 387 1712.50 391.50Q1748 396 1781.50 405Q1815 414 1843 428L1843 428L1843 591Q1781 549 1708.50 532Q1636 515 1562 515L1562 515Q1518 515 1471.50 524.50Q1425 534 1386.50 555.50Q1348 577 1323 613Q1298 649 1298 702Z"
         }
      }
   ]
}

var PY = {
   name: "PY",
   vendor: "UiFabric",
   unicode: 62201,
   value: "",
   charCode: "F2F9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1801 1801L1801 247L247 247L247 1801L1801 1801ZM602 1374L602 1664L512 1664L512 896L723 896Q778 896 825.50 909.50Q873 923 908 950.50Q943 978 962.50 1021.50Q982 1065 982 1125L982 1125Q982 1186 960 1232.50Q938 1279 899.50 1310.50Q861 1342 810.50 1358Q760 1374 703 1374L703 1374L602 1374ZM602 977L602 1292L696 1292Q736 1292 771 1283.50Q806 1275 832 1255.50Q858 1236 872.50 1205Q887 1174 887 1129L887 1129Q887 1087 873.50 1058Q860 1029 836 1011Q812 993 779 985Q746 977 707 977L707 977L602 977ZM1282 1664L1282 1382L1035 896L1137 896L1309 1243Q1315 1254 1319.50 1266Q1324 1278 1330 1290L1330 1290Q1333 1277 1338.50 1265.50Q1344 1254 1350 1243L1350 1243L1530 896L1625 896L1372 1380L1372 1664L1282 1664Z"
         }
      }
   ]
}

var MarkDownLanguage = {
   name: "MarkDownLanguage",
   vendor: "UiFabric",
   unicode: 62203,
   value: "",
   charCode: "F2FB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M637 1430L643 1430Q657 1390 671.50 1350.50Q686 1311 703 1273L703 1273L1096 384L1280 384L1280 1664L1134 1664L1134 805Q1134 742 1137 680.50Q1140 619 1143 556L1143 556Q1135 587 1126.50 619Q1118 651 1105 680L1105 680L676 1664L604 1664L176 688Q162 657 153.50 623Q145 589 135 556L135 556Q140 619 141 681.50Q142 744 142 807L142 807L142 1664L0 1664L0 384L194 384L580 1277Q596 1314 612 1352.50Q628 1391 637 1430L637 1430ZM1939 1299L2029 1389L1728 1690L1427 1389L1517 1299L1664 1445L1664 384L1792 384L1792 1445L1939 1299Z"
         }
      }
   ]
}

var FullWidthEdit = {
   name: "FullWidthEdit",
   vendor: "UiFabric",
   unicode: 62207,
   value: "",
   charCode: "F2FF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 796Q1990 759 1920 745L1920 745L1920 384L1536 384L1536 640L1408 640L1408 384L640 384L640 640L512 640L512 384L128 384L128 1664L512 1664L512 1536L640 1536L640 1664L768 1664L768 1792L0 1792L0 256ZM640 768L640 1024L512 1024L512 768L640 768ZM512 1408L512 1152L640 1152L640 1408L512 1408ZM1408 768L1536 768L1536 1024L1408 1024L1408 768ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838Z"
         }
      }
   ]
}

var PlugSolid = {
   name: "PlugSolid",
   vendor: "UiFabric",
   unicode: 62209,
   value: "",
   charCode: "F301",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 384L1408 384L1408 832Q1408 916 1379 991Q1350 1066 1298.50 1125Q1247 1184 1176.50 1223.50Q1106 1263 1024 1275L1024 1275L1024 2048L896 2048L896 1275Q813 1263 743 1223.50Q673 1184 621.50 1125Q570 1066 541 991Q512 916 512 832L512 832L512 384L640 384L640 0L768 0L768 384L1152 384L1152 0L1280 0L1280 384Z"
         }
      }
   ]
}

var PlugDisconnected = {
   name: "PlugDisconnected",
   vendor: "UiFabric",
   unicode: 62211,
   value: "",
   charCode: "F303",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1210 1110L1300 1201L1029 1472L1119 1562L893 1789Q830 1852 747.50 1886Q665 1920 576 1920L576 1920Q503 1920 434.50 1897.50Q366 1875 308 1831L308 1831L109 2029L19 1939L217 1740Q173 1682 150.50 1613.50Q128 1545 128 1472L128 1472Q128 1383 162 1300.50Q196 1218 259 1155L259 1155L486 929L576 1019L847 748L938 838L666 1110L938 1382L1210 1110ZM576 1792L576 1792Q640 1792 698.50 1767.50Q757 1743 802 1698L802 1698L938 1562L486 1110L350 1246Q305 1291 280.50 1349.50Q256 1408 256 1472L256 1472Q256 1538 281 1596.50Q306 1655 349.50 1698.50Q393 1742 451.50 1767Q510 1792 576 1792ZM2029 109L1831 308Q1875 366 1897.50 434.50Q1920 503 1920 576L1920 576Q1920 665 1886 747.50Q1852 830 1789 893L1789 893L1562 1119L929 486L1155 259Q1218 196 1300.50 162Q1383 128 1472 128L1472 128Q1545 128 1613.50 150.50Q1682 173 1740 217L1740 217L1939 19L2029 109ZM1562 938L1698 802Q1743 757 1767.50 698.50Q1792 640 1792 576L1792 576Q1792 510 1766.50 452Q1741 394 1697.50 350.50Q1654 307 1596 281.50Q1538 256 1472 256L1472 256Q1408 256 1349.50 280.50Q1291 305 1246 350L1246 350L1110 486L1562 938Z"
         }
      }
   ]
}

var Variable = {
   name: "Variable",
   vendor: "UiFabric",
   unicode: 62213,
   value: "",
   charCode: "F305",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1091 651L1072 732L848 732L689 1475Q672 1553 631 1633.50Q590 1714 530.50 1779.50Q471 1845 394.50 1886.50Q318 1928 231 1928L231 1928Q205 1928 178 1923Q151 1918 129 1906Q107 1894 92.50 1873.50Q78 1853 78 1822L78 1822Q78 1782 102.50 1753.50Q127 1725 169 1725L169 1725Q194 1725 214 1736Q234 1747 250 1764Q266 1781 279 1802Q292 1823 304 1842L304 1842L311 1854Q343 1852 369 1832Q395 1812 415.50 1782Q436 1752 452 1714.50Q468 1677 480 1639.50Q492 1602 500.50 1567.50Q509 1533 514 1509L514 1509L681 732L505 732L525 651L698 651L710 589Q726 509 764.50 428Q803 347 861 282Q919 217 994.50 176.50Q1070 136 1160 136L1160 136Q1186 136 1213 141Q1240 146 1262.50 158Q1285 170 1299 190.50Q1313 211 1313 242L1313 242Q1313 284 1290.50 312.50Q1268 341 1223 341L1223 341Q1191 341 1170 328.50Q1149 316 1134 297Q1119 278 1106.50 255Q1094 232 1081 210L1081 210Q1044 212 1015 238Q986 264 963.50 304.50Q941 345 925 394Q909 443 897.50 491.50Q886 540 878 582.50Q870 625 865 651L865 651L1091 651ZM1736 796L1736 796Q1711 816 1683 849Q1655 882 1628.50 918.50Q1602 955 1578.50 992Q1555 1029 1539 1057L1539 1057Q1549 1098 1558 1138Q1567 1178 1578 1219L1578 1219Q1588 1256 1600.50 1296Q1613 1336 1634 1369.50Q1655 1403 1686 1424.50Q1717 1446 1764 1446L1764 1446Q1776 1446 1792 1444.50Q1808 1443 1824.50 1440.50Q1841 1438 1856.50 1434.50Q1872 1431 1883 1426L1883 1426L1867 1485Q1837 1498 1810.50 1509Q1784 1520 1758 1528Q1732 1536 1703.50 1540.50Q1675 1545 1642 1545L1642 1545Q1598 1545 1569.50 1532.50Q1541 1520 1522.50 1497.50Q1504 1475 1492 1443Q1480 1411 1468 1373L1468 1373Q1454 1329 1443 1286Q1432 1243 1421 1198L1421 1198Q1383 1258 1345 1313.50Q1307 1369 1262 1423L1262 1423Q1242 1447 1222 1469Q1202 1491 1178.50 1508Q1155 1525 1128 1535Q1101 1545 1068 1545L1068 1545Q1026 1545 998.50 1521Q971 1497 971 1453L971 1453Q971 1427 981 1407.50Q991 1388 1008 1375Q1025 1362 1047 1355.50Q1069 1349 1093 1349L1093 1349Q1123 1349 1150.50 1360Q1178 1371 1207 1379L1207 1379Q1264 1322 1313.50 1258Q1363 1194 1401 1124L1401 1124L1399 1114Q1395 1095 1387 1063Q1379 1031 1369.50 993.50Q1360 956 1348 917Q1336 878 1323.50 845Q1311 812 1297.50 787.50Q1284 763 1271 755L1271 755Q1237 735 1194 735L1194 735Q1167 735 1138 740.50Q1109 746 1084 757L1084 757L1100 697Q1114 691 1142 680Q1170 669 1200 658Q1230 647 1258 639Q1286 631 1300 631L1300 631Q1344 631 1373.50 645Q1403 659 1423 684Q1443 709 1456 742Q1469 775 1480 813L1480 813Q1491 852 1500.50 892.50Q1510 933 1518 973L1518 973L1520 981Q1520 983 1520.50 984Q1521 985 1521 987L1521 987Q1540 957 1562 919Q1584 881 1610 841Q1636 801 1665.50 762.50Q1695 724 1728 694Q1761 664 1798 645.50Q1835 627 1876 627L1876 627Q1915 627 1942.50 653Q1970 679 1970 719L1970 719Q1970 744 1960 763Q1950 782 1933.50 795Q1917 808 1895.50 814.50Q1874 821 1851 821L1851 821Q1825 821 1793 812.50Q1761 804 1736 796Z"
         }
      }
   ]
}

var CommentUrgent = {
   name: "CommentUrgent",
   vendor: "UiFabric",
   unicode: 62215,
   value: "",
   charCode: "F307",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536L0 128ZM1920 1408L1920 256L128 256L128 1408L384 1408L384 1701L677 1408L1920 1408ZM1024 384L1024 896L896 896L896 384L1024 384ZM1024 1024L1024 1152L896 1152L896 1024L1024 1024Z"
         }
      }
   ]
}

var DiffInline = {
   name: "DiffInline",
   vendor: "UiFabric",
   unicode: 62217,
   value: "",
   charCode: "F309",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1792 0L1792 2048L256 2048L256 0ZM1664 128L384 128L384 512L1664 512L1664 128ZM1664 1920L1664 1536L384 1536L384 1920L1664 1920ZM384 1280L1664 1280L1664 640L384 640L384 1280Z"
         }
      }
   ]
}

var ImageDiff = {
   name: "ImageDiff",
   vendor: "UiFabric",
   unicode: 62219,
   value: "",
   charCode: "F30B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 1920L0 1920L0 0ZM128 859L128 896L1061 896L576 410L128 859ZM1243 896L1701 896L1408 603L1178 832L1243 896ZM128 1755L128 1792L1061 1792L576 1306L128 1755ZM1178 1728L1243 1792L1701 1792L1408 1499L1178 1728ZM1920 1792L1920 1024L128 1024L128 1573L576 1126L1088 1638L1408 1317L1883 1792L1920 1792ZM1883 896L1920 896L1920 128L128 128L128 677L576 230L1088 742L1408 421L1883 896Z"
         }
      }
   ]
}

var FileBug = {
   name: "FileBug",
   vendor: "UiFabric",
   unicode: 62221,
   value: "",
   charCode: "F30D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM256 1920L1664 1920L1664 640L1152 640L1152 128L256 128L256 1920ZM896 1280L896 768L1024 768L1024 1280L896 1280ZM896 1536L896 1408L1024 1408L1024 1536L896 1536Z"
         }
      }
   ]
}

var FileComment = {
   name: "FileComment",
   vendor: "UiFabric",
   unicode: 62223,
   value: "",
   charCode: "F30F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1536L1371 1536L987 1920L1664 1920L1664 1664L1792 1664L1792 2048L128 2048L128 0L1243 0L1664 421L1664 511L1574 511L1280 219L1280 512L1152 512L1152 128L256 128L256 1920L960 1920L960 1536L768 1536L768 640L2048 640L2048 1536ZM1088 1638L1317 1408L1920 1408L1920 768L896 768L896 1408L1088 1408L1088 1638ZM1024 1024L1024 896L1792 896L1792 1024L1024 1024ZM1024 1280L1024 1152L1792 1152L1792 1280L1024 1280Z"
         }
      }
   ]
}

var FileImage = {
   name: "FileImage",
   vendor: "UiFabric",
   unicode: 62225,
   value: "",
   charCode: "F311",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L1792 1920L1792 2048L128 2048L128 0L1243 0L1792 549L1792 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM640 768L2048 768L2048 1792L640 1792L640 768ZM1920 896L768 896L768 1317L1088 998L1504 1414L1664 1254L1920 1510L1920 896ZM1595 1504L1755 1664L1894 1664L1664 1434L1595 1504ZM768 1499L768 1664L1573 1664L1088 1178L768 1499ZM1728 1152L1728 1152Q1702 1152 1683 1133Q1664 1114 1664 1088L1664 1088Q1664 1062 1683 1043Q1702 1024 1728 1024L1728 1024Q1754 1024 1773 1043Q1792 1062 1792 1088L1792 1088Q1792 1114 1773 1133Q1754 1152 1728 1152Z"
         }
      }
   ]
}

var AutoFillTemplate = {
   name: "AutoFillTemplate",
   vendor: "UiFabric",
   unicode: 62227,
   value: "",
   charCode: "F313",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 896L0 896L0 256ZM1920 768L1920 384L128 384L128 768L1920 768ZM0 1664L0 1024L2048 1024L2048 1664L0 1664ZM128 1152L128 1536L1920 1536L1920 1152L128 1152ZM1536 512L1536 640L256 640L256 512L1536 512ZM256 1408L256 1280L896 1280L896 1408L256 1408Z"
         }
      }
   ]
}

var WorkItemBug = {
   name: "WorkItemBug",
   vendor: "UiFabric",
   unicode: 62229,
   value: "",
   charCode: "F315",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM896 384L640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384ZM1664 1920L1664 384L1536 384L1536 640L512 640L512 384L384 384L384 1920L1664 1920ZM896 1408L896 896L1024 896L1024 1408L896 1408ZM896 1664L896 1536L1024 1536L1024 1664L896 1664Z"
         }
      }
   ]
}

var ColumnOptions = {
   name: "ColumnOptions",
   vendor: "UiFabric",
   unicode: 62231,
   value: "",
   charCode: "F317",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1152L1920 1152L1920 640L1408 640L1408 1024L1280 1024L1280 640L768 640L768 1664L1024 1664L1024 1792L0 1792L0 128ZM640 1664L640 640L128 640L128 1664L640 1664ZM128 512L1920 512L1920 256L128 256L128 512ZM1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369ZM1601 1792L1601 1792Q1641 1792 1675.50 1777Q1710 1762 1736 1735.50Q1762 1709 1777 1674Q1792 1639 1792 1599L1792 1599Q1792 1560 1777 1525Q1762 1490 1735.50 1464Q1709 1438 1674 1423Q1639 1408 1600 1408L1600 1408Q1560 1408 1525 1423.50Q1490 1439 1464 1465Q1438 1491 1423 1526Q1408 1561 1408 1601L1408 1601Q1408 1641 1423 1675.50Q1438 1710 1464.50 1736Q1491 1762 1526 1777Q1561 1792 1601 1792Z"
         }
      }
   ]
}

var BuildIssue = {
   name: "BuildIssue",
   vendor: "UiFabric",
   unicode: 62233,
   value: "",
   charCode: "F319",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1905 1418L1905 1418L2048 1575L2048 1792L1920 1792L1920 1625L1819 1513Q1783 1533 1742 1535L1742 1535L1664 1624L1664 1792L1536 1792L1536 1576L1608 1494Q1603 1491 1599.50 1487.50Q1596 1484 1592 1480L1592 1480L1344 1231L1152 1424L1152 1920L1280 1920L1280 2048L640 2048L640 1920L768 1920L768 1344Q768 1306 782.50 1270.50Q797 1235 824 1208L824 1208L1208 824Q1235 797 1270.50 782.50Q1306 768 1344 768L1344 768Q1382 768 1417.50 782.50Q1453 797 1480 824L1480 824L1864 1208Q1891 1235 1905.50 1270.50Q1920 1306 1920 1344L1920 1344Q1920 1384 1905 1418ZM1299 915L1043 1171Q1104 1200 1133 1261L1133 1261L1389 1005Q1408 986 1408 960L1408 960Q1408 934 1389 915Q1370 896 1344 896L1344 896Q1318 896 1299 915L1299 915ZM896 1344L896 1920L1024 1920L1024 1344Q1024 1318 1005 1299Q986 1280 960 1280L960 1280Q934 1280 915 1299Q896 1318 896 1344L896 1344ZM1728 1408L1728 1408Q1754 1408 1773 1389Q1792 1370 1792 1344L1792 1344Q1792 1318 1773 1299L1773 1299L1517 1043Q1503 1074 1480.50 1095.50Q1458 1117 1434 1141L1434 1141L1683 1389Q1702 1408 1728 1408ZM256 1408L640 1408L640 1536L128 1536L128 128L1280 128L1280 640L1152 640L1152 256L256 256L256 1408ZM640 512L768 512L768 896L640 896L640 512ZM768 1152L640 1152L640 1024L768 1024L768 1152Z"
         }
      }
   ]
}

var VariableGroup = {
   name: "VariableGroup",
   vendor: "UiFabric",
   unicode: 62235,
   value: "",
   charCode: "F31B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M690 1347L690 1347Q690 1324 705 1309Q720 1294 743 1294L743 1294Q755 1294 766 1300Q777 1306 786 1313Q795 1320 802.50 1326Q810 1332 817 1332L817 1332Q827 1332 843.50 1316.50Q860 1301 878.50 1277Q897 1253 917 1223.50Q937 1194 954 1166.50Q971 1139 983 1116.50Q995 1094 1000 1083L1000 1083Q992 1049 983 1016Q974 983 966 949L966 949Q958 918 948.50 894.50Q939 871 924.50 855Q910 839 890.50 830.50Q871 822 843 822L843 822Q833 822 822.50 823Q812 824 801 826L801 826L801 801L985 768Q1006 791 1020.50 814.50Q1035 838 1044.50 862.50Q1054 887 1061 913.50Q1068 940 1076 970L1076 970Q1091 948 1113.50 913.50Q1136 879 1164.50 847Q1193 815 1225.50 791.50Q1258 768 1292 768L1292 768Q1317 768 1337 781.50Q1357 795 1357 822L1357 822Q1357 876 1303 876L1303 876Q1283 876 1266 867Q1249 858 1229 858L1229 858Q1210 858 1189 877Q1168 896 1148.50 922Q1129 948 1113 974.50Q1097 1001 1087 1016L1087 1016L1144 1253Q1145 1260 1148 1272.50Q1151 1285 1156 1297.50Q1161 1310 1168 1319.50Q1175 1329 1184 1329L1184 1329Q1196 1329 1211.50 1317.50Q1227 1306 1241 1290Q1255 1274 1266.50 1257.50Q1278 1241 1282 1230L1282 1230L1306 1242Q1298 1261 1278 1289Q1258 1317 1232.50 1343.50Q1207 1370 1180.50 1389Q1154 1408 1132 1408L1132 1408Q1110 1408 1095.50 1395Q1081 1382 1070 1365L1070 1365Q1061 1349 1053 1318.50Q1045 1288 1038 1253.50Q1031 1219 1024.50 1186Q1018 1153 1011 1133L1011 1133Q1000 1153 984.50 1181Q969 1209 949 1239.50Q929 1270 906 1300.50Q883 1331 858 1354.50Q833 1378 807.50 1393Q782 1408 757 1408L757 1408Q731 1408 710.50 1391Q690 1374 690 1347ZM1610 1408L1516 1408Q1570 1339 1599 1258.50Q1628 1178 1628 1090L1628 1090Q1628 1000 1599 920Q1570 840 1516 768L1516 768L1610 768Q1728 907 1728 1090L1728 1090Q1728 1181 1699.50 1260Q1671 1339 1610 1408L1610 1408ZM0 1792L0 128L2048 128L2048 1792L0 1792ZM128 1664L1920 1664L1920 640L128 640L128 1664ZM128 512L1920 512L1920 256L128 256L128 512ZM531 1408L438 1408Q376 1340 348 1260.50Q320 1181 320 1090L320 1090Q320 907 438 768L438 768L531 768Q477 838 448.50 919.50Q420 1001 420 1090L420 1090Q420 1177 448.50 1258Q477 1339 531 1408L531 1408Z"
         }
      }
   ]
}

var FullHistory = {
   name: "FullHistory",
   vendor: "UiFabric",
   unicode: 62236,
   value: "",
   charCode: "F31C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1024L896 512L1024 512L1024 1024L896 1024ZM512 640L512 768L0 768L0 256L128 256L128 530Q195 407 291 309Q387 211 503.50 142.50Q620 74 752 37Q884 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q895 128 773 164Q651 200 545.50 267Q440 334 355 428.50Q270 523 215 640L215 640L512 640ZM1024 1280L1024 1152L2048 1152L2048 1280L1024 1280ZM1024 1664L1024 1536L2048 1536L2048 1664L1024 1664ZM1024 2048L1024 1920L2048 1920L2048 2048L1024 2048ZM38 1297L161 1263Q197 1392 266.50 1502Q336 1612 432 1696.50Q528 1781 646 1836Q764 1891 896 1910L896 1910L896 2040Q742 2019 604 1957Q466 1895 354 1798.50Q242 1702 160.50 1574.50Q79 1447 38 1297L38 1297Z"
         }
      }
   ]
}

var AssessmentGroup = {
   name: "AssessmentGroup",
   vendor: "UiFabric",
   unicode: 62234,
   value: "",
   charCode: "F31A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1280L640 1536L384 1536L384 1280L640 1280ZM1152 1280L1152 1536L896 1536L896 1280L1152 1280ZM1664 256L1664 512L1408 512L1408 256L1664 256ZM1664 1280L1664 1536L1408 1536L1408 1280L1664 1280ZM1152 768L1152 1024L896 1024L896 768L1152 768ZM1664 768L1664 1024L1408 1024L1408 768L1664 768ZM1792 256L1920 256L1920 1792L128 1792L128 256L256 256L256 1664L1792 1664L1792 256Z"
         }
      }
   ]
}

var Packages = {
   name: "Packages",
   vendor: "UiFabric",
   unicode: 62232,
   value: "",
   charCode: "F318",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 640L2048 1024L1920 1024L1920 2048L640 2048L640 1024L512 1024L512 640L1280 640L1280 384L256 384L256 1280L640 1280L640 1408L128 1408L128 384L0 384L0 0L1536 0L1536 384L1408 384L1408 640L2048 640ZM128 128L128 256L1408 256L1408 128L128 128ZM1792 1920L1792 1024L768 1024L768 1920L1792 1920ZM1920 896L1920 768L640 768L640 896L1920 896ZM1408 1408L1408 1536L896 1536L896 1408L1408 1408ZM1280 1792L896 1792L896 1664L1280 1664L1280 1792Z"
         }
      }
   ]
}

var LogRemove = {
   name: "LogRemove",
   vendor: "UiFabric",
   unicode: 62230,
   value: "",
   charCode: "F316",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1536L256 1792L1348 1792L1220 1920L128 1920L128 1536L0 1536L0 1408L128 1408L128 640L0 640L0 512L128 512L128 0L1920 0L1920 1220L1792 1348L1792 128L256 128L256 512L384 512L384 640L256 640L256 1408L384 1408L384 1536L256 1536ZM640 640L1024 640L1024 1536L640 1536L640 640ZM896 1408L896 768L768 768L768 1408L896 1408ZM1501 1185L1408 1278L1408 512L1280 512L1280 1406L1185 1501L1219 1536L1152 1536L1152 384L1536 384L1536 1219L1501 1185ZM2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411L2045 1502Z"
         }
      }
   ]
}

var WorkItem = {
   name: "WorkItem",
   vendor: "UiFabric",
   unicode: 62228,
   value: "",
   charCode: "F314",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1920L1155 1920L1283 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256L1792 256L1792 1283L1664 1411L1664 384L1536 384L1536 640L512 640L512 384L384 384L384 1920ZM896 384L640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384ZM1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363Z"
         }
      }
   ]
}

var FileSymlink = {
   name: "FileSymlink",
   vendor: "UiFabric",
   unicode: 62226,
   value: "",
   charCode: "F312",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L896 1920L896 2048L128 2048L128 0L1243 0L1792 549L1792 896L1664 896L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM1024 1024L2048 1024L2048 2048L1024 2048L1024 1024ZM1920 1920L1920 1152L1152 1152L1152 1920L1920 1920ZM1389 1773L1299 1683L1573 1408L1408 1408L1408 1280L1792 1280L1792 1664L1664 1664L1664 1499L1389 1773Z"
         }
      }
   ]
}

var BusinessHoursSign = {
   name: "BusinessHoursSign",
   vendor: "UiFabric",
   unicode: 62224,
   value: "",
   charCode: "F310",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1627 896L1671 896Q1696 896 1718 905.50Q1740 915 1756.50 931.50Q1773 948 1782.50 970Q1792 992 1792 1017L1792 1017L1792 1799Q1792 1824 1782.50 1846Q1773 1868 1756.50 1884.50Q1740 1901 1718 1910.50Q1696 1920 1671 1920L1671 1920L249 1920Q224 1920 202 1910.50Q180 1901 163.50 1884.50Q147 1868 137.50 1846Q128 1824 128 1799L128 1799L128 1017Q128 992 137.50 970Q147 948 163.50 931.50Q180 915 202 905.50Q224 896 249 896L249 896L293 896L740 450Q722 421 713 388Q704 355 704 320L704 320Q704 267 724 220.50Q744 174 779 139Q814 104 860.50 84Q907 64 960 64L960 64Q1013 64 1059.50 84Q1106 104 1141 139Q1176 174 1196 220.50Q1216 267 1216 320L1216 320Q1216 355 1207 388Q1198 421 1180 450L1180 450L1627 896ZM960 192L960 192Q933 192 910 202Q887 212 869.50 229.50Q852 247 842 270Q832 293 832 320L832 320Q832 347 842 370Q852 393 869.50 410.50Q887 428 910 438Q933 448 960 448L960 448Q987 448 1010 438Q1033 428 1050.50 410.50Q1068 393 1078 370Q1088 347 1088 320L1088 320Q1088 293 1078 270Q1068 247 1050.50 229.50Q1033 212 1010 202Q987 192 960 192ZM830 540L475 896L1445 896L1090 540Q1031 576 960 576L960 576Q925 576 892 567Q859 558 830 540L830 540ZM1664 1792L1664 1024L256 1024L256 1792L1664 1792ZM1408 1280L1408 1408L512 1408L512 1280L1408 1280Z"
         }
      }
   ]
}

var FileCode = {
   name: "FileCode",
   vendor: "UiFabric",
   unicode: 62222,
   value: "",
   charCode: "F30E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM256 1920L1664 1920L1664 640L1152 640L1152 128L256 128L256 1920ZM659 851L749 941L538 1152L749 1363L659 1453L358 1152L659 851ZM1171 941L1261 851L1562 1152L1261 1453L1171 1363L1382 1152L1171 941Z"
         }
      }
   ]
}

var ImagePixel = {
   name: "ImagePixel",
   vendor: "UiFabric",
   unicode: 62220,
   value: "",
   charCode: "F30C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1792L0 1792L0 256ZM1920 1408L1920 384L128 384L128 896L384 896L384 1152L128 1152L128 1664L1152 1664L1152 1408L1408 1408L1408 1664L1664 1664L1664 1408L1920 1408ZM640 640L640 896L384 896L384 640L640 640ZM896 1152L640 1152L640 896L896 896L896 1152ZM896 1152L1152 1152L1152 1408L896 1408L896 1152ZM1408 1152L1664 1152L1664 1408L1408 1408L1408 1152ZM1664 640L1664 896L1408 896L1408 640L1664 640Z"
         }
      }
   ]
}

var DiffSideBySide = {
   name: "DiffSideBySide",
   vendor: "UiFabric",
   unicode: 62218,
   value: "",
   charCode: "F30A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 384L896 384L896 1664L0 1664ZM128 1536L768 1536L768 768L128 768L128 1536ZM768 512L128 512L128 640L768 640L768 512ZM1152 384L2048 384L2048 1664L1152 1664L1152 384ZM1920 1536L1920 1280L1280 1280L1280 1536L1920 1536ZM1920 1024L1920 512L1280 512L1280 1024L1920 1024Z"
         }
      }
   ]
}

var Storyboard = {
   name: "Storyboard",
   vendor: "UiFabric",
   unicode: 62216,
   value: "",
   charCode: "F308",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1792L0 1792L0 128ZM1920 256L128 256L128 512L1920 512L1920 256ZM128 640L128 1664L1152 1664L1152 640L128 640ZM1280 1664L1920 1664L1920 640L1280 640L1280 1664ZM1408 896L1408 768L1792 768L1792 896L1408 896ZM1408 1152L1408 1024L1792 1024L1792 1152L1408 1152ZM1408 1408L1408 1280L1792 1280L1792 1408L1408 1408ZM256 768L1024 768L1024 1536L256 1536L256 768ZM896 1408L896 896L384 896L384 1408L896 1408Z"
         }
      }
   ]
}

var Parameter = {
   name: "Parameter",
   vendor: "UiFabric",
   unicode: 62214,
   value: "",
   charCode: "F306",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1027 448L1027 448Q1148 448 1254 485Q1360 522 1439 592Q1518 662 1563.50 762Q1609 862 1609 988L1609 988Q1609 1054 1591.50 1125.50Q1574 1197 1537.50 1255.50Q1501 1314 1444.50 1352Q1388 1390 1310 1390L1310 1390Q1224 1390 1186 1343Q1148 1296 1147 1214L1147 1214L1143 1214Q1120 1293 1068.50 1341.50Q1017 1390 931 1390L931 1390Q872 1390 829.50 1366.50Q787 1343 759.50 1304.50Q732 1266 719 1216.50Q706 1167 706 1114L706 1114Q706 1044 724.50 974Q743 904 781 849Q819 794 877.50 759.50Q936 725 1016 725L1016 725Q1039 725 1062.50 731Q1086 737 1107 749Q1128 761 1144 779Q1160 797 1168 821L1168 821L1168 816Q1170 796 1171.50 776Q1173 756 1175 736L1175 736L1268 736L1244 1022Q1241 1054 1237 1087Q1233 1120 1233 1152L1233 1152Q1233 1174 1235.50 1200.50Q1238 1227 1247 1250.50Q1256 1274 1273.50 1289.50Q1291 1305 1321 1305L1321 1305Q1357 1305 1385 1289.50Q1413 1274 1433.50 1249Q1454 1224 1468 1191.50Q1482 1159 1491 1124.50Q1500 1090 1503.50 1056Q1507 1022 1507 994L1507 994Q1507 884 1471 798Q1435 712 1370.50 653Q1306 594 1216.50 563Q1127 532 1021 532L1021 532Q906 532 812.50 575Q719 618 652.50 691.50Q586 765 550 863Q514 961 514 1072L514 1072Q514 1187 549.50 1280.50Q585 1374 651 1440Q717 1506 810.50 1542Q904 1578 1019 1578L1019 1578Q1100 1578 1179.50 1565Q1259 1552 1332 1517L1332 1517L1332 1609Q1257 1641 1175 1652.50Q1093 1664 1012 1664L1012 1664Q879 1664 769 1622.50Q659 1581 579.50 1504.50Q500 1428 456 1319Q412 1210 412 1076L412 1076Q412 941 457 826Q502 711 583 627Q664 543 777 495.50Q890 448 1027 448ZM949 1303L949 1303Q1010 1303 1049 1268.50Q1088 1234 1110 1183Q1132 1132 1140.50 1074Q1149 1016 1149 969L1149 969Q1149 935 1142 906Q1135 877 1119.50 856Q1104 835 1078 823Q1052 811 1015 811L1015 811Q957 811 918 841Q879 871 855 916Q831 961 820.50 1014.50Q810 1068 810 1115L810 1115Q810 1148 817 1181.50Q824 1215 840 1242Q856 1269 883 1286Q910 1303 949 1303ZM0 1792L0 256L384 256L384 384L128 384L128 1664L384 1664L384 1792L0 1792ZM1664 256L2048 256L2048 1792L1664 1792L1664 1664L1920 1664L1920 384L1664 384L1664 256Z"
         }
      }
   ]
}

var UnlockSolid = {
   name: "UnlockSolid",
   vendor: "UiFabric",
   unicode: 62212,
   value: "",
   charCode: "F304",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 896L1792 896L1792 2048L256 2048L256 896L1408 896L1408 512Q1408 430 1379 359.50Q1350 289 1298.50 237.50Q1247 186 1176.50 157Q1106 128 1024 128L1024 128Q942 128 871.50 157Q801 186 749.50 237.50Q698 289 669 359.50Q640 430 640 512L640 512L512 512Q512 403 551 309.50Q590 216 659 147Q728 78 821.50 39Q915 0 1024 0L1024 0Q1133 0 1226.50 39Q1320 78 1389 147Q1458 216 1497 309.50Q1536 403 1536 512L1536 512L1536 896Z"
         }
      }
   ]
}

var PlugConnected = {
   name: "PlugConnected",
   vendor: "UiFabric",
   unicode: 62210,
   value: "",
   charCode: "F302",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1216L256 1216Q256 1127 290 1044.50Q324 962 387 899L387 899L614 673L1247 1306L1021 1533Q958 1596 875.50 1630Q793 1664 704 1664L704 1664Q631 1664 562.50 1641.50Q494 1619 436 1575L436 1575L109 1901L19 1811L345 1484Q301 1426 278.50 1357.50Q256 1289 256 1216ZM704 1536L704 1536Q768 1536 826.50 1511.50Q885 1487 930 1442L930 1442L1066 1306L614 854L478 990Q433 1035 408.50 1093.50Q384 1152 384 1216L384 1216Q384 1282 409 1340.50Q434 1399 477.50 1442.50Q521 1486 579.50 1511Q638 1536 704 1536ZM1901 109L1575 436Q1619 494 1641.50 562.50Q1664 631 1664 704L1664 704Q1664 793 1630 875.50Q1596 958 1533 1021L1533 1021L1306 1247L673 614L899 387Q962 324 1044.50 290Q1127 256 1216 256L1216 256Q1289 256 1357.50 278.50Q1426 301 1484 345L1484 345L1811 19L1901 109ZM1306 1066L1442 930Q1487 885 1511.50 826.50Q1536 768 1536 704L1536 704Q1536 638 1510.50 580Q1485 522 1441.50 478.50Q1398 435 1340 409.50Q1282 384 1216 384L1216 384Q1152 384 1093.50 408.50Q1035 433 990 478L990 478L854 614L1306 1066Z"
         }
      }
   ]
}

var Plug = {
   name: "Plug",
   vendor: "UiFabric",
   unicode: 62208,
   value: "",
   charCode: "F300",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 384L1408 384L1408 832Q1408 915 1379 990.50Q1350 1066 1298.50 1125Q1247 1184 1176.50 1223.50Q1106 1263 1024 1275L1024 1275L1024 2048L896 2048L896 1275Q813 1263 743 1223.50Q673 1184 621.50 1125Q570 1066 541 990.50Q512 915 512 832L512 832L512 384L640 384L640 0L768 0L768 384L1152 384L1152 0L1280 0L1280 384ZM1280 832L1280 512L640 512L640 832Q640 898 665 956.50Q690 1015 733.50 1058.50Q777 1102 835.50 1127Q894 1152 960 1152L960 1152Q1026 1152 1084 1127Q1142 1102 1185.50 1058.50Q1229 1015 1254.50 956.50Q1280 898 1280 832L1280 832Z"
         }
      }
   ]
}

var FullWidth = {
   name: "FullWidth",
   vendor: "UiFabric",
   unicode: 62206,
   value: "",
   charCode: "F2FE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1792L0 1792L0 256ZM1920 1664L1920 384L1536 384L1536 640L1408 640L1408 384L640 384L640 640L512 640L512 384L128 384L128 1664L512 1664L512 1536L640 1536L640 1664L1408 1664L1408 1536L1536 1536L1536 1664L1920 1664ZM512 1024L512 768L640 768L640 1024L512 1024ZM512 1408L512 1152L640 1152L640 1408L512 1408ZM1408 1024L1408 768L1536 768L1536 1024L1408 1024ZM1408 1408L1408 1152L1536 1152L1536 1408L1408 1408Z"
         }
      }
   ]
}

var CoffeeScript = {
   name: "CoffeeScript",
   vendor: "UiFabric",
   unicode: 62202,
   value: "",
   charCode: "F2FA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M576 544L576 544Q550 544 531 525Q512 506 512 480L512 480Q512 457 497.50 439Q483 421 465 409L465 409Q430 385 393.50 361Q357 337 326 308.50Q295 280 275.50 244Q256 208 256 160L256 160Q256 134 275 115Q294 96 320 96L320 96Q346 96 365 115Q384 134 384 160L384 160Q384 183 398.50 201Q413 219 431 231L431 231Q465 255 502 279Q539 303 570 331.50Q601 360 620.50 396Q640 432 640 480L640 480Q640 506 621 525Q602 544 576 544ZM1024 544L1024 544Q998 544 979 525Q960 506 960 480L960 480Q960 457 945.50 439Q931 421 913 409L913 409Q878 385 841.50 361Q805 337 774 308.50Q743 280 723.50 244Q704 208 704 160L704 160Q704 134 723 115Q742 96 768 96L768 96Q794 96 813 115Q832 134 832 160L832 160Q832 183 846.50 201Q861 219 879 231L879 231Q913 255 950 279Q987 303 1018 331.50Q1049 360 1068.50 396Q1088 432 1088 480L1088 480Q1088 506 1069 525Q1050 544 1024 544ZM1472 544L1472 544Q1446 544 1427 525Q1408 506 1408 480L1408 480Q1408 457 1393.50 439Q1379 421 1361 409L1361 409Q1326 385 1289.50 361Q1253 337 1222 308.50Q1191 280 1171.50 244Q1152 208 1152 160L1152 160Q1152 134 1171 115Q1190 96 1216 96L1216 96Q1242 96 1261 115Q1280 134 1280 160L1280 160Q1280 183 1294.50 201Q1309 219 1327 231L1327 231Q1361 255 1398 279Q1435 303 1466 331.50Q1497 360 1516.50 396Q1536 432 1536 480L1536 480Q1536 506 1517 525Q1498 544 1472 544ZM1733 1280L1605 1280Q1572 1355 1523 1418.50Q1474 1482 1413 1536L1413 1536L1856 1536L1856 1664Q1856 1709 1842 1754.50Q1828 1800 1801.50 1836.50Q1775 1873 1736.50 1896.50Q1698 1920 1648 1920L1648 1920L208 1920Q158 1920 119.50 1896.50Q81 1873 54.50 1836.50Q28 1800 14 1754.50Q0 1709 0 1664L0 1664L0 1536L379 1536Q261 1433 194.50 1297Q128 1161 128 1003L128 1003L128 640L1733 640Q1799 640 1856.50 665.50Q1914 691 1956.50 734.50Q1999 778 2023.50 836.50Q2048 895 2048 960L2048 960Q2048 1025 2023.50 1083.50Q1999 1142 1956.50 1185.50Q1914 1229 1856.50 1254.50Q1799 1280 1733 1280L1733 1280ZM1733 768L1664 768Q1664 810 1665 852Q1666 894 1666 937L1666 937Q1666 992 1662.50 1046Q1659 1100 1647 1152L1647 1152L1733 1152Q1772 1152 1806.50 1136.50Q1841 1121 1866 1095Q1891 1069 1905.50 1034Q1920 999 1920 960L1920 960Q1920 921 1905.50 886Q1891 851 1866 825Q1841 799 1806.50 783.50Q1772 768 1733 768L1733 768ZM256 768L256 1003Q256 1091 282.50 1172Q309 1253 357 1322Q405 1391 471 1445.50Q537 1500 616 1536L616 1536L1176 1536Q1255 1500 1321 1445.50Q1387 1391 1435 1322Q1483 1253 1509.50 1172Q1536 1091 1536 1003L1536 1003L1536 768L256 768ZM208 1792L1648 1792Q1669 1792 1684 1778Q1699 1764 1709 1744.50Q1719 1725 1723.50 1703Q1728 1681 1728 1664L1728 1664L128 1664Q128 1681 132.50 1703Q137 1725 147 1744.50Q157 1764 172 1778Q187 1792 208 1792L208 1792Z"
         }
      }
   ]
}

var PythonLanguage = {
   name: "PythonLanguage",
   vendor: "UiFabric",
   unicode: 62200,
   value: "",
   charCode: "F2F8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 384L480 384Q573 384 651.50 406.50Q730 429 788 475.50Q846 522 878.50 594Q911 666 911 766L911 766Q911 868 874 945Q837 1022 774 1074.50Q711 1127 626.50 1153.50Q542 1180 447 1180L447 1180L278 1180L278 1664L128 1664L128 384ZM278 1044L435 1044Q502 1044 560 1029.50Q618 1015 661 982.50Q704 950 729 898.50Q754 847 754 773L754 773Q754 702 731.50 653.50Q709 605 669 575.50Q629 546 574 533Q519 520 454 520L454 520L278 520L278 1044ZM1825 384L1984 384L1562 1191L1562 1664L1411 1664L1411 1194L1000 384L1171 384L1457 962Q1466 981 1473.50 1001Q1481 1021 1491 1041L1491 1041Q1497 1021 1506 1001Q1515 981 1525 962L1525 962L1825 384Z"
         }
      }
   ]
}

var FSharp = {
   name: "FSharp",
   vendor: "UiFabric",
   unicode: 62198,
   value: "",
   charCode: "F2F6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1801 1801L1801 247L247 247L247 1801L1801 1801ZM798 1343L798 1664L671 1664L671 896L1085 896L1085 1004L798 1004L798 1235L1063 1235L1063 1343L798 1343ZM1246 1536L1284 1355L1172 1355L1186 1287L1299 1287L1326 1152L1207 1152L1221 1084L1340 1084L1379 896L1458 896L1419 1084L1537 1084L1577 896L1655 896L1615 1084L1727 1084L1712 1152L1601 1152L1573 1287L1694 1287L1676 1355L1558 1355L1518 1536L1441 1536L1480 1355L1362 1355L1323 1536L1246 1536ZM1405 1152L1375 1287L1495 1287L1524 1152L1405 1152Z"
         }
      }
   ]
}

var CPlusPlus = {
   name: "CPlusPlus",
   vendor: "UiFabric",
   unicode: 62196,
   value: "",
   charCode: "F2F4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1801 1801L1801 247L247 247L247 1801L1801 1801ZM1024 1280L1280 1280L1280 1024L1408 1024L1408 1280L1664 1280L1664 1408L1408 1408L1408 1664L1280 1664L1280 1408L1024 1408L1024 1280ZM640 1280L640 1024L384 1024L384 896L640 896L640 640L768 640L768 896L1024 896L1024 1024L768 1024L768 1280L640 1280Z"
         }
      }
   ]
}

var VB = {
   name: "VB",
   vendor: "UiFabric",
   unicode: 62194,
   value: "",
   charCode: "F2F2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1801 1801L1801 247L247 247L247 1801L1801 1801ZM782 1664L639 1664L368 896L508 896L697 1479Q702 1495 705.50 1511Q709 1527 713 1544L713 1544Q715 1527 719.50 1511Q724 1495 729 1478L729 1478L923 896L1058 896L782 1664ZM1664 1443L1664 1443Q1664 1499 1640.50 1540.50Q1617 1582 1579 1609.50Q1541 1637 1492.50 1650.50Q1444 1664 1394 1664L1394 1664L1152 1664L1152 896L1392 896Q1433 896 1475.50 905Q1518 914 1552.50 935Q1587 956 1608.50 989.50Q1630 1023 1630 1072L1630 1072Q1630 1139 1593 1186Q1556 1233 1493 1256L1493 1256Q1571 1265 1617.50 1314.50Q1664 1364 1664 1443ZM1277 998L1277 1217L1358 1217Q1387 1217 1412.50 1210Q1438 1203 1457 1188.50Q1476 1174 1487 1151.50Q1498 1129 1498 1097L1498 1097Q1498 1068 1487 1049Q1476 1030 1458 1018.50Q1440 1007 1416.50 1002.50Q1393 998 1368 998L1368 998L1277 998ZM1277 1562L1384 1562Q1414 1562 1440.50 1555Q1467 1548 1487 1533.50Q1507 1519 1518.50 1495.50Q1530 1472 1530 1439L1530 1439Q1530 1403 1516 1379.50Q1502 1356 1479.50 1342.50Q1457 1329 1428 1324Q1399 1319 1368 1319L1368 1319L1277 1319L1277 1562Z"
         }
      }
   ]
}

var CSharp = {
   name: "CSharp",
   vendor: "UiFabric",
   unicode: 62192,
   value: "",
   charCode: "F2F0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128ZM1801 1801L1801 247L247 247L247 1801L1801 1801ZM873 1664L873 1664Q790 1664 724 1636.50Q658 1609 612 1560Q566 1511 541.50 1443Q517 1375 517 1294L517 1294Q517 1208 544.50 1135Q572 1062 622.50 1009Q673 956 744 926Q815 896 903 896L903 896Q948 896 994 902Q1040 908 1082 927L1082 927L1082 1049Q1044 1026 1002 1015Q960 1004 916 1004L916 1004Q852 1004 802 1025.50Q752 1047 717.50 1084.50Q683 1122 664.50 1174.50Q646 1227 646 1288L646 1288Q646 1346 663 1395Q680 1444 712.50 1480Q745 1516 792 1536Q839 1556 899 1556L899 1556Q948 1556 994 1544.50Q1040 1533 1082 1507L1082 1507L1082 1620Q1034 1645 980.50 1654.50Q927 1664 873 1664ZM1239 1536L1278 1355L1166 1355L1179 1287L1293 1287L1320 1152L1201 1152L1215 1084L1334 1084L1373 896L1451 896L1413 1084L1531 1084L1571 896L1648 896L1609 1084L1720 1084L1705 1152L1594 1152L1566 1287L1687 1287L1670 1355L1552 1355L1512 1536L1434 1536L1473 1355L1355 1355L1317 1536L1239 1536ZM1398 1152L1369 1287L1488 1287L1517 1152L1398 1152Z"
         }
      }
   ]
}

var JavaScriptLanguage = {
   name: "JavaScriptLanguage",
   vendor: "UiFabric",
   unicode: 62190,
   value: "",
   charCode: "F2EE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M385 1534L385 1534Q450 1534 489 1500.50Q528 1467 548.50 1417Q569 1367 575 1309Q581 1251 581 1201L581 1201L581 405L726 405L726 1199Q726 1281 709 1364Q692 1447 652 1513.50Q612 1580 546 1622Q480 1664 383 1664L383 1664Q353 1664 322.50 1660Q292 1656 264 1643L264 1643L264 1500Q290 1519 321.50 1526.50Q353 1534 385 1534ZM1136 702L1136 702Q1136 748 1153.50 783Q1171 818 1206 847L1206 847Q1250 883 1302 909.50Q1354 936 1405 961L1405 961Q1462 990 1520.50 1023.50Q1579 1057 1626.50 1101Q1674 1145 1703.50 1201.50Q1733 1258 1733 1331L1733 1331Q1733 1427 1694.50 1491Q1656 1555 1594 1593.50Q1532 1632 1452.50 1648Q1373 1664 1292 1664L1292 1664Q1261 1664 1218.50 1659Q1176 1654 1132 1645Q1088 1636 1048 1623Q1008 1610 982 1593L982 1593L982 1422Q1011 1448 1052.50 1468.50Q1094 1489 1139.50 1503.50Q1185 1518 1231 1526Q1277 1534 1315 1534L1315 1534Q1364 1534 1411.50 1526Q1459 1518 1496.50 1496Q1534 1474 1557.50 1437Q1581 1400 1581 1341L1581 1341Q1581 1289 1555.50 1249.50Q1530 1210 1488 1178Q1446 1146 1392 1118.50Q1338 1091 1282.50 1063Q1227 1035 1173 1003Q1119 971 1077 930.50Q1035 890 1009.50 837.50Q984 785 984 715L984 715Q984 627 1022.50 564.50Q1061 502 1122.50 462Q1184 422 1261 403Q1338 384 1414 384L1414 384Q1444 384 1479.50 385.50Q1515 387 1550.50 391.50Q1586 396 1619.50 405Q1653 414 1681 428L1681 428L1681 591Q1619 549 1546.50 532Q1474 515 1400 515L1400 515Q1356 515 1309.50 524.50Q1263 534 1224.50 555.50Q1186 577 1161 613Q1136 649 1136 702Z"
         }
      }
   ]
}

var FileLess = {
   name: "FileLess",
   vendor: "UiFabric",
   unicode: 62188,
   value: "",
   charCode: "F2EC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L384 1920L384 2048L128 2048L128 0L1243 0L1792 549L1792 1408L1664 1408L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM512 256L512 384L384 384L384 256L512 256ZM384 640L384 512L512 512L512 640L384 640ZM512 768L512 896L384 896L384 768L512 768ZM512 2038L512 1408L609 1408L609 2038L512 2038ZM942 1536L942 1536Q998 1536 1037.50 1555Q1077 1574 1102.50 1607Q1128 1640 1140 1684.50Q1152 1729 1152 1780L1152 1780L1152 1822L819 1822Q821 1893 862 1928Q903 1963 971 1963L971 1963Q1048 1963 1114 1917L1114 1917L1114 2006Q1075 2031 1029 2039.50Q983 2048 938 2048L938 2048Q879 2048 835.50 2029Q792 2010 763.50 1976.50Q735 1943 721 1896.50Q707 1850 707 1794L707 1794Q707 1742 723 1695.50Q739 1649 769.50 1613.50Q800 1578 843.50 1557Q887 1536 942 1536ZM819 1744L1045 1744Q1045 1719 1039.50 1696Q1034 1673 1021.50 1656Q1009 1639 989 1628.50Q969 1618 941 1618L941 1618Q914 1618 893 1628.50Q872 1639 856.50 1656.50Q841 1674 831.50 1697Q822 1720 819 1744L819 1744ZM1338 1676L1338 1676Q1338 1699 1355.50 1713.50Q1373 1728 1399.50 1739Q1426 1750 1456.50 1761Q1487 1772 1513.50 1789.50Q1540 1807 1557.50 1833.50Q1575 1860 1575 1901L1575 1901Q1575 1942 1555 1970.50Q1535 1999 1504.50 2016Q1474 2033 1437 2040.50Q1400 2048 1366 2048L1366 2048Q1330 2048 1295 2042Q1260 2036 1227 2021L1227 2021L1227 1919Q1257 1942 1291.50 1954Q1326 1966 1364 1966L1364 1966Q1379 1966 1396.50 1964Q1414 1962 1429.50 1956Q1445 1950 1455 1938.50Q1465 1927 1465 1907L1465 1907Q1465 1883 1447.50 1868.50Q1430 1854 1403.50 1843Q1377 1832 1346.50 1821.50Q1316 1811 1289.50 1794Q1263 1777 1245.50 1750.50Q1228 1724 1228 1681L1228 1681Q1228 1642 1246.50 1614.50Q1265 1587 1294.50 1569.50Q1324 1552 1359 1544Q1394 1536 1427 1536L1427 1536Q1458 1536 1489 1540.50Q1520 1545 1549 1556L1549 1556L1549 1654Q1496 1618 1431 1618L1431 1618Q1418 1618 1402 1620.50Q1386 1623 1371.50 1630Q1357 1637 1347.50 1648Q1338 1659 1338 1676ZM1760 1676L1760 1676Q1760 1700 1777.50 1714Q1795 1728 1821 1739Q1847 1750 1878 1761Q1909 1772 1935 1789.50Q1961 1807 1978.50 1833Q1996 1859 1996 1901L1996 1901Q1996 1943 1976.50 1971Q1957 1999 1926.50 2016Q1896 2033 1859 2040.50Q1822 2048 1788 2048L1788 2048Q1753 2048 1717 2042Q1681 2036 1649 2021L1649 2021L1649 1919Q1679 1942 1713.50 1954Q1748 1966 1786 1966L1786 1966Q1801 1966 1818.50 1964Q1836 1962 1851.50 1956Q1867 1950 1877 1938.50Q1887 1927 1887 1907L1887 1907Q1887 1883 1869.50 1868.50Q1852 1854 1825.50 1843Q1799 1832 1768.50 1821.50Q1738 1811 1711.50 1794Q1685 1777 1667.50 1750.50Q1650 1724 1650 1681L1650 1681Q1650 1642 1668.50 1614.50Q1687 1587 1716.50 1569.50Q1746 1552 1781 1544Q1816 1536 1849 1536L1849 1536Q1880 1536 1911 1540.50Q1942 1545 1971 1556L1971 1556L1971 1654Q1918 1618 1852 1618L1852 1618Q1839 1618 1823 1620.50Q1807 1623 1793 1630Q1779 1637 1769.50 1648Q1760 1659 1760 1676Z"
         }
      }
   ]
}

var FileCSS = {
   name: "FileCSS",
   vendor: "UiFabric",
   unicode: 62186,
   value: "",
   charCode: "F2EA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1243 0L1792 549L1792 2048L128 2048L128 0L1243 0ZM1280 219L1280 512L1573 512L1280 219ZM256 1920L1664 1920L1664 640L1152 640L1152 128L256 128L256 1920ZM576 1792L1472 896L1536 896L1536 1792L1408 1792L1408 1536L987 1536L731 1792L576 1792ZM1408 1408L1408 1115L1115 1408L1408 1408ZM384 384L384 256L512 256L512 384L384 384ZM384 640L384 512L512 512L512 640L384 640ZM384 896L384 768L512 768L512 896L384 896Z"
         }
      }
   ]
}

var FileJAVA = {
   name: "FileJAVA",
   vendor: "UiFabric",
   unicode: 62184,
   value: "",
   charCode: "F2E8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1280L128 1280L128 0L1243 0L1792 549L1792 1280L1664 1280L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM104 1957L104 1957Q138 1957 158.50 1942Q179 1927 190 1903Q201 1879 205 1850.50Q209 1822 209 1795L209 1795L209 1408L313 1408L313 1812Q313 1860 301.50 1903Q290 1946 265 1978Q240 2010 202 2029Q164 2048 111 2048L111 2048Q93 2048 75 2046.50Q57 2045 40 2038L40 2038L40 1940Q54 1949 70.50 1953Q87 1957 104 1957ZM607 1408L725 1408L959 2038L844 2038L788 1877L540 1877L486 2038L372 2038L607 1408ZM568 1792L760 1792L673 1541Q670 1531 667.50 1521.50Q665 1512 663 1502L663 1502Q660 1524 654 1541L654 1541L568 1792ZM1378 1408L1488 1408L1262 2038L1146 2038L923 1408L1038 1408L1193 1886Q1198 1899 1200.50 1912Q1203 1925 1206 1939L1206 1939Q1208 1925 1211 1912Q1214 1899 1219 1885L1219 1885L1378 1408ZM1806 1408L2040 2038L1925 2038L1869 1877L1621 1877L1567 2038L1452 2038L1688 1408L1806 1408ZM1648 1792L1841 1792L1753 1541Q1750 1532 1748 1522Q1746 1512 1743 1504L1743 1504Q1741 1513 1739.50 1523Q1738 1533 1735 1541L1735 1541L1648 1792Z"
         }
      }
   ]
}

var FileTemplate = {
   name: "FileTemplate",
   vendor: "UiFabric",
   unicode: 62182,
   value: "",
   charCode: "F2E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 0L1243 0L1792 549L1792 768L1664 768L1664 640L1152 640L1152 128L256 128L256 1920L1024 1920L1024 2048L128 2048L128 0ZM1280 219L1280 512L1573 512L1280 219ZM1920 2048L1920 1920L2048 1920L2048 2048L1920 2048ZM1664 2048L1664 1920L1792 1920L1792 2048L1664 2048ZM1408 2048L1408 1920L1536 1920L1536 2048L1408 2048ZM1664 1024L1664 896L1792 896L1792 1024L1664 1024ZM1408 1024L1408 896L1536 896L1536 1024L1408 1024ZM1152 2048L1152 1920L1280 1920L1280 2048L1152 2048ZM1920 1792L1920 1664L2048 1664L2048 1792L1920 1792ZM1152 1792L1152 1664L1280 1664L1280 1792L1152 1792ZM1920 1536L1920 1408L2048 1408L2048 1536L1920 1536ZM1152 1536L1152 1408L1280 1408L1280 1536L1152 1536ZM1920 1280L1920 1152L2048 1152L2048 1280L1920 1280ZM1152 1280L1152 1152L1280 1152L1280 1280L1152 1280ZM1920 896L2048 896L2048 1024L1920 1024L1920 896ZM1152 1024L1152 896L1280 896L1280 1024L1152 1024Z"
         }
      }
   ]
}

var CircleAdditionSolid = {
   name: "CircleAdditionSolid",
   vendor: "UiFabric",
   unicode: 62180,
   value: "",
   charCode: "F2E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1215Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q828 1920 705 1885.50Q582 1851 475.50 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444.50Q69 1338 34.50 1215.50Q0 1093 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 704.50 34.50Q827 0 960 0ZM1536 1024L1536 896L1024 896L1024 384L896 384L896 896L384 896L384 1024L896 1024L896 1536L1024 1536L1024 1024L1536 1024Z"
         }
      }
   ]
}

var UnknownMirroredSolid = {
   name: "UnknownMirroredSolid",
   vendor: "UiFabric",
   unicode: 62178,
   value: "",
   charCode: "F2E2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q828 0 705 34.50Q582 69 475.50 131.50Q369 194 281.50 281.50Q194 369 131.50 475.50Q69 582 34.50 705Q0 828 0 960L0 960Q0 1092 34.50 1215Q69 1338 131.50 1444.50Q194 1551 281.50 1638.50Q369 1726 475.50 1788.50Q582 1851 705 1885.50Q828 1920 960 1920L960 1920Q1092 1920 1215 1885.50Q1338 1851 1444.50 1788.50Q1551 1726 1638.50 1638.50Q1726 1551 1788.50 1444.50Q1851 1338 1885.50 1215.50Q1920 1093 1920 960L1920 960Q1920 828 1885.50 705Q1851 582 1788.50 475.50Q1726 369 1638.50 281.50Q1551 194 1444.50 131.50Q1338 69 1215.50 34.50Q1093 0 960 0ZM896 1536L896 1408L1024 1408L1024 1536L896 1536ZM888 1280L888 1239Q888 1202 881 1169Q874 1136 845 1107L845 1107Q806 1068 768 1032.50Q730 997 699.50 958Q669 919 650.50 873Q632 827 632 768L632 768Q632 700 658 640.50Q684 581 728.50 536.50Q773 492 832.50 466Q892 440 960 440L960 440Q1028 440 1087.50 466Q1147 492 1191.50 536.50Q1236 581 1262 640.50Q1288 700 1288 768L1288 768L1144 768Q1144 730 1129.50 696.50Q1115 663 1090 638Q1065 613 1031.50 598.50Q998 584 960 584L960 584Q922 584 888.50 598.50Q855 613 830 638Q805 663 790.50 696.50Q776 730 776 768L776 768Q776 809 795 841Q814 873 842.50 902.50Q871 932 904 962Q937 992 965.50 1028Q994 1064 1013 1109.50Q1032 1155 1032 1216L1032 1216L1032 1280L888 1280Z"
         }
      }
   ]
}

var NavigateForwardMirrored = {
   name: "NavigateForwardMirrored",
   vendor: "UiFabric",
   unicode: 62176,
   value: "",
   charCode: "F2E0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q827 0 704.50 34Q582 68 475 130.50Q368 193 280.50 280.50Q193 368 130.50 475Q68 582 34 704.50Q0 827 0 960L0 960Q0 1093 34 1215.50Q68 1338 130.50 1445Q193 1552 280.50 1639.50Q368 1727 475 1789.50Q582 1852 704.50 1886Q827 1920 960 1920L960 1920Q1093 1920 1215.50 1886Q1338 1852 1445 1789.50Q1552 1727 1639.50 1639.50Q1727 1552 1789.50 1445Q1852 1338 1886 1215.50Q1920 1093 1920 960L1920 960Q1920 827 1886 704.50Q1852 582 1789.50 475Q1727 368 1639.50 280.50Q1552 193 1445 130.50Q1338 68 1215.50 34Q1093 0 960 0ZM960 1792L960 1792Q845 1792 739 1762Q633 1732 540.50 1678Q448 1624 372 1548Q296 1472 242 1379.50Q188 1287 158 1181Q128 1075 128 960L128 960Q128 845 158 739Q188 633 242 540.50Q296 448 372 372Q448 296 540.50 242Q633 188 739 158Q845 128 960 128L960 128Q1075 128 1181 158Q1287 188 1379.50 242Q1472 296 1548 372Q1624 448 1678 540.50Q1732 633 1762 739Q1792 845 1792 960L1792 960Q1792 1075 1762 1181Q1732 1287 1678 1379.50Q1624 1472 1548 1548Q1472 1624 1379.50 1678Q1287 1732 1181 1762Q1075 1792 960 1792ZM727 896L1005 622L915 530L481 960L915 1390L1005 1298L727 1024L1408 1024L1408 896L727 896Z"
         }
      }
   ]
}

var NavigateBackMirrored = {
   name: "NavigateBackMirrored",
   vendor: "UiFabric",
   unicode: 62174,
   value: "",
   charCode: "F2DE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q827 0 704.50 34Q582 68 475 130.50Q368 193 280.50 280.50Q193 368 130.50 475Q68 582 34 704.50Q0 827 0 960L0 960Q0 1093 34 1215.50Q68 1338 130.50 1445Q193 1552 280.50 1639.50Q368 1727 475 1789.50Q582 1852 704.50 1886Q827 1920 960 1920L960 1920Q1093 1920 1215.50 1886Q1338 1852 1445 1789.50Q1552 1727 1639.50 1639.50Q1727 1552 1789.50 1445Q1852 1338 1886 1215.50Q1920 1093 1920 960L1920 960Q1920 827 1886 704.50Q1852 582 1789.50 475Q1727 368 1639.50 280.50Q1552 193 1445 130.50Q1338 68 1215.50 34Q1093 0 960 0ZM960 1792L960 1792Q845 1792 739 1762Q633 1732 540.50 1678Q448 1624 372 1548Q296 1472 242 1379.50Q188 1287 158 1181Q128 1075 128 960L128 960Q128 845 158 739Q188 633 242 540.50Q296 448 372 372Q448 296 540.50 242Q633 188 739 158Q845 128 960 128L960 128Q1075 128 1181 158Q1287 188 1379.50 242Q1472 296 1548 372Q1624 448 1678 540.50Q1732 633 1762 739Q1792 845 1792 960L1792 960Q1792 1075 1762 1181Q1732 1287 1678 1379.50Q1624 1472 1548 1548Q1472 1624 1379.50 1678Q1287 1732 1181 1762Q1075 1792 960 1792ZM915 622L1193 896L512 896L512 1024L1193 1024L915 1298L1005 1390L1439 960L1005 530L915 622Z"
         }
      }
   ]
}

var CircleStop = {
   name: "CircleStop",
   vendor: "UiFabric",
   unicode: 62172,
   value: "",
   charCode: "F2DC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1920L1024 1920Q1148 1920 1262.50 1888Q1377 1856 1476.50 1797.50Q1576 1739 1657.50 1657.50Q1739 1576 1797.50 1476.50Q1856 1377 1888 1262.50Q1920 1148 1920 1024L1920 1024Q1920 900 1888 785.50Q1856 671 1797.50 571.50Q1739 472 1657.50 390.50Q1576 309 1476.50 250.50Q1377 192 1262.50 160Q1148 128 1024 128L1024 128Q900 128 785.50 160Q671 192 571.50 250.50Q472 309 390.50 390.50Q309 472 250.50 571.50Q192 671 160 785.50Q128 900 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250.50 1476.50Q309 1576 390.50 1657.50Q472 1739 571.50 1797.50Q671 1856 785.50 1888Q900 1920 1024 1920ZM640 1408L640 640L1408 640L1408 1408L640 1408ZM768 768L768 1280L1280 1280L1280 768L768 768Z"
         }
      }
   ]
}

var MSNVideosSolid = {
   name: "MSNVideosSolid",
   vendor: "UiFabric",
   unicode: 62170,
   value: "",
   charCode: "F2DA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM768 1536L1536 1021L768 512L768 1536Z"
         }
      }
   ]
}

var CirclePauseSolid = {
   name: "CirclePauseSolid",
   vendor: "UiFabric",
   unicode: 62168,
   value: "",
   charCode: "F2D8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM896 1408L896 640L768 640L768 1408L896 1408ZM1280 1408L1280 640L1152 640L1152 1408L1280 1408Z"
         }
      }
   ]
}

var BoxPlaySolid = {
   name: "BoxPlaySolid",
   vendor: "UiFabric",
   unicode: 62166,
   value: "",
   charCode: "F2D6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1920 0L1920 1920L0 1920L0 0ZM576 1472L1344 957L576 448L576 1472Z"
         }
      }
   ]
}

var BoxAdditionSolid = {
   name: "BoxAdditionSolid",
   vendor: "UiFabric",
   unicode: 62164,
   value: "",
   charCode: "F2D4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1920 0L1920 1920L0 1920L0 0ZM1536 1024L1536 896L1024 896L1024 384L896 384L896 896L384 896L384 1024L896 1024L896 1536L1024 1536L1024 1024L1536 1024Z"
         }
      }
   ]
}

var CalculatorNotEqualTo = {
   name: "CalculatorNotEqualTo",
   vendor: "UiFabric",
   unicode: 62162,
   value: "",
   charCode: "F2D2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 640L1432 640L685 1280L1920 1280L1920 1408L536 1408L106 1777L22 1679L339 1408L0 1408L0 1280L488 1280L1235 640L0 640L0 512L1384 512L1814 143L1898 241L1581 512L1920 512L1920 640Z"
         }
      }
   ]
}

var LocationOutline = {
   name: "LocationOutline",
   vendor: "UiFabric",
   unicode: 62160,
   value: "",
   charCode: "F2D0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q1148 128 1262.50 160Q1377 192 1476.50 250.50Q1576 309 1657.50 390.50Q1739 472 1797.50 571.50Q1856 671 1888 785.50Q1920 900 1920 1024L1920 1024Q1920 1148 1888 1262.50Q1856 1377 1797.50 1476.50Q1739 1576 1657.50 1657.50Q1576 1739 1476.50 1797.50Q1377 1856 1262.50 1888Q1148 1920 1024 1920L1024 1920Q900 1920 785.50 1888Q671 1856 571.50 1797.50Q472 1739 390.50 1657.50Q309 1576 250.50 1476.50Q192 1377 160 1262.50Q128 1148 128 1024L128 1024Q128 900 160 785.50Q192 671 250.50 571.50Q309 472 390.50 390.50Q472 309 571.50 250.50Q671 192 785.50 160Q900 128 1024 128ZM1024 1792L1024 1792Q1130 1792 1228 1764.50Q1326 1737 1411.50 1687Q1497 1637 1567 1567Q1637 1497 1687 1411.50Q1737 1326 1764.50 1228Q1792 1130 1792 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792ZM1024 640L1024 640Q1103 640 1173 670Q1243 700 1295.50 752.50Q1348 805 1378 875Q1408 945 1408 1024L1408 1024Q1408 1104 1378 1173.50Q1348 1243 1295.50 1295.50Q1243 1348 1173 1378Q1103 1408 1024 1408L1024 1408Q944 1408 874.50 1378Q805 1348 752.50 1295.50Q700 1243 670 1173.50Q640 1104 640 1024L640 1024Q640 945 670 875Q700 805 752.50 752.50Q805 700 874.50 670Q944 640 1024 640ZM1024 1280L1024 1280Q1077 1280 1123.50 1260Q1170 1240 1205 1205Q1240 1170 1260 1123.50Q1280 1077 1280 1024L1280 1024Q1280 971 1260 924.50Q1240 878 1205 843Q1170 808 1123.50 788Q1077 768 1024 768L1024 768Q971 768 924.50 788Q878 808 843 843Q808 878 788 924.50Q768 971 768 1024L768 1024Q768 1077 788 1123.50Q808 1170 843 1205Q878 1240 924.50 1260Q971 1280 1024 1280Z"
         }
      }
   ]
}

var FolderList = {
   name: "FolderList",
   vendor: "UiFabric",
   unicode: 62158,
   value: "",
   charCode: "F2CE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 1280L1920 1280L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L1024 1664L1024 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM1408 2048L1408 1920L2048 1920L2048 2048L1408 2048ZM1152 2048L1152 1920L1280 1920L1280 2048L1152 2048ZM1152 1792L1152 1664L1280 1664L1280 1792L1152 1792ZM1408 1792L1408 1664L2048 1664L2048 1792L1408 1792ZM1152 1536L1152 1408L1280 1408L1280 1536L1152 1536ZM1408 1536L1408 1408L2048 1408L2048 1536L1408 1536Z"
         }
      }
   ]
}

var RepoSolid = {
   name: "RepoSolid",
   vendor: "UiFabric",
   unicode: 62156,
   value: "",
   charCode: "F2CC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1536L1280 768L1920 768L1920 1920L128 1920L128 768L768 768L768 1536L1024 1408L1280 1536ZM0 128L2048 128L2048 640L0 640L0 128Z"
         }
      }
   ]
}

var GitGraph = {
   name: "GitGraph",
   vendor: "UiFabric",
   unicode: 62154,
   value: "",
   charCode: "F2CA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1024L1600 1024Q1666 1024 1724 1049.50Q1782 1075 1825.50 1118.50Q1869 1162 1894.50 1220Q1920 1278 1920 1344L1920 1344Q1920 1410 1894.50 1468.50Q1869 1527 1825.50 1570.50Q1782 1614 1724 1639Q1666 1664 1600 1664L1600 1664Q1543 1664 1491 1644.50Q1439 1625 1397 1590.50Q1355 1556 1326 1509Q1297 1462 1286 1406L1286 1406Q1187 1400 1093.50 1370Q1000 1340 917 1290Q834 1240 763.50 1172Q693 1104 640 1020L640 1020L640 1414Q696 1426 743 1455Q790 1484 824 1525.50Q858 1567 877 1619Q896 1671 896 1728L896 1728Q896 1794 870.50 1852.50Q845 1911 801.50 1954.50Q758 1998 700 2023Q642 2048 576 2048L576 2048Q510 2048 451.50 2023Q393 1998 349.50 1954.50Q306 1911 281 1852.50Q256 1794 256 1728L256 1728Q256 1671 275 1619Q294 1567 328 1525.50Q362 1484 409 1455Q456 1426 512 1414L512 1414L512 634Q456 622 409 593Q362 564 328 522.50Q294 481 275 429Q256 377 256 320L256 320Q256 254 281 196Q306 138 349.50 94.50Q393 51 451.50 25.50Q510 0 576 0L576 0Q642 0 700 25.50Q758 51 801.50 94.50Q845 138 870.50 196Q896 254 896 320L896 320Q896 377 877 428.50Q858 480 824.50 521.50Q791 563 744 592Q697 621 642 633L642 633Q652 762 706 874.50Q760 987 846.50 1073.50Q933 1160 1045.50 1214Q1158 1268 1287 1278L1287 1278Q1299 1223 1328 1176Q1357 1129 1398.50 1095.50Q1440 1062 1491.50 1043Q1543 1024 1600 1024ZM1600 1536L1600 1536Q1640 1536 1675 1521Q1710 1506 1736 1480Q1762 1454 1777 1419Q1792 1384 1792 1344L1792 1344Q1792 1304 1777 1269Q1762 1234 1736 1208Q1710 1182 1675 1167Q1640 1152 1600 1152L1600 1152Q1560 1152 1525 1167Q1490 1182 1464 1208Q1438 1234 1423 1269Q1408 1304 1408 1344L1408 1344Q1408 1384 1423 1419Q1438 1454 1464 1480Q1490 1506 1525 1521Q1560 1536 1600 1536Z"
         }
      }
   ]
}

var BulletedList2Mirrored = {
   name: "BulletedList2Mirrored",
   vendor: "UiFabric",
   unicode: 62152,
   value: "",
   charCode: "F2C8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L0 384L0 512L1536 512L1536 384ZM1536 1024L1536 896L0 896L0 1024L1536 1024ZM1536 1536L1536 1408L0 1408L0 1536L1536 1536ZM2048 640L2048 256L1664 256L1664 640L2048 640ZM1920 384L1920 512L1792 512L1792 384L1920 384ZM2048 1152L2048 768L1664 768L1664 1152L2048 1152ZM1920 896L1920 1024L1792 1024L1792 896L1920 896ZM2048 1664L2048 1280L1664 1280L1664 1664L2048 1664ZM1920 1408L1920 1536L1792 1536L1792 1408L1920 1408Z"
         }
      }
   ]
}

var PlayResume = {
   name: "PlayResume",
   vendor: "UiFabric",
   unicode: 62150,
   value: "",
   charCode: "F2C6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1792L384 256L512 256L512 1792L384 1792ZM768 256L1856 1024L768 1792L768 256ZM896 503L896 1545L1634 1024L896 503Z"
         }
      }
   ]
}

var FieldNotChanged = {
   name: "FieldNotChanged",
   vendor: "UiFabric",
   unicode: 62148,
   value: "",
   charCode: "F2C4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1536L897 1536L846 1588L827 1664L0 1664L0 256L2048 256L2048 796Q2019 777 1986.50 765Q1954 753 1920 746L1920 746L1920 384L128 384L128 1536ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1772 910Q1808 896 1848 896ZM1207 1836L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836Z"
         }
      }
   ]
}

var FieldFilled = {
   name: "FieldFilled",
   vendor: "UiFabric",
   unicode: 62146,
   value: "",
   charCode: "F2C2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1664L0 1664L0 256ZM1920 1536L1920 384L128 384L128 1536L1920 1536ZM1792 512L1792 1408L256 1408L256 512L1792 512Z"
         }
      }
   ]
}

var ArrowTallDownRight = {
   name: "ArrowTallDownRight",
   vendor: "UiFabric",
   unicode: 62144,
   value: "",
   charCode: "F2C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 896L2048 896L2048 2048L896 2048L896 1920L1829 1920L19 109L109 19L1920 1829L1920 896Z"
         }
      }
   ]
}

var ArrowTallUpRight = {
   name: "ArrowTallUpRight",
   vendor: "UiFabric",
   unicode: 62142,
   value: "",
   charCode: "F2BE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 0L2048 0L2048 1152L1920 1152L1920 219L109 2029L19 1939L1829 128L896 128L896 0Z"
         }
      }
   ]
}

var MoreVertical = {
   name: "MoreVertical",
   vendor: "UiFabric",
   unicode: 62140,
   value: "",
   charCode: "F2BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1664L1024 1664Q1051 1664 1074 1674Q1097 1684 1114.50 1701.50Q1132 1719 1142 1742Q1152 1765 1152 1792L1152 1792Q1152 1819 1142 1842Q1132 1865 1114.50 1882.50Q1097 1900 1074 1910Q1051 1920 1024 1920L1024 1920Q997 1920 974 1910Q951 1900 933.50 1882.50Q916 1865 906 1842Q896 1819 896 1792L896 1792Q896 1765 906 1742Q916 1719 933.50 1701.50Q951 1684 974 1674Q997 1664 1024 1664ZM1024 896L1024 896Q1051 896 1074 906Q1097 916 1114.50 933.50Q1132 951 1142 974Q1152 997 1152 1024L1152 1024Q1152 1051 1142 1074Q1132 1097 1114.50 1114.50Q1097 1132 1074 1142Q1051 1152 1024 1152L1024 1152Q997 1152 974 1142Q951 1132 933.50 1114.50Q916 1097 906 1074Q896 1051 896 1024L896 1024Q896 997 906 974Q916 951 933.50 933.50Q951 916 974 906Q997 896 1024 896ZM1024 384L1024 384Q997 384 974 374Q951 364 933.50 346.50Q916 329 906 306Q896 283 896 256L896 256Q896 229 906 206Q916 183 933.50 165.50Q951 148 974 138Q997 128 1024 128L1024 128Q1051 128 1074 138Q1097 148 1114.50 165.50Q1132 183 1142 206Q1152 229 1152 256L1152 256Q1152 283 1142 306Q1132 329 1114.50 346.50Q1097 364 1074 374Q1051 384 1024 384Z"
         }
      }
   ]
}

var UserPause = {
   name: "UserPause",
   vendor: "UiFabric",
   unicode: 62138,
   value: "",
   charCode: "F2BA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1168 946L1168 946Q1254 979 1329.50 1031Q1405 1083 1467 1152L1467 1152L1278 1152Q1195 1090 1097.50 1057Q1000 1024 896 1024L896 1024Q808 1024 726 1047Q644 1070 573 1111.50Q502 1153 443.50 1211.50Q385 1270 343.50 1341Q302 1412 279 1494Q256 1576 256 1664L256 1664L128 1664Q128 1544 163.50 1433Q199 1322 264 1228Q329 1134 420.50 1061Q512 988 624 946L624 946Q511 872 447.50 760Q384 648 384 512L384 512Q384 406 424 312.50Q464 219 533.50 149.50Q603 80 696.50 40Q790 0 896 0L896 0Q1002 0 1095.50 40Q1189 80 1258.50 149.50Q1328 219 1368 312.50Q1408 406 1408 512L1408 512Q1408 578 1391.50 641Q1375 704 1344 760Q1313 816 1268.50 863.50Q1224 911 1168 946ZM512 512L512 512Q512 592 542 661.50Q572 731 624.50 783.50Q677 836 746.50 866Q816 896 896 896L896 896Q975 896 1045 866Q1115 836 1167.50 783.50Q1220 731 1250 661.50Q1280 592 1280 512L1280 512Q1280 433 1250 363Q1220 293 1167.50 240.50Q1115 188 1045 158Q975 128 896 128L896 128Q816 128 746.50 158Q677 188 624.50 240.50Q572 293 542 363Q512 433 512 512ZM1792 1280L1920 1280L1920 2048L1792 2048L1792 1280ZM1408 2048L1408 1280L1536 1280L1536 2048L1408 2048Z"
         }
      }
   ]
}

var QueryList = {
   name: "QueryList",
   vendor: "UiFabric",
   unicode: 62136,
   value: "",
   charCode: "F2B8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L0 128L0 0L1664 0ZM1664 512L1664 640L0 640L0 512L1664 512ZM0 1152L0 1024L768 1024L768 1152L0 1152ZM896 1024L2048 1024L2048 1243L1664 1627L1664 2048L1280 2048L1280 1627L896 1243L896 1024ZM1920 1189L1920 1152L1024 1152L1024 1189L1408 1573L1408 1920L1536 1920L1536 1573L1920 1189Z"
         }
      }
   ]
}

var ShopServer = {
   name: "ShopServer",
   vendor: "UiFabric",
   unicode: 62134,
   value: "",
   charCode: "F2B6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 640L256 1792Q256 1819 266 1842Q276 1865 293.50 1882.50Q311 1900 334 1910Q357 1920 384 1920L384 1920L1024 1920L1024 2048L384 2048Q331 2048 284.50 2028Q238 2008 203 1973Q168 1938 148 1891.50Q128 1845 128 1792L128 1792L128 512L384 512L384 384Q384 305 414 235Q444 165 496.50 112.50Q549 60 618.50 30Q688 0 768 0L768 0Q872 0 961 52L961 52Q1050 0 1152 0L1152 0Q1231 0 1301 30Q1371 60 1423.50 112.50Q1476 165 1506 235Q1536 305 1536 384L1536 384L1536 512L1792 512L1792 640L256 640ZM1408 512L1408 384Q1408 331 1388 284.50Q1368 238 1333 203Q1298 168 1251.50 148Q1205 128 1152 128L1152 128Q1107 128 1067 143L1067 143Q1096 179 1113 214Q1130 249 1138.50 284Q1147 319 1149.50 355.50Q1152 392 1152 432L1152 432L1152 512L1408 512ZM512 384L512 512L1024 512L1024 384Q1024 331 1004 284.50Q984 238 949 203Q914 168 867.50 148Q821 128 768 128L768 128Q715 128 668.50 148Q622 168 587 203Q552 238 532 284.50Q512 331 512 384L512 384ZM1280 768L1920 768Q1947 768 1970 778Q1993 788 2010.50 805.50Q2028 823 2038 846Q2048 869 2048 896L2048 896L2048 2048L1152 2048L1152 896Q1152 869 1162 846Q1172 823 1189.50 805.50Q1207 788 1230 778Q1253 768 1280 768L1280 768ZM1920 1920L1920 896L1280 896L1280 1920L1920 1920ZM1792 1664L1792 1792L1408 1792L1408 1664L1792 1664ZM1792 1408L1792 1536L1408 1536L1408 1408L1792 1408ZM1792 1024L1792 1152L1408 1152L1408 1024L1792 1024Z"
         }
      }
   ]
}

var CommentNext = {
   name: "CommentNext",
   vendor: "UiFabric",
   unicode: 62132,
   value: "",
   charCode: "F2B4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1155L1920 1027L1920 256L128 256L128 1408L384 1408L384 1701L677 1408L896 1408L896 1536L731 1536L256 2011L256 1536L0 1536L0 128ZM1603 1245L1693 1155L2011 1472L1693 1789L1603 1699L1766 1536L1152 1536L1152 1408L1766 1408L1603 1245Z"
         }
      }
   ]
}

var NewTeamProject = {
   name: "NewTeamProject",
   vendor: "UiFabric",
   unicode: 62130,
   value: "",
   charCode: "F2B2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L608 256Q653 256 685.50 265.50Q718 275 743.50 289Q769 303 789 320Q809 337 829.50 351Q850 365 873.50 374.50Q897 384 928 384L928 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512L2048 512L2048 1408L1920 1408L1920 512L928 512Q897 512 873.50 521.50Q850 531 829.50 545Q809 559 789 576Q769 593 743.50 607Q718 621 685.50 630.50Q653 640 608 640L608 640L128 640L128 1664L1152 1664L1152 1792L0 1792L0 384Q0 357 10 334Q20 311 37.50 293.50Q55 276 78 266Q101 256 128 256L128 256ZM128 512L608 512Q632 512 650 507.50Q668 503 683 494.50Q698 486 712.50 474.50Q727 463 744 448L744 448Q727 433 712.50 421.50Q698 410 683 401.50Q668 393 650 388.50Q632 384 608 384L608 384L128 384L128 512ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408ZM1363 851L1453 941L1024 1371L595 941L685 851L1024 1189L1363 851Z"
         }
      }
   ]
}

var ScopeTemplate = {
   name: "ScopeTemplate",
   vendor: "UiFabric",
   unicode: 62128,
   value: "",
   charCode: "F2B0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 512L256 1792L768 1792L768 1920L128 1920L128 0L1920 0L1920 768L1792 768L1792 512L256 512ZM1792 128L256 128L256 384L1792 384L1792 128ZM896 1280L896 896L1280 896L1280 1024L1024 1024L1024 1280L896 1280ZM1664 896L2048 896L2048 1280L1920 1280L1920 1024L1664 1024L1664 896ZM1024 1664L1024 1920L1280 1920L1280 2048L896 2048L896 1664L1024 1664ZM1920 1920L1920 1664L2048 1664L2048 2048L1664 2048L1664 1920L1920 1920Z"
         }
      }
   ]
}

var TaskGroup = {
   name: "TaskGroup",
   vendor: "UiFabric",
   unicode: 62126,
   value: "",
   charCode: "F2AE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1152L0 1152L0 256ZM1920 1024L1920 384L128 384L128 1024L1920 1024ZM1792 512L1792 640L768 640L768 512L1792 512ZM1408 768L1408 896L768 896L768 768L1408 768ZM640 512L640 896L256 896L256 512L640 512ZM512 768L512 640L384 640L384 768L512 768ZM256 1408L256 1280L1792 1280L1792 1408L256 1408ZM512 1664L512 1536L1536 1536L1536 1664L512 1664Z"
         }
      }
   ]
}

var Backlog = {
   name: "Backlog",
   vendor: "UiFabric",
   unicode: 62124,
   value: "",
   charCode: "F2AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 640L128 256L640 256L640 640L128 640ZM256 384L256 512L512 512L512 384L256 384ZM128 1152L128 768L640 768L640 1152L128 1152ZM256 896L256 1024L512 1024L512 896L256 896ZM768 640L768 256L1280 256L1280 640L768 640ZM896 384L896 512L1152 512L1152 384L896 384ZM1408 256L1920 256L1920 640L1408 640L1408 256ZM1792 512L1792 384L1536 384L1536 512L1792 512ZM768 1152L768 768L1280 768L1280 1152L768 1152ZM896 896L896 1024L1152 1024L1152 896L896 896ZM128 1664L128 1280L640 1280L640 1664L128 1664ZM256 1408L256 1536L512 1536L512 1408L256 1408Z"
         }
      }
   ]
}

var TimelineProgress = {
   name: "TimelineProgress",
   vendor: "UiFabric",
   unicode: 62122,
   value: "",
   charCode: "F2AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 768L256 640L896 640L896 768L256 768ZM1280 1280L1280 1152L1792 1152L1792 1280L1280 1280ZM0 256L2048 256L2048 1664L0 1664L0 256ZM1921 1537L1921 384L1407 384L1407 768L1280 768L1280 384L768 384L768 512L640 512L640 384L128 384L128 1537L640 1537L640 896L768 896L768 1537L1280 1537L1280 1408L1407 1408L1407 1537L1921 1537ZM897 1024L897 896L1536 896L1536 1024L897 1024Z"
         }
      }
   ]
}

var VisioLogoFill = {
   name: "VisioLogoFill",
   vendor: "UiFabric",
   unicode: 62120,
   value: "",
   charCode: "F2A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var IconSetsFlag = {
   name: "IconSetsFlag",
   vendor: "UiFabric",
   unicode: 62116,
   value: "",
   charCode: "F2A4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 2048L256 0L384 0L384 2048L256 2048ZM512 4L2038 576L512 1148L512 4ZM640 188L640 964L1674 576L640 188Z"
         }
      }
   ]
}

var TextCallout = {
   name: "TextCallout",
   vendor: "UiFabric",
   unicode: 62114,
   value: "",
   charCode: "F2A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1664L0 1664L0 256ZM1920 1536L1920 384L128 384L128 1536L1920 1536ZM1664 896L1664 1024L1024 1024L1024 896L1664 896ZM768 896L768 1024L384 1024L384 896L768 896Z"
         }
      }
   ]
}

var VisioDiagram = {
   name: "VisioDiagram",
   vendor: "UiFabric",
   unicode: 62112,
   value: "",
   charCode: "F2A0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 768L2048 768L2048 1280L1152 1280L1152 1024L979 1024L640 1250L640 1408L1024 1408L1024 1920L128 1920L128 1408L512 1408L512 1250L77 960L512 670L512 512L384 512Q331 512 284.50 492Q238 472 203 437Q168 402 148 355.50Q128 309 128 256L128 256Q128 203 148 156.50Q168 110 203 75Q238 40 284.50 20Q331 0 384 0L384 0L768 0Q821 0 867.50 20Q914 40 949 75Q984 110 1004 156.50Q1024 203 1024 256L1024 256Q1024 309 1004 355.50Q984 402 949 437Q914 472 867.50 492Q821 512 768 512L768 512L640 512L640 670L979 896L1152 896L1152 768ZM384 384L768 384Q795 384 818 374Q841 364 858.50 346.50Q876 329 886 306Q896 283 896 256L896 256Q896 229 886 206Q876 183 858.50 165.50Q841 148 818 138Q795 128 768 128L768 128L384 128Q357 128 334 138Q311 148 293.50 165.50Q276 183 266 206Q256 229 256 256L256 256Q256 283 266 306Q276 329 293.50 346.50Q311 364 334 374Q357 384 384 384L384 384ZM896 1536L256 1536L256 1792L896 1792L896 1536ZM576 1139L845 960L576 781L307 960L576 1139ZM1920 1152L1920 896L1280 896L1280 1152L1920 1152Z"
         }
      }
   ]
}

var Redeploy = {
   name: "Redeploy",
   vendor: "UiFabric",
   unicode: 62110,
   value: "",
   charCode: "F29E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M659 1171L960 870L1261 1171L1171 1261L1024 1115L1024 1792L896 1792L896 1115L749 1261L659 1171ZM128 640L128 128L640 128L640 640L128 640ZM768 640L768 128L1280 128L1280 640L768 640ZM1408 128L1920 128L1920 640L1408 640L1408 128Z"
         }
      }
   ]
}

var RowsChild = {
   name: "RowsChild",
   vendor: "UiFabric",
   unicode: 62108,
   value: "",
   charCode: "F29C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1024L2048 1024L2048 1664L768 1664L768 1408L256 1408L256 896L0 896L0 256L1280 256L1280 896L384 896L384 1280L768 1280L768 1024ZM128 384L128 768L1152 768L1152 384L128 384ZM1920 1536L1920 1152L896 1152L896 1536L1920 1536Z"
         }
      }
   ]
}

var MergeDuplicate = {
   name: "MergeDuplicate",
   vendor: "UiFabric",
   unicode: 62106,
   value: "",
   charCode: "F29A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 347L1024 640Q1024 735 1051 825Q1078 915 1128 992Q1178 1069 1248.50 1130.50Q1319 1192 1406 1231L1406 1231Q1421 1238 1443 1246Q1465 1254 1489 1261.50Q1513 1269 1536 1274.50Q1559 1280 1575 1280L1575 1280Q1593 1281 1611 1281Q1629 1281 1647 1281L1647 1281Q1683 1281 1719.50 1280.50Q1756 1280 1792 1280L1792 1280L1792 2048L1024 2048L1024 1280L1240 1280Q1148 1218 1076.50 1133Q1005 1048 960 946L960 946Q915 1048 843.50 1133Q772 1218 680 1280L680 1280L896 1280L896 2048L128 2048L128 1280Q164 1280 200.50 1280.50Q237 1281 273 1281L273 1281Q291 1281 309 1281Q327 1281 345 1280L345 1280Q361 1280 384 1274.50Q407 1269 431 1261.50Q455 1254 477 1246Q499 1238 514 1231L514 1231Q601 1192 671.50 1130.50Q742 1069 792 992Q842 915 869 825Q896 735 896 640L896 640L896 347L605 637L515 547L960 102L1405 547L1315 637L1024 347ZM768 1408L256 1408L256 1920L768 1920L768 1408ZM1664 1920L1664 1408L1152 1408L1152 1920L1664 1920Z"
         }
      }
   ]
}

var Wheelchair = {
   name: "Wheelchair",
   vendor: "UiFabric",
   unicode: 62239,
   value: "",
   charCode: "F31F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1369 896L1728 896Q1768 896 1803 911Q1838 926 1864 952Q1890 978 1905 1012.50Q1920 1047 1920 1087L1920 1087Q1920 1109 1916 1126L1916 1126L1788 1766Q1781 1799 1763.50 1827.50Q1746 1856 1721 1876.50Q1696 1897 1665 1908.50Q1634 1920 1600 1920L1600 1920Q1561 1920 1526 1905Q1491 1890 1464.50 1863.50Q1438 1837 1423 1802Q1408 1767 1408 1728L1408 1728Q1408 1718 1409 1708.50Q1410 1699 1412 1690L1412 1690L1494 1280L1395 1280Q1408 1341 1408 1408L1408 1408Q1408 1541 1358 1657.50Q1308 1774 1221 1861Q1134 1948 1017.50 1998Q901 2048 768 2048L768 2048Q635 2048 518.50 1998Q402 1948 315 1861Q228 1774 178 1657.50Q128 1541 128 1408L128 1408Q128 1293 167 1188Q206 1083 275 999.50Q344 916 439.50 858.50Q535 801 648 779L648 779L894 464L856 439L712 584Q685 611 649.50 625.50Q614 640 576 640L576 640Q536 640 501 625Q466 610 440 584Q414 558 399 523Q384 488 384 448L384 448Q384 410 398.50 374.50Q413 339 440 312L440 312L696 56Q723 29 758.50 14.50Q794 0 832 0L832 0Q890 0 939 32L939 32Q1026 88 1110 146Q1194 204 1280 261L1280 261Q1280 207 1299.50 159.50Q1319 112 1353.50 76.50Q1388 41 1435 20.50Q1482 0 1536 0L1536 0Q1589 0 1635.50 20Q1682 40 1717 75Q1752 110 1772 156.50Q1792 203 1792 256L1792 256Q1792 309 1772 355.50Q1752 402 1717 437Q1682 472 1635.50 492Q1589 512 1536 512L1536 512Q1529 512 1522.50 512Q1516 512 1509 511L1509 511Q1520 553 1520 593L1520 593Q1520 642 1507 682Q1494 722 1473 757Q1452 792 1425 825.50Q1398 859 1369 896L1369 896ZM1536 128L1536 128Q1509 128 1486 138Q1463 148 1445.50 165.50Q1428 183 1418 206Q1408 229 1408 256L1408 256Q1408 283 1418 306Q1428 329 1445.50 346.50Q1463 364 1486 374Q1509 384 1536 384L1536 384Q1563 384 1586 374Q1609 364 1626.50 346.50Q1644 329 1654 306Q1664 283 1664 256L1664 256Q1664 229 1654 206Q1644 183 1626.50 165.50Q1609 148 1586 138Q1563 128 1536 128ZM840 274L1080 434L818 770Q920 778 1014 817Q1108 856 1185 923L1185 923L1351 710Q1371 684 1381.50 654Q1392 624 1392 592L1392 592Q1392 547 1372.50 508.50Q1353 470 1318 441L1318 441Q1301 427 1281 414.50Q1261 402 1243 390L1243 390L942 189Q924 176 905.50 163Q887 150 868 139L868 139Q858 134 850.50 131Q843 128 832 128L832 128Q806 128 787 147L787 147L531 403Q512 422 512 448L512 448Q512 474 531 493Q550 512 576 512L576 512Q602 512 621 493L621 493L840 274ZM768 1920L768 1920Q874 1920 967 1879.50Q1060 1839 1129.50 1769.50Q1199 1700 1239.50 1607Q1280 1514 1280 1408L1280 1408Q1280 1302 1239.50 1209Q1199 1116 1129.50 1046.50Q1060 977 967 936.50Q874 896 768 896L768 896Q662 896 569 936.50Q476 977 406.50 1046.50Q337 1116 296.50 1209Q256 1302 256 1408L256 1408Q256 1514 296.50 1607Q337 1700 406.50 1769.50Q476 1839 569 1879.50Q662 1920 768 1920ZM1600 1792L1600 1792Q1623 1792 1640.50 1777.50Q1658 1763 1663 1741L1663 1741L1791 1101Q1792 1097 1792 1089L1792 1089Q1792 1062 1773.50 1043Q1755 1024 1728 1024L1728 1024L1280 1024Q1324 1083 1355 1152L1355 1152L1650 1152L1537 1715Q1536 1719 1536 1728L1536 1728Q1536 1754 1554.50 1773Q1573 1792 1600 1792ZM768 1024L768 1024Q847 1024 917 1054Q987 1084 1039.50 1136.50Q1092 1189 1122 1259Q1152 1329 1152 1408L1152 1408Q1152 1488 1122 1557.50Q1092 1627 1039.50 1679.50Q987 1732 917 1762Q847 1792 768 1792L768 1792Q688 1792 618.50 1762Q549 1732 496.50 1679.50Q444 1627 414 1557.50Q384 1488 384 1408L384 1408Q384 1329 414 1259Q444 1189 496.50 1136.50Q549 1084 618.50 1054Q688 1024 768 1024ZM768 1664L768 1664Q821 1664 867.50 1644Q914 1624 949 1589Q984 1554 1004 1507.50Q1024 1461 1024 1408L1024 1408Q1024 1355 1004 1308.50Q984 1262 949 1227Q914 1192 867.50 1172Q821 1152 768 1152L768 1152Q715 1152 668.50 1172Q622 1192 587 1227Q552 1262 532 1308.50Q512 1355 512 1408L512 1408Q512 1461 532 1507.50Q552 1554 587 1589Q622 1624 668.50 1644Q715 1664 768 1664Z"
         }
      }
   ]
}

var SingleColumnEdit = {
   name: "SingleColumnEdit",
   vendor: "UiFabric",
   unicode: 62241,
   value: "",
   charCode: "F321",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 384L128 1664L827 1664L795 1792L0 1792L0 256L1920 256L1920 746Q1902 743 1884 741Q1866 739 1848 739L1848 739Q1834 739 1820 740.50Q1806 742 1792 744L1792 744L1792 384L128 384ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838Z"
         }
      }
   ]
}

var DoubleColumnEdit = {
   name: "DoubleColumnEdit",
   vendor: "UiFabric",
   unicode: 62242,
   value: "",
   charCode: "F322",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 384L1152 1282L1024 1411L1024 256L1920 256L1920 746Q1902 743 1884 741Q1866 739 1848 739L1848 739Q1834 739 1820 740.50Q1806 742 1792 744L1792 744L1792 384L1152 384ZM896 256L896 1539L846 1590L795 1792L0 1792L0 256L896 256ZM768 1664L768 384L128 384L128 1664L768 1664ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838Z"
         }
      }
   ]
}

var TripleColumnEdit = {
   name: "TripleColumnEdit",
   vendor: "UiFabric",
   unicode: 62243,
   value: "",
   charCode: "F323",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L1536 898L1408 1026L1408 256L1920 256L1920 746Q1902 743 1884 741Q1866 739 1848 739L1848 739Q1834 739 1820 740.50Q1806 742 1792 744L1792 744L1792 384L1536 384ZM896 384L896 1539L768 1696L768 256L1280 256L1280 1154L1152 1282L1152 384L896 384ZM128 1792L128 256L640 256L640 1792L128 1792ZM256 384L256 1664L512 1664L512 384L256 384ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838Z"
         }
      }
   ]
}

var ColumnLeftTwoThirdsEdit = {
   name: "ColumnLeftTwoThirdsEdit",
   vendor: "UiFabric",
   unicode: 62244,
   value: "",
   charCode: "F324",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 384L128 1664L827 1664L795 1792L0 1792L0 256L1280 256L1280 1154L1152 1282L1152 384L128 384ZM1408 256L2048 256L2048 796Q2019 777 1986.50 765Q1954 753 1920 746L1920 746L1920 384L1536 384L1536 898L1408 1026L1408 256ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838Z"
         }
      }
   ]
}

var ColumnRightTwoThirdsEdit = {
   name: "ColumnRightTwoThirdsEdit",
   vendor: "UiFabric",
   unicode: 62245,
   value: "",
   charCode: "F325",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 256L640 256L640 1792L0 1792ZM128 384L128 1664L512 1664L512 384L128 384ZM768 256L2048 256L2048 796Q2019 777 1986.50 765Q1954 753 1920 746L1920 746L1920 384L896 384L896 1539L768 1696L768 256ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838Z"
         }
      }
   ]
}

var StreamLogo = {
   name: "StreamLogo",
   vendor: "UiFabric",
   unicode: 62249,
   value: "",
   charCode: "F329",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1919 1024L1919 1024L1920 1024Q1919 1045 1908.50 1064Q1898 1083 1880 1094L1880 1094L609 1903Q583 1920 553 1920L553 1920Q532 1920 512.50 1912Q493 1904 479 1890Q465 1876 456.50 1857.50Q448 1839 448 1817L448 1817L448 1365L213 1527Q207 1532 199 1534Q191 1536 183 1536L183 1536Q159 1536 143.50 1518Q128 1500 128 1477L128 1477L128 571Q128 548 143.50 530Q159 512 183 512L183 512Q191 512 199 514Q207 516 213 521L213 521L448 683L448 230Q448 208 456.50 189.50Q465 171 479 157.50Q493 144 512.50 136Q532 128 553 128L553 128Q583 128 609 145L609 145L1881 951Q1900 963 1909.50 982Q1919 1001 1919 1024ZM1656 960L576 275L576 772L849 960L1656 960ZM717 1024L256 707L256 1341L717 1024ZM576 1276L576 1773L1652 1088L849 1088L576 1276Z"
         }
      }
   ]
}

var PassiveAuthentication = {
   name: "PassiveAuthentication",
   vendor: "UiFabric",
   unicode: 62250,
   value: "",
   charCode: "F32A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1197 1363L1344 1510L1683 1171L1773 1261L1344 1690L1107 1453L1197 1363ZM1267 768L2048 768L2048 2048L768 2048L768 1267Q707 1280 640 1280L640 1280Q507 1280 390.50 1230Q274 1180 187 1093Q100 1006 50 889.50Q0 773 0 640L0 640Q0 507 50 390.50Q100 274 187 187Q274 100 390.50 50Q507 0 640 0L640 0Q773 0 889.50 50Q1006 100 1093 187Q1180 274 1230 390.50Q1280 507 1280 640L1280 640Q1280 707 1267 768L1267 768ZM128 640L128 640Q128 746 168.50 839Q209 932 278.50 1001.50Q348 1071 441 1111.50Q534 1152 640 1152L640 1152Q746 1152 839 1111.50Q932 1071 1001.50 1001.50Q1071 932 1111.50 839Q1152 746 1152 640L1152 640Q1152 534 1111.50 441Q1071 348 1001.50 278.50Q932 209 839 168.50Q746 128 640 128L640 128Q534 128 441 168.50Q348 209 278.50 278.50Q209 348 168.50 441Q128 534 128 640ZM1920 1920L1920 896L1227 896Q1176 1009 1092.50 1092.50Q1009 1176 896 1227L896 1227L896 1920L1920 1920ZM915 403L1005 493L576 922L339 685L429 595L576 742L915 403Z"
         }
      }
   ]
}

var ChevronDownEnd6 = {
   name: "ChevronDownEnd6",
   vendor: "UiFabric",
   unicode: 62319,
   value: "",
   charCode: "F36F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2041 249L1024 1265L7 249L249 7L1024 783L1799 7L2041 249ZM0 1707L2048 1707L2048 2048L0 2048L0 1707Z"
         }
      }
   ]
}

var DoubleChevronLeft8 = {
   name: "DoubleChevronLeft8",
   vendor: "UiFabric",
   unicode: 62317,
   value: "",
   charCode: "F36D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2042 443L1461 1024L2042 1605L1861 1786L1099 1024L1861 262L2042 443ZM837 262L1018 443L437 1024L1018 1605L837 1786L75 1024L837 262Z"
         }
      }
   ]
}

var DoubleChevronDown8 = {
   name: "DoubleChevronDown8",
   vendor: "UiFabric",
   unicode: 62315,
   value: "",
   charCode: "F36B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1786 187L1024 949L262 187L443 6L1024 587L1605 6L1786 187ZM1024 1611L1605 1030L1786 1211L1024 1973L262 1211L443 1030L1024 1611Z"
         }
      }
   ]
}

var ChevronUnfold10 = {
   name: "ChevronUnfold10",
   vendor: "UiFabric",
   unicode: 62313,
   value: "",
   charCode: "F369",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 350L559 815L414 670L1024 60L1634 670L1489 815L1024 350ZM1024 1698L1489 1233L1634 1378L1024 1988L414 1378L559 1233L1024 1698Z"
         }
      }
   ]
}

var CaretTopLeftCenter8 = {
   name: "CaretTopLeftCenter8",
   vendor: "UiFabric",
   unicode: 62311,
   value: "",
   charCode: "F367",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 256L1717 256L256 1717L256 256ZM512 512L512 1099L1099 512L512 512Z"
         }
      }
   ]
}

var CaretBottomLeftCenter8 = {
   name: "CaretBottomLeftCenter8",
   vendor: "UiFabric",
   unicode: 62309,
   value: "",
   charCode: "F365",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 331L1717 1792L256 1792L256 331ZM512 949L512 1536L1099 1536L512 949Z"
         }
      }
   ]
}

var ProjectCollection = {
   name: "ProjectCollection",
   vendor: "UiFabric",
   unicode: 62307,
   value: "",
   charCode: "F363",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 640L1920 640Q1947 640 1970 650Q1993 660 2010.50 677.50Q2028 695 2038 718Q2048 741 2048 768L2048 768L2048 1920L256 1920L256 1408L0 1408L0 128Q0 101 10 78Q20 55 37.50 37.50Q55 20 78 10Q101 0 128 0L128 0L608 0Q653 0 685.50 9.50Q718 19 743 33Q768 47 788.50 64Q809 81 829.50 95Q850 109 873.50 118.50Q897 128 928 128L928 128L1664 128Q1691 128 1714 138Q1737 148 1754.50 165.50Q1772 183 1782 206Q1792 229 1792 256L1792 256L1792 640ZM608 128L128 128L128 256L608 256Q632 256 650 251.50Q668 247 683 238.50Q698 230 712.50 218.50Q727 207 744 192L744 192Q727 177 712.50 165.50Q698 154 683 145.50Q668 137 650 132.50Q632 128 608 128L608 128ZM128 1280L256 1280L256 640Q256 613 266 590Q276 567 293.50 549.50Q311 532 334 522Q357 512 384 512L384 512L864 512Q909 512 941.50 521.50Q974 531 999.50 545Q1025 559 1045 576Q1065 593 1085.50 607Q1106 621 1129.50 630.50Q1153 640 1184 640L1184 640L1664 640L1664 256L928 256Q897 256 873.50 265.50Q850 275 829.50 289Q809 303 789 320Q769 337 743.50 351Q718 365 685.50 374.50Q653 384 608 384L608 384L128 384L128 1280ZM1000 704L1000 704Q983 689 968.50 677.50Q954 666 939 657.50Q924 649 906 644.50Q888 640 864 640L864 640L384 640L384 768L864 768Q888 768 906 763.50Q924 759 939 750.50Q954 742 968.50 730.50Q983 719 1000 704ZM1920 1792L1920 768L1184 768Q1153 768 1129.50 777.50Q1106 787 1085.50 801Q1065 815 1045 832Q1025 849 999.50 863Q974 877 941.50 886.50Q909 896 864 896L864 896L384 896L384 1792L1920 1792Z"
         }
      }
   ]
}

var TimelineMatrixView = {
   name: "TimelineMatrixView",
   vendor: "UiFabric",
   unicode: 62305,
   value: "",
   charCode: "F361",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 256L128 256L128 640L2048 640L2048 768L1664 768L1664 1152L2048 1152L2048 1280L1664 1280L1664 1664L2048 1664L2048 1792L1664 1792L1664 1920L1536 1920L1536 1792L896 1792L896 1920L768 1920L768 1792L128 1792L128 1920L0 1920L0 128L2048 128L2048 256ZM128 1664L768 1664L768 1280L128 1280L128 1664ZM1536 1664L1536 1280L896 1280L896 1664L1536 1664ZM1536 1152L1536 768L896 768L896 1152L1536 1152ZM768 768L128 768L128 1152L768 1152L768 768Z"
         }
      }
   ]
}

var NavigateExternalInline = {
   name: "NavigateExternalInline",
   vendor: "UiFabric",
   unicode: 62303,
   value: "",
   charCode: "F35F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1920L1536 1408L1664 1408L1664 2048L256 2048L256 640L896 640L896 768L384 768L384 1920L1536 1920ZM1024 640L1664 640L1664 1280L1536 1280L1536 859L941 1453L851 1363L1445 768L1024 768L1024 640Z"
         }
      }
   ]
}

var WorkItemBarSolid = {
   name: "WorkItemBarSolid",
   vendor: "UiFabric",
   unicode: 62301,
   value: "",
   charCode: "F35D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 128L1280 128L1280 1920L640 1920L640 128Z"
         }
      }
   ]
}

var FeedbackResponseSolid = {
   name: "FeedbackResponseSolid",
   vendor: "UiFabric",
   unicode: 62299,
   value: "",
   charCode: "F35B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1536L704 1536L256 1984L256 1536L0 1536L0 128ZM832 1352L1627 557L1491 421L832 1080L557 805L421 941L832 1352Z"
         }
      }
   ]
}

var FeedbackRequestSolid = {
   name: "FeedbackRequestSolid",
   vendor: "UiFabric",
   unicode: 62297,
   value: "",
   charCode: "F359",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1536L704 1536L256 1984L256 1536L0 1536L0 128ZM1024 1408L1024 1280L896 1280L896 1408L1024 1408ZM1032 1152L1032 1111Q1032 1074 1039 1041Q1046 1008 1075 979L1075 979Q1114 940 1152 904.50Q1190 869 1220.50 830Q1251 791 1269.50 745Q1288 699 1288 640L1288 640Q1288 572 1262 512.50Q1236 453 1191.50 408.50Q1147 364 1087.50 338Q1028 312 960 312L960 312Q892 312 832.50 338Q773 364 728.50 408.50Q684 453 658 512.50Q632 572 632 640L632 640L776 640Q776 602 790.50 568.50Q805 535 830 510Q855 485 888.50 470.50Q922 456 960 456L960 456Q998 456 1031.50 470.50Q1065 485 1090 510Q1115 535 1129.50 568.50Q1144 602 1144 640L1144 640Q1144 681 1125 713Q1106 745 1077.50 774.50Q1049 804 1016 834Q983 864 954.50 900Q926 936 907 981.50Q888 1027 888 1088L888 1088L888 1152L1032 1152Z"
         }
      }
   ]
}

var ReviewRequestMirroredSolid = {
   name: "ReviewRequestMirroredSolid",
   vendor: "UiFabric",
   unicode: 62295,
   value: "",
   charCode: "F357",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1245 1154L2029 1939Q2048 1958 2048 1984L2048 1984Q2048 2010 2029 2029Q2010 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1154 1245Q1059 1325 943.50 1366.50Q828 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 348.50 1312Q270 1266 206 1202Q142 1138 96 1059.50Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 348.50Q142 270 206 206Q270 142 348.50 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059.50 96Q1138 142 1202 206Q1266 270 1312 348.50Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 828 1366.50 943.50Q1325 1059 1245 1154L1245 1154ZM768 1152L768 1024L640 1024L640 1152L768 1152ZM888 512L1032 512Q1032 446 1003 396.50Q974 347 927 314Q880 281 821.50 264.50Q763 248 704 248L704 248Q644 248 585.50 267.50Q527 287 480.50 323.50Q434 360 405 412Q376 464 376 529L376 529Q376 582 395 621Q414 660 442.50 691Q471 722 504 746.50Q537 771 565.50 794.50Q594 818 613 842Q632 866 632 896L632 896L776 896Q776 843 757 804Q738 765 709.50 734Q681 703 648 678.50Q615 654 586.50 630.50Q558 607 539 583Q520 559 520 529L520 529Q520 495 538 469.50Q556 444 583 427Q610 410 642.50 401Q675 392 704 392L704 392Q731 392 763 398Q795 404 823 418.50Q851 433 869.50 456Q888 479 888 512L888 512Z"
         }
      }
   ]
}

var ReviewSolid = {
   name: "ReviewSolid",
   vendor: "UiFabric",
   unicode: 62293,
   value: "",
   charCode: "F355",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 768L448 768L128 1088L128 768L0 768L0 128L1664 128L1664 768ZM384 1664L384 1024L2048 1024L2048 1664L1920 1664L1920 1984L1600 1664L384 1664Z"
         }
      }
   ]
}

var FiltersSolid = {
   name: "FiltersSolid",
   vendor: "UiFabric",
   unicode: 62291,
   value: "",
   charCode: "F353",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1152L384 1024L1664 1024L1664 1152Q1664 1179 1654 1202Q1644 1225 1626.50 1242.50Q1609 1260 1586 1270Q1563 1280 1536 1280L1536 1280L1280 1280L1280 1792Q1280 1845 1260 1891.50Q1240 1938 1205 1973Q1170 2008 1123.50 2028Q1077 2048 1024 2048L1024 2048Q971 2048 924.50 2028Q878 2008 843 1973Q808 1938 788 1891.50Q768 1845 768 1792L768 1792L768 1280L512 1280Q485 1280 462 1270Q439 1260 421.50 1242.50Q404 1225 394 1202Q384 1179 384 1152L384 1152ZM640 0L1600 0Q1640 0 1675 15Q1710 30 1736 56Q1762 82 1777 117Q1792 152 1792 192L1792 192L1792 256L1758 256Q1741 256 1724.50 258Q1708 260 1694.50 266.50Q1681 273 1672.50 285.50Q1664 298 1664 320L1664 320L1664 896L384 896L384 256Q384 203 404 156.50Q424 110 459 75Q494 40 540.50 20Q587 0 640 0L640 0Z"
         }
      }
   ]
}

var Parachute = {
   name: "Parachute",
   vendor: "UiFabric",
   unicode: 62289,
   value: "",
   charCode: "F351",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 832L1920 832Q1920 861 1909.50 885.50Q1899 910 1882 931Q1865 952 1843 969Q1821 986 1798 999L1798 999Q1787 1006 1777.50 1008.50Q1768 1011 1758 1021L1758 1021L1280 1499L1280 1952Q1280 1992 1252 2020Q1224 2048 1184 2048L1184 2048L736 2048Q696 2048 668 2020Q640 1992 640 1952L640 1952L640 1499L162 1021Q152 1011 142.50 1008.50Q133 1006 122 999L122 999Q99 986 77 969Q55 952 38 931Q21 910 10.50 885.50Q0 861 0 832L0 832Q0 705 38.50 594Q77 483 144.50 390.50Q212 298 304 225.50Q396 153 502.50 103Q609 53 725.50 26.50Q842 0 960 0L960 0Q1077 0 1194 26.50Q1311 53 1417.50 103Q1524 153 1616 225.50Q1708 298 1775.50 390.50Q1843 483 1881.50 594Q1920 705 1920 832ZM960 128L960 128Q861 128 760.50 150Q660 172 567.50 214Q475 256 395 316.50Q315 377 255.50 455.50Q196 534 162 628.50Q128 723 128 832L128 832Q128 840 133 847Q138 854 145.50 861Q153 868 160.50 873Q168 878 173 881L173 881Q219 910 280.50 932Q342 954 412 970Q482 986 556.50 996Q631 1006 703.50 1012.50Q776 1019 841.50 1021.50Q907 1024 960 1024L960 1024Q1012 1024 1078 1021.50Q1144 1019 1216.50 1012.50Q1289 1006 1363.50 996Q1438 986 1508 970Q1578 954 1639.50 932Q1701 910 1747 881L1747 881Q1752 878 1759.50 873Q1767 868 1774.50 861Q1782 854 1787 847Q1792 840 1792 832L1792 832Q1792 723 1758 628.50Q1724 534 1664.50 455.50Q1605 377 1525 316.50Q1445 256 1352.50 214Q1260 172 1159.50 150Q1059 128 960 128ZM896 1408L896 1151Q778 1149 660 1137.50Q542 1126 426 1103L426 1103L731 1408L896 1408ZM1152 1920L1152 1536L768 1536L768 1920L1152 1920ZM1189 1408L1494 1103Q1378 1126 1260 1137.50Q1142 1149 1024 1151L1024 1151L1024 1408L1189 1408Z"
         }
      }
   ]
}

var BankSolid = {
   name: "BankSolid",
   vendor: "UiFabric",
   unicode: 62287,
   value: "",
   charCode: "F34F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 160L1920 640L1920 768L0 768L0 640L960 160ZM128 896L256 896L256 1408L128 1408L128 896ZM384 896L512 896L512 1408L384 1408L384 896ZM640 896L768 896L768 1408L640 1408L640 896ZM896 896L1024 896L1024 1408L896 1408L896 896ZM1152 896L1280 896L1280 1408L1152 1408L1152 896ZM1408 896L1536 896L1536 1408L1408 1408L1408 896ZM1792 896L1792 1408L1664 1408L1664 896L1792 896ZM128 1536L1792 1536L1920 1920L0 1920L128 1536Z"
         }
      }
   ]
}

var AsteriskSolid = {
   name: "AsteriskSolid",
   vendor: "UiFabric",
   unicode: 62285,
   value: "",
   charCode: "F34D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1975 623L1280 1024L1975 1425L1847 1647L1152 1246L1152 2048L896 2048L896 1246L201 1647L73 1425L768 1024L73 623L201 401L896 802L896 0L1152 0L1152 802L1847 401L1975 623Z"
         }
      }
   ]
}

var ParkingMirroredSolid = {
   name: "ParkingMirroredSolid",
   vendor: "UiFabric",
   unicode: 62283,
   value: "",
   charCode: "F34B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M285 512L29 1075Q0 1139 0 1208L0 1208L0 1280Q0 1318 10.50 1353Q21 1388 40.50 1418Q60 1448 88 1472.50Q116 1497 150 1512L150 1512Q165 1547 189.50 1575Q214 1603 244.50 1622.50Q275 1642 310.50 1653Q346 1664 384 1664L384 1664Q453 1664 512 1630Q571 1596 606 1536L606 1536L1314 1536Q1349 1596 1408 1630Q1467 1664 1536 1664L1536 1664Q1605 1664 1664 1630Q1723 1596 1758 1536L1758 1536L1920 1536Q1947 1536 1970 1526Q1993 1516 2010.50 1498.50Q2028 1481 2038 1458Q2048 1435 2048 1408L2048 1408L2048 1152Q2048 1073 2018 1003Q1988 933 1935.50 880.50Q1883 828 1813.50 798Q1744 768 1664 768L1664 768L1627 768L1299 440Q1272 413 1236.50 398.50Q1201 384 1163 384L1163 384L256 384L256 512L285 512ZM1536 1536L1536 1536Q1509 1536 1486 1526Q1463 1516 1445.50 1498.50Q1428 1481 1418 1458Q1408 1435 1408 1408L1408 1408Q1408 1381 1418 1358Q1428 1335 1445.50 1317.50Q1463 1300 1486 1290Q1509 1280 1536 1280L1536 1280Q1563 1280 1586 1290Q1609 1300 1626.50 1317.50Q1644 1335 1654 1358Q1664 1381 1664 1408L1664 1408Q1664 1435 1654 1458Q1644 1481 1626.50 1498.50Q1609 1516 1586 1526Q1563 1536 1536 1536ZM896 768L896 512L1163 512Q1189 512 1208 531L1208 531L1445 768L896 768ZM768 512L768 768L309 768L408 549Q416 532 432 522Q448 512 467 512L467 512L768 512ZM384 1536L384 1536Q357 1536 334 1526Q311 1516 293.50 1498.50Q276 1481 266 1458Q256 1435 256 1408L256 1408Q256 1381 266 1358Q276 1335 293.50 1317.50Q311 1300 334 1290Q357 1280 384 1280L384 1280Q411 1280 434 1290Q457 1300 474.50 1317.50Q492 1335 502 1358Q512 1381 512 1408L512 1408Q512 1435 502 1458Q492 1481 474.50 1498.50Q457 1516 434 1526Q411 1536 384 1536Z"
         }
      }
   ]
}

var PermissionsSolid = {
   name: "PermissionsSolid",
   vendor: "UiFabric",
   unicode: 62281,
   value: "",
   charCode: "F349",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1377 903L2048 1573L2048 2048L1536 2048L1536 1792L1280 1792L1280 1536L1024 1536L1024 1329Q950 1368 869 1388Q788 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 349 1312Q271 1266 206.50 1201.50Q142 1137 96 1059Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 349Q142 271 206.50 206.50Q271 142 349 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059 96Q1137 142 1201.50 206.50Q1266 271 1312 349Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 755 1400 805Q1392 855 1377 903L1377 903ZM512 704L512 704Q552 704 587 689Q622 674 648 648Q674 622 689 587Q704 552 704 512L704 512Q704 472 689 437Q674 402 648 376Q622 350 587 335Q552 320 512 320L512 320Q472 320 437 335Q402 350 376 376Q350 402 335 437Q320 472 320 512L320 512Q320 552 335 587Q350 622 376 648Q402 674 437 689Q472 704 512 704Z"
         }
      }
   ]
}

var FinancialMirroredSolid = {
   name: "FinancialMirroredSolid",
   vendor: "UiFabric",
   unicode: 62279,
   value: "",
   charCode: "F347",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 2048L2048 1898L1664 1514L1664 2048L2048 2048ZM1536 2048L1536 1386L1152 1002L1152 2048L1536 2048ZM512 1130L256 896L128 896L128 2048L512 2048L512 1130ZM1024 1002L704 1322L640 1258L640 2048L1024 2048L1024 1002ZM512 256L0 256L0 768L128 768L128 475L704 1050L1088 666L2048 1627L2048 1445L1088 486L704 870L219 384L512 384L512 256Z"
         }
      }
   ]
}

var RibbonSolid = {
   name: "RibbonSolid",
   vendor: "UiFabric",
   unicode: 62277,
   value: "",
   charCode: "F345",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 2048L512 1222Q619 1316 750 1366Q881 1416 1024 1416L1024 1416Q1167 1416 1298 1366Q1429 1316 1536 1222L1536 1222L1536 2048L1024 1792L512 2048ZM1024 1280L1024 1280Q936 1280 854 1257Q772 1234 701 1192.50Q630 1151 572 1092.50Q514 1034 472.50 963Q431 892 408 810Q385 728 385 640L385 640Q385 552 408 470Q431 388 472.50 317Q514 246 572 187.50Q630 129 701 87.50Q772 46 854 23Q936 0 1024 0L1024 0Q1112 0 1194 23Q1276 46 1347 87.50Q1418 129 1476.50 187.50Q1535 246 1576.50 317Q1618 388 1641 470Q1664 552 1664 640L1664 640Q1664 728 1641 810Q1618 892 1576.50 963Q1535 1034 1476.50 1092.50Q1418 1151 1347 1192.50Q1276 1234 1194 1257Q1112 1280 1024 1280ZM1024 248L1024 248Q943 248 871.50 279Q800 310 747 363Q694 416 663 487.50Q632 559 632 640L632 640Q632 721 663 792.50Q694 864 747 917Q800 970 871.50 1001Q943 1032 1024 1032L1024 1032Q1105 1032 1176.50 1001Q1248 970 1301 917Q1354 864 1385 792.50Q1416 721 1416 640L1416 640Q1416 559 1385 487.50Q1354 416 1301 363Q1248 310 1176.50 279Q1105 248 1024 248ZM1024 896L1024 896Q971 896 924.50 876Q878 856 843 821Q808 786 788 739.50Q768 693 768 640L768 640Q768 587 788 540.50Q808 494 843 459Q878 424 924.50 404Q971 384 1024 384L1024 384Q1077 384 1123.50 404Q1170 424 1205 459Q1240 494 1260 540.50Q1280 587 1280 640L1280 640Q1280 693 1260 739.50Q1240 786 1205 821Q1170 856 1123.50 876Q1077 896 1024 896Z"
         }
      }
   ]
}

var MailSolid = {
   name: "MailSolid",
   vendor: "UiFabric",
   unicode: 62275,
   value: "",
   charCode: "F343",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 469L1024 981L0 469L0 384ZM0 683L1024 1195L2048 683L2048 1664L0 1664L0 683Z"
         }
      }
   ]
}

var GiftBoxSolid = {
   name: "GiftBoxSolid",
   vendor: "UiFabric",
   unicode: 62273,
   value: "",
   charCode: "F341",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1500 768L1792 768L1792 2048L1024 2048L1024 768L1280 768Q1307 768 1330 758Q1353 748 1370.50 730.50Q1388 713 1398 690Q1408 667 1408 640L1408 640Q1408 613 1398 590Q1388 567 1370.50 549.50Q1353 532 1330 522Q1307 512 1280 512L1280 512Q1227 512 1180.50 532Q1134 552 1099 587Q1064 622 1044 668.50Q1024 715 1024 768L1024 768L896 768Q896 715 876 668.50Q856 622 821 587Q786 552 739.50 532Q693 512 640 512L640 512Q613 512 590 522Q567 532 549.50 549.50Q532 567 522 590Q512 613 512 640L512 640Q512 667 522 690Q532 713 549.50 730.50Q567 748 590 758Q613 768 640 768L640 768L896 768L896 2048L128 2048L128 768L420 768Q385 709 385 640L385 640Q385 587 405 540.50Q425 494 459.50 459Q494 424 540.50 404Q587 384 640 384L640 384Q737 384 821.50 429.50Q906 475 960 556L960 556Q1014 475 1098.50 429.50Q1183 384 1280 384L1280 384Q1333 384 1379.50 404Q1426 424 1461 459Q1496 494 1516 540.50Q1536 587 1536 640L1536 640Q1536 674 1526.50 706.50Q1517 739 1500 768L1500 768Z"
         }
      }
   ]
}

var HealthSolid = {
   name: "HealthSolid",
   vendor: "UiFabric",
   unicode: 62271,
   value: "",
   charCode: "F33F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1504 128L1504 128Q1617 128 1716 170.50Q1815 213 1888.50 286.50Q1962 360 2004.50 459Q2047 558 2047 671L2047 671Q2047 729 2035 786Q2023 843 1999 896L1999 896L1536 896L1344 696L1024 1016L576 568L256 896L49 896Q25 843 13 786Q1 729 1 671L1 671Q1 558 43.50 459Q86 360 159.50 286.50Q233 213 332 170.50Q431 128 544 128L544 128Q653 128 752.50 169Q852 210 929 287L929 287L1024 383L1119 287Q1196 210 1295.50 169Q1395 128 1504 128ZM1344 968L1408 1024L1918 1024Q1911 1032 1904 1040.50Q1897 1049 1889 1057L1889 1057L1024 1921L159 1057Q151 1049 144 1040.50Q137 1032 130 1024L130 1024L384 1024L576 840L1024 1288L1344 968Z"
         }
      }
   ]
}

var ReadingModeSolid = {
   name: "ReadingModeSolid",
   vendor: "UiFabric",
   unicode: 62269,
   value: "",
   charCode: "F33D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1664L640 1664Q683 1664 715.50 1673.50Q748 1683 775.50 1699.50Q803 1716 828 1740Q853 1764 882 1792L882 1792L0 1792L0 256L128 256L128 1664ZM256 128L640 128Q707 128 772 144.50Q837 161 896 194L896 194L896 1629Q842 1584 776 1560Q710 1536 640 1536L640 1536L256 1536L256 128ZM1792 256L1920 256L1920 1792L1038 1792Q1066 1764 1091.50 1740Q1117 1716 1144.50 1699.50Q1172 1683 1204.50 1673.50Q1237 1664 1280 1664L1280 1664L1792 1664L1792 256ZM1664 1536L1280 1536Q1210 1536 1144 1560Q1078 1584 1024 1629L1024 1629L1024 194Q1083 161 1148 144.50Q1213 128 1280 128L1280 128L1664 128L1664 1536Z"
         }
      }
   ]
}

var PageListMirroredSolid = {
   name: "PageListMirroredSolid",
   vendor: "UiFabric",
   unicode: 62267,
   value: "",
   charCode: "F33B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 0L256 0L256 1792L1792 1792L1792 0ZM1408 1280L1408 1152L1536 1152L1536 1280L1408 1280ZM1408 896L1408 768L1536 768L1536 896L1408 896ZM1408 512L1408 384L1536 384L1536 512L1408 512ZM512 1280L512 1152L1280 1152L1280 1280L512 1280ZM512 896L512 768L1280 768L1280 896L512 896ZM512 512L512 384L1280 384L1280 512L512 512Z"
         }
      }
   ]
}

var ConstructionConeSolid = {
   name: "ConstructionConeSolid",
   vendor: "UiFabric",
   unicode: 62265,
   value: "",
   charCode: "F339",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1650 1920L1920 1920L1920 2048L128 2048L128 1920L398 1920L494 1536L1296 1536L1264 1408L526 1408L590 1152L1200 1152L1168 1024L622 1024L846 128L1202 128L1650 1920Z"
         }
      }
   ]
}

var Trophy2Solid = {
   name: "Trophy2Solid",
   vendor: "UiFabric",
   unicode: 62263,
   value: "",
   charCode: "F337",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1536L640 1536Q640 1474 669.50 1426.50Q699 1379 745.50 1346.50Q792 1314 848.50 1297Q905 1280 960 1280L960 1280Q1015 1280 1071.50 1297Q1128 1314 1174.50 1346.50Q1221 1379 1250.50 1426.50Q1280 1474 1280 1536L1280 1536ZM416 1664L1504 1664Q1517 1664 1526.50 1673.50Q1536 1683 1536 1696L1536 1696L1536 1920L384 1920L384 1696Q384 1683 393.50 1673.50Q403 1664 416 1664L416 1664ZM1536 256L1792 256Q1819 256 1842 266Q1865 276 1882.50 293.50Q1900 311 1910 334Q1920 357 1920 384L1920 384L1920 576Q1920 674 1884 756Q1848 838 1785.50 897.50Q1723 957 1639 990.50Q1555 1024 1459 1024L1459 1024Q1418 1086 1362.50 1134Q1307 1182 1242 1214.50Q1177 1247 1105 1263.50Q1033 1280 960 1280L960 1280Q886 1280 814.50 1263.50Q743 1247 678 1214.50Q613 1182 557.50 1134Q502 1086 461 1024L461 1024Q365 1024 281 990.50Q197 957 134.50 897.50Q72 838 36 756Q0 674 0 576L0 576L0 384Q0 357 10 334Q20 311 37.50 293.50Q55 276 78 266Q101 256 128 256L128 256L384 256L384 128L1536 128L1536 256ZM384 890L384 384L128 384L128 576Q128 633 147 685Q166 737 200 778.50Q234 820 281 849Q328 878 384 890L384 890ZM1792 576L1792 384L1536 384L1536 890Q1592 878 1639 849Q1686 820 1720 778.50Q1754 737 1773 685Q1792 633 1792 576L1792 576Z"
         }
      }
   ]
}

var BugSolid = {
   name: "BugSolid",
   vendor: "UiFabric",
   unicode: 62261,
   value: "",
   charCode: "F335",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 448L704 448Q704 376 734 313L734 313L595 173L685 83L811 209Q856 170 910 149Q964 128 1024 128L1024 128Q1084 128 1138 149Q1192 170 1237 209L1237 209L1363 83L1453 173L1314 313Q1344 376 1344 448L1344 448Q1344 461 1342.50 473.50Q1341 486 1339 498L1339 498Q1264 466 1184.50 449Q1105 432 1024 432L1024 432Q943 432 863.50 449Q784 466 709 498L709 498Q707 486 705.50 473.50Q704 461 704 448ZM1578 896L1600 896Q1666 896 1724 921.50Q1782 947 1825.50 990.50Q1869 1034 1894.50 1092Q1920 1150 1920 1216L1920 1216L1920 1408L1792 1408L1792 1216Q1792 1182 1780.50 1150.50Q1769 1119 1748 1093.50Q1727 1068 1698.50 1050.50Q1670 1033 1636 1027L1636 1027Q1655 1089 1660 1152.50Q1665 1216 1665 1280L1665 1280Q1665 1316 1664.50 1352Q1664 1388 1664 1424L1664 1424L1667 1428Q1728 1494 1760 1566Q1792 1638 1792 1729L1792 1729Q1792 1814 1759.50 1891.50Q1727 1969 1667 2029L1667 2029L1577 1939Q1619 1897 1641.50 1842Q1664 1787 1664 1728L1664 1728Q1664 1661 1635 1600L1635 1600Q1603 1700 1543 1782.50Q1483 1865 1403 1924Q1323 1983 1226 2015.50Q1129 2048 1024 2048L1024 2048Q919 2048 822 2015.50Q725 1983 645 1924Q565 1865 504.50 1782.50Q444 1700 413 1600L413 1600Q384 1661 384 1728L384 1728Q384 1787 406.50 1842Q429 1897 471 1939L471 1939L381 2029Q321 1969 288.50 1891.50Q256 1814 256 1729L256 1729Q256 1638 288 1566Q320 1494 381 1428L381 1428L384 1424Q384 1388 383.50 1352Q383 1316 383 1280L383 1280Q383 1216 388 1152.50Q393 1089 412 1027L412 1027Q378 1033 349.50 1050.50Q321 1068 300 1093.50Q279 1119 267.50 1150.50Q256 1182 256 1216L256 1216L256 1408L128 1408L128 1216Q128 1150 153 1092Q178 1034 221.50 990.50Q265 947 323.50 921.50Q382 896 448 896L448 896L470 896Q510 827 567 768L567 768Q502 766 445.50 740Q389 714 347 671Q305 628 280.50 570.50Q256 513 256 448L256 448L256 256L384 256L384 448Q384 488 399 523Q414 558 440 584Q466 610 501 625Q536 640 576 640L576 640L745 640Q878 576 1024 576L1024 576Q1170 576 1303 640L1303 640L1472 640Q1512 640 1547 625Q1582 610 1608 584Q1634 558 1649 523Q1664 488 1664 448L1664 448L1664 256L1792 256L1792 448Q1792 513 1767.50 570.50Q1743 628 1701 671Q1659 714 1602.50 740Q1546 766 1481 768L1481 768Q1538 827 1578 896L1578 896Z"
         }
      }
   ]
}

var TaskSolid = {
   name: "TaskSolid",
   vendor: "UiFabric",
   unicode: 62259,
   value: "",
   charCode: "F333",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384L640 384ZM832 1736L1627 941L1491 805L832 1464L557 1189L421 1325L832 1736Z"
         }
      }
   ]
}

var AlertSolid = {
   name: "AlertSolid",
   vendor: "UiFabric",
   unicode: 62257,
   value: "",
   charCode: "F331",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM896 1536L1152 1536L1152 1280L896 1280L896 1536ZM896 1152L1152 1152L1152 512L896 512L896 1152Z"
         }
      }
   ]
}

var MegaphoneSolid = {
   name: "MegaphoneSolid",
   vendor: "UiFabric",
   unicode: 62258,
   value: "",
   charCode: "F332",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M122 768L1920 448Q1926 447 1936 446.50Q1946 446 1958 446L1958 446Q1982 446 2008 447Q2034 448 2048 448L2048 448L2048 1600Q2034 1600 2009 1600.50Q1984 1601 1960 1601L1960 1601Q1943 1601 1930 1601Q1917 1601 1909 1599L1909 1599L1146 1463Q1136 1520 1107.50 1569Q1079 1618 1037 1653Q995 1688 942.50 1708Q890 1728 832 1728L832 1728Q766 1728 707.50 1703Q649 1678 605.50 1634.50Q562 1591 537 1532.50Q512 1474 512 1408L512 1408Q512 1380 518 1351L518 1351L122 1280Q114 1279 104.50 1278.50Q95 1278 84 1278L84 1278Q62 1278 39.50 1279Q17 1280 0 1280L0 1280L0 768Q14 768 38.50 769Q63 770 86 770L86 770Q97 770 106.50 769.50Q116 769 122 768L122 768ZM832 1600L832 1600Q867 1600 899 1588Q931 1576 956 1554.50Q981 1533 998 1504Q1015 1475 1021 1440L1021 1440L643 1373Q640 1391 640 1408L640 1408Q640 1448 655 1483Q670 1518 696 1544Q722 1570 757 1585Q792 1600 832 1600Z"
         }
      }
   ]
}

var ConfigurationSolid = {
   name: "ConfigurationSolid",
   vendor: "UiFabric",
   unicode: 62260,
   value: "",
   charCode: "F334",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 37L1755 512L1280 512L1280 37ZM960 1032L960 1032Q998 1032 1031.50 1046.50Q1065 1061 1090 1086.50Q1115 1112 1129.50 1145.50Q1144 1179 1144 1216L1144 1216Q1144 1254 1129.50 1287.50Q1115 1321 1089.50 1346Q1064 1371 1030.50 1385.50Q997 1400 960 1400L960 1400Q922 1400 888.50 1385.50Q855 1371 830 1345.50Q805 1320 790.50 1287Q776 1254 776 1216L776 1216Q776 1178 790.50 1144.50Q805 1111 830.50 1086Q856 1061 889 1046.50Q922 1032 960 1032ZM1152 640L1792 640L1792 2048L128 2048L128 0L1152 0L1152 640ZM1468 1348L1283 1272Q1285 1258 1286 1244Q1287 1230 1287 1216L1287 1216Q1287 1202 1286 1188Q1285 1174 1283 1160L1283 1160L1468 1084L1413 950L1228 1027Q1195 981 1149 948L1149 948L1226 763L1092 708L1016 893Q1002 891 988 890Q974 889 960 889L960 889Q946 889 932 890Q918 891 904 893L904 893L828 708L694 763L771 948Q725 981 692 1027L692 1027L507 950L452 1084L637 1160Q635 1174 633.50 1188Q632 1202 632 1216L632 1216Q632 1230 633.50 1244Q635 1258 637 1272L637 1272L452 1348L507 1482L692 1405Q725 1451 771 1484L771 1484L694 1669L828 1724L904 1539Q918 1541 932 1542.50Q946 1544 960 1544L960 1544Q974 1544 988 1542.50Q1002 1541 1016 1539L1016 1539L1092 1724L1226 1669L1149 1484Q1195 1451 1228 1405L1228 1405L1413 1482L1468 1348Z"
         }
      }
   ]
}

var CrownSolid = {
   name: "CrownSolid",
   vendor: "UiFabric",
   unicode: 62262,
   value: "",
   charCode: "F336",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1354 1167L1792 640L1792 1920L256 1920L256 640L701 1166L1024 640ZM384 384L384 384Q384 411 374 434Q364 457 346.50 474.50Q329 492 306 502Q283 512 256 512L256 512Q229 512 206 502Q183 492 165.50 474.50Q148 457 138 434Q128 411 128 384L128 384Q128 357 138 334Q148 311 165.50 293.50Q183 276 206 266Q229 256 256 256L256 256Q283 256 306 266Q329 276 346.50 293.50Q364 311 374 334Q384 357 384 384ZM1024 512L1024 512Q997 512 974 502Q951 492 933.50 474.50Q916 457 906 434Q896 411 896 384L896 384Q896 357 906 334Q916 311 933.50 293.50Q951 276 974 266Q997 256 1024 256L1024 256Q1051 256 1074 266Q1097 276 1114.50 293.50Q1132 311 1142 334Q1152 357 1152 384L1152 384Q1152 411 1142 434Q1132 457 1114.50 474.50Q1097 492 1074 502Q1051 512 1024 512ZM1792 256L1792 256Q1819 256 1842 266Q1865 276 1882.50 293.50Q1900 311 1910 334Q1920 357 1920 384L1920 384Q1920 411 1910 434Q1900 457 1882.50 474.50Q1865 492 1842 502Q1819 512 1792 512L1792 512Q1765 512 1742 502Q1719 492 1701.50 474.50Q1684 457 1674 434Q1664 411 1664 384L1664 384Q1664 357 1674 334Q1684 311 1701.50 293.50Q1719 276 1742 266Q1765 256 1792 256Z"
         }
      }
   ]
}

var QuickNoteSolid = {
   name: "QuickNoteSolid",
   vendor: "UiFabric",
   unicode: 62264,
   value: "",
   charCode: "F338",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L768 1920L768 1280L128 1280L128 128ZM640 1920L128 1408L640 1408L640 1920Z"
         }
      }
   ]
}

var PageListSolid = {
   name: "PageListSolid",
   vendor: "UiFabric",
   unicode: 62266,
   value: "",
   charCode: "F33A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1792 0L1792 1792L256 1792L256 0ZM640 1280L640 1152L512 1152L512 1280L640 1280ZM640 896L640 768L512 768L512 896L640 896ZM640 512L640 384L512 384L512 512L640 512ZM1536 1280L1536 1152L768 1152L768 1280L1536 1280ZM1536 896L1536 768L768 768L768 896L1536 896ZM1536 512L1536 384L768 384L768 512L1536 512Z"
         }
      }
   ]
}

var StarburstSolid = {
   name: "StarburstSolid",
   vendor: "UiFabric",
   unicode: 62268,
   value: "",
   charCode: "F33C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024L1664 1280L1760 1760L1280 1664L1024 2048L768 1664L288 1760L384 1280L0 1024L384 768L288 288L768 384L1024 0L1280 384L1760 288L1664 768L2048 1024Z"
         }
      }
   ]
}

var SadSolid = {
   name: "SadSolid",
   vendor: "UiFabric",
   unicode: 62270,
   value: "",
   charCode: "F33E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM640 608L640 608Q607 608 578 620.50Q549 633 527 655Q505 677 492.50 706Q480 735 480 768L480 768Q480 801 492.50 830Q505 859 527 881Q549 903 578 915.50Q607 928 640 928L640 928Q673 928 702 915.50Q731 903 753 881Q775 859 787.50 830Q800 801 800 768L800 768Q800 735 787.50 706Q775 677 753 655Q731 633 702 620.50Q673 608 640 608ZM1400 1611L1544 1484Q1494 1429 1435 1385Q1376 1341 1309.50 1310.50Q1243 1280 1171 1264Q1099 1248 1024 1248L1024 1248Q949 1248 877 1264Q805 1280 738.50 1310.50Q672 1341 612.50 1385Q553 1429 504 1484L504 1484L648 1611Q720 1530 817.50 1485Q915 1440 1024 1440L1024 1440Q1133 1440 1230.50 1485Q1328 1530 1400 1611L1400 1611ZM1408 928L1408 928Q1441 928 1470 915.50Q1499 903 1521 881Q1543 859 1555.50 830Q1568 801 1568 768L1568 768Q1568 735 1555.50 706Q1543 677 1521 655Q1499 633 1470 620.50Q1441 608 1408 608L1408 608Q1375 608 1346 620.50Q1317 633 1295 655Q1273 677 1260.50 706Q1248 735 1248 768L1248 768Q1248 801 1260.50 830Q1273 859 1295 881Q1317 903 1346 915.50Q1375 928 1408 928Z"
         }
      }
   ]
}

var ShieldSolid = {
   name: "ShieldSolid",
   vendor: "UiFabric",
   unicode: 62272,
   value: "",
   charCode: "F340",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1011 0 1057 6.50Q1103 13 1146.50 26.50Q1190 40 1232 60.50Q1274 81 1317 108L1317 108Q1389 154 1461 183Q1533 212 1607 228Q1681 244 1759 250Q1837 256 1920 256L1920 256L1920 768Q1920 914 1883.50 1045Q1847 1176 1782.50 1293.50Q1718 1411 1630 1515Q1542 1619 1439 1710.50Q1336 1802 1221.50 1881Q1107 1960 991 2027L991 2027L960 2045L929 2027Q813 1960 698.50 1881Q584 1802 481 1710.50Q378 1619 290 1515Q202 1411 137.50 1293.50Q73 1176 36.50 1045Q0 914 0 768L0 768L0 256Q83 256 161 250Q239 244 313 228Q387 212 459 183Q531 154 603 108L603 108Q688 53 773 26.50Q858 0 960 0Z"
         }
      }
   ]
}

var ShoppingCartSolid = {
   name: "ShoppingCartSolid",
   vendor: "UiFabric",
   unicode: 62274,
   value: "",
   charCode: "F342",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M750 1536L1600 1536Q1640 1536 1675 1551Q1710 1566 1736 1592Q1762 1618 1777 1653Q1792 1688 1792 1728L1792 1728Q1792 1768 1777 1803Q1762 1838 1736 1864Q1710 1890 1675 1905Q1640 1920 1600 1920L1600 1920Q1560 1920 1525 1905Q1490 1890 1464 1864Q1438 1838 1423 1803Q1408 1768 1408 1728L1408 1728Q1408 1697 1419 1664L1419 1664L885 1664Q896 1697 896 1728L896 1728Q896 1768 881 1803Q866 1838 840 1864Q814 1890 779 1905Q744 1920 704 1920L704 1920Q664 1920 629 1905Q594 1890 568 1864Q542 1838 527 1803Q512 1768 512 1728L512 1728Q512 1673 541.50 1626Q571 1579 621 1555L621 1555L189 256L0 256L0 128L281 128L366 384L2048 384L1750 1280L665 1280L750 1536ZM768 1728L768 1728Q768 1702 749 1683Q730 1664 704 1664L704 1664Q678 1664 659 1683Q640 1702 640 1728L640 1728Q640 1754 659 1773Q678 1792 704 1792L704 1792Q730 1792 749 1773Q768 1754 768 1728ZM1600 1792L1600 1792Q1626 1792 1645 1773Q1664 1754 1664 1728L1664 1728Q1664 1702 1645 1683Q1626 1664 1600 1664L1600 1664Q1574 1664 1555 1683Q1536 1702 1536 1728L1536 1728Q1536 1754 1555 1773Q1574 1792 1600 1792Z"
         }
      }
   ]
}

var ChatSolid = {
   name: "ChatSolid",
   vendor: "UiFabric",
   unicode: 62276,
   value: "",
   charCode: "F344",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1536L704 1536L256 1984L256 1536L0 1536L0 128Z"
         }
      }
   ]
}

var FinancialSolid = {
   name: "FinancialSolid",
   vendor: "UiFabric",
   unicode: 62278,
   value: "",
   charCode: "F346",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 1898L384 1514L384 2048L0 2048ZM512 2048L512 1386L896 1002L896 2048L512 2048ZM1536 1130L1792 896L1920 896L1920 2048L1536 2048L1536 1130ZM1024 1002L1344 1322L1408 1258L1408 2048L1024 2048L1024 1002ZM1536 256L2048 256L2048 768L1920 768L1920 475L1344 1050L960 666L0 1627L0 1445L960 486L1344 870L1829 384L1536 384L1536 256Z"
         }
      }
   ]
}

var HeadsetSolid = {
   name: "HeadsetSolid",
   vendor: "UiFabric",
   unicode: 62280,
   value: "",
   charCode: "F348",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1130 0 1228 27.50Q1326 55 1411.50 105Q1497 155 1567 225Q1637 295 1687 380.50Q1737 466 1764.50 564Q1792 662 1792 768L1792 768L1792 1312Q1792 1352 1764 1380Q1736 1408 1696 1408L1696 1408L1408 1408L1408 768L1664 768Q1664 680 1641 598Q1618 516 1576.50 445Q1535 374 1476.50 315.50Q1418 257 1347 215.50Q1276 174 1194 151Q1112 128 1024 128L1024 128Q936 128 854 151Q772 174 701 215.50Q630 257 571.50 315.50Q513 374 471.50 445Q430 516 407 598Q384 680 384 768L384 768L640 768L640 1408L512 1408L512 1536Q512 1589 532 1635.50Q552 1682 587 1717Q622 1752 668.50 1772Q715 1792 768 1792L768 1792L768 1744Q768 1711 791.50 1687.50Q815 1664 848 1664L848 1664L1200 1664Q1233 1664 1256.50 1687.50Q1280 1711 1280 1744L1280 1744L1280 1968Q1280 2001 1256.50 2024.50Q1233 2048 1200 2048L1200 2048L848 2048Q815 2048 791.50 2024.50Q768 2001 768 1968L768 1968L768 1920Q688 1920 618 1890Q548 1860 496 1808Q444 1756 414 1686Q384 1616 384 1536L384 1536L384 1408L352 1408Q312 1408 284 1380Q256 1352 256 1312L256 1312L256 768Q256 662 283.50 564Q311 466 361 380.50Q411 295 481 225Q551 155 636.50 105Q722 55 820 27.50Q918 0 1024 0Z"
         }
      }
   ]
}

var ParkingSolid = {
   name: "ParkingSolid",
   vendor: "UiFabric",
   unicode: 62282,
   value: "",
   charCode: "F34A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1763 512L2019 1075Q2048 1139 2048 1208L2048 1208L2048 1280Q2048 1318 2037.50 1353Q2027 1388 2007.50 1418Q1988 1448 1960 1472.50Q1932 1497 1898 1512L1898 1512Q1883 1547 1858.50 1575Q1834 1603 1803.50 1622.50Q1773 1642 1737.50 1653Q1702 1664 1664 1664L1664 1664Q1595 1664 1536 1630Q1477 1596 1442 1536L1442 1536L734 1536Q699 1596 640 1630Q581 1664 512 1664L512 1664Q443 1664 384 1630Q325 1596 290 1536L290 1536L128 1536Q101 1536 78 1526Q55 1516 37.50 1498.50Q20 1481 10 1458Q0 1435 0 1408L0 1408L0 1152Q0 1073 30 1003Q60 933 112.50 880.50Q165 828 234.50 798Q304 768 384 768L384 768L421 768L749 440Q776 413 811.50 398.50Q847 384 885 384L885 384L1792 384L1792 512L1763 512ZM512 1536L512 1536Q539 1536 562 1526Q585 1516 602.50 1498.50Q620 1481 630 1458Q640 1435 640 1408L640 1408Q640 1381 630 1358Q620 1335 602.50 1317.50Q585 1300 562 1290Q539 1280 512 1280L512 1280Q485 1280 462 1290Q439 1300 421.50 1317.50Q404 1335 394 1358Q384 1381 384 1408L384 1408Q384 1435 394 1458Q404 1481 421.50 1498.50Q439 1516 462 1526Q485 1536 512 1536ZM1152 768L1152 512L885 512Q859 512 840 531L840 531L603 768L1152 768ZM1280 512L1280 768L1739 768L1640 549Q1632 532 1616 522Q1600 512 1581 512L1581 512L1280 512ZM1664 1536L1664 1536Q1691 1536 1714 1526Q1737 1516 1754.50 1498.50Q1772 1481 1782 1458Q1792 1435 1792 1408L1792 1408Q1792 1381 1782 1358Q1772 1335 1754.50 1317.50Q1737 1300 1714 1290Q1691 1280 1664 1280L1664 1280Q1637 1280 1614 1290Q1591 1300 1573.50 1317.50Q1556 1335 1546 1358Q1536 1381 1536 1408L1536 1408Q1536 1435 1546 1458Q1556 1481 1573.50 1498.50Q1591 1516 1614 1526Q1637 1536 1664 1536Z"
         }
      }
   ]
}

var DiamondSolid = {
   name: "DiamondSolid",
   vendor: "UiFabric",
   unicode: 62284,
   value: "",
   charCode: "F34C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1423 768L625 768L892 128L1156 128L1423 768ZM1994 768L1596 768L1329 128L1452 128L1994 768ZM626 896L1422 896L1024 1842L626 896ZM1596 896L1997 896L1150 1954L1596 896ZM51 896L452 896L898 1954L51 896ZM719 128L452 768L54 768L594 128L719 128Z"
         }
      }
   ]
}

var OfflineStorageSolid = {
   name: "OfflineStorageSolid",
   vendor: "UiFabric",
   unicode: 62286,
   value: "",
   charCode: "F34E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 768L960 768Q891 768 822.50 762Q754 756 686 743L686 743Q652 736 606.50 724.50Q561 713 513.50 695Q466 677 419.50 653Q373 629 337 598.50Q301 568 278.50 530.50Q256 493 256 448L256 448Q256 403 278.50 365.50Q301 328 337 297.50Q373 267 419.50 243Q466 219 513.50 201Q561 183 606.50 171.50Q652 160 686 153L686 153Q754 140 822.50 134Q891 128 960 128L960 128Q1029 128 1097.50 134Q1166 140 1234 153L1234 153Q1268 160 1313.50 171.50Q1359 183 1406.50 201Q1454 219 1500.50 243Q1547 267 1583 297.50Q1619 328 1641.50 365.50Q1664 403 1664 448L1664 448Q1664 493 1641.50 530.50Q1619 568 1583 598.50Q1547 629 1500.50 653Q1454 677 1406.50 695Q1359 713 1313.50 725Q1268 737 1234 743L1234 743Q1166 756 1097.50 762Q1029 768 960 768ZM960 896L960 896Q1005 896 1060.50 893Q1116 890 1175.50 883Q1235 876 1295.50 864.50Q1356 853 1412.50 836Q1469 819 1518 796Q1567 773 1604 743L1604 743Q1617 732 1625.50 721.50Q1634 711 1645 699L1645 699Q1647 697 1654 692.50Q1661 688 1664 686L1664 686L1664 832Q1664 878 1641 915.50Q1618 953 1580.50 984Q1543 1015 1495.50 1039Q1448 1063 1399.50 1081Q1351 1099 1304.50 1111Q1258 1123 1224 1129L1224 1129Q1158 1141 1092 1146.50Q1026 1152 960 1152L960 1152Q894 1152 828 1146.50Q762 1141 696 1129L696 1129Q662 1123 615.50 1111Q569 1099 520.50 1081Q472 1063 424.50 1039Q377 1015 339.50 984Q302 953 279 915.50Q256 878 256 832L256 832L256 686Q259 688 266 692.50Q273 697 275 699L275 699Q286 711 294.50 721.50Q303 732 316 743L316 743Q352 773 401.50 796Q451 819 507.50 836Q564 853 624.50 864.50Q685 876 744.50 883Q804 890 859 893Q914 896 960 896ZM960 1280L960 1280Q1005 1280 1060.50 1277Q1116 1274 1175.50 1267Q1235 1260 1295.50 1248.50Q1356 1237 1412.50 1220Q1469 1203 1518 1180Q1567 1157 1604 1127L1604 1127Q1617 1116 1625.50 1105.50Q1634 1095 1645 1083L1645 1083Q1647 1081 1654 1076.50Q1661 1072 1664 1070L1664 1070L1664 1216Q1664 1262 1641 1299.50Q1618 1337 1580.50 1368Q1543 1399 1495.50 1423Q1448 1447 1399.50 1465Q1351 1483 1304.50 1495Q1258 1507 1224 1513L1224 1513Q1158 1525 1092 1530.50Q1026 1536 960 1536L960 1536Q894 1536 828 1530.50Q762 1525 696 1513L696 1513Q662 1506 615.50 1494.50Q569 1483 520.50 1465Q472 1447 424.50 1423Q377 1399 339.50 1368Q302 1337 279 1299.50Q256 1262 256 1216L256 1216L256 1070Q259 1072 266 1076.50Q273 1081 275 1083L275 1083Q286 1095 294.50 1105.50Q303 1116 316 1127L316 1127Q352 1157 401.50 1180Q451 1203 507.50 1220Q564 1237 624.50 1248.50Q685 1260 744.50 1267Q804 1274 859 1277Q914 1280 960 1280ZM960 1664L960 1664Q1005 1664 1060.50 1661Q1116 1658 1175.50 1651Q1235 1644 1295.50 1632.50Q1356 1621 1412.50 1604Q1469 1587 1518 1564Q1567 1541 1604 1511L1604 1511Q1617 1500 1625.50 1489.50Q1634 1479 1645 1467L1645 1467Q1647 1465 1654 1460.50Q1661 1456 1664 1454L1664 1454L1664 1600Q1664 1646 1641 1683.50Q1618 1721 1580.50 1752Q1543 1783 1495.50 1807Q1448 1831 1399.50 1849Q1351 1867 1304.50 1879Q1258 1891 1224 1897L1224 1897Q1158 1909 1092 1914.50Q1026 1920 960 1920L960 1920Q894 1920 828 1914.50Q762 1909 696 1897L696 1897Q662 1891 615.50 1879Q569 1867 520.50 1849Q472 1831 424.50 1807Q377 1783 339.50 1752Q302 1721 279 1683.50Q256 1646 256 1600L256 1600L256 1454Q259 1456 266 1460.50Q273 1465 275 1467L275 1467Q286 1479 294.50 1489.50Q303 1500 316 1511L316 1511Q352 1541 401.50 1564Q451 1587 507.50 1604Q564 1621 624.50 1632.50Q685 1644 744.50 1651Q804 1658 859 1661Q914 1664 960 1664Z"
         }
      }
   ]
}

var DecisionSolid = {
   name: "DecisionSolid",
   vendor: "UiFabric",
   unicode: 62288,
   value: "",
   charCode: "F350",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M490 1343L490 1343Q465 1343 441.50 1333Q418 1323 400 1305L400 1305L37 942Q0 905 0 852L0 852Q0 825 10 802Q20 779 37.50 762Q55 745 78 735Q101 725 128 725L128 725Q154 725 177.50 734.50Q201 744 219 762L219 762L581 1124Q599 1142 608.50 1165.50Q618 1189 618 1215L618 1215Q618 1241 608 1264.50Q598 1288 580.50 1305.50Q563 1323 540 1333Q517 1343 490 1343ZM1214 619L1214 619Q1189 619 1165.50 609Q1142 599 1124 581L1124 581L762 219Q724 181 724 128L724 128Q724 101 734 78Q744 55 761.50 37.50Q779 20 802 10Q825 0 852 0L852 0Q905 0 942 37L942 37L1305 400Q1323 418 1332.50 441.50Q1342 465 1342 491L1342 491Q1342 517 1332 540.50Q1322 564 1304.50 581.50Q1287 599 1264 609Q1241 619 1214 619ZM1010 694L694 1010L332 648L648 332L1010 694ZM988 897L1938 1848Q1957 1867 1957 1893L1957 1893Q1957 1919 1938 1938Q1919 1957 1893 1957L1893 1957Q1867 1957 1848 1938L1848 1938L897 988L988 897ZM0 2048L0 1920L1024 1920L1024 2048L0 2048ZM128 1792L128 1664L896 1664L896 1792L128 1792Z"
         }
      }
   ]
}

var ParachuteSolid = {
   name: "ParachuteSolid",
   vendor: "UiFabric",
   unicode: 62290,
   value: "",
   charCode: "F352",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1055 0 1148 16Q1241 32 1331 64L1331 64Q1454 108 1561 183Q1668 258 1748 357Q1828 456 1874 576.50Q1920 697 1920 832L1920 832Q1920 882 1890 920Q1860 958 1821 985L1821 985Q1816 988 1806.50 993.50Q1797 999 1787 1004Q1777 1009 1768.50 1014Q1760 1019 1758 1021L1758 1021L1280 1499L1280 1952Q1280 1992 1252 2020Q1224 2048 1184 2048L1184 2048L736 2048Q696 2048 668 2020Q640 1992 640 1952L640 1952L640 1499L162 1021Q160 1019 151.50 1014Q143 1009 133 1004Q123 999 113.50 993.50Q104 988 99 985L99 985Q60 958 30 920Q0 882 0 832L0 832Q0 697 46 576.50Q92 456 172 357Q252 258 359 183Q466 108 589 64L589 64Q679 32 772 16Q865 0 960 0ZM896 1408L896 1151Q777 1149 659.50 1137.50Q542 1126 425 1103L425 1103L731 1408L896 1408ZM1024 1408L1189 1408L1495 1103Q1378 1126 1260.50 1137.50Q1143 1149 1024 1151L1024 1151L1024 1408Z"
         }
      }
   ]
}

var ColorSolid = {
   name: "ColorSolid",
   vendor: "UiFabric",
   unicode: 62292,
   value: "",
   charCode: "F354",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q971 2048 924.50 2028Q878 2008 843 1973Q808 1938 788 1891.50Q768 1845 768 1792L768 1792Q768 1739 781.50 1688.50Q795 1638 823 1593L823 1593Q829 1582 834 1576Q839 1570 846 1560L846 1560Q871 1521 883.50 1488.50Q896 1456 896 1408L896 1408Q896 1355 876 1308.50Q856 1262 821 1227Q786 1192 739.50 1172Q693 1152 640 1152L640 1152Q592 1152 559.50 1164.50Q527 1177 488 1202L488 1202Q478 1209 472 1214Q466 1219 455 1225L455 1225Q410 1253 359.50 1266.50Q309 1280 256 1280L256 1280Q203 1280 156.50 1260Q110 1240 75 1205Q40 1170 20 1123.50Q0 1077 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1408 480L1408 480Q1375 480 1346 492.50Q1317 505 1295 527Q1273 549 1260.50 578Q1248 607 1248 640L1248 640Q1248 673 1260.50 702Q1273 731 1295 753Q1317 775 1346 787.50Q1375 800 1408 800L1408 800Q1441 800 1470 787.50Q1499 775 1521 753Q1543 731 1555.50 702Q1568 673 1568 640L1568 640Q1568 607 1555.50 578Q1543 549 1521 527Q1499 505 1470 492.50Q1441 480 1408 480ZM512 928L512 928Q545 928 574 915.50Q603 903 625 881Q647 859 659.50 830Q672 801 672 768L672 768Q672 735 659.50 706Q647 677 625 655Q603 633 574 620.50Q545 608 512 608L512 608Q479 608 450 620.50Q421 633 399 655Q377 677 364.50 706Q352 735 352 768L352 768Q352 801 364.50 830Q377 859 399 881Q421 903 450 915.50Q479 928 512 928ZM896 672L896 672Q929 672 958 659.50Q987 647 1009 625Q1031 603 1043.50 574Q1056 545 1056 512L1056 512Q1056 479 1043.50 450Q1031 421 1009 399Q987 377 958 364.50Q929 352 896 352L896 352Q863 352 834 364.50Q805 377 783 399Q761 421 748.50 450Q736 479 736 512L736 512Q736 545 748.50 574Q761 603 783 625Q805 647 834 659.50Q863 672 896 672ZM1280 1696L1280 1696Q1313 1696 1342 1683.50Q1371 1671 1393 1649Q1415 1627 1427.50 1598Q1440 1569 1440 1536L1440 1536Q1440 1503 1427.50 1474Q1415 1445 1393 1423Q1371 1401 1342 1388.50Q1313 1376 1280 1376L1280 1376Q1247 1376 1218 1388.50Q1189 1401 1167 1423Q1145 1445 1132.50 1474Q1120 1503 1120 1536L1120 1536Q1120 1569 1132.50 1598Q1145 1627 1167 1649Q1189 1671 1218 1683.50Q1247 1696 1280 1696ZM1536 1312L1536 1312Q1569 1312 1598 1299.50Q1627 1287 1649 1265Q1671 1243 1683.50 1214Q1696 1185 1696 1152L1696 1152Q1696 1119 1683.50 1090Q1671 1061 1649 1039Q1627 1017 1598 1004.50Q1569 992 1536 992L1536 992Q1503 992 1474 1004.50Q1445 1017 1423 1039Q1401 1061 1388.50 1090Q1376 1119 1376 1152L1376 1152Q1376 1185 1388.50 1214Q1401 1243 1423 1265Q1445 1287 1474 1299.50Q1503 1312 1536 1312Z"
         }
      }
   ]
}

var ReviewRequestSolid = {
   name: "ReviewRequestSolid",
   vendor: "UiFabric",
   unicode: 62294,
   value: "",
   charCode: "F356",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1245 1154L2029 1939Q2048 1958 2048 1984L2048 1984Q2048 2010 2029 2029Q2010 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1154 1245Q1059 1325 943.50 1366.50Q828 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 348.50 1312Q270 1266 206 1202Q142 1138 96 1059.50Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 348.50Q142 270 206 206Q270 142 348.50 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059.50 96Q1138 142 1202 206Q1266 270 1312 348.50Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 828 1366.50 943.50Q1325 1059 1245 1154L1245 1154ZM768 1152L768 1024L640 1024L640 1152L768 1152ZM632 896L776 896Q776 866 795 842Q814 818 842.50 794.50Q871 771 904 746.50Q937 722 965.50 691Q994 660 1013 621Q1032 582 1032 529L1032 529Q1032 464 1003 412Q974 360 927.50 323.50Q881 287 822.50 267.50Q764 248 704 248L704 248Q645 248 586.50 264.50Q528 281 481 314Q434 347 405 396.50Q376 446 376 512L376 512L520 512Q520 479 538.50 456Q557 433 585 418.50Q613 404 645 398Q677 392 704 392L704 392Q733 392 765.50 401Q798 410 825 427Q852 444 870 469.50Q888 495 888 529L888 529Q888 559 869 583Q850 607 821.50 630.50Q793 654 760 678.50Q727 703 698.50 734Q670 765 651 804Q632 843 632 896L632 896Z"
         }
      }
   ]
}

var ReviewResponseSolid = {
   name: "ReviewResponseSolid",
   vendor: "UiFabric",
   unicode: 62296,
   value: "",
   charCode: "F358",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1245 1154L2029 1939Q2048 1958 2048 1984L2048 1984Q2048 2010 2029 2029Q2010 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1154 1245Q1059 1325 943.50 1366.50Q828 1408 704 1408L704 1408Q607 1408 517 1383Q427 1358 348.50 1312Q270 1266 206 1202Q142 1138 96 1059.50Q50 981 25 891Q0 801 0 704L0 704Q0 607 25 517Q50 427 96 348.50Q142 270 206 206Q270 142 348.50 96Q427 50 517 25Q607 0 704 0L704 0Q801 0 891 25Q981 50 1059.50 96Q1138 142 1202 206Q1266 270 1312 348.50Q1358 427 1383 517Q1408 607 1408 704L1408 704Q1408 828 1366.50 943.50Q1325 1059 1245 1154L1245 1154ZM576 1096L1146 525L1011 390L576 824L420 668L284 804L576 1096Z"
         }
      }
   ]
}

var FeedbackRequestMirroredSolid = {
   name: "FeedbackRequestMirroredSolid",
   vendor: "UiFabric",
   unicode: 62298,
   value: "",
   charCode: "F35A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1536L704 1536L256 1984L256 1536L0 1536L0 128ZM1024 1408L1024 1280L896 1280L896 1408L1024 1408ZM1144 640L1288 640Q1288 572 1262 512.50Q1236 453 1191.50 408.50Q1147 364 1087.50 338Q1028 312 960 312L960 312Q892 312 832.50 338Q773 364 728.50 408.50Q684 453 658 512.50Q632 572 632 640L632 640Q632 701 651 746.50Q670 792 698.50 828Q727 864 760 894Q793 924 821.50 953.50Q850 983 869 1015Q888 1047 888 1088L888 1088L888 1152L1032 1152L1032 1088Q1032 1027 1013 981.50Q994 936 965.50 900Q937 864 904 834Q871 804 842.50 774.50Q814 745 795 713Q776 681 776 640L776 640Q776 602 790.50 568.50Q805 535 830 510Q855 485 888.50 470.50Q922 456 960 456L960 456Q998 456 1031.50 470.50Q1065 485 1090 510Q1115 535 1129.50 568.50Q1144 602 1144 640L1144 640Z"
         }
      }
   ]
}

var WorkItemBar = {
   name: "WorkItemBar",
   vendor: "UiFabric",
   unicode: 62300,
   value: "",
   charCode: "F35C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 128L1280 128L1280 1920L640 1920L640 128ZM1152 1792L1152 256L768 256L768 1792L1152 1792Z"
         }
      }
   ]
}

var Separator = {
   name: "Separator",
   vendor: "UiFabric",
   unicode: 62302,
   value: "",
   charCode: "F35E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 128L1024 128L1024 1920L896 1920L896 128Z"
         }
      }
   ]
}

var PlanView = {
   name: "PlanView",
   vendor: "UiFabric",
   unicode: 62304,
   value: "",
   charCode: "F360",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 256L128 256L128 640L2048 640L2048 768L128 768L128 1920L0 1920L0 128L2048 128L2048 256ZM256 1024L256 896L384 896L384 1024L256 1024ZM512 1024L512 896L640 896L640 1024L512 1024ZM768 1024L768 896L896 896L896 1024L768 1024ZM1024 1024L1024 896L1152 896L1152 1024L1024 1024ZM1280 1024L1280 896L1408 896L1408 1024L1280 1024ZM1536 1024L1536 896L1664 896L1664 1024L1536 1024ZM1792 1024L1792 896L1920 896L1920 1024L1792 1024ZM256 1536L256 1408L384 1408L384 1536L256 1536ZM512 1536L512 1408L640 1408L640 1536L512 1536ZM768 1536L768 1408L896 1408L896 1536L768 1536ZM1024 1536L1024 1408L1152 1408L1152 1536L1024 1536ZM1280 1536L1280 1408L1408 1408L1408 1536L1280 1536ZM1536 1536L1536 1408L1664 1408L1664 1536L1536 1536ZM1792 1536L1792 1408L1920 1408L1920 1536L1792 1536ZM256 1280L256 1152L384 1152L384 1280L256 1280ZM512 1280L512 1152L640 1152L640 1280L512 1280ZM768 1280L768 1152L896 1152L896 1280L768 1280ZM1024 1280L1024 1152L1152 1152L1152 1280L1024 1280ZM1280 1280L1280 1152L1408 1152L1408 1280L1280 1280ZM1536 1280L1536 1152L1664 1152L1664 1280L1536 1280ZM1792 1280L1792 1152L1920 1152L1920 1280L1792 1280ZM256 1792L256 1664L384 1664L384 1792L256 1792ZM512 1792L512 1664L640 1664L640 1792L512 1792ZM768 1792L768 1664L896 1664L896 1792L768 1792ZM1024 1792L1024 1664L1152 1664L1152 1792L1024 1792ZM1280 1792L1280 1664L1408 1664L1408 1792L1280 1792Z"
         }
      }
   ]
}

var EngineeringGroup = {
   name: "EngineeringGroup",
   vendor: "UiFabric",
   unicode: 62306,
   value: "",
   charCode: "F362",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M644 512L453 512Q563 389 711 322.50Q859 256 1024 256L1024 256Q1056 256 1088 259Q1120 262 1152 267L1152 267L1152 397Q1120 391 1088 387.50Q1056 384 1024 384L1024 384Q920 384 823.50 417Q727 450 644 512L644 512ZM1781 1152L1651 1152Q1657 1120 1660.50 1088Q1664 1056 1664 1024L1664 1024Q1664 992 1660.50 960Q1657 928 1651 896L1651 896L1781 896Q1786 928 1789 960Q1792 992 1792 1024L1792 1024Q1792 1056 1789 1088Q1786 1120 1781 1152L1781 1152ZM360 1408L515 1408Q560 1468 617 1515.50Q674 1563 739.50 1596Q805 1629 877 1646.50Q949 1664 1024 1664L1024 1664Q1056 1664 1088 1660.50Q1120 1657 1152 1651L1152 1651L1152 1781Q1120 1786 1088 1789Q1056 1792 1024 1792L1024 1792Q921 1792 824 1765.50Q727 1739 641 1689Q555 1639 483 1568Q411 1497 360 1408L360 1408ZM1280 128L2048 128L2048 768L1280 768L1280 128ZM1920 640L1920 256L1408 256L1408 640L1920 640ZM1280 1920L1280 1280L2048 1280L2048 1920L1280 1920ZM1408 1408L1408 1792L1920 1792L1920 1408L1408 1408ZM768 640L768 1280L0 1280L0 640L768 640ZM640 1152L640 768L128 768L128 1152L640 1152Z"
         }
      }
   ]
}

var CaretBottomRightCenter8 = {
   name: "CaretBottomRightCenter8",
   vendor: "UiFabric",
   unicode: 62308,
   value: "",
   charCode: "F364",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M331 1792L1792 331L1792 1792L331 1792ZM1536 1536L1536 949L949 1536L1536 1536Z"
         }
      }
   ]
}

var CaretTopRightCenter8 = {
   name: "CaretTopRightCenter8",
   vendor: "UiFabric",
   unicode: 62310,
   value: "",
   charCode: "F366",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M331 256L1792 256L1792 1717L331 256ZM1536 1099L1536 512L949 512L1536 1099Z"
         }
      }
   ]
}

var DonutChart = {
   name: "DonutChart",
   vendor: "UiFabric",
   unicode: 62312,
   value: "",
   charCode: "F368",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q1147 128 1261.50 160Q1376 192 1475.50 250.50Q1575 309 1657 391Q1739 473 1797.50 572.50Q1856 672 1888 786.50Q1920 901 1920 1024L1920 1024Q1920 1147 1888 1261.50Q1856 1376 1797.50 1475.50Q1739 1575 1657 1657Q1575 1739 1475.50 1797.50Q1376 1856 1261.50 1888Q1147 1920 1024 1920L1024 1920Q901 1920 786.50 1888Q672 1856 572.50 1797.50Q473 1739 391 1657Q309 1575 250.50 1475.50Q192 1376 160 1262Q128 1148 128 1024L128 1024Q128 901 160 786.50Q192 672 250.50 572.50Q309 473 391 391Q473 309 572.50 250.50Q672 192 786 160Q900 128 1024 128ZM1152 267L1152 530Q1236 552 1306.50 599Q1377 646 1428 711.50Q1479 777 1507.50 857Q1536 937 1536 1024L1536 1024L1792 1024Q1792 884 1744 757Q1696 630 1610.50 529Q1525 428 1407.50 359.50Q1290 291 1152 267L1152 267ZM1408 1024L1408 1024Q1408 945 1378 875Q1348 805 1295.50 752.50Q1243 700 1173 670Q1103 640 1024 640L1024 640Q944 640 874.50 670Q805 700 752.50 752.50Q700 805 670 875Q640 945 640 1024L640 1024Q640 1104 670 1173.50Q700 1243 752.50 1295.50Q805 1348 874.50 1378Q944 1408 1024 1408L1024 1408Q1103 1408 1173 1378Q1243 1348 1295.50 1295.50Q1348 1243 1378 1173.50Q1408 1104 1408 1024ZM1024 1792L1024 1792Q1164 1792 1291 1744Q1418 1696 1519 1610.50Q1620 1525 1688.50 1407.50Q1757 1290 1781 1152L1781 1152L1518 1152Q1496 1236 1449 1306.50Q1402 1377 1336.50 1428Q1271 1479 1191 1507.50Q1111 1536 1024 1536L1024 1536Q918 1536 825 1495.50Q732 1455 662.50 1385.50Q593 1316 552.50 1223Q512 1130 512 1024L512 1024Q512 918 552.50 825Q593 732 662.50 662.50Q732 593 825 552.50Q918 512 1024 512L1024 512L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792Z"
         }
      }
   ]
}

var ChevronFold10 = {
   name: "ChevronFold10",
   vendor: "UiFabric",
   unicode: 62314,
   value: "",
   charCode: "F36A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M414 1796L1024 1186L1634 1796L1489 1941L1024 1476L559 1941L414 1796ZM1634 252L1024 862L414 252L559 107L1024 572L1489 107L1634 252Z"
         }
      }
   ]
}

var DoubleChevronUp8 = {
   name: "DoubleChevronUp8",
   vendor: "UiFabric",
   unicode: 62316,
   value: "",
   charCode: "F36C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M262 1861L1024 1099L1786 1861L1605 2042L1024 1461L443 2042L262 1861ZM1024 437L443 1018L262 837L1024 75L1786 837L1605 1018L1024 437Z"
         }
      }
   ]
}

var DoubleChevronRight8 = {
   name: "DoubleChevronRight8",
   vendor: "UiFabric",
   unicode: 62318,
   value: "",
   charCode: "F36E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M6 443L187 262L949 1024L187 1786L6 1605L587 1024L6 443ZM1211 262L1973 1024L1211 1786L1030 1605L1611 1024L1030 443L1211 262Z"
         }
      }
   ]
}

var ChevronUpEnd6 = {
   name: "ChevronUpEnd6",
   vendor: "UiFabric",
   unicode: 62320,
   value: "",
   charCode: "F370",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M7 1799L1024 783L2041 1799L1799 2041L1024 1265L249 2041L7 1799ZM0 0L2048 0L2048 341L0 341L0 0Z"
         }
      }
   ]
}

var ChevronLeftEnd6 = {
   name: "ChevronLeftEnd6",
   vendor: "UiFabric",
   unicode: 62321,
   value: "",
   charCode: "F371",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2041 249L1265 1024L2041 1799L1799 2041L783 1024L1799 7L2041 249ZM0 2048L0 0L341 0L341 2048L0 2048Z"
         }
      }
   ]
}

var ChevronRightEnd6 = {
   name: "ChevronRightEnd6",
   vendor: "UiFabric",
   unicode: 62322,
   value: "",
   charCode: "F372",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M7 249L249 7L1265 1024L249 2041L7 1799L783 1024L7 249ZM1707 0L2048 0L2048 2048L1707 2048L1707 0Z"
         }
      }
   ]
}

var ContextMenu = {
   name: "ContextMenu",
   vendor: "UiFabric",
   unicode: 62332,
   value: "",
   charCode: "F37C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L1792 128L1792 1792L256 1792L256 128ZM1664 1664L1664 256L384 256L384 1664L1664 1664ZM1408 896L1408 1024L640 1024L640 896L1408 896ZM1408 1280L1408 1408L640 1408L640 1280L1408 1280ZM1408 512L1408 640L640 640L640 512L1408 512Z"
         }
      }
   ]
}

var AzureAPIManagement = {
   name: "AzureAPIManagement",
   vendor: "UiFabric",
   unicode: 62335,
   value: "",
   charCode: "F37F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1661 640L1661 640Q1741 640 1811.50 670Q1882 700 1934.50 751.50Q1987 803 2017.50 873Q2048 943 2048 1024L2048 1024Q2048 1104 2018 1173.50Q1988 1243 1935.50 1295.50Q1883 1348 1813 1378Q1743 1408 1664 1408L1664 1408L1536 1408L1536 1280L1664 1280Q1717 1280 1763.50 1260Q1810 1240 1845 1205Q1880 1170 1900 1123.50Q1920 1077 1920 1024L1920 1024Q1920 971 1900 924.50Q1880 878 1845 843Q1810 808 1763.50 788Q1717 768 1664 768L1664 768L1536 768L1536 704Q1536 611 1500.50 529.50Q1465 448 1404.50 387.50Q1344 327 1262.50 291.50Q1181 256 1088 256L1088 256Q1025 256 966.50 273Q908 290 857.50 321.50Q807 353 765 397.50Q723 442 693 496L693 496L668 542Q630 529 591.50 520.50Q553 512 512 512L512 512Q432 512 362.50 542Q293 572 240.50 624.50Q188 677 158 747Q128 817 128 896L128 896Q128 976 158 1045.50Q188 1115 240.50 1167.50Q293 1220 362.50 1250Q432 1280 512 1280L512 1280L617 1280Q628 1244 649 1214.50Q670 1185 698.50 1164Q727 1143 761 1131.50Q795 1120 832 1120L832 1120Q878 1120 919 1137.50Q960 1155 990.50 1185.50Q1021 1216 1038.50 1257Q1056 1298 1056 1344L1056 1344Q1056 1391 1038.50 1431.50Q1021 1472 990.50 1502.50Q960 1533 919 1550.50Q878 1568 832 1568L832 1568Q795 1568 761 1556.50Q727 1545 698.50 1524Q670 1503 649 1473.50Q628 1444 617 1408L617 1408L512 1408Q406 1408 313 1367.50Q220 1327 150.50 1257.50Q81 1188 40.50 1095Q0 1002 0 896L0 896Q0 790 40.50 697Q81 604 150.50 534.50Q220 465 313 424.50Q406 384 512 384L512 384Q558 384 605 393L605 393Q644 332 697.50 283Q751 234 813.50 199.50Q876 165 945.50 146.50Q1015 128 1088 128L1088 128Q1198 128 1296.50 167Q1395 206 1472 275Q1549 344 1599 437.50Q1649 531 1661 640ZM832 832L832 832Q938 832 1031.50 872Q1125 912 1194.50 981.50Q1264 1051 1304 1144.50Q1344 1238 1344 1344L1344 1344Q1344 1450 1304 1543.50Q1264 1637 1194.50 1706.50Q1125 1776 1031.50 1816Q938 1856 832 1856L832 1856Q729 1856 636 1817.50Q543 1779 470 1706L470 1706L561 1615Q615 1670 685 1699Q755 1728 832 1728L832 1728Q911 1728 981 1697.50Q1051 1667 1103 1615Q1155 1563 1185.50 1493Q1216 1423 1216 1344L1216 1344Q1216 1265 1185.50 1195Q1155 1125 1103 1073Q1051 1021 981 990.50Q911 960 832 960L832 960Q755 960 685 989Q615 1018 561 1073L561 1073L470 982Q543 909 636 870.50Q729 832 832 832Z"
         }
      }
   ]
}

var AzureServiceEndpoint = {
   name: "AzureServiceEndpoint",
   vendor: "UiFabric",
   unicode: 62336,
   value: "",
   charCode: "F380",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M791 1024L1920 1024L1920 1152L791 1152Q780 1188 759 1217.50Q738 1247 709.50 1268Q681 1289 647 1300.50Q613 1312 576 1312L576 1312Q529 1312 488.50 1294.50Q448 1277 417.50 1246.50Q387 1216 369.50 1175.50Q352 1135 352 1088L352 1088Q352 1042 369.50 1001Q387 960 417.50 929.50Q448 899 488.50 881.50Q529 864 576 864L576 864Q613 864 647 875.50Q681 887 709.50 908Q738 929 759 958.50Q780 988 791 1024L791 1024ZM576 1472L576 1472Q653 1472 723 1443Q793 1414 847 1359L847 1359L938 1450Q865 1523 772 1561.50Q679 1600 576 1600L576 1600Q470 1600 376.50 1560Q283 1520 213.50 1450.50Q144 1381 104 1287.50Q64 1194 64 1088L64 1088Q64 982 104 888.50Q144 795 213.50 725.50Q283 656 376.50 616Q470 576 576 576L576 576Q679 576 772 614.50Q865 653 938 726L938 726L847 817Q793 762 723 733Q653 704 576 704L576 704Q497 704 427 734.50Q357 765 305 817Q253 869 222.50 939Q192 1009 192 1088L192 1088Q192 1167 222.50 1237Q253 1307 305 1359Q357 1411 427 1441.50Q497 1472 576 1472Z"
         }
      }
   ]
}

var VSTSLogo = {
   name: "VSTSLogo",
   vendor: "UiFabric",
   unicode: 62337,
   value: "",
   charCode: "F381",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1609 439L2048 373L2048 1627L1530 2048L731 1755L731 2048L293 1463L1609 1564L1609 439ZM1609 439L293 711L293 1463L0 1338L0 749L200 488L878 293L878 0L1609 439Z"
         }
      }
   ]
}

var VSTSAltLogo1 = {
   name: "VSTSAltLogo1",
   vendor: "UiFabric",
   unicode: 62338,
   value: "",
   charCode: "F382",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1088L992 1184L992 560L1280 508L1280 1218L998 1450L564 1305L564 1451L256 1088ZM1536 0L2048 213L2048 1835L1536 2048L0 1531L1536 1759L1536 0ZM256 704L256 1088L128 1051L128 725L245 573L641 418L641 298L992 560L256 704Z"
         }
      }
   ]
}

var VSTSAltLogo2 = {
   name: "VSTSAltLogo2",
   vendor: "UiFabric",
   unicode: 62339,
   value: "",
   charCode: "F383",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1073L1024 1195L1024 555L1280 508L1280 1218L998 1450L555 1305L555 1451L256 1073ZM1536 0L2048 213L2048 1835L1536 2048L0 1531L1536 1759L1536 0ZM1998 227L1909 190L1634 436L1998 227ZM1940 288L1568 502L1568 595L1940 288ZM1866 172L1776 135L1586 334L1866 172ZM1735 118L1568 48L1568 213L1735 118ZM1568 241L1568 318L1730 148L1568 241ZM1568 372L1568 464L1855 206L1568 372ZM1568 638L1568 735L1947 420L1568 638ZM1940 1377L1568 1590L1568 1683L1940 1377ZM1568 775L1568 871L1967 546L1568 775ZM1969 681L1568 911L1568 1011L1969 681ZM1926 841L1568 1047L1568 1144L1926 841ZM1972 951L1568 1183L1568 1275L1972 951ZM1950 1100L1568 1319L1568 1408L1950 1100ZM1981 1218L1568 1454L1568 1545L1981 1218ZM1952 1507L1568 1726L1568 1778L1952 1507ZM1413 1773L1293 1755L1150 1845L1413 1773ZM1228 1746L1125 1730L1009 1804L1228 1746ZM1066 1722L968 1707L871 1764L1066 1722ZM888 1695L788 1680L731 1718L888 1695ZM637 1658L607 1674L691 1666L637 1658ZM546 1681L597 1652L351 1615L546 1681ZM600 1699L677 1725L737 1685L600 1699ZM729 1743L812 1770L903 1717L729 1743ZM868 1789L946 1816L1049 1750L868 1789ZM996 1832L1080 1861L1221 1772L996 1832ZM1126 1876L1214 1906L1385 1806L1126 1876ZM1244 1916L1332 1945L1547 1793L1473 1782L1244 1916ZM1385 1963L1487 1998L1898 1673L1385 1963ZM1535 2014L2016 1814L2016 1742L1535 2014ZM2016 1714L2016 1610L1559 1972L2016 1714ZM2016 1578L2016 1491L1396 1929L2016 1578ZM2016 1442L2016 1346L1631 1663L2016 1442ZM2016 1306L2016 1221L1628 1528L2016 1306ZM2016 1170L2016 1077L1618 1398L2016 1170ZM2016 1034L2016 947L1632 1254L2016 1034ZM2016 898L2016 797L1643 1112L2016 898ZM2016 762L2016 673L1661 966L2016 762ZM2016 626L2016 537L1646 838L2016 626ZM2016 490L2016 394L1642 705L2016 490ZM2016 352L2016 256L1630 575L2016 352ZM256 703L256 1073L128 1051L128 725L251 559L641 446L641 298L1024 555L256 703Z"
         }
      }
   ]
}

var FileTypeSolution = {
   name: "FileTypeSolution",
   vendor: "UiFabric",
   unicode: 62343,
   value: "",
   charCode: "F387",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 640L128 1664L640 1664L640 1792L0 1792L0 128L2048 128L2048 704L1920 704L1920 640L128 640ZM1920 256L128 256L128 512L1920 512L1920 256ZM1728 768L2048 890L2048 1911L1728 2048L1225 1545L890 1804L768 1728L768 1089L890 1012L1225 1271L1728 768ZM905 1591L1088 1408L905 1225L905 1591ZM1728 1682L1728 1134L1408 1408L1728 1682Z"
         }
      }
   ]
}

var DateTime12 = {
   name: "DateTime12",
   vendor: "UiFabric",
   unicode: 62351,
   value: "",
   charCode: "F38F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1707 171L1707 911Q1785 948 1848.50 1004.50Q1912 1061 1956 1131.50Q2000 1202 2024 1283Q2048 1364 2048 1451L2048 1451Q2048 1574 2001 1683Q1954 1792 1873 1873Q1792 1954 1683 2001Q1574 2048 1451 2048L1451 2048Q1364 2048 1283 2024Q1202 2000 1131.50 1956Q1061 1912 1004.50 1848.50Q948 1785 911 1707L911 1707L0 1707L0 171L341 171L341 0L512 0L512 171L1195 171L1195 0L1365 0L1365 171L1707 171ZM171 341L171 512L1536 512L1536 341L171 341ZM171 1536L859 1536Q853 1494 853 1451L853 1451Q853 1327 900 1218Q947 1109 1028 1028Q1109 947 1218 900Q1327 853 1451 853L1451 853Q1494 853 1536 859L1536 859L1536 683L171 683L171 1536ZM1451 1877L1451 1877Q1539 1877 1616.50 1843.50Q1694 1810 1752 1752Q1810 1694 1843.50 1616.50Q1877 1539 1877 1451L1877 1451Q1877 1363 1843.50 1285Q1810 1207 1752.50 1149Q1695 1091 1617 1057.50Q1539 1024 1451 1024L1451 1024Q1362 1024 1284.50 1057.50Q1207 1091 1149 1149Q1091 1207 1057.50 1285Q1024 1363 1024 1451L1024 1451Q1024 1540 1057.50 1617.50Q1091 1695 1149 1752.50Q1207 1810 1285 1843.50Q1363 1877 1451 1877ZM1536 1195L1536 1365L1707 1365L1707 1536L1365 1536L1365 1195L1536 1195Z"
         }
      }
   ]
}

var WordLogoInverse16 = {
   name: "WordLogoInverse16",
   vendor: "UiFabric",
   unicode: 62352,
   value: "",
   charCode: "F390",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1946 2038 1969.50Q2028 1993 2010.50 2010.50Q1993 2028 1969.50 2038Q1946 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 102 394 78.50Q404 55 421.50 37.50Q439 20 462.50 10Q486 0 512 0L512 0ZM512 1920L1920 1920L1920 1536L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664L512 1920ZM1280 1408L1920 1408L1920 1024L1280 1024L1280 1408ZM1280 896L1920 896L1920 512L1280 512L1280 896ZM512 384L1920 384L1920 128L512 128L512 384ZM639 962L747 1440L959 1440L1143 608L939 608L852 1083L743 608L541 608L437 1086L343 608L137 608L322 1440L537 1440L639 962Z"
         }
      }
   ]
}

var WordLogo16 = {
   name: "WordLogo16",
   vendor: "UiFabric",
   unicode: 62353,
   value: "",
   charCode: "F391",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1946 2038 1969.50Q2028 1993 2010.50 2010.50Q1993 2028 1969.50 2038Q1946 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 102 394 78.50Q404 55 421.50 37.50Q439 20 462.50 10Q486 0 512 0L512 0ZM512 1920L1920 1920L1920 1536L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664L512 1920ZM1280 1408L1920 1408L1920 1024L1280 1024L1280 1408ZM1280 896L1920 896L1920 512L1280 512L1280 896ZM512 384L1920 384L1920 128L512 128L512 384ZM639 962L747 1440L959 1440L1143 608L939 608L852 1083L743 608L541 608L437 1086L343 608L137 608L322 1440L537 1440L639 962Z"
         }
      }
   ]
}

var PlayReverseResume = {
   name: "PlayReverseResume",
   vendor: "UiFabric",
   unicode: 62436,
   value: "",
   charCode: "F3E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 256L1664 256L1664 1792L1536 1792L1536 256ZM1280 1792L192 1024L1280 256L1280 1792ZM1152 1545L1152 503L414 1024L1152 1545Z"
         }
      }
   ]
}

var D365CustomerInsights = {
   name: "D365CustomerInsights",
   vendor: "UiFabric",
   unicode: 62408,
   value: "",
   charCode: "F3C8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1852 767L1852 767Q1941 875 1992.50 1006Q2044 1137 2044 1278L2044 1278Q2044 1383 2016.50 1481Q1989 1579 1939 1664Q1889 1749 1819 1819Q1749 1889 1664 1939Q1579 1989 1481 2016.50Q1383 2044 1278 2044L1278 2044Q1213 2044 1148.50 2035Q1084 2026 1022 2006L1022 2006Q960 2026 896 2035Q832 2044 767 2044L767 2044Q662 2044 564 2016.50Q466 1989 381 1939Q296 1889 225.50 1819Q155 1749 105 1664Q55 1579 27.50 1481Q0 1383 0 1278L0 1278Q0 1184 23 1094Q46 1004 88.50 923.50Q131 843 192.50 774Q254 705 332 651L332 651Q351 510 418.50 391Q486 272 587 185Q688 98 816.50 49Q945 0 1086 0L1086 0Q1193 0 1291.50 27Q1390 54 1475 103.50Q1560 153 1629.50 223Q1699 293 1748.50 378Q1798 463 1825 561.50Q1852 660 1852 767ZM447 767L447 767Q447 851 471 932.50Q495 1014 537 1086L537 1086Q576 947 650.50 841Q725 735 843 651L843 651Q885 622 929.50 594Q974 566 1022 549L1022 549Q1081 528 1148.50 519.50Q1216 511 1278 511L1278 511Q1399 511 1506 546.50Q1613 582 1712 651L1712 651Q1692 539 1634.50 443.50Q1577 348 1492.50 278Q1408 208 1303.50 168Q1199 128 1086 128L1086 128Q981 128 884 160.50Q787 193 707 252Q627 311 566.50 393Q506 475 473 575L473 575Q457 623 452 670Q447 717 447 767ZM1405 1316L1405 1278Q1405 1183 1378 1093.50Q1351 1004 1300.50 927.50Q1250 851 1179.50 790Q1109 729 1022 690L1022 690Q939 724 872 779Q805 834 756 904Q707 974 677.50 1056Q648 1138 639 1226L639 1226Q683 1270 735 1303.50Q787 1337 844.50 1359.50Q902 1382 963 1393.50Q1024 1405 1086 1405L1086 1405Q1172 1405 1251 1379.50Q1330 1354 1405 1316L1405 1316ZM843 1903L843 1903Q861 1903 885 1901.50Q909 1900 933.50 1896.50Q958 1893 981.50 1888.50Q1005 1884 1022 1878L1022 1878Q1040 1871 1058.50 1860.50Q1077 1850 1094 1839L1094 1839Q1190 1780 1262 1692Q1334 1604 1367 1495L1367 1495Q1298 1515 1228 1530.50Q1158 1546 1086 1546L1086 1546Q966 1546 857 1510Q748 1474 651 1405L651 1405Q612 1377 576.50 1346.50Q541 1316 511 1278L511 1278Q431 1177 380 1062.50Q329 948 319 818L319 818Q274 863 238.50 916.50Q203 970 178.50 1029Q154 1088 141 1151Q128 1214 128 1278L128 1278Q128 1412 177.50 1528.50Q227 1645 313.50 1731Q400 1817 516.50 1866.50Q633 1916 767 1916L767 1916Q788 1916 805.50 1914Q823 1912 843 1903ZM1278 1916L1278 1916Q1412 1916 1528.50 1866.50Q1645 1817 1731 1731Q1817 1645 1866.50 1528.50Q1916 1412 1916 1278L1916 1278Q1916 1192 1892 1112.50Q1868 1033 1827 958L1827 958Q1785 882 1727 822.50Q1669 763 1598 722Q1527 681 1446 660Q1365 639 1278 639L1278 639Q1257 639 1239 640.50Q1221 642 1201 651L1201 651Q1365 760 1449 921Q1533 1082 1533 1278L1533 1278Q1533 1306 1528 1335Q1523 1364 1520 1392L1520 1392Q1512 1467 1484.50 1540.50Q1457 1614 1414.50 1680.50Q1372 1747 1317 1804Q1262 1861 1201 1903L1201 1903Q1221 1913 1239 1914.50Q1257 1916 1278 1916Z"
         }
      }
   ]
}

var DislikeSolid = {
   name: "DislikeSolid",
   vendor: "UiFabric",
   unicode: 62400,
   value: "",
   charCode: "F3C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 256L960 256Q1138 256 1305 325L1305 325Q1377 354 1449.50 369Q1522 384 1600 384L1600 384L2048 384L2048 1280L1631 1280Q1566 1280 1508.50 1304Q1451 1328 1405 1374L1405 1374L783 1995Q758 2020 733 2034Q708 2048 672 2048L672 2048Q639 2048 610 2035.50Q581 2023 559 2001Q537 1979 524.50 1950Q512 1921 512 1888L512 1888Q512 1807 530 1733.50Q548 1660 583 1588L583 1588Q603 1545 617 1500.50Q631 1456 636 1408L636 1408L192 1408Q153 1408 118 1393Q83 1378 56.50 1352Q30 1326 15 1291Q0 1256 0 1216L0 1216Q0 1184 10 1155L10 1155L266 387Q286 328 336 292Q386 256 448 256L448 256L960 256Z"
         }
      }
   ]
}

var Transition = {
   name: "Transition",
   vendor: "UiFabric",
   unicode: 62396,
   value: "",
   charCode: "F3BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1536L768 1472Q768 1406 742.50 1348Q717 1290 673.50 1246.50Q630 1203 572 1177.50Q514 1152 448 1152L448 1152Q382 1152 323.50 1177.50Q265 1203 221.50 1246.50Q178 1290 153 1348Q128 1406 128 1472L128 1472L128 1536L0 1536L0 1472Q0 1409 16.50 1350.50Q33 1292 64.50 1240.50Q96 1189 140 1146.50Q184 1104 240 1075L240 1075Q186 1029 157 965.50Q128 902 128 832L128 832Q128 766 153 708Q178 650 221.50 606.50Q265 563 323.50 537.50Q382 512 448 512L448 512Q514 512 572 537.50Q630 563 673.50 606.50Q717 650 742.50 708Q768 766 768 832L768 832Q768 902 739 965.50Q710 1029 656 1075L656 1075Q711 1104 755.50 1146.50Q800 1189 831.50 1240.50Q863 1292 879.50 1350.50Q896 1409 896 1472L896 1472L896 1536L768 1536ZM256 832L256 832Q256 872 271 907Q286 942 312 968Q338 994 373 1009Q408 1024 448 1024L448 1024Q488 1024 523 1009Q558 994 584 968Q610 942 625 907Q640 872 640 832L640 832Q640 792 625 757Q610 722 584 696Q558 670 523 655Q488 640 448 640L448 640Q408 640 373 655Q338 670 312 696Q286 722 271 757Q256 792 256 832ZM1808 1075L1808 1075Q1863 1104 1907.50 1146.50Q1952 1189 1983.50 1240.50Q2015 1292 2031.50 1350.50Q2048 1409 2048 1472L2048 1472L2048 1536L1920 1536L1920 1472Q1920 1406 1894.50 1348Q1869 1290 1825.50 1246.50Q1782 1203 1724 1177.50Q1666 1152 1600 1152L1600 1152Q1534 1152 1475.50 1177.50Q1417 1203 1373.50 1246.50Q1330 1290 1305 1348Q1280 1406 1280 1472L1280 1472L1280 1536L1152 1536L1152 1472Q1152 1409 1168.50 1350.50Q1185 1292 1216.50 1240.50Q1248 1189 1292 1146.50Q1336 1104 1392 1075L1392 1075Q1338 1029 1309 965.50Q1280 902 1280 832L1280 832Q1280 766 1305 708Q1330 650 1373.50 606.50Q1417 563 1475.50 537.50Q1534 512 1600 512L1600 512Q1666 512 1724 537.50Q1782 563 1825.50 606.50Q1869 650 1894.50 708Q1920 766 1920 832L1920 832Q1920 902 1891 965.50Q1862 1029 1808 1075ZM1408 832L1408 832Q1408 872 1423 907Q1438 942 1464 968Q1490 994 1525 1009Q1560 1024 1600 1024L1600 1024Q1640 1024 1675 1009Q1710 994 1736 968Q1762 942 1777 907Q1792 872 1792 832L1792 832Q1792 792 1777 757Q1762 722 1736 696Q1710 670 1675 655Q1640 640 1600 640L1600 640Q1560 640 1525 655Q1490 670 1464 696Q1438 722 1423 757Q1408 792 1408 832ZM1152 128L1152 128Q1071 128 992.50 145Q914 162 841.50 194Q769 226 703.50 272.50Q638 319 584 379L584 379L489 293Q553 223 629 168.50Q705 114 789.50 76.50Q874 39 965.50 19.50Q1057 0 1152 0L1152 0Q1289 0 1420.50 40.50Q1552 81 1664 161L1664 161L1664 0L1792 0L1792 384L1408 384L1408 256L1577 256Q1482 193 1373.50 160.50Q1265 128 1152 128ZM896 1920L896 1920Q977 1920 1055 1903Q1133 1886 1206 1854Q1279 1822 1344.50 1775.50Q1410 1729 1464 1669L1464 1669L1559 1755Q1495 1825 1419 1879.50Q1343 1934 1258 1971.50Q1173 2009 1081.50 2028.50Q990 2048 896 2048L896 2048Q759 2048 627.50 2007.50Q496 1967 384 1887L384 1887L384 2048L256 2048L256 1664L640 1664L640 1792L471 1792Q566 1855 674.50 1887.50Q783 1920 896 1920Z"
         }
      }
   ]
}

var Onboarding = {
   name: "Onboarding",
   vendor: "UiFabric",
   unicode: 62394,
   value: "",
   charCode: "F3BA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1403 512L2048 512L2048 2048L0 2048L0 512L517 512Q515 496 513.50 480Q512 464 512 448L512 448Q512 355 547 273.50Q582 192 643 131Q704 70 785.50 35Q867 0 960 0L960 0Q1053 0 1134.50 35Q1216 70 1277 131Q1338 192 1373 273.50Q1408 355 1408 448L1408 448Q1408 464 1406.50 480Q1405 496 1403 512L1403 512ZM960 128L960 128Q894 128 835.50 153.50Q777 179 733.50 222.50Q690 266 665 324Q640 382 640 448L640 448Q640 514 665 572.50Q690 631 733.50 674.50Q777 718 835.50 743Q894 768 960 768L960 768Q1026 768 1084 743Q1142 718 1185.50 674.50Q1229 631 1254.50 572.50Q1280 514 1280 448L1280 448Q1280 382 1254.50 324Q1229 266 1185.50 222.50Q1142 179 1084 153.50Q1026 128 960 128ZM1920 1920L1920 640L1365 640Q1340 692 1303 737Q1266 782 1218 814L1218 814Q1321 854 1404 920.50Q1487 987 1544.50 1072.50Q1602 1158 1633 1260Q1664 1362 1664 1472L1664 1472L1664 1536L1536 1536L1536 1472Q1536 1349 1492 1243.50Q1448 1138 1371 1061Q1294 984 1188.50 940Q1083 896 960 896L960 896Q849 896 749.50 934.50Q650 973 573.50 1041Q497 1109 448 1203Q399 1297 387 1408L387 1408L1035 1408L805 1178L896 1088L1280 1472L896 1856L805 1766L1035 1536L256 1536L256 1472Q256 1362 287.50 1260.50Q319 1159 377 1073.50Q435 988 518 921.50Q601 855 703 815L703 815Q605 746 555 640L555 640L128 640L128 1920L1920 1920Z"
         }
      }
   ]
}

var AzureKeyVault = {
   name: "AzureKeyVault",
   vendor: "UiFabric",
   unicode: 62388,
   value: "",
   charCode: "F3B4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1216L896 821Q826 804 767 765.50Q708 727 665.50 673.50Q623 620 599.50 554Q576 488 576 416L576 416Q576 330 609 254.50Q642 179 698.50 122.50Q755 66 830.50 33Q906 0 992 0L992 0Q1078 0 1153.50 33Q1229 66 1285.50 122.50Q1342 179 1375 254.50Q1408 330 1408 416L1408 416Q1408 488 1384.50 554Q1361 620 1318.50 673.50Q1276 727 1217 765.50Q1158 804 1088 821L1088 821L1088 1664L896 1664L896 1408L640 1408L640 1216L896 1216ZM992 192L992 192Q946 192 905 209.50Q864 227 833.50 257.50Q803 288 785.50 329Q768 370 768 416L768 416Q768 462 785.50 503Q803 544 833.50 574.50Q864 605 905 622.50Q946 640 992 640L992 640Q1038 640 1079 622.50Q1120 605 1150.50 574.50Q1181 544 1198.50 503Q1216 462 1216 416L1216 416Q1216 370 1198.50 329Q1181 288 1150.50 257.50Q1120 227 1079 209.50Q1038 192 992 192ZM1528 507L1528 507Q1605 569 1666 645.50Q1727 722 1769 808.50Q1811 895 1833.50 990Q1856 1085 1856 1184L1856 1184Q1856 1303 1825 1413.50Q1794 1524 1737.50 1620Q1681 1716 1602.50 1794.50Q1524 1873 1428 1929.50Q1332 1986 1221.50 2017Q1111 2048 992 2048L992 2048Q873 2048 762.50 2017Q652 1986 556 1930Q460 1874 381 1795Q302 1716 246 1620Q190 1524 159 1413.50Q128 1303 128 1184L128 1184Q128 1085 150.50 990Q173 895 215 808.50Q257 722 318 645.50Q379 569 456 507L456 507Q474 611 528 699L528 699Q428 795 374 920.50Q320 1046 320 1184L320 1184Q320 1277 344 1362.50Q368 1448 412 1523Q456 1598 517 1659Q578 1720 653 1764Q728 1808 813.50 1832Q899 1856 992 1856L992 1856Q1085 1856 1170.50 1832Q1256 1808 1331 1764Q1406 1720 1467 1659Q1528 1598 1572 1523Q1616 1448 1640 1362.50Q1664 1277 1664 1184L1664 1184Q1664 1046 1610 920.50Q1556 795 1456 699L1456 699Q1510 611 1528 507Z"
         }
      }
   ]
}

var TriggerApproval = {
   name: "TriggerApproval",
   vendor: "UiFabric",
   unicode: 62386,
   value: "",
   charCode: "F3B2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1223 768L1883 768L603 2048L313 2048L697 1280L248 1280L888 0L1607 0L1223 768ZM549 1920L1573 896L1016 896L1400 128L967 128L455 1152L904 1152L520 1920L549 1920ZM1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363Z"
         }
      }
   ]
}

var Sprint = {
   name: "Sprint",
   vendor: "UiFabric",
   unicode: 62384,
   value: "",
   charCode: "F3B0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1741 1427L2042 1728L1741 2029L1651 1939L1798 1792L1415 1792Q1498 1736 1567 1664L1567 1664L1798 1664L1651 1517L1741 1427ZM1664 1024L1664 1024Q1664 1130 1636.50 1228Q1609 1326 1559 1411.50Q1509 1497 1439 1567Q1369 1637 1283.50 1687Q1198 1737 1100 1764.50Q1002 1792 896 1792L896 1792L0 1792L0 1664L896 1664Q984 1664 1066 1641Q1148 1618 1219 1576.50Q1290 1535 1348.50 1476.50Q1407 1418 1448.50 1347Q1490 1276 1513 1194Q1536 1112 1536 1024L1536 1024Q1536 936 1513 854Q1490 772 1448.50 701Q1407 630 1348.50 571.50Q1290 513 1219 471.50Q1148 430 1066 407Q984 384 896 384L896 384Q889 384 882 384.50Q875 385 867 386L867 386L861 386L1005 531L915 621L614 320L915 19L1005 109L857 257Q867 256 876.50 256Q886 256 896 256L896 256Q1002 256 1100 283.50Q1198 311 1283.50 361Q1369 411 1439 481Q1509 551 1559 636.50Q1609 722 1636.50 820Q1664 918 1664 1024ZM516 1536L325 1536Q230 1430 179 1298.50Q128 1167 128 1024L128 1024Q128 930 150.50 839.50Q173 749 216 667.50Q259 586 320.50 516.50Q382 447 460 393L460 393L553 486Q484 530 429 589Q374 648 335.50 717.50Q297 787 276.50 864.50Q256 942 256 1024L256 1024Q256 1100 274 1172.50Q292 1245 325.50 1310.50Q359 1376 407 1433.50Q455 1491 516 1536L516 1536Z"
         }
      }
   ]
}

var TestSuite = {
   name: "TestSuite",
   vendor: "UiFabric",
   unicode: 62382,
   value: "",
   charCode: "F3AE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L608 128Q653 128 685.50 137.50Q718 147 743.50 161Q769 175 789 192Q809 209 829.50 223Q850 237 873.50 246.50Q897 256 928 256L928 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384L2048 384L2048 1747L1920 1491L1920 384L928 384Q897 384 873.50 393.50Q850 403 829.50 417Q809 431 789 448Q769 465 743.50 479Q718 493 685.50 502.50Q653 512 608 512L608 512L128 512L128 1664L937 1664L873 1792L0 1792L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128ZM128 384L608 384Q632 384 650 379.50Q668 375 683 366.50Q698 358 712.50 346.50Q727 335 744 320L744 320Q727 305 712.50 293.50Q698 282 683 273.50Q668 265 650 260.50Q632 256 608 256L608 256L128 256L128 384ZM1664 1265L1963 1863Q1977 1891 1977 1920L1977 1920Q1977 1946 1967 1969.50Q1957 1993 1939.50 2010.50Q1922 2028 1898.50 2038Q1875 2048 1849 2048L1849 2048L1095 2048Q1069 2048 1045.50 2038Q1022 2028 1004.50 2010.50Q987 1993 977 1969.50Q967 1946 967 1920L967 1920Q967 1891 981 1863L981 1863L1280 1265L1280 1024L1152 1024L1152 896L1792 896L1792 1024L1664 1024L1664 1265ZM1223 1664L1721 1664L1536 1295L1536 1024L1408 1024L1408 1295L1223 1664Z"
         }
      }
   ]
}

var TestStep = {
   name: "TestStep",
   vendor: "UiFabric",
   unicode: 62380,
   value: "",
   charCode: "F3AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1536L1001 1536L937 1664L128 1664L128 1024L640 1024L640 640L1152 640L1152 256L1920 256L1920 768L1792 768L1792 384L1280 384L1280 768L768 768L768 1152L256 1152L256 1536ZM1664 1265L1963 1863Q1977 1891 1977 1920L1977 1920Q1977 1946 1967 1969.50Q1957 1993 1939.50 2010.50Q1922 2028 1898.50 2038Q1875 2048 1849 2048L1849 2048L1095 2048Q1069 2048 1045.50 2038Q1022 2028 1004.50 2010.50Q987 1993 977 1969.50Q967 1946 967 1920L967 1920Q967 1891 981 1863L981 1863L1280 1265L1280 1024L1152 1024L1152 896L1792 896L1792 1024L1664 1024L1664 1265ZM1223 1664L1721 1664L1536 1295L1536 1024L1408 1024L1408 1295L1223 1664Z"
         }
      }
   ]
}

var TestImpactSolid = {
   name: "TestImpactSolid",
   vendor: "UiFabric",
   unicode: 62378,
   value: "",
   charCode: "F3AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M798 1850L798 1850Q798 1889 814 1925Q830 1961 857 1988.50Q884 2016 920 2032Q956 2048 995 2048L995 2048L354 2048Q314 2048 279 2033Q244 2018 217.50 1992Q191 1966 176 1931Q161 1896 161 1856L161 1856Q161 1829 168 1804.50Q175 1780 189 1757L189 1757L758 767Q768 749 768 732L768 732L768 128L640 128L640 0L1408 0L1408 128L1280 128L1280 513L1269 513Q1236 513 1208.50 519.50Q1181 526 1152 546L1152 546L1152 128L896 128L896 732Q896 784 868 832L868 832L538 1408L1024 1408L825 1756Q812 1779 805 1801.50Q798 1824 798 1850ZM1754 1575L1859 1759Q1873 1782 1880 1805.50Q1887 1829 1887 1856L1887 1856Q1887 1896 1872 1931Q1857 1966 1830.50 1992Q1804 2018 1769 2033Q1734 2048 1695 2048L1695 2048L995 2048Q1044 2048 1089.50 2023Q1135 1998 1160 1955L1160 1955L1450 1454Q1456 1488 1475 1516Q1494 1544 1521 1564.50Q1548 1585 1580.50 1596Q1613 1607 1646 1607L1646 1607Q1704 1607 1754 1575L1754 1575ZM1853 980L1853 980Q1881 980 1900.50 1001.50Q1920 1023 1920 1050L1920 1050Q1920 1064 1912 1078L1912 1078L1700 1448Q1682 1479 1646 1479L1646 1479Q1617 1479 1595 1459.50Q1573 1440 1573 1411L1573 1411Q1573 1393 1580.50 1381Q1588 1369 1598 1355L1598 1355L1419 1252L1049 1891Q1041 1905 1025.50 1912.50Q1010 1920 994 1920L994 1920Q980 1920 968 1914Q956 1908 946.50 1898Q937 1888 931.50 1875Q926 1862 926 1849L926 1849Q926 1835 934 1822L934 1822L1300 1184L1125 1082Q1117 1094 1111 1104Q1105 1114 1098.50 1121.50Q1092 1129 1082 1133.50Q1072 1138 1057 1138L1057 1138Q1028 1138 1005 1119.50Q982 1101 982 1071L982 1071Q982 1064 983.50 1055Q985 1046 989 1040L989 1040L1206 670Q1214 656 1229 648Q1244 640 1261 640L1261 640Q1289 640 1311 661Q1333 682 1333 710L1333 710Q1333 727 1325 738.50Q1317 750 1308 763L1308 763L1781 1035Q1796 1013 1809.50 996.50Q1823 980 1853 980Z"
         }
      }
   ]
}

var TestAutoSolid = {
   name: "TestAutoSolid",
   vendor: "UiFabric",
   unicode: 62376,
   value: "",
   charCode: "F3A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369L2038 1488ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792ZM1024 1600L1024 1600Q1024 1665 1038.50 1728Q1053 1791 1080.50 1848Q1108 1905 1147.50 1956Q1187 2007 1238 2048L1238 2048L354 2048Q314 2048 279 2033Q244 2018 217.50 1992Q191 1966 176 1931Q161 1896 161 1856L161 1856Q161 1829 168 1804.50Q175 1780 189 1757L189 1757L758 767Q768 749 768 732L768 732L768 128L640 128L640 0L1408 0L1408 128L1280 128L1280 732Q1280 751 1289 766L1289 766L1449 1044Q1386 1062 1329 1092L1329 1092L1179 831Q1166 808 1159 783Q1152 758 1152 732L1152 732L1152 128L896 128L896 732Q896 784 868 832L868 832L538 1408L1057 1408Q1024 1501 1024 1600Z"
         }
      }
   ]
}

var TestBeakerSolid = {
   name: "TestBeakerSolid",
   vendor: "UiFabric",
   unicode: 62374,
   value: "",
   charCode: "F3A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1290 767L1859 1758Q1873 1781 1880 1805Q1887 1829 1887 1856L1887 1856Q1887 1896 1872 1931Q1857 1966 1831 1992Q1805 2018 1770 2033Q1735 2048 1695 2048L1695 2048L354 2048Q314 2048 279 2033Q244 2018 218 1992Q192 1966 177 1931Q162 1896 162 1856L162 1856Q162 1829 168.50 1805Q175 1781 189 1758L189 1758L758 766Q768 752 768 732L768 732L768 128L640 128L640 0L1408 0L1408 128L1280 128L1280 732Q1280 751 1290 767L1290 767ZM896 128L896 732Q896 785 869 831L869 831L538 1408L1510 1408L1179 831Q1152 785 1152 732L1152 732L1152 128L896 128Z"
         }
      }
   ]
}

var VisioLogoFill16 = {
   name: "VisioLogoFill16",
   vendor: "UiFabric",
   unicode: 62372,
   value: "",
   charCode: "F3A4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var VisioLogoInverse16 = {
   name: "VisioLogoInverse16",
   vendor: "UiFabric",
   unicode: 62370,
   value: "",
   charCode: "F3A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 640L2048 640L2048 1408Q2048 1435 2038 1458Q2028 1481 2010.50 1498.50Q1993 1516 1970 1526Q1947 1536 1920 1536L1920 1536L1664 1536Q1664 1642 1624 1735.50Q1584 1829 1514.50 1898.50Q1445 1968 1351.50 2008Q1258 2048 1152 2048L1152 2048Q1065 2048 985 2019.50Q905 1991 839.50 1940Q774 1889 727 1818.50Q680 1748 658 1664L658 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L715 384L1062 37Q1099 0 1152 0L1152 0Q1205 0 1242 37L1242 37L1627 422Q1664 459 1664 512L1664 512L1920 512Q1947 512 1970 522Q1993 532 2010.50 549.50Q2028 567 2038 590Q2048 613 2048 640ZM1536 512L1152 128L896 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 768L1536 512ZM531 1440L745 1440L1060 608L833 608L641 1167L452 608L220 608L531 1440ZM1152 1920L1152 1920Q1231 1920 1301 1890Q1371 1860 1423.50 1807.50Q1476 1755 1506 1685.50Q1536 1616 1536 1536L1536 1536Q1536 1475 1517.50 1418.50Q1499 1362 1465.50 1315Q1432 1268 1384.50 1232Q1337 1196 1280 1176L1280 1176L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L792 1664Q812 1721 848 1768.50Q884 1816 931 1849.50Q978 1883 1034.50 1901.50Q1091 1920 1152 1920ZM1646 1408L1920 1408L1920 640L1589 640L1280 949L1280 1042Q1347 1060 1406 1094Q1465 1128 1512.50 1175.50Q1560 1223 1594 1282Q1628 1341 1646 1408L1646 1408Z"
         }
      }
   ]
}

var PublisherLogo16 = {
   name: "PublisherLogo16",
   vendor: "UiFabric",
   unicode: 62368,
   value: "",
   charCode: "F3A0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L2048 384L2048 1664Q2048 1691 2038 1714Q2028 1737 2010.50 1754.50Q1993 1772 1970 1782Q1947 1792 1920 1792L1920 1792L1792 1792L1792 1920Q1792 1947 1782 1970Q1772 1993 1754.50 2010.50Q1737 2028 1714 2038Q1691 2048 1664 2048L1664 2048L512 2048Q485 2048 462 2038Q439 2028 421.50 2010.50Q404 1993 394 1970Q384 1947 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0L1664 0Q1691 0 1714 10Q1737 20 1754.50 37.50Q1772 55 1782 78Q1792 101 1792 128L1792 128L1792 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384ZM361 608L361 1440L567 1440L567 1169L674 1169Q739 1169 795.50 1149.50Q852 1130 894 1092.50Q936 1055 960 1001.50Q984 948 984 880L984 880Q984 810 961.50 758.50Q939 707 899.50 673.50Q860 640 804.50 624Q749 608 683 608L683 608L361 608ZM512 1920L1664 1920L1664 1536L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664L512 1920ZM1280 1408L1664 1408L1664 1024L1280 1024L1280 1408ZM1280 896L1664 896L1664 128L512 128L512 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 896ZM1792 1664L1920 1664L1920 384L1792 384L1792 1664ZM658 987L658 987L567 987L567 791L662 791Q715 791 742.50 811.50Q770 832 770 886L770 886Q770 943 741 965Q712 987 658 987Z"
         }
      }
   ]
}

var OutlookLogoFill16 = {
   name: "OutlookLogoFill16",
   vendor: "UiFabric",
   unicode: 62366,
   value: "",
   charCode: "F39E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var OutlookLogoInverse16 = {
   name: "OutlookLogoInverse16",
   vendor: "UiFabric",
   unicode: 62364,
   value: "",
   charCode: "F39C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1005L2048 1005L2048 1934Q2048 1958 2039 1978.50Q2030 1999 2014.50 2014.50Q1999 2030 1978.50 2039Q1958 2048 1934 2048L1934 2048L370 2048Q346 2048 325.50 2039Q305 2030 289.50 2014.50Q274 1999 265 1978.50Q256 1958 256 1934L256 1934L256 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0L1792 0Q1819 0 1842 10Q1865 20 1882.50 37.50Q1900 55 1910 78Q1920 101 1920 128L1920 128L1920 256L1920 904L2022 962Q2033 969 2040.50 980Q2048 991 2048 1005ZM1792 255L1152 256L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 768L1792 768L1792 255ZM1792 1024L1792 896L1280 896L1280 1319L1792 1024ZM1024 256L512 256L512 384L1024 384L1024 256ZM638 1440L638 1440Q733 1440 810 1409Q887 1378 941 1322.50Q995 1267 1024.50 1189Q1054 1111 1054 1016L1054 1016Q1054 925 1025.50 850Q997 775 944 721Q891 667 816.50 637Q742 607 651 607L651 607Q554 607 476 637Q398 667 343 722.50Q288 778 258 856.50Q228 935 228 1032L228 1032Q228 1124 258 1199Q288 1274 342 1327.50Q396 1381 471.50 1410.50Q547 1440 638 1440ZM384 1664L384 1920L1813 1920L1255 1608Q1237 1633 1210.50 1648.50Q1184 1664 1152 1664L1152 1664L384 1664ZM1280 1476L1920 1833L1920 1102L1919 1101L1919 1103L1280 1467L1280 1476ZM454 1024L454 1024Q454 979 465.50 938Q477 897 500.50 865.50Q524 834 560 815.50Q596 797 645 797L645 797Q696 797 731 816Q766 835 788 867Q810 899 819.50 940.50Q829 982 829 1027L829 1027Q829 1073 818.50 1113.50Q808 1154 785 1184Q762 1214 726 1231.50Q690 1249 640 1249L640 1249Q591 1249 556 1230.50Q521 1212 498.50 1180.50Q476 1149 465 1108.50Q454 1068 454 1024Z"
         }
      }
   ]
}

var OneNoteLogo16 = {
   name: "OneNoteLogo16",
   vendor: "UiFabric",
   unicode: 62362,
   value: "",
   charCode: "F39A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1946 2038 1969.50Q2028 1993 2010.50 2010.50Q1993 2028 1969.50 2038Q1946 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 102 394 78.50Q404 55 421.50 37.50Q439 20 462.50 10Q486 0 512 0L512 0ZM452 1440L452 940L844 1440L1049 1440L1049 608L842 608L842 1096L460 608L244 608L244 1440L452 1440ZM1536 1920L1920 1920L1920 1536L1536 1536L1536 1920ZM1536 1408L1920 1408L1920 1024L1536 1024L1536 1408ZM1536 896L1920 896L1920 512L1536 512L1536 896ZM1408 384L1920 384L1920 128L512 128L512 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664L512 1920L1408 1920L1408 384Z"
         }
      }
   ]
}

var ExcelLogoFill16 = {
   name: "ExcelLogoFill16",
   vendor: "UiFabric",
   unicode: 62360,
   value: "",
   charCode: "F398",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var ExcelLogoInverse16 = {
   name: "ExcelLogoInverse16",
   vendor: "UiFabric",
   unicode: 62358,
   value: "",
   charCode: "F396",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1946 2038 1969.50Q2028 1993 2010.50 2010.50Q1993 2028 1969.50 2038Q1946 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 102 394 78.50Q404 55 421.50 37.50Q439 20 462.50 10Q486 0 512 0L512 0ZM238 1440L496 1440L642 1173L785 1440L1040 1440L781 1021L1034 608L790 608L650 863L521 608L262 608L508 1022L238 1440ZM512 1920L1152 1920L1152 1664L512 1664L512 1920ZM512 384L1152 384L1152 128L512 128L512 384ZM1280 1920L1920 1920L1920 1536L1280 1536L1280 1920ZM1280 1408L1920 1408L1920 1024L1280 1024L1280 1408ZM1280 896L1920 896L1920 512L1280 512L1280 896ZM1280 384L1920 384L1920 128L1280 128L1280 384Z"
         }
      }
   ]
}

var PowerPointLogo16 = {
   name: "PowerPointLogo16",
   vendor: "UiFabric",
   unicode: 62356,
   value: "",
   charCode: "F394",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M658 987L658 987L568 987L568 791L662 791Q715 791 742.50 811.50Q770 832 770 886L770 886Q770 943 741 965Q712 987 658 987ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q907 2048 795 2022Q683 1996 580.50 1947Q478 1898 388 1826.50Q298 1755 225 1664L225 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L225 384Q298 293 388 221.50Q478 150 580.50 101Q683 52 795 26Q907 0 1024 0ZM1152 137L1152 137L1152 384Q1178 384 1201.50 394.50Q1225 405 1242.50 422Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 896L1911 896Q1890 749 1823.50 620Q1757 491 1657 391Q1557 291 1428 224.50Q1299 158 1152 137ZM1024 384L1024 128Q847 128 685.50 194Q524 260 398 384L398 384L1024 384ZM683 608L361 608L361 1440L568 1440L568 1168L674 1168Q740 1168 796.50 1148.50Q853 1129 894.50 1092Q936 1055 960 1001.50Q984 948 984 880L984 880Q984 810 961.50 758.50Q939 707 899.50 673.50Q860 640 804.50 624Q749 608 683 608L683 608ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475Q1856 1375 1888 1261Q1920 1147 1920 1023L1920 1023L1280 1023L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L398 1664Q524 1788 685.50 1854Q847 1920 1024 1920Z"
         }
      }
   ]
}

var WordLogoFill16 = {
   name: "WordLogoFill16",
   vendor: "UiFabric",
   unicode: 62354,
   value: "",
   charCode: "F392",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var PowerPointLogoInverse16 = {
   name: "PowerPointLogoInverse16",
   vendor: "UiFabric",
   unicode: 62355,
   value: "",
   charCode: "F393",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M658 987L658 987L568 987L568 791L662 791Q713 791 741.50 811Q770 831 770 886L770 886Q770 943 740.50 965Q711 987 658 987ZM1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q907 2048 795 2022Q683 1996 580.50 1947Q478 1898 388 1826.50Q298 1755 225 1664L225 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L225 384Q298 293 388 221.50Q478 150 580.50 101Q683 52 795 26Q907 0 1024 0ZM1152 137L1152 137L1152 384Q1178 384 1201.50 394.50Q1225 405 1242.50 422Q1260 439 1270 462Q1280 485 1280 512L1280 512L1280 896L1911 896Q1890 749 1823.50 620Q1757 491 1657 391Q1557 291 1428 224.50Q1299 158 1152 137ZM1024 384L1024 128Q847 128 685.50 194Q524 260 398 384L398 384L1024 384ZM683 608L361 608L361 1440L568 1440L568 1168L674 1168Q739 1168 795.50 1148.50Q852 1129 894 1092Q936 1055 960 1001.50Q984 948 984 880L984 880Q984 810 961.50 758.50Q939 707 899.50 673.50Q860 640 804.50 624Q749 608 683 608L683 608ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475Q1856 1375 1888 1261Q1920 1147 1920 1023L1920 1023L1280 1023L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L398 1664Q524 1788 685.50 1854Q847 1920 1024 1920Z"
         }
      }
   ]
}

var PowerPointLogoFill16 = {
   name: "PowerPointLogoFill16",
   vendor: "UiFabric",
   unicode: 62357,
   value: "",
   charCode: "F395",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var ExcelLogo16 = {
   name: "ExcelLogo16",
   vendor: "UiFabric",
   unicode: 62359,
   value: "",
   charCode: "F397",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1946 2038 1969.50Q2028 1993 2010.50 2010.50Q1993 2028 1969.50 2038Q1946 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 102 394 78.50Q404 55 421.50 37.50Q439 20 462.50 10Q486 0 512 0L512 0ZM238 1440L496 1440L642 1173L785 1440L1040 1440L781 1021L1034 608L790 608L650 863L521 608L262 608L508 1022L238 1440ZM512 1920L1152 1920L1152 1664L512 1664L512 1920ZM512 384L1152 384L1152 128L512 128L512 384ZM1280 1920L1920 1920L1920 1536L1280 1536L1280 1920ZM1280 1408L1920 1408L1920 1024L1280 1024L1280 1408ZM1280 896L1920 896L1920 512L1280 512L1280 896ZM1280 384L1920 384L1920 128L1280 128L1280 384Z"
         }
      }
   ]
}

var OneNoteLogoInverse16 = {
   name: "OneNoteLogoInverse16",
   vendor: "UiFabric",
   unicode: 62361,
   value: "",
   charCode: "F399",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1946 2038 1969.50Q2028 1993 2010.50 2010.50Q1993 2028 1969.50 2038Q1946 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 102 394 78.50Q404 55 421.50 37.50Q439 20 462.50 10Q486 0 512 0L512 0ZM452 1440L452 940L844 1440L1049 1440L1049 608L842 608L842 1096L460 608L244 608L244 1440L452 1440ZM1536 1920L1920 1920L1920 1536L1536 1536L1536 1920ZM1536 1408L1920 1408L1920 1024L1536 1024L1536 1408ZM1536 896L1920 896L1920 512L1536 512L1536 896ZM1408 384L1920 384L1920 128L512 128L512 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664L512 1920L1408 1920L1408 384Z"
         }
      }
   ]
}

var OneNoteLogoFill16 = {
   name: "OneNoteLogoFill16",
   vendor: "UiFabric",
   unicode: 62363,
   value: "",
   charCode: "F39B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var OutlookLogo16 = {
   name: "OutlookLogo16",
   vendor: "UiFabric",
   unicode: 62365,
   value: "",
   charCode: "F39D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1005L2048 1005L2048 1934Q2048 1958 2039 1978.50Q2030 1999 2014.50 2014.50Q1999 2030 1978.50 2039Q1958 2048 1934 2048L1934 2048L370 2048Q346 2048 325.50 2039Q305 2030 289.50 2014.50Q274 1999 265 1978.50Q256 1958 256 1934L256 1934L256 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0L1792 0Q1819 0 1842 10Q1865 20 1882.50 37.50Q1900 55 1910 78Q1920 101 1920 128L1920 128L1920 904L2022 962Q2033 969 2040.50 980Q2048 991 2048 1005ZM1792 255L1152 256L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 768L1792 768L1792 255ZM1792 1024L1792 896L1280 896L1280 1319L1792 1024ZM1024 256L512 256L512 384L1024 384L1024 256ZM638 1440L638 1440Q733 1440 810 1409Q887 1378 941 1322Q995 1266 1024.50 1188Q1054 1110 1054 1016L1054 1016Q1054 925 1025.50 850Q997 775 944 721Q891 667 816.50 637Q742 607 651 607L651 607Q554 607 476 637.50Q398 668 343 723.50Q288 779 258 857.50Q228 936 228 1032L228 1032Q228 1124 258 1199Q288 1274 342 1327.50Q396 1381 471.50 1410.50Q547 1440 638 1440ZM384 1664L384 1920L1813 1920L1255 1608Q1237 1633 1210 1648.50Q1183 1664 1152 1664L1152 1664L384 1664ZM1280 1476L1920 1833L1920 1102L1919 1101L1919 1103L1280 1467L1280 1476ZM454 1024L454 1024Q454 979 465.50 938Q477 897 500.50 865.50Q524 834 560 815.50Q596 797 645 797L645 797Q696 797 731 816Q766 835 788 867Q810 899 819.50 940.50Q829 982 829 1027L829 1027Q829 1073 818.50 1113.50Q808 1154 785 1184Q762 1214 726 1231.50Q690 1249 640 1249L640 1249Q591 1249 556 1230.50Q521 1212 498.50 1180.50Q476 1149 465 1108.50Q454 1068 454 1024Z"
         }
      }
   ]
}

var PublisherLogoInverse16 = {
   name: "PublisherLogoInverse16",
   vendor: "UiFabric",
   unicode: 62367,
   value: "",
   charCode: "F39F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L2048 384L2048 1664Q2048 1691 2038 1714Q2028 1737 2010.50 1754.50Q1993 1772 1970 1782Q1947 1792 1920 1792L1920 1792L1792 1792L1792 1920Q1792 1947 1782 1970Q1772 1993 1754.50 2010.50Q1737 2028 1714 2038Q1691 2048 1664 2048L1664 2048L512 2048Q485 2048 462 2038Q439 2028 421.50 2010.50Q404 1993 394 1970Q384 1947 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0L1664 0Q1691 0 1714 10Q1737 20 1754.50 37.50Q1772 55 1782 78Q1792 101 1792 128L1792 128L1792 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384ZM361 608L361 1440L567 1440L567 1169L674 1169Q739 1169 795.50 1149.50Q852 1130 894 1092.50Q936 1055 960 1001.50Q984 948 984 880L984 880Q984 810 961.50 758.50Q939 707 899.50 673.50Q860 640 804.50 624Q749 608 683 608L683 608L361 608ZM512 1920L1664 1920L1664 1536L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664L512 1920ZM1280 1408L1664 1408L1664 1024L1280 1024L1280 1408ZM1280 896L1664 896L1664 128L512 128L512 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 896ZM1792 1664L1920 1664L1920 384L1792 384L1792 1664ZM658 987L658 987L567 987L567 791L662 791Q715 791 742.50 811.50Q770 832 770 886L770 886Q770 943 741 965Q712 987 658 987Z"
         }
      }
   ]
}

var PublisherLogoFill16 = {
   name: "PublisherLogoFill16",
   vendor: "UiFabric",
   unicode: 62369,
   value: "",
   charCode: "F3A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var VisioLogo16 = {
   name: "VisioLogo16",
   vendor: "UiFabric",
   unicode: 62371,
   value: "",
   charCode: "F3A3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 640L2048 640L2048 1408Q2048 1435 2038 1458Q2028 1481 2010.50 1498.50Q1993 1516 1970 1526Q1947 1536 1920 1536L1920 1536L1664 1536Q1664 1642 1624 1735.50Q1584 1829 1514.50 1898.50Q1445 1968 1351.50 2008Q1258 2048 1152 2048L1152 2048Q1065 2048 985 2019.50Q905 1991 839.50 1940Q774 1889 727 1818.50Q680 1748 658 1664L658 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L715 384L1062 37Q1099 0 1152 0L1152 0Q1205 0 1242 37L1242 37L1627 422Q1664 459 1664 512L1664 512L1920 512Q1947 512 1970 522Q1993 532 2010.50 549.50Q2028 567 2038 590Q2048 613 2048 640ZM1536 512L1152 128L896 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 768L1536 512ZM531 1440L745 1440L1060 608L833 608L641 1167L452 608L220 608L531 1440ZM1152 1920L1152 1920Q1231 1920 1301 1890Q1371 1860 1423.50 1807.50Q1476 1755 1506 1685.50Q1536 1616 1536 1536L1536 1536Q1536 1475 1517.50 1418.50Q1499 1362 1465.50 1315Q1432 1268 1384.50 1232Q1337 1196 1280 1176L1280 1176L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L792 1664Q812 1721 848 1768.50Q884 1816 931 1849.50Q978 1883 1034.50 1901.50Q1091 1920 1152 1920ZM1646 1408L1920 1408L1920 640L1589 640L1280 949L1280 1042Q1347 1060 1406 1094Q1465 1128 1512.50 1175.50Q1560 1223 1594 1282Q1628 1341 1646 1408L1646 1408Z"
         }
      }
   ]
}

var TestBeaker = {
   name: "TestBeaker",
   vendor: "UiFabric",
   unicode: 62373,
   value: "",
   charCode: "F3A5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1290 767L1859 1758Q1873 1781 1880 1805Q1887 1829 1887 1856L1887 1856Q1887 1896 1872 1931Q1857 1966 1831 1992Q1805 2018 1770 2033Q1735 2048 1695 2048L1695 2048L354 2048Q314 2048 279 2033Q244 2018 218 1992Q192 1966 177 1931Q162 1896 162 1856L162 1856Q162 1829 168.50 1805Q175 1781 189 1758L189 1758L758 766Q768 752 768 732L768 732L768 128L640 128L640 0L1408 0L1408 128L1280 128L1280 732Q1280 751 1290 767L1290 767ZM896 128L896 732Q896 785 869 831L869 831L538 1408L1510 1408L1179 831Q1152 785 1152 732L1152 732L1152 128L896 128ZM354 1920L1695 1920Q1721 1920 1739.50 1901Q1758 1882 1758 1856L1758 1856Q1758 1846 1755.50 1838.50Q1753 1831 1748 1823L1748 1823L1584 1536L464 1536L299 1823Q290 1838 290 1856L290 1856Q290 1882 308.50 1901Q327 1920 354 1920L354 1920Z"
         }
      }
   ]
}

var TestExploreSolid = {
   name: "TestExploreSolid",
   vendor: "UiFabric",
   unicode: 62375,
   value: "",
   charCode: "F3A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896ZM1536 1792L1536 1948Q1617 1936 1687 1900.50Q1757 1865 1811 1811Q1865 1757 1900.50 1687Q1936 1617 1948 1536L1948 1536L1792 1536L1792 1408L1948 1408Q1936 1327 1900.50 1257Q1865 1187 1811 1133Q1757 1079 1687 1043.50Q1617 1008 1536 996L1536 996L1536 1152L1408 1152L1408 996Q1327 1008 1257 1043.50Q1187 1079 1133 1133Q1079 1187 1043.50 1257Q1008 1327 996 1408L996 1408L1152 1408L1152 1536L996 1536Q1008 1617 1043.50 1687Q1079 1757 1133 1811Q1187 1865 1257 1900.50Q1327 1936 1408 1948L1408 1948L1408 1792L1536 1792ZM1344 1472L1344 1472Q1344 1434 1364.50 1402Q1385 1370 1419 1355L1419 1355L1728 1216L1589 1525Q1574 1559 1542 1579.50Q1510 1600 1472 1600L1472 1600Q1445 1600 1422 1590Q1399 1580 1381.50 1562.50Q1364 1545 1354 1522Q1344 1499 1344 1472ZM768 1488L768 1488Q768 1570 786 1648.50Q804 1727 838 1798.50Q872 1870 922 1933.50Q972 1997 1035 2048L1035 2048L354 2048Q314 2048 279 2033Q244 2018 217.50 1992Q191 1966 176 1931Q161 1896 161 1856L161 1856Q161 1829 168 1804.50Q175 1780 189 1757L189 1757L758 767Q768 749 768 732L768 732L768 128L640 128L640 0L1408 0L1408 128L1280 128L1280 732Q1280 749 1288 763.50Q1296 778 1305 792L1305 792Q1273 801 1242.50 812Q1212 823 1183 837L1183 837Q1168 817 1160 787Q1152 757 1152 732L1152 732L1152 128L896 128L896 732Q896 784 868 832L868 832L538 1408L773 1408Q771 1428 769.50 1448Q768 1468 768 1488Z"
         }
      }
   ]
}

var TestUserSolid = {
   name: "TestUserSolid",
   vendor: "UiFabric",
   unicode: 62377,
   value: "",
   charCode: "F3A9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1848 1713L1848 1713Q1894 1738 1931 1774Q1968 1810 1994 1853.50Q2020 1897 2034 1946.50Q2048 1996 2048 2048L2048 2048L1920 2048Q1920 1995 1900 1948.50Q1880 1902 1845 1867Q1810 1832 1763.50 1812Q1717 1792 1664 1792L1664 1792Q1611 1792 1564.50 1812Q1518 1832 1483 1867Q1448 1902 1428 1948.50Q1408 1995 1408 2048L1408 2048L1280 2048Q1280 1996 1294 1946.50Q1308 1897 1334 1853.50Q1360 1810 1397 1774Q1434 1738 1480 1713L1480 1713Q1446 1678 1427 1632Q1408 1586 1408 1536L1408 1536Q1408 1483 1428 1436.50Q1448 1390 1483 1355Q1518 1320 1564.50 1300Q1611 1280 1664 1280L1664 1280Q1717 1280 1763.50 1300Q1810 1320 1845 1355Q1880 1390 1900 1436.50Q1920 1483 1920 1536L1920 1536Q1920 1586 1901 1632Q1882 1678 1848 1713ZM1664 1664L1664 1664Q1691 1664 1714 1654Q1737 1644 1754.50 1626.50Q1772 1609 1782 1586Q1792 1563 1792 1536L1792 1536Q1792 1509 1782 1486Q1772 1463 1754.50 1445.50Q1737 1428 1714 1418Q1691 1408 1664 1408L1664 1408Q1637 1408 1614 1418Q1591 1428 1573.50 1445.50Q1556 1463 1546 1486Q1536 1509 1536 1536L1536 1536Q1536 1563 1546 1586Q1556 1609 1573.50 1626.50Q1591 1644 1614 1654Q1637 1664 1664 1664ZM1308 1680L1308 1680Q1233 1752 1192.50 1848Q1152 1944 1152 2048L1152 2048L354 2048Q314 2048 279 2033Q244 2018 217.50 1992Q191 1966 176 1931Q161 1896 161 1856L161 1856Q161 1829 168 1804.50Q175 1780 189 1757L189 1757L758 767Q768 751 768 732L768 732L768 128L640 128L640 0L1408 0L1408 128L1280 128L1280 732Q1280 751 1289 766L1289 766L1526 1178Q1496 1190 1468.50 1206Q1441 1222 1416 1243L1416 1243L1179 831Q1166 808 1159 783Q1152 758 1152 732L1152 732L1152 128L896 128L896 732Q896 784 868 832L868 832L538 1408L1302 1408Q1280 1472 1280 1536L1280 1536Q1280 1612 1308 1680Z"
         }
      }
   ]
}

var TestPlan = {
   name: "TestPlan",
   vendor: "UiFabric",
   unicode: 62379,
   value: "",
   charCode: "F3AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 512L1152 640L512 640L512 512L1152 512ZM256 256L256 1664L937 1664L873 1792L128 1792L128 128L1536 128L1536 768L1408 768L1408 256L256 256ZM512 1408L512 1280L1129 1280L1065 1408L512 1408ZM512 896L1024 896L1024 1024L512 1024L512 896ZM1664 1265L1963 1863Q1977 1891 1977 1920L1977 1920Q1977 1946 1967 1969.50Q1957 1993 1939.50 2010.50Q1922 2028 1898.50 2038Q1875 2048 1849 2048L1849 2048L1095 2048Q1069 2048 1045.50 2038Q1022 2028 1004.50 2010.50Q987 1993 977 1969.50Q967 1946 967 1920L967 1920Q967 1891 981 1863L981 1863L1280 1265L1280 1024L1152 1024L1152 896L1792 896L1792 1024L1664 1024L1664 1265ZM1223 1664L1721 1664L1536 1295L1536 1024L1408 1024L1408 1295L1223 1664Z"
         }
      }
   ]
}

var TestParameter = {
   name: "TestParameter",
   vendor: "UiFabric",
   unicode: 62381,
   value: "",
   charCode: "F3AD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M125 716L125 716Q125 822 158.50 907Q192 992 252.50 1051.50Q313 1111 399 1143Q485 1175 590 1175L590 1175Q664 1175 737 1162.50Q810 1150 877 1118L877 1118L877 1226Q805 1256 727 1266.50Q649 1277 572 1277L572 1277Q446 1277 341 1238Q236 1199 160 1127Q84 1055 42 952Q0 849 0 721L0 721Q0 592 44 483Q88 374 166.50 295.50Q245 217 353.50 172.50Q462 128 591 128L591 128Q706 128 808 162.50Q910 197 986.50 262Q1063 327 1107.50 422Q1152 517 1152 638L1152 638Q1152 671 1148 703.50Q1144 736 1136 768L1136 768L1024 768L1024 954Q950 1017 855 1017L855 1017Q779 1017 736 981.50Q693 946 690 867L690 867Q666 939 618 978Q570 1017 493 1017L493 1017Q438 1017 398.50 995Q359 973 333.50 936.50Q308 900 296 853.50Q284 807 284 758L284 758Q284 693 301 628Q318 563 353 510.50Q388 458 442 425Q496 392 570 392L570 392Q591 392 613 398Q635 404 654 416Q673 428 687.50 445Q702 462 709 484L709 484L720 403L836 403L813 662Q811 691 807 720.50Q803 750 803 779L803 779Q803 797 805 821Q807 845 814 866.50Q821 888 835.50 903Q850 918 875 918L875 918Q921 918 950.50 887.50Q980 857 997 813.50Q1014 770 1020.50 722.50Q1027 675 1027 640L1027 640Q1027 541 994 464Q961 387 902 335Q843 283 762.50 256Q682 229 586 229L586 229Q482 229 397 267.50Q312 306 251.50 372Q191 438 158 526.50Q125 615 125 716ZM528 918L528 918Q562 918 587.50 903.50Q613 889 631.50 865.50Q650 842 662 812Q674 782 681 750Q688 718 691 686.50Q694 655 694 629L694 629Q694 600 688.50 575Q683 550 670 531.50Q657 513 635.50 502.50Q614 492 582 492L582 492Q533 492 500.50 518.50Q468 545 448 584.50Q428 624 419.50 670Q411 716 411 755L411 755Q411 783 417 812Q423 841 436.50 864.50Q450 888 472.50 903Q495 918 528 918ZM1664 1265L1963 1863Q1977 1891 1977 1920L1977 1920Q1977 1946 1967 1969.50Q1957 1993 1939.50 2010.50Q1922 2028 1898.50 2038Q1875 2048 1849 2048L1849 2048L1095 2048Q1069 2048 1045.50 2038Q1022 2028 1004.50 2010.50Q987 1993 977 1969.50Q967 1946 967 1920L967 1920Q967 1891 981 1863L981 1863L1280 1265L1280 1024L1152 1024L1152 896L1792 896L1792 1024L1664 1024L1664 1265ZM1223 1664L1721 1664L1536 1295L1536 1024L1408 1024L1408 1295L1223 1664Z"
         }
      }
   ]
}

var TestCase = {
   name: "TestCase",
   vendor: "UiFabric",
   unicode: 62383,
   value: "",
   charCode: "F3AF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1065 1408L1001 1536L0 1536L0 0L1536 0L1536 768L1408 768L1408 128L128 128L128 1408L1065 1408ZM1664 1265L1963 1863Q1977 1891 1977 1920L1977 1920Q1977 1946 1967 1969.50Q1957 1993 1939.50 2010.50Q1922 2028 1898.50 2038Q1875 2048 1849 2048L1849 2048L1095 2048Q1069 2048 1045.50 2038Q1022 2028 1004.50 2010.50Q987 1993 977 1969.50Q967 1946 967 1920L967 1920Q967 1891 981 1863L981 1863L1280 1265L1280 1024L1152 1024L1152 896L1792 896L1792 1024L1664 1024L1664 1265ZM1223 1664L1721 1664L1536 1295L1536 1024L1408 1024L1408 1295L1223 1664ZM333 755L576 998L1203 371L1293 461L576 1178L243 845L333 755Z"
         }
      }
   ]
}

var SignOut = {
   name: "SignOut",
   vendor: "UiFabric",
   unicode: 62385,
   value: "",
   charCode: "F3B1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1792L1152 1792L1152 1920L128 1920L128 0L1152 0L1152 128L256 128ZM1448 472L1935 960L1448 1448L1368 1368L1713 1024L640 1024L640 896L1713 896L1368 552L1448 472Z"
         }
      }
   ]
}

var Rocket = {
   name: "Rocket",
   vendor: "UiFabric",
   unicode: 62387,
   value: "",
   charCode: "F3B3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 0L2048 0L2048 64Q2048 246 2015.50 404Q1983 562 1917 703Q1851 844 1751 971.50Q1651 1099 1517 1220L1517 1220L1326 1792L1024 1792L1024 1565Q886 1646 745 1721L745 1721L327 1303Q402 1162 483 1024L483 1024L256 1024L256 722L828 532Q949 397 1076.50 297Q1204 197 1345 131Q1486 65 1644 32.50Q1802 0 1984 0L1984 0ZM384 896L558 896Q587 850 616.50 805Q646 760 678 716L678 716L384 814L384 896ZM486 1280L769 1562Q820 1533 871 1504.50Q922 1476 973 1447L973 1447L601 1075Q572 1126 543.50 1177Q515 1228 486 1280L486 1280ZM1234 1664L1332 1370Q1288 1402 1243 1431.50Q1198 1461 1152 1490L1152 1490L1152 1664L1234 1664ZM1515 1043L1515 1043Q1614 944 1687.50 841.50Q1761 739 1811 627.50Q1861 516 1887.50 392.50Q1914 269 1919 129L1919 129Q1779 134 1655.50 160.50Q1532 187 1420.50 237Q1309 287 1206 360.50Q1103 434 1003 532L1003 532Q904 629 822 736.50Q740 844 668 962L668 962L1086 1380Q1204 1308 1311 1225.50Q1418 1143 1515 1043ZM1280 1024L1280 1024Q1227 1024 1180.50 1004Q1134 984 1099 949Q1064 914 1044 867.50Q1024 821 1024 768L1024 768Q1024 715 1044 668.50Q1064 622 1099 587Q1134 552 1180.50 532Q1227 512 1280 512L1280 512Q1333 512 1379.50 532Q1426 552 1461 587Q1496 622 1516 668.50Q1536 715 1536 768L1536 768Q1536 821 1516 867.50Q1496 914 1461 949Q1426 984 1379.50 1004Q1333 1024 1280 1024ZM1280 640L1280 640Q1253 640 1230 650Q1207 660 1189.50 677.50Q1172 695 1162 718Q1152 741 1152 768L1152 768Q1152 795 1162 818Q1172 841 1189.50 858.50Q1207 876 1230 886Q1253 896 1280 896L1280 896Q1307 896 1330 886Q1353 876 1370.50 858.50Q1388 841 1398 818Q1408 795 1408 768L1408 768Q1408 741 1398 718Q1388 695 1370.50 677.50Q1353 660 1330 650Q1307 640 1280 640ZM256 1536L256 1536Q309 1536 355.50 1556Q402 1576 437 1611Q472 1646 492 1692.50Q512 1739 512 1792L512 1792Q512 1845 492 1891.50Q472 1938 437 1973Q402 2008 355.50 2028Q309 2048 256 2048L256 2048L0 2048L0 1792Q0 1739 20 1692.50Q40 1646 75 1611Q110 1576 156.50 1556Q203 1536 256 1536ZM128 1920L256 1920Q283 1920 306 1910Q329 1900 346.50 1882.50Q364 1865 374 1842Q384 1819 384 1792L384 1792Q384 1765 374 1742Q364 1719 346.50 1701.50Q329 1684 306 1674Q283 1664 256 1664L256 1664Q229 1664 206 1674Q183 1684 165.50 1701.50Q148 1719 138 1742Q128 1765 128 1792L128 1792L128 1920Z"
         }
      }
   ]
}

var LikeSolid = {
   name: "LikeSolid",
   vendor: "UiFabric",
   unicode: 62399,
   value: "",
   charCode: "F3BF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1412 640L1856 640Q1895 640 1930 655Q1965 670 1991.50 696Q2018 722 2033 757Q2048 792 2048 832L2048 832Q2048 864 2038 893L2038 893L1782 1661Q1772 1690 1754 1714.50Q1736 1739 1712 1756Q1688 1773 1659.50 1782.50Q1631 1792 1600 1792L1600 1792L1088 1792Q909 1792 743 1723L743 1723Q671 1694 598.50 1679Q526 1664 448 1664L448 1664L0 1664L0 768L417 768Q482 768 539.50 744Q597 720 643 674L643 674L1265 53Q1290 28 1315 14Q1340 0 1376 0L1376 0Q1409 0 1438 12.50Q1467 25 1489 47Q1511 69 1523.50 98Q1536 127 1536 160L1536 160Q1536 241 1518 314.50Q1500 388 1465 460L1465 460Q1445 503 1431 547.50Q1417 592 1412 640L1412 640Z"
         }
      }
   ]
}

var EditCreate = {
   name: "EditCreate",
   vendor: "UiFabric",
   unicode: 62409,
   value: "",
   charCode: "F3C9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M579 1054L226 701Q178 653 153 591.50Q128 530 128 464L128 464Q128 393 154 332.50Q180 272 225.50 227.50Q271 183 332 157.50Q393 132 463 132L463 132Q529 132 591.50 155.50Q654 179 701 226L701 226L1054 579L963 670L768 475L475 768L670 963L579 1054ZM464 258L464 258Q421 258 383 273.50Q345 289 317 317Q289 345 272.50 382.50Q256 420 256 464L256 464Q256 502 266.50 530.50Q277 559 295 583.50Q313 608 336 630Q359 652 384 677L384 677L677 384Q651 359 629.50 336Q608 313 584 295.50Q560 278 531.50 268Q503 258 464 258ZM1890 1415L2048 2048L1415 1890L1122 1597L1213 1506L1430 1724Q1446 1672 1474.50 1625.50Q1503 1579 1541 1541Q1579 1503 1625 1475Q1671 1447 1724 1430L1724 1430L1506 1213L1597 1122L1890 1415ZM1543 1790L1872 1872L1790 1543Q1743 1553 1702.50 1575.50Q1662 1598 1629.50 1630Q1597 1662 1575 1703Q1553 1744 1543 1790L1543 1790ZM1728 192L1728 192Q1781 192 1827.50 212Q1874 232 1909 267Q1944 302 1964 348.50Q1984 395 1984 448L1984 448Q1984 499 1964.50 546Q1945 593 1909 629L1909 629L763 1775Q754 1834 726 1883.50Q698 1933 656 1970Q614 2007 560.50 2027.50Q507 2048 448 2048L448 2048L0 2048L0 1920Q11 1920 23.50 1916.50Q36 1913 45 1908L45 1908Q70 1895 86 1875Q102 1855 111.50 1831Q121 1807 124.50 1780.50Q128 1754 128 1728L128 1728Q128 1669 148.50 1615.50Q169 1562 206 1520Q243 1478 292.50 1450Q342 1422 401 1413L401 1413L1547 267Q1583 231 1630 211.50Q1677 192 1728 192ZM192 1920L448 1920Q488 1920 523 1905Q558 1890 584 1864Q610 1838 625 1803Q640 1768 640 1728L640 1728Q640 1688 625 1653Q610 1618 584 1592Q558 1566 523 1551Q488 1536 448 1536L448 1536Q408 1536 373 1551Q338 1566 312 1592Q286 1618 271 1653Q256 1688 256 1728L256 1728Q256 1832 192 1920L192 1920ZM745 1612L966 1391Q934 1328 891 1285Q848 1242 785 1210L785 1210L564 1431Q626 1455 673.50 1502.50Q721 1550 745 1612L745 1612ZM1060 1297L1818 538Q1855 501 1855 448L1855 448Q1855 422 1845 399Q1835 376 1817.50 358.50Q1800 341 1777 331Q1754 321 1728 321L1728 321Q1675 321 1638 358L1638 358L879 1116Q940 1152 982 1194Q1024 1236 1060 1297L1060 1297Z"
         }
      }
   ]
}

var PlayReverse = {
   name: "PlayReverse",
   vendor: "UiFabric",
   unicode: 62437,
   value: "",
   charCode: "F3E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1024L1536 128L1536 1920L256 1024ZM1408 1674L1408 374L479 1024L1408 1674Z"
         }
      }
   ]
}

var SearchData = {
   name: "SearchData",
   vendor: "UiFabric",
   unicode: 62449,
   value: "",
   charCode: "F3F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547 1646Q1490 1628 1442 1593L1442 1593L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1351 1502Q1316 1454 1298 1397Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536ZM384 637L384 1600Q384 1615 392.50 1627.50Q401 1640 411 1650L411 1650Q440 1679 484.50 1701Q529 1723 579 1738.50Q629 1754 679 1764.50Q729 1775 768 1780L768 1780L768 1908L760 1908Q754 1908 752 1907L752 1907Q713 1902 661.50 1891.50Q610 1881 555 1864.50Q500 1848 447 1824.50Q394 1801 352 1768.50Q310 1736 284 1694.50Q258 1653 258 1600L258 1600L258 448Q258 400 280 361.50Q302 323 338.50 292Q375 261 421.50 237.50Q468 214 517 196.50Q566 179 612.50 168Q659 157 696 150L696 150Q762 139 828 133.50Q894 128 960 128L960 128Q1027 128 1093 133.50Q1159 139 1225 151L1225 151Q1261 157 1308 168.50Q1355 180 1403.50 197Q1452 214 1499 237.50Q1546 261 1582.50 292Q1619 323 1641.50 361.50Q1664 400 1664 448L1664 448L1664 768L1536 768L1536 637Q1478 674 1406 699Q1334 724 1257.50 739.50Q1181 755 1104.50 761.50Q1028 768 960 768L960 768Q892 768 815.50 761.50Q739 755 662.50 739.50Q586 724 514 699Q442 674 384 637L384 637ZM960 256L960 256Q903 256 829.50 262Q756 268 681.50 282.50Q607 297 538.50 322Q470 347 424 385L424 385Q410 396 397 412.50Q384 429 384 448L384 448Q384 467 397 483.50Q410 500 424 511L424 511Q470 549 538.50 574Q607 599 681.50 613.50Q756 628 829.50 634Q903 640 960 640L960 640Q1017 640 1090.50 634Q1164 628 1238.50 613.50Q1313 599 1381 574Q1449 549 1495 511L1495 511Q1509 500 1522.50 483.50Q1536 467 1536 448L1536 448Q1536 429 1522.50 412.50Q1509 396 1495 385L1495 385Q1449 347 1381 322Q1313 297 1238.50 282.50Q1164 268 1090.50 262Q1017 256 960 256Z"
         }
      }
   ]
}

var UnSetColor = {
   name: "UnSetColor",
   vendor: "UiFabric",
   unicode: 62457,
   value: "",
   charCode: "F3F9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1792L0 1792L0 256ZM1920 1664L1920 384L128 384L128 1664L1920 1664ZM1792 512L1792 1536L256 1536L256 512L1792 512ZM1664 1355L1664 640L540 640L1664 1355ZM384 693L384 1408L1508 1408L384 693Z"
         }
      }
   ]
}

var AutoDeploySettings = {
   name: "AutoDeploySettings",
   vendor: "UiFabric",
   unicode: 62458,
   value: "",
   charCode: "F3FA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369L2038 1488ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792ZM1085 1280L896 1280L896 1408L1026 1408Q1015 1439 1008.50 1471.50Q1002 1504 998 1536L998 1536L512 1536L512 1408L768 1408L768 1280L0 1280L0 256L1664 256L1664 1024L1536 1024L1536 384L128 384L128 1152L1192 1152Q1130 1209 1085 1280L1085 1280Z"
         }
      }
   ]
}

var TeamsLogo16 = {
   name: "TeamsLogo16",
   vendor: "UiFabric",
   unicode: 62474,
   value: "",
   charCode: "F40A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 873L2048 873Q2048 1004 2047.50 1133.50Q2047 1263 2047 1394L2047 1394Q2047 1466 2019.50 1530Q1992 1594 1945 1641Q1898 1688 1834 1715.50Q1770 1743 1698 1743L1698 1743Q1648 1743 1603 1730L1603 1730Q1566 1803 1511.50 1862Q1457 1921 1390.50 1962Q1324 2003 1247 2025.50Q1170 2048 1088 2048L1088 2048Q996 2048 911.50 2020.50Q827 1993 755.50 1942.50Q684 1892 629.50 1821Q575 1750 545 1664L545 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L768 384Q768 305 798 235Q828 165 880.50 112.50Q933 60 1002.50 30Q1072 0 1152 0L1152 0Q1231 0 1301 30Q1371 60 1423.50 112.50Q1476 165 1506 235Q1536 305 1536 384L1536 384Q1536 445 1517.50 501.50Q1499 558 1465.50 605.50Q1432 653 1384.50 689.50Q1337 726 1280 746L1280 746L1280 768L1943 768Q1965 768 1984 776.50Q2003 785 2017 799Q2031 813 2039.50 832Q2048 851 2048 873ZM1152 128L1152 128Q1099 128 1052.50 148Q1006 168 971 203Q936 238 916 284.50Q896 331 896 384L896 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 606Q1340 571 1374 512Q1408 453 1408 384L1408 384Q1408 331 1388 284.50Q1368 238 1333 203Q1298 168 1251.50 148Q1205 128 1152 128ZM608 800L608 1440L800 1440L800 800L1056 800L1056 608L352 608L352 800L608 800ZM1536 1472L1536 1472L1536 896L1280 896L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L683 1664Q711 1723 753.50 1770Q796 1817 849 1850.50Q902 1884 962.50 1902Q1023 1920 1088 1920L1088 1920Q1181 1920 1262.50 1884.50Q1344 1849 1404.50 1788.50Q1465 1728 1500.50 1646.50Q1536 1565 1536 1472ZM1920 1394L1920 1394L1920 896L1664 896L1664 1472Q1664 1540 1647 1610L1647 1610Q1675 1615 1698 1615L1698 1615Q1744 1615 1784.50 1597.50Q1825 1580 1855 1550Q1885 1520 1902.50 1480Q1920 1440 1920 1394ZM1792 640L1792 640Q1739 640 1692.50 620Q1646 600 1611 565Q1576 530 1556 483.50Q1536 437 1536 384L1536 384Q1536 331 1556 284.50Q1576 238 1611 203Q1646 168 1692.50 148Q1739 128 1792 128L1792 128Q1845 128 1891.50 148Q1938 168 1973 203Q2008 238 2028 284.50Q2048 331 2048 384L2048 384Q2048 437 2028 483.50Q2008 530 1973 565Q1938 600 1891.50 620Q1845 640 1792 640ZM1792 256L1792 256Q1765 256 1742 266Q1719 276 1701.50 293.50Q1684 311 1674 334Q1664 357 1664 384L1664 384Q1664 411 1674 434Q1684 457 1701.50 474.50Q1719 492 1742 502Q1765 512 1792 512L1792 512Q1819 512 1842 502Q1865 492 1882.50 474.50Q1900 457 1910 434Q1920 411 1920 384L1920 384Q1920 357 1910 334Q1900 311 1882.50 293.50Q1865 276 1842 266Q1819 256 1792 256Z"
         }
      }
   ]
}

var TeamsLogoFill16 = {
   name: "TeamsLogoFill16",
   vendor: "UiFabric",
   unicode: 62475,
   value: "",
   charCode: "F40B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var Spacer = {
   name: "Spacer",
   vendor: "UiFabric",
   unicode: 62477,
   value: "",
   charCode: "F40D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1562L659 1261L749 1171L896 1317L896 1024L1024 1024L1024 1317L1171 1171L1261 1261L960 1562ZM1024 896L896 896L896 603L749 749L659 659L960 358L1261 659L1171 749L1024 603L1024 896ZM0 128L1920 128L1920 256L0 256L0 128ZM0 1792L0 1664L1920 1664L1920 1792L0 1792Z"
         }
      }
   ]
}

var SkypeLogo16 = {
   name: "SkypeLogo16",
   vendor: "UiFabric",
   unicode: 62478,
   value: "",
   charCode: "F40E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1853 1142L1853 1142Q1886 1201 1903.50 1265.50Q1921 1330 1921 1398L1921 1398Q1921 1506 1880 1601.50Q1839 1697 1767.50 1767.50Q1696 1838 1600.50 1879Q1505 1920 1397 1920L1397 1920Q1327 1920 1259.50 1901.50Q1192 1883 1132 1848L1132 1848Q1107 1850 1082.50 1852Q1058 1854 1033 1854L1033 1854Q919 1854 813.50 1824.50Q708 1795 615.50 1741.50Q523 1688 447.50 1612.50Q372 1537 317.50 1445Q263 1353 233.50 1247.50Q204 1142 204 1028L204 1028Q204 998 206.50 967.50Q209 937 214 907L214 907Q180 848 162.50 782.50Q145 717 145 649L145 649Q145 541 186 446Q227 351 298.50 280.50Q370 210 465 169Q560 128 668 128L668 128Q741 128 811 148Q881 168 944 207L944 207Q967 205 988.50 203.50Q1010 202 1033 202L1033 202Q1147 202 1252.50 231.50Q1358 261 1450.50 314.50Q1543 368 1618.50 443.50Q1694 519 1748.50 611Q1803 703 1832.50 808.50Q1862 914 1862 1028L1862 1028Q1862 1057 1859.50 1085Q1857 1113 1853 1142ZM1386 1238L1386 1238Q1386 1177 1366 1131Q1346 1085 1312.50 1050Q1279 1015 1237 989Q1195 963 1150.50 943Q1106 923 1064 906.50Q1022 890 988.50 873.50Q955 857 935 839Q915 821 915 797L915 797Q915 773 927.50 758Q940 743 958.50 735Q977 727 999 724Q1021 721 1040 721L1040 721Q1073 721 1102 729Q1131 737 1156.50 747Q1182 757 1205 765Q1228 773 1249 773L1249 773Q1296 773 1323.50 741Q1351 709 1351 664L1351 664Q1351 630 1335 605Q1319 580 1293.50 563Q1268 546 1235 535.50Q1202 525 1168 519.50Q1134 514 1101.50 512Q1069 510 1044 510L1044 510Q978 510 909 526.50Q840 543 784.50 578.50Q729 614 693.50 669Q658 724 658 802L658 802Q658 883 693 938.50Q728 994 780 1032Q832 1070 893.50 1096Q955 1122 1007 1144.50Q1059 1167 1094 1191Q1129 1215 1129 1249L1129 1249Q1129 1274 1118.50 1289.50Q1108 1305 1091 1313Q1074 1321 1053.50 1324Q1033 1327 1013 1327L1013 1327Q971 1327 939.50 1316.50Q908 1306 881 1293Q854 1280 828 1269.50Q802 1259 771 1259L771 1259Q723 1259 691.50 1288Q660 1317 660 1366L660 1366Q660 1403 678.50 1430.50Q697 1458 726.50 1477Q756 1496 793.50 1508Q831 1520 869.50 1526.50Q908 1533 944.50 1535.50Q981 1538 1008 1538L1008 1538Q1081 1538 1149 1522.50Q1217 1507 1269.50 1471.50Q1322 1436 1354 1378.50Q1386 1321 1386 1238Z"
         }
      }
   ]
}

var SkypeForBusinessLogo16 = {
   name: "SkypeForBusinessLogo16",
   vendor: "UiFabric",
   unicode: 62479,
   value: "",
   charCode: "F40F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M836 795L836 795Q836 830 861.50 851.50Q887 873 929.50 886.50Q972 900 1025.50 910Q1079 920 1135.50 933Q1192 946 1245.50 965.50Q1299 985 1341.50 1018Q1384 1051 1409.50 1101Q1435 1151 1435 1224L1435 1224Q1435 1310 1399 1369.50Q1363 1429 1305 1466Q1247 1503 1174 1519.50Q1101 1536 1027 1536L1027 1536Q977 1536 922.50 1528.50Q868 1521 817 1503.50Q766 1486 721.50 1457Q677 1428 647 1384L647 1384Q632 1362 622.50 1337Q613 1312 613 1286L613 1286Q613 1244 641.50 1219.50Q670 1195 710 1195L710 1195Q740 1195 759.50 1208.50Q779 1222 795.50 1242Q812 1262 829 1285.50Q846 1309 871 1329Q896 1349 933 1362.50Q970 1376 1027 1376L1027 1376Q1056 1376 1088.50 1368Q1121 1360 1148 1343Q1175 1326 1193 1301Q1211 1276 1211 1241L1211 1241Q1211 1219 1203 1202Q1195 1185 1181 1173Q1167 1161 1149 1153Q1131 1145 1112 1140L1112 1140Q1049 1123 985.50 1108Q922 1093 859 1076L859 1076Q804 1062 760 1040.50Q716 1019 685 987Q654 955 637 911Q620 867 620 808L620 808Q620 726 654.50 669.50Q689 613 744 578Q799 543 868.50 527.50Q938 512 1009 512L1009 512Q1039 512 1079.50 518Q1120 524 1162.50 536Q1205 548 1246 566.50Q1287 585 1319.50 610Q1352 635 1372 667Q1392 699 1392 738L1392 738Q1392 759 1383.50 775.50Q1375 792 1361 802.50Q1347 813 1328.50 818.50Q1310 824 1291 824L1291 824Q1266 824 1248.50 813.50Q1231 803 1215 786.50Q1199 770 1182 751.50Q1165 733 1141 716.50Q1117 700 1082 689.50Q1047 679 995 679L995 679Q967 679 939 685Q911 691 888 704.50Q865 718 850.50 740Q836 762 836 795ZM1915 1107L1915 1107Q1979 1185 2013.50 1278.50Q2048 1372 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1372 2048 1278.50 2013.50Q1185 1979 1107 1915L1107 1915Q1086 1918 1065.50 1919Q1045 1920 1024 1920L1024 1920Q900 1920 785.50 1888Q671 1856 571.50 1797.50Q472 1739 390.50 1657.50Q309 1576 250.50 1476.50Q192 1377 160 1262.50Q128 1148 128 1024L128 1024Q128 1003 129 982.50Q130 962 133 941L133 941Q69 863 34.50 769.50Q0 676 0 576L0 576Q0 457 45.50 352Q91 247 169 169Q247 91 352 45.50Q457 0 576 0L576 0Q676 0 769.50 34.50Q863 69 941 133L941 133Q962 130 982.50 129Q1003 128 1024 128L1024 128Q1148 128 1262.50 160Q1377 192 1476.50 250.50Q1576 309 1657.50 390.50Q1739 472 1797.50 571.50Q1856 671 1888 785.50Q1920 900 1920 1024L1920 1024Q1920 1045 1919 1065.50Q1918 1086 1915 1107ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1375 1883.50 1296.50Q1847 1218 1782 1149L1782 1149Q1785 1117 1788.50 1086.50Q1792 1056 1792 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256L1024 256Q992 256 961.50 259.50Q931 263 899 266L899 266Q830 201 751.50 164.50Q673 128 576 128L576 128Q483 128 401.50 163.50Q320 199 259.50 259.50Q199 320 163.50 401.50Q128 483 128 576L128 576Q128 673 164.50 751.50Q201 830 266 899L266 899Q263 931 259.50 961.50Q256 992 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792L1024 1792Q1056 1792 1086.50 1788.50Q1117 1785 1149 1782L1149 1782Q1218 1847 1296.50 1883.50Q1375 1920 1472 1920Z"
         }
      }
   ]
}

var SkypeForBusinessLogoFill16 = {
   name: "SkypeForBusinessLogoFill16",
   vendor: "UiFabric",
   unicode: 62480,
   value: "",
   charCode: "F410",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1849 1127L1849 1127Q1913 1204 1948.50 1287Q1984 1370 1984 1472L1984 1472Q1984 1578 1943.50 1671Q1903 1764 1833.50 1833.50Q1764 1903 1671 1943.50Q1578 1984 1472 1984L1472 1984Q1370 1984 1287 1948.50Q1204 1913 1127 1849L1127 1849Q1101 1853 1075.50 1854.50Q1050 1856 1024 1856L1024 1856Q909 1856 803 1826Q697 1796 604.50 1742Q512 1688 436 1612Q360 1536 306 1443.50Q252 1351 222 1245Q192 1139 192 1024L192 1024Q192 998 193.50 972.50Q195 947 199 921L199 921Q135 844 99.50 761Q64 678 64 576L64 576Q64 470 104.50 377Q145 284 214.50 214.50Q284 145 377 104.50Q470 64 576 64L576 64Q678 64 761 99.50Q844 135 921 199L921 199Q947 195 972.50 193.50Q998 192 1024 192L1024 192Q1139 192 1245 222Q1351 252 1443.50 306Q1536 360 1612 436Q1688 512 1742 604.50Q1796 697 1826 803Q1856 909 1856 1024L1856 1024Q1856 1050 1854.50 1075.50Q1853 1101 1849 1127Z"
         }
      }
   ]
}

var FilterSolid = {
   name: "FilterSolid",
   vendor: "UiFabric",
   unicode: 62482,
   value: "",
   charCode: "F412",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 347L1280 1115L1280 1920L768 1920L768 1115L0 347L0 128Z"
         }
      }
   ]
}

var MailUndelivered = {
   name: "MailUndelivered",
   vendor: "UiFabric",
   unicode: 62485,
   value: "",
   charCode: "F415",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1280L1920 1280L1920 648L1024 1095L128 648L128 1536L1280 1536L1280 1664L0 1664L0 384ZM143 512L1024 953L1905 512L143 512ZM1955 1411L2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var MailTentative = {
   name: "MailTentative",
   vendor: "UiFabric",
   unicode: 62486,
   value: "",
   charCode: "F416",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1024L1920 1024L1920 648L1024 1095L128 648L128 1536L1536 1536L1536 1664L0 1664L0 384ZM143 512L1024 953L1905 512L143 512ZM1664 2048L1664 1920L1792 1920L1792 2048L1664 2048ZM1728 1152L1728 1152Q1781 1152 1827.50 1172Q1874 1192 1909 1227Q1944 1262 1964 1308.50Q1984 1355 1984 1408L1984 1408Q1984 1454 1970 1489Q1956 1524 1934.50 1552Q1913 1580 1888 1602.50Q1863 1625 1841.50 1647Q1820 1669 1806 1692Q1792 1715 1792 1744L1792 1744L1792 1792L1664 1792L1664 1744Q1664 1697 1678 1662.50Q1692 1628 1713.50 1600Q1735 1572 1760 1549.50Q1785 1527 1806.50 1505Q1828 1483 1842 1460Q1856 1437 1856 1408L1856 1408Q1856 1381 1846 1358Q1836 1335 1818.50 1317.50Q1801 1300 1778 1290Q1755 1280 1728 1280L1728 1280Q1701 1280 1678 1290Q1655 1300 1637.50 1317.50Q1620 1335 1610 1358Q1600 1381 1600 1408L1600 1408L1472 1408Q1472 1355 1492 1308.50Q1512 1262 1547 1227Q1582 1192 1628.50 1172Q1675 1152 1728 1152Z"
         }
      }
   ]
}

var MailTentativeMirrored = {
   name: "MailTentativeMirrored",
   vendor: "UiFabric",
   unicode: 62487,
   value: "",
   charCode: "F417",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L0 384L0 1024L128 1024L128 648L1024 1095L1920 648L1920 1536L512 1536L512 1664L2048 1664L2048 384ZM1905 512L1024 953L143 512L1905 512ZM384 2048L384 1920L256 1920L256 2048L384 2048ZM320 1152L320 1152Q267 1152 220.50 1172Q174 1192 139 1227Q104 1262 84 1308.50Q64 1355 64 1408L64 1408Q64 1454 78 1489Q92 1524 113.50 1552Q135 1580 160 1602.50Q185 1625 206.50 1647Q228 1669 242 1692Q256 1715 256 1744L256 1744L256 1792L384 1792L384 1744Q384 1697 370 1662.50Q356 1628 334.50 1600Q313 1572 288 1549.50Q263 1527 241.50 1505Q220 1483 206 1460Q192 1437 192 1408L192 1408Q192 1381 202 1358Q212 1335 229.50 1317.50Q247 1300 270 1290Q293 1280 320 1280L320 1280Q347 1280 370 1290Q393 1300 410.50 1317.50Q428 1335 438 1358Q448 1381 448 1408L448 1408L576 1408Q576 1355 556 1308.50Q536 1262 501 1227Q466 1192 419.50 1172Q373 1152 320 1152Z"
         }
      }
   ]
}

var MailReminder = {
   name: "MailReminder",
   vendor: "UiFabric",
   unicode: 62488,
   value: "",
   charCode: "F418",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1024L1920 1024L1920 648L1024 1095L128 648L128 1536L1024 1536L1024 1664L0 1664L0 384ZM143 512L1024 953L1905 512L143 512ZM1600 1152L1600 1152Q1666 1152 1724 1177.50Q1782 1203 1825.50 1246.50Q1869 1290 1894.50 1348Q1920 1406 1920 1472L1920 1472L1920 1664L2048 1664L2048 1792L1792 1792L1792 1856Q1792 1896 1777 1931Q1762 1966 1736 1992Q1710 2018 1675 2033Q1640 2048 1600 2048L1600 2048Q1560 2048 1525 2033Q1490 2018 1464 1992Q1438 1966 1423 1931Q1408 1896 1408 1856L1408 1856L1408 1792L1152 1792L1152 1664L1280 1664L1280 1472Q1280 1406 1305 1348Q1330 1290 1373.50 1246.50Q1417 1203 1475.50 1177.50Q1534 1152 1600 1152ZM1664 1856L1664 1792L1536 1792L1536 1856Q1536 1882 1555 1901Q1574 1920 1600 1920L1600 1920Q1626 1920 1645 1901Q1664 1882 1664 1856L1664 1856ZM1408 1664L1792 1664L1792 1472Q1792 1432 1777 1397Q1762 1362 1736 1336Q1710 1310 1675 1295Q1640 1280 1600 1280L1600 1280Q1560 1280 1525 1295Q1490 1310 1464 1336Q1438 1362 1423 1397Q1408 1432 1408 1472L1408 1472L1408 1664Z"
         }
      }
   ]
}

var ReceiptUndelivered = {
   name: "ReceiptUndelivered",
   vendor: "UiFabric",
   unicode: 62489,
   value: "",
   charCode: "F419",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 256L704 256Q801 256 891 281Q981 306 1059.50 352Q1138 398 1202 462Q1266 526 1312 604.50Q1358 683 1383 773Q1408 863 1408 960L1408 960Q1408 1057 1383 1147Q1358 1237 1312 1315.50Q1266 1394 1202 1458Q1138 1522 1059.50 1568Q981 1614 891 1639Q801 1664 704 1664L704 1664Q607 1664 517 1639Q427 1614 348.50 1568Q270 1522 206 1458Q142 1394 96 1315.50Q50 1237 25 1147Q0 1057 0 960L0 960Q0 863 25 773Q50 683 96 604.50Q142 526 206 462Q270 398 348.50 352Q427 306 517 281Q607 256 704 256ZM704 1536L704 1536Q823 1536 928 1490.50Q1033 1445 1111 1367Q1189 1289 1234.50 1184Q1280 1079 1280 960L1280 960Q1280 841 1234.50 736Q1189 631 1111 553Q1033 475 928 429.50Q823 384 704 384L704 384Q585 384 480 429.50Q375 475 297 553Q219 631 173.50 736Q128 841 128 960L128 960Q128 1079 173.50 1184Q219 1289 297 1367Q375 1445 480 1490.50Q585 1536 704 1536ZM1664 1024L1664 896L2048 896L2048 1024L1664 1024ZM1536 512L2048 512L2048 640L1536 640L1536 512ZM1664 1408L1664 1280L2048 1280L2048 1408L1664 1408ZM931 643L1021 734L795 960L1021 1187L931 1277L704 1051L477 1278L387 1187L614 960L387 733L477 643L704 870L931 643Z"
         }
      }
   ]
}

var ReceiptTentative = {
   name: "ReceiptTentative",
   vendor: "UiFabric",
   unicode: 62490,
   value: "",
   charCode: "F41A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 256L704 256Q801 256 891 281Q981 306 1059.50 352Q1138 398 1202 462Q1266 526 1312 604.50Q1358 683 1383 773Q1408 863 1408 960L1408 960Q1408 1057 1383 1147Q1358 1237 1312 1315.50Q1266 1394 1202 1458Q1138 1522 1059.50 1568Q981 1614 891 1639Q801 1664 704 1664L704 1664Q607 1664 517 1639Q427 1614 348.50 1568Q270 1522 206 1458Q142 1394 96 1315.50Q50 1237 25 1147Q0 1057 0 960L0 960Q0 863 25 773Q50 683 96 604.50Q142 526 206 462Q270 398 348.50 352Q427 306 517 281Q607 256 704 256ZM704 1536L704 1536Q823 1536 928 1490.50Q1033 1445 1111 1367Q1189 1289 1234.50 1184Q1280 1079 1280 960L1280 960Q1280 841 1234.50 736Q1189 631 1111 553Q1033 475 928 429.50Q823 384 704 384L704 384Q585 384 480 429.50Q375 475 297 553Q219 631 173.50 736Q128 841 128 960L128 960Q128 1079 173.50 1184Q219 1289 297 1367Q375 1445 480 1490.50Q585 1536 704 1536ZM1664 1024L1664 896L2048 896L2048 1024L1664 1024ZM1536 512L2048 512L2048 640L1536 640L1536 512ZM1664 1408L1664 1280L2048 1280L2048 1408L1664 1408ZM640 1408L640 1280L768 1280L768 1408L640 1408ZM704 512L704 512Q757 512 803.50 532Q850 552 885 587Q920 622 940 668.50Q960 715 960 768L960 768Q960 814 946 849Q932 884 910.50 912Q889 940 864 962.50Q839 985 817.50 1007Q796 1029 782 1052Q768 1075 768 1104L768 1104L768 1152L640 1152L640 1104Q640 1058 654 1023Q668 988 689.50 960Q711 932 736 909.50Q761 887 782.50 865Q804 843 818 820Q832 797 832 768L832 768Q832 741 822 718Q812 695 794.50 677.50Q777 660 754 650Q731 640 704 640L704 640Q677 640 654 650Q631 660 613.50 677.50Q596 695 586 718Q576 741 576 768L576 768L448 768Q448 715 468 668.50Q488 622 523 587Q558 552 604.50 532Q651 512 704 512Z"
         }
      }
   ]
}

var ReceiptTentativeMirrored = {
   name: "ReceiptTentativeMirrored",
   vendor: "UiFabric",
   unicode: 62491,
   value: "",
   charCode: "F41B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 256L704 256Q801 256 891 281Q981 306 1059.50 352Q1138 398 1202 462Q1266 526 1312 604.50Q1358 683 1383 773Q1408 863 1408 960L1408 960Q1408 1057 1383 1147Q1358 1237 1312 1315.50Q1266 1394 1202 1458Q1138 1522 1059.50 1568Q981 1614 891 1639Q801 1664 704 1664L704 1664Q607 1664 517 1639Q427 1614 348.50 1568Q270 1522 206 1458Q142 1394 96 1315.50Q50 1237 25 1147Q0 1057 0 960L0 960Q0 863 25 773Q50 683 96 604.50Q142 526 206 462Q270 398 348.50 352Q427 306 517 281Q607 256 704 256ZM704 1536L704 1536Q823 1536 928 1490.50Q1033 1445 1111 1367Q1189 1289 1234.50 1184Q1280 1079 1280 960L1280 960Q1280 841 1234.50 736Q1189 631 1111 553Q1033 475 928 429.50Q823 384 704 384L704 384Q585 384 480 429.50Q375 475 297 553Q219 631 173.50 736Q128 841 128 960L128 960Q128 1079 173.50 1184Q219 1289 297 1367Q375 1445 480 1490.50Q585 1536 704 1536ZM1664 1024L1664 896L2048 896L2048 1024L1664 1024ZM1536 512L2048 512L2048 640L1536 640L1536 512ZM1664 1408L1664 1280L2048 1280L2048 1408L1664 1408ZM640 1408L640 1280L768 1280L768 1408L640 1408ZM704 512L704 512Q757 512 803.50 532Q850 552 885 587Q920 622 940 668.50Q960 715 960 768L960 768L832 768Q832 741 822 718Q812 695 794.50 677.50Q777 660 754 650Q731 640 704 640L704 640Q677 640 654 650Q631 660 613.50 677.50Q596 695 586 718Q576 741 576 768L576 768Q576 797 590 820Q604 843 625.50 865Q647 887 672 909.50Q697 932 718.50 960Q740 988 754 1023Q768 1058 768 1104L768 1104L768 1152L640 1152L640 1118Q640 1093 635 1071Q630 1049 610 1029L610 1029Q580 999 551 971.50Q522 944 499 914Q476 884 462 849Q448 814 448 768L448 768Q448 715 468 668.50Q488 622 523 587Q558 552 604.50 532Q651 512 704 512Z"
         }
      }
   ]
}

var Inbox = {
   name: "Inbox",
   vendor: "UiFabric",
   unicode: 62492,
   value: "",
   charCode: "F41C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1537 128L1920 1276Q1921 1279 1921.50 1324Q1922 1369 1922 1437L1922 1437Q1922 1504 1921.50 1583Q1921 1662 1921 1732.50Q1921 1803 1920.50 1855Q1920 1907 1920 1920L1920 1920L0 1920Q0 1907-0.50 1855Q-1 1803-1 1732.50Q-1 1662-1.50 1583Q-2 1504-2 1437L-2 1437Q-2 1369-1.50 1324Q-1 1279 0 1276L0 1276L383 128L1537 128ZM1792 1792L1792 1408L1448 1408L1320 1664L600 1664L472 1408L128 1408L128 1792L1792 1792ZM1368 1280L1786 1280L1445 256L475 256L134 1280L552 1280L680 1536L1240 1536L1368 1280Z"
         }
      }
   ]
}

var IRMReply = {
   name: "IRMReply",
   vendor: "UiFabric",
   unicode: 62493,
   value: "",
   charCode: "F41D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1792L960 1792Q1074 1792 1187 1760L1187 1760L1288 1861Q1209 1890 1127 1905Q1045 1920 960 1920L960 1920Q828 1920 705 1885.50Q582 1851 475.50 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444.50Q69 1338 34.50 1215.50Q0 1093 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 704.50 34.50Q827 0 960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1056 1901 1149.50Q1882 1243 1845 1331L1845 1331L1746 1231Q1792 1098 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM384 1024L384 896L1536 896L1536 1024L384 1024ZM1499 1536L1792 1536Q1845 1536 1891.50 1556Q1938 1576 1973 1611Q2008 1646 2028 1692.50Q2048 1739 2048 1792L2048 1792Q2048 1845 2028 1891.50Q2008 1938 1973 1973Q1938 2008 1891.50 2028Q1845 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373L1499 1536Z"
         }
      }
   ]
}

var IRMReplyMirrored = {
   name: "IRMReplyMirrored",
   vendor: "UiFabric",
   unicode: 62494,
   value: "",
   charCode: "F41E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1215Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q844 1920 730 1891L730 1891L839 1782Q869 1787 899.50 1789.50Q930 1792 960 1792L960 1792Q1075 1792 1181 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1054 149.50 1145.50Q171 1237 212 1322L212 1322L116 1418Q59 1312 29.50 1196Q0 1080 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 704.50 34.50Q827 0 960 0ZM1536 896L1536 1024L384 1024L384 896L1536 896ZM477 1283L794 1600L477 1917L387 1827L549 1664L256 1664Q229 1664 206 1674Q183 1684 165.50 1701.50Q148 1719 138 1742Q128 1765 128 1792L128 1792Q128 1819 138 1842Q148 1865 165.50 1882.50Q183 1900 206 1910Q229 1920 256 1920L256 1920L256 2048Q203 2048 156.50 2028Q110 2008 75 1973Q40 1938 20 1891.50Q0 1845 0 1792L0 1792Q0 1739 20 1692.50Q40 1646 75 1611Q110 1576 156.50 1556Q203 1536 256 1536L256 1536L549 1536L387 1373L477 1283Z"
         }
      }
   ]
}

var IRMForward = {
   name: "IRMForward",
   vendor: "UiFabric",
   unicode: 62495,
   value: "",
   charCode: "F41F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792L960 1792L1280 1792L1280 1863Q1202 1890 1122 1905Q1042 1920 960 1920L960 1920Q827 1920 705 1885.50Q583 1851 476.50 1788.50Q370 1726 283 1638.50Q196 1551 133.50 1444Q71 1337 37 1214.50Q3 1092 3 960L3 960Q3 828 37 705.50Q71 583 133.50 476Q196 369 283 281.50Q370 194 476.50 131.50Q583 69 705 34.50Q827 0 960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1090 1885 1216L1885 1216L1778 1109Q1792 1033 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960ZM384 1024L384 896L1536 896L1536 1024L384 1024ZM1725 1283L2042 1600L1725 1917L1635 1827L1798 1664L1280 1664L1280 1536L1798 1536L1635 1373L1725 1283Z"
         }
      }
   ]
}

var IRMForwardMirrored = {
   name: "IRMForwardMirrored",
   vendor: "UiFabric",
   unicode: 62496,
   value: "",
   charCode: "F420",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1092 1885.50 1215Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q865 1920 768 1900L768 1900L768 1792L960 1792Q1075 1792 1181 1762Q1287 1732 1379.50 1678Q1472 1624 1548 1548Q1624 1472 1678 1379.50Q1732 1287 1762 1181Q1792 1075 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960L128 960Q128 1024 137.50 1087.50Q147 1151 167 1212L167 1212L67 1312Q34 1227 18.50 1139Q3 1051 3 960L3 960Q3 828 37 705.50Q71 583 133.50 476Q196 369 283 281.50Q370 194 476.50 131.50Q583 69 705 34.50Q827 0 960 0ZM1536 896L1536 1024L384 1024L384 896L1536 896ZM768 1664L250 1664L413 1827L323 1917L6 1600L323 1283L413 1373L250 1536L768 1536L768 1664Z"
         }
      }
   ]
}

var VoicemailIRM = {
   name: "VoicemailIRM",
   vendor: "UiFabric",
   unicode: 62497,
   value: "",
   charCode: "F421",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M668 1152L1192 1152Q1130 1209 1085 1280L1085 1280L384 1280Q304 1280 234.50 1250Q165 1220 112.50 1167.50Q60 1115 30 1045.50Q0 976 0 896L0 896Q0 817 30 747Q60 677 112.50 624.50Q165 572 234.50 542Q304 512 384 512L384 512Q463 512 533 542Q603 572 655.50 624.50Q708 677 738 747Q768 817 768 896L768 896Q768 968 742 1033.50Q716 1099 668 1152L668 1152ZM384 1152L384 1152Q437 1152 483.50 1132Q530 1112 565 1077Q600 1042 620 995.50Q640 949 640 896L640 896Q640 843 620 796.50Q600 750 565 715Q530 680 483.50 660Q437 640 384 640L384 640Q331 640 284.50 660Q238 680 203 715Q168 750 148 796.50Q128 843 128 896L128 896Q128 949 148 995.50Q168 1042 203 1077Q238 1112 284.50 1132Q331 1152 384 1152ZM1439 1016L1439 1016Q1408 1025 1378.50 1036.50Q1349 1048 1321 1063L1321 1063Q1301 1024 1290.50 982Q1280 940 1280 896L1280 896Q1280 817 1310 747Q1340 677 1392.50 624.50Q1445 572 1514.50 542Q1584 512 1664 512L1664 512Q1743 512 1813 542Q1883 572 1935.50 624.50Q1988 677 2018 747Q2048 817 2048 896L2048 896Q2048 958 2028 1015.50Q2008 1073 1972 1123L1972 1123Q1922 1083 1862 1054L1862 1054Q1889 1020 1904.50 980Q1920 940 1920 896L1920 896Q1920 843 1900 796.50Q1880 750 1845 715Q1810 680 1763.50 660Q1717 640 1664 640L1664 640Q1611 640 1564.50 660Q1518 680 1483 715Q1448 750 1428 796.50Q1408 843 1408 896L1408 896Q1408 959 1439 1016ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1600 1920L1600 1920Q1666 1920 1724 1895Q1782 1870 1825.50 1826.50Q1869 1783 1894.50 1724.50Q1920 1666 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1534 1280 1475.50 1305.50Q1417 1331 1373.50 1374.50Q1330 1418 1305 1476Q1280 1534 1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920ZM1408 1664L1408 1536L1792 1536L1792 1664L1408 1664Z"
         }
      }
   ]
}

var EventAccepted = {
   name: "EventAccepted",
   vendor: "UiFabric",
   unicode: 62498,
   value: "",
   charCode: "F422",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1152L1920 1152L1920 640L128 640L128 1792L1024 1792L1024 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512ZM1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829Z"
         }
      }
   ]
}

var EventTentative = {
   name: "EventTentative",
   vendor: "UiFabric",
   unicode: 62499,
   value: "",
   charCode: "F423",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1024L1920 1024L1920 640L128 640L128 1792L1536 1792L1536 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512ZM1664 2048L1664 1920L1792 1920L1792 2048L1664 2048ZM1728 1152L1728 1152Q1781 1152 1827.50 1172Q1874 1192 1909 1227Q1944 1262 1964 1308.50Q1984 1355 1984 1408L1984 1408Q1984 1454 1970 1489Q1956 1524 1934.50 1552Q1913 1580 1888 1602.50Q1863 1625 1841.50 1647Q1820 1669 1806 1692Q1792 1715 1792 1744L1792 1744L1792 1792L1664 1792L1664 1744Q1664 1697 1678 1662.50Q1692 1628 1713.50 1600Q1735 1572 1760 1549.50Q1785 1527 1806.50 1505Q1828 1483 1842 1460Q1856 1437 1856 1408L1856 1408Q1856 1381 1846 1358Q1836 1335 1818.50 1317.50Q1801 1300 1778 1290Q1755 1280 1728 1280L1728 1280Q1701 1280 1678 1290Q1655 1300 1637.50 1317.50Q1620 1335 1610 1358Q1600 1381 1600 1408L1600 1408L1472 1408Q1472 1355 1492 1308.50Q1512 1262 1547 1227Q1582 1192 1628.50 1172Q1675 1152 1728 1152Z"
         }
      }
   ]
}

var EventTentativeMirrored = {
   name: "EventTentativeMirrored",
   vendor: "UiFabric",
   unicode: 62500,
   value: "",
   charCode: "F424",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 128L0 128L0 1024L128 1024L128 640L1920 640L1920 1792L512 1792L512 1920L2048 1920L2048 128L1664 128L1664 0L1536 0L1536 128L512 128L512 0L384 0L384 128ZM1920 512L128 512L128 256L384 256L384 384L512 384L512 256L1536 256L1536 384L1664 384L1664 256L1920 256L1920 512ZM384 2048L384 1920L256 1920L256 2048L384 2048ZM320 1152L320 1152Q267 1152 220.50 1172Q174 1192 139 1227Q104 1262 84 1308.50Q64 1355 64 1408L64 1408Q64 1454 78 1489Q92 1524 113.50 1552Q135 1580 160 1602.50Q185 1625 206.50 1647Q228 1669 242 1692Q256 1715 256 1744L256 1744L256 1792L384 1792L384 1744Q384 1697 370 1662.50Q356 1628 334.50 1600Q313 1572 288 1549.50Q263 1527 241.50 1505Q220 1483 206 1460Q192 1437 192 1408L192 1408Q192 1381 202 1358Q212 1335 229.50 1317.50Q247 1300 270 1290Q293 1280 320 1280L320 1280Q347 1280 370 1290Q393 1300 410.50 1317.50Q428 1335 438 1358Q448 1381 448 1408L448 1408L576 1408Q576 1355 556 1308.50Q536 1262 501 1227Q466 1192 419.50 1172Q373 1152 320 1152Z"
         }
      }
   ]
}

var EventDeclined = {
   name: "EventDeclined",
   vendor: "UiFabric",
   unicode: 62501,
   value: "",
   charCode: "F425",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1280L1920 1280L1920 640L128 640L128 1792L1280 1792L1280 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512ZM1955 1411L2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var IDBadge = {
   name: "IDBadge",
   vendor: "UiFabric",
   unicode: 62503,
   value: "",
   charCode: "F427",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1256 384L1568 384Q1608 384 1636 412Q1664 440 1664 480L1664 480L1664 1952Q1664 1992 1636 2020Q1608 2048 1568 2048L1568 2048L480 2048Q440 2048 412 2020Q384 1992 384 1952L384 1952L384 480Q384 440 412 412Q440 384 480 384L480 384L792 384L600 0L744 0L936 384L1112 384L1304 0L1448 0L1256 384ZM1536 1920L1536 512L1000 512L1081 675Q1088 691 1088 704L1088 704Q1088 730 1069 749Q1050 768 1024 768L1024 768Q1006 768 990.50 758.50Q975 749 967 733L967 733L856 512L512 512L512 1920L1536 1920ZM768 1152L768 1152Q768 1099 788 1052.50Q808 1006 843 971Q878 936 924.50 916Q971 896 1024 896L1024 896Q1077 896 1123.50 916Q1170 936 1205 971Q1240 1006 1260 1052.50Q1280 1099 1280 1152L1280 1152Q1280 1201 1261.50 1247Q1243 1293 1210 1328L1210 1328Q1256 1353 1292.50 1389Q1329 1425 1354.50 1469Q1380 1513 1394 1562.50Q1408 1612 1408 1664L1408 1664L1280 1664Q1280 1611 1260 1564.50Q1240 1518 1205 1483Q1170 1448 1123.50 1428Q1077 1408 1024 1408L1024 1408Q971 1408 924.50 1428Q878 1448 843 1483Q808 1518 788 1564.50Q768 1611 768 1664L768 1664L640 1664Q640 1612 654 1562.50Q668 1513 693.50 1469Q719 1425 755.50 1389Q792 1353 838 1328L838 1328Q805 1293 786.50 1247Q768 1201 768 1152ZM1152 1152L1152 1152Q1152 1125 1142 1102Q1132 1079 1114.50 1061.50Q1097 1044 1074 1034Q1051 1024 1024 1024L1024 1024Q997 1024 974 1034Q951 1044 933.50 1061.50Q916 1079 906 1102Q896 1125 896 1152L896 1152Q896 1179 906 1202Q916 1225 933.50 1242.50Q951 1260 974 1270Q997 1280 1024 1280L1024 1280Q1051 1280 1074 1270Q1097 1260 1114.50 1242.50Q1132 1225 1142 1202Q1152 1179 1152 1152Z"
         }
      }
   ]
}

var BackgroundColor = {
   name: "BackgroundColor",
   vendor: "UiFabric",
   unicode: 62507,
   value: "",
   charCode: "F42B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 256L2048 256L2048 2048L256 2048L256 1408L384 1536L384 1920L1920 1920L1920 384L1152 384L1152 256ZM1434 832L704 1562L102 960L640 421L640 192Q640 152 655 117Q670 82 696 56Q722 30 757 15Q792 0 832 0L832 0Q872 0 907 15Q942 30 968 56Q994 82 1009 117Q1024 152 1024 192L1024 192L1024 768L896 768L896 192Q896 166 877 147Q858 128 832 128L832 128Q806 128 787 147Q768 166 768 192L768 192L768 475L347 896L1189 896L1254 832L1171 749L1261 659L1434 832ZM704 1382L1061 1024L347 1024L704 1382ZM1478 1810L1478 1810Q1411 1810 1348.50 1787Q1286 1764 1238 1722.50Q1190 1681 1161 1623Q1132 1565 1132 1494L1132 1494Q1132 1451 1144 1410Q1156 1369 1179 1333L1179 1333L1472 872L1758 1322Q1781 1360 1794 1401.50Q1807 1443 1807 1488L1807 1488Q1807 1555 1780.50 1614Q1754 1673 1709 1716.50Q1664 1760 1604 1785Q1544 1810 1478 1810ZM1472 1176L1317 1421Q1295 1454 1295 1492L1295 1492Q1295 1528 1310.50 1556.50Q1326 1585 1351.50 1605Q1377 1625 1408.50 1635.50Q1440 1646 1473 1646L1473 1646Q1506 1646 1537 1634.50Q1568 1623 1591.50 1602Q1615 1581 1629.50 1552Q1644 1523 1644 1488L1644 1488Q1644 1447 1620 1409L1620 1409L1472 1176Z"
         }
      }
   ]
}

var OfficeFormsLogoInverse16 = {
   name: "OfficeFormsLogoInverse16",
   vendor: "UiFabric",
   unicode: 62515,
   value: "",
   charCode: "F433",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0ZM1920 128L512 128L512 384L1152 384Q1166 384 1180 387.50Q1194 391 1207 396L1207 396Q1252 330 1322 293Q1392 256 1472 256L1472 256Q1538 256 1596.50 281Q1655 306 1698.50 349.50Q1742 393 1767 451.50Q1792 510 1792 576L1792 576Q1792 642 1767 700.50Q1742 759 1698.50 802.50Q1655 846 1596.50 871Q1538 896 1472 896L1472 896Q1420 896 1371 879.50Q1322 863 1280 832L1280 832L1280 1024L1920 1024L1920 128ZM1472 384L1472 384Q1432 384 1397 399Q1362 414 1336 440Q1310 466 1295 501Q1280 536 1280 576L1280 576Q1280 616 1295 651Q1310 686 1336 712Q1362 738 1397 753Q1432 768 1472 768L1472 768Q1512 768 1547 753Q1582 738 1608 712Q1634 686 1649 651Q1664 616 1664 576L1664 576Q1664 536 1649 501Q1634 466 1608 440Q1582 414 1547 399Q1512 384 1472 384ZM392 608L392 1440L607 1440L607 1130L917 1130L917 942L607 942L607 797L939 797L939 608L392 608ZM512 1664L512 1920L1920 1920L1920 1152L1280 1152L1280 1280L1792 1280L1792 1792L1280 1792L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664ZM1408 1408L1408 1664L1664 1664L1664 1408L1408 1408Z"
         }
      }
   ]
}

var OfficeFormsLogo = {
   name: "OfficeFormsLogo",
   vendor: "UiFabric",
   unicode: 62516,
   value: "",
   charCode: "F434",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 1664L1344 1216L1792 1216L1792 1664L1344 1664ZM1472 1344L1472 1536L1664 1536L1664 1344L1472 1344ZM1568 896L1568 896Q1508 896 1455.50 873.50Q1403 851 1364 812Q1325 773 1302.50 720.50Q1280 668 1280 608L1280 608Q1280 548 1302.50 495.50Q1325 443 1364 404Q1403 365 1455.50 342.50Q1508 320 1568 320L1568 320Q1628 320 1680.50 342.50Q1733 365 1772 404Q1811 443 1833.50 495.50Q1856 548 1856 608L1856 608Q1856 668 1833.50 720.50Q1811 773 1772 812Q1733 851 1680.50 873.50Q1628 896 1568 896ZM1568 448L1568 448Q1535 448 1506 460.50Q1477 473 1455 495Q1433 517 1420.50 546Q1408 575 1408 608L1408 608Q1408 641 1420.50 670Q1433 699 1455 721Q1477 743 1506 755.50Q1535 768 1568 768L1568 768Q1601 768 1630 755.50Q1659 743 1681 721Q1703 699 1715.50 670Q1728 641 1728 608L1728 608Q1728 575 1715.50 546Q1703 517 1681 495Q1659 473 1630 460.50Q1601 448 1568 448ZM597 128L1963 128Q1998 128 2023 153Q2048 178 2048 213L2048 213L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L597 1920Q562 1920 537 1895Q512 1870 512 1835L512 1835L512 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L512 512L512 213Q512 178 537 153Q562 128 597 128L597 128ZM640 256L640 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 960L1920 960L1920 256L640 256ZM461 1102L720 1102L720 966L461 966L461 824L739 824L739 688L304 688L304 1360L461 1360L461 1102ZM640 1792L1920 1792L1920 1088L1024 1088L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L640 1536L640 1792Z"
         }
      }
   ]
}

var OfficeFormsLogoFill = {
   name: "OfficeFormsLogoFill",
   vendor: "UiFabric",
   unicode: 62517,
   value: "",
   charCode: "F435",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var OfficeFormsLogo16 = {
   name: "OfficeFormsLogo16",
   vendor: "UiFabric",
   unicode: 62518,
   value: "",
   charCode: "F436",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1920 0Q1946 0 1969.50 10Q1993 20 2010.50 37.50Q2028 55 2038 78.50Q2048 102 2048 128L2048 128L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L512 2048Q486 2048 462.50 2038Q439 2028 421.50 2010.50Q404 1993 394 1969.50Q384 1946 384 1920L384 1920L384 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L384 384L384 128Q384 101 394 78Q404 55 421.50 37.50Q439 20 462 10Q485 0 512 0L512 0ZM1920 128L512 128L512 384L1152 384Q1166 384 1180 387.50Q1194 391 1207 396L1207 396Q1252 330 1322 293Q1392 256 1472 256L1472 256Q1538 256 1596.50 281Q1655 306 1698.50 349.50Q1742 393 1767 451.50Q1792 510 1792 576L1792 576Q1792 642 1767 700.50Q1742 759 1698.50 802.50Q1655 846 1596.50 871Q1538 896 1472 896L1472 896Q1420 896 1371 879.50Q1322 863 1280 832L1280 832L1280 1024L1920 1024L1920 128ZM1472 384L1472 384Q1432 384 1397 399Q1362 414 1336 440Q1310 466 1295 501Q1280 536 1280 576L1280 576Q1280 616 1295 651Q1310 686 1336 712Q1362 738 1397 753Q1432 768 1472 768L1472 768Q1512 768 1547 753Q1582 738 1608 712Q1634 686 1649 651Q1664 616 1664 576L1664 576Q1664 536 1649 501Q1634 466 1608 440Q1582 414 1547 399Q1512 384 1472 384ZM392 608L392 1440L607 1440L607 1130L917 1130L917 942L607 942L607 797L939 797L939 608L392 608ZM512 1664L512 1920L1920 1920L1920 1152L1280 1152L1280 1280L1792 1280L1792 1792L1280 1792L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L512 1664ZM1408 1408L1408 1664L1664 1664L1664 1408L1408 1408Z"
         }
      }
   ]
}

var OfficeFormsLogoFill16 = {
   name: "OfficeFormsLogoFill16",
   vendor: "UiFabric",
   unicode: 62519,
   value: "",
   charCode: "F437",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var OfficeFormsLogoInverse24 = {
   name: "OfficeFormsLogoInverse24",
   vendor: "UiFabric",
   unicode: 62522,
   value: "",
   charCode: "F43A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1877 1707L1365 1707L1365 1195L1877 1195L1877 1707ZM1792 1280L1451 1280L1451 1621L1792 1621L1792 1280ZM1579 853L1579 853Q1517 853 1462.50 829.50Q1408 806 1367.50 765.50Q1327 725 1303.50 671Q1280 617 1280 555L1280 555Q1280 493 1303.50 438.50Q1327 384 1367.50 343.50Q1408 303 1462.50 279.50Q1517 256 1579 256L1579 256Q1641 256 1695 279.50Q1749 303 1789.50 343.50Q1830 384 1853.50 438.50Q1877 493 1877 555L1877 555Q1877 617 1853.50 671Q1830 725 1789.50 765.50Q1749 806 1695 829.50Q1641 853 1579 853ZM1579 341L1579 341Q1535 341 1496 358Q1457 375 1428 404Q1399 433 1382 472Q1365 511 1365 555L1365 555Q1365 599 1382 637.50Q1399 676 1428 705Q1457 734 1496 751Q1535 768 1579 768L1579 768Q1623 768 1661.50 751Q1700 734 1729 705Q1758 676 1775 637.50Q1792 599 1792 555L1792 555Q1792 511 1775 472Q1758 433 1729 404Q1700 375 1661.50 358Q1623 341 1579 341ZM597 85L1963 85Q1981 85 1996.50 92Q2012 99 2023.50 110.50Q2035 122 2041.50 137.50Q2048 153 2048 171L2048 171L2048 1877Q2048 1895 2041.50 1910.50Q2035 1926 2023.50 1937.50Q2012 1949 1996.50 1956Q1981 1963 1963 1963L1963 1963L597 1963Q579 1963 563.50 1956Q548 1949 536.50 1937.50Q525 1926 518.50 1910.50Q512 1895 512 1877L512 1877L512 1621L100 1621Q58 1621 29 1592.50Q0 1564 0 1522L0 1522L0 526Q0 484 29 455.50Q58 427 100 427L100 427L512 427L512 171Q512 153 518.50 137.50Q525 122 536.50 110.50Q548 99 563.50 92Q579 85 597 85L597 85ZM1963 171L597 171L597 427L1095 427Q1137 427 1166 455.50Q1195 484 1195 526L1195 526L1195 939L1963 939L1963 171ZM496 1387L496 1111L772 1111L772 958L496 958L496 815L792 815L792 661L320 661L320 1387L496 1387ZM597 1621L597 1877L1963 1877L1963 1024L1195 1024L1195 1522Q1195 1564 1166 1592.50Q1137 1621 1095 1621L1095 1621L597 1621Z"
         }
      }
   ]
}

var OfficeFormsLogo24 = {
   name: "OfficeFormsLogo24",
   vendor: "UiFabric",
   unicode: 62523,
   value: "",
   charCode: "F43B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1877 1707L1365 1707L1365 1195L1877 1195L1877 1707ZM1792 1280L1451 1280L1451 1621L1792 1621L1792 1280ZM1579 853L1579 853Q1517 853 1462.50 829.50Q1408 806 1367.50 765.50Q1327 725 1303.50 671Q1280 617 1280 555L1280 555Q1280 493 1303.50 438.50Q1327 384 1367.50 343.50Q1408 303 1462.50 279.50Q1517 256 1579 256L1579 256Q1641 256 1695 279.50Q1749 303 1789.50 343.50Q1830 384 1853.50 438.50Q1877 493 1877 555L1877 555Q1877 617 1853.50 671Q1830 725 1789.50 765.50Q1749 806 1695 829.50Q1641 853 1579 853ZM1579 341L1579 341Q1535 341 1496 358Q1457 375 1428 404Q1399 433 1382 472Q1365 511 1365 555L1365 555Q1365 599 1382 637.50Q1399 676 1428 705Q1457 734 1496 751Q1535 768 1579 768L1579 768Q1623 768 1661.50 751Q1700 734 1729 705Q1758 676 1775 637.50Q1792 599 1792 555L1792 555Q1792 511 1775 472Q1758 433 1729 404Q1700 375 1661.50 358Q1623 341 1579 341ZM597 85L1963 85Q1981 85 1996.50 92Q2012 99 2023.50 110.50Q2035 122 2041.50 137.50Q2048 153 2048 171L2048 171L2048 1877Q2048 1895 2041.50 1910.50Q2035 1926 2023.50 1937.50Q2012 1949 1996.50 1956Q1981 1963 1963 1963L1963 1963L597 1963Q579 1963 563.50 1956Q548 1949 536.50 1937.50Q525 1926 518.50 1910.50Q512 1895 512 1877L512 1877L512 1621L100 1621Q58 1621 29 1592.50Q0 1564 0 1522L0 1522L0 526Q0 484 29 455.50Q58 427 100 427L100 427L512 427L512 171Q512 153 518.50 137.50Q525 122 536.50 110.50Q548 99 563.50 92Q579 85 597 85L597 85ZM1963 171L597 171L597 427L1095 427Q1137 427 1166 455.50Q1195 484 1195 526L1195 526L1195 939L1963 939L1963 171ZM496 1387L496 1111L772 1111L772 958L496 958L496 815L792 815L792 661L320 661L320 1387L496 1387ZM597 1621L597 1877L1963 1877L1963 1024L1195 1024L1195 1522Q1195 1564 1166 1592.50Q1137 1621 1095 1621L1095 1621L597 1621Z"
         }
      }
   ]
}

var OfficeFormsLogoFill24 = {
   name: "OfficeFormsLogoFill24",
   vendor: "UiFabric",
   unicode: 62524,
   value: "",
   charCode: "F43C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var PageLock = {
   name: "PageLock",
   vendor: "UiFabric",
   unicode: 62527,
   value: "",
   charCode: "F43F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 640L1152 640L1152 128L256 128L256 1920L1152 1920L1152 2048L128 2048L128 0L1243 0L1792 549L1792 886Q1761 876 1729 870Q1697 864 1664 864L1664 864L1664 640ZM1280 219L1280 512L1573 512L1280 219ZM1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1408 1408L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408ZM1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920Z"
         }
      }
   ]
}

var NotExecuted = {
   name: "NotExecuted",
   vendor: "UiFabric",
   unicode: 62528,
   value: "",
   charCode: "F440",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 374L640 1674L1028 1403Q1013 1447 1004.50 1492Q996 1537 994 1583L994 1583L512 1920L512 128L1790 1025Q1744 1010 1696.50 1001Q1649 992 1600 992L1600 992Q1583 992 1566.50 994.50Q1550 997 1533 999L1533 999L640 374ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var NotImpactedSolid = {
   name: "NotImpactedSolid",
   vendor: "UiFabric",
   unicode: 62529,
   value: "",
   charCode: "F441",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 992L1600 992Q1498 992 1407.50 1024Q1317 1056 1241 1112L1241 1112L1052 988L392 1989Q372 2018 338 2018L338 2018Q320 2018 303 2007L303 2007Q275 1988 275 1954L275 1954Q275 1935 285 1919L285 1919L946 917L619 702L599 733Q580 761 551.50 775.50Q523 790 491 790L491 790Q453 790 422 769L422 769Q394 750 379 721.50Q364 693 364 661L364 661Q364 624 385 592L385 592L738 57Q757 29 785 14.50Q813 0 845 0L845 0Q882 0 915 21L915 21Q943 40 958 68.50Q973 97 973 129L973 129Q973 167 952 198L952 198L931 229L1679 722L1699 692Q1718 664 1746.50 649Q1775 634 1807 634L1807 634Q1844 634 1877 655L1877 655Q1905 674 1919.50 702.50Q1934 731 1934 763L1934 763Q1934 800 1913 833L1913 833L1787 1024Q1742 1010 1695.50 1001Q1649 992 1600 992ZM1917 1283L1917 1283Q1980 1347 2014 1428Q2048 1509 2048 1600L2048 1600Q2048 1691 2014 1772Q1980 1853 1917 1916L1917 1916Q1853 1980 1772 2014Q1691 2048 1600 2048L1600 2048Q1509 2048 1428 2014Q1347 1980 1284 1917L1284 1917Q1220 1853 1186 1772Q1152 1691 1152 1600L1152 1600Q1152 1509 1186 1428Q1220 1347 1283 1284L1283 1284Q1347 1220 1428 1186Q1509 1152 1600 1152L1600 1152Q1691 1152 1772 1186Q1853 1220 1917 1283ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1649 1920 1693.50 1906Q1738 1892 1776 1867L1776 1867L1333 1424Q1308 1462 1294 1506.50Q1280 1551 1280 1600ZM1424 1333L1867 1776Q1892 1738 1906 1693.50Q1920 1649 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1551 1280 1506.50 1294Q1462 1308 1424 1333L1424 1333Z"
         }
      }
   ]
}

var FieldReadOnly = {
   name: "FieldReadOnly",
   vendor: "UiFabric",
   unicode: 62530,
   value: "",
   charCode: "F442",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1121Q2028 1071 1995 1029Q1962 987 1920 955L1920 955L1920 384L128 384L128 1536L1152 1536L1152 1664L0 1664L0 256ZM1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1408 1408L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024ZM1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920Z"
         }
      }
   ]
}

var FieldRequired = {
   name: "FieldRequired",
   vendor: "UiFabric",
   unicode: 62531,
   value: "",
   charCode: "F443",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1015Q2020 980 1988 948Q1956 916 1920 889L1920 889L1920 384L128 384L128 1536L740 1536Q743 1568 748.50 1600Q754 1632 762 1664L762 1664L0 1664L0 256ZM1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1408 1536L1408 1152L1536 1152L1536 1536L1408 1536ZM1408 1792L1408 1664L1536 1664L1536 1792L1408 1792Z"
         }
      }
   ]
}

var BacklogBoard = {
   name: "BacklogBoard",
   vendor: "UiFabric",
   unicode: 62532,
   value: "",
   charCode: "F444",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 768L256 384L768 384L768 768L256 768ZM384 512L384 640L640 640L640 512L384 512ZM256 1280L256 896L768 896L768 1280L256 1280ZM384 1024L384 1152L640 1152L640 1024L384 1024ZM896 768L896 384L1408 384L1408 768L896 768ZM1024 512L1024 640L1280 640L1280 512L1024 512ZM1536 768L1536 384L2048 384L2048 768L1536 768ZM1664 512L1664 640L1920 640L1920 512L1664 512ZM896 1280L896 896L1408 896L1408 1280L896 1280ZM1024 1024L1024 1152L1280 1152L1280 1024L1024 1024ZM1536 1280L1536 896L2048 896L2048 1280L1536 1280ZM1664 1024L1664 1152L1920 1152L1920 1024L1664 1024ZM256 1792L256 1408L768 1408L768 1792L256 1792ZM384 1536L384 1664L640 1664L640 1536L384 1536ZM1536 1792L1536 1408L2048 1408L2048 1792L1536 1792ZM1664 1536L1664 1664L1920 1664L1920 1536L1664 1536ZM0 128L2048 128L2048 256L128 256L128 1920L0 1920L0 128Z"
         }
      }
   ]
}

var ExternalBuild = {
   name: "ExternalBuild",
   vendor: "UiFabric",
   unicode: 62533,
   value: "",
   charCode: "F445",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 256L256 256L256 1792L512 1792L512 1920L128 1920L128 128L1920 128L1920 896L1792 896L1792 256ZM1905 1418L1905 1418L2048 1575L2048 1792L1920 1792L1920 1625L1819 1513Q1783 1533 1742 1535L1742 1535L1664 1624L1664 1792L1536 1792L1536 1576L1608 1494Q1603 1491 1599.50 1487.50Q1596 1484 1592 1480L1592 1480L1344 1231L1152 1424L1152 1920L1280 1920L1280 2048L640 2048L640 1920L768 1920L768 1344Q768 1306 782.50 1270.50Q797 1235 824 1208L824 1208L1208 824Q1235 797 1270.50 782.50Q1306 768 1344 768L1344 768Q1382 768 1417.50 782.50Q1453 797 1480 824L1480 824L1864 1208Q1891 1235 1905.50 1270.50Q1920 1306 1920 1344L1920 1344Q1920 1384 1905 1418ZM1299 915L1043 1171Q1104 1200 1133 1261L1133 1261L1389 1005Q1408 986 1408 960L1408 960Q1408 934 1389 915Q1370 896 1344 896L1344 896Q1318 896 1299 915L1299 915ZM896 1344L896 1920L1024 1920L1024 1344Q1024 1318 1005 1299Q986 1280 960 1280L960 1280Q934 1280 915 1299Q896 1318 896 1344L896 1344ZM1728 1408L1728 1408Q1754 1408 1773 1389Q1792 1370 1792 1344L1792 1344Q1792 1318 1773 1299L1773 1299L1517 1043Q1503 1074 1480.50 1095.50Q1458 1117 1434 1141L1434 1141L1683 1389Q1702 1408 1728 1408Z"
         }
      }
   ]
}

var ExternalTFVC = {
   name: "ExternalTFVC",
   vendor: "UiFabric",
   unicode: 62534,
   value: "",
   charCode: "F446",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 256L256 1792L640 1792L640 1920L128 1920L128 128L1920 128L1920 640L1792 640L1792 256L256 256ZM1856 1152L1856 1152Q1796 1152 1747 1118Q1698 1084 1676 1028L1676 1028L1529 1077Q1536 1112 1536 1152L1536 1152Q1536 1218 1514.50 1280Q1493 1342 1451 1393L1451 1393L1706 1684Q1748 1664 1792 1664L1792 1664Q1832 1664 1867 1679Q1902 1694 1928 1720Q1954 1746 1969 1781Q1984 1816 1984 1856L1984 1856Q1984 1896 1969 1931Q1954 1966 1928 1992Q1902 2018 1867 2033Q1832 2048 1792 2048L1792 2048Q1752 2048 1717 2033Q1682 2018 1656 1992Q1630 1966 1615 1931Q1600 1896 1600 1856L1600 1856Q1600 1827 1608 1799Q1616 1771 1633 1748L1633 1748L1382 1460Q1332 1497 1273.50 1516.50Q1215 1536 1152 1536L1152 1536Q1144 1536 1135 1535.50Q1126 1535 1118 1535L1118 1535L1064 1695Q1105 1721 1128.50 1764Q1152 1807 1152 1856L1152 1856Q1152 1896 1137 1931Q1122 1966 1096 1992Q1070 2018 1035 2033Q1000 2048 960 2048L960 2048Q920 2048 885 2033Q850 2018 824 1992Q798 1966 783 1931Q768 1896 768 1856L768 1856Q768 1812 784.50 1776.50Q801 1741 828.50 1716Q856 1691 893.50 1677.50Q931 1664 973 1664L973 1664L1023 1514Q966 1494 919 1457.50Q872 1421 838.50 1373.50Q805 1326 786.50 1269.50Q768 1213 768 1152L768 1152Q768 1073 798 1003Q828 933 880.50 880.50Q933 828 1002.50 798Q1072 768 1152 768L1152 768Q1207 768 1259 783.50Q1311 799 1356 827.50Q1401 856 1437.50 896Q1474 936 1498 986L1498 986L1666 930Q1672 895 1689 865.50Q1706 836 1731 814Q1756 792 1788 780Q1820 768 1856 768L1856 768Q1896 768 1931 783Q1966 798 1992 824Q2018 850 2033 885Q2048 920 2048 960L2048 960Q2048 1000 2033 1035Q2018 1070 1992 1096Q1966 1122 1931 1137Q1896 1152 1856 1152ZM1152 1344L1152 1344Q1192 1344 1227 1329Q1262 1314 1288 1288Q1314 1262 1329 1227Q1344 1192 1344 1152L1344 1152Q1344 1112 1329 1077Q1314 1042 1288 1016Q1262 990 1227 975Q1192 960 1152 960L1152 960Q1112 960 1077 975Q1042 990 1016 1016Q990 1042 975 1077Q960 1112 960 1152L960 1152Q960 1192 975 1227Q990 1262 1016 1288Q1042 1314 1077 1329Q1112 1344 1152 1344Z"
         }
      }
   ]
}

var ExternalXAML = {
   name: "ExternalXAML",
   vendor: "UiFabric",
   unicode: 62535,
   value: "",
   charCode: "F447",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1152L1792 256L256 256L256 1920L128 1920L128 128L1920 128L1920 1152L1792 1152ZM1435 1280L1655 1664L1435 2048L997 2048L777 1664L997 1280L1435 1280ZM1797 1280L2016 1664L1797 2048L1649 2048L1869 1664L1649 1280L1797 1280ZM783 1280L563 1664L783 2048L635 2048L416 1664L635 1280L783 1280Z"
         }
      }
   ]
}

var IssueSolid = {
   name: "IssueSolid",
   vendor: "UiFabric",
   unicode: 62536,
   value: "",
   charCode: "F448",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384L640 384ZM1024 1664L1024 1536L896 1536L896 1664L1024 1664ZM1024 1408L1024 768L896 768L896 1408L1024 1408Z"
         }
      }
   ]
}

var DefectSolid = {
   name: "DefectSolid",
   vendor: "UiFabric",
   unicode: 62537,
   value: "",
   charCode: "F449",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M849 384L1192 42Q1299 79 1386 144.50Q1473 210 1535 296.50Q1597 383 1630.50 487Q1664 591 1664 704L1664 704Q1664 848 1608.50 971.50Q1553 1095 1453 1197L1453 1197Q1382 1270 1340 1352Q1298 1434 1287 1536L1287 1536L633 1536Q622 1434 580.50 1352Q539 1270 468 1198L468 1198Q368 1095 312 972Q256 849 256 704L256 704Q256 607 281 516.50Q306 426 352 348Q398 270 462 206Q526 142 604 96Q682 50 772 25Q862 0 960 0L960 0Q971 0 981.50 1.50Q992 3 1003 4L1003 4L623 384L1071 832L808 1095L921 1209L1297 832L849 384ZM640 1856L640 1664L1280 1664L1280 1856Q1280 1896 1265 1931Q1250 1966 1224 1992Q1198 2018 1163 2033Q1128 2048 1088 2048L1088 2048L832 2048Q792 2048 757 2033Q722 2018 696 1992Q670 1966 655 1931Q640 1896 640 1856L640 1856Z"
         }
      }
   ]
}

var LadybugSolid = {
   name: "LadybugSolid",
   vendor: "UiFabric",
   unicode: 62538,
   value: "",
   charCode: "F44A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 576L1024 576Q1126 576 1220 602.50Q1314 629 1395.50 676.50Q1477 724 1544.50 791.50Q1612 859 1659.50 940.50Q1707 1022 1733.50 1116Q1760 1210 1760 1312L1760 1312Q1760 1424 1727.50 1528Q1695 1632 1635.50 1721Q1576 1810 1491.50 1880Q1407 1950 1304 1992L1304 1992L1260 1860Q1205 1889 1145.50 1904.50Q1086 1920 1024 1920L1024 1920Q962 1920 902.50 1904.50Q843 1889 788 1860L788 1860L744 1992Q640 1950 556 1880Q472 1810 412.50 1721Q353 1632 320.50 1528Q288 1424 288 1312L288 1312Q288 1210 314.50 1116Q341 1022 388.50 940.50Q436 859 503.50 791.50Q571 724 652.50 676.50Q734 629 828 602.50Q922 576 1024 576ZM640 1536L640 1536Q667 1536 690 1526Q713 1516 730.50 1498.50Q748 1481 758 1458Q768 1435 768 1408L768 1408Q768 1381 758 1358Q748 1335 730.50 1317.50Q713 1300 690 1290Q667 1280 640 1280L640 1280Q613 1280 590 1290Q567 1300 549.50 1317.50Q532 1335 522 1358Q512 1381 512 1408L512 1408Q512 1435 522 1458Q532 1481 549.50 1498.50Q567 1516 590 1526Q613 1536 640 1536ZM768 1152L768 1152Q795 1152 818 1142Q841 1132 858.50 1114.50Q876 1097 886 1074Q896 1051 896 1024L896 1024Q896 997 886 974Q876 951 858.50 933.50Q841 916 818 906Q795 896 768 896L768 896Q741 896 718 906Q695 916 677.50 933.50Q660 951 650 974Q640 997 640 1024L640 1024Q640 1051 650 1074Q660 1097 677.50 1114.50Q695 1132 718 1142Q741 1152 768 1152ZM1024 1792L1024 1792Q1076 1792 1125 1777.50Q1174 1763 1219 1737L1219 1737L1024 1152L829 1737Q874 1763 923 1777.50Q972 1792 1024 1792ZM1152 1024L1152 1024Q1152 1051 1162 1074Q1172 1097 1189.50 1114.50Q1207 1132 1230 1142Q1253 1152 1280 1152L1280 1152Q1307 1152 1330 1142Q1353 1132 1370.50 1114.50Q1388 1097 1398 1074Q1408 1051 1408 1024L1408 1024Q1408 997 1398 974Q1388 951 1370.50 933.50Q1353 916 1330 906Q1307 896 1280 896L1280 896Q1253 896 1230 906Q1207 916 1189.50 933.50Q1172 951 1162 974Q1152 997 1152 1024ZM1408 1536L1408 1536Q1435 1536 1458 1526Q1481 1516 1498.50 1498.50Q1516 1481 1526 1458Q1536 1435 1536 1408L1536 1408Q1536 1381 1526 1358Q1516 1335 1498.50 1317.50Q1481 1300 1458 1290Q1435 1280 1408 1280L1408 1280Q1381 1280 1358 1290Q1335 1300 1317.50 1317.50Q1300 1335 1290 1358Q1280 1381 1280 1408L1280 1408Q1280 1435 1290 1458Q1300 1481 1317.50 1498.50Q1335 1516 1358 1526Q1381 1536 1408 1536ZM704 448L704 448Q704 376 734 313L734 313L595 173L685 83L811 209Q856 170 910 149Q964 128 1024 128L1024 128Q1084 128 1138 149Q1192 170 1237 209L1237 209L1363 83L1453 173L1314 313Q1344 376 1344 448L1344 448Q1344 461 1342.50 473.50Q1341 486 1339 498L1339 498Q1264 466 1184.50 449Q1105 432 1024 432L1024 432Q943 432 863.50 449Q784 466 709 498L709 498Q707 486 705.50 473.50Q704 461 704 448Z"
         }
      }
   ]
}

var NugetLogo = {
   name: "NugetLogo",
   vendor: "UiFabric",
   unicode: 62540,
   value: "",
   charCode: "F44C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M838 256L1467 256Q1588 256 1693.50 301.50Q1799 347 1878 426Q1957 505 2002.50 611Q2048 717 2048 838L2048 838L2048 1466Q2048 1587 2002.50 1693Q1957 1799 1878 1878Q1799 1957 1693.50 2002.50Q1588 2048 1467 2048L1467 2048L838 2048Q717 2048 611 2002.50Q505 1957 426.50 1878Q348 1799 302.50 1693Q257 1587 257 1466L257 1466L257 838Q257 717 302.50 611Q348 505 426.50 426Q505 347 611 301.50Q717 256 838 256L838 256ZM715 996L715 996Q760 996 799.50 979Q839 962 868.50 932.50Q898 903 915 863.50Q932 824 932 779L932 779Q932 734 915 694.50Q898 655 868.50 625.50Q839 596 799.50 579Q760 562 715 562L715 562Q670 562 630.50 579Q591 596 561.50 625.50Q532 655 515 694.50Q498 734 498 779L498 779Q498 824 515 863.50Q532 903 561.50 932.50Q591 962 630.50 979Q670 996 715 996ZM1408 1842L1408 1842Q1486 1842 1554.50 1812.50Q1623 1783 1674 1732Q1725 1681 1754.50 1612.50Q1784 1544 1784 1466L1784 1466Q1784 1388 1754.50 1319.50Q1725 1251 1674 1200Q1623 1149 1554.50 1119.50Q1486 1090 1408 1090L1408 1090Q1330 1090 1261.50 1119.50Q1193 1149 1142 1200Q1091 1251 1061.50 1319.50Q1032 1388 1032 1466L1032 1466Q1032 1544 1061.50 1612.50Q1091 1681 1142 1732Q1193 1783 1261.50 1812.50Q1330 1842 1408 1842ZM384 192L384 192Q384 232 369 267Q354 302 328 328Q302 354 267 369Q232 384 192 384L192 384Q152 384 117 369Q82 354 56 328Q30 302 15 267Q0 232 0 192L0 192Q0 152 15 117Q30 82 56 56Q82 30 117 15Q152 0 192 0L192 0Q232 0 267 15Q302 30 328 56Q354 82 369 117Q384 152 384 192Z"
         }
      }
   ]
}

var TFVCLogo = {
   name: "TFVCLogo",
   vendor: "UiFabric",
   unicode: 62541,
   value: "",
   charCode: "F44D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1760 576L1760 576Q1718 576 1678 564Q1638 552 1604 530Q1570 508 1542.50 476.50Q1515 445 1497 407L1497 407L1148 507Q1150 524 1151 541.50Q1152 559 1152 576L1152 576Q1152 675 1119.50 767Q1087 859 1026 936L1026 936L1479 1388Q1513 1366 1552 1355Q1591 1344 1632 1344L1632 1344Q1692 1344 1744.50 1366.50Q1797 1389 1836 1428Q1875 1467 1897.50 1519.50Q1920 1572 1920 1632L1920 1632Q1920 1692 1897.50 1744.50Q1875 1797 1836 1836Q1797 1875 1744.50 1897.50Q1692 1920 1632 1920L1632 1920Q1572 1920 1519.50 1897.50Q1467 1875 1428 1836Q1389 1797 1366.50 1744.50Q1344 1692 1344 1632L1344 1632Q1344 1591 1355 1552Q1366 1513 1388 1479L1388 1479L936 1026Q859 1087 767 1119.50Q675 1152 576 1152L576 1152Q545 1152 515 1149L515 1149L425 1507Q460 1526 488 1553Q516 1580 535.50 1613Q555 1646 565.50 1683.50Q576 1721 576 1760L576 1760Q576 1820 553.50 1872.50Q531 1925 492 1964Q453 2003 400.50 2025.50Q348 2048 288 2048L288 2048Q228 2048 175.50 2025.50Q123 2003 84 1964Q45 1925 22.50 1872.50Q0 1820 0 1760L0 1760Q0 1696 24 1643Q48 1590 89 1552Q130 1514 185 1493Q240 1472 302 1472L302 1472L390 1121Q303 1091 231 1037Q159 983 107.50 911Q56 839 28 753.50Q0 668 0 576L0 576Q0 457 45.50 352Q91 247 169 169Q247 91 352 45.50Q457 0 576 0L576 0Q667 0 751.50 27.50Q836 55 907.50 105Q979 155 1033.50 225.50Q1088 296 1118 382L1118 382L1472 281Q1473 223 1496.50 171.50Q1520 120 1559 82Q1598 44 1649.50 22Q1701 0 1760 0L1760 0Q1820 0 1872.50 22.50Q1925 45 1964 84Q2003 123 2025.50 175.50Q2048 228 2048 288L2048 288Q2048 348 2025.50 400.50Q2003 453 1964 492Q1925 531 1872.50 553.50Q1820 576 1760 576ZM576 896L576 896Q642 896 700 871Q758 846 801.50 802.50Q845 759 870.50 700.50Q896 642 896 576L896 576Q896 510 870.50 452Q845 394 801.50 350.50Q758 307 700 281.50Q642 256 576 256L576 256Q510 256 451.50 281.50Q393 307 349.50 350.50Q306 394 281 452Q256 510 256 576L256 576Q256 642 281 700.50Q306 759 349.50 802.50Q393 846 451.50 871Q510 896 576 896Z"
         }
      }
   ]
}

var ProjectLogo32 = {
   name: "ProjectLogo32",
   vendor: "UiFabric",
   unicode: 62590,
   value: "",
   charCode: "F47E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M400 819L496 819Q545 819 574 838.50Q603 858 603 910L603 910Q603 933 592.50 947.50Q582 962 566 971Q550 980 530 983.50Q510 987 492 987L492 987L400 987L400 819ZM2048 1365L2048 1365L2048 1835Q2048 1870 2023 1895Q1998 1920 1963 1920L1963 1920L789 1920Q754 1920 729 1895Q704 1870 704 1835L704 1835L704 1536L85 1536Q50 1536 25 1511Q0 1486 0 1451L0 1451L0 597Q0 562 25 537Q50 512 85 512L85 512L256 512L256 213Q256 178 281 153Q306 128 341 128L341 128L1259 128Q1294 128 1319 153Q1344 178 1344 213L1344 213L1344 704L1579 704Q1614 704 1639 729Q1664 754 1664 789L1664 789L1664 1280L1963 1280Q1998 1280 2023 1305Q2048 1330 2048 1365ZM1536 1280L1536 832L1024 832L1024 1280L1536 1280ZM767 905L767 905Q767 847 747.50 805.50Q728 764 694 738Q660 712 614 700Q568 688 514 688L514 688L243 688L243 1359L400 1359L400 1125L506 1125Q555 1125 601.50 1110.50Q648 1096 685 1068.50Q722 1041 744.50 1000Q767 959 767 905ZM384 256L384 512L939 512Q974 512 999 537Q1024 562 1024 597L1024 597L1024 704L1216 704L1216 256L384 256ZM832 1792L1920 1792L1920 1408L1024 1408L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536L832 1536L832 1792Z"
         }
      }
   ]
}

var ProjectLogoFill32 = {
   name: "ProjectLogoFill32",
   vendor: "UiFabric",
   unicode: 62591,
   value: "",
   charCode: "F47F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var ProjectLogo16 = {
   name: "ProjectLogo16",
   vendor: "UiFabric",
   unicode: 62592,
   value: "",
   charCode: "F480",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1536L2048 1536L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L640 2048Q613 2048 590 2038Q567 2028 549.50 2010.50Q532 1993 522 1970Q512 1947 512 1920L512 1920L512 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L256 384L256 160Q256 130 266 101.50Q276 73 295 50.50Q314 28 340 14Q366 0 398 0L398 0L1394 0Q1426 0 1452 14Q1478 28 1497 50.50Q1516 73 1526 101.50Q1536 130 1536 160L1536 160L1536 640L1646 640Q1676 640 1702.50 651.50Q1729 663 1749 683Q1769 703 1780.50 729.50Q1792 756 1792 786L1792 786L1792 1408L1920 1408Q1947 1408 1970 1418Q1993 1428 2010.50 1445.50Q2028 1463 2038 1486Q2048 1509 2048 1536ZM1646 768L1646 768L1280 768L1280 1408L1664 1408L1664 786Q1664 778 1659 773Q1654 768 1646 768ZM384 160L384 160L384 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 640L1408 640L1408 160Q1408 158 1407 152.50Q1406 147 1404.50 141.50Q1403 136 1400 132Q1397 128 1394 128L1394 128L398 128Q395 128 392 132Q389 136 387.50 141.50Q386 147 385 152.50Q384 158 384 160ZM567 1440L567 1169L674 1169Q739 1169 795.50 1149.50Q852 1130 894 1092.50Q936 1055 960 1001.50Q984 948 984 880L984 880Q984 810 961.50 758.50Q939 707 899.50 673.50Q860 640 804.50 624Q749 608 683 608L683 608L361 608L361 1440L567 1440ZM640 1920L1920 1920L1920 1536L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L640 1664L640 1920ZM770 886L770 886Q770 943 741 965Q712 987 658 987L658 987L567 987L567 791L662 791Q715 791 742.50 811.50Q770 832 770 886Z"
         }
      }
   ]
}

var ProjectLogoFill16 = {
   name: "ProjectLogoFill16",
   vendor: "UiFabric",
   unicode: 62593,
   value: "",
   charCode: "F481",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": ""
         }
      }
   ]
}

var SwayLogo32 = {
   name: "SwayLogo32",
   vendor: "UiFabric",
   unicode: 62594,
   value: "",
   charCode: "F482",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 320L1984 320L1984 1728Q1984 1754 1965 1773Q1946 1792 1920 1792L1920 1792L1216 1792L1216 1997L64 1731L64 317L1216 51L1216 256L1920 256Q1946 256 1965 275Q1984 294 1984 320ZM842 1194L842 1194Q842 1135 823.50 1095Q805 1055 777 1027Q749 999 716 979.50Q683 960 655 941.50Q627 923 608.50 902Q590 881 590 850L590 850Q590 818 606 805Q622 792 648 782L648 782Q653 782 657 781Q661 780 665 780L665 780Q712 780 745.50 793.50Q779 807 814 837L814 837L814 656Q785 643 754.50 637.50Q724 632 692 632L692 632Q671 632 650 634Q629 636 609 640L609 640Q568 648 536 669.50Q504 691 482.50 722Q461 753 450 790.50Q439 828 439 868L439 868Q439 924 457 962.50Q475 1001 501.50 1028.50Q528 1056 559 1076Q590 1096 616.50 1114.50Q643 1133 661 1154Q679 1175 679 1204L679 1204Q679 1241 656 1255Q633 1269 601 1269L601 1269Q552 1269 511.50 1240.50Q471 1212 442 1176L442 1176L442 1362Q465 1377 485.50 1387Q506 1397 527 1403.50Q548 1410 571 1413Q594 1416 622 1416L622 1416Q725 1416 783.50 1356.50Q842 1297 842 1194ZM1216 1728L1920 1728L1920 1216L1216 1216L1216 1344L1408 1344L1408 1408L1216 1408L1216 1536L1408 1536L1408 1600L1216 1600L1216 1728ZM1663 796L1920 1056L1920 320L1216 320L1216 885Q1222 880 1243.50 861Q1265 842 1289 821.50Q1313 801 1333.50 784.50Q1354 768 1359 768L1359 768Q1370 768 1374 775.50Q1378 783 1384 789L1384 789L1728 1152L1856 1152L1558 864Q1564 857 1574 844Q1584 831 1595.50 818Q1607 805 1618.50 795Q1630 785 1638 785L1638 785Q1645 785 1651.50 788Q1658 791 1663 796L1663 796ZM1472 1344L1856 1344L1856 1408L1472 1408L1472 1344ZM1752 606L1752 606Q1722 606 1701 585Q1680 564 1680 534L1680 534Q1680 505 1702 484Q1724 463 1752 463L1752 463Q1781 463 1802 484Q1823 505 1823 534L1823 534Q1823 563 1802 584.50Q1781 606 1752 606ZM1472 1536L1856 1536L1856 1600L1472 1600L1472 1536Z"
         }
      }
   ]
}

var SwayLogoFill32 = {
   name: "SwayLogoFill32",
   vendor: "UiFabric",
   unicode: 62595,
   value: "",
   charCode: "F483",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 288L1920 288Q1934 288 1943 297Q1952 306 1952 320L1952 320L1952 1728Q1952 1742 1943 1751Q1934 1760 1920 1760L1920 1760L1024 1760Q1010 1760 1001 1751Q992 1742 992 1728L992 1728L992 320Q992 306 1001 297Q1010 288 1024 288L1024 288ZM874 1194L874 1194Q874 1252 856.50 1299Q839 1346 806 1379Q773 1412 726.50 1430Q680 1448 622 1448L622 1448Q565 1448 511 1432.50Q457 1417 413 1380L413 1380Q412 1376 411 1371Q410 1366 410 1362L410 1362L410 1091Q429 1114 450 1139.50Q471 1165 494.50 1186.50Q518 1208 545.50 1222.50Q573 1237 607 1237L607 1237Q624 1237 635.50 1230Q647 1223 647 1204L647 1204Q647 1200 646 1194Q645 1188 643 1186L643 1186Q639 1170 619.50 1156Q600 1142 574 1125Q548 1108 518.50 1087Q489 1066 464.50 1036Q440 1006 423.50 965Q407 924 407 868L407 868Q407 804 427.50 754Q448 704 485.50 669.50Q523 635 575 617.50Q627 600 689 600L689 600Q734 600 767 607.50Q800 615 841 632L841 632Q842 634 844 644Q846 654 846 656L846 656L846 904Q823 885 803.50 868Q784 851 764 838.50Q744 826 721 819Q698 812 667 812L667 812Q650 812 636 822Q622 832 622 850L622 850Q622 866 629 877.50Q636 889 647 898Q658 907 670.50 914Q683 921 694 927L694 927Q734 951 767.50 977Q801 1003 824.50 1034.50Q848 1066 861 1105Q874 1144 874 1194Z"
         }
      }
   ]
}

var SwayLogo16 = {
   name: "SwayLogo16",
   vendor: "UiFabric",
   unicode: 62596,
   value: "",
   charCode: "F484",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 256L2048 256L2048 1792Q2048 1819 2038 1842Q2028 1865 2010.50 1882.50Q1993 1900 1970 1910Q1947 1920 1920 1920L1920 1920L1280 1920L1280 2048L0 1824L0 224L1280 0L1280 128L1920 128Q1947 128 1970 138Q1993 148 2010.50 165.50Q2028 183 2038 206Q2048 229 2048 256ZM912 1256L912 1256Q912 1177 886 1122.50Q860 1068 821 1029Q782 990 736 962Q690 934 651 908Q612 882 586 854Q560 826 560 786L560 786Q560 761 569.50 743.50Q579 726 595 715.50Q611 705 631.50 700.50Q652 696 674 696L674 696Q706 696 732 701.50Q758 707 781 717.50Q804 728 826 743Q848 758 873 777L873 777L873 516Q828 498 784 490.50Q740 483 691 483L691 483Q614 483 549.50 504Q485 525 438 566Q391 607 365 668Q339 729 339 810L339 810Q339 888 364 941Q389 994 426 1032.50Q463 1071 507 1098.50Q551 1126 588 1151Q625 1176 650 1204Q675 1232 675 1271L675 1271Q675 1315 646.50 1334.50Q618 1354 578 1354L578 1354Q538 1354 505.50 1343.50Q473 1333 445 1315Q417 1297 392 1272.50Q367 1248 342 1220L342 1220L342 1489Q366 1510 397.50 1524.50Q429 1539 463.50 1548.50Q498 1558 533 1562Q568 1566 599 1566L599 1566Q671 1566 729 1545Q787 1524 827.50 1484Q868 1444 890 1386.50Q912 1329 912 1256ZM1920 1792L1920 256L1280 256L1280 823L1393 678Q1407 660 1428 649.50Q1449 639 1472 639L1472 639Q1495 639 1516 649.50Q1537 660 1551 678L1551 678L1920 1152L1280 1152L1280 1280L1792 1280L1792 1408L1280 1408L1280 1536L1792 1536L1792 1664L1280 1664L1280 1792L1920 1792ZM1664 384L1792 384L1792 512L1664 512L1664 384Z"
         }
      }
   ]
}

var SwayLogoFill16 = {
   name: "SwayLogoFill16",
   vendor: "UiFabric",
   unicode: 62597,
   value: "",
   charCode: "F485",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1088 1856L1088 192L1984 192L1984 1856L1088 1856ZM976 1256L976 1256Q976 1342 949 1411Q922 1480 872.50 1529Q823 1578 753.50 1604Q684 1630 599 1630L599 1630Q549 1630 508.50 1624Q468 1618 431.50 1605.50Q395 1593 359.50 1573.50Q324 1554 284 1526L284 1526Q282 1517 280 1507.50Q278 1498 278 1489L278 1489L278 1054Q309 1089 342 1130Q375 1171 412.50 1206.50Q450 1242 493.50 1266Q537 1290 590 1290L590 1290L604 1286L611 1271Q610 1250 585 1230Q560 1210 522.50 1186Q485 1162 442 1131Q399 1100 361.50 1056Q324 1012 299.50 952Q275 892 275 810L275 810Q275 716 306 643Q337 570 392.50 520Q448 470 524.50 444Q601 418 692 418L692 418Q758 418 812.50 431.50Q867 445 928 469L928 469Q930 480 933.50 492.50Q937 505 937 516L937 516L937 909Q910 887 880 861Q850 835 817 812.50Q784 790 748 774.50Q712 759 674 759L674 759Q664 759 653 760.50Q642 762 633 767L633 767L625 777Q624 782 624 786.50Q624 791 624 793L624 793L624 798Q624 815 650 832.50Q676 850 715 873Q754 896 800 927.50Q846 959 885 1004.50Q924 1050 950 1111.50Q976 1173 976 1256Z"
         }
      }
   ]
}

var ClassNotebookLogo32 = {
   name: "ClassNotebookLogo32",
   vendor: "UiFabric",
   unicode: 62598,
   value: "",
   charCode: "F486",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 384L1984 384L1984 768Q1984 786 1976 800L1976 800Q1984 814 1984 832L1984 832L1984 1216Q1984 1234 1976 1248L1976 1248Q1984 1262 1984 1280L1984 1280L1984 1664Q1984 1690 1965 1709Q1946 1728 1920 1728L1920 1728L1856 1728Q1856 1754 1837 1773Q1818 1792 1792 1792L1792 1792L1216 1792L1216 1992L64 1791L64 263L1216 56L1216 256L1792 256Q1818 256 1837 275Q1856 294 1856 320L1856 320L1920 320Q1946 320 1965 339Q1984 358 1984 384ZM743 1388L897 1397L897 631L753 639L753 1153L467 655L321 660L321 1366L436 1372L436 854L743 1388ZM1856 1664L1920 1664L1920 1280L1856 1280L1856 1664ZM1856 1216L1920 1216L1920 832L1856 832L1856 1216ZM1792 768L1920 768L1920 384L1792 384L1792 320L1216 320L1216 1280L1600 1280L1600 1344L1216 1344L1216 1472L1600 1472L1600 1536L1216 1536L1216 1728L1792 1728L1792 768ZM1640 539L1690 568L1690 626L1728 676L1690 726L1690 783L1640 812L1611 862L1599 862L1599 1095L1502 1010L1409 1095L1409 862L1395 862L1366 812L1316 783L1316 726L1280 676L1316 626L1316 568L1366 539L1395 489L1453 489L1503 453L1553 489L1611 489L1640 539ZM1503 768L1503 768Q1522 768 1540 759.50Q1558 751 1571 737.50Q1584 724 1592 706Q1600 688 1600 669L1600 669Q1600 650 1592 632.50Q1584 615 1571 602Q1558 589 1540 581.50Q1522 574 1503 574L1503 574Q1483 574 1465 581.50Q1447 589 1433.50 602Q1420 615 1412 632.50Q1404 650 1404 669L1404 669Q1404 688 1412 706Q1420 724 1433.50 737.50Q1447 751 1465 759.50Q1483 768 1503 768Z"
         }
      }
   ]
}

var ClassNotebookLogoFill32 = {
   name: "ClassNotebookLogoFill32",
   vendor: "UiFabric",
   unicode: 62599,
   value: "",
   charCode: "F487",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M485 622L720 1032L720 609L929 597L929 1431L724 1419L468 974L468 1405L289 1397L289 630L485 622ZM1824 288L1824 352L1952 352L1952 1696L1824 1696L1824 1760L1184 1760L1184 288L1824 288Z"
         }
      }
   ]
}

var ClassNotebookLogo16 = {
   name: "ClassNotebookLogo16",
   vendor: "UiFabric",
   unicode: 62600,
   value: "",
   charCode: "F488",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L2048 384L2048 768Q2048 785 2042.50 801.50Q2037 818 2028 832L2028 832Q2037 846 2042.50 862.50Q2048 879 2048 896L2048 896L2048 1152Q2048 1169 2042.50 1185.50Q2037 1202 2028 1216L2028 1216Q2037 1230 2042.50 1246.50Q2048 1263 2048 1280L2048 1280L2048 1664Q2048 1691 2038 1714Q2028 1737 2010.50 1754.50Q1993 1772 1970 1782Q1947 1792 1920 1792L1920 1792L1792 1792Q1792 1819 1782 1842Q1772 1865 1754.50 1882.50Q1737 1900 1714 1910Q1691 1920 1664 1920L1664 1920L1280 1920L1280 2048L0 1824L0 224L1280 0L1280 128L1664 128Q1691 128 1714 138Q1737 148 1754.50 165.50Q1772 183 1782 206Q1792 229 1792 256L1792 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384ZM806 1539L1039 1552L1039 495L813 508Q813 669 813.50 827.50Q814 986 814 1147L814 1147Q810 1142 807 1136Q804 1130 801 1124L801 1124L459 528L240 540L240 1508L442 1519Q442 1376 442 1276Q442 1176 442 1108.50Q442 1041 442 1001.50Q442 962 441.50 939.50Q441 917 440.50 907.50Q440 898 440 891L440 891L806 1539ZM1792 1664L1920 1664L1920 1280L1792 1280L1792 1664ZM1792 1152L1920 1152L1920 896L1792 896L1792 1152ZM1664 768L1920 768L1920 384L1664 384L1664 256L1280 256L1280 1152L1536 1152L1536 1280L1280 1280L1280 1408L1536 1408L1536 1536L1280 1536L1280 1792L1664 1792L1664 768ZM1408 1024L1408 756Q1379 746 1355.50 728Q1332 710 1315.50 686.50Q1299 663 1289.50 634.50Q1280 606 1280 576L1280 576Q1280 536 1295 501Q1310 466 1336 440Q1362 414 1397 399Q1432 384 1472 384L1472 384Q1512 384 1547 399Q1582 414 1608 440Q1634 466 1649 501Q1664 536 1664 576L1664 576Q1664 606 1654.50 634.50Q1645 663 1628.50 686.50Q1612 710 1588 728Q1564 746 1536 756L1536 756L1536 1024L1408 1024ZM1536 512L1408 512L1408 640L1536 640L1536 512Z"
         }
      }
   ]
}

var ClassNotebookLogoFill16 = {
   name: "ClassNotebookLogoFill16",
   vendor: "UiFabric",
   unicode: 62601,
   value: "",
   charCode: "F489",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 192L1728 320L1984 320L1984 1728L1728 1728L1728 1856L1088 1856L1088 1619L768 1601L505 1136L505 1587L176 1568L176 480L495 462L749 905L749 447L1088 428L1088 192L1728 192Z"
         }
      }
   ]
}

var ClassNotebookLogoInverse32 = {
   name: "ClassNotebookLogoInverse32",
   vendor: "UiFabric",
   unicode: 62602,
   value: "",
   charCode: "F48A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 1992L64 1791L64 263L1216 56L1216 1992ZM467 655L321 660L321 1366L436 1372L436 854L743 1388L897 1397L897 631L752 639Q752 768 752 896Q752 1024 753 1153L753 1153L467 655ZM1920 832L1958 832Q1971 832 1977.50 844.50Q1984 857 1984 868L1984 868L1984 1116Q1984 1127 1977.50 1139.50Q1971 1152 1958 1152L1958 1152L1920 1152L1920 832ZM1920 1216L1958 1216Q1971 1216 1977.50 1228.50Q1984 1241 1984 1252L1984 1252L1984 1500Q1984 1511 1977.50 1523.50Q1971 1536 1958 1536L1958 1536L1920 1536L1920 1216ZM1984 469L1984 747Q1984 760 1981 764Q1978 768 1964 768L1964 768L1856 768L1856 1677Q1856 1684 1853.50 1693Q1851 1702 1846.50 1709.50Q1842 1717 1835.50 1722.50Q1829 1728 1821 1728L1821 1728L1280 1728L1280 1536L1664 1536L1664 1472L1280 1472L1280 1344L1664 1344L1664 1280L1280 1280L1280 320L1821 320Q1841 320 1848.50 337Q1856 354 1856 371L1856 371L1856 448L1964 448Q1978 448 1981 451.50Q1984 455 1984 469L1984 469ZM1753 783L1753 726L1792 676L1753 626L1753 568L1704 539L1675 489L1617 489L1567 453L1517 489L1459 489L1431 539L1381 568L1381 626L1344 676L1381 726L1381 783L1431 812L1459 862L1473 862L1473 1095L1566 1010L1663 1095L1663 862L1675 862L1704 812L1753 783ZM1567 574L1567 574Q1586 574 1604 581.50Q1622 589 1635 601.50Q1648 614 1656 631.50Q1664 649 1664 669L1664 669Q1664 689 1656 706.50Q1648 724 1635 738Q1622 752 1604 760Q1586 768 1567 768L1567 768Q1547 768 1529.50 760Q1512 752 1498 738Q1484 724 1476 706.50Q1468 689 1468 669L1468 669Q1468 649 1476 631.50Q1484 614 1498 601.50Q1512 589 1529.50 581.50Q1547 574 1567 574Z"
         }
      }
   ]
}

var ClassNotebookLogoInverse16 = {
   name: "ClassNotebookLogoInverse16",
   vendor: "UiFabric",
   unicode: 62603,
   value: "",
   charCode: "F48B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 2048L0 1824L0 224L1152 0L1152 2048ZM395 528L177 540L177 1508L378 1519Q378 1361 377.50 1205Q377 1049 377 891L377 891L743 1539L975 1552L975 495L750 508L750 1147Q749 1145 746.50 1140.50Q744 1136 733 1117.50Q722 1099 700.50 1061Q679 1023 640 955Q601 887 541 783Q481 679 395 528L395 528ZM1920 768L1952 768Q1968 768 1985.50 773Q2003 778 2016.50 788Q2030 798 2039 812Q2048 826 2048 845L2048 845L2048 1075Q2048 1094 2039 1108.50Q2030 1123 2016.50 1132.50Q2003 1142 1985.50 1147Q1968 1152 1952 1152L1952 1152L1920 1152L1920 768ZM1920 1280L1952 1280Q1968 1280 1985.50 1285Q2003 1290 2016.50 1300Q2030 1310 2039 1324Q2048 1338 2048 1357L2048 1357L2048 1587Q2048 1606 2039 1620.50Q2030 1635 2016.50 1644.50Q2003 1654 1985.50 1659Q1968 1664 1952 1664L1952 1664L1920 1664L1920 1280ZM1408 512L1536 512L1536 640L1408 640L1408 512ZM2048 333L2048 333L2048 563Q2048 582 2039 596.50Q2030 611 2016.50 620.50Q2003 630 1985.50 635Q1968 640 1952 640L1952 640L1792 640L1792 1792Q1792 1818 1782 1841.50Q1772 1865 1754.50 1882.50Q1737 1900 1713.50 1910Q1690 1920 1664 1920L1664 1920L1280 1920L1280 1536L1536 1536L1536 1408L1280 1408L1280 1280L1536 1280L1536 1152L1280 1152L1280 576Q1280 606 1289.50 634.50Q1299 663 1315.50 686.50Q1332 710 1355.50 728Q1379 746 1408 756L1408 756L1408 1024L1536 1024L1536 756Q1564 746 1588 728Q1612 710 1628.50 686.50Q1645 663 1654.50 634.50Q1664 606 1664 576L1664 576Q1664 536 1649 501Q1634 466 1608 440Q1582 414 1547 399Q1512 384 1472 384L1472 384Q1432 384 1397 399Q1362 414 1336 440Q1310 466 1295 501Q1280 536 1280 576L1280 576L1280 128L1664 128Q1690 128 1713.50 138Q1737 148 1754.50 165.50Q1772 183 1782 206.50Q1792 230 1792 256L1792 256L1952 256Q1968 256 1985.50 261Q2003 266 2016.50 276Q2030 286 2039 300Q2048 314 2048 333Z"
         }
      }
   ]
}

var StaffNotebookLogo32 = {
   name: "StaffNotebookLogo32",
   vendor: "UiFabric",
   unicode: 62604,
   value: "",
   charCode: "F48C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 384L1984 384L1984 768Q1984 784 1976 800L1976 800Q1984 816 1984 832L1984 832L1984 1216Q1984 1232 1976 1248L1976 1248Q1984 1264 1984 1280L1984 1280L1984 1664Q1984 1686 1975.50 1698.50Q1967 1711 1953.50 1717.50Q1940 1724 1923.50 1726Q1907 1728 1890 1728L1890 1728L1856 1728Q1856 1754 1837 1773Q1818 1792 1792 1792L1792 1792L1216 1792L1216 1992L64 1791L64 263L1216 56L1216 256L1792 256Q1818 256 1837 275Q1856 294 1856 320L1856 320L1890 320Q1907 320 1923.50 322Q1940 324 1953.50 330.50Q1967 337 1975.50 349.50Q1984 362 1984 384ZM743 1388L897 1397L897 631L752 639Q752 768 752 896Q752 1024 753 1153L753 1153L467 655L321 660L321 1366L436 1372L436 854L743 1388ZM1856 1664L1920 1664L1920 1280L1856 1280L1856 1664ZM1856 1216L1920 1216L1920 832L1856 832L1856 1216ZM1792 768L1920 768L1920 384L1792 384L1792 320L1216 320L1216 717L1408 640L1728 768L1664 794L1664 992Q1664 1006 1655 1015Q1646 1024 1632 1024L1632 1024Q1618 1024 1609 1015Q1600 1006 1600 992L1600 992L1600 819L1408 896L1216 819L1216 1280L1600 1280L1600 1344L1216 1344L1216 1472L1600 1472L1600 1536L1216 1536L1216 1728L1792 1728L1792 768ZM1280 1024L1280 931L1408 982L1536 931L1536 1024Q1536 1043 1521 1055Q1506 1067 1485 1074.50Q1464 1082 1442.50 1085Q1421 1088 1408 1088L1408 1088Q1395 1088 1373.50 1085Q1352 1082 1331 1074.50Q1310 1067 1295 1055Q1280 1043 1280 1024L1280 1024Z"
         }
      }
   ]
}

var StaffNotebookLogoFill32 = {
   name: "StaffNotebookLogoFill32",
   vendor: "UiFabric",
   unicode: 62605,
   value: "",
   charCode: "F48D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M485 622L720 1032L720 609L929 597L929 1431L724 1419L468 974L468 1405L289 1397L289 630L485 622ZM1824 288L1824 352L1952 352L1952 1696L1824 1696L1824 1760L1184 1760L1184 288L1824 288Z"
         }
      }
   ]
}

var StaffNotebookLogo16 = {
   name: "StaffNotebookLogo16",
   vendor: "UiFabric",
   unicode: 62606,
   value: "",
   charCode: "F48E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 384L2048 384L2048 768Q2048 785 2042.50 801.50Q2037 818 2028 832L2028 832Q2037 846 2042.50 862.50Q2048 879 2048 896L2048 896L2048 1152Q2048 1169 2042.50 1185.50Q2037 1202 2028 1216L2028 1216Q2037 1230 2042.50 1246.50Q2048 1263 2048 1280L2048 1280L2048 1664Q2048 1691 2038 1714Q2028 1737 2010.50 1754.50Q1993 1772 1970 1782Q1947 1792 1920 1792L1920 1792L1792 1792Q1792 1819 1782 1842Q1772 1865 1754.50 1882.50Q1737 1900 1714 1910Q1691 1920 1664 1920L1664 1920L1280 1920L1280 2048L0 1824L0 224L1280 0L1280 128L1664 128Q1691 128 1714 138Q1737 148 1754.50 165.50Q1772 183 1782 206Q1792 229 1792 256L1792 256L1920 256Q1947 256 1970 266Q1993 276 2010.50 293.50Q2028 311 2038 334Q2048 357 2048 384ZM806 1539L1039 1552L1039 495L813 508Q813 669 813.50 827.50Q814 986 814 1147L814 1147Q810 1142 807 1136Q804 1130 801 1124L801 1124L459 528L240 540L240 1508L442 1519Q442 1376 442 1276Q442 1176 442 1108.50Q442 1041 442 1001.50Q442 962 441.50 939.50Q441 917 440.50 907.50Q440 898 440 891L440 891L806 1539ZM1792 1664L1920 1664L1920 1280L1792 1280L1792 1664ZM1792 1152L1920 1152L1920 896L1792 896L1792 1152ZM1664 768L1920 768L1920 384L1664 384L1664 256L1280 256L1280 576L1408 512L1664 640L1408 768L1280 704L1280 847L1408 911L1536 847L1536 960Q1536 979 1521 991Q1506 1003 1485 1010.50Q1464 1018 1442.50 1021Q1421 1024 1408 1024L1408 1024Q1395 1024 1373.50 1021Q1352 1018 1331 1010.50Q1310 1003 1295 991Q1280 979 1280 960L1280 960L1280 1152L1536 1152L1536 1280L1280 1280L1280 1408L1536 1408L1536 1536L1280 1536L1280 1792L1664 1792L1664 768Z"
         }
      }
   ]
}

var StaffNotebookLogoFill16 = {
   name: "StaffNotebookLogoFill16",
   vendor: "UiFabric",
   unicode: 62607,
   value: "",
   charCode: "F48F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 192L1728 320L1984 320L1984 1728L1728 1728L1728 1856L1088 1856L1088 1619L768 1601L505 1136L505 1587L176 1568L176 480L495 462L749 905L749 447L1088 428L1088 192L1728 192Z"
         }
      }
   ]
}

var StaffNotebookLogoInverted32 = {
   name: "StaffNotebookLogoInverted32",
   vendor: "UiFabric",
   unicode: 62608,
   value: "",
   charCode: "F490",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 1992L64 1791L64 263L1216 56L1216 1992ZM467 655L321 660L321 1366L436 1372L436 854L743 1388L897 1397L897 631L752 639Q752 768 752 896Q752 1024 753 1153L753 1153L467 655ZM1920 832L1958 832Q1971 832 1977.50 844.50Q1984 857 1984 868L1984 868L1984 1116Q1984 1127 1977.50 1139.50Q1971 1152 1958 1152L1958 1152L1920 1152L1920 832ZM1920 1216L1958 1216Q1971 1216 1977.50 1228.50Q1984 1241 1984 1252L1984 1252L1984 1500Q1984 1511 1977.50 1523.50Q1971 1536 1958 1536L1958 1536L1920 1536L1920 1216ZM1984 469L1984 747Q1984 760 1981 764Q1978 768 1964 768L1964 768L1856 768L1856 1677Q1856 1684 1853.50 1693Q1851 1702 1846.50 1709.50Q1842 1717 1835.50 1722.50Q1829 1728 1821 1728L1821 1728L1280 1728L1280 1536L1664 1536L1664 1472L1280 1472L1280 1344L1664 1344L1664 1280L1280 1280L1280 819L1472 896L1664 819L1664 992Q1664 1006 1673 1015Q1682 1024 1696 1024L1696 1024Q1710 1024 1719 1015Q1728 1006 1728 992L1728 992L1728 794L1792 768L1472 640L1280 717L1280 320L1821 320Q1841 320 1848.50 337Q1856 354 1856 371L1856 371L1856 448L1964 448Q1978 448 1981 451.50Q1984 455 1984 469L1984 469ZM1600 1024L1600 1024L1600 931L1472 982L1344 931L1344 1024Q1344 1043 1359 1055Q1374 1067 1395 1074.50Q1416 1082 1437.50 1085Q1459 1088 1472 1088L1472 1088Q1485 1088 1506.50 1085Q1528 1082 1549 1074.50Q1570 1067 1585 1055Q1600 1043 1600 1024Z"
         }
      }
   ]
}

var StaffNotebookLogoInverted16 = {
   name: "StaffNotebookLogoInverted16",
   vendor: "UiFabric",
   unicode: 62609,
   value: "",
   charCode: "F491",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 2048L0 1824L0 224L1152 0L1152 2048ZM395 528L177 540L177 1508L378 1519Q378 1361 377.50 1205Q377 1049 377 891L377 891L743 1539L975 1552L975 495L750 508L750 1147Q749 1145 746.50 1140.50Q744 1136 733 1117.50Q722 1099 700.50 1061Q679 1023 640 955Q601 887 541 783Q481 679 395 528L395 528ZM1920 768L1952 768Q1968 768 1985.50 773Q2003 778 2016.50 788Q2030 798 2039 812Q2048 826 2048 845L2048 845L2048 1075Q2048 1094 2039 1108.50Q2030 1123 2016.50 1132.50Q2003 1142 1985.50 1147Q1968 1152 1952 1152L1952 1152L1920 1152L1920 768ZM1920 1280L1952 1280Q1968 1280 1985.50 1285Q2003 1290 2016.50 1300Q2030 1310 2039 1324Q2048 1338 2048 1357L2048 1357L2048 1587Q2048 1606 2039 1620.50Q2030 1635 2016.50 1644.50Q2003 1654 1985.50 1659Q1968 1664 1952 1664L1952 1664L1920 1664L1920 1280ZM2048 333L2048 333L2048 563Q2048 582 2039 596.50Q2030 611 2016.50 620.50Q2003 630 1985.50 635Q1968 640 1952 640L1952 640L1792 640L1792 1792Q1792 1818 1782 1841.50Q1772 1865 1754.50 1882.50Q1737 1900 1713.50 1910Q1690 1920 1664 1920L1664 1920L1280 1920L1280 1536L1536 1536L1536 1408L1280 1408L1280 1280L1536 1280L1536 1152L1280 1152L1280 960Q1280 979 1295 991Q1310 1003 1331 1010.50Q1352 1018 1373.50 1021Q1395 1024 1408 1024L1408 1024Q1421 1024 1442.50 1021Q1464 1018 1485 1010.50Q1506 1003 1521 991Q1536 979 1536 960L1536 960L1536 847L1408 911L1280 847L1280 720L1408 784L1696 640L1408 496L1280 560L1280 128L1664 128Q1690 128 1713.50 138Q1737 148 1754.50 165.50Q1772 183 1782 206.50Q1792 230 1792 256L1792 256L1952 256Q1968 256 1985.50 261Q2003 266 2016.50 276Q2030 286 2039 300Q2048 314 2048 333Z"
         }
      }
   ]
}

var KaizalaLogo = {
   name: "KaizalaLogo",
   vendor: "UiFabric",
   unicode: 62610,
   value: "",
   charCode: "F492",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2001 375L1878 498Q1962 613 2005 747Q2048 881 2048 1024L2048 1024Q2048 1148 2016 1262.50Q1984 1377 1925.50 1476.50Q1867 1576 1785.50 1657.50Q1704 1739 1604.50 1797.50Q1505 1856 1390.50 1888Q1276 1920 1152 1920L1152 1920Q1028 1920 913.50 1888Q799 1856 699.50 1797.50Q600 1739 518.50 1657.50Q437 1576 378.50 1476.50Q320 1377 288 1262.50Q256 1148 256 1024L256 1024L256 565Q256 533 242 507.50Q228 482 206.50 459.50Q185 437 160 416Q135 395 113.50 372Q92 349 78 323Q64 297 64 264L64 264Q64 236 74.50 211Q85 186 103.50 167.50Q122 149 147 138.50Q172 128 200 128L200 128L1152 128Q1319 128 1471.50 186.50Q1624 245 1749 356L1749 356L1865 239Q1893 211 1933 211L1933 211Q1973 211 2001 239Q2029 267 2029 307L2029 307Q2029 347 2001 375L2001 375ZM1920 1024L1920 1024Q1920 907 1886 796.50Q1852 686 1786 590L1786 590L1092 1284Q1064 1312 1024 1312L1024 1312Q984 1312 956 1284L956 1284L640 968Q612 940 612 900L612 900Q612 860 640 832Q668 804 708 804L708 804Q748 804 776 832L776 832L1024 1080L1658 446Q1551 352 1422.50 304Q1294 256 1152 256L1152 256L200 256Q192 256 192 264L192 264L194 269L309 384Q345 420 364.50 467Q384 514 384 565L384 565L384 1024Q384 1130 411.50 1228Q439 1326 489 1411.50Q539 1497 609 1567Q679 1637 764.50 1687Q850 1737 948 1764.50Q1046 1792 1152 1792L1152 1792Q1258 1792 1356 1764.50Q1454 1737 1539.50 1687Q1625 1637 1695 1567Q1765 1497 1815 1411.50Q1865 1326 1892.50 1228Q1920 1130 1920 1024Z"
         }
      }
   ]
}

var TaskLogo = {
   name: "TaskLogo",
   vendor: "UiFabric",
   unicode: 62611,
   value: "",
   charCode: "F493",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1894 387L1894 387Q1894 399 1886 409L1886 409L994 1557L372 886Q363 877 363 862L363 862Q363 846 374 835L374 835L521 699Q531 689 546 689L546 689Q561 689 572 700L572 700L976 1135L1671 242Q1682 228 1699 228L1699 228Q1711 228 1722 236L1722 236L1880 359Q1894 371 1894 387ZM256 1792L1664 1792L1664 974L1792 810L1792 1920L128 1920L128 256L1457 256L1357 384L256 384L256 1792Z"
         }
      }
   ]
}

var ProtectionCenterLogo32 = {
   name: "ProtectionCenterLogo32",
   vendor: "UiFabric",
   unicode: 62612,
   value: "",
   charCode: "F494",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 640L1216 640L1216 832L832 832L832 640Q832 600 847 565Q862 530 888 504Q914 478 949 463Q984 448 1024 448L1024 448Q1064 448 1099 463Q1134 478 1160 504Q1186 530 1201 565Q1216 600 1216 640ZM1344 1344L704 1344L704 896L1344 896L1344 1344ZM1856 347L1856 347L1856 790Q1856 922 1823 1038Q1790 1154 1731.50 1256Q1673 1358 1593.50 1448Q1514 1538 1421.50 1617Q1329 1696 1227.50 1765.50Q1126 1835 1024 1897L1024 1897Q921 1835 820 1765.50Q719 1696 626.50 1617Q534 1538 454.50 1448Q375 1358 316.50 1256Q258 1154 225 1038Q192 922 192 790L192 790L192 347Q267 347 334 342Q401 337 464 323Q527 309 589 283.50Q651 258 716 217L716 217Q789 171 863 149.50Q937 128 1024 128L1024 128Q1112 128 1186 150Q1260 172 1334 218L1334 218Q1398 259 1460 284Q1522 309 1585 323Q1648 337 1714.50 342Q1781 347 1856 347ZM640 1408L1408 1408L1408 832L1280 832L1280 640Q1280 588 1259.50 541Q1239 494 1204.50 459.50Q1170 425 1123 404.50Q1076 384 1024 384L1024 384Q971 384 924.50 404.50Q878 425 843.50 459.50Q809 494 788.50 541Q768 588 768 640L768 640L768 832L640 832L640 1408Z"
         }
      }
   ]
}

var GallatinLogo = {
   name: "GallatinLogo",
   vendor: "UiFabric",
   unicode: 62614,
   value: "",
   charCode: "F496",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M12199 769L12199 985L12110 985L12110 845L11232 845L11232 985L11155 985L11155 769L12199 769ZM12237 603L12237 667L11894 667L11894 743L11804 743L11804 667L11537 667L11537 743L11461 743L11461 667L11117 667L11117 603L11461 603L11461 514L11537 514L11537 603L11804 603L11804 514L11894 514L11894 603L12237 603ZM11932 1189L11423 1189L11423 1214L11333 1214L11333 934L12021 934L12021 1214L11932 1214L11932 1189ZM11423 1011L11423 1125L11932 1125L11932 1011L11423 1011ZM12021 1634L12021 1570L11346 1570L11346 1634L11257 1634L11257 1291L12110 1291L12110 1634L12021 1634ZM12021 1507L12021 1354L11346 1354L11346 1507L12021 1507ZM10990 578L10990 667L10353 667L10353 578L10990 578ZM11066 871L11066 959L10633 959Q10588 1040 10542.50 1121Q10497 1202 10443 1278L10443 1278Q10542 1267 10640 1263.50Q10738 1260 10837 1252L10837 1252Q10803 1210 10776.50 1165Q10750 1120 10723 1074L10723 1074L10786 1036Q10851 1111 10907 1190.50Q10963 1270 11015 1354L11015 1354L10939 1418Q10925 1396 10912.50 1374Q10900 1352 10888 1329L10888 1329Q10770 1336 10652.50 1344.50Q10535 1353 10417 1367L10417 1367Q10397 1369 10379 1374Q10361 1379 10341 1380L10341 1380L10303 1303Q10337 1268 10367 1226Q10397 1184 10423.50 1139.50Q10450 1095 10473.50 1049Q10497 1003 10519 959L10519 959L10277 959L10277 871L11066 871ZM10010 578L10074 514Q10119 568 10163 622.50Q10207 677 10252 731L10252 731L10175 794Q10131 741 10091.50 686.50Q10052 632 10010 578L10010 578ZM10137 1456L10137 1456Q10095 1488 10062 1528Q10029 1568 9997 1609L9997 1609L9946 1507Q9986 1477 10023.50 1444.50Q10061 1412 10099 1380L10099 1380L10099 998L9959 998L9959 909L10188 909L10188 1392Q10233 1446 10293.50 1476.50Q10354 1507 10424 1507L10424 1507L11079 1507L11041 1596L10405 1596Q10322 1585 10254.50 1555Q10187 1525 10137 1456ZM9755 323L9755 323Q9767 347 9780.50 371.50Q9794 396 9794 425L9794 425Q9794 455 9781.50 482.50Q9769 510 9747.50 531.50Q9726 553 9698.50 565.50Q9671 578 9641 578L9641 578Q9611 578 9585 565Q9559 552 9540.50 530Q9522 508 9511.50 481Q9501 454 9501 425L9501 425Q9501 361 9539 323Q9577 285 9641 285L9641 285Q9676 285 9701 294.50Q9726 304 9755 323ZM9641 311L9641 311Q9619 311 9596 320Q9573 329 9554.50 344.50Q9536 360 9524.50 381Q9513 402 9513 425L9513 425Q9513 446 9525 468.50Q9537 491 9556 509.50Q9575 528 9597.50 540Q9620 552 9641 552L9641 552Q9667 552 9690 542Q9713 532 9730.50 514.50Q9748 497 9758 474Q9768 451 9768 425L9768 425Q9768 368 9731.50 339.50Q9695 311 9641 311ZM9653 450L9664 450Q9669 450 9671.50 452Q9674 454 9679 463L9679 463L9704 514L9692 514L9666 463Q9659 463 9652.50 459Q9646 455 9641 450L9641 450L9615 450L9615 514L9590 514L9590 349L9641 349Q9692 349 9692 400L9692 400Q9692 420 9681 431Q9670 442 9653 450L9653 450ZM9679 400L9679 400Q9679 391 9672.50 387Q9666 383 9666 374L9666 374Q9658 369 9647 369L9647 369Q9641 369 9641 374L9641 374L9615 374L9615 425L9641 425Q9652 425 9662 415.50Q9672 406 9679 400ZM9042 285L9042 285Q9065 299 9086 310.50Q9107 322 9128.50 331Q9150 340 9172.50 348Q9195 356 9221 362L9221 362Q9181 415 9137 463Q9093 511 9055 565L9055 565L9259 565L9233 718L8877 705Q8867 764 8850 820.50Q8833 877 8814 934L8814 934L9221 934L9183 1100L8826 1087Q8853 1141 8866 1186Q8879 1231 8889 1269Q8899 1307 8911 1340Q8923 1373 8948.50 1402Q8974 1431 9017 1456.50Q9060 1482 9132 1507L9132 1507Q9088 1543 9047 1581.50Q9006 1620 8966 1660L8966 1660L8947 1645Q8901 1611 8868 1584.50Q8835 1558 8810 1534.50Q8785 1511 8767 1486Q8749 1461 8733.50 1429Q8718 1397 8704 1354.50Q8690 1312 8673 1252L8673 1252Q8628 1322 8574 1379Q8520 1436 8457.50 1482.50Q8395 1529 8324.50 1566Q8254 1603 8177 1634L8177 1634Q8153 1597 8132 1558.50Q8111 1520 8088 1482L8088 1482Q8184 1468 8253.50 1434.50Q8323 1401 8377 1350Q8431 1299 8474 1232.50Q8517 1166 8559 1087L8559 1087L8215 1087L8253 921L8610 934Q8622 875 8640.50 819.50Q8659 764 8673 705L8673 705L8330 705L8355 552L8571 565Q8561 534 8553.50 507.50Q8546 481 8538 455.50Q8530 430 8520 404.50Q8510 379 8495 349L8495 349Q8544 335 8591 318.50Q8638 302 8686 285L8686 285Q8704 337 8727.50 395.50Q8751 454 8775 502L8775 502Q8746 509 8727.50 512.50Q8709 516 8694 521.50Q8679 527 8663 536.50Q8647 546 8623 565L8623 565L8941 565Q8925 551 8904.50 541.50Q8884 532 8864 527L8864 527Q8892 499 8915 469Q8938 439 8958 408.50Q8978 378 8998 347Q9018 316 9042 285ZM8406 489L8304 476L8152 1176Q8184 1168 8217 1162.50Q8250 1157 8279 1138L8279 1138Q8271 1153 8268.50 1168.50Q8266 1184 8266 1201L8266 1201Q8250 1225 8244.50 1251Q8239 1277 8228 1303L8228 1303Q8199 1303 8170.50 1311Q8142 1319 8114 1329L8114 1329L8050 1634L7846 1634L7922 1367Q7810 1384 7699 1402Q7588 1420 7477 1443L7477 1443L7477 1278L7566 1265L7744 476L7655 476L7681 323L8432 323L8406 489ZM7897 642L8088 642L8126 476L7935 476L7897 642ZM8024 909L8050 769L7872 769L7834 909L8024 909ZM7961 1214L7961 1214L7986 1049L7808 1049L7757 1240Q7808 1232 7858.50 1223Q7909 1214 7961 1214ZM7159 387L7108 578L6332 578L6242 705L6866 705Q6773 870 6693 1038.50Q6613 1207 6535 1380L6535 1380L7006 1380L6955 1558L5352 1558L5403 1354L6293 1354L6370 1214L5683 1214Q5740 1135 5793.50 1053Q5847 971 5899.50 889.50Q5952 808 6005.50 726.50Q6059 645 6115 565L6115 565L5695 565L5746 387L7159 387ZM6141 871L6026 1049L6446 1049L6535 871L6141 871ZM4843 794L4919 540L4333 540L4372 362L5174 362L5021 959L4473 959Q4469 969 4459.50 1002.50Q4450 1036 4437.50 1081Q4425 1126 4411 1177.50Q4397 1229 4385.50 1274.50Q4374 1320 4366.50 1354.50Q4359 1389 4359 1401L4359 1401L4359 1405Q4376 1414 4397 1419Q4418 1424 4440 1426.50Q4462 1429 4484 1429.50Q4506 1430 4525 1430L4525 1430L4639 1430Q4693 1430 4726.50 1420Q4760 1410 4783.50 1390Q4807 1370 4824 1339.50Q4841 1309 4861 1267L4861 1267Q4863 1263 4864.50 1259.50Q4866 1256 4868 1252L4868 1252Q4884 1269 4906 1281.50Q4928 1294 4952 1303.50Q4976 1313 5000.50 1322Q5025 1331 5046 1342L5046 1342Q5028 1379 5006.50 1409Q4985 1439 4961 1465.50Q4937 1492 4910 1517.50Q4883 1543 4855 1570L4855 1570Q4833 1570 4811.50 1573.50Q4790 1577 4768 1581.50Q4746 1586 4724 1589.50Q4702 1593 4680 1593L4680 1593Q4645 1593 4607 1593.50Q4569 1594 4527 1594L4527 1594Q4475 1594 4421.50 1592Q4368 1590 4316 1583.50Q4264 1577 4216.50 1564.50Q4169 1552 4130 1532L4130 1532Q4130 1531 4129.50 1530.50Q4129 1530 4129 1529L4129 1529Q4126 1518 4121 1502.50Q4116 1487 4116 1476L4116 1476Q4116 1471 4117 1469L4117 1469L4295 794L4843 794ZM4117 489L4117 489Q4141 513 4168 534Q4195 555 4219 578L4219 578L4270 590Q4134 695 4002 800.50Q3870 906 3735 1011L3735 1011Q3840 993 3944.50 981.50Q4049 970 4155 959L4155 959Q4131 1000 4109.50 1041.50Q4088 1083 4066 1125L4066 1125Q3909 1125 3753.50 1146Q3598 1167 3443 1189L3443 1189Q3435 1150 3431.50 1112Q3428 1074 3417 1036L3417 1036Q3500 995 3574 941Q3648 887 3723 833L3723 833L3468 833Q3477 816 3482 795Q3487 774 3489.50 752Q3492 730 3492.50 708Q3493 686 3493 667L3493 667Q3511 650 3533.50 634.50Q3556 619 3580 603.50Q3604 588 3627.50 572.50Q3651 557 3671 540L3671 540Q3742 478 3804.50 412Q3867 346 3926 272L3926 272Q3971 299 4018.50 318.50Q4066 338 4117 349L4117 349Q4023 434 3929 517.50Q3835 601 3735 680L3735 680L3901 680Q3957 632 4011 586.50Q4065 541 4117 489ZM3112 680L3061 871L2755 858L2641 1278L1966 1278L2081 845L1890 845L1750 1380L2870 1380L2819 1570L1470 1570L1661 845L1419 845L1470 667L1711 680L1801 323L2042 336L1941 680L2132 680L2208 349L2450 349L2348 680L2564 680L2653 349L2895 349L2793 680L3112 680ZM2513 858L2310 845L2246 1100L2450 1100L2513 858ZM3315 1380L3315 1380Q3510 1360 3700 1323.50Q3890 1287 4079 1240L4079 1240Q4064 1255 4052.50 1274Q4041 1293 4041 1316L4041 1316Q4024 1335 4017.50 1358.50Q4011 1382 4002 1405L4002 1405Q3842 1443 3684 1480.50Q3526 1518 3366 1558L3366 1558Q3356 1511 3343.50 1468Q3331 1425 3315 1380ZM553 514L655 514L655 718L1075 718L1075 1609L986 1609L986 1545L222 1545L222 1609L134 1609L134 718L553 718L553 514ZM986 1087L986 807L655 807L655 1087L986 1087ZM222 807L222 1087L553 1087L553 807L222 807ZM655 1176L655 1456L986 1456L986 1176L655 1176ZM222 1456L553 1456L553 1176L222 1176L222 1456Z"
         }
      }
   ]
}

var GIF = {
   name: "GIF",
   vendor: "UiFabric",
   unicode: 62633,
   value: "",
   charCode: "F4A9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M192 128L1856 128Q1895 128 1930 143Q1965 158 1991.50 184.50Q2018 211 2033 246Q2048 281 2048 320L2048 320L2048 1600Q2048 1639 2033 1674Q2018 1709 1991.50 1735.50Q1965 1762 1930 1777Q1895 1792 1856 1792L1856 1792L192 1792Q153 1792 118 1777Q83 1762 56.50 1735.50Q30 1709 15 1674Q0 1639 0 1600L0 1600L0 320Q0 281 15 246Q30 211 56.50 184.50Q83 158 118 143Q153 128 192 128L192 128ZM1920 1600L1920 1600L1920 320Q1920 294 1901 275Q1882 256 1856 256L1856 256L192 256Q166 256 147 275Q128 294 128 320L128 320L128 1600Q128 1626 147 1645Q166 1664 192 1664L192 1664L1856 1664Q1882 1664 1901 1645Q1920 1626 1920 1600ZM1398 1274L1294 1274L1294 646L1632 646L1632 735L1398 735L1398 923L1614 923L1614 1011L1398 1011L1398 1274ZM770 1020L638 1020L638 933L874 933L874 1231Q823 1258 768 1271Q713 1284 656 1284L656 1284Q585 1284 527.50 1261Q470 1238 429 1196.50Q388 1155 366 1097Q344 1039 344 968L344 968Q344 895 369 834Q394 773 438.50 729Q483 685 544 660.50Q605 636 678 636L678 636Q723 636 767.50 642.50Q812 649 854 666L854 666L854 774Q816 748 772 736.50Q728 725 682 725L682 725Q630 725 588 743Q546 761 516 793Q486 825 470 868.50Q454 912 454 963L454 963Q454 1011 466.50 1053.50Q479 1096 504.50 1127.50Q530 1159 568 1177Q606 1195 658 1195L658 1195Q687 1195 715.50 1189.50Q744 1184 770 1170L770 1170L770 1020ZM1142 1280L1034 1280L1034 653L1142 653L1142 1280Z"
         }
      }
   ]
}

var UnsyncOccurence = {
   name: "UnsyncOccurence",
   vendor: "UiFabric",
   unicode: 62628,
   value: "",
   charCode: "F4A4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M205 115L1933 1843L1843 1933L1608 1699Q1489 1802 1340.50 1861Q1192 1920 1024 1920L1024 1920Q905 1920 792.50 1889.50Q680 1859 581 1803Q482 1747 399 1666.50Q316 1586 256 1486L256 1486L256 1792L128 1792L128 1280L640 1280L640 1408L359 1408Q410 1497 481.50 1568Q553 1639 639 1688.50Q725 1738 822.50 1765Q920 1792 1024 1792L1024 1792Q1165 1792 1290.50 1743.50Q1416 1695 1518 1608L1518 1608L439 530Q376 603 333 690Q290 777 270 877L270 877L144 852Q167 733 220 629.50Q273 526 349 440L349 440L115 205L205 115ZM1024 256L1024 256Q927 256 837 280Q747 304 666 347L666 347L572 252Q673 192 786.50 160Q900 128 1024 128L1024 128Q1142 128 1254 158.50Q1366 189 1465.50 245.50Q1565 302 1648.50 382Q1732 462 1792 562L1792 562L1792 256L1920 256L1920 768L1408 768L1408 640L1689 640Q1638 552 1566.50 481Q1495 410 1408.50 360Q1322 310 1224.50 283Q1127 256 1024 256ZM1797 1477L1797 1477L1701 1381Q1727 1332 1747 1280.50Q1767 1229 1778 1172L1778 1172L1903 1196Q1889 1273 1861.50 1342.50Q1834 1412 1797 1477Z"
         }
      }
   ]
}

var SyncOccurence = {
   name: "SyncOccurence",
   vendor: "UiFabric",
   unicode: 62627,
   value: "",
   charCode: "F4A3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 562L1792 256L1920 256L1920 768L1408 768L1408 640L1689 640Q1638 552 1566.50 481Q1495 410 1408.50 360Q1322 310 1224.50 283Q1127 256 1024 256L1024 256Q886 256 761 302.50Q636 349 535.50 431.50Q435 514 365.50 628Q296 742 270 877L270 877L144 852Q164 747 207.50 653Q251 559 313.50 478.50Q376 398 454.50 333Q533 268 624 222.50Q715 177 816 152.50Q917 128 1024 128L1024 128Q1142 128 1254 158.50Q1366 189 1465.50 245.50Q1565 302 1648.50 382Q1732 462 1792 562L1792 562ZM1024 1792L1024 1792Q1162 1792 1287 1745.50Q1412 1699 1512.50 1616.50Q1613 1534 1682.50 1420.50Q1752 1307 1778 1172L1778 1172L1903 1196Q1873 1354 1792 1486.50Q1711 1619 1594 1715.50Q1477 1812 1330.50 1866Q1184 1920 1024 1920L1024 1920Q905 1920 792.50 1889.50Q680 1859 581 1803Q482 1747 399 1666.50Q316 1586 256 1486L256 1486L256 1792L128 1792L128 1280L640 1280L640 1408L359 1408Q410 1497 481.50 1568Q553 1639 639 1688.50Q725 1738 822.50 1765Q920 1792 1024 1792Z"
         }
      }
   ]
}

var Chopsticks = {
   name: "Chopsticks",
   vendor: "UiFabric",
   unicode: 62626,
   value: "",
   charCode: "F4A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 709L1920 709Q1920 735 1901 754Q1882 773 1856 773L1856 773L768 773L768 1152L1600 1152Q1626 1152 1645 1171Q1664 1190 1664 1216L1664 1216Q1664 1331 1634.50 1437.50Q1605 1544 1550.50 1636.50Q1496 1729 1420.50 1804.50Q1345 1880 1252.50 1934.50Q1160 1989 1053.50 2018.50Q947 2048 832 2048L832 2048Q717 2048 610.50 2018.50Q504 1989 411.50 1934.50Q319 1880 243.50 1804.50Q168 1729 113.50 1636.50Q59 1544 29.50 1437.50Q0 1331 0 1216L0 1216Q0 1190 19 1171Q38 1152 64 1152L64 1152L640 1152L640 773L512 773L512 960Q512 986 493 1005Q474 1024 448 1024L448 1024Q422 1024 403 1005Q384 986 384 960L384 960L384 773L192 773Q166 773 147 754Q128 735 128 709L128 709Q128 683 147 664Q166 645 192 645L192 645L384 645L384 489Q369 492 344 497Q319 502 292 507Q265 512 240.50 516Q216 520 203 520L203 520Q177 520 158 501Q139 482 139 456L139 456Q139 433 154 415Q169 397 192 393L192 393L1851 101Q1855 100 1862 100L1862 100Q1888 100 1907 119Q1926 138 1926 164L1926 164Q1926 187 1911 205Q1896 223 1873 227L1873 227L768 422L768 645L1856 645Q1882 645 1901 664Q1920 683 1920 709ZM832 1920L832 1920Q968 1920 1090 1871Q1212 1822 1306.50 1736Q1401 1650 1461 1533Q1521 1416 1533 1280L1533 1280L131 1280Q143 1416 203 1533Q263 1650 357.50 1736Q452 1822 574 1871Q696 1920 832 1920ZM512 467L512 645L640 645L640 444L512 467Z"
         }
      }
   ]
}

var Taxi = {
   name: "Taxi",
   vendor: "UiFabric",
   unicode: 62625,
   value: "",
   charCode: "F4A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1152L384 1152Q411 1152 434 1162Q457 1172 474.50 1189.50Q492 1207 502 1230Q512 1253 512 1280L512 1280Q512 1307 502 1330Q492 1353 474.50 1370.50Q457 1388 434 1398Q411 1408 384 1408L384 1408Q357 1408 334 1398Q311 1388 293.50 1370.50Q276 1353 266 1330Q256 1307 256 1280L256 1280Q256 1253 266 1230Q276 1207 293.50 1189.50Q311 1172 334 1162Q357 1152 384 1152ZM1664 1152L1664 1152Q1691 1152 1714 1162Q1737 1172 1754.50 1189.50Q1772 1207 1782 1230Q1792 1253 1792 1280L1792 1280Q1792 1307 1782 1330Q1772 1353 1754.50 1370.50Q1737 1388 1714 1398Q1691 1408 1664 1408L1664 1408Q1637 1408 1614 1398Q1591 1388 1573.50 1370.50Q1556 1353 1546 1330Q1536 1307 1536 1280L1536 1280Q1536 1253 1546 1230Q1556 1207 1573.50 1189.50Q1591 1172 1614 1162Q1637 1152 1664 1152ZM2048 768L2048 896L2011 896L1945 961Q1947 966 1955 991Q1963 1016 1974.50 1050Q1986 1084 1999 1123Q2012 1162 2023 1194.50Q2034 1227 2041 1248.50Q2048 1270 2048 1270L2048 1270L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L1792 2048Q1765 2048 1742 2038Q1719 2028 1701.50 2010.50Q1684 1993 1674 1970Q1664 1947 1664 1920L1664 1920L384 1920Q384 1947 374 1970Q364 1993 346.50 2010.50Q329 2028 306 2038Q283 2048 256 2048L256 2048L128 2048Q101 2048 78 2038Q55 2028 37.50 2010.50Q20 1993 10 1970Q0 1947 0 1920L0 1920L0 1270Q0 1270 7 1248.50Q14 1227 25 1194.50Q36 1162 49 1123Q62 1084 73.50 1050Q85 1016 93 991Q101 966 103 961L103 961L37 896L0 896L0 768L91 768L148 826L222 603Q239 551 270 510.50Q301 470 342.50 442Q384 414 433 399Q482 384 536 384L536 384L647 163Q655 147 671 137.50Q687 128 704 128L704 128L1344 128Q1361 128 1377 137.50Q1393 147 1401 163L1401 163L1512 384Q1566 384 1615 399Q1664 414 1705.50 442Q1747 470 1778 510.50Q1809 551 1826 603L1826 603L1900 826L1957 768L2048 768ZM1304 256L744 256L680 384L1368 384L1304 256ZM344 643L259 896L1789 896L1704 643Q1684 584 1634.50 548Q1585 512 1522 512L1522 512L526 512Q463 512 413.50 548Q364 584 344 643L344 643ZM640 1792L1408 1792L1408 1743L1304 1536L744 1536L640 1743L640 1792ZM1536 1713L1536 1792L1920 1792L1920 1290Q1920 1290 1914 1271.50Q1908 1253 1898.50 1225Q1889 1197 1878 1163.50Q1867 1130 1857 1100.50Q1847 1071 1840 1050Q1833 1029 1831 1024L1831 1024L217 1024Q215 1029 208 1050Q201 1071 191 1100.50Q181 1130 170 1163.50Q159 1197 149.50 1225Q140 1253 134 1271.50Q128 1290 128 1290L128 1290L128 1792L512 1792L512 1713L664 1408L1384 1408L1536 1713Z"
         }
      }
   ]
}

var Vacation = {
   name: "Vacation",
   vendor: "UiFabric",
   unicode: 62623,
   value: "",
   charCode: "F49F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1664L1728 1664Q1754 1664 1773 1683Q1792 1702 1792 1728L1792 1728Q1792 1754 1773 1773Q1754 1792 1728 1792L1728 1792L960 1792Q934 1792 915 1773Q896 1754 896 1728L896 1728Q896 1702 915 1683Q934 1664 960 1664L960 1664ZM1088 1920L1600 1920Q1626 1920 1645 1939Q1664 1958 1664 1984L1664 1984Q1664 2010 1645 2029Q1626 2048 1600 2048L1600 2048L1088 2048Q1062 2048 1043 2029Q1024 2010 1024 1984L1024 1984Q1024 1958 1043 1939Q1062 1920 1088 1920L1088 1920ZM1838 1408L1838 1408L2048 1408L2048 1536L537 1536Q527 1600 522.50 1664Q518 1728 515.50 1791.50Q513 1855 513 1919Q513 1983 512 2048L512 2048L128 2048L128 1855Q128 1774 134 1695Q140 1616 151 1536L151 1536L0 1536L0 1408L172 1408Q222 1163 323 937Q424 711 573 510L573 510Q427 505 305 448.50Q183 392 82 289L82 289L37 243L84 199Q188 102 312 51.50Q436 1 579 1L579 1Q735 1 865 59.50Q995 118 1104 227L1104 227Q1181 229 1253 251Q1325 273 1387 311Q1449 349 1500 401Q1551 453 1587.50 516Q1624 579 1644 651Q1664 723 1664 801L1664 801L1664 865L1600 865Q1468 865 1352.50 808.50Q1237 752 1154 650L1154 650Q1078 788 963 877Q848 966 694 1002L694 1002Q651 1101 617.50 1202Q584 1303 561 1408L561 1408L850 1408Q872 1324 919 1253.50Q966 1183 1031.50 1132Q1097 1081 1177 1052.50Q1257 1024 1344 1024L1344 1024Q1431 1024 1511 1052.50Q1591 1081 1656.50 1132Q1722 1183 1769 1253.50Q1816 1324 1838 1408ZM1238 380L1238 380Q1232 445 1212 512L1212 512Q1263 600 1346.50 658Q1430 716 1531 732L1531 732Q1521 671 1496 616.50Q1471 562 1432.50 516Q1394 470 1345 435.50Q1296 401 1238 380ZM1112 387L1112 387Q1010 395 919.50 437.50Q829 480 758.50 547.50Q688 615 641.50 704Q595 793 581 893L581 893Q666 886 742 856.50Q818 827 881 779Q944 731 993 666.50Q1042 602 1074 523L1074 523Q1088 490 1097.50 456Q1107 422 1112 387ZM224 247L224 247Q304 313 401 348Q498 383 602 383L602 383Q699 383 789.50 353Q880 323 957 265L957 265Q877 199 780 164Q683 129 579 129L579 129Q482 129 391.50 159Q301 189 224 247ZM542 1022L542 1022Q534 1024 526 1024Q518 1024 510 1024L510 1024Q494 1024 478 1023.50Q462 1023 446 1022L446 1022L446 975Q393 1093 356.50 1207Q320 1321 297.50 1437Q275 1553 265.50 1672.50Q256 1792 256 1920L256 1920L384 1920Q384 1799 392.50 1686Q401 1573 419.50 1463Q438 1353 468 1244Q498 1135 542 1022ZM984 1408L984 1408L1704 1408Q1684 1351 1648 1303.50Q1612 1256 1564.50 1222.50Q1517 1189 1461 1170.50Q1405 1152 1344 1152L1344 1152Q1283 1152 1227 1170.50Q1171 1189 1123.50 1222.50Q1076 1256 1040 1303.50Q1004 1351 984 1408Z"
         }
      }
   ]
}

var BeerMug = {
   name: "BeerMug",
   vendor: "UiFabric",
   unicode: 62622,
   value: "",
   charCode: "F49E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L1600 512Q1666 512 1724 537.50Q1782 563 1825.50 606.50Q1869 650 1894.50 708Q1920 766 1920 832L1920 832L1920 1344Q1920 1410 1894.50 1468.50Q1869 1527 1825.50 1570.50Q1782 1614 1724 1639Q1666 1664 1600 1664L1600 1664L1536 1664L1536 1856Q1536 1896 1521 1931Q1506 1966 1480 1992Q1454 2018 1419 2033Q1384 2048 1344 2048L1344 2048L320 2048Q280 2048 245 2033Q210 2018 184 1992Q158 1966 143 1931Q128 1896 128 1856L128 1856L128 477Q69 443 34.50 384Q0 325 0 256L0 256Q0 204 20 157Q40 110 74.50 75.50Q109 41 155 20.50Q201 0 254 0L254 0L1408 0Q1461 0 1507.50 20Q1554 40 1589 75Q1624 110 1644 156.50Q1664 203 1664 256L1664 256Q1664 291 1654.50 325Q1645 359 1628.50 389.50Q1612 420 1588 445Q1564 470 1536 488L1536 488L1536 512ZM1408 128L255 128Q229 128 205.50 138Q182 148 165 165.50Q148 183 138 206.50Q128 230 128 256L128 256Q128 296 151.50 329Q175 362 213 376L213 376L256 391L256 960Q256 986 275 1005Q294 1024 320 1024L320 1024Q346 1024 365 1005Q384 986 384 960L384 960L384 576Q384 536 399 501Q414 466 440 440Q466 414 501 399Q536 384 576 384L576 384Q616 384 651 399Q686 414 712 440Q738 466 753 501Q768 536 768 576L768 576L768 832Q768 858 787 877Q806 896 832 896L832 896Q858 896 877 877Q896 858 896 832L896 832L896 576Q896 536 911 501Q926 466 952 440Q978 414 1013 399Q1048 384 1088 384L1088 384L1459 384Q1492 368 1514 332Q1536 296 1536 256L1536 256Q1536 229 1526 206Q1516 183 1498.50 165.50Q1481 148 1458 138Q1435 128 1408 128L1408 128ZM1408 1856L1408 1856L1408 1780Q1393 1785 1377 1788.50Q1361 1792 1344 1792L1344 1792L320 1792Q303 1792 287 1788.50Q271 1785 256 1780L256 1780L256 1856Q256 1882 275 1901Q294 1920 320 1920L320 1920L1344 1920Q1370 1920 1389 1901Q1408 1882 1408 1856ZM1152 1664L1344 1664Q1370 1664 1389 1645Q1408 1626 1408 1600L1408 1600L1408 512L1088 512Q1062 512 1043 531Q1024 550 1024 576L1024 576L1024 832Q1024 872 1009 907Q994 942 968 968Q942 994 907 1009Q872 1024 832 1024L832 1024Q792 1024 757 1009Q722 994 696 968Q670 942 655 907Q640 872 640 832L640 832L640 576Q640 550 621 531Q602 512 576 512L576 512Q550 512 531 531Q512 550 512 576L512 576L512 960Q512 1000 497 1035Q482 1070 456 1096Q430 1122 395 1137Q360 1152 320 1152L320 1152Q287 1152 256 1141L256 1141L256 1600Q256 1626 275 1645Q294 1664 320 1664L320 1664L512 1664L512 1216Q512 1189 531 1170.50Q550 1152 576 1152L576 1152Q602 1152 621 1170.50Q640 1189 640 1216L640 1216L640 1664L1024 1664L1024 1088Q1024 1061 1043 1042.50Q1062 1024 1088 1024L1088 1024Q1114 1024 1133 1042.50Q1152 1061 1152 1088L1152 1088L1152 1664ZM1792 1344L1792 1344L1792 832Q1792 792 1777 757Q1762 722 1736 696Q1710 670 1675 655Q1640 640 1600 640L1600 640L1536 640L1536 1536L1600 1536Q1640 1536 1675 1521Q1710 1506 1736 1480Q1762 1454 1777 1419Q1792 1384 1792 1344Z"
         }
      }
   ]
}

var Brunch = {
   name: "Brunch",
   vendor: "UiFabric",
   unicode: 62621,
   value: "",
   charCode: "F49D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1662 896L1662 896Q1658 968 1647 1036Q1636 1104 1618.50 1170Q1601 1236 1578.50 1301.50Q1556 1367 1530 1433L1530 1433Q1521 1456 1515.50 1484.50Q1510 1513 1507 1536L1507 1536L1792 1536L1792 1600Q1792 1656 1773.50 1707Q1755 1758 1721.50 1799.50Q1688 1841 1642 1870.50Q1596 1900 1542 1912L1542 1912L1564 2048L878 2048L894 1920L320 1920Q254 1920 195.50 1895Q137 1870 93.50 1826.50Q50 1783 25 1724.50Q0 1666 0 1600L0 1600L0 1536L256 1536Q256 1457 286 1387Q316 1317 368.50 1264.50Q421 1212 490.50 1182Q560 1152 640 1152L640 1152Q690 1152 737 1165Q784 1178 827 1203L827 1203Q800 1106 784 1007.50Q768 909 768 808L768 808Q768 730 780.50 659Q793 588 816 514L816 514L959 514L857 110L982 79L1091 514L1280 514Q1280 435 1310 364.50Q1340 294 1392 241.50Q1444 189 1514 158.50Q1584 128 1664 128L1664 128Q1743 128 1813 158Q1883 188 1935.50 240.50Q1988 293 2018 363Q2048 433 2048 512L2048 512Q2048 592 2017.50 662Q1987 732 1934.50 784Q1882 836 1812 866Q1742 896 1662 896ZM1664 256L1664 256Q1611 256 1564 276.50Q1517 297 1482.50 332Q1448 367 1428 414Q1408 461 1408 514L1408 514L1616 514Q1636 578 1647 639.50Q1658 701 1661 768L1661 768Q1715 768 1762 748Q1809 728 1844.50 693Q1880 658 1900 611.50Q1920 565 1920 512L1920 512Q1920 459 1900 412.50Q1880 366 1845 331Q1810 296 1763.50 276Q1717 256 1664 256ZM640 1280L640 1280Q587 1280 540.50 1300Q494 1320 459 1355Q424 1390 404 1436.50Q384 1483 384 1536L384 1536L896 1536Q896 1483 876 1436.50Q856 1390 821 1355Q786 1320 739.50 1300Q693 1280 640 1280ZM926 1664L926 1664L139 1664Q149 1693 167 1716.50Q185 1740 209 1757Q233 1774 261.50 1783Q290 1792 320 1792L320 1792L911 1792Q915 1760 920.50 1728Q926 1696 926 1664ZM1653 1664L1503 1664Q1505 1695 1510.50 1724.50Q1516 1754 1520 1784L1520 1784Q1566 1772 1601.50 1740.50Q1637 1709 1653 1664L1653 1664ZM1536 814L1536 814Q1536 770 1532.50 727Q1529 684 1519 642L1519 642L913 642Q904 684 900 725.50Q896 767 896 809L896 809Q896 867 904 936Q912 1005 926.50 1075Q941 1145 961 1211.50Q981 1278 1006 1332L1006 1332Q1035 1395 1046 1460.50Q1057 1526 1057 1595L1057 1595Q1057 1677 1045.50 1758Q1034 1839 1023 1920L1023 1920L1413 1920Q1401 1845 1386.50 1770.50Q1372 1696 1372 1619L1372 1619Q1372 1592 1374 1561.50Q1376 1531 1381 1499.50Q1386 1468 1393.50 1438Q1401 1408 1412 1383L1412 1383Q1442 1313 1465 1244Q1488 1175 1504 1105.50Q1520 1036 1528 963.50Q1536 891 1536 814Z"
         }
      }
   ]
}

var Breakfast = {
   name: "Breakfast",
   vendor: "UiFabric",
   unicode: 62620,
   value: "",
   charCode: "F49C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 592L1408 592Q1382 592 1363 573Q1344 554 1344 528L1344 528Q1344 477 1363.50 430Q1383 383 1419 347L1419 347L1498 267Q1536 229 1536 176L1536 176Q1536 150 1555 131Q1574 112 1600 112L1600 112Q1626 112 1645 131Q1664 150 1664 176L1664 176Q1664 227 1644.50 274Q1625 321 1589 357L1589 357L1510 437Q1472 475 1472 528L1472 528Q1472 554 1453 573Q1434 592 1408 592ZM1024 592L1024 592Q998 592 979 573Q960 554 960 528L960 528Q960 477 979.50 430Q999 383 1035 347L1035 347L1114 267Q1152 229 1152 176L1152 176Q1152 150 1171 131Q1190 112 1216 112L1216 112Q1242 112 1261 131Q1280 150 1280 176L1280 176Q1280 227 1260.50 274Q1241 321 1205 357L1205 357L1126 437Q1088 475 1088 528L1088 528Q1088 554 1069 573Q1050 592 1024 592ZM1792 768L1856 768Q1896 768 1931 783Q1966 798 1992 824Q2018 850 2033 885Q2048 920 2048 960L2048 960L2048 1344Q2048 1384 2033 1419Q2018 1454 1992 1480Q1966 1506 1931 1521Q1896 1536 1856 1536L1856 1536L1799 1536Q1797 1543 1795.50 1549Q1794 1555 1792 1561L1792 1561L1792 1600Q1792 1666 1766.50 1724.50Q1741 1783 1697.50 1826.50Q1654 1870 1596 1895Q1538 1920 1472 1920L1472 1920L1088 1920Q1010 1920 944 1885Q878 1850 834 1792L834 1792L334 1792Q268 1792 209.50 1767Q151 1742 107.50 1698.50Q64 1655 39 1596.50Q14 1538 14 1472L14 1472L14 1408L270 1408Q270 1329 300.50 1259Q331 1189 383 1136.50Q435 1084 505 1054Q575 1024 654 1024L654 1024Q684 1024 712.50 1029.50Q741 1035 768 1043L768 1043L768 640L1792 640L1792 768ZM654 1152L654 1152Q601 1152 554.50 1172Q508 1192 473 1227Q438 1262 418 1308.50Q398 1355 398 1408L398 1408L768 1408L768 1180Q742 1167 713.50 1159.50Q685 1152 654 1152ZM334 1664L334 1664L775 1664Q768 1635 768 1600L768 1600L768 1536L153 1536Q163 1564 181 1587.50Q199 1611 222.50 1628Q246 1645 274.50 1654.50Q303 1664 334 1664ZM797 1731L797 1731Q797 1732 797.50 1732.50Q798 1733 798 1734L798 1734Q798 1733 797.50 1732.50Q797 1732 797 1731ZM1664 1600L1664 1600L1664 768L896 768L896 1600Q896 1640 911 1675Q926 1710 952 1736Q978 1762 1013 1777Q1048 1792 1088 1792L1088 1792L1472 1792Q1512 1792 1547 1777Q1582 1762 1608 1736Q1634 1710 1649 1675Q1664 1640 1664 1600ZM1920 1344L1920 1344L1920 960Q1920 934 1901 915Q1882 896 1856 896L1856 896L1792 896L1792 1408L1856 1408Q1882 1408 1901 1389Q1920 1370 1920 1344Z"
         }
      }
   ]
}

var Guitar = {
   name: "Guitar",
   vendor: "UiFabric",
   unicode: 62619,
   value: "",
   charCode: "F49B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 320L2048 320Q2048 346 2029 365L2029 365L1741 653Q1722 672 1696 672L1696 672Q1667 672 1648 650L1648 650L1146 1152L1216 1152Q1242 1152 1261 1171Q1280 1190 1280 1216L1280 1216L1280 1344Q1280 1384 1265 1419Q1250 1454 1224 1480Q1198 1506 1163 1521Q1128 1536 1088 1536L1088 1536Q1062 1536 1043 1555Q1024 1574 1024 1600L1024 1600Q1024 1693 989 1774.50Q954 1856 893 1917Q832 1978 750.50 2013Q669 2048 576 2048L576 2048Q457 2048 352 2002.50Q247 1957 169 1879Q91 1801 45.50 1696Q0 1591 0 1472L0 1472Q0 1379 35 1297.50Q70 1216 131 1155Q192 1094 273.50 1059Q355 1024 448 1024L448 1024Q474 1024 493 1005Q512 986 512 960L512 960Q512 907 532 860.50Q552 814 587 779Q622 744 668.50 724Q715 704 768 704L768 704Q834 704 888.50 734Q943 764 980 818L980 818L1398 400Q1376 381 1376 352L1376 352Q1376 326 1395 307L1395 307L1683 19Q1702 0 1728 0L1728 0Q1754 0 1773 19L1773 19L2029 275Q2048 294 2048 320ZM1152 1344L1152 1280L992 1280Q966 1280 947 1261L947 1261L787 1101Q768 1082 768 1056L768 1056Q768 1030 787 1011L787 1011L886 912Q872 876 839.50 854Q807 832 768 832L768 832Q741 832 718 842Q695 852 677.50 869.50Q660 887 650 910Q640 933 640 960L640 960Q640 1000 625 1035Q610 1070 584 1096Q558 1122 523 1137Q488 1152 448 1152L448 1152Q382 1152 323.50 1177.50Q265 1203 221.50 1246.50Q178 1290 153 1348Q128 1406 128 1472L128 1472Q128 1565 163.50 1646.50Q199 1728 259.50 1788.50Q320 1849 401.50 1884.50Q483 1920 576 1920L576 1920Q642 1920 700 1895Q758 1870 801.50 1826.50Q845 1783 870.50 1724.50Q896 1666 896 1600L896 1600Q896 1560 911 1525Q926 1490 952 1464Q978 1438 1013 1423Q1048 1408 1088 1408L1088 1408Q1114 1408 1133 1389Q1152 1370 1152 1344L1152 1344ZM922 1056L992 1126L1558 560L1488 490L922 1056ZM1530 352L1696 518L1894 320L1728 154L1530 352ZM579 1693L355 1469L445 1379L669 1603L579 1693ZM771 1501L547 1277L637 1187L861 1411L771 1501Z"
         }
      }
   ]
}

var Globe2 = {
   name: "Globe2",
   vendor: "UiFabric",
   unicode: 62618,
   value: "",
   charCode: "F49A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1897 1572L1897 1572Q1897 1598 1878 1617Q1859 1636 1833 1636L1833 1636Q1818 1636 1802 1626Q1786 1616 1771 1602.50Q1756 1589 1743 1574Q1730 1559 1720 1549L1720 1549Q1614 1643 1487.50 1700Q1361 1757 1221 1777L1221 1777L1221 1920L1408 1920L1408 2048L896 2048L896 1920L1093 1920L1093 1786Q959 1786 836 1752Q713 1718 605.50 1656Q498 1594 410 1506.50Q322 1419 259.50 1312.50Q197 1206 162.50 1083Q128 960 128 826L128 826Q128 649 189 488.50Q250 328 365 194L365 194Q356 186 346.50 177Q337 168 328.50 158Q320 148 314.50 136.50Q309 125 309 112L309 112Q309 86 328 67Q347 48 373 48L373 48Q400 48 419 67L419 67L641 288Q736 210 850.50 169Q965 128 1088 128L1088 128Q1185 128 1275 153Q1365 178 1443.50 224Q1522 270 1586 334Q1650 398 1696 476.50Q1742 555 1767 645Q1792 735 1792 832L1792 832Q1792 955 1751 1069.50Q1710 1184 1632 1279L1632 1279L1878 1526Q1897 1545 1897 1572ZM512 832L512 832Q512 913 535 993L535 993L664 863Q627 808 598 749.50Q569 691 549 628L549 628Q512 728 512 832ZM756 401L756 401Q705 401 681 425.50Q657 450 657 501L657 501Q657 534 666 570Q675 606 689.50 641.50Q704 677 721.50 710Q739 743 757 771L757 771L1027 501Q999 483 965.50 465Q932 447 897 433Q862 419 826 410Q790 401 756 401ZM1419 893L1419 893L1149 1163Q1177 1181 1210 1198.50Q1243 1216 1278.50 1230.50Q1314 1245 1350 1254Q1386 1263 1419 1263L1419 1263Q1471 1263 1495 1239Q1519 1215 1519 1163L1519 1163Q1519 1130 1510 1094Q1501 1058 1486.50 1022.50Q1472 987 1454.50 954Q1437 921 1419 893ZM1043 1088L1043 1088L1344 787Q1249 671 1133 576L1133 576L832 877Q927 993 1043 1088ZM741 967L741 967L589 1120Q627 1186 680.50 1239.50Q734 1293 800 1331L800 1331L953 1179Q836 1084 741 967ZM1057 1256L1057 1256L927 1385Q1007 1408 1088 1408L1088 1408Q1192 1408 1292 1371L1292 1371Q1229 1351 1170.50 1322Q1112 1293 1057 1256ZM1627 1036L1627 1036Q1664 936 1664 832L1664 832Q1664 751 1641 671L1641 671L1512 801Q1549 856 1578 914.50Q1607 973 1627 1036ZM1435 697L1587 544Q1549 478 1495.50 424.50Q1442 371 1376 333L1376 333L1223 485Q1340 580 1435 697L1435 697ZM1119 408L1249 279Q1169 256 1088 256L1088 256Q984 256 884 293L884 293Q947 313 1005.50 342Q1064 371 1119 408L1119 408ZM1088 1658L1088 1658Q1237 1658 1376 1606.50Q1515 1555 1629 1458L1629 1458L1542 1371Q1445 1451 1330 1493.50Q1215 1536 1088 1536L1088 1536Q991 1536 901 1511Q811 1486 732.50 1440Q654 1394 590 1330Q526 1266 480 1187.50Q434 1109 409 1019Q384 929 384 832L384 832Q384 705 426.50 590Q469 475 549 378L549 378L456 285Q359 399 307.50 538Q256 677 256 827L256 827Q256 942 285.50 1048Q315 1154 369.50 1246.50Q424 1339 499.50 1414.50Q575 1490 667.50 1544.50Q760 1599 866.50 1628.50Q973 1658 1088 1658Z"
         }
      }
   ]
}

var Teeth = {
   name: "Teeth",
   vendor: "UiFabric",
   unicode: 62624,
   value: "",
   charCode: "F4A0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 512L1024 512Q1094 512 1156.50 492Q1219 472 1280 448Q1341 424 1403 404Q1465 384 1536 384L1536 384L1536 512Q1492 512 1452 521.50Q1412 531 1373.50 545Q1335 559 1296 576Q1257 593 1215 607Q1173 621 1126 630.50Q1079 640 1024 640L1024 640Q969 640 922 630.50Q875 621 833 607Q791 593 752.50 576Q714 559 675 545Q636 531 596 521.50Q556 512 512 512L512 512L512 384Q581 384 644 404Q707 424 768 448Q829 472 892 492Q955 512 1024 512ZM2048 579L2048 579Q2048 756 2022 939.50Q1996 1123 1945.50 1302.50Q1895 1482 1820 1651.50Q1745 1821 1647 1970L1647 1970Q1623 2006 1586 2027Q1549 2048 1505 2048L1505 2048Q1450 2048 1406 2016.50Q1362 1985 1345 1933L1345 1933L1167 1401Q1132 1405 1096 1406.50Q1060 1408 1024 1408L1024 1408Q988 1408 952 1406.50Q916 1405 881 1401L881 1401L703 1933Q686 1985 642 2016.50Q598 2048 543 2048L543 2048Q499 2048 462 2027Q425 2006 401 1970L401 1970Q303 1821 228 1651.50Q153 1482 102.50 1302.50Q52 1123 26 939.50Q0 756 0 579L0 579Q0 467 34 362.50Q68 258 133 177.50Q198 97 293 48.50Q388 0 510 0L510 0Q581 0 643.50 20Q706 40 767 64Q828 88 890.50 108Q953 128 1024 128L1024 128Q1095 128 1157.50 108Q1220 88 1281 64Q1342 40 1404.50 20Q1467 0 1538 0L1538 0Q1660 0 1755 48.50Q1850 97 1915 177.50Q1980 258 2014 362.50Q2048 467 2048 579ZM1920 581L1920 581Q1920 488 1895 405.50Q1870 323 1819.50 261.50Q1769 200 1694 164Q1619 128 1519 128L1519 128Q1461 128 1407.50 148Q1354 168 1296 192Q1238 216 1172 236Q1106 256 1024 256L1024 256Q941 256 875.50 236Q810 216 752 192Q694 168 637.50 148Q581 128 516 128L516 128Q419 128 346 166Q273 204 224.50 267Q176 330 152 411.50Q128 493 128 581L128 581Q128 679 139.50 792.50Q151 906 173.50 1026Q196 1146 228.50 1267.50Q261 1389 303.50 1503Q346 1617 398 1719Q450 1821 510 1901L510 1901Q525 1920 548 1920L548 1920Q560 1920 579 1883.50Q598 1847 619.50 1790Q641 1733 664 1664Q687 1595 707.50 1530.50Q728 1466 744 1413Q760 1360 768 1336L768 1336Q776 1310 798.50 1290.50Q821 1271 850 1271L850 1271Q894 1271 937 1275.50Q980 1280 1024 1280L1024 1280Q1068 1280 1111 1275.50Q1154 1271 1198 1271L1198 1271Q1227 1271 1249.50 1290.50Q1272 1310 1280 1336L1280 1336Q1288 1360 1304 1413Q1320 1466 1340.50 1530.50Q1361 1595 1384 1664Q1407 1733 1428.50 1790Q1450 1847 1469 1883.50Q1488 1920 1500 1920L1500 1920Q1523 1920 1538 1901L1538 1901Q1598 1821 1650 1719Q1702 1617 1744.50 1503Q1787 1389 1819.50 1267.50Q1852 1146 1874.50 1026.50Q1897 907 1908.50 793Q1920 679 1920 581Z"
         }
      }
   ]
}

var PrimaryCalendar = {
   name: "PrimaryCalendar",
   vendor: "UiFabric",
   unicode: 62638,
   value: "",
   charCode: "F4AE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1696 1537L2031 1537L1765 1734L1867 2047L1600 1854L1334 2048L1435 1734L1169 1537L1504 1537L1601 1227L1696 1537ZM1664 128L2048 128L2048 1377L1920 1377L1920 640L128 640L128 1792L1244 1792L1248 1795L1207 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512Z"
         }
      }
   ]
}

var SearchCalendar = {
   name: "SearchCalendar",
   vendor: "UiFabric",
   unicode: 62639,
   value: "",
   charCode: "F4AF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 896Q1990 839 1920 801L1920 801L1920 640L128 640L128 1792L835 1792Q818 1809 805 1822.50Q792 1836 781.50 1850Q771 1864 762 1880.50Q753 1897 746 1920L746 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935 1008.50Q1987 1061 2017 1131Q2047 1201 2047 1280L2047 1280Q2047 1360 2017 1429.50Q1987 1499 1935 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547.50 1645.50Q1491 1627 1442 1592L1442 1592L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1352 1502Q1317 1453 1298.50 1396.50Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var VideoOff = {
   name: "VideoOff",
   vendor: "UiFabric",
   unicode: 62640,
   value: "",
   charCode: "F4B0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333ZM1536 760L2048 504L2048 1190Q1991 1127 1920 1084L1920 1084L1920 711L1536 904L1536 996Q1503 999 1471 1006Q1439 1013 1408 1024L1408 1024L1408 640L128 640L128 1408L1024 1408Q1013 1439 1006 1471Q999 1503 996 1536L996 1536L0 1536L0 512L1536 512L1536 760Z"
         }
      }
   ]
}

var MicrosoftFlowLogo = {
   name: "MicrosoftFlowLogo",
   vendor: "UiFabric",
   unicode: 62641,
   value: "",
   charCode: "F4B1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M288 256L1760 256Q1820 256 1872.50 278.50Q1925 301 1964 340Q2003 379 2025.50 431.50Q2048 484 2048 544L2048 544L2048 1312Q2048 1372 2025.50 1424.50Q2003 1477 1964 1516Q1925 1555 1872.50 1577.50Q1820 1600 1760 1600L1760 1600L1088 1600L1088 1472L1760 1472Q1793 1472 1822 1459.50Q1851 1447 1873 1425Q1895 1403 1907.50 1374Q1920 1345 1920 1312L1920 1312L1920 544Q1920 511 1907.50 482Q1895 453 1873 431Q1851 409 1822 396.50Q1793 384 1760 384L1760 384L288 384Q255 384 226 396.50Q197 409 175 431Q153 453 140.50 482Q128 511 128 544L128 544L128 1216L0 1216L0 544Q0 484 22.50 431.50Q45 379 84 340Q123 301 175.50 278.50Q228 256 288 256L288 256ZM1554 1152L1134 1152Q1115 1152 1101.50 1138.50Q1088 1125 1088 1106L1088 1106L1088 960L973 960L748 1580Q738 1608 721 1625Q704 1642 683 1651Q662 1660 637.50 1663Q613 1666 588 1666L588 1666Q568 1666 549 1665Q530 1664 512 1664L512 1664L512 1760Q512 1800 484 1828Q456 1856 416 1856L416 1856L96 1856Q56 1856 28 1828Q0 1800 0 1760L0 1760L0 1440Q0 1400 28 1372Q56 1344 96 1344L96 1344L416 1344Q456 1344 484 1372Q512 1400 512 1440L512 1440L512 1536L627 1536L853 916Q863 888 879.50 871Q896 854 917 845Q938 836 962 833Q986 830 1011 830L1011 830Q1031 830 1050 831Q1069 832 1088 832L1088 832L1088 686Q1088 667 1101.50 653.50Q1115 640 1134 640L1134 640L1554 640Q1573 640 1586.50 653.50Q1600 667 1600 686L1600 686L1600 1106Q1600 1125 1586.50 1138.50Q1573 1152 1554 1152L1554 1152ZM384 1728L384 1472L128 1472L128 1728L384 1728Z"
         }
      }
   ]
}

var BusinessCenterLogo = {
   name: "BusinessCenterLogo",
   vendor: "UiFabric",
   unicode: 62642,
   value: "",
   charCode: "F4B2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1342 512L1728 512Q1768 512 1803 527Q1838 542 1864 568Q1890 594 1905 629Q1920 664 1920 704L1920 704L1920 1472Q1920 1512 1905 1547Q1890 1582 1864 1608Q1838 1634 1803 1649Q1768 1664 1728 1664L1728 1664L320 1664Q280 1664 245 1649Q210 1634 184 1608Q158 1582 143 1547Q128 1512 128 1472L128 1472L128 704Q128 664 143 629Q158 594 184 568Q210 542 245 527Q280 512 320 512L320 512L642 512Q648 458 673 411Q698 364 736.50 329.50Q775 295 824 275.50Q873 256 928 256L928 256L1056 256Q1111 256 1160 275.50Q1209 295 1247.50 329.50Q1286 364 1311 411Q1336 458 1342 512L1342 512ZM1056 384L928 384Q900 384 874 393.50Q848 403 827 420Q806 437 791.50 460.50Q777 484 771 512L771 512L1213 512Q1207 484 1192.50 460.50Q1178 437 1157 420Q1136 403 1110 393.50Q1084 384 1056 384L1056 384ZM1408 1536L1408 640L320 640Q294 640 275 659Q256 678 256 704L256 704L256 1472Q256 1498 275 1517Q294 1536 320 1536L320 1536L1408 1536ZM1792 1472L1792 704Q1792 678 1773 659Q1754 640 1728 640L1728 640L1536 640L1536 1536L1728 1536Q1754 1536 1773 1517Q1792 1498 1792 1472L1792 1472Z"
         }
      }
   ]
}

var ToDoLogoBottom = {
   name: "ToDoLogoBottom",
   vendor: "UiFabric",
   unicode: 62643,
   value: "",
   charCode: "F4B3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M452 641L894 1082L541 1435L452 1435L55 1038L452 641Z"
         }
      }
   ]
}

var ToDoLogoTop = {
   name: "ToDoLogoTop",
   vendor: "UiFabric",
   unicode: 62644,
   value: "",
   charCode: "F4B4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1648 240L2048 640L853 1835L453 1435L1648 240Z"
         }
      }
   ]
}

var EditSolid12 = {
   name: "EditSolid12",
   vendor: "UiFabric",
   unicode: 62645,
   value: "",
   charCode: "F4B5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1754 0L1754 0Q1815 0 1868.50 21.50Q1922 43 1962 81.50Q2002 120 2025 172.50Q2048 225 2048 286L2048 286Q2048 333 2038 370Q2028 407 2010 439.50Q1992 472 1966 501.50Q1940 531 1908 562L1908 562L1484 139Q1515 108 1543.50 82Q1572 56 1603 38Q1634 20 1670.50 10Q1707 0 1754 0ZM348 1287L1334 290L1756 712L753 1713L0 2046L348 1287Z"
         }
      }
   ]
}

var EditSolidMirrored12 = {
   name: "EditSolidMirrored12",
   vendor: "UiFabric",
   unicode: 62646,
   value: "",
   charCode: "F4B6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M294 0L294 0Q233 0 179.50 21.50Q126 43 86 81.50Q46 120 23 172.50Q0 225 0 286L0 286Q0 333 10 370Q20 407 38 439.50Q56 472 82 501.50Q108 531 140 562L140 562L564 139Q533 108 504.50 82Q476 56 445 38Q414 20 377.50 10Q341 0 294 0ZM1700 1287L714 290L292 712L1295 1713L2048 2046L1700 1287Z"
         }
      }
   ]
}

var UneditableSolid12 = {
   name: "UneditableSolid12",
   vendor: "UiFabric",
   unicode: 62647,
   value: "",
   charCode: "F4B7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1908 562L1908 562L1484 139Q1515 108 1543.50 82Q1572 56 1603 38Q1634 20 1670.50 10Q1707 0 1754 0L1754 0Q1815 0 1868.50 21.50Q1922 43 1962 81.50Q2002 120 2025 172.50Q2048 225 2048 286L2048 286Q2048 333 2038 370.50Q2028 408 2010 440Q1992 472 1966 501.50Q1940 531 1908 562ZM1334 290L1756 712L1474 994L1054 574L1334 290ZM755 876L25 146L146 25L2023 1902L1902 2023L1173 1294L753 1713L0 2046L348 1287L755 876Z"
         }
      }
   ]
}

var UneditableSolidMirrored12 = {
   name: "UneditableSolidMirrored12",
   vendor: "UiFabric",
   unicode: 62648,
   value: "",
   charCode: "F4B8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M994 574L574 994L292 712L714 290L994 574ZM1700 1287L2048 2046L1295 1713L875 1294L146 2023L25 1902L1902 25L2023 146L1293 876L1700 1287ZM564 139L140 562Q108 531 82 501.50Q56 472 38 439.50Q20 407 10 370Q0 333 0 286L0 286Q0 225 23 172.50Q46 120 86 81.50Q126 43 179.50 21.50Q233 0 294 0L294 0Q341 0 377.50 10Q414 20 445 38Q476 56 504 82Q532 108 564 139L564 139Z"
         }
      }
   ]
}

var UneditableMirrored = {
   name: "UneditableMirrored",
   vendor: "UiFabric",
   unicode: 62649,
   value: "",
   charCode: "F4B9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M576 1152L576 1152Q669 1152 750.50 1187Q832 1222 893 1283Q954 1344 989 1425.50Q1024 1507 1024 1600L1024 1600Q1024 1693 989 1774.50Q954 1856 893 1917Q832 1978 750.50 2013Q669 2048 576 2048L576 2048Q483 2048 401.50 2013Q320 1978 259 1917Q198 1856 163 1774.50Q128 1693 128 1600L128 1600Q128 1507 163 1425.50Q198 1344 259 1283Q320 1222 401.50 1187Q483 1152 576 1152ZM256 1600L256 1600Q256 1666 281 1724.50Q306 1783 349.50 1826.50Q393 1870 451.50 1895Q510 1920 576 1920L576 1920Q623 1920 668 1906.50Q713 1893 752 1867L752 1867L309 1424Q283 1463 269.50 1508Q256 1553 256 1600ZM400 1333L843 1776Q869 1737 882.50 1692Q896 1647 896 1600L896 1600Q896 1534 870.50 1476Q845 1418 801.50 1374.50Q758 1331 700 1305.50Q642 1280 576 1280L576 1280Q529 1280 484 1293.50Q439 1307 400 1333L400 1333ZM1890 1415L2048 2048L1415 1890L1152 1627L1152 1445L1428 1722Q1444 1670 1472.50 1623.50Q1501 1577 1539 1539Q1577 1501 1623 1473Q1669 1445 1722 1428L1722 1428L640 347L347 640L731 1024L549 1024L98 573Q50 525 25 463.50Q0 402 0 336L0 336Q0 266 26.50 205Q53 144 98.50 98.50Q144 53 205 26.50Q266 0 335 0L335 0Q402 0 463.50 25Q525 50 573 98L573 98L1877 1403L1890 1415ZM256 549L549 256Q524 231 502 208Q480 185 455.50 167Q431 149 402 138.50Q373 128 335 128L335 128Q292 128 254.50 144.50Q217 161 189 189Q161 217 144.50 255Q128 293 128 336L128 336Q128 374 138.50 402.50Q149 431 167 455.50Q185 480 208 502Q231 524 256 549L256 549ZM1543 1790L1872 1872L1790 1543Q1743 1553 1702.50 1575.50Q1662 1598 1629.50 1630Q1597 1662 1575 1703Q1553 1744 1543 1790L1543 1790Z"
         }
      }
   ]
}

var AdminALogo32 = {
   name: "AdminALogo32",
   vendor: "UiFabric",
   unicode: 62650,
   value: "",
   charCode: "F4BA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1971 1384L1757 1356Q1743 1375 1729 1393Q1715 1411 1699 1428L1699 1428L1774 1622L1512 1775L1380 1603Q1353 1608 1325.50 1611Q1298 1614 1271 1614L1271 1614Q1243 1614 1216 1611L1216 1611L1216 1997L64 1731L64 317L1216 51L1216 437Q1225 436 1234.50 435.50Q1244 435 1253 435L1253 435L1336 248L1629 325L1601 537Q1621 551 1639.50 565Q1658 579 1675 596L1675 596L1867 522L2019 784L1849 915Q1854 938 1856 961Q1858 984 1859 1007L1859 1007L2048 1091L1971 1384ZM1216 1140L1216 1307Q1230 1309 1243 1310.50Q1256 1312 1270 1312L1270 1312Q1330 1312 1382.50 1289.50Q1435 1267 1474 1228Q1513 1189 1535.50 1136.50Q1558 1084 1558 1024L1558 1024Q1558 964 1535.50 911.50Q1513 859 1474 820Q1435 781 1382.50 758.50Q1330 736 1270 736L1270 736Q1256 736 1243 737.50Q1230 739 1216 741L1216 741L1216 908Q1241 896 1270 896L1270 896Q1297 896 1320 906Q1343 916 1360.50 933.50Q1378 951 1388 974Q1398 997 1398 1024L1398 1024Q1398 1051 1388 1074Q1378 1097 1360.50 1114.50Q1343 1132 1320 1142Q1297 1152 1270 1152L1270 1152Q1241 1152 1216 1140L1216 1140ZM721 1381L888 1391Q833 1202 777 1015.50Q721 829 668 640L668 640L504 650L305 1355L451 1364L489 1217L679 1217L721 1381ZM1695 1594L1625 1412Q1655 1385 1680 1353.50Q1705 1322 1725 1287L1725 1287L1923 1313L1972 1128L1795 1049Q1795 1044 1795.50 1038Q1796 1032 1796 1027L1796 1027Q1796 992 1791 958Q1786 924 1778 888L1778 888L1936 767L1839 601L1659 670Q1602 613 1533 569L1533 569L1558 373L1372 324L1294 499Q1289 498 1283 498Q1277 498 1272 498L1272 498Q1258 498 1245 501L1245 501Q1244 501 1243.50 501.50Q1243 502 1240 502L1240 502L1216 502L1216 676Q1230 674 1243 673Q1256 672 1270 672L1270 672Q1343 672 1407 699.50Q1471 727 1519 775Q1567 823 1594.50 887Q1622 951 1622 1024L1622 1024Q1622 1097 1594.50 1161Q1567 1225 1519 1273Q1471 1321 1407 1348.50Q1343 1376 1270 1376L1270 1376Q1256 1376 1243 1375Q1230 1374 1216 1372L1216 1372L1216 1547Q1229 1549 1241 1549Q1253 1549 1266 1549L1266 1549Q1337 1549 1406 1531L1406 1531L1528 1691L1695 1594ZM582 830L582 830Q582 832 586 848.50Q590 865 596 889.50Q602 914 609.50 943.50Q617 973 624 999.50Q631 1026 636.50 1046.50Q642 1067 644 1074L644 1074L520 1074L578 845Q580 835 582 830Z"
         }
      }
   ]
}

var AdminALogoFill32 = {
   name: "AdminALogoFill32",
   vendor: "UiFabric",
   unicode: 62651,
   value: "",
   charCode: "F4BB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1837 1028L2020 1109L1957 1349L1751 1322Q1734 1348 1714.50 1373Q1695 1398 1672 1420L1672 1420L1744 1608L1530 1733L1403 1567Q1341 1581 1280 1581L1280 1581Q1213 1581 1148.50 1565.50Q1084 1550 1024 1519L1024 1519L1024 1214Q1069 1275 1136.50 1309.50Q1204 1344 1280 1344L1280 1344Q1346 1344 1404.50 1319Q1463 1294 1506.50 1250.50Q1550 1207 1575 1148.50Q1600 1090 1600 1024L1600 1024Q1600 958 1575 899.50Q1550 841 1506.50 797.50Q1463 754 1404.50 729Q1346 704 1280 704L1280 704Q1204 704 1136.50 738.50Q1069 773 1024 834L1024 834L1024 529Q1085 497 1150 482Q1215 467 1284 467L1284 467L1364 286L1604 349L1577 553Q1632 588 1677 633L1677 633L1863 562L1987 776L1824 901Q1830 933 1833.50 964.50Q1837 996 1837 1028L1837 1028ZM479 620L691 607L931 1426L696 1411L654 1244L514 1244L475 1398L264 1385L479 620Z"
         }
      }
   ]
}

var ToDoLogoInverse = {
   name: "ToDoLogoInverse",
   vendor: "UiFabric",
   unicode: 62652,
   value: "",
   charCode: "F4BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 896L384 512L768 896L384 1280L0 896ZM512 1408L1664 256L2048 640L896 1792L512 1408Z"
         }
      }
   ]
}

var Snooze = {
   name: "Snooze",
   vendor: "UiFabric",
   unicode: 62653,
   value: "",
   charCode: "F4BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 896L640 1280L896 1280L896 1408L512 1408L512 896L640 896ZM640 640L640 640Q728 640 810 663Q892 686 963 727.50Q1034 769 1092.50 827.50Q1151 886 1192.50 957Q1234 1028 1257 1110Q1280 1192 1280 1280L1280 1280Q1280 1368 1257 1450Q1234 1532 1192.50 1603Q1151 1674 1092.50 1732.50Q1034 1791 963 1832.50Q892 1874 810 1897Q728 1920 640 1920L640 1920Q552 1920 470 1897Q388 1874 317 1832.50Q246 1791 187.50 1732.50Q129 1674 87.50 1603Q46 1532 23 1450Q0 1368 0 1280L0 1280Q0 1192 23 1110Q46 1028 87.50 957Q129 886 187.50 827.50Q246 769 317 727.50Q388 686 470 663Q552 640 640 640ZM640 1792L640 1792Q746 1792 839 1751.50Q932 1711 1001.50 1641.50Q1071 1572 1111.50 1479Q1152 1386 1152 1280L1152 1280Q1152 1174 1111.50 1081Q1071 988 1001.50 918.50Q932 849 839 808.50Q746 768 640 768L640 768Q534 768 441 808.50Q348 849 278.50 918.50Q209 988 168.50 1081Q128 1174 128 1280L128 1280Q128 1386 168.50 1479Q209 1572 278.50 1641.50Q348 1711 441 1751.50Q534 1792 640 1792ZM1598 334L1361 651L1600 651L1600 768L1152 768L1152 702L1402 373L1177 373L1177 256L1598 256L1598 334ZM1877 425L2048 425L2048 512L1728 512L1728 463L1907 215L1746 215L1746 128L2047 128L2047 187L1877 425Z"
         }
      }
   ]
}

var CortanaLogoReadyOuter = {
   name: "CortanaLogoReadyOuter",
   vendor: "UiFabric",
   unicode: 62665,
   value: "",
   charCode: "F4C9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1536L1024 1536Q1130 1536 1223.50 1496Q1317 1456 1386.50 1386.50Q1456 1317 1496 1223.50Q1536 1130 1536 1024L1536 1024Q1536 918 1496 824.50Q1456 731 1386.50 661.50Q1317 592 1223.50 552Q1130 512 1024 512L1024 512Q918 512 824.50 552Q731 592 661.50 661.50Q592 731 552 824.50Q512 918 512 1024L512 1024Q512 1130 552 1223.50Q592 1317 661.50 1386.50Q731 1456 824.50 1496Q918 1536 1024 1536Z"
         }
      }
   ]
}

var CortanaLogoReadyInner = {
   name: "CortanaLogoReadyInner",
   vendor: "UiFabric",
   unicode: 62664,
   value: "",
   charCode: "F4C8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 384L1024 384Q1112 384 1194 407Q1276 430 1347 471.50Q1418 513 1476.50 571.50Q1535 630 1576.50 701Q1618 772 1641 854Q1664 936 1664 1024L1664 1024Q1664 1112 1641 1194Q1618 1276 1576.50 1347Q1535 1418 1476.50 1476.50Q1418 1535 1347 1576.50Q1276 1618 1194 1641Q1112 1664 1024 1664L1024 1664Q936 1664 854 1641Q772 1618 701 1576.50Q630 1535 571.50 1476.50Q513 1418 471.50 1347Q430 1276 407 1194Q384 1112 384 1024L384 1024Q384 936 407 854Q430 772 471.50 701Q513 630 571.50 571.50Q630 513 701 471.50Q772 430 854 407Q936 384 1024 384Z"
         }
      }
   ]
}

var CortanaLogoBeckonOuter = {
   name: "CortanaLogoBeckonOuter",
   vendor: "UiFabric",
   unicode: 62663,
   value: "",
   charCode: "F4C7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1664L1024 1664Q1112 1664 1194 1641Q1276 1618 1347 1576.50Q1418 1535 1476.50 1476.50Q1535 1418 1576.50 1347Q1618 1276 1641 1194Q1664 1112 1664 1024L1664 1024Q1664 936 1641 854Q1618 772 1576.50 701Q1535 630 1476.50 571.50Q1418 513 1347 471.50Q1276 430 1194 407Q1112 384 1024 384L1024 384Q936 384 854 407Q772 430 701 471.50Q630 513 571.50 571.50Q513 630 471.50 701Q430 772 407 854Q384 936 384 1024L384 1024Q384 1112 407 1194Q430 1276 471.50 1347Q513 1418 571.50 1476.50Q630 1535 701 1576.50Q772 1618 854 1641Q936 1664 1024 1664Z"
         }
      }
   ]
}

var CortanaLogoBeckonInner = {
   name: "CortanaLogoBeckonInner",
   vendor: "UiFabric",
   unicode: 62662,
   value: "",
   charCode: "F4C6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 299L1024 299Q1124 299 1217 325Q1310 351 1390.50 398Q1471 445 1537 511Q1603 577 1650 657.50Q1697 738 1723 831Q1749 924 1749 1024L1749 1024Q1749 1124 1723 1217Q1697 1310 1650 1390.50Q1603 1471 1537 1537Q1471 1603 1390.50 1650Q1310 1697 1217 1723Q1124 1749 1024 1749L1024 1749Q924 1749 831 1723Q738 1697 657.50 1650Q577 1603 511 1537Q445 1471 398 1390.50Q351 1310 325 1217Q299 1124 299 1024L299 1024Q299 924 325 831Q351 738 398 657.50Q445 577 511 511Q577 445 657.50 398Q738 351 831 325Q924 299 1024 299Z"
         }
      }
   ]
}

var WaffleOffice365 = {
   name: "WaffleOffice365",
   vendor: "UiFabric",
   unicode: 62688,
   value: "",
   charCode: "F4E0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M192 0L192 0Q232 0 267 15Q302 30 328 56Q354 82 369 117Q384 152 384 192L384 192Q384 232 369 267Q354 302 328 328Q302 354 267 369Q232 384 192 384L192 384Q152 384 117 369Q82 354 56 328Q30 302 15 267Q0 232 0 192L0 192Q0 152 15 117Q30 82 56 56Q82 30 117 15Q152 0 192 0ZM960 0L960 0Q1000 0 1035 15Q1070 30 1096 56Q1122 82 1137 117Q1152 152 1152 192L1152 192Q1152 232 1137 267Q1122 302 1096 328Q1070 354 1035 369Q1000 384 960 384L960 384Q920 384 885 369Q850 354 824 328Q798 302 783 267Q768 232 768 192L768 192Q768 152 783 117Q798 82 824 56Q850 30 885 15Q920 0 960 0ZM1728 384L1728 384Q1688 384 1653 369Q1618 354 1592 328Q1566 302 1551 267Q1536 232 1536 192L1536 192Q1536 152 1551 117Q1566 82 1592 56Q1618 30 1653 15Q1688 0 1728 0L1728 0Q1768 0 1803 15Q1838 30 1864 56Q1890 82 1905 117Q1920 152 1920 192L1920 192Q1920 232 1905 267Q1890 302 1864 328Q1838 354 1803 369Q1768 384 1728 384ZM192 768L192 768Q232 768 267 783Q302 798 328 824Q354 850 369 885Q384 920 384 960L384 960Q384 1000 369 1035Q354 1070 328 1096Q302 1122 267 1137Q232 1152 192 1152L192 1152Q152 1152 117 1137Q82 1122 56 1096Q30 1070 15 1035Q0 1000 0 960L0 960Q0 920 15 885Q30 850 56 824Q82 798 117 783Q152 768 192 768ZM960 768L960 768Q1000 768 1035 783Q1070 798 1096 824Q1122 850 1137 885Q1152 920 1152 960L1152 960Q1152 1000 1137 1035Q1122 1070 1096 1096Q1070 1122 1035 1137Q1000 1152 960 1152L960 1152Q920 1152 885 1137Q850 1122 824 1096Q798 1070 783 1035Q768 1000 768 960L768 960Q768 920 783 885Q798 850 824 824Q850 798 885 783Q920 768 960 768ZM1728 768L1728 768Q1768 768 1803 783Q1838 798 1864 824Q1890 850 1905 885Q1920 920 1920 960L1920 960Q1920 1000 1905 1035Q1890 1070 1864 1096Q1838 1122 1803 1137Q1768 1152 1728 1152L1728 1152Q1688 1152 1653 1137Q1618 1122 1592 1096Q1566 1070 1551 1035Q1536 1000 1536 960L1536 960Q1536 920 1551 885Q1566 850 1592 824Q1618 798 1653 783Q1688 768 1728 768ZM192 1536L192 1536Q232 1536 267 1551Q302 1566 328 1592Q354 1618 369 1653Q384 1688 384 1728L384 1728Q384 1768 369 1803Q354 1838 328 1864Q302 1890 267 1905Q232 1920 192 1920L192 1920Q152 1920 117 1905Q82 1890 56 1864Q30 1838 15 1803Q0 1768 0 1728L0 1728Q0 1688 15 1653Q30 1618 56 1592Q82 1566 117 1551Q152 1536 192 1536ZM960 1536L960 1536Q1000 1536 1035 1551Q1070 1566 1096 1592Q1122 1618 1137 1653Q1152 1688 1152 1728L1152 1728Q1152 1768 1137 1803Q1122 1838 1096 1864Q1070 1890 1035 1905Q1000 1920 960 1920L960 1920Q920 1920 885 1905Q850 1890 824 1864Q798 1838 783 1803Q768 1768 768 1728L768 1728Q768 1688 783 1653Q798 1618 824 1592Q850 1566 885 1551Q920 1536 960 1536ZM1728 1536L1728 1536Q1768 1536 1803 1551Q1838 1566 1864 1592Q1890 1618 1905 1653Q1920 1688 1920 1728L1920 1728Q1920 1768 1905 1803Q1890 1838 1864 1864Q1838 1890 1803 1905Q1768 1920 1728 1920L1728 1920Q1688 1920 1653 1905Q1618 1890 1592 1864Q1566 1838 1551 1803Q1536 1768 1536 1728L1536 1728Q1536 1688 1551 1653Q1566 1618 1592 1592Q1618 1566 1653 1551Q1688 1536 1728 1536Z"
         }
      }
   ]
}

var ImageSearch = {
   name: "ImageSearch",
   vendor: "UiFabric",
   unicode: 62696,
   value: "",
   charCode: "F4E8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 576L1664 576Q1664 602 1645 621Q1626 640 1600 640L1600 640Q1574 640 1555 621Q1536 602 1536 576L1536 576Q1536 550 1555 531Q1574 512 1600 512L1600 512Q1626 512 1645 531Q1664 550 1664 576ZM0 256L2048 256L2048 895Q2020 867 1987.50 844.50Q1955 822 1920 803L1920 803L1920 384L128 384L128 1061L576 614L1132 1169Q1120 1223 1120 1280L1120 1280Q1120 1296 1122 1312Q1124 1328 1126 1344L1126 1344L576 794L128 1243L128 1664L963 1664L835 1792L0 1792L0 256ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547.50 1645.50Q1491 1627 1442 1592L1442 1592L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1352 1502Q1317 1453 1298.50 1396.50Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var NewsSearch = {
   name: "NewsSearch",
   vendor: "UiFabric",
   unicode: 62697,
   value: "",
   charCode: "F4E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 768L1487 768Q1428 788 1375.50 820Q1323 852 1279 896L1279 896L1024 896L1024 768ZM1024 1280L1120 1280Q1120 1312 1124.50 1344Q1129 1376 1137 1408L1137 1408L1024 1408L1024 1280ZM1792 512L2048 512L2048 895Q2020 867 1987.50 844.50Q1955 822 1920 803L1920 803L1920 640L1792 640L1792 753Q1760 745 1728 740.50Q1696 736 1664 736L1664 736L1664 384L128 384L128 1415Q128 1440 137.50 1462Q147 1484 163.50 1500.50Q180 1517 202 1526.50Q224 1536 249 1536L249 1536L1091 1536L963 1664L249 1664Q198 1664 152.50 1644.50Q107 1625 73 1591Q39 1557 19.50 1511.50Q0 1466 0 1415L0 1415L0 256L1792 256L1792 512ZM1536 512L1536 640L256 640L256 512L1536 512ZM256 1408L256 768L896 768L896 1408L256 1408ZM384 896L384 1280L768 1280L768 896L384 896ZM1024 1152L1024 1024L1152 1024L1152 1103Q1143 1128 1137 1152L1137 1152L1024 1152ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547.50 1645.50Q1491 1627 1442 1592L1442 1592L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1352 1502Q1317 1453 1298.50 1396.50Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var VideoSearch = {
   name: "VideoSearch",
   vendor: "UiFabric",
   unicode: 62698,
   value: "",
   charCode: "F4EA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 895Q2020 867 1987.50 844.50Q1955 822 1920 803L1920 803L1920 384L1792 384L1792 512L1664 512L1664 384L384 384L384 512L256 512L256 384L128 384L128 1536L256 1536L256 1408L384 1408L384 1536L1091 1536L963 1664L0 1664L0 256ZM1664 640L1792 640L1792 753Q1760 745 1728 740.50Q1696 736 1664 736L1664 736L1664 640ZM384 896L384 1024L256 1024L256 896L384 896ZM384 640L384 768L256 768L256 640L384 640ZM256 1280L256 1152L384 1152L384 1280L256 1280ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547.50 1645.50Q1491 1627 1442 1592L1442 1592L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1352 1502Q1317 1453 1298.50 1396.50Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var R = {
   name: "R",
   vendor: "UiFabric",
   unicode: 62699,
   value: "",
   charCode: "F4EB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1023 1352L1023 1664L896 1664L896 896L1149 896Q1198 896 1243.50 908Q1289 920 1323.50 945Q1358 970 1378.50 1009Q1399 1048 1399 1103L1399 1103Q1399 1186 1353 1239Q1307 1292 1229 1315L1229 1315Q1268 1337 1299 1373.50Q1330 1410 1353 1448L1353 1448L1489 1664L1341 1664L1218 1458Q1205 1436 1191 1417Q1177 1398 1160.50 1383.50Q1144 1369 1123 1360.50Q1102 1352 1074 1352L1074 1352L1023 1352ZM1023 999L1023 1249L1129 1249Q1189 1249 1227 1213.50Q1265 1178 1265 1117L1265 1117Q1265 1055 1226 1027Q1187 999 1130 999L1130 999L1023 999ZM128 128L1920 128L1920 1920L128 1920L128 128ZM1792 1792L1792 256L256 256L256 1792L1792 1792Z"
         }
      }
   ]
}

var FontColorA = {
   name: "FontColorA",
   vendor: "UiFabric",
   unicode: 62700,
   value: "",
   charCode: "F4EC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1027 0L1582 1664L1447 1664L1277 1152L643 1152L473 1664L338 1664L893 0L1027 0ZM686 1024L1234 1024L960 203L686 1024Z"
         }
      }
   ]
}

var FontColorSwatch = {
   name: "FontColorSwatch",
   vendor: "UiFabric",
   unicode: 62701,
   value: "",
   charCode: "F4ED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1792L1664 1792L1664 2048L256 2048L256 1792Z"
         }
      }
   ]
}

var LightWeight = {
   name: "LightWeight",
   vendor: "UiFabric",
   unicode: 62702,
   value: "",
   charCode: "F4EE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1457 1317L1457 1317Q1457 1428 1419.50 1516Q1382 1604 1316 1665.50Q1250 1727 1159 1759.50Q1068 1792 960 1792L960 1792L512 1792L512 128L950 128Q1039 128 1117 152.50Q1195 177 1253 225.50Q1311 274 1344.50 346Q1378 418 1378 512L1378 512Q1378 584 1358.50 648Q1339 712 1301.50 764Q1264 816 1209.50 854.50Q1155 893 1086 915L1086 915L1086 919Q1170 928 1238 959Q1306 990 1355 1041Q1404 1092 1430.50 1161.50Q1457 1231 1457 1317ZM904 234L627 234L627 878L859 878Q940 878 1012.50 857Q1085 836 1139.50 793.50Q1194 751 1226.50 686Q1259 621 1259 533L1259 533Q1259 449 1232.50 391.50Q1206 334 1158.50 299Q1111 264 1046 249Q981 234 904 234L904 234ZM1340 1326L1340 1326Q1340 1222 1300 1155Q1260 1088 1194.50 1049.50Q1129 1011 1044.50 996.50Q960 982 872 982L872 982L627 982L627 1688L936 1688Q1024 1688 1098.50 1667Q1173 1646 1226.50 1601.50Q1280 1557 1310 1489Q1340 1421 1340 1326Z"
         }
      }
   ]
}

var NormalWeight = {
   name: "NormalWeight",
   vendor: "UiFabric",
   unicode: 62703,
   value: "",
   charCode: "F4EF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1313L1536 1313Q1536 1428 1492 1517Q1448 1606 1373.50 1666.50Q1299 1727 1201 1758.50Q1103 1790 996 1790L996 1790L512 1790L512 128L985 128Q1073 128 1157.50 150Q1242 172 1307.50 218.50Q1373 265 1413 336.50Q1453 408 1453 508L1453 508Q1453 577 1433.50 640Q1414 703 1376.50 754.50Q1339 806 1285.50 844Q1232 882 1165 902L1165 902L1165 907Q1249 916 1317.50 948.50Q1386 981 1434.50 1033.50Q1483 1086 1509.50 1157Q1536 1228 1536 1313ZM931 304L707 304L707 840L905 840Q977 840 1039.50 823.50Q1102 807 1148.50 772Q1195 737 1221.50 681Q1248 625 1248 547L1248 547Q1248 475 1222 428Q1196 381 1152 353.50Q1108 326 1051 315Q994 304 931 304L931 304ZM1332 1310L1332 1310Q1332 1220 1297.50 1163Q1263 1106 1206.50 1073.50Q1150 1041 1077.50 1029Q1005 1017 929 1017L929 1017L707 1017L707 1614L970 1614Q1043 1614 1108.50 1596.50Q1174 1579 1223.50 1542.50Q1273 1506 1302.50 1448.50Q1332 1391 1332 1310Z"
         }
      }
   ]
}

var SemiboldWeight = {
   name: "SemiboldWeight",
   vendor: "UiFabric",
   unicode: 62704,
   value: "",
   charCode: "F4F0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1639 1314L1639 1314Q1639 1396 1615 1463Q1591 1530 1549.50 1583Q1508 1636 1451.50 1675.50Q1395 1715 1329 1741Q1263 1767 1190.50 1779.50Q1118 1792 1046 1792L1046 1792L512 1792L512 128L1040 128Q1099 128 1160.50 136.50Q1222 145 1280.50 164Q1339 183 1390 212.50Q1441 242 1479.50 284Q1518 326 1540.50 382Q1563 438 1563 508L1563 508Q1563 581 1542 644Q1521 707 1481.50 757.50Q1442 808 1386.50 845Q1331 882 1262 903L1262 903L1262 908Q1347 918 1416.50 950Q1486 982 1535.50 1034Q1585 1086 1612 1156.50Q1639 1227 1639 1314ZM988 350L787 350L787 823L966 823Q1029 823 1085 808.50Q1141 794 1183 762.50Q1225 731 1249 682Q1273 633 1273 563L1273 563Q1273 499 1249 457.50Q1225 416 1185 392Q1145 368 1094 359Q1043 350 988 350L988 350ZM1345 1303L1345 1303Q1345 1224 1314 1173.50Q1283 1123 1232.50 1094.50Q1182 1066 1117.50 1055.50Q1053 1045 987 1045L987 1045L787 1045L787 1572L1023 1572Q1088 1572 1146.50 1557Q1205 1542 1249 1510Q1293 1478 1319 1426.50Q1345 1375 1345 1303Z"
         }
      }
   ]
}

var GroupObject = {
   name: "GroupObject",
   vendor: "UiFabric",
   unicode: 62705,
   value: "",
   charCode: "F4F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L256 256L0 256L0 0L256 0ZM1792 0L2048 0L2048 256L1792 256L1792 0ZM0 2048L0 1792L256 1792L256 2048L0 2048ZM1792 2048L1792 1792L2048 1792L2048 2048L1792 2048ZM768 1408L768 1792L1664 1792L1664 1920L640 1920L640 1408L128 1408L128 384L256 384L256 1280L640 1280L640 640L1280 640L1280 256L384 256L384 128L1408 128L1408 640L1920 640L1920 1664L1792 1664L1792 768L1408 768L1408 1408L768 1408ZM768 768L768 1280L1280 1280L1280 768L768 768Z"
         }
      }
   ]
}

var UngroupObject = {
   name: "UngroupObject",
   vendor: "UiFabric",
   unicode: 62706,
   value: "",
   charCode: "F4F2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 896L1920 896L1920 1792L2048 1792L2048 2048L1792 2048L1792 1920L896 1920L896 2048L640 2048L640 1792L768 1792L768 1280L256 1280L256 1408L0 1408L0 1152L128 1152L128 256L0 256L0 0L256 0L256 128L1152 128L1152 0L1408 0L1408 256L1280 256L1280 768L1792 768L1792 640L2048 640L2048 896ZM256 1152L768 1152L768 896L640 896L640 640L896 640L896 768L1152 768L1152 256L256 256L256 1152ZM1152 896L896 896L896 1152L1152 1152L1152 896ZM1792 1792L1792 896L1280 896L1280 1152L1408 1152L1408 1408L1152 1408L1152 1280L896 1280L896 1792L1792 1792Z"
         }
      }
   ]
}

var AlignHorizontalLeft = {
   name: "AlignHorizontalLeft",
   vendor: "UiFabric",
   unicode: 62707,
   value: "",
   charCode: "F4F3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 0L128 0L128 2048L0 2048ZM1408 384L1408 896L256 896L256 384L1408 384ZM1280 768L1280 512L384 512L384 768L1280 768ZM256 1152L1920 1152L1920 1664L256 1664L256 1152ZM1792 1536L1792 1280L384 1280L384 1536L1792 1536Z"
         }
      }
   ]
}

var AlignHorizontalCenter = {
   name: "AlignHorizontalCenter",
   vendor: "UiFabric",
   unicode: 62708,
   value: "",
   charCode: "F4F4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1152L1792 1664L1024 1664L1024 2048L896 2048L896 1664L128 1664L128 1152L896 1152L896 896L384 896L384 384L896 384L896 0L1024 0L1024 384L1536 384L1536 896L1024 896L1024 1152L1792 1152ZM512 512L512 768L1408 768L1408 512L512 512ZM1664 1536L1664 1280L256 1280L256 1536L1664 1536Z"
         }
      }
   ]
}

var AlignHorizontalRight = {
   name: "AlignHorizontalRight",
   vendor: "UiFabric",
   unicode: 62709,
   value: "",
   charCode: "F4F5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 0L1920 0L1920 2048L1792 2048L1792 0ZM512 896L512 384L1664 384L1664 896L512 896ZM640 512L640 768L1536 768L1536 512L640 512ZM0 1664L0 1152L1664 1152L1664 1664L0 1664ZM128 1280L128 1536L1536 1536L1536 1280L128 1280Z"
         }
      }
   ]
}

var AlignVerticalTop = {
   name: "AlignVerticalTop",
   vendor: "UiFabric",
   unicode: 62710,
   value: "",
   charCode: "F4F6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 128L0 128L0 0ZM1152 1408L1152 256L1664 256L1664 1408L1152 1408ZM1280 384L1280 1280L1536 1280L1536 384L1280 384ZM384 1920L384 256L896 256L896 1920L384 1920ZM512 384L512 1792L768 1792L768 384L512 384Z"
         }
      }
   ]
}

var AlignVerticalCenter = {
   name: "AlignVerticalCenter",
   vendor: "UiFabric",
   unicode: 62711,
   value: "",
   charCode: "F4F7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 896L2048 1024L1664 1024L1664 1536L1152 1536L1152 1024L896 1024L896 1792L384 1792L384 1024L0 1024L0 896L384 896L384 128L896 128L896 896L1152 896L1152 384L1664 384L1664 896L2048 896ZM768 1664L768 256L512 256L512 1664L768 1664ZM1536 1408L1536 512L1280 512L1280 1408L1536 1408Z"
         }
      }
   ]
}

var AlignVerticalBottom = {
   name: "AlignVerticalBottom",
   vendor: "UiFabric",
   unicode: 62712,
   value: "",
   charCode: "F4F8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L2048 1792L2048 1920L0 1920L0 1792ZM1664 512L1664 1664L1152 1664L1152 512L1664 512ZM1536 1536L1536 640L1280 640L1280 1536L1536 1536ZM896 0L896 1664L384 1664L384 0L896 0ZM768 1536L768 128L512 128L512 1536L768 1536Z"
         }
      }
   ]
}

var HorizontalDistributeCenter = {
   name: "HorizontalDistributeCenter",
   vendor: "UiFabric",
   unicode: 62713,
   value: "",
   charCode: "F4F9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 0L640 256L896 256L896 1792L640 1792L640 2048L512 2048L512 1792L256 1792L256 256L512 256L512 0L640 0ZM768 1664L768 384L384 384L384 1664L768 1664ZM1792 512L1792 1536L1536 1536L1536 2048L1408 2048L1408 1536L1152 1536L1152 512L1408 512L1408 0L1536 0L1536 512L1792 512ZM1664 1408L1664 640L1280 640L1280 1408L1664 1408Z"
         }
      }
   ]
}

var VerticalDistributeCenter = {
   name: "VerticalDistributeCenter",
   vendor: "UiFabric",
   unicode: 62714,
   value: "",
   charCode: "F4FA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L2048 512L2048 640L1536 640L1536 896L512 896L512 640L0 640L0 512L512 512L512 256L1536 256L1536 512ZM1408 768L1408 384L640 384L640 768L1408 768ZM1792 1152L1792 1408L2048 1408L2048 1536L1792 1536L1792 1792L256 1792L256 1536L0 1536L0 1408L256 1408L256 1152L1792 1152ZM1664 1664L1664 1280L384 1280L384 1664L1664 1664Z"
         }
      }
   ]
}

var Ellipse = {
   name: "Ellipse",
   vendor: "UiFabric",
   unicode: 62715,
   value: "",
   charCode: "F4FB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 256L1024 256Q1155 256 1292.50 283.50Q1430 311 1556.50 368Q1683 425 1789.50 512Q1896 599 1964 718L1964 718Q2005 789 2026.50 865.50Q2048 942 2048 1024L2048 1024Q2048 1106 2026.50 1182.50Q2005 1259 1964 1330L1964 1330Q1896 1449 1789.50 1536Q1683 1623 1556.50 1680Q1430 1737 1292.50 1764.50Q1155 1792 1024 1792L1024 1792Q893 1792 755.50 1764.50Q618 1737 491.50 1680Q365 1623 258.50 1536Q152 1449 84 1330L84 1330Q43 1259 21.50 1182.50Q0 1106 0 1024L0 1024Q0 942 21.50 865.50Q43 789 84 718L84 718Q152 599 258.50 512Q365 425 491.50 368Q618 311 755.50 283.50Q893 256 1024 256ZM1024 1664L1024 1664Q1108 1664 1193 1652.50Q1278 1641 1360 1617Q1442 1593 1519.50 1556.50Q1597 1520 1665 1470L1665 1470Q1719 1430 1766 1381.50Q1813 1333 1847 1276.50Q1881 1220 1900.50 1157Q1920 1094 1920 1024L1920 1024Q1920 954 1900.50 891Q1881 828 1847 771.50Q1813 715 1766 666.50Q1719 618 1665 578L1665 578Q1597 528 1519.50 491.50Q1442 455 1360 431Q1278 407 1193 395.50Q1108 384 1024 384L1024 384Q940 384 855 395.50Q770 407 688 431Q606 455 528.50 491.50Q451 528 383 578L383 578Q329 618 282 666.50Q235 715 201 771.50Q167 828 147.50 891Q128 954 128 1024L128 1024Q128 1094 147.50 1157Q167 1220 201 1276.50Q235 1333 282 1381.50Q329 1430 383 1470L383 1470Q451 1520 528.50 1556.50Q606 1593 688 1617Q770 1641 855 1652.50Q940 1664 1024 1664Z"
         }
      }
   ]
}

var Line = {
   name: "Line",
   vendor: "UiFabric",
   unicode: 62716,
   value: "",
   charCode: "F4FC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M109 19L2029 1939L1939 2029L19 109L109 19Z"
         }
      }
   ]
}

var Octagon = {
   name: "Octagon",
   vendor: "UiFabric",
   unicode: 62717,
   value: "",
   charCode: "F4FD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1358 0L1920 562L1920 1358L1358 1920L562 1920L0 1358L0 562L562 0L1358 0ZM1792 1305L1792 615L1305 128L615 128L128 615L128 1305L615 1792L1305 1792L1792 1305Z"
         }
      }
   ]
}

var Hexagon = {
   name: "Hexagon",
   vendor: "UiFabric",
   unicode: 62718,
   value: "",
   charCode: "F4FE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1527 0L2024 960L1527 1920L521 1920L24 960L521 0L1527 0ZM1449 1792L1880 960L1449 128L599 128L168 960L599 1792L1449 1792Z"
         }
      }
   ]
}

var Pentagon = {
   name: "Pentagon",
   vendor: "UiFabric",
   unicode: 62719,
   value: "",
   charCode: "F4FF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 18L2042 723L1653 1920L395 1920L6 723L1024 18ZM1560 1792L1891 774L1024 174L157 774L488 1792L1560 1792Z"
         }
      }
   ]
}

var RightTriangle = {
   name: "RightTriangle",
   vendor: "UiFabric",
   unicode: 62720,
   value: "",
   charCode: "F500",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 37L2011 1920L128 1920L128 37ZM256 347L256 1792L1701 1792L256 347Z"
         }
      }
   ]
}

var HalfCircle = {
   name: "HalfCircle",
   vendor: "UiFabric",
   unicode: 62721,
   value: "",
   charCode: "F501",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 0L1536 0L1536 1920Q1477 1920 1422 1917Q1367 1914 1313 1906Q1259 1898 1205.50 1883Q1152 1868 1098 1845L1098 1845Q964 1788 856 1697.50Q748 1607 671.50 1491.50Q595 1376 553.50 1240.50Q512 1105 512 960L512 960Q512 827 546 704.50Q580 582 642.50 475Q705 368 792.50 280.50Q880 193 987 130.50Q1094 68 1216.50 34Q1339 0 1472 0L1472 0ZM1408 1790L1408 130Q1300 138 1201 172.50Q1102 207 1017 263Q932 319 862 394.50Q792 470 743 559.50Q694 649 667 750.50Q640 852 640 960L640 960Q640 1068 667 1169.50Q694 1271 743 1360.50Q792 1450 862 1525.50Q932 1601 1017 1657Q1102 1713 1201 1747.50Q1300 1782 1408 1790L1408 1790Z"
         }
      }
   ]
}

var QuarterCircle = {
   name: "QuarterCircle",
   vendor: "UiFabric",
   unicode: 62722,
   value: "",
   charCode: "F502",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1856 128L1920 128L1920 1920L128 1920Q128 1821 134.50 1728Q141 1635 157 1544.50Q173 1454 199 1364.50Q225 1275 264 1183L264 1183Q332 1023 428 882.50Q524 742 643 625Q762 508 901.50 415.50Q1041 323 1195 259Q1349 195 1515.50 161.50Q1682 128 1856 128L1856 128ZM1792 1792L1792 257Q1584 265 1392 324.50Q1200 384 1032 485Q864 586 725 725Q586 864 485 1032Q384 1200 324.50 1392Q265 1584 257 1792L257 1792L1792 1792Z"
         }
      }
   ]
}

var ThreeQuarterCircle = {
   name: "ThreeQuarterCircle",
   vendor: "UiFabric",
   unicode: 62723,
   value: "",
   charCode: "F503",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 896L1920 896Q1920 955 1917 1010Q1914 1065 1905.50 1119Q1897 1173 1882.50 1226.50Q1868 1280 1845 1334L1845 1334Q1788 1468 1697 1576Q1606 1684 1490.50 1760.50Q1375 1837 1240 1878.50Q1105 1920 960 1920L960 1920Q827 1920 704.50 1886Q582 1852 475 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445Q68 1338 34 1215.50Q0 1093 0 960L0 960Q0 827 34 704.50Q68 582 130.50 475Q193 368 280.50 280.50Q368 193 475 130.50Q582 68 704.50 34Q827 0 960 0L960 0L1024 0L1024 896ZM960 1792L960 1792Q1068 1792 1169.50 1765Q1271 1738 1360.50 1689Q1450 1640 1525.50 1570Q1601 1500 1657 1415Q1713 1330 1747.50 1231Q1782 1132 1790 1024L1790 1024L896 1024L896 130Q788 138 689 172.50Q590 207 505 263Q420 319 350 394.50Q280 470 231 559.50Q182 649 155 750.50Q128 852 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792Z"
         }
      }
   ]
}

var PointStar6 = {
   name: "PointStar6",
   vendor: "UiFabric",
   unicode: 62724,
   value: "",
   charCode: "F504",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1955 512L1648 1024L1955 1536L1340 1536L1024 2050L708 1536L93 1536L399 1025L76 512L708 512L1024-2L1340 512L1955 512ZM1729 1408L1499 1024L1729 640L1269 640L1024 242L779 640L308 640L550 1023L319 1408L779 1408L1024 1806L1269 1408L1729 1408Z"
         }
      }
   ]
}

var PointStar12 = {
   name: "PointStar12",
   vendor: "UiFabric",
   unicode: 62725,
   value: "",
   charCode: "F505",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2031 1024L1754 1220L1896 1528L1558 1558L1528 1896L1220 1754L1024 2031L828 1754L520 1896L490 1558L152 1528L294 1220L17 1024L294 828L152 520L490 490L520 152L828 294L1024 17L1220 294L1528 152L1558 490L1896 520L1754 828L2031 1024ZM1440 1440L1704 1416L1593 1176L1809 1024L1593 872L1704 632L1440 608L1416 344L1176 455L1024 239L872 455L632 344L608 608L344 632L455 872L239 1024L455 1176L344 1416L608 1440L632 1704L872 1593L1024 1809L1176 1593L1416 1704L1440 1440Z"
         }
      }
   ]
}

var ArrangeBringToFront = {
   name: "ArrangeBringToFront",
   vendor: "UiFabric",
   unicode: 62726,
   value: "",
   charCode: "F506",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 384L1664 1664L384 1664L384 384L1664 384ZM1536 1536L1536 512L512 512L512 1536L1536 1536ZM128 128L128 768L256 768L256 896L0 896L0 0L896 0L896 256L768 256L768 128L128 128ZM1792 1152L2048 1152L2048 2048L1152 2048L1152 1792L1280 1792L1280 1920L1920 1920L1920 1280L1792 1280L1792 1152Z"
         }
      }
   ]
}

var ArrangeSendToBack = {
   name: "ArrangeSendToBack",
   vendor: "UiFabric",
   unicode: 62727,
   value: "",
   charCode: "F507",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 1024L512 1536L1024 1536L1024 1664L384 1664L384 1024L512 1024ZM1536 1024L1536 512L1024 512L1024 384L1664 384L1664 1024L1536 1024ZM896 0L896 896L0 896L0 0L896 0ZM768 768L768 128L128 128L128 768L768 768ZM1152 1152L2048 1152L2048 2048L1152 2048L1152 1152ZM1920 1920L1920 1280L1280 1280L1280 1920L1920 1920Z"
         }
      }
   ]
}

var ArrangeSendBackward = {
   name: "ArrangeSendBackward",
   vendor: "UiFabric",
   unicode: 62728,
   value: "",
   charCode: "F508",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L128 1536L640 1536L640 1664L0 1664L0 0L1664 0L1664 640L1536 640L1536 128L128 128ZM768 768L2048 768L2048 2048L768 2048L768 768ZM1920 1920L1920 896L896 896L896 1920L1920 1920Z"
         }
      }
   ]
}

var ArrangeBringForward = {
   name: "ArrangeBringForward",
   vendor: "UiFabric",
   unicode: 62729,
   value: "",
   charCode: "F509",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 1664L0 1664L0 0L1664 0ZM1536 1536L1536 128L128 128L128 1536L1536 1536ZM1792 768L2048 768L2048 2048L768 2048L768 1792L896 1792L896 1920L1920 1920L1920 896L1792 896L1792 768Z"
         }
      }
   ]
}

var BorderDash = {
   name: "BorderDash",
   vendor: "UiFabric",
   unicode: 62730,
   value: "",
   charCode: "F50A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L256 128L0 128L0 0L256 0ZM640 0L640 128L384 128L384 0L640 0ZM1024 0L1024 128L768 128L768 0L1024 0ZM1408 0L1408 128L1152 128L1152 0L1408 0ZM1792 0L1792 128L1536 128L1536 0L1792 0ZM0 512L0 256L128 256L128 512L0 512ZM0 896L0 640L128 640L128 896L0 896ZM0 1280L0 1024L128 1024L128 1280L0 1280ZM0 1664L0 1408L128 1408L128 1664L0 1664ZM0 2048L0 1792L128 1792L128 2048L0 2048ZM1792 2048L1792 1920L2048 1920L2048 2048L1792 2048ZM1408 2048L1408 1920L1664 1920L1664 2048L1408 2048ZM1024 2048L1024 1920L1280 1920L1280 2048L1024 2048ZM640 2048L640 1920L896 1920L896 2048L640 2048ZM256 2048L256 1920L512 1920L512 2048L256 2048ZM1920 1792L1920 1536L2048 1536L2048 1792L1920 1792ZM1920 1408L1920 1152L2048 1152L2048 1408L1920 1408ZM1920 1024L1920 768L2048 768L2048 1024L1920 1024ZM1920 640L1920 384L2048 384L2048 640L1920 640ZM1920 0L2048 0L2048 256L1920 256L1920 0Z"
         }
      }
   ]
}

var BorderDot = {
   name: "BorderDot",
   vendor: "UiFabric",
   unicode: 62731,
   value: "",
   charCode: "F50B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L0 0L128 0L128 128L0 128ZM384 128L384 0L512 0L512 128L384 128ZM768 128L768 0L896 0L896 128L768 128ZM1152 128L1152 0L1280 0L1280 128L1152 128ZM1536 128L1536 0L1664 0L1664 128L1536 128ZM1920 0L2048 0L2048 128L1920 128L1920 0ZM0 2048L0 1920L128 1920L128 2048L0 2048ZM384 2048L384 1920L512 1920L512 2048L384 2048ZM768 2048L768 1920L896 1920L896 2048L768 2048ZM1152 2048L1152 1920L1280 1920L1280 2048L1152 2048ZM1536 2048L1536 1920L1664 1920L1664 2048L1536 2048ZM0 1664L0 1536L128 1536L128 1664L0 1664ZM0 1280L0 1152L128 1152L128 1280L0 1280ZM0 896L0 768L128 768L128 896L0 896ZM0 512L0 384L128 384L128 512L0 512ZM1920 1664L1920 1536L2048 1536L2048 1664L1920 1664ZM1920 1280L1920 1152L2048 1152L2048 1280L1920 1280ZM1920 896L1920 768L2048 768L2048 896L1920 896ZM1920 512L1920 384L2048 384L2048 512L1920 512ZM1920 2048L1920 1920L2048 1920L2048 2048L1920 2048Z"
         }
      }
   ]
}

var LineStyle = {
   name: "LineStyle",
   vendor: "UiFabric",
   unicode: 62732,
   value: "",
   charCode: "F50C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L1920 384L1920 512L0 512L0 384ZM128 768L128 896L0 896L0 768L128 768ZM384 768L384 896L256 896L256 768L384 768ZM512 896L512 768L640 768L640 896L512 896ZM896 768L896 896L768 896L768 768L896 768ZM1152 768L1152 896L1024 896L1024 768L1152 768ZM1280 896L1280 768L1408 768L1408 896L1280 896ZM1664 768L1664 896L1536 896L1536 768L1664 768ZM1792 896L1792 768L1920 768L1920 896L1792 896ZM256 1152L256 1280L0 1280L0 1152L256 1152ZM384 1280L384 1152L640 1152L640 1280L384 1280ZM768 1280L768 1152L1024 1152L1024 1280L768 1280ZM1152 1280L1152 1152L1408 1152L1408 1280L1152 1280ZM1536 1280L1536 1152L1792 1152L1792 1280L1536 1280ZM0 1664L0 1536L384 1536L384 1664L0 1664ZM512 1664L512 1536L640 1536L640 1664L512 1664ZM768 1664L768 1536L1152 1536L1152 1664L768 1664ZM1536 1664L1536 1536L1920 1536L1920 1664L1536 1664ZM1280 1664L1280 1536L1408 1536L1408 1664L1280 1664Z"
         }
      }
   ]
}

var LineThickness = {
   name: "LineThickness",
   vendor: "UiFabric",
   unicode: 62733,
   value: "",
   charCode: "F50D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 512L0 512L0 384ZM0 1024L0 768L2048 768L2048 1024L0 1024ZM0 1664L0 1280L2048 1280L2048 1664L0 1664Z"
         }
      }
   ]
}

var WindowEdit = {
   name: "WindowEdit",
   vendor: "UiFabric",
   unicode: 62734,
   value: "",
   charCode: "F50E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 768L1920 768L1920 640L128 640L128 1664L768 1664L768 1792L0 1792L0 128ZM1920 512L1920 256L128 256L128 512L1920 512ZM1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1207 1838L1899 1145Q1920 1124 1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838Z"
         }
      }
   ]
}

var HintText = {
   name: "HintText",
   vendor: "UiFabric",
   unicode: 62735,
   value: "",
   charCode: "F50F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 640L1920 640L1920 384L128 384L128 1536L1024 1536L1024 1664L0 1664L0 256ZM1536 640L1536 640Q1642 640 1735.50 680Q1829 720 1898.50 789.50Q1968 859 2008 952.50Q2048 1046 2048 1152L2048 1152Q2048 1258 2009.50 1347.50Q1971 1437 1899 1513L1899 1513L1867 1547Q1855 1560 1842 1576.50Q1829 1593 1818.50 1612Q1808 1631 1801.50 1650.50Q1795 1670 1795 1688L1795 1688L1795 1856Q1795 1897 1779.50 1932.50Q1764 1968 1738 1994Q1712 2020 1676 2035.50Q1640 2051 1600 2051L1600 2051L1472 2051Q1431 2051 1395.50 2035.50Q1360 2020 1334 1994Q1308 1968 1292.50 1932.50Q1277 1897 1277 1856L1277 1856L1277 1688Q1276 1663 1266 1639Q1256 1615 1241 1593Q1226 1571 1207.50 1551Q1189 1531 1173 1513L1173 1513Q1101 1437 1062.50 1347.50Q1024 1258 1024 1152L1024 1152Q1024 1046 1064 952.50Q1104 859 1173.50 789.50Q1243 720 1336.50 680Q1430 640 1536 640ZM1661 1856L1661 1795L1411 1795L1411 1856Q1411 1881 1429 1899Q1447 1917 1472 1917L1472 1917L1600 1917Q1625 1917 1643 1899Q1661 1881 1661 1856L1661 1856ZM1402 1661L1670 1661Q1680 1604 1702 1562.50Q1724 1521 1752 1486.50Q1780 1452 1809.50 1420.50Q1839 1389 1863.50 1351.50Q1888 1314 1904 1266.50Q1920 1219 1920 1152L1920 1152Q1920 1072 1890 1002Q1860 932 1808 880Q1756 828 1686 798Q1616 768 1536 768L1536 768Q1456 768 1386 798Q1316 828 1264 880Q1212 932 1182 1002Q1152 1072 1152 1152L1152 1152Q1152 1228 1181 1299.50Q1210 1371 1264 1427L1264 1427Q1291 1454 1313.50 1479.50Q1336 1505 1353.50 1532Q1371 1559 1383 1590.50Q1395 1622 1402 1661L1402 1661Z"
         }
      }
   ]
}

var MediaAdd = {
   name: "MediaAdd",
   vendor: "UiFabric",
   unicode: 62736,
   value: "",
   charCode: "F510",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 512L256 384L384 384L384 512L256 512ZM256 768L256 640L384 640L384 768L256 768ZM1152 512L1152 384L1280 384L1280 512L1152 512ZM1728 1126L1883 1280L1573 1280L1728 1126ZM1408 960L1408 960Q1408 934 1427 915Q1446 896 1472 896L1472 896Q1498 896 1517 915Q1536 934 1536 960L1536 960Q1536 986 1517 1005Q1498 1024 1472 1024L1472 1024Q1446 1024 1427 1005Q1408 986 1408 960ZM1536 640L2048 640L2048 1536L1920 1536L1920 768L640 768L640 1317L960 998L1408 1445L1536 1317L1536 1499L1499 1536L1317 1536L960 1178L640 1499L640 1664L1280 1664L1280 1792L512 1792L512 1152L0 1152L0 0L1536 0L1536 640ZM512 640L1408 640L1408 128L1280 128L1280 256L1152 256L1152 128L384 128L384 256L256 256L256 128L128 128L128 1024L256 1024L256 896L384 896L384 1024L512 1024L512 640ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408Z"
         }
      }
   ]
}

var AnchorLock = {
   name: "AnchorLock",
   vendor: "UiFabric",
   unicode: 62737,
   value: "",
   charCode: "F511",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1216 640Q1242 640 1261 659Q1280 678 1280 704L1280 704Q1280 730 1261 749Q1242 768 1216 768L1216 768L1024 768L1024 1785Q1057 1782 1089 1773.50Q1121 1765 1152 1754L1152 1754L1152 1890Q1105 1904 1057 1912Q1009 1920 960 1920L960 1920Q869 1920 784 1897.50Q699 1875 624 1834Q549 1793 485.50 1735Q422 1677 374.50 1606Q327 1535 297 1452.50Q267 1370 259 1280L259 1280L128 1280L320 1024L512 1280L391 1280Q402 1380 445 1467Q488 1554 555 1621Q622 1688 709 1731Q796 1774 896 1785L896 1785L896 768L704 768Q678 768 659 749Q640 730 640 704L640 704Q640 678 659 659Q678 640 704 640L704 640L896 640L896 500Q867 490 843.50 472Q820 454 803.50 430.50Q787 407 777.50 378.50Q768 350 768 320L768 320Q768 280 783 245Q798 210 824 184Q850 158 885 143Q920 128 960 128L960 128Q1000 128 1035 143Q1070 158 1096 184Q1122 210 1137 245Q1152 280 1152 320L1152 320Q1152 350 1142.50 378.50Q1133 407 1116.50 430.50Q1100 454 1076 472Q1052 490 1024 500L1024 500L1024 640ZM960 384L960 384Q986 384 1005 365Q1024 346 1024 320L1024 320Q1024 294 1005 275Q986 256 960 256L960 256Q934 256 915 275Q896 294 896 320L896 320Q896 346 915 365Q934 384 960 384ZM1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1408 1408L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408ZM1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920Z"
         }
      }
   ]
}

var AutoHeight = {
   name: "AutoHeight",
   vendor: "UiFabric",
   unicode: 62738,
   value: "",
   charCode: "F512",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M83 467L448 102L813 467L723 557L512 347L512 896L384 896L384 347L173 557L83 467ZM512 1701L723 1491L813 1581L448 1946L83 1581L173 1491L384 1701L384 1152L512 1152L512 1701ZM896 256L2048 256L2048 1792L896 1792L896 1664L1920 1664L1920 384L896 384L896 256ZM1176 512L1664 512L1467 832L1807 832L1181 1536L927 1536L1092 1152L856 1152L1176 512ZM1521 960L1239 960L1435 640L1256 640L1064 1024L1286 1024L1123 1408L1521 960Z"
         }
      }
   ]
}

var ChartSeries = {
   name: "ChartSeries",
   vendor: "UiFabric",
   unicode: 62739,
   value: "",
   charCode: "F513",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 384L512 640L896 640L896 1920L0 1920L0 384L512 384ZM384 1792L384 512L128 512L128 1792L384 1792ZM768 768L512 768L512 1792L768 1792L768 768ZM1664 896L2048 896L2048 1920L1152 1920L1152 128L1664 128L1664 896ZM1536 1792L1536 256L1280 256L1280 1792L1536 1792ZM1920 1792L1920 1024L1664 1024L1664 1792L1920 1792Z"
         }
      }
   ]
}

var ChartXAngle = {
   name: "ChartXAngle",
   vendor: "UiFabric",
   unicode: 62740,
   value: "",
   charCode: "F514",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1811 1773L384 347L384 1918Q459 1912 535.50 1893Q612 1874 683 1842Q754 1810 818 1765.50Q882 1721 933 1664L933 1664L640 1664L640 1536L1152 1536L1152 2048L1024 2048L1024 1755L1005 1773Q862 1910 690 1979Q518 2048 320 2048L320 2048L256 2048L256 37L1901 1683L1811 1773Z"
         }
      }
   ]
}

var ChartYAngle = {
   name: "ChartYAngle",
   vendor: "UiFabric",
   unicode: 62741,
   value: "",
   charCode: "F515",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 896L2048 1024L1755 1024L1773 1043Q1910 1186 1979 1358Q2048 1530 2048 1728L2048 1728L2048 1792L37 1792L1683 147L1773 237L347 1664L1918 1664Q1912 1589 1893 1512.50Q1874 1436 1842 1365Q1810 1294 1765.50 1230Q1721 1166 1664 1115L1664 1115L1664 1408L1536 1408L1536 896L2048 896Z"
         }
      }
   ]
}

var Combobox = {
   name: "Combobox",
   vendor: "UiFabric",
   unicode: 62742,
   value: "",
   charCode: "F516",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L2048 256L2048 1664L0 1664L0 256ZM1920 1536L1920 384L128 384L128 1536L1920 1536ZM1792 896L1536 1152L1280 896L1792 896ZM512 896L512 1024L256 1024L256 896L512 896ZM1024 896L1024 1024L768 1024L768 896L1024 896Z"
         }
      }
   ]
}

var LineSpacing = {
   name: "LineSpacing",
   vendor: "UiFabric",
   unicode: 62743,
   value: "",
   charCode: "F517",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M83 467L448 102L813 467L723 557L512 347L512 896L384 896L384 347L173 557L83 467ZM512 1701L723 1491L813 1581L448 1946L83 1581L173 1491L384 1701L384 1152L512 1152L512 1701ZM1024 384L2048 384L2048 512L1024 512L1024 384ZM1024 896L1024 768L2048 768L2048 896L1024 896ZM1024 1280L1024 1152L2048 1152L2048 1280L1024 1280ZM1024 1664L1024 1536L2048 1536L2048 1664L1024 1664Z"
         }
      }
   ]
}

var Padding = {
   name: "Padding",
   vendor: "UiFabric",
   unicode: 62744,
   value: "",
   charCode: "F518",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L0 0L128 0L128 128L0 128ZM1792 0L1920 0L1920 128L1792 128L1792 0ZM256 128L256 0L512 0L512 128L256 128ZM896 0L896 128L640 128L640 0L896 0ZM1280 0L1280 128L1024 128L1024 0L1280 0ZM1408 128L1408 0L1664 0L1664 128L1408 128ZM0 2048L0 1920L128 1920L128 2048L0 2048ZM1792 2048L1792 1920L1920 1920L1920 2048L1792 2048ZM256 2048L256 1920L512 1920L512 2048L256 2048ZM640 2048L640 1920L896 1920L896 2048L640 2048ZM1024 2048L1024 1920L1280 1920L1280 2048L1024 2048ZM1408 2048L1408 1920L1664 1920L1664 2048L1408 2048ZM1235 813L1024 603L1024 1445L1235 1235L1325 1325L960 1690L595 1325L685 1235L896 1445L896 603L685 813L595 723L960 358L1325 723L1235 813Z"
         }
      }
   ]
}

var PaddingTop = {
   name: "PaddingTop",
   vendor: "UiFabric",
   unicode: 62745,
   value: "",
   charCode: "F519",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 1920L1920 1920L1920 2048L0 2048ZM128 0L128 128L0 128L0 0L128 0ZM1792 0L1920 0L1920 128L1792 128L1792 0ZM512 0L512 128L256 128L256 0L512 0ZM896 0L896 128L640 128L640 0L896 0ZM1280 0L1280 128L1024 128L1024 0L1280 0ZM1664 0L1664 128L1408 128L1408 0L1664 0ZM896 603L685 813L595 723L960 358L1325 723L1235 813L1024 603L1024 1664L896 1664L896 603Z"
         }
      }
   ]
}

var PaddingBottom = {
   name: "PaddingBottom",
   vendor: "UiFabric",
   unicode: 62746,
   value: "",
   charCode: "F51A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L0 128L1920 128L1920 0L0 0ZM128 2048L128 1920L0 1920L0 2048L128 2048ZM1792 2048L1920 2048L1920 1920L1792 1920L1792 2048ZM512 2048L512 1920L256 1920L256 2048L512 2048ZM896 2048L896 1920L640 1920L640 2048L896 2048ZM1280 2048L1280 1920L1024 1920L1024 2048L1280 2048ZM1664 2048L1664 1920L1408 1920L1408 2048L1664 2048ZM896 1445L685 1235L595 1325L960 1690L1325 1325L1235 1235L1024 1445L1024 384L896 384L896 1445Z"
         }
      }
   ]
}

var PaddingLeft = {
   name: "PaddingLeft",
   vendor: "UiFabric",
   unicode: 62747,
   value: "",
   charCode: "F51B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 0L2048 0L2048 1920L1920 1920L1920 0ZM0 128L0 0L128 0L128 128L0 128ZM0 1920L0 1792L128 1792L128 1920L0 1920ZM0 512L0 256L128 256L128 512L0 512ZM0 896L0 640L128 640L128 896L0 896ZM0 1280L0 1024L128 1024L128 1280L0 1280ZM0 1664L0 1408L128 1408L128 1664L0 1664ZM813 685L603 896L1664 896L1664 1024L603 1024L813 1235L723 1325L358 960L723 595L813 685Z"
         }
      }
   ]
}

var PaddingRight = {
   name: "PaddingRight",
   vendor: "UiFabric",
   unicode: 62748,
   value: "",
   charCode: "F51C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 0L0 0L0 1920L128 1920L128 0ZM2048 128L2048 0L1920 0L1920 128L2048 128ZM2048 1920L2048 1792L1920 1792L1920 1920L2048 1920ZM2048 512L2048 256L1920 256L1920 512L2048 512ZM2048 896L2048 640L1920 640L1920 896L2048 896ZM2048 1280L2048 1024L1920 1024L1920 1280L2048 1280ZM2048 1664L2048 1408L1920 1408L1920 1664L2048 1664ZM1235 685L1445 896L384 896L384 1024L1445 1024L1235 1235L1325 1325L1690 960L1325 595L1235 685Z"
         }
      }
   ]
}

var NavigationFlipper = {
   name: "NavigationFlipper",
   vendor: "UiFabric",
   unicode: 62749,
   value: "",
   charCode: "F51D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M861 1405L771 1315L1061 1024L771 733L861 643L1243 1024L861 1405ZM256 0L1664 0L1664 2048L256 2048L256 0ZM1536 1920L1536 128L384 128L384 1920L1536 1920Z"
         }
      }
   ]
}

var AlignJustify = {
   name: "AlignJustify",
   vendor: "UiFabric",
   unicode: 62750,
   value: "",
   charCode: "F51E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 256L0 256L0 128ZM0 1792L0 1664L2048 1664L2048 1792L0 1792ZM0 1024L0 896L2048 896L2048 1024L0 1024ZM0 640L0 512L2048 512L2048 640L0 640ZM0 1408L0 1280L2048 1280L2048 1408L0 1408Z"
         }
      }
   ]
}

var TextOverflow = {
   name: "TextOverflow",
   vendor: "UiFabric",
   unicode: 62751,
   value: "",
   charCode: "F51F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M390 650L507 650L741 1278L626 1278L570 1118L323 1118L269 1278L155 1278L390 650ZM350 1033L543 1033L455 783Q452 774 450 763Q448 752 446 743L446 743Q444 752 442.50 762.50Q441 773 437 783L437 783L350 1033ZM1041 819L1041 819Q1089 819 1123.50 837.50Q1158 856 1180 887Q1202 918 1212 958Q1222 998 1222 1041L1222 1041Q1222 1089 1210.50 1133.50Q1199 1178 1175 1212.50Q1151 1247 1113 1267.50Q1075 1288 1021 1288L1021 1288Q936 1288 887 1213L887 1213L887 1278L785 1278L785 614L889 614L889 908Q940 819 1041 819ZM997 1208L997 1208Q1031 1208 1054.50 1192.50Q1078 1177 1092 1153Q1106 1129 1112 1099.50Q1118 1070 1118 1041L1118 1041Q1118 1015 1111.50 989.50Q1105 964 1091.50 944Q1078 924 1057 912Q1036 900 1006 900L1006 900Q977 900 954.50 911Q932 922 917 940.50Q902 959 894 983.50Q886 1008 886 1035L886 1035L886 1090Q886 1114 894 1135.50Q902 1157 916.50 1173Q931 1189 951.50 1198.50Q972 1208 997 1208ZM1984 1152L1984 1152Q2010 1152 2029 1171Q2048 1190 2048 1216L2048 1216Q2048 1242 2029 1261Q2010 1280 1984 1280L1984 1280Q1958 1280 1939 1261Q1920 1242 1920 1216L1920 1216Q1920 1190 1939 1171Q1958 1152 1984 1152ZM1728 1152L1728 1152Q1754 1152 1773 1171Q1792 1190 1792 1216L1792 1216Q1792 1242 1773 1261Q1754 1280 1728 1280L1728 1280Q1702 1280 1683 1261Q1664 1242 1664 1216L1664 1216Q1664 1190 1683 1171Q1702 1152 1728 1152ZM1472 1152L1472 1152Q1498 1152 1517 1171Q1536 1190 1536 1216L1536 1216Q1536 1242 1517 1261Q1498 1280 1472 1280L1472 1280Q1446 1280 1427 1261Q1408 1242 1408 1216L1408 1216Q1408 1190 1427 1171Q1446 1152 1472 1152Z"
         }
      }
   ]
}

var VisualsFolder = {
   name: "VisualsFolder",
   vendor: "UiFabric",
   unicode: 62752,
   value: "",
   charCode: "F520",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M552 896L168 1664L1024 1664L1024 1792L0 1792L0 384Q0 357 10 334Q20 311 37.50 293.50Q55 276 78 266Q101 256 128 256L128 256L480 256Q525 256 557.50 265.50Q590 275 615.50 289Q641 303 661 320Q681 337 701.50 351Q722 365 745.50 374.50Q769 384 800 384L800 384L1536 384Q1562 384 1585.50 394Q1609 404 1626.50 421.50Q1644 439 1654 462.50Q1664 486 1664 512L1664 512L1664 768L1920 768Q1946 768 1969.50 778Q1993 788 2010.50 805.50Q2028 823 2038 846Q2048 869 2048 895L2048 895Q2048 925 2034 953L2034 953L1935 1152L1792 1152L1920 896L552 896ZM128 384L128 1457L437 839Q454 806 484.50 787Q515 768 552 768L552 768L1536 768L1536 512L800 512Q755 512 722.50 502.50Q690 493 664.50 479Q639 465 619 448Q599 431 578.50 417Q558 403 534.50 393.50Q511 384 480 384L480 384L128 384ZM1920 2048L1920 1408L2048 1408L2048 2048L1920 2048ZM1664 2048L1664 1280L1792 1280L1792 2048L1664 2048ZM1408 2048L1408 1536L1536 1536L1536 2048L1408 2048ZM1152 2048L1152 1792L1280 1792L1280 2048L1152 2048Z"
         }
      }
   ]
}

var VisualsStore = {
   name: "VisualsStore",
   vendor: "UiFabric",
   unicode: 62753,
   value: "",
   charCode: "F521",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 0L1152 0Q1231 0 1301 30Q1371 60 1423.50 112.50Q1476 165 1506 235Q1536 305 1536 384L1536 384L1536 512L1792 512L1792 1152L1664 1152L1664 640L1408 640L1408 1408L1280 1408L1280 640L256 640L256 1792Q256 1819 266 1842Q276 1865 293.50 1882.50Q311 1900 334 1910Q357 1920 384 1920L384 1920L1024 1920L1024 2048L384 2048Q331 2048 284.50 2028Q238 2008 203 1973Q168 1938 148 1891.50Q128 1845 128 1792L128 1792L128 512L384 512L384 384Q384 305 414 235Q444 165 496.50 112.50Q549 60 618.50 30Q688 0 768 0L768 0Q872 0 961 52L961 52Q1050 0 1152 0ZM1408 512L1408 384Q1408 331 1388 284.50Q1368 238 1333 203Q1298 168 1251.50 148Q1205 128 1152 128L1152 128Q1107 128 1067 143L1067 143Q1096 179 1113 214Q1130 249 1138.50 284Q1147 319 1149.50 355.50Q1152 392 1152 432L1152 432L1152 512L1408 512ZM512 384L512 512L1024 512L1024 384Q1024 331 1004 284.50Q984 238 949 203Q914 168 867.50 148Q821 128 768 128L768 128Q715 128 668.50 148Q622 168 587 203Q552 238 532 284.50Q512 331 512 384L512 384ZM1920 1408L2048 1408L2048 2048L1920 2048L1920 1408ZM1664 2048L1664 1280L1792 1280L1792 2048L1664 2048ZM1408 2048L1408 1536L1536 1536L1536 2048L1408 2048ZM1152 2048L1152 1792L1280 1792L1280 2048L1152 2048Z"
         }
      }
   ]
}

var PictureCenter = {
   name: "PictureCenter",
   vendor: "UiFabric",
   unicode: 62754,
   value: "",
   charCode: "F522",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 384L1792 1536L256 1536L256 384L1792 384ZM1664 512L384 512L384 998L736 646L1184 1093L1376 902L1664 1189L1664 512ZM384 1178L384 1408L1317 1408L736 827L384 1178ZM1499 1408L1664 1408L1664 1371L1376 1083L1274 1184L1499 1408ZM1472 768L1472 768Q1446 768 1427 749Q1408 730 1408 704L1408 704Q1408 678 1427 659Q1446 640 1472 640L1472 640Q1498 640 1517 659Q1536 678 1536 704L1536 704Q1536 730 1517 749Q1498 768 1472 768ZM0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1920L1920 128L128 128L128 1920L1920 1920Z"
         }
      }
   ]
}

var PictureFill = {
   name: "PictureFill",
   vendor: "UiFabric",
   unicode: 62755,
   value: "",
   charCode: "F523",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1701L1920 987L1562 1344L1920 1701ZM1664 256L1664 256Q1664 229 1654 206Q1644 183 1626.50 165.50Q1609 148 1586 138Q1563 128 1536 128L1536 128Q1509 128 1486 138Q1463 148 1445.50 165.50Q1428 183 1418 206Q1408 229 1408 256L1408 256Q1408 283 1418 306Q1428 329 1445.50 346.50Q1463 364 1486 374Q1509 384 1536 384L1536 384Q1563 384 1586 374Q1609 364 1626.50 346.50Q1644 329 1654 306Q1664 283 1664 256ZM1314 128L128 128L128 805L576 358L1472 1254L1920 805L1920 128L1758 128Q1792 186 1792 256L1792 256Q1792 309 1772 355.50Q1752 402 1717 437Q1682 472 1635.50 492Q1589 512 1536 512L1536 512Q1483 512 1436.50 492Q1390 472 1355 437Q1320 402 1300 355.50Q1280 309 1280 256L1280 256Q1280 186 1314 128L1314 128ZM128 1920L1920 1920L1920 1883L576 538L128 987L128 1920Z"
         }
      }
   ]
}

var PicturePosition = {
   name: "PicturePosition",
   vendor: "UiFabric",
   unicode: 62756,
   value: "",
   charCode: "F524",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 1536L512 512L1536 512L1536 1536L512 1536ZM640 1243L640 1408L1189 1408L832 1050L640 1243ZM1408 640L640 640L640 1061L832 870L1371 1408L1408 1408L1408 640ZM1216 896L1216 896Q1190 896 1171 877Q1152 858 1152 832L1152 832Q1152 806 1171 787Q1190 768 1216 768L1216 768Q1242 768 1261 787Q1280 806 1280 832L1280 832Q1280 858 1261 877Q1242 896 1216 896ZM1024 181L859 347L768 256L1024 0L1280 256L1189 347L1024 181ZM1024 1867L1189 1701L1280 1792L1024 2048L768 1792L859 1701L1024 1867ZM256 768L347 859L181 1024L347 1189L256 1280L0 1024L256 768ZM1792 768L2048 1024L1792 1280L1701 1189L1867 1024L1701 859L1792 768Z"
         }
      }
   ]
}

var PictureStretch = {
   name: "PictureStretch",
   vendor: "UiFabric",
   unicode: 62757,
   value: "",
   charCode: "F525",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1920L0 768L1408 768L1408 1920L0 1920ZM128 1499L128 1792L998 1792L416 1211L128 1499ZM1178 1792L1280 1792L1280 1690L1056 1467L955 1568L1178 1792ZM1280 896L128 896L128 1317L416 1030L864 1477L1056 1286L1280 1510L1280 896ZM960 1152L960 1152Q934 1152 915 1133Q896 1114 896 1088L896 1088Q896 1062 915 1043Q934 1024 960 1024L960 1024Q986 1024 1005 1043Q1024 1062 1024 1088L1024 1088Q1024 1114 1005 1133Q986 1152 960 1152ZM2048 640L1920 640L1920 347L1581 685L1491 595L1829 256L1536 256L1536 128L2048 128L2048 640ZM1152 256L1152 128L1408 128L1408 256L1152 256ZM1024 128L1024 256L768 256L768 128L1024 128ZM640 128L640 256L384 256L384 128L640 128ZM256 128L256 256L0 256L0 128L256 128ZM128 384L128 640L0 640L0 384L128 384ZM1920 768L2048 768L2048 1024L1920 1024L1920 768ZM1920 1408L1920 1152L2048 1152L2048 1408L1920 1408ZM1920 1792L1920 1536L2048 1536L2048 1792L1920 1792ZM1536 1920L1536 1792L1792 1792L1792 1920L1536 1920Z"
         }
      }
   ]
}

var PictureTile = {
   name: "PictureTile",
   vendor: "UiFabric",
   unicode: 62758,
   value: "",
   charCode: "F526",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M704 384L704 384Q678 384 659 365Q640 346 640 320L640 320Q640 294 659 275Q678 256 704 256L704 256Q730 256 749 275Q768 294 768 320L768 320Q768 346 749 365Q730 384 704 384ZM0 0L1920 0L1920 1920L0 1920L0 0ZM1024 731L1024 896L1573 896L1216 538L1024 731ZM896 128L128 128L128 549L320 358L859 896L896 896L896 128ZM128 731L128 896L677 896L320 538L128 731ZM128 1627L128 1792L677 1792L320 1434L128 1627ZM896 1792L896 1024L128 1024L128 1445L320 1254L859 1792L896 1792ZM1024 1627L1024 1792L1573 1792L1216 1434L1024 1627ZM1792 1792L1792 1024L1024 1024L1024 1445L1216 1254L1755 1792L1792 1792ZM1755 896L1792 896L1792 128L1024 128L1024 549L1216 358L1755 896ZM1600 256L1600 256Q1626 256 1645 275Q1664 294 1664 320L1664 320Q1664 346 1645 365Q1626 384 1600 384L1600 384Q1574 384 1555 365Q1536 346 1536 320L1536 320Q1536 294 1555 275Q1574 256 1600 256ZM704 1280L704 1280Q678 1280 659 1261Q640 1242 640 1216L640 1216Q640 1190 659 1171Q678 1152 704 1152L704 1152Q730 1152 749 1171Q768 1190 768 1216L768 1216Q768 1242 749 1261Q730 1280 704 1280ZM1600 1280L1600 1280Q1574 1280 1555 1261Q1536 1242 1536 1216L1536 1216Q1536 1190 1555 1171Q1574 1152 1600 1152L1600 1152Q1626 1152 1645 1171Q1664 1190 1664 1216L1664 1216Q1664 1242 1645 1261Q1626 1280 1600 1280Z"
         }
      }
   ]
}

var Slider = {
   name: "Slider",
   vendor: "UiFabric",
   unicode: 62759,
   value: "",
   charCode: "F527",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 896L2048 1024L890 1024Q878 1080 849 1127Q820 1174 778.50 1208Q737 1242 685 1261Q633 1280 576 1280L576 1280Q519 1280 467 1261Q415 1242 373.50 1208Q332 1174 303 1127Q274 1080 262 1024L262 1024L0 1024L0 896L262 896Q274 840 303 793Q332 746 373.50 712Q415 678 467 659Q519 640 576 640L576 640Q633 640 685 659Q737 678 778.50 712Q820 746 849 793Q878 840 890 896L890 896L2048 896ZM576 1152L576 1152Q616 1152 651 1137Q686 1122 712 1096Q738 1070 753 1035Q768 1000 768 960L768 960Q768 920 753 885Q738 850 712 824Q686 798 651 783Q616 768 576 768L576 768Q536 768 501 783Q466 798 440 824Q414 850 399 885Q384 920 384 960L384 960Q384 1000 399 1035Q414 1070 440 1096Q466 1122 501 1137Q536 1152 576 1152Z"
         }
      }
   ]
}

var SliderHandleSize = {
   name: "SliderHandleSize",
   vendor: "UiFabric",
   unicode: 62760,
   value: "",
   charCode: "F528",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1919 1249L1919 1249Q1980 1304 2014 1378.50Q2048 1453 2048 1536L2048 1536Q2048 1616 2018 1685.50Q1988 1755 1935.50 1807.50Q1883 1860 1813 1890Q1743 1920 1664 1920L1664 1920Q1576 1920 1497 1882L1497 1882Q1392 1920 1280 1920L1280 1920Q1235 1920 1190.50 1913.50Q1146 1907 1102 1895L1102 1895Q1051 1908 999.50 1914Q948 1920 896 1920L896 1920Q772 1920 657.50 1888Q543 1856 443.50 1797.50Q344 1739 262.50 1657.50Q181 1576 122.50 1476.50Q64 1377 32 1262.50Q0 1148 0 1024L0 1024Q0 900 32 785.50Q64 671 122.50 571.50Q181 472 262.50 390.50Q344 309 443.50 250.50Q543 192 657.50 160Q772 128 896 128L896 128Q1006 128 1109 153.50Q1212 179 1304.50 227Q1397 275 1476 342Q1555 409 1616.50 493Q1678 577 1720 674.50Q1762 772 1780 880L1780 880Q1843 959 1878.50 1053.50Q1914 1148 1919 1249ZM128 1024L128 1024Q128 1130 155.50 1228Q183 1326 233 1411.50Q283 1497 353 1567Q423 1637 508.50 1687Q594 1737 692 1764.50Q790 1792 896 1792L896 1792Q835 1746 787.50 1689Q740 1632 707 1566.50Q674 1501 657 1428.50Q640 1356 640 1280L640 1280Q640 1147 690 1030.50Q740 914 827 827Q914 740 1030.50 690Q1147 640 1280 640L1280 640Q1366 640 1448 662Q1530 684 1604 728L1604 728Q1559 622 1486 534.50Q1413 447 1320.50 385.50Q1228 324 1120 290Q1012 256 896 256L896 256Q790 256 692 283.50Q594 311 508.50 361Q423 411 353 481Q283 551 233 636.50Q183 722 155.50 820Q128 918 128 1024ZM768 1280L768 1280Q768 1386 808.50 1479Q849 1572 918.50 1641.50Q988 1711 1081 1751.50Q1174 1792 1280 1792L1280 1792Q1303 1792 1325.50 1790Q1348 1788 1371 1784L1371 1784Q1326 1732 1303 1668Q1280 1604 1280 1536L1280 1536Q1280 1457 1310 1387Q1340 1317 1392.50 1264.50Q1445 1212 1514.50 1182Q1584 1152 1664 1152L1664 1152Q1724 1152 1780 1170L1780 1170Q1761 1082 1714 1008Q1667 934 1600.50 881Q1534 828 1452 798Q1370 768 1280 768L1280 768Q1174 768 1081 808.50Q988 849 918.50 918.50Q849 988 808.50 1081Q768 1174 768 1280ZM1664 1792L1664 1792Q1717 1792 1763.50 1772Q1810 1752 1845 1717Q1880 1682 1900 1635.50Q1920 1589 1920 1536L1920 1536Q1920 1483 1900 1436.50Q1880 1390 1845 1355Q1810 1320 1763.50 1300Q1717 1280 1664 1280L1664 1280Q1611 1280 1564.50 1300Q1518 1320 1483 1355Q1448 1390 1428 1436.50Q1408 1483 1408 1536L1408 1536Q1408 1589 1428 1635.50Q1448 1682 1483 1717Q1518 1752 1564.50 1772Q1611 1792 1664 1792Z"
         }
      }
   ]
}

var DefaultRatio = {
   name: "DefaultRatio",
   vendor: "UiFabric",
   unicode: 62761,
   value: "",
   charCode: "F529",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1280L640 860Q611 877 578.50 886.50Q546 896 512 896L512 896L512 768Q539 768 562 758Q585 748 602.50 730.50Q620 713 630 690Q640 667 640 640L640 640L768 640L768 1280L640 1280ZM1280 1280L1280 860Q1251 877 1218.50 886.50Q1186 896 1152 896L1152 896L1152 768Q1179 768 1202 758Q1225 748 1242.50 730.50Q1260 713 1270 690Q1280 667 1280 640L1280 640L1408 640L1408 1280L1280 1280ZM960 896L960 896Q934 896 915 877Q896 858 896 832L896 832Q896 806 915 787Q934 768 960 768L960 768Q986 768 1005 787Q1024 806 1024 832L1024 832Q1024 858 1005 877Q986 896 960 896ZM960 1152L960 1152Q934 1152 915 1133Q896 1114 896 1088L896 1088Q896 1062 915 1043Q934 1024 960 1024L960 1024Q986 1024 1005 1043Q1024 1062 1024 1088L1024 1088Q1024 1114 1005 1133Q986 1152 960 1152ZM0 0L1920 0L1920 1920L0 1920L0 0ZM1792 1792L1792 128L128 128L128 1792L1792 1792Z"
         }
      }
   ]
}

var NumberSequence = {
   name: "NumberSequence",
   vendor: "UiFabric",
   unicode: 62762,
   value: "",
   charCode: "F52A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 896L1280 476Q1251 493 1218.50 502.50Q1186 512 1152 512L1152 512L1152 384Q1179 384 1202 374Q1225 364 1242.50 346.50Q1260 329 1270 306Q1280 283 1280 256L1280 256L1408 256L1408 896L1280 896ZM1472 1664L1472 1792L1088 1792Q1088 1779 1087.50 1766.50Q1087 1754 1087 1741L1087 1741Q1087 1716 1090 1691.50Q1093 1667 1102 1644L1102 1644Q1113 1616 1135 1589.50Q1157 1563 1184 1537.50Q1211 1512 1239.50 1487.50Q1268 1463 1291 1438.50Q1314 1414 1329 1390.50Q1344 1367 1344 1344L1344 1344Q1344 1317 1325 1298.50Q1306 1280 1280 1280L1280 1280Q1257 1280 1239.50 1294Q1222 1308 1217 1331L1217 1331L1092 1305Q1098 1272 1115.50 1244Q1133 1216 1159 1195.50Q1185 1175 1216 1163.50Q1247 1152 1280 1152L1280 1152Q1320 1152 1355 1167Q1390 1182 1416 1208Q1442 1234 1457 1269Q1472 1304 1472 1344L1472 1344Q1472 1403 1447 1446Q1422 1489 1385.50 1525Q1349 1561 1308.50 1593.50Q1268 1626 1237 1664L1237 1664L1472 1664ZM579 734L525 894L411 894L646 266L763 266L997 894L882 894L826 734L579 734ZM701 359L701 359Q699 370 697.50 380Q696 390 693 399L693 399L606 649L799 649L711 399Q708 390 706 379.50Q704 369 701 359ZM579 1630L525 1790L411 1790L646 1162L763 1162L997 1790L882 1790L826 1630L579 1630ZM701 1255L701 1255Q699 1266 697.50 1276Q696 1286 693 1295L693 1295L606 1545L799 1545L711 1295Q708 1286 706 1275.50Q704 1265 701 1255ZM1538 1077L1538 1017Q1559 1017 1572 1005Q1585 993 1592 975.50Q1599 958 1601.50 938Q1604 918 1604 902L1604 902L1536 902L1536 770L1664 770L1664 902Q1664 932 1657.50 963Q1651 994 1636.50 1019.50Q1622 1045 1598 1061Q1574 1077 1538 1077L1538 1077ZM0 0L2048 0L2048 2048L0 2048L0 0ZM1920 1920L1920 128L128 128L128 1920L1920 1920Z"
         }
      }
   ]
}

var GUID = {
   name: "GUID",
   vendor: "UiFabric",
   unicode: 62763,
   value: "",
   charCode: "F52B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 256L0 128L384 128L384 256L0 256ZM512 256L512 128L1280 128L1280 256L512 256ZM1408 128L2048 128L2048 256L1408 256L1408 128ZM0 640L0 512L384 512L384 640L0 640ZM512 640L512 512L1280 512L1280 640L512 640ZM1408 640L1408 512L2048 512L2048 640L1408 640ZM0 1024L0 896L384 896L384 1024L0 1024ZM512 1024L512 896L1280 896L1280 1024L512 1024ZM1408 1024L1408 896L2048 896L2048 1024L1408 1024ZM0 1408L0 1280L384 1280L384 1408L0 1408ZM512 1408L512 1280L1280 1280L1280 1408L512 1408ZM1408 1408L1408 1280L2048 1280L2048 1408L1408 1408ZM0 1792L0 1664L384 1664L384 1792L0 1792ZM512 1792L512 1664L1280 1664L1280 1792L512 1792ZM1408 1792L1408 1664L2048 1664L2048 1792L1408 1792Z"
         }
      }
   ]
}

var ReportAdd = {
   name: "ReportAdd",
   vendor: "UiFabric",
   unicode: 62764,
   value: "",
   charCode: "F52C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 384L1920 1280L1536 1280L1536 384L1920 384ZM0 1664L0 1024L384 1024L384 1664L0 1664ZM1408 0L1408 1536L1280 1536L1280 1664L1024 1664L1024 0L1408 0ZM512 1664L512 384L896 384L896 1664L512 1664ZM1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408L1792 1664Z"
         }
      }
   ]
}

var DashboardAdd = {
   name: "DashboardAdd",
   vendor: "UiFabric",
   unicode: 62765,
   value: "",
   charCode: "F52D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1248 320L1196 436Q1081 384 957 384L957 384Q878 384 805 404.50Q732 425 668 463Q604 501 552 553.50Q500 606 462.50 670Q425 734 404.50 807.50Q384 881 384 960L384 960Q384 1075 428 1180.50Q472 1286 553 1367L553 1367L462 1458Q362 1358 309 1229.50Q256 1101 256 960L256 960Q256 863 281 773Q306 683 352 605Q398 527 462 463Q526 399 604 353.50Q682 308 772 283Q862 258 960 258L960 258Q1035 258 1107.50 273.50Q1180 289 1248 320L1248 320ZM1586 1280L1437 1280Q1485 1209 1510 1127.50Q1535 1046 1535 961L1535 961Q1535 899 1522 839.50Q1509 780 1484 724L1484 724L1600 672Q1631 740 1646.50 812.50Q1662 885 1662 960L1662 960Q1662 1044 1643 1124.50Q1624 1205 1586 1280L1586 1280ZM128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792L960 1792Q1126 1792 1280 1728L1280 1728L1280 1864Q1126 1920 960 1920L960 1920Q828 1920 705.50 1885.50Q583 1851 476 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444Q69 1337 34.50 1214.50Q0 1092 0 960L0 960Q0 828 34.50 705.50Q69 583 131.50 476Q194 369 281.50 281.50Q369 194 476 131.50Q583 69 705.50 34.50Q828 0 960 0L960 0Q1092 0 1214.50 34.50Q1337 69 1444 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 476Q1851 583 1885.50 705.50Q1920 828 1920 960L1920 960Q1920 1126 1864 1280L1864 1280L1728 1280Q1792 1126 1792 960L1792 960Q1792 845 1762 739Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1181 158Q1075 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739Q128 845 128 960ZM1501 509L1132 876Q1152 916 1152 960L1152 960Q1152 1000 1137 1035Q1122 1070 1096 1096Q1070 1122 1035 1137Q1000 1152 960 1152L960 1152Q920 1152 885 1137Q850 1122 824 1096Q798 1070 783 1035Q768 1000 768 960L768 960Q768 920 783 885Q798 850 824 824Q850 798 885 783Q920 768 960 768L960 768Q1003 768 1043 787L1043 787L1411 419L1501 509ZM960 1024L960 1024Q986 1024 1005 1005Q1024 986 1024 960L1024 960Q1024 934 1005 915Q986 896 960 896L960 896Q934 896 915 915Q896 934 896 960L896 960Q896 986 915 1005Q934 1024 960 1024ZM1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408L1792 1664Z"
         }
      }
   ]
}

var MapPinSolid = {
   name: "MapPinSolid",
   vendor: "UiFabric",
   unicode: 62766,
   value: "",
   charCode: "F52E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 896L1920 2048L0 2048L384 896L896 896L896 634Q840 622 793 593Q746 564 712 522.50Q678 481 659 429Q640 377 640 320L640 320Q640 254 665 196Q690 138 733.50 94.50Q777 51 835.50 25.50Q894 0 960 0L960 0Q1026 0 1084 25.50Q1142 51 1185.50 94.50Q1229 138 1254.50 196Q1280 254 1280 320L1280 320Q1280 377 1261 429Q1242 481 1208 522.50Q1174 564 1127 593Q1080 622 1024 634L1024 634L1024 896L1536 896ZM768 320L768 320Q768 360 783 395Q798 430 824 456Q850 482 885 497Q920 512 960 512L960 512Q1000 512 1035 497Q1070 482 1096 456Q1122 430 1137 395Q1152 360 1152 320L1152 320Q1152 280 1137 245Q1122 210 1096 184Q1070 158 1035 143Q1000 128 960 128L960 128Q920 128 885 143Q850 158 824 184Q798 210 783 245Q768 280 768 320ZM1024 1504L1024 1024L896 1024L896 1504Q896 1513 903.50 1519.50Q911 1526 921.50 1529.50Q932 1533 942.50 1534.50Q953 1536 960 1536L960 1536Q967 1536 977.50 1534.50Q988 1533 998.50 1529.50Q1009 1526 1016.50 1519.50Q1024 1513 1024 1504L1024 1504Z"
         }
      }
   ]
}

var WebPublish = {
   name: "WebPublish",
   vendor: "UiFabric",
   unicode: 62767,
   value: "",
   charCode: "F52F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1152L1920 1152L1920 640L128 640L128 1664L1536 1664L1536 1792L0 1792L0 128ZM1920 512L1920 256L128 256L128 512L1920 512ZM1408 1445L1728 1126L2048 1445L1957 1536L1792 1371L1792 2048L1664 2048L1664 1371L1499 1536L1408 1445Z"
         }
      }
   ]
}

var PieSingleSolid = {
   name: "PieSingleSolid",
   vendor: "UiFabric",
   unicode: 62768,
   value: "",
   charCode: "F530",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 896L1152 0Q1276 0 1390.50 32Q1505 64 1604.50 122.50Q1704 181 1785.50 262.50Q1867 344 1925.50 443.50Q1984 543 2016 657.50Q2048 772 2048 896L2048 896L1152 896ZM1024 128L1024 1024L1920 1024Q1920 1083 1917 1138Q1914 1193 1905.50 1247Q1897 1301 1882.50 1354.50Q1868 1408 1845 1462L1845 1462Q1788 1596 1697 1704Q1606 1812 1490.50 1888.50Q1375 1965 1240 2006.50Q1105 2048 960 2048L960 2048Q827 2048 704.50 2014Q582 1980 475 1917.50Q368 1855 280.50 1767.50Q193 1680 130.50 1573Q68 1466 34 1343.50Q0 1221 0 1088L0 1088Q0 955 34 832.50Q68 710 130.50 603Q193 496 280.50 408.50Q368 321 475 258.50Q582 196 704.50 162Q827 128 960 128L960 128L1024 128Z"
         }
      }
   ]
}

var BlockedSolid = {
   name: "BlockedSolid",
   vendor: "UiFabric",
   unicode: 62769,
   value: "",
   charCode: "F531",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1208 1985 1378.50Q1922 1549 1802 1689L1802 1689L359 246Q499 126 669.50 63Q840 0 1024 0ZM0 1024L0 1024Q0 840 63 669.50Q126 499 246 359L246 359L1689 1802Q1549 1922 1378.50 1985Q1208 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024Z"
         }
      }
   ]
}

var DrillDown = {
   name: "DrillDown",
   vendor: "UiFabric",
   unicode: 62770,
   value: "",
   charCode: "F532",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1089 1381L1555 915L1645 1005L1025 1627L403 1005L493 915L960 1382L960 384L1089 384L1089 1381Z"
         }
      }
   ]
}

var DrillDownSolid = {
   name: "DrillDownSolid",
   vendor: "UiFabric",
   unicode: 62771,
   value: "",
   charCode: "F533",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1025 1627L1645 1005L1555 915L1088 1381L1088 384L961 384L961 1382L493 915L403 1005L1025 1627Z"
         }
      }
   ]
}

var DrillExpand = {
   name: "DrillExpand",
   vendor: "UiFabric",
   unicode: 62772,
   value: "",
   charCode: "F534",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1408 1317L1555 1171L1645 1261L1344 1562L1043 1261L1133 1171L1280 1317L1280 896L768 896L768 1317L915 1171L1005 1261L704 1562L403 1261L493 1171L640 1317L640 768L960 768L960 384L1088 384L1088 768L1408 768L1408 1317Z"
         }
      }
   ]
}

var DrillShow = {
   name: "DrillShow",
   vendor: "UiFabric",
   unicode: 62773,
   value: "",
   charCode: "F535",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM768 1317L915 1171L1005 1261L704 1562L403 1261L493 1171L640 1317L640 512L768 512L768 1317ZM1408 1317L1555 1171L1645 1261L1344 1562L1043 1261L1133 1171L1280 1317L1280 512L1408 512L1408 1317Z"
         }
      }
   ]
}

var SpecialEvent = {
   name: "SpecialEvent",
   vendor: "UiFabric",
   unicode: 62774,
   value: "",
   charCode: "F536",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 128L1920 128L1920 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1408 128L1408 0L1536 0L1536 128ZM384 256L128 256L128 512L1792 512L1792 256L1536 256L1536 384L1408 384L1408 256L512 256L512 384L384 384L384 256ZM128 1792L1792 1792L1792 640L128 640L128 1792ZM1050 1024L1352 1024L1111 1213L1212 1528L960 1331L708 1528L809 1213L568 1024L870 1024L960 744L1050 1024Z"
         }
      }
   ]
}

var OneDriveFolder16 = {
   name: "OneDriveFolder16",
   vendor: "UiFabric",
   unicode: 62779,
   value: "",
   charCode: "F53B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1088 256L2048 256L2048 1792L0 1792L0 512L832 512L1088 256ZM562 1408L646 1408Q639 1377 639 1341L639 1341Q639 1249 692.50 1191Q746 1133 833 1113L833 1113Q862 1003 938 942Q1014 881 1130 881L1130 881Q1193 881 1248.50 905Q1304 929 1347 976L1347 976Q1362 972 1377 969.50Q1392 967 1407 966L1407 966Q1408 956 1408 947Q1408 938 1408 928L1408 928Q1408 915 1404 900Q1400 885 1395 874L1395 874Q1374 810 1330.50 763Q1287 716 1224 691L1224 691Q1173 670 1116 670L1116 670Q1038 670 974 711Q910 752 873 819L873 819Q851 805 821 798Q791 791 766 791L766 791Q719 791 678.50 809.50Q638 828 608 859Q578 890 561 932Q544 974 544 1020L544 1020Q544 1025 544 1031Q544 1037 545 1043L545 1043Q508 1046 478 1061.50Q448 1077 427 1102.50Q406 1128 395 1160.50Q384 1193 384 1229L384 1229Q384 1264 398.50 1296.50Q413 1329 437.50 1353.50Q462 1378 494.50 1393Q527 1408 562 1408L562 1408ZM894 1536L1610 1536Q1638 1536 1662.50 1523.50Q1687 1511 1705 1490.50Q1723 1470 1733 1443.50Q1743 1417 1743 1390L1743 1390Q1743 1362 1734.50 1336Q1726 1310 1710 1290Q1694 1270 1671 1257.50Q1648 1245 1618 1243L1618 1243L1618 1229Q1618 1187 1605 1150.50Q1592 1114 1567.50 1087Q1543 1060 1507.50 1044.50Q1472 1029 1428 1029L1428 1029Q1404 1029 1375.50 1035Q1347 1041 1326 1053L1326 1053Q1292 1002 1243 973.50Q1194 945 1131 945L1131 945Q1081 945 1038 961.50Q995 978 963 1007.50Q931 1037 911 1078.50Q891 1120 887 1170L887 1170Q850 1171 816.50 1183Q783 1195 758 1217Q733 1239 718 1270.50Q703 1302 703 1341L703 1341Q703 1432 752.50 1484Q802 1536 894 1536L894 1536Z"
         }
      }
   ]
}

var FunctionalManagerDashboard = {
   name: "FunctionalManagerDashboard",
   vendor: "UiFabric",
   unicode: 62786,
   value: "",
   charCode: "F542",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 384L1152 512L896 512L896 256L1024 256L1024 384L1152 384ZM1664 1152L1664 1544Q1706 1555 1741 1579Q1776 1603 1801.50 1636Q1827 1669 1841.50 1709Q1856 1749 1856 1792L1856 1792Q1856 1845 1836 1891.50Q1816 1938 1781 1973Q1746 2008 1699.50 2028Q1653 2048 1600 2048L1600 2048Q1547 2048 1500.50 2028Q1454 2008 1419 1973Q1384 1938 1364 1891.50Q1344 1845 1344 1792L1344 1792Q1344 1749 1358 1709Q1372 1669 1397.50 1636Q1423 1603 1458.50 1579Q1494 1555 1536 1544L1536 1544L1536 1280L1024 1280L1024 1544Q1066 1555 1101 1579Q1136 1603 1161.50 1636Q1187 1669 1201.50 1709Q1216 1749 1216 1792L1216 1792Q1216 1845 1196 1891.50Q1176 1938 1141 1973Q1106 2008 1059.50 2028Q1013 2048 960 2048L960 2048Q907 2048 860.50 2028Q814 2008 779 1973Q744 1938 724 1891.50Q704 1845 704 1792L704 1792Q704 1749 718 1709Q732 1669 757.50 1636Q783 1603 818.50 1579Q854 1555 896 1544L896 1544L896 1280L384 1280L384 1544Q426 1555 461 1579Q496 1603 521.50 1636Q547 1669 561.50 1709Q576 1749 576 1792L576 1792Q576 1845 556 1891.50Q536 1938 501 1973Q466 2008 419.50 2028Q373 2048 320 2048L320 2048Q267 2048 220.50 2028Q174 2008 139 1973Q104 1938 84 1891.50Q64 1845 64 1792L64 1792Q64 1749 78 1709Q92 1669 117.50 1636Q143 1603 178.50 1579Q214 1555 256 1544L256 1544L256 1152L896 1152L896 891Q813 880 742.50 840.50Q672 801 621 741.50Q570 682 541 606.50Q512 531 512 448L512 448Q512 355 547 273.50Q582 192 643 131Q704 70 785.50 35Q867 0 960 0L960 0Q1053 0 1134.50 35Q1216 70 1277 131Q1338 192 1373 273.50Q1408 355 1408 448L1408 448Q1408 531 1379 606.50Q1350 682 1299 741.50Q1248 801 1177.50 840.50Q1107 880 1024 891L1024 891L1024 1152L1664 1152ZM640 448L640 448Q640 514 665 572.50Q690 631 733.50 674.50Q777 718 835.50 743Q894 768 960 768L960 768Q1026 768 1084 743Q1142 718 1185.50 674.50Q1229 631 1254.50 572.50Q1280 514 1280 448L1280 448Q1280 382 1254.50 324Q1229 266 1185.50 222.50Q1142 179 1084 153.50Q1026 128 960 128L960 128Q894 128 835.50 153.50Q777 179 733.50 222.50Q690 266 665 324Q640 382 640 448ZM448 1792L448 1792Q448 1765 438 1742Q428 1719 410.50 1701.50Q393 1684 370 1674Q347 1664 320 1664L320 1664Q293 1664 270 1674Q247 1684 229.50 1701.50Q212 1719 202 1742Q192 1765 192 1792L192 1792Q192 1819 202 1842Q212 1865 229.50 1882.50Q247 1900 270 1910Q293 1920 320 1920L320 1920Q347 1920 370 1910Q393 1900 410.50 1882.50Q428 1865 438 1842Q448 1819 448 1792ZM1088 1792L1088 1792Q1088 1765 1078 1742Q1068 1719 1050.50 1701.50Q1033 1684 1010 1674Q987 1664 960 1664L960 1664Q933 1664 910 1674Q887 1684 869.50 1701.50Q852 1719 842 1742Q832 1765 832 1792L832 1792Q832 1819 842 1842Q852 1865 869.50 1882.50Q887 1900 910 1910Q933 1920 960 1920L960 1920Q987 1920 1010 1910Q1033 1900 1050.50 1882.50Q1068 1865 1078 1842Q1088 1819 1088 1792ZM1600 1920L1600 1920Q1627 1920 1650 1910Q1673 1900 1690.50 1882.50Q1708 1865 1718 1842Q1728 1819 1728 1792L1728 1792Q1728 1765 1718 1742Q1708 1719 1690.50 1701.50Q1673 1684 1650 1674Q1627 1664 1600 1664L1600 1664Q1573 1664 1550 1674Q1527 1684 1509.50 1701.50Q1492 1719 1482 1742Q1472 1765 1472 1792L1472 1792Q1472 1819 1482 1842Q1492 1865 1509.50 1882.50Q1527 1900 1550 1910Q1573 1920 1600 1920Z"
         }
      }
   ]
}

var BIDashboard = {
   name: "BIDashboard",
   vendor: "UiFabric",
   unicode: 62787,
   value: "",
   charCode: "F543",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 2048L512 896L896 896L896 2048L512 2048ZM640 1024L640 1920L768 1920L768 1024L640 1024ZM1024 2048L1024 1152L1408 1152L1408 2048L1024 2048ZM1152 1280L1152 1920L1280 1920L1280 1280L1152 1280ZM0 2048L0 1408L384 1408L384 2048L0 2048ZM128 1536L128 1920L256 1920L256 1536L128 1536ZM1536 2048L1536 640L1920 640L1920 2048L1536 2048ZM1664 768L1664 1920L1792 1920L1792 768L1664 768ZM1645 365L1389 621Q1408 662 1408 704L1408 704Q1408 744 1393 779Q1378 814 1352 840Q1326 866 1291 881Q1256 896 1216 896L1216 896Q1176 896 1141 881Q1106 866 1080 840Q1054 814 1039 779Q1024 744 1024 704L1024 704Q1024 698 1024 692Q1024 686 1025 680L1025 680L837 586Q811 612 776 626Q741 640 704 640L704 640Q662 640 621 621L621 621L365 877Q384 918 384 960L384 960Q384 1000 369 1035Q354 1070 328 1096Q302 1122 267 1137Q232 1152 192 1152L192 1152Q152 1152 117 1137Q82 1122 56 1096Q30 1070 15 1035Q0 1000 0 960L0 960Q0 920 15 885Q30 850 56 824Q82 798 117 783Q152 768 192 768L192 768Q234 768 275 787L275 787L531 531Q512 490 512 448L512 448Q512 408 527 373Q542 338 568 312Q594 286 629 271Q664 256 704 256L704 256Q744 256 779 271Q814 286 840 312Q866 338 881 373Q896 408 896 448L896 448Q896 454 896 460Q896 466 895 472L895 472L1083 566Q1109 540 1144 526Q1179 512 1216 512L1216 512Q1258 512 1299 531L1299 531L1555 275Q1536 234 1536 192L1536 192Q1536 152 1551 117Q1566 82 1592 56Q1618 30 1653 15Q1688 0 1728 0L1728 0Q1768 0 1803 15Q1838 30 1864 56Q1890 82 1905 117Q1920 152 1920 192L1920 192Q1920 232 1905 267Q1890 302 1864 328Q1838 354 1803 369Q1768 384 1728 384L1728 384Q1686 384 1645 365L1645 365ZM192 1024L192 1024Q218 1024 237 1005Q256 986 256 960L256 960Q256 934 237 915Q218 896 192 896L192 896Q166 896 147 915Q128 934 128 960L128 960Q128 986 147 1005Q166 1024 192 1024ZM1728 128L1728 128Q1702 128 1683 147Q1664 166 1664 192L1664 192Q1664 218 1683 237Q1702 256 1728 256L1728 256Q1754 256 1773 237Q1792 218 1792 192L1792 192Q1792 166 1773 147Q1754 128 1728 128ZM704 512L704 512Q730 512 749 493Q768 474 768 448L768 448Q768 422 749 403Q730 384 704 384L704 384Q678 384 659 403Q640 422 640 448L640 448Q640 474 659 493Q678 512 704 512ZM1216 768L1216 768Q1242 768 1261 749Q1280 730 1280 704L1280 704Q1280 678 1261 659Q1242 640 1216 640L1216 640Q1190 640 1171 659Q1152 678 1152 704L1152 704Q1152 730 1171 749Q1190 768 1216 768Z"
         }
      }
   ]
}

var CodeEdit = {
   name: "CodeEdit",
   vendor: "UiFabric",
   unicode: 62788,
   value: "",
   charCode: "F544",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M557 685L219 1024L424 1229L387 1374L37 1024L467 595L557 685ZM1765 779L2011 1024L1581 1453L1491 1363L1829 1024L1680 875Q1706 849 1727 826.50Q1748 804 1765 779L1765 779ZM1464 384L1464 384Q1506 384 1542.50 399Q1579 414 1606 441Q1633 468 1648.50 504Q1664 540 1664 582L1664 582Q1664 621 1649 658Q1634 695 1606 723L1606 723L889 1442L512 1536L606 1159L1323 441Q1351 413 1388 398.50Q1425 384 1464 384ZM823 1326L1515 633Q1536 612 1536 582L1536 582Q1536 551 1515.50 531.50Q1495 512 1464 512L1464 512Q1450 512 1437 516.50Q1424 521 1414 531L1414 531L722 1225L688 1360L823 1326Z"
         }
      }
   ]
}

var RenewalCurrent = {
   name: "RenewalCurrent",
   vendor: "UiFabric",
   unicode: 62789,
   value: "",
   charCode: "F545",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256ZM128 1792L1920 1792L1920 640L128 640L128 1792ZM787 877L877 787L1306 1216L877 1645L787 1555L1126 1216L787 877Z"
         }
      }
   ]
}

var RenewalFuture = {
   name: "RenewalFuture",
   vendor: "UiFabric",
   unicode: 62790,
   value: "",
   charCode: "F546",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM384 256L128 256L128 512L1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256ZM128 1792L1920 1792L1920 640L128 640L128 1792ZM621 787L1050 1216L621 1645L531 1555L870 1216L531 877L621 787ZM1043 877L1133 787L1562 1216L1133 1645L1043 1555L1382 1216L1043 877Z"
         }
      }
   ]
}

var SplitObject = {
   name: "SplitObject",
   vendor: "UiFabric",
   unicode: 62791,
   value: "",
   charCode: "F547",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1408L1600 1408Q1666 1408 1724 1433.50Q1782 1459 1825.50 1502.50Q1869 1546 1894.50 1604Q1920 1662 1920 1728L1920 1728Q1920 1794 1894.50 1852.50Q1869 1911 1825.50 1954.50Q1782 1998 1724 2023Q1666 2048 1600 2048L1600 2048Q1534 2048 1475.50 2023Q1417 1998 1373.50 1954.50Q1330 1911 1305 1852.50Q1280 1794 1280 1728L1280 1728Q1280 1654 1312.50 1588Q1345 1522 1403 1476L1403 1476L1101 873Q1032 896 960 896L960 896Q888 896 819 873L819 873L517 1476Q575 1522 607.50 1588Q640 1654 640 1728L640 1728Q640 1794 614.50 1852.50Q589 1911 545.50 1954.50Q502 1998 444 2023Q386 2048 320 2048L320 2048Q254 2048 195.50 2023Q137 1998 93.50 1954.50Q50 1911 25 1852.50Q0 1794 0 1728L0 1728Q0 1662 25 1604Q50 1546 93.50 1502.50Q137 1459 195.50 1433.50Q254 1408 320 1408L320 1408Q361 1408 403 1419L403 1419L705 816Q660 785 624 744.50Q588 704 563 656Q538 608 525 555.50Q512 503 512 448L512 448Q512 355 547 273.50Q582 192 643 131Q704 70 785.50 35Q867 0 960 0L960 0Q1053 0 1134.50 35Q1216 70 1277 131Q1338 192 1373 273.50Q1408 355 1408 448L1408 448Q1408 503 1395 555.50Q1382 608 1357 656Q1332 704 1296 744.50Q1260 785 1215 816L1215 816L1517 1419Q1559 1408 1600 1408ZM320 1920L320 1920Q360 1920 395 1905Q430 1890 456 1864Q482 1838 497 1803Q512 1768 512 1728L512 1728Q512 1688 497 1653Q482 1618 456 1592Q430 1566 395 1551Q360 1536 320 1536L320 1536Q280 1536 245 1551Q210 1566 184 1592Q158 1618 143 1653Q128 1688 128 1728L128 1728Q128 1768 143 1803Q158 1838 184 1864Q210 1890 245 1905Q280 1920 320 1920ZM640 448L640 448Q640 514 665 572.50Q690 631 733.50 674.50Q777 718 835.50 743Q894 768 960 768L960 768Q1026 768 1084 743Q1142 718 1185.50 674.50Q1229 631 1254.50 572.50Q1280 514 1280 448L1280 448Q1280 382 1254.50 324Q1229 266 1185.50 222.50Q1142 179 1084 153.50Q1026 128 960 128L960 128Q894 128 835.50 153.50Q777 179 733.50 222.50Q690 266 665 324Q640 382 640 448ZM1600 1920L1600 1920Q1640 1920 1675 1905Q1710 1890 1736 1864Q1762 1838 1777 1803Q1792 1768 1792 1728L1792 1728Q1792 1688 1777 1653Q1762 1618 1736 1592Q1710 1566 1675 1551Q1640 1536 1600 1536L1600 1536Q1560 1536 1525 1551Q1490 1566 1464 1592Q1438 1618 1423 1653Q1408 1688 1408 1728L1408 1728Q1408 1768 1423 1803Q1438 1838 1464 1864Q1490 1890 1525 1905Q1560 1920 1600 1920Z"
         }
      }
   ]
}

var BulkUpload = {
   name: "BulkUpload",
   vendor: "UiFabric",
   unicode: 62792,
   value: "",
   charCode: "F548",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 384L512 1920L1536 1920L1536 2048L384 2048L384 1792L128 1792L128 0L987 0Q1189 202 1389 402.50Q1589 603 1792 805L1792 805L1792 896L1152 896L1152 384L512 384ZM1280 475L1280 768L1573 768L1280 475ZM256 1664L384 1664L384 256L1061 256L933 128L256 128L256 1664ZM1411 1571L1728 1254L2045 1571L1955 1661L1792 1499L1792 2048L1664 2048L1664 1499L1501 1661L1411 1571ZM1408 1024L2048 1024L2048 1152L1408 1152L1408 1024Z"
         }
      }
   ]
}

var DownloadDocument = {
   name: "DownloadDocument",
   vendor: "UiFabric",
   unicode: 62793,
   value: "",
   charCode: "F549",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L1280 1920L1280 2048L128 2048L128 0L1243 0L1792 549L1792 896L1664 896L1664 640L1152 640L1152 128L256 128ZM1280 219L1280 512L1573 512L1280 219ZM1792 1024L1792 1573L1955 1411L2045 1501L1728 1818L1411 1501L1501 1411L1664 1573L1664 1024L1792 1024ZM1408 1920L2048 1920L2048 2048L1408 2048L1408 1920Z"
         }
      }
   ]
}

var GreetingCard = {
   name: "GreetingCard",
   vendor: "UiFabric",
   unicode: 62795,
   value: "",
   charCode: "F54B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 384L1664 384L1664 2048L256 2048L256 401L1408 41L1408 384ZM1280 384L1280 215L739 384L1280 384ZM1536 1920L1536 512L384 512L384 1920L1536 1920ZM960 902L960 902Q997 868 1043.50 850Q1090 832 1141 832L1141 832Q1196 832 1245 853Q1294 874 1330 910Q1366 946 1387 995Q1408 1044 1408 1100L1408 1100Q1408 1153 1388 1202Q1368 1251 1330 1289L1330 1289L960 1658L590 1289Q552 1251 532 1202Q512 1153 512 1100L512 1100Q512 1044 533 995Q554 946 590 910Q626 874 674.50 853Q723 832 779 832L779 832Q830 832 876.50 850Q923 868 960 902ZM960 1477L1239 1198Q1280 1157 1280 1100L1280 1100Q1280 1071 1269 1045.50Q1258 1020 1239 1001Q1220 982 1194.50 971Q1169 960 1140 960L1140 960Q1083 960 1042 1001L1042 1001L960 1083L878 1001Q837 960 780 960L780 960Q751 960 725.50 971Q700 982 681 1001Q662 1020 651 1045.50Q640 1071 640 1100L640 1100Q640 1157 681 1198L681 1198L960 1477Z"
         }
      }
   ]
}

var Flower = {
   name: "Flower",
   vendor: "UiFabric",
   unicode: 62798,
   value: "",
   charCode: "F54E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 576L1600 576Q1600 616 1585 651Q1570 686 1544 712Q1518 738 1483 753Q1448 768 1408 768L1408 768L1292 768Q1305 791 1319.50 813.50Q1334 836 1346 859.50Q1358 883 1366 908Q1374 933 1374 960L1374 960Q1374 999 1359 1034Q1344 1069 1318 1095.50Q1292 1122 1257 1137Q1222 1152 1182 1152L1182 1152Q1134 1152 1092.50 1130Q1051 1108 1024 1069L1024 1069L1024 1494Q1065 1443 1115.50 1403Q1166 1363 1223.50 1336Q1281 1309 1344 1294.50Q1407 1280 1472 1280L1472 1280L1536 1280L1536 1344Q1536 1454 1497 1552.50Q1458 1651 1389 1728Q1320 1805 1226.50 1854.50Q1133 1904 1024 1917L1024 1917L1024 2048L896 2048L896 1917Q787 1904 693.50 1854.50Q600 1805 531 1728Q462 1651 423 1552.50Q384 1454 384 1344L384 1344L384 1280L448 1280Q513 1280 576 1294.50Q639 1309 696.50 1336Q754 1363 804.50 1403Q855 1443 896 1494L896 1494L896 1069Q869 1108 827.50 1130Q786 1152 738 1152L738 1152Q698 1152 663 1137Q628 1122 602 1095.50Q576 1069 561 1034Q546 999 546 960L546 960Q546 933 554 908Q562 883 574 859.50Q586 836 600.50 813.50Q615 791 628 768L628 768L512 768Q472 768 437 753Q402 738 376 712Q350 686 335 651Q320 616 320 576L320 576Q320 536 335 501Q350 466 376 440Q402 414 437 399Q472 384 512 384L512 384L628 384Q615 362 600.50 339Q586 316 574 292.50Q562 269 554 244Q546 219 546 192L546 192Q546 153 561 118Q576 83 602 56.50Q628 30 663 15Q698 0 738 0L738 0Q781 0 812.50 13.50Q844 27 867 50Q890 73 908.50 103Q927 133 945 166L945 166L960 192L975 166Q993 133 1011.50 103Q1030 73 1053 50Q1076 27 1107 13.50Q1138 0 1182 0L1182 0Q1222 0 1257 15Q1292 30 1318 56.50Q1344 83 1359 118Q1374 153 1374 192L1374 192Q1374 219 1366 244Q1358 269 1346 292.50Q1334 316 1319.50 339Q1305 362 1292 384L1292 384L1408 384Q1448 384 1483 399Q1518 414 1544 440Q1570 466 1585 501Q1600 536 1600 576ZM1181 128L1181 128Q1164 128 1149 137Q1134 146 1126 160L1126 160L1029 329Q1092 347 1139 393L1139 393L1237 224Q1246 209 1246 192L1246 192Q1246 166 1227 147Q1208 128 1181 128ZM960 704L960 704Q987 704 1010 694Q1033 684 1050.50 666.50Q1068 649 1078 626Q1088 603 1088 576L1088 576Q1088 549 1078 526Q1068 503 1050.50 485.50Q1033 468 1010 458Q987 448 960 448L960 448Q933 448 910 458Q887 468 869.50 485.50Q852 503 842 526Q832 549 832 576L832 576Q832 603 842 626Q852 649 869.50 666.50Q887 684 910 694Q933 704 960 704ZM739 128L739 128Q712 128 693 147Q674 166 674 192L674 192Q674 209 683 224L683 224L781 393Q828 347 891 329L891 329L794 160Q786 146 771 137Q756 128 739 128ZM512 640L712 640Q708 624 706 608.50Q704 593 704 576L704 576Q704 559 706 543.50Q708 528 712 512L712 512L512 512Q486 512 467 531Q448 550 448 576L448 576Q448 602 467 621Q486 640 512 640L512 640ZM739 1024L739 1024Q756 1024 771 1015.50Q786 1007 794 992L794 992L891 823Q828 805 781 759L781 759L683 928Q674 943 674 960L674 960Q674 986 693 1005Q712 1024 739 1024ZM517 1413L517 1413Q528 1485 561 1548Q594 1611 643.50 1660.50Q693 1710 756 1743Q819 1776 891 1787L891 1787Q880 1715 847 1652Q814 1589 764.50 1539.50Q715 1490 652 1457Q589 1424 517 1413ZM1402 1413L1402 1413Q1330 1424 1267 1457Q1204 1490 1155 1539.50Q1106 1589 1073 1652Q1040 1715 1029 1787L1029 1787Q1101 1776 1164 1743Q1227 1710 1276.50 1660.50Q1326 1611 1358.50 1548Q1391 1485 1402 1413ZM1181 1024L1181 1024Q1208 1024 1227 1005Q1246 986 1246 960L1246 960Q1246 943 1237 928L1237 928L1139 759Q1092 805 1029 823L1029 823L1126 992Q1134 1007 1149 1015.50Q1164 1024 1181 1024ZM1208 640L1408 640Q1434 640 1453 621Q1472 602 1472 576L1472 576Q1472 550 1453 531Q1434 512 1408 512L1408 512L1208 512Q1212 528 1214 543.50Q1216 559 1216 576L1216 576Q1216 593 1214 608.50Q1212 624 1208 640L1208 640Z"
         }
      }
   ]
}

var WaitlistConfirm = {
   name: "WaitlistConfirm",
   vendor: "UiFabric",
   unicode: 62800,
   value: "",
   charCode: "F550",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L1536 640L1024 640L1024 512L1536 512ZM1024 1152L1024 1024L1536 1024L1536 1152L1024 1152ZM384 1920L1155 1920L1283 2048L256 2048L256 0L1792 0L1792 1283L1664 1411L1664 128L384 128L384 1920ZM851 339L941 429L704 666L531 493L621 403L704 486L851 339ZM851 851L941 941L704 1178L531 1005L621 915L704 998L851 851ZM621 1427L704 1510L851 1363L941 1453L704 1690L531 1517L621 1427ZM1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363Z"
         }
      }
   ]
}

var LaptopSecure = {
   name: "LaptopSecure",
   vendor: "UiFabric",
   unicode: 62802,
   value: "",
   charCode: "F552",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M64 1536L884 1536Q899 1603 926 1664L926 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536Q0 1520 3 1501.50Q6 1483 11.50 1464Q17 1445 25.50 1428.50Q34 1412 46 1400L46 1400L256 1189L256 256L1792 256L1792 867Q1762 850 1729.50 839Q1697 828 1664 820L1664 820L1664 384L384 384L384 1152L864 1152L864 1280L347 1280L141 1485Q138 1488 135.50 1495Q133 1502 131.50 1509.50Q130 1517 129 1524.50Q128 1532 128 1536L128 1536L64 1536ZM1536 965L1536 965Q1595 965 1644 979Q1693 993 1744 1022L1744 1022Q1786 1047 1840 1053.50Q1894 1060 1948 1060L1948 1060Q1974 1060 1999.50 1059.50Q2025 1059 2048 1059L2048 1059L2048 1384Q2048 1489 2010 1582.50Q1972 1676 1908.50 1755.50Q1845 1835 1763.50 1899Q1682 1963 1595 2009L1595 2009L1536 2040L1476 2009Q1389 1964 1307.50 1899.50Q1226 1835 1163 1755Q1100 1675 1062 1581.50Q1024 1488 1024 1384L1024 1384L1024 1059Q1048 1059 1074.50 1059.50Q1101 1060 1128 1060L1128 1060Q1181 1060 1234.50 1053.50Q1288 1047 1330 1021L1330 1021Q1380 992 1429 978.50Q1478 965 1536 965ZM1920 1384L1920 1187Q1854 1187 1793 1175Q1732 1163 1675 1130L1675 1130Q1641 1110 1608.50 1101.50Q1576 1093 1536 1093L1536 1093Q1498 1093 1465 1101.50Q1432 1110 1399 1129L1399 1129Q1341 1162 1279.50 1174.50Q1218 1187 1152 1187L1152 1187L1152 1384Q1152 1470 1185.50 1546.50Q1219 1623 1273.50 1688.50Q1328 1754 1396.50 1806.50Q1465 1859 1536 1896L1536 1896Q1606 1859 1675 1806.50Q1744 1754 1798.50 1688.50Q1853 1623 1886.50 1546.50Q1920 1470 1920 1384L1920 1384Z"
         }
      }
   ]
}

var EntryView = {
   name: "EntryView",
   vendor: "UiFabric",
   unicode: 62804,
   value: "",
   charCode: "F554",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1920L777 1920Q792 1955 813.50 1987Q835 2019 861 2048L861 2048L0 2048L0 0L1536 0L1536 911Q1504 902 1472 894Q1440 886 1408 881L1408 881L1408 128L128 128L128 1920ZM1280 384L1280 512L256 512L256 384L1280 384ZM256 896L256 768L1280 768L1280 896L256 896ZM1216 1408L1216 1408Q1282 1408 1340 1433.50Q1398 1459 1441.50 1502.50Q1485 1546 1510.50 1604Q1536 1662 1536 1728L1536 1728Q1536 1794 1510.50 1852.50Q1485 1911 1441.50 1954.50Q1398 1998 1340 2023Q1282 2048 1216 2048L1216 2048Q1150 2048 1091.50 2023Q1033 1998 989.50 1954.50Q946 1911 921 1852.50Q896 1794 896 1728L896 1728Q896 1662 921 1604Q946 1546 989.50 1502.50Q1033 1459 1091.50 1433.50Q1150 1408 1216 1408ZM1216 1920L1216 1920Q1256 1920 1291 1905Q1326 1890 1352 1864Q1378 1838 1393 1803Q1408 1768 1408 1728L1408 1728Q1408 1688 1393 1653Q1378 1618 1352 1592Q1326 1566 1291 1551Q1256 1536 1216 1536L1216 1536Q1176 1536 1141 1551Q1106 1566 1080 1592Q1054 1618 1039 1653Q1024 1688 1024 1728L1024 1728Q1024 1768 1039 1803Q1054 1838 1080 1864Q1106 1890 1141 1905Q1176 1920 1216 1920ZM1216 1024L1216 1024Q1316 1024 1416.50 1045.50Q1517 1067 1609.50 1109Q1702 1151 1782 1212Q1862 1273 1921 1351Q1980 1429 2014 1524Q2048 1619 2048 1728L2048 1728L1920 1728Q1920 1637 1890.50 1559Q1861 1481 1810 1417Q1759 1353 1690.50 1303.50Q1622 1254 1544 1220.50Q1466 1187 1382 1169.50Q1298 1152 1216 1152L1216 1152Q1134 1152 1050 1169.50Q966 1187 888 1220.50Q810 1254 741.50 1303.50Q673 1353 622 1417Q571 1481 541.50 1559Q512 1637 512 1728L512 1728L384 1728Q384 1619 418 1524Q452 1429 511 1351Q570 1273 650 1212Q730 1151 822.50 1109Q915 1067 1015.50 1045.50Q1116 1024 1216 1024Z"
         }
      }
   ]
}

var ContactCardSettings = {
   name: "ContactCardSettings",
   vendor: "UiFabric",
   unicode: 62806,
   value: "",
   charCode: "F556",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 768L1792 896L1152 896L1152 768L1792 768ZM0 256L2048 256L2048 1243Q2020 1208 1988.50 1177Q1957 1146 1920 1121L1920 1121L1920 384L128 384L128 1664L1031 1664Q1034 1697 1041 1729Q1048 1761 1059 1792L1059 1792L0 1792L0 256ZM384 1408L256 1408Q256 1356 270 1306.50Q284 1257 310 1213.50Q336 1170 373 1134Q410 1098 456 1073L456 1073Q422 1038 403 992Q384 946 384 896L384 896Q384 843 404 796.50Q424 750 459 715Q494 680 540.50 660Q587 640 640 640L640 640Q693 640 739.50 660Q786 680 821 715Q856 750 876 796.50Q896 843 896 896L896 896Q896 946 877 992Q858 1038 824 1073L824 1073Q870 1098 907 1134Q944 1170 970 1213.50Q996 1257 1010 1306.50Q1024 1356 1024 1408L1024 1408L896 1408Q896 1355 876 1308.50Q856 1262 821 1227Q786 1192 739.50 1172Q693 1152 640 1152L640 1152Q587 1152 540.50 1172Q494 1192 459 1227Q424 1262 404 1308.50Q384 1355 384 1408L384 1408ZM640 768L640 768Q613 768 590 778Q567 788 549.50 805.50Q532 823 522 846Q512 869 512 896L512 896Q512 923 522 946Q532 969 549.50 986.50Q567 1004 590 1014Q613 1024 640 1024L640 1024Q667 1024 690 1014Q713 1004 730.50 986.50Q748 969 758 946Q768 923 768 896L768 896Q768 869 758 846Q748 823 730.50 805.50Q713 788 690 778Q667 768 640 768ZM1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792Z"
         }
      }
   ]
}

var CalendarSettings = {
   name: "CalendarSettings",
   vendor: "UiFabric",
   unicode: 62808,
   value: "",
   charCode: "F558",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L2048 128L2048 1192Q1991 1130 1920 1085L1920 1085L1920 640L128 640L128 1792L1026 1792Q1037 1826 1051.50 1858Q1066 1890 1085 1920L1085 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512L1920 512ZM896 1280L896 1408L768 1408L768 1280L896 1280ZM1152 1152L1152 1024L1280 1024L1280 1085Q1233 1115 1192 1152L1192 1152L1152 1152ZM1280 768L1280 896L1152 896L1152 768L1280 768ZM1664 768L1664 896L1536 896L1536 768L1664 768ZM512 1280L512 1408L384 1408L384 1280L512 1280ZM384 1664L384 1536L512 1536L512 1664L384 1664ZM512 1024L512 1152L384 1152L384 1024L512 1024ZM896 768L896 896L768 896L768 768L896 768ZM768 1664L768 1536L896 1536L896 1664L768 1664ZM896 1024L896 1152L768 1152L768 1024L896 1024ZM1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792Z"
         }
      }
   ]
}

var HardDriveLock = {
   name: "HardDriveLock",
   vendor: "UiFabric",
   unicode: 62810,
   value: "",
   charCode: "F55A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M320 512L1728 512Q1794 512 1852 537.50Q1910 563 1953.50 606.50Q1997 650 2022.50 708Q2048 766 2048 832L2048 832L2048 1124Q2028 1074 1995 1031Q1962 988 1920 955L1920 955L1920 832Q1920 792 1905 757Q1890 722 1864 696Q1838 670 1803 655Q1768 640 1728 640L1728 640L320 640Q280 640 245 655Q210 670 184 696Q158 722 143 757Q128 792 128 832L128 832L128 1152L1280 1152L1280 1280L0 1280L0 832Q0 766 25 708Q50 650 93.50 606.50Q137 563 195.50 537.50Q254 512 320 512L320 512ZM1664 768L1792 768L1792 896L1664 896L1664 768ZM1536 768L1536 896L1408 896L1408 768L1536 768ZM1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1410 1408L1410 1280Q1411 1227 1430.50 1180.50Q1450 1134 1484 1099Q1518 1064 1564 1044Q1610 1024 1664 1024ZM1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920Z"
         }
      }
   ]
}

var AccountManagement = {
   name: "AccountManagement",
   vendor: "UiFabric",
   unicode: 62812,
   value: "",
   charCode: "F55C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1152L1148 1152Q1065 1090 968.50 1057Q872 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q440 911 395.50 863.50Q351 816 320 760Q289 704 272.50 641Q256 578 256 512L256 512Q256 406 296.50 313Q337 220 406.50 150.50Q476 81 569 40.50Q662 0 768 0L768 0Q874 0 967 40.50Q1060 81 1129.50 150.50Q1199 220 1239.50 313Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140 863.50Q1095 911 1039 946L1039 946Q1099 969 1152 1000L1152 1000L1152 1152ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1792 1280L2048 1280L2048 2048L1024 2048L1024 1280L1280 1280L1280 1024L1792 1024L1792 1280ZM1408 1152L1408 1280L1664 1280L1664 1152L1408 1152ZM1920 1920L1920 1664L1792 1664L1792 1792L1664 1792L1664 1664L1408 1664L1408 1792L1280 1792L1280 1664L1152 1664L1152 1920L1920 1920ZM1920 1536L1920 1408L1152 1408L1152 1536L1920 1536Z"
         }
      }
   ]
}

var ReportWarning = {
   name: "ReportWarning",
   vendor: "UiFabric",
   unicode: 62825,
   value: "",
   charCode: "F569",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1664L910 1664L846 1792L256 1792L256 0L1792 0L1792 1179L1664 923L1664 128L384 128L384 1664ZM640 768L640 896L512 896L512 768L640 768ZM1358 768L1294 896L768 896L768 768L1358 768ZM512 1280L512 1152L640 1152L640 1280L512 1280ZM768 1280L768 1152L1166 1152L1102 1280L768 1280ZM640 384L640 512L512 512L512 384L640 384ZM1536 384L1536 512L768 512L768 384L1536 384ZM1408 1408L1536 1408L1536 1728L1408 1728L1408 1408ZM1408 1920L1408 1792L1536 1792L1536 1920L1408 1920ZM1472 896L2048 2048L896 2048L1472 896ZM1472 1146L1077 1936L1867 1936L1472 1146Z"
         }
      }
   ]
}

var HardDriveUnlock = {
   name: "HardDriveUnlock",
   vendor: "UiFabric",
   unicode: 62811,
   value: "",
   charCode: "F55B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M320 512L1728 512Q1794 512 1852 537.50Q1910 563 1953.50 606.50Q1997 650 2022.50 708Q2048 766 2048 832L2048 832L2048 1124Q2028 1074 1995 1031Q1962 988 1920 955L1920 955L1920 832Q1920 792 1905 757Q1890 722 1864 696Q1838 670 1803 655Q1768 640 1728 640L1728 640L320 640Q280 640 245 655Q210 670 184 696Q158 722 143 757Q128 792 128 832L128 832L128 1152L1280 1152L1280 1280L0 1280L0 832Q0 766 25 708Q50 650 93.50 606.50Q137 563 195.50 537.50Q254 512 320 512L320 512ZM1664 768L1792 768L1792 896L1664 896L1664 768ZM1536 768L1536 896L1408 896L1408 768L1536 768ZM1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280L1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280L1536 1280L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024ZM1920 1920L1920 1536L1408 1536L1408 1920L1920 1920Z"
         }
      }
   ]
}

var CalendarSettingsMirrored = {
   name: "CalendarSettingsMirrored",
   vendor: "UiFabric",
   unicode: 62809,
   value: "",
   charCode: "F559",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 768L1280 896L1152 896L1152 768L1280 768ZM896 1280L896 1408L768 1408L768 1280L896 1280ZM1664 128L2048 128L2048 1192Q1991 1130 1920 1085L1920 1085L1920 640L128 640L128 1792L1026 1792Q1037 1826 1051.50 1858Q1066 1890 1085 1920L1085 1920L0 1920L0 128L384 128L384 0L512 0L512 128L1536 128L1536 0L1664 0L1664 128ZM1920 512L1920 256L1664 256L1664 384L1536 384L1536 256L512 256L512 384L384 384L384 256L128 256L128 512L1920 512ZM1152 1152L1152 1024L1280 1024L1280 1085Q1233 1115 1192 1152L1192 1152L1152 1152ZM384 1408L384 1280L512 1280L512 1408L384 1408ZM512 768L512 896L384 896L384 768L512 768ZM512 1024L512 1152L384 1152L384 1024L512 1024ZM896 768L896 896L768 896L768 768L896 768ZM768 1664L768 1536L896 1536L896 1664L768 1664ZM896 1024L896 1152L768 1152L768 1024L896 1024ZM1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369ZM1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792Z"
         }
      }
   ]
}

var ContactCardSettingsMirrored = {
   name: "ContactCardSettingsMirrored",
   vendor: "UiFabric",
   unicode: 62807,
   value: "",
   charCode: "F557",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 768L256 896L896 896L896 768L256 768ZM2048 256L0 256L0 1243Q28 1208 59.50 1177Q91 1146 128 1121L128 1121L128 384L1920 384L1920 1664L1017 1664Q1014 1697 1007 1729Q1000 1761 989 1792L989 1792L2048 1792L2048 256ZM1664 1408L1792 1408Q1792 1356 1778 1306.50Q1764 1257 1738 1213.50Q1712 1170 1675 1134Q1638 1098 1592 1073L1592 1073Q1626 1038 1645 992Q1664 946 1664 896L1664 896Q1664 843 1644 796.50Q1624 750 1589 715Q1554 680 1507.50 660Q1461 640 1408 640L1408 640Q1355 640 1308.50 660Q1262 680 1227 715Q1192 750 1172 796.50Q1152 843 1152 896L1152 896Q1152 946 1171 992Q1190 1038 1224 1073L1224 1073Q1178 1098 1141 1134Q1104 1170 1078 1213.50Q1052 1257 1038 1306.50Q1024 1356 1024 1408L1024 1408L1152 1408Q1152 1355 1172 1308.50Q1192 1262 1227 1227Q1262 1192 1308.50 1172Q1355 1152 1408 1152L1408 1152Q1461 1152 1507.50 1172Q1554 1192 1589 1227Q1624 1262 1644 1308.50Q1664 1355 1664 1408L1664 1408ZM1408 768L1408 768Q1435 768 1458 778Q1481 788 1498.50 805.50Q1516 823 1526 846Q1536 869 1536 896L1536 896Q1536 923 1526 946Q1516 969 1498.50 986.50Q1481 1004 1458 1014Q1435 1024 1408 1024L1408 1024Q1381 1024 1358 1014Q1335 1004 1317.50 986.50Q1300 969 1290 946Q1280 923 1280 896L1280 896Q1280 869 1290 846Q1300 823 1317.50 805.50Q1335 788 1358 778Q1381 768 1408 768ZM59 1369L10 1488L134 1539Q128 1569 128 1600L128 1600Q128 1631 134 1661L134 1661L10 1712L59 1831L183 1779Q218 1830 269 1865L269 1865L217 1989L336 2038L387 1914Q417 1920 448 1920L448 1920Q479 1920 509 1914L509 1914L560 2038L679 1989L627 1865Q678 1830 713 1779L713 1779L837 1831L886 1712L762 1661Q768 1631 768 1600L768 1600Q768 1569 762 1539L762 1539L886 1488L837 1369L713 1421Q678 1370 627 1335L627 1335L679 1211L560 1162L509 1286Q479 1280 448 1280L448 1280Q417 1280 387 1286L387 1286L336 1162L217 1211L269 1335Q218 1370 183 1421L183 1421L59 1369ZM448 1792L448 1792Q408 1792 373 1777Q338 1762 312 1736Q286 1710 271 1675Q256 1640 256 1600L256 1600Q256 1560 271 1525Q286 1490 312 1464Q338 1438 373 1423Q408 1408 448 1408L448 1408Q488 1408 523 1423Q558 1438 584 1464Q610 1490 625 1525Q640 1560 640 1600L640 1600Q640 1640 625 1675Q610 1710 584 1736Q558 1762 523 1777Q488 1792 448 1792Z"
         }
      }
   ]
}

var EntryDecline = {
   name: "EntryDecline",
   vendor: "UiFabric",
   unicode: 62805,
   value: "",
   charCode: "F555",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 896L512 768L1536 768L1536 896L512 896ZM1536 384L1536 512L512 512L512 384L1536 384ZM384 1920L1152 1920L1279 2048L256 2048L256 0L1792 0L1792 1348L1728 1411L1664 1347L1664 128L384 128L384 1920ZM1725 2048L1728 2045L1731 2048L1725 2048ZM512 1152L1536 1152L1407 1280L512 1280L512 1152ZM512 1536L1219 1536L1347 1664L512 1664L512 1536ZM2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411L2045 1502Z"
         }
      }
   ]
}

var DragObject = {
   name: "DragObject",
   vendor: "UiFabric",
   unicode: 62803,
   value: "",
   charCode: "F553",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 1478L1043 1395L1133 1485L960 1659L787 1485L877 1395L960 1478ZM960 443L877 526L787 435L960 262L1133 435L1043 526L960 443ZM179 787L269 877L187 960L269 1043L179 1133L6 960L179 787ZM1741 787L1914 960L1741 1133L1651 1043L1734 960L1651 877L1741 787ZM384 768L384 640L1536 640L1536 768L384 768ZM384 1024L384 896L1536 896L1536 1024L384 1024ZM384 1280L384 1152L1536 1152L1536 1280L384 1280Z"
         }
      }
   ]
}

var WaitlistConfirmMirrored = {
   name: "WaitlistConfirmMirrored",
   vendor: "UiFabric",
   unicode: 62801,
   value: "",
   charCode: "F551",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1261 915L1344 998L1491 851L1581 941L1344 1178L1171 1005L1261 915ZM512 1664L512 1536L1024 1536L1024 1664L512 1664ZM1024 512L1024 640L512 640L512 512L1024 512ZM1024 1024L1024 1152L512 1152L512 1024L1024 1024ZM1491 339L1581 429L1344 666L1171 493L1261 403L1344 486L1491 339ZM384 1920L1155 1920L1283 2048L256 2048L256 0L1792 0L1792 1283L1664 1411L1664 128L384 128L384 1920ZM1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829L1939 1363Z"
         }
      }
   ]
}

var PlaySolid = {
   name: "PlaySolid",
   vendor: "UiFabric",
   unicode: 62896,
   value: "",
   charCode: "F5B0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 128L1792 1024L512 1920L512 128Z"
         }
      }
   ]
}

var TransitionPush = {
   name: "TransitionPush",
   vendor: "UiFabric",
   unicode: 62899,
   value: "",
   charCode: "F5B3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM128 512L128 1408L1920 1408L1920 512L128 512ZM0 128L2048 128L2048 256L0 256L0 128ZM0 1792L0 1664L2048 1664L2048 1792L0 1792ZM1533 733L1371 896L1792 896L1792 1024L1371 1024L1533 1187L1443 1277L1126 960L1443 643L1533 733ZM515 733L605 643L922 960L605 1277L515 1187L677 1024L256 1024L256 896L677 896L515 733Z"
         }
      }
   ]
}

var LookupEntities = {
   name: "LookupEntities",
   vendor: "UiFabric",
   unicode: 62901,
   value: "",
   charCode: "F5B5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 128L2048 835L1920 707L1920 256L1408 256L1408 768L1280 768L1280 256L768 256L768 1664L1280 1664L1280 1152L1408 1152L1408 1664L1920 1664L1920 1213L2048 1085L2048 1792L0 1792L0 128L2048 128ZM640 1152L640 768L128 768L128 1152L640 1152ZM128 1664L640 1664L640 1280L128 1280L128 1664ZM640 640L640 256L128 256L128 640L640 640ZM1629 1277L1539 1187L1701 1024L1024 1024L1024 896L1701 896L1539 733L1629 643L1946 960L1629 1277Z"
         }
      }
   ]
}

var AddBookmark = {
   name: "AddBookmark",
   vendor: "UiFabric",
   unicode: 62903,
   value: "",
   charCode: "F5B7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1581L1024 1581Q1056 1597 1088 1613Q1120 1629 1152 1646L1152 1646L1152 1789L1024 1725L384 2048L384 0L1664 0L1664 1280L1536 1280L1536 128L512 128L512 1840Q641 1775 768 1710Q895 1645 1024 1581ZM1664 1664L1920 1664L1920 1792L1664 1792L1664 2048L1536 2048L1536 1792L1280 1792L1280 1664L1536 1664L1536 1408L1664 1408L1664 1664Z"
         }
      }
   ]
}

var DrillThrough = {
   name: "DrillThrough",
   vendor: "UiFabric",
   unicode: 62905,
   value: "",
   charCode: "F5B9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296.50Q0 1166 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 751.50 36.50Q882 0 1024 0ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1262Q1920 1148 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q901 128 786.50 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1147 160 1261.50Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786 1888Q900 1920 1024 1920ZM1043 621L1133 531L1627 1023L1133 1517L1043 1427L1382 1088L832 1088Q743 1088 660.50 1054Q578 1020 515 957L515 957Q452 894 418 811.50Q384 729 384 640L384 640L512 640Q512 706 537 764.50Q562 823 605.50 866.50Q649 910 707.50 935Q766 960 832 960L832 960Q970 960 1106.50 959.50Q1243 959 1381 959L1381 959L1043 621Z"
         }
      }
   ]
}

var CertifiedDatabase = {
   name: "CertifiedDatabase",
   vendor: "UiFabric",
   unicode: 62907,
   value: "",
   charCode: "F5BB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 637L384 1600Q384 1619 397 1635.50Q410 1652 424 1663L424 1663Q470 1701 538.50 1726Q607 1751 681.50 1765.50Q756 1780 829.50 1786Q903 1792 960 1792L960 1792Q1041 1792 1121 1783.50Q1201 1775 1280 1756L1280 1756L1280 1886Q1201 1904 1121 1912Q1041 1920 960 1920L960 1920Q899 1920 838.50 1915.50Q778 1911 718 1901L718 1901Q680 1895 631.50 1884Q583 1873 531.50 1856Q480 1839 430.50 1815.50Q381 1792 342.50 1760.50Q304 1729 280 1689Q256 1649 256 1600L256 1600L256 448Q256 399 280 359Q304 319 342.50 287.50Q381 256 430.50 232.50Q480 209 531.50 192Q583 175 631.50 164Q680 153 718 147L718 147Q778 137 838.50 132.50Q899 128 960 128L960 128Q1021 128 1081.50 132.50Q1142 137 1202 147L1202 147Q1239 153 1288 164Q1337 175 1388.50 192Q1440 209 1489.50 232.50Q1539 256 1577.50 287.50Q1616 319 1640 359Q1664 399 1664 448L1664 448L1664 768L1536 768L1536 637Q1478 674 1406 699Q1334 724 1257.50 739.50Q1181 755 1104.50 761.50Q1028 768 960 768L960 768Q892 768 815.50 761.50Q739 755 662.50 739.50Q586 724 514 699Q442 674 384 637L384 637ZM960 256L960 256Q903 256 829.50 262Q756 268 681.50 282.50Q607 297 538.50 322Q470 347 424 385L424 385Q410 396 397 412.50Q384 429 384 448L384 448Q384 467 397 483.50Q410 500 424 511L424 511Q470 549 538.50 574Q607 599 681.50 613.50Q756 628 829.50 634Q903 640 960 640L960 640Q1017 640 1090.50 634Q1164 628 1238.50 613.50Q1313 599 1381 574Q1449 549 1495 511L1495 511Q1509 500 1522.50 483.50Q1536 467 1536 448L1536 448Q1536 429 1522.50 412.50Q1509 396 1495 385L1495 385Q1449 347 1381 322Q1313 297 1238.50 282.50Q1164 268 1090.50 262Q1017 256 960 256ZM2048 1280L2048 1280Q2048 1362 2014 1436.50Q1980 1511 1920 1566L1920 1566L1920 2023L1664 1895L1408 2023L1408 1566Q1348 1511 1314 1436.50Q1280 1362 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280ZM1792 1816L1792 1642Q1728 1664 1664 1664L1664 1664Q1600 1664 1536 1642L1536 1642L1536 1816L1664 1752L1792 1816ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var MinimumValue = {
   name: "MinimumValue",
   vendor: "UiFabric",
   unicode: 62909,
   value: "",
   charCode: "F5BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1408L1024 512L1152 512L1152 1408L1024 1408ZM768 1408L768 512L896 512L896 1408L768 1408ZM1920 896L1920 1024L1499 1024L1661 1187L1571 1277L1254 960L1571 643L1661 733L1499 896L1920 896ZM259 733L349 643L666 960L349 1277L259 1187L421 1024L0 1024L0 896L421 896L259 733Z"
         }
      }
   ]
}

var PasteAsText = {
   name: "PasteAsText",
   vendor: "UiFabric",
   unicode: 62933,
   value: "",
   charCode: "F5D5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 384L256 1792L1024 1792L1024 1920L128 1920L128 256L640 256Q640 203 660 156.50Q680 110 715 75Q750 40 796.50 20Q843 0 896 0L896 0Q949 0 995.50 20Q1042 40 1077 75Q1112 110 1132 156.50Q1152 203 1152 256L1152 256L1664 256L1664 896L1536 896L1536 384L1408 384L1408 640L384 640L384 384L256 384ZM768 384L512 384L512 512L1280 512L1280 384L1024 384L1024 256Q1024 229 1014 206Q1004 183 986.50 165.50Q969 148 946 138Q923 128 896 128L896 128Q869 128 846 138Q823 148 805.50 165.50Q788 183 778 206Q768 229 768 256L768 256L768 384ZM1667 1024L2009 2048L1874 2048L1789 1792L1411 1792L1326 2048L1191 2048L1533 1024L1667 1024ZM1454 1664L1746 1664L1600 1227L1454 1664Z"
         }
      }
   ]
}

var BrowserTab = {
   name: "BrowserTab",
   vendor: "UiFabric",
   unicode: 62935,
   value: "",
   charCode: "F5D7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 256L1792 256L1792 2048L128 2048L128 0L1024 0L1024 256ZM1664 1920L1664 384L896 384L896 128L256 128L256 1920L1664 1920Z"
         }
      }
   ]
}

var DesktopScreenshot = {
   name: "DesktopScreenshot",
   vendor: "UiFabric",
   unicode: 62937,
   value: "",
   charCode: "F5D9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1536L1152 1536L1152 1664L1408 1664L1408 1792L768 1792L768 1664L1024 1664L1024 1536L128 1536L128 1152L256 1152L256 1408L1920 1408L1920 512L1408 512L1408 384L2048 384L2048 1536ZM1280 128L1280 1024L0 1024L0 128L293 128L421 0L859 0L987 128L1280 128ZM1152 896L1152 256L933 256L805 128L475 128L347 256L128 256L128 896L1152 896ZM640 256L640 256Q693 256 739.50 276Q786 296 821 331Q856 366 876 412.50Q896 459 896 512L896 512Q896 565 876 611.50Q856 658 821 693Q786 728 739.50 748Q693 768 640 768L640 768Q587 768 540.50 748Q494 728 459 693Q424 658 404 611.50Q384 565 384 512L384 512Q384 459 404 412.50Q424 366 459 331Q494 296 540.50 276Q587 256 640 256ZM640 640L640 640Q667 640 690 630Q713 620 730.50 602.50Q748 585 758 562Q768 539 768 512L768 512Q768 485 758 462Q748 439 730.50 421.50Q713 404 690 394Q667 384 640 384L640 384Q613 384 590 394Q567 404 549.50 421.50Q532 439 522 462Q512 485 512 512L512 512Q512 539 522 562Q532 585 549.50 602.50Q567 620 590 630Q613 640 640 640Z"
         }
      }
   ]
}

var FabricUserFolder = {
   name: "FabricUserFolder",
   vendor: "UiFabric",
   unicode: 62949,
   value: "",
   charCode: "F5E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1103Q2028 1044 1996 991.50Q1964 939 1920 895L1920 895L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L1024 1536L1024 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1039.50 228.50Q1061 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1764 1589L1764 1589Q1829 1622 1881.50 1670.50Q1934 1719 1971 1778.50Q2008 1838 2028 1906.50Q2048 1975 2048 2048L2048 2048L1920 2048Q1920 1969 1890 1899Q1860 1829 1807.50 1776.50Q1755 1724 1685 1694Q1615 1664 1536 1664L1536 1664Q1456 1664 1386.50 1694Q1317 1724 1264.50 1776.50Q1212 1829 1182 1899Q1152 1969 1152 2048L1152 2048L1024 2048Q1024 1975 1044 1906.50Q1064 1838 1101 1778.50Q1138 1719 1190.50 1670.50Q1243 1622 1308 1589L1308 1589Q1234 1534 1193 1453Q1152 1372 1152 1280L1152 1280Q1152 1201 1182 1131Q1212 1061 1264.50 1008.50Q1317 956 1386.50 926Q1456 896 1536 896L1536 896Q1615 896 1685 926Q1755 956 1807.50 1008.50Q1860 1061 1890 1131Q1920 1201 1920 1280L1920 1280Q1920 1372 1879 1453Q1838 1534 1764 1589ZM1280 1280L1280 1280Q1280 1333 1300 1379.50Q1320 1426 1355 1461Q1390 1496 1436.50 1516Q1483 1536 1536 1536L1536 1536Q1589 1536 1635.50 1516Q1682 1496 1717 1461Q1752 1426 1772 1379.50Q1792 1333 1792 1280L1792 1280Q1792 1227 1772 1180.50Q1752 1134 1717 1099Q1682 1064 1635.50 1044Q1589 1024 1536 1024L1536 1024Q1483 1024 1436.50 1044Q1390 1064 1355 1099Q1320 1134 1300 1180.50Q1280 1227 1280 1280Z"
         }
      }
   ]
}

var FabricNetworkFolder = {
   name: "FabricNetworkFolder",
   vendor: "UiFabric",
   unicode: 62950,
   value: "",
   charCode: "F5E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1015Q1993 945 1920 889L1920 889L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L768 1536L768 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248.50 2002.50Q1144 1957 1066 1879Q988 1801 943 1696Q898 1591 898 1472L898 1472Q898 1353 943 1248Q988 1143 1066 1065Q1144 987 1248.50 941.50Q1353 896 1472 896ZM1715 1280L1894 1280Q1857 1199 1792 1137Q1727 1075 1645 1041L1645 1041Q1673 1098 1689.50 1158Q1706 1218 1715 1280L1715 1280ZM1936 1472L1936 1472Q1936 1456 1935 1440Q1934 1424 1931 1408L1931 1408L1727 1408L1727 1472Q1727 1488 1727 1504Q1727 1520 1726 1536L1726 1536L1931 1536Q1934 1520 1935 1504Q1936 1488 1936 1472ZM1600 1664L1600 1664L1341 1664Q1348 1713 1360.50 1761.50Q1373 1810 1396 1855L1396 1855Q1400 1864 1408.50 1877.50Q1417 1891 1427 1904Q1437 1917 1449 1926.50Q1461 1936 1473 1936L1473 1936Q1482 1936 1489.50 1930Q1497 1924 1503 1918L1503 1918Q1523 1898 1539 1866.50Q1555 1835 1567 1799Q1579 1763 1587 1727.50Q1595 1692 1600 1664ZM1329 1536L1329 1536L1614 1536Q1615 1520 1615.50 1504Q1616 1488 1616 1472L1616 1472Q1616 1456 1615.50 1440Q1615 1424 1614 1408L1614 1408L1329 1408Q1329 1424 1328.50 1440Q1328 1456 1328 1472L1328 1472Q1328 1488 1328.50 1504Q1329 1520 1329 1536ZM1015 1536L1015 1536L1217 1536L1217 1408L1015 1408Q1013 1424 1011.50 1440Q1010 1456 1010 1472L1010 1472Q1010 1488 1011.50 1504Q1013 1520 1015 1536ZM1341 1280L1341 1280L1601 1280Q1593 1232 1580.50 1185Q1568 1138 1546 1095L1546 1095Q1543 1089 1534.50 1074.50Q1526 1060 1515 1045Q1504 1030 1492.50 1019Q1481 1008 1472 1008L1472 1008Q1461 1008 1449.50 1018Q1438 1028 1427.50 1041.50Q1417 1055 1408.50 1069Q1400 1083 1396 1091L1396 1091Q1375 1132 1362 1183.50Q1349 1235 1341 1280ZM1052 1280L1052 1280L1228 1280Q1237 1219 1252.50 1159Q1268 1099 1295 1043L1295 1043Q1214 1077 1151 1138.50Q1088 1200 1052 1280ZM1228 1664L1052 1664Q1087 1743 1150 1805Q1213 1867 1293 1900L1293 1900Q1267 1845 1251.50 1784.50Q1236 1724 1228 1664L1228 1664ZM1646 1902L1646 1902Q1729 1869 1793 1807Q1857 1745 1894 1664L1894 1664L1714 1664Q1704 1724 1688 1785.50Q1672 1847 1646 1902Z"
         }
      }
   ]
}

var ClipboardSolid = {
   name: "ClipboardSolid",
   vendor: "UiFabric",
   unicode: 62940,
   value: "",
   charCode: "F5DC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 256L1792 256L1792 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256ZM640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384L640 384Z"
         }
      }
   ]
}

var FileYML = {
   name: "FileYML",
   vendor: "UiFabric",
   unicode: 62938,
   value: "",
   charCode: "F5DA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 128L256 128L256 1920L1280 1920L1280 2048L128 2048L128 0L1243 0L1792 549L1792 1280L1664 1280L1664 640L1152 640L1152 128ZM1573 512L1280 219L1280 512L1573 512ZM1616 1682L1748 1408L1860 1408L1650 1816L1650 2048L1544 2048L1544 1818L1340 1408L1461 1408L1587 1682Q1591 1691 1594 1701Q1597 1711 1600 1720L1600 1720L1601 1720Q1607 1699 1616 1682L1616 1682ZM1984 1664L1984 1664Q1958 1664 1939 1645Q1920 1626 1920 1600L1920 1600Q1920 1574 1939 1555Q1958 1536 1984 1536L1984 1536Q2010 1536 2029 1555Q2048 1574 2048 1600L2048 1600Q2048 1626 2029 1645Q2010 1664 1984 1664ZM1984 1792L1984 1792Q2010 1792 2029 1811Q2048 1830 2048 1856L2048 1856Q2048 1882 2029 1901Q2010 1920 1984 1920L1984 1920Q1958 1920 1939 1901Q1920 1882 1920 1856L1920 1856Q1920 1830 1939 1811Q1958 1792 1984 1792Z"
         }
      }
   ]
}

var BrowserTabScreenshot = {
   name: "BrowserTabScreenshot",
   vendor: "UiFabric",
   unicode: 62936,
   value: "",
   charCode: "F5D8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L256 1920L640 1920L640 2048L128 2048L128 0L1024 0L1024 256L1792 256L1792 896L1664 896L1664 384L896 384L896 128L256 128ZM1755 1152L2048 1152L2048 2048L768 2048L768 1152L1061 1152L1189 1024L1627 1024L1755 1152ZM1920 1920L1920 1280L1701 1280L1573 1152L1243 1152L1115 1280L896 1280L896 1920L1920 1920ZM1408 1280L1408 1280Q1461 1280 1507.50 1300Q1554 1320 1589 1355Q1624 1390 1644 1436.50Q1664 1483 1664 1536L1664 1536Q1664 1589 1644 1635.50Q1624 1682 1589 1717Q1554 1752 1507.50 1772Q1461 1792 1408 1792L1408 1792Q1355 1792 1308.50 1772Q1262 1752 1227 1717Q1192 1682 1172 1635.50Q1152 1589 1152 1536L1152 1536Q1152 1483 1172 1436.50Q1192 1390 1227 1355Q1262 1320 1308.50 1300Q1355 1280 1408 1280ZM1408 1664L1408 1664Q1435 1664 1458 1654Q1481 1644 1498.50 1626.50Q1516 1609 1526 1586Q1536 1563 1536 1536L1536 1536Q1536 1509 1526 1486Q1516 1463 1498.50 1445.50Q1481 1428 1458 1418Q1435 1408 1408 1408L1408 1408Q1381 1408 1358 1418Q1335 1428 1317.50 1445.50Q1300 1463 1290 1486Q1280 1509 1280 1536L1280 1536Q1280 1563 1290 1586Q1300 1609 1317.50 1626.50Q1335 1644 1358 1654Q1381 1664 1408 1664Z"
         }
      }
   ]
}

var PasteAsCode = {
   name: "PasteAsCode",
   vendor: "UiFabric",
   unicode: 62934,
   value: "",
   charCode: "F5D6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 384L256 1792L768 1792L768 1920L128 1920L128 256L640 256Q640 203 660 156.50Q680 110 715 75Q750 40 796.50 20Q843 0 896 0L896 0Q949 0 995.50 20Q1042 40 1077 75Q1112 110 1132 156.50Q1152 203 1152 256L1152 256L1664 256L1664 896L1536 896L1536 384L1408 384L1408 640L384 640L384 384L256 384ZM768 384L512 384L512 512L1280 512L1280 384L1024 384L1024 256Q1024 229 1014 206Q1004 183 986.50 165.50Q969 148 946 138Q923 128 896 128L896 128Q869 128 846 138Q823 148 805.50 165.50Q788 183 778 206Q768 229 768 256L768 256L768 384ZM947 1235L1037 1325L827 1536L1037 1747L947 1837L646 1536L947 1235ZM1741 1235L2042 1536L1741 1837L1651 1747L1861 1536L1651 1325L1741 1235ZM1152 2048L1493 1024L1621 1024L1280 2048L1152 2048Z"
         }
      }
   ]
}

var VisualStudioIDELogo32 = {
   name: "VisualStudioIDELogo32",
   vendor: "UiFabric",
   unicode: 62928,
   value: "",
   charCode: "F5D0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L2048 213L2048 1835L1536 2048L0 1536L1536 1759L1536 0ZM528 985L245 1199L128 1160L128 590L245 551L528 764L998 299L1280 418L1280 1331L998 1451L528 985ZM998 631L675 875L998 1119L998 631ZM245 705L245 1044L416 875L245 705Z"
         }
      }
   ]
}

var MaximumValue = {
   name: "MaximumValue",
   vendor: "UiFabric",
   unicode: 62908,
   value: "",
   charCode: "F5BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1408L0 512L128 512L128 1408L0 1408ZM1920 512L2048 512L2048 1408L1920 1408L1920 512ZM1427 733L1517 643L1835 960L1517 1277L1427 1187L1589 1024L475 1024L637 1187L547 1277L230 960L547 643L637 733L475 896L1589 896L1427 733Z"
         }
      }
   ]
}

var MasterDatabase = {
   name: "MasterDatabase",
   vendor: "UiFabric",
   unicode: 62906,
   value: "",
   charCode: "F5BA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 768L960 768Q892 768 815.50 761.50Q739 755 662.50 739.50Q586 724 514 699Q442 674 384 637L384 637L384 1600Q384 1623 403 1643.50Q422 1664 451.50 1682Q481 1700 517 1714Q553 1728 588 1739Q623 1750 652.50 1757Q682 1764 698 1767L698 1767Q747 1776 796.50 1781.50Q846 1787 896 1789L896 1789L896 1919Q852 1917 787.50 1910Q723 1903 652 1888Q581 1873 510 1849Q439 1825 382.50 1790Q326 1755 291 1708Q256 1661 256 1600L256 1600L256 448Q256 401 278 362Q300 323 336.50 292.50Q373 262 419.50 238Q466 214 514.50 197Q563 180 609.50 169Q656 158 693 151L693 151Q759 139 826 133.50Q893 128 960 128L960 128Q1027 128 1094 133.50Q1161 139 1227 151L1227 151Q1263 158 1310 169Q1357 180 1405.50 197.50Q1454 215 1500.50 238Q1547 261 1583.50 292Q1620 323 1642 362Q1664 401 1664 448L1664 448L1664 896L1536 896L1536 637Q1477 674 1405.50 699Q1334 724 1257.50 739.50Q1181 755 1104.50 761.50Q1028 768 960 768ZM960 256L960 256Q903 256 829.50 262Q756 268 681.50 282.50Q607 297 538.50 322Q470 347 424 385L424 385Q410 396 397 412.50Q384 429 384 448L384 448Q384 467 397 483.50Q410 500 424 511L424 511Q470 549 538.50 574Q607 599 681.50 613.50Q756 628 829.50 634Q903 640 960 640L960 640Q1017 640 1090.50 634Q1164 628 1238.50 613.50Q1313 599 1381 574Q1449 549 1495 511L1495 511Q1509 500 1522.50 483.50Q1536 467 1536 448L1536 448Q1536 429 1522.50 412.50Q1509 396 1495 385L1495 385Q1449 347 1381 322Q1313 297 1238.50 282.50Q1164 268 1090.50 262Q1017 256 960 256ZM1749 1400L2048 995L2048 2048L1024 2048L1024 999L1328 1400L1538 1020L1749 1400ZM1920 1920L1920 1384L1734 1637L1538 1284L1344 1634L1152 1380L1152 1920L1920 1920Z"
         }
      }
   ]
}

var SearchBookmark = {
   name: "SearchBookmark",
   vendor: "UiFabric",
   unicode: 62904,
   value: "",
   charCode: "F5B8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M996 1632L896 1725L256 2048L256 0L1536 0L1536 753Q1469 769 1408 803L1408 803L1408 128L384 128L384 1840Q513 1775 640 1710Q767 1645 896 1581L896 1581Q922 1593 946.50 1605.50Q971 1618 996 1632L996 1632ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935 1008.50Q1987 1061 2017 1131Q2047 1201 2047 1280L2047 1280Q2047 1360 2017 1429.50Q1987 1499 1935 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547 1646Q1490 1628 1442 1593L1442 1593L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1351 1502Q1316 1454 1298 1397Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var ExploreData = {
   name: "ExploreData",
   vendor: "UiFabric",
   unicode: 62902,
   value: "",
   charCode: "F5B6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1408L256 1408L256 1152L0 1152L0 0L1536 0L1536 256L1792 256L1792 768L1664 768L1664 384L384 384L384 1280L1152 1280L1152 1408ZM128 1024L256 1024L256 256L1408 256L1408 128L128 128L128 1024ZM640 1152L512 1152L512 896L640 896L640 1152ZM896 1152L768 1152L768 640L896 640L896 1152ZM1152 1152L1024 1152L1024 768L1152 768L1152 1152ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547 1646Q1490 1628 1442 1593L1442 1593L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1351 1502Q1316 1454 1298 1397Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var TransitionEffect = {
   name: "TransitionEffect",
   vendor: "UiFabric",
   unicode: 62900,
   value: "",
   charCode: "F5B4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 0L1920 0L1920 896L0 896L0 0L128 0L128 768L896 768L896 347L733 509L643 419L960 102L1277 419L1187 509L1024 347L1024 768L1792 768L1792 0ZM0 1920L0 1024L1920 1024L1920 1920L1792 1920L1792 1152L1024 1152L1024 1573L1187 1411L1277 1501L960 1818L643 1501L733 1411L896 1573L896 1152L128 1152L128 1920L0 1920Z"
         }
      }
   ]
}

var TransitionPop = {
   name: "TransitionPop",
   vendor: "UiFabric",
   unicode: 62898,
   value: "",
   charCode: "F5B2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM128 512L128 1408L1920 1408L1920 512L128 512ZM1427 733L1517 643L1835 960L1517 1277L1427 1187L1589 1024L475 1024L637 1187L547 1277L230 960L547 643L637 733L475 896L1589 896L1427 733ZM0 128L2048 128L2048 256L0 256L0 128ZM0 1792L0 1664L2048 1664L2048 1792L0 1792Z"
         }
      }
   ]
}

var AnalyticsView = {
   name: "AnalyticsView",
   vendor: "UiFabric",
   unicode: 62961,
   value: "",
   charCode: "F5F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1792L0 1792L0 128ZM1920 256L128 256L128 512L1920 512L1920 256ZM128 1664L1920 1664L1920 640L128 640L128 1664ZM256 1536L256 896L384 896L384 1536L256 1536ZM512 1536L512 1280L640 1280L640 1536L512 1536ZM768 1536L768 1152L896 1152L896 1536L768 1536ZM1024 1536L1024 768L1152 768L1152 1536L1024 1536ZM1536 1536L1536 896L1664 896L1664 1536L1536 1536ZM1280 1536L1280 1152L1408 1152L1408 1536L1280 1536Z"
         }
      }
   ]
}

var Video360Generic = {
   name: "Video360Generic",
   vendor: "UiFabric",
   unicode: 62985,
   value: "",
   charCode: "F609",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1178 0 1322 44.50Q1466 89 1589.50 170.50Q1713 252 1810.50 367.50Q1908 483 1968 625L1968 625Q2002 706 2024.50 799Q2047 892 2047 980L2047 980Q2047 1040 2043.50 1096Q2040 1152 2031 1206Q2022 1260 2007 1313.50Q1992 1367 1968 1423L1968 1423Q1908 1565 1811 1680.50Q1714 1796 1590.50 1877.50Q1467 1959 1322.50 2003.50Q1178 2048 1024 2048L1024 2048Q870 2048 725.50 2003.50Q581 1959 457.50 1877.50Q334 1796 237 1680.50Q140 1565 80 1423L80 1423Q56 1367 41 1313.50Q26 1260 17 1206Q8 1152 4.50 1096Q1 1040 1 980L1 980Q1 892 23.50 799Q46 706 80 625L80 625Q140 483 237.50 367.50Q335 252 458.50 170.50Q582 89 726 44.50Q870 0 1024 0ZM1502 692L1502 692Q1516 774 1522 857Q1528 940 1528 1024L1528 1024Q1528 1124 1519 1223L1519 1223Q1594 1205 1667.50 1177Q1741 1149 1807 1107L1807 1107Q1821 1098 1840 1083Q1859 1068 1876.50 1050Q1894 1032 1906.50 1012.50Q1919 993 1919 975L1919 975Q1919 964 1918 952Q1917 940 1915 930L1915 930Q1909 900 1880.50 871.50Q1852 843 1815.50 819Q1779 795 1741.50 776.50Q1704 758 1679 748L1679 748Q1636 731 1591.50 717Q1547 703 1502 692ZM1857 692L1857 692Q1820 600 1764 519Q1708 438 1637 371.50Q1566 305 1481.50 254Q1397 203 1303 172L1303 172Q1365 256 1407 355Q1449 454 1473 555L1473 555Q1574 576 1670 608.50Q1766 641 1857 692ZM1045 128L1003 128Q995 128 987 128Q979 128 971 130L971 130Q965 131 951 138Q937 145 932 149L932 149Q903 166 878 191Q853 216 831.50 244.50Q810 273 792 304Q774 335 760 365L760 365Q740 406 725 448Q710 490 697 534L697 534Q778 523 860 517.50Q942 512 1024 512L1024 512Q1106 512 1188 517.50Q1270 523 1351 534L1351 534Q1338 490 1323 448Q1308 406 1288 365L1288 365Q1274 335 1256 304Q1238 273 1216.50 244.50Q1195 216 1170 191Q1145 166 1116 149L1116 149Q1111 145 1097 138Q1083 131 1077 130L1077 130Q1069 128 1061 128Q1053 128 1045 128L1045 128ZM745 172L745 172Q651 203 566.50 254Q482 305 411 371.50Q340 438 284 519Q228 600 191 692L191 692Q282 641 378 608.50Q474 576 575 555L575 555Q599 454 641 355Q683 256 745 172ZM145 1197L145 1197Q168 1316 222 1422.50Q276 1529 354 1617.50Q432 1706 531.50 1772Q631 1838 746 1876L746 1876Q688 1800 649.50 1710.50Q611 1621 585 1530L585 1530Q615 1536 645.50 1540.50Q676 1545 707 1549L707 1549Q721 1593 741 1641.50Q761 1690 787.50 1736.50Q814 1783 846.50 1823.50Q879 1864 918 1891L918 1891Q922 1894 929 1898Q936 1902 944 1906.50Q952 1911 959 1914.50Q966 1918 971 1919L971 1919Q977 1920 983.50 1920Q990 1920 997 1920L997 1920L1045 1920Q1053 1920 1061 1920Q1069 1920 1077 1918L1077 1918Q1085 1916 1099.50 1908.50Q1114 1901 1121 1897L1121 1897Q1162 1871 1196 1830.50Q1230 1790 1257 1743Q1284 1696 1305 1646.50Q1326 1597 1340 1553L1340 1553Q1381 1427 1398.50 1291.50Q1416 1156 1416 1024L1416 1024Q1416 934 1408.50 845Q1401 756 1384 668L1384 668Q1294 654 1204.50 647Q1115 640 1024 640L1024 640Q933 640 843.50 647Q754 654 664 668L664 668Q647 756 639.50 845Q632 934 632 1024L632 1024Q632 1039 632 1053.50Q632 1068 634 1083L634 1083Q605 1078 577 1071Q549 1064 521 1055L521 1055Q520 1047 520 1039.50Q520 1032 520 1024L520 1024Q520 940 526 857Q532 774 546 692L546 692Q501 703 456.50 717Q412 731 369 748L369 748Q343 759 305.50 777Q268 795 232 819Q196 843 168 871.50Q140 900 133 930L133 930Q131 940 130 952.50Q129 965 129 975L129 975Q129 980 133.50 991Q138 1002 140 1007L140 1007Q155 1036 182 1061Q209 1086 241 1107Q273 1128 306.50 1144Q340 1160 369 1172L369 1172Q443 1202 525 1222.50Q607 1243 691.50 1256Q776 1269 860.50 1274.50Q945 1280 1024 1280L1024 1280L1061 1280L915 1133L1005 1043L1306 1344L1005 1645L915 1555L1062 1408Q989 1408 910 1404.50Q831 1401 749.50 1392Q668 1383 586 1367.50Q504 1352 426.50 1328.50Q349 1305 277.50 1272.50Q206 1240 145 1197ZM1303 1876L1303 1876Q1418 1838 1517.50 1771.50Q1617 1705 1695 1617Q1773 1529 1826.50 1422Q1880 1315 1903 1196L1903 1196Q1860 1228 1811 1253Q1762 1278 1710.50 1298Q1659 1318 1605.50 1333Q1552 1348 1501 1359L1501 1359Q1490 1425 1473 1494Q1456 1563 1432 1629.50Q1408 1696 1376 1759Q1344 1822 1303 1876Z"
         }
      }
   ]
}

var BullseyeTarget = {
   name: "BullseyeTarget",
   vendor: "UiFabric",
   unicode: 62960,
   value: "",
   charCode: "F5F0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q1148 128 1262.50 160Q1377 192 1476.50 250.50Q1576 309 1657.50 390.50Q1739 472 1797.50 571.50Q1856 671 1888 785.50Q1920 900 1920 1024L1920 1024Q1920 1148 1888 1262.50Q1856 1377 1797.50 1476.50Q1739 1576 1657.50 1657.50Q1576 1739 1476.50 1797.50Q1377 1856 1262.50 1888Q1148 1920 1024 1920L1024 1920Q900 1920 785.50 1888Q671 1856 571.50 1797.50Q472 1739 390.50 1657.50Q309 1576 250.50 1476.50Q192 1377 160 1262.50Q128 1148 128 1024L128 1024Q128 900 160 785.50Q192 671 250.50 571.50Q309 472 390.50 390.50Q472 309 571.50 250.50Q671 192 785.50 160Q900 128 1024 128ZM1024 1792L1024 1792Q1130 1792 1228 1764.50Q1326 1737 1411.50 1687Q1497 1637 1567 1567Q1637 1497 1687 1411.50Q1737 1326 1764.50 1228Q1792 1130 1792 1024L1792 1024Q1792 918 1764.50 820Q1737 722 1687 636.50Q1637 551 1567 481Q1497 411 1411.50 361Q1326 311 1228 283.50Q1130 256 1024 256L1024 256Q918 256 820 283.50Q722 311 636.50 361Q551 411 481 481Q411 551 361 636.50Q311 722 283.50 820Q256 918 256 1024L256 1024Q256 1130 283.50 1228Q311 1326 361 1411.50Q411 1497 481 1567Q551 1637 636.50 1687Q722 1737 820 1764.50Q918 1792 1024 1792ZM1024 512L1024 512Q1130 512 1223.50 552Q1317 592 1386.50 661.50Q1456 731 1496 824.50Q1536 918 1536 1024L1536 1024Q1536 1130 1496 1223.50Q1456 1317 1386.50 1386.50Q1317 1456 1223.50 1496Q1130 1536 1024 1536L1024 1536Q918 1536 824.50 1496Q731 1456 661.50 1386.50Q592 1317 552 1223.50Q512 1130 512 1024L512 1024Q512 918 552 824.50Q592 731 661.50 661.50Q731 592 824.50 552Q918 512 1024 512ZM1024 1408L1024 1408Q1103 1408 1173 1378Q1243 1348 1295.50 1295.50Q1348 1243 1378 1173.50Q1408 1104 1408 1024L1408 1024Q1408 945 1378 875Q1348 805 1295.50 752.50Q1243 700 1173 670Q1103 640 1024 640L1024 640Q944 640 874.50 670Q805 700 752.50 752.50Q700 805 670 875Q640 945 640 1024L640 1024Q640 1104 670 1173.50Q700 1243 752.50 1295.50Q805 1348 874.50 1378Q944 1408 1024 1408ZM1024 896L1024 896Q1051 896 1074 906Q1097 916 1114.50 933.50Q1132 951 1142 974Q1152 997 1152 1024L1152 1024Q1152 1051 1142 1074Q1132 1097 1114.50 1114.50Q1097 1132 1074 1142Q1051 1152 1024 1152L1024 1152Q997 1152 974 1142Q951 1132 933.50 1114.50Q916 1097 906 1074Q896 1051 896 1024L896 1024Q896 997 906 974Q916 951 933.50 933.50Q951 916 974 906Q997 896 1024 896Z"
         }
      }
   ]
}

var Untag = {
   name: "Untag",
   vendor: "UiFabric",
   unicode: 62987,
   value: "",
   charCode: "F60B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 448L1600 448Q1600 475 1590 498Q1580 521 1562.50 538.50Q1545 556 1522 566Q1499 576 1472 576L1472 576Q1445 576 1422 566Q1399 556 1381.50 538.50Q1364 521 1354 498Q1344 475 1344 448L1344 448Q1344 421 1354 398Q1364 375 1381.50 357.50Q1399 340 1422 330Q1445 320 1472 320L1472 320Q1499 320 1522 330Q1545 340 1562.50 357.50Q1580 375 1590 398Q1600 421 1600 448ZM181 1024L896 1739L1159 1476L1250 1566L896 1920L0 1024L1024 0L1920 0L1920 896L1567 1249L1476 1159L1792 843L1792 128L1077 128L181 1024ZM1955 1411L2045 1501L1819 1728L2045 1955L1955 2045L1728 1818L1501 2045L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var Blocked12 = {
   name: "Blocked12",
   vendor: "UiFabric",
   unicode: 63022,
   value: "",
   charCode: "F62E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M939 171L939 171Q1068 171 1188 204.50Q1308 238 1412.50 299Q1517 360 1602.50 445.50Q1688 531 1749 635.50Q1810 740 1843.50 860Q1877 980 1877 1109L1877 1109Q1877 1238 1843.50 1358Q1810 1478 1749 1582.50Q1688 1687 1602.50 1773Q1517 1859 1412.50 1920Q1308 1981 1188 2014.50Q1068 2048 939 2048L939 2048Q809 2048 689 2014.50Q569 1981 465 1920Q361 1859 275 1773Q189 1687 128 1583Q67 1479 33.50 1359Q0 1239 0 1109L0 1109Q0 980 33.50 860Q67 740 128.50 635.50Q190 531 275.50 445.50Q361 360 465.50 299Q570 238 689.50 204.50Q809 171 939 171ZM939 1911L939 1911Q1050 1911 1152.50 1882.50Q1255 1854 1344 1801.50Q1433 1749 1506 1676Q1579 1603 1631.50 1514Q1684 1425 1712.50 1322.50Q1741 1220 1741 1109L1741 1109Q1741 999 1712.50 896.50Q1684 794 1631.50 705Q1579 616 1505.50 542.50Q1432 469 1343 416.50Q1254 364 1151.50 335.50Q1049 307 939 307L939 307Q828 307 725.50 335.50Q623 364 534 416.50Q445 469 372 542Q299 615 246.50 704Q194 793 165.50 895.50Q137 998 137 1109L137 1109Q137 1220 165.50 1322.50Q194 1425 246 1514Q298 1603 371.50 1676.50Q445 1750 534 1802Q623 1854 725.50 1882.50Q828 1911 939 1911ZM469 1195L469 1024L1408 1024L1408 1195L469 1195Z"
         }
      }
   ]
}

var CheckedOutByOther12 = {
   name: "CheckedOutByOther12",
   vendor: "UiFabric",
   unicode: 63024,
   value: "",
   charCode: "F630",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M939 171L939 171Q1068 171 1188 204.50Q1308 238 1412.50 299Q1517 360 1602.50 445.50Q1688 531 1749 635.50Q1810 740 1843.50 860Q1877 980 1877 1109L1877 1109Q1877 1238 1843.50 1358Q1810 1478 1749 1582.50Q1688 1687 1602.50 1773Q1517 1859 1412.50 1920Q1308 1981 1188 2014.50Q1068 2048 939 2048L939 2048Q809 2048 689 2014.50Q569 1981 465 1920Q361 1859 275 1773Q189 1687 128 1583Q67 1479 33.50 1359Q0 1239 0 1109L0 1109Q0 980 33.50 860Q67 740 128.50 635.50Q190 531 275.50 445.50Q361 360 465.50 299Q570 238 689.50 204.50Q809 171 939 171ZM939 1911L939 1911Q1050 1911 1152.50 1882.50Q1255 1854 1344 1801.50Q1433 1749 1506 1676Q1579 1603 1631.50 1514Q1684 1425 1712.50 1322.50Q1741 1220 1741 1109L1741 1109Q1741 999 1712.50 896.50Q1684 794 1631.50 705Q1579 616 1505.50 542.50Q1432 469 1343 416.50Q1254 364 1151.50 335.50Q1049 307 939 307L939 307Q828 307 725.50 335.50Q623 364 534 416.50Q445 469 372 542Q299 615 246.50 704Q194 793 165.50 895.50Q137 998 137 1109L137 1109Q137 1220 165.50 1322.50Q194 1425 246 1514Q298 1603 371.50 1676.50Q445 1750 534 1802Q623 1854 725.50 1882.50Q828 1911 939 1911ZM1195 1245L1195 853L1365 853L1365 1536L683 1536L683 1365L1074 1365L537 828L658 708L1195 1245Z"
         }
      }
   ]
}

var CircleShapeSolid = {
   name: "CircleShapeSolid",
   vendor: "UiFabric",
   unicode: 63036,
   value: "",
   charCode: "F63C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0Z"
         }
      }
   ]
}

var TriangleShapeSolid = {
   name: "TriangleShapeSolid",
   vendor: "UiFabric",
   unicode: 63038,
   value: "",
   charCode: "F63E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L1920 1920L0 1920L960 0Z"
         }
      }
   ]
}

var RectangleShapeSolid = {
   name: "RectangleShapeSolid",
   vendor: "UiFabric",
   unicode: 63040,
   value: "",
   charCode: "F640",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1664L0 1664L0 384Z"
         }
      }
   ]
}

var DropShapeSolid = {
   name: "DropShapeSolid",
   vendor: "UiFabric",
   unicode: 63039,
   value: "",
   charCode: "F63F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1607 1166Q1635 1223 1649.50 1284Q1664 1345 1664 1408L1664 1408Q1664 1496 1641 1578Q1618 1660 1576.50 1731Q1535 1802 1476.50 1860.50Q1418 1919 1347 1960.50Q1276 2002 1194 2025Q1112 2048 1024 2048L1024 2048Q936 2048 854 2025Q772 2002 701 1960.50Q630 1919 571.50 1860.50Q513 1802 471.50 1731Q430 1660 407 1578Q384 1496 384 1408L384 1408Q384 1345 398.50 1284Q413 1223 441 1166L441 1166L1024 0Z"
         }
      }
   ]
}

var SquareShapeSolid = {
   name: "SquareShapeSolid",
   vendor: "UiFabric",
   unicode: 63037,
   value: "",
   charCode: "F63D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 1920L128 1920L128 128Z"
         }
      }
   ]
}

var CheckedOutByYou12 = {
   name: "CheckedOutByYou12",
   vendor: "UiFabric",
   unicode: 63025,
   value: "",
   charCode: "F631",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M939 171L939 171Q1068 171 1187.50 204.50Q1307 238 1411.50 299.50Q1516 361 1601.50 446.50Q1687 532 1748.50 636.50Q1810 741 1843.50 860.50Q1877 980 1877 1109L1877 1109Q1877 1238 1843.50 1357.50Q1810 1477 1748.50 1581.50Q1687 1686 1601.50 1772Q1516 1858 1411.50 1919.50Q1307 1981 1187.50 2014.50Q1068 2048 939 2048L939 2048Q810 2048 690 2014.50Q570 1981 465.50 1919.50Q361 1858 275.50 1772.50Q190 1687 128.50 1582.50Q67 1478 33.50 1358Q0 1238 0 1109L0 1109Q0 980 33.50 860.50Q67 741 128.50 636.50Q190 532 276 446.50Q362 361 466.50 299.50Q571 238 690.50 204.50Q810 171 939 171ZM683 1536L1365 1536L1365 853L1195 853L1195 1214L673 693L522 843L1044 1365L683 1365L683 1536Z"
         }
      }
   ]
}

var Warning12 = {
   name: "Warning12",
   vendor: "UiFabric",
   unicode: 63023,
   value: "",
   charCode: "F62F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M939 57L1884 2048L-7 2048L939 57ZM939 455L263 1877L1614 1877L939 455ZM853 853L1024 853L1024 1408L853 1408L853 853ZM853 1707L853 1536L1024 1536L1024 1707L853 1707Z"
         }
      }
   ]
}

var Trending12 = {
   name: "Trending12",
   vendor: "UiFabric",
   unicode: 63021,
   value: "",
   charCode: "F62D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1365 341L2048 341L2048 1024L1877 1024L1877 633L1109 1401L768 1059L103 1724L-18 1604L768 818L1109 1159L1757 512L1365 512L1365 341Z"
         }
      }
   ]
}

var Leave = {
   name: "Leave",
   vendor: "UiFabric",
   unicode: 63015,
   value: "",
   charCode: "F627",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1565 515L2011 960L1565 1405L1475 1315L1766 1024L768 1024L768 896L1766 896L1475 605L1565 515ZM1152 1792L1152 1280L1280 1280L1280 1920L0 1920L0 0L1280 0L1280 640L1152 640L1152 128L128 128L128 1792L1152 1792Z"
         }
      }
   ]
}

var ContentSettings = {
   name: "ContentSettings",
   vendor: "UiFabric",
   unicode: 63047,
   value: "",
   charCode: "F647",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1192Q2020 1161 1987.50 1134.50Q1955 1108 1920 1085L1920 1085L1920 640L128 640L128 1664L996 1664Q999 1697 1006 1729Q1013 1761 1024 1792L1024 1792L0 1792L0 128ZM1920 512L1920 256L128 256L128 512L1920 512ZM896 1536L256 1536L256 768L896 768L896 1536ZM384 896L384 1408L768 1408L768 896L384 896ZM1408 768L1408 896L1024 896L1024 768L1408 768ZM1024 1152L1024 1026L1408 1026Q1286 1067 1192 1152L1192 1152L1024 1152ZM1989 1369L2038 1488L1914 1539Q1920 1569 1920 1598L1920 1598Q1920 1630 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1848 1804 1826.50 1826Q1805 1848 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1585 1920 1570 1917Q1555 1914 1540 1911L1540 1911L1488 2038L1369 1989L1421 1864Q1396 1847 1375.50 1825Q1355 1803 1338 1778L1338 1778L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1602L1280 1602Q1280 1571 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1352 1396 1373.50 1374Q1395 1352 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1598 1280L1598 1280Q1629 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1804 1352 1826 1373.50Q1848 1395 1865 1421L1865 1421L1989 1369ZM1600 1791L1600 1791Q1640 1791 1675 1776Q1710 1761 1736 1735Q1762 1709 1777 1674Q1792 1639 1792 1600L1792 1600Q1792 1561 1777 1526Q1762 1491 1735.50 1464.50Q1709 1438 1674 1423Q1639 1408 1600 1408L1600 1408Q1561 1408 1526 1423Q1491 1438 1464.50 1464.50Q1438 1491 1423 1526Q1408 1561 1408 1600L1408 1600Q1408 1640 1423 1674.50Q1438 1709 1464.50 1735Q1491 1761 1526 1776Q1561 1791 1600 1791Z"
         }
      }
   ]
}

var ZoomToFit = {
   name: "ZoomToFit",
   vendor: "UiFabric",
   unicode: 63049,
   value: "",
   charCode: "F649",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 181L749 456L659 365L1024 0L1389 365L1299 456L1024 181ZM1024 1867L1299 1592L1389 1683L1024 2048L659 1683L749 1592L1024 1867ZM365 659L456 749L181 1024L456 1299L365 1389L0 1024L365 659ZM1683 659L2048 1024L1683 1389L1592 1299L1867 1024L1592 749L1683 659ZM640 1408L640 640L1408 640L1408 1408L640 1408ZM768 768L768 1280L1280 1280L1280 768L768 768Z"
         }
      }
   ]
}

var InsertColumnsLeft = {
   name: "InsertColumnsLeft",
   vendor: "UiFabric",
   unicode: 63050,
   value: "",
   charCode: "F64A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1792L0 1792L0 1280L128 1408L128 1664L640 1664L640 1152L1152 1152L1152 768L640 768L640 256L128 256L128 512L0 640L0 128ZM1920 1664L1920 1280L1408 1280L1408 1664L1920 1664ZM1920 1152L1920 768L1408 768L1408 1152L1920 1152ZM1920 640L1920 256L1408 256L1408 640L1920 640ZM435 531L525 621L250 896L1024 896L1024 1024L250 1024L525 1299L435 1389L6 960L435 531Z"
         }
      }
   ]
}

var InsertRowsAbove = {
   name: "InsertRowsAbove",
   vendor: "UiFabric",
   unicode: 63052,
   value: "",
   charCode: "F64C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 128L2048 128L2048 1792L0 1792L0 128L512 128L384 256L128 256L128 640L768 640L768 1152L1152 1152L1152 640L1920 640L1920 256L1536 256L1408 128ZM640 1664L640 1280L128 1280L128 1664L640 1664ZM1280 1664L1280 1280L768 1280L768 1664L1280 1664ZM1920 1664L1920 1280L1408 1280L1408 1664L1920 1664ZM896 250L621 525L531 435L960 6L1389 435L1299 525L1024 250L1024 1024L896 1024L896 250Z"
         }
      }
   ]
}

var DeleteColumns = {
   name: "DeleteColumns",
   vendor: "UiFabric",
   unicode: 63054,
   value: "",
   charCode: "F64E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1091L640 0L1280 0L1280 1092L960 1411L640 1091ZM1792 0L1920 0L1920 1024L1408 1024L1408 896L1792 896L1792 0ZM128 0L128 896L512 896L512 1024L0 1024L0 0L128 0ZM1187 1411L1277 1502L1051 1728L1277 1955L1187 2045L960 1819L733 2046L643 1955L870 1728L643 1501L733 1411L960 1638L1187 1411Z"
         }
      }
   ]
}

var DeleteRowsMirrored = {
   name: "DeleteRowsMirrored",
   vendor: "UiFabric",
   unicode: 63056,
   value: "",
   charCode: "F650",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1150 512L1150 128L2046 128L2046 0L1022 0L1022 512L1150 512ZM954 640L635 960L955 1280L2046 1280L2046 640L954 640ZM1150 1792L1150 1408L1022 1408L1022 1920L2046 1920L2046 1792L1150 1792ZM0 1187L91 1277L318 1050L545 1277L635 1187L408 960L635 733L544 643L318 869L91 643L1 733L227 960L0 1187Z"
         }
      }
   ]
}

var AccountBrowser = {
   name: "AccountBrowser",
   vendor: "UiFabric",
   unicode: 63058,
   value: "",
   charCode: "F652",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1792L0 1792L0 128ZM1920 256L128 256L128 512L1920 512L1920 256ZM128 1664L1920 1664L1920 640L128 640L128 1664ZM1210 1200L1210 1200Q1256 1226 1292.50 1262Q1329 1298 1354.50 1341.50Q1380 1385 1394 1434.50Q1408 1484 1408 1536L1408 1536L1280 1536Q1280 1483 1260 1436.50Q1240 1390 1205 1355Q1170 1320 1123.50 1300Q1077 1280 1024 1280L1024 1280Q971 1280 924.50 1300Q878 1320 843 1355Q808 1390 788 1436.50Q768 1483 768 1536L768 1536L640 1536Q640 1484 654 1434.50Q668 1385 693.50 1341.50Q719 1298 755.50 1262Q792 1226 838 1200L838 1200Q805 1165 786.50 1119Q768 1073 768 1024L768 1024Q768 971 788 924.50Q808 878 843 843Q878 808 924.50 788Q971 768 1024 768L1024 768Q1077 768 1123.50 788Q1170 808 1205 843Q1240 878 1260 924.50Q1280 971 1280 1024L1280 1024Q1280 1073 1261.50 1119Q1243 1165 1210 1200ZM896 1024L896 1024Q896 1051 906 1074Q916 1097 933.50 1114.50Q951 1132 974 1142Q997 1152 1024 1152L1024 1152Q1051 1152 1074 1142Q1097 1132 1114.50 1114.50Q1132 1097 1142 1074Q1152 1051 1152 1024L1152 1024Q1152 997 1142 974Q1132 951 1114.50 933.50Q1097 916 1074 906Q1051 896 1024 896L1024 896Q997 896 974 906Q951 916 933.50 933.50Q916 951 906 974Q896 997 896 1024Z"
         }
      }
   ]
}

var DeleteTable = {
   name: "DeleteTable",
   vendor: "UiFabric",
   unicode: 63057,
   value: "",
   charCode: "F651",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2045 1501L1819 1728L2046 1955L1955 2045L1728 1818L1501 2045L1411 1955L1638 1728L1411 1501L1502 1411L1728 1637L1955 1411L2045 1501ZM2048 1731L2045 1728L2048 1725L2048 1731ZM0 128L2048 128L2048 1280L1406 1280L1280 1406L1280 1280L768 1280L768 1664L1280 1664L1280 1792L0 1792L0 128ZM640 1664L640 1280L128 1280L128 1664L640 1664ZM640 1152L640 768L128 768L128 1152L640 1152ZM640 640L640 256L128 256L128 640L640 640ZM1280 1152L1280 768L768 768L768 1152L1280 1152ZM1280 640L1280 256L768 256L768 640L1280 640ZM1920 1152L1920 768L1408 768L1408 1152L1920 1152ZM1920 640L1920 256L1408 256L1408 640L1920 640Z"
         }
      }
   ]
}

var DeleteRows = {
   name: "DeleteRows",
   vendor: "UiFabric",
   unicode: 63055,
   value: "",
   charCode: "F64F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 512L896 128L0 128L0 0L1024 0L1024 512L896 512ZM1092 640L1411 960L1091 1280L0 1280L0 640L1092 640ZM896 1792L896 1408L1024 1408L1024 1920L0 1920L0 1792L896 1792ZM2046 1187L1955 1277L1728 1050L1501 1277L1411 1187L1638 960L1411 733L1502 643L1728 869L1955 643L2045 733L1819 960L2046 1187Z"
         }
      }
   ]
}

var InsertRowsBelow = {
   name: "InsertRowsBelow",
   vendor: "UiFabric",
   unicode: 63053,
   value: "",
   charCode: "F64D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L2048 128L2048 1792L1408 1792L1536 1664L1920 1664L1920 1280L1152 1280L1152 768L768 768L768 1280L128 1280L128 1664L384 1664L512 1792L0 1792L0 128ZM640 640L640 256L128 256L128 640L640 640ZM1280 640L1280 256L768 256L768 640L1280 640ZM1920 640L1920 256L1408 256L1408 640L1920 640ZM1024 1670L1299 1395L1389 1485L960 1914L531 1485L621 1395L896 1670L896 896L1024 896L1024 1670Z"
         }
      }
   ]
}

var InsertColumnsRight = {
   name: "InsertColumnsRight",
   vendor: "UiFabric",
   unicode: 63051,
   value: "",
   charCode: "F64B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 128L2048 640L1920 512L1920 256L1408 256L1408 768L896 768L896 1152L1408 1152L1408 1664L1920 1664L1920 1408L2048 1280L2048 1792L0 1792L0 128L2048 128ZM640 1664L640 1280L128 1280L128 1664L640 1664ZM640 1152L640 768L128 768L128 1152L640 1152ZM640 640L640 256L128 256L128 640L640 640ZM1613 1389L1523 1299L1798 1024L1024 1024L1024 896L1798 896L1523 621L1613 531L2042 960L1613 1389Z"
         }
      }
   ]
}

var QuadColumn = {
   name: "QuadColumn",
   vendor: "UiFabric",
   unicode: 63087,
   value: "",
   charCode: "F66F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 256L384 256L384 1792L0 1792ZM128 384L128 1664L256 1664L256 384L128 384ZM1024 1792L1024 256L1408 256L1408 1792L1024 1792ZM1152 384L1152 1664L1280 1664L1280 384L1152 384ZM512 1792L512 256L896 256L896 1792L512 1792ZM640 384L640 1664L768 1664L768 384L640 384ZM1536 256L1920 256L1920 1792L1536 1792L1536 256ZM1792 1664L1792 384L1664 384L1664 1664L1792 1664Z"
         }
      }
   ]
}

var WhiteBoardApp16 = {
   name: "WhiteBoardApp16",
   vendor: "UiFabric",
   unicode: 63091,
   value: "",
   charCode: "F673",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1147 889L1262 637L1885 31L2019 169L1604 574Q1574 604 1550 629Q1526 654 1503 677.50Q1480 701 1455 725Q1430 749 1397 776L1397 776L1147 889ZM1920 444L2048 319L2048 1664L0 1664L0 256L1470 256L1339 384L128 384L128 663Q162 642 215.50 612Q269 582 328.50 554.50Q388 527 446 507.50Q504 488 546 488L546 488Q595 488 629.50 515.50Q664 543 664 595L664 595Q664 638 643.50 680Q623 722 601 757L601 757Q561 823 538 894.50Q515 966 515 1044L515 1044Q515 1077 522.50 1121Q530 1165 547.50 1204Q565 1243 594 1270.50Q623 1298 666 1298L666 1298Q715 1298 764 1266Q813 1234 856 1188.50Q899 1143 934 1093Q969 1043 990 1007L990 1007L1100 1073Q1078 1109 1051 1149.50Q1024 1190 991.50 1229Q959 1268 922.50 1304Q886 1340 845 1367Q804 1394 759.50 1410Q715 1426 668 1426L668 1426Q593 1426 540 1390Q487 1354 453 1297.50Q419 1241 403 1173.50Q387 1106 387 1043L387 1043Q387 947 414.50 859Q442 771 492 689L492 689L494 685Q504 668 513.50 651.50Q523 635 530 616L530 616Q510 619 476 631Q442 643 402 660.50Q362 678 319.50 699.50Q277 721 239.50 743Q202 765 172 785Q142 805 128 820L128 820L128 1536L1920 1536L1920 444Z"
         }
      }
   ]
}

var InsertSignatureLine = {
   name: "InsertSignatureLine",
   vendor: "UiFabric",
   unicode: 63095,
   value: "",
   charCode: "F677",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1920L1664 1532L1792 1404L1792 2048L128 2048L128 0L1243 0L1742 499Q1707 510 1681.50 522.50Q1656 535 1634 550.50Q1612 566 1592 586Q1572 606 1548 630L1548 630L1538 640L1152 640L1152 128L256 128L256 1920L1664 1920ZM1280 219L1280 512L1573 512L1280 219ZM1848 640L1848 640Q1890 640 1926.50 655Q1963 670 1990 697Q2017 724 2032.50 760Q2048 796 2048 838L2048 838Q2048 877 2033 914Q2018 951 1990 979L1990 979L1273 1698Q1266 1700 1236 1707.50Q1206 1715 1164.50 1725.50Q1123 1736 1076 1747.50Q1029 1759 989.50 1769Q950 1779 923.50 1785.50Q897 1792 896 1792L896 1792L384 1792L384 1664L928 1664L990 1415L1707 697Q1735 669 1772 654.50Q1809 640 1848 640ZM1207 1582L1899 889Q1920 868 1920 838L1920 838Q1920 807 1899.50 787.50Q1879 768 1848 768L1848 768Q1834 768 1821 772.50Q1808 777 1798 787L1798 787L1106 1481L1072 1616L1207 1582Z"
         }
      }
   ]
}

var Phishing = {
   name: "Phishing",
   vendor: "UiFabric",
   unicode: 63097,
   value: "",
   charCode: "F679",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L2048 384L2048 1664L1920 1434L1920 648L1024 1095L128 648L128 1536L973 1536L909 1664L0 1664L0 384ZM143 512L1024 953L1905 512L143 512ZM1408 1728L1408 1408L1536 1408L1536 1728L1408 1728ZM1408 1920L1408 1792L1536 1792L1536 1920L1408 1920ZM896 2048L1472 896L2048 2048L896 2048ZM1077 1936L1867 1936L1472 1146L1077 1936Z"
         }
      }
   ]
}

var CreateMailRule = {
   name: "CreateMailRule",
   vendor: "UiFabric",
   unicode: 63098,
   value: "",
   charCode: "F67A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1152L2048 1152L2048 2048L640 2048L640 1152ZM1753 1280L935 1280L1344 1525L1753 1280ZM768 1920L1920 1920L1920 1329L1344 1675L768 1329L768 1920ZM1664 512L928 512Q897 512 873.50 521.50Q850 531 829.50 545Q809 559 789 576Q769 593 743.50 607Q718 621 685.50 630.50Q653 640 608 640L608 640L128 640L128 1536L512 1536L512 1664L0 1664L0 384Q0 357 10 334Q20 311 37.50 293.50Q55 276 78 266Q101 256 128 256L128 256L608 256Q653 256 685.50 265.50Q718 275 743.50 289Q769 303 789 320Q809 337 829.50 351Q850 365 873.50 374.50Q897 384 928 384L928 384L1664 384Q1691 384 1714 394Q1737 404 1754.50 421.50Q1772 439 1782 462Q1792 485 1792 512L1792 512L1792 1024L1664 1024L1664 512ZM608 384L128 384L128 512L608 512Q632 512 650 507.50Q668 503 683 494.50Q698 486 712.50 474.50Q727 463 744 448L744 448Q727 433 712.50 421.50Q698 410 683 401.50Q668 393 650 388.50Q632 384 608 384L608 384Z"
         }
      }
   ]
}

var ArrangeByFrom = {
   name: "ArrangeByFrom",
   vendor: "UiFabric",
   unicode: 63096,
   value: "",
   charCode: "F678",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 120L2048 632L2048 1096Q2007 982 1920 895L1920 895L1920 859L1901 877Q1877 855 1850.50 836.50Q1824 818 1795 802L1795 802L1897 700L1024 264L151 700L475 1024L1056 1024Q1040 1055 1027.50 1086.50Q1015 1118 1007 1152L1007 1152L421 1152L128 859L128 1792L915 1792Q890 1853 876 1920L876 1920L0 1920L0 632L1024 120ZM1764 1589L1764 1589Q1829 1621 1881.50 1669.50Q1934 1718 1971 1778Q2008 1838 2028 1907Q2048 1976 2048 2048L2048 2048L1920 2048Q1920 1969 1890 1899Q1860 1829 1807.50 1776.50Q1755 1724 1685 1694Q1615 1664 1536 1664L1536 1664Q1456 1664 1386.50 1694Q1317 1724 1264.50 1776.50Q1212 1829 1182 1899Q1152 1969 1152 2048L1152 2048L1024 2048Q1024 1976 1044 1907Q1064 1838 1101 1778Q1138 1718 1190.50 1669.50Q1243 1621 1308 1589L1308 1589Q1234 1534 1193 1453Q1152 1372 1152 1280L1152 1280Q1152 1201 1182 1131Q1212 1061 1264.50 1008.50Q1317 956 1386.50 926Q1456 896 1536 896L1536 896Q1615 896 1685 926Q1755 956 1807.50 1008.50Q1860 1061 1890 1131Q1920 1201 1920 1280L1920 1280Q1920 1372 1879 1453Q1838 1534 1764 1589ZM1280 1280L1280 1280Q1280 1333 1300 1379.50Q1320 1426 1355 1461Q1390 1496 1436.50 1516Q1483 1536 1536 1536L1536 1536Q1589 1536 1635.50 1516Q1682 1496 1717 1461Q1752 1426 1772 1379.50Q1792 1333 1792 1280L1792 1280Q1792 1227 1772 1180.50Q1752 1134 1717 1099Q1682 1064 1635.50 1044Q1589 1024 1536 1024L1536 1024Q1483 1024 1436.50 1044Q1390 1064 1355 1099Q1320 1134 1300 1180.50Q1280 1227 1280 1280Z"
         }
      }
   ]
}

var PinnedSolid = {
   name: "PinnedSolid",
   vendor: "UiFabric",
   unicode: 63094,
   value: "",
   charCode: "F676",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1300 58L1990 748Q1957 781 1925.50 808.50Q1894 836 1860 855Q1826 874 1786.50 884.50Q1747 895 1698 895L1698 895Q1664 895 1633 889L1633 889L1254 1268Q1267 1306 1273 1346Q1279 1386 1279 1426L1279 1426Q1279 1491 1266 1544.50Q1253 1598 1228.50 1644.50Q1204 1691 1169 1733.50Q1134 1776 1090 1820L1090 1820L704 1434L136 2003L0 2048L45 1912L614 1344L228 958Q272 914 314.50 879Q357 844 403.50 819.50Q450 795 503.50 782Q557 769 622 769L622 769Q662 769 702 775Q742 781 780 794L780 794L1159 415Q1153 384 1153 350L1153 350Q1153 301 1163.50 261.50Q1174 222 1193 188Q1212 154 1239.50 122.50Q1267 91 1300 58L1300 58Z"
         }
      }
   ]
}

var WhiteBoardApp32 = {
   name: "WhiteBoardApp32",
   vendor: "UiFabric",
   unicode: 63092,
   value: "",
   charCode: "F674",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1158 895L1254 674L1793 137L1912 256L1553 615Q1527 641 1506 663.50Q1485 686 1465 707Q1445 728 1423.50 749Q1402 770 1374 794L1374 794L1158 895ZM1792 556L1920 428L1920 1664L128 1664L128 320L1428 320L1299 448L256 448L256 767Q283 753 316 737Q349 721 384.50 707.50Q420 694 455.50 685Q491 676 522 676L522 676Q566 676 595.50 701Q625 726 625 772L625 772Q625 799 616.50 823.50Q608 848 595 871.50Q582 895 566.50 918.50Q551 942 538 966.50Q525 991 516.50 1018Q508 1045 508 1076L508 1076Q508 1108 519 1134Q530 1160 549 1178.50Q568 1197 594.50 1207Q621 1217 652 1217L652 1217Q706 1217 757.50 1191Q809 1165 854.50 1125.50Q900 1086 937 1039Q974 992 1000 950L1000 950L1109 1018Q1073 1077 1024.50 1135Q976 1193 918 1240Q860 1287 793 1316Q726 1345 652 1345L652 1345Q594 1345 544 1325Q494 1305 457.50 1269Q421 1233 400.50 1184Q380 1135 380 1076L380 1076Q380 1031 389 997.50Q398 964 412.50 934Q427 904 445.50 874.50Q464 845 483 809L483 809Q423 826 366.50 854.50Q310 883 256 913L256 913L256 1536L1792 1536L1792 556Z"
         }
      }
   ]
}

var TripleColumnWide = {
   name: "TripleColumnWide",
   vendor: "UiFabric",
   unicode: 63086,
   value: "",
   charCode: "F66E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 256L512 256L512 1792L0 1792ZM128 384L128 1664L384 1664L384 384L128 384ZM1536 256L2048 256L2048 1792L1536 1792L1536 256ZM1920 1664L1920 384L1664 384L1664 1664L1920 1664ZM640 1792L640 256L1408 256L1408 1792L640 1792ZM768 384L768 1664L1280 1664L1280 384L768 384Z"
         }
      }
   ]
}

var StackedColumnChart2 = {
   name: "StackedColumnChart2",
   vendor: "UiFabric",
   unicode: 63078,
   value: "",
   charCode: "F666",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1792L1920 1792L1920 1920L128 1920L128 128L256 128L256 1792ZM768 512L768 1664L384 1664L384 512L768 512ZM640 1536L640 1024L512 1024L512 1536L640 1536ZM640 896L640 640L512 640L512 896L640 896ZM1280 768L1280 1664L896 1664L896 768L1280 768ZM1152 1536L1152 1280L1024 1280L1024 1536L1152 1536ZM1152 1152L1152 896L1024 896L1024 1152L1152 1152ZM1792 256L1792 1664L1408 1664L1408 256L1792 256ZM1664 1536L1664 768L1536 768L1536 1536L1664 1536ZM1664 640L1664 384L1536 384L1536 640L1664 640Z"
         }
      }
   ]
}

var VersionControlPush = {
   name: "VersionControlPush",
   vendor: "UiFabric",
   unicode: 63076,
   value: "",
   charCode: "F664",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1664 0L1664 128L256 128L256 0ZM1363 941L1024 603L1024 1157Q1107 1168 1177.50 1207.50Q1248 1247 1299 1306.50Q1350 1366 1379 1441.50Q1408 1517 1408 1600L1408 1600Q1408 1693 1373 1774.50Q1338 1856 1277 1917Q1216 1978 1134.50 2013Q1053 2048 960 2048L960 2048Q867 2048 785.50 2013Q704 1978 643 1917Q582 1856 547 1774.50Q512 1693 512 1600L512 1600Q512 1517 541 1441.50Q570 1366 621 1306.50Q672 1247 742.50 1207.50Q813 1168 896 1157L896 1157L896 603L557 941L467 851L960 358L1453 851L1363 941ZM1280 1600L1280 1600Q1280 1534 1254.50 1476Q1229 1418 1185.50 1374.50Q1142 1331 1084 1305.50Q1026 1280 960 1280L960 1280Q894 1280 835.50 1305.50Q777 1331 733.50 1374.50Q690 1418 665 1476Q640 1534 640 1600L640 1600Q640 1666 665 1724.50Q690 1783 733.50 1826.50Q777 1870 835.50 1895Q894 1920 960 1920L960 1920Q1026 1920 1084 1895Q1142 1870 1185.50 1826.50Q1229 1783 1254.50 1724.50Q1280 1666 1280 1600Z"
         }
      }
   ]
}

var UserEvent = {
   name: "UserEvent",
   vendor: "UiFabric",
   unicode: 63132,
   value: "",
   charCode: "F69C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1190 1026L1190 1026L1132 1141Q1052 1084 959.50 1054Q867 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q383 872 319.50 760Q256 648 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760.50Q1185 817 1140 864.50Q1095 912 1039 947L1039 947Q1079 963 1117 982.50Q1155 1002 1190 1026ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM2017 768L1779 1152L2048 1152L1376 2048L1112 2048L1368 1536L1112 1536L1499 768L2017 768ZM1576 1408L1335 1890L1792 1280L1549 1280L1787 896L1578 896L1320 1408L1576 1408Z"
         }
      }
   ]
}

var UserRemove = {
   name: "UserRemove",
   vendor: "UiFabric",
   unicode: 63131,
   value: "",
   charCode: "F69B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1040 946L1040 946Q1159 992 1257 1074Q1355 1156 1421 1265L1421 1265L1328 1358Q1286 1281 1226 1219.50Q1166 1158 1093.50 1114.50Q1021 1071 938.50 1047.50Q856 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q383 872 319.50 760Q256 648 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140.50 863.50Q1096 911 1040 946ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1955 1411L2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var DictionaryRemove = {
   name: "DictionaryRemove",
   vendor: "UiFabric",
   unicode: 63130,
   value: "",
   charCode: "F69A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1920L256 1920L1022 1920L1150 2048L256 2048Q203 2048 156.50 2028Q110 2008 75 1973Q40 1938 20 1891.50Q0 1845 0 1792L0 1792L0 256Q0 207 21.50 161Q43 115 79 79Q115 43 161 21.50Q207 0 256 0L256 0L1664 0L1664 1219L1600 1283L1536 1219L1536 128L256 128Q233 128 210 139.50Q187 151 169 169Q151 187 139.50 210Q128 233 128 256L128 256L128 1572Q157 1555 189 1545.50Q221 1536 256 1536L256 1536L1219 1536L1283 1600L1219 1664L256 1664Q229 1664 206 1674Q183 1684 165.50 1701.50Q148 1719 138 1742Q128 1765 128 1792L128 1792Q128 1819 138 1842Q148 1865 165.50 1882.50Q183 1900 206 1910Q229 1920 256 1920ZM1280 384L1280 768L384 768L384 384L1280 384ZM1152 512L512 512L512 640L1152 640L1152 512ZM1891 1219L1981 1309L1690 1600L1981 1891L1891 1981L1600 1690L1309 1981L1219 1891L1510 1600L1219 1309L1309 1219L1600 1510L1891 1219Z"
         }
      }
   ]
}

var PublishCourse = {
   name: "PublishCourse",
   vendor: "UiFabric",
   unicode: 63129,
   value: "",
   charCode: "F699",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1760 1590L1760 1590Q1826 1623 1879 1671Q1932 1719 1969.50 1778Q2007 1837 2027.50 1906Q2048 1975 2048 2048L2048 2048L1920 2048Q1920 1969 1890 1899Q1860 1829 1807.50 1776.50Q1755 1724 1685 1694Q1615 1664 1536 1664L1536 1664Q1456 1664 1386.50 1694Q1317 1724 1264.50 1776.50Q1212 1829 1182 1899Q1152 1969 1152 2048L1152 2048L1024 2048Q1024 1975 1044.50 1906Q1065 1837 1102.50 1778Q1140 1719 1193 1671Q1246 1623 1312 1590L1312 1590Q1237 1536 1194.50 1455Q1152 1374 1152 1280L1152 1280Q1152 1201 1182 1131Q1212 1061 1264.50 1008.50Q1317 956 1386.50 926Q1456 896 1536 896L1536 896Q1615 896 1685 926Q1755 956 1807.50 1008.50Q1860 1061 1890 1131Q1920 1201 1920 1280L1920 1280Q1920 1374 1877.50 1455Q1835 1536 1760 1590ZM1536 1536L1536 1536Q1589 1536 1635.50 1516Q1682 1496 1717 1461Q1752 1426 1772 1379.50Q1792 1333 1792 1280L1792 1280Q1792 1227 1772 1180.50Q1752 1134 1717 1099Q1682 1064 1635.50 1044Q1589 1024 1536 1024L1536 1024Q1483 1024 1436.50 1044Q1390 1064 1355 1099Q1320 1134 1300 1180.50Q1280 1227 1280 1280L1280 1280Q1280 1333 1300 1379.50Q1320 1426 1355 1461Q1390 1496 1436.50 1516Q1483 1536 1536 1536ZM1024 351L1024 1616Q992 1653 966 1693.50Q940 1734 920 1779L920 1779Q867 1724 791.50 1694Q716 1664 640 1664L640 1664L256 1664L256 384L128 384L128 1792L915 1792Q901 1823 892 1855Q883 1887 877 1920L877 1920L0 1920L0 256L256 256L256 128L640 128Q728 128 809.50 155Q891 182 960 236L960 236Q1029 182 1110.50 155Q1192 128 1280 128L1280 128L1664 128L1664 256L1920 256L1920 896Q1862 839 1792 801L1792 801L1792 384L1664 384L1664 753Q1632 744 1600 740Q1568 736 1536 736L1536 736L1536 256L1280 256Q1210 256 1144 280.50Q1078 305 1024 351L1024 351ZM896 1603L896 1603L896 351Q842 305 776 280.50Q710 256 640 256L640 256L384 256L384 1536L640 1536Q707 1536 772 1553Q837 1570 896 1603Z"
         }
      }
   ]
}

var Number = {
   name: "Number",
   vendor: "UiFabric",
   unicode: 63121,
   value: "",
   charCode: "F691",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1166 2011.50 1296.50Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q900 128 786 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920ZM1082 448L1082 448L1152 448L1152 1600L1024 1600L1024 694Q967 730 901.50 749Q836 768 768 768L768 768L768 640Q871 640 952 588.50Q1033 537 1082 448Z"
         }
      }
   ]
}

var Encryption = {
   name: "Encryption",
   vendor: "UiFabric",
   unicode: 63133,
   value: "",
   charCode: "F69D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 256L1920 256L1920 768Q1920 919 1882 1053Q1844 1187 1777 1306Q1710 1425 1618.50 1529Q1527 1633 1420.50 1724.50Q1314 1816 1196.50 1895.50Q1079 1975 960 2045L960 2045Q841 1975 723.50 1895.50Q606 1816 499.50 1724.50Q393 1633 301.50 1529Q210 1425 143 1306Q76 1187 38 1053Q0 919 0 768L0 768L0 256Q83 256 161 250Q239 244 313 228Q387 212 459 183Q531 154 603 108L603 108Q688 53 773 26.50Q858 0 960 0L960 0Q1011 0 1057 6.50Q1103 13 1146.50 26.50Q1190 40 1232 60.50Q1274 81 1317 108L1317 108Q1389 154 1461 183Q1533 212 1607 228Q1681 244 1759 250Q1837 256 1920 256ZM1792 768L1792 768L1792 382Q1643 374 1506.50 334Q1370 294 1244 213L1244 213Q1176 169 1108.50 148.50Q1041 128 960 128L960 128Q879 128 811.50 148.50Q744 169 676 213L676 213Q550 294 413.50 334Q277 374 128 382L128 382L128 768Q128 895 161.50 1012Q195 1129 253 1234.50Q311 1340 391 1434.50Q471 1529 563 1612.50Q655 1696 756.50 1767Q858 1838 960 1897L960 1897Q1062 1838 1163.50 1767Q1265 1696 1357 1612.50Q1449 1529 1529 1434.50Q1609 1340 1667 1234.50Q1725 1129 1758.50 1012Q1792 895 1792 768ZM960 320L960 320Q1026 320 1084 345.50Q1142 371 1185.50 414.50Q1229 458 1254.50 516Q1280 574 1280 640L1280 640L1280 768L1408 768L1408 1408L512 1408L512 768L640 768L640 640Q640 574 665 516Q690 458 733.50 414.50Q777 371 835.50 345.50Q894 320 960 320ZM640 1280L1280 1280L1280 896L640 896L640 1280ZM768 640L768 768L1152 768L1152 640Q1152 600 1137 565Q1122 530 1096 504Q1070 478 1035 463Q1000 448 960 448L960 448Q920 448 885 463Q850 478 824 504Q798 530 783 565Q768 600 768 640L768 640Z"
         }
      }
   ]
}

var LiveSite = {
   name: "LiveSite",
   vendor: "UiFabric",
   unicode: 63142,
   value: "",
   charCode: "F6A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 768L960 768Q1053 768 1134.50 803.50Q1216 839 1276.50 899.50Q1337 960 1372.50 1041.50Q1408 1123 1408 1216L1408 1216Q1408 1309 1372.50 1390.50Q1337 1472 1276.50 1532.50Q1216 1593 1134.50 1628.50Q1053 1664 960 1664L960 1664Q867 1664 785.50 1628.50Q704 1593 643.50 1532.50Q583 1472 547.50 1390.50Q512 1309 512 1216L512 1216Q512 1123 547.50 1041.50Q583 960 643.50 899.50Q704 839 785.50 803.50Q867 768 960 768ZM1182 1152L1306 1152Q1291 1072 1243 1007Q1195 942 1123 904L1123 904Q1152 962 1165 1025Q1178 1088 1182 1152L1182 1152ZM1085 1280L1085 1280L834 1280Q835 1296 838.50 1324Q842 1352 848.50 1384Q855 1416 865 1448.50Q875 1481 889 1507.50Q903 1534 920.50 1551Q938 1568 960 1568L960 1568Q981 1568 998 1551Q1015 1534 1028.50 1507Q1042 1480 1052 1447Q1062 1414 1069 1382Q1076 1350 1080 1322.50Q1084 1295 1085 1280ZM834 1152L834 1152L1086 1152Q1085 1137 1081 1110Q1077 1083 1070 1051Q1063 1019 1052.50 986Q1042 953 1028.50 925.50Q1015 898 997.50 881Q980 864 960 864L960 864Q938 864 920.50 881Q903 898 889.50 925Q876 952 866 985Q856 1018 849 1050Q842 1082 838.50 1109.50Q835 1137 834 1152ZM793 906L793 906Q758 925 728.50 951Q699 977 676 1008.50Q653 1040 637 1076.50Q621 1113 614 1152L614 1152L738 1152Q742 1089 754 1026.50Q766 964 793 906ZM738 1280L614 1280Q628 1358 675 1422.50Q722 1487 791 1525L791 1525Q765 1468 753.50 1405.50Q742 1343 738 1280L738 1280ZM1124 1528L1124 1528Q1195 1490 1243 1424.50Q1291 1359 1306 1280L1306 1280L1182 1280Q1177 1343 1163.50 1406.50Q1150 1470 1124 1528ZM256 0L1115 0L1664 549L1664 1920L256 1920L256 0ZM1445 512L1152 219L1152 512L1445 512ZM384 128L384 1792L1536 1792L1536 640L1024 640L1024 128L384 128Z"
         }
      }
   ]
}

var MedalSolid = {
   name: "MedalSolid",
   vendor: "UiFabric",
   unicode: 63161,
   value: "",
   charCode: "F6B9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1468 0L1111 512L937 512L580 0L1468 0ZM1663 0L1792 0Q1845 0 1891.50 20Q1938 40 1973 75Q2008 110 2028 156.50Q2048 203 2048 256L2048 256Q2048 323 2028.50 377Q2009 431 1972 486L1972 486L1548 1121Q1457 1007 1330.50 941.50Q1204 876 1058 868L1058 868L1663 0ZM385 0L990 868Q844 876 717.50 941.50Q591 1007 500 1121L500 1121L75 484Q39 430 19.50 376Q0 322 0 256L0 256Q0 203 20 156.50Q40 110 75 75Q110 40 156.50 20Q203 0 256 0L256 0L385 0ZM1024 1024L1024 1024Q1130 1024 1223.50 1064Q1317 1104 1386.50 1173.50Q1456 1243 1496 1336.50Q1536 1430 1536 1536L1536 1536Q1536 1642 1496 1735.50Q1456 1829 1386.50 1898.50Q1317 1968 1223.50 2008Q1130 2048 1024 2048L1024 2048Q918 2048 824.50 2008Q731 1968 661.50 1898.50Q592 1829 552 1735.50Q512 1642 512 1536L512 1536Q512 1430 552 1336.50Q592 1243 661.50 1173.50Q731 1104 824.50 1064Q918 1024 1024 1024Z"
         }
      }
   ]
}

var DefenderTVM = {
   name: "DefenderTVM",
   vendor: "UiFabric",
   unicode: 63155,
   value: "",
   charCode: "F6B3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 896L1664 1408L1408 1408L1408 1664L1536 1664L1536 2048L384 2048L384 1664L512 1664L512 1408L256 1408L256 896L640 896L640 1024L768 1024L768 768L896 768L896 31L1570 320L1024 554L1024 768L1152 768L1152 1024L1280 1024L1280 896L1664 896ZM1246 320L1024 225L1024 415L1246 320ZM512 1920L1408 1920L1408 1792L512 1792L512 1920ZM640 1408L640 1664L1280 1664L1280 1408L640 1408ZM384 1024L384 1280L1536 1280L1536 1024L1408 1024L1408 1152L1024 1152L1024 896L896 896L896 1152L512 1152L512 1024L384 1024Z"
         }
      }
   ]
}

var WebTemplate = {
   name: "WebTemplate",
   vendor: "UiFabric",
   unicode: 63154,
   value: "",
   charCode: "F6B2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 2048L768 896L2048 896L2048 2048L768 2048ZM896 1920L1920 1920L1920 1280L896 1280L896 1920ZM896 1152L1920 1152L1920 1024L896 1024L896 1152ZM0 0L128 0L128 128L0 128L0 0ZM0 256L128 256L128 384L0 384L0 256ZM0 512L128 512L128 640L0 640L0 512ZM0 768L128 768L128 896L0 896L0 768ZM0 1024L128 1024L128 1152L0 1152L0 1024ZM0 1280L128 1280L128 1408L0 1408L0 1280ZM0 1536L128 1536L128 1664L0 1664L0 1536ZM0 1920L0 1792L128 1792L128 1920L0 1920ZM256 2048L128 2048L128 1920L256 1920L256 2048ZM256 0L384 0L384 128L256 128L256 0ZM512 2048L384 2048L384 1920L512 1920L512 2048ZM640 128L512 128L512 0L640 0L640 128ZM768 0L896 0L896 128L768 128L768 0ZM1024 0L1152 0L1152 128L1024 128L1024 0ZM1280 0L1408 0L1408 128L1280 128L1280 0ZM1536 128L1536 256L1408 256L1408 128L1536 128ZM1408 384L1536 384L1536 512L1408 512L1408 384ZM1536 768L1408 768L1408 640L1536 640L1536 768Z"
         }
      }
   ]
}

var AuthenticatorApp = {
   name: "AuthenticatorApp",
   vendor: "UiFabric",
   unicode: 63153,
   value: "",
   charCode: "F6B1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1024 640Q1221 640 1413.50 672Q1606 704 1792 768L1792 768L1792 896Q1792 1085 1737 1261Q1682 1437 1581.50 1588Q1481 1739 1339.50 1857Q1198 1975 1024 2048L1024 2048Q851 1976 709 1857.50Q567 1739 466.50 1589Q366 1439 311 1263Q256 1087 256 899L256 899Q256 886 258 869Q260 852 262.50 834Q265 816 267.50 799Q270 782 272 768L272 768Q457 704 643 672Q829 640 1024 640ZM768 1536L1280 1536L1280 1504Q1280 1463 1267.50 1425Q1255 1387 1232 1355Q1209 1323 1177 1299Q1145 1275 1106 1262L1106 1262Q1157 1238 1186.50 1191Q1216 1144 1216 1088L1216 1088Q1216 1048 1201 1013Q1186 978 1160 952Q1134 926 1099 911Q1064 896 1024 896L1024 896Q984 896 949 911Q914 926 888 952Q862 978 847 1013Q832 1048 832 1088L832 1088Q832 1144 861.50 1191Q891 1238 942 1262L942 1262Q903 1275 871 1299Q839 1323 816 1355Q793 1387 780.50 1425Q768 1463 768 1504L768 1504L768 1536ZM1024 192L1024 192Q958 192 899.50 217Q841 242 797.50 285.50Q754 329 729 387.50Q704 446 704 512L704 512L512 544L512 512Q512 406 552.50 313Q593 220 662.50 150.50Q732 81 825 40.50Q918 0 1024 0L1024 0Q1130 0 1223 40.50Q1316 81 1385.50 150.50Q1455 220 1495.50 313Q1536 406 1536 512L1536 512L1536 544L1344 512Q1344 446 1319 387.50Q1294 329 1250.50 285.50Q1207 242 1148.50 217Q1090 192 1024 192Z"
         }
      }
   ]
}

var MarkAsProtected = {
   name: "MarkAsProtected",
   vendor: "UiFabric",
   unicode: 63150,
   value: "",
   charCode: "F6AE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1476 1328L1193 1611L489 907L772 624L1476 1328ZM1193 1430L1295 1328L772 805L670 907L1193 1430ZM256 1920L1664 1920L1664 1280L1792 1280L1792 2048L128 2048L128 0L1050 0L922 128L256 128L256 1920ZM2043 365L1969 439L1754 526L1999 771L1731 1039L1659 966L1570 1052L988 470L1077 384L1007 315L1275 47L1516 289L1607 77L1681 3L2043 365ZM1847 350L1694 197L1596 365L1675 447L1847 350ZM1708 892L1818 771L1275 228L1165 349L1708 892Z"
         }
      }
   ]
}

var VerifiedBrandSolid = {
   name: "VerifiedBrandSolid",
   vendor: "UiFabric",
   unicode: 63149,
   value: "",
   charCode: "F6AD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1969 869L1845 1024L1969 1179Q1987 1202 1997 1229.50Q2007 1257 2007 1286L2007 1286Q2007 1316 1997.50 1343Q1988 1370 1971.50 1392Q1955 1414 1931 1430Q1907 1446 1879 1454L1879 1454L1688 1507Q1690 1558 1693.50 1610Q1697 1662 1697 1714L1697 1714Q1697 1750 1683.50 1781Q1670 1812 1646.50 1835.50Q1623 1859 1591.50 1872.50Q1560 1886 1524 1886L1524 1886Q1493 1886 1463 1875L1463 1875L1278 1805L1169 1970Q1145 2007 1106.50 2027.50Q1068 2048 1024 2048L1024 2048Q980 2048 941.50 2027.50Q903 2007 879 1970L879 1970L770 1805L585 1875Q555 1886 524 1886L524 1886Q488 1886 456.50 1872.50Q425 1859 401.50 1835.50Q378 1812 364.50 1781Q351 1750 351 1714L351 1714Q351 1662 354.50 1610Q358 1558 360 1507L360 1507L169 1454Q140 1446 116.50 1430Q93 1414 76.50 1392Q60 1370 50.50 1343Q41 1316 41 1286L41 1286Q41 1257 51 1229.50Q61 1202 79 1179L79 1179L203 1024L79 869Q41 822 41 762L41 762Q41 732 50.50 705Q60 678 76.50 656Q93 634 116.50 618Q140 602 169 594L169 594L360 541Q358 490 354.50 438Q351 386 351 334L351 334Q351 298 364.50 267Q378 236 401.50 212.50Q425 189 456.50 175.50Q488 162 524 162L524 162Q555 162 585 173L585 173L770 243L879 78Q903 41 941.50 20.50Q980 0 1024 0L1024 0Q1068 0 1106.50 20.50Q1145 41 1169 78L1169 78L1278 243L1463 173Q1493 162 1524 162L1524 162Q1560 162 1591.50 175.50Q1623 189 1646.50 212.50Q1670 236 1683.50 267Q1697 298 1697 334L1697 334Q1697 386 1693.50 438Q1690 490 1688 541L1688 541L1879 594Q1907 602 1931 618Q1955 634 1971.50 656Q1988 678 1997.50 705Q2007 732 2007 762L2007 762Q2007 822 1969 869L1969 869ZM583 1081L896 1393L1465 825L1351 711L896 1167L697 967L583 1081Z"
         }
      }
   ]
}

var Hide3 = {
   name: "Hide3",
   vendor: "UiFabric",
   unicode: 63148,
   value: "",
   charCode: "F6AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M301 520L74 292L164 202L1794 1831L1703 1922L1246 1465Q1192 1500 1140.50 1518Q1089 1536 1024 1536L1024 1536Q944 1536 874 1506Q804 1476 752 1424Q700 1372 670 1302Q640 1232 640 1152L640 1152Q640 1087 658 1035.50Q676 984 711 930L711 930L391 610Q266 715 197 851Q128 987 128 1152L128 1152L0 1152Q0 1061 21 972.50Q42 884 81 802.50Q120 721 175.50 649.50Q231 578 301 520L301 520ZM768 1152L768 1152Q768 1205 788 1251.50Q808 1298 843 1333Q878 1368 924.50 1388Q971 1408 1024 1408L1024 1408Q1060 1408 1091 1398.50Q1122 1389 1153 1372L1153 1372L804 1023Q787 1054 777.50 1085Q768 1116 768 1152ZM1096 907L1096 907L963 774Q978 772 993.50 770Q1009 768 1024 768L1024 768Q1103 768 1173 798Q1243 828 1295.50 880.50Q1348 933 1378 1003Q1408 1073 1408 1152L1408 1152Q1408 1167 1406 1182.50Q1404 1198 1402 1213L1402 1213L1269 1080Q1227 949 1096 907ZM2048 1152L2048 1152L1920 1152Q1920 1034 1884 931Q1848 828 1784.50 743Q1721 658 1635 591Q1549 524 1449.50 478Q1350 432 1241.50 408Q1133 384 1024 384L1024 384Q926 384 832 403Q738 422 647 459L647 459L549 361Q665 308 780.50 282Q896 256 1024 256L1024 256Q1168 256 1309 291.50Q1450 327 1574.50 396Q1699 465 1800 566.50Q1901 668 1966 800L1966 800Q2006 882 2027 971Q2048 1060 2048 1152Z"
         }
      }
   ]
}

var OpenInNewTab = {
   name: "OpenInNewTab",
   vendor: "UiFabric",
   unicode: 63147,
   value: "",
   charCode: "F6AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L2048 0L2048 1664L1664 1664L1664 2048L0 2048L0 384L384 384L384 0ZM1664 1536L1920 1536L1920 128L512 128L512 384L768 384L768 512L128 512L128 1920L1536 1920L1536 1280L1664 1280L1664 1536ZM1536 603L941 1197L851 1107L1445 512L1024 512L1024 384L1664 384L1664 1024L1536 1024L1536 603Z"
         }
      }
   ]
}

var PasswordField = {
   name: "PasswordField",
   vendor: "UiFabric",
   unicode: 63146,
   value: "",
   charCode: "F6AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 256L2048 256L2048 1664L0 1664ZM128 1536L1920 1536L1920 384L128 384L128 1536ZM512 1120L512 1120Q479 1120 450 1107.50Q421 1095 399 1073Q377 1051 364.50 1022Q352 993 352 960L352 960Q352 927 364.50 898Q377 869 399 847Q421 825 450 812.50Q479 800 512 800L512 800Q545 800 574 812.50Q603 825 625 847Q647 869 659.50 898Q672 927 672 960L672 960Q672 993 659.50 1022Q647 1051 625 1073Q603 1095 574 1107.50Q545 1120 512 1120ZM1024 1120L1024 1120Q991 1120 962 1107.50Q933 1095 911 1073Q889 1051 876.50 1022Q864 993 864 960L864 960Q864 927 876.50 898Q889 869 911 847Q933 825 962 812.50Q991 800 1024 800L1024 800Q1057 800 1086 812.50Q1115 825 1137 847Q1159 869 1171.50 898Q1184 927 1184 960L1184 960Q1184 993 1171.50 1022Q1159 1051 1137 1073Q1115 1095 1086 1107.50Q1057 1120 1024 1120ZM1536 1120L1536 1120Q1503 1120 1474 1107.50Q1445 1095 1423 1073Q1401 1051 1388.50 1022Q1376 993 1376 960L1376 960Q1376 927 1388.50 898Q1401 869 1423 847Q1445 825 1474 812.50Q1503 800 1536 800L1536 800Q1569 800 1598 812.50Q1627 825 1649 847Q1671 869 1683.50 898Q1696 927 1696 960L1696 960Q1696 993 1683.50 1022Q1671 1051 1649 1073Q1627 1095 1598 1107.50Q1569 1120 1536 1120Z"
         }
      }
   ]
}

var D365TalentLearn = {
   name: "D365TalentLearn",
   vendor: "UiFabric",
   unicode: 63163,
   value: "",
   charCode: "F6BB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 135.50 1228Q200 1134 291.50 1062Q383 990 495 946L495 946Q439 910 395 862.50Q351 815 320 759.50Q289 704 272.50 641.50Q256 579 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 590 1257.50 661.50Q1235 733 1194 794.50Q1153 856 1095.50 904.50Q1038 953 967 984L967 984Q922 1004 876 1011Q830 1018 783.50 1022Q737 1026 690.50 1030Q644 1034 598 1047L598 1047Q494 1076 407.50 1135.50Q321 1195 259 1276.50Q197 1358 162.50 1457Q128 1556 128 1664ZM768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 241Q987 189 917 158.50Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896ZM1792 1791L1792 1791L1344 2016L896 1791Q896 1755 897 1714.50Q898 1674 904.50 1634.50Q911 1595 924 1557.50Q937 1520 961 1490L961 1490L768 1402L768 1984L640 1984L640 1344L1344 1024L2048 1344L1727 1490Q1751 1521 1764 1558Q1777 1595 1783.50 1634.50Q1790 1674 1791 1714Q1792 1754 1792 1791ZM1739 1344L1344 1164L949 1344L1344 1524L1739 1344ZM1025 1713L1344 1873L1664 1712Q1663 1686 1659.50 1664.50Q1656 1643 1649 1623.50Q1642 1604 1632.50 1584.50Q1623 1565 1610 1543L1610 1543L1344 1664L1078 1543Q1064 1566 1054.50 1585.50Q1045 1605 1039 1624.50Q1033 1644 1029.50 1665Q1026 1686 1025 1713L1025 1713Z"
         }
      }
   ]
}

var D365TalentInsight = {
   name: "D365TalentInsight",
   vendor: "UiFabric",
   unicode: 63164,
   value: "",
   charCode: "F6BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1664L128 1664L0 1664Q0 1543 35 1432Q70 1321 135 1227.50Q200 1134 291 1062Q382 990 495 946L495 946Q439 910 394.50 862.50Q350 815 319.50 759.50Q289 704 272.50 641.50Q256 579 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 590 1258 662Q1236 734 1195 795.50Q1154 857 1096.50 905Q1039 953 967 984L967 984Q918 1005 872.50 1012.50Q827 1020 782.50 1023Q738 1026 692.50 1029.50Q647 1033 598 1047L598 1047Q494 1076 407.50 1135.50Q321 1195 259 1276.50Q197 1358 162.50 1457Q128 1556 128 1664ZM768 896L768 896Q848 896 918 866Q988 836 1040 784Q1092 732 1122 662Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618 158Q548 188 496 240Q444 292 414 362Q384 432 384 512L384 512Q384 592 414 662Q444 732 496 784Q548 836 618 866Q688 896 768 896ZM1472 1152L1472 1152Q1538 1152 1596.50 1177Q1655 1202 1698.50 1245.50Q1742 1289 1767 1347.50Q1792 1406 1792 1472L1792 1472Q1792 1538 1768.50 1591.50Q1745 1645 1702 1693L1702 1693Q1664 1735 1664 1792L1664 1792L1664 1920Q1664 1947 1654 1970Q1644 1993 1626.50 2010.50Q1609 2028 1586 2038Q1563 2048 1536 2048L1536 2048L1408 2048Q1382 2048 1358.50 2038Q1335 2028 1317.50 2010.50Q1300 1993 1290 1969.50Q1280 1946 1280 1920L1280 1920L1280 1792Q1280 1763 1271.50 1739.50Q1263 1716 1243 1694L1243 1694Q1199 1645 1175.50 1591.50Q1152 1538 1152 1472L1152 1472Q1152 1405 1177 1346.50Q1202 1288 1245 1245Q1288 1202 1346.50 1177Q1405 1152 1472 1152ZM1408 1920L1536 1920L1536 1792L1408 1792L1408 1920ZM1664 1472L1664 1472Q1664 1432 1649 1397Q1634 1362 1608 1336Q1582 1310 1547 1295Q1512 1280 1472 1280L1472 1280Q1431 1280 1396 1294.50Q1361 1309 1335 1335Q1309 1361 1294.50 1396Q1280 1431 1280 1472L1280 1472Q1280 1508 1289.50 1532.50Q1299 1557 1313 1577Q1327 1597 1344 1616.50Q1361 1636 1376 1664L1376 1664L1568 1664Q1583 1637 1600 1617Q1617 1597 1631 1576.50Q1645 1556 1654.50 1532Q1664 1508 1664 1472ZM1472 1088L1472 1088Q1446 1088 1427 1069Q1408 1050 1408 1024L1408 1024L1408 960Q1408 933 1426.50 914.50Q1445 896 1472 896L1472 896Q1499 896 1517.50 914.50Q1536 933 1536 960L1536 960L1536 1024Q1536 1050 1517 1069Q1498 1088 1472 1088ZM1920 1408L1984 1408Q2011 1408 2029.50 1426.50Q2048 1445 2048 1472L2048 1472Q2048 1499 2029.50 1517.50Q2011 1536 1984 1536L1984 1536L1920 1536Q1894 1536 1875 1517Q1856 1498 1856 1472L1856 1472Q1856 1446 1875 1427Q1894 1408 1920 1408L1920 1408ZM960 1408L1024 1408Q1050 1408 1069 1427Q1088 1446 1088 1472L1088 1472Q1088 1498 1069 1517Q1050 1536 1024 1536L1024 1536L960 1536Q933 1536 914.50 1517.50Q896 1499 896 1472L896 1472Q896 1445 914.50 1426.50Q933 1408 960 1408L960 1408ZM1898 1110L1898 1110Q1898 1136 1879 1155L1879 1155Q1870 1164 1860 1175.50Q1850 1187 1839.50 1197Q1829 1207 1816.50 1213.50Q1804 1220 1789 1220L1789 1220Q1763 1220 1743.50 1200.50Q1724 1181 1724 1155L1724 1155Q1724 1140 1730.50 1127.50Q1737 1115 1747 1104.50Q1757 1094 1768.50 1084Q1780 1074 1789 1065L1789 1065Q1808 1046 1834 1046L1834 1046Q1860 1046 1879 1065Q1898 1084 1898 1110ZM1155 1220L1155 1220Q1140 1220 1127.50 1213.50Q1115 1207 1104.50 1197Q1094 1187 1084 1175.50Q1074 1164 1065 1155L1065 1155Q1046 1136 1046 1110L1046 1110Q1046 1084 1065 1065Q1084 1046 1110 1046L1110 1046Q1136 1046 1155 1065L1155 1065Q1164 1074 1175.50 1084Q1187 1094 1197 1104.50Q1207 1115 1213.50 1127.50Q1220 1140 1220 1155L1220 1155Q1220 1181 1200.50 1200.50Q1181 1220 1155 1220Z"
         }
      }
   ]
}

var D365CoreHR = {
   name: "D365CoreHR",
   vendor: "UiFabric",
   unicode: 63165,
   value: "",
   charCode: "F6BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M269 128L1766 128Q1796 128 1824 138Q1852 148 1873.50 166.50Q1895 185 1907.50 211Q1920 237 1920 269L1920 269L1920 1766Q1920 1798 1907.50 1826Q1895 1854 1874 1875Q1853 1896 1825 1908Q1797 1920 1766 1920L1766 1920L269 1920Q237 1920 211 1907.50Q185 1895 166.50 1873.50Q148 1852 138 1824Q128 1796 128 1766L128 1766L128 269Q128 240 139 214.50Q150 189 169.50 169.50Q189 150 214.50 139Q240 128 269 128L269 128ZM269 1792L768 1792L768 1306Q768 1298 764 1291.50Q760 1285 755 1280L755 1280L256 1280L256 1766Q256 1774 260 1780.50Q264 1787 269 1792L269 1792ZM896 1792L1280 1792L1280 781Q1275 776 1268 772Q1261 768 1254 768L1254 768L883 768Q873 837 840 896Q807 955 757.50 997.50Q708 1040 645 1064Q582 1088 512 1088L512 1088Q440 1088 373.50 1062.50Q307 1037 256 986L256 986L256 1152L755 1152Q787 1152 813 1164.50Q839 1177 857.50 1198.50Q876 1220 886 1248Q896 1276 896 1306L896 1306L896 1792ZM256 704L256 704Q256 757 276 803.50Q296 850 331 885Q366 920 412.50 940Q459 960 512 960L512 960Q565 960 611.50 940Q658 920 693 885Q728 850 748 803.50Q768 757 768 704L768 704Q768 651 748 604.50Q728 558 693 523Q658 488 611.50 468Q565 448 512 448L512 448Q459 448 412.50 468Q366 488 331 523Q296 558 276 604.50Q256 651 256 704ZM1792 1766L1792 1766L1792 269Q1787 264 1780 260Q1773 256 1766 256L1766 256L269 256L256 269L256 423Q307 371 373.50 345.50Q440 320 512 320L512 320Q582 320 645 344Q708 368 757.50 410.50Q807 453 840 512Q873 571 883 640L883 640L1254 640Q1284 640 1312 650Q1340 660 1361.50 678.50Q1383 697 1395.50 723Q1408 749 1408 781L1408 781L1408 1792L1766 1792Q1776 1792 1784 1784Q1792 1776 1792 1766Z"
         }
      }
   ]
}

var BacklogList = {
   name: "BacklogList",
   vendor: "UiFabric",
   unicode: 63167,
   value: "",
   charCode: "F6BF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L128 128L1920 128L1920 640L128 640L128 128ZM1792 512L1792 512L1792 256L256 256L256 512L1792 512ZM512 1280L512 1280L512 768L1920 768L1920 1280L512 1280ZM640 896L640 896L640 1152L1792 1152L1792 896L640 896ZM128 1920L128 1920L128 1408L1920 1408L1920 1920L128 1920ZM256 1536L256 1536L256 1792L1792 1792L1792 1536L256 1536Z"
         }
      }
   ]
}

var ButtonControl = {
   name: "ButtonControl",
   vendor: "UiFabric",
   unicode: 63168,
   value: "",
   charCode: "F6C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 384L2048 384L2048 1536L0 1536ZM128 1408L1920 1408L1920 512L128 512L128 1408ZM768 896L1792 896L1792 1024L768 1024L768 896ZM448 1152L448 1152Q408 1152 373 1137Q338 1122 312 1096Q286 1070 271 1035Q256 1000 256 960L256 960Q256 920 271 885Q286 850 312 824Q338 798 373 783Q408 768 448 768L448 768Q488 768 523 783Q558 798 584 824Q610 850 625 885Q640 920 640 960L640 960Q640 1000 625 1035Q610 1070 584 1096Q558 1122 523 1137Q488 1152 448 1152ZM448 896L448 896Q422 896 403 915Q384 934 384 960L384 960Q384 986 403 1005Q422 1024 448 1024L448 1024Q474 1024 493 1005Q512 986 512 960L512 960Q512 934 493 915Q474 896 448 896Z"
         }
      }
   ]
}

var TableGroup = {
   name: "TableGroup",
   vendor: "UiFabric",
   unicode: 63193,
   value: "",
   charCode: "F6D9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 512L384 512L2048 512L2048 2048L384 2048L384 512ZM896 1920L896 1920L896 1664L512 1664L512 1920L896 1920ZM896 1536L896 1536L896 1280L512 1280L512 1536L896 1536ZM896 1152L896 1152L896 896L512 896L512 1152L896 1152ZM1408 1920L1408 1920L1408 1664L1024 1664L1024 1920L1408 1920ZM1408 1536L1408 1536L1408 1280L1024 1280L1024 1536L1408 1536ZM1408 1152L1408 1152L1408 896L1024 896L1024 1152L1408 1152ZM1920 1920L1920 1920L1920 1664L1536 1664L1536 1920L1920 1920ZM1920 1536L1920 1536L1920 1280L1536 1280L1536 1536L1920 1536ZM1920 1152L1920 1152L1920 896L1536 896L1536 1152L1920 1152ZM1920 768L1920 768L1920 640L512 640L512 768L1920 768ZM128 384L128 384L128 640L256 640L256 768L128 768L128 1024L256 1024L256 1152L128 1152L128 1408L256 1408L256 1536L0 1536L0 0L1664 0L1664 384L128 384ZM128 128L128 128L128 256L1536 256L1536 128L128 128Z"
         }
      }
   ]
}

var MountainClimbing = {
   name: "MountainClimbing",
   vendor: "UiFabric",
   unicode: 63195,
   value: "",
   charCode: "F6DB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 817L1408 817L2024 2048L24 2048L768 561L768 0L1280 0L1280 384L896 384L896 561L1216 1201L1408 817ZM896 128L896 128L896 256L1152 256L1152 128L896 128ZM989 1033L989 1033L832 719L675 1033L832 1189L989 1033ZM1432 1920L1432 1920L1049 1153L832 1371L615 1153L232 1920L1432 1920ZM1576 1920L1576 1920L1816 1920L1408 1103L1288 1344L1576 1920Z"
         }
      }
   ]
}

var Lock12 = {
   name: "Lock12",
   vendor: "UiFabric",
   unicode: 63206,
   value: "",
   charCode: "F6E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L1536 853L1707 853L1707 2048L341 2048L341 853L512 853L512 512Q512 406 552 312.50Q592 219 661.50 149.50Q731 80 824.50 40Q918 0 1024 0L1024 0Q1130 0 1223.50 40Q1317 80 1386.50 149.50Q1456 219 1496 312.50Q1536 406 1536 512L1536 512ZM683 512L683 512L683 853L1365 853L1365 512Q1365 442 1338 379.50Q1311 317 1265 271Q1219 225 1156.50 198Q1094 171 1024 171L1024 171Q953 171 891 198Q829 225 783 271Q737 317 710 379.50Q683 442 683 512ZM512 1877L1536 1877L1536 1024L512 1024L512 1877Z"
         }
      }
   ]
}

var Presentation12 = {
   name: "Presentation12",
   vendor: "UiFabric",
   unicode: 63205,
   value: "",
   charCode: "F6E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L1877 0L1877 171L1707 171L1707 1024Q1707 1059 1693.50 1090.50Q1680 1122 1656.50 1145Q1633 1168 1602 1181.50Q1571 1195 1536 1195L1536 1195L1024 1195L1024 1707L1365 1707L1365 1877L512 1877L512 1707L853 1707L853 1195L341 1195Q306 1195 275 1181.50Q244 1168 221 1145Q198 1122 184.50 1090.50Q171 1059 171 1024L171 1024L171 171L0 171L0 0ZM341 1024L1536 1024L1536 171L341 171L341 1024ZM512 512L1365 512L1365 683L512 683L512 512Z"
         }
      }
   ]
}

var Presentation = {
   name: "Presentation",
   vendor: "UiFabric",
   unicode: 63204,
   value: "",
   charCode: "F6E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L0 0L1920 0L1920 128L1792 128L1792 1024Q1792 1050 1782 1073.50Q1772 1097 1754.50 1114.50Q1737 1132 1713.50 1142Q1690 1152 1664 1152L1664 1152L1024 1152L1024 1792L1536 1792L1536 1920L384 1920L384 1792L896 1792L896 1152L256 1152Q230 1152 206.50 1142Q183 1132 165.50 1114.50Q148 1097 138 1073.50Q128 1050 128 1024L128 1024L128 128L0 128ZM256 1024L1664 1024L1664 128L256 128L256 1024ZM512 512L1408 512L1408 640L512 640L512 512Z"
         }
      }
   ]
}

var Link12 = {
   name: "Link12",
   vendor: "UiFabric",
   unicode: 63203,
   value: "",
   charCode: "F6E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1707 904L1707 715Q1783 742 1846 790Q1909 838 1954 901Q1999 964 2023.50 1039Q2048 1114 2048 1195L2048 1195Q2048 1301 2007.50 1394Q1967 1487 1897.50 1556.50Q1828 1626 1735 1666.50Q1642 1707 1536 1707L1536 1707L1024 1707Q918 1707 825 1666.50Q732 1626 662.50 1556.50Q593 1487 552.50 1394Q512 1301 512 1195L512 1195Q512 1089 552.50 996Q593 903 662.50 833.50Q732 764 825 723.50Q918 683 1024 683L1024 683L1195 683Q1195 718 1181.50 749Q1168 780 1144.50 803Q1121 826 1090 839.50Q1059 853 1024 853L1024 853Q953 853 891 880Q829 907 782.50 953.50Q736 1000 709.50 1062.50Q683 1125 683 1195L683 1195Q683 1266 710 1328Q737 1390 783 1436Q829 1482 891 1509Q953 1536 1024 1536L1024 1536L1536 1536Q1606 1536 1668.50 1509Q1731 1482 1777 1436Q1823 1390 1850 1328Q1877 1266 1877 1195L1877 1195Q1877 1103 1831 1026.50Q1785 950 1707 904L1707 904ZM171 683L171 683Q171 774 217 850.50Q263 927 341 974L341 974L341 1163Q265 1136 202 1088Q139 1040 94 977Q49 914 24.50 839Q0 764 0 683L0 683Q0 577 40.50 484Q81 391 150.50 321.50Q220 252 313 211.50Q406 171 512 171L512 171L1024 171Q1130 171 1223 211.50Q1316 252 1385.50 321.50Q1455 391 1495.50 484Q1536 577 1536 683L1536 683Q1536 789 1495.50 882Q1455 975 1385.50 1044.50Q1316 1114 1223 1154.50Q1130 1195 1024 1195L1024 1195L853 1195Q853 1160 866.50 1129Q880 1098 903 1074.50Q926 1051 957 1037.50Q988 1024 1024 1024L1024 1024Q1094 1024 1156.50 997Q1219 970 1265 924Q1311 878 1338 816Q1365 754 1365 683L1365 683Q1365 613 1338.50 550.50Q1312 488 1265.50 441.50Q1219 395 1157 368Q1095 341 1024 341L1024 341L512 341Q441 341 379 368Q317 395 270.50 441.50Q224 488 197.50 550.50Q171 613 171 683Z"
         }
      }
   ]
}

var TagUnknown12Mirror = {
   name: "TagUnknown12Mirror",
   vendor: "UiFabric",
   unicode: 63202,
   value: "",
   charCode: "F6E2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1365 427L1365 427Q1365 391 1390 366Q1415 341 1451 341L1451 341Q1469 341 1484.50 348Q1500 355 1511.50 366.50Q1523 378 1529.50 393.50Q1536 409 1536 427L1536 427Q1536 462 1511 487Q1486 512 1451 512L1451 512Q1433 512 1417.50 505.50Q1402 499 1390.50 487.50Q1379 476 1372 460.50Q1365 445 1365 427ZM248 1024L853 1630L1101 1382Q1129 1456 1171 1517L1171 1517L853 1835L43 1024L1067 0L1877 0L1877 683L1707 683L1707 171L1101 171L248 1024ZM1707 2048L1536 2048L1536 1877L1707 1877L1707 2048ZM1621 853L1621 853Q1692 853 1754 880Q1816 907 1862.50 953.50Q1909 1000 1936 1062Q1963 1124 1963 1195L1963 1195L1792 1195Q1792 1160 1778.50 1129Q1765 1098 1741.50 1074.50Q1718 1051 1687 1037.50Q1656 1024 1621 1024L1621 1024Q1586 1024 1555 1037.50Q1524 1051 1501 1074.50Q1478 1098 1464.50 1129Q1451 1160 1451 1195L1451 1195Q1451 1234 1470 1265Q1489 1296 1517.50 1325Q1546 1354 1579 1384Q1612 1414 1640.50 1450.50Q1669 1487 1688 1534Q1707 1581 1707 1643L1707 1643L1707 1707L1536 1707L1536 1643Q1536 1604 1517 1573Q1498 1542 1469.50 1513Q1441 1484 1408 1454Q1375 1424 1346.50 1387Q1318 1350 1299 1303.50Q1280 1257 1280 1195L1280 1195Q1280 1125 1306.50 1062.50Q1333 1000 1379.50 953.50Q1426 907 1488 880Q1550 853 1621 853Z"
         }
      }
   ]
}

var TagUnknown12 = {
   name: "TagUnknown12",
   vendor: "UiFabric",
   unicode: 63201,
   value: "",
   charCode: "F6E1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1365 427L1365 427Q1365 391 1390 366Q1415 341 1451 341L1451 341Q1469 341 1484.50 348Q1500 355 1511.50 366.50Q1523 378 1529.50 393.50Q1536 409 1536 427L1536 427Q1536 462 1511 487Q1486 512 1451 512L1451 512Q1433 512 1417.50 505.50Q1402 499 1390.50 487.50Q1379 476 1372 460.50Q1365 445 1365 427ZM248 1024L853 1630L1101 1382Q1129 1456 1171 1517L1171 1517L853 1835L43 1024L1067 0L1877 0L1877 683L1707 683L1707 171L1101 171L248 1024ZM1707 2048L1536 2048L1536 1877L1707 1877L1707 2048ZM1621 853L1621 853Q1692 853 1754 880Q1816 907 1862.50 953.50Q1909 1000 1936 1062Q1963 1124 1963 1195L1963 1195Q1963 1256 1944 1303Q1925 1350 1894 1390Q1863 1430 1824.50 1466.50Q1786 1503 1746 1542L1746 1542Q1729 1559 1720.50 1578.50Q1712 1598 1709 1619.50Q1706 1641 1706.50 1663Q1707 1685 1707 1707L1707 1707L1536 1707L1536 1643Q1536 1581 1555 1534Q1574 1487 1602.50 1450Q1631 1413 1664 1383Q1697 1353 1725.50 1324Q1754 1295 1773 1264.50Q1792 1234 1792 1195L1792 1195Q1792 1160 1778.50 1129Q1765 1098 1741.50 1074.50Q1718 1051 1687 1037.50Q1656 1024 1621 1024L1621 1024Q1586 1024 1555 1037.50Q1524 1051 1501 1074.50Q1478 1098 1464.50 1129Q1451 1160 1451 1195L1451 1195L1280 1195Q1280 1125 1306.50 1062.50Q1333 1000 1379.50 953.50Q1426 907 1488 880Q1550 853 1621 853Z"
         }
      }
   ]
}

var TagUnknownMirror = {
   name: "TagUnknownMirror",
   vendor: "UiFabric",
   unicode: 63200,
   value: "",
   charCode: "F6E0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 448L1600 448Q1600 475 1590 498Q1580 521 1562.50 538.50Q1545 556 1522 566Q1499 576 1472 576L1472 576Q1445 576 1422 566Q1399 556 1381.50 538.50Q1364 521 1354 498Q1344 475 1344 448L1344 448Q1344 421 1354 398Q1364 375 1381.50 357.50Q1399 340 1422 330Q1445 320 1472 320L1472 320Q1499 320 1522 330Q1545 340 1562.50 357.50Q1580 375 1590 398Q1600 421 1600 448ZM1077 128L181 1024L896 1739L1280 1355L1280 1536L896 1920L0 1024L1024 0L1920 0L1920 896L1815 1001Q1771 992 1728 992L1728 992Q1703 992 1678.50 995.50Q1654 999 1630 1005L1630 1005L1792 843L1792 128L1077 128ZM1792 2048L1664 2048L1664 1920L1792 1920L1792 2048ZM1728 1152L1728 1152Q1781 1152 1827.50 1172Q1874 1192 1909 1227Q1944 1262 1964 1308.50Q1984 1355 1984 1408L1984 1408L1856 1408Q1856 1381 1846 1358Q1836 1335 1818.50 1317.50Q1801 1300 1778 1290Q1755 1280 1728 1280L1728 1280Q1701 1280 1678 1290Q1655 1300 1637.50 1317.50Q1620 1335 1610 1358Q1600 1381 1600 1408L1600 1408Q1600 1437 1614 1460Q1628 1483 1649.50 1505Q1671 1527 1696 1549.50Q1721 1572 1742.50 1600Q1764 1628 1778 1663Q1792 1698 1792 1744L1792 1744L1792 1792L1664 1792L1664 1744Q1664 1715 1650 1692Q1636 1669 1614.50 1647Q1593 1625 1568 1602.50Q1543 1580 1521.50 1552Q1500 1524 1486 1489.50Q1472 1455 1472 1408L1472 1408Q1472 1355 1492 1308.50Q1512 1262 1547 1227Q1582 1192 1628.50 1172Q1675 1152 1728 1152Z"
         }
      }
   ]
}

var TagUnknown = {
   name: "TagUnknown",
   vendor: "UiFabric",
   unicode: 63199,
   value: "",
   charCode: "F6DF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 448L1600 448Q1600 475 1590 498Q1580 521 1562.50 538.50Q1545 556 1522 566Q1499 576 1472 576L1472 576Q1445 576 1422 566Q1399 556 1381.50 538.50Q1364 521 1354 498Q1344 475 1344 448L1344 448Q1344 421 1354 398Q1364 375 1381.50 357.50Q1399 340 1422 330Q1445 320 1472 320L1472 320Q1499 320 1522 330Q1545 340 1562.50 357.50Q1580 375 1590 398Q1600 421 1600 448ZM1077 128L181 1024L896 1739L1280 1355L1280 1536L896 1920L0 1024L1024 0L1920 0L1920 896L1815 1001Q1771 992 1728 992L1728 992Q1703 992 1678.50 995.50Q1654 999 1630 1005L1630 1005L1792 843L1792 128L1077 128ZM1792 2048L1664 2048L1664 1920L1792 1920L1792 2048ZM1728 1152L1728 1152Q1781 1152 1827.50 1172Q1874 1192 1909 1227Q1944 1262 1964 1308.50Q1984 1355 1984 1408L1984 1408Q1984 1454 1970 1489Q1956 1524 1933 1554Q1910 1584 1881 1611.50Q1852 1639 1822 1669L1822 1669Q1802 1689 1796.50 1711.50Q1791 1734 1791 1759L1791 1759Q1791 1767 1791.50 1775.50Q1792 1784 1792 1792L1792 1792L1664 1792L1664 1744Q1664 1698 1678 1663Q1692 1628 1713.50 1600Q1735 1572 1760 1549.50Q1785 1527 1806.50 1505Q1828 1483 1842 1460Q1856 1437 1856 1408L1856 1408Q1856 1381 1846 1358Q1836 1335 1818.50 1317.50Q1801 1300 1778 1290Q1755 1280 1728 1280L1728 1280Q1701 1280 1678 1290Q1655 1300 1637.50 1317.50Q1620 1335 1610 1358Q1600 1381 1600 1408L1600 1408L1472 1408Q1472 1355 1492 1308.50Q1512 1262 1547 1227Q1582 1192 1628.50 1172Q1675 1152 1728 1152Z"
         }
      }
   ]
}

var BuildDefinition = {
   name: "BuildDefinition",
   vendor: "UiFabric",
   unicode: 63209,
   value: "",
   charCode: "F6E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 1088L896 1920L1024 1920L1024 2048L0 2048L0 1920L128 1920L128 1088Q128 1012 156 944.50Q184 877 232.50 825.50Q281 774 346.50 742Q412 710 488 705L488 705L1096 78Q1131 42 1178 21Q1225 0 1276 0L1276 0Q1312 0 1348 10Q1384 20 1416 39Q1448 58 1473.50 85Q1499 112 1514 146L1514 146L1898 1004Q1915 1041 1915 1087L1915 1087Q1915 1127 1900.50 1162Q1886 1197 1860.50 1223.50Q1835 1250 1800 1265Q1765 1280 1725 1280L1725 1280Q1668 1280 1620.50 1249Q1573 1218 1550 1166L1550 1166L1299 604L891 1025Q893 1041 894.50 1056.50Q896 1072 896 1088L896 1088ZM1394 506L1394 506L1592 946L1709 896L1489 403Q1470 432 1443.50 457Q1417 482 1394 506ZM1788 1087L1788 1087Q1788 1067 1779 1048.50Q1770 1030 1762 1013L1762 1013L1644 1063Q1651 1078 1657 1093.50Q1663 1109 1672 1122Q1681 1135 1693.50 1143.50Q1706 1152 1726 1152L1726 1152Q1753 1152 1770.50 1133Q1788 1114 1788 1087ZM1188 167L644 727Q706 750 757 792Q808 834 842 891L842 891L1372 345Q1390 326 1399 303Q1408 280 1408 254L1408 254Q1408 228 1398 205Q1388 182 1371 165Q1354 148 1331 138Q1308 128 1282 128L1282 128Q1226 128 1188 167L1188 167ZM256 1088L256 1920L768 1920L768 1088Q768 1035 748 988.50Q728 942 693 907Q658 872 611.50 852Q565 832 512 832L512 832Q459 832 412.50 852Q366 872 331 907Q296 942 276 988.50Q256 1035 256 1088L256 1088ZM512 1024L512 1024Q539 1024 562 1034Q585 1044 602.50 1061.50Q620 1079 630 1102Q640 1125 640 1152L640 1152Q640 1179 630 1202Q620 1225 602.50 1242.50Q585 1260 562 1270Q539 1280 512 1280L512 1280Q485 1280 462 1270Q439 1260 421.50 1242.50Q404 1225 394 1202Q384 1179 384 1152L384 1152Q384 1125 394 1102Q404 1079 421.50 1061.50Q439 1044 462 1034Q485 1024 512 1024ZM576 1152L512 1152L576 1152ZM2048 1792L1408 1792L1408 1664L2048 1664L2048 1792ZM1408 1536L1408 1408L2048 1408L2048 1536L1408 1536ZM1280 1536L1152 1536L1152 1408L1280 1408L1280 1536ZM2048 2048L1408 2048L1408 1920L2048 1920L2048 2048ZM1280 2048L1152 2048L1152 1920L1280 1920L1280 2048ZM1280 1792L1152 1792L1152 1664L1280 1664L1280 1792Z"
         }
      }
   ]
}

var ReleaseDefinition = {
   name: "ReleaseDefinition",
   vendor: "UiFabric",
   unicode: 63210,
   value: "",
   charCode: "F6EA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 0L2048 0L2048 64Q2048 231 2022.50 374.50Q1997 518 1943 647Q1889 776 1805.50 895.50Q1722 1015 1605 1133L1605 1133Q1567 1171 1528 1208Q1489 1245 1447 1280L1447 1280L1237 1280Q1312 1226 1380.50 1168Q1449 1110 1514 1044L1514 1044Q1613 943 1687 841Q1761 739 1811 628Q1861 517 1887.50 394Q1914 271 1919 129L1919 129Q1777 134 1654 160.50Q1531 187 1420.50 237Q1310 287 1208 360.50Q1106 434 1005 533L1005 533Q905 630 823 737Q741 844 668 962L668 962L1024 1317L1024 1565Q886 1645 745 1721L745 1721L327 1303Q403 1162 483 1024L483 1024L256 1024L256 722L828 531L828 532Q955 396 1080.50 296Q1206 196 1344 130Q1482 64 1639 32Q1796 0 1984 0L1984 0ZM973 1447L973 1447L601 1075Q572 1126 543.50 1177Q515 1228 486 1279L486 1279L486 1280L768 1562L769 1562Q820 1533 871 1504.50Q922 1476 973 1447ZM384 896L558 896Q587 850 616.50 805Q646 760 678 716L678 716L384 814L384 896ZM1536 768L1536 768Q1536 821 1516 867.50Q1496 914 1461 949Q1426 984 1379.50 1004Q1333 1024 1280 1024L1280 1024Q1227 1024 1180.50 1004Q1134 984 1099 949Q1064 914 1044 867.50Q1024 821 1024 768L1024 768Q1024 715 1044 668.50Q1064 622 1099 587Q1134 552 1180.50 532Q1227 512 1280 512L1280 512Q1333 512 1379.50 532Q1426 552 1461 587Q1496 622 1516 668.50Q1536 715 1536 768ZM1152 768L1152 768Q1152 795 1162 818Q1172 841 1189.50 858.50Q1207 876 1230 886Q1253 896 1280 896L1280 896Q1307 896 1330 886Q1353 876 1370.50 858.50Q1388 841 1398 818Q1408 795 1408 768L1408 768Q1408 741 1398 718Q1388 695 1370.50 677.50Q1353 660 1330 650Q1307 640 1280 640L1280 640Q1253 640 1230 650Q1207 660 1189.50 677.50Q1172 695 1162 718Q1152 741 1152 768ZM256 1536L256 1536Q309 1536 355.50 1556Q402 1576 437 1611Q472 1646 492 1692.50Q512 1739 512 1792L512 1792Q512 1845 492 1891.50Q472 1938 437 1973Q402 2008 355.50 2028Q309 2048 256 2048L256 2048L0 2048L0 1792Q0 1739 20 1692.50Q40 1646 75 1611Q110 1576 156.50 1556Q203 1536 256 1536ZM128 1920L256 1920Q283 1920 306 1910Q329 1900 346.50 1882.50Q364 1865 374 1842Q384 1819 384 1792L384 1792Q384 1765 374 1742Q364 1719 346.50 1701.50Q329 1684 306 1674Q283 1664 256 1664L256 1664Q229 1664 206 1674Q183 1684 165.50 1701.50Q148 1719 138 1742Q128 1765 128 1792L128 1792L128 1920ZM2048 1792L1408 1792L1408 1664L2048 1664L2048 1792ZM2048 1536L1408 1536L1408 1408L2048 1408L2048 1536ZM1280 2048L1152 2048L1152 1920L1280 1920L1280 2048ZM1280 1536L1152 1536L1152 1408L1280 1408L1280 1536ZM2048 2048L1408 2048L1408 1920L2048 1920L2048 2048ZM1280 1792L1152 1792L1152 1664L1280 1664L1280 1792Z"
         }
      }
   ]
}

var SaveTemplate = {
   name: "SaveTemplate",
   vendor: "UiFabric",
   unicode: 63212,
   value: "",
   charCode: "F6EC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 512L256 512L256 640L128 640L128 512ZM128 768L256 768L256 896L128 896L128 768ZM128 1024L256 1024L256 1152L128 1152L128 1024ZM128 1280L256 1280L256 1408L128 1408L128 1280ZM128 1536L256 1536L256 1664L128 1664L128 1536ZM128 1920L128 1792L256 1792L256 1920L128 1920ZM384 2048L256 2048L256 1920L384 1920L384 2048ZM640 2048L512 2048L512 1920L640 1920L640 2048ZM256 0L256 128L128 128L128 0L256 0ZM384 0L512 0L512 128L384 128L384 0ZM640 0L768 0L768 128L640 128L640 0ZM896 0L1024 0L1024 128L896 128L896 0ZM1152 0L1280 0L1280 128L1152 128L1152 0ZM1408 0L1536 0L1536 128L1408 128L1408 0ZM1664 128L1664 256L1536 256L1536 128L1664 128ZM1664 512L1536 512L1536 384L1664 384L1664 512ZM128 256L256 256L256 384L128 384L128 256ZM896 768L1920 768Q1946 768 1969.50 778Q1993 788 2010.50 805.50Q2028 823 2038 846.50Q2048 870 2048 896L2048 896L2048 2048L933 2048L768 1883L768 896Q768 870 778 846.50Q788 823 805.50 805.50Q823 788 846.50 778Q870 768 896 768L896 768ZM1664 896L1152 896L1152 1280L1664 1280L1664 896ZM1408 1920L1664 1920L1664 1664L1152 1664L1152 1920L1280 1920L1280 1792L1408 1792L1408 1920ZM1792 1920L1920 1920L1920 896L1792 896L1792 1408L1024 1408L1024 896L896 896L896 1829L987 1920L1024 1920L1024 1536L1792 1536L1792 1920Z"
         }
      }
   ]
}

var UserGauge = {
   name: "UserGauge",
   vendor: "UiFabric",
   unicode: 63213,
   value: "",
   charCode: "F6ED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1545 35.50 1433.50Q71 1322 136 1227.50Q201 1133 292.50 1060.50Q384 988 496 946L496 946Q381 871 318.50 760Q256 649 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140.50 863.50Q1096 911 1040 946L1040 946Q1095 967 1145.50 997Q1196 1027 1242 1064L1242 1064Q1173 1088 1109 1126L1109 1126Q1079 1102 1036.50 1083Q994 1064 946.50 1051Q899 1038 852 1031Q805 1024 768 1024ZM768 896L768 896Q848 896 918 866Q988 836 1040 784Q1092 732 1122 662Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618 158Q548 188 496 240Q444 292 414 362Q384 432 384 512L384 512Q384 592 414 662Q444 732 496 784Q548 836 618 866Q688 896 768 896ZM1840 1269L1931 1360L1645 1646Q1664 1687 1664 1728L1664 1728Q1664 1768 1649 1803Q1634 1838 1608 1864Q1582 1890 1547 1905Q1512 1920 1472 1920L1472 1920Q1432 1920 1397 1905Q1362 1890 1336 1864Q1310 1838 1295 1803Q1280 1768 1280 1728L1280 1728Q1280 1688 1295 1653Q1310 1618 1336 1592Q1362 1566 1397 1551Q1432 1536 1472 1536L1472 1536Q1513 1536 1554 1555L1554 1555L1840 1269ZM1472 1792L1472 1792Q1498 1792 1517 1773Q1536 1754 1536 1728L1536 1728Q1536 1702 1517 1683Q1498 1664 1472 1664L1472 1664Q1446 1664 1427 1683Q1408 1702 1408 1728L1408 1728Q1408 1754 1427 1773Q1446 1792 1472 1792ZM1472 1280L1472 1280Q1379 1280 1297.50 1315.50Q1216 1351 1155.50 1411.50Q1095 1472 1059.50 1553.50Q1024 1635 1024 1728L1024 1728Q1024 1792 1042.50 1853.50Q1061 1915 1095 1969L1095 1969L993 2048Q945 1976 920.50 1894.50Q896 1813 896 1728L896 1728Q896 1609 941.50 1504Q987 1399 1065 1321Q1143 1243 1248 1197.50Q1353 1152 1472 1152L1472 1152Q1537 1152 1599 1167Q1661 1182 1719 1210L1719 1210L1621 1307Q1585 1295 1547.50 1287.50Q1510 1280 1472 1280ZM1893 1579L1990 1481Q2018 1539 2033 1601Q2048 1663 2048 1728L2048 1728Q2048 1813 2023.50 1894.50Q1999 1976 1951 2048L1951 2048L1849 1969Q1883 1915 1901.50 1853.50Q1920 1792 1920 1728L1920 1728Q1920 1690 1912.50 1652.50Q1905 1615 1893 1579L1893 1579Z"
         }
      }
   ]
}

var TagSolid = {
   name: "TagSolid",
   vendor: "UiFabric",
   unicode: 63246,
   value: "",
   charCode: "F70E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1024L1024 0L1920 0L1920 896L896 1920L0 1024ZM1472 624L1472 624Q1508 624 1540 610Q1572 596 1596 572Q1620 548 1634 516Q1648 484 1648 448L1648 448Q1648 412 1634 380Q1620 348 1596 324Q1572 300 1540 286Q1508 272 1472 272L1472 272Q1436 272 1404 286Q1372 300 1348 324Q1324 348 1310 380Q1296 412 1296 448L1296 448Q1296 484 1310 516Q1324 548 1348 572Q1372 596 1404 610Q1436 624 1472 624Z"
         }
      }
   ]
}

var BlockedSiteSolid12 = {
   name: "BlockedSiteSolid12",
   vendor: "UiFabric",
   unicode: 63242,
   value: "",
   charCode: "F70A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1877 250L1877 250L1877 751Q1877 895 1839.50 1025.50Q1802 1156 1736.50 1273Q1671 1390 1582 1494Q1493 1598 1388.50 1688.50Q1284 1779 1169.50 1856.50Q1055 1934 939 1999L939 1999Q823 1938 708.50 1860.50Q594 1783 489.50 1691.50Q385 1600 295.50 1494.50Q206 1389 140.50 1271Q75 1153 37.50 1022.50Q0 892 0 751L0 751L0 250Q84 250 159.50 244.50Q235 239 306.50 223Q378 207 448 178.50Q518 150 591 104L591 104Q633 78 674 58.50Q715 39 757 26Q799 13 844 6.50Q889 0 939 0L939 0Q990 0 1035 6.50Q1080 13 1122 26.50Q1164 40 1205 59.50Q1246 79 1288 106L1288 106Q1359 151 1429 179Q1499 207 1571 223Q1643 239 1719 244.50Q1795 250 1877 250ZM1288 1439L1439 1288L1090 939L1441 587L1290 437L939 788L587 437L437 587L788 939L437 1290L587 1441L939 1090L1288 1439Z"
         }
      }
   ]
}

var OfficeChat = {
   name: "OfficeChat",
   vendor: "UiFabric",
   unicode: 63247,
   value: "",
   charCode: "F70F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1280L384 1280L384 1573L640 1317L640 1499L256 1883L256 1408L0 1408L0 128L1792 128L1792 640L1664 640L1664 256L128 256L128 1280ZM768 1664L768 768L2048 768L2048 1664L1792 1664L1792 2011L1445 1664L768 1664ZM1664 1536L1920 1536L1920 896L896 896L896 1536L1499 1536L1664 1701L1664 1536Z"
         }
      }
   ]
}

var OfficeChatSolid = {
   name: "OfficeChatSolid",
   vendor: "UiFabric",
   unicode: 63248,
   value: "",
   charCode: "F710",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L1792 128L1792 640L640 640L640 1499L256 1883L256 1408L0 1408L0 128ZM768 1664L768 768L2048 768L2048 1664L1792 1664L1792 2011L1445 1664L768 1664Z"
         }
      }
   ]
}

var MailSchedule = {
   name: "MailSchedule",
   vendor: "UiFabric",
   unicode: 63278,
   value: "",
   charCode: "F72E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 565L960 1100L128 565L128 1536L896 1536L896 1664L0 1664L0 384L1920 384L1920 985Q1907 976 1891 965.50Q1875 955 1858 945.50Q1841 936 1824 927.50Q1807 919 1792 915L1792 915L1792 565ZM960 948L1638 512L282 512L960 948ZM2048 1536L2048 1536Q2048 1642 2008 1735.50Q1968 1829 1898.50 1898.50Q1829 1968 1735.50 2008Q1642 2048 1536 2048L1536 2048Q1430 2048 1336.50 2008Q1243 1968 1173.50 1898.50Q1104 1829 1064 1735.50Q1024 1642 1024 1536L1024 1536Q1024 1430 1064 1336.50Q1104 1243 1173.50 1173.50Q1243 1104 1336.50 1064Q1430 1024 1536 1024L1536 1024Q1642 1024 1735.50 1064Q1829 1104 1898.50 1173.50Q1968 1243 2008 1336.50Q2048 1430 2048 1536ZM1536 1920L1536 1920Q1615 1920 1685 1890Q1755 1860 1807.50 1807.50Q1860 1755 1890 1685.50Q1920 1616 1920 1536L1920 1536Q1920 1457 1890 1387Q1860 1317 1807.50 1264.50Q1755 1212 1685 1182Q1615 1152 1536 1152L1536 1152Q1456 1152 1386.50 1182Q1317 1212 1264.50 1264.50Q1212 1317 1182 1387Q1152 1457 1152 1536L1152 1536Q1152 1616 1182 1685.50Q1212 1755 1264.50 1807.50Q1317 1860 1386.50 1890Q1456 1920 1536 1920ZM1408 1280L1536 1280L1536 1536L1728 1536L1728 1664L1408 1664L1408 1280Z"
         }
      }
   ]
}

var PowerShell2 = {
   name: "PowerShell2",
   vendor: "UiFabric",
   unicode: 63280,
   value: "",
   charCode: "F730",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1792L768 1664L2048 1664L2048 1792L768 1792ZM27 390L101 286L1134 1024L101 1762L27 1658L914 1024L27 390Z"
         }
      }
   ]
}

var Blocked2Solid = {
   name: "Blocked2Solid",
   vendor: "UiFabric",
   unicode: 63287,
   value: "",
   charCode: "F737",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 0L960 0Q1092 0 1215 34.50Q1338 69 1444.50 131.50Q1551 194 1638.50 281.50Q1726 369 1788.50 475.50Q1851 582 1885.50 705Q1920 828 1920 960L1920 960Q1920 1093 1885.50 1215.50Q1851 1338 1788.50 1444.50Q1726 1551 1638.50 1638.50Q1551 1726 1444.50 1788.50Q1338 1851 1215 1885.50Q1092 1920 960 1920L960 1920Q827 1920 704.50 1885.50Q582 1851 475.50 1788.50Q369 1726 281.50 1638.50Q194 1551 131.50 1444.50Q69 1338 34.50 1215Q0 1092 0 960L0 960Q0 828 34.50 705Q69 582 131.50 475.50Q194 369 281.50 281.50Q369 194 475.50 131.50Q582 69 705 34.50Q828 0 960 0ZM384 1024L1536 1024L1536 896L384 896L384 1024Z"
         }
      }
   ]
}

var WarningSolid = {
   name: "WarningSolid",
   vendor: "UiFabric",
   unicode: 63286,
   value: "",
   charCode: "F736",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1920L960 0L1920 1920L0 1920ZM896 1664L1024 1664L1024 1536L896 1536L896 1664ZM896 640L896 1408L1024 1408L1024 640L896 640Z"
         }
      }
   ]
}

var SkypeCircleArrow = {
   name: "SkypeCircleArrow",
   vendor: "UiFabric",
   unicode: 63303,
   value: "",
   charCode: "F747",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1295.50 36.50Q1426 73 1540 140Q1654 207 1747.50 300.50Q1841 394 1908 508Q1975 622 2011.50 752.50Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1295.50Q1975 1426 1908 1540Q1841 1654 1747.50 1747.50Q1654 1841 1540 1908Q1426 1975 1295.50 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752.50 2011.50Q622 1975 508 1908Q394 1841 300.50 1747.50Q207 1654 140 1540Q73 1426 36.50 1295.50Q0 1165 0 1024L0 1024Q0 883 36.50 752.50Q73 622 140 508Q207 394 300.50 300.50Q394 207 508 140Q622 73 752.50 36.50Q883 0 1024 0ZM1577 1024L1577 1024Q1577 1002 1568.50 982.50Q1560 963 1545 948Q1530 933 1510 924.50Q1490 916 1468 916L1468 916L824 916Q843 897 874.50 871Q906 845 936 815Q966 785 987.50 751.50Q1009 718 1009 684L1009 684Q1009 662 1000.50 642Q992 622 977 608Q962 594 942 585.50Q922 577 900 577L900 577Q879 577 859 585Q839 593 824 608L824 608L486 947L485 947Q471 961 462 980Q453 999 453 1019L453 1019Q453 1042 460.50 1063Q468 1084 485 1101L485 1101L486 1101L824 1440Q855 1471 901 1471L901 1471Q948 1471 978.50 1439.50Q1009 1408 1009 1361L1009 1361Q1009 1330 986.50 1297Q964 1264 934 1233Q904 1202 873 1176Q842 1150 824 1132L824 1132L1468 1132Q1490 1132 1510 1123.50Q1530 1115 1545 1100Q1560 1085 1568.50 1065.50Q1577 1046 1577 1024Z"
         }
      }
   ]
}

var SkypeArrow = {
   name: "SkypeArrow",
   vendor: "UiFabric",
   unicode: 63304,
   value: "",
   charCode: "F748",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1980 964L1980 964Q1980 1005 1964.50 1041Q1949 1077 1922 1104Q1895 1131 1859 1146.50Q1823 1162 1782 1162L1782 1162L739 1162L1020 1442Q1048 1469 1063 1506Q1078 1543 1078 1582L1078 1582Q1078 1623 1062.50 1659Q1047 1695 1020 1722Q993 1749 957 1764.50Q921 1780 880 1780L880 1780Q841 1780 804.50 1765Q768 1750 740 1722L740 1722L125 1106Q92 1073 78 1038Q64 1003 64 956L64 956Q64 917 81.50 882.50Q99 848 125 822L125 822L740 206Q768 178 805 163Q842 148 881 148L881 148Q922 148 958 164Q994 180 1020.50 207Q1047 234 1062.50 270.50Q1078 307 1078 347L1078 347Q1078 386 1063 422Q1048 458 1020 486L1020 486L739 766L1782 766Q1823 766 1859 781.50Q1895 797 1922 824Q1949 851 1964.50 887Q1980 923 1980 964Z"
         }
      }
   ]
}

var SyncStatus = {
   name: "SyncStatus",
   vendor: "UiFabric",
   unicode: 63313,
   value: "",
   charCode: "F751",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1166 2011.50 1296.50Q1975 1427 1908.50 1541Q1842 1655 1748.50 1748.50Q1655 1842 1541 1908.50Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q882 2048 751.50 2011.50Q621 1975 507 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 139.50 507Q206 393 299.50 299.50Q393 206 507 139.50Q621 73 752 36.50Q883 0 1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1541 139.50Q1655 206 1748.50 299.50Q1842 393 1908.50 507Q1975 621 2011.50 752Q2048 883 2048 1024ZM1024 1920L1024 1920Q1147 1920 1261.50 1888Q1376 1856 1475.50 1797.50Q1575 1739 1657 1657Q1739 1575 1797.50 1475.50Q1856 1376 1888 1261.50Q1920 1147 1920 1024L1920 1024Q1920 901 1888 786.50Q1856 672 1797.50 572.50Q1739 473 1657 391Q1575 309 1475.50 250.50Q1376 192 1261.50 160Q1147 128 1024 128L1024 128Q900 128 786 160Q672 192 572.50 250.50Q473 309 391 391Q309 473 250.50 572.50Q192 672 160 786.50Q128 901 128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920ZM1024 1408L1024 1408Q1079 1408 1131.50 1392.50Q1184 1377 1229 1348Q1274 1319 1310.50 1278.50Q1347 1238 1371 1188L1371 1188L1487 1244Q1455 1311 1406.50 1365Q1358 1419 1297.50 1457Q1237 1495 1167.50 1515.50Q1098 1536 1024 1536L1024 1536Q914 1536 813.50 1491Q713 1446 640 1363L640 1363L640 1536L512 1536L512 1152L896 1152L896 1280L738 1280Q792 1340 867.50 1374Q943 1408 1024 1408ZM1408 685L1408 685L1408 512L1536 512L1536 896L1152 896L1152 768L1310 768Q1256 708 1180.50 674Q1105 640 1024 640L1024 640Q969 640 916.50 655.50Q864 671 819 700Q774 729 737.50 769.50Q701 810 677 860L677 860L561 804Q593 737 641.50 683Q690 629 750.50 591Q811 553 880.50 532.50Q950 512 1024 512L1024 512Q1134 512 1234.50 557Q1335 602 1408 685Z"
         }
      }
   ]
}

var SyncStatusSolid = {
   name: "SyncStatusSolid",
   vendor: "UiFabric",
   unicode: 63314,
   value: "",
   charCode: "F752",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1024 1558L1024 1558Q1101 1558 1173.50 1536.50Q1246 1515 1309 1475Q1372 1435 1423 1378.50Q1474 1322 1507 1253L1507 1253L1351 1179Q1328 1226 1294 1264Q1260 1302 1217 1329Q1174 1356 1125 1371Q1076 1386 1024 1386L1024 1386Q952 1386 886.50 1358Q821 1330 770 1280L770 1280L896 1280L896 1152L512 1152L512 1536L640 1536L640 1394Q715 1472 815 1515Q915 1558 1024 1558ZM1152 896L1536 896L1536 512L1408 512L1408 654Q1333 576 1233 533Q1133 490 1024 490L1024 490Q947 490 874.50 511.50Q802 533 739 573Q676 613 625 669.50Q574 726 541 795L541 795L697 869Q719 822 753.50 784Q788 746 831 719Q874 692 923 677Q972 662 1024 662L1024 662Q1096 662 1161.50 690Q1227 718 1278 768L1278 768L1152 768L1152 896Z"
         }
      }
   ]
}

var ProjectDocument = {
   name: "ProjectDocument",
   vendor: "UiFabric",
   unicode: 63321,
   value: "",
   charCode: "F759",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M400 879L457 879Q507 879 539.50 900.50Q572 922 572 977L572 977Q572 1033 540.50 1055.50Q509 1078 457 1078L457 1078L400 1078L400 879ZM384 0L1459 0L2048 589L2048 2048L384 2048L384 1712L0 1651L0 512L384 457L384 0ZM400 1408L400 1187L469 1187Q518 1187 564.50 1174Q611 1161 646 1134.50Q681 1108 702.50 1067.50Q724 1027 724 972L724 972Q724 915 705.50 876Q687 837 655 813Q623 789 578.50 778.50Q534 768 482 768L482 768L256 768L256 1408L400 1408ZM512 1920L1920 1920L1920 768L1792 768L1792 1792L1024 1792L1024 1664L1664 1664L1664 1536L1152 1536L1152 1280L1664 1280L1664 768L1024 768L1024 640L1280 640L1280 128L512 128L512 439L896 384L896 1792L512 1732L512 1920ZM1408 640L1920 640L1408 128L1408 640ZM1024 896L1536 896L1536 1152L1024 1152L1024 896Z"
         }
      }
   ]
}

var ToDoLogoOutline = {
   name: "ToDoLogoOutline",
   vendor: "UiFabric",
   unicode: 63323,
   value: "",
   charCode: "F75B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1720 237L2023 540Q2048 567 2048 600L2048 600Q2048 635 2023 660L2023 660L872 1811Q860 1824 844.50 1830Q829 1836 812 1836L812 1836Q777 1836 752 1811L752 1811L116 1175Q103 1163 97 1147.50Q91 1132 91 1115L91 1115Q91 1080 116 1055L116 1055L419 751Q446 726 479 726L479 726Q514 726 539 751L539 751L812 1024L1599 237Q1612 224 1627.50 218Q1643 212 1659 212L1659 212Q1676 212 1691.50 218Q1707 224 1720 237L1720 237ZM479 872L237 1115L479 1357L722 1115L479 872ZM577 1455L812 1690L1902 600L1659 358L570 1448L577 1455Z"
         }
      }
   ]
}

var BookmarkReport = {
   name: "BookmarkReport",
   vendor: "UiFabric",
   unicode: 63339,
   value: "",
   charCode: "F76B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1664L0 1664L0 1024L384 1024L384 1664ZM1536 384L1920 384L1920 768L1536 768L1536 384ZM1024 0L1408 0L1408 768L1152 768L1152 1664L1024 1664L1024 0ZM896 1664L512 1664L512 384L896 384L896 1664ZM1280 2048L1280 896L2048 896L2048 2048L1664 1792L1280 2048ZM1920 1809L1920 1024L1408 1024L1408 1809Q1473 1766 1536.50 1724Q1600 1682 1664 1638L1664 1638Q1729 1680 1792.50 1723Q1856 1766 1920 1809L1920 1809Z"
         }
      }
   ]
}

var DistributeDown = {
   name: "DistributeDown",
   vendor: "UiFabric",
   unicode: 63338,
   value: "",
   charCode: "F76A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1798L1747 1587L1837 1677L1472 2042L1107 1677L1197 1587L1408 1798L1408 1024L512 1024L512 1798L723 1587L813 1677L448 2042L83 1677L173 1587L384 1798L384 896L896 896L896 0L1024 0L1024 896L1536 896L1536 1798Z"
         }
      }
   ]
}

var DoubleDownArrow = {
   name: "DoubleDownArrow",
   vendor: "UiFabric",
   unicode: 63337,
   value: "",
   charCode: "F769",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L512 1798L773 1537L863 1627L448 2042L33 1627L123 1537L384 1798L384 0L512 0ZM1536 1798L1797 1537L1887 1627L1472 2042L1057 1627L1147 1537L1408 1798L1408 0L1536 0L1536 1798Z"
         }
      }
   ]
}

var ResponsesMenu = {
   name: "ResponsesMenu",
   vendor: "UiFabric",
   unicode: 63336,
   value: "",
   charCode: "F768",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1536L640 1536L640 1152L1024 1152L1024 1536ZM896 1280L768 1280L768 1408L896 1408L896 1280ZM640 512L1024 512L1024 896L640 896L640 512ZM768 768L896 768L896 640L768 640L768 768ZM1152 640L1408 640L1408 768L1152 768L1152 640ZM256 1251L256 0L1792 0L1792 2048L546 2048L674 1920L1664 1920L1664 128L384 128L384 1246L323 1185L256 1251ZM1408 1408L1152 1408L1152 1280L1408 1280L1408 1408ZM768 1664L768 1792L250 1792L413 1955L323 2045L6 1728L323 1411L413 1501L250 1664L768 1664Z"
         }
      }
   ]
}

var UserOptional = {
   name: "UserOptional",
   vendor: "UiFabric",
   unicode: 63335,
   value: "",
   charCode: "F767",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 512L1280 512Q1280 618 1240 711.50Q1200 805 1130.50 874.50Q1061 944 967.50 984Q874 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1547 35.50 1435Q71 1323 136.50 1227.50Q202 1132 293.50 1058.50Q385 985 496 946L496 946Q440 910 395.50 863Q351 816 320 760Q289 704 272.50 641.50Q256 579 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512ZM768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896ZM2048 1472L2048 1472Q2048 1591 2002.50 1696Q1957 1801 1879 1879Q1801 1957 1696 2002.50Q1591 2048 1472 2048L1472 2048Q1353 2048 1248 2002.50Q1143 1957 1065 1879Q987 1801 941.50 1696Q896 1591 896 1472L896 1472Q896 1353 941.50 1248Q987 1143 1065 1065Q1143 987 1248 941.50Q1353 896 1472 896L1472 896Q1591 896 1696 941.50Q1801 987 1879 1065Q1957 1143 2002.50 1248Q2048 1353 2048 1472ZM1472 1920L1472 1920Q1565 1920 1646.50 1884.50Q1728 1849 1788.50 1788.50Q1849 1728 1884.50 1646.50Q1920 1565 1920 1472L1920 1472Q1920 1379 1884.50 1297.50Q1849 1216 1788.50 1155.50Q1728 1095 1646.50 1059.50Q1565 1024 1472 1024L1472 1024Q1379 1024 1297.50 1059.50Q1216 1095 1155.50 1155.50Q1095 1216 1059.50 1297.50Q1024 1379 1024 1472L1024 1472Q1024 1565 1059.50 1646.50Q1095 1728 1155.50 1788.50Q1216 1849 1297.50 1884.50Q1379 1920 1472 1920ZM1536 1792L1408 1792L1408 1408L1536 1408L1536 1792ZM1536 1280L1408 1280L1408 1152L1536 1152L1536 1280Z"
         }
      }
   ]
}

var EventDateMissed12 = {
   name: "EventDateMissed12",
   vendor: "UiFabric",
   unicode: 63332,
   value: "",
   charCode: "F764",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L1536 171L1877 171L1877 2048L0 2048L0 171L341 171L341 0L512 0L512 171L1365 171L1365 0L1536 0ZM171 1877L1707 1877L1707 683L171 683L171 1877ZM171 512L1707 512L1707 341L171 341L171 512ZM1024 1365L853 1365L853 853L1024 853L1024 1365ZM1024 1707L853 1707L853 1536L1024 1536L1024 1707Z"
         }
      }
   ]
}

var Event12 = {
   name: "Event12",
   vendor: "UiFabric",
   unicode: 63331,
   value: "",
   charCode: "F763",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 0L1536 171L1877 171L1877 2048L0 2048L0 171L341 171L341 0L512 0L512 171L1365 171L1365 0L1536 0ZM171 1877L1707 1877L1707 683L171 683L171 1877ZM171 512L1707 512L1707 341L171 341L171 512Z"
         }
      }
   ]
}

var VisioDiagramSync = {
   name: "VisioDiagramSync",
   vendor: "UiFabric",
   unicode: 63330,
   value: "",
   charCode: "F762",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 896L1152 768L2048 768L2048 1024L1920 1024L1920 896L1280 896L1280 1024L979 1024L640 1250L640 1408L1024 1408L1024 1920L128 1920L128 1408L512 1408L512 1250L77 960L512 670L512 512L216 512Q198 512 182 505Q166 498 154 486Q142 474 135 458Q128 442 128 424L128 424L128 88Q128 70 135 54Q142 38 154 26Q166 14 182 7Q198 0 216 0L216 0L936 0Q954 0 970 7Q986 14 998 26Q1010 38 1017 54Q1024 70 1024 88L1024 88L1024 424Q1024 442 1017 458Q1010 474 998 486Q986 498 970 505Q954 512 936 512L936 512L640 512L640 670L979 896L1152 896ZM896 128L256 128L256 384L896 384L896 128ZM256 1792L896 1792L896 1536L256 1536L256 1792ZM307 960L576 1139L845 960L576 781L307 960ZM1920 1289L1920 1289L1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1541 1280 1488.50 1300Q1436 1320 1394 1355.50Q1352 1391 1324 1440Q1296 1489 1286 1547L1286 1547L1159 1525Q1173 1444 1213 1376Q1253 1308 1311.50 1258Q1370 1208 1444 1180Q1518 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289ZM1600 1920L1600 1920Q1658 1920 1711 1900Q1764 1880 1806 1844.50Q1848 1809 1876 1760Q1904 1711 1914 1653L1914 1653L2041 1675Q2027 1756 1987 1824Q1947 1892 1888.50 1942Q1830 1992 1756 2020Q1682 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920Z"
         }
      }
   ]
}

var FilterSettings = {
   name: "FilterSettings",
   vendor: "UiFabric",
   unicode: 63340,
   value: "",
   charCode: "F76C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1865 1421L1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421ZM1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600ZM0 347L0 128L2048 128L2048 347L1280 1115Q1270 1125 1253.50 1138.50Q1237 1152 1218.50 1166Q1200 1180 1182 1193Q1164 1206 1152 1216L1152 1216L1152 1061L1920 293L1920 256L128 256L128 293L896 1061L896 1792L1059 1792Q1071 1826 1086 1858Q1101 1890 1121 1920L1121 1920L768 1920L768 1115L0 347Z"
         }
      }
   ]
}

var AddIn = {
   name: "AddIn",
   vendor: "UiFabric",
   unicode: 63349,
   value: "",
   charCode: "F775",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 128L1024 128L1024 1024L1920 1024L1920 2048L0 2048L0 128ZM128 1920L896 1920L896 1152L128 1152L128 1920ZM128 1024L896 1024L896 256L128 256L128 1024ZM1792 1920L1792 1152L1024 1152L1024 1920L1792 1920ZM1664 0L1664 384L2048 384L2048 512L1664 512L1664 896L1536 896L1536 512L1152 512L1152 384L1536 384L1536 0L1664 0Z"
         }
      }
   ]
}

var MailAttached = {
   name: "MailAttached",
   vendor: "UiFabric",
   unicode: 63348,
   value: "",
   charCode: "F774",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 384L2048 384L2048 1152L1920 1152L1920 648L1676 769Q1605 769 1534.50 768.50Q1464 768 1393 768L1393 768L1905 512L143 512L1024 953L1024 1095L128 648L128 1536L1024 1536L1024 1664L0 1664ZM1920 1600L1920 1280L2048 1280L2048 1600Q2048 1693 2012.50 1774.50Q1977 1856 1916.50 1916.50Q1856 1977 1774.50 2012.50Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2012.50Q1344 1977 1283.50 1916.50Q1223 1856 1187.50 1774.50Q1152 1693 1152 1600L1152 1600L1152 1216Q1152 1150 1177 1092Q1202 1034 1245.50 990.50Q1289 947 1347.50 921.50Q1406 896 1472 896L1472 896Q1538 896 1596 921.50Q1654 947 1697.50 990.50Q1741 1034 1766.50 1092Q1792 1150 1792 1216L1792 1216L1792 1536Q1792 1576 1777 1611Q1762 1646 1736 1672Q1710 1698 1675 1713Q1640 1728 1600 1728L1600 1728Q1560 1728 1525 1713Q1490 1698 1464 1672Q1438 1646 1423 1611Q1408 1576 1408 1536L1408 1536L1408 1280L1536 1280L1536 1536Q1536 1562 1555 1581Q1574 1600 1600 1600L1600 1600Q1626 1600 1645 1581Q1664 1562 1664 1536L1664 1536L1664 1216Q1664 1176 1649 1141Q1634 1106 1608 1080Q1582 1054 1547 1039Q1512 1024 1472 1024L1472 1024Q1432 1024 1397 1039Q1362 1054 1336 1080Q1310 1106 1295 1141Q1280 1176 1280 1216L1280 1216L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1666 1920 1724 1895Q1782 1870 1825.50 1826.50Q1869 1783 1894.50 1724.50Q1920 1666 1920 1600L1920 1600Z"
         }
      }
   ]
}

var GripperDotsVertical = {
   name: "GripperDotsVertical",
   vendor: "UiFabric",
   unicode: 63346,
   value: "",
   charCode: "F772",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 640L1152 384L1408 384L1408 640L1152 640ZM1408 1152L1152 1152L1152 896L1408 896L1408 1152ZM1408 1664L1152 1664L1152 1408L1408 1408L1408 1664ZM896 640L640 640L640 384L896 384L896 640ZM896 1152L640 1152L640 896L896 896L896 1152ZM896 1664L640 1664L640 1408L896 1408L896 1664Z"
         }
      }
   ]
}

var MicrosoftTranslatorLogo = {
   name: "MicrosoftTranslatorLogo",
   vendor: "UiFabric",
   unicode: 63362,
   value: "",
   charCode: "F782",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M737 1716L737 1716Q737 1793 742.50 1869.50Q748 1946 762 2022L762 2022L614 2027Q609 2005 606 1983.50Q603 1962 603 1939L603 1939L594 1939Q528 1999 446.50 2022Q365 2045 278 2045L278 2045Q218 2045 169 2027Q120 2009 85.50 1975.50Q51 1942 32 1893.50Q13 1845 13 1784L13 1784Q13 1696 43 1632.50Q73 1569 125 1527.50Q177 1486 247.50 1466.50Q318 1447 399 1447L399 1447Q462 1447 525 1459L525 1459Q538 1461 558.50 1467.50Q579 1474 591 1474L591 1474Q596 1474 597 1471.50Q598 1469 598 1464L598 1464Q598 1453 596 1443Q594 1433 594 1422L594 1422Q594 1359 575.50 1321Q557 1283 524 1262.50Q491 1242 445 1235.50Q399 1229 345 1229L345 1229Q315 1229 292.50 1233.50Q270 1238 249.50 1244.50Q229 1251 208 1258.50Q187 1266 159 1273L159 1273L135 1143Q170 1133 201 1124Q232 1115 262.50 1108.50Q293 1102 325.50 1098.50Q358 1095 395 1095L395 1095Q475 1095 539.50 1110Q604 1125 650 1160.50Q696 1196 720.50 1254.50Q745 1313 745 1400L745 1400Q745 1479 741 1558Q737 1637 737 1716ZM348 1916L348 1916Q415 1916 479 1899Q543 1882 596 1838L596 1838Q593 1773 592 1709.50Q591 1646 591 1581L591 1581Q556 1570 519 1564.50Q482 1559 445 1559L445 1559Q399 1559 349.50 1570Q300 1581 259.50 1605Q219 1629 193 1667Q167 1705 167 1760L167 1760Q167 1802 181 1831.50Q195 1861 219 1879.50Q243 1898 276 1907Q309 1916 348 1916ZM0 128L224 352Q299 300 386.50 275Q474 250 565 250L565 250Q608 250 653 255.50Q698 261 742 272.50Q786 284 827.50 301.50Q869 319 905 343L905 343Q843 348 778.50 368Q714 388 654.50 421Q595 454 544.50 498.50Q494 543 461 596L461 596L758 894L0 894L0 128ZM1587 1580L1290 1282L2048 1282L2048 2048L1824 1825Q1749 1877 1661.50 1901.50Q1574 1926 1483 1926L1483 1926Q1440 1926 1395.50 1920.50Q1351 1915 1307 1903.50Q1263 1892 1221 1874.50Q1179 1857 1143 1833L1143 1833Q1204 1829 1269 1808.50Q1334 1788 1393.50 1755Q1453 1722 1503.50 1677.50Q1554 1633 1587 1580L1587 1580ZM1442 993L1442 993Q1416 1020 1387.50 1045Q1359 1070 1327 1089.50Q1295 1109 1259.50 1120.50Q1224 1132 1185 1132L1185 1132Q1104 1132 1066 1083Q1028 1034 1028 956L1028 956Q1028 889 1051.50 833Q1075 777 1114 731.50Q1153 686 1204.50 649.50Q1256 613 1312 584L1312 584Q1311 567 1310.50 551Q1310 535 1310 518L1310 518Q1310 471 1312.50 425Q1315 379 1320 333L1320 333Q1308 334 1295.50 334Q1283 334 1271 334L1271 334L1235 334Q1208 334 1187 332.50Q1166 331 1147 323.50Q1128 316 1110 301Q1092 286 1070 260L1070 260Q1061 249 1050 236.50Q1039 224 1039 210L1039 210Q1039 191 1053 183Q1067 175 1084 175L1084 175Q1106 175 1119.50 183Q1133 191 1142.50 201Q1152 211 1160 220Q1168 229 1179 232L1179 232Q1193 236 1210 236.50Q1227 237 1243 237L1243 237L1264 237Q1297 237 1330 234L1330 234Q1334 201 1339 168.50Q1344 136 1349 103L1349 103Q1344 89 1332 82Q1320 75 1307.50 69.50Q1295 64 1285.50 57Q1276 50 1276 36L1276 36Q1276 16 1291.50 10.50Q1307 5 1322 5L1322 5Q1333 5 1348 9.50Q1363 14 1374 16L1374 16Q1386 19 1409.50 24.50Q1433 30 1457 39Q1481 48 1499 60.50Q1517 73 1517 89L1517 89Q1517 91 1512 107.50Q1507 124 1501 143.50Q1495 163 1489.50 180.50Q1484 198 1483 203L1483 203Q1539 184 1587 148L1587 148Q1610 131 1638.50 115.50Q1667 100 1697 100L1697 100Q1723 100 1741 115Q1759 130 1759 157L1759 157Q1759 186 1742.50 208.50Q1726 231 1699.50 247.50Q1673 264 1639.50 276Q1606 288 1572 296.50Q1538 305 1507 310Q1476 315 1455 319L1455 319Q1444 372 1437.50 425.50Q1431 479 1429 533L1429 533Q1463 521 1498 511.50Q1533 502 1569 497L1569 497Q1560 489 1543 479.50Q1526 470 1508.50 459.50Q1491 449 1478.50 438Q1466 427 1466 415L1466 415Q1466 395 1480 389.50Q1494 384 1511 384L1511 384Q1537 384 1574 387.50Q1611 391 1645 402Q1679 413 1703 434.50Q1727 456 1727 492L1727 492Q1795 499 1853.50 521.50Q1912 544 1954.50 583Q1997 622 2021 677Q2045 732 2045 804L2045 804Q2045 821 2040 844.50Q2035 868 2030 885L2030 885Q2014 936 1983.50 979.50Q1953 1023 1913.50 1059Q1874 1095 1827.50 1123.50Q1781 1152 1734 1174L1734 1174Q1711 1185 1683 1197Q1655 1209 1629 1214L1629 1214L1622 1215Q1606 1213 1588.50 1201.50Q1571 1190 1571 1172L1571 1172Q1571 1153 1587 1146Q1603 1139 1617 1136L1617 1136Q1621 1135 1632 1130.50Q1643 1126 1655.50 1120Q1668 1114 1679 1108Q1690 1102 1694 1100L1694 1100Q1732 1080 1773.50 1052.50Q1815 1025 1850 990.50Q1885 956 1908 914.50Q1931 873 1931 825L1931 825Q1931 819 1930.50 812.50Q1930 806 1929 800L1929 800Q1901 595 1695 580L1695 580Q1658 666 1614 748.50Q1570 831 1515 906L1515 906Q1530 928 1546 946.50Q1562 965 1580 985L1580 985Q1589 994 1589 1004L1589 1004Q1589 1013 1583 1021Q1577 1029 1568.50 1035Q1560 1041 1550.50 1044.50Q1541 1048 1533 1048L1533 1048Q1521 1048 1508 1043Q1495 1038 1482 1030Q1469 1022 1458.50 1012Q1448 1002 1442 993ZM1565 588L1565 588Q1496 600 1430 624L1430 624Q1433 664 1439.50 703.50Q1446 743 1458 781L1458 781Q1471 760 1486.50 736Q1502 712 1516.50 687Q1531 662 1544 637Q1557 612 1565 588ZM1141 978L1141 978Q1141 1004 1159.50 1023.50Q1178 1043 1204 1043L1204 1043Q1226 1043 1251.50 1026Q1277 1009 1301 985Q1325 961 1345 936Q1365 911 1377 895L1377 895Q1353 844 1340 789.50Q1327 735 1320 679L1320 679Q1286 703 1254 736.50Q1222 770 1197 809.50Q1172 849 1156.50 892Q1141 935 1141 978Z"
         }
      }
   ]
}

var MicOff2 = {
   name: "MicOff2",
   vendor: "UiFabric",
   unicode: 63361,
   value: "",
   charCode: "F781",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 192L640 324L512 196L512 192Q512 152 527 117Q542 82 568 56Q594 30 629 15Q664 0 704 0L704 0L1216 0Q1256 0 1291 15Q1326 30 1352 56Q1378 82 1393 117Q1408 152 1408 192L1408 192L1408 1092L1280 964L1280 192Q1280 165 1261.50 146.50Q1243 128 1216 128L1216 128L704 128Q677 128 658.50 146.50Q640 165 640 192L640 192ZM1536 1024L1664 1024L1664 1347L1536 1220L1536 1024ZM109 19L2029 1939L1939 2029L1562 1652Q1503 1719 1423 1755.50Q1343 1792 1254 1792L1254 1792L1024 1792L1024 1920L1280 1920L1280 2048L640 2048L640 1920L896 1920L896 1792L666 1792Q581 1792 506.50 1759.50Q432 1727 376.50 1671.50Q321 1616 288.50 1541.50Q256 1467 256 1382L256 1382L256 1024L384 1024L384 1382Q384 1440 406.50 1491.50Q429 1543 467 1581Q505 1619 556.50 1641.50Q608 1664 666 1664L666 1664L1254 1664Q1317 1664 1373.50 1637Q1430 1610 1471 1562L1471 1562L1369 1459Q1342 1495 1301.50 1515.50Q1261 1536 1216 1536L1216 1536L704 1536Q664 1536 629 1521Q594 1506 568 1480Q542 1454 527 1419Q512 1384 512 1344L512 1344L512 603L19 109L109 19ZM704 1408L1216 1408Q1236 1408 1252.50 1397Q1269 1386 1276 1367L1276 1367L640 731L640 1344Q640 1371 658.50 1389.50Q677 1408 704 1408L704 1408Z"
         }
      }
   ]
}

var BarChartVerticalFilterSolid = {
   name: "BarChartVerticalFilterSolid",
   vendor: "UiFabric",
   unicode: 63359,
   value: "",
   charCode: "F77F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1152L1024 1536L1152 1664L768 1664L768 768L1152 768L1152 1152L1024 1152ZM1280 256L1664 256L1664 1152L1280 1152L1280 256ZM256 512L640 512L640 1664L256 1664L256 512ZM0 128L128 128L128 1792L1280 1792L1280 1920L0 1920L0 128ZM1152 1432L1152 1280L2048 1280L2048 1432L1792 1720L1792 2048L1408 2048L1408 1720L1152 1432Z"
         }
      }
   ]
}

var BarChartVerticalFilter = {
   name: "BarChartVerticalFilter",
   vendor: "UiFabric",
   unicode: 63358,
   value: "",
   charCode: "F77E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L1408 384L1408 1152L1280 1152L1280 256L1664 256L1664 1152L1536 1152L1536 384ZM896 1536L1024 1536L1152 1664L768 1664L768 768L1152 768L1152 1152L1024 1152L1024 896L896 896L896 1536ZM256 512L640 512L640 1664L256 1664L256 512ZM384 1536L512 1536L512 640L384 640L384 1536ZM1152 1432L1152 1280L2048 1280L2048 1432L1792 1720L1792 2048L1408 2048L1408 1720L1152 1432ZM1664 1920L1664 1672L1898 1408L1302 1408L1536 1672L1536 1920L1664 1920ZM0 128L128 128L128 1792L1280 1792L1280 1920L0 1920L0 128Z"
         }
      }
   ]
}

var PromotedDatabase = {
   name: "PromotedDatabase",
   vendor: "UiFabric",
   unicode: 63357,
   value: "",
   charCode: "F77D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 637L128 637L128 1600Q128 1620 141 1635.50Q154 1651 168 1663L168 1663Q214 1701 282 1726Q350 1751 424 1765.50Q498 1780 571.50 1786Q645 1792 704 1792L704 1792Q785 1792 865 1784Q945 1776 1024 1756L1024 1756L1024 1886Q945 1904 865 1912Q785 1920 704 1920L704 1920Q643 1920 582.50 1915.50Q522 1911 462 1901L462 1901Q424 1895 375 1883.50Q326 1872 274.50 1855Q223 1838 173.50 1815Q124 1792 85.50 1760.50Q47 1729 23.50 1689Q0 1649 0 1600L0 1600L0 448Q0 379 39.50 328.50Q79 278 142 242.50Q205 207 284 184.50Q363 162 441 149.50Q519 137 589 132.50Q659 128 704 128L704 128Q749 128 819 132.50Q889 137 967 149.50Q1045 162 1124 184.50Q1203 207 1266 242.50Q1329 278 1368.50 328.50Q1408 379 1408 448L1408 448L1408 1408L1280 1408L1280 637Q1222 674 1150 699Q1078 724 1001.50 739.50Q925 755 848 761.50Q771 768 704 768L704 768Q636 768 559.50 761.50Q483 755 406.50 739.50Q330 724 258 699Q186 674 128 637ZM128 448L128 448Q128 468 141 483.50Q154 499 168 511L168 511Q214 549 282 574Q350 599 424 613.50Q498 628 571.50 634Q645 640 704 640L704 640Q762 640 835.50 634Q909 628 983.50 613.50Q1058 599 1125 574Q1192 549 1239 511L1239 511Q1253 500 1266.50 484Q1280 468 1280 448L1280 448Q1280 428 1266.50 412Q1253 396 1239 385L1239 385Q1192 347 1125 322Q1058 297 983.50 282.50Q909 268 835.50 262Q762 256 704 256L704 256Q645 256 571.50 262Q498 268 424 282.50Q350 297 282 322Q214 347 168 385L168 385Q154 397 141 412.50Q128 428 128 448ZM1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829Z"
         }
      }
   ]
}

var TableLink = {
   name: "TableLink",
   vendor: "UiFabric",
   unicode: 63354,
   value: "",
   charCode: "F77A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1024L1024 1024L1024 896L640 896L640 1664L0 1664L0 128L1664 128L1664 1024L1536 1024L1536 896L1152 896L1152 1024ZM1152 768L1536 768L1536 512L1152 512L1152 768ZM128 1536L512 1536L512 1280L128 1280L128 1536ZM128 1152L512 1152L512 896L128 896L128 1152ZM128 768L512 768L512 512L128 512L128 768ZM128 256L128 384L1536 384L1536 256L128 256ZM640 512L640 768L1024 768L1024 512L640 512ZM2048 1728L2048 1728Q2048 1794 2023 1852.50Q1998 1911 1954.50 1954.50Q1911 1998 1852.50 2023Q1794 2048 1728 2048L1728 2048L1472 2048Q1405 2048 1347 2023Q1289 1998 1245.50 1954.50Q1202 1911 1177 1853Q1152 1795 1152 1728L1152 1728Q1152 1671 1171 1619Q1190 1567 1224 1525.50Q1258 1484 1305 1455Q1352 1426 1408 1414L1408 1414L1408 1547Q1350 1568 1315 1616.50Q1280 1665 1280 1728L1280 1728Q1280 1768 1295 1803Q1310 1838 1336 1864Q1362 1890 1397 1905Q1432 1920 1472 1920L1472 1920L1728 1920Q1768 1920 1803 1905Q1838 1890 1864 1864Q1890 1838 1905 1803Q1920 1768 1920 1728L1920 1728Q1920 1663 1883 1614.50Q1846 1566 1786 1545L1786 1545Q1792 1509 1792 1472L1792 1472Q1792 1457 1791 1442.50Q1790 1428 1788 1414L1788 1414Q1845 1426 1892.50 1454.50Q1940 1483 1974.50 1524.50Q2009 1566 2028.50 1617.50Q2048 1669 2048 1728ZM896 1472L896 1472Q896 1537 933 1585.50Q970 1634 1030 1655L1030 1655Q1024 1691 1024 1728L1024 1728Q1024 1743 1025 1757.50Q1026 1772 1028 1786L1028 1786Q972 1777 924 1748Q876 1719 841.50 1676.50Q807 1634 787.50 1581Q768 1528 768 1472L768 1472Q768 1406 793 1347.50Q818 1289 861.50 1245.50Q905 1202 963.50 1177Q1022 1152 1088 1152L1088 1152L1344 1152Q1410 1152 1468 1177.50Q1526 1203 1569.50 1246.50Q1613 1290 1638.50 1348Q1664 1406 1664 1472L1664 1472Q1664 1526 1643.50 1577.50Q1623 1629 1588 1671Q1553 1713 1506.50 1743.50Q1460 1774 1408 1786L1408 1786L1408 1653Q1450 1644 1475 1629.50Q1500 1615 1513.50 1593.50Q1527 1572 1531.50 1542Q1536 1512 1536 1472L1536 1472Q1536 1432 1521 1397Q1506 1362 1480 1336Q1454 1310 1419 1295Q1384 1280 1344 1280L1344 1280L1088 1280Q1048 1280 1013 1295Q978 1310 952 1336Q926 1362 911 1397Q896 1432 896 1472Z"
         }
      }
   ]
}

var LinkedDatabase = {
   name: "LinkedDatabase",
   vendor: "UiFabric",
   unicode: 63353,
   value: "",
   charCode: "F779",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 637L128 1600Q128 1620 141 1635.50Q154 1651 168 1663L168 1663Q203 1692 249 1713Q295 1734 347 1748Q399 1762 454.50 1771Q510 1780 565 1784.50Q620 1789 672 1790.50Q724 1792 768 1792L768 1792L768 1920L694 1920Q647 1920 577.50 1914Q508 1908 431 1894Q354 1880 277 1856.50Q200 1833 138.50 1797.50Q77 1762 38.50 1713Q0 1664 0 1600L0 1600L0 448Q0 379 39.50 328.50Q79 278 142 242.50Q205 207 284 184.50Q363 162 441 149.50Q519 137 589 132.50Q659 128 704 128L704 128Q749 128 819 132.50Q889 137 967 149.50Q1045 162 1124 184.50Q1203 207 1266 242.50Q1329 278 1368.50 328.50Q1408 379 1408 448L1408 448L1408 1024L1280 1024L1280 637Q1222 674 1150 699Q1078 724 1001.50 739.50Q925 755 848 761.50Q771 768 704 768L704 768Q636 768 559.50 761.50Q483 755 406.50 739.50Q330 724 258 699Q186 674 128 637L128 637ZM704 256L704 256Q645 256 571.50 262Q498 268 424 282.50Q350 297 282 322Q214 347 168 385L168 385Q154 397 141 412.50Q128 428 128 448L128 448Q128 468 141 483.50Q154 499 168 511L168 511Q214 549 282 574Q350 599 424 613.50Q498 628 571.50 634Q645 640 704 640L704 640Q762 640 835.50 634Q909 628 983.50 613.50Q1058 599 1125 574Q1192 549 1239 511L1239 511Q1253 500 1266.50 484Q1280 468 1280 448L1280 448Q1280 428 1266.50 412Q1253 396 1239 385L1239 385Q1192 347 1125 322Q1058 297 983.50 282.50Q909 268 835.50 262Q762 256 704 256ZM1344 1280L1088 1280Q1048 1280 1013 1295Q978 1310 952 1336Q926 1362 911 1397Q896 1432 896 1472L896 1472Q896 1537 933 1585.50Q970 1634 1030 1655L1030 1655Q1024 1691 1024 1728L1024 1728Q1024 1743 1025 1757.50Q1026 1772 1028 1786L1028 1786Q972 1777 924 1748Q876 1719 841.50 1676.50Q807 1634 787.50 1581Q768 1528 768 1472L768 1472Q768 1406 793 1347.50Q818 1289 861.50 1245.50Q905 1202 963.50 1177Q1022 1152 1088 1152L1088 1152L1344 1152Q1410 1152 1468 1177.50Q1526 1203 1569.50 1246.50Q1613 1290 1638.50 1348Q1664 1406 1664 1472L1664 1472Q1664 1526 1643.50 1577Q1623 1628 1588 1670.50Q1553 1713 1506.50 1743.50Q1460 1774 1408 1786L1408 1786L1408 1653Q1450 1644 1475 1629.50Q1500 1615 1513.50 1593.50Q1527 1572 1531.50 1542Q1536 1512 1536 1472L1536 1472Q1536 1432 1521 1397Q1506 1362 1480 1336Q1454 1310 1419 1295Q1384 1280 1344 1280L1344 1280ZM1788 1414L1788 1414Q1845 1426 1892.50 1454.50Q1940 1483 1974.50 1524.50Q2009 1566 2028.50 1617.50Q2048 1669 2048 1728L2048 1728Q2048 1794 2023 1852.50Q1998 1911 1954.50 1954.50Q1911 1998 1852.50 2023Q1794 2048 1728 2048L1728 2048L1472 2048Q1405 2048 1347 2023Q1289 1998 1245.50 1954.50Q1202 1911 1177 1853Q1152 1795 1152 1728L1152 1728Q1152 1671 1171 1619Q1190 1567 1224 1525.50Q1258 1484 1305 1455Q1352 1426 1408 1414L1408 1414L1408 1547Q1350 1568 1315 1616.50Q1280 1665 1280 1728L1280 1728Q1280 1768 1295 1803Q1310 1838 1336 1864Q1362 1890 1397 1905Q1432 1920 1472 1920L1472 1920L1728 1920Q1768 1920 1803 1905Q1838 1890 1864 1864Q1890 1838 1905 1803Q1920 1768 1920 1728L1920 1728Q1920 1663 1883 1614.50Q1846 1566 1786 1545L1786 1545Q1792 1509 1792 1472L1792 1472Q1792 1457 1791 1442.50Q1790 1428 1788 1414Z"
         }
      }
   ]
}

var ShowTimeAs = {
   name: "ShowTimeAs",
   vendor: "UiFabric",
   unicode: 63367,
   value: "",
   charCode: "F787",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L0 0L2048 0L2048 2048L0 2048L0 0ZM128 768L128 768L128 933L293 768L128 768ZM128 1115L128 1115L128 1280L293 1280L805 768L475 768L128 1115ZM1920 1189L1920 1189L1920 859L1499 1280L1829 1280L1920 1189ZM1317 1280L1317 1280L1829 768L1499 768L987 1280L1317 1280ZM805 1280L805 1280L1317 768L987 768L475 1280L805 1280ZM128 640L128 640L1920 640L1920 128L128 128L128 640Z"
         }
      }
   ]
}

var FileRequest = {
   name: "FileRequest",
   vendor: "UiFabric",
   unicode: 63369,
   value: "",
   charCode: "F789",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1408L1920 1408L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L1024 1536L1024 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM2048 1792L2048 1792Q2048 1845 2028 1891.50Q2008 1938 1973 1973Q1938 2008 1891.50 2028Q1845 2048 1792 2048L1792 2048L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792L1920 1792Q1920 1765 1910 1742Q1900 1719 1882.50 1701.50Q1865 1684 1842 1674Q1819 1664 1792 1664L1792 1664L1499 1664L1661 1827L1571 1917L1254 1600L1571 1283L1661 1373L1499 1536L1792 1536Q1845 1536 1891.50 1556Q1938 1576 1973 1611Q2008 1646 2028 1692.50Q2048 1739 2048 1792Z"
         }
      }
   ]
}

var AcceptMedium = {
   name: "AcceptMedium",
   vendor: "UiFabric",
   unicode: 63372,
   value: "",
   charCode: "F78C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M683 1415L1902 196L2023 316L683 1657L25 999L146 878L683 1415Z"
         }
      }
   ]
}

var WorkItemAlert = {
   name: "WorkItemAlert",
   vendor: "UiFabric",
   unicode: 63375,
   value: "",
   charCode: "F78F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 384L384 384L384 1920L1280 1920L1280 2048L256 2048L256 256L768 256Q768 203 788 156.50Q808 110 843 75Q878 40 924.50 20Q971 0 1024 0L1024 0Q1077 0 1123.50 20Q1170 40 1205 75Q1240 110 1260 156.50Q1280 203 1280 256L1280 256L1792 256L1792 1024L1664 1024L1664 384L1536 384L1536 640L512 640L512 384ZM896 384L640 384L640 512L1408 512L1408 384L1152 384L1152 256Q1152 229 1142 206Q1132 183 1114.50 165.50Q1097 148 1074 138Q1051 128 1024 128L1024 128Q997 128 974 138Q951 148 933.50 165.50Q916 183 906 206Q896 229 896 256L896 256L896 384ZM1920 1472L1920 1664L2048 1664L2048 1792L1792 1792L1792 1856Q1792 1896 1777 1931Q1762 1966 1736 1992Q1710 2018 1675 2033Q1640 2048 1600 2048L1600 2048Q1560 2048 1525 2033Q1490 2018 1464 1992Q1438 1966 1423 1931Q1408 1896 1408 1856L1408 1856L1408 1792L1152 1792L1152 1664L1280 1664L1280 1472Q1280 1406 1305 1348Q1330 1290 1373.50 1246.50Q1417 1203 1475.50 1177.50Q1534 1152 1600 1152L1600 1152Q1666 1152 1724 1177.50Q1782 1203 1825.50 1246.50Q1869 1290 1894.50 1348Q1920 1406 1920 1472L1920 1472ZM1664 1856L1664 1856L1664 1792L1536 1792L1536 1856Q1536 1882 1555 1901Q1574 1920 1600 1920L1600 1920Q1626 1920 1645 1901Q1664 1882 1664 1856ZM1408 1472L1408 1664L1792 1664L1792 1472Q1792 1432 1777 1397Q1762 1362 1736 1336Q1710 1310 1675 1295Q1640 1280 1600 1280L1600 1280Q1560 1280 1525 1295Q1490 1310 1464 1336Q1438 1362 1423 1397Q1408 1432 1408 1472L1408 1472Z"
         }
      }
   ]
}

var PowerBILogo16 = {
   name: "PowerBILogo16",
   vendor: "UiFabric",
   unicode: 63376,
   value: "",
   charCode: "F790",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1143L384 1143Q411 1143 434.50 1154Q458 1165 475.50 1183Q493 1201 502.50 1225Q512 1249 512 1276L512 1276L512 1582Q512 1609 502.50 1633Q493 1657 475.50 1675.50Q458 1694 434.50 1704.50Q411 1715 384 1715L384 1715Q357 1715 333.50 1704.50Q310 1694 292.50 1675.50Q275 1657 265.50 1633Q256 1609 256 1582L256 1582L256 1276Q256 1249 265.50 1225Q275 1201 292.50 1183Q310 1165 333.50 1154Q357 1143 384 1143ZM768 664L768 664Q795 664 818.50 674.50Q842 685 859.50 703.50Q877 722 886.50 746Q896 770 896 797L896 797L896 1582Q896 1609 886.50 1633Q877 1657 859.50 1675.50Q842 1694 818.50 1704.50Q795 1715 768 1715L768 1715Q741 1715 717.50 1704.50Q694 1694 676.50 1675.50Q659 1657 649.50 1633Q640 1609 640 1582L640 1582L640 797Q640 770 649.50 746Q659 722 676.50 703.50Q694 685 717.50 674.50Q741 664 768 664ZM1536 333L1536 333Q1563 333 1586.50 344Q1610 355 1627.50 373Q1645 391 1654.50 415Q1664 439 1664 466L1664 466L1664 1578Q1664 1605 1654.50 1629Q1645 1653 1627.50 1671.50Q1610 1690 1586.50 1700.50Q1563 1711 1536 1711L1536 1711Q1509 1711 1485.50 1700.50Q1462 1690 1445 1672Q1428 1654 1418 1630Q1408 1606 1408 1579L1408 1579L1408 466Q1408 439 1417.50 415Q1427 391 1444.50 372.50Q1462 354 1485.50 343.50Q1509 333 1536 333ZM1152 865L1152 865Q1179 865 1202.50 876Q1226 887 1243.50 905Q1261 923 1270.50 947Q1280 971 1280 998L1280 998L1280 1582Q1280 1609 1270.50 1633Q1261 1657 1243.50 1675Q1226 1693 1202.50 1704Q1179 1715 1152 1715L1152 1715Q1125 1715 1101.50 1704.50Q1078 1694 1060.50 1675.50Q1043 1657 1033.50 1633Q1024 1609 1024 1582L1024 1582L1024 998Q1024 971 1034 947Q1044 923 1061 905Q1078 887 1101.50 876Q1125 865 1152 865Z"
         }
      }
   ]
}

var PowerBILogoBackplate16 = {
   name: "PowerBILogoBackplate16",
   vendor: "UiFabric",
   unicode: 63377,
   value: "",
   charCode: "F791",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 0L2048 0L2048 2048L0 2048Z"
         }
      }
   ]
}

var BulletedListText = {
   name: "BulletedListText",
   vendor: "UiFabric",
   unicode: 63378,
   value: "",
   charCode: "F792",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1280L384 1280L384 1152L2048 1152L2048 1280ZM2048 1664L384 1664L384 1536L2048 1536L2048 1664ZM2048 896L384 896L384 768L2048 768L2048 896ZM384 512L384 384L2048 384L2048 512L384 512Z"
         }
      }
   ]
}

var M365InvoicingLogo = {
   name: "M365InvoicingLogo",
   vendor: "UiFabric",
   unicode: 63425,
   value: "",
   charCode: "F7C1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1461 512L1461 717L430 717L430 512L1461 512ZM768 1562L768 1152L2048 1152L2048 1562Q2048 1636 2020 1701Q1992 1766 1943 1815Q1894 1864 1829 1892Q1764 1920 1690 1920L1690 1920L358 1920Q284 1920 219 1892Q154 1864 105 1815Q56 1766 28 1701Q0 1636 0 1562L0 1562L0 0L1894 0L1894 998L1690 998L1690 205L205 205L205 1562Q205 1594 217 1621.50Q229 1649 250 1670Q271 1691 298.50 1703Q326 1715 358 1715L358 1715L614 1715Q645 1715 673 1703Q701 1691 722 1670Q743 1649 755.50 1621Q768 1593 768 1562L768 1562ZM1843 1562L1843 1562L1843 1357L973 1357L973 1562Q973 1602 964.50 1641Q956 1680 938 1715L938 1715L1690 1715Q1721 1715 1749 1703Q1777 1691 1798 1670Q1819 1649 1831 1621.50Q1843 1594 1843 1562Z"
         }
      }
   ]
}

var ReleaseGateError = {
   name: "ReleaseGateError",
   vendor: "UiFabric",
   unicode: 63424,
   value: "",
   charCode: "F7C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M659 493L749 403L1306 960L749 1517L659 1427L1061 1024L0 1024L0 896L1061 896L659 493ZM1664 1024L1536 1024L1536 128L1152 128L1152 0L1664 0L1664 1024ZM2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600ZM1600 1920L1600 1920Q1666 1920 1724 1895Q1782 1870 1825.50 1826.50Q1869 1783 1894.50 1724.50Q1920 1666 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1534 1280 1475.50 1305.50Q1417 1331 1373.50 1374.50Q1330 1418 1305 1476Q1280 1534 1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920ZM1600 1521L1704 1416L1784 1496L1679 1600L1784 1704L1704 1784L1600 1679L1496 1784L1416 1704L1521 1600L1416 1496L1496 1416L1600 1521Z"
         }
      }
   ]
}

var ReleaseGateCheck = {
   name: "ReleaseGateCheck",
   vendor: "UiFabric",
   unicode: 63423,
   value: "",
   charCode: "F7BF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M659 493L749 403L1306 960L749 1517L659 1427L1061 1024L0 1024L0 896L1061 896L659 493ZM1664 1411L1536 1539L1536 128L1152 128L1152 0L1664 0L1664 1411ZM1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829Z"
         }
      }
   ]
}

var ReleaseGate = {
   name: "ReleaseGate",
   vendor: "UiFabric",
   unicode: 63422,
   value: "",
   charCode: "F7BE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M659 493L749 403L1306 960L749 1517L659 1427L1061 1024L0 1024L0 896L1061 896L659 493ZM1152 128L1152 0L1664 0L1664 1920L1152 1920L1152 1792L1536 1792L1536 128L1152 128Z"
         }
      }
   ]
}

var VerifiedBrand = {
   name: "VerifiedBrand",
   vendor: "UiFabric",
   unicode: 63421,
   value: "",
   charCode: "F7BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1969 869L1845 1024L1969 1179Q1987 1202 1997 1229.50Q2007 1257 2007 1286L2007 1286Q2007 1316 1997.50 1343Q1988 1370 1971.50 1392Q1955 1414 1931 1430Q1907 1446 1879 1454L1879 1454L1688 1507Q1690 1558 1693.50 1610Q1697 1662 1697 1714L1697 1714Q1697 1750 1683.50 1781Q1670 1812 1646.50 1835.50Q1623 1859 1591.50 1872.50Q1560 1886 1524 1886L1524 1886Q1493 1886 1463 1875L1463 1875L1278 1805L1169 1970Q1145 2006 1106.50 2027Q1068 2048 1024 2048L1024 2048Q980 2048 941.50 2027Q903 2006 879 1970L879 1970L770 1805L585 1875Q555 1886 524 1886L524 1886Q488 1886 456.50 1872.50Q425 1859 401.50 1835.50Q378 1812 364.50 1781Q351 1750 351 1714L351 1714Q351 1662 354.50 1610Q358 1558 360 1507L360 1507L169 1454Q140 1446 116.50 1430Q93 1414 76.50 1392Q60 1370 50.50 1343Q41 1316 41 1286L41 1286Q41 1257 51 1229.50Q61 1202 79 1179L79 1179L203 1024L79 869Q41 822 41 762L41 762Q41 732 50.50 705Q60 678 76.50 656Q93 634 116.50 618Q140 602 169 594L169 594L360 541Q358 490 354.50 438Q351 386 351 334L351 334Q351 298 364.50 267Q378 236 401.50 212.50Q425 189 456.50 175.50Q488 162 524 162L524 162Q555 162 585 173L585 173L770 243L879 78Q903 42 941.50 21Q980 0 1024 0L1024 0Q1068 0 1106.50 21Q1145 42 1169 78L1169 78L1278 243L1463 173Q1493 162 1524 162L1524 162Q1560 162 1591.50 175.50Q1623 189 1646.50 212.50Q1670 236 1683.50 267Q1697 298 1697 334L1697 334Q1697 386 1693.50 438Q1690 490 1688 541L1688 541L1879 594Q1907 602 1931 618Q1955 634 1971.50 656Q1988 678 1997.50 705Q2007 732 2007 762L2007 762Q2007 822 1969 869L1969 869ZM1879 1286L1879 1286Q1879 1272 1869 1259L1869 1259L1681 1024L1869 789Q1879 776 1879 762L1879 762Q1879 728 1845 718L1845 718L1654 665L1556 638Q1559 562 1564 486Q1569 410 1569 334L1569 334Q1569 317 1555 303.50Q1541 290 1524 290L1524 290Q1518 290 1497 296.50Q1476 303 1447.50 313.50Q1419 324 1386 337Q1353 350 1322 362Q1291 374 1265.50 384Q1240 394 1227 399L1227 399L1171 314L1062 148Q1049 128 1024 128L1024 128Q999 128 986 148L986 148L877 314L821 399Q808 394 782.50 384Q757 374 726 362Q695 350 662 337Q629 324 600.50 313.50Q572 303 551 296.50Q530 290 524 290L524 290Q507 290 493 303.50Q479 317 479 334L479 334Q479 410 484 486Q489 562 492 638L492 638L394 665L203 718Q169 728 169 762L169 762Q169 776 179 789L179 789L367 1024L179 1259Q169 1272 169 1286L169 1286Q169 1320 203 1330L203 1330L394 1383L492 1410Q489 1486 484 1562Q479 1638 479 1714L479 1714Q479 1731 493 1744.50Q507 1758 524 1758L524 1758Q530 1758 551 1751.50Q572 1745 600.50 1734.50Q629 1724 662 1711Q695 1698 726 1686Q757 1674 782.50 1664Q808 1654 821 1649L821 1649L877 1734L986 1900Q999 1920 1024 1920L1024 1920Q1049 1920 1062 1900L1062 1900L1171 1734L1227 1649Q1240 1654 1265.50 1664Q1291 1674 1322 1686Q1353 1698 1386 1711Q1419 1724 1447.50 1734.50Q1476 1745 1497 1751.50Q1518 1758 1524 1758L1524 1758Q1541 1758 1555 1744.50Q1569 1731 1569 1714L1569 1714Q1569 1638 1564 1562Q1559 1486 1556 1410L1556 1410L1654 1383L1845 1330Q1879 1320 1879 1286ZM685 979L896 1189L1363 723L1453 813L896 1371L595 1069L685 979Z"
         }
      }
   ]
}

var Coupon = {
   name: "Coupon",
   vendor: "UiFabric",
   unicode: 63420,
   value: "",
   charCode: "F7BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M624 832L624 832Q624 868 610 900Q596 932 572 956Q548 980 516 994Q484 1008 448 1008L448 1008Q412 1008 380 994Q348 980 324 956Q300 932 286 900Q272 868 272 832L272 832Q272 796 286 764Q300 732 324 708Q348 684 380 670Q412 656 448 656L448 656Q484 656 516 670Q548 684 572 708Q596 732 610 764Q624 796 624 832ZM448 912L448 912Q481 912 504.50 888.50Q528 865 528 832L528 832Q528 799 504.50 775.50Q481 752 448 752L448 752Q415 752 391.50 775.50Q368 799 368 832L368 832Q368 865 391.50 888.50Q415 912 448 912ZM960 1040L960 1040Q996 1040 1028 1054Q1060 1068 1084 1092Q1108 1116 1122 1148Q1136 1180 1136 1216L1136 1216Q1136 1252 1122 1284Q1108 1316 1084 1340Q1060 1364 1028 1378Q996 1392 960 1392L960 1392Q924 1392 892 1378Q860 1364 836 1340Q812 1316 798 1284Q784 1252 784 1216L784 1216Q784 1180 798 1148Q812 1116 836 1092Q860 1068 892 1054Q924 1040 960 1040ZM960 1296L960 1296Q993 1296 1016.50 1272.50Q1040 1249 1040 1216L1040 1216Q1040 1183 1016.50 1159.50Q993 1136 960 1136L960 1136Q927 1136 903.50 1159.50Q880 1183 880 1216L880 1216Q880 1249 903.50 1272.50Q927 1296 960 1296ZM458 1408L842 640L950 640L566 1408L458 1408ZM0 384L1408 384L2048 1024L1408 1664L0 1664L0 384ZM128 1536L1355 1536L1867 1024L1355 512L128 512L128 1536ZM1536 960L1536 960Q1562 960 1581 979Q1600 998 1600 1024L1600 1024Q1600 1050 1581 1069Q1562 1088 1536 1088L1536 1088Q1510 1088 1491 1069Q1472 1050 1472 1024L1472 1024Q1472 998 1491 979Q1510 960 1536 960Z"
         }
      }
   ]
}

var Photo2Fill = {
   name: "Photo2Fill",
   vendor: "UiFabric",
   unicode: 63391,
   value: "",
   charCode: "F79F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1296L576 975L1136 1536L256 1536L256 1296Z"
         }
      }
   ]
}

var ClearFormattingEraser = {
   name: "ClearFormattingEraser",
   vendor: "UiFabric",
   unicode: 63390,
   value: "",
   charCode: "F79E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M520 1619L704 1434L1126 1856L1061 1920L731 1920L520 1709Q501 1690 501 1664L501 1664Q501 1638 520 1619L520 1619ZM794 1344L1344 794L1766 1216L1216 1766L794 1344Z"
         }
      }
   ]
}

var ClearFormattingA = {
   name: "ClearFormattingA",
   vendor: "UiFabric",
   unicode: 63389,
   value: "",
   charCode: "F79D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L640 0L969 988L864 1093L799 896L353 896L268 1152L128 1152L512 0ZM576 228L396 768L756 768L576 228Z"
         }
      }
   ]
}

var FabricTextHighlight = {
   name: "FabricTextHighlight",
   vendor: "UiFabric",
   unicode: 63388,
   value: "",
   charCode: "F79C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M905 924L903 924L903 1010L768 1010L768 128L903 128L903 519L905 519Q940 461 990 430.50Q1040 400 1108 400L1108 400Q1172 400 1217.50 424.50Q1263 449 1292 490.50Q1321 532 1334.50 585Q1348 638 1348 695L1348 695Q1348 699 1347.50 702Q1347 705 1347 709L1347 709L1038 1019Q994 1011 961 986.50Q928 962 905 924L905 924ZM902 687L902 761Q902 793 912.50 821.50Q923 850 942 871Q961 892 988.50 904.50Q1016 917 1049 917L1049 917Q1095 917 1126 897Q1157 877 1176 845Q1195 813 1202.50 773.50Q1210 734 1210 695L1210 695Q1210 660 1202 626.50Q1194 593 1176 566.50Q1158 540 1130 524Q1102 508 1062 508L1062 508Q1023 508 993.50 522.50Q964 537 943.50 561.50Q923 586 912.50 618.50Q902 651 902 687L902 687ZM630 623L630 1010L499 1010L499 917L496 917Q435 1024 315 1024L315 1024Q274 1024 240 1012.50Q206 1001 181 979Q156 957 142 924.50Q128 892 128 850L128 850Q128 804 142 769.50Q156 735 181.50 711.50Q207 688 243 673.50Q279 659 322 653L322 653L499 628Q499 566 470 533.50Q441 501 378 501L378 501Q324 501 276 520Q228 539 186 574L186 574L186 456Q236 427 291.50 413.50Q347 400 404 400L404 400Q630 400 630 623L630 623ZM499 769L499 769L499 717L374 735Q349 738 327.50 743.50Q306 749 290.50 760Q275 771 266 789Q257 807 257 836L257 836Q257 879 287.50 900.50Q318 922 357 922L357 922Q390 922 416 910Q442 898 460.50 877Q479 856 489 828Q499 800 499 769ZM1901 636L1901 636Q1901 661 1891 684Q1881 707 1864 724L1864 724L1073 1514Q1051 1482 1033 1458.50Q1015 1435 996 1415.50Q977 1396 954 1378Q931 1360 898 1339L898 1339L1689 548Q1725 512 1777 512L1777 512Q1802 512 1825 522Q1848 532 1864.50 548.50Q1881 565 1891 588Q1901 611 1901 636ZM936 1635L936 1635Q936 1668 923.50 1696.50Q911 1725 889.50 1746Q868 1767 839 1779.50Q810 1792 778 1792L778 1792L568 1792Q547 1792 531 1776L531 1776Q573 1757 597 1718.50Q621 1680 621 1635L621 1635Q621 1603 633 1573L633 1573Q651 1530 691 1503.50Q731 1477 778 1477L778 1477Q811 1477 839.50 1489.50Q868 1502 889.50 1523.50Q911 1545 923.50 1573.50Q936 1602 936 1635Z"
         }
      }
   ]
}

var RemoveLinkX = {
   name: "RemoveLinkX",
   vendor: "UiFabric",
   unicode: 63387,
   value: "",
   charCode: "F79B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1955 1411L2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var RemoveLinkChain = {
   name: "RemoveLinkChain",
   vendor: "UiFabric",
   unicode: 63386,
   value: "",
   charCode: "F79A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1088 1536L1264 1536L1392 1664L1088 1664Q995 1664 913.50 1628.50Q832 1593 771.50 1532.50Q711 1472 675.50 1390.50Q640 1309 640 1216L640 1216Q640 1149 659.50 1086Q679 1023 714.50 969Q750 915 800.50 872.50Q851 830 913 803L913 803Q943 790 970.50 783Q998 776 1025 772.50Q1052 769 1080 768.50Q1108 768 1138 768L1138 768L1152 768L1152 896L1108 896Q1070 896 1037.50 900Q1005 904 964 922L964 922Q919 942 883 971.50Q847 1001 821.50 1039Q796 1077 782 1122Q768 1167 768 1216L768 1216Q768 1282 793 1340.50Q818 1399 861.50 1442.50Q905 1486 963.50 1511Q1022 1536 1088 1536L1088 1536ZM2048 1216L2048 1216Q2048 1262 2037 1312L2037 1312L1918 1193Q1915 1148 1899 1106Q1883 1064 1857.50 1028Q1832 992 1796.50 964Q1761 936 1719 919L1719 919Q1679 903 1645 899.50Q1611 896 1573 896L1573 896L1536 896L1536 768L1600 768Q1693 768 1774.50 803.50Q1856 839 1916.50 899.50Q1977 960 2012.50 1041.50Q2048 1123 2048 1216ZM1407 832L1407 832Q1407 900 1387.50 963Q1368 1026 1332.50 1079.50Q1297 1133 1246.50 1175.50Q1196 1218 1134 1245L1134 1245Q1105 1258 1077.50 1265Q1050 1272 1023 1275.50Q996 1279 968 1279.50Q940 1280 910 1280L910 1280L896 1280L896 1152L939 1152Q977 1152 1010.50 1148Q1044 1144 1084 1127L1084 1127Q1128 1108 1164 1077.50Q1200 1047 1226 1008.50Q1252 970 1266 925Q1280 880 1280 832L1280 832Q1280 766 1254.50 708Q1229 650 1185.50 606.50Q1142 563 1084 537.50Q1026 512 960 512L960 512L448 512Q382 512 323.50 537.50Q265 563 221.50 606.50Q178 650 153 708Q128 766 128 832L128 832Q128 881 142 926Q156 971 181.50 1009Q207 1047 243 1077.50Q279 1108 324 1127L324 1127Q363 1144 396.50 1148Q430 1152 468 1152L468 1152L512 1152L512 1280L448 1280Q355 1280 273.50 1244.50Q192 1209 131.50 1148.50Q71 1088 35.50 1006.50Q0 925 0 832L0 832Q0 739 35.50 657.50Q71 576 131.50 515.50Q192 455 273.50 419.50Q355 384 448 384L448 384L960 384Q1053 384 1134 419.50Q1215 455 1276 515.50Q1337 576 1372 657.50Q1407 739 1407 832Z"
         }
      }
   ]
}

var NumberedListTextMirrored = {
   name: "NumberedListTextMirrored",
   vendor: "UiFabric",
   unicode: 63384,
   value: "",
   charCode: "F798",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1536L0 1536L0 1408L1536 1408L1536 1536ZM1536 1024L0 1024L0 896L1536 896L1536 1024ZM0 512L0 384L1536 384L1536 512L0 512Z"
         }
      }
   ]
}

var NumberedListNumberMirrored = {
   name: "NumberedListNumberMirrored",
   vendor: "UiFabric",
   unicode: 63385,
   value: "",
   charCode: "F799",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1927 640L1927 349Q1913 360 1889 370.50Q1865 381 1847 381L1847 381L1847 312Q1877 302 1905.50 288.50Q1934 275 1960 255L1960 255L2009 255L2009 640L1927 640ZM1888 1083L1888 1083L2048 1083L2048 1152L1797 1152L1797 1140Q1797 1123 1798.50 1106Q1800 1089 1807 1072L1807 1072Q1819 1044 1845 1020Q1871 996 1897 974Q1923 952 1943 930Q1963 908 1963 884L1963 884Q1963 857 1948.50 846Q1934 835 1908 835L1908 835Q1882 835 1858.50 846Q1835 857 1815 874L1815 874L1815 801Q1865 769 1926 769L1926 769Q1977 769 2012.50 795Q2048 821 2048 876L2048 876Q2048 922 2023 952.50Q1998 983 1968 1005.50Q1938 1028 1913 1045.50Q1888 1063 1888 1083ZM2048 1556L2048 1556Q2048 1587 2035.50 1609Q2023 1631 2003 1644.50Q1983 1658 1956.50 1664.50Q1930 1671 1903 1671L1903 1671Q1877 1671 1854 1667Q1831 1663 1808 1652L1808 1652L1808 1579Q1828 1593 1849.50 1600Q1871 1607 1896 1607L1896 1607Q1922 1607 1942.50 1596Q1963 1585 1963 1555L1963 1555Q1963 1537 1953.50 1526.50Q1944 1516 1929.50 1511Q1915 1506 1898 1504.50Q1881 1503 1866 1503L1866 1503L1846 1503L1846 1439L1869 1439Q1883 1439 1897.50 1437.50Q1912 1436 1924 1431.50Q1936 1427 1944 1417.50Q1952 1408 1952 1391L1952 1391Q1952 1365 1935.50 1355Q1919 1345 1896 1345L1896 1345Q1857 1345 1822 1369L1822 1369L1822 1301Q1844 1290 1867.50 1285.50Q1891 1281 1915 1281L1915 1281Q1937 1281 1958.50 1286Q1980 1291 1997.50 1302.50Q2015 1314 2026 1332Q2037 1350 2037 1375L2037 1375Q2037 1413 2017.50 1435.50Q1998 1458 1962 1467L1962 1467L1962 1468Q1999 1473 2023.50 1495.50Q2048 1518 2048 1556Z"
         }
      }
   ]
}

var NumberedListNumber = {
   name: "NumberedListNumber",
   vendor: "UiFabric",
   unicode: 63383,
   value: "",
   charCode: "F797",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M135 640L135 349Q121 360 97 370.50Q73 381 55 381L55 381L55 312Q85 302 113.50 288.50Q142 275 168 255L168 255L217 255L217 640L135 640ZM96 1083L96 1083L256 1083L256 1152L5 1152L5 1140Q5 1123 6.50 1106Q8 1089 15 1072L15 1072Q27 1044 53 1020Q79 996 105 974Q131 952 151 930Q171 908 171 884L171 884Q171 857 156.50 846Q142 835 116 835L116 835Q90 835 66.50 846Q43 857 23 874L23 874L23 801Q73 769 134 769L134 769Q185 769 220.50 795Q256 821 256 876L256 876Q256 922 231 952.50Q206 983 176 1005.50Q146 1028 121 1045.50Q96 1063 96 1083ZM256 1556L256 1556Q256 1587 243.50 1609Q231 1631 211 1644.50Q191 1658 164.50 1664.50Q138 1671 111 1671L111 1671Q85 1671 62 1667Q39 1663 16 1652L16 1652L16 1579Q36 1593 57.50 1600Q79 1607 104 1607L104 1607Q130 1607 150.50 1596Q171 1585 171 1555L171 1555Q171 1537 161.50 1526.50Q152 1516 137.50 1511Q123 1506 106 1504.50Q89 1503 74 1503L74 1503L54 1503L54 1439L77 1439Q91 1439 105.50 1437.50Q120 1436 132 1431.50Q144 1427 152 1417.50Q160 1408 160 1391L160 1391Q160 1365 143.50 1355Q127 1345 104 1345L104 1345Q65 1345 30 1369L30 1369L30 1301Q52 1290 75.50 1285.50Q99 1281 123 1281L123 1281Q145 1281 166.50 1286Q188 1291 205.50 1302.50Q223 1314 234 1332Q245 1350 245 1375L245 1375Q245 1413 225.50 1435.50Q206 1458 170 1467L170 1467L170 1468Q207 1473 231.50 1495.50Q256 1518 256 1556Z"
         }
      }
   ]
}

var NumberedListText = {
   name: "NumberedListText",
   vendor: "UiFabric",
   unicode: 63382,
   value: "",
   charCode: "F796",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1536L512 1536L512 1408L2048 1408L2048 1536ZM512 512L512 384L2048 384L2048 512L512 512ZM2048 1024L512 1024L512 896L2048 896L2048 1024Z"
         }
      }
   ]
}

var BulletedListBulletMirrored = {
   name: "BulletedListBulletMirrored",
   vendor: "UiFabric",
   unicode: 63381,
   value: "",
   charCode: "F795",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1280L1920 1280L1920 1152L2048 1152L2048 1280ZM2048 1664L1920 1664L1920 1536L2048 1536L2048 1664ZM2048 896L1920 896L1920 768L2048 768L2048 896ZM1920 512L1920 384L2048 384L2048 512L1920 512Z"
         }
      }
   ]
}

var BulletedListTextMirrored = {
   name: "BulletedListTextMirrored",
   vendor: "UiFabric",
   unicode: 63380,
   value: "",
   charCode: "F794",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1664L0 1664L0 1536L1664 1536L1664 1664ZM1664 1280L0 1280L0 1152L1664 1152L1664 1280ZM1664 896L0 896L0 768L1664 768L1664 896ZM0 512L0 384L1664 384L1664 512L0 512Z"
         }
      }
   ]
}

var BulletedListBullet = {
   name: "BulletedListBullet",
   vendor: "UiFabric",
   unicode: 63379,
   value: "",
   charCode: "F793",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1664L0 1664L0 1536L128 1536L128 1664ZM128 1280L0 1280L0 1152L128 1152L128 1280ZM0 512L0 384L128 384L128 512L0 512ZM128 896L0 896L0 768L128 768L128 896Z"
         }
      }
   ]
}

var IncreaseIndentText = {
   name: "IncreaseIndentText",
   vendor: "UiFabric",
   unicode: 63392,
   value: "",
   charCode: "F7A0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1792 640L1792 768L1024 768L1024 640ZM1024 512L1024 384L2048 384L2048 512L1024 512ZM1024 1152L1792 1152L1792 1280L1024 1280L1024 1152ZM2048 1536L1024 1536L1024 1408L2048 1408L2048 1536ZM2048 1024L1024 1024L1024 896L2048 896L2048 1024Z"
         }
      }
   ]
}

var IncreaseIndentArrow = {
   name: "IncreaseIndentArrow",
   vendor: "UiFabric",
   unicode: 63393,
   value: "",
   charCode: "F7A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M483 733L573 643L890 960L573 1277L483 1187L646 1024L0 1024L0 896L646 896L483 733Z"
         }
      }
   ]
}

var DecreaseIndentText = {
   name: "DecreaseIndentText",
   vendor: "UiFabric",
   unicode: 63394,
   value: "",
   charCode: "F7A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1792 640L1792 768L1024 768L1024 640ZM1024 1152L1792 1152L1792 1280L1024 1280L1024 1152ZM1024 512L1024 384L2048 384L2048 512L1024 512ZM2048 1024L1024 1024L1024 896L2048 896L2048 1024ZM2048 1536L1024 1536L1024 1408L2048 1408L2048 1536Z"
         }
      }
   ]
}

var DecreaseIndentArrow = {
   name: "DecreaseIndentArrow",
   vendor: "UiFabric",
   unicode: 63395,
   value: "",
   charCode: "F7A3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M250 896L896 896L896 1024L250 1024L413 1187L323 1277L6 960L323 643L413 733L250 896Z"
         }
      }
   ]
}

var IncreaseIndentTextMirrored = {
   name: "IncreaseIndentTextMirrored",
   vendor: "UiFabric",
   unicode: 63396,
   value: "",
   charCode: "F7A4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L0 1024L0 896L1024 896L1024 1024ZM1024 1536L0 1536L0 1408L1024 1408L1024 1536ZM1024 1280L256 1280L256 1152L1024 1152L1024 1280ZM1024 768L256 768L256 640L1024 640L1024 768ZM0 512L0 384L1024 384L1024 512L0 512Z"
         }
      }
   ]
}

var IncreaseIndentArrowMirrored = {
   name: "IncreaseIndentArrowMirrored",
   vendor: "UiFabric",
   unicode: 63397,
   value: "",
   charCode: "F7A5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1402 896L2048 896L2048 1024L1402 1024L1565 1187L1475 1277L1158 960L1475 643L1565 733L1402 896Z"
         }
      }
   ]
}

var DecreaseIndentTextMirrored = {
   name: "DecreaseIndentTextMirrored",
   vendor: "UiFabric",
   unicode: 63398,
   value: "",
   charCode: "F7A6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1280L256 1280L256 1152L1024 1152L1024 1280ZM1024 1536L0 1536L0 1408L1024 1408L1024 1536ZM0 512L0 384L1024 384L1024 512L0 512ZM1024 1024L0 1024L0 896L1024 896L1024 1024ZM1024 768L256 768L256 640L1024 640L1024 768Z"
         }
      }
   ]
}

var DecreaseIndentArrowMirrored = {
   name: "DecreaseIndentArrowMirrored",
   vendor: "UiFabric",
   unicode: 63399,
   value: "",
   charCode: "F7A7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1641 733L1731 643L2048 960L1731 1277L1641 1187L1804 1024L1158 1024L1158 896L1804 896L1641 733Z"
         }
      }
   ]
}

var CheckListText = {
   name: "CheckListText",
   vendor: "UiFabric",
   unicode: 63400,
   value: "",
   charCode: "F7A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1664L640 1664L640 1536L2048 1536L2048 1664ZM2048 1280L640 1280L640 1152L2048 1152L2048 1280ZM640 512L640 384L2048 384L2048 512L640 512ZM2048 896L640 896L640 768L2048 768L2048 896Z"
         }
      }
   ]
}

var CheckListCheck = {
   name: "CheckListCheck",
   vendor: "UiFabric",
   unicode: 63401,
   value: "",
   charCode: "F7A9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M403 259L493 349L192 650L19 477L109 387L192 469L403 259ZM109 1539L192 1621L403 1411L493 1501L192 1802L19 1629L109 1539ZM109 771L192 853L403 643L493 733L192 1034L19 861L109 771ZM109 1155L192 1237L403 1027L493 1117L192 1418L19 1245L109 1155Z"
         }
      }
   ]
}

var CheckListTextMirrored = {
   name: "CheckListTextMirrored",
   vendor: "UiFabric",
   unicode: 63402,
   value: "",
   charCode: "F7AA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 512L0 384L1408 384L1408 512L0 512ZM1408 1280L0 1280L0 1152L1408 1152L1408 1280ZM1408 1664L0 1664L0 1536L1408 1536L1408 1664ZM1408 896L0 896L0 768L1408 768L1408 896Z"
         }
      }
   ]
}

var CheckListCheckMirrored = {
   name: "CheckListCheckMirrored",
   vendor: "UiFabric",
   unicode: 63403,
   value: "",
   charCode: "F7AB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1645 1539L1728 1621L1939 1411L2029 1501L1728 1802L1555 1629L1645 1539ZM1939 259L2029 349L1728 650L1555 477L1645 387L1728 469L1939 259ZM1645 771L1728 853L1939 643L2029 733L1728 1034L1555 861L1645 771ZM1645 1155L1728 1237L1939 1027L2029 1117L1728 1418L1555 1245L1645 1155Z"
         }
      }
   ]
}

var NumberSymbol = {
   name: "NumberSymbol",
   vendor: "UiFabric",
   unicode: 63404,
   value: "",
   charCode: "F7AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1713 640L1685 768L1359 768L1279 1152L1630 1152L1598 1280L1265 1280L1152 1792L989 1792L1100 1280L778 1280L669 1792L508 1792L616 1280L298 1280L322 1152L652 1152L731 768L384 768L409 640L749 640L856 128L1017 128L910 640L1230 640L1340 128L1497 128L1390 640L1713 640ZM801 1152L1126 1152L1208 768L886 768L801 1152Z"
         }
      }
   ]
}

var RemoveFromShoppingList = {
   name: "RemoveFromShoppingList",
   vendor: "UiFabric",
   unicode: 63445,
   value: "",
   charCode: "F7D5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 768L640 768L640 896L512 896L512 768ZM768 768L1536 768L1536 896L768 896L768 768ZM640 1280L512 1280L512 1152L640 1152L640 1280ZM1536 1280L768 1280L768 1152L1536 1152L1536 1280ZM512 384L640 384L640 512L512 512L512 384ZM768 384L1536 384L1536 512L768 512L768 384ZM1664 128L384 128L384 1664L1280 1664L1280 1792L256 1792L256 0L1792 0L1792 1280L1664 1280L1664 128ZM1939 1427L2029 1517L1818 1728L2029 1939L1939 2029L1728 1818L1517 2029L1427 1939L1638 1728L1427 1517L1517 1427L1728 1638L1939 1427Z"
         }
      }
   ]
}

var ShieldAlert = {
   name: "ShieldAlert",
   vendor: "UiFabric",
   unicode: 63447,
   value: "",
   charCode: "F7D7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1408L1024 1536L896 1536L896 1408L1024 1408ZM896 384L1024 384L1024 1280L896 1280L896 384ZM991 2027L960 2045L929 2027Q812 1960 698 1881Q584 1802 481 1710.50Q378 1619 290 1515Q202 1411 137.50 1293.50Q73 1176 36.50 1045Q0 914 0 768L0 768L0 256Q83 256 161 250Q239 244 313 228Q387 212 459 183Q531 154 603 108L603 108Q688 53 773 26.50Q858 0 960 0L960 0Q1011 0 1057 6.50Q1103 13 1146.50 26.50Q1190 40 1232 60.50Q1274 81 1317 108L1317 108Q1389 154 1461 183Q1533 212 1607 228Q1681 244 1759 250Q1837 256 1920 256L1920 256L1920 768Q1920 914 1883.50 1045Q1847 1176 1782.50 1293.50Q1718 1411 1630 1515Q1542 1619 1439 1710.50Q1336 1802 1221.50 1881Q1107 1960 991 2027L991 2027ZM128 382L128 382L128 768Q128 895 161.50 1012Q195 1129 253 1235Q311 1341 391 1435.50Q471 1530 563 1613Q655 1696 756.50 1767Q858 1838 960 1897L960 1897Q1062 1838 1163.50 1767Q1265 1696 1357 1613Q1449 1530 1529 1435.50Q1609 1341 1667 1235Q1725 1129 1758.50 1012Q1792 895 1792 768L1792 768L1792 382Q1643 374 1506.50 334Q1370 294 1244 213L1244 213Q1176 169 1108.50 148.50Q1041 128 960 128L960 128Q879 128 811.50 148.50Q744 169 676 213L676 213Q550 294 413.50 334Q277 374 128 382Z"
         }
      }
   ]
}

var StreamDiscover = {
   name: "StreamDiscover",
   vendor: "UiFabric",
   unicode: 63449,
   value: "",
   charCode: "F7D9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 896L768 896Q847 896 917 926Q987 956 1039 1008.50Q1091 1061 1121 1131Q1151 1201 1151 1280L1151 1280Q1151 1360 1121 1429.50Q1091 1499 1039 1551.50Q987 1604 917 1634Q847 1664 768 1664L768 1664Q708 1664 651 1646Q594 1628 546 1593L546 1593L109 2029Q90 2048 64 2048L64 2048Q38 2048 19 2029Q0 2010 0 1984L0 1984Q0 1958 19 1939L19 1939L455 1502Q420 1454 402 1397Q384 1340 384 1280L384 1280Q384 1201 414 1131Q444 1061 496.50 1008.50Q549 956 618.50 926Q688 896 768 896ZM768 1536L768 1536Q821 1536 867.50 1516Q914 1496 949 1461Q984 1426 1004 1379.50Q1024 1333 1024 1280L1024 1280Q1024 1227 1004 1180.50Q984 1134 949 1099Q914 1064 867.50 1044Q821 1024 768 1024L768 1024Q715 1024 668.50 1044Q622 1064 587 1099Q552 1134 532 1180.50Q512 1227 512 1280L512 1280Q512 1333 532 1379.50Q552 1426 587 1461Q622 1496 668.50 1516Q715 1536 768 1536ZM0 1664L0 384L2048 384L2048 1664L1152 1664Q1180 1636 1202.50 1603.50Q1225 1571 1244 1536L1244 1536L1920 1536L1920 512L128 512L128 1664L0 1664Z"
         }
      }
   ]
}

var FabricTextHighlightComposite = {
   name: "FabricTextHighlightComposite",
   vendor: "UiFabric",
   unicode: 63450,
   value: "",
   charCode: "F7DA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M905 796L903 796L903 882L768 882L768 0L903 0L903 391L905 391Q940 333 990 302.50Q1040 272 1108 272L1108 272Q1172 272 1217.50 296.50Q1263 321 1292 362.50Q1321 404 1334.50 457Q1348 510 1348 567L1348 567Q1348 571 1347.50 574Q1347 577 1347 581L1347 581L1038 891Q994 883 961 858.50Q928 834 905 796L905 796ZM902 559L902 559L902 633Q902 665 912.50 693.50Q923 722 942 743Q961 764 988.50 776.50Q1016 789 1049 789L1049 789Q1095 789 1126 769Q1157 749 1176 717Q1195 685 1202.50 645.50Q1210 606 1210 567L1210 567Q1210 532 1202 498.50Q1194 465 1176 438.50Q1158 412 1130 396Q1102 380 1062 380L1062 380Q1023 380 993.50 394.50Q964 409 943.50 433.50Q923 458 912.50 490.50Q902 523 902 559ZM778 1349L778 1349Q811 1349 839.50 1361.50Q868 1374 889.50 1395.50Q911 1417 923.50 1445.50Q936 1474 936 1507L936 1507Q936 1540 923.50 1568.50Q911 1597 889.50 1618Q868 1639 839 1651.50Q810 1664 778 1664L778 1664L568 1664Q547 1664 531 1648L531 1648Q573 1629 597 1590.50Q621 1552 621 1507L621 1507Q621 1475 633 1445L633 1445Q651 1402 691 1375.50Q731 1349 778 1349ZM1901 508L1901 508Q1901 533 1891 556Q1881 579 1864 596L1864 596L1073 1386Q1051 1354 1033 1330.50Q1015 1307 996 1287.50Q977 1268 954 1250Q931 1232 898 1211L898 1211L1689 420Q1725 384 1777 384L1777 384Q1802 384 1825 394Q1848 404 1864.50 420.50Q1881 437 1891 460Q1901 483 1901 508ZM499 789L496 789Q435 896 315 896L315 896Q274 896 240 884.50Q206 873 181 851Q156 829 142 796.50Q128 764 128 722L128 722Q128 676 142 641.50Q156 607 181.50 583.50Q207 560 243 545.50Q279 531 322 525L322 525L499 500Q499 438 470 405.50Q441 373 378 373L378 373Q324 373 276 392Q228 411 186 446L186 446L186 328Q236 299 291.50 285.50Q347 272 404 272L404 272Q630 272 630 495L630 495L630 882L499 882L499 789ZM257 708L257 708Q257 751 287.50 772.50Q318 794 357 794L357 794Q390 794 416 782Q442 770 460.50 749Q479 728 489 700Q499 672 499 641L499 641L499 589L374 607Q349 610 327.50 615.50Q306 621 290.50 632Q275 643 266 661Q257 679 257 708ZM1664 2048L256 2048L256 1792L1664 1792L1664 2048Z"
         }
      }
   ]
}

var ContactList = {
   name: "ContactList",
   vendor: "UiFabric",
   unicode: 63461,
   value: "",
   charCode: "F7E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M740 1461L740 1461Q805 1494 857.50 1542.50Q910 1591 947 1650.50Q984 1710 1004 1778.50Q1024 1847 1024 1920L1024 1920L896 1920Q896 1841 866 1771Q836 1701 783.50 1648.50Q731 1596 661 1566Q591 1536 512 1536L512 1536Q432 1536 362.50 1566Q293 1596 240.50 1648.50Q188 1701 158 1771Q128 1841 128 1920L128 1920L0 1920Q0 1847 20 1778.50Q40 1710 77 1650.50Q114 1591 166.50 1542.50Q219 1494 284 1461L284 1461Q210 1406 169 1325Q128 1244 128 1152L128 1152Q128 1073 158 1003Q188 933 240.50 880.50Q293 828 362.50 798Q432 768 512 768L512 768Q604 768 685 809Q766 850 821 924L821 924Q859 849 918 790Q977 731 1052 693L1052 693Q978 638 937 557Q896 476 896 384L896 384Q896 305 926 235Q956 165 1008.50 112.50Q1061 60 1130.50 30Q1200 0 1280 0L1280 0Q1359 0 1429 30Q1499 60 1551.50 112.50Q1604 165 1634 235Q1664 305 1664 384L1664 384Q1664 476 1623 557Q1582 638 1508 693L1508 693Q1573 726 1625.50 774.50Q1678 823 1715 882.50Q1752 942 1772 1010.50Q1792 1079 1792 1152L1792 1152L1664 1152Q1664 1073 1634 1003Q1604 933 1551.50 880.50Q1499 828 1429 798Q1359 768 1280 768L1280 768Q1200 768 1130.50 798Q1061 828 1008.50 880.50Q956 933 926 1003Q896 1073 896 1152L896 1152Q896 1244 855 1325Q814 1406 740 1461ZM1024 384L1024 384Q1024 437 1044 483.50Q1064 530 1099 565Q1134 600 1180.50 620Q1227 640 1280 640L1280 640Q1333 640 1379.50 620Q1426 600 1461 565Q1496 530 1516 483.50Q1536 437 1536 384L1536 384Q1536 331 1516 284.50Q1496 238 1461 203Q1426 168 1379.50 148Q1333 128 1280 128L1280 128Q1227 128 1180.50 148Q1134 168 1099 203Q1064 238 1044 284.50Q1024 331 1024 384ZM256 1152L256 1152Q256 1205 276 1251.50Q296 1298 331 1333Q366 1368 412.50 1388Q459 1408 512 1408L512 1408Q565 1408 611.50 1388Q658 1368 693 1333Q728 1298 748 1251.50Q768 1205 768 1152L768 1152Q768 1099 748 1052.50Q728 1006 693 971Q658 936 611.50 916Q565 896 512 896L512 896Q459 896 412.50 916Q366 936 331 971Q296 1006 276 1052.50Q256 1099 256 1152ZM1280 1536L1280 1408L2048 1408L2048 1536L1280 1536ZM2048 1792L1280 1792L1280 1664L2048 1664L2048 1792ZM2048 2048L1280 2048L1280 1920L2048 1920L2048 2048Z"
         }
      }
   ]
}

var SnapToGrid = {
   name: "SnapToGrid",
   vendor: "UiFabric",
   unicode: 63460,
   value: "",
   charCode: "F7E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L384 0L384 128L256 128L256 0ZM0 256L128 256L128 384L0 384L0 256ZM0 0L128 0L128 128L0 128L0 0ZM0 512L128 512L128 640L0 640L0 512ZM1024 768L896 768L896 640L1024 640L1024 768ZM768 0L896 0L896 128L768 128L768 0ZM896 384L1024 384L1024 512L896 512L896 384ZM1280 0L1408 0L1408 128L1280 128L1280 0ZM1536 0L1664 0L1664 128L1536 128L1536 0ZM128 1920L0 1920L0 1792L128 1792L128 1920ZM1024 128L1024 256L896 256L896 128L1024 128ZM1024 0L1152 0L1152 128L1024 128L1024 0ZM512 0L640 0L640 128L512 128L512 0ZM1920 640L1792 640L1792 512L1920 512L1920 640ZM640 1920L512 1920L512 1792L640 1792L640 1920ZM640 896L768 896L768 1024L640 1024L640 896ZM896 896L1792 896L1792 768L1920 768L1920 1920L768 1920L768 1792L896 1792L896 896ZM1024 1792L1792 1792L1792 1024L1024 1024L1024 1792ZM1792 128L1792 0L1920 0L1920 128L1792 128ZM1920 384L1792 384L1792 256L1920 256L1920 384ZM128 1664L0 1664L0 1536L128 1536L128 1664ZM384 896L512 896L512 1024L384 1024L384 896ZM128 1152L0 1152L0 1024L128 1024L128 1152ZM128 1408L0 1408L0 1280L128 1280L128 1408ZM0 896L0 768L128 768L128 896L0 896ZM128 896L256 896L256 1024L128 1024L128 896ZM384 1920L256 1920L256 1792L384 1792L384 1920Z"
         }
      }
   ]
}

var GenericScanFilled = {
   name: "GenericScanFilled",
   vendor: "UiFabric",
   unicode: 63459,
   value: "",
   charCode: "F7E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 256L1536 128L2048 128L2048 640L1920 640L1920 256L1536 256ZM512 256L128 256L128 640L0 640L0 128L512 128L512 256ZM1536 1792L1920 1792L1920 1408L2048 1408L2048 1920L1536 1920L1536 1792ZM1792 1664L256 1664L256 384L1792 384L1792 1664ZM1664 640L1536 640L1536 1408L1664 1408L1664 640ZM1280 640L1152 640L1152 1408L1280 1408L1280 640ZM896 640L768 640L768 1408L896 1408L896 640ZM512 640L384 640L384 1408L512 1408L512 640ZM0 1408L128 1408L128 1792L512 1792L512 1920L0 1920L0 1408Z"
         }
      }
   ]
}

var ScreenCast = {
   name: "ScreenCast",
   vendor: "UiFabric",
   unicode: 63458,
   value: "",
   charCode: "F7E2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1792L1408 1792Q1408 1765 1398 1742Q1388 1719 1370.50 1701.50Q1353 1684 1330 1674Q1307 1664 1280 1664L1280 1664L1280 1536Q1333 1536 1379.50 1556Q1426 1576 1461 1611Q1496 1646 1516 1692.50Q1536 1739 1536 1792L1536 1792ZM1792 384L128 384L128 1280L1152 1280L1152 1408L1024 1408L1024 1536L1152 1536L1152 1664L640 1664L640 1536L896 1536L896 1408L0 1408L0 256L1920 256L1920 1122Q1861 1066 1792 1020L1792 1020L1792 384ZM1792 1792L1664 1792Q1664 1713 1634 1643Q1604 1573 1551.50 1520.50Q1499 1468 1429 1438Q1359 1408 1280 1408L1280 1408L1280 1280Q1386 1280 1479.50 1320Q1573 1360 1642.50 1429.50Q1712 1499 1752 1592.50Q1792 1686 1792 1792L1792 1792ZM2048 1792L1920 1792Q1920 1660 1869.50 1543.50Q1819 1427 1732 1340Q1645 1253 1528.50 1202.50Q1412 1152 1280 1152L1280 1152L1280 1024Q1386 1024 1484 1051.50Q1582 1079 1667.50 1129Q1753 1179 1823 1249Q1893 1319 1943 1404.50Q1993 1490 2020.50 1588Q2048 1686 2048 1792L2048 1792Z"
         }
      }
   ]
}

var Orientation2 = {
   name: "Orientation2",
   vendor: "UiFabric",
   unicode: 63457,
   value: "",
   charCode: "F7E1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 768L1536 768L1536 896L1408 896L1408 768ZM1408 0L1536 0L1536 128L1408 128L1408 0ZM1664 0L1792 0L1792 128L1664 128L1664 0ZM1664 768L1792 768L1792 896L1664 896L1664 768ZM2048 384L1920 384L1920 256L2048 256L2048 384ZM2048 640L1920 640L1920 512L2048 512L2048 640ZM384 0L1280 0L1280 1408L384 1408L384 0ZM512 1280L1152 1280L1152 128L512 128L512 1280ZM1920 128L1920 0L2048 0L2048 128L1920 128ZM2048 896L1920 896L1920 768L2048 768L2048 896ZM1829 1536L1536 1536L1536 1408L2048 1408L2048 1920L1920 1920L1920 1627Q1817 1730 1720.50 1808.50Q1624 1887 1519.50 1940.50Q1415 1994 1295 2021Q1175 2048 1024 2048L1024 2048Q882 2048 751 2011.50Q620 1975 506.50 1908.50Q393 1842 299.50 1748.50Q206 1655 139.50 1541.50Q73 1428 36.50 1297Q0 1166 0 1024L0 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920Q1156 1920 1265 1894.50Q1374 1869 1469.50 1820Q1565 1771 1652 1699.50Q1739 1628 1829 1536L1829 1536Z"
         }
      }
   ]
}

var SaveToMobile = {
   name: "SaveToMobile",
   vendor: "UiFabric",
   unicode: 63456,
   value: "",
   charCode: "F7E0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1664L1792 1664L1792 1792L1536 1792L1536 1664ZM1408 128L384 128L384 768L1152 768L1152 896L256 896L256 128L128 128L128 1509L282 1664L384 1664L384 1152L1152 1152L1152 1280L512 1280L512 1664L640 1664L640 1408L768 1408L768 1664L1152 1664L1152 1792L229 1792L0 1562L0 128Q0 101 10 78Q20 55 37.50 37.50Q55 20 78 10Q101 0 128 0L128 0L1664 0Q1691 0 1714 10Q1737 20 1754.50 37.50Q1772 55 1782 78Q1792 101 1792 128L1792 128L1792 640L1664 640L1664 128L1536 128L1536 640L1408 640L1408 128ZM2048 896L2048 896L2048 1920Q2048 1947 2038 1970Q2028 1993 2010.50 2010.50Q1993 2028 1970 2038Q1947 2048 1920 2048L1920 2048L1408 2048Q1381 2048 1358 2038Q1335 2028 1317.50 2010.50Q1300 1993 1290 1970Q1280 1947 1280 1920L1280 1920L1280 896Q1280 869 1290 846Q1300 823 1317.50 805.50Q1335 788 1358 778Q1381 768 1408 768L1408 768L1920 768Q1947 768 1970 778Q1993 788 2010.50 805.50Q2028 823 2038 846Q2048 869 2048 896ZM1408 1920L1920 1920L1920 896L1408 896L1408 1920Z"
         }
      }
   ]
}

var DiagnosticDataBarTooltip = {
   name: "DiagnosticDataBarTooltip",
   vendor: "UiFabric",
   unicode: 63455,
   value: "",
   charCode: "F7DF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 0L128 0L1920 0L1920 1792L1280 1792L1024 2048L768 1792L128 1792L128 0ZM1792 1664L1792 1664L1792 128L256 128L256 1664L820 1664L1024 1868L1228 1664L1792 1664ZM768 640L768 640L768 1536L512 1536L512 640L768 640ZM1152 1024L1152 1024L1152 1536L896 1536L896 1024L1152 1024ZM1536 384L1536 384L1536 1536L1280 1536L1280 384L1536 384Z"
         }
      }
   ]
}

var ShowGrid = {
   name: "ShowGrid",
   vendor: "UiFabric",
   unicode: 63454,
   value: "",
   charCode: "F7DE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1024L1664 1024L1664 896L1792 896L1792 1024ZM1536 0L1664 0L1664 128L1536 128L1536 0ZM1920 1024L1920 1152L1792 1152L1792 1024L1920 1024ZM1280 0L1408 0L1408 128L1280 128L1280 0ZM1280 1024L1152 1024L1152 896L1280 896L1280 1024ZM768 0L896 0L896 128L768 128L768 0ZM1536 1024L1408 1024L1408 896L1536 896L1536 1024ZM1792 768L1920 768L1920 896L1792 896L1792 768ZM896 896L1024 896L1024 1024L896 1024L896 896ZM896 640L1024 640L1024 768L896 768L896 640ZM896 384L1024 384L1024 512L896 512L896 384ZM1024 0L1152 0L1152 128L1024 128L1024 0ZM1792 512L1920 512L1920 640L1792 640L1792 512ZM896 1255L896 1255L896 1152L1024 1152L1024 1178Q957 1211 896 1255ZM1792 256L1920 256L1920 384L1792 384L1792 256ZM1792 0L1920 0L1920 128L1792 128L1792 0ZM128 1408L0 1408L0 1280L128 1280L128 1408ZM128 1664L0 1664L0 1536L128 1536L128 1664ZM128 1152L0 1152L0 1024L128 1024L128 1152ZM128 896L256 896L256 1024L128 1024L128 896ZM0 896L0 768L128 768L128 896L0 896ZM384 1920L256 1920L256 1792L384 1792L384 1920ZM640 1920L512 1920L512 1792L640 1792L640 1920ZM384 896L512 896L512 1024L384 1024L384 896ZM512 0L640 0L640 128L512 128L512 0ZM256 0L384 0L384 128L256 128L256 0ZM1024 128L1024 256L896 256L896 128L1024 128ZM640 896L768 896L768 1024L640 1024L640 896ZM0 0L128 0L128 128L0 128L0 0ZM128 1920L0 1920L0 1792L128 1792L128 1920ZM0 512L128 512L128 640L0 640L0 512ZM0 256L128 256L128 384L0 384L0 256ZM2048 1792L2048 1792L1920 1792Q1920 1726 1898.50 1669.50Q1877 1613 1839.50 1567Q1802 1521 1752.50 1485Q1703 1449 1646 1425Q1589 1401 1528 1388.50Q1467 1376 1408 1376L1408 1376Q1349 1376 1288 1388.50Q1227 1401 1170 1425Q1113 1449 1063.50 1484.50Q1014 1520 976.50 1566.50Q939 1613 917.50 1669.50Q896 1726 896 1792L896 1792L768 1792Q768 1708 794 1635Q820 1562 865.50 1501.50Q911 1441 972.50 1394Q1034 1347 1105 1314.50Q1176 1282 1253.50 1265Q1331 1248 1408 1248L1408 1248Q1485 1248 1562.50 1265Q1640 1282 1711 1314.50Q1782 1347 1843.50 1394Q1905 1441 1950.50 1501.50Q1996 1562 2022 1635Q2048 1708 2048 1792ZM1408 1536L1408 1536Q1461 1536 1508 1556Q1555 1576 1589.50 1610.50Q1624 1645 1644 1692Q1664 1739 1664 1792L1664 1792Q1664 1845 1644 1892Q1624 1939 1589.50 1973.50Q1555 2008 1508 2028Q1461 2048 1408 2048L1408 2048Q1355 2048 1308 2028Q1261 2008 1226.50 1973.50Q1192 1939 1172 1892Q1152 1845 1152 1792L1152 1792Q1152 1739 1172 1692Q1192 1645 1226.50 1610.50Q1261 1576 1308 1556Q1355 1536 1408 1536ZM1408 1920L1408 1920Q1434 1920 1457.50 1910Q1481 1900 1498.50 1882.50Q1516 1865 1526 1841.50Q1536 1818 1536 1792L1536 1792Q1536 1766 1526 1742.50Q1516 1719 1498.50 1701.50Q1481 1684 1457.50 1674Q1434 1664 1408 1664L1408 1664Q1382 1664 1358.50 1674Q1335 1684 1317.50 1701.50Q1300 1719 1290 1742.50Q1280 1766 1280 1792L1280 1792Q1280 1818 1290 1841.50Q1300 1865 1317.50 1882.50Q1335 1900 1358.50 1910Q1382 1920 1408 1920Z"
         }
      }
   ]
}

var Dataflows = {
   name: "Dataflows",
   vendor: "UiFabric",
   unicode: 63453,
   value: "",
   charCode: "F7DD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 640L1280 0L1920 0L1920 640L1664 640L1664 1152L512 1152L512 1408L768 1408L768 2048L128 2048L128 1408L384 1408L384 640L128 640L128 0L768 0L768 640L512 640L512 1024L1536 1024L1536 640L1280 640ZM256 128L256 512L640 512L640 128L256 128ZM256 1920L640 1920L640 1536L256 1536L256 1920ZM1408 512L1792 512L1792 128L1408 128L1408 512Z"
         }
      }
   ]
}

var LearningTools = {
   name: "LearningTools",
   vendor: "UiFabric",
   unicode: 63451,
   value: "",
   charCode: "F7DB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 256L384 1536L512 1536L512 1664L256 1664L256 384L128 384L128 1792L512 1792L512 1920L0 1920L0 256L256 256L256 128L640 128Q728 128 809.50 155Q891 182 960 236L960 236Q1029 182 1110.50 155Q1192 128 1280 128L1280 128L1664 128L1664 256L1920 256L1920 1075L1792 1017L1792 384L1664 384L1664 959L1536 900L1536 256L1280 256Q1209 256 1143.50 280.50Q1078 305 1024 351L1024 351L1024 959L896 1017L896 351Q842 305 776.50 280.50Q711 256 640 256L640 256L384 256ZM1792 1791L1792 1791L1344 2016L896 1791Q896 1755 897.50 1714.50Q899 1674 905.50 1634Q912 1594 925 1556.50Q938 1519 961 1490L961 1490L768 1402L768 1984L640 1984L640 1344L1344 1024L2048 1344L1727 1490L1735 1501Q1756 1532 1767.50 1568Q1779 1604 1784.50 1641.50Q1790 1679 1791 1717Q1792 1755 1792 1791ZM1739 1344L1344 1164L949 1344L1344 1524L1739 1344ZM1025 1713L1344 1873L1664 1712Q1663 1686 1659.50 1664.50Q1656 1643 1649 1623.50Q1642 1604 1632.50 1584.50Q1623 1565 1610 1543L1610 1543L1344 1664L1078 1543Q1063 1567 1053.50 1586Q1044 1605 1038 1624Q1032 1643 1029 1664.50Q1026 1686 1025 1713L1025 1713Z"
         }
      }
   ]
}

var NewMail = {
   name: "NewMail",
   vendor: "UiFabric",
   unicode: 63466,
   value: "",
   charCode: "F7EA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1280L1792 1280L1792 1536L2048 1536L2048 1664L1792 1664L1792 1920L1664 1920L1664 1664L1408 1664L1408 1536L1664 1536L1664 1280ZM0 1664L0 384L2048 384L2048 1280L1920 1280L1920 648L1024 1095L128 648L128 1536L1152 1536L1152 1664L0 1664ZM1905 512L143 512L1024 953L1905 512Z"
         }
      }
   ]
}

var EyeShadow = {
   name: "EyeShadow",
   vendor: "UiFabric",
   unicode: 63467,
   value: "",
   charCode: "F7EB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1305 896L1305 896L2048 896L2048 1920L0 1920L0 896L771 896Q846 805 925 720Q1004 635 1087 552L1087 552Q1118 521 1173 468Q1228 415 1295.50 353.50Q1363 292 1438.50 229.50Q1514 167 1586 116Q1658 65 1721 32.50Q1784 0 1828 0L1828 0Q1869 0 1894.50 25.50Q1920 51 1920 92L1920 92Q1920 127 1899 174.50Q1878 222 1842.50 277.50Q1807 333 1760.50 393.50Q1714 454 1662.50 515Q1611 576 1558.50 634Q1506 692 1458 742.50Q1410 793 1370 832.50Q1330 872 1305 896ZM893 950L893 950Q918 961 938.50 981.50Q959 1002 970 1027L970 1027Q1027 980 1098.50 914Q1170 848 1247.50 772Q1325 696 1403.50 613.50Q1482 531 1551.50 450Q1621 369 1677.50 292.50Q1734 216 1768 152L1768 152Q1704 186 1627.50 242.50Q1551 299 1470 368.50Q1389 438 1306.50 516.50Q1224 595 1148 672.50Q1072 750 1006 821.50Q940 893 893 950ZM792 1057L792 1057Q768 1057 735 1064Q702 1071 665.50 1082.50Q629 1094 591.50 1109.50Q554 1125 519.50 1142.50Q485 1160 457.50 1178.50Q430 1197 413 1215L413 1215Q397 1232 390.50 1251Q384 1270 384 1293L384 1293Q384 1337 405.50 1380.50Q427 1424 461.50 1458.50Q496 1493 539.50 1514.50Q583 1536 627 1536L627 1536Q650 1536 669 1529.50Q688 1523 705 1507L705 1507Q723 1490 741.50 1462.50Q760 1435 777.50 1401Q795 1367 810.50 1329Q826 1291 837.50 1254.50Q849 1218 856 1185.50Q863 1153 863 1128L863 1128Q863 1087 848 1072Q833 1057 792 1057ZM128 1792L1920 1792L1920 1024L1168 1024Q1123 1064 1078.50 1102.50Q1034 1141 987 1179L987 1179Q982 1224 963.50 1283Q945 1342 918.50 1401Q892 1460 860 1512Q828 1564 795 1597L795 1597Q760 1632 717 1648Q674 1664 625 1664L625 1664Q554 1664 487.50 1632.50Q421 1601 369.50 1549.50Q318 1498 287 1431.50Q256 1365 256 1294L256 1294Q256 1240 273.50 1199.50Q291 1159 321 1127.50Q351 1096 390.50 1071.50Q430 1047 473 1024L473 1024L128 1024L128 1792ZM1152 1408L1152 1408Q1152 1355 1172 1308.50Q1192 1262 1227 1227Q1262 1192 1308.50 1172Q1355 1152 1408 1152L1408 1152Q1461 1152 1507.50 1172Q1554 1192 1589 1227Q1624 1262 1644 1308.50Q1664 1355 1664 1408L1664 1408Q1664 1461 1644 1507.50Q1624 1554 1589 1589Q1554 1624 1507.50 1644Q1461 1664 1408 1664L1408 1664Q1355 1664 1308.50 1644Q1262 1624 1227 1589Q1192 1554 1172 1507.50Q1152 1461 1152 1408ZM1408 1280L1408 1280Q1381 1280 1358 1290Q1335 1300 1317.50 1317.50Q1300 1335 1290 1358Q1280 1381 1280 1408L1280 1408Q1280 1435 1290 1458Q1300 1481 1317.50 1498.50Q1335 1516 1358 1526Q1381 1536 1408 1536L1408 1536Q1435 1536 1458 1526Q1481 1516 1498.50 1498.50Q1516 1481 1526 1458Q1536 1435 1536 1408L1536 1408Q1536 1381 1526 1358Q1516 1335 1498.50 1317.50Q1481 1300 1458 1290Q1435 1280 1408 1280Z"
         }
      }
   ]
}

var CampaignTemplate = {
   name: "CampaignTemplate",
   vendor: "UiFabric",
   unicode: 63505,
   value: "",
   charCode: "F811",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1142L2048 940L2048 1856L1531 1782Q1522 1839 1493 1887.50Q1464 1936 1421.50 1972Q1379 2008 1326 2028Q1273 2048 1216 2048L1216 2048Q1167 2048 1122 2034.50Q1077 2021 1039 1995.50Q1001 1970 970.50 1934Q940 1898 921 1853L921 1853Q906 1818 902 1787Q898 1756 898 1721L898 1721L898 1692Q868 1687 830.50 1680.50Q793 1674 754 1668Q715 1662 678 1657.50Q641 1653 612 1652L612 1652L598 1652Q576 1652 554.50 1653Q533 1654 512 1654L512 1654L512 1142Q540 1142 567 1143Q594 1144 622 1144L622 1144Q627 1144 631 1143.50Q635 1143 640 1142L640 1142ZM1404 1764L1404 1764L1026 1710Q1024 1715 1024 1719Q1024 1723 1024 1728L1024 1728Q1024 1768 1039 1803Q1054 1838 1080 1864Q1106 1890 1141 1905Q1176 1920 1216 1920L1216 1920Q1250 1920 1281.50 1908.50Q1313 1897 1338 1876Q1363 1855 1380.50 1826.50Q1398 1798 1404 1764ZM640 1526L1920 1708L1920 1088L640 1270L640 1526ZM0 0L128 0L128 128L0 128L0 0ZM0 256L128 256L128 384L0 384L0 256ZM0 512L128 512L128 640L0 640L0 512ZM0 768L128 768L128 896L0 896L0 768ZM0 1024L128 1024L128 1152L0 1152L0 1024ZM0 1280L128 1280L128 1408L0 1408L0 1280ZM0 1536L128 1536L128 1664L0 1664L0 1536ZM0 1920L0 1792L128 1792L128 1920L0 1920ZM256 2048L128 2048L128 1920L256 1920L256 2048ZM256 0L384 0L384 128L256 128L256 0ZM512 2048L384 2048L384 1920L512 1920L512 2048ZM768 2048L640 2048L640 1920L768 1920L768 2048ZM512 0L640 0L640 128L512 128L512 0ZM768 0L896 0L896 128L768 128L768 0ZM1024 0L1152 0L1152 128L1024 128L1024 0ZM1280 0L1408 0L1408 128L1280 128L1280 0ZM1536 128L1536 256L1408 256L1408 128L1536 128ZM1408 384L1536 384L1536 512L1408 512L1408 384ZM1536 768L1408 768L1408 640L1536 640L1536 768Z"
         }
      }
   ]
}

var ChartTemplate = {
   name: "ChartTemplate",
   vendor: "UiFabric",
   unicode: 63506,
   value: "",
   charCode: "F812",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 0L128 0L128 128L0 128L0 0ZM0 256L128 256L128 384L0 384L0 256ZM0 512L128 512L128 640L0 640L0 512ZM0 768L128 768L128 896L0 896L0 768ZM0 1024L128 1024L128 1152L0 1152L0 1024ZM0 1280L128 1280L128 1408L0 1408L0 1280ZM0 1536L128 1536L128 1664L0 1664L0 1536ZM0 1920L0 1792L128 1792L128 1920L0 1920ZM256 2048L128 2048L128 1920L256 1920L256 2048ZM256 0L384 0L384 128L256 128L256 0ZM512 2048L384 2048L384 1920L512 1920L512 2048ZM768 2048L640 2048L640 1920L768 1920L768 2048ZM512 0L640 0L640 128L512 128L512 0ZM768 0L896 0L896 128L768 128L768 0ZM1024 0L1152 0L1152 128L1024 128L1024 0ZM1280 0L1408 0L1408 128L1280 128L1280 0ZM1536 128L1536 256L1408 256L1408 128L1536 128ZM1408 384L1536 384L1536 512L1408 512L1408 384ZM1536 768L1408 768L1408 640L1536 640L1536 768ZM1536 1024L1408 1024L1408 896L1536 896L1536 1024ZM1664 1280L1152 1280L1152 1152L1664 1152L1664 1280ZM1024 1024L1024 1920L1920 1920L1920 2048L896 2048L896 1024L1024 1024ZM1152 1536L1152 1408L1536 1408L1536 1536L1152 1536ZM1792 1792L1152 1792L1152 1664L1792 1664L1792 1792Z"
         }
      }
   ]
}

var PageListFilter = {
   name: "PageListFilter",
   vendor: "UiFabric",
   unicode: 63507,
   value: "",
   charCode: "F813",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1432L1152 1280L2048 1280L2048 1432L1792 1720L1792 2048L1408 2048L1408 1720L1152 1432ZM1664 1920L1664 1672L1898 1408L1302 1408L1536 1672L1536 1920L1664 1920ZM512 384L1280 384L1280 512L512 512L512 384ZM1024 1280L512 1280L512 1152L1024 1152L1024 1280ZM128 128L128 1664L1187 1664L1280 1769L1280 1792L0 1792L0 0L1536 0L1536 1152L1408 1152L1408 128L128 128ZM512 768L1280 768L1280 896L512 896L512 768ZM256 384L384 384L384 512L256 512L256 384ZM256 768L384 768L384 896L256 896L256 768ZM384 1280L256 1280L256 1152L384 1152L384 1280Z"
         }
      }
   ]
}

var SecondaryNav = {
   name: "SecondaryNav",
   vendor: "UiFabric",
   unicode: 63508,
   value: "",
   charCode: "F814",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 384L1024 384L1024 512L0 512L0 384ZM0 1024L0 896L2048 896L2048 1024L0 1024ZM2048 1536L1024 1536L1024 1408L2048 1408L2048 1536Z"
         }
      }
   ]
}

var FabricFolderConfirm = {
   name: "FabricFolderConfirm",
   vendor: "UiFabric",
   unicode: 63487,
   value: "",
   charCode: "F7FF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1246L1920 1118L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L1182 1536L1054 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1293 1651L1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651Z"
         }
      }
   ]
}

var InformationBarriers = {
   name: "InformationBarriers",
   vendor: "UiFabric",
   unicode: 63491,
   value: "",
   charCode: "F803",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 768L384 128L2048 128L2048 768L1920 768L1920 1088L1600 768L1536 768L1536 640L1653 640L1792 779L1792 640L1920 640L1920 256L512 256L512 555Q470 602 438.50 655Q407 708 387 768L387 768L384 768ZM960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960L1408 960Q1408 1053 1373 1134.50Q1338 1216 1277 1277Q1216 1338 1134.50 1373Q1053 1408 960 1408ZM1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q913 640 868 653.50Q823 667 784 693L784 693L1227 1136Q1253 1097 1266.50 1052Q1280 1007 1280 960ZM640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280L960 1280Q1007 1280 1052 1266.50Q1097 1253 1136 1227L1136 1227L693 784Q667 823 653.50 868Q640 913 640 960ZM395 1536L1536 1536L1536 1024L1664 1024L1664 1664L448 1664L128 1984L128 1664L0 1664L0 1024L384 1024L384 1152L128 1152L128 1536L256 1536L256 1675L395 1536Z"
         }
      }
   ]
}

var CommentActive = {
   name: "CommentActive",
   vendor: "UiFabric",
   unicode: 63492,
   value: "",
   charCode: "F804",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 640L1728 640Q1662 640 1603.50 615Q1545 590 1501.50 546.50Q1458 503 1433 444.50Q1408 386 1408 320L1408 320Q1408 254 1433 195.50Q1458 137 1501.50 93.50Q1545 50 1603.50 25Q1662 0 1728 0L1728 0Q1794 0 1852.50 25Q1911 50 1954.50 93.50Q1998 137 2023 195.50Q2048 254 2048 320L2048 320Q2048 386 2023 444.50Q1998 503 1954.50 546.50Q1911 590 1852.50 615Q1794 640 1728 640ZM1280 896L1152 896L1152 640L1370 640Q1388 660 1408 678L1408 678L1408 896Q1408 923 1398 946Q1388 969 1370.50 986.50Q1353 1004 1330 1014Q1307 1024 1280 1024L1280 1024L1280 896ZM768 1024L768 1024L768 896L640 896L640 640L896 640L896 896Q896 923 886 946Q876 969 858.50 986.50Q841 1004 818 1014Q795 1024 768 1024ZM677 1408L1920 1408L1920 760Q1955 745 1987 724Q2019 703 2048 678L2048 678L2048 1536L731 1536L256 2011L256 1536L0 1536L0 128L1288 128Q1261 189 1252 256L1252 256L128 256L128 1408L384 1408L384 1701L677 1408Z"
         }
      }
   ]
}

var ColumnVerticalSectionEdit = {
   name: "ColumnVerticalSectionEdit",
   vendor: "UiFabric",
   unicode: 63494,
   value: "",
   charCode: "F806",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896ZM1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838L1899 1145Q1920 1124 1920 1094ZM1408 1044L1408 256L2048 256L2048 812Q1991 773 1920 759L1920 759L1920 384L1536 384L1536 916L1408 1044ZM512 384L256 384L256 256L512 256L512 384ZM640 256L896 256L896 384L640 384L640 256ZM512 1792L256 1792L256 1664L512 1664L512 1792ZM808 1792L640 1792L640 1664L840 1664L808 1792ZM128 896L0 896L0 640L128 640L128 896ZM128 512L0 512L0 256L128 256L128 512ZM128 1664L0 1664L0 1408L128 1408L128 1664ZM128 1280L0 1280L0 1024L128 1024L128 1280ZM1024 768L1152 768L1152 1024L1024 1024L1024 768ZM1024 384L1152 384L1152 640L1024 640L1024 384ZM1024 1152L1152 1152L1152 1280L1024 1408L1024 1152Z"
         }
      }
   ]
}

var WavingHand = {
   name: "WavingHand",
   vendor: "UiFabric",
   unicode: 63495,
   value: "",
   charCode: "F807",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 706L1920 1401Q1920 1484 1900.50 1564.50Q1881 1645 1844 1716.50Q1807 1788 1754.50 1848.50Q1702 1909 1636 1953Q1570 1997 1492 2021.50Q1414 2046 1327 2046L1327 2046Q1268 2046 1209 2034.50Q1150 2023 1094.50 2001.50Q1039 1980 989 1947.50Q939 1915 897 1873L897 1873L276 1252Q249 1225 234.50 1189.50Q220 1154 220 1116L220 1116Q220 1059 251 1011.50Q282 964 335 941L335 941Q310 896 310 846L310 846Q310 789 341.50 740.50Q373 692 426 670L426 670Q400 626 400 575L400 575Q400 535 415 500Q430 465 456 439Q482 413 517 398Q552 383 592 383L592 383Q642 383 687 408L687 408Q711 355 758 324Q805 293 863 293L863 293Q901 293 936 307.50Q971 322 998 349L998 349L1536 887L1536 706Q1536 668 1550.50 632.50Q1565 597 1592 570L1592 570Q1619 544 1654.50 529Q1690 514 1728 514L1728 514Q1768 514 1803 529Q1838 544 1864 570Q1890 596 1905 631Q1920 666 1920 706L1920 706ZM1792 1398L1792 1398L1792 706Q1792 680 1773 661Q1754 642 1728 642L1728 642Q1701 642 1682.50 660.50Q1664 679 1664 706L1664 706L1664 933Q1664 966 1646 993Q1628 1020 1597 1033L1597 1033Q1587 1038 1576.50 1039.50Q1566 1041 1555 1041L1555 1041Q1509 1041 1478 1010L1478 1010L908 440Q889 421 863 421L863 421Q837 421 818 440Q799 459 799 485L799 485Q799 511 818 530L818 530L1179 891Q1198 910 1198 936L1198 936Q1198 962 1179 981Q1160 1000 1134 1000L1134 1000Q1108 1000 1089 981L1089 981L637 530Q618 511 592 511L592 511Q566 511 547 530Q528 549 528 575L528 575Q528 601 547 620L547 620L998 1071Q1017 1090 1017 1117L1017 1117Q1017 1143 998 1162Q979 1181 953 1181L953 1181Q927 1181 908 1162L908 1162L547 801Q528 782 502 782L502 782Q476 782 457 801Q438 820 438 846L438 846Q438 872 457 891L457 891L863 1297Q882 1316 882 1342L882 1342Q882 1368 863 1387Q844 1406 818 1406L818 1406Q792 1406 773 1387L773 1387L456 1072Q437 1053 412 1053L412 1053Q386 1053 367 1071.50Q348 1090 348 1117L348 1117Q348 1142 367 1161L367 1161L987 1782Q1053 1848 1143 1882.50Q1233 1917 1326 1917L1326 1917Q1431 1917 1517 1873.50Q1603 1830 1664 1758Q1725 1686 1758.50 1592.50Q1792 1499 1792 1398ZM1152 64L1152 64Q1152 38 1171 19Q1190 0 1216 0L1216 0Q1309 0 1390.50 35Q1472 70 1533 131Q1594 192 1629 273.50Q1664 355 1664 448L1664 448Q1664 474 1645 493Q1626 512 1600 512L1600 512Q1574 512 1555 493Q1536 474 1536 448L1536 448Q1536 382 1510.50 324Q1485 266 1441.50 222.50Q1398 179 1340 153.50Q1282 128 1216 128L1216 128Q1190 128 1171 109Q1152 90 1152 64ZM1152 288L1152 288Q1152 262 1171 243Q1190 224 1216 224L1216 224Q1262 224 1303 241.50Q1344 259 1374.50 289.50Q1405 320 1422.50 361Q1440 402 1440 448L1440 448Q1440 474 1421 493Q1402 512 1376 512L1376 512Q1350 512 1331 493Q1312 474 1312 448L1312 448Q1312 408 1284 380Q1256 352 1216 352L1216 352Q1190 352 1171 333Q1152 314 1152 288ZM512 1856L512 1856Q512 1882 493 1901Q474 1920 448 1920L448 1920Q355 1920 273.50 1885Q192 1850 131 1789Q70 1728 35 1646.50Q0 1565 0 1472L0 1472Q0 1446 19 1427Q38 1408 64 1408L64 1408Q90 1408 109 1427Q128 1446 128 1472L128 1472Q128 1538 153 1596.50Q178 1655 221.50 1698.50Q265 1742 323.50 1767Q382 1792 448 1792L448 1792Q474 1792 493 1811Q512 1830 512 1856ZM512 1632L512 1632Q512 1658 493 1677Q474 1696 448 1696L448 1696Q401 1696 360.50 1678.50Q320 1661 289.50 1630.50Q259 1600 241.50 1559.50Q224 1519 224 1472L224 1472Q224 1446 243 1427Q262 1408 288 1408L288 1408Q314 1408 333 1427Q352 1446 352 1472L352 1472Q352 1512 380 1540Q408 1568 448 1568L448 1568Q474 1568 493 1587Q512 1606 512 1632Z"
         }
      }
   ]
}

var ShakeDevice = {
   name: "ShakeDevice",
   vendor: "UiFabric",
   unicode: 63498,
   value: "",
   charCode: "F80A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1897 1527L1897 1527Q1897 1561 1878.50 1590.50Q1860 1620 1830 1635L1830 1635L1026 2035Q1013 2041 1000 2044.50Q987 2048 973 2048L973 2048Q938 2048 909.50 2030.50Q881 2013 865 1981L865 1981L164 574Q151 546 151 521L151 521Q151 487 169.50 457.50Q188 428 218 413L218 413L1022 13Q1050 0 1075 0L1075 0Q1110 0 1139 18Q1168 36 1183 67L1183 67L1884 1474Q1897 1502 1897 1527ZM282 524L976 1917L1766 1524L1072 131L282 524ZM1346 1419L1403 1534L1202 1634L1145 1519L1346 1419ZM1664 640L1664 347L1581 429L1491 339L1728 102L1965 339L1875 429L1792 347L1792 640L1664 640ZM384 1408L384 1701L467 1619L557 1709L320 1946L83 1709L173 1619L256 1701L256 1408L384 1408Z"
         }
      }
   ]
}

var SmartGlassRemote = {
   name: "SmartGlassRemote",
   vendor: "UiFabric",
   unicode: 63499,
   value: "",
   charCode: "F80B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1152L768 1152L768 1280L640 1280L640 1152ZM1280 1536L1152 1536L1152 1408L1280 1408L1280 1536ZM1024 1280L896 1280L896 1152L1024 1152L1024 1280ZM1280 1280L1152 1280L1152 1152L1280 1152L1280 1280ZM640 1408L768 1408L768 1536L640 1536L640 1408ZM1024 1536L896 1536L896 1408L1024 1408L1024 1536ZM640 1664L768 1664L768 1792L640 1792L640 1664ZM1280 1792L1152 1792L1152 1664L1280 1664L1280 1792ZM1024 1792L896 1792L896 1664L1024 1664L1024 1792ZM960 896L960 896Q894 896 835.50 871Q777 846 733.50 802.50Q690 759 665 700.50Q640 642 640 576L640 576Q640 510 665 452Q690 394 733.50 350.50Q777 307 835.50 281.50Q894 256 960 256L960 256Q1026 256 1084 281.50Q1142 307 1185.50 350.50Q1229 394 1254.50 452Q1280 510 1280 576L1280 576Q1280 642 1254.50 700.50Q1229 759 1185.50 802.50Q1142 846 1084 871Q1026 896 960 896ZM960 384L960 384Q920 384 885 399Q850 414 824 440Q798 466 783 501Q768 536 768 576L768 576Q768 616 783 651Q798 686 824 712Q850 738 885 753Q920 768 960 768L960 768Q1000 768 1035 753Q1070 738 1096 712Q1122 686 1137 651Q1152 616 1152 576L1152 576Q1152 536 1137 501Q1122 466 1096 440Q1070 414 1035 399Q1000 384 960 384ZM384 2048L384 0L1536 0L1536 2048L384 2048ZM512 1920L1408 1920L1408 128L512 128L512 1920Z"
         }
      }
   ]
}

var Rotate90Clockwise = {
   name: "Rotate90Clockwise",
   vendor: "UiFabric",
   unicode: 63501,
   value: "",
   charCode: "F80D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1061L1939 915L2029 1005L1728 1306L1427 1005L1517 915L1664 1061L1664 1024Q1664 918 1636.50 820Q1609 722 1559 636.50Q1509 551 1439 481Q1369 411 1283.50 361Q1198 311 1100 283.50Q1002 256 896 256L896 256Q790 256 692 283.50Q594 311 508.50 361Q423 411 353 481Q283 551 233 636.50Q183 722 155.50 820Q128 918 128 1024L128 1024Q128 1130 155.50 1228Q183 1326 233 1411.50Q283 1497 353 1567Q423 1637 508.50 1687Q594 1737 692 1764.50Q790 1792 896 1792L896 1792L896 1920Q772 1920 657.50 1888Q543 1856 443.50 1797.50Q344 1739 262.50 1657.50Q181 1576 122.50 1476.50Q64 1377 32 1262.50Q0 1148 0 1024L0 1024Q0 900 32 785.50Q64 671 122.50 571.50Q181 472 262.50 390.50Q344 309 443.50 250.50Q543 192 657.50 160Q772 128 896 128L896 128Q1031 128 1157.50 167Q1284 206 1391.50 277Q1499 348 1584 449.50Q1669 551 1722 675L1722 675Q1762 769 1777 864Q1792 959 1792 1061L1792 1061ZM896 768L896 768Q949 768 995.50 788Q1042 808 1077 843Q1112 878 1132 924.50Q1152 971 1152 1024L1152 1024Q1152 1077 1132 1123.50Q1112 1170 1077 1205Q1042 1240 995.50 1260Q949 1280 896 1280L896 1280Q843 1280 796.50 1260Q750 1240 715 1205Q680 1170 660 1123.50Q640 1077 640 1024L640 1024Q640 971 660 924.50Q680 878 715 843Q750 808 796.50 788Q843 768 896 768ZM896 1152L896 1152Q923 1152 946 1142Q969 1132 986.50 1114.50Q1004 1097 1014 1074Q1024 1051 1024 1024L1024 1024Q1024 997 1014 974Q1004 951 986.50 933.50Q969 916 946 906Q923 896 896 896L896 896Q869 896 846 906Q823 916 805.50 933.50Q788 951 778 974Q768 997 768 1024L768 1024Q768 1051 778 1074Q788 1097 805.50 1114.50Q823 1132 846 1142Q869 1152 896 1152Z"
         }
      }
   ]
}

var Rotate90CounterClockwise = {
   name: "Rotate90CounterClockwise",
   vendor: "UiFabric",
   unicode: 63502,
   value: "",
   charCode: "F80E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1024L2048 1024Q2048 1148 2016 1262.50Q1984 1377 1925.50 1476.50Q1867 1576 1785.50 1657.50Q1704 1739 1604.50 1797.50Q1505 1856 1390.50 1888Q1276 1920 1152 1920L1152 1920L1152 1792Q1258 1792 1356 1764.50Q1454 1737 1539.50 1687Q1625 1637 1695 1567Q1765 1497 1815 1411.50Q1865 1326 1892.50 1228Q1920 1130 1920 1024L1920 1024Q1920 918 1892.50 820Q1865 722 1815 636.50Q1765 551 1695 481Q1625 411 1539.50 361Q1454 311 1356 283.50Q1258 256 1152 256L1152 256Q1046 256 948 283.50Q850 311 764.50 361Q679 411 609 481Q539 551 489 636.50Q439 722 411.50 820Q384 918 384 1024L384 1024L384 1061L531 915L621 1005L320 1306L19 1005L109 915L256 1061L256 1051Q256 953 272 860Q288 767 326 675L326 675Q378 551 463 450Q548 349 656.50 277.50Q765 206 891.50 167Q1018 128 1152 128L1152 128Q1276 128 1390.50 160Q1505 192 1604.50 250.50Q1704 309 1785.50 390.50Q1867 472 1925.50 571.50Q1984 671 2016 785.50Q2048 900 2048 1024ZM1408 1024L1408 1024Q1408 1077 1388 1123.50Q1368 1170 1333 1205Q1298 1240 1251.50 1260Q1205 1280 1152 1280L1152 1280Q1099 1280 1052.50 1260Q1006 1240 971 1205Q936 1170 916 1123.50Q896 1077 896 1024L896 1024Q896 971 916 924.50Q936 878 971 843Q1006 808 1052.50 788Q1099 768 1152 768L1152 768Q1205 768 1251.50 788Q1298 808 1333 843Q1368 878 1388 924.50Q1408 971 1408 1024ZM1024 1024L1024 1024Q1024 1051 1034 1074Q1044 1097 1061.50 1114.50Q1079 1132 1102 1142Q1125 1152 1152 1152L1152 1152Q1179 1152 1202 1142Q1225 1132 1242.50 1114.50Q1260 1097 1270 1074Q1280 1051 1280 1024L1280 1024Q1280 997 1270 974Q1260 951 1242.50 933.50Q1225 916 1202 906Q1179 896 1152 896L1152 896Q1125 896 1102 906Q1079 916 1061.50 933.50Q1044 951 1034 974Q1024 997 1024 1024Z"
         }
      }
   ]
}

var ColumnVerticalSection = {
   name: "ColumnVerticalSection",
   vendor: "UiFabric",
   unicode: 63518,
   value: "",
   charCode: "F81E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1792L1408 256L2048 256L2048 1792L1408 1792ZM1536 1664L1920 1664L1920 384L1536 384L1536 1664ZM512 384L256 384L256 256L512 256L512 384ZM896 384L640 384L640 256L896 256L896 384ZM512 1792L256 1792L256 1664L512 1664L512 1792ZM896 1792L640 1792L640 1664L896 1664L896 1792ZM128 896L0 896L0 640L128 640L128 896ZM128 512L0 512L0 256L128 256L128 512ZM128 1664L0 1664L0 1408L128 1408L128 1664ZM128 1280L0 1280L0 1024L128 1024L128 1280ZM1152 1024L1024 1024L1024 768L1152 768L1152 1024ZM1152 640L1024 640L1024 384L1152 384L1152 640ZM1152 1792L1024 1792L1024 1536L1152 1536L1152 1792ZM1152 1408L1024 1408L1024 1152L1152 1152L1152 1408Z"
         }
      }
   ]
}

var SkypeCircleSlash = {
   name: "SkypeCircleSlash",
   vendor: "UiFabric",
   unicode: 63525,
   value: "",
   charCode: "F825",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 0Q1165 0 1296 36.50Q1427 73 1540.50 140Q1654 207 1747.50 300.50Q1841 394 1908 507.50Q1975 621 2011.50 752Q2048 883 2048 1024L2048 1024Q2048 1165 2011.50 1296Q1975 1427 1908 1540.50Q1841 1654 1747.50 1747.50Q1654 1841 1540.50 1908Q1427 1975 1296 2011.50Q1165 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 883 36.50 752Q73 621 140 507.50Q207 394 300.50 300.50Q394 207 507.50 140Q621 73 752 36.50Q883 0 1024 0ZM1456 1349L1456 1349Q1456 1303 1425 1272L1425 1272L776 623Q745 592 699 592L699 592Q677 592 657.50 600.50Q638 609 623 623.50Q608 638 599.50 658Q591 678 591 700L591 700Q591 744 623 776L623 776L1272 1425Q1304 1457 1348 1457L1348 1457Q1370 1457 1390 1448.50Q1410 1440 1424.50 1425Q1439 1410 1447.50 1390.50Q1456 1371 1456 1349Z"
         }
      }
   ]
}

var SkypeSlash = {
   name: "SkypeSlash",
   vendor: "UiFabric",
   unicode: 63526,
   value: "",
   charCode: "F826",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1807 1605L1807 1605Q1807 1646 1791 1682.50Q1775 1719 1747.50 1746.50Q1720 1774 1683.50 1790Q1647 1806 1606 1806L1606 1806Q1566 1806 1529.50 1791Q1493 1776 1464 1747L1464 1747L302 585Q274 557 258.50 519.50Q243 482 243 443L243 443Q243 401 259 364.50Q275 328 302.50 301Q330 274 366.50 258Q403 242 444 242L444 242Q527 242 586 301L586 301L1748 1463Q1777 1492 1792 1528.50Q1807 1565 1807 1605Z"
         }
      }
   ]
}

var CustomizeToolbar = {
   name: "CustomizeToolbar",
   vendor: "UiFabric",
   unicode: 63528,
   value: "",
   charCode: "F828",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 512L896 1024L384 1024L384 512L896 512ZM768 640L512 640L512 896L768 896L768 640ZM1152 512L1664 512L1664 1024L1152 1024L1152 512ZM1280 896L1536 896L1536 640L1280 640L1280 896ZM0 1280L0 256L2048 256L2048 1024L1920 1024L1920 384L128 384L128 1152L1024 1152L1024 1280L0 1280ZM1865 1421L1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421ZM1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600Z"
         }
      }
   ]
}

var DuplicateRow = {
   name: "DuplicateRow",
   vendor: "UiFabric",
   unicode: 63530,
   value: "",
   charCode: "F82A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 384L1664 768L2048 768L2048 1536L384 1536L384 1152L0 1152L0 384L1664 384ZM128 1024L384 1024L384 768L1536 768L1536 512L128 512L128 1024ZM512 1408L1920 1408L1920 896L512 896L512 1408Z"
         }
      }
   ]
}

var RemoveFromTrash = {
   name: "RemoveFromTrash",
   vendor: "UiFabric",
   unicode: 63531,
   value: "",
   charCode: "F82B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M996 0L1086 91L281 896L1280 896L1280 1856Q1280 1896 1265 1931Q1250 1966 1224 1992Q1198 2018 1163 2033Q1128 2048 1088 2048L1088 2048L320 2048Q280 2048 245 2033Q210 2018 184 1992Q158 1966 143 1931Q128 1896 128 1856L128 1856L128 1049L91 1086L0 996L272 724L181 634Q163 616 153.50 592.50Q144 569 144 543L144 543Q144 492 181 453L181 453L452 181Q470 163 493.50 153.50Q517 144 543 144L543 144Q569 144 592.50 153.50Q616 163 634 181L634 181L724 272L996 0ZM1152 1856L1152 1856L1152 1024L256 1024L256 1856Q256 1882 275 1901Q294 1920 320 1920L320 1920L1088 1920Q1114 1920 1133 1901Q1152 1882 1152 1856ZM634 362L543 272L272 543L362 634L634 362ZM1920 550L1920 256L2048 256L2048 768L1536 768L1536 640L1828 640Q1751 580 1660.50 549Q1570 518 1473 518L1473 518Q1358 518 1254 561Q1150 604 1069 685L1069 685L979 595Q1079 495 1205 442.50Q1331 390 1473 390L1473 390Q1596 390 1711 431Q1826 472 1920 550L1920 550ZM896 1152L1024 1152L1024 1792L896 1792L896 1152ZM640 1152L768 1152L768 1792L640 1792L640 1152ZM384 1152L512 1152L512 1792L384 1792L384 1152Z"
         }
      }
   ]
}

var Header = {
   name: "Header",
   vendor: "UiFabric",
   unicode: 63535,
   value: "",
   charCode: "F82F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 2048L128 0L1920 0L1920 2048L128 2048ZM256 1920L1792 1920L1792 128L256 128L256 1920ZM384 256L1664 256L1664 768L384 768L384 256ZM512 640L1536 640L1536 384L512 384L512 640Z"
         }
      }
   ]
}

var Footer = {
   name: "Footer",
   vendor: "UiFabric",
   unicode: 63534,
   value: "",
   charCode: "F82E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 2048L128 0L1920 0L1920 2048L128 2048ZM256 1920L1792 1920L1792 128L256 128L256 1920ZM384 1280L1664 1280L1664 1792L384 1792L384 1280ZM512 1664L1536 1664L1536 1408L512 1408L512 1664Z"
         }
      }
   ]
}

var Childof = {
   name: "Childof",
   vendor: "UiFabric",
   unicode: 63533,
   value: "",
   charCode: "F82D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L1024 256L1024 384L128 384L128 256ZM1491 1069L1581 979L1946 1344L1581 1709L1491 1619L1701 1408L512 1408L512 512L640 512L640 1280L1701 1280L1491 1069Z"
         }
      }
   ]
}

var MailOptions = {
   name: "MailOptions",
   vendor: "UiFabric",
   unicode: 63532,
   value: "",
   charCode: "F82C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 384L2048 384L2048 1189Q2020 1158 1987.50 1131.50Q1955 1105 1920 1083L1920 1083L1920 648L1024 1095L128 648L128 1536L1024 1536L1024 1664L0 1664ZM1905 512L143 512L1024 953L1905 512ZM1865 1421L1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421ZM1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600Z"
         }
      }
   ]
}

var StackedColumnChart2Fill = {
   name: "StackedColumnChart2Fill",
   vendor: "UiFabric",
   unicode: 63537,
   value: "",
   charCode: "F831",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 256L1792 256L1792 1664L1408 1664L1408 256ZM1536 640L1664 640L1664 384L1536 384L1536 640ZM896 768L1280 768L1280 1664L896 1664L896 768ZM1024 1152L1152 1152L1152 896L1024 896L1024 1152ZM384 512L768 512L768 1664L384 1664L384 512ZM512 896L640 896L640 640L512 640L512 896ZM256 128L256 1792L1920 1792L1920 1920L128 1920L128 128L256 128Z"
         }
      }
   ]
}

var BarChartVerticalFill = {
   name: "BarChartVerticalFill",
   vendor: "UiFabric",
   unicode: 63536,
   value: "",
   charCode: "F830",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 768L1280 768L1280 1664L896 1664L896 768L1280 768ZM1792 256L1792 256L1792 1664L1408 1664L1408 256L1792 256ZM256 1792L256 1792L1920 1792L1920 1920L128 1920L128 128L256 128L256 1792ZM768 512L768 512L768 1664L384 1664L384 512L768 512Z"
         }
      }
   ]
}

var PlainText = {
   name: "PlainText",
   vendor: "UiFabric",
   unicode: 63540,
   value: "",
   charCode: "F834",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1536L128 1535L128 1280L256 1280L256 1536L128 1536ZM384 640L512 640L512 896L384 896L384 640ZM1152 1664L1024 1664L1024 1536L1152 1536L1152 1664ZM896 1536L896 1280L1024 1280L1024 1536L896 1536ZM768 640L768 896L640 896L640 640L768 640ZM512 384L640 384L640 640L512 640L512 384ZM768 1152L768 896L896 896L896 1280L256 1280L256 896L384 896L384 1152L768 1152ZM128 1664L0 1664L0 1536L128 1536L128 1664ZM1408 896L1408 768L1792 768L1792 896L1408 896ZM1408 1024L1280 1024L1280 896L1408 896L1408 1024ZM1280 1536L1280 1280L1408 1280L1408 1536L1280 1536ZM1664 1664L1408 1664L1408 1536L1664 1536L1664 1664ZM1792 1152L1792 896L1920 896L1920 1664L1792 1664L1792 1536L1664 1536L1664 1408L1792 1408L1792 1280L1408 1280L1408 1152L1792 1152Z"
         }
      }
   ]
}

var AccessibiltyChecker = {
   name: "AccessibiltyChecker",
   vendor: "UiFabric",
   unicode: 63541,
   value: "",
   charCode: "F835",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L128 128L128 1920L512 1920L512 2048L0 2048L0 0L1115 0L1664 549L1664 640L1024 640L1024 128ZM1445 512L1152 219L1152 512L1445 512ZM1408 1280L1536 1280L1344 1536L1152 1280L1280 1280L1280 768L1408 768L1408 1280ZM1792 1152L2048 1344L1792 1536L1792 1408L1600 1408L1696 1280L1792 1280L1792 1152ZM775 1408L647 1408Q656 1327 686.50 1252.50Q717 1178 768 1114L768 1114L859 1205Q790 1295 775 1408L775 1408ZM647 1536L775 1536Q790 1649 859 1739L859 1739L768 1830Q717 1766 686.50 1691.50Q656 1617 647 1536L647 1536ZM1152 903L1152 1031Q1039 1046 949 1115L949 1115L858 1024Q922 973 996.50 942.50Q1071 912 1152 903L1152 903ZM1664 1830L1573 1739Q1642 1649 1657 1536L1657 1536L1785 1536Q1776 1617 1745.50 1691.50Q1715 1766 1664 1830L1664 1830ZM1280 2041L1280 1913Q1393 1898 1483 1829L1483 1829L1574 1920Q1510 1971 1435.50 2001.50Q1361 2032 1280 2041L1280 2041ZM858 1920L858 1920L949 1829Q1039 1898 1152 1913L1152 1913L1152 2041Q1071 2032 996.50 2001.50Q922 1971 858 1920Z"
         }
      }
   ]
}

var DatabaseSync = {
   name: "DatabaseSync",
   vendor: "UiFabric",
   unicode: 63554,
   value: "",
   charCode: "F842",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M252 569L252 569Q220 557 188.50 542.50Q157 528 128 510L128 510L128 1216Q128 1235 142.50 1253Q157 1271 177.50 1286Q198 1301 220 1312.50Q242 1324 256 1330L256 1330L256 1466Q215 1451 170 1429Q125 1407 87 1376.50Q49 1346 24.50 1306Q0 1266 0 1216L0 1216L0 320Q0 272 22.50 233.50Q45 195 82 164Q119 133 166 109.50Q213 86 262 68.50Q311 51 358 40Q405 29 442 22L442 22Q570 0 704 0L704 0Q751 0 814.50 4.50Q878 9 947.50 20Q1017 31 1087.50 49.50Q1158 68 1218.50 96Q1279 124 1325.50 162.50Q1372 201 1394 252L1394 252Q1344 243 1295 236.50Q1246 230 1195 227L1195 227Q1144 199 1082.50 180Q1021 161 956 149.50Q891 138 826 133Q761 128 704 128L704 128Q646 128 575 133.50Q504 139 432 153Q360 167 293.50 190.50Q227 214 179 249L179 249Q162 261 145 279.50Q128 298 128 320L128 320Q128 346 152 368.50Q176 391 208.50 409.50Q241 428 274.50 441Q308 454 327 460L327 460Q304 484 285 511Q266 538 252 569ZM1088 1024L1088 1024Q1020 1024 943.50 1017.50Q867 1011 790.50 995.50Q714 980 642 955Q570 930 512 894L512 894L512 1600Q512 1623 530.50 1644Q549 1665 578.50 1682.50Q608 1700 644.50 1714.50Q681 1729 716 1740Q751 1751 780.50 1758.50Q810 1766 826 1769L826 1769Q875 1778 924.50 1783.50Q974 1789 1024 1791L1024 1791L1024 1919Q980 1917 915.50 1910Q851 1903 780 1888Q709 1873 638 1849Q567 1825 510.50 1790Q454 1755 419 1708Q384 1661 384 1600L384 1600L384 704Q384 657 406 618Q428 579 464.50 548.50Q501 518 547.50 494.50Q594 471 642.50 453.50Q691 436 738 425Q785 414 821 407L821 407Q887 395 954 389.50Q1021 384 1088 384L1088 384Q1155 384 1222 389.50Q1289 395 1355 407L1355 407Q1391 414 1438 425Q1485 436 1533.50 453Q1582 470 1628.50 494Q1675 518 1711.50 548.50Q1748 579 1770 618Q1792 657 1792 704L1792 704L1792 1024L1664 1024L1664 894Q1605 930 1533.50 955Q1462 980 1385.50 995.50Q1309 1011 1232.50 1017.50Q1156 1024 1088 1024ZM1088 512L1088 512Q1031 512 957.50 518Q884 524 809.50 538.50Q735 553 666.50 578Q598 603 552 641L552 641Q538 652 525 668.50Q512 685 512 704L512 704Q512 723 525 739.50Q538 756 552 767L552 767Q598 805 666.50 830Q735 855 809.50 869.50Q884 884 957.50 890Q1031 896 1088 896L1088 896Q1145 896 1218.50 890Q1292 884 1366.50 869.50Q1441 855 1509 830Q1577 805 1623 767L1623 767Q1637 756 1650.50 739.50Q1664 723 1664 704L1664 704Q1664 685 1650.50 669Q1637 653 1623 641L1623 641Q1577 603 1509 578Q1441 553 1366.50 538.50Q1292 524 1218.50 518Q1145 512 1088 512ZM1920 1289L1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1541 1280 1488.50 1300Q1436 1320 1394 1355.50Q1352 1391 1324 1440Q1296 1489 1286 1547L1286 1547L1159 1525Q1173 1444 1213 1376Q1253 1308 1311.50 1258Q1370 1208 1444 1180Q1518 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289L1920 1289ZM1600 1920L1600 1920Q1659 1920 1711.50 1900Q1764 1880 1806 1844.50Q1848 1809 1876.50 1760Q1905 1711 1915 1653L1915 1653L2041 1675Q2027 1756 1987 1824Q1947 1892 1888.50 1942Q1830 1992 1756 2020Q1682 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920Z"
         }
      }
   ]
}

var ReservationOrders = {
   name: "ReservationOrders",
   vendor: "UiFabric",
   unicode: 63557,
   value: "",
   charCode: "F845",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 512L896 512L896 640L512 640L512 512ZM896 896L512 896L512 768L896 768L896 896ZM768 1152L512 1152L512 1024L768 1024L768 1152ZM256 512L384 512L384 640L256 640L256 512ZM256 768L384 768L384 896L256 896L256 768ZM384 1152L256 1152L256 1024L384 1024L384 1152ZM1024 128L128 128L128 1920L768 1920L768 2048L0 2048L0 0L1115 0L1664 549L1664 768L1536 768L1536 640L1024 640L1024 128ZM1445 512L1152 219L1152 512L1445 512ZM1792 896L1792 1024L2048 1024L2048 2048L896 2048L896 1024L1152 1024L1152 896L1280 896L1280 1024L1664 1024L1664 896L1792 896ZM1024 1920L1920 1920L1920 1408L1024 1408L1024 1920ZM1024 1280L1920 1280L1920 1152L1024 1152L1024 1280Z"
         }
      }
   ]
}

var TabOneColumn = {
   name: "TabOneColumn",
   vendor: "UiFabric",
   unicode: 63561,
   value: "",
   charCode: "F849",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 256L1920 256L1920 2048L0 2048L0 0L1024 0ZM128 1920L1792 1920L1792 384L896 384L896 128L128 128L128 1920ZM1664 1792L256 1792L256 512L1664 512L1664 1792ZM1536 640L384 640L384 1664L1536 1664L1536 640Z"
         }
      }
   ]
}

var TabTwoColumn = {
   name: "TabTwoColumn",
   vendor: "UiFabric",
   unicode: 63562,
   value: "",
   charCode: "F84A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 256L1920 256L1920 2048L0 2048L0 0L1024 0ZM128 1920L1792 1920L1792 384L896 384L896 128L128 128L128 1920ZM896 1792L256 1792L256 512L896 512L896 1792ZM768 640L384 640L384 1664L768 1664L768 640ZM1024 512L1664 512L1664 1792L1024 1792L1024 512ZM1152 1664L1536 1664L1536 640L1152 640L1152 1664Z"
         }
      }
   ]
}

var TabThreeColumn = {
   name: "TabThreeColumn",
   vendor: "UiFabric",
   unicode: 63563,
   value: "",
   charCode: "F84B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 0L1024 256L1920 256L1920 2048L0 2048L0 0L1024 0ZM128 1920L1792 1920L1792 384L896 384L896 128L128 128L128 1920ZM640 1792L256 1792L256 512L640 512L640 1792ZM512 640L384 640L384 1664L512 1664L512 640ZM1152 1792L768 1792L768 512L1152 512L1152 1792ZM1024 640L896 640L896 1664L1024 1664L1024 640ZM1280 512L1664 512L1664 1792L1280 1792L1280 512ZM1408 1664L1536 1664L1536 640L1408 640L1408 1664Z"
         }
      }
   ]
}

var BulletedTreeList = {
   name: "BulletedTreeList",
   vendor: "UiFabric",
   unicode: 63564,
   value: "",
   charCode: "F84C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 512L512 384L2048 384L2048 512L512 512ZM2048 1024L1024 1024L1024 896L2048 896L2048 1024ZM2048 1536L1024 1536L1024 1408L2048 1408L2048 1536ZM384 640L0 640L0 256L384 256L384 640ZM256 384L128 384L128 512L256 512L256 384ZM896 1152L512 1152L512 768L896 768L896 1152ZM768 896L640 896L640 1024L768 1024L768 896ZM896 1664L512 1664L512 1280L896 1280L896 1664ZM768 1408L640 1408L640 1536L768 1536L768 1408Z"
         }
      }
   ]
}

var MicrosoftTranslatorLogoGreen = {
   name: "MicrosoftTranslatorLogoGreen",
   vendor: "UiFabric",
   unicode: 63570,
   value: "",
   charCode: "F852",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1587 1580L1290 1282L2048 1282L2048 2048L1824 1825Q1749 1877 1661.50 1901.50Q1574 1926 1483 1926L1483 1926Q1440 1926 1395.50 1920.50Q1351 1915 1307 1903.50Q1263 1892 1221 1874.50Q1179 1857 1143 1833L1143 1833Q1204 1829 1269 1808.50Q1334 1788 1393.50 1755Q1453 1722 1503.50 1677.50Q1554 1633 1587 1580L1587 1580ZM1442 993L1442 993Q1416 1020 1387.50 1045Q1359 1070 1327 1089.50Q1295 1109 1259.50 1120.50Q1224 1132 1185 1132L1185 1132Q1104 1132 1066 1083Q1028 1034 1028 956L1028 956Q1028 889 1051.50 833Q1075 777 1114 731.50Q1153 686 1204.50 649.50Q1256 613 1312 584L1312 584Q1311 567 1310.50 551Q1310 535 1310 518L1310 518Q1310 471 1312.50 425Q1315 379 1320 333L1320 333Q1308 334 1295.50 334Q1283 334 1271 334L1271 334L1235 334Q1208 334 1187 332.50Q1166 331 1147 323.50Q1128 316 1110 301Q1092 286 1070 260L1070 260Q1061 249 1050 236.50Q1039 224 1039 210L1039 210Q1039 191 1053 183Q1067 175 1084 175L1084 175Q1106 175 1119.50 183Q1133 191 1142.50 201Q1152 211 1160 220Q1168 229 1179 232L1179 232Q1193 236 1210 236.50Q1227 237 1243 237L1243 237L1264 237Q1297 237 1330 234L1330 234Q1334 201 1339 168.50Q1344 136 1349 103L1349 103Q1344 89 1332 82Q1320 75 1307.50 69.50Q1295 64 1285.50 57Q1276 50 1276 36L1276 36Q1276 16 1291.50 10.50Q1307 5 1322 5L1322 5Q1333 5 1348 9.50Q1363 14 1374 16L1374 16Q1386 19 1409.50 24.50Q1433 30 1457 39Q1481 48 1499 60.50Q1517 73 1517 89L1517 89Q1517 91 1512 107.50Q1507 124 1501 143.50Q1495 163 1489.50 180.50Q1484 198 1483 203L1483 203Q1539 184 1587 148L1587 148Q1610 131 1638.50 115.50Q1667 100 1697 100L1697 100Q1723 100 1741 115Q1759 130 1759 157L1759 157Q1759 186 1742.50 208.50Q1726 231 1699.50 247.50Q1673 264 1639.50 276Q1606 288 1572 296.50Q1538 305 1507 310Q1476 315 1455 319L1455 319Q1444 372 1437.50 425.50Q1431 479 1429 533L1429 533Q1463 521 1498 511.50Q1533 502 1569 497L1569 497Q1560 489 1543 479.50Q1526 470 1508.50 459.50Q1491 449 1478.50 438Q1466 427 1466 415L1466 415Q1466 395 1480 389.50Q1494 384 1511 384L1511 384Q1537 384 1574 387.50Q1611 391 1645 402Q1679 413 1703 434.50Q1727 456 1727 492L1727 492Q1795 499 1853.50 521.50Q1912 544 1954.50 583Q1997 622 2021 677Q2045 732 2045 804L2045 804Q2045 821 2040 844.50Q2035 868 2030 885L2030 885Q2014 936 1983.50 979.50Q1953 1023 1913.50 1059Q1874 1095 1827.50 1123.50Q1781 1152 1734 1174L1734 1174Q1711 1185 1683 1197Q1655 1209 1629 1214L1629 1214L1622 1215Q1606 1213 1588.50 1201.50Q1571 1190 1571 1172L1571 1172Q1571 1153 1587 1146Q1603 1139 1617 1136L1617 1136Q1621 1135 1632 1130.50Q1643 1126 1655.50 1120Q1668 1114 1679 1108Q1690 1102 1694 1100L1694 1100Q1732 1080 1773.50 1052.50Q1815 1025 1850 990.50Q1885 956 1908 914.50Q1931 873 1931 825L1931 825Q1931 819 1930.50 812.50Q1930 806 1929 800L1929 800Q1901 595 1695 580L1695 580Q1658 666 1614 748.50Q1570 831 1515 906L1515 906Q1530 928 1546 946.50Q1562 965 1580 985L1580 985Q1589 994 1589 1004L1589 1004Q1589 1013 1583 1021Q1577 1029 1568.50 1035Q1560 1041 1550.50 1044.50Q1541 1048 1533 1048L1533 1048Q1521 1048 1508 1043Q1495 1038 1482 1030Q1469 1022 1458.50 1012Q1448 1002 1442 993ZM1565 588L1565 588Q1496 600 1430 624L1430 624Q1433 664 1439.50 703.50Q1446 743 1458 781L1458 781Q1471 760 1486.50 736Q1502 712 1516.50 687Q1531 662 1544 637Q1557 612 1565 588ZM1141 978L1141 978Q1141 1004 1159.50 1023.50Q1178 1043 1204 1043L1204 1043Q1226 1043 1251.50 1026Q1277 1009 1301 985Q1325 961 1345 936Q1365 911 1377 895L1377 895Q1353 844 1340 789.50Q1327 735 1320 679L1320 679Q1286 703 1254 736.50Q1222 770 1197 809.50Q1172 849 1156.50 892Q1141 935 1141 978Z"
         }
      }
   ]
}

var MicrosoftTranslatorLogoBlue = {
   name: "MicrosoftTranslatorLogoBlue",
   vendor: "UiFabric",
   unicode: 63571,
   value: "",
   charCode: "F853",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M737 1716L737 1716Q737 1793 742.50 1869.50Q748 1946 762 2022L762 2022L614 2027Q609 2005 606 1983.50Q603 1962 603 1939L603 1939L594 1939Q528 1999 446.50 2022Q365 2045 278 2045L278 2045Q218 2045 169 2027Q120 2009 85.50 1975.50Q51 1942 32 1893.50Q13 1845 13 1784L13 1784Q13 1696 43 1632.50Q73 1569 125 1527.50Q177 1486 247.50 1466.50Q318 1447 399 1447L399 1447Q462 1447 525 1459L525 1459Q538 1461 558.50 1467.50Q579 1474 591 1474L591 1474Q596 1474 597 1471.50Q598 1469 598 1464L598 1464Q598 1453 596 1443Q594 1433 594 1422L594 1422Q594 1359 575.50 1321Q557 1283 524 1262.50Q491 1242 445 1235.50Q399 1229 345 1229L345 1229Q315 1229 292.50 1233.50Q270 1238 249.50 1244.50Q229 1251 208 1258.50Q187 1266 159 1273L159 1273L135 1143Q170 1133 201 1124Q232 1115 262.50 1108.50Q293 1102 325.50 1098.50Q358 1095 395 1095L395 1095Q475 1095 539.50 1110Q604 1125 650 1160.50Q696 1196 720.50 1254.50Q745 1313 745 1400L745 1400Q745 1479 741 1558Q737 1637 737 1716ZM348 1916L348 1916Q415 1916 479 1899Q543 1882 596 1838L596 1838Q593 1773 592 1709.50Q591 1646 591 1581L591 1581Q556 1570 519 1564.50Q482 1559 445 1559L445 1559Q399 1559 349.50 1570Q300 1581 259.50 1605Q219 1629 193 1667Q167 1705 167 1760L167 1760Q167 1802 181 1831.50Q195 1861 219 1879.50Q243 1898 276 1907Q309 1916 348 1916ZM461 596L461 596L758 894L0 894L0 128L224 352Q299 300 386.50 275Q474 250 565 250L565 250Q608 250 653 255.50Q698 261 742 272.50Q786 284 827.50 301.50Q869 319 905 343L905 343Q843 348 778.50 368Q714 388 654.50 421Q595 454 544.50 498.50Q494 543 461 596Z"
         }
      }
   ]
}

var InternalInvestigation = {
   name: "InternalInvestigation",
   vendor: "UiFabric",
   unicode: 63572,
   value: "",
   charCode: "F854",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1408L512 1408Q512 1325 552.50 1253.50Q593 1182 663 1137L663 1137Q637 1107 622.50 1069.50Q608 1032 608 992L608 992Q608 946 625.50 905Q643 864 673.50 833.50Q704 803 744.50 785.50Q785 768 832 768L832 768Q878 768 919 785.50Q960 803 990.50 833.50Q1021 864 1038.50 905Q1056 946 1056 992L1056 992Q1056 1032 1041.50 1069.50Q1027 1107 1001 1137L1001 1137Q1072 1182 1112 1253Q1152 1324 1152 1408L1152 1408L1024 1408Q1024 1368 1009 1333Q994 1298 968 1272Q942 1246 907 1231Q872 1216 832 1216L832 1216Q792 1216 757 1231Q722 1246 696 1272.50Q670 1299 655 1334Q640 1369 640 1408L640 1408ZM832 896L832 896Q792 896 764 924Q736 952 736 992L736 992Q736 1032 764 1060Q792 1088 832 1088L832 1088Q873 1088 900.50 1060.50Q928 1033 928 992L928 992Q928 952 900 924Q872 896 832 896ZM384 384L384 1664L963 1664L835 1792L352 1792Q312 1792 284 1764Q256 1736 256 1696L256 1696L256 352Q256 312 284 284Q312 256 352 256L352 256L595 256L466 0L609 0L738 256L924 256L1052 0L1195 0L1067 256L1312 256Q1352 256 1380 284Q1408 312 1408 352L1408 352L1408 803Q1373 822 1340.50 844.50Q1308 867 1280 895L1280 895L1280 384L802 384Q808 397 823 424Q838 451 853.50 481Q869 511 880.50 537.50Q892 564 892 576L892 576Q892 603 873 622Q854 641 828 641L828 641Q810 641 794.50 631.50Q779 622 771 606L771 606L659 384L384 384ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547.50 1645.50Q1491 1627 1442 1592L1442 1592L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1957 915 1938L915 1938L1351 1502Q1317 1453 1298.50 1396.50Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var RepeatAll = {
   name: "RepeatAll",
   vendor: "UiFabric",
   unicode: 59630,
   value: "",
   charCode: "E8EE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1024L128 1024Q128 1093 143.50 1160.50Q159 1228 187.50 1290.50Q216 1353 257.50 1408Q299 1463 352 1508L352 1508L261 1599Q199 1544 151 1478.50Q103 1413 69 1339.50Q35 1266 17.50 1186.50Q0 1107 0 1024L0 1024Q0 918 27.50 820Q55 722 105 636.50Q155 551 225 481Q295 411 380.50 361Q466 311 564 283.50Q662 256 768 256L768 256L1414 256L1251 93L1341 3L1658 320L1341 637L1251 547L1414 384L768 384Q680 384 598 407Q516 430 445 471.50Q374 513 315.50 571.50Q257 630 215.50 701Q174 772 151 854Q128 936 128 1024ZM1697 539L1787 450Q1849 504 1897.50 569.50Q1946 635 1979.50 708.50Q2013 782 2030.50 862Q2048 942 2048 1024L2048 1024Q2048 1130 2020.50 1228Q1993 1326 1943 1411.50Q1893 1497 1823 1567Q1753 1637 1667.50 1687Q1582 1737 1484 1764.50Q1386 1792 1280 1792L1280 1792L634 1792L797 1955L707 2045L390 1728L707 1411L797 1501L634 1664L1280 1664Q1368 1664 1450 1641Q1532 1618 1603 1576.50Q1674 1535 1732.50 1476.50Q1791 1418 1832.50 1347Q1874 1276 1897 1194Q1920 1112 1920 1024L1920 1024Q1920 954 1905 886.50Q1890 819 1861.50 757Q1833 695 1791.50 639.50Q1750 584 1697 539L1697 539Z"
         }
      }
   ]
}

var RepeatOne = {
   name: "RepeatOne",
   vendor: "UiFabric",
   unicode: 59629,
   value: "",
   charCode: "E8ED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1024L128 1024Q128 1093 143.50 1160.50Q159 1228 187.50 1290.50Q216 1353 257.50 1408Q299 1463 352 1508L352 1508L261 1599Q199 1544 151 1478.50Q103 1413 69 1339.50Q35 1266 17.50 1186.50Q0 1107 0 1024L0 1024Q0 918 27.50 820Q55 722 105 636.50Q155 551 225 481Q295 411 380.50 361Q466 311 564 283.50Q662 256 768 256L768 256L1414 256L1251 93L1341 3L1658 320L1341 637L1251 547L1414 384L768 384Q680 384 598 407Q516 430 445 471.50Q374 513 315.50 571.50Q257 630 215.50 701Q174 772 151 854Q128 936 128 1024ZM1697 539L1787 450Q1849 504 1897.50 569.50Q1946 635 1979.50 708.50Q2013 782 2030.50 862Q2048 942 2048 1024L2048 1024Q2048 1130 2020.50 1228Q1993 1326 1943 1411.50Q1893 1497 1823 1567Q1753 1637 1667.50 1687Q1582 1737 1484 1764.50Q1386 1792 1280 1792L1280 1792L634 1792L797 1955L707 2045L390 1728L707 1411L797 1501L634 1664L1280 1664Q1368 1664 1450 1641Q1532 1618 1603 1576.50Q1674 1535 1732.50 1476.50Q1791 1418 1832.50 1347Q1874 1276 1897 1194Q1920 1112 1920 1024L1920 1024Q1920 954 1905 886.50Q1890 819 1861.50 757Q1833 695 1791.50 639.50Q1750 584 1697 539L1697 539ZM1152 640L1152 1408L1024 1408L1024 820Q995 841 963 854.50Q931 868 896 877L896 877L896 746Q952 727 1002.50 700.50Q1053 674 1101 640L1101 640L1152 640Z"
         }
      }
   ]
}

var AddReaction = {
   name: "AddReaction",
   vendor: "UiFabric",
   unicode: 63581,
   value: "",
   charCode: "F85D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 896L1792 896Q1765 896 1742 886Q1719 876 1701.50 858.50Q1684 841 1674 818Q1664 795 1664 768L1664 768Q1664 741 1674 718Q1684 695 1701.50 677.50Q1719 660 1742 650Q1765 640 1792 640L1792 640Q1819 640 1842 650Q1865 660 1882.50 677.50Q1900 695 1910 718Q1920 741 1920 768L1920 768Q1920 795 1910 818Q1900 841 1882.50 858.50Q1865 876 1842 886Q1819 896 1792 896ZM3200 1024L3200 1024Q3200 1166 3163.50 1296.50Q3127 1427 3060.50 1541Q2994 1655 2900.50 1748.50Q2807 1842 2693 1908.50Q2579 1975 2448 2011.50Q2317 2048 2176 2048L2176 2048Q2034 2048 1903.50 2011.50Q1773 1975 1659 1908.50Q1545 1842 1451.50 1748.50Q1358 1655 1291.50 1541Q1225 1427 1188.50 1296Q1152 1165 1152 1024L1152 1024Q1152 883 1188.50 752Q1225 621 1291.50 507Q1358 393 1451.50 299.50Q1545 206 1659 139.50Q1773 73 1904 36.50Q2035 0 2176 0L2176 0Q2317 0 2448 36.50Q2579 73 2693 139.50Q2807 206 2900.50 299.50Q2994 393 3060.50 507Q3127 621 3163.50 752Q3200 883 3200 1024ZM2176 1920L2176 1920Q2299 1920 2413.50 1888Q2528 1856 2627.50 1797.50Q2727 1739 2809 1657Q2891 1575 2949.50 1475.50Q3008 1376 3040 1261.50Q3072 1147 3072 1024L3072 1024Q3072 901 3040 786.50Q3008 672 2949.50 572.50Q2891 473 2809 391Q2727 309 2627.50 250.50Q2528 192 2413.50 160Q2299 128 2176 128L2176 128Q2052 128 1938 160Q1824 192 1724.50 250.50Q1625 309 1543 391Q1461 473 1402.50 572.50Q1344 672 1312 786.50Q1280 901 1280 1024L1280 1024Q1280 1148 1312 1262Q1344 1376 1402.50 1475.50Q1461 1575 1543 1657Q1625 1739 1724.50 1797.50Q1824 1856 1938.50 1888Q2053 1920 2176 1920ZM2560 896L2560 896Q2533 896 2510 886Q2487 876 2469.50 858.50Q2452 841 2442 818Q2432 795 2432 768L2432 768Q2432 741 2442 718Q2452 695 2469.50 677.50Q2487 660 2510 650Q2533 640 2560 640L2560 640Q2587 640 2610 650Q2633 660 2650.50 677.50Q2668 695 2678 718Q2688 741 2688 768L2688 768Q2688 795 2678 818Q2668 841 2650.50 858.50Q2633 876 2610 886Q2587 896 2560 896ZM2176 1536L2176 1536Q2249 1536 2317.50 1516Q2386 1496 2445 1459Q2504 1422 2551.50 1369Q2599 1316 2632 1251L2632 1251L2747 1309Q2706 1390 2646 1456Q2586 1522 2512 1568Q2438 1614 2352.50 1639Q2267 1664 2176 1664L2176 1664Q2084 1664 1999 1639Q1914 1614 1840 1568Q1766 1522 1706 1456Q1646 1390 1605 1309L1605 1309L1720 1251Q1753 1316 1800.50 1369Q1848 1422 1907 1459Q1966 1496 2034 1516Q2102 1536 2176 1536ZM384 512L512 512L512 896L896 896L896 1024L512 1024L512 1408L384 1408L384 1024L0 1024L0 896L384 896L384 512Z"
         }
      }
   ]
}

var ContactHeart = {
   name: "ContactHeart",
   vendor: "UiFabric",
   unicode: 63586,
   value: "",
   charCode: "F862",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1484L2048 1484Q2048 1538 2028 1586.50Q2008 1635 1970 1673L1970 1673L1600 2042L1230 1673Q1192 1635 1172 1586.50Q1152 1538 1152 1484L1152 1484Q1152 1429 1173 1380Q1194 1331 1230 1294.50Q1266 1258 1314.50 1237Q1363 1216 1419 1216L1419 1216Q1469 1216 1516.50 1233.50Q1564 1251 1600 1286L1600 1286Q1638 1251 1684 1233.50Q1730 1216 1781 1216L1781 1216Q1837 1216 1885.50 1237Q1934 1258 1970 1294.50Q2006 1331 2027 1380Q2048 1429 2048 1484ZM1920 1484L1920 1484Q1920 1455 1909 1429.50Q1898 1404 1879 1385Q1860 1366 1834.50 1355Q1809 1344 1780 1344L1780 1344Q1723 1344 1682 1385L1682 1385L1600 1467L1518 1385Q1498 1365 1472.50 1354.50Q1447 1344 1420 1344L1420 1344Q1391 1344 1365.50 1355Q1340 1366 1321 1385Q1302 1404 1291 1429.50Q1280 1455 1280 1484L1280 1484Q1280 1541 1321 1582L1321 1582L1600 1861L1879 1582Q1920 1541 1920 1484ZM1152 1152L1152 1152Q1065 1087 971 1055.50Q877 1024 768 1024L768 1024Q634 1024 517 1073.50Q400 1123 313.50 1209.50Q227 1296 177.50 1413Q128 1530 128 1664L128 1664L0 1664Q0 1543 35 1431.50Q70 1320 135 1226Q200 1132 291.50 1059.50Q383 987 497 945L497 945Q442 911 397.50 863Q353 815 321.50 758.50Q290 702 273 639.50Q256 577 256 512L256 512Q256 406 296.50 313Q337 220 406.50 150.50Q476 81 569 40.50Q662 0 768 0L768 0Q874 0 967 40.50Q1060 81 1129.50 150.50Q1199 220 1239.50 313Q1280 406 1280 512L1280 512Q1280 577 1263 639.50Q1246 702 1214.50 758.50Q1183 815 1138.50 863Q1094 911 1039 945L1039 945Q1105 968 1160.50 1003.50Q1216 1039 1269 1085L1269 1085Q1236 1096 1207.50 1113Q1179 1130 1152 1152ZM1152 512L1152 512Q1152 433 1121.50 363.50Q1091 294 1038.50 241.50Q986 189 916.50 158.50Q847 128 768 128L768 128Q689 128 619.50 158.50Q550 189 497.50 241.50Q445 294 414.50 363.50Q384 433 384 512L384 512Q384 591 414.50 660.50Q445 730 497.50 782.50Q550 835 619.50 865.50Q689 896 768 896L768 896Q847 896 916.50 865.50Q986 835 1038.50 782.50Q1091 730 1121.50 660.50Q1152 591 1152 512Z"
         }
      }
   ]
}

var VisuallyImpaired = {
   name: "VisuallyImpaired",
   vendor: "UiFabric",
   unicode: 63590,
   value: "",
   charCode: "F866",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M842 1519L176 854Q203 830 232 808Q261 786 290 765L290 765L1059 1534Q1050 1534 1041.50 1535Q1033 1536 1024 1536L1024 1536Q978 1536 932.50 1531.50Q887 1527 842 1519L842 1519ZM2048 1024L2048 1024Q1920 1168 1763 1281.50Q1606 1395 1424 1461L1424 1461L1773 1811L1683 1901L1285 1503L1222 1516L400 694L448 666L19 237L109 147L570 608Q678 562 792 537Q906 512 1024 512L1024 512Q1174 512 1316 551Q1458 590 1588.50 658.50Q1719 727 1834.50 821Q1950 915 2048 1024ZM1024 640L1024 640Q947 640 876.50 669Q806 698 752 752L752 752L933 933Q951 915 974.50 905.50Q998 896 1024 896L1024 896Q1051 896 1074.50 906Q1098 916 1115 933Q1132 950 1142 973.50Q1152 997 1152 1024L1152 1024Q1152 1050 1142.50 1073.50Q1133 1097 1115 1115L1115 1115L1296 1296Q1350 1242 1379 1171.50Q1408 1101 1408 1024L1408 1024Q1408 944 1378 874Q1348 804 1296 752Q1244 700 1174 670Q1104 640 1024 640ZM1443 1316L1443 1316Q1563 1263 1670 1189Q1777 1115 1871 1024L1871 1024Q1777 933 1670 859Q1563 785 1443 732L1443 732Q1488 796 1511 871Q1534 946 1534 1024L1534 1024Q1534 1102 1511 1177Q1488 1252 1443 1316ZM0 1024L0 1024Q39 981 81 940L81 940L592 1451Q420 1382 271.50 1272Q123 1162 0 1024Z"
         }
      }
   ]
}

var EventToDoLogo = {
   name: "EventToDoLogo",
   vendor: "UiFabric",
   unicode: 63593,
   value: "",
   charCode: "F869",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 640L128 640L128 1408L384 1408L384 1536L0 1536L0 128L256 128L256 0L384 0L384 128L1152 128L1152 0L1280 0L1280 128L1536 128L1536 768L1408 768L1408 640ZM256 384L256 256L128 256L128 512L1408 512L1408 256L1280 256L1280 384L1152 384L1152 256L384 256L384 384L256 384ZM2048 1084L2048 1084Q2048 1104 2039.50 1123.50Q2031 1143 2017 1157L2017 1157Q1809 1365 1605 1571Q1401 1777 1192 1983L1192 1983Q1160 2013 1117 2013L1117 2013Q1074 2013 1044 1983L1044 1983L633 1573Q618 1559 610 1539.50Q602 1520 602 1499L602 1499Q602 1456 633 1425L633 1425L810 1248Q841 1217 884 1217L884 1217Q926 1217 957 1248L957 1248L1117 1408L1693 833Q1723 803 1766 803L1766 803Q1786 803 1806.50 811Q1827 819 1841 833L1841 833L2017 1010Q2031 1024 2039.50 1043.50Q2048 1063 2048 1084ZM741 1499L885 1642L1028 1499L884 1355L741 1499ZM1910 1083L1910 1083L1766 939Q1567 1139 1370.50 1336.50Q1174 1534 974 1733L974 1733Q1010 1769 1045.50 1805Q1081 1841 1117 1877L1117 1877Q1317 1678 1514 1480.50Q1711 1283 1910 1083Z"
         }
      }
   ]
}

var Variable2 = {
   name: "Variable2",
   vendor: "UiFabric",
   unicode: 63597,
   value: "",
   charCode: "F86D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M139 960L139 960Q139 1183 198 1390Q257 1597 363 1792L363 1792L266 1792Q204 1701 155 1600.50Q106 1500 71.50 1394.50Q37 1289 18.50 1179Q0 1069 0 959L0 959Q0 729 71 524Q142 319 266 128L266 128L363 128Q308 236 266.50 333Q225 430 196.50 528.50Q168 627 153.50 732Q139 837 139 960ZM1624 482L1624 482Q1624 530 1598.50 554Q1573 578 1526 578L1526 578Q1509 578 1492 573Q1475 568 1458.50 562Q1442 556 1425.50 551Q1409 546 1392 546L1392 546Q1371 546 1347 562Q1323 578 1297.50 604Q1272 630 1247.50 662Q1223 694 1201.50 726Q1180 758 1163.50 786Q1147 814 1138 831L1138 831L1239 1257Q1242 1270 1247.50 1292.50Q1253 1315 1261.50 1337.50Q1270 1360 1282.50 1376.50Q1295 1393 1312 1393L1312 1393Q1335 1393 1362.50 1373Q1390 1353 1415 1324.50Q1440 1296 1460 1266.50Q1480 1237 1489 1217L1489 1217L1532 1238Q1520 1261 1499.50 1292Q1479 1323 1454 1356Q1429 1389 1399.50 1421Q1370 1453 1339 1478.50Q1308 1504 1277.50 1520Q1247 1536 1219 1536L1219 1536Q1180 1536 1153 1513Q1126 1490 1108 1458L1108 1458Q1100 1444 1090 1413Q1080 1382 1069.50 1342Q1059 1302 1048 1257Q1037 1212 1028 1170.50Q1019 1129 1011.50 1094.50Q1004 1060 1001 1041L1001 1041Q975 1089 938.50 1149.50Q902 1210 860.50 1271Q819 1332 775 1386Q731 1440 690 1474L690 1474Q658 1500 622 1518Q586 1536 544 1536L544 1536Q520 1536 498.50 1528.50Q477 1521 460.50 1506.50Q444 1492 434 1472Q424 1452 424 1427L424 1427Q424 1385 450 1358Q476 1331 518 1331L518 1331Q540 1331 559 1342Q578 1353 594.50 1365.50Q611 1378 625.50 1389Q640 1400 652 1400L652 1400Q670 1400 699.50 1372Q729 1344 762.50 1300Q796 1256 831.50 1203Q867 1150 897 1100Q927 1050 949.50 1010Q972 970 981 951L981 951Q971 913 961 876Q951 839 942 801L942 801Q934 769 925 728.50Q916 688 902.50 647.50Q889 607 870 572.50Q851 538 823 518L823 518Q792 496 758.50 490Q725 484 688 484L688 484Q655 484 622 487L622 487L622 443L954 384Q994 427 1019 469Q1044 511 1061 554.50Q1078 598 1090.50 645.50Q1103 693 1118 747L1118 747Q1150 699 1182.50 649Q1215 599 1251.50 553.50Q1288 508 1331.50 469.50Q1375 431 1429 404L1429 404Q1447 395 1467 389.50Q1487 384 1507 384L1507 384Q1529 384 1550.50 390Q1572 396 1588 408Q1604 420 1614 438.50Q1624 457 1624 482ZM2048 959L2048 959Q2048 1069 2029.50 1179Q2011 1289 1976.50 1394.50Q1942 1500 1893 1600.50Q1844 1701 1782 1792L1782 1792L1685 1792Q1791 1597 1850 1390Q1909 1183 1909 960L1909 960Q1909 814 1883.50 669.50Q1858 525 1806 388L1806 388Q1780 321 1748.50 256.50Q1717 192 1685 128L1685 128L1782 128Q1906 319 1977 524Q2048 729 2048 959Z"
         }
      }
   ]
}

var ModelingView = {
   name: "ModelingView",
   vendor: "UiFabric",
   unicode: 63601,
   value: "",
   charCode: "F871",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 0L2048 896L1152 896L1152 384L512 384L512 640L896 640L896 1536L512 1536L512 1792L1152 1792L1152 1152L2048 1152L2048 2048L1152 2048L1152 1920L384 1920L384 1536L0 1536L0 640L384 640L384 256L1152 256L1152 0L2048 0ZM1920 128L1280 128L1280 256L1920 256L1920 128ZM1920 384L1280 384L1280 768L1920 768L1920 384ZM1920 1280L1280 1280L1280 1408L1920 1408L1920 1280ZM1920 1536L1280 1536L1280 1920L1920 1920L1920 1536ZM128 1408L768 1408L768 1024L128 1024L128 1408ZM768 896L768 768L128 768L128 896L768 896Z"
         }
      }
   ]
}

var DisconnectVirtualMachine = {
   name: "DisconnectVirtualMachine",
   vendor: "UiFabric",
   unicode: 63603,
   value: "",
   charCode: "F873",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1187 1411L1277 1501L1050 1728L1277 1955L1187 2045L960 1818L733 2045L643 1955L870 1728L643 1501L733 1411L960 1638L1187 1411ZM128 1664L608 1664L672 1728L608 1792L128 1792L128 1664ZM1312 1792L1248 1728L1312 1664L1792 1664L1792 1792L1312 1792ZM128 1280L128 128L1792 128L1792 1280L1024 1280L1024 1376L960 1440L896 1376L896 1280L128 1280ZM256 1152L1664 1152L1664 256L256 256L256 1152Z"
         }
      }
   ]
}

var ReportLock = {
   name: "ReportLock",
   vendor: "UiFabric",
   unicode: 63605,
   value: "",
   charCode: "F875",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1280L1920 1408L2048 1408L2048 2048L1280 2048L1280 1408L1408 1408L1408 1280Q1408 1227 1428 1180.50Q1448 1134 1483 1099Q1518 1064 1564.50 1044Q1611 1024 1664 1024L1664 1024Q1717 1024 1763.50 1044Q1810 1064 1845 1099Q1880 1134 1900 1180.50Q1920 1227 1920 1280L1920 1280ZM1536 1280L1536 1280L1536 1408L1792 1408L1792 1280Q1792 1253 1782 1230Q1772 1207 1754.50 1189.50Q1737 1172 1714 1162Q1691 1152 1664 1152L1664 1152Q1637 1152 1614 1162Q1591 1172 1573.50 1189.50Q1556 1207 1546 1230Q1536 1253 1536 1280ZM1408 1920L1920 1920L1920 1536L1408 1536L1408 1920ZM896 1408L896 1792L640 1792L640 1408L896 1408ZM512 1152L512 1792L256 1792L256 1152L512 1152ZM0 2048L0 0L987 0L1536 549L1536 896L1408 896L1408 640L896 640L896 128L128 128L128 1920L1152 1920L1152 2048L0 2048ZM1317 512L1024 219L1024 512L1317 512ZM1024 896L1280 896L1280 1280L1152 1280L1152 1792L1024 1792L1024 896Z"
         }
      }
   ]
}

var Uneditable2 = {
   name: "Uneditable2",
   vendor: "UiFabric",
   unicode: 63606,
   value: "",
   charCode: "F876",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 1307L633 1890L0 2048L158 1415L742 832L19 109L109 19L2029 1939L1939 2029L1216 1307ZM258 1543L176 1872L505 1790Q495 1744 472.50 1703Q450 1662 418 1630Q386 1598 345 1575.50Q304 1553 258 1543L258 1543ZM620 1722L1126 1216L832 923L326 1428Q378 1445 424.50 1473Q471 1501 509 1539Q547 1577 575 1623.50Q603 1670 620 1722L620 1722ZM1950 573L1420 1103L1329 1013L1702 640L1408 347L1036 719L945 629L1475 98L1476 98Q1523 50 1584.50 25Q1646 0 1713 0L1713 0Q1782 0 1843 26.50Q1904 53 1949.50 98.50Q1995 144 2021.50 205Q2048 266 2048 336L2048 336Q2048 402 2023 463.50Q1998 525 1950 573L1950 573ZM1860 482L1859 482Q1888 453 1904 415Q1920 377 1920 336L1920 336Q1920 293 1903.50 255Q1887 217 1859 189Q1831 161 1793 144.50Q1755 128 1712 128L1712 128Q1674 128 1645.50 138.50Q1617 149 1592.50 167Q1568 185 1546 208Q1524 231 1499 256L1499 256L1792 549L1859 482L1860 482Z"
         }
      }
   ]
}

var Uneditable2Mirrored = {
   name: "Uneditable2Mirrored",
   vendor: "UiFabric",
   unicode: 63607,
   value: "",
   charCode: "F877",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1890 1415L2048 2048L1415 1890L832 1307L109 2029L19 1939L1939 19L2029 109L1307 832L1890 1415ZM1543 1790L1543 1790L1872 1872L1790 1543Q1743 1553 1702.50 1575.50Q1662 1598 1629.50 1630Q1597 1662 1575 1703Q1553 1744 1543 1790ZM1722 1428L1216 923L923 1216L1428 1722Q1444 1670 1472.50 1623.50Q1501 1577 1539 1539Q1577 1501 1623 1473Q1669 1445 1722 1428L1722 1428ZM0 336L0 336Q0 266 26.50 205Q53 144 98.50 98.50Q144 53 205 26.50Q266 0 335 0L335 0Q402 0 463.50 25Q525 50 573 98L573 98L1103 629L1013 719L640 347L347 640L719 1013L629 1103L98 573Q50 525 25 463.50Q0 402 0 336ZM128 336L128 336Q128 374 138.50 402.50Q149 431 167 455.50Q185 480 208 502Q231 524 256 549L256 549L549 256Q524 231 502 208Q480 185 455.50 167Q431 149 402 138.50Q373 128 335 128L335 128Q292 128 254.50 144.50Q217 161 189 189Q161 217 144.50 255Q128 293 128 336Z"
         }
      }
   ]
}

var Spelling = {
   name: "Spelling",
   vendor: "UiFabric",
   unicode: 63611,
   value: "",
   charCode: "F87B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M549 788L547 788Q518 839 475.50 867.50Q433 896 373 896L373 896Q333 896 299.50 884.50Q266 873 242 851Q218 829 205 796.50Q192 764 192 723L192 723Q192 678 205.50 644.50Q219 611 243.50 587.50Q268 564 302.50 549.50Q337 535 379 529L379 529L549 504Q549 474 543.50 446.50Q538 419 525 398.50Q512 378 489 365.50Q466 353 432 353L432 353Q379 353 332.50 372Q286 391 247 426L247 426L247 328Q263 316 287.50 306Q312 296 339.50 288.50Q367 281 393.50 276.50Q420 272 440 272L440 272Q494 272 532 287.50Q570 303 594 332Q618 361 629 402Q640 443 640 494L640 494L640 881L549 881L549 788ZM394 815L394 815Q431 815 459.50 800.50Q488 786 508 761.50Q528 737 538.50 705.50Q549 674 549 640L549 640L549 580L412 601Q384 606 360.50 612Q337 618 320.50 630.50Q304 643 294.50 663Q285 683 285 716L285 716Q285 764 317 789.50Q349 815 394 815ZM861 796L859 796L859 881L768 881L768 0L859 0L859 391L861 391Q894 332 948.50 302Q1003 272 1069 272L1069 272Q1132 272 1176 297.50Q1220 323 1248 364.50Q1276 406 1289 458.50Q1302 511 1302 566L1302 566Q1302 627 1287.50 686Q1273 745 1242 791.50Q1211 838 1161.50 867Q1112 896 1043 896L1043 896Q986 896 938 871Q890 846 861 796L861 796ZM859 555L859 555L859 638Q859 677 871.50 709.50Q884 742 907 765.50Q930 789 962 802Q994 815 1033 815L1033 815Q1084 815 1118 791.50Q1152 768 1172 732Q1192 696 1200.50 651.50Q1209 607 1209 565L1209 565Q1209 526 1200.50 488Q1192 450 1172.50 420Q1153 390 1122 371.50Q1091 353 1046 353L1046 353Q1001 353 966 368.50Q931 384 907 411Q883 438 871 475Q859 512 859 555ZM1699 353L1699 353Q1649 353 1611.50 373Q1574 393 1549.50 426Q1525 459 1513 502Q1501 545 1501 590L1501 590Q1501 635 1512.50 676Q1524 717 1547.50 748Q1571 779 1607.50 797Q1644 815 1694 815L1694 815Q1732 815 1767.50 800.50Q1803 786 1833 763L1833 763L1833 854Q1798 877 1759 886.50Q1720 896 1678 896L1678 896Q1613 896 1563 872.50Q1513 849 1478.50 808.50Q1444 768 1426 713.50Q1408 659 1408 598L1408 598Q1408 529 1427 469.50Q1446 410 1483 366Q1520 322 1575.50 297Q1631 272 1703 272L1703 272Q1737 272 1770.50 279Q1804 286 1834 302L1834 302L1834 399Q1804 377 1770 365Q1736 353 1699 353ZM557 1491L895 1829L1619 1107L1709 1197L895 2011L467 1581L557 1491Z"
         }
      }
   ]
}

var BarChartVerticalEdit = {
   name: "BarChartVerticalEdit",
   vendor: "UiFabric",
   unicode: 63645,
   value: "",
   charCode: "F89D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 384L1408 384L1408 1025L1280 1153L1280 256L1664 256L1664 787Q1625 809 1596.50 837.50Q1568 866 1536 898L1536 898L1536 384ZM256 512L640 512L640 1664L256 1664L256 512ZM384 1536L512 1536L512 640L384 640L384 1536ZM2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1771.50 910Q1807 896 1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094ZM1920 1094L1920 1094Q1920 1062 1900 1043Q1880 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836L1899 1145Q1920 1124 1920 1094ZM896 896L896 1536L897 1536Q884 1549 871.50 1561.50Q859 1574 845 1587L845 1587Q840 1607 835.50 1626Q831 1645 826 1664L826 1664L768 1664L768 768L1152 768L1152 1281L1025 1408L1024 1408L1024 896L896 896ZM0 128L128 128L128 1792L794 1792L762 1920L0 1920L0 128Z"
         }
      }
   ]
}

var GlobalNavButtonActive = {
   name: "GlobalNavButtonActive",
   vendor: "UiFabric",
   unicode: 63647,
   value: "",
   charCode: "F89F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 1024L1728 1024Q1662 1024 1603.50 999Q1545 974 1501.50 930.50Q1458 887 1433 828.50Q1408 770 1408 704L1408 704Q1408 638 1433 579.50Q1458 521 1501.50 477.50Q1545 434 1603.50 409Q1662 384 1728 384L1728 384Q1794 384 1852.50 409Q1911 434 1954.50 477.50Q1998 521 2023 579.50Q2048 638 2048 704L2048 704Q2048 770 2023 828.50Q1998 887 1954.50 930.50Q1911 974 1852.50 999Q1794 1024 1728 1024ZM0 512L1254 512Q1242 543 1234.50 575Q1227 607 1222 640L1222 640L0 640L0 512ZM0 1024L1332 1024Q1397 1104 1485 1152L1485 1152L0 1152L0 1024ZM2048 1664L0 1664L0 1536L2048 1536L2048 1664Z"
         }
      }
   ]
}

var PollResults = {
   name: "PollResults",
   vendor: "UiFabric",
   unicode: 63648,
   value: "",
   charCode: "F8A0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 640L2048 640L2048 1280L1280 1280L1280 1792L128 1792L128 1920L0 1920L0 0L128 0L128 128L1536 128L1536 640ZM1408 256L128 256L128 640L1408 640L1408 256ZM128 1664L1152 1664L1152 1280L128 1280L128 1664ZM128 1152L1920 1152L1920 768L128 768L128 1152Z"
         }
      }
   ]
}

var Rerun = {
   name: "Rerun",
   vendor: "UiFabric",
   unicode: 63649,
   value: "",
   charCode: "F8A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 640L1152 640L1152 512L1573 512Q1519 458 1465.50 404.50Q1412 351 1358 297L1358 297Q1277 217 1175.50 174.50Q1074 132 960 132L960 132Q881 132 808.50 153Q736 174 672.50 211.50Q609 249 557 302Q505 355 467.50 419Q430 483 409.50 556Q389 629 389 707L389 707Q389 819 431.50 921Q474 1023 553 1102L553 1102L1152 1701L1152 1883L462 1193Q365 1096 312.50 969Q260 842 260 704L260 704Q260 608 285.50 518.50Q311 429 357 351.50Q403 274 467.50 210Q532 146 610 100.50Q688 55 777.50 30Q867 5 963 5L963 5Q1088 5 1182.50 39Q1277 73 1356.50 130.50Q1436 188 1509 263.50Q1582 339 1664 421L1664 421L1664 0L1792 0L1792 640ZM1280 2048L1280 1152L2048 1600L1280 2048ZM1794 1600L1408 1375L1408 1825L1794 1600Z"
         }
      }
   ]
}

var QandA = {
   name: "QandA",
   vendor: "UiFabric",
   unicode: 63650,
   value: "",
   charCode: "F8A2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1536L1792 384L1920 384L1920 1664L1664 1664L1664 2048L1280 1664L768 1664L896 1536L1333 1536L1536 1739L1536 1536L1792 1536ZM1664 1408L768 1408L384 1792L384 1408L0 1408L0 0L1664 0L1664 1408ZM128 128L128 1280L512 1280L512 1483L715 1280L1536 1280L1536 128L128 128ZM896 1152L768 1152L768 1024L896 1024L896 1152ZM832 384L832 384Q805 384 782 394Q759 404 741.50 421.50Q724 439 714 462Q704 485 704 512L704 512L576 512Q576 459 596 412.50Q616 366 651 331Q686 296 732.50 276Q779 256 832 256L832 256Q885 256 931.50 276Q978 296 1013 331Q1048 366 1068 412.50Q1088 459 1088 512L1088 512Q1088 558 1074 593Q1060 628 1037 658Q1014 688 985 715.50Q956 743 926 773L926 773Q906 793 900.50 815Q895 837 895 862L895 862Q895 870 895.50 878.50Q896 887 896 896L896 896L768 896L768 848Q768 802 782 767Q796 732 817.50 704Q839 676 864 653.50Q889 631 910.50 609Q932 587 946 564Q960 541 960 512L960 512Q960 485 950 462Q940 439 922.50 421.50Q905 404 882 394Q859 384 832 384Z"
         }
      }
   ]
}

var QandAMirror = {
   name: "QandAMirror",
   vendor: "UiFabric",
   unicode: 63651,
   value: "",
   charCode: "F8A3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1739L587 1536L1024 1536L1152 1664L640 1664L256 2048L256 1664L0 1664L0 384L128 384L128 1536L384 1536L384 1739ZM256 1408L256 0L1920 0L1920 1408L1536 1408L1536 1792L1152 1408L256 1408ZM1408 1280L1792 1280L1792 128L384 128L384 1280L1205 1280L1408 1483L1408 1280ZM1152 1152L1024 1152L1024 1024L1152 1024L1152 1152ZM832 512L832 512Q832 459 852 412.50Q872 366 907 331Q942 296 988.50 276Q1035 256 1088 256L1088 256Q1141 256 1187.50 276Q1234 296 1269 331Q1304 366 1324 412.50Q1344 459 1344 512L1344 512L1216 512Q1216 485 1206 462Q1196 439 1178.50 421.50Q1161 404 1138 394Q1115 384 1088 384L1088 384Q1061 384 1038 394Q1015 404 997.50 421.50Q980 439 970 462Q960 485 960 512L960 512Q960 541 974 564Q988 587 1009.50 609Q1031 631 1056 653.50Q1081 676 1102.50 704Q1124 732 1138 767Q1152 802 1152 848L1152 848L1152 896L1024 896L1024 848Q1024 819 1010 795.50Q996 772 974.50 750.50Q953 729 928 706.50Q903 684 881.50 656Q860 628 846 593.50Q832 559 832 512Z"
         }
      }
   ]
}

var BookAnswers = {
   name: "BookAnswers",
   vendor: "UiFabric",
   unicode: 63652,
   value: "",
   charCode: "F8A4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 0L384 0L1792 0L1792 2048L384 2048Q331 2048 284.50 2028Q238 2008 203 1973Q168 1938 148 1891.50Q128 1845 128 1792L128 1792L128 256Q128 203 148 156.50Q168 110 203 75Q238 40 284.50 20Q331 0 384 0ZM384 1920L1664 1920L1664 1664L384 1664Q357 1664 334 1674Q311 1684 293.50 1701.50Q276 1719 266 1742Q256 1765 256 1792L256 1792Q256 1819 266 1842Q276 1865 293.50 1882.50Q311 1900 334 1910Q357 1920 384 1920L384 1920ZM384 1536L1664 1536L1664 128L384 128Q357 128 334 138Q311 148 293.50 165.50Q276 183 266 206Q256 229 256 256L256 256L256 1570Q316 1536 384 1536L384 1536ZM1024 1280L896 1280L896 640L1024 640L1024 1280ZM1024 512L896 512L896 384L1024 384L1024 512Z"
         }
      }
   ]
}

var AlertSettings = {
   name: "AlertSettings",
   vendor: "UiFabric",
   unicode: 63670,
   value: "",
   charCode: "F8B6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 512L1024 512L1024 1152L896 1152L896 512ZM960 1792L960 1792Q977 1792 992.50 1790.50Q1008 1789 1025 1788L1025 1788Q1046 1853 1081 1912L1081 1912Q1051 1916 1020.50 1918Q990 1920 960 1920L960 1920Q827 1920 704 1886Q581 1852 474.50 1789.50Q368 1727 280.50 1639.50Q193 1552 130.50 1445.50Q68 1339 34 1216Q0 1093 0 960L0 960Q0 827 34 704Q68 581 130.50 474.50Q193 368 280.50 280.50Q368 193 474.50 130.50Q581 68 704 34Q827 0 960 0L960 0Q1093 0 1216 34Q1339 68 1445.50 130.50Q1552 193 1639.50 280.50Q1727 368 1789.50 474.50Q1852 581 1886 704Q1920 827 1920 960L1920 960Q1920 990 1918 1020.50Q1916 1051 1912 1081L1912 1081Q1883 1063 1851.50 1049.50Q1820 1036 1788 1025L1788 1025Q1789 1008 1790.50 992.50Q1792 977 1792 960L1792 960Q1792 846 1762 739.50Q1732 633 1678 540.50Q1624 448 1548 372Q1472 296 1379.50 242Q1287 188 1180.50 158Q1074 128 960 128L960 128Q845 128 739 158Q633 188 540.50 242Q448 296 372 372Q296 448 242 540.50Q188 633 158 739.50Q128 846 128 960L128 960Q128 1075 158 1181Q188 1287 242 1379.50Q296 1472 372 1548Q448 1624 540.50 1678Q633 1732 739 1762Q845 1792 960 1792ZM1024 1408L896 1408L896 1280L1024 1280L1024 1408ZM1920 1600L1920 1600Q1920 1631 1914 1661L1914 1661L2038 1712L1989 1831L1865 1779Q1830 1830 1779 1865L1779 1865L1831 1989L1712 2038L1661 1914Q1631 1920 1600 1920L1600 1920Q1569 1920 1539 1914L1539 1914L1488 2038L1369 1989L1421 1865Q1370 1830 1335 1779L1335 1779L1211 1831L1162 1712L1286 1661Q1280 1631 1280 1600L1280 1600Q1280 1569 1286 1539L1286 1539L1162 1488L1211 1369L1335 1421Q1370 1370 1421 1335L1421 1335L1369 1211L1488 1162L1539 1286Q1569 1280 1600 1280L1600 1280Q1631 1280 1661 1286L1661 1286L1712 1162L1831 1211L1779 1335Q1830 1370 1865 1421L1865 1421L1989 1369L2038 1488L1914 1539Q1920 1569 1920 1600ZM1792 1600L1792 1600Q1792 1560 1777 1525Q1762 1490 1736 1464Q1710 1438 1675 1423Q1640 1408 1600 1408L1600 1408Q1560 1408 1525 1423Q1490 1438 1464 1464Q1438 1490 1423 1525Q1408 1560 1408 1600L1408 1600Q1408 1640 1423 1675Q1438 1710 1464 1736Q1490 1762 1525 1777Q1560 1792 1600 1792L1600 1792Q1640 1792 1675 1777Q1710 1762 1736 1736Q1762 1710 1777 1675Q1792 1640 1792 1600Z"
         }
      }
   ]
}

var TrimEnd = {
   name: "TrimEnd",
   vendor: "UiFabric",
   unicode: 63676,
   value: "",
   charCode: "F8BC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 128L384 0L1792 0L1792 2048L384 2048L384 1920L1152 1920L1152 128L384 128ZM1280 1920L1664 1920L1664 128L1280 128L1280 1920Z"
         }
      }
   ]
}

var TrimStart = {
   name: "TrimStart",
   vendor: "UiFabric",
   unicode: 63675,
   value: "",
   charCode: "F8BB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 0L1664 128L896 128L896 1920L1664 1920L1664 2048L256 2048L256 0L1664 0ZM384 1920L768 1920L768 128L384 128L384 1920Z"
         }
      }
   ]
}

var TableComputed = {
   name: "TableComputed",
   vendor: "UiFabric",
   unicode: 63733,
   value: "",
   charCode: "F8F5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1101L1062 1280L640 1280L640 1536L933 1536L868 1664L0 1664L0 128L1664 128L1664 640L1536 640L1536 512L1152 512L1152 768L1320 768L1255 896L1152 896L1152 1101ZM640 1152L1024 1152L1024 896L640 896L640 1152ZM640 768L1024 768L1024 512L640 512L640 768ZM128 1536L512 1536L512 1280L128 1280L128 1536ZM128 1152L512 1152L512 896L128 896L128 1152ZM128 768L512 768L512 512L128 512L128 768ZM128 256L128 384L1536 384L1536 256L128 256ZM2017 768L1779 1152L2048 1152L1376 2048L1112 2048L1368 1536L1112 1536L1499 768L2017 768ZM1576 1408L1335 1890L1792 1280L1549 1280L1787 896L1578 896L1320 1408L1576 1408Z"
         }
      }
   ]
}

var PageLink = {
   name: "PageLink",
   vendor: "UiFabric",
   unicode: 58114,
   value: "",
   charCode: "E302",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M901 1472L901 1472Q901 1537 938 1585.50Q975 1634 1035 1655L1035 1655Q1032 1673 1030 1691Q1028 1709 1028 1728L1028 1728Q1028 1742 1029.50 1757Q1031 1772 1033 1786L1033 1786Q976 1775 928.50 1746.50Q881 1718 846.50 1676.50Q812 1635 793 1582.50Q774 1530 774 1472L774 1472Q774 1406 799 1348Q824 1290 866.50 1246.50Q909 1203 967 1177.50Q1025 1152 1091 1152L1091 1152L1345 1152Q1410 1152 1468 1177.50Q1526 1203 1569 1247Q1612 1291 1637 1349Q1662 1407 1662 1472L1662 1472Q1662 1528 1643 1580Q1624 1632 1590.50 1674Q1557 1716 1510 1745.50Q1463 1775 1408 1785L1408 1785L1408 1652Q1465 1630 1500 1582.50Q1535 1535 1535 1472L1535 1472Q1535 1433 1520 1398Q1505 1363 1479.50 1336.50Q1454 1310 1419.50 1295Q1385 1280 1345 1280L1345 1280L1091 1280Q1051 1280 1016 1295Q981 1310 955.50 1336Q930 1362 915.50 1397Q901 1432 901 1472ZM2048 1725L2048 1725Q2048 1791 2023 1850Q1998 1909 1954.50 1953Q1911 1997 1853 2022.50Q1795 2048 1728 2048L1728 2048L1472 2048Q1405 2048 1347 2022.50Q1289 1997 1245.50 1953Q1202 1909 1177 1850Q1152 1791 1152 1725L1152 1725Q1152 1669 1171 1616.50Q1190 1564 1224 1521.50Q1258 1479 1305 1449Q1352 1419 1408 1409L1408 1409L1408 1542Q1379 1552 1355.50 1570.50Q1332 1589 1315.50 1613.50Q1299 1638 1289.50 1666.50Q1280 1695 1280 1725L1280 1725Q1280 1765 1295 1800.50Q1310 1836 1336 1862.50Q1362 1889 1397 1904.50Q1432 1920 1472 1920L1472 1920L1728 1920Q1768 1920 1803 1904.50Q1838 1889 1864 1862Q1890 1835 1905 1799.50Q1920 1764 1920 1725L1920 1725Q1920 1694 1910 1665Q1900 1636 1882.50 1611Q1865 1586 1840 1567.50Q1815 1549 1785 1540L1785 1540Q1788 1522 1790 1503.50Q1792 1485 1792 1467L1792 1467Q1792 1452 1790 1437.50Q1788 1423 1786 1409L1786 1409Q1843 1420 1891 1449Q1939 1478 1974 1520Q2009 1562 2028.50 1614.50Q2048 1667 2048 1725ZM1024 128L128 128L128 1920L1024 1920L1024 2048L0 2048L0 0L1115 0L1664 549L1664 1024L1536 1024L1536 640L1024 640L1024 128ZM1445 512L1152 219L1152 512L1445 512Z"
         }
      }
   ]
}

var CommentSolid = {
   name: "CommentSolid",
   vendor: "UiFabric",
   unicode: 58126,
   value: "",
   charCode: "E30E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536ZM896 896L896 640L640 640L640 896L768 896L768 1024Q795 1024 818 1014Q841 1004 858.50 986.50Q876 969 886 946Q896 923 896 896L896 896ZM1408 896L1408 640L1152 640L1152 896L1280 896L1280 1024Q1307 1024 1330 1014Q1353 1004 1370.50 986.50Q1388 969 1398 946Q1408 923 1408 896L1408 896Z"
         }
      }
   ]
}

var ChangeEntitlements = {
   name: "ChangeEntitlements",
   vendor: "UiFabric",
   unicode: 58128,
   value: "",
   charCode: "E310",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L128 1920L1027 1920L1155 2048L0 2048L0 0L1115 0L1664 549L1664 768L1536 768L1536 640L1024 640L1024 128L128 128ZM1445 512L1152 219L1152 512L1445 512ZM256 639L256 512L895 512L895 639L256 639ZM256 768L1407 768L1407 895L256 895L256 768ZM256 1151L256 1024L1023 1024L1023 1151L256 1151ZM256 1280L1024 1280L1024 1407L256 1407L256 1280ZM896 1663L256 1663L256 1536L1024 1536L896 1663ZM1379 1411L1469 1501L1306 1663L1920 1663L1920 1792L1306 1792L1469 1955L1379 2045L1061 1728L1379 1411ZM1152 1152L1766 1152L1603 989L1693 899L2011 1216L1693 1533L1603 1443L1766 1280L1152 1280L1152 1152Z"
         }
      }
   ]
}

var Installation = {
   name: "Installation",
   vendor: "UiFabric",
   unicode: 58129,
   value: "",
   charCode: "E311",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1920L1664 1664L1792 1664L1792 2048L128 2048L128 1664L256 1664L256 1920L1664 1920ZM1427 1043L1517 1133L960 1690L403 1133L493 1043L896 1445L896 128L1024 128L1024 1445L1427 1043Z"
         }
      }
   ]
}

var WebAppBuilderFragment = {
   name: "WebAppBuilderFragment",
   vendor: "UiFabric",
   unicode: 58132,
   value: "",
   charCode: "E314",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 448L768 896L256 896L0 448L256 0L768 0L1024 448ZM694 128L330 128L147 448L330 768L694 768L877 448L694 128ZM0 1472L256 1024L768 1024L1024 1472L768 1920L256 1920L0 1472ZM330 1792L694 1792L877 1472L694 1152L330 1152L147 1472L330 1792ZM1152 512L1664 512L1920 960L1664 1408L1152 1408L896 960L1152 512ZM1226 1280L1590 1280L1773 960L1590 640L1226 640L1043 960L1226 1280Z"
         }
      }
   ]
}

var WebAppBuilderModule = {
   name: "WebAppBuilderModule",
   vendor: "UiFabric",
   unicode: 58131,
   value: "",
   charCode: "E313",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 128L1536 128L2048 1024L1536 1920L512 1920L0 1024L512 128ZM586 1792L1462 1792L1901 1024L1462 256L586 256L147 1024L586 1792Z"
         }
      }
   ]
}

var WebAppBuilderSlot = {
   name: "WebAppBuilderSlot",
   vendor: "UiFabric",
   unicode: 58133,
   value: "",
   charCode: "E315",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1664L0 1664L0 1408L128 1408L128 1664L0 1664ZM256 0L256 0L256 128L0 128L0 0L256 0ZM0 2048L0 2048L0 1792L128 1792L128 2048L0 2048ZM1792 0L1792 0L1792 128L1536 128L1536 0L1792 0ZM0 1280L0 1280L0 1024L128 1024L128 1280L0 1280ZM640 384L640 384L1408 384L1792 1024L1408 1664L640 1664L256 1024L640 384ZM1336 1536L1336 1536L1643 1024L1336 512L712 512L405 1024L712 1536L1336 1536ZM640 0L640 0L640 128L384 128L384 0L640 0ZM0 896L0 896L0 640L128 640L128 896L0 896ZM1024 0L1024 0L1024 128L768 128L768 0L1024 0ZM1408 0L1408 0L1408 128L1152 128L1152 0L1408 0ZM1920 1792L1920 1792L1920 1536L2048 1536L2048 1792L1920 1792ZM1920 1024L1920 1024L1920 768L2048 768L2048 1024L1920 1024ZM1920 1408L1920 1408L1920 1152L2048 1152L2048 1408L1920 1408ZM1920 640L1920 640L1920 384L2048 384L2048 640L1920 640ZM1920 0L1920 0L2048 0L2048 256L1920 256L1920 0ZM0 512L0 512L0 256L128 256L128 512L0 512ZM640 2048L640 2048L640 1920L896 1920L896 2048L640 2048ZM256 2048L256 2048L256 1920L512 1920L512 2048L256 2048ZM1408 2048L1408 2048L1408 1920L1664 1920L1664 2048L1408 2048ZM1024 2048L1024 2048L1024 1920L1280 1920L1280 2048L1024 2048ZM1792 2048L1792 2048L1792 1920L2048 1920L2048 2048L1792 2048Z"
         }
      }
   ]
}

var BullseyeTargetEdit = {
   name: "BullseyeTargetEdit",
   vendor: "UiFabric",
   unicode: 58137,
   value: "",
   charCode: "E319",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1735 925 1772.50 912Q1810 899 1848 899L1848 899Q1890 899 1926.50 913.50Q1963 928 1990 954Q2017 980 2032.50 1015.50Q2048 1051 2048 1094ZM1920 1094L1920 1094Q1920 1061 1900 1043Q1880 1025 1848 1025L1848 1025Q1834 1025 1821 1029Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836L1899 1145Q1920 1124 1920 1094ZM1408 1026L1238 1195Q1261 1157 1270.50 1112.50Q1280 1068 1280 1024L1280 1024Q1280 945 1250 875Q1220 805 1167.50 752.50Q1115 700 1045 670Q975 640 896 640L896 640Q816 640 746 670Q676 700 624 752Q572 804 542 874Q512 944 512 1024L512 1024Q512 1104 542 1174Q572 1244 624 1296Q676 1348 746 1378Q816 1408 896 1408L896 1408Q941 1408 984 1398Q1027 1388 1067 1366L1067 1366L897 1536L896 1536Q789 1536 696 1496Q603 1456 533.50 1386.50Q464 1317 424 1224Q384 1131 384 1024L384 1024Q384 918 424 824.50Q464 731 533.50 661.50Q603 592 696.50 552Q790 512 896 512L896 512Q1003 512 1096.50 552.50Q1190 593 1259 662.50Q1328 732 1368 826Q1408 920 1408 1026L1408 1026ZM796 1785L796 1785L765 1910Q655 1895 556 1854Q457 1813 372 1751.50Q287 1690 218 1609.50Q149 1529 101 1435.50Q53 1342 26.50 1238Q0 1134 0 1024L0 1024Q0 901 32 786.50Q64 672 122.50 572.50Q181 473 263 391Q345 309 444.50 250.50Q544 192 658.50 160Q773 128 896 128L896 128Q1044 128 1178.50 173Q1313 218 1424.50 300.50Q1536 383 1619.50 498Q1703 613 1749 753L1749 753Q1717 763 1688.50 775.50Q1660 788 1633 809L1633 809Q1597 686 1525 584Q1453 482 1356 409.50Q1259 337 1141.50 296.50Q1024 256 896 256L896 256Q790 256 692 283.50Q594 311 508.50 361Q423 411 353 481Q283 551 233 636.50Q183 722 155.50 820Q128 918 128 1024L128 1024Q128 1119 151 1209.50Q174 1300 216.50 1380.50Q259 1461 319 1530.50Q379 1600 453.50 1652.50Q528 1705 614.50 1739.50Q701 1774 796 1785ZM1024 1024L1024 1024Q1024 1051 1014 1074Q1004 1097 986.50 1114.50Q969 1132 946 1142Q923 1152 896 1152L896 1152Q869 1152 846 1142Q823 1132 805.50 1114.50Q788 1097 778 1074Q768 1051 768 1024L768 1024Q768 997 778 974Q788 951 805.50 933.50Q823 916 846 906Q869 896 896 896L896 896Q923 896 946 906Q969 916 986.50 933.50Q1004 951 1014 974Q1024 997 1024 1024Z"
         }
      }
   ]
}

var UnpublishContent = {
   name: "UnpublishContent",
   vendor: "UiFabric",
   unicode: 58143,
   value: "",
   charCode: "E31F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1664L768 347L365 749L275 659L832 102L1389 659L1299 749L896 347L896 1664L768 1664ZM2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600ZM1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600L1280 1600Q1280 1667 1305 1725Q1330 1783 1373.50 1826.50Q1417 1870 1475 1895Q1533 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867ZM1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600ZM128 1920L1085 1920Q1107 1957 1133 1989Q1159 2021 1192 2048L1192 2048L0 2048L0 1664L128 1664L128 1920Z"
         }
      }
   ]
}

var WebAppBuilderFragmentCreate = {
   name: "WebAppBuilderFragmentCreate",
   vendor: "UiFabric",
   unicode: 58139,
   value: "",
   charCode: "E31B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 448L768 896L256 896L0 448L256 0L768 0L1024 448ZM694 128L330 128L147 448L330 768L694 768L877 448L694 128ZM1792 1408L1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408ZM1226 1280L1536 1280L1536 1408L1152 1408L896 960L1152 512L1664 512L1920 960L1737 1280L1590 1280L1773 960L1590 640L1226 640L1043 960L1226 1280ZM0 1472L256 1024L768 1024L1024 1472L768 1920L256 1920L0 1472ZM330 1792L694 1792L877 1472L694 1152L330 1152L147 1472L330 1792Z"
         }
      }
   ]
}

var PageData = {
   name: "PageData",
   vendor: "UiFabric",
   unicode: 58140,
   value: "",
   charCode: "E31C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1216L2048 1216L2048 1834Q2048 1875 2028.50 1907Q2009 1939 1976.50 1962.50Q1944 1986 1903 2002.50Q1862 2019 1819.50 2029Q1777 2039 1736 2043.50Q1695 2048 1664 2048L1664 2048Q1632 2048 1591 2044Q1550 2040 1507.50 2030Q1465 2020 1424 2004Q1383 1988 1351 1964Q1319 1940 1299.50 1908Q1280 1876 1280 1834L1280 1834L1280 1216Q1280 1177 1300.50 1147Q1321 1117 1354 1096Q1387 1075 1429 1061Q1471 1047 1513.50 1038.50Q1556 1030 1596 1027Q1636 1024 1665 1024L1665 1024Q1694 1024 1734 1027Q1774 1030 1816.50 1038.50Q1859 1047 1900.50 1060.50Q1942 1074 1975 1095.50Q2008 1117 2028 1146.50Q2048 1176 2048 1216ZM1920 1834L1920 1834L1920 1364Q1860 1388 1795 1398Q1730 1408 1665 1408L1665 1408Q1602 1408 1534.50 1398Q1467 1388 1408 1364L1408 1364L1408 1834Q1408 1842 1414.50 1847.50Q1421 1853 1426 1858L1426 1858Q1445 1875 1475.50 1887Q1506 1899 1539.50 1906.50Q1573 1914 1606 1917Q1639 1920 1664 1920L1664 1920Q1690 1920 1723 1917Q1756 1914 1789 1906.50Q1822 1899 1852 1887.50Q1882 1876 1902 1858L1902 1858Q1907 1853 1913.50 1847.50Q1920 1842 1920 1834ZM1920 1213L1920 1213Q1908 1197 1874 1185Q1840 1173 1800.50 1166Q1761 1159 1723 1155.50Q1685 1152 1665 1152L1665 1152Q1646 1152 1606.50 1155.50Q1567 1159 1525.50 1167.50Q1484 1176 1449.50 1189Q1415 1202 1407 1220L1407 1220Q1420 1237 1454.50 1248Q1489 1259 1528.50 1266.50Q1568 1274 1606 1277Q1644 1280 1665 1280L1665 1280Q1684 1280 1723 1276.50Q1762 1273 1803 1265Q1844 1257 1877.50 1244.50Q1911 1232 1920 1213ZM1664 896L1664 640L1152 640L1152 128L256 128L256 1920L1152 1920L1152 2048L128 2048L128 0L1243 0L1792 549L1792 896L1664 896ZM1573 512L1280 219L1280 512L1573 512Z"
         }
      }
   ]
}

var PageHeaderEdit = {
   name: "PageHeaderEdit",
   vendor: "UiFabric",
   unicode: 58141,
   value: "",
   charCode: "E31D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 128L128 128L128 1920L768 1920Q758 1952 748.50 1984Q739 2016 732 2048L732 2048L0 2048L0 0L1792 0L1792 741Q1757 746 1725.50 757Q1694 768 1664 787L1664 787L1664 128ZM2049 1094L2049 1094Q2049 1133 2034 1170Q2019 1207 1991 1235L1991 1235L1274 1952L897 2046L991 1669L1708 953Q1737 924 1772.50 910Q1808 896 1849 896L1849 896Q1891 896 1927.50 911Q1964 926 1991 952.50Q2018 979 2033.50 1015.50Q2049 1052 2049 1094ZM1921 1094L1921 1094Q1921 1062 1900.50 1043Q1880 1024 1849 1024L1849 1024Q1835 1024 1822 1028.50Q1809 1033 1799 1043L1799 1043L1107 1735L1073 1870L1208 1836L1900 1145Q1921 1124 1921 1094ZM1536 258L1536 896L256 896L256 258L1536 258ZM1408 384L384 384L384 768L1408 768L1408 384ZM384 1152L384 1536L898 1536Q885 1549 872.50 1561.50Q860 1574 846 1587L846 1587Q841 1607 836.50 1626Q832 1645 827 1664L827 1664L256 1664L256 1024L1410 1024L1281 1152L384 1152Z"
         }
      }
   ]
}

var EntitlementRedemption = {
   name: "EntitlementRedemption",
   vendor: "UiFabric",
   unicode: 58183,
   value: "",
   charCode: "E347",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 640L256 512L896 512L896 640L256 640ZM256 768L1408 768L1408 896L256 896L256 768ZM256 1024L1408 1024L1408 1152L256 1152L256 1024ZM256 1280L1408 1280L1408 1408L256 1408L256 1280ZM1054 1664L256 1664L256 1536L1182 1536L1054 1664ZM128 128L128 1920L1155 1920L1283 2048L0 2048L0 0L1115 0L1664 549L1664 1411L1536 1539L1536 640L1024 640L1024 128L128 128ZM1445 512L1152 219L1152 512L1445 512ZM1472 1829L1939 1363L2029 1453L1472 2011L1203 1741L1293 1651L1472 1829Z"
         }
      }
   ]
}

var EntitlementPolicy = {
   name: "EntitlementPolicy",
   vendor: "UiFabric",
   unicode: 58182,
   value: "",
   charCode: "E346",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L128 128L128 1920L1024 1920L1024 2048L0 2048L0 0L1115 0L1664 549L1664 1280L1536 1280L1536 640L1024 640L1024 128ZM1445 512L1152 219L1152 512L1445 512ZM256 640L256 512L896 512L896 640L256 640ZM256 768L1408 768L1408 896L256 896L256 768ZM1408 1152L256 1152L256 1024L1408 1024L1408 1152ZM1024 1408L256 1408L256 1280L1024 1280L1024 1408ZM1024 1664L256 1664L256 1536L1024 1536L1024 1664ZM1408 1536L1408 1408L2048 1408L2048 1536L1408 1536ZM2048 1792L1408 1792L1408 1664L2048 1664L2048 1792ZM2048 2048L1408 2048L1408 1920L2048 1920L2048 2048ZM1280 1536L1152 1536L1152 1408L1280 1408L1280 1536ZM1280 1792L1152 1792L1152 1664L1280 1664L1280 1792ZM1280 2048L1152 2048L1152 1920L1280 1920L1280 2048Z"
         }
      }
   ]
}

var DependencyRemove = {
   name: "DependencyRemove",
   vendor: "UiFabric",
   unicode: 58181,
   value: "",
   charCode: "E345",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 512L128 512L128 1152L640 1152L640 1280L0 1280L0 384L1280 384L1280 896L1152 896L1152 512ZM2048 1920L768 1920L768 1024L2048 1024L2048 1920ZM1920 1152L896 1152L896 1792L1920 1792L1920 1152ZM1957 0L2048 92L1820 320L2048 548L1957 640L1728 411L1500 640L1408 549L1637 320L1408 91L1500 0L1728 229L1957 0Z"
         }
      }
   ]
}

var DependencyAdd = {
   name: "DependencyAdd",
   vendor: "UiFabric",
   unicode: 58180,
   value: "",
   charCode: "E344",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 512L128 512L128 1152L640 1152L640 1280L0 1280L0 384L1280 384L1280 896L1152 896L1152 512ZM2048 1920L768 1920L768 1024L2048 1024L2048 1920ZM1920 1152L896 1152L896 1792L1920 1792L1920 1152ZM1537 129L1280 129L1280 0L1537 0Q1588 0 1635.50 19.50Q1683 39 1719 75L1719 75Q1755 111 1774.50 158.50Q1794 206 1794 257L1794 257L1794 551L1958 389L2048 479L1730 797L1411 479L1502 389L1666 551L1666 257Q1666 230 1656 206.50Q1646 183 1628.50 166Q1611 149 1587.50 139Q1564 129 1537 129L1537 129Z"
         }
      }
   ]
}

var SchoolDataSyncLogo = {
   name: "SchoolDataSyncLogo",
   vendor: "UiFabric",
   unicode: 58188,
   value: "",
   charCode: "E34C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1856L2048 1856Q2048 1882 2029 1901Q2010 1920 1984 1920L1984 1920L1536 1920L1536 1472Q1536 1446 1555 1427Q1574 1408 1600 1408L1600 1408Q1626 1408 1645 1427Q1664 1446 1664 1472L1664 1472L1664 1777Q1788 1651 1854 1490Q1920 1329 1920 1152L1920 1152Q1920 1029 1888 914.50Q1856 800 1797.50 700.50Q1739 601 1657 519Q1575 437 1475.50 378.50Q1376 320 1261.50 288Q1147 256 1024 256L1024 256Q900 256 786 288Q672 320 572.50 378.50Q473 437 391 519Q309 601 250.50 700.50Q192 800 160 914.50Q128 1029 128 1152L128 1152Q128 1320 189 1476Q250 1632 364 1756L364 1756Q436 1650 538.50 1572Q641 1494 762 1452L762 1452Q674 1386 625 1292.50Q576 1199 576 1088L576 1088Q576 995 611 913.50Q646 832 707 771Q768 710 849.50 675Q931 640 1024 640L1024 640Q1117 640 1198.50 675Q1280 710 1341 771Q1402 832 1437 913.50Q1472 995 1472 1088L1472 1088Q1472 1199 1423 1292.50Q1374 1386 1286 1452L1286 1452Q1303 1458 1324 1465Q1345 1472 1363 1482.50Q1381 1493 1393.50 1508Q1406 1523 1406 1545L1406 1545Q1406 1571 1387 1589.50Q1368 1608 1342 1608L1342 1608Q1327 1608 1314 1602L1314 1602Q1242 1570 1173 1553Q1104 1536 1024 1536L1024 1536Q875 1536 742 1598Q609 1660 512 1772L512 1772Q488 1800 470 1829Q452 1858 432 1889L432 1889Q421 1906 408.50 1914.50Q396 1923 376 1923L376 1923Q353 1923 333 1906L333 1906Q295 1875 260 1835Q225 1795 194 1751.50Q163 1708 136.50 1662Q110 1616 90 1571L90 1571Q0 1372 0 1152L0 1152Q0 1011 36.50 880Q73 749 139.50 635Q206 521 299.50 427.50Q393 334 507 267.50Q621 201 752 164.50Q883 128 1024 128L1024 128Q1165 128 1296 164.50Q1427 201 1541 267.50Q1655 334 1748.50 427.50Q1842 521 1908.50 635Q1975 749 2011.50 880Q2048 1011 2048 1152L2048 1152Q2048 1330 1990.50 1491.50Q1933 1653 1822 1792L1822 1792L1984 1792Q2010 1792 2029 1811Q2048 1830 2048 1856ZM704 1088L704 1088Q704 1154 729 1212.50Q754 1271 797.50 1314.50Q841 1358 899.50 1383Q958 1408 1024 1408L1024 1408Q1090 1408 1148 1383Q1206 1358 1249.50 1314.50Q1293 1271 1318.50 1212.50Q1344 1154 1344 1088L1344 1088Q1344 1022 1318.50 964Q1293 906 1249.50 862.50Q1206 819 1148 793.50Q1090 768 1024 768L1024 768Q958 768 899.50 793.50Q841 819 797.50 862.50Q754 906 729 964Q704 1022 704 1088Z"
         }
      }
   ]
}

var PinSolid12 = {
   name: "PinSolid12",
   vendor: "UiFabric",
   unicode: 58194,
   value: "",
   charCode: "E352",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1963 512L1963 512L2048 512L2048 1365L1963 1365Q1860 1365 1773 1320.50Q1686 1276 1623 1195L1623 1195L1306 1195Q1269 1273 1212.50 1336Q1156 1399 1086 1443.50Q1016 1488 935 1512Q854 1536 768 1536L768 1536L683 1536L683 1024L171 1024L0 939L171 853L683 853L683 341L768 341Q854 341 935 365Q1016 389 1086.50 434Q1157 479 1213 542Q1269 605 1306 683L1306 683L1623 683Q1685 602 1772.50 557Q1860 512 1963 512Z"
         }
      }
   ]
}

var PinSolidOff12 = {
   name: "PinSolidOff12",
   vendor: "UiFabric",
   unicode: 58195,
   value: "",
   charCode: "E353",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1963 512L2048 512L2048 1365L1963 1365Q1925 1365 1887.50 1357Q1850 1349 1815 1336L1815 1336L825 345Q903 353 975 380.50Q1047 408 1109.50 451.50Q1172 495 1222 554Q1272 613 1306 683L1306 683L1623 683Q1683 602 1773 557Q1863 512 1963 512L1963 512ZM683 803L25 146L146 25L2023 1902L1902 2023L1213 1334Q1171 1382 1120 1419.50Q1069 1457 1012 1483Q955 1509 893.50 1522.50Q832 1536 768 1536L768 1536L683 1536L683 1024L171 1024L0 939L171 853L683 853L683 803Z"
         }
      }
   ]
}

var AddLink = {
   name: "AddLink",
   vendor: "UiFabric",
   unicode: 58206,
   value: "",
   charCode: "E35E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 1216L768 1216Q768 1282 793 1340.50Q818 1399 861.50 1442.50Q905 1486 963.50 1511Q1022 1536 1088 1536L1088 1536L1280 1536L1280 1664L1088 1664Q995 1664 913.50 1628.50Q832 1593 771.50 1532.50Q711 1472 675.50 1390.50Q640 1309 640 1216L640 1216Q640 1123 675.50 1041.50Q711 960 771.50 899.50Q832 839 913.50 803.50Q995 768 1088 768L1088 768L1152 768L1152 896L1088 896Q1022 896 963.50 921.50Q905 947 861.50 990.50Q818 1034 793 1092Q768 1150 768 1216ZM1600 896L1536 896L1536 768L1600 768Q1693 768 1774.50 803.50Q1856 839 1916.50 899.50Q1977 960 2012.50 1041.50Q2048 1123 2048 1216L2048 1216Q2048 1304 2015 1385Q1982 1466 1920 1529L1920 1529L1920 1216Q1920 1150 1894.50 1092Q1869 1034 1825.50 990.50Q1782 947 1724 921.50Q1666 896 1600 896L1600 896ZM448 384L960 384Q1053 384 1134.50 419.50Q1216 455 1276.50 515.50Q1337 576 1372.50 657.50Q1408 739 1408 832L1408 832Q1408 925 1372.50 1006.50Q1337 1088 1276.50 1148.50Q1216 1209 1134.50 1244.50Q1053 1280 960 1280L960 1280L896 1280L896 1152L960 1152Q1026 1152 1084 1127Q1142 1102 1185.50 1058.50Q1229 1015 1254.50 956.50Q1280 898 1280 832L1280 832Q1280 766 1254.50 708Q1229 650 1185.50 606.50Q1142 563 1084 537.50Q1026 512 960 512L960 512L448 512Q382 512 323.50 537.50Q265 563 221.50 606.50Q178 650 153 708Q128 766 128 832L128 832Q128 898 153 956.50Q178 1015 221.50 1058.50Q265 1102 323.50 1127Q382 1152 448 1152L448 1152L512 1152L512 1280L448 1280Q355 1280 273.50 1244.50Q192 1209 131.50 1148.50Q71 1088 35.50 1006.50Q0 925 0 832L0 832Q0 739 35.50 657.50Q71 576 131.50 515.50Q192 455 273.50 419.50Q355 384 448 384L448 384ZM1792 1664L2048 1664L2048 1792L1792 1792L1792 2048L1664 2048L1664 1792L1408 1792L1408 1664L1664 1664L1664 1408L1792 1408L1792 1664Z"
         }
      }
   ]
}

var SharepointAppIcon16 = {
   name: "SharepointAppIcon16",
   vendor: "UiFabric",
   unicode: 58213,
   value: "",
   charCode: "E365",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1152L2048 1152Q2048 1259 2007.50 1352.50Q1967 1446 1896.50 1515Q1826 1584 1732 1624Q1638 1664 1531 1664L1531 1664Q1519 1747 1479.50 1817Q1440 1887 1381 1938.50Q1322 1990 1246.50 2019Q1171 2048 1088 2048L1088 2048Q1005 2048 929.50 2019Q854 1990 795 1938.50Q736 1887 696.50 1817Q657 1747 645 1664L645 1664L128 1664Q102 1664 78.50 1654Q55 1644 37.50 1626.50Q20 1609 10 1585.50Q0 1562 0 1536L0 1536L0 512Q0 486 10 462.50Q20 439 37.50 421.50Q55 404 78.50 394Q102 384 128 384L128 384L417 384Q447 298 501.50 227.50Q556 157 627.50 106.50Q699 56 784 28Q869 0 960 0L960 0Q1079 0 1184 45.50Q1289 91 1367 169Q1445 247 1490.50 352Q1536 457 1536 576L1536 576Q1536 592 1535 608Q1534 624 1532 640L1532 640Q1638 640 1732 680Q1826 720 1896.50 789Q1967 858 2007.50 951.50Q2048 1045 2048 1152ZM960 128L960 128Q895 128 834.50 146Q774 164 721 197.50Q668 231 625.50 278.50Q583 326 555 384L555 384L1152 384Q1178 384 1201.50 394Q1225 404 1242.50 421.50Q1260 439 1270 462.50Q1280 486 1280 512L1280 512L1280 709Q1309 693 1338.50 680Q1368 667 1400 658L1400 658Q1408 615 1408 576L1408 576Q1408 483 1372.50 401.50Q1337 320 1276.50 259.50Q1216 199 1134.50 163.50Q1053 128 960 128ZM624 1440L624 1440Q684 1440 739.50 1427.50Q795 1415 838.50 1386Q882 1357 908 1310Q934 1263 934 1195L934 1195Q934 1140 917.50 1100.50Q901 1061 872 1032Q843 1003 804 981.50Q765 960 719 941L719 941Q708 933 684 924Q660 915 634.50 904Q609 893 590 878.50Q571 864 571 844L571 844Q571 826 583.50 815.50Q596 805 614 799Q632 793 651 791Q670 789 683 789L683 789Q719 789 746.50 793.50Q774 798 798.50 807.50Q823 817 847 831Q871 845 901 864L901 864L901 646Q846 623 792.50 615.50Q739 608 679 608L679 608Q622 608 564.50 621Q507 634 461.50 663.50Q416 693 387 739.50Q358 786 358 852L358 852Q358 916 385 960Q412 1004 452.50 1034.50Q493 1065 540 1085.50Q587 1106 627.50 1124Q668 1142 695 1160Q722 1178 722 1203L722 1203Q722 1222 710 1233Q698 1244 681 1250Q664 1256 645.50 1257.50Q627 1259 613 1259L613 1259Q589 1259 561.50 1254.50Q534 1250 507 1241.50Q480 1233 455 1221.50Q430 1210 411 1195L411 1195L360 1155L360 1386Q422 1418 488.50 1429Q555 1440 624 1440ZM1088 1920L1088 1920Q1154 1920 1212 1895Q1270 1870 1313.50 1826.50Q1357 1783 1382.50 1724.50Q1408 1666 1408 1600L1408 1600Q1408 1524 1374.50 1457Q1341 1390 1280 1344L1280 1344L1280 1536Q1280 1562 1270 1585.50Q1260 1609 1242.50 1626.50Q1225 1644 1201.50 1654Q1178 1664 1152 1664L1152 1664L774 1664Q786 1720 815 1767Q844 1814 885.50 1848Q927 1882 979 1901Q1031 1920 1088 1920ZM1531 1536L1536 1536Q1615 1536 1685 1506Q1755 1476 1807.50 1423.50Q1860 1371 1890 1301.50Q1920 1232 1920 1152L1920 1152Q1920 1073 1890 1003Q1860 933 1807.50 880.50Q1755 828 1685 798Q1615 768 1536 768L1536 768Q1465 768 1399 793.50Q1333 819 1280 867L1280 867L1280 1195Q1331 1219 1373.50 1254.50Q1416 1290 1448.50 1334Q1481 1378 1502 1429.50Q1523 1481 1531 1536L1531 1536Z"
         }
      }
   ]
}

var DataflowsLink = {
   name: "DataflowsLink",
   vendor: "UiFabric",
   unicode: 58214,
   value: "",
   charCode: "E366",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 1728L2048 1728Q2048 1794 2023 1852.50Q1998 1911 1954.50 1954.50Q1911 1998 1852.50 2023Q1794 2048 1728 2048L1728 2048L1472 2048Q1405 2048 1347 2023Q1289 1998 1245.50 1954.50Q1202 1911 1177 1853Q1152 1795 1152 1728L1152 1728Q1152 1671 1171 1619Q1190 1567 1224 1525.50Q1258 1484 1305 1455Q1352 1426 1408 1414L1408 1414L1408 1547Q1350 1568 1315 1616.50Q1280 1665 1280 1728L1280 1728Q1280 1768 1295 1803Q1310 1838 1336 1864Q1362 1890 1397 1905Q1432 1920 1472 1920L1472 1920L1728 1920Q1768 1920 1803 1905Q1838 1890 1864 1864Q1890 1838 1905 1803Q1920 1768 1920 1728L1920 1728Q1920 1663 1883 1614.50Q1846 1566 1786 1545L1786 1545Q1792 1509 1792 1472L1792 1472Q1792 1457 1791 1442.50Q1790 1428 1788 1414L1788 1414Q1845 1426 1892.50 1454.50Q1940 1483 1974.50 1524.50Q2009 1566 2028.50 1617.50Q2048 1669 2048 1728ZM1536 1024L384 1024L384 1408L640 1408L640 2048L0 2048L0 1408L256 1408L256 640L0 640L0 0L640 0L640 640L384 640L384 896L1408 896L1408 640L1152 640L1152 0L1792 0L1792 640L1536 640L1536 1024ZM1280 128L1280 512L1664 512L1664 128L1280 128ZM128 128L128 512L512 512L512 128L128 128ZM512 1920L512 1536L128 1536L128 1920L512 1920ZM896 1472L896 1472Q896 1537 933 1585.50Q970 1634 1030 1655L1030 1655Q1024 1691 1024 1728L1024 1728Q1024 1743 1025 1757.50Q1026 1772 1028 1786L1028 1786Q972 1777 924 1748Q876 1719 841.50 1676.50Q807 1634 787.50 1581Q768 1528 768 1472L768 1472Q768 1406 793 1347.50Q818 1289 861.50 1245.50Q905 1202 963.50 1177Q1022 1152 1088 1152L1088 1152L1344 1152Q1410 1152 1468 1177.50Q1526 1203 1569.50 1246.50Q1613 1290 1638.50 1348Q1664 1406 1664 1472L1664 1472Q1664 1526 1643.50 1577.50Q1623 1629 1588 1671Q1553 1713 1506.50 1743.50Q1460 1774 1408 1786L1408 1786L1408 1653Q1450 1644 1475 1629.50Q1500 1615 1513.50 1593.50Q1527 1572 1531.50 1542Q1536 1512 1536 1472L1536 1472Q1536 1432 1521 1397Q1506 1362 1480 1336Q1454 1310 1419 1295Q1384 1280 1344 1280L1344 1280L1088 1280Q1048 1280 1013 1295Q978 1310 952 1336Q926 1362 911 1397Q896 1432 896 1472Z"
         }
      }
   ]
}

var TimePicker = {
   name: "TimePicker",
   vendor: "UiFabric",
   unicode: 58215,
   value: "",
   charCode: "E367",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M192 768L192 768Q232 768 267 783Q302 798 328 824Q354 850 369 885Q384 920 384 960L384 960L384 1088Q384 1128 369 1163Q354 1198 328 1224Q302 1250 267 1265Q232 1280 192 1280L192 1280Q152 1280 117 1265Q82 1250 56 1224Q30 1198 15 1163Q0 1128 0 1088L0 1088L0 960Q0 920 15 885Q30 850 56 824Q82 798 117 783Q152 768 192 768ZM256 1104L256 1104L256 944Q256 918 237 899Q218 880 192 880L192 880Q166 880 147 899Q128 918 128 944L128 944L128 1104Q128 1130 147 1149Q166 1168 192 1168L192 1168Q218 1168 237 1149Q256 1130 256 1104ZM704 768L704 768Q744 768 779 783Q814 798 840 824Q866 850 881 885Q896 920 896 960L896 960L896 1088Q896 1128 881 1163Q866 1198 840 1224Q814 1250 779 1265Q744 1280 704 1280L704 1280Q664 1280 629 1265Q594 1250 568 1224Q542 1198 527 1163Q512 1128 512 1088L512 1088L512 960Q512 920 527 885Q542 850 568 824Q594 798 629 783Q664 768 704 768ZM768 1104L768 1104L768 944Q768 918 749 899Q730 880 704 880L704 880Q678 880 659 899Q640 918 640 944L640 944L640 1104Q640 1130 659 1149Q678 1168 704 1168L704 1168Q730 1168 749 1149Q768 1130 768 1104ZM1344 768L1344 768Q1384 768 1419 783Q1454 798 1480 824Q1506 850 1521 885Q1536 920 1536 960L1536 960L1536 1088Q1536 1128 1521 1163Q1506 1198 1480 1224Q1454 1250 1419 1265Q1384 1280 1344 1280L1344 1280Q1304 1280 1269 1265Q1234 1250 1208 1224Q1182 1198 1167 1163Q1152 1128 1152 1088L1152 1088L1152 960Q1152 920 1167 885Q1182 850 1208 824Q1234 798 1269 783Q1304 768 1344 768ZM1408 1104L1408 1104L1408 944Q1408 918 1389 899Q1370 880 1344 880L1344 880Q1318 880 1299 899Q1280 918 1280 944L1280 944L1280 1104Q1280 1130 1299 1149Q1318 1168 1344 1168L1344 1168Q1370 1168 1389 1149Q1408 1130 1408 1104ZM1856 768L1856 768Q1896 768 1931 783Q1966 798 1992 824Q2018 850 2033 885Q2048 920 2048 960L2048 960L2048 1088Q2048 1128 2033 1163Q2018 1198 1992 1224Q1966 1250 1931 1265Q1896 1280 1856 1280L1856 1280Q1816 1280 1781 1265Q1746 1250 1720 1224Q1694 1198 1679 1163Q1664 1128 1664 1088L1664 1088L1664 960Q1664 920 1679 885Q1694 850 1720 824Q1746 798 1781 783Q1816 768 1856 768ZM1920 1104L1920 1104L1920 944Q1920 918 1901 899Q1882 880 1856 880L1856 880Q1830 880 1811 899Q1792 918 1792 944L1792 944L1792 1104Q1792 1130 1811 1149Q1830 1168 1856 1168L1856 1168Q1882 1168 1901 1149Q1920 1130 1920 1104ZM1024 1024L1024 1024Q998 1024 979 1005Q960 986 960 960L960 960Q960 934 979 915Q998 896 1024 896L1024 896Q1050 896 1069 915Q1088 934 1088 960L1088 960Q1088 986 1069 1005Q1050 1024 1024 1024ZM1024 1280L1024 1280Q998 1280 979 1261Q960 1242 960 1216L960 1216Q960 1190 979 1171Q998 1152 1024 1152L1024 1152Q1050 1152 1069 1171Q1088 1190 1088 1216L1088 1216Q1088 1242 1069 1261Q1050 1280 1024 1280ZM1517 531L1427 621L1024 219L621 621L531 531L1024 37L1517 531ZM1517 1517L1024 2011L531 1517L621 1427L1024 1829L1427 1427L1517 1517Z"
         }
      }
   ]
}

var UserWarning = {
   name: "UserWarning",
   vendor: "UiFabric",
   unicode: 58216,
   value: "",
   charCode: "E368",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1219 1044L1219 1044L1160 1162Q1075 1096 975.50 1060Q876 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1544 35.50 1433Q71 1322 136 1228Q201 1134 292.50 1061Q384 988 496 946L496 946Q383 872 319.50 760Q256 648 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 578 1263.50 641Q1247 704 1216 760Q1185 816 1140.50 863.50Q1096 911 1040 946L1040 946Q1136 983 1219 1044ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512ZM1408 1728L1408 1408L1536 1408L1536 1728L1408 1728ZM1536 1920L1408 1920L1408 1792L1536 1792L1536 1920ZM896 2048L1472 896L2048 2048L896 2048ZM1867 1936L1472 1146L1077 1936L1867 1936Z"
         }
      }
   ]
}

var ComplianceAudit = {
   name: "ComplianceAudit",
   vendor: "UiFabric",
   unicode: 58217,
   value: "",
   charCode: "E369",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M384 1280L1033 1280Q1019 1310 1011.50 1342.50Q1004 1375 999 1408L999 1408L384 1408L384 1280ZM1034 1664L384 1664L384 1536L997 1536Q1002 1569 1011 1601Q1020 1633 1034 1664L1034 1664ZM256 128L256 1920L1605 1920L1732 2048L128 2048L128 0L1243 0L1792 549L1792 1117Q1763 1091 1731 1069.50Q1699 1048 1664 1033L1664 1033L1664 640L1152 640L1152 128L256 128ZM1573 512L1280 219L1280 512L1573 512ZM384 1024L1304 1024Q1195 1065 1117 1152L1117 1152L384 1152L384 1024ZM384 640L384 512L1024 512L1024 640L384 640ZM384 768L1536 768L1536 896L384 896L384 768ZM2048 1984L2048 1984Q2048 2010 2029 2029Q2010 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1648 1739Q1609 1765 1564 1778.50Q1519 1792 1472 1792L1472 1792Q1406 1792 1347.50 1767Q1289 1742 1245.50 1698.50Q1202 1655 1177 1596.50Q1152 1538 1152 1472L1152 1472Q1152 1406 1177 1348Q1202 1290 1245.50 1246.50Q1289 1203 1347.50 1177.50Q1406 1152 1472 1152L1472 1152Q1538 1152 1596 1177.50Q1654 1203 1697.50 1246.50Q1741 1290 1766.50 1348Q1792 1406 1792 1472L1792 1472Q1792 1519 1778.50 1564Q1765 1609 1739 1648L1739 1648L2029 1939Q2048 1958 2048 1984ZM1280 1472L1280 1472Q1280 1512 1295 1547Q1310 1582 1336 1608Q1362 1634 1397 1649Q1432 1664 1472 1664L1472 1664Q1512 1664 1547 1649Q1582 1634 1608 1608Q1634 1582 1649 1547Q1664 1512 1664 1472L1664 1472Q1664 1432 1649 1397Q1634 1362 1608 1336Q1582 1310 1547 1295Q1512 1280 1472 1280L1472 1280Q1432 1280 1397 1295Q1362 1310 1336 1336Q1310 1362 1295 1397Q1280 1432 1280 1472Z"
         }
      }
   ]
}

var StickyNotesOutlineAppIcon = {
   name: "StickyNotesOutlineAppIcon",
   vendor: "UiFabric",
   unicode: 58218,
   value: "",
   charCode: "E36A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M213 128L1835 128Q1870 128 1895 153Q1920 178 1920 213L1920 213L1920 1835Q1920 1870 1895 1895Q1870 1920 1835 1920L1835 1920L213 1920Q178 1920 153 1895Q128 1870 128 1835L128 1835L128 213Q128 178 153 153Q178 128 213 128L213 128ZM256 1792L1792 1792L1792 256L256 256L256 1792ZM1024 1792L1024 1097Q1024 1067 1045.50 1045.50Q1067 1024 1097 1024L1097 1024L1792 1024L1024 1792Z"
         }
      }
   ]
}

var StickyNotesSolidAppIcon = {
   name: "StickyNotesSolidAppIcon",
   vendor: "UiFabric",
   unicode: 58219,
   value: "",
   charCode: "E36B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1835 1920L1835 1920L1024 1920L1920 1024L1920 1835Q1920 1870 1895 1895Q1870 1920 1835 1920ZM213 128L1835 128Q1870 128 1895 153Q1920 178 1920 213L1920 213L1920 1024L1109 1024Q1074 1024 1049 1049Q1024 1074 1024 1109L1024 1109L1024 1920L213 1920Q178 1920 153 1895Q128 1870 128 1835L128 1835L128 213Q128 178 153 153Q178 128 213 128L213 128Z"
         }
      }
   ]
}

var eDiscovery = {
   name: "eDiscovery",
   vendor: "UiFabric",
   unicode: 58224,
   value: "",
   charCode: "E370",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1792L220 1792L178 1920L1664 1920L1664 2048L0 2048Q2 2042 12.50 2011Q23 1980 37 1937.50Q51 1895 67 1847Q83 1799 96.50 1758.50Q110 1718 119 1691Q128 1664 128 1664L128 1664L128 896L0 896L0 768L896 320L896 0L1279 0L1279 256L1024 256L1024 320L1920 768L1920 896L1792 896L1792 1024L1664 1024L1664 896L1536 896L1536 1024L1408 1024L1408 896L1280 896L1280 1024L1152 1024L1152 896L1024 896L1024 1792ZM512 1664L640 1664L640 896L512 896L512 1664ZM768 1664L896 1664L896 896L768 896L768 1664ZM1634 768L960 431L286 768L1634 768ZM384 896L256 896L256 1664L384 1664L384 896ZM2048 1984L2048 1984Q2048 2010 2029 2029Q2010 2048 1984 2048L1984 2048Q1958 2048 1939 2029L1939 2029L1648 1739Q1609 1765 1564 1778.50Q1519 1792 1472 1792L1472 1792Q1406 1792 1347.50 1767Q1289 1742 1245.50 1698.50Q1202 1655 1177 1596.50Q1152 1538 1152 1472L1152 1472Q1152 1406 1177 1348Q1202 1290 1245.50 1246.50Q1289 1203 1347.50 1177.50Q1406 1152 1472 1152L1472 1152Q1538 1152 1596 1177.50Q1654 1203 1697.50 1246.50Q1741 1290 1766.50 1348Q1792 1406 1792 1472L1792 1472Q1792 1519 1778.50 1564Q1765 1609 1739 1648L1739 1648L2029 1939Q2048 1958 2048 1984ZM1280 1472L1280 1472Q1280 1512 1295 1547Q1310 1582 1336 1608Q1362 1634 1397 1649Q1432 1664 1472 1664L1472 1664Q1512 1664 1547 1649Q1582 1634 1608 1608Q1634 1582 1649 1547Q1664 1512 1664 1472L1664 1472Q1664 1432 1649 1397Q1634 1362 1608 1336Q1582 1310 1547 1295Q1512 1280 1472 1280L1472 1280Q1432 1280 1397 1295Q1362 1310 1336 1336Q1310 1362 1295 1397Q1280 1432 1280 1472Z"
         }
      }
   ]
}

var Webcam2Off = {
   name: "Webcam2Off",
   vendor: "UiFabric",
   unicode: 58221,
   value: "",
   charCode: "E36D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 128L1024 128Q905 128 793 163.50Q681 199 584 267L584 267L493 176Q609 90 744 45Q879 0 1024 0L1024 0Q1147 0 1261.50 32Q1376 64 1475.50 122.50Q1575 181 1657 263Q1739 345 1797.50 444.50Q1856 544 1888 658.50Q1920 773 1920 896L1920 896Q1920 1040 1875 1176Q1830 1312 1744 1427L1744 1427L1650 1334Q1699 1264 1732.50 1186.50Q1766 1109 1781 1024L1781 1024L1451 1024Q1445 1044 1437 1063.50Q1429 1083 1419 1102L1419 1102L1323 1006Q1344 954 1344 896L1344 896Q1344 830 1319 771.50Q1294 713 1250.50 669.50Q1207 626 1148.50 601Q1090 576 1024 576L1024 576Q966 576 914 597L914 597L818 501Q866 475 918 461.50Q970 448 1024 448L1024 448Q1117 448 1198.50 483.50Q1280 519 1340.50 579.50Q1401 640 1436.50 721.50Q1472 803 1472 896L1472 896L1792 896Q1792 790 1764.50 692Q1737 594 1687 508.50Q1637 423 1567 353Q1497 283 1411.50 233Q1326 183 1228 155.50Q1130 128 1024 128ZM1939 2029L1537 1628Q1418 1712 1280 1754L1280 1754L1280 1920L1664 1920L1664 2048L384 2048L384 1920L768 1920L768 1754Q626 1712 508 1628Q390 1544 305.50 1431Q221 1318 174.50 1181.50Q128 1045 128 896L128 896Q128 757 170 626Q212 495 292 382L292 382L19 109L109 19L2029 1939L1939 2029ZM1112 1203L717 808Q711 830 707.50 851.50Q704 873 704 896L704 896Q704 962 729 1020.50Q754 1079 797.50 1122.50Q841 1166 899.50 1191Q958 1216 1024 1216L1024 1216Q1047 1216 1068.50 1212.50Q1090 1209 1112 1203L1112 1203ZM619 709L383 474Q320 568 288 675.50Q256 783 256 896L256 896L576 896Q576 798 619 709L619 709ZM896 1920L1152 1920L1152 1782Q1120 1787 1088 1789.50Q1056 1792 1024 1792L1024 1792Q992 1792 960 1789.50Q928 1787 896 1782L896 1782L896 1920ZM1024 1664L1024 1664Q1137 1664 1243.50 1631Q1350 1598 1444 1535L1444 1535L1212 1302Q1123 1344 1024 1344L1024 1344Q950 1344 882 1320.50Q814 1297 757.50 1254.50Q701 1212 659.50 1153.50Q618 1095 597 1024L597 1024L267 1024Q291 1162 359.50 1279.50Q428 1397 529 1482.50Q630 1568 757 1616Q884 1664 1024 1664Z"
         }
      }
   ]
}

var CalendarYear = {
   name: "CalendarYear",
   vendor: "UiFabric",
   unicode: 58225,
   value: "",
   charCode: "E371",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 384L1664 512L1920 512L1920 2048L256 2048L256 512L512 512L512 384L640 384L640 512L1536 512L1536 384L1664 384ZM1792 768L1792 640L1664 640L1664 768L1792 768ZM1536 768L1536 640L640 640L640 768L1536 768ZM512 768L512 640L384 640L384 768L512 768ZM384 896L384 1920L1792 1920L1792 896L384 896ZM384 384L256 384L256 256L128 256L128 1664L0 1664L0 128L256 128L256 0L384 0L384 128L1280 128L1280 0L1408 0L1408 128L1664 128L1664 256L1408 256L1408 384L1280 384L1280 256L384 256L384 384ZM768 1408L640 1408L640 1280L768 1280L768 1408ZM1024 1408L896 1408L896 1280L1024 1280L1024 1408ZM1280 1408L1152 1408L1152 1280L1280 1280L1280 1408ZM1536 1408L1408 1408L1408 1280L1536 1280L1536 1408ZM768 1664L640 1664L640 1536L768 1536L768 1664ZM1024 1664L896 1664L896 1536L1024 1536L1024 1664ZM1280 1664L1152 1664L1152 1536L1280 1536L1280 1664ZM1024 1152L896 1152L896 1024L1024 1024L1024 1152ZM1280 1152L1152 1152L1152 1024L1280 1024L1280 1152ZM1536 1152L1408 1152L1408 1024L1536 1024L1536 1152Z"
         }
      }
   ]
}

var IgnoreConversation = {
   name: "IgnoreConversation",
   vendor: "UiFabric",
   unicode: 58226,
   value: "",
   charCode: "E372",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1664L256 512L2048 512L2048 1152L1920 1152L1920 760L1152 1144L384 760L384 1536L1024 1536L1024 1664L256 1664ZM1873 640L431 640L1152 1000L1873 640ZM0 256L1792 256L1792 384L128 384L128 1408L0 1408L0 256ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var CommonDataServiceCDS = {
   name: "CommonDataServiceCDS",
   vendor: "UiFabric",
   unicode: 58231,
   value: "",
   charCode: "E377",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M525 0L1523 0L2048 525L2048 1523L1523 2048L525 2048L0 1523L0 525L525 0ZM128 1470L512 1854L525 1523L128 1139L128 1470ZM128 958L512 1342L512 1011L128 627L128 958ZM194 512L512 830L512 194L194 512ZM1470 128L640 128L640 896L1470 896L1854 512L1470 128ZM909 1408L640 1139L640 1408L909 1408ZM908 1536L640 1536L640 1804L908 1536ZM1470 1920L1920 1470L1920 1139L1523 1536L1089 1536L705 1920L1470 1920ZM1470 1408L1920 958L1920 627L1523 1024L706 1024L1090 1408L1470 1408Z"
         }
      }
   ]
}

var Forum = {
   name: "Forum",
   vendor: "UiFabric",
   unicode: 58232,
   value: "",
   charCode: "E378",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1536L0 128L2048 128L2048 1536L731 1536L256 2011L256 1536L0 1536ZM677 1408L1920 1408L1920 256L128 256L128 1408L384 1408L384 1701L677 1408ZM256 384L1792 384L1792 1280L256 1280L256 384ZM384 1152L512 1152L512 896L384 896L384 1152ZM384 768L512 768L512 512L384 512L384 768ZM640 1152L1664 1152L1664 896L640 896L640 1152ZM640 768L1664 768L1664 512L640 512L640 768Z"
         }
      }
   ]
}

var KeyPhraseExtraction = {
   name: "KeyPhraseExtraction",
   vendor: "UiFabric",
   unicode: 58261,
   value: "",
   charCode: "E395",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1152L896 1152L896 1280L0 1280L0 1152ZM640 896L1536 896L1536 1024L640 1024L640 896ZM256 0L1371 0L1920 549L1920 2048L256 2048L256 1408L384 1408L384 1920L1792 1920L1792 640L1280 640L1280 128L384 128L384 1024L256 1024L256 0ZM1408 219L1408 512L1701 512L1408 219ZM1536 1536L640 1536L640 1408L1536 1408L1536 1536Z"
         }
      }
   ]
}

var TextRecognition = {
   name: "TextRecognition",
   vendor: "UiFabric",
   unicode: 58260,
   value: "",
   charCode: "E394",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1152L128 1152L128 1536L512 1536L512 1664L0 1664L0 1152ZM283 1278L518 650L635 650L869 1278L754 1278L698 1118L451 1118L397 1278L283 1278ZM565 783L478 1033L671 1033L583 783Q580 774 578.50 763.50Q577 753 575 743L575 743L573 743Q571 753 569.50 763Q568 773 565 783L565 783ZM512 384L128 384L128 768L0 768L0 256L512 256L512 384ZM1367 1041L1367 1041Q1367 1089 1355.50 1133.50Q1344 1178 1320 1212.50Q1296 1247 1258 1267.50Q1220 1288 1166 1288L1166 1288Q1080 1288 1034 1213L1034 1213L1033 1213L1033 1278L931 1278L931 614L1033 614L1033 908L1034 908Q1059 865 1097.50 842Q1136 819 1186 819L1186 819Q1234 819 1268.50 837.50Q1303 856 1325 887Q1347 918 1357 958Q1367 998 1367 1041ZM1263 1041L1263 1041Q1263 1014 1257 989Q1251 964 1238 944Q1225 924 1203.50 912Q1182 900 1152 900L1152 900Q1123 900 1100.50 911Q1078 922 1063 940.50Q1048 959 1040 983.50Q1032 1008 1032 1035L1032 1035L1032 1090Q1032 1114 1040 1135.50Q1048 1157 1062 1173Q1076 1189 1096.50 1198.50Q1117 1208 1142 1208L1142 1208Q1177 1208 1200 1193Q1223 1178 1237 1154Q1251 1130 1257 1100Q1263 1070 1263 1041ZM1536 384L1536 256L2048 256L2048 768L1920 768L1920 384L1536 384ZM1536 1536L1920 1536L1920 1152L2048 1152L2048 1664L1536 1664L1536 1536ZM1664 1288L1664 1288Q1614 1288 1573 1271.50Q1532 1255 1503 1225.50Q1474 1196 1458 1155Q1442 1114 1442 1064L1442 1064Q1442 1009 1459 964Q1476 919 1507.50 886.50Q1539 854 1583.50 836.50Q1628 819 1684 819L1684 819Q1739 819 1792 840L1792 840L1792 935Q1771 920 1744.50 910Q1718 900 1692 900L1692 900Q1657 900 1630 912.50Q1603 925 1584.50 946Q1566 967 1556 996Q1546 1025 1546 1058L1546 1058Q1546 1125 1582.50 1166.50Q1619 1208 1688 1208L1688 1208Q1720 1208 1743.50 1197.50Q1767 1187 1792 1169L1792 1169L1792 1257Q1763 1274 1730.50 1281Q1698 1288 1664 1288Z"
         }
      }
   ]
}

var SentimentAnalysis = {
   name: "SentimentAnalysis",
   vendor: "UiFabric",
   unicode: 58259,
   value: "",
   charCode: "E393",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 640L1344 640Q1441 640 1531 665Q1621 690 1699.50 736Q1778 782 1842 846Q1906 910 1952 988.50Q1998 1067 2023 1157Q2048 1247 2048 1344L2048 1344Q2048 1441 2023 1531Q1998 1621 1952 1699.50Q1906 1778 1842 1842Q1778 1906 1699.50 1952Q1621 1998 1531 2023Q1441 2048 1344 2048L1344 2048Q1247 2048 1157 2023Q1067 1998 988.50 1952Q910 1906 846 1842Q782 1778 736 1699.50Q690 1621 665 1531Q640 1441 640 1344L640 1344Q640 1312 643 1280L643 1280Q510 1280 393 1230Q276 1180 188.50 1093.50Q101 1007 50.50 890.50Q0 774 0 640L0 640Q0 552 23 470Q46 388 87.50 317Q129 246 187.50 187.50Q246 129 317 87.50Q388 46 470 23Q552 0 640 0L640 0Q729 0 811 23Q893 46 964 88Q1035 130 1093.50 188.50Q1152 247 1193.50 318.50Q1235 390 1257.50 472Q1280 554 1280 643L1280 643Q1311 640 1344 640ZM640 1152L640 1152Q647 1152 654 1151Q661 1150 668 1149L668 1149Q686 1086 715.50 1028.50Q745 971 784 919L784 919Q749 908 713 902Q677 896 640 896L640 896Q579 896 520.50 911Q462 926 408 954L408 954L350 840Q418 806 491 787Q564 768 640 768L640 768Q702 768 761.50 781Q821 794 878 817L878 817Q937 765 1005.50 727Q1074 689 1149 668L1149 668Q1150 661 1151 654Q1152 647 1152 640L1152 640Q1152 534 1111.50 441Q1071 348 1001.50 278.50Q932 209 839 168.50Q746 128 640 128L640 128Q534 128 441 168.50Q348 209 278.50 278.50Q209 348 168.50 441Q128 534 128 640L128 640Q128 746 168.50 839Q209 932 278.50 1001.50Q348 1071 441 1111.50Q534 1152 640 1152ZM1344 1920L1344 1920Q1463 1920 1568 1874.50Q1673 1829 1751 1751Q1829 1673 1874.50 1568Q1920 1463 1920 1344L1920 1344Q1920 1225 1874.50 1120Q1829 1015 1751 937Q1673 859 1568 813.50Q1463 768 1344 768L1344 768Q1225 768 1120 813.50Q1015 859 937 937Q859 1015 813.50 1120Q768 1225 768 1344L768 1344Q768 1463 813.50 1568Q859 1673 937 1751Q1015 1829 1120 1874.50Q1225 1920 1344 1920ZM1600 1312L1600 1312Q1560 1312 1532 1284Q1504 1256 1504 1216L1504 1216Q1504 1176 1532 1148Q1560 1120 1600 1120L1600 1120Q1640 1120 1668 1148Q1696 1176 1696 1216L1696 1216Q1696 1256 1668 1284Q1640 1312 1600 1312ZM1088 1312L1088 1312Q1048 1312 1020 1284Q992 1256 992 1216L992 1216Q992 1176 1020 1148Q1048 1120 1088 1120L1088 1120Q1128 1120 1156 1148Q1184 1176 1184 1216L1184 1216Q1184 1256 1156 1284Q1128 1312 1088 1312ZM1344 1664L1344 1664Q1387 1664 1428 1652.50Q1469 1641 1505 1619.50Q1541 1598 1571 1568Q1601 1538 1622 1500L1622 1500L1733 1563Q1703 1616 1661 1658.50Q1619 1701 1569 1730.50Q1519 1760 1462 1776Q1405 1792 1344 1792L1344 1792Q1283 1792 1226 1776Q1169 1760 1118.50 1730.50Q1068 1701 1026.50 1658.50Q985 1616 955 1563L955 1563L1066 1500Q1087 1538 1117 1568Q1147 1598 1183 1619.50Q1219 1641 1259.50 1652.50Q1300 1664 1344 1664ZM448 528L448 528Q415 528 391.50 504.50Q368 481 368 448L368 448Q368 415 391.50 391.50Q415 368 448 368L448 368Q481 368 504.50 391.50Q528 415 528 448L528 448Q528 481 504.50 504.50Q481 528 448 528ZM832 528L832 528Q799 528 775.50 504.50Q752 481 752 448L752 448Q752 415 775.50 391.50Q799 368 832 368L832 368Q865 368 888.50 391.50Q912 415 912 448L912 448Q912 481 888.50 504.50Q865 528 832 528Z"
         }
      }
   ]
}

var Send = {
   name: "Send",
   vendor: "UiFabric",
   unicode: 59172,
   value: "",
   charCode: "E724",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M18 77L1997 960L18 1843L238 960L18 77ZM1545 899L206 301L355 899L1545 899ZM1533 1027L353 1027L206 1619L1533 1027Z"
         }
      }
   ]
}

var IncreaseIndentHangingMirrored = {
   name: "IncreaseIndentHangingMirrored",
   vendor: "UiFabric",
   unicode: 58270,
   value: "",
   charCode: "E39E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 256L128 256L128 128ZM896 1792L128 1792L128 1664L896 1664L896 1792ZM896 768L128 768L128 640L896 640L896 768ZM896 1280L128 1280L128 1152L896 1152L896 1280ZM1402 896L2048 896L2048 1024L1402 1024L1565 1187L1475 1277L1158 960L1475 643L1565 733L1402 896Z"
         }
      }
   ]
}

var IncreaseIndentHanging = {
   name: "IncreaseIndentHanging",
   vendor: "UiFabric",
   unicode: 58269,
   value: "",
   charCode: "E39D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L128 128L1920 128L1920 256L128 256ZM1920 1792L1152 1792L1152 1664L1920 1664L1920 1792ZM1920 768L1152 768L1152 640L1920 640L1920 768ZM1920 1280L1152 1280L1152 1152L1920 1152L1920 1280ZM646 896L483 733L573 643L890 960L573 1277L483 1187L646 1024L0 1024L0 896L646 896Z"
         }
      }
   ]
}

var DecreaseIndentMirrored = {
   name: "DecreaseIndentMirrored",
   vendor: "UiFabric",
   unicode: 58268,
   value: "",
   charCode: "E39C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 256L128 256L128 128ZM1920 1792L128 1792L128 1664L1920 1664L1920 1792ZM128 640L896 640L896 768L128 768L128 640ZM128 1152L896 1152L896 1280L128 1280L128 1152ZM2048 960L1731 1277L1641 1187L1804 1024L1158 1024L1158 896L1804 896L1641 733L1731 643L2048 960Z"
         }
      }
   ]
}

var DecreaseIndent = {
   name: "DecreaseIndent",
   vendor: "UiFabric",
   unicode: 58267,
   value: "",
   charCode: "E39B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L128 128L1920 128L1920 256L128 256ZM1920 1792L128 1792L128 1664L1920 1664L1920 1792ZM1920 768L1152 768L1152 640L1920 640L1920 768ZM1920 1280L1152 1280L1152 1152L1920 1152L1920 1280ZM0 960L317 643L407 733L244 896L890 896L890 1024L244 1024L407 1187L317 1277L0 960Z"
         }
      }
   ]
}

var IncreaseIndentMirrored = {
   name: "IncreaseIndentMirrored",
   vendor: "UiFabric",
   unicode: 58266,
   value: "",
   charCode: "E39A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L1920 128L1920 256L128 256L128 128ZM1920 1792L128 1792L128 1664L1920 1664L1920 1792ZM128 640L896 640L896 768L128 768L128 640ZM128 1152L896 1152L896 1280L128 1280L128 1152ZM1565 733L1402 896L2048 896L2048 1024L1402 1024L1565 1187L1475 1277L1158 960L1475 643L1565 733Z"
         }
      }
   ]
}

var IncreaseIndent = {
   name: "IncreaseIndent",
   vendor: "UiFabric",
   unicode: 58265,
   value: "",
   charCode: "E399",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 256L128 128L1920 128L1920 256L128 256ZM1920 1792L128 1792L128 1664L1920 1664L1920 1792ZM1920 768L1152 768L1152 640L1920 640L1920 768ZM1920 1280L1152 1280L1152 1152L1920 1152L1920 1280ZM573 1277L483 1187L646 1024L0 1024L0 896L646 896L483 733L573 643L890 960L573 1277Z"
         }
      }
   ]
}

var NumberedListMirrored = {
   name: "NumberedListMirrored",
   vendor: "UiFabric",
   unicode: 58264,
   value: "",
   charCode: "E398",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L0 512L0 384L1536 384L1536 512ZM1536 1024L0 1024L0 896L1536 896L1536 1024ZM1536 1536L0 1536L0 1408L1536 1408L1536 1536ZM1847 381L1847 381L1847 312Q1878 301 1906 288Q1934 275 1960 255L1960 255L2009 255L2009 640L1927 640L1927 349Q1913 360 1889.50 370.50Q1866 381 1847 381ZM1888 1083L2048 1083L2048 1152L1797 1152L1797 1124Q1797 1090 1809.50 1065Q1822 1040 1840 1020.50Q1858 1001 1880 985.50Q1902 970 1920 954.50Q1938 939 1950.50 922.50Q1963 906 1963 884L1963 884Q1963 857 1948 846Q1933 835 1908 835L1908 835Q1882 835 1858.50 846Q1835 857 1815 874L1815 874L1815 801Q1865 769 1926 769L1926 769Q1951 769 1973.50 775.50Q1996 782 2012.50 795.50Q2029 809 2038.50 829Q2048 849 2048 876L2048 876Q2048 907 2036 930.50Q2024 954 2006.50 972.50Q1989 991 1968 1005.50Q1947 1020 1929.50 1032.50Q1912 1045 1900 1057.50Q1888 1070 1888 1083L1888 1083ZM1962 1467L1962 1468Q1998 1473 2023 1495Q2048 1517 2048 1556L2048 1556Q2048 1587 2035.50 1609Q2023 1631 2003 1644.50Q1983 1658 1956.50 1664.50Q1930 1671 1903 1671L1903 1671Q1879 1671 1854.50 1667Q1830 1663 1808 1652L1808 1652L1808 1579Q1827 1593 1849.50 1600Q1872 1607 1896 1607L1896 1607Q1922 1607 1942.50 1596Q1963 1585 1963 1555L1963 1555Q1963 1537 1954 1526.50Q1945 1516 1931 1511Q1917 1506 1900 1504.50Q1883 1503 1868 1503L1868 1503L1846 1503L1846 1439L1872 1439Q1885 1439 1899.50 1437.50Q1914 1436 1925.50 1431.50Q1937 1427 1944.50 1417.50Q1952 1408 1952 1391L1952 1391Q1952 1365 1935.50 1355Q1919 1345 1896 1345L1896 1345Q1857 1345 1822 1369L1822 1369L1822 1301Q1844 1290 1867.50 1285.50Q1891 1281 1915 1281L1915 1281Q1937 1281 1959 1286Q1981 1291 1998 1302.50Q2015 1314 2026 1332Q2037 1350 2037 1375L2037 1375Q2037 1413 2017.50 1435.50Q1998 1458 1962 1467L1962 1467Z"
         }
      }
   ]
}

var AltText = {
   name: "AltText",
   vendor: "UiFabric",
   unicode: 58263,
   value: "",
   charCode: "E397",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 704L1536 704Q1536 678 1555 659Q1574 640 1600 640L1600 640Q1626 640 1645 659Q1664 678 1664 704L1664 704Q1664 730 1645 749Q1626 768 1600 768L1600 768Q1574 768 1555 749Q1536 730 1536 704ZM0 1792L0 256L2048 256L2048 1280L1920 1280L1920 384L128 384L128 1061L576 614L1216 1254L1472 998L1755 1280L1573 1280L1472 1178L1371 1280L1061 1280L576 794L128 1243L128 1664L640 1664L640 1792L0 1792ZM2048 2048L768 2048L768 1408L2048 1408L2048 2048ZM1920 1536L896 1536L896 1920L1920 1920L1920 1536ZM1664 1792L1152 1792L1152 1664L1664 1664L1664 1792Z"
         }
      }
   ]
}

var ArchiveUndo = {
   name: "ArchiveUndo",
   vendor: "UiFabric",
   unicode: 58273,
   value: "",
   charCode: "E3A1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 1152L1728 1152Q1795 1152 1853.50 1177.50Q1912 1203 1955.50 1246.50Q1999 1290 2023.50 1349Q2048 1408 2048 1475L2048 1475Q2048 1566 2014 1646.50Q1980 1727 1917 1792L1917 1792Q1891 1818 1864 1842Q1837 1866 1810 1890L1810 1890Q1765 1930 1722 1969.50Q1679 2009 1634 2048L1634 2048L1536 1957Q1582 1918 1627 1879Q1672 1840 1717 1800L1717 1800Q1745 1776 1772.50 1751.50Q1800 1727 1826 1701L1826 1701Q1873 1653 1896.50 1596.50Q1920 1540 1920 1472L1920 1472Q1920 1431 1904.50 1396Q1889 1361 1863 1335Q1837 1309 1801 1294.50Q1765 1280 1725 1280L1725 1280Q1659 1280 1608.50 1301.50Q1558 1323 1516.50 1359Q1475 1395 1440 1441Q1405 1487 1371 1536L1371 1536L1664 1536L1664 1664L1152 1664L1152 1152L1280 1152L1280 1438Q1326 1377 1371 1325Q1416 1273 1467.50 1234.50Q1519 1196 1582 1174Q1645 1152 1728 1152ZM0 768L0 128L2048 128L2048 768L1920 768L1920 1024L1792 1024L1792 768L256 768L256 1792L1408 1792L1408 1920L128 1920L128 768L0 768ZM128 640L1920 640L1920 256L128 256L128 640ZM1024 1024L1024 1152L640 1152L640 1024L1024 1024Z"
         }
      }
   ]
}

var LeaveUser = {
   name: "LeaveUser",
   vendor: "UiFabric",
   unicode: 58280,
   value: "",
   charCode: "E3A8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1402 1536L2048 1536L2048 1664L1402 1664L1613 1875L1523 1965L1158 1600L1523 1235L1613 1325L1402 1536ZM1292 1103L1292 1103L1204 1196Q1115 1112 1002.50 1068Q890 1024 768 1024L768 1024Q680 1024 598 1047Q516 1070 445 1111.50Q374 1153 315.50 1211.50Q257 1270 215.50 1341Q174 1412 151 1494Q128 1576 128 1664L128 1664L0 1664Q0 1547 35.50 1435Q71 1323 136.50 1227.50Q202 1132 293.50 1058.50Q385 985 496 946L496 946Q440 910 395.50 863Q351 816 320 760Q289 704 272.50 641.50Q256 579 256 512L256 512Q256 406 296 312.50Q336 219 405.50 149.50Q475 80 568.50 40Q662 0 768 0L768 0Q874 0 967.50 40Q1061 80 1130.50 149.50Q1200 219 1240 312.50Q1280 406 1280 512L1280 512Q1280 649 1216.50 760.50Q1153 872 1040 946L1040 946Q1110 972 1173.50 1012Q1237 1052 1292 1103ZM384 512L384 512Q384 592 414 661.50Q444 731 496.50 783.50Q549 836 618.50 866Q688 896 768 896L768 896Q847 896 917 866Q987 836 1039.50 783.50Q1092 731 1122 661.50Q1152 592 1152 512L1152 512Q1152 433 1122 363Q1092 293 1039.50 240.50Q987 188 917 158Q847 128 768 128L768 128Q688 128 618.50 158Q549 188 496.50 240.50Q444 293 414 363Q384 433 384 512Z"
         }
      }
   ]
}

var Insights = {
   name: "Insights",
   vendor: "UiFabric",
   unicode: 58287,
   value: "",
   charCode: "E3AF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 384L960 384Q1079 384 1184 429.50Q1289 475 1367 553Q1445 631 1490.50 736Q1536 841 1536 960L1536 960Q1536 1023 1528 1078Q1520 1133 1502.50 1183.50Q1485 1234 1458.50 1282.50Q1432 1331 1395 1382L1395 1382Q1366 1422 1344 1454Q1322 1486 1308 1518.50Q1294 1551 1287 1588.50Q1280 1626 1280 1677L1280 1677L1280 1856Q1280 1896 1265 1931Q1250 1966 1224 1992Q1198 2018 1163 2033Q1128 2048 1088 2048L1088 2048L832 2048Q792 2048 757 2033Q722 2018 696 1992Q670 1966 655 1931Q640 1896 640 1856L640 1856L640 1676Q640 1625 633 1588Q626 1551 611.50 1518.50Q597 1486 575.50 1454Q554 1422 525 1382L525 1382Q488 1331 461.50 1282.50Q435 1234 417.50 1183.50Q400 1133 392 1078Q384 1023 384 960L384 960Q384 841 429.50 736Q475 631 553 553Q631 475 736 429.50Q841 384 960 384ZM1152 1856L1152 1856L1152 1792L768 1792L768 1856Q768 1882 787 1901Q806 1920 832 1920L832 1920L1088 1920Q1114 1920 1133 1901Q1152 1882 1152 1856ZM1408 960L1408 960Q1408 867 1373 785.50Q1338 704 1277 643Q1216 582 1134.50 547Q1053 512 960 512L960 512Q867 512 785.50 547Q704 582 643 643Q582 704 547 785.50Q512 867 512 960L512 960Q512 1049 530.50 1113Q549 1177 577.50 1227.50Q606 1278 638.50 1321.50Q671 1365 699.50 1413.50Q728 1462 747.50 1521.50Q767 1581 768 1664L768 1664L1152 1664Q1153 1581 1172.50 1521.50Q1192 1462 1220.50 1413.50Q1249 1365 1281.50 1321.50Q1314 1278 1342.50 1227.50Q1371 1177 1389.50 1113Q1408 1049 1408 960ZM960 256L960 256Q934 256 915 237Q896 218 896 192L896 192L896 64Q896 38 915 19Q934 0 960 0L960 0Q986 0 1005 19Q1024 38 1024 64L1024 64L1024 192Q1024 218 1005 237Q986 256 960 256ZM192 928L192 928L64 928Q38 928 19 909Q0 890 0 864L0 864Q0 838 19 819Q38 800 64 800L64 800L192 800Q218 800 237 819Q256 838 256 864L256 864Q256 890 237 909Q218 928 192 928ZM245 1189L245 1189Q271 1189 290 1208Q309 1227 309 1254L309 1254Q309 1274 297.50 1289.50Q286 1305 268 1313L268 1313Q257 1318 237.50 1326.50Q218 1335 197 1343.50Q176 1352 156.50 1358.50Q137 1365 125 1365L125 1365Q99 1365 80 1346Q61 1327 61 1300L61 1300Q61 1280 72.50 1264.50Q84 1249 102 1241L102 1241Q113 1237 132.50 1228Q152 1219 173 1210.50Q194 1202 213.50 1195.50Q233 1189 245 1189ZM397 544L397 544Q397 570 378 589Q359 608 333 608L333 608Q315 608 300 599L300 599L191 532Q177 523 168.50 508.50Q160 494 160 477L160 477Q160 451 179 432Q198 413 224 413L224 413Q240 413 257 423L257 423L367 489Q381 497 389 512Q397 527 397 544ZM480 176L480 176Q480 150 499 131Q518 112 544 112L544 112Q561 112 576.50 121Q592 130 600 145L600 145L662 257Q670 271 670 287L670 287Q670 314 651 333Q632 352 606 352L606 352Q589 352 573.50 343Q558 334 550 319L550 319L488 207Q480 193 480 176ZM1728 800L1856 800Q1882 800 1901 819Q1920 838 1920 864L1920 864Q1920 890 1901 909Q1882 928 1856 928L1856 928L1728 928Q1702 928 1683 909Q1664 890 1664 864L1664 864Q1664 838 1683 819Q1702 800 1728 800L1728 800ZM1858 1301L1858 1301Q1858 1327 1839 1346Q1820 1365 1794 1365L1794 1365Q1783 1365 1763.50 1358.50Q1744 1352 1723 1343Q1702 1334 1682.50 1325.50Q1663 1317 1652 1312L1652 1312Q1634 1304 1622.50 1288Q1611 1272 1611 1252L1611 1252Q1611 1225 1630.50 1206.50Q1650 1188 1676 1188L1676 1188Q1688 1188 1707 1195Q1726 1202 1747 1211Q1768 1220 1787.50 1229Q1807 1238 1818 1242L1818 1242Q1836 1250 1847 1265.50Q1858 1281 1858 1301ZM1587 608L1587 608Q1561 608 1542 589Q1523 570 1523 544L1523 544Q1523 527 1531 512Q1539 497 1553 489L1553 489L1663 423Q1680 413 1696 413L1696 413Q1722 413 1741 432Q1760 451 1760 477L1760 477Q1760 494 1751.50 508.50Q1743 523 1729 532L1729 532L1620 599Q1605 608 1587 608ZM1250 287L1250 287Q1250 271 1258 257L1258 257L1320 145Q1328 130 1343.50 121Q1359 112 1376 112L1376 112Q1402 112 1421 131Q1440 150 1440 176L1440 176Q1440 193 1432 207L1432 207L1370 319Q1362 334 1346.50 343Q1331 352 1314 352L1314 352Q1288 352 1269 333Q1250 314 1250 287Z"
         }
      }
   ]
}

var MapPin12 = {
   name: "MapPin12",
   vendor: "UiFabric",
   unicode: 58286,
   value: "",
   charCode: "E3AE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1024L1536 1024L1877 2048L0 2048L341 1024L853 1024L853 650Q796 636 749 604.50Q702 573 668.50 529Q635 485 616 431.50Q597 378 597 320L597 320Q597 249 624 187Q651 125 697.50 78.50Q744 32 806 5.50Q868-21 939-21L939-21Q1009-21 1071.50 6Q1134 33 1180 79Q1226 125 1253 187.50Q1280 250 1280 320L1280 320Q1280 378 1261 431.50Q1242 485 1208.50 529Q1175 573 1128 604.50Q1081 636 1024 650L1024 650L1024 1024ZM768 320L768 320Q768 355 781.50 386.50Q795 418 818 441Q841 464 872.50 477.50Q904 491 939 491L939 491Q974 491 1005 477.50Q1036 464 1059 441Q1082 418 1095.50 386.50Q1109 355 1109 320L1109 320Q1109 285 1095.50 254Q1082 223 1059 199.50Q1036 176 1005 162.50Q974 149 939 149L939 149Q904 149 872.50 162.50Q841 176 818 199.50Q795 223 781.50 254Q768 285 768 320ZM853 1195L464 1195L237 1877L1640 1877L1413 1195L1024 1195L1024 1451Q1024 1486 999 1511Q974 1536 939 1536L939 1536Q921 1536 905.50 1529.50Q890 1523 878.50 1511.50Q867 1500 860 1484.50Q853 1469 853 1451L853 1451L853 1195Z"
         }
      }
   ]
}

var RedEye12 = {
   name: "RedEye12",
   vendor: "UiFabric",
   unicode: 58285,
   value: "",
   charCode: "E3AD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 512L1024 512Q1174 512 1316 551Q1458 590 1588.50 658.50Q1719 727 1834.50 821Q1950 915 2048 1024L2048 1024Q1950 1134 1834.50 1227.50Q1719 1321 1588.50 1389.50Q1458 1458 1316 1497Q1174 1536 1024 1536L1024 1536Q874 1536 732 1497Q590 1458 459.50 1389.50Q329 1321 213 1227.50Q97 1134 0 1024L0 1024Q97 915 213 821Q329 727 459.50 658.50Q590 590 732 551Q874 512 1024 512ZM1024 1390L1024 1390Q1100 1390 1166.50 1361Q1233 1332 1282.50 1282.50Q1332 1233 1361 1166.50Q1390 1100 1390 1024L1390 1024Q1390 948 1361 881.50Q1332 815 1282.50 765.50Q1233 716 1166.50 687Q1100 658 1024 658L1024 658Q948 658 881.50 687Q815 716 765.50 765.50Q716 815 687 881.50Q658 948 658 1024L658 1024Q658 1100 687 1166.50Q716 1233 765.50 1282.50Q815 1332 881.50 1361Q948 1390 1024 1390ZM649 1336L649 1336Q594 1270 565 1190Q536 1110 536 1024L536 1024Q536 938 565 858Q594 778 649 712L649 712Q515 765 397.50 844.50Q280 924 177 1024L177 1024Q280 1124 397.50 1203.50Q515 1283 649 1336ZM1871 1024L1871 1024Q1768 924 1650.50 844.50Q1533 765 1399 712L1399 712Q1454 778 1483 858Q1512 938 1512 1024L1512 1024Q1512 1110 1483 1190Q1454 1270 1399 1336L1399 1336Q1533 1283 1650.50 1203.50Q1768 1124 1871 1024ZM1024 853L1024 853Q1059 853 1090 866.50Q1121 880 1144.50 903.50Q1168 927 1181.50 958Q1195 989 1195 1024L1195 1024Q1195 1059 1181.50 1090.50Q1168 1122 1144.50 1145Q1121 1168 1090 1181.50Q1059 1195 1024 1195L1024 1195Q989 1195 957.50 1181.50Q926 1168 903 1145Q880 1122 866.50 1090.50Q853 1059 853 1024L853 1024Q853 989 866.50 958Q880 927 903 903.50Q926 880 957.50 866.50Q989 853 1024 853Z"
         }
      }
   ]
}

var FabricFolderUpload = {
   name: "FabricFolderUpload",
   vendor: "UiFabric",
   unicode: 58284,
   value: "",
   charCode: "E3AC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1024L1920 1024L1920 512L1216 512Q1169 512 1139 518Q1109 524 1088 534Q1067 544 1052 556.50Q1037 569 1022 582.50Q1007 596 988 608.50Q969 621 940 631L940 631Q923 637 902 638.50Q881 640 864 640L864 640L128 640L128 1536L1536 1536L1536 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 932.50 141.50Q964 155 991 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 327.50Q1117 345 1132.50 358Q1148 371 1168 377.50Q1188 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM1017 425L1017 425Q1002 409 985.50 380.50Q969 352 950.50 324.50Q932 297 910.50 276.50Q889 256 864 256L864 256L128 256L128 512L864 512Q891 512 910 502.50Q929 493 946 479.50Q963 466 979.50 451Q996 436 1017 425ZM1499 1408L1408 1317L1728 998L2048 1317L1957 1408L1792 1243L1792 1920L1664 1920L1664 1243L1499 1408Z"
         }
      }
   ]
}

var TaskList = {
   name: "TaskList",
   vendor: "UiFabric",
   unicode: 58294,
   value: "",
   charCode: "E3B6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 384L768 256L2048 256L2048 384L768 384ZM2048 1024L768 1024L768 896L2048 896L2048 1024ZM2048 1664L768 1664L768 1536L2048 1536L2048 1664ZM256 768L256 768Q309 768 355.50 788Q402 808 437 843Q472 878 492 924.50Q512 971 512 1024L512 1024Q512 1077 492 1123.50Q472 1170 437 1205Q402 1240 355.50 1260Q309 1280 256 1280L256 1280Q203 1280 156.50 1260Q110 1240 75 1205Q40 1170 20 1123.50Q0 1077 0 1024L0 1024Q0 971 20 924.50Q40 878 75 843Q110 808 156.50 788Q203 768 256 768ZM256 1168L256 1168Q286 1168 312 1156.50Q338 1145 357.50 1125.50Q377 1106 388.50 1080Q400 1054 400 1024L400 1024Q400 994 388.50 968Q377 942 357.50 922.50Q338 903 312 891.50Q286 880 256 880L256 880Q226 880 200 891.50Q174 903 154.50 922.50Q135 942 123.50 968Q112 994 112 1024L112 1024Q112 1054 123.50 1080Q135 1106 154.50 1125.50Q174 1145 200 1156.50Q226 1168 256 1168ZM256 1408L256 1408Q309 1408 355.50 1428Q402 1448 437 1483Q472 1518 492 1564.50Q512 1611 512 1664L512 1664Q512 1717 492 1763.50Q472 1810 437 1845Q402 1880 355.50 1900Q309 1920 256 1920L256 1920Q203 1920 156.50 1900Q110 1880 75 1845Q40 1810 20 1763.50Q0 1717 0 1664L0 1664Q0 1611 20 1564.50Q40 1518 75 1483Q110 1448 156.50 1428Q203 1408 256 1408ZM256 1808L256 1808Q286 1808 312 1796.50Q338 1785 357.50 1765.50Q377 1746 388.50 1720Q400 1694 400 1664L400 1664Q400 1634 388.50 1608Q377 1582 357.50 1562.50Q338 1543 312 1531.50Q286 1520 256 1520L256 1520Q226 1520 200 1531.50Q174 1543 154.50 1562.50Q135 1582 123.50 1608Q112 1634 112 1664L112 1664Q112 1694 123.50 1720Q135 1746 154.50 1765.50Q174 1785 200 1796.50Q226 1808 256 1808ZM109 275L192 358L467 83L557 173L192 538L19 365L109 275Z"
         }
      }
   ]
}

var MachineLearning = {
   name: "MachineLearning",
   vendor: "UiFabric",
   unicode: 58296,
   value: "",
   charCode: "E3B8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1740 410L1968 1095Q2006 1131 2027 1179Q2048 1227 2048 1280L2048 1280Q2048 1333 2028 1379.50Q2008 1426 1973 1461Q1938 1496 1891.50 1516Q1845 1536 1792 1536L1792 1536Q1771 1536 1750 1533L1750 1533L1279 1768Q1280 1774 1280 1780Q1280 1786 1280 1792L1280 1792Q1280 1845 1260 1891.50Q1240 1938 1205 1973Q1170 2008 1123.50 2028Q1077 2048 1024 2048L1024 2048Q972 2048 925.50 2028Q879 2008 843.50 1973.50Q808 1939 787.50 1893Q767 1847 767 1795L767 1795Q767 1788 767.50 1781.50Q768 1775 769 1768L769 1768L298 1533Q277 1536 256 1536L256 1536Q203 1536 156.50 1516Q110 1496 75 1461Q40 1426 20 1379.50Q0 1333 0 1280L0 1280Q0 1209 36.50 1148.50Q73 1088 135 1055L135 1055L310 413Q256 344 256 256L256 256Q256 203 276 156.50Q296 110 331 75Q366 40 412.50 20Q459 0 512 0L512 0Q581 0 640 34Q699 68 734 128L734 128L1314 128Q1349 68 1408 34Q1467 0 1536 0L1536 0Q1589 0 1635.50 20Q1682 40 1717 75Q1752 110 1772 156.50Q1792 203 1792 256L1792 256Q1792 298 1779 337.50Q1766 377 1740 410L1740 410ZM512 1280L1536 1280Q1536 1225 1558 1175Q1580 1125 1622 1089L1622 1089L1173 752L510 1249L512 1280ZM512 512L512 512Q465 512 420 495L420 495L276 1025Q331 1030 379.50 1056Q428 1082 461 1126L461 1126L1067 672L717 410Q680 458 626.50 485Q573 512 512 512ZM1280 672L1753 1027Q1761 1025 1771 1024.50Q1781 1024 1790 1024L1790 1024Q1795 1024 1800 1024Q1805 1024 1810 1025L1810 1025L1633 493Q1584 512 1536 512L1536 512Q1516 512 1497 509L1497 509L1280 672ZM1536 128L1536 128Q1509 128 1486 138Q1463 148 1445.50 165.50Q1428 183 1418 206Q1408 229 1408 256L1408 256Q1408 283 1418 306Q1428 329 1445.50 346.50Q1463 364 1486 374Q1509 384 1536 384L1536 384Q1563 384 1586 374Q1609 364 1626.50 346.50Q1644 329 1654 306Q1664 283 1664 256L1664 256Q1664 229 1654 206Q1644 183 1626.50 165.50Q1609 148 1586 138Q1563 128 1536 128ZM1280 256L1280 256L768 256L766 287L1173 592L1366 447Q1324 411 1302 361Q1280 311 1280 256ZM512 128L512 128Q485 128 462 138Q439 148 421.50 165.50Q404 183 394 206Q384 229 384 256L384 256Q384 283 394 306Q404 329 421.50 346.50Q439 364 462 374Q485 384 512 384L512 384Q539 384 562 374Q585 364 602.50 346.50Q620 329 630 306Q640 283 640 256L640 256Q640 229 630 206Q620 183 602.50 165.50Q585 148 562 138Q539 128 512 128ZM128 1280L128 1280Q128 1307 138 1330Q148 1353 165.50 1370.50Q183 1388 206 1398Q229 1408 256 1408L256 1408Q283 1408 306 1398Q329 1388 346.50 1370.50Q364 1353 374 1330Q384 1307 384 1280L384 1280Q384 1253 374 1230Q364 1207 346.50 1189.50Q329 1172 306 1162Q283 1152 256 1152L256 1152Q229 1152 206 1162Q183 1172 165.50 1189.50Q148 1207 138 1230Q128 1253 128 1280ZM1024 1920L1024 1920Q1051 1920 1074 1910Q1097 1900 1114.50 1882.50Q1132 1865 1142 1842Q1152 1819 1152 1792L1152 1792Q1152 1765 1142 1742Q1132 1719 1114.50 1701.50Q1097 1684 1074 1674Q1051 1664 1024 1664L1024 1664Q997 1664 974 1674Q951 1684 933.50 1701.50Q916 1719 906 1742Q896 1765 896 1792L896 1792Q896 1819 906 1842Q916 1865 933.50 1882.50Q951 1900 974 1910Q997 1920 1024 1920ZM1024 1536L1024 1536Q1087 1536 1143.50 1565.50Q1200 1595 1235 1647L1235 1647L1610 1460Q1599 1448 1588.50 1435Q1578 1422 1570 1408L1570 1408L478 1408Q470 1422 459.50 1435Q449 1448 438 1460L438 1460L813 1647Q848 1595 904.50 1565.50Q961 1536 1024 1536ZM1792 1408L1792 1408Q1819 1408 1842 1398Q1865 1388 1882.50 1370.50Q1900 1353 1910 1330Q1920 1307 1920 1280L1920 1280Q1920 1247 1904 1218Q1888 1189 1860 1172L1860 1172L1859 1173L1858 1172L1859 1171Q1827 1152 1792 1152L1792 1152Q1765 1152 1742 1162Q1719 1172 1701.50 1189.50Q1684 1207 1674 1230Q1664 1253 1664 1280L1664 1280Q1664 1307 1674 1330Q1684 1353 1701.50 1370.50Q1719 1388 1742 1398Q1765 1408 1792 1408Z"
         }
      }
   ]
}

var HealthRefresh = {
   name: "HealthRefresh",
   vendor: "UiFabric",
   unicode: 58301,
   value: "",
   charCode: "E3BD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M129 671L129 671Q129 718 140 768L140 768L9 768Q4 744 2.50 720Q1 696 1 672L1 672Q1 559 43.50 460Q86 361 159.50 287Q233 213 332 170.50Q431 128 544 128L544 128Q652 128 752.50 169Q853 210 929 287L929 287L1024 383L1119 287Q1195 210 1295.50 169Q1396 128 1504 128L1504 128Q1616 128 1715 170.50Q1814 213 1887.50 286Q1961 359 2003.50 458Q2046 557 2046 669L2046 669Q2046 767 2012 858Q1978 949 1915 1024L1915 1024L1445 1024L1344 922L1243 1024L1061 1024L1344 742L1499 896L1854 896Q1886 845 1903 788Q1920 731 1920 671L1920 671Q1920 584 1887.50 509Q1855 434 1798.50 378.50Q1742 323 1666.50 291.50Q1591 260 1504 260L1504 260Q1422 260 1345.50 290Q1269 320 1210 378L1210 378L1024 564L838 378Q778 318 703.50 287Q629 256 544 256L544 256Q458 256 382 288.50Q306 321 250 377.50Q194 434 161.50 509.50Q129 585 129 671ZM347 1024L308 1024L1009 1725Q1017 1766 1030.50 1805Q1044 1844 1064 1881L1064 1881L1024 1921L159 1057Q124 1022 97 981.50Q70 941 50 896L50 896L293 896L576 614L1024 1061L1024 1243L576 794L347 1024ZM1751 1179L1749 1179L1751 1179ZM2048 1601L2048 1601Q2048 1694 2013 1775Q1978 1856 1917.50 1916.50Q1857 1977 1775.50 2012Q1694 2047 1602 2047L1602 2047Q1509 2047 1428 2012Q1347 1977 1286 1916.50Q1225 1856 1190 1774.50Q1155 1693 1155 1601L1155 1601Q1155 1510 1190 1426.50Q1225 1343 1290 1280L1290 1280L1153 1280L1153 1152L1537 1152L1537 1536L1410 1536L1410 1345Q1350 1391 1316 1457.50Q1282 1524 1282 1600L1282 1600Q1282 1666 1307.50 1724.50Q1333 1783 1376.50 1826.50Q1420 1870 1478.50 1895.50Q1537 1921 1603 1921L1603 1921Q1669 1921 1727 1896Q1785 1871 1828.50 1827.50Q1872 1784 1897 1725.50Q1922 1667 1922 1601L1922 1601Q1922 1550 1906.50 1503Q1891 1456 1863 1416Q1835 1376 1795.50 1346Q1756 1316 1708 1299L1708 1299L1751 1179Q1818 1203 1872.50 1245Q1927 1287 1966 1342.50Q2005 1398 2026.50 1464Q2048 1530 2048 1601Z"
         }
      }
   ]
}

var SharedDatabase = {
   name: "SharedDatabase",
   vendor: "UiFabric",
   unicode: 58329,
   value: "",
   charCode: "E3D9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M960 768L960 768Q892 768 815.50 761.50Q739 755 662.50 739.50Q586 724 514 699Q442 674 384 637L384 637L384 1600Q384 1620 397 1635.50Q410 1651 424 1663L424 1663Q454 1689 495 1708Q536 1727 583.50 1741.50Q631 1756 682 1765.50Q733 1775 783 1781Q833 1787 879.50 1789.50Q926 1792 965 1792L965 1792Q1025 1792 1081 1786.50Q1137 1781 1197 1771L1197 1771Q1191 1781 1181 1799.50Q1171 1818 1162 1838.50Q1153 1859 1146 1878.50Q1139 1898 1139 1909L1139 1909Q1097 1917 1050.50 1918.50Q1004 1920 961 1920L961 1920Q928 1920 880 1917.50Q832 1915 776 1908Q720 1901 659.50 1889.50Q599 1878 541.50 1860.50Q484 1843 432 1819Q380 1795 341 1763.50Q302 1732 279 1691Q256 1650 256 1600L256 1600L256 448Q256 380 294.50 330Q333 280 395 244.50Q457 209 534.50 186Q612 163 690.50 150.50Q769 138 840 133Q911 128 960 128L960 128Q1009 128 1080 132.50Q1151 137 1229 150Q1307 163 1385 185.50Q1463 208 1525 243.50Q1587 279 1625.50 329.50Q1664 380 1664 448L1664 448L1664 1120Q1631 1120 1599 1126Q1567 1132 1536 1142L1536 1142L1536 637Q1478 674 1406 699Q1334 724 1257.50 739.50Q1181 755 1104.50 761.50Q1028 768 960 768ZM384 448L384 448Q384 459 387.50 467.50Q391 476 397 484L397 484Q421 516 462 539.50Q503 563 553 580.50Q603 598 659 609.50Q715 621 769.50 627.50Q824 634 873 637Q922 640 960 640L960 640Q998 640 1047 637Q1096 634 1150.50 627Q1205 620 1260.50 608.50Q1316 597 1365.50 580Q1415 563 1456 539Q1497 515 1522 484L1522 484Q1536 467 1536 448L1536 448Q1536 437 1532 428.50Q1528 420 1522 412L1522 412Q1497 381 1456.50 357Q1416 333 1366 316Q1316 299 1260.50 287.50Q1205 276 1151 269Q1097 262 1047.50 259Q998 256 960 256L960 256Q923 256 873.50 259Q824 262 769.50 269Q715 276 659 287.50Q603 299 553 316Q503 333 462 357Q421 381 397 412L397 412Q391 420 387.50 428.50Q384 437 384 448ZM1848 1713L1848 1713Q1894 1738 1931 1774Q1968 1810 1994 1853.50Q2020 1897 2034 1946.50Q2048 1996 2048 2048L2048 2048L1920 2048Q1920 1995 1900 1948Q1880 1901 1845.50 1866.50Q1811 1832 1764 1812Q1717 1792 1664 1792L1664 1792Q1611 1792 1564.50 1812Q1518 1832 1483 1867Q1448 1902 1428 1948.50Q1408 1995 1408 2048L1408 2048L1280 2048Q1280 1996 1294 1946.50Q1308 1897 1334 1853.50Q1360 1810 1397 1774Q1434 1738 1480 1713L1480 1713Q1445 1678 1426.50 1632Q1408 1586 1408 1536L1408 1536Q1408 1483 1428 1436.50Q1448 1390 1483 1355Q1518 1320 1564.50 1300Q1611 1280 1664 1280L1664 1280Q1717 1280 1763.50 1300Q1810 1320 1845 1355Q1880 1390 1900 1436.50Q1920 1483 1920 1536L1920 1536Q1920 1586 1901.50 1632Q1883 1678 1848 1713ZM1664 1664L1664 1664Q1690 1664 1713.50 1654Q1737 1644 1754.50 1626.50Q1772 1609 1782 1585.50Q1792 1562 1792 1536L1792 1536Q1792 1510 1782 1486.50Q1772 1463 1754.50 1445.50Q1737 1428 1713.50 1418Q1690 1408 1664 1408L1664 1408Q1637 1408 1614 1418Q1591 1428 1573.50 1445.50Q1556 1463 1546 1486Q1536 1509 1536 1536L1536 1536Q1536 1563 1546 1586Q1556 1609 1573.50 1626.50Q1591 1644 1614 1654Q1637 1664 1664 1664Z"
         }
      }
   ]
}

var WebEnvironment = {
   name: "WebEnvironment",
   vendor: "UiFabric",
   unicode: 58331,
   value: "",
   charCode: "E3DB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1688 1280L1920 1280L2048 1920L0 1920L128 1280L360 1280Q309 1192 282.50 1095Q256 998 256 896L256 896Q256 790 283.50 692Q311 594 361 508.50Q411 423 481 353Q551 283 636.50 233Q722 183 820 155.50Q918 128 1024 128L1024 128Q1130 128 1228 155.50Q1326 183 1411.50 233Q1497 283 1567 353Q1637 423 1687 508.50Q1737 594 1764.50 692Q1792 790 1792 896L1792 896Q1792 998 1765.50 1095Q1739 1192 1688 1280L1688 1280ZM1664 896L1664 896Q1664 864 1660.50 832Q1657 800 1651 768L1651 768L1402 768Q1408 833 1408 896L1408 896Q1408 960 1402 1024L1402 1024L1651 1024Q1657 992 1660.50 960Q1664 928 1664 896ZM774 1024L774 1024L1274 1024Q1280 960 1280 896L1280 896Q1280 833 1274 768L1274 768L774 768Q768 833 768 896L768 896Q768 960 774 1024ZM1256 1152L1256 1152L792 1152Q796 1175 806 1212.50Q816 1250 831.50 1293Q847 1336 866.50 1379Q886 1422 910.50 1457Q935 1492 963.50 1514Q992 1536 1024 1536L1024 1536Q1056 1536 1084.50 1514Q1113 1492 1137.50 1457Q1162 1422 1181.50 1379Q1201 1336 1216.50 1293Q1232 1250 1241.50 1212.50Q1251 1175 1256 1152ZM779 1487L779 1487Q733 1411 705 1325Q677 1239 662 1152L662 1152L438 1152Q462 1205 498 1255.50Q534 1306 578.50 1350Q623 1394 674 1429.50Q725 1465 779 1487ZM1610 1152L1386 1152Q1370 1238 1342.50 1324.50Q1315 1411 1270 1487L1270 1487Q1324 1463 1374.50 1428Q1425 1393 1469.50 1349.50Q1514 1306 1550 1256Q1586 1206 1610 1152L1610 1152ZM1386 640L1610 640Q1559 527 1471.50 440Q1384 353 1269 305L1269 305Q1315 381 1342.50 467Q1370 553 1386 640L1386 640ZM1024 256L1024 256Q992 256 963.50 278Q935 300 910.50 335Q886 370 866.50 413Q847 456 831.50 499Q816 542 806 579.50Q796 617 792 640L792 640L1256 640Q1251 617 1241.50 579.50Q1232 542 1216.50 499Q1201 456 1181.50 413Q1162 370 1137.50 335Q1113 300 1084.50 278Q1056 256 1024 256ZM779 305L779 305Q664 353 576.50 440Q489 527 438 640L438 640L662 640Q678 553 705.50 467Q733 381 779 305ZM646 768L397 768Q391 800 387.50 832Q384 864 384 896L384 896Q384 928 387.50 960Q391 992 397 1024L397 1024L646 1024Q640 960 640 896L640 896Q640 833 646 768L646 768ZM233 1408L156 1792L1892 1792L1815 1408L1595 1408Q1541 1469 1475.50 1516.50Q1410 1564 1337 1597Q1264 1630 1185 1647Q1106 1664 1024 1664L1024 1664Q942 1664 863 1647Q784 1630 711 1597Q638 1564 572.50 1516.50Q507 1469 453 1408L453 1408L233 1408Z"
         }
      }
   ]
}

var TagGroup = {
   name: "TagGroup",
   vendor: "UiFabric",
   unicode: 58358,
   value: "",
   charCode: "E3F6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 832L1600 832Q1573 832 1550 822Q1527 812 1509.50 794.50Q1492 777 1482 754Q1472 731 1472 704L1472 704Q1472 677 1482 654Q1492 631 1509.50 613.50Q1527 596 1550 586Q1573 576 1600 576L1600 576Q1627 576 1650 586Q1673 596 1690.50 613.50Q1708 631 1718 654Q1728 677 1728 704L1728 704Q1728 731 1718 754Q1708 777 1690.50 794.50Q1673 812 1650 822Q1627 832 1600 832ZM1792 0L1792 256L2048 256L2048 1115L1152 2011Q874 1732 595.50 1453Q317 1174 37 896L37 896L933 0L1792 0ZM1664 128L987 128L219 896L384 1061L1189 256L1664 256L1664 128ZM1152 1829L1920 1061L1920 384L1243 384L475 1152L1152 1829Z"
         }
      }
   ]
}

var AutomateFlow = {
   name: "AutomateFlow",
   vendor: "UiFabric",
   unicode: 58357,
   value: "",
   charCode: "E3F5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1147 128L821 768L1389 768L313 1792L56 1792L360 1152L0 1152L535 128L1147 128ZM258 1664L262 1664L1069 896L613 896L938 256L613 256L211 1024L562 1024L258 1664ZM2048 0L2048 640L1792 640L1792 1280L2048 1280L2048 1920L1408 1920L1408 1280L1664 1280L1664 1024L1280 1024L1408 896L1664 896L1664 640L1408 640L1408 0L2048 0ZM1920 1792L1920 1408L1536 1408L1536 1792L1920 1792ZM1536 128L1536 512L1920 512L1920 128L1536 128Z"
         }
      }
   ]
}

var TableBrandedColumn = {
   name: "TableBrandedColumn",
   vendor: "UiFabric",
   unicode: 58353,
   value: "",
   charCode: "E3F1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM1280 768L768 768L768 1152L1280 1152L1280 768ZM768 640L1280 640L1280 256L768 256L768 640ZM1280 1280L768 1280L768 1664L1280 1664L1280 1280Z"
         }
      }
   ]
}

var TableLastColumn = {
   name: "TableLastColumn",
   vendor: "UiFabric",
   unicode: 58352,
   value: "",
   charCode: "E3F0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM1280 768L768 768L768 1152L1280 1152L1280 768ZM128 1152L640 1152L640 768L128 768L128 1152ZM768 640L1280 640L1280 256L768 256L768 640ZM1280 1664L1280 1280L768 1280L768 1664L1280 1664ZM640 640L640 256L128 256L128 640L640 640ZM640 1280L128 1280L128 1664L640 1664L640 1280Z"
         }
      }
   ]
}

var TableFirstColumn = {
   name: "TableFirstColumn",
   vendor: "UiFabric",
   unicode: 58351,
   value: "",
   charCode: "E3EF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM1408 640L1920 640L1920 256L1408 256L1408 640ZM1280 256L768 256L768 640L1280 640L1280 256ZM1280 1280L768 1280L768 1664L1280 1664L1280 1280ZM768 768L768 1152L1280 1152L1280 768L768 768ZM1920 768L1408 768L1408 1152L1920 1152L1920 768ZM1408 1280L1408 1664L1920 1664L1920 1280L1408 1280Z"
         }
      }
   ]
}

var TableBrandedRow = {
   name: "TableBrandedRow",
   vendor: "UiFabric",
   unicode: 58350,
   value: "",
   charCode: "E3EE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM768 768L768 1152L1280 1152L1280 768L768 768ZM640 1152L640 768L128 768L128 1152L640 1152ZM1408 768L1408 1152L1920 1152L1920 768L1408 768Z"
         }
      }
   ]
}

var TableTotalRow = {
   name: "TableTotalRow",
   vendor: "UiFabric",
   unicode: 58349,
   value: "",
   charCode: "E3ED",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM1408 640L1920 640L1920 256L1408 256L1408 640ZM1280 1152L1280 768L768 768L768 1152L1280 1152ZM768 256L768 640L1280 640L1280 256L768 256ZM128 1152L640 1152L640 768L128 768L128 1152ZM1408 768L1408 1152L1920 1152L1920 768L1408 768ZM640 640L640 256L128 256L128 640L640 640Z"
         }
      }
   ]
}

var TableHeaderRow = {
   name: "TableHeaderRow",
   vendor: "UiFabric",
   unicode: 58348,
   value: "",
   charCode: "E3EC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM768 768L768 1152L1280 1152L1280 768L768 768ZM1280 1664L1280 1280L768 1280L768 1664L1280 1664ZM640 1152L640 768L128 768L128 1152L640 1152ZM1920 768L1408 768L1408 1152L1920 1152L1920 768ZM640 1280L128 1280L128 1664L640 1664L640 1280ZM1408 1280L1408 1664L1920 1664L1920 1280L1408 1280Z"
         }
      }
   ]
}

var RepeatHeaderRows = {
   name: "RepeatHeaderRows",
   vendor: "UiFabric",
   unicode: 58347,
   value: "",
   charCode: "E3EB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 2048L640 384L2048 384L2048 2048L640 2048ZM768 1920L1920 1920L1920 512L768 512L768 1920ZM1280 128L128 128L128 1536L512 1536L512 1664L0 1664L0 0L1408 0L1408 256L1280 256L1280 128ZM256 1408L256 256L512 256L512 640L384 640L384 1280L512 1280L512 1408L256 1408ZM1792 640L1792 1792L896 1792L896 640L1792 640ZM1280 1280L1280 1024L1024 1024L1024 1280L1280 1280ZM1024 1408L1024 1664L1280 1664L1280 1408L1024 1408ZM1408 1664L1664 1664L1664 1408L1408 1408L1408 1664ZM1408 1280L1664 1280L1664 1024L1408 1024L1408 1280Z"
         }
      }
   ]
}

var FixedColumnWidth = {
   name: "FixedColumnWidth",
   vendor: "UiFabric",
   unicode: 58346,
   value: "",
   charCode: "E3EA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 640L1920 0L2048 0L2048 768L0 768L0 0L128 0L128 640L384 640L384 384L512 384L512 640L768 640L768 128L896 128L896 640L1152 640L1152 384L1280 384L1280 640L1536 640L1536 128L1664 128L1664 640L1920 640ZM128 2048L0 2048L0 896L2048 896L2048 2048L1920 2048L1920 1920L1408 1920L1408 2048L1280 2048L1280 1920L768 1920L768 2048L640 2048L640 1920L128 1920L128 2048ZM768 1408L768 1792L1280 1792L1280 1408L768 1408ZM1408 1408L1408 1792L1920 1792L1920 1408L1408 1408ZM1920 1024L128 1024L128 1280L1920 1280L1920 1024ZM640 1792L640 1408L128 1408L128 1792L640 1792Z"
         }
      }
   ]
}

var AutoFitWindow = {
   name: "AutoFitWindow",
   vendor: "UiFabric",
   unicode: 58345,
   value: "",
   charCode: "E3E9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 2048L0 2048L0 896L2048 896L2048 2048L1920 2048L1920 1920L1408 1920L1408 2048L1280 2048L1280 1920L768 1920L768 2048L640 2048L640 1920L128 1920L128 2048ZM768 1792L1280 1792L1280 1408L768 1408L768 1792ZM1408 1792L1920 1792L1920 1408L1408 1408L1408 1792ZM1920 1024L128 1024L128 1280L1920 1280L1920 1024ZM640 1408L128 1408L128 1792L640 1792L640 1408ZM384 512L128 512L128 768L0 768L0 128L128 128L128 384L384 384L384 512ZM1920 384L1920 128L2048 128L2048 768L1920 768L1920 512L1536 512L1536 384L1920 384ZM1248 0L797 768L669 768L1120 0L1248 0ZM704 384L704 384Q664 384 629 369Q594 354 568 328Q542 302 527 267Q512 232 512 192L512 192Q512 152 527 117Q542 82 568 56Q594 30 629 15Q664 0 704 0L704 0Q744 0 779 15Q814 30 840 56Q866 82 881 117Q896 152 896 192L896 192Q896 232 881 267Q866 302 840 328Q814 354 779 369Q744 384 704 384ZM704 96L704 96Q664 96 636 124Q608 152 608 192L608 192Q608 232 636 260Q664 288 704 288L704 288Q744 288 772 260Q800 232 800 192L800 192Q800 152 772 124Q744 96 704 96ZM1024 576L1024 576Q1024 536 1039 501Q1054 466 1080 440Q1106 414 1141 399Q1176 384 1216 384L1216 384Q1256 384 1291 399Q1326 414 1352 440Q1378 466 1393 501Q1408 536 1408 576L1408 576Q1408 616 1393 651Q1378 686 1352 712Q1326 738 1291 753Q1256 768 1216 768L1216 768Q1176 768 1141 753Q1106 738 1080 712Q1054 686 1039 651Q1024 616 1024 576ZM1312 576L1312 576Q1312 536 1284 508Q1256 480 1216 480L1216 480Q1176 480 1148 508Q1120 536 1120 576L1120 576Q1120 616 1148 644Q1176 672 1216 672L1216 672Q1256 672 1284 644Q1312 616 1312 576Z"
         }
      }
   ]
}

var AutoFitContents = {
   name: "AutoFitContents",
   vendor: "UiFabric",
   unicode: 58344,
   value: "",
   charCode: "E3E8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 2048L0 2048L0 896L2048 896L2048 2048L1920 2048L1920 1920L1408 1920L1408 2048L1280 2048L1280 1920L768 1920L768 2048L640 2048L640 1920L128 1920L128 2048ZM768 1792L1280 1792L1280 1408L768 1408L768 1792ZM1408 1792L1920 1792L1920 1408L1408 1408L1408 1792ZM1920 1024L128 1024L128 1280L1920 1280L1920 1024ZM640 1408L128 1408L128 1792L640 1792L640 1408ZM512 512L128 512L128 768L0 768L0 128L128 128L128 384L512 384L512 512ZM1920 384L1920 128L2048 128L2048 768L1920 768L1920 512L1408 512L1408 384L1920 384ZM731 128L896 293L805 384L640 219L731 128ZM1189 128L1280 219L1115 384L1024 293L1189 128ZM1115 512L1280 677L1189 768L1024 603L1115 512ZM805 512L896 603L719 768L640 677L805 512Z"
         }
      }
   ]
}

var TextRotate270Degrees = {
   name: "TextRotate270Degrees",
   vendor: "UiFabric",
   unicode: 58343,
   value: "",
   charCode: "E3E7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM128 1664L1920 1664L1920 256L128 256L128 1664ZM896 1404L896 1507L256 1267L256 1165L896 925L896 1028L768 1076L768 1356L896 1404ZM640 1308L640 1124L393 1216L640 1308ZM1408 1530L1408 628L1245 791L1155 701L1472 384L1789 701L1699 791L1536 628L1536 1530L1408 1530Z"
         }
      }
   ]
}

var TextRotate90Degrees = {
   name: "TextRotate90Degrees",
   vendor: "UiFabric",
   unicode: 58342,
   value: "",
   charCode: "E3E6",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM128 1664L1920 1664L1920 256L128 256L128 1664ZM896 653L896 755L256 995L256 892L384 844L384 564L256 516L256 413L896 653ZM512 612L512 796L759 704L512 612ZM1699 1123L1789 1213L1472 1530L1155 1213L1245 1123L1408 1286L1408 384L1536 384L1536 1286L1699 1123Z"
         }
      }
   ]
}

var TextRotateHorizontal = {
   name: "TextRotateHorizontal",
   vendor: "UiFabric",
   unicode: 58341,
   value: "",
   charCode: "E3E5",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 1792L0 128L2048 128L2048 1792L0 1792ZM128 1664L1920 1664L1920 256L128 256L128 1664ZM716 896L436 896L388 1024L285 1024L525 384L627 384L867 1024L764 1024L716 896ZM668 768L576 521L484 768L668 768ZM1469 1533L1379 1443L1542 1280L256 1280L256 1152L1542 1152L1379 989L1469 899L1786 1216L1469 1533Z"
         }
      }
   ]
}

var TextParagraphOption = {
   name: "TextParagraphOption",
   vendor: "UiFabric",
   unicode: 58339,
   value: "",
   charCode: "E3E3",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M588 640L308 640L260 768L157 768L397 128L499 128L739 768L636 768L588 640ZM540 512L448 265L356 512L540 512ZM512 896L512 1670L675 1507L765 1597L448 1914L131 1597L221 1507L384 1670L384 896L512 896ZM1024 256L1024 128L1920 128L1920 256L1024 256ZM1920 768L1024 768L1024 640L1920 640L1920 768ZM1920 1280L1024 1280L1024 1152L1920 1152L1920 1280ZM1920 1792L1024 1792L1024 1664L1920 1664L1920 1792Z"
         }
      }
   ]
}

var TextRotation = {
   name: "TextRotation",
   vendor: "UiFabric",
   unicode: 58340,
   value: "",
   charCode: "E3E4",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1612 640L1332 640L1284 768L1181 768L1421 128L1523 128L1763 768L1660 768L1612 640ZM1564 512L1472 265L1380 512L1564 512ZM1536 1670L1699 1507L1789 1597L1472 1914L1155 1597L1245 1507L1408 1670L1408 896L1536 896L1536 1670ZM640 128L640 1670L803 1507L893 1597L576 1914L259 1597L349 1507L512 1670L512 128L640 128Z"
         }
      }
   ]
}

var TextAlignBottom = {
   name: "TextAlignBottom",
   vendor: "UiFabric",
   unicode: 58338,
   value: "",
   charCode: "E3E2",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 1024L128 896L1920 896L1920 1024L128 1024ZM384 1536L384 1408L1664 1408L1664 1536L384 1536ZM1920 2048L128 2048L128 1920L1920 1920L1920 2048Z"
         }
      }
   ]
}

var TextAlignMiddle = {
   name: "TextAlignMiddle",
   vendor: "UiFabric",
   unicode: 58337,
   value: "",
   charCode: "E3E1",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 512L128 384L1920 384L1920 512L128 512ZM384 1024L384 896L1664 896L1664 1024L384 1024ZM1920 1536L128 1536L128 1408L1920 1408L1920 1536Z"
         }
      }
   ]
}

var TextAlignTop = {
   name: "TextAlignTop",
   vendor: "UiFabric",
   unicode: 58336,
   value: "",
   charCode: "E3E0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 128L128 0L1920 0L1920 128L128 128ZM384 640L384 512L1664 512L1664 640L384 640ZM1920 1152L128 1152L128 1024L1920 1024L1920 1152Z"
         }
      }
   ]
}

var AddSpaceAfter = {
   name: "AddSpaceAfter",
   vendor: "UiFabric",
   unicode: 58335,
   value: "",
   charCode: "E3DF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 768L128 768L128 640L1920 640L1920 768ZM128 256L128 128L1920 128L1920 256L128 256ZM1024 896L1024 1542L1187 1379L1277 1469L960 1786L643 1469L733 1379L896 1542L896 896L1024 896Z"
         }
      }
   ]
}

var AddSpaceBefore = {
   name: "AddSpaceBefore",
   vendor: "UiFabric",
   unicode: 58334,
   value: "",
   charCode: "E3DE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1792L128 1792L128 1664L1920 1664L1920 1792ZM128 1280L128 1152L1920 1152L1920 1280L128 1280ZM1187 611L1277 701L960 1018L643 701L733 611L896 774L896 128L1024 128L1024 774L1187 611Z"
         }
      }
   ]
}

var IndentFirstLine = {
   name: "IndentFirstLine",
   vendor: "UiFabric",
   unicode: 58333,
   value: "",
   charCode: "E3DD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 256L1152 128L1920 128L1920 256L1152 256ZM1920 1792L768 1792L768 1664L1920 1664L1920 1792ZM1920 768L768 768L768 640L1920 640L1920 768ZM1920 1280L768 1280L768 1152L1920 1152L1920 1280ZM483 93L573 3L890 320L573 637L483 547L646 384L0 384L0 256L646 256L483 93Z"
         }
      }
   ]
}

var FormatPainter = {
   name: "FormatPainter",
   vendor: "UiFabric",
   unicode: 58332,
   value: "",
   charCode: "E3DC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2037 256L2037 256Q2037 304 2019 349Q2001 394 1966 429L1966 429L1627 768L1747 888Q1774 915 1788.50 950.50Q1803 986 1803 1024L1803 1024Q1803 1062 1788.50 1097.50Q1774 1133 1747 1160L1747 1160Q1721 1186 1694.50 1214Q1668 1242 1640 1265L1640 1265L888 1881L11 857L114 834Q197 815 261 796.50Q325 778 377.50 756Q430 734 474 706.50Q518 679 561 642Q604 605 649 557.50Q694 510 748 447L748 447Q781 409 816.50 373Q852 337 888 301L888 301Q915 274 950.50 259.50Q986 245 1024 245L1024 245Q1062 245 1097.50 259.50Q1133 274 1160 301L1160 301L1280 421L1619 82Q1654 47 1699 29Q1744 11 1792 11L1792 11Q1843 11 1887.50 30Q1932 49 1965.50 82.50Q1999 116 2018 160.50Q2037 205 2037 256ZM244 933L244 933L331 1035L1318 1364L1505 1211L835 542Q786 599 743.50 644Q701 689 660 726Q619 763 576.50 792.50Q534 822 484.50 846.50Q435 871 376.50 892Q318 913 244 933ZM1201 1460L493 1224L904 1703L1201 1460ZM1909 256L1909 256Q1909 232 1899.50 210.50Q1890 189 1874.50 173.50Q1859 158 1837.50 148.50Q1816 139 1792 139L1792 139Q1744 139 1710 173L1710 173L1280 603L1069 392Q1050 373 1024 373L1024 373Q1008 373 994 381Q980 389 967 401Q954 413 943 426Q932 439 922 448L922 448L1600 1126Q1609 1116 1622 1105Q1635 1094 1647 1081Q1659 1068 1667 1054Q1675 1040 1675 1024L1675 1024Q1675 998 1656 979L1656 979L1445 768L1875 338Q1909 304 1909 256Z"
         }
      }
   ]
}

var FontSize2 = {
   name: "FontSize2",
   vendor: "UiFabric",
   unicode: 58304,
   value: "",
   charCode: "E3C0",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L585 512L728 512L1310 2048L1152 2048L964 1536L343 1536L159 2048L0 2048ZM620 781L387 1409L916 1409L683 781Q663 728 655 673L655 673L650 673Q639 729 620 781L620 781ZM1833 513L1604 283L1374 513L1284 422L1604 102L1924 422L1833 513ZM1370 640L1600 870L1830 640L1920 730L1600 1050L1280 730L1370 640Z"
         }
      }
   ]
}

var ProcessingPause = {
   name: "ProcessingPause",
   vendor: "UiFabric",
   unicode: 58373,
   value: "",
   charCode: "E405",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1930 630L1930 630Q1930 676 1920 716L1920 716L2043 767L1995 885L1871 834Q1824 908 1750 955L1750 955L1801 1079L1683 1128L1632 1004Q1592 1014 1546 1014L1546 1014Q1500 1014 1460 1004L1460 1004L1409 1128L1291 1079L1342 955Q1268 908 1221 834L1221 834L1097 885L1048 767L1172 716Q1162 676 1162 630L1162 630Q1162 584 1172 544L1172 544L1048 493L1097 375L1221 426Q1268 352 1342 305L1342 305L1291 182L1409 133L1460 256Q1500 246 1546 246L1546 246Q1592 246 1632 256L1632 256L1683 133L1801 182L1750 305Q1824 352 1871 426L1871 426L1995 375L2043 493L1920 544Q1930 584 1930 630ZM1546 886L1546 886Q1599 886 1645.50 866Q1692 846 1727 811Q1762 776 1782 729.50Q1802 683 1802 630L1802 630Q1802 577 1782 530.50Q1762 484 1727 449Q1692 414 1645.50 394Q1599 374 1546 374L1546 374Q1493 374 1446.50 394Q1400 414 1365 449Q1330 484 1310 530.50Q1290 577 1290 630L1290 630Q1290 683 1310 729.50Q1330 776 1365 811Q1400 846 1446.50 866Q1493 886 1546 886ZM971 1105L1108 1048L1157 1167L1020 1223Q1034 1279 1034 1334L1034 1334Q1034 1389 1020 1445L1020 1445L1157 1502L1108 1620L971 1563Q941 1614 903 1651Q865 1688 815 1720L815 1720L872 1857L753 1905L697 1768Q641 1782 586 1782L586 1782Q531 1782 475 1768L475 1768L418 1905L300 1857L357 1720Q306 1688 269 1651Q232 1614 200 1563L200 1563L63 1620L15 1502L152 1445Q138 1389 138 1334L138 1334Q138 1279 152 1223L152 1223L15 1167L63 1048L200 1105Q232 1055 269 1017Q306 979 357 949L357 949L300 812L418 763L475 900Q531 886 586 886L586 886Q641 886 697 900L697 900L753 763L872 812L815 949Q912 1008 971 1105L971 1105ZM586 1654L586 1654Q652 1654 710 1629Q768 1604 811.50 1560.50Q855 1517 880.50 1458.50Q906 1400 906 1334L906 1334Q906 1268 880.50 1210Q855 1152 811.50 1108.50Q768 1065 710 1039.50Q652 1014 586 1014L586 1014Q520 1014 461.50 1039.50Q403 1065 359.50 1108.50Q316 1152 291 1210Q266 1268 266 1334L266 1334Q266 1400 291 1458.50Q316 1517 359.50 1560.50Q403 1604 461.50 1629Q520 1654 586 1654ZM1920 2048L1792 2048L1792 1280L1920 1280L1920 2048ZM1536 2048L1408 2048L1408 1280L1536 1280L1536 2048Z"
         }
      }
   ]
}

var ProcessingRun = {
   name: "ProcessingRun",
   vendor: "UiFabric",
   unicode: 58372,
   value: "",
   charCode: "E404",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1930 630L1930 630Q1930 652 1927.50 673.50Q1925 695 1920 716L1920 716L2043 767L1994 885L1870 834Q1824 908 1750 954L1750 954L1801 1079L1683 1128L1631 1004Q1610 1009 1589 1011.50Q1568 1014 1546 1014L1546 1014Q1524 1014 1502.50 1011.50Q1481 1009 1460 1004L1460 1004L1437 1060L1326 993L1342 954Q1268 908 1222 834L1222 834L1097 885L1048 767L1172 716Q1167 695 1164.50 673.50Q1162 652 1162 630L1162 630Q1162 608 1164.50 587Q1167 566 1172 545L1172 545L1048 493L1097 375L1222 427Q1245 390 1275 359.50Q1305 329 1342 306L1342 306L1291 182L1409 133L1460 256Q1481 251 1502.50 248.50Q1524 246 1546 246L1546 246Q1568 246 1589 248.50Q1610 251 1631 256L1631 256L1683 133L1801 182L1750 306Q1824 352 1870 426L1870 426L1994 375L2043 493L1920 545Q1925 566 1927.50 587Q1930 608 1930 630ZM1546 886L1546 886Q1599 886 1645.50 866Q1692 846 1727 811Q1762 776 1782 729.50Q1802 683 1802 630L1802 630Q1802 577 1782 530.50Q1762 484 1727 449Q1692 414 1645.50 394Q1599 374 1546 374L1546 374Q1493 374 1446.50 394Q1400 414 1365 449Q1330 484 1310 530.50Q1290 577 1290 630L1290 630Q1290 683 1310 729.50Q1330 776 1365 811Q1400 846 1446.50 866Q1493 886 1546 886ZM969 1106L969 1106L1108 1048L1152 1154L1152 1169L1019 1224Q1026 1251 1030 1278.50Q1034 1306 1034 1334L1034 1334Q1034 1362 1030 1389.50Q1026 1417 1019 1444L1019 1444L1152 1499L1152 1514L1108 1620L969 1562Q940 1610 901 1649.50Q862 1689 814 1718L814 1718L872 1857L753 1906L696 1767Q669 1774 641.50 1778Q614 1782 586 1782L586 1782Q558 1782 530.50 1778Q503 1774 476 1767L476 1767L418 1906L300 1857L358 1717Q261 1659 203 1562L203 1562L63 1620L15 1502L153 1444Q146 1417 142 1389.50Q138 1362 138 1334L138 1334Q138 1306 142 1278.50Q146 1251 153 1224L153 1224L15 1167L63 1048L203 1106Q261 1009 358 951L358 951L300 812L418 763L476 901Q503 894 530.50 890Q558 886 586 886L586 886Q614 886 641.50 890Q669 894 696 901L696 901L753 763L872 812L814 951Q911 1009 969 1106ZM586 1654L586 1654Q652 1654 710 1629Q768 1604 811.50 1560.50Q855 1517 880.50 1458.50Q906 1400 906 1334L906 1334Q906 1268 880.50 1210Q855 1152 811.50 1108.50Q768 1065 710 1039.50Q652 1014 586 1014L586 1014Q520 1014 461.50 1039.50Q403 1065 359.50 1108.50Q316 1152 291 1210Q266 1268 266 1334L266 1334Q266 1400 291 1458.50Q316 1517 359.50 1560.50Q403 1604 461.50 1629Q520 1654 586 1654ZM2027 1600L1280 2048L1280 1152L2027 1600ZM1778 1600L1408 1378L1408 1822L1778 1600Z"
         }
      }
   ]
}

var ProcessingCancel = {
   name: "ProcessingCancel",
   vendor: "UiFabric",
   unicode: 58371,
   value: "",
   charCode: "E403",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1546 1014L1546 1014Q1500 1014 1460 1004L1460 1004L1409 1128L1291 1079L1342 955Q1268 908 1221 834L1221 834L1097 885L1048 767L1172 716Q1162 676 1162 630L1162 630Q1162 584 1172 544L1172 544L1048 493L1097 375L1221 426Q1268 352 1342 305L1342 305L1291 182L1409 133L1460 256Q1500 246 1546 246L1546 246Q1592 246 1632 256L1632 256L1683 133L1801 182L1750 305Q1824 352 1871 426L1871 426L1995 375L2043 493L1920 544Q1930 584 1930 630L1930 630Q1930 676 1920 716L1920 716L2043 767L1995 885L1871 834Q1824 908 1750 955L1750 955L1801 1079L1683 1128L1632 1004Q1592 1014 1546 1014ZM1546 374L1546 374Q1493 374 1446.50 394Q1400 414 1365 449Q1330 484 1310 530.50Q1290 577 1290 630L1290 630Q1290 683 1310 729.50Q1330 776 1365 811Q1400 846 1446.50 866Q1493 886 1546 886L1546 886Q1599 886 1645.50 866Q1692 846 1727 811Q1762 776 1782 729.50Q1802 683 1802 630L1802 630Q1802 577 1782 530.50Q1762 484 1727 449Q1692 414 1645.50 394Q1599 374 1546 374ZM971 1105L1108 1048L1157 1167L1020 1223Q1034 1279 1034 1334L1034 1334Q1034 1389 1020 1445L1020 1445L1157 1502L1108 1620L971 1563Q941 1614 903 1651Q865 1688 815 1720L815 1720L872 1857L753 1905L697 1768Q641 1782 586 1782L586 1782Q531 1782 475 1768L475 1768L418 1905L300 1857L357 1720Q306 1688 269 1651Q232 1614 200 1563L200 1563L63 1620L15 1502L152 1445Q138 1389 138 1334L138 1334Q138 1279 152 1223L152 1223L15 1167L63 1048L200 1105Q232 1055 269 1017Q306 979 357 949L357 949L300 812L418 763L475 900Q531 886 586 886L586 886Q641 886 697 900L697 900L753 763L872 812L815 949Q912 1008 971 1105L971 1105ZM586 1654L586 1654Q652 1654 710 1629Q768 1604 811.50 1560.50Q855 1517 880.50 1458.50Q906 1400 906 1334L906 1334Q906 1268 880.50 1210Q855 1152 811.50 1108.50Q768 1065 710 1039.50Q652 1014 586 1014L586 1014Q520 1014 461.50 1039.50Q403 1065 359.50 1108.50Q316 1152 291 1210Q266 1268 266 1334L266 1334Q266 1400 291 1458.50Q316 1517 359.50 1560.50Q403 1604 461.50 1629Q520 1654 586 1654ZM1955 1411L2045 1501L1819 1728L2045 1955L1955 2045L1728 1818L1501 2045L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638L1955 1411Z"
         }
      }
   ]
}

var DeviceOff = {
   name: "DeviceOff",
   vendor: "UiFabric",
   unicode: 58370,
   value: "",
   charCode: "E402",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 384L128 384L128 1280L1085 1280Q1066 1310 1051.50 1342Q1037 1374 1026 1408L1026 1408L1024 1408L1024 1415Q1022 1427 1017.50 1439.50Q1013 1452 1010 1463L1010 1463Q1002 1497 997 1531Q992 1565 992 1600L992 1600Q992 1616 994 1632Q996 1648 998 1664L998 1664L640 1664L640 1536L896 1536L896 1408L0 1408L0 256L1920 256L1920 1085Q1890 1066 1858 1051.50Q1826 1037 1792 1026L1792 1026L1792 384ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var DeviceRun = {
   name: "DeviceRun",
   vendor: "UiFabric",
   unicode: 58369,
   value: "",
   charCode: "E401",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 384L128 384L128 1280L1152 1280L1152 1408L1024 1408L1024 1536L1152 1536L1152 1664L640 1664L640 1536L896 1536L896 1408L0 1408L0 256L1920 256L1920 1349L1792 1273L1792 384ZM1280 2048L1280 1152L2027 1600L1280 2048ZM1778 1600L1408 1378L1408 1822L1778 1600Z"
         }
      }
   ]
}

var BugBlock = {
   name: "BugBlock",
   vendor: "UiFabric",
   unicode: 58368,
   value: "",
   charCode: "E400",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 1920L1024 1920Q1038 1920 1053 1918Q1068 1916 1082 1914L1082 1914Q1101 1946 1122.50 1974.50Q1144 2003 1170 2029L1170 2029Q1134 2037 1097.50 2042.50Q1061 2048 1024 2048L1024 2048Q919 2048 822.50 2015Q726 1982 646 1923Q566 1864 506.50 1781Q447 1698 416 1598L416 1598Q385 1662 385 1730L385 1730Q385 1790 407 1843.50Q429 1897 471 1939L471 1939L381 2029Q321 1969 288.50 1891.50Q256 1814 256 1729L256 1729Q256 1644 288.50 1566Q321 1488 381 1428L381 1428L387 1434Q386 1427 385 1421Q384 1415 384 1408L384 1408L384 1152Q384 1122 387.50 1091.50Q391 1061 397 1032L397 1032Q366 1041 340 1058.50Q314 1076 295.50 1100.50Q277 1125 266.50 1154.50Q256 1184 256 1216L256 1216L256 1408L128 1408L128 1216Q128 1151 152.50 1093.50Q177 1036 219 993Q261 950 318 924.50Q375 899 440 897L440 897Q471 827 520 762L520 762Q463 752 414.50 723.50Q366 695 331 653Q296 611 276 558.50Q256 506 256 448L256 448L256 256L384 256L384 448Q384 488 399 523Q414 558 440 584Q466 610 501 625Q536 640 576 640L576 640L640 640L640 643Q687 608 736 584L736 584Q721 552 712.50 517.50Q704 483 704 448L704 448Q704 378 735 313L735 313L595 173L685 83L812 210Q857 171 910.50 149.50Q964 128 1024 128L1024 128Q1084 128 1137.50 149.50Q1191 171 1236 210L1236 210L1363 83L1453 173L1313 313Q1344 378 1344 448L1344 448Q1344 483 1335.50 517.50Q1327 552 1312 584L1312 584Q1338 597 1361.50 611.50Q1385 626 1408 643L1408 643L1408 640L1472 640Q1512 640 1547 625Q1582 610 1608 584Q1634 558 1649 523Q1664 488 1664 448L1664 448L1664 256L1792 256L1792 448Q1792 506 1772 558.50Q1752 611 1717 653Q1682 695 1633.50 723.50Q1585 752 1528 762L1528 762Q1577 827 1608 897L1608 897Q1650 898 1690 910Q1730 922 1765 944Q1800 966 1829 996Q1858 1026 1879 1063L1879 1063Q1814 1029 1743.50 1010.50Q1673 992 1600 992L1600 992Q1577 992 1555.50 995Q1534 998 1512 1001L1512 1001Q1487 922 1439 856Q1391 790 1326.50 742Q1262 694 1184.50 667Q1107 640 1024 640L1024 640Q919 640 826 681Q733 722 663.50 792Q594 862 553 955Q512 1048 512 1152L512 1152L512 1408Q512 1514 552.50 1607Q593 1700 662.50 1769.50Q732 1839 825 1879.50Q918 1920 1024 1920ZM1024 256L1024 256Q984 256 949 271Q914 286 888 312Q862 338 847 373Q832 408 832 448L832 448Q832 498 856 538L856 538Q898 527 939.50 520.50Q981 514 1024 514L1024 514Q1067 514 1108.50 520.50Q1150 527 1192 538L1192 538Q1216 498 1216 448L1216 448Q1216 408 1201 373Q1186 338 1160 312Q1134 286 1099 271Q1064 256 1024 256ZM2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var BugSync = {
   name: "BugSync",
   vendor: "UiFabric",
   unicode: 58367,
   value: "",
   charCode: "E3FF",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 640L1024 640Q919 640 826 681Q733 722 663.50 792Q594 862 553 955Q512 1048 512 1152L512 1152L512 1408Q512 1514 552.50 1607Q593 1700 662.50 1769.50Q732 1839 825 1879.50Q918 1920 1024 1920L1024 1920L1024 2048Q919 2048 822.50 2015Q726 1982 646 1923Q566 1864 506.50 1781Q447 1698 416 1598L416 1598Q385 1662 385 1730L385 1730Q385 1790 407 1843.50Q429 1897 471 1939L471 1939L381 2029Q321 1969 288.50 1891.50Q256 1814 256 1729L256 1729Q256 1644 288.50 1566Q321 1488 381 1428L381 1428L387 1434Q386 1427 385 1421Q384 1415 384 1408L384 1408L384 1152Q384 1122 387.50 1091.50Q391 1061 397 1032L397 1032Q366 1041 340 1058.50Q314 1076 295.50 1100.50Q277 1125 266.50 1154.50Q256 1184 256 1216L256 1216L256 1408L128 1408L128 1216Q128 1151 152.50 1093.50Q177 1036 219 993Q261 950 318 924.50Q375 899 440 897L440 897Q471 827 520 762L520 762Q463 752 414.50 723.50Q366 695 331 653Q296 611 276 558.50Q256 506 256 448L256 448L256 256L384 256L384 448Q384 488 399 523Q414 558 440 584Q466 610 501 625Q536 640 576 640L576 640L640 640L640 643Q687 608 736 584L736 584Q721 552 712.50 517.50Q704 483 704 448L704 448Q704 378 735 313L735 313L595 173L685 83L812 210Q857 171 910.50 149.50Q964 128 1024 128L1024 128Q1084 128 1137.50 149.50Q1191 171 1236 210L1236 210L1363 83L1453 173L1313 313Q1344 378 1344 448L1344 448Q1344 483 1335.50 517.50Q1327 552 1312 584L1312 584Q1338 597 1361.50 611.50Q1385 626 1408 643L1408 643L1408 640L1472 640Q1512 640 1547 625Q1582 610 1608 584Q1634 558 1649 523Q1664 488 1664 448L1664 448L1664 256L1792 256L1792 448Q1792 506 1772 558.50Q1752 611 1717 653Q1682 695 1633.50 723.50Q1585 752 1528 762L1528 762Q1577 827 1608 897L1608 897Q1682 899 1745.50 932.50Q1809 966 1854 1024L1854 1024L1518 1024Q1496 941 1448.50 870.50Q1401 800 1335.50 749Q1270 698 1190 669Q1110 640 1024 640ZM1024 256L1024 256Q984 256 949 271Q914 286 888 312Q862 338 847 373Q832 408 832 448L832 448Q832 498 856 538L856 538Q898 527 939.50 520.50Q981 514 1024 514L1024 514Q1067 514 1108.50 520.50Q1150 527 1192 538L1192 538Q1216 498 1216 448L1216 448Q1216 408 1201 373Q1186 338 1160 312Q1134 286 1099 271Q1064 256 1024 256ZM1920 1289L1920 1152L2048 1152L2048 1536L1664 1536L1664 1408L1854 1408Q1809 1348 1742 1314Q1675 1280 1600 1280L1600 1280Q1541 1280 1488.50 1300Q1436 1320 1394 1355.50Q1352 1391 1324 1440Q1296 1489 1286 1547L1286 1547L1159 1525Q1173 1444 1213 1376Q1253 1308 1311.50 1258Q1370 1208 1444 1180Q1518 1152 1600 1152L1600 1152Q1691 1152 1774 1187.50Q1857 1223 1920 1289L1920 1289ZM1600 1920L1600 1920Q1658 1920 1711 1900Q1764 1880 1806 1844.50Q1848 1809 1876 1760Q1904 1711 1914 1653L1914 1653L2041 1675Q2027 1756 1987 1824Q1947 1892 1888.50 1942Q1830 1992 1756 2020Q1682 2048 1600 2048L1600 2048Q1509 2048 1426 2012.50Q1343 1977 1280 1911L1280 1911L1280 2048L1152 2048L1152 1664L1536 1664L1536 1792L1346 1792Q1391 1852 1458 1886Q1525 1920 1600 1920Z"
         }
      }
   ]
}

var URLBlock = {
   name: "URLBlock",
   vendor: "UiFabric",
   unicode: 58366,
   value: "",
   charCode: "E3FE",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1351 1047L1351 1047Q1276 1081 1212 1134Q1148 1187 1100 1255L1100 1255Q1048 1273 999 1276.50Q950 1280 896 1280L896 1280L896 1152L960 1152Q1026 1152 1084 1127Q1142 1102 1185.50 1058.50Q1229 1015 1254.50 956.50Q1280 898 1280 832L1280 832Q1280 766 1254.50 708Q1229 650 1185.50 606.50Q1142 563 1084 537.50Q1026 512 960 512L960 512L448 512Q382 512 323.50 537.50Q265 563 221.50 606.50Q178 650 153 708Q128 766 128 832L128 832Q128 898 153 956.50Q178 1015 221.50 1058.50Q265 1102 323.50 1127Q382 1152 448 1152L448 1152L512 1152L512 1280L448 1280Q355 1280 273.50 1244.50Q192 1209 131.50 1148.50Q71 1088 35.50 1006.50Q0 925 0 832L0 832Q0 739 35.50 657.50Q71 576 131.50 515.50Q192 455 273.50 419.50Q355 384 448 384L448 384L960 384Q1053 384 1134.50 419.50Q1216 455 1276.50 515.50Q1337 576 1372.50 657.50Q1408 739 1408 832L1408 832Q1408 889 1393 943Q1378 997 1351 1047ZM1879 1063L1879 1063Q1858 1025 1828 994Q1798 963 1762 941.50Q1726 920 1685 908Q1644 896 1600 896L1600 896L1536 896L1536 768L1600 768Q1688 768 1767 800.50Q1846 833 1906 890Q1966 947 2003 1024Q2040 1101 2045 1189L2045 1189Q1974 1112 1879 1063ZM768 1216L768 1216Q768 1269 785 1318Q802 1367 833 1407.50Q864 1448 906.50 1477.50Q949 1507 1000 1522L1000 1522Q997 1542 994.50 1561Q992 1580 992 1600L992 1600Q992 1614 994 1627.50Q996 1641 998 1655L998 1655Q920 1639 854.50 1598Q789 1557 741 1498.50Q693 1440 666.50 1368Q640 1296 640 1216L640 1216Q640 1123 675.50 1041.50Q711 960 771.50 899.50Q832 839 913.50 803.50Q995 768 1088 768L1088 768L1152 768L1152 896L1088 896Q1022 896 963.50 921.50Q905 947 861.50 990.50Q818 1034 793 1092Q768 1150 768 1216ZM2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600ZM1600 1920L1600 1920Q1666 1920 1724 1895Q1782 1870 1825.50 1826.50Q1869 1783 1894.50 1724.50Q1920 1666 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1534 1280 1475.50 1305.50Q1417 1331 1373.50 1374.50Q1330 1418 1305 1476Q1280 1534 1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920ZM1792 1664L1408 1664L1408 1536L1792 1536L1792 1664Z"
         }
      }
   ]
}

var ServiceOff = {
   name: "ServiceOff",
   vendor: "UiFabric",
   unicode: 58365,
   value: "",
   charCode: "E3FD",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1044 710L1044 710L189 1566Q160 1595 144 1633Q128 1671 128 1713L128 1713Q128 1755 144.50 1793Q161 1831 189 1859Q217 1887 255 1903.50Q293 1920 335 1920L335 1920Q376 1920 414.50 1904Q453 1888 482 1859L482 1859L1024 1318L1024 1499L573 1950Q525 1998 463.50 2023Q402 2048 335 2048L335 2048Q266 2048 205.50 2021.50Q145 1995 99 1949Q53 1903 26.50 1842.50Q0 1782 0 1713L0 1713Q0 1644 25 1583.50Q50 1523 98 1475L98 1475L904 669Q900 646 898 622.50Q896 599 896 576L896 576Q896 497 916.50 423.50Q937 350 974.50 286Q1012 222 1065 169Q1118 116 1182 78.50Q1246 41 1319.50 20.50Q1393 0 1472 0L1472 0Q1526 0 1571.50 8.50Q1617 17 1659 32.50Q1701 48 1742 70Q1783 92 1828 118L1828 118L1434 512L1536 614L1930 220Q1954 262 1975.50 304.50Q1997 347 2013.50 391Q2030 435 2040 481.50Q2050 528 2050 577L2050 577Q2050 643 2033.50 708Q2017 773 1987 832.50Q1957 892 1914.50 943.50Q1872 995 1820 1035L1820 1035Q1774 1017 1726 1007Q1678 997 1628 995L1628 995Q1693 971 1747 929Q1801 887 1839.50 832.50Q1878 778 1899 713.50Q1920 649 1920 579L1920 579Q1920 504 1896 435L1896 435L1536 794L1254 512L1613 152Q1545 128 1472 128L1472 128Q1379 128 1297.50 163.50Q1216 199 1155.50 259.50Q1095 320 1059.50 401.50Q1024 483 1024 576L1024 576Q1024 610 1030 643.50Q1036 677 1044 710ZM1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var FileOff = {
   name: "FileOff",
   vendor: "UiFabric",
   unicode: 58364,
   value: "",
   charCode: "E3FC",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 1920L1085 1920Q1130 1991 1192 2048L1192 2048L128 2048L128 0L1243 0L1792 549L1792 1026Q1761 1015 1728.50 1008.50Q1696 1002 1664 998L1664 998L1664 640L1152 640L1152 128L256 128L256 1920ZM1573 512L1280 219L1280 512L1573 512ZM2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var DriverOff = {
   name: "DriverOff",
   vendor: "UiFabric",
   unicode: 58363,
   value: "",
   charCode: "E3FB",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 224L1152 224Q1125 224 1102 234Q1079 244 1061.50 261.50Q1044 279 1034 302Q1024 325 1024 352L1024 352L1024 512L640 512L640 896L416 896Q389 896 366 906Q343 916 325.50 933.50Q308 951 298 974Q288 997 288 1024L288 1024Q288 1051 298 1074Q308 1097 325.50 1114.50Q343 1132 366 1142Q389 1152 416 1152L416 1152L640 1152L640 1536L998 1536Q996 1552 994 1568Q992 1584 992 1600L992 1600Q992 1632 996 1663Q1000 1694 1007 1725L1007 1725Q1008 1729 1011 1738Q1014 1747 1017 1757Q1020 1767 1022 1775Q1024 1783 1024 1785L1024 1785L1024 1980Q965 1946 930.50 1887.50Q896 1829 896 1760L896 1760L896 1664L512 1664L512 1280L416 1280Q363 1280 316.50 1260Q270 1240 235 1205Q200 1170 180 1123.50Q160 1077 160 1024L160 1024Q160 971 180 924.50Q200 878 235 843Q270 808 316.50 788Q363 768 416 768L416 768L512 768L512 384L896 384L896 352Q896 299 916 252.50Q936 206 971 171Q1006 136 1052.50 116Q1099 96 1152 96L1152 96Q1205 96 1251.50 116Q1298 136 1333 171Q1368 206 1388 252.50Q1408 299 1408 352L1408 352L1408 384L1792 384L1792 896L1632 896Q1586 896 1551.50 926Q1517 956 1509 1001L1509 1001Q1475 1006 1442 1014.50Q1409 1023 1377 1036L1377 1036Q1377 1033 1376.50 1030Q1376 1027 1376 1024L1376 1024Q1376 971 1396 924.50Q1416 878 1451 843Q1486 808 1532.50 788Q1579 768 1632 768L1632 768L1664 768L1664 512L1280 512L1280 352Q1280 325 1270 302Q1260 279 1242.50 261.50Q1225 244 1202 234Q1179 224 1152 224ZM2048 1600L2048 1600Q2048 1693 2013 1774.50Q1978 1856 1917 1917Q1856 1978 1774.50 2013Q1693 2048 1600 2048L1600 2048Q1507 2048 1425.50 2013Q1344 1978 1283 1917Q1222 1856 1187 1774.50Q1152 1693 1152 1600L1152 1600Q1152 1507 1187 1425.50Q1222 1344 1283 1283Q1344 1222 1425.50 1187Q1507 1152 1600 1152L1600 1152Q1693 1152 1774.50 1187Q1856 1222 1917 1283Q1978 1344 2013 1425.50Q2048 1507 2048 1600ZM1280 1600L1280 1600Q1280 1666 1305 1724.50Q1330 1783 1373.50 1826.50Q1417 1870 1475.50 1895Q1534 1920 1600 1920L1600 1920Q1647 1920 1692 1906.50Q1737 1893 1776 1867L1776 1867L1333 1424Q1307 1463 1293.50 1508Q1280 1553 1280 1600ZM1424 1333L1867 1776Q1893 1737 1906.50 1692Q1920 1647 1920 1600L1920 1600Q1920 1534 1894.50 1476Q1869 1418 1825.50 1374.50Q1782 1331 1724 1305.50Q1666 1280 1600 1280L1600 1280Q1553 1280 1508 1293.50Q1463 1307 1424 1333L1424 1333Z"
         }
      }
   ]
}

var HexaditeInvestigationSemiAuto = {
   name: "HexaditeInvestigationSemiAuto",
   vendor: "UiFabric",
   unicode: 58362,
   value: "",
   charCode: "E3FA",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 147L256 586L256 1462L901 1830Q890 1862 882.50 1894.50Q875 1927 870 1960L870 1960L128 1536L128 512L1024 0L1920 512L1920 896Q1892 868 1859.50 845.50Q1827 823 1792 803L1792 803L1792 586L1024 147ZM1216 842L1024 733L768 879L768 1169L993 1298Q995 1340 1003.50 1381Q1012 1422 1026 1462L1026 1462L1024 1463L640 1243L640 805L1024 585L1349 771Q1314 785 1280.50 802Q1247 819 1216 842L1216 842ZM1763 1589L1763 1589Q1828 1622 1881 1670Q1934 1718 1971 1778Q2008 1838 2028 1906.50Q2048 1975 2048 2048L2048 2048L1920 2048Q1920 1969 1890 1899Q1860 1829 1807.50 1776.50Q1755 1724 1685 1694Q1615 1664 1536 1664L1536 1664Q1456 1664 1386.50 1694Q1317 1724 1264.50 1776.50Q1212 1829 1182 1899Q1152 1969 1152 2048L1152 2048L1024 2048Q1024 1975 1044 1906.50Q1064 1838 1101 1778Q1138 1718 1191 1670Q1244 1622 1309 1589L1309 1589Q1235 1535 1193.50 1453.50Q1152 1372 1152 1280L1152 1280Q1152 1201 1182 1131Q1212 1061 1264.50 1008.50Q1317 956 1386.50 926Q1456 896 1536 896L1536 896Q1615 896 1685 926Q1755 956 1807 1008.50Q1859 1061 1889 1131Q1919 1201 1919 1280L1919 1280Q1919 1372 1878 1453.50Q1837 1535 1763 1589ZM1280 1280L1280 1280Q1280 1333 1300 1379.50Q1320 1426 1355 1461Q1390 1496 1436.50 1516Q1483 1536 1536 1536L1536 1536Q1589 1536 1635.50 1516Q1682 1496 1717 1461Q1752 1426 1772 1379.50Q1792 1333 1792 1280L1792 1280Q1792 1227 1772 1180.50Q1752 1134 1717 1099Q1682 1064 1635.50 1044Q1589 1024 1536 1024L1536 1024Q1483 1024 1436.50 1044Q1390 1064 1355 1099Q1320 1134 1300 1180.50Q1280 1227 1280 1280Z"
         }
      }
   ]
}

var HexaditeInvestigationCancel = {
   name: "HexaditeInvestigationCancel",
   vendor: "UiFabric",
   unicode: 58361,
   value: "",
   charCode: "E3F9",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 879L768 1169L965 1282Q974 1289 993 1307.50Q1012 1326 1033 1347Q1054 1368 1073 1388Q1092 1408 1102 1418L1102 1418L1024 1463L640 1243L640 805L1024 585L1408 805L1408 1091L1280 963L1280 879L1024 733L768 879ZM1024 147L256 586L256 1462L998 1886L904 1979L128 1536L128 512L1024 0L1920 512L1920 963L1792 1091L1792 586L1024 147ZM1939 1171L2029 1261L1690 1600L2029 1939L1939 2029L1600 1690L1261 2029L1171 1939L1510 1600L1171 1261L1261 1171L1600 1510L1939 1171Z"
         }
      }
   ]
}

var HexaditeInvestigation = {
   name: "HexaditeInvestigation",
   vendor: "UiFabric",
   unicode: 58360,
   value: "",
   charCode: "E3F8",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024 585L1407 804Q1372 823 1340 845Q1308 867 1280 895L1280 895L1280 879L1024 733L768 879L768 1169L1024 1315L1122 1259Q1122 1264 1121 1269.50Q1120 1275 1120 1280L1120 1280Q1120 1310 1124.50 1340Q1129 1370 1136 1399L1136 1399L1024 1463L640 1243L640 805L1024 585ZM1024 147L256 586L256 1462L835 1792Q810 1818 789.50 1839.50Q769 1861 755 1894L755 1894L128 1536L128 512L1024 0L1920 512L1920 803Q1859 769 1792 753L1792 753L1792 586L1024 147ZM1664 896L1664 896Q1743 896 1813 926Q1883 956 1935.50 1008.50Q1988 1061 2018 1131Q2048 1201 2048 1280L2048 1280Q2048 1360 2018 1429.50Q1988 1499 1935.50 1551.50Q1883 1604 1813 1634Q1743 1664 1664 1664L1664 1664Q1604 1664 1547 1646Q1490 1628 1442 1593L1442 1593L1005 2029Q986 2048 960 2048L960 2048Q934 2048 915 2029Q896 2010 896 1984L896 1984Q896 1958 915 1939L915 1939L1351 1502Q1316 1454 1298 1397Q1280 1340 1280 1280L1280 1280Q1280 1201 1310 1131Q1340 1061 1392.50 1008.50Q1445 956 1514.50 926Q1584 896 1664 896ZM1664 1536L1664 1536Q1717 1536 1763.50 1516Q1810 1496 1845 1461Q1880 1426 1900 1379.50Q1920 1333 1920 1280L1920 1280Q1920 1227 1900 1180.50Q1880 1134 1845 1099Q1810 1064 1763.50 1044Q1717 1024 1664 1024L1664 1024Q1611 1024 1564.50 1044Q1518 1064 1483 1099Q1448 1134 1428 1180.50Q1408 1227 1408 1280L1408 1280Q1408 1333 1428 1379.50Q1448 1426 1483 1461Q1518 1496 1564.50 1516Q1611 1536 1664 1536Z"
         }
      }
   ]
}

var PhotoError = {
   name: "PhotoError",
   vendor: "UiFabric",
   unicode: 58359,
   value: "",
   charCode: "E3F7",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 1600L1408 1600L1408 1280L1536 1280L1536 1600ZM1536 1792L1408 1792L1408 1664L1536 1664L1536 1792ZM0 1664L0 128L2048 128L2048 1562L1920 1306L1920 256L128 256L128 933L576 486L1148 1058L1088 1178L576 666L128 1115L128 1536L909 1536L845 1664L0 1664ZM1600 512L1600 512Q1574 512 1555 493Q1536 474 1536 448L1536 448Q1536 422 1555 403Q1574 384 1600 384L1600 384Q1626 384 1645 403Q1664 422 1664 448L1664 448Q1664 474 1645 493Q1626 512 1600 512ZM2048 1920L896 1920L1472 768L2048 1920ZM1472 1018L1077 1808L1867 1808L1472 1018Z"
         }
      }
   ]
}

var CalculatorDelta = {
   name: "CalculatorDelta",
   vendor: "UiFabric",
   unicode: 58374,
   value: "",
   charCode: "E406",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M769 768L896 768L896 896L769 896L769 768ZM256 256L1152 256L1152 640L256 640L256 256ZM384 512L1024 512L1024 384L384 384L384 512ZM513 1280L640 1280L640 1408L513 1408L513 1280ZM769 1024L896 1024L896 1152L769 1152L769 1024ZM1037 1664L1025 1664L1025 1536L1101 1536L1037 1664ZM640 1664L513 1664L513 1536L640 1536L640 1664ZM769 1280L896 1280L896 1408L769 1408L769 1280ZM896 1664L769 1664L769 1536L896 1536L896 1664ZM384 1664L256 1664L256 1536L384 1536L384 1664ZM1025 768L1152 768L1152 896L1025 896L1025 768ZM1025 1280L1152 1280L1152 1408L1025 1408L1025 1280ZM1025 1024L1152 1024L1152 1152L1025 1152L1025 1024ZM513 1024L640 1024L640 1152L513 1152L513 1024ZM1280 128L128 128L128 1792L973 1792L909 1920L0 1920L0 0L1408 0L1408 922L1280 1178L1280 128ZM513 768L640 768L640 896L513 896L513 768ZM256 768L384 768L384 896L256 896L256 768ZM256 1280L384 1280L384 1408L256 1408L256 1280ZM256 1024L384 1024L384 1152L256 1152L256 1024ZM1024 2048L1536 1024L2048 2048L1024 2048ZM1841 1920L1536 1310L1231 1920L1841 1920Z"
         }
      }
   ]
}

var DeviceBug = {
   name: "DeviceBug",
   vendor: "UiFabric",
   unicode: 58404,
   value: "",
   charCode: "E424",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2029 1389L1792 1627L1792 1701L2029 1939L1939 2029L1765 1856Q1746 1900 1716 1935Q1686 1970 1647.50 1995.50Q1609 2021 1564.50 2034.50Q1520 2048 1472 2048L1472 2048Q1424 2048 1379.50 2034.50Q1335 2021 1296.50 1995.50Q1258 1970 1228 1935Q1198 1900 1179 1856L1179 1856L1005 2029L915 1939L1152 1701L1152 1653Q1152 1614 1154 1579.50Q1156 1545 1164.50 1512Q1173 1479 1190 1447Q1207 1415 1237 1383L1237 1383Q1216 1335 1216 1280L1216 1280Q1216 1234 1232 1191Q1248 1148 1278 1113L1278 1113L1171 1005L1261 915L1385 1039Q1427 1024 1472 1024L1472 1024Q1517 1024 1559 1039L1559 1039L1683 915L1773 1005L1666 1113Q1696 1148 1712 1191Q1728 1234 1728 1280L1728 1280Q1728 1335 1707 1383L1707 1383Q1744 1424 1765 1472L1765 1472L1939 1299L2029 1389ZM1600 1280L1600 1280Q1600 1253 1590 1230Q1580 1207 1562.50 1189.50Q1545 1172 1522 1162Q1499 1152 1472 1152L1472 1152Q1445 1152 1422 1162Q1399 1172 1381.50 1189.50Q1364 1207 1354 1230Q1344 1253 1344 1280L1344 1280Q1344 1293 1347 1306L1347 1306Q1376 1292 1408 1286Q1440 1280 1472 1280L1472 1280Q1504 1280 1536 1286Q1568 1292 1597 1306L1597 1306Q1600 1293 1600 1280ZM1680 1728L1680 1728L1680 1600Q1680 1557 1663.50 1519Q1647 1481 1619 1453Q1591 1425 1553 1408.50Q1515 1392 1472 1392L1472 1392Q1429 1392 1391 1408.50Q1353 1425 1325 1453Q1297 1481 1280.50 1519Q1264 1557 1264 1600L1264 1600L1264 1728Q1264 1771 1280.50 1809Q1297 1847 1325 1875Q1353 1903 1391 1919.50Q1429 1936 1472 1936L1472 1936Q1515 1936 1553 1919.50Q1591 1903 1619 1875Q1647 1847 1663.50 1809Q1680 1771 1680 1728ZM1024 1280L1024 1664L640 1664L640 1536L896 1536L896 1408L0 1408L0 256L1920 256L1920 768L1792 768L1792 384L128 384L128 1280L1024 1280Z"
         }
      }
   ]
}

var Reset = {
   name: "Reset",
   vendor: "UiFabric",
   unicode: 58403,
   value: "",
   charCode: "E423",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1920 1216L1920 1216Q1920 1331 1890 1437Q1860 1543 1806 1635.50Q1752 1728 1676 1804Q1600 1880 1507.50 1934Q1415 1988 1309 2018Q1203 2048 1088 2048L1088 2048Q973 2048 867 2018Q761 1988 668.50 1934Q576 1880 500 1804Q424 1728 370 1635.50Q316 1543 286 1437Q256 1331 256 1216L256 1216L256 1152L384 1152L384 1216Q384 1313 409 1403Q434 1493 480 1571Q526 1649 590.50 1713.50Q655 1778 733 1824Q811 1870 901 1895Q991 1920 1088 1920L1088 1920Q1185 1920 1275 1895Q1365 1870 1443 1824Q1521 1778 1585.50 1713.50Q1650 1649 1696 1571Q1742 1493 1767 1403Q1792 1313 1792 1216L1792 1216Q1792 1119 1767 1029Q1742 939 1696 861Q1650 783 1585.50 718.50Q1521 654 1443 608Q1365 562 1275 537Q1185 512 1088 512L1088 512L250 512L541 803L451 893L6 448L451 3L541 93L250 384L1088 384Q1203 384 1309 414Q1415 444 1507.50 498Q1600 552 1676 628Q1752 704 1806 796.50Q1860 889 1890 995Q1920 1101 1920 1216Z"
         }
      }
   ]
}

var ShapeSolid = {
   name: "ShapeSolid",
   vendor: "UiFabric",
   unicode: 58402,
   value: "",
   charCode: "E422",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 297L896 128L2048 128L2048 1280L1814 1280L1297 384L1194 561Q1139 476 1063 409Q987 342 896 297L896 297ZM1101 723L1101 723L633 1533Q604 1536 576 1536L576 1536Q457 1536 352 1490.50Q247 1445 169 1367Q91 1289 45.50 1184Q0 1079 0 960L0 960Q0 841 45.50 736Q91 631 169 553Q247 475 352 429.50Q457 384 576 384L576 384Q661 384 740.50 408Q820 432 888.50 476Q957 520 1011.50 582.50Q1066 645 1101 723ZM1999 1920L595 1920L1297 704L1999 1920Z"
         }
      }
   ]
}

var CubeShapeSolid = {
   name: "CubeShapeSolid",
   vendor: "UiFabric",
   unicode: 58401,
   value: "",
   charCode: "E421",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M210 528L960 152L1710 528L960 903L210 528ZM896 1991L128 1607L128 665L896 1049L896 1991ZM1024 1991L1024 1049L1792 665L1792 1607L1024 1991Z"
         }
      }
   ]
}

var ImageInAR = {
   name: "ImageInAR",
   vendor: "UiFabric",
   unicode: 58400,
   value: "",
   charCode: "E420",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1472 640L1472 640Q1446 640 1427 621Q1408 602 1408 576L1408 576Q1408 550 1427 531Q1446 512 1472 512L1472 512Q1498 512 1517 531Q1536 550 1536 576L1536 576Q1536 602 1517 621Q1498 640 1472 640ZM1024 1664L0 1664L0 256L1792 256L1792 901L1664 837L1664 384L128 384L128 805L320 614L832 1126L1088 870L1216 998L1096 1058L1088 1050L922 1216L1024 1318L1024 1499L320 794L128 987L128 1536L1024 1536L1024 1664ZM1486 1185L1428 1070L1600 984L1772 1070L1715 1185L1600 1128L1486 1185ZM1812 1234L1869 1119L2048 1209L2048 1408L1920 1408L1920 1351L1869 1377L1812 1262L1841 1248L1812 1234ZM1812 1774L1920 1721L1920 1536L2048 1536L2048 1800L1869 1889L1812 1774ZM1664 1792L1664 1849L1715 1823L1772 1938L1600 2024L1428 1938L1486 1823L1536 1849L1536 1792L1664 1792ZM1152 1536L1280 1536L1280 1720L1388 1774L1331 1889L1152 1800L1152 1536ZM1152 1208L1331 1119L1388 1234L1359 1248L1388 1262L1331 1377L1280 1351L1280 1408L1152 1408L1152 1208ZM1485 1312L1600 1369L1715 1312L1772 1426L1664 1480L1664 1664L1536 1664L1536 1480L1428 1426L1485 1312Z"
         }
      }
   ]
}

var ViewInAR = {
   name: "ViewInAR",
   vendor: "UiFabric",
   unicode: 58399,
   value: "",
   charCode: "E41F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M478 695L256 583L256 832L128 832L128 441L478 265L535 380L335 480L536 580L478 695ZM896 512L896 199L674 311L617 196L960 24L1303 196L1246 311L1024 199L1024 512L896 512ZM1024 1408L1024 1721L1246 1609L1304 1724L960 1896L617 1724L674 1609L896 1721L896 1408L1024 1408ZM256 1337L510 1209L569 1323L335 1440L535 1540L478 1655L128 1479L128 1088L256 1088L256 1337ZM674 649L960 792L1246 649L1304 764L1024 904L1024 1216L896 1216L896 904L617 764L674 649ZM1385 380L1442 265L1792 441L1792 832L1664 832L1664 583L1442 695L1385 580L1585 480L1385 380ZM1410 1209L1664 1337L1664 1088L1792 1088L1792 1479L1442 1655L1385 1540L1585 1440L1351 1323L1410 1209Z"
         }
      }
   ]
}

var InputAddress = {
   name: "InputAddress",
   vendor: "UiFabric",
   unicode: 58398,
   value: "",
   charCode: "E41E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1117 768L128 768L128 1280L1280 1280L1280 1408L0 1408L0 640L1033 640Q1048 675 1069.50 707Q1091 739 1117 768L1117 768ZM1911 640L1911 640L2048 640L2048 1408L1664 1408L1664 1280L1920 1280L1920 768L1827 768Q1853 739 1874.50 707Q1896 675 1911 640ZM1536 762L1536 762L1536 1792L1472 1920L1408 1792L1408 762Q1352 750 1305 721Q1258 692 1224 650.50Q1190 609 1171 557Q1152 505 1152 448L1152 448Q1152 382 1177 323.50Q1202 265 1245.50 221.50Q1289 178 1347.50 153Q1406 128 1472 128L1472 128Q1538 128 1596 153.50Q1654 179 1697.50 222.50Q1741 266 1766.50 324Q1792 382 1792 448L1792 448Q1792 505 1773 557Q1754 609 1720 650.50Q1686 692 1639 721Q1592 750 1536 762ZM1664 448L1664 448Q1664 408 1649 373Q1634 338 1608 312Q1582 286 1547 271Q1512 256 1472 256L1472 256Q1432 256 1397 271Q1362 286 1336 312Q1310 338 1295 373Q1280 408 1280 448L1280 448Q1280 488 1295 523Q1310 558 1336 584Q1362 610 1397 625Q1432 640 1472 640L1472 640Q1512 640 1547 625Q1582 610 1608 584Q1634 558 1649 523Q1664 488 1664 448Z"
         }
      }
   ]
}

var ContentFeed = {
   name: "ContentFeed",
   vendor: "UiFabric",
   unicode: 58408,
   value: "",
   charCode: "E428",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1280 1920L1024 1920L1024 1792L1280 1792L1280 1920ZM384 2048L256 2048L256 1536L1792 1536L1792 2048L1664 2048L1664 1664L896 1664L896 2048L768 2048L768 1664L384 1664L384 2048ZM1536 1152L1024 1152L1024 1024L1536 1024L1536 1152ZM1024 256L1536 256L1536 384L1024 384L1024 256ZM1792 1408L256 1408L256 768L1792 768L1792 1408ZM1664 896L896 896L896 1280L1664 1280L1664 896ZM768 896L384 896L384 1280L768 1280L768 896ZM256 640L256 0L1792 0L1792 640L256 640ZM384 512L768 512L768 128L384 128L384 512ZM896 512L1664 512L1664 128L896 128L896 512Z"
         }
      }
   ]
}

var HomeDropdown = {
   name: "HomeDropdown",
   vendor: "UiFabric",
   unicode: 58407,
   value: "",
   charCode: "E427",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1600 1984L1152 1536L2048 1536L1600 1984ZM1280 1408L1152 1408L1152 1280L896 1280L896 1920L256 1920L256 1115L173 1197L83 1107L1024 165L1965 1107L1875 1197L1792 1115L1792 1408L1664 1408L1664 987L1024 347L384 987L384 1792L768 1792L768 1152L1280 1152L1280 1408Z"
         }
      }
   ]
}

var D365ProjectOperations = {
   name: "D365ProjectOperations",
   vendor: "UiFabric",
   unicode: 58418,
   value: "",
   charCode: "E432",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1913 1022L1913 1022Q1913 1065 1890 1102L1890 1102L1415 1846Q1394 1878 1360.50 1896.50Q1327 1915 1289 1915L1289 1915L280 1915Q249 1915 222 1903.50Q195 1892 174.50 1871.50Q154 1851 142 1824Q130 1797 130 1766L130 1766L130 277Q130 246 142 219Q154 192 174.50 171.50Q195 151 222 139.50Q249 128 280 128L280 128L1289 128Q1327 128 1361 146.50Q1395 165 1415 197L1415 197L1890 941Q1913 978 1913 1022ZM280 1787L280 1787L426 1787Q433 1775 456 1736.50Q479 1698 512.50 1643Q546 1588 585.50 1521.50Q625 1455 665.50 1387Q706 1319 744 1254.50Q782 1190 811.50 1139.50Q841 1089 859 1057Q877 1025 877 1022L877 1022Q877 1019 859 986.50Q841 954 811.50 903.50Q782 853 743.50 788.50Q705 724 664.50 656Q624 588 584 521.50Q544 455 511 400Q478 345 454.50 306.50Q431 268 424 256L424 256L280 256Q272 256 265 262Q258 268 258 277L258 277L258 1766Q258 1775 264.50 1781Q271 1787 280 1787ZM984 1098L575 1787L871 1787Q878 1775 902 1736.50Q926 1698 959.50 1643Q993 1588 1034.50 1521Q1076 1454 1117.50 1386Q1159 1318 1198 1253.50Q1237 1189 1267.50 1138.50Q1298 1088 1316.50 1056Q1335 1024 1335 1022L1335 1022Q1335 1020 1316.50 988Q1298 956 1267.50 905.50Q1237 855 1197.50 790Q1158 725 1116 657Q1074 589 1032.50 522Q991 455 957 399.50Q923 344 899.50 305.50Q876 267 869 256L869 256L573 256L984 945Q1005 980 1005 1022L1005 1022Q1005 1042 1000 1061.50Q995 1081 984 1098L984 1098ZM1786 1022L1786 1022Q1786 1019 1767 987.50Q1748 956 1716.50 906Q1685 856 1644.50 792Q1604 728 1561 661Q1518 594 1475.50 528Q1433 462 1398 408Q1363 354 1338.50 316Q1314 278 1307 266L1307 266Q1300 256 1289 256L1289 256L1019 256L1440 944Q1451 962 1457 982Q1463 1002 1463 1022L1463 1022Q1463 1064 1441 1100L1441 1100L1021 1787L1289 1787Q1300 1787 1307 1777L1307 1777Q1314 1765 1338.50 1727Q1363 1689 1398 1635Q1433 1581 1475.50 1515Q1518 1449 1561 1382Q1604 1315 1644.50 1251.50Q1685 1188 1716.50 1138Q1748 1088 1767 1056.50Q1786 1025 1786 1022Z"
         }
      }
   ]
}

var CompareUneven = {
   name: "CompareUneven",
   vendor: "UiFabric",
   unicode: 58414,
   value: "",
   charCode: "E42E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1653 662L1817 1152L1920 1152L1920 1280L1898 1280Q1878 1337 1841.50 1384Q1805 1431 1757 1465Q1709 1499 1652.50 1517.50Q1596 1536 1536 1536L1536 1536Q1476 1536 1419 1517.50Q1362 1499 1314 1465.50Q1266 1432 1229.50 1384.50Q1193 1337 1174 1280L1174 1280L1152 1280L1152 1152L1255 1152L1442 592L1024 453L1024 1666Q1193 1677 1341 1741Q1489 1805 1613 1920L1613 1920L1792 1920L1792 2048L128 2048L128 1920L307 1920Q430 1806 579.50 1741.50Q729 1677 896 1666L896 1666L896 410L502 279L665 768L768 768L768 896L746 896Q726 953 689.50 1000Q653 1047 605 1081Q557 1115 500.50 1133.50Q444 1152 384 1152L384 1152Q324 1152 267 1133.50Q210 1115 162 1081.50Q114 1048 77.50 1000.50Q41 953 22 896L22 896L0 896L0 768L103 768L290 208L28 121L69 0L896 275L896 0L1024 0L1024 318L1891 606L1850 728L1653 662ZM606 896L606 896L162 896Q197 956 256 990Q315 1024 384 1024L384 1024Q453 1024 512 990Q571 956 606 896ZM238 768L530 768L384 330L238 768ZM960 1792L960 1792Q842 1792 729 1824.50Q616 1857 516 1920L516 1920L1404 1920Q1305 1857 1191 1824.50Q1077 1792 960 1792ZM1682 1152L1536 714L1390 1152L1682 1152ZM1758 1280L1758 1280L1314 1280Q1349 1340 1408 1374Q1467 1408 1536 1408L1536 1408Q1605 1408 1664 1374Q1723 1340 1758 1280Z"
         }
      }
   ]
}

var AzureDataExplorer = {
   name: "AzureDataExplorer",
   vendor: "UiFabric",
   unicode: 58425,
   value: "",
   charCode: "E439",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M199 0L1984 0Q2010 0 2029 19Q2048 38 2048 64L2048 64L2048 1849Q2048 1875 2029 1894Q2010 1913 1984 1913L1984 1913Q1958 1913 1939 1894L1939 1894L154 109Q135 90 135 64L135 64Q135 38 154 19Q173 0 199 0L199 0ZM1420 1194L1920 695L1920 128L1379 128L866 641L1420 1194ZM776 550L1198 128L354 128L776 550ZM1920 876L1511 1285L1920 1694L1920 876ZM82 1875L850 1107L940 1197L172 1965L82 1875ZM700 1981L609 1890L1121 1378L1212 1469L700 1981ZM578 835L669 926L157 1438L66 1347L578 835ZM1409 519L1296 406L1409 292L1522 406L1409 519ZM1643 524L1756 637L1643 750L1529 637L1643 524ZM1159 767L1046 654L1159 541L1272 654L1159 767ZM1393 999L1280 886L1393 773L1506 886L1393 999Z"
         }
      }
   ]
}

var Column = {
   name: "Column",
   vendor: "UiFabric",
   unicode: 58424,
   value: "",
   charCode: "E438",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 1920L512 0L1536 0L1536 1920L512 1920ZM640 1792L1408 1792L1408 384L640 384L640 1792ZM640 256L1408 256L1408 128L640 128L640 256Z"
         }
      }
   ]
}

var DatabaseView = {
   name: "DatabaseView",
   vendor: "UiFabric",
   unicode: 58423,
   value: "",
   charCode: "E437",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 1280L256 1280L256 1152L1408 1152L1408 1280ZM384 384L384 0L2048 0L2048 1536L1792 1536L1792 1408L1920 1408L1920 384L384 384ZM512 256L1920 256L1920 128L512 128L512 256ZM1664 2048L0 2048L0 512L1664 512L1664 2048ZM1536 640L128 640L128 768L1536 768L1536 640ZM1536 896L128 896L128 1920L1536 1920L1536 896Z"
         }
      }
   ]
}

var BlobStorage = {
   name: "BlobStorage",
   vendor: "UiFabric",
   unicode: 58422,
   value: "",
   charCode: "E436",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 0L2048 0L2048 2048L0 2048ZM128 1920L1920 1920L1920 512L128 512L128 1920ZM128 384L1920 384L1920 128L128 128L128 384ZM256 1280L768 1280L768 1792L256 1792L256 1280ZM384 1664L640 1664L640 1408L384 1408L384 1664ZM1280 640L1792 640L1792 1152L1280 1152L1280 640ZM1408 1024L1664 1024L1664 768L1408 768L1408 1024ZM1792 1792L896 1792L896 1280L1792 1280L1792 1792ZM1664 1408L1024 1408L1024 1664L1664 1664L1664 1408ZM256 640L1152 640L1152 1152L256 1152L256 640ZM384 1024L1024 1024L1024 768L384 768L384 1024Z"
         }
      }
   ]
}

var StorageAcount = {
   name: "StorageAcount",
   vendor: "UiFabric",
   unicode: 58421,
   value: "",
   charCode: "E435",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 0L2048 0L2048 2048L0 2048ZM128 1920L1920 1920L1920 512L128 512L128 1920ZM128 384L1920 384L1920 128L128 128L128 384ZM256 640L1792 640L1792 1152L256 1152L256 640ZM384 1024L1664 1024L1664 768L384 768L384 1024ZM256 1280L1792 1280L1792 1792L256 1792L256 1280ZM384 1664L1664 1664L1664 1408L384 1408L384 1664Z"
         }
      }
   ]
}

var SQLAnalyticsPool = {
   name: "SQLAnalyticsPool",
   vendor: "UiFabric",
   unicode: 58420,
   value: "",
   charCode: "E434",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 512L1408 774Q1424 773 1439.50 773Q1455 773 1471 773L1471 773Q1508 773 1565 776.50Q1622 780 1686 790.50Q1750 801 1815 818.50Q1880 836 1931.50 864Q1983 892 2015.50 931.50Q2048 971 2048 1024L2048 1024L2048 1792Q2048 1846 2015.50 1885.50Q1983 1925 1931.50 1953.50Q1880 1982 1815.50 2000.50Q1751 2019 1687 2029.50Q1623 2040 1566 2044Q1509 2048 1472 2048L1472 2048Q1435 2048 1378 2044Q1321 2040 1257 2029.50Q1193 2019 1128.50 2000.50Q1064 1982 1012.50 1953.50Q961 1925 928.50 1885Q896 1845 896 1792L896 1792L896 1024Q896 983 916 951Q936 919 968.50 893.50Q1001 868 1042.50 849.50Q1084 831 1126.50 818Q1169 805 1209 797Q1249 789 1280 785L1280 785L1280 512L256 512L256 1280L128 1280L128 512L0 512L0 384L768 0L1536 384L1536 512L1408 512ZM768 143L286 384L1250 384L768 143ZM1920 1792L1920 1792L1920 1189Q1810 1240 1701 1260Q1592 1280 1472 1280L1472 1280Q1352 1280 1243 1260Q1134 1240 1024 1189L1024 1189L1024 1792Q1024 1803 1034.50 1813Q1045 1823 1053 1828L1053 1828Q1091 1855 1144.50 1873Q1198 1891 1255.50 1901.50Q1313 1912 1370 1916Q1427 1920 1472 1920L1472 1920Q1517 1920 1573.50 1916Q1630 1912 1688 1901.50Q1746 1891 1799.50 1873Q1853 1855 1891 1828L1891 1828Q1899 1823 1909.50 1813Q1920 1803 1920 1792ZM1472 1152L1472 1152Q1517 1152 1573.50 1148Q1630 1144 1688 1133.50Q1746 1123 1799.50 1105Q1853 1087 1891 1060L1891 1060Q1898 1055 1909 1045Q1920 1035 1920 1024L1920 1024Q1920 1013 1909 1003Q1898 993 1891 988L1891 988Q1853 961 1799.50 943.50Q1746 926 1688 915.50Q1630 905 1573.50 900.50Q1517 896 1472 896L1472 896Q1427 896 1370 900.50Q1313 905 1255.50 915.50Q1198 926 1144.50 943.50Q1091 961 1053 988L1053 988Q1046 993 1035 1003Q1024 1013 1024 1024L1024 1024Q1024 1035 1035 1045Q1046 1055 1053 1060L1053 1060Q1091 1087 1144.50 1105Q1198 1123 1255.50 1133.50Q1313 1144 1370 1148Q1427 1152 1472 1152ZM512 1280L384 1280L384 1152L512 1152L512 1280ZM768 1280L640 1280L640 1152L768 1152L768 1280ZM512 1024L384 1024L384 896L512 896L512 1024ZM512 768L384 768L384 640L512 640L512 768ZM768 1024L640 1024L640 896L768 896L768 1024Z"
         }
      }
   ]
}

var FileSystem = {
   name: "FileSystem",
   vendor: "UiFabric",
   unicode: 58419,
   value: "",
   charCode: "E433",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M670 384L1378 384L1442 512L606 512L670 384ZM414 896L1634 896L1698 1024L350 1024L414 896ZM542 640L1506 640L1570 768L478 768L542 640ZM512 128L1536 128L2048 1152L2048 1792L0 1792L0 1152L512 128ZM1457 256L591 256L143 1152L1905 1152L1457 256ZM128 1664L1920 1664L1920 1280L128 1280L128 1664ZM256 1408L512 1408L512 1536L256 1536L256 1408Z"
         }
      }
   ]
}

var SortLinesAscending = {
   name: "SortLinesAscending",
   vendor: "UiFabric",
   unicode: 58426,
   value: "",
   charCode: "E43A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M93 573L3 483L320 165L637 483L547 573L384 410L384 1920L256 1920L256 410L93 573ZM768 384L1280 384L1280 512L768 512L768 384ZM768 768L1664 768L1664 896L768 896L768 768ZM768 1280L768 1152L2048 1152L2048 1280L768 1280Z"
         }
      }
   ]
}

var TextDocumentEdit = {
   name: "TextDocumentEdit",
   vendor: "UiFabric",
   unicode: 58427,
   value: "",
   charCode: "E43B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 952.50Q2017 979 2032.50 1015.50Q2048 1052 2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1952L896 2046L990 1669L1707 953Q1736 924 1772 910Q1808 896 1848 896ZM1920 1094L1920 1094Q1920 1062 1899.50 1043Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1735L1072 1870L1207 1836L1899 1145Q1920 1124 1920 1094ZM1152 128L256 128L256 1920L762 1920L731 2048L128 2048L128 0L1243 0L1792 549L1792 741Q1755 746 1725.50 756.50Q1696 767 1664 787L1664 787L1664 640L1152 640L1152 128ZM1573 512L1280 219L1280 512L1573 512ZM512 896L1408 896L1408 1024L512 1024L512 896ZM897 1536L512 1536L512 1408L1025 1408L897 1536ZM512 1152L1281 1152L1153 1280L512 1280L512 1152Z"
         }
      }
   ]
}

var VideoOff2 = {
   name: "VideoOff2",
   vendor: "UiFabric",
   unicode: 58428,
   value: "",
   charCode: "E43C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1536 512L1536 760L2048 504L2048 1544L1798 1419Q1780 1410 1764.50 1403.50Q1749 1397 1734 1390.50Q1719 1384 1704.50 1376Q1690 1368 1673 1356L1673 1356Q1658 1346 1647 1335.50Q1636 1325 1626.50 1314.50Q1617 1304 1607.50 1292.50Q1598 1281 1585 1268L1585 1268L1408 1091L1408 640L957 640L829 512L1536 512ZM1536 1144L1920 1337L1920 711L1536 904L1536 1144ZM421 512L19 109L109 19L2029 1939L1939 2029L1445 1536L0 1536L0 512L421 512ZM128 640L128 1408L1317 1408L549 640L128 640Z"
         }
      }
   ]
}

var RewindEightX = {
   name: "RewindEightX",
   vendor: "UiFabric",
   unicode: 58441,
   value: "",
   charCode: "E449",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1024 507L1664-5L1664 1030L1024 513L1024 1030L380 510L1024-5ZM584 511L896 762L896 261L584 511ZM1224 511L1536 762L1536 261L1224 511ZM1012 1792L1012 1792Q1012 1853 989.50 1900.50Q967 1948 929 1981Q891 2014 840 2031Q789 2048 731 2048L731 2048Q674 2048 622.50 2031Q571 2014 533 1981Q495 1948 472.50 1900.50Q450 1853 450 1792L450 1792Q450 1754 462 1718.50Q474 1683 495 1653Q516 1623 545.50 1600Q575 1577 610 1563L610 1563Q556 1533 521.50 1485Q487 1437 487 1373L487 1373Q487 1322 507 1281Q527 1240 560.50 1211.50Q594 1183 638.50 1167.50Q683 1152 731 1152L731 1152Q779 1152 823.50 1167.50Q868 1183 901.50 1211.50Q935 1240 955 1281Q975 1322 975 1373L975 1373Q975 1436 940.50 1484.50Q906 1533 853 1563L853 1563Q887 1577 916.50 1600.50Q946 1624 967 1654Q988 1684 1000 1719.50Q1012 1755 1012 1792ZM732 1526L732 1526Q762 1526 788 1514.50Q814 1503 833.50 1483Q853 1463 864.50 1437Q876 1411 876 1381L876 1381Q876 1351 865 1324.50Q854 1298 834.50 1278.50Q815 1259 789 1247.50Q763 1236 732 1236L732 1236Q700 1236 674 1247Q648 1258 628.50 1277Q609 1296 598.50 1323Q588 1350 588 1381L588 1381Q588 1411 599 1437.50Q610 1464 629.50 1483.50Q649 1503 675.50 1514.50Q702 1526 732 1526ZM906 1784L906 1784Q906 1746 893 1713.50Q880 1681 857 1657.50Q834 1634 802 1620.50Q770 1607 732 1607L732 1607Q694 1607 662 1620.50Q630 1634 606.50 1657.50Q583 1681 570 1713.50Q557 1746 557 1784L557 1784Q557 1865 604 1912.50Q651 1960 732 1960L732 1960Q771 1960 803 1947Q835 1934 858 1911Q881 1888 893.50 1855.50Q906 1823 906 1784ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var RewindFourX = {
   name: "RewindFourX",
   vendor: "UiFabric",
   unicode: 58440,
   value: "",
   charCode: "E448",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1024 507L1664-5L1664 1030L1024 513L1024 1030L380 510L1024-5ZM584 511L896 762L896 261L584 511ZM1224 511L1536 762L1536 261L1224 511ZM800 1152L909 1152L909 1744L1024 1744L1024 1837L909 1837L909 2048L808 2048L808 1837L387 1837L387 1749Q446 1683 503.50 1611.50Q561 1540 614.50 1465Q668 1390 715 1311.50Q762 1233 800 1152L800 1152ZM502 1744L808 1744L808 1305Q742 1423 664.50 1530.50Q587 1638 502 1744L502 1744ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var RewindTwoX = {
   name: "RewindTwoX",
   vendor: "UiFabric",
   unicode: 58439,
   value: "",
   charCode: "E447",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1024 507L1664-5L1664 1030L1024 513L1024 1030L380 510L1024-5ZM584 511L896 762L896 261L584 511ZM1224 511L1536 762L1536 261L1224 511ZM562 1958L562 1958L1001 1958L1001 2048L457 2048L457 2004Q457 1979 459.50 1954Q462 1929 469 1905L469 1905Q484 1850 519.50 1808.50Q555 1767 598.50 1732Q642 1697 689 1664Q736 1631 775 1593Q814 1555 839 1508Q864 1461 864 1398L864 1398Q864 1323 820.50 1280Q777 1237 702 1237L702 1237Q672 1237 642.50 1245.50Q613 1254 586 1269Q559 1284 534.50 1303.50Q510 1323 491 1345L491 1345L491 1237Q538 1190 593 1171Q648 1152 714 1152L714 1152Q768 1152 814.50 1168Q861 1184 895 1214Q929 1244 948 1288Q967 1332 967 1389L967 1389Q967 1472 937 1530Q907 1588 862 1632Q817 1676 764.50 1710.50Q712 1745 667 1781Q622 1817 592 1858.50Q562 1900 562 1958ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var RewindOneFiveX = {
   name: "RewindOneFiveX",
   vendor: "UiFabric",
   unicode: 58438,
   value: "",
   charCode: "E446",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1030L1024 513L1024 1030L380 510L1024-5L1024 507L1664-5L1664 1030ZM1536 762L1536 261L1224 511L1536 762ZM584 511L896 762L896 261L584 511ZM346 1152L346 1152L384 1152L384 2048L284 2048L284 1291Q265 1308 240 1324Q215 1340 188 1353.50Q161 1367 133.50 1378Q106 1389 81 1395L81 1395L81 1293Q111 1285 148 1270Q185 1255 221 1236Q257 1217 290 1195Q323 1173 346 1152ZM575 1856L575 1856Q594 1856 612 1863.50Q630 1871 643 1884.50Q656 1898 664 1915.50Q672 1933 672 1952L672 1952Q672 1993 643.50 2020.50Q615 2048 575 2048L575 2048Q535 2048 507.50 2020Q480 1992 480 1952L480 1952Q480 1933 487.50 1915.50Q495 1898 508 1885Q521 1872 538 1864Q555 1856 575 1856ZM1287 1764L1287 1764Q1287 1833 1262.50 1886Q1238 1939 1196 1975Q1154 2011 1097 2029.50Q1040 2048 975 2048L975 2048Q953 2048 929 2046.50Q905 2045 881 2041.50Q857 2038 834.50 2030.50Q812 2023 793 2011L793 2011L793 1904Q835 1931 880.50 1946.50Q926 1962 976 1962L976 1962Q1020 1962 1058 1949.50Q1096 1937 1124 1912.50Q1152 1888 1168 1852Q1184 1816 1184 1770L1184 1770Q1184 1719 1165.50 1684Q1147 1649 1116 1627Q1085 1605 1044 1595.50Q1003 1586 958 1586L958 1586Q922 1586 883 1587Q844 1588 809 1594L809 1594L839 1152L1247 1152L1247 1243L927 1243L909 1501Q929 1501 949.50 1499.50Q970 1498 990 1498L990 1498Q1053 1498 1107.50 1514.50Q1162 1531 1202 1564Q1242 1597 1264.50 1647Q1287 1697 1287 1764ZM1834 1408L1947 1408L1732 1732L1943 2048L1824 2048Q1785 1984 1746.50 1920.50Q1708 1857 1670 1792L1670 1792L1668 1792Q1626 1855 1588 1919.50Q1550 1984 1510 2048L1510 2048L1392 2048L1610 1734L1401 1408L1521 1408Q1559 1475 1597.50 1541.50Q1636 1608 1672 1677L1672 1677L1674 1677L1834 1408Z"
         }
      }
   ]
}

var RewindOneX = {
   name: "RewindOneX",
   vendor: "UiFabric",
   unicode: 58437,
   value: "",
   charCode: "E445",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1024 507L1664-5L1664 1030L1024 513L1024 1030L380 510L1024-5ZM584 511L896 762L896 261L584 511ZM1224 511L1536 762L1536 261L1224 511ZM858 1152L858 1152L896 1152L896 2048L796 2048L796 1291Q777 1308 752 1324Q727 1340 700 1353.50Q673 1367 645.50 1378Q618 1389 593 1395L593 1395L593 1293Q623 1285 660 1270Q697 1255 733 1236Q769 1217 802 1195Q835 1173 858 1152ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var RewindPointFiveX = {
   name: "RewindPointFiveX",
   vendor: "UiFabric",
   unicode: 58436,
   value: "",
   charCode: "E444",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1030L1024 513L1024 1030L380 510L1024-5L1024 507L1664-5L1664 1030ZM1536 762L1536 261L1224 511L1536 762ZM584 511L896 762L896 261L584 511ZM1935 1408L2048 1408L1833 1732L2044 2048L1925 2048Q1886 1984 1847.50 1920.50Q1809 1857 1771 1792L1771 1792L1769 1792Q1727 1855 1689 1919.50Q1651 1984 1611 2048L1611 2048L1493 2048L1711 1734L1502 1408L1622 1408Q1660 1475 1699.50 1541Q1739 1607 1772 1677L1772 1677L1775 1677L1935 1408ZM703 1856L703 1856Q722 1856 740 1863.50Q758 1871 771 1884.50Q784 1898 792 1915.50Q800 1933 800 1952L800 1952Q800 1993 771.50 2020.50Q743 2048 703 2048L703 2048Q663 2048 635.50 2020Q608 1992 608 1952L608 1952Q608 1933 615.50 1915.50Q623 1898 636 1885Q649 1872 666 1864Q683 1856 703 1856ZM1391 1764L1391 1764Q1391 1833 1366.50 1886Q1342 1939 1300 1975Q1258 2011 1201 2029.50Q1144 2048 1079 2048L1079 2048Q1057 2048 1033 2046.50Q1009 2045 985 2041.50Q961 2038 938 2030.50Q915 2023 896 2011L896 2011L896 1904Q938 1931 984 1946.50Q1030 1962 1080 1962L1080 1962Q1124 1962 1162 1949Q1200 1936 1228 1911.50Q1256 1887 1272 1851.50Q1288 1816 1288 1770L1288 1770Q1288 1719 1269.50 1684Q1251 1649 1220 1627.50Q1189 1606 1148 1596Q1107 1586 1062 1586L1062 1586L1035 1586Q1005 1586 973.50 1587.50Q942 1589 913 1594L913 1594L943 1152L1350 1152L1350 1243L1030 1243L1013 1501Q1033 1501 1053 1499.50Q1073 1498 1093 1498L1093 1498Q1156 1498 1210.50 1514.50Q1265 1531 1305 1564Q1345 1597 1368 1647Q1391 1697 1391 1764ZM292 1152L292 1152Q351 1152 394.50 1172Q438 1192 468.50 1226Q499 1260 517.50 1304.50Q536 1349 546.50 1398.50Q557 1448 560.50 1499Q564 1550 564 1596L564 1596Q564 1643 559 1695Q554 1747 542 1797Q530 1847 509 1892.50Q488 1938 455.50 1972.50Q423 2007 378.50 2027.50Q334 2048 274 2048L274 2048Q217 2048 174.50 2028.50Q132 2009 101.50 1976Q71 1943 51.50 1899.50Q32 1856 20.50 1808Q9 1760 4.50 1711Q0 1662 0 1617L0 1617Q0 1569 4.50 1515.50Q9 1462 20.50 1410.50Q32 1359 53 1312Q74 1265 106.50 1229.50Q139 1194 184.50 1173Q230 1152 292 1152ZM283 1963L283 1963Q325 1963 354.50 1945Q384 1927 404 1897Q424 1867 436 1829.50Q448 1792 454 1752Q460 1712 461.50 1674Q463 1636 463 1606L463 1606Q463 1577 461.50 1538.50Q460 1500 454.50 1458.50Q449 1417 437.50 1377.50Q426 1338 406.50 1306.50Q387 1275 358 1255.50Q329 1236 287 1236L287 1236Q243 1236 212.50 1255.50Q182 1275 161.50 1306.50Q141 1338 129 1378Q117 1418 111 1460Q105 1502 103.50 1541.50Q102 1581 102 1612L102 1612Q102 1642 103.50 1680Q105 1718 111.50 1757Q118 1796 129.50 1833Q141 1870 161.50 1899Q182 1928 211.50 1945.50Q241 1963 283 1963Z"
         }
      }
   ]
}

var FastForwardEightX = {
   name: "FastForwardEightX",
   vendor: "UiFabric",
   unicode: 58435,
   value: "",
   charCode: "E443",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1668 510L1024 1030L1024 513L384 1030L384-5L1024 507L1024-5ZM512 261L512 762L824 511L512 261ZM1464 511L1152 261L1152 762L1464 511ZM1012 1792L1012 1792Q1012 1853 989.50 1900.50Q967 1948 929 1981Q891 2014 840 2031Q789 2048 731 2048L731 2048Q674 2048 622.50 2031Q571 2014 533 1981Q495 1948 472.50 1900.50Q450 1853 450 1792L450 1792Q450 1754 462 1718.50Q474 1683 495 1653Q516 1623 545.50 1600Q575 1577 610 1563L610 1563Q556 1533 521.50 1485Q487 1437 487 1373L487 1373Q487 1322 507 1281Q527 1240 560.50 1211.50Q594 1183 638.50 1167.50Q683 1152 731 1152L731 1152Q779 1152 823.50 1167.50Q868 1183 901.50 1211.50Q935 1240 955 1281Q975 1322 975 1373L975 1373Q975 1436 940.50 1484.50Q906 1533 853 1563L853 1563Q887 1577 916.50 1600.50Q946 1624 967 1654Q988 1684 1000 1719.50Q1012 1755 1012 1792ZM732 1526L732 1526Q762 1526 788 1514.50Q814 1503 833.50 1483Q853 1463 864.50 1437Q876 1411 876 1381L876 1381Q876 1351 865 1324.50Q854 1298 834.50 1278.50Q815 1259 789 1247.50Q763 1236 732 1236L732 1236Q700 1236 674 1247Q648 1258 628.50 1277Q609 1296 598.50 1323Q588 1350 588 1381L588 1381Q588 1411 599 1437.50Q610 1464 629.50 1483.50Q649 1503 675.50 1514.50Q702 1526 732 1526ZM906 1784L906 1784Q906 1746 893 1713.50Q880 1681 857 1657.50Q834 1634 802 1620.50Q770 1607 732 1607L732 1607Q694 1607 662 1620.50Q630 1634 606.50 1657.50Q583 1681 570 1713.50Q557 1746 557 1784L557 1784Q557 1865 604 1912.50Q651 1960 732 1960L732 1960Q771 1960 803 1947Q835 1934 858 1911Q881 1888 893.50 1855.50Q906 1823 906 1784ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var FastForwardFourX = {
   name: "FastForwardFourX",
   vendor: "UiFabric",
   unicode: 58434,
   value: "",
   charCode: "E442",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1668 510L1024 1030L1024 513L384 1030L384-5L1024 507L1024-5ZM512 261L512 762L824 511L512 261ZM1464 511L1152 261L1152 762L1464 511ZM800 1152L909 1152L909 1744L1024 1744L1024 1837L909 1837L909 2048L808 2048L808 1837L387 1837L387 1749Q446 1683 503.50 1611.50Q561 1540 614.50 1465Q668 1390 715 1311.50Q762 1233 800 1152L800 1152ZM502 1744L808 1744L808 1305Q742 1423 664.50 1530.50Q587 1638 502 1744L502 1744ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var FastForwardTwoX = {
   name: "FastForwardTwoX",
   vendor: "UiFabric",
   unicode: 58433,
   value: "",
   charCode: "E441",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1668 510L1024 1030L1024 513L384 1030L384-5L1024 507L1024-5ZM512 261L512 762L824 511L512 261ZM1464 511L1152 261L1152 762L1464 511ZM562 1958L562 1958L1001 1958L1001 2048L457 2048L457 2004Q457 1979 459.50 1954Q462 1929 469 1905L469 1905Q484 1850 519.50 1808.50Q555 1767 598.50 1732Q642 1697 689 1664Q736 1631 775 1593Q814 1555 839 1508Q864 1461 864 1398L864 1398Q864 1323 820.50 1280Q777 1237 702 1237L702 1237Q672 1237 642.50 1245.50Q613 1254 586 1269Q559 1284 534.50 1303.50Q510 1323 491 1345L491 1345L491 1237Q538 1190 593 1171Q648 1152 714 1152L714 1152Q768 1152 814.50 1168Q861 1184 895 1214Q929 1244 948 1288Q967 1332 967 1389L967 1389Q967 1472 937 1530Q907 1588 862 1632Q817 1676 764.50 1710.50Q712 1745 667 1781Q622 1817 592 1858.50Q562 1900 562 1958ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var FastForwardOneFiveX = {
   name: "FastForwardOneFiveX",
   vendor: "UiFabric",
   unicode: 58432,
   value: "",
   charCode: "E440",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1668 510L1024 1030L1024 513L384 1030L384-5L1024 507L1024-5L1668 510ZM512 261L512 762L824 510L512 261ZM1464 511L1152 261L1152 762L1464 511ZM346 1152L346 1152L384 1152L384 2048L284 2048L284 1291Q265 1308 240 1324Q215 1340 188 1353.50Q161 1367 133.50 1378Q106 1389 81 1395L81 1395L81 1293Q111 1285 148 1270Q185 1255 221 1236Q257 1217 290 1195Q323 1173 346 1152ZM575 1856L575 1856Q594 1856 612 1863.50Q630 1871 643 1884.50Q656 1898 664 1915.50Q672 1933 672 1952L672 1952Q672 1993 643.50 2020.50Q615 2048 575 2048L575 2048Q535 2048 507.50 2020Q480 1992 480 1952L480 1952Q480 1933 487.50 1915.50Q495 1898 508 1885Q521 1872 538 1864Q555 1856 575 1856ZM1287 1764L1287 1764Q1287 1833 1262.50 1886Q1238 1939 1196 1975Q1154 2011 1097 2029.50Q1040 2048 975 2048L975 2048Q953 2048 929 2046.50Q905 2045 881 2041.50Q857 2038 834.50 2030.50Q812 2023 793 2011L793 2011L793 1904Q835 1931 880.50 1946.50Q926 1962 976 1962L976 1962Q1020 1962 1058 1949.50Q1096 1937 1124 1912.50Q1152 1888 1168 1852Q1184 1816 1184 1770L1184 1770Q1184 1719 1165.50 1684Q1147 1649 1116 1627Q1085 1605 1044 1595.50Q1003 1586 958 1586L958 1586Q922 1586 883 1587Q844 1588 809 1594L809 1594L839 1152L1247 1152L1247 1243L927 1243L909 1501Q929 1501 949.50 1499.50Q970 1498 990 1498L990 1498Q1053 1498 1107.50 1514.50Q1162 1531 1202 1564Q1242 1597 1264.50 1647Q1287 1697 1287 1764ZM1834 1408L1947 1408L1732 1732L1943 2048L1824 2048Q1785 1984 1746.50 1920.50Q1708 1857 1670 1792L1670 1792L1668 1792Q1626 1855 1588 1919.50Q1550 1984 1510 2048L1510 2048L1392 2048L1610 1734L1401 1408L1521 1408Q1559 1475 1597.50 1541.50Q1636 1608 1672 1677L1672 1677L1674 1677L1834 1408Z"
         }
      }
   ]
}

var FastForwardOneX = {
   name: "FastForwardOneX",
   vendor: "UiFabric",
   unicode: 58431,
   value: "",
   charCode: "E43F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1024-5L1668 510L1024 1030L1024 513L384 1030L384-5L1024 507L1024-5ZM512 261L512 762L824 511L512 261ZM1464 511L1152 261L1152 762L1464 511ZM858 1152L858 1152L896 1152L896 2048L796 2048L796 1291Q777 1308 752 1324Q727 1340 700 1353.50Q673 1367 645.50 1378Q618 1389 593 1395L593 1395L593 1293Q623 1285 660 1270Q697 1255 733 1236Q769 1217 802 1195Q835 1173 858 1152ZM1372 1677L1532 1408L1645 1408L1430 1732L1641 2048L1522 2048Q1484 1984 1445 1920.50Q1406 1857 1368 1792L1368 1792L1366 1792Q1358 1804 1351.50 1816.50Q1345 1829 1337 1841L1337 1841L1208 2048L1090 2048L1308 1734L1100 1408L1219 1408Q1257 1475 1295.50 1541.50Q1334 1608 1370 1677L1370 1677L1372 1677Z"
         }
      }
   ]
}

var FastForwardPointFiveX = {
   name: "FastForwardPointFiveX",
   vendor: "UiFabric",
   unicode: 58430,
   value: "",
   charCode: "E43E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1668 510L1024 1030L1024 513L384 1030L384-5L1024 507L1024-5L1668 510ZM512 261L512 762L824 510L512 261ZM1464 511L1152 261L1152 762L1464 511ZM1935 1408L2048 1408L1833 1732L2044 2048L1925 2048Q1886 1984 1847.50 1920.50Q1809 1857 1771 1792L1771 1792L1769 1792Q1727 1855 1689 1919.50Q1651 1984 1611 2048L1611 2048L1493 2048L1711 1734L1502 1408L1622 1408Q1660 1475 1699.50 1541Q1739 1607 1772 1677L1772 1677L1775 1677L1935 1408ZM703 1856L703 1856Q722 1856 740 1863.50Q758 1871 771 1884.50Q784 1898 792 1915.50Q800 1933 800 1952L800 1952Q800 1993 771.50 2020.50Q743 2048 703 2048L703 2048Q663 2048 635.50 2020Q608 1992 608 1952L608 1952Q608 1933 615.50 1915.50Q623 1898 636 1885Q649 1872 666 1864Q683 1856 703 1856ZM1391 1764L1391 1764Q1391 1833 1366.50 1886Q1342 1939 1300 1975Q1258 2011 1201 2029.50Q1144 2048 1079 2048L1079 2048Q1057 2048 1033 2046.50Q1009 2045 985 2041.50Q961 2038 938 2030.50Q915 2023 896 2011L896 2011L896 1904Q938 1931 984 1946.50Q1030 1962 1080 1962L1080 1962Q1124 1962 1162 1949Q1200 1936 1228 1911.50Q1256 1887 1272 1851.50Q1288 1816 1288 1770L1288 1770Q1288 1719 1269.50 1684Q1251 1649 1220 1627.50Q1189 1606 1148 1596Q1107 1586 1062 1586L1062 1586L1035 1586Q1005 1586 973.50 1587.50Q942 1589 913 1594L913 1594L943 1152L1350 1152L1350 1243L1030 1243L1013 1501Q1033 1501 1053 1499.50Q1073 1498 1093 1498L1093 1498Q1156 1498 1210.50 1514.50Q1265 1531 1305 1564Q1345 1597 1368 1647Q1391 1697 1391 1764ZM292 1152L292 1152Q351 1152 394.50 1172Q438 1192 468.50 1226Q499 1260 517.50 1304.50Q536 1349 546.50 1398.50Q557 1448 560.50 1499Q564 1550 564 1596L564 1596Q564 1643 559 1695Q554 1747 542 1797Q530 1847 509 1892.50Q488 1938 455.50 1972.50Q423 2007 378.50 2027.50Q334 2048 274 2048L274 2048Q217 2048 174.50 2028.50Q132 2009 101.50 1976Q71 1943 51.50 1899.50Q32 1856 20.50 1808Q9 1760 4.50 1711Q0 1662 0 1617L0 1617Q0 1569 4.50 1515.50Q9 1462 20.50 1410.50Q32 1359 53 1312Q74 1265 106.50 1229.50Q139 1194 184.50 1173Q230 1152 292 1152ZM283 1963L283 1963Q325 1963 354.50 1945Q384 1927 404 1897Q424 1867 436 1829.50Q448 1792 454 1752Q460 1712 461.50 1674Q463 1636 463 1606L463 1606Q463 1577 461.50 1538.50Q460 1500 454.50 1458.50Q449 1417 437.50 1377.50Q426 1338 406.50 1306.50Q387 1275 358 1255.50Q329 1236 287 1236L287 1236Q243 1236 212.50 1255.50Q182 1275 161.50 1306.50Q141 1338 129 1378Q117 1418 111 1460Q105 1502 103.50 1541.50Q102 1581 102 1612L102 1612Q102 1642 103.50 1680Q105 1718 111.50 1757Q118 1796 129.50 1833Q141 1870 161.50 1899Q182 1928 211.50 1945.50Q241 1963 283 1963Z"
         }
      }
   ]
}

var LockShare = {
   name: "LockShare",
   vendor: "UiFabric",
   unicode: 58453,
   value: "",
   charCode: "E455",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1946 1472L1629 1789L1539 1699L1701 1536L1408 1536Q1381 1536 1358 1546Q1335 1556 1317.50 1573.50Q1300 1591 1290 1614Q1280 1637 1280 1664L1280 1664L1280 1792L1152 1792L1152 1664Q1152 1611 1172 1564.50Q1192 1518 1227 1483Q1262 1448 1308.50 1428Q1355 1408 1408 1408L1408 1408L1701 1408L1539 1245L1629 1155L1946 1472ZM1792 2048L1152 2048L1152 1920L1792 1920L1792 2048ZM1792 1024L384 1024L384 1920L1024 1920L1024 2048L256 2048L256 896L512 896L512 522Q512 414 551 319Q590 224 659 153Q728 82 821.50 41Q915 0 1024 0L1024 0Q1133 0 1226.50 41Q1320 82 1389 153Q1458 224 1497 319Q1536 414 1536 522L1536 522L1536 896L1792 896L1792 1024ZM640 522L640 522L640 896L1408 896L1408 522Q1408 441 1379 369.50Q1350 298 1298.50 244Q1247 190 1176.50 159Q1106 128 1024 128L1024 128Q942 128 871.50 159Q801 190 749.50 244Q698 298 669 369.50Q640 441 640 522Z"
         }
      }
   ]
}

var FabricFolderLink = {
   name: "FabricFolderLink",
   vendor: "UiFabric",
   unicode: 58460,
   value: "",
   charCode: "E45C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M2048 512L2048 512L2048 1368Q2019 1342 1987 1322Q1955 1302 1920 1286L1920 1286L1920 512L1216 512Q1160 512 1125.50 521.50Q1091 531 1067.50 545Q1044 559 1027 576Q1010 593 989.50 607Q969 621 940 630.50Q911 640 864 640L864 640L128 640L128 1536L640 1536L640 1664L128 1664Q101 1664 78 1654Q55 1644 37.50 1626.50Q20 1609 10 1586Q0 1563 0 1536L0 1536L0 256Q0 229 10 206Q20 183 37.50 165.50Q55 148 78 138Q101 128 128 128L128 128L864 128Q901 128 933 141.50Q965 155 991.50 177.50Q1018 200 1040 228.50Q1062 257 1079 287L1079 287Q1092 310 1104.50 328Q1117 346 1132.50 358.50Q1148 371 1167.50 377.50Q1187 384 1216 384L1216 384L1920 384Q1947 384 1970 394Q1993 404 2010.50 421.50Q2028 439 2038 462Q2048 485 2048 512ZM128 512L864 512Q891 512 909.50 503Q928 494 944.50 481Q961 468 978 452.50Q995 437 1017 425L1017 425Q1002 408 985.50 379.50Q969 351 950 323.50Q931 296 909.50 276Q888 256 864 256L864 256L128 256L128 512ZM1344 1280L1088 1280Q1048 1280 1013 1295Q978 1310 952 1336Q926 1362 911 1397Q896 1432 896 1472L896 1472Q896 1504 906 1532.50Q916 1561 933.50 1585Q951 1609 976 1627Q1001 1645 1031 1655L1031 1655Q1028 1673 1026 1691.50Q1024 1710 1024 1728L1024 1728Q1024 1742 1026 1757Q1028 1772 1030 1786L1030 1786Q973 1776 925 1747.50Q877 1719 842 1677Q807 1635 787.50 1582.50Q768 1530 768 1472L768 1472Q768 1406 793 1348Q818 1290 861.50 1246.50Q905 1203 963.50 1177.50Q1022 1152 1088 1152L1088 1152L1344 1152Q1410 1152 1468 1177.50Q1526 1203 1569.50 1246.50Q1613 1290 1638.50 1348Q1664 1406 1664 1472L1664 1472Q1664 1529 1645 1581Q1626 1633 1592 1674.50Q1558 1716 1511 1745Q1464 1774 1408 1785L1408 1785L1408 1652Q1436 1642 1460 1624Q1484 1606 1500.50 1582.50Q1517 1559 1526.50 1530.50Q1536 1502 1536 1472L1536 1472Q1536 1432 1521 1397Q1506 1362 1480 1336Q1454 1310 1419 1295Q1384 1280 1344 1280L1344 1280ZM1786 1409L1786 1409Q1843 1420 1891 1449Q1939 1478 1974 1520Q2009 1562 2028.50 1614.50Q2048 1667 2048 1725L2048 1725Q2048 1791 2023 1849.50Q1998 1908 1954.50 1952.50Q1911 1997 1852.50 2022.50Q1794 2048 1728 2048L1728 2048L1472 2048Q1406 2048 1347.50 2022.50Q1289 1997 1245.50 1952.50Q1202 1908 1177 1849.50Q1152 1791 1152 1725L1152 1725Q1152 1668 1171 1616Q1190 1564 1224 1521.50Q1258 1479 1305 1449.50Q1352 1420 1408 1409L1408 1409L1408 1542Q1379 1552 1355.50 1570.50Q1332 1589 1315.50 1613.50Q1299 1638 1289.50 1666.50Q1280 1695 1280 1725L1280 1725Q1280 1764 1295 1799.50Q1310 1835 1336 1862Q1362 1889 1397 1904.50Q1432 1920 1472 1920L1472 1920L1728 1920Q1768 1920 1803 1904.50Q1838 1889 1864 1862Q1890 1835 1905 1799.50Q1920 1764 1920 1725L1920 1725Q1920 1694 1910 1664.50Q1900 1635 1882.50 1610.50Q1865 1586 1840 1567.50Q1815 1549 1785 1540L1785 1540Q1788 1522 1790 1503.50Q1792 1485 1792 1467L1792 1467Q1792 1453 1790 1438Q1788 1423 1786 1409Z"
         }
      }
   ]
}

var LightningBoltSolid = {
   name: "LightningBoltSolid",
   vendor: "UiFabric",
   unicode: 58463,
   value: "",
   charCode: "E45F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1607 0L1223 768L1883 768L603 2048L313 2048L697 1280L248 1280L888 0L1607 0Z"
         }
      }
   ]
}

var MobileAngled = {
   name: "MobileAngled",
   vendor: "UiFabric",
   unicode: 58467,
   value: "",
   charCode: "E463",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1919 1058L2048 2048L1919 2048L1792 1074Q1789 1048 1781.50 1021.50Q1774 995 1755 976L1755 976L1308 532L1341 930Q1386 975 1429.50 1018.50Q1473 1062 1517 1107L1517 1107L1427 1197L1057 828Q1029 800 990 800L990 800Q971 800 954 807.50Q937 815 924 828Q911 841 903.50 858Q896 875 896 894L896 894Q896 933 924 961L924 961L1088 1126L1088 1280Q1088 1346 1111.50 1403Q1135 1460 1176.50 1502.50Q1218 1545 1274.50 1570.50Q1331 1596 1396 1599L1396 1599Q1396 1602 1395.50 1605Q1395 1608 1395 1611L1395 1611Q1395 1627 1397 1646Q1399 1665 1401.50 1684.50Q1404 1704 1406 1723Q1408 1742 1408 1758L1408 1758Q1408 1793 1394.50 1822.50Q1381 1852 1358.50 1873.50Q1336 1895 1305.50 1907.50Q1275 1920 1241 1920L1241 1920L155 1920Q123 1920 94.50 1909Q66 1898 45 1878Q24 1858 12 1830.50Q0 1803 0 1770L0 1770Q0 1763 0.50 1757Q1 1751 2 1744L2 1744L239 220Q243 197 258 180Q273 163 293.50 151.50Q314 140 337.50 134Q361 128 381 128L381 128L1147 128Q1167 128 1190 133.50Q1213 139 1233 150.50Q1253 162 1267 179.50Q1281 197 1283 220L1283 220L1292 335L1844 885Q1880 921 1896 964.50Q1912 1008 1919 1058L1919 1058ZM1201 790L1201 790L1157 257Q1154 256 1147 256L1147 256L381 256Q376 256 371.50 257Q367 258 362 259L362 259L128 1764L128 1770Q128 1781 136 1786.50Q144 1792 155 1792L155 1792L1241 1792Q1255 1792 1267.50 1784Q1280 1776 1280 1760L1280 1760Q1280 1747 1279 1733.50Q1278 1720 1276 1707L1276 1707Q1224 1692 1178.50 1665Q1133 1638 1095 1601Q1057 1564 1028.50 1519Q1000 1474 983 1423L983 1423Q967 1377 963.50 1334Q960 1291 960 1245L960 1245L960 1178L833 1052Q801 1020 784.50 979.50Q768 939 768 894L768 894Q768 848 785.50 807.50Q803 767 833 737Q863 707 903.50 689.50Q944 672 990 672L990 672Q1027 672 1055.50 681Q1084 690 1108 706Q1132 722 1154 743.50Q1176 765 1201 790ZM832 1664L576 1664L576 1536L832 1536L832 1664Z"
         }
      }
   ]
}

var CalculatorGroup = {
   name: "CalculatorGroup",
   vendor: "UiFabric",
   unicode: 58466,
   value: "",
   charCode: "E462",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1152 1280L1024 1280L1024 1152L1152 1152L1152 1280ZM1152 1536L1024 1536L1024 1408L1152 1408L1152 1536ZM1536 1792L1408 1792L1408 1664L1536 1664L1536 1792ZM1536 1536L1408 1536L1408 1408L1536 1408L1536 1536ZM1152 1792L1024 1792L1024 1664L1152 1664L1152 1792ZM128 0L1536 0L1536 128L256 128L256 1792L128 1792L128 0ZM640 1152L768 1152L768 1280L640 1280L640 1152ZM640 1408L768 1408L768 1536L640 1536L640 1408ZM640 1664L768 1664L768 1792L640 1792L640 1664ZM384 2048L384 256L1792 256L1792 2048L384 2048ZM512 1920L1664 1920L1664 384L512 384L512 1920ZM640 512L1536 512L1536 896L640 896L640 512ZM768 768L1408 768L1408 640L768 640L768 768ZM1536 1280L1408 1280L1408 1152L1536 1152L1536 1280Z"
         }
      }
   ]
}

var AssignPolicy = {
   name: "AssignPolicy",
   vendor: "UiFabric",
   unicode: 58465,
   value: "",
   charCode: "E461",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 1024L384 1024L384 1792L512 1792L512 1920L256 1920L256 0L1792 0L1792 1024ZM1664 128L384 128L384 896L1664 896L1664 128ZM896 512L1152 512L1152 384L1280 384L1280 640L768 640L768 384L896 384L896 512ZM640 2048L640 1152L2048 1152L2048 2048L640 2048ZM1344 1542L1851 1280L837 1280L1344 1542ZM768 1381L768 1920L1920 1920L1920 1381L1344 1678L768 1381Z"
         }
      }
   ]
}

var Gather = {
   name: "Gather",
   vendor: "UiFabric",
   unicode: 58464,
   value: "",
   charCode: "E460",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 1920L0 1920L0 1408L512 1408L512 1920ZM384 1536L128 1536L128 1792L384 1792L384 1536ZM1536 1536L1536 640L2048 640L2048 1536L1536 1536ZM1664 1408L1920 1408L1920 1152L1664 1152L1664 1408ZM1664 1024L1920 1024L1920 768L1664 768L1664 1024ZM512 1280L0 1280L0 768L512 768L512 1280ZM384 896L128 896L128 1152L384 1152L384 896ZM512 640L0 640L0 128L512 128L512 640ZM384 256L128 256L128 512L384 512L384 256ZM1164 1024L1001 861L1091 771L1408 1088L1091 1405L1001 1315L1164 1152L640 1152L640 1024L1164 1024Z"
         }
      }
   ]
}

var CopyEdit = {
   name: "CopyEdit",
   vendor: "UiFabric",
   unicode: 58468,
   value: "",
   charCode: "E464",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1532 1920L1792 1920L1792 1660L1920 1531L1920 2048L1405 2048L1532 1920ZM1538 896L1408 896L1408 512L768 512L768 1900Q768 1901 762.50 1922.50Q757 1944 750.50 1970.50Q744 1997 738 2020.50Q732 2044 731 2048L731 2048L640 2048L640 1664L128 1664L128 0L987 0L1371 384L1499 384L1854 739Q1772 739 1701 768L1701 768L1536 603L1536 768L1701 768Q1673 780 1652 793.50Q1631 807 1613 822.50Q1595 838 1577 856.50Q1559 875 1538 896L1538 896ZM640 1536L640 384L1189 384L933 128L256 128L256 1536L640 1536ZM2048 1094L2048 1094Q2048 1133 2033 1170Q2018 1207 1990 1235L1990 1235L1273 1954L896 2048L990 1671L1707 953Q1735 925 1772 910.50Q1809 896 1848 896L1848 896Q1890 896 1926.50 911Q1963 926 1990 953Q2017 980 2032.50 1016Q2048 1052 2048 1094ZM1920 1094L1920 1094Q1920 1063 1899.50 1043.50Q1879 1024 1848 1024L1848 1024Q1834 1024 1821 1028.50Q1808 1033 1798 1043L1798 1043L1106 1737L1072 1872L1207 1838L1899 1145Q1920 1124 1920 1094Z"
         }
      }
   ]
}

var EntityExtraction = {
   name: "EntityExtraction",
   vendor: "UiFabric",
   unicode: 58471,
   value: "",
   charCode: "E467",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 0L1243 0L1792 549L1792 2048L128 2048L128 0ZM1573 512L1280 219L1280 512L1573 512ZM256 128L256 1920L1664 1920L1664 640L1152 640L1152 128L256 128ZM384 384L768 384L768 512L384 512L384 384ZM384 768L768 768L768 896L384 896L384 768ZM768 1664L384 1664L384 1536L768 1536L768 1664ZM384 1024L896 1024L896 1152L384 1152L384 1024ZM1536 1152L1024 1152L1024 1024L1536 1024L1536 1152ZM896 768L1152 768L1152 896L896 896L896 768ZM1536 896L1280 896L1280 768L1536 768L1536 896ZM384 1280L640 1280L640 1408L384 1408L384 1280ZM768 1280L1024 1280L1024 1408L768 1408L768 1280ZM1152 1664L896 1664L896 1536L1152 1536L1152 1664ZM1536 1664L1280 1664L1280 1536L1536 1536L1536 1664ZM1536 1408L1152 1408L1152 1280L1536 1280L1536 1408Z"
         }
      }
   ]
}

var MostyCloudyFlurriesNight = {
   name: "MostyCloudyFlurriesNight",
   vendor: "UiFabric",
   unicode: 58493,
   value: "",
   charCode: "E47D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1536 1792L1536 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L640 1664L640 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1267 153.50 1195Q179 1123 227 1063L227 1063Q146 1009 90.50 929Q35 849 14 754L14 754Q72 768 128 768L128 768Q234 768 327.50 728Q421 688 490.50 618.50Q560 549 600 455.50Q640 362 640 256L640 256Q640 200 626 142L626 142Q713 162 786 209Q859 256 912 322Q965 388 994.50 469.50Q1024 551 1024 640L1024 640Q1024 648 1023 657Q1022 666 1021 674L1021 674Q1068 657 1117 648.50Q1166 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM723 921L723 921Q783 820 879 750L879 750Q896 694 896 640L896 640Q896 555 861 479Q826 403 761 348L761 348Q746 453 699 545Q652 637 580.50 708.50Q509 780 417 827Q325 874 220 889L220 889Q242 915 268.50 936Q295 957 324 974L324 974Q380 936 444 916Q508 896 576 896L576 896Q650 896 723 921ZM1318 1888L1318 1888Q1318 1915 1299 1933.50Q1280 1952 1254 1952L1254 1952Q1242 1952 1228 1946.50Q1214 1941 1200.50 1933Q1187 1925 1174.50 1917Q1162 1909 1152 1903L1152 1903Q1152 1914 1152.50 1927Q1153 1940 1153 1954L1153 1954Q1153 1971 1151 1988Q1149 2005 1142 2018.50Q1135 2032 1122 2040Q1109 2048 1088 2048L1088 2048Q1067 2048 1054 2040Q1041 2032 1034 2018.50Q1027 2005 1025 1988Q1023 1971 1023 1954L1023 1954Q1023 1940 1023.50 1927Q1024 1914 1024 1903L1024 1903Q1014 1909 1001.50 1917Q989 1925 975.50 1933Q962 1941 948 1946.50Q934 1952 922 1952L922 1952Q896 1952 877 1933.50Q858 1915 858 1888L858 1888Q858 1852 890 1833L890 1833L960 1792L890 1751Q858 1732 858 1696L858 1696Q858 1670 876.50 1651Q895 1632 921 1632L921 1632Q934 1632 948 1637.50Q962 1643 975.50 1651Q989 1659 1001.50 1667Q1014 1675 1024 1681L1024 1681Q1024 1670 1023.50 1657.50Q1023 1645 1023 1631L1023 1631Q1023 1614 1025 1597Q1027 1580 1034 1566.50Q1041 1553 1054 1544.50Q1067 1536 1088 1536L1088 1536Q1109 1536 1122 1544.50Q1135 1553 1142 1566.50Q1149 1580 1151 1597Q1153 1614 1153 1631L1153 1631Q1153 1645 1152.50 1657.50Q1152 1670 1152 1681L1152 1681Q1162 1675 1174.50 1667Q1187 1659 1200.50 1651Q1214 1643 1228 1637.50Q1242 1632 1255 1632L1255 1632Q1281 1632 1299.50 1651Q1318 1670 1318 1696L1318 1696Q1318 1732 1286 1751L1286 1751L1216 1792L1286 1833Q1318 1852 1318 1888Z"
         }
      }
   ]
}

var PartlySunnyTStormsNight = {
   name: "PartlySunnyTStormsNight",
   vendor: "UiFabric",
   unicode: 58492,
   value: "",
   charCode: "E47C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1280 1792L1408 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L832 1664L768 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1267 153.50 1195Q179 1123 227 1063L227 1063Q146 1009 90.50 929Q35 849 14 754L14 754Q72 768 128 768L128 768Q234 768 327.50 728Q421 688 490.50 618.50Q560 549 600 455.50Q640 362 640 256L640 256Q640 200 626 142L626 142Q713 162 786 209Q859 256 912 322Q965 388 994.50 469.50Q1024 551 1024 640L1024 640Q1024 648 1023 657Q1022 666 1021 674L1021 674Q1068 657 1117 648.50Q1166 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM723 921L723 921Q783 820 879 750L879 750Q896 694 896 640L896 640Q896 555 861 479Q826 403 761 348L761 348Q746 453 699 545Q652 637 580.50 708.50Q509 780 417 827Q325 874 220 889L220 889Q242 915 268.50 936Q295 957 324 974L324 974Q380 936 444 916Q508 896 576 896L576 896Q650 896 723 921ZM1152 1408L1472 1408L832 2048L1088 1536L864 1536L1056 1152L1280 1152L1152 1408Z"
         }
      }
   ]
}

var MostyCloudyTStormsNight = {
   name: "MostyCloudyTStormsNight",
   vendor: "UiFabric",
   unicode: 58491,
   value: "",
   charCode: "E47B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1787 1218L1787 1218Q1829 1223 1865 1242.50Q1901 1262 1927.50 1291.50Q1954 1321 1969 1359.50Q1984 1398 1984 1440L1984 1440Q1984 1486 1966.50 1527Q1949 1568 1918.50 1598.50Q1888 1629 1847 1646.50Q1806 1664 1760 1664L1760 1664L1664 1664L1664 1536Q1676 1536 1689 1536.50Q1702 1537 1716 1537L1716 1537Q1741 1537 1766 1534Q1791 1531 1811 1521.50Q1831 1512 1843.50 1492.50Q1856 1473 1856 1440L1856 1440Q1856 1407 1843.50 1388Q1831 1369 1811 1359Q1791 1349 1766 1346Q1741 1343 1716 1343L1716 1343Q1702 1343 1689 1343.50Q1676 1344 1664 1344L1664 1344L1664 1280Q1664 1227 1644 1180.50Q1624 1134 1589 1099Q1554 1064 1507.50 1044Q1461 1024 1408 1024L1408 1024Q1328 1024 1265.50 1067.50Q1203 1111 1171 1184L1171 1184Q1166 1197 1160.50 1210Q1155 1223 1150 1236L1150 1236Q1127 1230 1103 1223Q1079 1216 1056 1216L1056 1216Q1023 1216 994 1228.50Q965 1241 943 1263Q921 1285 908.50 1314Q896 1343 896 1376L896 1376Q896 1421 919.50 1458Q943 1495 982 1515L982 1515L926 1632Q890 1613 861 1586Q832 1559 811 1526Q790 1493 779 1455Q768 1417 768 1376L768 1376Q768 1319 789.50 1267Q811 1215 850 1174L850 1174Q747 1028 693.50 859.50Q640 691 640 512L640 512Q640 350 685 195L685 195Q559 247 456 332Q353 417 280.50 525.50Q208 634 168 761Q128 888 128 1024L128 1024Q128 1142 157.50 1252Q187 1362 241 1459Q295 1556 371 1637Q447 1718 540 1778Q633 1838 741 1874.50Q849 1911 967 1918L967 1918L904 2041Q775 2026 658 1981Q541 1936 440.50 1866Q340 1796 258.50 1704.50Q177 1613 119.50 1505Q62 1397 31 1275Q0 1153 0 1024L0 1024Q0 895 31 773.50Q62 652 119.50 544.50Q177 437 258 345.50Q339 254 439 184Q539 114 656 69Q773 24 901 8L901 8Q836 123 802 251Q768 379 768 512L768 512Q768 672 816 823Q864 974 957 1105L957 1105Q1005 1088 1053 1088L1053 1088Q1058 1088 1063.50 1088.50Q1069 1089 1075 1089L1075 1089Q1100 1044 1136 1008Q1172 972 1215 947.50Q1258 923 1307 909.50Q1356 896 1408 896L1408 896Q1478 896 1542 920.50Q1606 945 1656.50 988Q1707 1031 1741.50 1090Q1776 1149 1787 1218ZM1272 1280L1464 1280L1344 1536L1600 1536L1080 2048L1280 1664L1088 1664L1272 1280Z"
         }
      }
   ]
}

var PartlySunnyShowersNight = {
   name: "PartlySunnyShowersNight",
   vendor: "UiFabric",
   unicode: 58490,
   value: "",
   charCode: "E47A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1787 1218L1787 1218Q1829 1223 1865 1242.50Q1901 1262 1927.50 1291.50Q1954 1321 1969 1359.50Q1984 1398 1984 1440L1984 1440Q1984 1486 1966.50 1527Q1949 1568 1918.50 1598.50Q1888 1629 1847 1646.50Q1806 1664 1760 1664L1760 1664L1646 1664Q1635 1630 1619 1599Q1603 1568 1587 1536L1587 1536L1760 1536Q1800 1536 1828 1508Q1856 1480 1856 1440L1856 1440Q1856 1400 1828 1372Q1800 1344 1760 1344L1760 1344L1664 1344L1664 1280Q1664 1227 1644 1180.50Q1624 1134 1589 1099Q1554 1064 1507.50 1044Q1461 1024 1408 1024L1408 1024Q1328 1024 1265 1067.50Q1202 1111 1171 1184L1171 1184Q1166 1197 1160.50 1210Q1155 1223 1150 1236L1150 1236Q1127 1230 1103 1223Q1079 1216 1056 1216L1056 1216Q1023 1216 994 1228.50Q965 1241 943 1263Q921 1285 908.50 1314Q896 1343 896 1376L896 1376Q896 1409 908.50 1438Q921 1467 943 1489Q965 1511 994 1523.50Q1023 1536 1056 1536L1056 1536L1101 1536Q1085 1568 1069.50 1598.50Q1054 1629 1043 1663L1043 1663Q986 1660 935.50 1636.50Q885 1613 848 1574.50Q811 1536 789.50 1485Q768 1434 768 1376L768 1376Q768 1319 789.50 1267Q811 1215 850 1174L850 1174Q747 1028 693.50 859.50Q640 691 640 512L640 512Q640 350 685 195L685 195Q559 247 456 332Q353 417 280.50 525.50Q208 634 168 761Q128 888 128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920Q1035 1920 1045 1920Q1055 1920 1066 1919L1066 1919Q1087 1955 1116.50 1985Q1146 2015 1182 2036L1182 2036Q1104 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 895 31 773.50Q62 652 119.50 544.50Q177 437 258 345.50Q339 254 439 184Q539 114 656 69Q773 24 901 8L901 8Q836 123 802 251Q768 379 768 512L768 512Q768 672 816 823Q864 974 957 1105L957 1105Q1005 1088 1053 1088L1053 1088Q1058 1088 1063.50 1088.50Q1069 1089 1075 1089L1075 1089Q1100 1044 1136 1008Q1172 972 1215 947.50Q1258 923 1307 909.50Q1356 896 1408 896L1408 896Q1478 896 1542 920.50Q1606 945 1656.50 988Q1707 1031 1741.50 1090Q1776 1149 1787 1218ZM1198 1699L1344 1408L1490 1699Q1504 1729 1504 1760L1504 1760Q1504 1793 1491.50 1822Q1479 1851 1457 1873Q1435 1895 1406 1907.50Q1377 1920 1344 1920L1344 1920Q1311 1920 1282 1907.50Q1253 1895 1231 1873Q1209 1851 1196.50 1822Q1184 1793 1184 1760L1184 1760Q1184 1729 1198 1699L1198 1699Z"
         }
      }
   ]
}

var HazyNight = {
   name: "HazyNight",
   vendor: "UiFabric",
   unicode: 58489,
   value: "",
   charCode: "E479",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 1280L1984 1280Q2010 1280 2029 1299Q2048 1318 2048 1344L2048 1344Q2048 1370 2029 1389Q2010 1408 1984 1408L1984 1408L448 1408Q422 1408 403 1389Q384 1370 384 1344L384 1344Q384 1318 403 1299Q422 1280 448 1280L448 1280ZM704 1536L1600 1536Q1626 1536 1645 1555Q1664 1574 1664 1600L1664 1600Q1664 1626 1647 1644Q1630 1662 1604 1664L1604 1664Q1471 1787 1305 1852Q1139 1917 958 1917L958 1917Q826 1917 703.50 1883Q581 1849 474.50 1786.50Q368 1724 280.50 1636.50Q193 1549 130.50 1442.50Q68 1336 34 1213.50Q0 1091 0 959L0 959Q0 838 29 724.50Q58 611 111.50 510Q165 409 241 323.50Q317 238 410.50 172.50Q504 107 613.50 65Q723 23 843 8L843 8Q782 117 750.50 236Q719 355 719 480L719 480Q719 626 762 764.50Q805 903 888 1024L888 1024L1728 1024Q1754 1024 1773 1043Q1792 1062 1792 1088L1792 1088Q1792 1114 1773 1133Q1754 1152 1728 1152L1728 1152L704 1152Q678 1152 659 1133Q640 1114 640 1088L640 1088Q640 1065 649 1052Q658 1039 672.50 1033Q687 1027 704 1025.50Q721 1024 738 1024L738 1024Q666 899 628.50 761.50Q591 624 591 480L591 480Q591 408 600.50 337Q610 266 628 197L628 197Q514 246 422 325Q330 404 264.50 503.50Q199 603 163.50 719Q128 835 128 959L128 959Q128 1073 157.50 1179Q187 1285 241.50 1377.50Q296 1470 371.50 1545.50Q447 1621 539.50 1675.50Q632 1730 738 1759.50Q844 1789 958 1789L958 1789Q1074 1789 1185 1757Q1296 1725 1395 1664L1395 1664L704 1664Q678 1664 659 1645Q640 1626 640 1600L640 1600Q640 1574 659 1555Q678 1536 704 1536L704 1536Z"
         }
      }
   ]
}

var IntermittentCloudsNight = {
   name: "IntermittentCloudsNight",
   vendor: "UiFabric",
   unicode: 58488,
   value: "",
   charCode: "E478",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 512L896 512Q896 653 932.50 784Q969 915 1036 1028.50Q1103 1142 1196.50 1235.50Q1290 1329 1403.50 1396Q1517 1463 1648 1499.50Q1779 1536 1920 1536L1920 1536Q1951 1536 1981.50 1534Q2012 1532 2043 1528L2043 1528Q1975 1648 1879 1744.50Q1783 1841 1667.50 1908.50Q1552 1976 1421 2012Q1290 2048 1152 2048L1152 2048Q1022 2048 897 2015.50Q772 1983 658 1920L658 1920L256 1920Q203 1920 156.50 1900Q110 1880 75 1845Q40 1810 20 1763.50Q0 1717 0 1664L0 1664Q0 1618 15.50 1576.50Q31 1535 58.50 1501.50Q86 1468 123.50 1445Q161 1422 206 1413L206 1413Q168 1320 148 1222Q128 1124 128 1024L128 1024Q128 895 159 773.50Q190 652 247.50 544.50Q305 437 386 345.50Q467 254 567 184Q667 114 783.50 69Q900 24 1029 8L1029 8Q964 123 930 251Q896 379 896 512ZM128 1664L128 1664Q128 1691 138 1714Q148 1737 165.50 1754.50Q183 1772 206 1782Q229 1792 256 1792L256 1792L800 1792Q840 1792 868 1764Q896 1736 896 1696L896 1696Q896 1656 868 1628Q840 1600 800 1600L800 1600L709 1600L697 1552Q689 1521 671 1494.50Q653 1468 628.50 1448.50Q604 1429 574.50 1418.50Q545 1408 512 1408L512 1408Q475 1408 447 1418.50Q419 1429 397 1447.50Q375 1466 357 1491.50Q339 1517 323 1546L323 1546Q306 1543 289.50 1539.50Q273 1536 256 1536L256 1536Q229 1536 206 1546Q183 1556 165.50 1573.50Q148 1591 138 1614Q128 1637 128 1664ZM1152 1920L1152 1920Q1241 1920 1327.50 1902.50Q1414 1885 1495 1851Q1576 1817 1649.50 1768Q1723 1719 1786 1656L1786 1656Q1641 1639 1509.50 1588.50Q1378 1538 1265 1459.50Q1152 1381 1060 1277.50Q968 1174 903 1052.50Q838 931 803 794.50Q768 658 768 512L768 512Q768 350 813 195L813 195Q687 247 584 332Q481 417 408.50 525.50Q336 634 296 761Q256 888 256 1024L256 1024Q256 1190 317 1347L317 1347Q359 1315 409 1297.50Q459 1280 512 1280L512 1280Q560 1280 604.50 1293.50Q649 1307 687 1332.50Q725 1358 755 1393.50Q785 1429 804 1472L804 1472Q850 1473 890 1491Q930 1509 960 1539Q990 1569 1007 1609.50Q1024 1650 1024 1696L1024 1696Q1024 1755 995 1806.50Q966 1858 915 1888L915 1888Q1032 1920 1152 1920ZM1824 768L1280 768Q1227 768 1180.50 748Q1134 728 1099 693Q1064 658 1044 611.50Q1024 565 1024 512L1024 512Q1024 459 1044.50 412Q1065 365 1100 330.50Q1135 296 1181.50 276Q1228 256 1281 256L1281 256Q1326 196 1393.50 162Q1461 128 1536 128L1536 128Q1584 128 1628.50 141.50Q1673 155 1711 180.50Q1749 206 1779 241.50Q1809 277 1828 320L1828 320Q1874 321 1914 339Q1954 357 1984 387Q2014 417 2031 457.50Q2048 498 2048 544L2048 544Q2048 590 2030.50 631Q2013 672 1982.50 702.50Q1952 733 1911 750.50Q1870 768 1824 768L1824 768ZM1280 384L1280 384Q1253 384 1230 394Q1207 404 1189.50 421.50Q1172 439 1162 462Q1152 485 1152 512L1152 512Q1152 539 1162 562Q1172 585 1189.50 602.50Q1207 620 1230 630Q1253 640 1280 640L1280 640L1824 640Q1864 640 1892 612Q1920 584 1920 544L1920 544Q1920 504 1892 476Q1864 448 1824 448L1824 448L1733 448L1721 400Q1713 369 1695 342.50Q1677 316 1652.50 296.50Q1628 277 1598.50 266.50Q1569 256 1536 256L1536 256Q1499 256 1471 266.50Q1443 277 1421 295.50Q1399 314 1381 339.50Q1363 365 1347 394L1347 394Q1330 391 1313.50 387.50Q1297 384 1280 384Z"
         }
      }
   ]
}

var PartlyClearNight = {
   name: "PartlyClearNight",
   vendor: "UiFabric",
   unicode: 58487,
   value: "",
   charCode: "E477",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1984 1440L1984 1440Q1984 1476 1973 1509.50Q1962 1543 1942 1570.50Q1922 1598 1894 1619Q1866 1640 1832 1652L1832 1652Q1759 1746 1668.50 1819.50Q1578 1893 1474.50 1944Q1371 1995 1257 2021.50Q1143 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 895 31 773.50Q62 652 119.50 544.50Q177 437 258 345.50Q339 254 439 184Q539 114 656 69Q773 24 901 8L901 8Q836 123 802 251Q768 379 768 512L768 512Q768 673 816 823.50Q864 974 958 1105L958 1105Q978 1097 1003.50 1092.50Q1029 1088 1053 1088L1053 1088Q1058 1088 1064 1088Q1070 1088 1075 1089L1075 1089Q1101 1044 1137 1008Q1173 972 1216 947.50Q1259 923 1307.50 909.50Q1356 896 1408 896L1408 896Q1478 896 1542 920.50Q1606 945 1656.50 988Q1707 1031 1741.50 1090Q1776 1149 1787 1218L1787 1218Q1829 1223 1865 1242.50Q1901 1262 1927.50 1291.50Q1954 1321 1969 1359.50Q1984 1398 1984 1440ZM1056 1216L1056 1216Q1023 1216 994 1228.50Q965 1241 943 1263Q921 1285 908.50 1314Q896 1343 896 1376L896 1376Q896 1409 908.50 1438Q921 1467 943 1489Q965 1511 994 1523.50Q1023 1536 1056 1536L1056 1536L1760 1536Q1800 1536 1828 1508Q1856 1480 1856 1440L1856 1440Q1856 1400 1828 1372Q1800 1344 1760 1344L1760 1344L1664 1344L1664 1280Q1664 1227 1644 1180.50Q1624 1134 1589 1099Q1554 1064 1507.50 1044Q1461 1024 1408 1024L1408 1024Q1369 1024 1332.50 1035.50Q1296 1047 1265.50 1068Q1235 1089 1210.50 1118.50Q1186 1148 1171 1184L1171 1184L1150 1236Q1127 1230 1103 1223Q1079 1216 1056 1216ZM128 1024L128 1024Q128 1148 160 1262Q192 1376 250.50 1475.50Q309 1575 391 1657Q473 1739 572.50 1797.50Q672 1856 786.50 1888Q901 1920 1024 1920L1024 1920Q1201 1920 1362.50 1854Q1524 1788 1650 1664L1650 1664L1056 1664Q996 1664 943.50 1641.50Q891 1619 852 1580Q813 1541 790.50 1488.50Q768 1436 768 1376L768 1376Q768 1319 789.50 1267Q811 1215 851 1174L851 1174Q748 1028 694 859.50Q640 691 640 512L640 512Q640 350 685 195L685 195Q559 247 456 332Q353 417 280.50 525.50Q208 634 168 761Q128 888 128 1024Z"
         }
      }
   ]
}

var MostyClearNight = {
   name: "MostyClearNight",
   vendor: "UiFabric",
   unicode: 58486,
   value: "",
   charCode: "E476",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 512L768 512Q768 653 804.50 784Q841 915 908 1028.50Q975 1142 1068.50 1235.50Q1162 1329 1275.50 1396Q1389 1463 1520 1499.50Q1651 1536 1792 1536L1792 1536Q1823 1536 1853.50 1534Q1884 1532 1915 1528L1915 1528Q1847 1648 1751 1744.50Q1655 1841 1539.50 1908.50Q1424 1976 1293 2012Q1162 2048 1024 2048L1024 2048Q883 2048 752 2011.50Q621 1975 507.50 1908Q394 1841 300.50 1747.50Q207 1654 140 1540.50Q73 1427 36.50 1296Q0 1165 0 1024L0 1024Q0 895 31 773.50Q62 652 119.50 544.50Q177 437 258 345.50Q339 254 439 184Q539 114 656 69Q773 24 901 8L901 8Q836 123 802 251Q768 379 768 512ZM1658 1656L1658 1656Q1513 1639 1381.50 1588.50Q1250 1538 1137 1459.50Q1024 1381 932 1277.50Q840 1174 775 1052.50Q710 931 675 794.50Q640 658 640 512L640 512Q640 350 685 195L685 195Q559 246 456 331Q353 416 280.50 524.50Q208 633 168 760.50Q128 888 128 1024L128 1024Q128 1148 160 1262.50Q192 1377 250.50 1476.50Q309 1576 390.50 1657.50Q472 1739 571.50 1797.50Q671 1856 785.50 1888Q900 1920 1024 1920L1024 1920Q1205 1920 1367.50 1852Q1530 1784 1658 1656ZM1828 576L1828 576Q1874 577 1914 595Q1954 613 1984 643Q2014 673 2031 713.50Q2048 754 2048 800L2048 800Q2048 846 2030.50 887Q2013 928 1982.50 958.50Q1952 989 1911 1006.50Q1870 1024 1824 1024L1824 1024L1280 1024Q1227 1024 1180.50 1004Q1134 984 1099 949Q1064 914 1044 867.50Q1024 821 1024 768L1024 768Q1024 715 1044.50 668Q1065 621 1100 586.50Q1135 552 1181.50 532Q1228 512 1281 512L1281 512Q1326 452 1393.50 418Q1461 384 1536 384L1536 384Q1584 384 1628.50 397.50Q1673 411 1711 436.50Q1749 462 1779 497.50Q1809 533 1828 576ZM1280 896L1824 896Q1864 896 1892 868Q1920 840 1920 800L1920 800Q1920 760 1892 732Q1864 704 1824 704L1824 704L1733 704L1721 656Q1713 625 1695 598.50Q1677 572 1652.50 552.50Q1628 533 1598.50 522.50Q1569 512 1536 512L1536 512Q1499 512 1471 522.50Q1443 533 1421 551.50Q1399 570 1381 595.50Q1363 621 1347 650L1347 650Q1330 647 1313.50 643.50Q1297 640 1280 640L1280 640Q1253 640 1230 650Q1207 660 1189.50 677.50Q1172 695 1162 718Q1152 741 1152 768L1152 768Q1152 795 1162 818Q1172 841 1189.50 858.50Q1207 876 1230 886Q1253 896 1280 896L1280 896Z"
         }
      }
   ]
}

var FreezingRain = {
   name: "FreezingRain",
   vendor: "UiFabric",
   unicode: 58485,
   value: "",
   charCode: "E475",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 1920L1152 1600L1344 1280L1536 1600L1344 1920ZM686 1827L832 1536L978 1827Q992 1857 992 1888L992 1888Q992 1921 979.50 1950Q967 1979 945 2001Q923 2023 894 2035.50Q865 2048 832 2048L832 2048Q799 2048 770 2035.50Q741 2023 719 2001Q697 1979 684.50 1950Q672 1921 672 1888L672 1888Q672 1857 686 1827L686 1827ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1469 2029.50 1525.50Q2011 1582 1977.50 1629Q1944 1676 1896.50 1712Q1849 1748 1792 1768L1792 1768L1792 1629Q1851 1594 1885.50 1535.50Q1920 1477 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L515 1786Q432 1775 361 1736Q290 1697 238.50 1637.50Q187 1578 157.50 1503Q128 1428 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036Z"
         }
      }
   ]
}

var Sleet = {
   name: "Sleet",
   vendor: "UiFabric",
   unicode: 58484,
   value: "",
   charCode: "E474",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 1408L1344 1408Q1384 1408 1419 1423Q1454 1438 1480 1464Q1506 1490 1521 1525Q1536 1560 1536 1600L1536 1600Q1536 1640 1521 1675Q1506 1710 1480 1736Q1454 1762 1419 1777Q1384 1792 1344 1792L1344 1792Q1304 1792 1269 1777Q1234 1762 1208 1736Q1182 1710 1167 1675Q1152 1640 1152 1600L1152 1600Q1152 1560 1167 1525Q1182 1490 1208 1464Q1234 1438 1269 1423Q1304 1408 1344 1408ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1469 2029.50 1525.50Q2011 1582 1977.50 1629Q1944 1676 1896.50 1712Q1849 1748 1792 1768L1792 1768L1792 1629Q1851 1594 1885.50 1535.50Q1920 1477 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1405 277.50 1459.50Q299 1514 337.50 1556Q376 1598 428 1625.50Q480 1653 540 1660L540 1660Q522 1687 509 1717.50Q496 1748 489 1780L489 1780Q411 1764 345 1724Q279 1684 230.50 1626Q182 1568 155 1496Q128 1424 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036ZM832 1664L832 1664Q872 1664 907 1679Q942 1694 968 1720Q994 1746 1009 1781Q1024 1816 1024 1856L1024 1856Q1024 1896 1009 1931Q994 1966 968 1992Q942 2018 907 2033Q872 2048 832 2048L832 2048Q792 2048 757 2033Q722 2018 696 1992Q670 1966 655 1931Q640 1896 640 1856L640 1856Q640 1816 655 1781Q670 1746 696 1720Q722 1694 757 1679Q792 1664 832 1664Z"
         }
      }
   ]
}

var Ice = {
   name: "Ice",
   vendor: "UiFabric",
   unicode: 58483,
   value: "",
   charCode: "E473",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1344 1920L1152 1600L1344 1280L1536 1600L1344 1920ZM832 2048L640 1728L832 1408L1024 1728L832 2048ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1469 2029.50 1525.50Q2011 1582 1977.50 1629Q1944 1676 1896.50 1712Q1849 1748 1792 1768L1792 1768L1792 1629Q1851 1594 1885.50 1535.50Q1920 1477 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1401 275 1453Q294 1505 328 1546.50Q362 1588 409 1617Q456 1646 512 1657L512 1657L512 1785Q430 1773 359.50 1734Q289 1695 237.50 1636Q186 1577 157 1502Q128 1427 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036Z"
         }
      }
   ]
}

var PartlySunnyFlurriesDay = {
   name: "PartlySunnyFlurriesDay",
   vendor: "UiFabric",
   unicode: 58482,
   value: "",
   charCode: "E472",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 960L1408 960Q1408 1018 1393.50 1073.50Q1379 1129 1351 1178.50Q1323 1228 1283.50 1270Q1244 1312 1194 1342L1194 1342Q1216 1391 1216 1440L1216 1440Q1216 1486 1198.50 1527Q1181 1568 1150.50 1598.50Q1120 1629 1079 1646.50Q1038 1664 992 1664L992 1664L896 1664L896 1536L992 1536Q1032 1536 1060 1508Q1088 1480 1088 1440L1088 1440Q1088 1400 1060 1372Q1032 1344 992 1344L992 1344L896 1344L896 1280Q896 1227 876 1180.50Q856 1134 821 1099Q786 1064 739.50 1044Q693 1024 640 1024L640 1024Q601 1024 564.50 1035.50Q528 1047 497 1068Q466 1089 442 1118.50Q418 1148 403 1184L403 1184L382 1236Q359 1230 335 1223Q311 1216 288 1216L288 1216Q255 1216 226 1228.50Q197 1241 175 1263Q153 1285 140.50 1314Q128 1343 128 1376L128 1376Q128 1405 137.50 1430Q147 1455 164.50 1475.50Q182 1496 205.50 1509.50Q229 1523 256 1529L256 1529L256 1661Q202 1655 155 1630.50Q108 1606 73.50 1567.50Q39 1529 19.50 1480Q0 1431 0 1376L0 1376Q0 1317 22.50 1264.50Q45 1212 83 1173Q121 1134 172.50 1111Q224 1088 283 1088L283 1088Q289 1088 295 1088Q301 1088 307 1089L307 1089Q342 1029 395 984.50Q448 940 514 917L514 917Q522 831 560.50 757Q599 683 659 628.50Q719 574 796 543Q873 512 960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960ZM1019 1218L1019 1218Q1063 1222 1104 1246L1104 1246Q1144 1226 1176.50 1195.50Q1209 1165 1232 1127.50Q1255 1090 1267.50 1047.50Q1280 1005 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q903 640 851 659Q799 678 757.50 712Q716 746 687 793Q658 840 646 896L646 896Q715 897 778 922Q841 947 890.50 989.50Q940 1032 974 1090.50Q1008 1149 1019 1218ZM896 0L1024 0L1024 384L896 384L896 0ZM1536 1024L1536 896L1920 896L1920 1024L1536 1024ZM326 236L598 507L507 598L236 326L326 236ZM1594 1684L1322 1413L1413 1322L1684 1594L1594 1684ZM1594 236L1684 326L1413 598L1322 507L1594 236ZM806 1888L806 1888Q806 1915 787 1933.50Q768 1952 742 1952L742 1952Q730 1952 716 1946.50Q702 1941 688.50 1933Q675 1925 662.50 1917Q650 1909 640 1903L640 1903Q640 1914 640.50 1927Q641 1940 641 1954L641 1954Q641 1971 639 1988Q637 2005 630 2018.50Q623 2032 610 2040Q597 2048 576 2048L576 2048Q555 2048 542 2040Q529 2032 522 2018.50Q515 2005 513 1988Q511 1971 511 1954L511 1954Q511 1940 511.50 1927Q512 1914 512 1903L512 1903Q502 1909 489.50 1917Q477 1925 463.50 1933Q450 1941 436 1946.50Q422 1952 410 1952L410 1952Q384 1952 365 1933.50Q346 1915 346 1888L346 1888Q346 1852 378 1833L378 1833L448 1792L378 1751Q346 1732 346 1696L346 1696Q346 1670 364.50 1651Q383 1632 409 1632L409 1632Q422 1632 436 1637.50Q450 1643 463.50 1651Q477 1659 489.50 1667Q502 1675 512 1681L512 1681Q512 1670 511.50 1657.50Q511 1645 511 1631L511 1631Q511 1614 513 1597Q515 1580 522 1566.50Q529 1553 542 1544.50Q555 1536 576 1536L576 1536Q597 1536 610 1544.50Q623 1553 630 1566.50Q637 1580 639 1597Q641 1614 641 1631L641 1631Q641 1645 640.50 1657.50Q640 1670 640 1681L640 1681Q650 1675 662.50 1667Q675 1659 688.50 1651Q702 1643 716 1637.50Q730 1632 743 1632L743 1632Q769 1632 787.50 1651Q806 1670 806 1696L806 1696Q806 1732 774 1751L774 1751L704 1792L774 1833Q806 1852 806 1888Z"
         }
      }
   ]
}

var MostyCloudyFlurriesDay = {
   name: "MostyCloudyFlurriesDay",
   vendor: "UiFabric",
   unicode: 58481,
   value: "",
   charCode: "E471",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1536 1792L1536 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L640 1664L640 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1277 147 1214.50Q166 1152 201 1098.50Q236 1045 285.50 1003Q335 961 396 934L396 934Q384 885 384 832L384 832Q384 739 419 657.50Q454 576 515 515Q576 454 657.50 419Q739 384 832 384L832 384Q896 384 957 402Q1018 420 1070.50 453.50Q1123 487 1165.50 534.50Q1208 582 1235 640L1235 640Q1325 643 1407.50 673.50Q1490 704 1559.50 756Q1629 808 1681 879.50Q1733 951 1761 1036ZM723 921L723 921Q784 818 881 748Q978 678 1095 653L1095 653Q1051 587 981 549.50Q911 512 832 512L832 512Q766 512 707.50 537.50Q649 563 605.50 606.50Q562 650 537 708Q512 766 512 832L512 832Q512 849 513.50 865.50Q515 882 520 899L520 899Q548 896 576 896L576 896Q650 896 723 921ZM1318 1888L1318 1888Q1318 1915 1299 1933.50Q1280 1952 1254 1952L1254 1952Q1242 1952 1228 1946.50Q1214 1941 1200.50 1933Q1187 1925 1174.50 1917Q1162 1909 1152 1903L1152 1903Q1152 1914 1152.50 1927Q1153 1940 1153 1954L1153 1954Q1153 1971 1151 1988Q1149 2005 1142 2018.50Q1135 2032 1122 2040Q1109 2048 1088 2048L1088 2048Q1067 2048 1054 2040Q1041 2032 1034 2018.50Q1027 2005 1025 1988Q1023 1971 1023 1954L1023 1954Q1023 1940 1023.50 1927Q1024 1914 1024 1903L1024 1903Q1014 1909 1001.50 1917Q989 1925 975.50 1933Q962 1941 948 1946.50Q934 1952 922 1952L922 1952Q896 1952 877 1933.50Q858 1915 858 1888L858 1888Q858 1852 890 1833L890 1833L960 1792L890 1751Q858 1732 858 1696L858 1696Q858 1670 876.50 1651Q895 1632 921 1632L921 1632Q934 1632 948 1637.50Q962 1643 975.50 1651Q989 1659 1001.50 1667Q1014 1675 1024 1681L1024 1681Q1024 1670 1023.50 1657.50Q1023 1645 1023 1631L1023 1631Q1023 1614 1025 1597Q1027 1580 1034 1566.50Q1041 1553 1054 1544.50Q1067 1536 1088 1536L1088 1536Q1109 1536 1122 1544.50Q1135 1553 1142 1566.50Q1149 1580 1151 1597Q1153 1614 1153 1631L1153 1631Q1153 1645 1152.50 1657.50Q1152 1670 1152 1681L1152 1681Q1162 1675 1174.50 1667Q1187 1659 1200.50 1651Q1214 1643 1228 1637.50Q1242 1632 1255 1632L1255 1632Q1281 1632 1299.50 1651Q1318 1670 1318 1696L1318 1696Q1318 1732 1286 1751L1286 1751L1216 1792L1286 1833Q1318 1852 1318 1888ZM0 768L256 768L256 896L0 896L0 768ZM289 198L470 379L379 470L198 289L289 198ZM768 0L896 0L896 256L768 256L768 0ZM1375 198L1466 289L1285 470L1194 379L1375 198Z"
         }
      }
   ]
}

var PartlySunnyTStormsDay = {
   name: "PartlySunnyTStormsDay",
   vendor: "UiFabric",
   unicode: 58480,
   value: "",
   charCode: "E470",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 960L1408 960Q1408 1018 1393.50 1073.50Q1379 1129 1351 1178.50Q1323 1228 1283.50 1270Q1244 1312 1194 1342L1194 1342Q1216 1391 1216 1440L1216 1440Q1216 1486 1198.50 1527Q1181 1568 1150.50 1598.50Q1120 1629 1079 1646.50Q1038 1664 992 1664L992 1664L896 1664L896 1536L992 1536Q1032 1536 1060 1508Q1088 1480 1088 1440L1088 1440Q1088 1400 1060 1372Q1032 1344 992 1344L992 1344L896 1344L896 1280Q896 1227 876 1180.50Q856 1134 821 1099Q786 1064 739.50 1044Q693 1024 640 1024L640 1024Q601 1024 564.50 1035.50Q528 1047 497 1068Q466 1089 442 1118.50Q418 1148 403 1184L403 1184L382 1236Q359 1230 335 1223Q311 1216 288 1216L288 1216Q255 1216 226 1228.50Q197 1241 175 1263Q153 1285 140.50 1314Q128 1343 128 1376L128 1376Q128 1421 151.50 1458Q175 1495 214 1515L214 1515L158 1632Q122 1613 93 1586Q64 1559 43 1526Q22 1493 11 1455Q0 1417 0 1376L0 1376Q0 1316 22.50 1263.50Q45 1211 84 1172Q123 1133 175 1110.50Q227 1088 286 1088L286 1088Q291 1088 296.50 1088.50Q302 1089 307 1089L307 1089Q342 1029 395 984.50Q448 940 514 917L514 917Q522 831 560.50 757Q599 683 659 628.50Q719 574 796 543Q873 512 960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960ZM1019 1218L1019 1218Q1063 1222 1104 1246L1104 1246Q1144 1226 1176.50 1195.50Q1209 1165 1232 1127.50Q1255 1090 1267.50 1047.50Q1280 1005 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q903 640 851 659Q799 678 757.50 712Q716 746 687 793Q658 840 646 896L646 896Q715 897 778 922Q841 947 890.50 989.50Q940 1032 974 1090.50Q1008 1149 1019 1218ZM896 0L1024 0L1024 384L896 384L896 0ZM1536 1024L1536 896L1920 896L1920 1024L1536 1024ZM326 236L598 507L507 598L236 326L326 236ZM1594 1684L1322 1413L1413 1322L1684 1594L1594 1684ZM1594 236L1684 326L1413 598L1322 507L1594 236ZM504 1280L696 1280L576 1536L832 1536L312 2048L512 1664L320 1664L504 1280Z"
         }
      }
   ]
}

var MostyCloudyTStormsDay = {
   name: "MostyCloudyTStormsDay",
   vendor: "UiFabric",
   unicode: 58479,
   value: "",
   charCode: "E46F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 768L256 768L256 896L0 896L0 768ZM289 198L470 379L379 470L198 289L289 198ZM768 0L896 0L896 256L768 256L768 0ZM1375 198L1466 289L1285 470L1194 379L1375 198ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1280 1792L1408 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306.50Q1879 1260 1843 1225.50Q1807 1191 1759.50 1171.50Q1712 1152 1658 1152L1658 1152Q1646 1070 1607 999.50Q1568 929 1509 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L832 1664L768 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1277 147 1214.50Q166 1152 201 1098.50Q236 1045 285.50 1003Q335 961 396 934L396 934Q384 885 384 832L384 832Q384 739 419 657.50Q454 576 515 515Q576 454 657.50 419Q739 384 832 384L832 384Q896 384 957 402Q1018 420 1070.50 453.50Q1123 487 1165.50 534.50Q1208 582 1235 640L1235 640Q1325 643 1407.50 673.50Q1490 704 1559.50 756Q1629 808 1681 879.50Q1733 951 1761 1036ZM723 921L723 921Q784 818 881 748Q978 678 1095 653L1095 653Q1051 587 981 549.50Q911 512 832 512L832 512Q766 512 707.50 537.50Q649 563 605.50 606.50Q562 650 537 708Q512 766 512 832L512 832Q512 849 513.50 865.50Q515 882 520 899L520 899Q548 896 576 896L576 896Q650 896 723 921ZM1152 1408L1472 1408L832 2048L1088 1536L864 1536L1056 1152L1280 1152L1152 1408Z"
         }
      }
   ]
}

var PartlySunnyShowersDay = {
   name: "PartlySunnyShowersDay",
   vendor: "UiFabric",
   unicode: 58478,
   value: "",
   charCode: "E46E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 960L1408 960Q1408 1018 1393.50 1073.50Q1379 1129 1351 1178.50Q1323 1228 1283.50 1270Q1244 1312 1194 1342L1194 1342Q1216 1391 1216 1440L1216 1440Q1216 1486 1198.50 1527Q1181 1568 1150.50 1598.50Q1120 1629 1079 1646.50Q1038 1664 992 1664L992 1664L878 1664Q867 1630 851 1599Q835 1568 819 1536L819 1536L992 1536Q1032 1536 1060 1508Q1088 1480 1088 1440L1088 1440Q1088 1400 1060 1372Q1032 1344 992 1344L992 1344L896 1344L896 1280Q896 1227 876 1180.50Q856 1134 821 1099Q786 1064 739.50 1044Q693 1024 640 1024L640 1024Q601 1024 564.50 1035.50Q528 1047 497 1068Q466 1089 442 1118.50Q418 1148 403 1184L403 1184L382 1236Q359 1230 335 1223Q311 1216 288 1216L288 1216Q255 1216 226 1228.50Q197 1241 175 1263Q153 1285 140.50 1314Q128 1343 128 1376L128 1376Q128 1409 140.50 1438Q153 1467 175 1489Q197 1511 226 1523.50Q255 1536 288 1536L288 1536L333 1536Q317 1568 301.50 1598.50Q286 1629 275 1663L275 1663Q218 1660 167.50 1636.50Q117 1613 80 1574.50Q43 1536 21.50 1485Q0 1434 0 1376L0 1376Q0 1316 22.50 1263.50Q45 1211 84 1172Q123 1133 175 1110.50Q227 1088 286 1088L286 1088Q291 1088 296.50 1088.50Q302 1089 307 1089L307 1089Q342 1029 395 984.50Q448 940 514 917L514 917Q522 831 560.50 757Q599 683 659 628.50Q719 574 796 543Q873 512 960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960ZM1019 1218L1019 1218Q1063 1222 1104 1246L1104 1246Q1144 1226 1177 1195.50Q1210 1165 1232.50 1128Q1255 1091 1267.50 1048Q1280 1005 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q903 640 851 659Q799 678 757.50 712Q716 746 687 793Q658 840 646 896L646 896Q715 897 778 922Q841 947 890.50 989.50Q940 1032 974 1090.50Q1008 1149 1019 1218ZM896 0L1024 0L1024 384L896 384L896 0ZM1536 1024L1536 896L1920 896L1920 1024L1536 1024ZM326 236L598 507L507 598L236 326L326 236ZM1594 1684L1322 1413L1413 1322L1684 1594L1594 1684ZM1594 236L1684 326L1413 598L1322 507L1594 236ZM430 1699L576 1408L722 1699Q736 1729 736 1760L736 1760Q736 1793 723.50 1822Q711 1851 689 1873Q667 1895 638 1907.50Q609 1920 576 1920L576 1920Q543 1920 514 1907.50Q485 1895 463 1873Q441 1851 428.50 1822Q416 1793 416 1760L416 1760Q416 1729 430 1699L430 1699Z"
         }
      }
   ]
}

var MostyCloudyShowersDay = {
   name: "MostyCloudyShowersDay",
   vendor: "UiFabric",
   unicode: 58477,
   value: "",
   charCode: "E46D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M750 1827L896 1536L1042 1827Q1056 1857 1056 1888L1056 1888Q1056 1921 1043.50 1950Q1031 1979 1009 2001Q987 2023 958 2035.50Q929 2048 896 2048L896 2048Q863 2048 834 2035.50Q805 2023 783 2001Q761 1979 748.50 1950Q736 1921 736 1888L736 1888Q736 1857 750 1827L750 1827ZM1134 1571L1280 1280L1426 1571Q1440 1601 1440 1632L1440 1632Q1440 1665 1427.50 1694Q1415 1723 1393 1745Q1371 1767 1342 1779.50Q1313 1792 1280 1792L1280 1792Q1247 1792 1218 1779.50Q1189 1767 1167 1745Q1145 1723 1132.50 1694Q1120 1665 1120 1632L1120 1632Q1120 1601 1134 1571L1134 1571ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1556 1792Q1573 1763 1583 1730.50Q1593 1698 1597 1664L1597 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508.50 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L672 1664L608 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1277 147 1214.50Q166 1152 201 1098.50Q236 1045 285.50 1003Q335 961 396 934L396 934Q384 885 384 832L384 832Q384 739 419.50 657.50Q455 576 515.50 515.50Q576 455 657.50 419.50Q739 384 832 384L832 384Q897 384 957.50 402Q1018 420 1070.50 453.50Q1123 487 1165 534.50Q1207 582 1235 640L1235 640Q1325 643 1407.50 673.50Q1490 704 1559.50 756Q1629 808 1681 879.50Q1733 951 1761 1036ZM723 921L723 921Q784 818 881.50 748Q979 678 1096 653L1096 653Q1051 587 981.50 549.50Q912 512 832 512L832 512Q766 512 707.50 537.50Q649 563 605.50 606.50Q562 650 537 708Q512 766 512 832L512 832Q512 864 520 899L520 899Q548 896 576 896L576 896Q650 896 723 921ZM0 768L256 768L256 896L0 896L0 768ZM289 198L470 379L379 470L198 289L289 198ZM768 0L896 0L896 256L768 256L768 0ZM1375 198L1466 289L1285 470L1194 379L1375 198Z"
         }
      }
   ]
}

var Showers = {
   name: "Showers",
   vendor: "UiFabric",
   unicode: 58476,
   value: "",
   charCode: "E46C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M750 1827L896 1536L1042 1827Q1056 1857 1056 1888L1056 1888Q1056 1921 1043.50 1950Q1031 1979 1009 2001Q987 2023 958 2035.50Q929 2048 896 2048L896 2048Q863 2048 834 2035.50Q805 2023 783 2001Q761 1979 748.50 1950Q736 1921 736 1888L736 1888Q736 1857 750 1827L750 1827ZM1134 1571L1280 1280L1426 1571Q1440 1601 1440 1632L1440 1632Q1440 1665 1427.50 1694Q1415 1723 1393 1745Q1371 1767 1342 1779.50Q1313 1792 1280 1792L1280 1792Q1247 1792 1218 1779.50Q1189 1767 1167 1745Q1145 1723 1132.50 1694Q1120 1665 1120 1632L1120 1632Q1120 1601 1134 1571L1134 1571ZM1761 1036L1761 1036Q1824 1053 1876.50 1088.50Q1929 1124 1967.50 1173Q2006 1222 2027 1282Q2048 1342 2048 1408L2048 1408Q2048 1488 2018 1557.50Q1988 1627 1935.50 1679.50Q1883 1732 1813 1762Q1743 1792 1664 1792L1664 1792L1556 1792Q1573 1763 1583 1730.50Q1593 1698 1597 1664L1597 1664L1664 1664Q1717 1664 1763.50 1644Q1810 1624 1845 1589Q1880 1554 1900 1507.50Q1920 1461 1920 1408L1920 1408Q1920 1353 1899.50 1306Q1879 1259 1843 1225Q1807 1191 1759 1171.50Q1711 1152 1657 1152L1657 1152Q1645 1070 1606 999.50Q1567 929 1508.50 877.50Q1450 826 1375 797Q1300 768 1216 768L1216 768Q1139 768 1069.50 793Q1000 818 943 862Q886 906 844.50 968Q803 1030 784 1103L784 1103Q740 1065 687 1044.50Q634 1024 576 1024L576 1024Q510 1024 451.50 1049Q393 1074 349.50 1117.50Q306 1161 281 1219.50Q256 1278 256 1344L256 1344Q256 1410 281 1468.50Q306 1527 349.50 1570.50Q393 1614 451.50 1639Q510 1664 576 1664L576 1664L672 1664L608 1792L576 1792Q483 1792 401.50 1756.50Q320 1721 259.50 1660.50Q199 1600 163.50 1518.50Q128 1437 128 1344L128 1344Q128 1251 163.50 1169.50Q199 1088 259.50 1027.50Q320 967 401.50 931.50Q483 896 576 896L576 896Q650 896 723 921L723 921Q762 856 815.50 804Q869 752 932.50 715.50Q996 679 1068 659.50Q1140 640 1216 640L1216 640Q1309 640 1394.50 669Q1480 698 1552 750.50Q1624 803 1678 875.50Q1732 948 1761 1036Z"
         }
      }
   ]
}

var HazyDay = {
   name: "HazyDay",
   vendor: "UiFabric",
   unicode: 58475,
   value: "",
   charCode: "E46B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 0L1024 0L1024 384L896 384L896 0ZM0 896L384 896L384 1024L0 1024L0 896ZM326 236L598 507L507 598L236 326L326 236ZM1594 236L1684 326L1413 598L1322 507L1594 236ZM2048 1344L2048 1344Q2048 1370 2029 1389Q2010 1408 1984 1408L1984 1408L448 1408Q422 1408 403 1389Q384 1370 384 1344L384 1344Q384 1318 403 1299Q422 1280 448 1280L448 1280L647 1280L643 1277Q611 1247 587 1210Q563 1173 546 1132Q529 1091 520.50 1047.50Q512 1004 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960L1408 960Q1408 976 1406.50 992Q1405 1008 1403 1024L1403 1024L1728 1024Q1754 1024 1773 1043Q1792 1062 1792 1088L1792 1088Q1792 1114 1773 1133Q1754 1152 1728 1152L1728 1152L832 1152Q806 1152 787 1133Q768 1114 768 1088L768 1088Q768 1062 787 1043Q806 1024 832 1024L832 1024L1274 1024Q1280 993 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280L960 1280L1984 1280Q2010 1280 2029 1299Q2048 1318 2048 1344ZM704 1536L1600 1536Q1626 1536 1645 1555Q1664 1574 1664 1600L1664 1600Q1664 1626 1645 1645Q1626 1664 1600 1664L1600 1664L704 1664Q678 1664 659 1645Q640 1626 640 1600L640 1600Q640 1574 659 1555Q678 1536 704 1536L704 1536Z"
         }
      }
   ]
}

var IntermittentCloudsDay = {
   name: "IntermittentCloudsDay",
   vendor: "UiFabric",
   unicode: 58474,
   value: "",
   charCode: "E46A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 0L1024 0L1024 384L896 384L896 0ZM1920 1024L1536 1024L1536 896L1920 896L1920 1024ZM0 896L384 896L384 1024L0 1024L0 896ZM326 236L598 507L507 598L236 326L326 236ZM1594 1684L1322 1413L1413 1322L1684 1594L1594 1684ZM1828 320L1828 320Q1874 321 1914 339Q1954 357 1984 387Q2014 417 2031 457.50Q2048 498 2048 544L2048 544Q2048 590 2030.50 631Q2013 672 1982.50 702.50Q1952 733 1911 750.50Q1870 768 1824 768L1824 768L1365 768Q1408 860 1408 960L1408 960Q1408 1053 1373 1134.50Q1338 1216 1277 1277Q1216 1338 1134.50 1373Q1053 1408 960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512L960 512Q976 512 992 513.50Q1008 515 1024 517L1024 517Q1024 463 1043.50 415.50Q1063 368 1097.50 332.50Q1132 297 1179 276.50Q1226 256 1281 256L1281 256Q1326 196 1393.50 162Q1461 128 1536 128L1536 128Q1584 128 1628.50 141.50Q1673 155 1711 180.50Q1749 206 1779 241.50Q1809 277 1828 320ZM960 1280L960 1280Q1026 1280 1084 1255Q1142 1230 1185.50 1186.50Q1229 1143 1254.50 1084.50Q1280 1026 1280 960L1280 960Q1280 905 1261.50 853Q1243 801 1208 758L1208 758Q1166 745 1131 720Q1096 695 1071 660L1071 660Q1017 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1280 640L1824 640Q1864 640 1892 612Q1920 584 1920 544L1920 544Q1920 504 1892 476Q1864 448 1824 448L1824 448L1733 448L1721 400Q1713 369 1695 342.50Q1677 316 1652.50 296.50Q1628 277 1598.50 266.50Q1569 256 1536 256L1536 256Q1499 256 1471 266.50Q1443 277 1421 295.50Q1399 314 1381 339.50Q1363 365 1347 394L1347 394Q1330 391 1313.50 387.50Q1297 384 1280 384L1280 384Q1253 384 1230 394Q1207 404 1189.50 421.50Q1172 439 1162 462Q1152 485 1152 512L1152 512Q1152 539 1162 562Q1172 585 1189.50 602.50Q1207 620 1230 630Q1253 640 1280 640L1280 640ZM804 1472L804 1472Q850 1473 890 1491Q930 1509 960 1539Q990 1569 1007 1609.50Q1024 1650 1024 1696L1024 1696Q1024 1742 1006.50 1783Q989 1824 958.50 1854.50Q928 1885 887 1902.50Q846 1920 800 1920L800 1920L256 1920Q203 1920 156.50 1900Q110 1880 75 1845Q40 1810 20 1763.50Q0 1717 0 1664L0 1664Q0 1612 20 1565Q40 1518 75 1483.50Q110 1449 156 1428.50Q202 1408 255 1408L255 1408L257 1408Q302 1348 369.50 1314Q437 1280 512 1280L512 1280Q560 1280 604.50 1293.50Q649 1307 687 1332.50Q725 1358 755 1393.50Q785 1429 804 1472ZM256 1792L800 1792Q840 1792 868 1764Q896 1736 896 1696L896 1696Q896 1656 868 1628Q840 1600 800 1600L800 1600L709 1600L697 1552Q689 1521 671 1494.50Q653 1468 628.50 1448.50Q604 1429 574.50 1418.50Q545 1408 512 1408L512 1408Q475 1408 447 1418.50Q419 1429 397 1447.50Q375 1466 357 1491.50Q339 1517 323 1546L323 1546Q306 1543 289.50 1539.50Q273 1536 256 1536L256 1536Q229 1536 206 1546Q183 1556 165.50 1573.50Q148 1591 138 1614Q128 1637 128 1664L128 1664Q128 1691 138 1714Q148 1737 165.50 1754.50Q183 1772 206 1782Q229 1792 256 1792L256 1792Z"
         }
      }
   ]
}

var PartlySunnyDay = {
   name: "PartlySunnyDay",
   vendor: "UiFabric",
   unicode: 58473,
   value: "",
   charCode: "E469",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1408 960L1408 960Q1408 1018 1393.50 1073.50Q1379 1129 1351 1178.50Q1323 1228 1283.50 1270Q1244 1312 1194 1342L1194 1342Q1216 1391 1216 1440L1216 1440Q1216 1486 1198.50 1527Q1181 1568 1150.50 1598.50Q1120 1629 1079 1646.50Q1038 1664 992 1664L992 1664L288 1664Q228 1664 175.50 1641.50Q123 1619 84 1580Q45 1541 22.50 1488.50Q0 1436 0 1376L0 1376Q0 1316 22.50 1263.50Q45 1211 84 1172Q123 1133 175.50 1110.50Q228 1088 288 1088L288 1088Q293 1088 297.50 1088Q302 1088 307 1089L307 1089Q342 1029 395 984.50Q448 940 514 917L514 917Q522 831 560.50 757Q599 683 659 628.50Q719 574 796 543Q873 512 960 512L960 512Q1053 512 1134.50 547Q1216 582 1277 643Q1338 704 1373 785.50Q1408 867 1408 960ZM960 640L960 640Q903 640 851 659Q799 678 757.50 712Q716 746 687 793Q658 840 646 896L646 896Q715 897 778 922Q841 947 890.50 989.50Q940 1032 974 1090.50Q1008 1149 1019 1218L1019 1218Q1063 1222 1104 1246L1104 1246Q1144 1226 1176.50 1195.50Q1209 1165 1232 1127.50Q1255 1090 1267.50 1047.50Q1280 1005 1280 960L1280 960Q1280 894 1254.50 836Q1229 778 1185.50 734.50Q1142 691 1084 665.50Q1026 640 960 640ZM288 1536L992 1536Q1032 1536 1060 1508Q1088 1480 1088 1440L1088 1440Q1088 1400 1060 1372Q1032 1344 992 1344L992 1344L896 1344L896 1280Q896 1227 876 1180.50Q856 1134 821 1099Q786 1064 739.50 1044Q693 1024 640 1024L640 1024Q601 1024 564.50 1035.50Q528 1047 497.50 1068Q467 1089 442.50 1118.50Q418 1148 403 1184L403 1184L382 1236Q359 1230 335 1223Q311 1216 288 1216L288 1216Q255 1216 226 1228.50Q197 1241 175 1263Q153 1285 140.50 1314Q128 1343 128 1376L128 1376Q128 1409 140.50 1438Q153 1467 175 1489Q197 1511 226 1523.50Q255 1536 288 1536L288 1536ZM896 0L1024 0L1024 384L896 384L896 0ZM1536 1024L1536 896L1920 896L1920 1024L1536 1024ZM326 236L598 507L507 598L236 326L326 236ZM1594 1684L1322 1413L1413 1322L1684 1594L1594 1684ZM1594 236L1684 326L1413 598L1322 507L1594 236Z"
         }
      }
   ]
}

var MostySunnyDay = {
   name: "MostySunnyDay",
   vendor: "UiFabric",
   unicode: 58472,
   value: "",
   charCode: "E468",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M896 0L1024 0L1024 384L896 384L896 0ZM1024 1920L896 1920L896 1536L1024 1536L1024 1920ZM0 896L384 896L384 1024L0 1024L0 896ZM326 236L598 507L507 598L236 326L326 236ZM1594 1684L1322 1413L1413 1322L1684 1594L1594 1684ZM326 1684L236 1594L507 1322L598 1413L326 1684ZM1828 576L1828 576Q1874 577 1914 595Q1954 613 1984 643Q2014 673 2031 713.50Q2048 754 2048 800L2048 800Q2048 846 2030.50 887Q2013 928 1982.50 958.50Q1952 989 1911 1006.50Q1870 1024 1824 1024L1824 1024L1403 1024Q1392 1107 1352.50 1177.50Q1313 1248 1253.50 1299Q1194 1350 1118.50 1379Q1043 1408 960 1408L960 1408Q867 1408 785.50 1373Q704 1338 643 1277Q582 1216 547 1134.50Q512 1053 512 960L512 960Q512 867 547 785.50Q582 704 643 643Q704 582 785.50 547Q867 512 960 512L960 512Q1008 512 1054 522Q1100 532 1144 551L1144 551Q1175 532 1210 522Q1245 512 1281 512L1281 512Q1326 452 1393.50 418Q1461 384 1536 384L1536 384Q1584 384 1628.50 397.50Q1673 411 1711 436.50Q1749 462 1779 497.50Q1809 533 1828 576ZM960 1280L960 1280Q1017 1280 1069 1261Q1121 1242 1162.50 1208Q1204 1174 1233 1127Q1262 1080 1274 1024L1274 1024Q1222 1023 1176.50 1002.50Q1131 982 1097 947Q1063 912 1043.50 866Q1024 820 1024 768L1024 768Q1024 738 1031 709Q1038 680 1051 653L1051 653Q1028 647 1005.50 643.50Q983 640 960 640L960 640Q894 640 835.50 665.50Q777 691 733.50 734.50Q690 778 665 836Q640 894 640 960L640 960Q640 1026 665 1084.50Q690 1143 733.50 1186.50Q777 1230 835.50 1255Q894 1280 960 1280ZM1280 896L1824 896Q1864 896 1892 868Q1920 840 1920 800L1920 800Q1920 760 1892 732Q1864 704 1824 704L1824 704L1733 704L1721 656Q1713 625 1695 598.50Q1677 572 1652.50 552.50Q1628 533 1598.50 522.50Q1569 512 1536 512L1536 512Q1499 512 1471 522.50Q1443 533 1421 551.50Q1399 570 1381 595.50Q1363 621 1347 650L1347 650Q1330 647 1313.50 643.50Q1297 640 1280 640L1280 640Q1253 640 1230 650Q1207 660 1189.50 677.50Q1172 695 1162 718Q1152 741 1152 768L1152 768Q1152 795 1162 818Q1172 841 1189.50 858.50Q1207 876 1230 886Q1253 896 1280 896L1280 896Z"
         }
      }
   ]
}

var Sharepoint2013LogoInverse = {
   name: "Sharepoint2013LogoInverse",
   vendor: "UiFabric",
   unicode: 58496,
   value: "",
   charCode: "E480",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1216 1992L64 1791L64 263L1216 56L1216 1992ZM392 869L392 869Q392 926 411 964.50Q430 1003 458.50 1030.50Q487 1058 520 1077.50Q553 1097 581.50 1116Q610 1135 629 1155.50Q648 1176 648 1206L648 1206Q648 1225 641 1237.50Q634 1250 622 1257Q610 1264 595 1267Q580 1270 564 1270L564 1270Q517 1270 478.50 1247.50Q440 1225 408 1193L408 1193L394 1199L394 1359L398 1366Q438 1395 487.50 1406Q537 1417 586 1417L586 1417Q639 1417 682.50 1403Q726 1389 756.50 1361Q787 1333 804 1291.50Q821 1250 821 1195L821 1195Q821 1136 801 1096.50Q781 1057 751 1028.50Q721 1000 686.50 980.50Q652 961 622 942.50Q592 924 572 903Q552 882 552 852L552 852Q552 832 560 818.50Q568 805 581 797Q594 789 610.50 785.50Q627 782 644 782L644 782Q680 782 715 793.50Q750 805 778 828L778 828L791 821L791 662L786 655Q762 644 729 638.50Q696 633 670 633L670 633Q645 633 621 634.50Q597 636 573 641L573 641Q488 660 440 721Q392 782 392 869ZM1884 835L1884 835Q1919 840 1949 856.50Q1979 873 2001 898.50Q2023 924 2035.50 956Q2048 988 2048 1024L2048 1024Q2048 1060 2035.50 1092Q2023 1124 2001 1149.50Q1979 1175 1949 1191.50Q1919 1208 1884 1213L1884 1213Q1844 1311 1769.50 1386Q1695 1461 1596 1500L1596 1500Q1600 1516 1600 1536L1600 1536Q1600 1576 1585 1611Q1570 1646 1544 1672Q1518 1698 1483 1713Q1448 1728 1408 1728L1408 1728Q1373 1728 1339.50 1715Q1306 1702 1280 1678L1280 1678L1280 1394Q1306 1370 1339.50 1357Q1373 1344 1408 1344L1408 1344Q1446 1344 1481.50 1358.50Q1517 1373 1543 1400L1543 1400Q1618 1373 1676.50 1319.50Q1735 1266 1769 1194L1769 1194Q1721 1170 1692.50 1124Q1664 1078 1664 1024L1664 1024Q1664 970 1692.50 924Q1721 878 1769 854L1769 854Q1735 782 1676.50 728.50Q1618 675 1543 648L1543 648Q1517 675 1481.50 689.50Q1446 704 1408 704L1408 704Q1373 704 1339.50 691Q1306 678 1280 654L1280 654L1280 370Q1306 346 1339.50 333Q1373 320 1408 320L1408 320Q1448 320 1483 335Q1518 350 1544 376Q1570 402 1585 437Q1600 472 1600 512L1600 512Q1600 532 1596 548L1596 548Q1695 587 1769.50 662Q1844 737 1884 835Z"
         }
      }
   ]
}

var PowerVirtualAgentsLogo = {
   name: "PowerVirtualAgentsLogo",
   vendor: "UiFabric",
   unicode: 58500,
   value: "",
   charCode: "E484",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M241 256L1806 256Q1856 256 1900 275Q1944 294 1977 327Q2010 360 2029 404Q2048 448 2048 498L2048 498L2048 1337Q2048 1387 2029 1431Q2010 1475 1977 1508Q1944 1541 1900 1560Q1856 1579 1806 1579L1806 1579L1749 1576L1749 1493L1806 1496Q1838 1496 1867 1483.50Q1896 1471 1917.50 1449Q1939 1427 1952 1398Q1965 1369 1965 1337L1965 1337L1965 498Q1965 465 1952.50 436.50Q1940 408 1918 386Q1896 364 1867.50 351.50Q1839 339 1806 339L1806 339L241 339Q208 339 179.50 352Q151 365 129.50 386.50Q108 408 95.50 437Q83 466 83 498L83 498L83 1337Q83 1381 98.50 1411Q114 1441 139.50 1459.50Q165 1478 198.50 1486Q232 1494 268 1494L268 1494Q276 1494 283.50 1494Q291 1494 299 1493L299 1493L299 1576L241 1579Q191 1579 147.50 1560Q104 1541 71 1508Q38 1475 19 1431Q0 1387 0 1337L0 1337L0 498Q0 448 19 404Q38 360 70.50 327Q103 294 147 275Q191 256 241 256L241 256ZM1280 1365L1280 1365L1280 1408Q1280 1443 1255 1468Q1230 1493 1195 1493L1195 1493L683 1493Q683 1508 687 1544Q691 1580 691 1619L691 1619Q691 1641 689 1661.50Q687 1682 681 1697.50Q675 1713 665 1722.50Q655 1732 640 1732L640 1732L610 1719Q598 1707 577 1688.50Q556 1670 530.50 1647.50Q505 1625 479 1599.50Q453 1574 432 1549Q411 1524 397.50 1500.50Q384 1477 384 1458L384 1458L384 939Q384 921 390.50 905.50Q397 890 408.50 878.50Q420 867 435.50 860Q451 853 469 853L469 853L683 853Q683 962 680.50 1041.50Q678 1121 678 1179L678 1179Q678 1241 684 1279.50Q690 1318 708.50 1339.50Q727 1361 761 1368.50Q795 1376 851 1376L851 1376Q918 1376 1022.50 1370.50Q1127 1365 1280 1365ZM875 576L1643 576Q1678 576 1703 601Q1728 626 1728 661L1728 661L1728 1159Q1728 1180 1707.50 1211Q1687 1242 1656 1277.50Q1625 1313 1588 1348.50Q1551 1384 1517.50 1412Q1484 1440 1460 1458Q1436 1476 1430 1476L1430 1476Q1415 1476 1405 1467Q1395 1458 1389.50 1443.50Q1384 1429 1382 1410Q1380 1391 1380 1371L1380 1371Q1380 1336 1383.50 1304.50Q1387 1273 1387 1259L1387 1259L875 1259Q857 1259 841.50 1252Q826 1245 814.50 1233.50Q803 1222 796 1206.50Q789 1191 789 1173L789 1173L789 661Q789 643 796 627.50Q803 612 815 600.50Q827 589 842.50 582.50Q858 576 875 576L875 576ZM1493 1280L1621 1152L1621 683L896 683L896 1152L1493 1152L1493 1280Z"
         }
      }
   ]
}

var CaretSolidAlt = {
   name: "CaretSolidAlt",
   vendor: "UiFabric",
   unicode: 58499,
   value: "",
   charCode: "E483",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 1755L640 293L1371 1024L640 1755Z"
         }
      }
   ]
}

var OutlookSpacesBucket = {
   name: "OutlookSpacesBucket",
   vendor: "UiFabric",
   unicode: 58497,
   value: "",
   charCode: "E481",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M448 0L1472 0Q1512 0 1547 15Q1582 30 1608 56Q1634 82 1649 117Q1664 152 1664 192L1664 192L1664 1856Q1664 1896 1649 1931Q1634 1966 1608 1992Q1582 2018 1547 2033Q1512 2048 1472 2048L1472 2048L448 2048Q408 2048 373 2033Q338 2018 312 1992Q286 1966 271 1931Q256 1896 256 1856L256 1856L256 192Q256 152 271 117Q286 82 312 56Q338 30 373 15Q408 0 448 0L448 0ZM1536 1856L1536 1856L1536 192Q1536 166 1517 147Q1498 128 1472 128L1472 128L448 128Q422 128 403 147Q384 166 384 192L384 192L384 1856Q384 1882 403 1901Q422 1920 448 1920L448 1920L1472 1920Q1498 1920 1517 1901Q1536 1882 1536 1856ZM1408 1024L512 1024L512 256L1408 256L1408 1024ZM1280 384L640 384L640 896L1280 896L1280 384ZM1408 1792L512 1792L512 1152L1408 1152L1408 1792ZM1280 1280L640 1280L640 1664L1280 1664L1280 1280Z"
         }
      }
   ]
}

var FluidLogo = {
   name: "FluidLogo",
   vendor: "UiFabric",
   unicode: 58506,
   value: "",
   charCode: "E48A",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 1664L768 1664L768 1792L512 1792Q459 1792 412.50 1772Q366 1752 331 1717Q296 1682 276 1635.50Q256 1589 256 1536L256 1536L256 768L384 768L384 1536Q384 1563 394 1586Q404 1609 421.50 1626.50Q439 1644 462 1654Q485 1664 512 1664L512 1664ZM1536 384L768 384L768 256L1536 256Q1589 256 1635.50 276Q1682 296 1717 331Q1752 366 1772 412.50Q1792 459 1792 512L1792 512L1792 768L1664 768L1664 512Q1664 485 1654 462Q1644 439 1626.50 421.50Q1609 404 1586 394Q1563 384 1536 384L1536 384ZM640 192L640 448Q640 488 625 523Q610 558 584 584Q558 610 523 625Q488 640 448 640L448 640L192 640Q152 640 117 625Q82 610 56 584Q30 558 15 523Q0 488 0 448L0 448L0 192Q0 152 15 117Q30 82 56 56Q82 30 117 15Q152 0 192 0L192 0L448 0Q488 0 523 15Q558 30 584 56Q610 82 625 117Q640 152 640 192L640 192ZM128 192L128 448Q128 474 147 493Q166 512 192 512L192 512L448 512Q474 512 493 493Q512 474 512 448L512 448L512 192Q512 166 493 147Q474 128 448 128L448 128L192 128Q166 128 147 147Q128 166 128 192L128 192ZM1152 896L1792 896Q1845 896 1891.50 916Q1938 936 1973 971Q2008 1006 2028 1052.50Q2048 1099 2048 1152L2048 1152L2048 1792Q2048 1845 2028 1891.50Q2008 1938 1973 1973Q1938 2008 1891.50 2028Q1845 2048 1792 2048L1792 2048L1152 2048Q1099 2048 1052.50 2028Q1006 2008 971 1973Q936 1938 916 1891.50Q896 1845 896 1792L896 1792L896 1152Q896 1099 916 1052.50Q936 1006 971 971Q1006 936 1052.50 916Q1099 896 1152 896L1152 896ZM1920 1792L1920 1792L1920 1152Q1920 1125 1910 1102Q1900 1079 1882.50 1061.50Q1865 1044 1842 1034Q1819 1024 1792 1024L1792 1024L1152 1024Q1125 1024 1102 1034Q1079 1044 1061.50 1061.50Q1044 1079 1034 1102Q1024 1125 1024 1152L1024 1152L1024 1792Q1024 1819 1034 1842Q1044 1865 1061.50 1882.50Q1079 1900 1102 1910Q1125 1920 1152 1920L1152 1920L1792 1920Q1819 1920 1842 1910Q1865 1900 1882.50 1882.50Q1900 1865 1910 1842Q1920 1819 1920 1792Z"
         }
      }
   ]
}

var CategoryClassification = {
   name: "CategoryClassification",
   vendor: "UiFabric",
   unicode: 58508,
   value: "",
   charCode: "E48C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 0L1371 0L1920 549L1920 2048L256 2048L256 1152L384 1152L384 1920L1792 1920L1792 640L1280 640L1280 128L384 128L384 256L256 256L256 0ZM1701 512L1408 219L1408 512L1701 512ZM1536 1664L640 1664L640 1536L1536 1536L1536 1664ZM640 1280L677 1280L421 1024L128 1024L128 384L1024 384L1024 1024L768 1024L768 1280L1536 1280L1536 1408L640 1408L640 1280ZM896 512L256 512L256 896L475 896L640 1061L640 896L896 896L896 512ZM507 742L507 742L493 756Q484 762 471.50 765Q459 768 448 768L448 768L448 725L384 725L384 640L512 640L512 725Q512 729 510 733.50Q508 738 507 742ZM704 768L704 768L704 725L640 725L640 640L768 640L768 725Q768 729 766 733.50Q764 738 763 742L763 742L749 756Q740 762 727.50 765Q715 768 704 768Z"
         }
      }
   ]
}

var FormProcessing = {
   name: "FormProcessing",
   vendor: "UiFabric",
   unicode: 58507,
   value: "",
   charCode: "E48B",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M512 0L1499 0L2048 549L2048 2048L512 2048L512 0ZM1829 512L1536 219L1536 512L1829 512ZM640 128L640 1920L1920 1920L1920 640L1408 640L1408 128L640 128ZM384 1920L0 1920L0 128L384 128L384 256L128 256L128 1792L384 1792L384 1920ZM1536 1408L768 1408L768 1280L1536 1280L1536 1408ZM1792 1408L1664 1408L1664 1280L1792 1280L1792 1408ZM1536 1152L768 1152L768 1024L1536 1024L1536 1152ZM768 384L1152 384L1152 512L768 512L768 384ZM1792 1152L1664 1152L1664 1024L1792 1024L1792 1152Z"
         }
      }
   ]
}

var PhishingCampaign = {
   name: "PhishingCampaign",
   vendor: "UiFabric",
   unicode: 58509,
   value: "",
   charCode: "E48D",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1792 0L1792 256L2048 256L2048 1153Q2021 1116 1989 1083.50Q1957 1051 1920 1024L1920 1024L1920 520L1771 594Q1748 532 1704 485L1704 485L1905 384L399 384L1152 760L1160 757Q1165 789 1176 820Q1187 851 1204 878L1204 878L1152 904L384 520L384 1280L896 1280L896 1408L256 1408L256 1152L0 1152L0 0L1792 0ZM128 128L128 1024L256 1024L256 256L1664 256L1664 128L128 128ZM2048 1536L2048 1536Q2048 1642 2007.50 1735Q1967 1828 1897.50 1897.50Q1828 1967 1735 2007.50Q1642 2048 1536 2048L1536 2048Q1430 2048 1337 2007.50Q1244 1967 1174.50 1897.50Q1105 1828 1064.50 1735Q1024 1642 1024 1536L1024 1536L1024 1280L1280 1536L1152 1536Q1152 1615 1182.50 1685Q1213 1755 1265 1807Q1317 1859 1387 1889.50Q1457 1920 1536 1920L1536 1920Q1615 1920 1685 1889.50Q1755 1859 1807 1807Q1859 1755 1889.50 1685Q1920 1615 1920 1536L1920 1536Q1920 1469 1902.50 1417Q1885 1365 1856 1323.50Q1827 1282 1789 1249Q1751 1216 1709.50 1185.50Q1668 1155 1625 1125Q1582 1095 1544.50 1061Q1507 1027 1476.50 985.50Q1446 944 1428 891L1428 891Q1396 884 1368.50 866Q1341 848 1321.50 823Q1302 798 1291 767.50Q1280 737 1280 704L1280 704Q1280 665 1295 630Q1310 595 1336.50 568.50Q1363 542 1398 527Q1433 512 1472 512L1472 512Q1511 512 1546 527Q1581 542 1607.50 568.50Q1634 595 1649 630Q1664 665 1664 704L1664 704Q1664 758 1635.50 804Q1607 850 1559 875L1559 875Q1578 915 1609 947Q1640 979 1677.50 1008.50Q1715 1038 1757.50 1066.50Q1800 1095 1841 1127.50Q1882 1160 1919.50 1198.50Q1957 1237 1985.50 1286Q2014 1335 2031 1396.50Q2048 1458 2048 1536Z"
         }
      }
   ]
}

var PhishingHook = {
   name: "PhishingHook",
   vendor: "UiFabric",
   unicode: 58510,
   value: "",
   charCode: "E48E",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 1344L1664 1344Q1664 1441 1639 1531Q1614 1621 1568 1699.50Q1522 1778 1458 1842Q1394 1906 1315.50 1952Q1237 1998 1147 2023Q1057 2048 960 2048L960 2048Q863 2048 773 2023Q683 1998 604.50 1952Q526 1906 462 1842Q398 1778 352 1699.50Q306 1621 281 1531Q256 1441 256 1344L256 1344L256 896L640 1280L384 1280L384 1344Q384 1463 429.50 1568Q475 1673 553 1751Q631 1829 736 1874.50Q841 1920 960 1920L960 1920Q1079 1920 1184 1874.50Q1289 1829 1367 1751Q1445 1673 1490.50 1568Q1536 1463 1536 1344L1536 1344Q1536 1219 1484.50 1105.50Q1433 992 1339 910L1339 910Q1267 847 1194.50 784Q1122 721 1050 658L1050 658Q987 604 948.50 530Q910 456 899 374L899 374Q840 354 804 304Q768 254 768 192L768 192Q768 152 783 117Q798 82 824 56Q850 30 885 15Q920 0 960 0L960 0Q1000 0 1035 15Q1070 30 1096 56Q1122 82 1137 117Q1152 152 1152 192L1152 192Q1152 252 1118 301Q1084 350 1028 372L1028 372Q1037 428 1064.50 476Q1092 524 1134 561L1134 561L1423 813Q1480 863 1525 923.50Q1570 984 1601 1052Q1632 1120 1648 1194Q1664 1268 1664 1344ZM960 128L960 128Q934 128 915 147Q896 166 896 192L896 192Q896 218 915 237Q934 256 960 256L960 256Q986 256 1005 237Q1024 218 1024 192L1024 192Q1024 166 1005 147Q986 128 960 128Z"
         }
      }
   ]
}

var SecurityTest = {
   name: "SecurityTest",
   vendor: "UiFabric",
   unicode: 58511,
   value: "",
   charCode: "E48F",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M128 382L128 382L128 768Q128 882 155 987.50Q182 1093 230.50 1189.50Q279 1286 345 1374Q411 1462 489 1540.50Q567 1619 654 1687.50Q741 1756 830 1815L830 1815Q809 1866 809 1920L809 1920Q809 1939 812 1958L812 1958Q708 1893 607 1816Q506 1739 416 1650.50Q326 1562 249.50 1462Q173 1362 117.50 1251.50Q62 1141 31 1020Q0 899 0 768L0 768L0 256Q83 256 161 250Q239 244 314 228Q389 212 461 183Q533 154 604 107L604 107Q687 53 773.50 28.50Q860 4 959 4L959 4Q1059 4 1146 29Q1233 54 1317 108L1317 108Q1388 154 1460 183Q1532 212 1606.50 228Q1681 244 1759 250Q1837 256 1920 256L1920 256L1920 768L1792 768L1792 382Q1689 377 1606 356.50Q1523 336 1452 308Q1381 280 1320 248.50Q1259 217 1200.50 191Q1142 165 1083.50 147.50Q1025 130 960 130L960 130Q894 130 835.50 147.50Q777 165 718.50 191Q660 217 599 248.50Q538 280 467.50 308Q397 336 313.50 356.50Q230 377 128 382ZM1977 1920L1977 1920Q1977 1946 1966.50 1969Q1956 1992 1938.50 2009.50Q1921 2027 1898 2037.50Q1875 2048 1849 2048L1849 2048L1095 2048Q1069 2048 1046 2037.50Q1023 2027 1005.50 2009.50Q988 1992 977.50 1969Q967 1946 967 1920L967 1920Q967 1897 986.50 1846.50Q1006 1796 1036 1732Q1066 1668 1103 1597Q1140 1526 1175 1461.50Q1210 1397 1238 1344.50Q1266 1292 1280 1265L1280 1265L1280 1024L1152 1024L1152 896L1792 896L1792 1024L1664 1024L1664 1265Q1677 1292 1705.50 1344.50Q1734 1397 1769 1461.50Q1804 1526 1841 1597Q1878 1668 1908 1732Q1938 1796 1957.50 1846.50Q1977 1897 1977 1920ZM1536 1295L1536 1024L1408 1024L1408 1295L1223 1664L1721 1664L1536 1295Z"
         }
      }
   ]
}

var OfficeCatchUp = {
   name: "OfficeCatchUp",
   vendor: "UiFabric",
   unicode: 58512,
   value: "",
   charCode: "E490",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M256 128L1152 128L1664 640L1664 1920L256 1920L256 1280L384 1280L384 1792L1536 1792L1536 768L1024 768L1024 256L384 256L384 599L263 865L256 865L256 128ZM1152 308L1152 640L1484 640L1152 308ZM832 1571L544 942L448 1153L128 1153L128 1025L366 1025L544 634L841 1284L981 1025L1280 1025L1280 1153L1058 1153L832 1571Z"
         }
      }
   ]
}

var GroupRemove = {
   name: "GroupRemove",
   vendor: "UiFabric",
   unicode: 58517,
   value: "",
   charCode: "E495",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1251 1334L1251 1334Q1285 1351 1315 1371L1315 1371L1221 1464Q1176 1437 1126 1422.50Q1076 1408 1024 1408L1024 1408Q944 1408 874.50 1438Q805 1468 752.50 1520.50Q700 1573 670 1643Q640 1713 640 1792L640 1792L512 1792Q512 1719 532 1650.50Q552 1582 589 1522Q626 1462 679 1414Q732 1366 797 1333L797 1333Q723 1279 681.50 1197.50Q640 1116 640 1024L640 1024Q640 971 620 924.50Q600 878 565 843Q530 808 483.50 788Q437 768 384 768L384 768Q331 768 284.50 788Q238 808 203 843Q168 878 148 924.50Q128 971 128 1024L128 1024L0 1024Q0 972 14 922.50Q28 873 53.50 829.50Q79 786 115.50 750Q152 714 198 688L198 688Q165 653 146.50 607Q128 561 128 512L128 512Q128 459 148 412.50Q168 366 203 331Q238 296 284.50 276Q331 256 384 256L384 256Q437 256 483.50 276Q530 296 565 331Q600 366 620 412.50Q640 459 640 512L640 512Q640 561 621.50 607Q603 653 570 688L570 688Q652 733 704 812L704 812Q731 772 766 740Q801 708 842 686Q883 664 929.50 652Q976 640 1024 640L1024 640Q1072 640 1118 652Q1164 664 1205.50 686Q1247 708 1282 740Q1317 772 1344 812L1344 812Q1396 733 1478 688L1478 688Q1445 653 1426.50 607Q1408 561 1408 512L1408 512Q1408 459 1428 412.50Q1448 366 1483 331Q1518 296 1564.50 276Q1611 256 1664 256L1664 256Q1717 256 1763.50 276Q1810 296 1845 331Q1880 366 1900 412.50Q1920 459 1920 512L1920 512Q1920 561 1901.50 607Q1883 653 1850 688L1850 688Q1896 714 1932.50 750Q1969 786 1994.50 829.50Q2020 873 2034 922.50Q2048 972 2048 1024L2048 1024L1920 1024Q1920 971 1900 924.50Q1880 878 1845 843Q1810 808 1763.50 788Q1717 768 1664 768L1664 768Q1611 768 1564.50 788Q1518 808 1483 843Q1448 878 1428 924.50Q1408 971 1408 1024L1408 1024Q1408 1116 1366.50 1197.50Q1325 1279 1251 1334ZM1536 512L1536 512Q1536 539 1546 562Q1556 585 1573.50 602.50Q1591 620 1614 630Q1637 640 1664 640L1664 640Q1691 640 1714 630Q1737 620 1754.50 602.50Q1772 585 1782 562Q1792 539 1792 512L1792 512Q1792 485 1782 462Q1772 439 1754.50 421.50Q1737 404 1714 394Q1691 384 1664 384L1664 384Q1637 384 1614 394Q1591 404 1573.50 421.50Q1556 439 1546 462Q1536 485 1536 512ZM256 512L256 512Q256 539 266 562Q276 585 293.50 602.50Q311 620 334 630Q357 640 384 640L384 640Q411 640 434 630Q457 620 474.50 602.50Q492 585 502 562Q512 539 512 512L512 512Q512 485 502 462Q492 439 474.50 421.50Q457 404 434 394Q411 384 384 384L384 384Q357 384 334 394Q311 404 293.50 421.50Q276 439 266 462Q256 485 256 512ZM1024 1280L1024 1280Q1077 1280 1123.50 1260Q1170 1240 1205 1205Q1240 1170 1260 1123.50Q1280 1077 1280 1024L1280 1024Q1280 971 1260 924.50Q1240 878 1205 843Q1170 808 1123.50 788Q1077 768 1024 768L1024 768Q971 768 924.50 788Q878 808 843 843Q808 878 788 924.50Q768 971 768 1024L768 1024Q768 1077 788 1123.50Q808 1170 843 1205Q878 1240 924.50 1260Q971 1280 1024 1280ZM1728 1638L1955 1411L2045 1502L1819 1728L2045 1955L1955 2045L1728 1819L1501 2046L1411 1955L1638 1728L1411 1501L1501 1411L1728 1638Z"
         }
      }
   ]
}

var DynamicList = {
   name: "DynamicList",
   vendor: "UiFabric",
   unicode: 58513,
   value: "",
   charCode: "E491",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M0 2048L0 0L2048 0L2048 2048L0 2048ZM128 1920L640 1920L640 1408L128 1408L128 1920ZM128 1280L640 1280L640 128L128 128L128 1280ZM768 1920L1920 1920L1920 1408L768 1408L768 1920ZM768 1280L1920 1280L1920 128L768 128L768 1280Z"
         }
      }
   ]
}

var ReceiptProcessing = {
   name: "ReceiptProcessing",
   vendor: "UiFabric",
   unicode: 58518,
   value: "",
   charCode: "E496",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M640 384L1408 384L1408 512L640 512L640 384ZM640 768L1152 768L1152 896L640 896L640 768ZM640 1024L1152 1024L1152 1152L640 1152L640 1024ZM640 1280L1152 1280L1152 1408L640 1408L640 1280ZM1408 896L1280 896L1280 768L1408 768L1408 896ZM1408 1152L1280 1152L1280 1024L1408 1024L1408 1152ZM1408 1408L1280 1408L1280 1280L1408 1280L1408 1408ZM1664 302L1664 1536L2048 1536L2045 1606Q2043 1652 2037.50 1696Q2032 1740 2019 1785L2019 1785Q2007 1825 1987.50 1867Q1968 1909 1940 1945.50Q1912 1982 1876 2009Q1840 2036 1797 2047L1797 2047Q1796 2047 1795 2047.50Q1794 2048 1792 2048L1792 2048L773 2048Q744 2048 711 2038Q678 2028 645 2013Q612 1998 582.50 1979.50Q553 1961 531 1944L531 1944Q459 1887 421.50 1815.50Q384 1744 384 1651L384 1651L384 512L0 512L1 443Q3 345 24 266Q45 187 90.50 130Q136 73 208 40Q280 7 384 1L384 1L384 0L1287 0Q1358 0 1425.50 17Q1493 34 1546 71Q1599 108 1631.50 165Q1664 222 1664 302L1664 302ZM128 384L384 384L384 128Q360 128 333.50 131.50Q307 135 281.50 142.50Q256 150 232.50 162Q209 174 192 192L192 192Q170 215 157 236.50Q144 258 137.50 281Q131 304 129.50 329Q128 354 128 384L128 384ZM791 1926L791 1926Q859 1926 918 1899.50Q977 1873 1024 1825L1024 1825Q1082 1765 1134.50 1690Q1187 1615 1216 1536L1216 1536L1536 1536L1536 308Q1536 271 1522 238Q1508 205 1483.50 180.50Q1459 156 1426 142Q1393 128 1356 128L1356 128L512 128L512 1650Q512 1710 536 1760.50Q560 1811 607 1849L607 1849Q624 1863 646.50 1876.50Q669 1890 693.50 1901Q718 1912 743.50 1919Q769 1926 791 1926ZM1100 1920L1781 1920Q1783 1920 1787 1918Q1791 1916 1795 1913Q1799 1910 1802.50 1907Q1806 1904 1807 1903L1807 1903Q1831 1882 1851.50 1854Q1872 1826 1887.50 1794.50Q1903 1763 1911.50 1729.50Q1920 1696 1920 1664L1920 1664L1279 1664Q1272 1691 1251 1727Q1230 1763 1203 1799.50Q1176 1836 1148 1868.50Q1120 1901 1100 1920L1100 1920Z"
         }
      }
   ]
}

var InboxActive = {
   name: "InboxActive",
   vendor: "UiFabric",
   unicode: 58519,
   value: "",
   charCode: "E497",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1728 800L1728 800Q1736 800 1744 798.50Q1752 797 1760 797L1760 797Q1763 805 1776 843.50Q1789 882 1806.50 935Q1824 988 1844 1048Q1864 1108 1881 1158.50Q1898 1209 1909 1242.50Q1920 1276 1920 1276L1920 1276L1920 1920L0 1920L0 1276Q0 1276 10 1245.50Q20 1215 37.50 1163Q55 1111 78 1041.50Q101 972 127.50 893Q154 814 182 729.50Q210 645 237.50 563.50Q265 482 289.50 408Q314 334 333.50 275.50Q353 217 366 178Q379 139 383 128L383 128L1289 128Q1275 159 1267 191Q1259 223 1254 256L1254 256L475 256L134 1280L552 1280L680 1536L1240 1536L1368 1280L1786 1280L1622 787Q1648 793 1674.50 796.50Q1701 800 1728 800ZM128 1792L1792 1792L1792 1408L1448 1408L1320 1664L600 1664L472 1408L128 1408L128 1792ZM1728 0L1728 0Q1794 0 1852.50 25Q1911 50 1954.50 93.50Q1998 137 2023 195.50Q2048 254 2048 320L2048 320Q2048 386 2023 444.50Q1998 503 1954.50 546.50Q1911 590 1852.50 615Q1794 640 1728 640L1728 640Q1662 640 1603.50 615Q1545 590 1501.50 546.50Q1458 503 1433 444.50Q1408 386 1408 320L1408 320Q1408 254 1433 195.50Q1458 137 1501.50 93.50Q1545 50 1603.50 25Q1662 0 1728 0Z"
         }
      }
   ]
}

var RingerActive = {
   name: "RingerActive",
   vendor: "UiFabric",
   unicode: 58520,
   value: "",
   charCode: "E498",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M1664 794L1664 794L1664 1536L1792 1536L1792 1664L1280 1664Q1280 1717 1260 1763.50Q1240 1810 1205 1845Q1170 1880 1123.50 1900Q1077 1920 1024 1920L1024 1920Q971 1920 924.50 1900Q878 1880 843 1845Q808 1810 788 1763.50Q768 1717 768 1664L768 1664L256 1664L256 1536L384 1536L384 768Q384 680 407 598Q430 516 471.50 445Q513 374 571.50 315.50Q630 257 701 215.50Q772 174 854 151Q936 128 1024 128L1024 128Q1154 128 1272 178L1272 178Q1262 210 1256 243Q1250 276 1249 310L1249 310Q1196 284 1139.50 270Q1083 256 1024 256L1024 256Q918 256 825 296.50Q732 337 662.50 406.50Q593 476 552.50 569Q512 662 512 768L512 768L512 1536L1536 1536L1536 768Q1536 766 1535.50 763.50Q1535 761 1535 759L1535 759Q1566 773 1598.50 781Q1631 789 1664 794ZM1024 1792L1024 1792Q1051 1792 1074 1782Q1097 1772 1114.50 1754.50Q1132 1737 1142 1714Q1152 1691 1152 1664L1152 1664L896 1664Q896 1691 906 1714Q916 1737 933.50 1754.50Q951 1772 974 1782Q997 1792 1024 1792ZM1728 0L1728 0Q1794 0 1852.50 25Q1911 50 1954.50 93.50Q1998 137 2023 195.50Q2048 254 2048 320L2048 320Q2048 386 2023 444.50Q1998 503 1954.50 546.50Q1911 590 1852.50 615Q1794 640 1728 640L1728 640Q1662 640 1603.50 615Q1545 590 1501.50 546.50Q1458 503 1433 444.50Q1408 386 1408 320L1408 320Q1408 254 1433 195.50Q1458 137 1501.50 93.50Q1545 50 1603.50 25Q1662 0 1728 0Z"
         }
      }
   ]
}

var FlowTemplate = {
   name: "FlowTemplate",
   vendor: "UiFabric",
   unicode: 58524,
   value: "",
   charCode: "E49C",
   viewBox: "0 0 2048 2048",
   svgData: [
      {
         "path": {
            "d": "M768 0L896 0L896 128L768 128L768 0ZM0 512L128 512L128 640L0 640L0 512ZM0 0L128 0L128 128L0 128L0 0ZM0 256L128 256L128 384L0 384L0 256ZM1024 0L1152 0L1152 128L1024 128L1024 0ZM1536 128L1536 256L1408 256L1408 128L1536 128ZM1280 0L1408 0L1408 128L1280 128L1280 0ZM1408 640L1536 640L1536 768L1408 768L1408 640ZM1408 384L1536 384L1536 512L1408 512L1408 384ZM1536 1024L1408 1024L1408 896L1536 896L1536 1024ZM256 2048L128 2048L128 1920L256 1920L256 2048ZM512 2048L384 2048L384 1920L512 1920L512 2048ZM512 0L640 0L640 128L512 128L512 0ZM256 0L384 0L384 128L256 128L256 0ZM1536 1280L1536 1152L1920 1152L1920 1536L1536 1536L1536 1408L1426 1408L1221 1920L1024 1920L1024 2048L640 2048L640 1664L1024 1664L1024 1792L1134 1792L1339 1280L1536 1280ZM768 1920L896 1920L896 1792L768 1792L768 1920ZM1664 1408L1792 1408L1792 1280L1664 1280L1664 1408ZM0 1280L128 1280L128 1408L0 1408L0 1280ZM0 1920L0 1792L128 1792L128 1920L0 1920ZM0 1024L128 1024L128 1152L0 1152L0 1024ZM0 768L128 768L128 896L0 896L0 768ZM0 1536L128 1536L128 1664L0 1664L0 1536Z"
         }
      }
   ]
}




export {
   GlobalNavButton,
   ChevronDown,
   Add,
   Cancel,
   Settings,
   Mail,
   Pin,
   Filter,
   Share,
   Remove,
   SwitchUser,
   Print,
   ReturnKey,
   PageLeft,
   PageRight,
   KeyboardClassic,
   Emoji2,
   WindowsLogo,
   Chat,
   Nav2DMapView,
   StreetsideSplitMinimize,
   IncidentTriangle,
   Location,
   MapLayers,
   SearchNearby,
   InternetSharing,
   Brightness,
   MapPin,
   Airplane,
   Tablet,
   QuickNote,
   ChevronUp,
   More,
   Video,
   Phone,
   Stop,
   Link,
   AllApps,
   Zoom,
   ZoomOut,
   Microphone,
   FavoriteList,
   PageSolid,
   Forward,
   Back,
   Refresh,
   Lock,
   BlockedSite,
   ReportHacked,
   Blocked,
   FavoriteStar,
   ReadingMode,
   Favicon,
   Checkbox,
   CheckboxComposite,
   CheckboxFill,
   CheckboxCompositeReversed,
   BackToWindow,
   FullScreen,
   Up,
   Down,
   OEM,
   Cloud,
   Flashlight,
   Sad,
   RealEstate,
   Move,
   EraseTool,
   GripperTool,
   Dialpad,
   Play,
   Pause,
   ChevronLeft,
   ChevronRight,
   InkingTool,
   GripperBarHorizontal,
   System,
   Personalize,
   SearchAndApps,
   Globe,
   EaseOfAccess,
   UpdateRestore,
   ContactInfo,
   Unpin,
   Contact,
   Memo,
   IncomingCall,
   Paste,
   Bus,
   EatDrink,
   SeeDo,
   LocationCircle,
   Home,
   SwitcherStartEnd,
   ParkingLocation,
   MapDirections,
   CaretHollow,
   CaretSolid,
   History,
   Work,
   Recent,
   Hotel,
   Bank,
   LocationDot,
   Group,
   News,
   Edit,
   People,
   Search,
   Camera,
   CheckMark,
   Delete,
   Save,
   Package,
   Error,
   GripperBarVertical,
   Unlock,
   Slideshow,
   Calendar,
   Megaphone,
   Trim,
   AutoEnhanceOn,
   AutoEnhanceOff,
   Color,
   SaveAs,
   Light,
   Filters,
   AspectRatio,
   Contrast,
   Undo,
   Crop,
   PhotoCollection,
   Album,
   OpenWith,
   Rotate,
   SIPMove,
   PanoIndicator,
   Translate,
   RedEye,
   ViewOriginal,
   ThumbnailView,
   Telemarketer,
   Warning,
   Financial,
   Education,
   ShoppingCart,
   Train,
   Flag,
   Page,
   TouchPointer,
   Merge,
   TurnRight,
   Ferry,
   Highlight,
   PowerButton,
   Tab,
   Car,
   Admin,
   SDCard,
   TVMonitor,
   Speakers,
   UnstackSelected,
   StackIndicator,
   MultiSelect,
   FavoriteStarFill,
   Redo,
   Dictionary,
   ChromeBack,
   CortanaLogoOuter,
   CortanaLogoInner,
   ProvisioningPackage,
   FolderOpen,
   Pinned,
   PinnedFill,
   RevToggleKey,
   USB,
   CheckboxIndeterminate,
   View,
   Previous,
   Next,
   Clear,
   Sync,
   Download,
   Help,
   Upload,
   Emoji,
   MailForward,
   ClosePane,
   OpenPane,
   PreviewLink,
   ZoomIn,
   Bookmarks,
   Document,
   ProtectedDocument,
   OpenInNewWindow,
   MailFill,
   ViewAll,
   Switch,
   Rename,
   Go,
   Remote,
   SelectAll,
   Orientation,
   Import,
   Folder,
   Picture,
   ChromeClose,
   ShowResults,
   Message,
   CalendarDay,
   CalendarWeek,
   MailReplyAll,
   Read,
   Cut,
   Attach,
   Copy,
   Important,
   MailReply,
   Sort,
   GotoToday,
   Font,
   FolderFill,
   Permissions,
   DisableUpdates,
   FontColor,
   Unfavorite,
   Italic,
   Underline,
   Bold,
   MoveToFolder,
   Dislike,
   Like,
   AlignRight,
   AlignCenter,
   AlignLeft,
   OpenFile,
   ClearSelection,
   FontDecrease,
   FontIncrease,
   FontSize,
   CellPhone,
   Tag,
   Calculator,
   Library,
   PostUpdate,
   NewFolder,
   CalendarReply,
   UnsyncFolder,
   SyncFolder,
   BlockContact,
   AddFriend,
   Accept,
   BulletedList,
   Preview,
   World,
   Comment,
   DockLeft,
   DockRight,
   Repair,
   Accounts,
   Street,
   RadioBullet,
   Stopwatch,
   Clock,
   WorldClock,
   AlarmClock,
   Photo,
   ActionCenter,
   Hospital,
   Timer,
   FullCircleMask,
   LocationFill,
   ChromeMinimize,
   ChromeRestore,
   Annotation,
   Touch,
   EMI,
   Fingerprint,
   Handwriting,
   HorizontalTabKey,
   Completed,
   Label,
   Shop,
   Heart,
   HeartFill,
   DecreaseIndentLegacy,
   IncreaseIndentLegacy,
   SizeLegacy,
   MiniLink,
   FlickDown,
   FlickUp,
   FlickLeft,
   FlickRight,
   MiniExpand,
   MiniContract,
   ChromeFullScreen,
   Streaming,
   MusicInCollection,
   OneDriveLogo,
   CompassNW,
   Code,
   LightningBolt,
   Info,
   CalculatorMultiply,
   CalculatorAddition,
   CalculatorSubtract,
   CalculatorPercentage,
   CalculatorEqualTo,
   PrintfaxPrinterFile,
   StorageOptical,
   Communications,
   FlashAuto,
   Health,
   Webcam2,
   FrontCamera,
   ChevronUpSmall,
   ChevronDownSmall,
   ChevronLeftSmall,
   CommandPrompt,
   ChevronRightSmall,
   ChevronUpMed,
   ChevronDownMed,
   ChevronLeftMed,
   ChevronRightMed,
   Devices2,
   PC1,
   PresenceChickletVideo,
   Reply,
   HalfAlpha,
   ConstructionCone,
   DoubleChevronLeftMed,
   Volume0,
   Volume1,
   Volume2,
   Volume3,
   Chart,
   Robot,
   Manufacturing,
   LockSolid,
   FitPage,
   FitWidth,
   BidiLtr,
   BidiRtl,
   RightDoubleQuote,
   Headset,
   Sunny,
   CloudWeather,
   Cloudy,
   PartlyCloudyDay,
   PartlyCloudyNight,
   ClearNight,
   RainShowersDay,
   Rain,
   Thunderstorms,
   RainSnow,
   Snow,
   BlowingSnow,
   Frigid,
   Fog,
   Squalls,
   Duststorm,
   Unknown,
   Precipitation,
   Ringer,
   PDF,
   HeartBroken,
   StoreLogo16,
   MultiSelectMirrored,
   Broom,
   StoreLogoMed20,
   Info2,
   MusicInCollectionFill,
   List,
   Asterisk,
   ErrorBadge,
   CircleRing,
   CircleFill,
   Record2,
   ThumbnailViewMirrored,
   ShowResultsMirrored,
   SendMirrored,
   ParkingLocationMirrored,
   OpenWithMirrored,
   OpenPaneMirrored,
   MiniExpandMirrored,
   MiniContractMirrored,
   MailReplyAllMirrored,
   MailReplyMirrored,
   MailForwardMirrored,
   ListMirrored,
   ImportAllMirrored,
   ImportMirrored,
   HelpMirrored,
   GoMirrored,
   DoubleChevronLeftMedMirrored,
   DockLeftMirrored,
   ClosePaneMirrored,
   ClearSelectionMirrored,
   ChromeBackMirrored,
   CaretSolidMirrored,
   CaretHollowMirrored,
   BulletedListMirrored,
   BookmarksMirrored,
   AllAppsMirrored,
   Media,
   Devices3,
   FlashOff,
   Focus,
   VideoLightOff,
   Lightbulb,
   StatusTriangle,
   SortLines,
   Ribbon,
   AreaChart,
   Assign,
   FlowChart,
   CheckList,
   Diagnostic,
   Generate,
   Total,
   Equalizer,
   BarChartHorizontal,
   BarChartVertical,
   TriangleSolid,
   UpgradeAnalysis,
   VideoSolid,
   VolumeDisabled,
   Puzzle,
   EmojiNeutral,
   EmojiDisappointed,
   HomeSolid,
   AddToShoppingList,
   Cocktails,
   Wines,
   Articles,
   Cycling,
   DietPlanNotebook,
   Pill,
   ExerciseTracker,
   HandsFree,
   Medical,
   Running,
   Weights,
   Trackers,
   Vaccination,
   AddNotes,
   AllCurrency,
   BarChart4,
   CirclePlus,
   Coffee,
   Cotton,
   Currency,
   Market,
   Money,
   PieDouble,
   PieSingle,
   RemoveFilter,
   Savings,
   Sell,
   StockDown,
   StockUp,
   Source,
   MSNVideos,
   Cricket,
   Golf,
   Baseball,
   Soccer,
   MoreSports,
   AutoRacing,
   CollegeHoops,
   CollegeFootball,
   ProFootball,
   ProHockey,
   Rugby,
   SubstitutionsIn,
   Tennis,
   Arrivals,
   Website,
   Drop,
   HistoricalWeather,
   SkiResorts,
   Snowflake,
   BusSolid,
   FerrySolid,
   EndPointSolid,
   AirplaneSolid,
   TrainSolid,
   ContactLock,
   DeclineCall,
   Game,
   PaymentCard,
   LineChart,
   Freezing,
   FunnelChart,
   Processing,
   Quantity,
   ReportDocument,
   StackColumnChart,
   SnowShowerDay,
   HailDay,
   WorkFlow,
   LightSnow,
   HourGlass,
   TimeSheet,
   RainShowersNight,
   SnowShowerNight,
   Teamwork,
   HailNight,
   PeopleAdd,
   Glasses,
   DateTime2,
   Shield,
   Header1,
   PageAdd,
   NumberedList,
   PowerBILogo,
   Lamp,
   Design,
   Ticket,
   WifiWarning4,
   Devices4,
   Door,
   GiftCard,
   DoubleBookmark,
   StatusErrorFull,
   NUIFace,
   AzureLogo,
   BingLogo,
   MSNLogo,
   OutlookLogoInverse,
   OfficeLogo,
   SkypeLogo,
   EditMirrored,
   Certificate,
   FastForward,
   Rewind,
   Photo2,
   OpenSource,
   WindDirection,
   Family,
   CloudDownload,
   Movers,
   RectangularClipping,
   TabletMode,
   ReminderTime,
   ReminderGroup,
   ReminderPerson,
   DeliveryTruck,
   JS,
   CSS,
   F12DevTools,
   BrowserScreenShot,
   SiteScan,
   Bug,
   StopSolid,
   Umbrella,
   NetworkTower,
   CityNext,
   CityNext2,
   Section,
   OneNoteLogoInverse,
   ToggleFilled,
   ToggleBorder,
   SliderThumb,
   ToggleThumb,
   Documentation,
   Badge,
   Giftbox,
   VisualStudioLogo,
   HomeGroup,
   MyNetwork,
   ExcelLogoInverse,
   WordLogoInverse,
   PowerPointLogoInverse,
   Commitments,
   SpeedHigh,
   Cafe,
   EdgeOldLogo,
   PlaybackRate1x,
   MicOff,
   MusicNote,
   ThisPC,
   CompletedSolid,
   AlbumRemove,
   MessageFill,
   TabletSelected,
   MobileSelected,
   LaptopSelected,
   TVMonitorSelected,
   DeveloperTools,
   Shapes,
   InsertTextBox,
   POI,
   Calories,
   Photo2Remove,
   Photo2Add,
   AppIconDefault,
   CloudAdd,
   DRM,
   PartyLeader,
   Org,
   Tiles,
   Cake,
   Event,
   DateTime,
   ScrollUpDown,
   CloudUpload,
   DOM,
   OfflineStorage,
   WebComponents,
   LowerBrightness,
   ExploreContent,
   RadioBtnOn,
   RadioBtnOff,
   AddTo,
   RemoveContent,
   Embed,
   PageHeader,
   Toolbox,
   FangBody,
   Blocked2,
   Hot,
   ProgressLoopOuter,
   ProgressLoopInner,
   Product,
   ChatInviteFriend,
   Brush,
   Shirt,
   Crown,
   Diamond,
   Glimmer,
   ScaleUp,
   ResetDevice,
   QRCode,
   Feedback,
   SharepointLogoInverse,
   YammerLogo,
   Hide,
   Uneditable,
   OpenFolderHorizontal,
   ReturnToSession,
   CalendarMirrored,
   TrackersMirrored,
   SkipForward30,
   SkipBack10,
   OutOfOffice,
   SwayLogoInverse,
   Trophy,
   EmojiTabSymbols,
   ReopenPages,
   EventInfo,
   RemoveEvent,
   Waffle,
   VoicemailReply,
   VoicemailForward,
   Table,
   SecurityGroup,
   MailRepeat,
   MailPause,
   MailLowImportance,
   MailCheck,
   MailAlert,
   Cat,
   Balloons,
   VisioLogoInverse,
   SocialListeningLogo,
   LyncLogo,
   ExchangeLogoInverse,
   DelveLogoInverse,
   AdminYLogoInverse32,
   AdminSLogoInverse32,
   AdminPLogoInverse32,
   AdminOLogoInverse32,
   AdminMLogoInverse32,
   AdminLLogoInverse32,
   AdminELogoInverse32,
   AdminDLogoInverse32,
   AdminCLogoInverse32,
   AdminALogoInverse32,
   AccessLogo,
   AADLogo,
   OfficeVideoLogoInverse,
   DateTimeMirrored,
   HardDrive,
   Unsubscribe,
   CircleHalfFull,
   Timeline,
   NotePinned,
   NoteReply,
   AddPhone,
   PeoplePause,
   PeopleRepeat,
   RemoveLink,
   AddOnlineMeeting,
   ForwardEvent,
   WipePhone,
   JoinOnlineMeeting,
   PeopleBlock,
   PeopleAlert,
   TransferCall,
   UnknownCall,
   NoteForward,
   RemoveOccurrence,
   EditNote,
   Room,
   Subscribe,
   RecurringTask,
   ProjectLogoInverse,
   PowerApps,
   OneNoteEduLogoInverse,
   OfficeAssistantLogo,
   Dynamics365Logo,
   DelveAnalyticsLogo,
   ClassNotebookLogoInverse,
   PenWorkspace,
   NumberField,
   TextBox,
   Ascending,
   DoubleChevronLeft,
   Split,
   TaskManagerMirrored,
   TaskManager,
   Combine,
   DoubleChevronUp,
   DoubleChevronRight,
   Descending,
   TextField,
   Dropdown,
   BookingsLogo,
   DocsLogoInverse,
   DynamicSMBLogo,
   OfficeStoreLogo,
   PlannerLogo,
   Suitcase,
   CaretLeft8,
   CaretRight8,
   CaretUp8,
   CaretDown8,
   CaretLeftSolid8,
   CaretRightSolid8,
   CaretUpSolid8,
   CaretDownSolid8,
   ClearFormatting,
   Superscript,
   Subscript,
   Strikethrough,
   Export,
   ExportMirrored,
   SingleBookmark,
   SingleBookmarkSolid,
   DoubleChevronDown,
   ProductVariant,
   ProductRelease,
   RecruitmentManagement,
   ReplyAll,
   FollowUser,
   WorkforceManagement,
   Questionnaire,
   ManagerSelfService,
   ProductionFloorManagement,
   ReplyMirrored,
   ReplyAllMirrored,
   Medal,
   AddGroup,
   QuestionnaireMirrored,
   CloudImportExport,
   MyMoviesTV,
   AwayStatus,
   SortUp,
   GroupedDescending,
   CaretSolid16,
   TemporaryUser,
   GroupedAscending,
   SortDown,
   SyncToPC,
   WifiEthernet,
   AustralianRules,
   GenericScan,
   CalendarAgenda,
   DoubleChevronLeft12,
   DoubleChevronUp12,
   DoubleChevronDown12,
   DoubleChevronRight12,
   ConnectVirtualMachine,
   IssueTrackingMirrored,
   CustomListMirrored,
   ContactCard,
   ReportLibrary,
   FormLibrary,
   DataConnectionLibrary,
   AddEvent,
   AssetLibrary,
   DocLibrary,
   FormLibraryMirrored,
   ReportLibraryMirrored,
   CustomList,
   IssueTracking,
   PictureLibrary,
   DocumentSet,
   ArrowUpRight8,
   TriangleLeft12,
   TriangleUp12,
   TriangleSolidLeft12,
   TriangleSolidUp12,
   OfflineOneDriveParachute,
   OfficeAddinsLogo,
   OfflineOneDriveParachuteDisabled,
   LargeGrid,
   TriangleSolidDown12,
   TriangleSolidRight12,
   TriangleDown12,
   TriangleRight12,
   ArrowDownRight8,
   GoToDashboard,
   ArrowUpRightMirrored8,
   CompanyDirectory,
   ArrowDownRightMirrored8,
   DelveAnalytics,
   OpenEnrollment,
   CompanyDirectoryMirrored,
   OneDriveAdd,
   ProfileSearch,
   Header2,
   Header3,
   Header4,
   RingerSolid,
   Flow,
   Breadcrumb,
   EmptyRecycleBin,
   OfficeFormsLogoInverse,
   ClosedCaption,
   SkypeMinus,
   SkypeCheck,
   SkypeCircleClock,
   Tiles2,
   AirTickets,
   Starburst,
   Sections,
   GroupedList,
   PowerPointDocument,
   PublicFolder,
   PublicContactCard,
   DocumentSearch,
   SunQuestionMark,
   Boards,
   CollapseMenu,
   InboxCheck,
   Lifesaver,
   EditStyle,
   ReplyAlt,
   Fax,
   ReceiptReply,
   PlayerSettings,
   ViewAll2,
   CaretTopLeftSolid8,
   SidePanel,
   MarketDown,
   Eyedropper,
   CalendarWorkWeek,
   GlobeFavorite,
   CaretTopRightSolid8,
   DocumentReply,
   ReceiptForward,
   ReceiptCheck,
   RecurringEvent,
   ReplyAllAlt,
   EditMail,
   LifesaverLock,
   FolderSearch,
   ExpandMenu,
   SunAdd,
   LandscapeOrientation,
   PublicCalendar,
   PublicEmail,
   WordDocument,
   ExcelDocument,
   ClassroomLogo,
   EditPhoto,
   ShareiOS,
   PencilReply,
   SkypeCircleCheck,
   SkypeCircleMinus,
   SkypeClock,
   SkypeMessage,
   ATPLogo,
   RecycleBin,
   Hide2,
   BirthdayCake,
   ClearFilter,
   FixedAssetManagement,
   TimeEntry,
   Compare,
   MessageFriendRequest,
   Archive,
   PageShared,
   TextDocumentShared,
   TextDocument,
   SurveyQuestions,
   Relationship,
   ScatterChart,
   DeactivateOrders,
   EditContact,
   Database,
   CRMProcesses,
   PageEdit,
   PageArrowRight,
   PageRemove,
   DataManagementSettings,
   CRMServices,
   ConnectContacts,
   AppIconDefaultAdd,
   AppIconDefaultList,
   ActivateOrders,
   ProductCatalog,
   AccountActivity,
   DocumentManagement,
   CRMReport,
   KnowledgeArticle,
   HomeVerify,
   ZipFolder,
   PageCheckedOut,
   SaveAndClose,
   Script,
   ActivityFeed,
   ArrowUpRight,
   EventDate,
   CaretRight,
   SetAction,
   SearchIssue,
   PowerApps2Logo,
   PowerAppsLogo,
   CaretSolidUp,
   CaretSolidRight,
   CaretSolidDown,
   CaretSolidLeft,
   ChatBot,
   SearchIssueMirrored,
   FabricAssetLibrary,
   FabricPictureLibrary,
   FabricFolderFill,
   FabricOpenFolderHorizontal,
   FabricUnsyncFolder,
   FabricFolderSearch,
   FabricReportLibraryMirrored,
   FabricFormLibraryMirrored,
   FabricDocLibrary,
   FabricDataConnectionLibrary,
   FabricFormLibrary,
   FabricReportLibrary,
   FabricPublicFolder,
   FabricMovetoFolder,
   FabricSyncFolder,
   FabricFolder,
   FabricNewFolder,
   PhotoVideoMedia,
   AddFavorite,
   AddFavoriteFill,
   BufferTimeBefore,
   BufferTimeAfter,
   BufferTimeBoth,
   PublishContent,
   ClipboardList,
   ClipboardListMirrored,
   CannedChat,
   SkypeForBusinessLogo,
   TabCenter,
   PageCheckedin,
   PageList,
   ReadOutLoud,
   ScreenPreviewOn,
   CaretBottomLeftSolid8,
   CaretBottomRightSolid8,
   FolderHorizontal,
   MicrosoftStaffhubLogo,
   GiftboxOpen,
   StatusCircleOuter,
   StatusCircleInner,
   StatusCircleRing,
   StatusTriangleOuter,
   StatusTriangleInner,
   StatusTriangleExclamation,
   StatusCircleExclamation,
   StatusCircleErrorX,
   StatusCircleCheckmark,
   StatusCircleInfo,
   StatusCircleBlock,
   StatusCircleBlock2,
   StatusCircleQuestionMark,
   StatusCircleSync,
   Toll,
   ExploreContentSingle,
   CollapseContent,
   CollapseContentSingle,
   InfoSolid,
   GroupList,
   ProgressRingDots,
   CheckboxIndeterminateCombo,
   CaloriesAdd,
   BranchFork,
   MuteChat,
   AddHome,
   AddWork,
   ScreenTime,
   MobileReport,
   ScaleVolume,
   HardDriveGroup,
   FastMode,
   ToggleLeft,
   ToggleRight,
   FullView,
   FocusView,
   CircleShape,
   SquareShape,
   TriangleShape,
   DropShape,
   RectangleShape,
   CubeShape,
   Trophy2,
   BucketColor,
   BucketColorFill,
   Taskboard,
   SingleColumn,
   DoubleColumn,
   TripleColumn,
   ColumnLeftTwoThirds,
   ColumnRightTwoThirds,
   AccessLogoFill,
   AnalyticsLogo,
   AnalyticsQuery,
   AnalyticsReport,
   NewAnalyticsQuery,
   ExcelLogoFill,
   ExcelLogo,
   OneNoteLogo,
   FlameSolid,
   OneNoteLogoFill,
   PowerPointLogo,
   PowerPointLogoFill,
   OutlookLogo,
   OutlookLogoFill,
   WordLogo,
   WordLogoFill,
   PublisherLogo,
   PublisherLogoFill,
   ScheduleEventAction,
   SaveAll,
   ServerProcesses,
   Server,
   RegistryEditor,
   PowerShell,
   LinkedInLogo,
   FilterDescending,
   SidePanelMirrored,
   FilterAscending,
   Decimals,
   ProtectRestrict,
   IOT,
   UnknownMirrored,
   PublicContactCardMirrored,
   GridViewSmall,
   GridViewLarge,
   StepInsert,
   StepSharedAdd,
   ViewDashboard,
   ViewListGroup,
   TriggerAuto,
   PivotChart,
   StackedLineChart,
   BuildQueueNew,
   BuildQueue,
   StackedBarChart,
   TriggerUser,
   ViewListTree,
   ViewList,
   StepSharedInsert,
   StepShared,
   Step,
   GridViewMedium,
   Blog,
   UserFollowed,
   ContactLink,
   Stack,
   Bullseye,
   VennDiagram,
   FiveTileGrid,
   FocalPoint,
   Insert,
   RingerRemove,
   TeamsLogoInverse,
   TeamsLogo,
   TeamsLogoFill,
   SkypeForBusinessLogoFill,
   SharepointLogo,
   SharepointLogoFill,
   DelveLogo,
   DelveLogoFill,
   OfficeVideoLogo,
   OfficeVideoLogoFill,
   ExchangeLogo,
   ExchangeLogoFill,
   Signin,
   DocumentApproval,
   CloneToDesktop,
   InstallToDrive,
   Blur,
   Build,
   ProcessMetaTask,
   BranchFork2,
   BranchLocked,
   BranchCommit,
   BranchCompare,
   BranchMerge,
   BranchPullRequest,
   BranchSearch,
   BranchShelveset,
   RawSource,
   RowsGroup,
   Deploy,
   ServerEnviroment,
   HighlightMappedShapes,
   VisioLogo,
   VisioDocument,
   TimelineDelivery,
   TeamFavorite,
   TaskGroupMirrored,
   AssessmentGroupTemplate,
   CommentAdd,
   CommentPrevious,
   LocaleLanguage,
   UserSync,
   StreamingOff,
   ArrowTallUpLeft,
   ArrowTallDownLeft,
   FieldEmpty,
   FieldChanged,
   RingerOff,
   BulletedList2,
   ImageCrosshair,
   Repo,
   FolderQuery,
   FolderListMirrored,
   POISolid,
   BoxSubtractSolid,
   BoxMultiplySolid,
   BoxCheckmarkSolid,
   CirclePause,
   CircleStopSolid,
   NavigateBack,
   NavigateForward,
   UnknownSolid,
   CircleAddition,
   FilePDB,
   FileSQL,
   FileASPX,
   FileSass,
   FileHTML,
   CSharpLanguage,
   VisualBasicLanguage,
   CPlusPlusLanguage,
   FSharpLanguage,
   TypeScriptLanguage,
   PY,
   MarkDownLanguage,
   FullWidthEdit,
   PlugSolid,
   PlugDisconnected,
   Variable,
   CommentUrgent,
   DiffInline,
   ImageDiff,
   FileBug,
   FileComment,
   FileImage,
   AutoFillTemplate,
   WorkItemBug,
   ColumnOptions,
   BuildIssue,
   VariableGroup,
   FullHistory,
   AssessmentGroup,
   Packages,
   LogRemove,
   WorkItem,
   FileSymlink,
   BusinessHoursSign,
   FileCode,
   ImagePixel,
   DiffSideBySide,
   Storyboard,
   Parameter,
   UnlockSolid,
   PlugConnected,
   Plug,
   FullWidth,
   CoffeeScript,
   PythonLanguage,
   FSharp,
   CPlusPlus,
   VB,
   CSharp,
   JavaScriptLanguage,
   FileLess,
   FileCSS,
   FileJAVA,
   FileTemplate,
   CircleAdditionSolid,
   UnknownMirroredSolid,
   NavigateForwardMirrored,
   NavigateBackMirrored,
   CircleStop,
   MSNVideosSolid,
   CirclePauseSolid,
   BoxPlaySolid,
   BoxAdditionSolid,
   CalculatorNotEqualTo,
   LocationOutline,
   FolderList,
   RepoSolid,
   GitGraph,
   BulletedList2Mirrored,
   PlayResume,
   FieldNotChanged,
   FieldFilled,
   ArrowTallDownRight,
   ArrowTallUpRight,
   MoreVertical,
   UserPause,
   QueryList,
   ShopServer,
   CommentNext,
   NewTeamProject,
   ScopeTemplate,
   TaskGroup,
   Backlog,
   TimelineProgress,
   VisioLogoFill,
   IconSetsFlag,
   TextCallout,
   VisioDiagram,
   Redeploy,
   RowsChild,
   MergeDuplicate,
   Wheelchair,
   SingleColumnEdit,
   DoubleColumnEdit,
   TripleColumnEdit,
   ColumnLeftTwoThirdsEdit,
   ColumnRightTwoThirdsEdit,
   StreamLogo,
   PassiveAuthentication,
   ChevronDownEnd6,
   DoubleChevronLeft8,
   DoubleChevronDown8,
   ChevronUnfold10,
   CaretTopLeftCenter8,
   CaretBottomLeftCenter8,
   ProjectCollection,
   TimelineMatrixView,
   NavigateExternalInline,
   WorkItemBarSolid,
   FeedbackResponseSolid,
   FeedbackRequestSolid,
   ReviewRequestMirroredSolid,
   ReviewSolid,
   FiltersSolid,
   Parachute,
   BankSolid,
   AsteriskSolid,
   ParkingMirroredSolid,
   PermissionsSolid,
   FinancialMirroredSolid,
   RibbonSolid,
   MailSolid,
   GiftBoxSolid,
   HealthSolid,
   ReadingModeSolid,
   PageListMirroredSolid,
   ConstructionConeSolid,
   Trophy2Solid,
   BugSolid,
   TaskSolid,
   AlertSolid,
   MegaphoneSolid,
   ConfigurationSolid,
   CrownSolid,
   QuickNoteSolid,
   PageListSolid,
   StarburstSolid,
   SadSolid,
   ShieldSolid,
   ShoppingCartSolid,
   ChatSolid,
   FinancialSolid,
   HeadsetSolid,
   ParkingSolid,
   DiamondSolid,
   OfflineStorageSolid,
   DecisionSolid,
   ParachuteSolid,
   ColorSolid,
   ReviewRequestSolid,
   ReviewResponseSolid,
   FeedbackRequestMirroredSolid,
   WorkItemBar,
   Separator,
   PlanView,
   EngineeringGroup,
   CaretBottomRightCenter8,
   CaretTopRightCenter8,
   DonutChart,
   ChevronFold10,
   DoubleChevronUp8,
   DoubleChevronRight8,
   ChevronUpEnd6,
   ChevronLeftEnd6,
   ChevronRightEnd6,
   ContextMenu,
   AzureAPIManagement,
   AzureServiceEndpoint,
   VSTSLogo,
   VSTSAltLogo1,
   VSTSAltLogo2,
   FileTypeSolution,
   DateTime12,
   WordLogoInverse16,
   WordLogo16,
   PlayReverseResume,
   D365CustomerInsights,
   DislikeSolid,
   Transition,
   Onboarding,
   AzureKeyVault,
   TriggerApproval,
   Sprint,
   TestSuite,
   TestStep,
   TestImpactSolid,
   TestAutoSolid,
   TestBeakerSolid,
   VisioLogoFill16,
   VisioLogoInverse16,
   PublisherLogo16,
   OutlookLogoFill16,
   OutlookLogoInverse16,
   OneNoteLogo16,
   ExcelLogoFill16,
   ExcelLogoInverse16,
   PowerPointLogo16,
   WordLogoFill16,
   PowerPointLogoInverse16,
   PowerPointLogoFill16,
   ExcelLogo16,
   OneNoteLogoInverse16,
   OneNoteLogoFill16,
   OutlookLogo16,
   PublisherLogoInverse16,
   PublisherLogoFill16,
   VisioLogo16,
   TestBeaker,
   TestExploreSolid,
   TestUserSolid,
   TestPlan,
   TestParameter,
   TestCase,
   SignOut,
   Rocket,
   LikeSolid,
   EditCreate,
   PlayReverse,
   SearchData,
   UnSetColor,
   AutoDeploySettings,
   TeamsLogo16,
   TeamsLogoFill16,
   Spacer,
   SkypeLogo16,
   SkypeForBusinessLogo16,
   SkypeForBusinessLogoFill16,
   FilterSolid,
   MailUndelivered,
   MailTentative,
   MailTentativeMirrored,
   MailReminder,
   ReceiptUndelivered,
   ReceiptTentative,
   ReceiptTentativeMirrored,
   Inbox,
   IRMReply,
   IRMReplyMirrored,
   IRMForward,
   IRMForwardMirrored,
   VoicemailIRM,
   EventAccepted,
   EventTentative,
   EventTentativeMirrored,
   EventDeclined,
   IDBadge,
   BackgroundColor,
   OfficeFormsLogoInverse16,
   OfficeFormsLogo,
   OfficeFormsLogoFill,
   OfficeFormsLogo16,
   OfficeFormsLogoFill16,
   OfficeFormsLogoInverse24,
   OfficeFormsLogo24,
   OfficeFormsLogoFill24,
   PageLock,
   NotExecuted,
   NotImpactedSolid,
   FieldReadOnly,
   FieldRequired,
   BacklogBoard,
   ExternalBuild,
   ExternalTFVC,
   ExternalXAML,
   IssueSolid,
   DefectSolid,
   LadybugSolid,
   NugetLogo,
   TFVCLogo,
   ProjectLogo32,
   ProjectLogoFill32,
   ProjectLogo16,
   ProjectLogoFill16,
   SwayLogo32,
   SwayLogoFill32,
   SwayLogo16,
   SwayLogoFill16,
   ClassNotebookLogo32,
   ClassNotebookLogoFill32,
   ClassNotebookLogo16,
   ClassNotebookLogoFill16,
   ClassNotebookLogoInverse32,
   ClassNotebookLogoInverse16,
   StaffNotebookLogo32,
   StaffNotebookLogoFill32,
   StaffNotebookLogo16,
   StaffNotebookLogoFill16,
   StaffNotebookLogoInverted32,
   StaffNotebookLogoInverted16,
   KaizalaLogo,
   TaskLogo,
   ProtectionCenterLogo32,
   GallatinLogo,
   GIF,
   UnsyncOccurence,
   SyncOccurence,
   Chopsticks,
   Taxi,
   Vacation,
   BeerMug,
   Brunch,
   Breakfast,
   Guitar,
   Globe2,
   Teeth,
   PrimaryCalendar,
   SearchCalendar,
   VideoOff,
   MicrosoftFlowLogo,
   BusinessCenterLogo,
   ToDoLogoBottom,
   ToDoLogoTop,
   EditSolid12,
   EditSolidMirrored12,
   UneditableSolid12,
   UneditableSolidMirrored12,
   UneditableMirrored,
   AdminALogo32,
   AdminALogoFill32,
   ToDoLogoInverse,
   Snooze,
   CortanaLogoReadyOuter,
   CortanaLogoReadyInner,
   CortanaLogoBeckonOuter,
   CortanaLogoBeckonInner,
   WaffleOffice365,
   ImageSearch,
   NewsSearch,
   VideoSearch,
   R,
   FontColorA,
   FontColorSwatch,
   LightWeight,
   NormalWeight,
   SemiboldWeight,
   GroupObject,
   UngroupObject,
   AlignHorizontalLeft,
   AlignHorizontalCenter,
   AlignHorizontalRight,
   AlignVerticalTop,
   AlignVerticalCenter,
   AlignVerticalBottom,
   HorizontalDistributeCenter,
   VerticalDistributeCenter,
   Ellipse,
   Line,
   Octagon,
   Hexagon,
   Pentagon,
   RightTriangle,
   HalfCircle,
   QuarterCircle,
   ThreeQuarterCircle,
   PointStar6,
   PointStar12,
   ArrangeBringToFront,
   ArrangeSendToBack,
   ArrangeSendBackward,
   ArrangeBringForward,
   BorderDash,
   BorderDot,
   LineStyle,
   LineThickness,
   WindowEdit,
   HintText,
   MediaAdd,
   AnchorLock,
   AutoHeight,
   ChartSeries,
   ChartXAngle,
   ChartYAngle,
   Combobox,
   LineSpacing,
   Padding,
   PaddingTop,
   PaddingBottom,
   PaddingLeft,
   PaddingRight,
   NavigationFlipper,
   AlignJustify,
   TextOverflow,
   VisualsFolder,
   VisualsStore,
   PictureCenter,
   PictureFill,
   PicturePosition,
   PictureStretch,
   PictureTile,
   Slider,
   SliderHandleSize,
   DefaultRatio,
   NumberSequence,
   GUID,
   ReportAdd,
   DashboardAdd,
   MapPinSolid,
   WebPublish,
   PieSingleSolid,
   BlockedSolid,
   DrillDown,
   DrillDownSolid,
   DrillExpand,
   DrillShow,
   SpecialEvent,
   OneDriveFolder16,
   FunctionalManagerDashboard,
   BIDashboard,
   CodeEdit,
   RenewalCurrent,
   RenewalFuture,
   SplitObject,
   BulkUpload,
   DownloadDocument,
   GreetingCard,
   Flower,
   WaitlistConfirm,
   LaptopSecure,
   EntryView,
   ContactCardSettings,
   CalendarSettings,
   HardDriveLock,
   AccountManagement,
   ReportWarning,
   HardDriveUnlock,
   CalendarSettingsMirrored,
   ContactCardSettingsMirrored,
   EntryDecline,
   DragObject,
   WaitlistConfirmMirrored,
   PlaySolid,
   TransitionPush,
   LookupEntities,
   AddBookmark,
   DrillThrough,
   CertifiedDatabase,
   MinimumValue,
   PasteAsText,
   BrowserTab,
   DesktopScreenshot,
   FabricUserFolder,
   FabricNetworkFolder,
   ClipboardSolid,
   FileYML,
   BrowserTabScreenshot,
   PasteAsCode,
   VisualStudioIDELogo32,
   MaximumValue,
   MasterDatabase,
   SearchBookmark,
   ExploreData,
   TransitionEffect,
   TransitionPop,
   AnalyticsView,
   Video360Generic,
   BullseyeTarget,
   Untag,
   Blocked12,
   CheckedOutByOther12,
   CircleShapeSolid,
   TriangleShapeSolid,
   RectangleShapeSolid,
   DropShapeSolid,
   SquareShapeSolid,
   CheckedOutByYou12,
   Warning12,
   Trending12,
   Leave,
   ContentSettings,
   ZoomToFit,
   InsertColumnsLeft,
   InsertRowsAbove,
   DeleteColumns,
   DeleteRowsMirrored,
   AccountBrowser,
   DeleteTable,
   DeleteRows,
   InsertRowsBelow,
   InsertColumnsRight,
   QuadColumn,
   WhiteBoardApp16,
   InsertSignatureLine,
   Phishing,
   CreateMailRule,
   ArrangeByFrom,
   PinnedSolid,
   WhiteBoardApp32,
   TripleColumnWide,
   StackedColumnChart2,
   VersionControlPush,
   UserEvent,
   UserRemove,
   DictionaryRemove,
   PublishCourse,
   Number,
   Encryption,
   LiveSite,
   MedalSolid,
   DefenderTVM,
   WebTemplate,
   AuthenticatorApp,
   MarkAsProtected,
   VerifiedBrandSolid,
   Hide3,
   OpenInNewTab,
   PasswordField,
   D365TalentLearn,
   D365TalentInsight,
   D365CoreHR,
   BacklogList,
   ButtonControl,
   TableGroup,
   MountainClimbing,
   Lock12,
   Presentation12,
   Presentation,
   Link12,
   TagUnknown12Mirror,
   TagUnknown12,
   TagUnknownMirror,
   TagUnknown,
   BuildDefinition,
   ReleaseDefinition,
   SaveTemplate,
   UserGauge,
   TagSolid,
   BlockedSiteSolid12,
   OfficeChat,
   OfficeChatSolid,
   MailSchedule,
   PowerShell2,
   Blocked2Solid,
   WarningSolid,
   SkypeCircleArrow,
   SkypeArrow,
   SyncStatus,
   SyncStatusSolid,
   ProjectDocument,
   ToDoLogoOutline,
   BookmarkReport,
   DistributeDown,
   DoubleDownArrow,
   ResponsesMenu,
   UserOptional,
   EventDateMissed12,
   Event12,
   VisioDiagramSync,
   FilterSettings,
   AddIn,
   MailAttached,
   GripperDotsVertical,
   MicrosoftTranslatorLogo,
   MicOff2,
   BarChartVerticalFilterSolid,
   BarChartVerticalFilter,
   PromotedDatabase,
   TableLink,
   LinkedDatabase,
   ShowTimeAs,
   FileRequest,
   AcceptMedium,
   WorkItemAlert,
   PowerBILogo16,
   PowerBILogoBackplate16,
   BulletedListText,
   M365InvoicingLogo,
   ReleaseGateError,
   ReleaseGateCheck,
   ReleaseGate,
   VerifiedBrand,
   Coupon,
   Photo2Fill,
   ClearFormattingEraser,
   ClearFormattingA,
   FabricTextHighlight,
   RemoveLinkX,
   RemoveLinkChain,
   NumberedListTextMirrored,
   NumberedListNumberMirrored,
   NumberedListNumber,
   NumberedListText,
   BulletedListBulletMirrored,
   BulletedListTextMirrored,
   BulletedListBullet,
   IncreaseIndentText,
   IncreaseIndentArrow,
   DecreaseIndentText,
   DecreaseIndentArrow,
   IncreaseIndentTextMirrored,
   IncreaseIndentArrowMirrored,
   DecreaseIndentTextMirrored,
   DecreaseIndentArrowMirrored,
   CheckListText,
   CheckListCheck,
   CheckListTextMirrored,
   CheckListCheckMirrored,
   NumberSymbol,
   RemoveFromShoppingList,
   ShieldAlert,
   StreamDiscover,
   FabricTextHighlightComposite,
   ContactList,
   SnapToGrid,
   GenericScanFilled,
   ScreenCast,
   Orientation2,
   SaveToMobile,
   DiagnosticDataBarTooltip,
   ShowGrid,
   Dataflows,
   LearningTools,
   NewMail,
   EyeShadow,
   CampaignTemplate,
   ChartTemplate,
   PageListFilter,
   SecondaryNav,
   FabricFolderConfirm,
   InformationBarriers,
   CommentActive,
   ColumnVerticalSectionEdit,
   WavingHand,
   ShakeDevice,
   SmartGlassRemote,
   Rotate90Clockwise,
   Rotate90CounterClockwise,
   ColumnVerticalSection,
   SkypeCircleSlash,
   SkypeSlash,
   CustomizeToolbar,
   DuplicateRow,
   RemoveFromTrash,
   Header,
   Footer,
   Childof,
   MailOptions,
   StackedColumnChart2Fill,
   BarChartVerticalFill,
   PlainText,
   AccessibiltyChecker,
   DatabaseSync,
   ReservationOrders,
   TabOneColumn,
   TabTwoColumn,
   TabThreeColumn,
   BulletedTreeList,
   MicrosoftTranslatorLogoGreen,
   MicrosoftTranslatorLogoBlue,
   InternalInvestigation,
   RepeatAll,
   RepeatOne,
   AddReaction,
   ContactHeart,
   VisuallyImpaired,
   EventToDoLogo,
   Variable2,
   ModelingView,
   DisconnectVirtualMachine,
   ReportLock,
   Uneditable2,
   Uneditable2Mirrored,
   Spelling,
   BarChartVerticalEdit,
   GlobalNavButtonActive,
   PollResults,
   Rerun,
   QandA,
   QandAMirror,
   BookAnswers,
   AlertSettings,
   TrimEnd,
   TrimStart,
   TableComputed,
   PageLink,
   CommentSolid,
   ChangeEntitlements,
   Installation,
   WebAppBuilderFragment,
   WebAppBuilderModule,
   WebAppBuilderSlot,
   BullseyeTargetEdit,
   UnpublishContent,
   WebAppBuilderFragmentCreate,
   PageData,
   PageHeaderEdit,
   EntitlementRedemption,
   EntitlementPolicy,
   DependencyRemove,
   DependencyAdd,
   SchoolDataSyncLogo,
   PinSolid12,
   PinSolidOff12,
   AddLink,
   SharepointAppIcon16,
   DataflowsLink,
   TimePicker,
   UserWarning,
   ComplianceAudit,
   StickyNotesOutlineAppIcon,
   StickyNotesSolidAppIcon,
   eDiscovery,
   Webcam2Off,
   CalendarYear,
   IgnoreConversation,
   CommonDataServiceCDS,
   Forum,
   KeyPhraseExtraction,
   TextRecognition,
   SentimentAnalysis,
   Send,
   IncreaseIndentHangingMirrored,
   IncreaseIndentHanging,
   DecreaseIndentMirrored,
   DecreaseIndent,
   IncreaseIndentMirrored,
   IncreaseIndent,
   NumberedListMirrored,
   AltText,
   ArchiveUndo,
   LeaveUser,
   Insights,
   MapPin12,
   RedEye12,
   FabricFolderUpload,
   TaskList,
   MachineLearning,
   HealthRefresh,
   SharedDatabase,
   WebEnvironment,
   TagGroup,
   AutomateFlow,
   TableBrandedColumn,
   TableLastColumn,
   TableFirstColumn,
   TableBrandedRow,
   TableTotalRow,
   TableHeaderRow,
   RepeatHeaderRows,
   FixedColumnWidth,
   AutoFitWindow,
   AutoFitContents,
   TextRotate270Degrees,
   TextRotate90Degrees,
   TextRotateHorizontal,
   TextParagraphOption,
   TextRotation,
   TextAlignBottom,
   TextAlignMiddle,
   TextAlignTop,
   AddSpaceAfter,
   AddSpaceBefore,
   IndentFirstLine,
   FormatPainter,
   FontSize2,
   ProcessingPause,
   ProcessingRun,
   ProcessingCancel,
   DeviceOff,
   DeviceRun,
   BugBlock,
   BugSync,
   URLBlock,
   ServiceOff,
   FileOff,
   DriverOff,
   HexaditeInvestigationSemiAuto,
   HexaditeInvestigationCancel,
   HexaditeInvestigation,
   PhotoError,
   CalculatorDelta,
   DeviceBug,
   Reset,
   ShapeSolid,
   CubeShapeSolid,
   ImageInAR,
   ViewInAR,
   InputAddress,
   ContentFeed,
   HomeDropdown,
   D365ProjectOperations,
   CompareUneven,
   AzureDataExplorer,
   Column,
   DatabaseView,
   BlobStorage,
   StorageAcount,
   SQLAnalyticsPool,
   FileSystem,
   SortLinesAscending,
   TextDocumentEdit,
   VideoOff2,
   RewindEightX,
   RewindFourX,
   RewindTwoX,
   RewindOneFiveX,
   RewindOneX,
   RewindPointFiveX,
   FastForwardEightX,
   FastForwardFourX,
   FastForwardTwoX,
   FastForwardOneFiveX,
   FastForwardOneX,
   FastForwardPointFiveX,
   LockShare,
   FabricFolderLink,
   LightningBoltSolid,
   MobileAngled,
   CalculatorGroup,
   AssignPolicy,
   Gather,
   CopyEdit,
   EntityExtraction,
   MostyCloudyFlurriesNight,
   PartlySunnyTStormsNight,
   MostyCloudyTStormsNight,
   PartlySunnyShowersNight,
   HazyNight,
   IntermittentCloudsNight,
   PartlyClearNight,
   MostyClearNight,
   FreezingRain,
   Sleet,
   Ice,
   PartlySunnyFlurriesDay,
   MostyCloudyFlurriesDay,
   PartlySunnyTStormsDay,
   MostyCloudyTStormsDay,
   PartlySunnyShowersDay,
   MostyCloudyShowersDay,
   Showers,
   HazyDay,
   IntermittentCloudsDay,
   PartlySunnyDay,
   MostySunnyDay,
   Sharepoint2013LogoInverse,
   PowerVirtualAgentsLogo,
   CaretSolidAlt,
   OutlookSpacesBucket,
   FluidLogo,
   CategoryClassification,
   FormProcessing,
   PhishingCampaign,
   PhishingHook,
   SecurityTest,
   OfficeCatchUp,
   GroupRemove,
   DynamicList,
   ReceiptProcessing,
   InboxActive,
   RingerActive,
   FlowTemplate
}